'use strict';

angular.module('metabuyer',
  [
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngResource',
    'ui.router',
    'ui.bootstrap',
    'xeditable',
    'ui.select',
    'satellizer',
    'angularMoment',
    'cgNotify',
    'toastr',
    'flow',
    'ct.ui.router.extras.sticky',
    'ct.ui.router.extras.dsr',
    'ui.utils',
    'smart-table',
    'mentio',
    'angular-loading-bar',
    'ui.sortable',
    'ui.router.title',
    'angularTinycon',
    'daterangepicker',
    'ngTagsInput',
    'ngPatternRestrict',
    'angular-peity',
    'isteven-multi-select',
    'metabuyer.services.attachments',
    'metabuyer.services.catalogServices',
    'metabuyer.services.commentsServices',
    'custom-angularjs-dropdown-multiselect',
    'metabuyer.services.itemsCategoriesServices',
    'metabuyer.services.starringServices',
    'dropzone',
    'metabuyer.services.itemsServices',
    'metabuyer.services.taxes',
    'metabuyer.services.uoms',
    'metabuyer.services.suppliersManagement',
    'metabuyer.services.paymentMethods',
    'metabuyer.services.BusinessUnits',
    'metabuyer.services.industries',
    'metabuyer.services.paymentTerms',
    'metabuyer.services.approval',
    'metabuyer.services.purchaseRequisitions',
    'metabuyer.services.users',
    'metabuyer.services.companies',
    'metabuyer.services.orders',
    'metabuyer.services.costcenters',
    'metabuyer.services.availability',
    'metabuyer.services.waitingOnUserList',
    'metabuyer.services.expenseTypes',
    'metabuyer.services.auditTrail',
    'metabuyer.services.commodity',
    'metabuyer.services.accountCodes',
    'metabuyer.services.notification',
    'metabuyer.services.address',
    'metabuyer.services.permissions',
    'metabuyer.services.roles',
    'metabuyer.services.escalation',
    'metabuyer.services.notes',
    'metabuyer.services.reports',
    'metabuyer.services.adminSettings',
    'metabuyer.services.delegation',
    'metabuyer.services.export',
    'metabuyer.services.GRN',
    'metabuyer.services.genericSearch',
    'metabuyer.services.catalogCode',
    'metabuyer.services.budgets',
    'metabuyer.services.pdfPreview',
    'metabuyer.services.attachmentCategory',
    'metabuyer.services.attachmentCategory',
    'metabuyer.services.approvalEngine.positionManage',
    'metabuyer.services.approvalEngine.positionAssign',
    'metabuyer.services.approvalEngine.approvalTemplates',
    'metabuyer.services.approvalEngine.approvalTemplateHistory',
    'tandibar/ng-rollbar',
    'rzModule',
    'ui.knob',
    'ngIntlTelInput'
  ])

  .config(function ($stateProvider, $urlRouterProvider, $authProvider, $httpProvider, pathConstants,
                    toastrConfig, cfpLoadingBarProvider, RollbarProvider, $locationProvider, $qProvider, ngIntlTelInputProvider) {

    ngIntlTelInputProvider.set({
      initialCountry: 'my',
      autoHideDialCode: true,
      nationalMode: true,
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.6/js/utils.js'
    });

    $locationProvider.hashPrefix('');
    $authProvider.loginUrl = pathConstants.apiUrls.login;
    $authProvider.loginRedirect = '/user/waiting-on-you';

    // we handle the logout redirect on our own since
    // Satellizer doesn't clear the URL params when redirecting
    $authProvider.logoutRedirect = false;
    $httpProvider.defaults.headers.common['Accept'] = 'application/json';
    $httpProvider.interceptors.push('metabuyerInterceptor');

    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.includeBar = true;

    /**
     * Setting up the the Rollbar
     */
    RollbarProvider.init({
      accessToken: pathConstants.RollbarConfiguration.token,
      captureUncaught: pathConstants.RollbarConfiguration.captureUncaught,
      payload: {
        environment: pathConstants.RollbarConfiguration.environment,
        build: pathConstants.RollbarConfiguration.buildNumber
      }
    });

    /**
     * Silencing the unhandled promise rejections, which is default to true
     */
    $qProvider.errorOnUnhandledRejections(false);

    $stateProvider
      .state('main', {
        url: '/',
        controller: 'MainCtrl',
        templateUrl: 'app/main/main.html',
        resolve: {
          authenticated: function ($q, $location, $auth, pathConstants, Rollbar) {

            /**
             * disabling Rollbar in case 'production' was not provided
             */
            if (!pathConstants.RollbarConfiguration || !pathConstants.RollbarConfiguration.environment
              || pathConstants.RollbarConfiguration.environment !== 'production') {
              Rollbar.disable();
            }

            /**
             * turn on the option for verbose errors in the console log
             */
            if(pathConstants.RollbarConfiguration && !!pathConstants.RollbarConfiguration.verbose) {
              Rollbar.verbose();
            }


            var deferred = $q.defer();
            if ($auth.isAuthenticated()) {
              deferred.resolve(true);
            } else {
              deferred.resolve(false);
            }

            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Login';
          },
          isMobileBrowser: function($rootScope, globalFunc) {
            $rootScope.isMobileBrowser = globalFunc.isMobileBrowser();
            $rootScope.isMobileMode = globalFunc.isMobileBrowser();
            return globalFunc.isMobileBrowser();
          }
        }
      })
      .state('login', {
        url: '/login',
        controller: 'LoginCtrl',
        templateUrl: 'app/login/login.html',
        resolve: {
          authenticated: function ($q, $location, $auth, userSettings) {
            var deferred = $q.defer();

            if ($auth.isAuthenticated()) {
              $location.url('/user/waiting-on-you');
              deferred.resolve(true);
            } else {
              userSettings.loggedOut();
              deferred.resolve(false);
            }

            return deferred.promise;
          },
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          },
          $title: function ($stateParams) {
            return 'Login';
          }
        }
      })
      .state('forgotPassword', {
        templateUrl: 'app/forgotPassword/forgotPasswordTemplate.html',
        controller: 'forgotPasswordCtrl',
        url: '/forgotPassword',
        resolve: {
          authenticated: function ($q, $location, $auth, userSettings) {
            var deferred = $q.defer();

            if ($auth.isAuthenticated()) {
              $location.url('/user/waiting-on-you');
              deferred.resolve(true);
            } else {
              userSettings.loggedOut();
              deferred.resolve(false);
            }

            return deferred.promise;
          },
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          },
          $title: function ($stateParams) {
            return 'Password reset';
          }
        }
      })
      .state('main.explore-apps', {
        url: 'explore-apps',
        templateUrl: 'app/explore-apps/explore-apps.html',
        controller: 'ExploreAppsCtrl',
        resolve: {
          $title: function ($stateParams) {
            return "explore apps";
          }
        }
      })
      .state('passwordReset', {
        templateUrl: 'app/user/passwordReset/password-reset-template.html',
        controller: 'passwordResetCtrl',
        resolve: {
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      })
      .state('accountLocked', {
        templateUrl: 'app/user/accountLocked/accountLocked.html',
        controller: 'accountLockedCtrl',
        resolve: {
          style: function($rootScope, userSettings){
            userSettings.loggedOut();
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      })
      .state('notAuthorized', {
        templateUrl: 'app/user/notAuthorized/notAuthorized.html',
        url: '/not-authorized',
        controller: 'notAuthorizedCtrl',
        resolve: {
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      })
      .state('unauthorizedBudgetAccess', {
        templateUrl: 'app/user/unauthorizedBudgetAccess/unauthorizedBudgetAccess.html',
        url: '/unauthorized-budget-access',
        controller: 'unauthorizedBudgetAccessCtrl',
        resolve: {
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      })
      .state('invalidUrl', {
        templateUrl: 'app/user/invalidUrl/invalidUrl.html',
        url: '/invalid-url',
        controller: 'invalidUrlCtrl',
        resolve: {
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      })
      .state('underMaintenance', {
        templateUrl: 'app/user/underMaintenance/underMaintenanceTemplate.html',
        url: '/underMaintenance',
        controller: 'underMaintenanceCtrl',
        resolve: {
          style: function($rootScope){
            $rootScope.bodyClasses = 'gray-bg';
          }
        }
      });
    $urlRouterProvider.otherwise('/login');

    angular.extend(toastrConfig, {
      allowHtml: true,
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      extendedTimeOut: 1000,
      maxOpened: 0,
      newestOnTop: true,
      progressBar: true,
      onHidden: null,
      onShown: null,
      tapToDismiss: true,
      target: 'body',
      timeOut: 5000
    });

  })
  .run(function ($rootScope, $location, $window, cfpLoadingBar, editableOptions, editableThemes,
                 $timeout, Rollbar, pathConstants, $state) {

    var url = $location.absUrl().substr(0, 4);

    // Checks if accessed url is not valid
    if (!!url && url.toLowerCase() !== 'http') {
      $state.go('invalidUrl');
    }

    /**
     * disabling Rollbar in case 'production' was not provided
     */
    var trackedEnvironments = ['production', 'stg', 'sit', 'staging', 'development'];

    if (!pathConstants.RollbarConfiguration || !pathConstants.RollbarConfiguration.environment
      || trackedEnvironments.indexOf(pathConstants.RollbarConfiguration.environment) === -1) {
      Rollbar.disable();
    }

    $rootScope.buildNumber = (!!pathConstants.RollbarConfiguration && !!pathConstants.RollbarConfiguration.buildNumber)
      ? pathConstants.RollbarConfiguration.buildNumber : 'Not specified';

    $rootScope.previousState = {
      page: {}
    };
    $rootScope.scrollPosition = {};

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      cfpLoadingBar.start();
      cfpLoadingBar.set(0.5);

      $rootScope.previousState.name = fromState.name;
      $rootScope.previousState.params = fromParams;
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      $rootScope.previousState.name = fromState.name;
      $rootScope.previousState.params = fromParams;

      $rootScope.actualLocation = $location.path();

      cfpLoadingBar.complete();

      //scroll fix
      $rootScope.fixPosition(toState, toParams, fromState, fromParams);
    });

    $rootScope.fixPosition = function (toState, toParams, fromState, fromParams) {
      var x = null;
      var y = null;

      if (toState.name === fromState.name) {
        if (toParams.status !== fromParams.status) {
          x = 0;
          y = 0;
        }
      } else if (fromState.name.replace(/manage|search/, "") === toState.name.replace("detail", "")) {
        $rootScope.scrollPosition[fromState.name + "_" + fromParams.status + "_" + "x"] = $window.pageXOffset;
        $rootScope.scrollPosition[fromState.name + "_" + fromParams.status + "_" + "y"] = $window.pageYOffset;
        x = 0;
        y = 0;
      } else if (fromState.name.replace("detail", "") === toState.name.replace(/manage|search/, "")) {
        if (toParams.status !== fromParams.status) {
          x = 0;
          y = 0;
        } else {
          x = $rootScope.scrollPosition[toState.name + "_" + fromParams.status + "_" + "x"] || 0;
          y = $rootScope.scrollPosition[toState.name + "_" + fromParams.status + "_" + "y"] || 0;
        }
      } else if (toState.name.replace(fromState.name, "") === ".catalog.tab") {
        $rootScope.scrollPosition[fromState.name + "_" + fromParams.status + "_" + "x"] = $window.pageXOffset;
        $rootScope.scrollPosition[fromState.name + "_" + fromParams.status + "_" + "y"] = $window.pageYOffset;
        x = 0;
        y = 0;
      } else if (fromState.name.replace(toState.name, "") === ".catalog.tab") {
        x = $rootScope.scrollPosition[toState.name + "_" + fromParams.status + "_" + "x"] || 0;
        y = $rootScope.scrollPosition[toState.name + "_" + fromParams.status + "_" + "y"] || 0;
      } else {
        x = 0;
        y = 0;
        $rootScope.scrollPosition = {};
      }

      $timeout(function () {
        if (x != null && y != null) {
          $window.scroll(x || 0, y || 0);
        }
      });
    };


    // Config xeditable
    editableOptions.theme = 'bs3';
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm';
  });


'use strict';

/**
 * @name userProfileCtrl
 * @desc Controller for user profile
 */
function userProfileCtrl($scope, $state, globalFunc, $auth, profile, Account, toastr, pathConstants,
                         $rootScope, ManageLocalStorage, updateProfile) {
  $scope.loading = false;
  $scope.removeCachedData = removeCachedData;
  $scope.selectedEmailFrequency = selectedEmailFrequency;
  $scope.isUploadImageError = isUploadImageError;
  $scope.delegatee = {};

  $scope.emailFrequency = [
    {descr: 'Immediate', value: true, id: 1 },
    {descr: 'End of Day', value: false, id: 2}
  ];

  function selectedEmailFrequency(value){

    swal({
      title: 'Set Email Notification Frequency',
      text: 'Confirm update your email notification frequency?',
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        updateProfile.put(
          {
            id: $scope.profile._id
          },
          {
            receive_email_immediate: value
          },
          function(){
            toastr.success('Email notification frequency updated');
            profile.receive_email_immediate = value;
          }
        );
      } else {
        if(!!profile.receive_email_immediate)
          $scope.activeRadio = 1;
        else
          $scope.activeRadio = 2;
      }
    });
  }

  function removeCachedData() {
    swal({
      title: 'Clearing Cached Data',
      text: 'Metabuyer makes itself snappy by storing non-sensitive data like Commodity Codes and Preferences in Local Storage of your browser. Confirming this clear the cached data and force Metabuyer to renew it for you.',
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        ManageLocalStorage.clearLocalStorage('All');
        toastr.success('Cached data removed');
      }
    });
  }

  function isUploadImageError(file, message, flow){
    var error;
    try{
      error = JSON.parse(message);
    }catch (e){
      error = 'Error occurred while uploading'
    }
    globalFunc.objectErrorMessage(error);
  }

  $scope.isUploadImageSuccess = function (file, message, flow) {
    if (!!message) {
      toastr.success('Image updated successfully');
      loadNewProfileData();
    }
  };

  function loadNewProfileData(){
    Account.getProfile()
      .then(function (data) {
        if ((data.status === 404)) {
          $auth.logout();
          $state.go('login');
        }
        if (!!data && !!data.content && !!data.content.data) {
          $scope.user = data.content.data;
          $rootScope.currentUser = $scope.user;
        }
      })
      .catch(function (error) {
        if (error) {
          console.error(error);
          $auth.logout();
          $state.go('login');
        }
      });
  }

  // handle company & cost center
  $scope.companies = [];
  $scope.handleGroup = function(objects){
    var groups = [];

    for(var index in objects){
      var obj = objects[index];
      var group = undefined;

      for(var i in groups){
        if(obj.company_code === groups[i].code){
          group = groups[i];
          break;
        }
      }

      if(group){
        group.costCenters.push(obj);
      } else {
        groups.push({
          code: obj.company_code,
          name: obj.company_name,
          costCenters: [obj]
        })
      }
    }

    return groups;
  };
  $scope.companies = $scope.handleGroup(profile.costCenters);

  function initialize() {
    $scope.imageBasePath = pathConstants.apiUrls.image.user + '/';
    $scope.profile = _.cloneDeep(profile);

    if (!!($scope.profile) && !_.isUndefined($scope.profile.receive_email_immediate)) {
        if (!!profile.receive_email_immediate){
          $scope.activeRadio = 1;
        }else{
          $scope.activeRadio = 2;
        }
    }

    // config flowjs
    $scope.flowConfig = new Flow({
      target: Account.uploadImagePath($scope.profile._id),
      singleFile: true,
      testChunks:false,
      chunkSize : 10000000,
      headers: {
        'Authorization': 'Bearer ' + $auth.getToken()
      }
    });
  }
  initialize();
}


userProfileCtrl.$inject = [
  '$scope', '$state', 'globalFunc', '$auth', 'profile', 'Account', 'toastr', 'pathConstants',
  '$rootScope', 'ManageLocalStorage', 'updateProfile'
];
angular
  .module('metabuyer')
  .controller('userProfileCtrl', userProfileCtrl);

'use strict';

/**
 * @name subscriptionsCtrl
 * @desc Controller for user subscriptions
 */
function subscriptionsCtrl($scope, $state){

}
subscriptionsCtrl.$inject = ['$scope', '$state'];
angular
  .module('metabuyer')
  .controller('subscriptionsCtrl', subscriptionsCtrl);

'use strict';
/**
 * Controller for listing supplier groups
 * @param $scope
 * @param $stateParams
 * @param dataList
 * @param listingBusinessUnits
 */
function supplierGroupsCtrl($scope, $stateParams, dataList, listingBusinessUnits) {

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function initialize(){
    $scope.status = $stateParams.status;
    $scope.title = $stateParams.title;
    $scope.dataList = dataList.data;
    $scope.meta = dataList.meta;
    $scope.listingBUService = listingBusinessUnits;
    $scope.showColumn = showColumn;

    $scope.storageKey = 'supplier-groups-listing-selected-columns';
  }

  initialize();

}

supplierGroupsCtrl.$inject = ['$scope','$stateParams', 'dataList', 'listingBusinessUnits'];

angular.module('metabuyer')
  .controller('supplierGroupsCtrl', supplierGroupsCtrl);

'use strict';

/**
 * Controller for viewing supplier groups
 * @param $scope
 * @param globalFunc
 * @param suppliersByGroup
 * @param suppliersList
 * @param $stateParams
 * @param $rootScope
 * @param HighlightId
 * @param supplierGlobalFunc
 */

function supplierGroupDetailCtrl(
  $scope, globalFunc, suppliersByGroup, suppliersList, $stateParams, $rootScope, HighlightId, supplierGlobalFunc
) {

  function back(){
    window.history.back();
  }

  function getStatusName(bu_status, status){
    if($scope.supplierBUCode.toLowerCase() === 'global'){
      if (status === 1) {
        return 'Active'
      }
      if (status === 2) {
        return 'Black Listed'
      }
      if (status === 6) {
        return 'Inactive'
      }
    }
    else{
      var buStatusAsArray = globalFunc.reformatFromObjectToArray(bu_status);
      var supplierStatus;
      _.forEach(buStatusAsArray, function(bu){
        if(bu.key === $scope.supplierBUCode){
          supplierStatus = bu.value.status;
        }
      });

      if (supplierStatus === 1) {
        return 'Active'
      }
      if (supplierStatus === 2) {
        return 'Black Listed'
      }
      if (supplierStatus === 6) {
        return 'Inactive'
      }
    }
  }

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * Check if current user has system role: Supplier Manager
   *
   * @returns {boolean}
   */
  function isCurrentUserSupplierManager () {
    return (supplierGlobalFunc.checkIfUserHasSupplierManagerRole($rootScope.currentUser));
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    /**
     * Switch case to display readable status
     */
    switch($stateParams.status){
      case 'all':
        $scope.supplierBUStatus = 'all';
        break;
      case 'active':
        $scope.supplierBUStatus = 'active';
        break;
      case 'black_listed':
        $scope.supplierBUStatus = 'black listed';
        break;
      case 'inactive':
        $scope.supplierBUStatus = 'inactive';
        break;
    }

    $scope.supplierBUCode = $stateParams.bu_code;
    $scope.supplierBUDescr = $stateParams.bu_descr;
    $scope.title = $stateParams.title;
    $scope.dataList = suppliersByGroup.data;
    $scope.meta = suppliersByGroup.meta;
    $scope.listingSupplierService = suppliersList;
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;
    $scope.getStatusName = getStatusName;
    $scope.showColumn = showColumn;
    $scope.back = back;
    $scope.isCurrentUserSupplierManager = isCurrentUserSupplierManager;

    $scope.storageKey = 'suppliers-listing-by-bu-selected-columns';
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();
}

supplierGroupDetailCtrl.$inject = [
  '$scope', 'globalFunc', 'suppliersByGroup', 'suppliersList', '$stateParams', '$rootScope', 'HighlightId', 'supplierGlobalFunc'
];

angular.module('metabuyer')
  .controller('supplierGroupDetailCtrl', supplierGroupDetailCtrl);

'use strict';

function supplierBranchDetailCtrl($scope, param, branchIndex, branches, $uibModalInstance, globalFunc, editable, $timeout, $rootScope, toastr) {
  $scope.branchesDetails = _.cloneDeep(param);
  $scope.editClicked = editable;
  $scope.closeModal = closeModal;
  $scope.saveBranchDetails = saveBranchDetails;
  $scope.validateEmail = validateEmail;
  $scope.removeContact = removeContact;
  $scope.addContact = addContact;
  $scope.onUpdatedContact = onUpdatedContact;
  $scope.onUpdatedState = onUpdatedState;
  $scope.onUpdatedCountry = onUpdatedCountry;
  $scope.countries = globalFunc.countryCode();
  $scope.MYStates = globalFunc.malaysiaState();

  $scope.branchStatus = [
    {descr: 'Active', value: 1},
    {descr: 'Inactive', value: 0}
  ];


  function validate() {
    var result = [];
    result.decision = false;
    if(!$scope.branchesDetails.descr) {
      result.reason = 'fill in Supplier Branch Name';
      return result;
    }

    if (!validateBranchUnique($scope.branchesDetails.descr, branchIndex)) {
      result.reason = 'use unique Supplier Branch Name';
      return result;
    }

    if((!$scope.branchesDetails.receive_via_fax && !$scope.branchesDetails.receive_via_email
      && !$scope.branchesDetails.receive_via_post)) {
      result.reason = 'select one method of receiving PO';
      return result;
    }

    if(!!$scope.branchesDetails.receive_via_email) {
      if(!$scope.branchesDetails.email) {
        result.reason = 'fill in Branch Email Address';
        return result;
      }
    }

    if(!!$scope.branchesDetails.email && !validateEmail($scope.branchesDetails.email)) {
      result.reason = 'enter Branch Email Address with the correct format';
      return result;
    }

    if(!!$scope.branchesDetails.receive_via_fax) {
      if(!$scope.branchesDetails.fax) {

        result.reason = 'fill in Branch Fax Number';
        return result;
      }
    }

    if(!$scope.branchesDetails.phone) {
      result.reason = 'fill in Branch Phone Number';
      return result;
    }

    if(!$scope.branchesDetails.address || !$scope.branchesDetails.address.line1 || !$scope.branchesDetails.address.city ||
      !$scope.branchesDetails.address.state || !$scope.branchesDetails.address.country ||
      !$scope.branchesDetails.address.postal_code) {
      result.reason = 'fill in Branch Corresponding Address';
      return result;
    }

    if(!validatePostalCode($scope.branchesDetails.address.postal_code)) {
      result.reason = 'enter a correct postal code (alphanumeric only)';
      return result;
    }

    if($scope.branchesDetails.contact.length == 0) {
      result.reason = 'create a Branch contact person';
      return result;
    }

    if($scope.branchesDetails.isActive !== 0 && $scope.branchesDetails.isActive !== 1) {
      result.reason = 'select Branch Status';
      return result;
    }

    result.decision = true;
    return result;
  }

  function validateBranchUnique(branchName, branchIndex) {
    var i = 0;
    for (i; i < branches.length; i++) {
      if (i != branchIndex && branchName == branches[i].descr) {
        return false;
      }
    }
    return true;
  }

  function validateEmail(email) {
    var regex = /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }

  function validatePostalCode(postalCode) {
    var regex = /^[a-z0-9]+$/i;
    return regex.test(postalCode);
  }

  function closeModal() {
    $uibModalInstance.close();
  }

  function onUpdatedCountry(country) {
    $scope.branchesDetails.address.state = undefined;
    if (!!country.descr) {
      $scope.branchesDetails.address.country = country.descr;
      $scope.selectedMalaysia = (country.descr === 'Malaysia');
    }
  }

  function onUpdatedState(state) {
    if (!!state) {
      $scope.branchesDetails.address.state = state.descr;
    }
  }

  function saveBranchDetails() {
    if (validate().decision) {
      $uibModalInstance.close($scope.branchesDetails);
    } else {
      toastr.error('Please ' + validate().reason + ' to create a new branch');
    }
  }

  function removeContact(contact) {
    var index = _.findIndex($scope.branchesDetails.contact, function (item) {
      return item._id == contact._id;
    });

    $scope.branchesDetails.contact.splice(index, 1);
  }

  function addContact(contact) {
    var spliceIndex = $scope.branchesDetails.contact[0];
    if (!!spliceIndex) {
      $scope.branchesDetails.contact.push(contact);
    }
    /**
     * If the first index is null, undefined or empty
     */
    else {
      $scope.branchesDetails.contact.splice(spliceIndex, 1, contact);
    }
  }

  function onUpdatedContact(contact) {
    var index = _.findIndex($scope.branchesDetails.contact, function (item) {
      return item._id == contact._id;
    });
    $scope.branchesDetails.contact.splice(index, 1, contact);
  }


}

supplierBranchDetailCtrl.$inject = [
  '$scope', 'param', 'branchIndex', 'branches', '$uibModalInstance', 'globalFunc', 'editable', '$timeout', '$rootScope', 'toastr'
];

angular.module('metabuyer')
  .controller('supplierBranchDetailCtrl', supplierBranchDetailCtrl);

'use strict';
/**
 * @name addSupplierBranches
 * @desc Controller to add branch to supplier
 */
function addSupplierBranches($scope, toastr, branches, globalFunc, $uibModalInstance, $timeout) {
  $scope.closeModal = closeModal;
  $scope.newBranch = newBranch;
  $scope.validateEmail = validateEmail;
  $scope.onUpdatedCountry = onUpdatedCountry;
  $scope.onUpdatedState = onUpdatedState;
  $scope.addContact = addContact;
  $scope.removeContact = removeContact;
  $scope.onUpdatedContact = onUpdatedContact;
  $scope.branches = {};
  $scope.branches.contact=[];

  function closeModal() {
    $uibModalInstance.close();
  }
  $scope.branchStatus = [{
    descr: 'Active',
    value: 1
  },{
    descr: 'Inactive',
    value: 0
  } ];

  function newBranch() {
    if (validate().decision) {
      $uibModalInstance.close($scope.branches);
    } else {
      toastr.error('Please ' + validate().reason + ' to create a new branch');
    }
  }

  function onUpdatedCountry(country) {
    $scope.branches.address.state = '';
    if (!!country.descr) {
      $scope.branches.address.country = country.descr;
      $scope.selectedMalaysia = (country.descr === 'Malaysia');
    }
  }

  function onUpdatedState(state) {
    if (!!state) {
      $scope.branches.address.state = state.descr;
    }
  }

  function addContact(contact) {
    var spliceIndex = $scope.branches.contact[0];
    if (!!spliceIndex) {
      $scope.branches.contact.push(contact);
    }
    /**
     * If the first index is null, undefined or empty
     */
    else {
      $scope.branches.contact.splice(spliceIndex, 1, contact);
    }
  }

  function removeContact(contact) {
    var index = _.findIndex($scope.branches.contact, function (item) {
      return item._id == contact._id;
    });
    $scope.branches.contact.splice(index, 1);
  }

  function onUpdatedContact(contact) {
    var index = _.findIndex($scope.branches.contact, function (item) {
      return item._id == contact._id;
    });

    $scope.branches.contact.splice(index, 1, contact);
  }

  function validateEmail(email) {
    var regex = /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }

  function validatePostalCode(postalCode) {
    var regex = /^[a-z0-9]+$/i;
    return regex.test(postalCode);
  }

  function validateBranchUnique(name) {
    var sameBranchName = globalFunc.findInArray(branches,'descr', name);
    return (!sameBranchName);
  }

  function validate() {

    var result = [];
    result.decision = false;
    if(!$scope.branches.descr) {
      result.reason = 'fill in Supplier Branch Name';
      return result;
    }

    if (!validateBranchUnique($scope.branches.descr)) {
      result.reason = 'use unique Supplier Branch Name';
      return result;
    }

    if((!$scope.branches.receive_via_fax && !$scope.branches.receive_via_email
      && !$scope.branches.receive_via_post)) {
      result.reason = 'select one method of receiving PO';
      return result;
    }

    if(!!$scope.branches.receive_via_email) {
      if(!$scope.branches.email) {
        result.reason = 'fill in Branch Email Address';
        return result;
      }
    }

    if (!!$scope.branches.email && !validateEmail($scope.branches.email)) {
      result.reason = 'enter Branch Email Address with the correct format';
      return result;
    }

    if(!!$scope.branches.receive_via_fax) {
      if(!$scope.branches.fax) {

        result.reason = 'fill in Branch Fax Number';
        return result;
      }
    }

    if(!$scope.branches.phone) {
      result.reason = 'fill in Branch Phone Number';
      return result;
    }

    if(!$scope.branches.address || !$scope.branches.address.line1 || !$scope.branches.address.city ||
      !$scope.branches.address.state || !$scope.branches.address.country ||
      !$scope.branches.address.postal_code) {
      result.reason = 'fill in Branch Corresponding Address';
      return result;
    }

    if(!validatePostalCode($scope.branches.address.postal_code)) {
      result.reason = 'enter a correct postal code (alphanumeric only)';
      return result;
    }

    if($scope.branches.contact.length == 0) {
      result.reason = 'create a Branch contact person';
      return result;
    }

    if($scope.branches.isActive !== 1 && $scope.branches.isActive !== 0) {
      result.reason = 'select Branch Status';
      return result;
    }

    result.decision = true;
    return result;
  }

  function initialize() {

    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();

    /**
     * To initialize country by looping and comparing descr with returned data
     */
    if (!!$scope.branches.country) {
      if (!!globalFunc.findInArray($scope.countries, 'descr', $scope.address.branches.country)
        && globalFunc.findInArray($scope.countries, 'descr', $scope.address.branches.country).descr ===
        $scope.address.branches.country) {
        $scope.selectedMalaysia = ($scope.address.branches.country === 'Malaysia');
      }
    }
  }

  initialize();

}

addSupplierBranches.$inject = [
  '$scope', 'toastr', 'branches', 'globalFunc', '$uibModalInstance', '$timeout'
];

angular
  .module('metabuyer')
  .controller('addSupplierBranches', addSupplierBranches);

'use strict';

function supplierTagsBySupplierCtrl($scope, suppliersList, $stateParams, $state, detailState, HighlightId)
{

  $scope.showColumn = showColumn;
  $scope.supplierTagDetails = supplierTagDetails;
  $scope.getStatusName = getStatusName;

  function showColumn (id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function supplierTagDetails (supplier) {
    $state.go(detailState,
      {
        supplierCode: supplier.mb_supplier_code,
        supplierName: supplier.descr
      });
  }

  function getStatusName(status){
    switch (status) {
      case 1:
        return 'Active';
        break;
      case 2:
        return 'Black Listed';
        break;
      case 6:
        return 'Inactive';
        break;
      default:
        return 'N/A';
    }
  }

  function initialize () {
    $scope.dataList = suppliersList.data;
    $scope.storageKey = 'supplier-tags-by-supplier-selected-columns';
    $scope.meta = suppliersList.meta;
    $scope.suppliersService = suppliersList;
    $scope.status = $stateParams.status;
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();
}

supplierTagsBySupplierCtrl.$inject = [
  '$scope', 'suppliersList', '$stateParams', '$state', 'detailState', 'HighlightId'
];

angular.module('metabuyer')
  .controller('supplierTagsBySupplierCtrl', supplierTagsBySupplierCtrl);

'use strict';

/**
 * @name supplierTagsBySupplierDetailCtrl
 *
 * @description Controller for supplier tags grouped by selected supplier
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright 2018 Metacloud Sdn. Bhd.
 */
function supplierTagsBySupplierDetailCtrl($scope, companiesTaggedToSupplier, $rootScope, supplierName, HighlightId,
                                          $stateParams, supplierGlobalFunc) {

  $scope.showColumn = showColumn;
  $scope.back = back;
  $scope.isCurrentUserSupplierManager = isCurrentUserSupplierManager;

  function showColumn(id) {
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if (!!$scope.columns[i].conditional) {
          if ($scope.status === $scope.columns[i].condition) {
            return $scope.columns[i].selected;
          }
          if ($scope.columns[i].condition instanceof Array) {
            for (var j in $scope.columns[i].condition) {
              if ($scope.status === $scope.columns[i].condition[j]) {
                return $scope.columns[i].selected;
              }
            }
          }
        } else {
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function back() {
    if (!!$stateParams.supplierCode) {
      HighlightId.setId($stateParams.supplierCode);
    }
    window.history.back();
  }

  /**
   * Check if current user has system role: Supplier Manager
   *
   * @returns {boolean}
   */
  function isCurrentUserSupplierManager() {
    return (supplierGlobalFunc.checkIfUserHasSupplierManagerRole($rootScope.currentUser));
  }

  function initialize() {
    $scope.editClicked = false;
    $scope.supplierName = supplierName;
    $scope.companiesTaggedToSupplier = companiesTaggedToSupplier.data;
    $scope.meta = companiesTaggedToSupplier.meta;
    $scope.supplierTagService = companiesTaggedToSupplier;
    $scope.storageKey = 'companies-tagged-to-supplier-selected-columns';
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

supplierTagsBySupplierDetailCtrl.$inject = [
  '$scope', 'companiesTaggedToSupplier', '$rootScope', 'supplierName', 'HighlightId', '$stateParams',
  'supplierGlobalFunc'
];

angular.module('metabuyer')
  .controller('supplierTagsBySupplierDetailCtrl', supplierTagsBySupplierDetailCtrl);

'use strict';

function supplierTagsByCompanyCtrl($scope, companiesList, $stateParams, $state, detailState, HighlightId)
{

  $scope.showColumn = showColumn;
  $scope.supplierTagDetails = supplierTagDetails;

  function showColumn (id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function supplierTagDetails (company) {
    $state.go(detailState,
      {
        companyCode: company.code,
        companyName: company.descr,
        companyId: company._id
      });
  }

  function initialize () {
    $scope.dataList = companiesList.data;
    $scope.storageKey = 'supplier-tags-by-company-selected-columns';
    $scope.meta = companiesList.meta;
    $scope.companiesService = companiesList;
    $scope.status = $stateParams.status;
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();
}

supplierTagsByCompanyCtrl.$inject = [
  '$scope', 'companiesList', '$stateParams', '$state', 'detailState', 'HighlightId'
];

angular.module('metabuyer')
  .controller('supplierTagsByCompanyCtrl', supplierTagsByCompanyCtrl);

'use strict';

/**
 * @name supplierTagsByCompanyDetailCtrl
 *
 * @description Controller for supplier tags grouped by selected company
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright 2018 Metacloud Sdn. Bhd.
 */
function supplierTagsByCompanyDetailCtrl($scope, suppliersTaggedToCompany, $rootScope, companyName, $stateParams,
                                         supplierGlobalFunc, detailState, $state, canEditSupplierTag, HighlightId) {

  $scope.showColumn = showColumn;
  $scope.back = back;
  $scope.getStatusName = getStatusName;
  $scope.goToSupplierTagging = goToSupplierTagging;
  $scope.isCurrentUserSupplierManager = isCurrentUserSupplierManager;

  function showColumn(id) {
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if (!!$scope.columns[i].conditional) {
          if ($scope.status === $scope.columns[i].condition) {
            return $scope.columns[i].selected;
          }
          if ($scope.columns[i].condition instanceof Array) {
            for (var j in $scope.columns[i].condition) {
              if ($scope.status === $scope.columns[i].condition[j]) {
                return $scope.columns[i].selected;
              }
            }
          }
        } else {
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function back() {
    if (!!$stateParams.companyId) {
      HighlightId.setId($stateParams.companyId);
    }

    window.history.back();
  }

  /**
   * returns the status name
   * @param supplierStatus
   * @param approvalStatus
   * @param draftingStatus
   * @returns {*}
   */
  function getStatusName(supplierStatus, approvalStatus, draftingStatus) {
    var status = supplierGlobalFunc.getSupplierStatus(supplierStatus, approvalStatus, draftingStatus, 'val');
    if (!!status)
      return status;

    return 'N/A';
  }

  function goToSupplierTagging() {
    $state.go(detailState,
      {
        companyCode: $scope.companyCode
      });
  }

  /**
   * Check if current user has system role: Supplier Manager
   *
   * @returns {boolean}
   */
  function isCurrentUserSupplierManager() {
    return (supplierGlobalFunc.checkIfUserHasSupplierManagerRole($rootScope.currentUser));
  }

  function initialize() {
    $scope.editClicked = false;
    $scope.canEditSupplierTag = canEditSupplierTag;
    $scope.companyName = companyName;
    $scope.companyCode = $stateParams.companyCode;
    $scope.suppliersTaggedToCompany = suppliersTaggedToCompany.data;
    $scope.meta = suppliersTaggedToCompany.meta;
    $scope.supplierTagService = suppliersTaggedToCompany;
    $scope.storageKey = 'suppliers-tagged-to-company-selected-columns';
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

supplierTagsByCompanyDetailCtrl.$inject = [
  '$scope', 'suppliersTaggedToCompany', '$rootScope', 'companyName', '$stateParams', 'supplierGlobalFunc',
  'detailState', '$state', 'canEditSupplierTag', 'HighlightId'
];

angular.module('metabuyer')
  .controller('supplierTagsByCompanyDetailCtrl', supplierTagsByCompanyDetailCtrl);

'use strict';
/**
 * Controller for listing supplier groups
 * @param $scope
 * @param $stateParams
 * @param dataList
 * @param listingBusinessUnits
 */
function supplierListGroupsCtrl($scope, $stateParams, dataList, listingBusinessUnits) {

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function initialize(){
    $scope.status = $stateParams.status;
    $scope.title = $stateParams.title;
    $scope.dataList = dataList.data;
    $scope.meta = dataList.meta;
    $scope.listingBUService = listingBusinessUnits;
    $scope.showColumn = showColumn;

    $scope.storageKey = 'supplier-groups-listing-selected-columns';
  }

  initialize();

}

supplierListGroupsCtrl.$inject = ['$scope','$stateParams', 'dataList', 'listingBusinessUnits'];

angular.module('metabuyer')
  .controller('supplierListGroupsCtrl', supplierListGroupsCtrl);

'use strict';

/**
 * Controller for viewing supplier groups
 * @param $scope
 * @param globalFunc
 * @param suppliersByGroup
 * @param suppliersList
 * @param $stateParams
 * @param $rootScope
 * @param HighlightId
 */

function supplierListGroupDetailCtrl(
  $scope, globalFunc, suppliersByGroup, suppliersList, $stateParams, $rootScope, HighlightId
) {

  function back(){
    window.history.back();
  }

  function getStatusName(bu_status, status){
    if($scope.supplierBUCode.toLowerCase() === 'global'){
      if (status === 1) {
        return 'Active'
      }
      if (status === 2) {
        return 'Black Listed'
      }
      if (status === 6) {
        return 'Inactive'
      }
    }
    else{
      var buStatusAsArray = globalFunc.reformatFromObjectToArray(bu_status);
      var supplierStatus;
      _.forEach(buStatusAsArray, function(bu){
        if(bu.key === $scope.supplierBUCode){
          supplierStatus = bu.value.status;
        }
      });

      if (supplierStatus === 1) {
        return 'Active'
      }
      if (supplierStatus === 2) {
        return 'Black Listed'
      }
      if (supplierStatus === 6) {
        return 'Inactive'
      }
    }
  }

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    /**
     * Switch case to display readable status
     */
    switch($stateParams.status){
      case 'all':
        $scope.supplierBUStatus = 'all';
        break;
      case 'active':
        $scope.supplierBUStatus = 'active';
        break;
      case 'black_listed':
        $scope.supplierBUStatus = 'black listed';
        break;
      case 'inactive':
        $scope.supplierBUStatus = 'inactive';
        break;
    }

    $scope.supplierBUCode = $stateParams.bu_code;
    $scope.supplierBUDescr = $stateParams.bu_descr;
    $scope.title = $stateParams.title;
    $scope.dataList = suppliersByGroup.data;
    $scope.meta = suppliersByGroup.meta;
    $scope.listingSupplierService = suppliersList;
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;
    $scope.getStatusName = getStatusName;
    $scope.showColumn = showColumn;
    $scope.back = back;

    $scope.storageKey = 'suppliers-listing-by-bu-selected-columns';
    $scope.highlightId = HighlightId.getId();
    if(!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();
}

supplierListGroupDetailCtrl.$inject = [
  '$scope', 'globalFunc', 'suppliersByGroup', 'suppliersList', '$stateParams', '$rootScope', 'HighlightId'
];

angular.module('metabuyer')
  .controller('supplierListGroupDetailCtrl', supplierListGroupDetailCtrl);

'use strict';
/**
 * @name approvalFlowCtrl
 * @desc Controller for Approval Flow Management Parent Controller
 */
function PRPOPrefixCtrl ($scope, companies, $uibModal, $q, companyReferenceCounter, toastr, $filter, globalFunc) {
  $scope.companies = companies.data;
  $scope.openPrefixPanel = openPrefixPanel;

  function openPrefixPanel(company) {
    $scope.prefixes = null;
    $scope.companyTitle = company.descr;
    var prefixModal = $uibModal.open({
        templateUrl: 'app/settings/PR-POSettings/prefix/prefixModalTemplate.html',
        backdrop: 'static',
        keyboard: false,
        scope: $scope,
//        windowClass: 'preFix-modal-window',
        controller: function($scope, prefix){
          $scope.closeModal = closeModal;
          $scope.onSelectedPrefixType = onSelectedPrefixType;
          $scope.addPrefix = addPrefix;
          $scope.updatePrefix = updatePrefix;
          $scope.validateXeditable = validateXeditable;
          $scope.replaceStringCase = replaceStringCase;
//          $scope.deletePrefix = deletePrefix;
          $scope.editMode = editMode;
          $scope.initialize = initialize;

          $scope.prefixTypes = [
            {descr: 'PR', value: 'purchase_requisition'},
            {descr: 'PO', value: 'purchase_order'},
            {descr: 'GRN', value: 'goods_received_note'}
          ];

          /**
           * To replace the Case of the status and remove the underscore
           * @param string
           * @returns {*}
           */
          //TODO: To put this function and the one in orders manage into global function (Justin 26/2/2016)
          function replaceStringCase(string){
            var newString = string.replace(/_/g, ' ');
            newString = $filter('titleCase')(newString);
            return newString;
          }

          $scope.editClicked = false;

          function closeModal() {
            $scope.$close();
          }

          function onSelectedPrefixType(prefixType){
            $scope.prefixType = prefixType.value;
          }

          function addPrefix(addPrefixModel, addPrefixCount){

              var submit_data =
              {
                prefix: addPrefixModel,
                suffix: 'MB',
                type: $scope.prefixType,
                count: addPrefixCount,
                length: 8,
                separator: '-',
                format: '#prefix#company_code#suffix#count',
                company_code: company.code
              };

              companyReferenceCounter.post(
                {
                  companyId: company._id
                },
                submit_data,
                function (resource) {
                  $scope.prefixes.push(resource.content.data);
                  $scope.addPrefixField = undefined;
                  $scope.addPrefixCount = undefined;
                  $scope.selectPrefixType = undefined;
                },
                function (error) {
                  toastr.error(error.data.message);
                }
              );
          }

          /**
           *
           * @param data
           * @param prefixObject
           * @returns {*}
           *
           * Function to validate the editable field before saving
           */
          function validateXeditable(data, prefixObject) {
            if (data === undefined) {
              return 'Please enter a prefix';
            }
            if(data === prefixObject.prefix){
              return false;
            }
          }

          function updatePrefix(prefixModel, prefixObject, index){
            if(!validateXeditable){
              return false;
            }
            else{
              var update_data =
              {
                prefix: prefixModel,
                suffix: 'MB',
                type: prefixObject.type,
                count: prefixObject.count,
                length: prefixObject.length,
                separator: prefixObject.separator,
                format: '#prefix#company_code#suffix#count',
                company_code: company.code
              };

              companyReferenceCounter.put(
                {
                  companyId: company._id,
                  referenceId: prefixObject._id
                },
                update_data,
                function(resource){
                  toastr.success('Successfully updated prefix');
                  $scope.prefixes[index] = resource.content.data;
                },
                function(error){
                  globalFunc.objectErrorMessage(error);
//                  $scope.prefixes[index] =
                }
              );
            }
          }

//          function deletePrefix(prefixObject, index){
//            companyReferenceCounter.delete(
//              {
//                companyId: company._id,
//                referenceId: prefixObject._id
//              },
//              function(){
//                toastr.success('Successfully deleted prefix');
//                $scope.prefixes.splice(index, 1);
//              },
//              function(error){
//                toastr.error(error.data.message);
//              }
//            );
//          }

          function editMode(){
            $scope.editClicked = true;
          }

          function initialize(){
            $scope.companyPrefix = prefix[0].prefix;
          }

        },
        resolve: {
          prefix: function () {
            var deferred = $q.defer();
            companyReferenceCounter.get(
              {
                companyId: company._id
              },
              function (resource) {
                if (!!resource.content) {
                  $scope.prefixes = resource.content.data;
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          }
        }
      }
    );
  }
}
PRPOPrefixCtrl.$inject = ['$scope', 'companies', '$uibModal', '$q', 'companyReferenceCounter', 'toastr', '$filter',
  'globalFunc'];

angular
  .module('metabuyer')
  .controller('PRPOPrefixCtrl', PRPOPrefixCtrl);

'use strict';
/**
 * @name MasterDataManageUOMCtrl
 * @desc Controller for master data UOM controller
 */
function MasterDataManageUOMCtrl($scope, $stateParams, uoms, uomList, $location, toastr, singleUom,
                                 $state, $uibModal, globalFunc,pathConstants) {
  $scope.dataList = uomList.data;
  $scope.meta = uomList.meta;
  $scope.uomService = uoms;

  $scope.search = search;
  $scope.newUom = newUom;
  $scope.uomDetails = uomDetails;
  $scope.importUOM = importUOM;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importLink = pathConstants.apiUrls.uom.import;
  $scope.params = {};
  $scope.showColumn = showColumn;
  $scope.columns = [

        {id: 'code', label: 'Code'},
        {id: 'descr', label: 'Description'},
        {id: 'fraction', label: 'Fraction Enabled'},
        {id: 'updated_at', label: 'Updated At'},
        {id: 'updater.display_name', label: 'Updated By'},
        {id: 'created_at', label: 'Created At'},
        {id: 'creator.display_name', label: 'Created By'},
        {id: 'is_active', label: 'Status'}
      ];

  $scope.storageKey = 'master-data-uom-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }


  $scope.uomFraction = [
    {
      status: 'Allow',
      value: 1
    },
    {
      status: 'Disallow',
      value: 0
    }
  ];

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  function search(query) {
    $location.search({query: query});
  }

  function importUOM() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'UOM';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function validate(uom){
    if (!uom){
      return false;
    }
    if (!uom.code){
      return false;
    }
    if (!uom.descr){
      return false;
    }
    if (!uom.is_fraction){
      return false;
    }
    return true;
  }

  function newUom() {

    $scope.submitted = true;
    if (validate($scope.uom)) {
      singleUom.post(
        {},
        {
          descr: $scope.uom.descr,
          code: $scope.uom.code,
          is_fraction: $scope.uom.is_fraction.value,
          is_active: 1
        },
        function (resource) {
          toastr.success('UOM was added successfully');
          if (!!resource.content && !!resource.content.data) {
            var addedUOM = resource.content.data;
            $scope.dataList.unshift({
              _id: addedUOM._id,
              code: addedUOM.code,
              descr: addedUOM.descr,
              is_fraction: addedUOM.is_fraction,
              created_at: addedUOM.created_at,
              updated_at: addedUOM.updated_at,
              updater: [$scope.user],
              creator: [$scope.user],
              is_active: 1
            });
          }
          $scope.uom.code = '';
          $scope.uom.descr = '';
          $scope.uom.is_fraction = null;
        },
        function (err) {
          globalFunc.objectErrorMessage(err);
        }
      )
    }
    else{
      toastr.error('Please fill all the required fields');
    }
  }

  function uomDetails(index) {
    var uomId = $scope.dataList[index]._id;
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/uom/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'uomDetailsCtrl',
      size: 'lg',
      resolve: {
        uomDetails: function($q, singleUom) {
          var deferred = $q.defer();
          singleUom.get(
            {
              id: uomId
            },
            function (resource) {
              deferred.resolve(resource.content || {data: []});
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_fraction = newValue.is_fraction;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  initialize();
}

MasterDataManageUOMCtrl.$inject = [
  '$scope', '$stateParams', 'uoms', 'uomList', '$location', 'toastr', 'singleUom', '$state',
  '$uibModal', 'globalFunc', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('MasterDataManageUOMCtrl', MasterDataManageUOMCtrl);

'use strict';
/**
 * @name uomDetailsCtrl
 * @desc Controller for master data UOM details controller
 */
function uomDetailsCtrl($scope, $uibModalInstance, uomDetails, singleUom, toastr, globalFunc) {
  $scope.editClicked = false;
  $scope.uomDetails = uomDetails.data;
  $scope.originalCode = $scope.uomDetails.code;

  // Statuses for dropdown in object
  $scope.uomStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];

  $scope.uomFraction = [
    {
      status: 'Allow',
      value: 1
    },
    {
      status: 'Disallow',
      value: 0
    }
  ];

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.uomDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\UOM',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab        = toggleTab;
  $scope.cancel           = cancel;
  $scope.editUOM          = editUOM;
  $scope.updateUom        = updateUom;
  $scope.duplicationCheck = duplicationCheck;

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function setFraction(uom){
    if(uom.is_fraction ===1){
      uom.is_fraction = {
        status: 'Allow',
        value: 1
      };
    }else{
      uom.is_fraction = {
        status: 'Disallow',
        value: 0
      };
    }
  }


  function cancel() {
    $uibModalInstance.close();
  }

  function editUOM(){
    $scope.editClicked = true;
  }

  function validate(uom){
    if (!uom){
      return false;
    }
    if (!uom.code){
      return false;
    }
    if (!uom.descr){
      return false;
    }
    if (!uom.uomStatus){
      return false;
    }
    if (!uom.is_fraction){
      return false;
    }
    return true;
  }

  function updateUom() {
    if(!!$scope.codeCheck){
      toastr.error($scope.uomDetails.code + ' is already in use');
    }
    else if(validate($scope.uomDetails)){
      swal({
          title: 'Confirm Updating the UOM',
          text: 'This will update the details for this UOM',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394  ',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {
            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.uomDetails.uomStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.uomDetails.is_active = $scope.uomDetails.uomStatus.isActive.toUpperCase();
            $scope.uomDetails.updated_at = new Date();

            singleUom.put(
              {
                id: $scope.uomDetails._id
              },
              {
                code: $scope.uomDetails.code,
                descr: $scope.uomDetails.descr,
                is_active: tempStatus,
                is_fraction: !!$scope.uomDetails.is_fraction ? $scope.uomDetails.is_fraction.value : 0
              },
              function (resource) {
                toastr.success('UOM has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          if($scope.uomDetails.code != $scope.originalCode){
            $scope.codeCheck = true;
          }
          else{
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }


  function initialize() {
    if(!!$scope.uomDetails.is_active) {
      $scope.uomDetails.uomStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.uomDetails.is_active)};
    }

    setFraction($scope.uomDetails);
  }

  initialize();
}

uomDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'uomDetails', 'singleUom', 'toastr', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('uomDetailsCtrl', uomDetailsCtrl);

'use strict';
/**
 * @name MasterDataManageTaxesCtrl
 * @desc Controller for master data tax controller
 */
function MasterDataManageTaxesCtrl($scope, dataList, $stateParams, toastr, $uibModal,
                                   taxesMasterDataList, $location, $filter, globalFunc,pathConstants, $timeout) {

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function initialize(){
    $scope.dataList = dataList.data;
    $scope.meta = dataList.meta;
    $scope.taxesMasterDataList = taxesMasterDataList;
    $scope.addNewTax = addNewTax;
    $scope.search = search;
    $scope.showColumn = showColumn;
    $scope.getActiveStatusName = getActiveStatusName;
    $scope.countryCode = globalFunc.countryCode();
    $scope.params = {};
    $scope.importTax = importTax;
    $scope.importLink = pathConstants.apiUrls.tax.import;

    // Datepicker
    $scope.openDatepicker = openDatepicker;

    $scope.startDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.datepickerOpened = {
      start_date: false,
      end_date: false
    };

    $scope.openTaxDetails = openTaxDetails;

    $scope.columns = [
      {id: 'code', label: 'Code'},
      {id: 'descr', label: 'Description'},
      {id: 'rate', label: 'Rate %'},
      {id: 'effective_at', label: 'Start date'},
      {id: 'expiry_at', label: 'End date'},
      {id: 'is_active', label: 'Status'}
    ];

    $scope.storageKey = 'master-data-tax-management-selected-columns';

    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  function validate(newTax){
    if (!newTax){
      return false;
    }
    if (!newTax.code){
      return false;
    }
    if (!newTax.descr) {
      return false;
    }
    if (!newTax.rate || (newTax.rate < 0)) {
      return false;
    }
    if (!newTax.countryCode) {
      return false;
    }
    if (!newTax.effective_at) {
      return false;
    }
    if (!newTax.expiry_at) {
      return false;
    }
    if (newTax.effective_at >= newTax.expiry_at){
      return false;
    }

    return true;
  }

  function addNewTax(newTax) {
    $scope.submitted = true;

    if(validate(newTax)) {
      var submitData = {
        code: newTax.code,
        descr: newTax.descr,
        is_active: 1,
        country_code: newTax.countryCode.descr,
        effective_at: globalFunc.convertDateToTimestamp(newTax.effective_at),
        expiry_at: globalFunc.convertDateToTimestamp(newTax.expiry_at),
        rate: newTax.rate
      };
      taxesMasterDataList.post(
        {},
        submitData,
        function (resource) {
          var addedTax = resource.content.data;
          toastr.success('The tax was added successfully');
          $scope.dataList.unshift({
            _id: addedTax._id,
            code: addedTax.code,
            descr: addedTax.descr,
            rate: addedTax.rate,
            effective_at: addedTax.effective_at,
            expiry_at: addedTax.expiry_at,
            is_active: 1
          });

          //to clear the ng-model fields
          $scope.newTax = {
            code: '',
            descr: '',
            rate: '',
            effective_at: '',
            expiry_at: ''
          };
          $scope.submitted = false;
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        });
    }
    else{
      toastr.error('Please fill in all the fields');
    }
  }

  function openDatepicker($event, which) {

    /**
     * Setting minimum selection for start date to be today
     */
    $scope.startDateOptions.minDate = new Date();

    /**
     * Setting the minimum selection for end date to be one day ahead of selected start date
     */
    var startDateClone = _.cloneDeep($scope.newTax.effective_at);
    var startDate = new Date(startDateClone);
    startDate.setDate(startDate.getDate() + 1);
    $scope.endDateOptions.minDate = startDate;

    if($scope.datepickerOpened[which]){
      $event.preventDefault();
      $event.stopPropagation();
    }
    else{
      $timeout(function(){
        $scope.datepickerOpened[which] = true;
      })
    }
  }

  function openTaxDetails(index) {
    var taxId = $scope.dataList[index]._id;
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/taxes/detail/detail.html',
      controller: 'taxDetailsCtrl',
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        taxDetails: function($q, taxesMasterDataList) {
          var deferred = $q.defer();
          taxesMasterDataList.get(
            {
              id: taxId
            },
            function (resource) {
              deferred.resolve(resource.content || {data: []});
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.rate = newValue.rate;
            dataList.is_active = newValue.is_active;
            dataList.effective_at = newValue.effective_at;
            dataList.expiry_at = newValue.expiry_at;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    });
  }

  function importTax() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Tax';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function search(query) {
    $location.search({query: query});
  }

  initialize();
}

MasterDataManageTaxesCtrl.$inject = [
  '$scope', 'dataList', '$stateParams', 'toastr', '$uibModal', 'taxesMasterDataList',
  '$location', '$filter', 'globalFunc', 'pathConstants', '$timeout'
];

angular
  .module('metabuyer')
  .controller('MasterDataManageTaxesCtrl', MasterDataManageTaxesCtrl);

'use strict';

function taxDetailsCtrl($scope, $uibModalInstance, taxDetails, $state, globalFunc,
                        taxesMasterDataList, $filter, toastr, $timeout) {

  $scope.editClicked = false;
  $scope.taxDetails = taxDetails.data;
  $scope.originalCode = $scope.taxDetails.code;
  $scope.countryCode = globalFunc.countryCode();

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.taxDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\Tax',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab        = toggleTab;
  $scope.duplicationCheck = duplicationCheck;
  $scope.cancel           = cancel;
  $scope.editTax          = editTax;
  $scope.updateTax        = updateTax;
  $scope.openDatepicker   = openDatepicker;

  function toggleTab(tab) {
    $scope.tab = tab;
  }

  function cancel() {
    $uibModalInstance.close();
  }

  function duplicationCheck(model, field, value, checker) {
    globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
      switch (callback) {
        case 'codeCheckTrue':
          if ($scope.taxDetails.code != $scope.originalCode) {
            $scope.codeCheck = true;
          }
          else {
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function openDatepicker($event, which) {

    /**
     * Setting minimum selection for start date to be today
     */
    $scope.startDateOptions.minDate = new Date();

    /**
     * Setting the minimum selection for end date to be one day ahead of selected start date
     */
    var startDateClone = _.cloneDeep($scope.taxDetails.effective_at);
    var startDate = new Date(startDateClone);
    startDate.setDate(startDate.getDate() + 1);
    $scope.endDateOptions.minDate = startDate;

    if ($scope.datepickerOpened[which]) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    else {
      $timeout(function () {
        $scope.datepickerOpened[which] = true;
      })
    }
  }

  function editTax() {
    $scope.editClicked = true;
  }

  function validate(newTax) {
    if (!newTax) {
      return false;
    }
    if (!newTax.code) {
      return false;
    }
    if (!newTax.descr) {
      return false;
    }
    if (newTax.rate < 0) {
      return false;
    }
    if (!newTax.selectedCountryCode) {
      return false;
    }
    if (!newTax.effective_at) {
      return false;
    }
    if (!newTax.expiry_at) {
      return false;
    }
    if (newTax.effective_at >= newTax.expiry_at) {
      return false;
    }

    return true;
  }

  function updateTax(taxDetails) {
    $scope.submitted = true;
    if (!!$scope.codeCheck) {
      toastr.error(taxDetails.code + ' is already in use');
    }
    else if (validate(taxDetails)) {

      swal({
          title: 'Confirm Updating the Tax',
          text: 'This will update the details for this Tax',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch (taxDetails.taxStatus.isActive.toLowerCase()) {
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            var submitData = {
              code: taxDetails.code,
              descr: taxDetails.descr,
              rate: taxDetails.rate,
              country_code: taxDetails.selectedCountryCode.descr,
              effective_at: globalFunc.convertDateToTimestamp(taxDetails.effective_at),
              expiry_at: globalFunc.convertDateToTimestamp(taxDetails.expiry_at),
              is_active: tempStatus
            };

            taxesMasterDataList.put(
              {
                id: $scope.taxDetails._id
              },
              submitData,
              function (resource) {
                toastr.success('Tax has been updated');

                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
    else {
      toastr.error('Please fill up all the required fields first');
    }
  }

  function initialize() {
    if (!!$scope.taxDetails.is_active) {
      $scope.taxDetails.taxStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.taxDetails.is_active)};
    }

    $scope.taxStatuses = [
      {isActive: 'Active'},
      {isActive: 'Deactivated'}
    ];

    $scope.startDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };
    $scope.datepickerOpened = {
      start_date: false,
      end_date: false
    };

    if (!!$scope.countryCode) {
      var temp = _.find($scope.countryCode, function (item) {
        return $scope.taxDetails.country_code === item.descr
      });

      if (!!temp) {
        $scope.taxDetails.selectedCountryCode = temp;
      }
    }
  }

  initialize();
}

taxDetailsCtrl.inject = [
  '$scope', '$uibModalInstance', 'taxDetails', '$state', 'globalFunc', 'taxesMasterDataList',
  '$filter', 'toastr', '$timeout'
];

angular
  .module('metabuyer')
  .controller('taxDetailsCtrl', taxDetailsCtrl);

'use strict';
/**
 * @name masterDataPaymentTermsCtrl
 * @desc Controller for master data payment terms controller
 */
function masterDataManagePaymentTermsCtrl(
  $scope, $stateParams, toastr, dataList, paymentTermsMasterDataList, $uibModal, globalFunc, $location,
  pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.paymentTermService = paymentTermsMasterDataList;

  $scope.addPaymentTerm = addPaymentTerm;
  $scope.editPaymentTerm = editPaymentTerm;
  $scope.search = search;
  $scope.showColumn = showColumn;
  $scope.params = {};
  $scope.duplicationCheck = duplicationCheck;
  $scope.importPaymentTerm = importPaymentTerm;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importLink = pathConstants.apiUrls.paymentTerms.import;

  $scope.columns =
    [
      {id: 'code', label: 'Code'},
      {id: 'descr', label: 'Description'},
      {id: 'updated_at', label: 'Updated At'},
      {id: 'updater.display_name', label: 'Updated By'},
      {id: 'created_at', label: 'Created At'},
      {id: 'creator.display_name', label: 'Created By'},
      {id: 'is_active', label: 'Status'}
    ];

  $scope.storageKey = 'master-data-payment-terms-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function search(query) {
    $location.search({query: query});
  }

  function importPaymentTerm() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Payment term';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function addPaymentTerm() {
      paymentTermsMasterDataList.post(
        {
        },
        {
          code: $scope.paymentTerms.code,
          descr: $scope.paymentTerms.descr,
          is_active: 1
        }
        ,
        function (resource) {
          toastr.success('Payment term has been added');
          if(!!resource.content && !!resource.content.data) {
            var addedPaymentTerm = resource.content.data;
            $scope.dataList.unshift({
              _id: addedPaymentTerm._id,
              code: addedPaymentTerm.code,
              descr: addedPaymentTerm.descr,
              created_at: addedPaymentTerm.created_at,
              updated_at: addedPaymentTerm.updated_at,
              updater: [$scope.user],
              creator: [$scope.user],
              is_active: 1
            });
          }
        },
        function (err) {
          globalFunc.objectErrorMessage(err);
        }
      )
  }

  function editPaymentTerm(paymentTerm){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/paymentTerms/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'editPaymentTermCtrl',
      scope: $scope,
      size: 'lg',
      resolve:{
        modalPaymentTerm: function($q,singlePaymentTerm){
          var deferred = $q.defer();
          singlePaymentTerm.get(
            {
              id: paymentTerm._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  initialize();

}

masterDataManagePaymentTermsCtrl.$inject = [
  '$scope', '$stateParams', 'toastr', 'dataList', 'paymentTermsMasterDataList', '$uibModal',
  'globalFunc', '$location', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('masterDataManagePaymentTermsCtrl', masterDataManagePaymentTermsCtrl);

'use strict';

/**
 * @name editPaymentTermCtrl
 * @desc Controller for master data payment terms details controller
 */
function editPaymentTermCtrl($scope, toastr, paymentTermDetails, singlePaymentTerm,
                             globalFunc, $uibModalInstance) {
  $scope.paymentTermDetails = paymentTermDetails.data;

  $scope.editClicked = false;
  $scope.submitted = false;
  $scope.originalCode = $scope.paymentTermDetails.code;

  $scope.editMode         = editMode;
  $scope.savePaymentTerm  = savePaymentTerm;
  $scope.duplicationCheck = duplicationCheck;
  $scope.cancel           = cancel;
  $scope.toggleTab        = toggleTab;

  $scope.paymentTermStatuses = [
    {isActive: 'Active'},
    {isActive: 'Deactivated'}
  ];

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.paymentTermDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\PaymentTerm',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    $scope.tab = tab;
  }

  function editMode() {
    $scope.editClicked = true;
  }

  function validate(paymentTerm) {
    if (!paymentTerm) {
      return false;
    }
    if (!paymentTerm.code) {
      return false;
    }
    if (!paymentTerm.descr) {
      return false;
    }
    if (!paymentTerm.paymentTermStatus) {
      return false;
    }
    return true;
  }

  function savePaymentTerm() {
    $scope.submitted = true;
    if (!!$scope.codeCheck) {
      toastr.error($scope.paymentTermDetails.code + ' is already in use');
    }
    else if (validate($scope.paymentTermDetails)) {
      swal({
          title: 'Confirm Updating the Payment Term',
          text: 'This will update the details for this Payment Term',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch ($scope.paymentTermDetails.paymentTermStatus.isActive.toLowerCase()) {
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.paymentTermDetails.is_active = $scope.paymentTermDetails.paymentTermStatus.isActive.toUpperCase();
            $scope.paymentTermDetails.updated_at = new Date();

            singlePaymentTerm.put(
              {
                id: $scope.paymentTermDetails._id
              },
              {
                code: $scope.paymentTermDetails.code,
                descr: $scope.paymentTermDetails.descr,
                is_active: tempStatus
              },
              function (resource) {
                toastr.success('Payment term has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model, field, value, checker) {
    globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
      switch (callback) {
        case 'codeCheckTrue':
          if ($scope.paymentTermDetails.code != $scope.originalCode) {
            $scope.codeCheck = true;
          }
          else {
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }



  function initialize() {
    if (!!$scope.paymentTermDetails.is_active) {
      $scope.paymentTermDetails.paymentTermStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.paymentTermDetails.is_active)};
    }
  }

  initialize();
}

editPaymentTermCtrl.$inject = [
  '$scope', 'toastr', 'modalPaymentTerm', 'singlePaymentTerm',
  'globalFunc', '$uibModalInstance'
];

angular
  .module('metabuyer')
  .controller('editPaymentTermCtrl', editPaymentTermCtrl);

'use strict';
/**
 * @name masterDataPaymentMethodsCtrl
 * @desc Controller for master data payment methods controller
 */
function masterDataPaymentMethodsCtrl($scope, $stateParams, toastr, dataList,
                                      paymentMethodsMasterDataList, $uibModal, globalFunc,
                                      $location,pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.paymentMethodService = paymentMethodsMasterDataList;

  $scope.addPaymentMethod = addPaymentMethod;
  $scope.editPaymentMethod = editPaymentMethod;
  $scope.search = search;
  $scope.showColumn = showColumn;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.params = {};
  $scope.duplicationCheck = duplicationCheck;
  $scope.importPaymentMethod = importPaymentMethod;
  $scope.importLink = pathConstants.apiUrls.paymentMethods.import;

  $scope.columns =
    [
      {id: 'code', label: 'Code'},
      {id: 'descr', label: 'Description'},
      {id: 'updated_at', label: 'Updated At'},
      {id: 'updater.display_name', label: 'Updated By'},
      {id: 'created_at', label: 'Created At'},
      {id: 'creator.display_name', label: 'Created By'},
      {id: 'is_active', label: 'Status'}
    ];

  $scope.storageKey = 'master-data-payment-methods-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function search(query) {
    $location.search({query: query});
  }

  function addPaymentMethod() {
      paymentMethodsMasterDataList.post(
        {
        },
        {
          code: $scope.paymentMethods.code,
          descr: $scope.paymentMethods.descr
        }
        ,
        function (resource) {
          toastr.success('Payment method has been added');
          if(!!resource.content && !!resource.content.data) {
            var addedPaymentMethod = resource.content.data;
            $scope.dataList.unshift({
              _id: addedPaymentMethod._id,
              code: addedPaymentMethod.code,
              descr: addedPaymentMethod.descr,
              created_at: addedPaymentMethod.created_at,
              updated_at: addedPaymentMethod.updated_at,
              updater: [$scope.user],
              creator: [$scope.user],
              is_active: 1
            });
          }
        },
        function (err) {
          globalFunc.objectErrorMessage(err);
        });
  }

  function editPaymentMethod(paymentMethod){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/paymentMethods/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'paymentMethodDetailsCtrl',
      scope: $scope,
      size: 'lg',
      resolve:{
        modalPaymentMethod: function($q,singlePaymentMethod){
          var deferred = $q.defer();
          singlePaymentMethod.get(
            {
              id: paymentMethod._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  function importPaymentMethod() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Payment Method';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  initialize();

}

masterDataPaymentMethodsCtrl.$inject = [
  '$scope', '$stateParams', 'toastr', 'dataList', 'paymentMethodsMasterDataList',
  '$uibModal', 'globalFunc', '$location', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('masterDataPaymentMethodsCtrl', masterDataPaymentMethodsCtrl);

'use strict';

/**
 * @name editPaymentTermCtrl
 * @desc Controller for master data payment terms details controller
 */
function paymentMethodDetailsCtrl($scope, toastr, paymentMethodDetails, singlePaymentMethod, $state,
                               globalFunc, $uibModalInstance) {

  $scope.paymentMethodDetails = paymentMethodDetails.data;
  $scope.submitted = false;
  $scope.editClicked = false;
  $scope.originalCode = $scope.paymentMethodDetails.code;

  $scope.editMode = editMode;
  $scope.savePaymentMethod = savePaymentMethod;
  $scope.duplicationCheck = duplicationCheck;
  $scope.cancel = cancel;
  $scope.toggleTab = toggleTab;

  $scope.paymentMethodStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.paymentMethodDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\PaymentMethod',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    $scope.tab = tab;
  }

  function editMode(){
    $scope.editClicked = true;
  }

  function validate(paymentMethod){
    return(!_.isUndefined(paymentMethod) && !_.isUndefined(paymentMethod.code) &&
    !_.isUndefined(paymentMethod.descr) && !_.isUndefined(paymentMethod.paymentMethodStatus));
  }

  function savePaymentMethod(){
    $scope.submitted = true;
    if(!!$scope.codeCheck){
      toastr.error($scope.paymentMethodDetails.code + ' is already in use');
    }
    else if(validate($scope.paymentMethodDetails)) {
      swal({
          title: 'Confirm Updating the Payment Method',
          text: 'This will update the details for this Payment Method',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.paymentMethodDetails.paymentMethodStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.paymentMethodDetails.is_active = $scope.paymentMethodDetails.paymentMethodStatus.isActive.toUpperCase();
            $scope.paymentMethodDetails.updated_at = new Date();

            singlePaymentMethod.put(
              {
                id: $scope.paymentMethodDetails._id
              },
              {
                code: $scope.paymentMethodDetails.code,
                descr: $scope.paymentMethodDetails.descr,
                is_active: tempStatus
              },
              function (resource) {
                toastr.success('Payment Method has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          if($scope.paymentMethodDetails.code != $scope.originalCode){
            $scope.codeCheck = true;
          }
          else{
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize() {
    if(!!$scope.paymentMethodDetails.is_active) {
      $scope.paymentMethodDetails.paymentMethodStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.paymentMethodDetails.is_active)};
    }
  }

  initialize();
}

paymentMethodDetailsCtrl.$inject = ['$scope', 'toastr', 'modalPaymentMethod', 'singlePaymentMethod',
  '$state', 'globalFunc', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('paymentMethodDetailsCtrl', paymentMethodDetailsCtrl);

'use strict';
/**
 * @name MasterDataManageExpenseTypesCtrl
 * @desc Controller for master data expense types controller
 */
function MasterDataManageExpenseTypesCtrl($scope, dataList, expenseTypeMasterDataList,
                                          toastr, $uibModal, $location,pathConstants, globalFunc, $stateParams) {
  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.expenseTypeMasterDataList = expenseTypeMasterDataList;
  $scope.addNewExpenseType = addNewExpenseType;
  $scope.expenseTypesDetails = expenseTypesDetails;
  $scope.search = search;
  $scope.showColumn = showColumn;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importExpenseType = importExpenseType;
  $scope.importLink = pathConstants.apiUrls.expenseTypes.import;
  $scope.params = {};

  $scope.columns = [
    {id: 'code', label: 'Code'},
    {id: 'descr', label: 'Description'},
    {id: 'updated_at', label: 'Updated At'},
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'created_at', label: 'Created At'},
    {id: 'creator.display_name', label: 'Created By'},
    {id: 'is_active', label: 'Status'}
  ];

  $scope.storageKey = 'master-data-expense-types-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function importExpenseType() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Expense Type';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function addNewExpenseType() {
    if(validate($scope.expenseType)) {
      expenseTypeMasterDataList.post(
        {
          code: $scope.expenseType.code,
          descr: $scope.expenseType.descr,
          is_active: 1
        },
        function (resource) {
          toastr.success('A new Expense Type has been added successfully');
          var addedExpenseType = resource.content.data;
          $scope.dataList.unshift({
            _id: addedExpenseType._id,
            code: addedExpenseType.code,
            descr: addedExpenseType.descr,
            created_at: addedExpenseType.created_at,
            updated_at: addedExpenseType.updated_at,
            creator: [$scope.user],
            updater: [$scope.user],
            is_active: 1
          });
          $scope.expenseType.code='';
          $scope.expenseType.descr='';
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
  }

  function search(query) {
    $location.search({query: query});
  }

  function validate(expenseType){
    if (!expenseType){
      return false;
    }
    if (!expenseType.code){
      return false;
    }
    if (!expenseType.descr){
      return false;
    }

    return true;
  }

  function expenseTypesDetails(index) {
    var expenseTypeId = $scope.dataList[index]._id;
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/expenseTypes/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'expenseTypeDetailsCtrl',
      size: 'lg',
      resolve: {
        expenseTypeDetails: function($q, expenseTypeMasterDataList) {
          var deferred = $q.defer();
          expenseTypeMasterDataList.get(
            {
              id: expenseTypeId
            },
            function (resource) {
              deferred.resolve(resource.content || {data: []});
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  function initialize(){
    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  initialize();
}

MasterDataManageExpenseTypesCtrl.$inject = [
  '$scope', 'dataList', 'expenseTypeMasterDataList', 'toastr', '$uibModal',
  '$location', 'pathConstants', 'globalFunc', '$stateParams'
];

angular
  .module('metabuyer')
  .controller('MasterDataManageExpenseTypesCtrl', MasterDataManageExpenseTypesCtrl);

'use strict';
/**
 * @name expenseTypeDetailsCtrl
 * @desc Controller for master data ExpenseType details controller
 */
function expenseTypeDetailsCtrl($scope, $uibModalInstance, expenseTypeDetails,
                                expenseTypeMasterDataList, globalFunc, toastr, $state) {
  $scope.editClicked = false;
  $scope.expenseTypeDetails = expenseTypeDetails.data;

  $scope.expenseTypeStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];
  $scope.originalCode = $scope.expenseTypeDetails.code;
  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.expenseTypeDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\ExpenseTypes',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab         = toggleTab;
  $scope.cancel            = cancel;
  $scope.editExpenseType   = editExpenseType;
  $scope.updateExpenseType = updateExpenseType;
  $scope.duplicationCheck  = duplicationCheck;

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function editExpenseType(){
    $scope.editClicked = true;
  }

  function validate(expenseTypeDetails){
    if (!expenseTypeDetails){
      return false;
    }
    if (!expenseTypeDetails.code){
      return false;
    }
    if (!expenseTypeDetails.descr){
      return false;
    }
    if (!expenseTypeDetails.expenseTypeStatus){
      return false;
    }
    return true;
  }

  function updateExpenseType() {
    if(!!$scope.codeCheck){
      toastr.error($scope.expenseTypeDetails.code + ' is already in use');
    }
    else if(validate($scope.expenseTypeDetails)){
      swal({
          title: 'Confirm Updating the Expense Type',
          text: 'This will update the details for this Expense Type',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.expenseTypeDetails.expenseTypeStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.expenseTypeDetails.is_active = $scope.expenseTypeDetails.expenseTypeStatus.isActive;
            $scope.expenseTypeDetails.updated_at = new Date();

            expenseTypeMasterDataList.put(
              {
                id: $scope.expenseTypeDetails._id
              },
              {
                code: $scope.expenseTypeDetails.code,
                descr: $scope.expenseTypeDetails.descr,
                is_active: tempStatus
              },
              function (resource) {
                toastr.success('Expense Type has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          if($scope.expenseTypeDetails.code != $scope.originalCode){
          $scope.codeCheck = true;
          }
          else{
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize() {
    if(!!$scope.expenseTypeDetails.is_active) {
      $scope.expenseTypeDetails.expenseTypeStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.expenseTypeDetails.is_active)};
    }
  }

  initialize();
}

expenseTypeDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'expenseTypeDetails', 'expenseTypeMasterDataList', 'globalFunc',
  'toastr', '$state'
];

angular
  .module('metabuyer')
  .controller('expenseTypeDetailsCtrl', expenseTypeDetailsCtrl);

'use strict';
/**
 * @name MasterDataManageExchangeRateCtrl
 * @desc Controller for master data exchange rate controller
 *
 * @param $scope
 * @param $stateParams
 * @param $uibModal
 * @param toastr
 * @param exchangeRateMasterDataList
 * @param ExchangeRate
 * @param globalFunc
 * @param currencies
 * @param $location
 * @param $filter
 * @param pathConstants
 * @param dataList
 *
 * @function newExchangeRate
 * This function is for adding a new exchange rate. By passing 'global' as company_id, exchange rate created is global level
 *
 * @function validate
 * This function is for validating the fields before adding new exchange rate
 *
 * @function exchangeRateDetail
 * This function is to open a modal displaying the details of the exchange rate
 *
 * @function search
 * This function is to search/filter the exchange rates
 *
 * @function reset
 * This function is to reset the data/clear the search results
 *
 * @function importExchangeRate
 * This function is to import the exchange rates to csv
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>, Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */
function MasterDataManageExchangeRateCtrl($scope, $stateParams, $uibModal, toastr,
                                          exchangeRateMasterDataList, ExchangeRate,
                                          globalFunc, currencies, $location, $filter, pathConstants, dataList) {

  function onSelectedFromCurrency(selected_data){
    $scope.exchangeRate.source_currency_id = selected_data._id;
  }

  function onSelectedToCurrency(selected_data){
    $scope.exchangeRate.target_currency_id = selected_data._id;
  }

  function openDatepicker($event, which) {
    /**
     * Setting minimum selection for start date to be today
     */
    $scope.startDateOptions.minDate = new Date();

    /**
     * Setting the minimum selection for end date to be one day ahead of selected start date
     */
    var startDateClone = _.cloneDeep($scope.exchangeRate.effective_at);
    var startDate = new Date(startDateClone);
    startDate.setDate(startDate.getDate() + 1);
    $scope.endDateOptions.minDate = startDate;

    $event.preventDefault();
    $event.stopPropagation();

    $scope.datepickerOpened[which] = true;
  }

  $scope.columns= [
        {id: 'code', label: 'Code'},
        {id: 'descr', label: 'Description'},
        {id: 'multiplier_rate', label: 'Rate'},
        {id: 'updated_at', label: 'Updated At'},
        {id: 'updater.display_name', label: 'Updated By'},
        {id: 'created_at', label: 'Created At'},
        {id: 'creator.display_name', label: 'Created By'},
        {id: 'effective_at', label: 'Effective At'},
        {id: 'expiry_at', label: 'Expire At'},
        {id: 'status', label: 'Status'}
      ];

  $scope.storageKey = 'master-data-exchange-rate-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function importGlobalExchangeRate() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/exchangeRate/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Exchange Rate';
        },
        id: function() {
          return 'global';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title, id) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
        $scope.id = id;
      }
    });
  }

  $scope.exchangeRateStatuses = [
    {value: 5, text: 'ACTIVE'},
    {value: 6, text: 'DEACTIVATED'},
    {value: 7, text: 'DISABLED'}
  ];

  function search(query) {
    $location.search({query: query});
  }

  function clearForm(){
    $scope.exchangeRate.descr = '';
    $scope.exchangeRate.status = '';
    $scope.exchangeRate.multiplier_rate = '';
    $scope.exchangeRate.effective_at = '';
    $scope.exchangeRate.expiry_at = '';
    $scope.exchangeRate.fromCurrency = undefined;
    $scope.exchangeRate.toCurrency = undefined;
    $scope.exchangeRate.source_currency_id = undefined;
    $scope.exchangeRate.target_currency_id = undefined;
  }

    $scope.validateMultiplierRate = validateMultiplierRate;
    function validateMultiplierRate(multiplier_rate) {
        return Number(multiplier_rate) === 0;
    }

  function validate(exchangeRate){
    if(!exchangeRate.fromCurrency || !exchangeRate.toCurrency ||
      (exchangeRate.fromCurrency === exchangeRate.toCurrency)){
      return false;
    }
    if(!exchangeRate.multiplier_rate || Number(exchangeRate.multiplier_rate) === 0){
      return false;
    }
    if(!exchangeRate.descr){
      return false;
    }
    if(!exchangeRate.effective_at || !exchangeRate.expiry_at){
      return false;
    }

    if(exchangeRate.effective_at >= exchangeRate.expiry_at){
      return false;
    }

    return true;
  }

  function newExchangeRate() {
    $scope.submitted = true;

    if(!!validate($scope.exchangeRate)) {
      if(!!$scope.exchangeRate){
        $scope.exchangeRate.status = 2;
      }
      //Formatting the dates before posting
      $scope.exchangeRate.effective_at = globalFunc.convertDateToTimestamp($scope.exchangeRate.effective_at);
      $scope.exchangeRate.expiry_at = globalFunc.convertDateToTimestamp($scope.exchangeRate.expiry_at);


      var submit_data = {
        descr: $scope.exchangeRate.descr,
        status: $scope.exchangeRate.status,
        multiplier_rate: $scope.exchangeRate.multiplier_rate,
        effective_at: $scope.exchangeRate.effective_at,
        expiry_at: $scope.exchangeRate.expiry_at,
        source_currency_id: $scope.exchangeRate.source_currency_id,
        target_currency_id: $scope.exchangeRate.target_currency_id
      };

      exchangeRateMasterDataList.post(
        {
          id: 'global'
        },
        submit_data,
        function (resource) {
          toastr.success('Exchange rate was added successfully');
          if (!!resource.content) {
            if (!!resource.content.data) {
              var addedExchangeRate = resource.content.data;
              $scope.dataList.unshift({
                _id: addedExchangeRate._id,
                code: addedExchangeRate.code,
                descr: addedExchangeRate.descr,
                multiplier_rate: addedExchangeRate.rate,
                effective_at: addedExchangeRate.effective_at,
                expiry_at: addedExchangeRate.expiry_at,
                created_at: addedExchangeRate.created_at,
                updated_at: addedExchangeRate.updated_at,
                updater: [$scope.user],
                creator: [$scope.user],
                is_active: 1
              });
            }
          }

          clearForm();
          $scope.submitted = false;
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      )
    }
    else{
      toastr.error('Please fill in all the fields');
    }
  }

  function exchangeRateDetail(exchangeRate) {
    var exchangeRateId = $scope.dataList[exchangeRate]._id;
    var modalInstance = $uibModal.open({
      templateUrl: 'components/exchangeRate/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'exchangeRateDetailsCtrl',
      size: 'lg',
      resolve: {
        currencyExchange: function(){
          return $scope.currencyExchange;
        },
        exchangeRateDetails: function($q, exchangeRateSpecificRate) {
          var deferred = $q.defer();
          exchangeRateSpecificRate.get(
            {
              rate_id: exchangeRateId,
              id: 'global'
            },
            function (resource) {
              deferred.resolve(resource.content || {data: []});
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.multiplier_rate = newValue.rate;
            dataList.effective_at = newValue.effective_at;
            dataList.expiry_at = newValue.expiry_at;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    });
  }

  function reset (){
    $scope.query = false;
    exchangeRateMasterDataList.get(
      {
        id: 'global'
      },
      function (resource) {
        if(!!resource.content){
          if(!!resource.content.data) {
            $scope.dataList = resource.content.data;
          }
        }
      },
      function (error) {
        toastr.error(error);
      });
  }

  function initialize(){

    $scope.dataList = dataList.data;
    $scope.meta = dataList.meta;
    $scope.accountCodesListService = exchangeRateMasterDataList;
    $scope.newExchangeRate = newExchangeRate;
    $scope.validate = validate;
    $scope.exchangeRateDetail = exchangeRateDetail;
    $scope.search = search;
    $scope.reset = reset;
    $scope.showColumn = showColumn;
    $scope.getActiveStatusName = getActiveStatusName;
    $scope.importGlobalExchangeRate = importGlobalExchangeRate;
    $scope.importLink = pathConstants.apiUrls.globalExchangeRate.import;
    $scope.exchangeRate = {};

    // Datepicker
    $scope.openDatepicker = openDatepicker;

    $scope.startDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.datepickerOpened = {
      start_date: false,
      end_date: false
    };
    $scope.currencyExchange = currencies.data;

    $scope.onSelectedFromCurrency = onSelectedFromCurrency;
    $scope.onSelectedToCurrency = onSelectedToCurrency;

    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }

  initialize();
}

MasterDataManageExchangeRateCtrl.$inject = [
  '$scope', '$stateParams', '$uibModal', 'toastr',
  'exchangeRateMasterDataList', 'ExchangeRate',
  'globalFunc', 'currencies', '$location', '$filter', 'pathConstants', 'dataList'
];

angular
  .module('metabuyer')
  .controller('MasterDataManageExchangeRateCtrl', MasterDataManageExchangeRateCtrl);

'use strict';
/**
 * @name MasterDataManageCurrencyCtrl
 * @desc Controller for master data currency controller
 */
function MasterDataManageCurrencyCtrl($scope, $uibModal, toastr, currenciesMasterDataList,
                                      dataList, $location,pathConstants, globalFunc, $stateParams) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.currenciesService = currenciesMasterDataList;

  $scope.search = search;
  $scope.newCurrencies = newCurrencies;
  $scope.currencyDetails = currencyDetails;
  $scope.showColumn = showColumn;
  $scope.importCurrencies = importCurrencies;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importLink = pathConstants.apiUrls.currencies.import;
  $scope.params = {};
  $scope.columns = [
        {id: 'code', label: 'Code'},
        {id: 'descr', label: 'Description'},
        {id: 'updated_at', label: 'Updated At'},
        {id: 'updater.display_name', label: 'Updated By'},
        {id: 'created_at', label: 'Created At'},
        {id: 'creator.display_name', label: 'Created By'},
        {id: 'is_active', label: 'Status'}
      ];

  $scope.storageKey = 'master-data-currencies-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }


  function initialize(){

    /**
     * setting the model with the searched text
     */
    if(!!$stateParams.search){
      $scope.searchText = $stateParams.search;
    }
    else{
      $scope.searchText = '';
    }
  }


  function search(query) {
    $location.search({query: query});
  }

  function importCurrencies() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Currencies';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function newCurrencies() {
    if(!!$scope.currency){
      $scope.currency.is_active = 1;
    }

    currenciesMasterDataList.post(
      {},
      $scope.currency,
      function(resource) {
        toastr.success('Currency was added successfully');
        if(!!resource.content && !!resource.content.data) {
          var addedCurrency = resource.content.data;
          $scope.dataList.unshift({
            _id: addedCurrency._id,
            code: addedCurrency.code,
            descr: addedCurrency.descr,
            created_at: addedCurrency.created_at,
            updated_at: addedCurrency.updated_at,
            updater: [$scope.user],
            creator: [$scope.user],
            is_active: 1
          });
        }
        $scope.currency.code = '';
        $scope.currency.descr = '';
      },
      function(error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function currencyDetails(index) {
    var currencyId = $scope.dataList[index]._id;
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/currency/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'currencyDetailsCtrl',
      size: 'lg',
      resolve: {
        currencyDetails: function($q, currenciesMasterDataList) {
          var deferred = $q.defer();
          currenciesMasterDataList.get(
            {
              id: currencyId
            },
            function (resource) {
              deferred.resolve(resource.content || {data: []});
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  initialize();
}

MasterDataManageCurrencyCtrl.$inject = [
  '$scope', '$uibModal', 'toastr', 'currenciesMasterDataList', 'dataList',
  '$location', 'pathConstants', 'globalFunc', '$stateParams'
];

angular
  .module('metabuyer')
  .controller('MasterDataManageCurrencyCtrl', MasterDataManageCurrencyCtrl);

'use strict';

/**
 * @name currencyDetailsCtrl
 * @desc Controller for master data Currencies details controller
 */
function currencyDetailsCtrl($scope, $uibModalInstance, currencyDetails,
                                   currenciesMasterDataList, globalFunc, toastr) {
  $scope.currencyDetails = currencyDetails.data;
  $scope.editClicked = false;
  // Create new variable to replace currencyDetails.status
  // with object to load and selected the right status
  // on the dropdown list
  if(!!$scope.currencyDetails.is_active) {
    $scope.currencyDetails.currencyStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.currencyDetails.is_active)};
  }
  // Statuses for dropdown in object
  $scope.currencyStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];
  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.currencyDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\Currencies',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab = toggleTab;
  $scope.cancel = cancel;
  $scope.editCurrency = editCurrency;
  $scope.updateCurrency = updateCurrency;
  $scope.duplicationCheck = duplicationCheck;
  $scope.originalCode = $scope.currencyDetails.code;

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function editCurrency(){
    $scope.editClicked = true;
  }

  function validate(currency){
    if (!currency){
      return false;
    }
    if (!currency.code){
      return false;
    }
    if (!currency.descr){
      return false;
    }
    if (!currency.currencyStatus){
      return false;
    }
    return true;
  }

  function updateCurrency() {
    if(!!$scope.codeCheck){
      toastr.error($scope.currencyDetails.code + ' is already in use');
    }
    else if(validate($scope.currencyDetails)){
      swal({
          title: 'Confirm Updating the Currency',
          text: 'This will update the details for this Currency',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.currencyDetails.currencyStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            $scope.currencyDetails.is_active = $scope.currencyDetails.currencyStatus.isActive.toUpperCase();
            $scope.currencyDetails.updated_at = new Date();

            currenciesMasterDataList.put(
              {
                id: $scope.currencyDetails._id
              },
              {
                code: $scope.currencyDetails.code,
                descr: $scope.currencyDetails.descr,
                is_active: tempStatus
              },
              function (resource) {
                toastr.success('Currency has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          if($scope.currencyDetails.code != $scope.originalCode){
            $scope.codeCheck = true;
          }
          else{
            $scope.codeCheck = false;
          }
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }
}

currencyDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'currencyDetails', 'currenciesMasterDataList', 'globalFunc', 'toastr'
];

angular
  .module('metabuyer')
  .controller('currencyDetailsCtrl', currencyDetailsCtrl);

'use strict';
/**
 * @name MasterDataManageCommodityCodeCtrl
 * @desc Controller for master data commodity code
 */
function masterDataCommodityCodeCtrl(
  $scope, $state, $q, toastr, dataList, commodityList, $uibModal, pathConstants, $location, $window, $stateParams,
  HighlightId) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.commodityService = commodityList;

  $scope.title = 'Segments';

  $scope.addCommodityModal = addCommodityModal;
  $scope.editCommodityModal = editCommodityModal;
  $scope.importCommodity = importCommodity;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importLink = pathConstants.apiUrls.commodity.import;
  $scope.search = search;
  $scope.backToParent = backToParent;
  $scope.backToSegments = backToSegments;
  $scope.showParentButton = false;
  $scope.showSegmentButton = false;
  var rootCommodityCode = 0;

  $scope.showColumn = showColumn;
  $scope.params = { code: rootCommodityCode };

  $scope.columns =[
        {id: 'code', label: 'Code'},
        {id: 'descr', label: 'Description'},
        {id: 'updated_at', label: 'Updated At'},
        {id: 'updater.display_name', label: 'Updated By'},
        {id: 'created_at', label: 'Created At'},
        {id: 'creator.display_name', label: 'Created By'},
        {id: 'is_active', label: 'Status'}
      ];

  $scope.storageKey = 'master-data-commodity-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }


  function backToParent() {
    if (!!$stateParams.parentUniqueName) {
      HighlightId.setId($stateParams.parentUniqueName);
    }
    $window.history.back();
  }

  function backToSegments() {
    $location.search({parentUniqueName: 'All'});
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function search(query) {
    $location.search({query: query});
  }

  function importCommodity() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Commodity';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function addCommodityModal(){
    $scope.params = { code: rootCommodityCode };
    $uibModal.open({
      templateUrl: 'app/masterDataManagement/commodityCode/add/addCommodityTemplate.html',
        backdrop: 'static',
        keyboard: false,
      controller: 'addCommodityCtrl',
      scope: $scope,
      resolve:{
        segmentList: function ($q, commodityList) {
          var deferred = $q.defer();
          commodityList.get(
            {
              code: '00',
              offset: 0
            },
            function (resource) {
              deferred.resolve(resource.content);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    })
  }

  function editCommodityModal(data, index){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/commodityCode/details/details.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'commodityDetailsCtrl',
      scope: $scope,
      size: 'lg',
      resolve:{
        commodityDetails: function ($q, singleCommodity) {
          var deferred = $q.defer();
          singleCommodity.get(
            {
              id: data._id
            },
            function (resource) {
              deferred.resolve(resource.content);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        },
        segmentList : function($q, commodityList){
          var deferred = $q.defer();
          commodityList.get(
            {
              code: '00',
              //TODO: have the backend return ALL data (Ahmed Saleh, 22/7/2016)
              offset: 1000
            },
            function (resource) {
              deferred.resolve(resource.content);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updated_by;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

  $scope.viewChild = function(data, index){
    $scope.params = { code: data.unique_name };
    if(data.unique_name.length < 8) {
      $location.search({parentUniqueName: data.unique_name});
    }
    else{
      editCommodityModal(data, index);
    }
  };

  function initialize(){
    if($stateParams.parentUniqueName !== 'All'){
      $scope.showParentButton = true;
      $scope.showSegmentButton = true;
    }
    else{
      $scope.showParentButton = false;
      $scope.showSegmentButton = false;
    }

    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();

}

masterDataCommodityCodeCtrl.$inject = [
  '$scope', '$state', '$q', 'toastr', 'dataList', 'commodityList', '$uibModal', 'pathConstants', '$location', '$window',
  '$stateParams', 'HighlightId'];

angular
  .module('metabuyer')
  .controller('masterDataCommodityCodeCtrl', masterDataCommodityCodeCtrl);

'use strict';
function commodityDetailsCtrl($scope, toastr, commodityDetails, segmentList, commodityList, singleCommodity,
                              availability, $uibModalInstance, globalFunc) {
  $scope.commodityDetails = commodityDetails.data;
  $scope.submitted = false;
  $scope.editClicked = false;

  $scope.masterDataSegments = segmentList.data;
  $scope.masterDataFamilies = [];
  $scope.masterDataClasses = [];
  $scope.masterDataCommodities = [];

  $scope.commodityDetails.segment = $scope.commodityDetails.code.substring(0,2);
  $scope.commodityDetails.family = $scope.commodityDetails.code.substring(2,4);
  $scope.commodityDetails.class = $scope.commodityDetails.code.substring(4,6);
  $scope.commodityDetails.commodity = $scope.commodityDetails.code.substring(6,8);

  $scope.originalCode = $scope.commodityDetails.commodity;
  $scope.fullCode = $scope.commodityDetails.code;
  $scope.firstSixCode = $scope.commodityDetails.code.substring(0,6);

  // Statuses for dropdown in object
  $scope.commodityStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];

  $scope.commodityPosting = [
    {value:1, text: 'POSTING'},
    {value:0, text: 'NON POSTING'}
  ];

  $scope.commodityTypes = [
    {value: 'OI' , descr: 'Other Items'},
    {value: 'IT' , descr: 'Information Technology'},
    {value: 'CP' , descr: 'Car Purchase'},
    {value: 'ME' , descr: 'M&E (for SunCity PI only)'}
  ];

  $scope.tab = 1;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.commodityDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\Commodity',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.cancel                     = cancel;
  $scope.saveCommodity              = saveCommodity;
  $scope.editMode                   = editMode;
  $scope.toggleTab                  = toggleTab;
  $scope.selectedMasterDataSegments = selectedMasterDataSegments;
  $scope.selectedMasterDataFamilies = selectedMasterDataFamilies;
  $scope.selectedMasterDataClasses  = selectedMasterDataClasses;
  $scope.duplicationCheck           = duplicationCheck;

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    $scope.tab = tab;
  }

  function editMode(){
    $scope.editClicked = true;
  }

  function selectedMasterDataSegments(item, callback) {
    $scope.masterDataSegments.selected = item;
    $scope.masterDataFamilies.selected = undefined;
    $scope.masterDataClasses.selected = undefined;
    commodityList.get(
        {
          code : item.unique_name
        },
        function(resource){
          $scope.masterDataFamilies = resource.content.data;
          $scope.segmentCode = item.unique_name;
          if(typeof callback === 'function'){
            callback($scope.masterDataFamilies);
          }
        },
        function(error){
          if (error.status === 404) {
            toastr.error('Could not load families for this segment');
          }
        }
      );
  }

  function selectedMasterDataFamilies(item, callback) {
    $scope.masterDataFamilies.selected = item;
    $scope.masterDataClasses.selected = undefined;
    commodityList.get(
      {
        code : item.unique_name
      },
      function(resource){
        $scope.masterDataClasses = resource.content.data;
        $scope.familyCode = item.unique_name.substring(2);
        if(typeof callback === 'function'){
          callback($scope.masterDataClasses);
        }
      },
      function(error){
        if (error.status === 404) {
          toastr.error('Could not load classes for this family');
        }
      }
    );
  }

  function selectedMasterDataClasses(item) {
    $scope.masterDataClasses.selected = item;
    $scope.commodityDetails.commodity = undefined;
    commodityList.get(
      {
        code : item.unique_name
      },
      function(resource){
        $scope.masterDataCommodities = resource.content.data;
        $scope.classCode = item.unique_name.substring(4);
        $scope.firstSixCode = item.unique_name;
      },
      function(error){
        if (error.status === 404) {
          toastr.error('Could not load commodity for this class');
        }
      }
    );
  }

  function validate(commodity){
    if(!commodity){
      return false;
    }
    if (!(commodity.code)){
      return false;
    }
    if (!(commodity.descr)) {
      return false;
    }
    if (!(commodity.commodityStatus)) {
      return false;
    }
    if (!(commodity.select_commodity_type)) {
      return false;
    }
    if (!(commodity.commodity) || commodity.commodity.length != 2) {
      return false;
    }
    if (!(commodity.posting)) {
      return false;
    }
    return true;
  }

  function saveCommodity(){
    $scope.submitted = true;
    if(!!$scope.codeCheck){
      toastr.error('Commodity Code ' + $scope.commodityDetails.commodity + ' is already in use');
    }
    else if(validate($scope.commodityDetails)) {
      var postingValue = 0;
      if($scope.commodityDetails.posting.text === 'POSTING'){
        postingValue = 1;
      }
      if($scope.commodityDetails.posting.text === 'NON POSTING'){
        postingValue = 0;
      }

      // set status in integer to pass it as parameter
      var tempStatus;
      switch($scope.commodityDetails.commodityStatus.isActive.toLowerCase()){
        case 'active':
          tempStatus = 1;
          break;
        case 'deactivated':
          tempStatus = 0;
          break;
        case 'disabled':
          tempStatus = 3;
          break;
      }

      $scope.fullCode = $scope.firstSixCode + $scope.commodityDetails.commodity;
      $scope.commodityDetails.segment = $scope.fullCode.substring(0,2);
      $scope.commodityDetails.family = $scope.fullCode.substring(2,4);
      $scope.commodityDetails.class = $scope.fullCode.substring(4,6);
      $scope.commodityCode = $scope.fullCode.substring(6);

      var submitData = {
        code: $scope.fullCode,
        descr: $scope.commodityDetails.descr,
        is_active: tempStatus,
        domain: $scope.commodityDetails.domain,
        type: $scope.commodityDetails.select_commodity_type.value,
        segment: $scope.commodityDetails.segment,
        family: $scope.commodityDetails.family,
        class: $scope.commodityDetails.class,
        commodity: $scope.commodityCode,
        unique_name: $scope.fullCode,
        parent_unique_name: $scope.firstSixCode,
        posting: postingValue
      };
      singleCommodity.put(
        {
          id: $scope.commodityDetails._id
        },
        submitData,
        function (resource) {
          toastr.success('Commodity has been updated');
          $uibModalInstance.close(resource.content.data);
        },
        function () {
          toastr.error('Failed to update commodity');
          return false;
        }
      );
    }
    else{
      toastr.error('Please fill in required fields');
      return false;
    }
  }

  function initialize(){
    if(!!$scope.commodityDetails.is_active) {
      $scope.commodityDetails.commodityStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.commodityDetails.is_active)};
    }

    $scope.commodityDetails.status = {status: $scope.commodityDetails.status};

    if(!_.isUndefined($scope.commodityDetails) && !_.isUndefined($scope.commodityDetails.type)){
      switch($scope.commodityDetails.type){
        case 'Other Items':
          $scope.commodityDetails.select_commodity_type = $scope.commodityTypes[0];
          break;
        case 'Information Technology':
          $scope.commodityDetails.select_commodity_type = $scope.commodityTypes[1];
          break;
        case 'Car Purchase':
          $scope.commodityDetails.select_commodity_type = $scope.commodityTypes[2];
          break;
        case 'M&E (for SunCity PI only)':
          $scope.commodityDetails.select_commodity_type = $scope.commodityTypes[3];
          break;
      }
    }

    if(!_.isUndefined($scope.commodityDetails.code)) {
      var tempSegment = $scope.commodityDetails.code.substring(0, 2);
      var tempFamily = $scope.commodityDetails.code.substring(2, 4);
      var tempClass = $scope.commodityDetails.code.substring(4,6);
      var tempCommodity = $scope.commodityDetails.code.substring(6,8);

      var commoditySegment = tempSegment + '000000';
      var commodityFamily = tempSegment + tempFamily + '0000';
      var commodityClass = tempSegment + tempFamily + tempClass + '00';


      for (var a = 0; a < $scope.masterDataSegments.length; a++) {
        if ($scope.masterDataSegments[a].code === commoditySegment) {
          $scope.masterDataSegments.selected = $scope.masterDataSegments[a];
        }
      }
      selectedMasterDataSegments($scope.masterDataSegments.selected, function(callback){
        $scope.masterDataFamilies = callback;
        for(var b = 0; b < callback.length ; b++){
          if(callback[b].code === commodityFamily){
            $scope.masterDataFamilies.selected = callback[b];
            selectedMasterDataFamilies($scope.masterDataFamilies.selected, function(callback){
              $scope.masterDataClasses = callback;
              for(var c = 0; c < callback.length ; c++){
                if(callback[c].code === commodityClass){
                  $scope.masterDataClasses.selected = callback[c];
                }
              }
            });
          }
        }
      });

      $scope.commodityDetails.commodity = tempCommodity;
    }

    if($scope.commodityDetails.posting === 1){
      $scope.posting = 'POSTING';
    }
    else{
      $scope.posting = 'NON POSTING';
    }
    $scope.commodityDetails.posting = {text: $scope.posting};
  }

  initialize();

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker)
  {
    if(!!value) {
      availability.get(
        {
          model: model,
          field: field,
          value: $scope.firstSixCode + value
        },
        function (resource) {
          if(resource) {
            if(checker === 'code'){
              $scope.codeCheck = false;
            }
          }
        },
        function (error) {
          if(error) {
            if(checker === 'code' && ($scope.commodityDetails.commodity != $scope.originalCode)){
              $scope.codeCheck = true;
            }
            else {
              $scope.codeCheck = false;
            }
          }
        }
      );
    }
  }
}

commodityDetailsCtrl.$inject = [
  '$scope', 'toastr', 'commodityDetails', 'segmentList', 'commodityList', 'singleCommodity',
  'availability', '$uibModalInstance', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('commodityDetailsCtrl', commodityDetailsCtrl);

'use strict';
/**
 * @name addCommodityCtrl
 * @desc Controller for adding commodity code
 */

function addCommodityCtrl($scope ,toastr, commodityMasterDataList, commodityList, segmentList, availability,
                          $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.addCommodity = addCommodity;
  $scope.masterDataSegments = segmentList.data;
  $scope.masterDataFamilies = [];
  $scope.masterDataClasses = [];
  $scope.masterDataCommodities = [];

  $scope.segmentCode = undefined;
  $scope.familyCode = undefined;
  $scope.classCode = undefined;
  $scope.commodityCode = undefined;

  $scope.fullCode = undefined;

  $scope.firstSixCode = undefined;

  $scope.selectedMasterDataSegments = selectedMasterDataSegments;
  $scope.selectedMasterDataFamilies = selectedMasterDataFamilies;
  $scope.selectedMasterDataClasses = selectedMasterDataClasses;
  $scope.duplicationCheck = duplicationCheck;

  // Statuses for dropdown in object
  $scope.commodityStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' },
    { isActive: 'Disabled' }
  ];

  $scope.commodityPosting = [
    {value: 1, text: 'POSTING'},
    {value: 0, text: 'NON POSTING'}
  ];

  $scope.commodityTypes = [
    {value: 'OI' , descr: 'Other Items'},
    {value: 'IT' , descr: 'Information Technology'},
    {value: 'CP' , descr: 'Car Purchase'},
    {value: 'ME' , descr: 'M&E (for SunCity PI only)'}
  ];

  //to push a N/A field for segment
  var empty = {_id: null, code: -1, descr: 'N/A'};
  $scope.masterDataSegments.unshift(empty);

  function selectedMasterDataSegments(item) {
    if (item.code === -1) {
      $scope.masterDataSegments.selected = undefined;
      $scope.masterDataFamilies.selected = undefined;
      $scope.masterDataClasses.selected = undefined;
    } else {
      commodityList.get(
        {
          code : item.unique_name
        },
        function(resource){
          $scope.masterDataFamilies = resource.content.data;
          $scope.segmentCode = item.unique_name;
        },
        function(error){
          globalFunc.objectErrorMessage(error);
        }
      );

      $scope.masterDataFamilies.selected = undefined;
      $scope.masterDataClasses.selected = undefined;
    }
  }

  function selectedMasterDataFamilies(item) {
    commodityList.get(
      {
        code : item.unique_name
      },
      function(resource){
        $scope.masterDataClasses = resource.content.data;
        $scope.familyCode = item.unique_name.substring(2);
      },
      function(error){
        globalFunc.objectErrorMessage(error);
      }
    );

    $scope.masterDataClasses.selected = undefined;
  }

  function selectedMasterDataClasses(item) {
    commodityList.get(
      {
        code : item.unique_name
      },
      function(resource){
        $scope.masterDataCommodities = resource.content.data;
        $scope.classCode = item.unique_name.substring(4);
        $scope.firstSixCode = item.unique_name;
      },
      function(error){
        globalFunc.objectErrorMessage(error);
      }
    );
    $scope.masterDataCommodities.selected = undefined;
  }

  function validate(commodity){
    if(!commodity){
      return false;
    }
    if (!(commodity.descr)) {
      return false;
    }
    if (!(commodity.status)) {
      return false;
    }
    if (!(commodity.domain)) {
      return false;
    }
    if (!(commodity.select_commodity_type)) {
      return false;
    }
    if (!(commodity.commodity) || commodity.commodity.length != 2) {
      return false;
    }
    if (!(commodity.posting)) {
      return false;
    }
    return true;
  }

  function addCommodity(commodity){
    $scope.submitted = true;
    if(validate(commodity)){
      var postingValue = 0;
      if($scope.commodity.posting.text === 'POSTING'){
        postingValue = 1;
      }
      if($scope.commodity.posting.text === 'NON POSTING'){
        postingValue = 0;
      }

        // set status in integer to pass it as parameter
        var tempStatus;
        switch($scope.commodity.status.isActive.toLowerCase()){
          case 'active':
            tempStatus = 1;
            break;
          case 'deactivated':
            tempStatus = 0;
            break;
          case 'disabled':
            tempStatus = 3;
            break;
        }

      $scope.fullCode = $scope.firstSixCode + $scope.commodity.commodity;
      $scope.commodityCode = $scope.fullCode.substring(6);

      var submitData = {
        code: $scope.fullCode,
        descr: $scope.commodity.descr,
        status: tempStatus,
        domain: $scope.commodity.domain,
        type: $scope.commodity.select_commodity_type.value,
        segment: $scope.segmentCode,
        family: $scope.familyCode,
        class: $scope.classCode,
        commodity: $scope.commodityCode,
        unique_name: $scope.fullCode,
        parent_unique_name: $scope.firstSixCode,
        posting: postingValue
      };

        commodityMasterDataList.post(
          {},
          submitData,
          function () {
            toastr.success('Commodity has been added');
            closeModal();
          },
          function () {
            toastr.error('Commodity failed to be added');
            return false;
          }
        )
    }
    else{
      toastr.error('Please fill in required fields');
      return false;
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker)
  {
    if(!!value) {
      availability.get(
        {
          model: model,
          field: field,
          value: $scope.firstSixCode + value
        },
        function (resource) {
          if(resource) {
            if(checker === 'code'){
              $scope.codeCheck = false;
            }
          }
        },
        function (error) {
          if(error) {
            if(checker === 'code'){
              $scope.codeCheck = true;
            }
          }
        }
      );
    }
  }

  function closeModal() {
    $uibModalInstance.close();
  }
}

addCommodityCtrl.$inject = ['$scope', 'toastr', 'commodityMasterDataList', 'commodityList', 'segmentList',
  'availability', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('addCommodityCtrl', addCommodityCtrl);

'use strict';

/**
 * Controller for catalog items listing
 * @param $scope
 * @param dataList
 * @param $uibModal
 * @param toastr
 */

function manageCatalogItemsCtrl($scope, dataList, $uibModal, toastr) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.catalogItemsManageService = dataList;
  $scope.viewCatalogItemDetails = viewCatalogItemDetails;

  $scope.showColumn = showColumn;

  $scope.storageKey = 'catalog-items-management-selected-columns';

  function showColumn(id){
    var i;
    var columns = $scope.columns;
    for (i in columns) {
      if(columns.hasOwnProperty(i)) {
        if (id === columns[i].id) {
          if(!!columns[i].conditional){
            if($scope.status === columns[i].condition)
              return columns[i].selected;
            if(columns[i].condition instanceof Array){
              var j;
              var columnCondition = $scope.columns[i].condition;
              for(j in columnCondition){
                if(columnCondition.hasOwnProperty(j)) {
                  if($scope.status === columnCondition[j])
                    return columns[i].selected;
                }
              }
            }
          }
          else
            return columns[i].selected;
        }
      }
    }
  }

  function viewCatalogItemDetails(data){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/singleItemDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        data: function(){
          return data;
        }
      },
      controller: function ($scope, $uibModalInstance, data, singleItemDetails) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        singleItemDetails.get(
          {
            summary_id: data.import_summary_id,
            import_item_id: data._id
          },
          function(resource){
            $scope.singleItemDetail = resource.content.data;
          },
          function(){
            toastr.error('Unable to view item detail');
          }
        )
      }
    });
  }

}

manageCatalogItemsCtrl.$inject = ['$scope', 'dataList', '$uibModal', 'toastr'];

angular.module('metabuyer')
  .controller('manageCatalogItemsCtrl', manageCatalogItemsCtrl);

'use strict';

/**
 * Controller for catalog groups listing
 * @param $scope
 * @param dataList
 * @param $state
 * @param $uibModal
 * @param pathConstants
 */

function manageCatalogGroupCtrl($scope, dataList, $state, $uibModal, pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.catalogItemsManageService = dataList;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.importCatalogGroups = importCatalogGroups;
  $scope.newCatalogGroup = newCatalogGroup;
  $scope.viewCatalogGroupDetails = viewCatalogGroupDetails;

  $scope.showColumn = showColumn;

  $scope.storageKey = 'catalog-group-management-selected-columns';

  $scope.importLink = pathConstants.apiUrls.imports.now;

  function showColumn(id){
    var i;
    var columns = $scope.columns;
    for (i in columns) {
      if(columns.hasOwnProperty(i)) {
        if (id === columns[i].id) {
          if(!!columns[i].conditional){
            if($scope.status === columns[i].condition)
              return columns[i].selected;
            if(columns[i].condition instanceof Array){
              var j;
              var columnCondition = $scope.columns[i].condition;
              for(j in columnCondition){
                if(columnCondition.hasOwnProperty(j)) {
                  if($scope.status === columnCondition[j])
                    return columns[i].selected;
                }
              }
            }
          }
          else
            return columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function importCatalogGroups(){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Catalog Group Assignment';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
        $scope.params = {
          class: 'Metabuyer\\Models\\CatalogGroup',
          'additional_params[]': ''
        };
      }
    });
  }

  function newCatalogGroup(){
    $state.go('main.user.items.createCatalogGroup');
  }

  function viewCatalogGroupDetails(data){
    $state.go('main.user.items.editCatalogGroup', {id: data._id});
  }

}

manageCatalogGroupCtrl.$inject = ['$scope', 'dataList', '$state', '$uibModal', 'pathConstants'];

angular.module('metabuyer')
  .controller('manageCatalogGroupCtrl', manageCatalogGroupCtrl);

'use strict';

/**
 * Controller for editing catalog groups
 * @param $scope
 * @param toastr
 * @param globalFunc
 * @param catalogGroupDetails
 * @param companyGroupsList
 * @param $state
 * @param companies
 * @param companyGroupsAction
 * @param $rootScope
 */

function editCatalogGroupCtrl($scope, toastr, globalFunc, catalogGroupDetails, companyGroupsList, $state, companies,
                              companyGroupsAction, $rootScope) {
  $scope.deleteGroup = deleteGroup;
  $scope.selectCompany = selectCompany;
  $scope.editMode = editMode;
  $scope.saveChanges = saveChanges;
  $scope.cancelUpdate = cancelUpdate;
  $scope.duplicationCheck = duplicationCheck;

  function deleteGroup(){
    companyGroupsList.delete(
      {
        groupId: $scope.catalogGroupDetails._id
      },
      function (resource) {
        toastr.info('Catalog group deleted');
        $state.go('main.user.items.catalogGroup');
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  /**
   * add / remove a company from a group
   * @param data
   * @param action
   */
  function selectCompany(data, action){
    if(!!$scope.catalogGroupDetails && !!$scope.catalogGroupDetails._id) {
      $scope.saving = true;
      companyGroupsAction.put({
          groupId: $scope.catalogGroupDetails._id,
          companyId: data.code
        },
        {
          action: action
        },
        function (resource) {
          if(action === 'assign')
            toastr.success('Company assigned');
          else
            toastr.success('Company unassigned');

          $scope.saving = false;
        },
        function (error) {
          $scope.saving = false;
          globalFunc.objectErrorMessage(error);
        });
    }
  }

  function editMode(){
    $scope.editClicked = true;
  }

  function validate(){
    return !!$scope.catalogGroupDetails.code && !!$scope.catalogGroupDetails.descr;
  }

  function saveChanges(){
    $scope.submitted = true;
    if(validate()) {

      //TODO: pass tempStatus when status is affecting catalog group (Justin 14/11/16)
      // set status in integer to pass it as parameter
      // var tempStatus;
      // switch ($scope.catalogGroupDetails.status.isActive.toLowerCase()) {
      //   case 'active':
      //     tempStatus = 1;
      //     break;
      //   case 'deactivated':
      //     tempStatus = 0;
      //     break;
      //   case 'disabled':
      //     tempStatus = 3;
      //     break;
      // }

      companyGroupsList.put(
        {
          groupId: $scope.catalogGroupDetails._id
        },
        {
          code: $scope.catalogGroupDetails.code,
          descr: $scope.catalogGroupDetails.descr,
          is_active: 1
        },
        function (resource) {
          toastr.success('Catalog group edit successful');
          $state.go('main.user.items.catalogGroup');
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      )
    }
    else{
      toastr.error('Please fill all the required fields before saving')
    }
  }

  function cancelUpdate(){
    if($scope.editClicked === true){
      $scope.editClicked = false;
      $scope.submitted = false;
      toastr.success('Changes reverted!');
      $state.go('main.user.items.catalogGroup.edit');
    }
    else {
      window.history.back();
    }
  }

  function loadGroupsCompanies(group){
    $scope.loadingCompaniesList = true;
    $scope.selectedCompanies = [];
    var temp;
    _.forEach(companies.data, function(company){
      temp = checkCompany(company, group);
      if (!!temp) {
        $scope.selectedCompanies.push(temp);
      }
    });
    $scope.selectedCompanies = globalFunc.sortObjectsArray($scope.selectedCompanies, 'descr');
  }

  /**
   * Checks inside the company array
   * @param company
   * @param group
   * returns {*}
   */
  function checkCompany(company, group){
    var temp = null;
    if (!!company.catalog_groups) {
      _.forEach(company.catalog_groups, function (companyGroup) {
        if (companyGroup._id === group._id) {
          temp = company;
        }
      });
    }
    return temp;
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize(){

    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    $scope.editClicked = false;
    $scope.catalogGroupDetails = catalogGroupDetails.data;
    $scope.companies = companies.data;
    loadGroupsCompanies($scope.catalogGroupDetails);
    $scope.catalogGroupStatuses = [
      { isActive: 'Active' },
      { isActive: 'Deactivated' }
    ];

    if(!!$scope.catalogGroupDetails.is_active) {
      $scope.catalogGroupDetails.status = {isActive: globalFunc.capitalizeFirstCharacter($scope.catalogGroupDetails.is_active)};
    }
  }

  initialize();
}

editCatalogGroupCtrl.$inject = ['$scope', 'toastr', 'globalFunc', 'catalogGroupDetails', 'companyGroupsList', '$state',
                                'companies', 'companyGroupsAction', '$rootScope'];

angular.module('metabuyer')
  .controller('editCatalogGroupCtrl', editCatalogGroupCtrl);

'use strict';

/**
 * Controller for creating new catalog group
 * @param $scope
 * @param toastr
 * @param globalFunc
 * @param $state
 * @param companyGroupsList
 * @param searchModule
 * @param HighlightId
 */
function createCatalogGroupCtrl($scope, toastr, globalFunc, $state, companyGroupsList, searchModule, HighlightId) {
  $scope.submitCatalogGroup = submitCatalogGroup;
  $scope.cancel = cancel;
  $scope.loadCompanies = loadCompanies;
  $scope.selectCompany = selectCompany;
  $scope.duplicationCheck = duplicationCheck;

  $scope.catalogGroupStatuses = [
    { isActive: 'Active' },
    { isActive: 'Deactivated' }
  ];

  function cancel(){
    window.history.back();
  }

  function loadCompanies(){
    $scope.loadingCompaniesList = true;
    searchModule.get(
      {
        module: 'companies',
        offset: 0
      },
      function (resource) {
        $scope.loadingCompaniesList = false;
        if(!!resource.content && !!resource.content.data){
          $scope.companies = resource.content.data;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        $scope.loadingCompaniesList = false;
      }
    );
  }

  //TODO: have company assigning when adding catalog group (Justin 11/11/16)
  function selectCompany(company, action){
    if(action === 'assign'){
      $scope.selectedCompanyArray.push(company);
    }
    else{
      $scope.selectedCompanyArray = globalFunc.removeValueFromArray($scope.selectedCompanyArray, '_id', company._id);
    }
  }

  function validate(){

    return !!$scope.catalogGroup.code && !!$scope.catalogGroup.descr;

    //TODO: have validation for company assigning when adding catalog group (Justin 11/11/16)
    // if(!$scope.selectedCompanies || (!!$scope.selectedCompanies && $scope.selectedCompanies.length === 0)){
    //   return false;
    // }
  }

  function submitCatalogGroup(code, descr, status){
    $scope.submitted = true;
    if(validate()) {

      //TODO: pass tempStatus when status is affecting catalog group (Justin 14/11/16)
      // set status in integer to pass it as parameter
      // var tempStatus;
      // switch (status.isActive.toLowerCase()) {
      //   case 'active':
      //     tempStatus = 1;
      //     break;
      //   case 'deactivated':
      //     tempStatus = 0;
      //     break;
      //   case 'disabled':
      //     tempStatus = 3;
      //     break;
      // }

      companyGroupsList.post(
        {
          code: code,
          descr: descr,
          is_active: 1
        },
        function (resource) {
          toastr.success('Catalog group added');
          $state.go('main.user.items.catalogGroup');
          HighlightId.setId(resource.content.data._id);
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      )
    }
    else{
      toastr.error('Please fill all the required fields before submitting');
    }
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize(){
    $scope.catalogGroup = {};
    $scope.selectedCompanies = [];
    $scope.selectedCompanyArray = [];
    loadCompanies();
  }

  initialize();
}

createCatalogGroupCtrl.$inject = ['$scope', 'toastr', 'globalFunc', '$state', 'companyGroupsList', 'searchModule',
                                  'HighlightId'];

angular.module('metabuyer')
  .controller('createCatalogGroupCtrl', createCatalogGroupCtrl);

'use strict';

function ManageCatalogCodeCtrl($scope, dataList, catalogCode, $uibModal, globalFunc, toastr, pathConstants) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.catalogCodesManageService = dataList;
  $scope.getActiveStatusName = getActiveStatusName;
  $scope.newCatalogCode = newCatalogCode;
  $scope.importCatalogCodes = importCatalogCodes;
  $scope.viewCatalogCodeDetails = viewCatalogCodeDetails;

  $scope.importLink = pathConstants.apiUrls.imports.now;

  $scope.showColumn = showColumn;

  $scope.storageKey = 'catalog-code-management-selected-columns';

  function showColumn(id){
    var i;
    var columns = $scope.columns;
    for (i in columns) {
      if(columns.hasOwnProperty(i)) {
        if (id === columns[i].id) {
          if(!!columns[i].conditional){
            if($scope.status === columns[i].condition)
              return columns[i].selected;
            if(columns[i].condition instanceof Array){
              var j;
              var columnCondition = $scope.columns[i].condition;
              for(j in columnCondition){
                if(columnCondition.hasOwnProperty(j)) {
                  if($scope.status === columnCondition[j])
                    return columns[i].selected;
                }
              }
            }
          }
          else
            return columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getActiveStatusName(code){
    /**
     DEACTIVATED = 0; 
     ACTIVE = 1; 
     DELETED = 2; 
     DISABLED = 3; 
     */
    if (code === 0 || code === 'INACTIVE') {
      return 'Inactive'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    if (code === 2 || code === 'DELETED') {
      return 'Deleted'
    }
    if (code === 3 || code === 'DISABLED') {
      return 'Disabled'
    }
    return 'N/A';
  }

  function newCatalogCode(){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/catalog-code/add/addCatalogCode.html',
      backdrop: 'static',
      keyboard: false,
      controller: function($scope, $uibModalInstance) {
        $scope.submitCatalogCode = submitCatalogCode;
        $scope.closeModal = closeModal;

        function closeModal(){
          $uibModalInstance.close();
        }

        function submitCatalogCode(code, descr){
          catalogCode.post(
            {
              code: code,
              descr: descr
            },
            function(resource){
              toastr.success('Catalog code added');
              $uibModalInstance.close(resource.content.data);
            },
            function(error){
              globalFunc.objectErrorMessage(error);
            }
          )
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        $scope.dataList.unshift({
          _id: newValue._id,
          code: newValue.code,
          descr: newValue.descr,
          created_at: newValue.created_at,
          updated_at: newValue.updated_at,
          updater: [$scope.user],
          creator: [$scope.user],
          is_active: 1
        });
      }
    }, function () {
    });

  }

  function importCatalogCodes(){
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "Catalog Codes";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
        $scope.params = {
          class: 'Metabuyer\\Models\\CatalogCode',
          'additional_params[]': ''
        };
      }
    });
  }

  function viewCatalogCodeDetails(data){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/catalog-code/details/singleCatalogCode.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        catalogCodeDetails: function($q){
          var deferred = $q.defer();
          catalogCode.get(
            {
              id: data._id
            },
            function(resource){
              deferred.resolve(resource.content || {data: []});
            },
            function(){
              deferred.resolve([]);
            }
          );
          return deferred.promise;
        }
      },
      controller: function($scope, $uibModalInstance, catalogCodeDetails) {
        $scope.closeModal = closeModal;
        $scope.catalogCodeDetails = catalogCodeDetails.data;
        $scope.saveChanges = saveChanges;

        function closeModal(){
          $uibModalInstance.close();
        }

        function validateDesc(){
          if(!$scope.catalogCodeDetails.descr){
            return false;
          }
          return true;
        }

        function saveChanges(){

          if(validateDesc() == false) {
            toastr.error('Please fill required field before proceeding');
            return;
          }

          catalogCode.put(
                {
                  id: $scope.catalogCodeDetails._id
                },
                {
                  code: $scope.catalogCodeDetails.code,
                  descr: $scope.catalogCodeDetails.descr
                },
                function(resource){
                  toastr.success('Catalog code details updated');
                  $uibModalInstance.close(resource.content.data);
                },
                function(error){
                  globalFunc.objectErrorMessage(error);
                }
            )
        }

      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.dataList, function(dataList){
          if(dataList._id === newValue._id){
            dataList.code = newValue.code;
            dataList.descr = newValue.descr;
            dataList.is_active = newValue.is_active;
            dataList.updater[0].display_name = newValue.updater.display_name;
            dataList.updated_at = newValue.updated_at;
          }
        });
      }
    }, function () {
    });
  }

}

ManageCatalogCodeCtrl.$inject = ['$scope', 'dataList', 'catalogCode', '$uibModal', 'globalFunc', 'toastr', 'pathConstants'];

angular.module('metabuyer')
  .controller('ManageCatalogCodeCtrl', ManageCatalogCodeCtrl);

'use strict';
/**
 * @name manageIndustryCtrl
 * @desc Controller for managing Industry
 */
function manageIndustryCtrl($scope, $stateParams, industryList, listingIndustries, pathConstants, $uibModal) {
  $scope.status = $stateParams.status;
  $scope.title = $stateParams.title;
  $scope.dataList = industryList.data;
  $scope.meta = industryList.meta;
  $scope.listingIndustryService = listingIndustries;
  $scope.importIndustry = importIndustry;
  $scope.importLink = pathConstants.apiUrls.industry.import;
  $scope.showColumn = showColumn;

    function importIndustry() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "Industry";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };
        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  $scope.storageKey = 'industries-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

}
manageIndustryCtrl.$inject = ['$scope','$stateParams', 'industryList', 'listingIndustries', 'pathConstants','$uibModal'];

angular.module('metabuyer')
  .controller('manageIndustryCtrl', manageIndustryCtrl);

'use strict';
/**
 * @name industryDetailCtrl
 * @desc Controller for industry detail
 */
function industryDetailCtrl($scope, $state, toastr, industryDetails, singleIndustry, globalFunc, $rootScope) {

  $scope.industryDetails = industryDetails.data;
  $scope.editIndustry = false;
  $scope.updateChanges = updateChanges;
  $scope.revertUpdate = revertUpdate;
  $scope.cancelUpdate = cancelUpdate;
  $scope.back = back;
  $scope.editableIndustry = editableIndustry;
  $scope.deleteIndustry = deleteIndustry;
  $scope.updateIndustry = updateIndustry;
  $scope.duplicationCheck = duplicationCheck;
  $scope.newIndustryDetails = {};

  function back() {
    window.history.back();
  }

  function editableIndustry() {
    angular.copy($scope.industryDetails, $scope.newIndustryDetails);
    $scope.editIndustry = true;
  }


  $scope.validateInputData = function(){

    if(!$scope.industryDetails.descr || !$scope.industryDetails.descr.length) {
      return false;
    }

    if(!$scope.industryDetails.code || !$scope.industryDetails.code.length) {
      return false;
    }

    return true;
  };

  function updateChanges(){

    $scope.submitted = true;
    if($scope.validateInputData() == false){
      toastr.error("Please fill the required fields before proceeding");
      return;
    }
    updateIndustry();
  }

  function revertUpdate() {
    $state.go('main.user.companiesMgmt.manageIndustries');
  }

  function cancelUpdate() {
    $scope.editIndustry = false;
  }
  function getUpdateData(){
    var update_data = {
      _id: $scope.industryDetails._id
    };

    if(!!$scope.newIndustryDetails.descr){
      update_data.descr = $scope.newIndustryDetails.descr;
    }
    if(!!$scope.newIndustryDetails.code && $scope.newIndustryDetails.code.trim() !== '' &&
      $scope.newIndustryDetails.code !== $scope.industryDetails.code){
      update_data.code = $scope.newIndustryDetails.code;
    }

    return update_data;
  }

  function updateIndustry() {

    singleIndustry.put(
      {
        id: $scope.industryDetails._id
      },
      getUpdateData() ,
      function(){
        toastr.success('The Industry was updated successfully');
        $state.go("main.user.companiesMgmt.manageIndustries");
      },
      function(){
        toastr.error('Failed to update the Industry');
        revertUpdate();
      }
    );
  }

  function deleteIndustry() {
    swal(
      {
        title: "Confirm delete Industry?",
        text: "This Industry will be deleted by you",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function(isConfirm) {
        if(isConfirm){
          singleIndustry.delete(
            {
              id: $scope.industryDetails._id
            },
            function(){
              toastr.success('The Industry was deleted successfully');
              $state.go("main.user.companiesMgmt.manageIndustries");
            },
            function(){
              toastr.error('Failed to delete the Industry');
            }
          );
        }
      }
    );
  }


  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[2],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

industryDetailCtrl.$inject = [
  '$scope', '$state', 'toastr', 'industryDetails', 'singleIndustry', 'globalFunc', '$rootScope'
];

angular
  .module('metabuyer')
  .controller('industryDetailCtrl', industryDetailCtrl);

'use strict';
/**
 * @name addIndustryCtrl
 * @desc Controller for add Industry
 */
function addIndustryCtrl($scope, $state, newIndustry, toastr, globalFunc, $rootScope) {

  $scope.submitted = false;
  $scope.duplicationCheck = duplicationCheck;
  $scope.addIndustry = addIndustry;
  $scope.back = back;
  $scope.cancelAddIndustry = cancelAddIndustry;

  $scope.industry = {};

  function validate(){

    if(!$scope.industry.name || !$scope.industry.name.length) {
      return false;
    }

    if(!$scope.industry.code || !$scope.industry.code.length) {
      return false;
    }

    return true;
  }

  function back() {
    window.history.back();
  }

  //upload company detail
  function addIndustry(){

    $scope.submitted = true;

    if(validate() == false){
      toastr.error('Please fill all required fields before proceeding');
      return;
    }

    var submit_data = {
      descr: $scope.industry.name,
      code: $scope.industry.code
    };

    newIndustry.post(
      {},
      submit_data,
      function (resource) {
        toastr.success("Industry has been added");
        $state.go("main.user.companiesMgmt.manageIndustries");
      },
      function (err) {
        globalFunc.objectErrorMessage(err);
      }
    )
  }
  //cancel button
  function cancelAddIndustry(){
    $state.go('main.user.companiesMgmt.manageIndustries');
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[3],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();

}

addIndustryCtrl.$inject = ['$scope', '$state', 'newIndustry', 'toastr', 'globalFunc', '$rootScope'];

angular
  .module('metabuyer')
  .controller('addIndustryCtrl', addIndustryCtrl);



'use strict';
/**
 * @name CostCentersManageCtrl
 * @desc Controller for companies cost centers tabs
 */
function CostCentersManageCtrl($scope, $stateParams, costCenters , CostCenters) {
  $scope.status = $stateParams.status;
  $scope.title = $stateParams.title;
  $scope.costCenters = costCenters.data;
  //if ($scope.actionType == 'search')
  //  $scope.activeSearch(true);
  //else {
  //  $scope.activeSearch(false);
  //  $scope.tabData.more.activateTab($scope.status);
  //}
  // Store last open tab
  $scope.pagination = {
    index: 1,
    init: function (meta) {
      $scope.pagination.size = Math.min(CostCentersManageCtrl.PazeSize, meta.count),
        $scope.pagination.total = meta.count;
      $scope.pagination.meta = meta;
    },
    getTotalPage: function () {
      return $scope.pagination.total;
    },
    getPageIndex: function () {
      return $scope.pagination.index * $scope.pagination.size - $scope.pagination.size + 1;
    },
    getPageSize: function () {
      return Math.min($scope.pagination.index * $scope.pagination.size, $scope.pagination.total);
    },
    goPreviousPage: function () {
      if ($scope.pagination.getPageIndex() == 1) return;
      --$scope.pagination.index;
      $scope.pagination.cursor = $scope.pagination.meta.prev;
      $scope.action.refresh();
    },
    goNextPage: function () {
      if ($scope.pagination.getPageSize() == $scope.pagination.total) return;
      ++$scope.pagination.index;
      $scope.pagination.cursor = $scope.pagination.meta.next;
      $scope.action.refresh();
    }
  };

  if ($scope.costCenters.length && !!costCenters.meta) {
    $scope.pagination.init(costCenters.meta.cursor);
  }
  else {
    $scope.pagination.init({count: $scope.costCenters.length});
  }
  var checkedListItem = [];
  // Trigger if any item is checked. Display action button.
  $scope.check = function (requisition) {
    checkedListItem.splice(0, checkedListItem.length);
    $scope.showAction = false;
    for (var index = 0; index < $scope.costCenters.length; ++index) {
      var item = $scope.costCenters[index];
      if (!item.selected) {
        continue;
      }
      $scope.showAction = true;
      checkedListItem.push(item);
    }
  };
  // Check all item.
  $scope.checkAll = function () {
    if ($scope.selectedAll) {
      $scope.showAction = $scope.selectedAll = true;
    } else {
      $scope.showAction = $scope.selectedAll = false;
    }
    checkedListItem.splice(0, checkedListItem.length);
    angular.forEach($scope.costCenters, function (item) {
      item.selected = $scope.selectedAll;
      if (item.selected)
        checkedListItem.push(item);
    });
  };

  $scope.action = {
    refresh: function () {
      if ($scope.actionType == 'show') {
        var param = {
          status: $scope.status,
          offset: $scope.pagination.size
        };

        if(!!$scope.pagination.cursor){
          param.cursor = $scope.pagination.cursor;
        }

        CostCenters.get(
          param,
          function (resource) {
            if(!!resource && !!resource.content && !!resource.content.data){
              $scope.companies = resource.content.data;
            }

            if(!!resource && !!resource.content && !!resource.content.data && !! resource.content.meta.cursor){
              $scope.pagination.init(resource.content.meta.cursor);
            }

            $scope.pagination.pageLoad.finish();
          },
          function (error) {
            if (error.status === 404) {
              window.location = "404.html";
            }

            $scope.pagination.pageLoad.finish();
          }
        );
      } else if ($scope.actionType == 'search') {

      }
    }
  };

  $scope.column = {
    columns: [
      {id: 'company', label: 'Company'},
      {id: 'name', label: 'Name'},
      {id: 'code', label: 'Code'},
      {id: 'created', label: 'Created Date'}
    ],
    selectedColumns: [],
    buttonText: {buttonDefaultText: 'Columns'},
    setting: {
      buttonClasses: "btn btn-white",
      smartButtonMaxItems: 3,
      showCheckAll: false,
      showUncheckAll: false
    },
    events: {
      onItemSelect: function (item) {
        $scope.column.saveSelectedColumn($scope.column.selectedColumns);
      },
      onItemDeselect: function (item) {
        $scope.column.saveSelectedColumn($scope.column.selectedColumns);
      }
    },
    showColumn: function (name) {
      for (var index = 0; index < $scope.column.selectedColumns.length; ++index) {
        var item = $scope.column.selectedColumns[index];
        if (item.id == name) {
          return true;
        }
      }
      return false;
    },
    saveSelectedColumn: function (columns) {
      window.localStorage.setItem("costcenter-columns", JSON.stringify(_.map(columns, function (item) {
        return item.id || item
      })));
    },
    loadSelectedColumn: function () {
      return JSON.parse(window.localStorage.getItem("costcenter-columns")) || [];
    }
  };
  // Apply selected column
  var selectedColumn = $scope.column.loadSelectedColumn();
  if (selectedColumn.length == 0) { // Default column
    for (var index = 0; index < $scope.column.columns.length; ++index) {
      $scope.column.selectedColumns.push($scope.column.columns[index]);
    }
  }
  else {
    for (var index = 0; index < selectedColumn.length; ++index) {
      var column = _.find($scope.column.columns, function (item) {
        return item.id == selectedColumn[index];
      });
      if (!!column)
        $scope.column.selectedColumns.push(column);
    }
  }
}

CostCentersManageCtrl.$inject = ['$scope', '$stateParams', 'costCenters', 'CostCenters'];
CostCentersManageCtrl.PazeSize = 50;

angular
  .module('metabuyer')
  .controller('CostCentersManageCtrl', CostCentersManageCtrl);

'use strict';
/**
 * @name costCenterDetailCtrl
 * @desc Controller for cost centers detail
 */
function costCenterDetailCtrl($scope, $state, toastr, costCenterDetails, CostCenters,
                              $uibModalInstance, singleAddress, addressList, globalFunc) {

  $scope.costCenterDetails = costCenterDetails;
  $scope.delivery_address = $scope.costCenterDetails.corresponding_address;
  $scope.editClicked = false;

  $scope.backToDetailCompanies = backToDetailCompanies;
  $scope.cancel = cancel;
  $scope.editCostCenter = editCostCenter;
  $scope.saveDeliveryAddress = saveDeliveryAddress;
  $scope.saveDeliveryAddressChanges = saveDeliveryAddressChanges;
  $scope.updateChanges = updateChanges;
  $scope.deleteCostCenter = deleteCostCenter;
  $scope.validateInput = validateInput;
  $scope.addressesList = addressesList;
  $scope.editCostCenterUsers = editCostCenterUsers;

  $scope.duplicateAddress = {
    value: true
  };

  function cancel() {
    $uibModalInstance.close();
  }

  function backToDetailCompanies() {
    $state.go($scope.previousState.name, $scope.previousState.params);
  }

  function editCostCenter(){
    $scope.editClicked = true;
  }

  function saveDeliveryAddress(){
    //To set default to follow corresponding
    if(!$scope.delivery_address.line1 && !$scope.delivery_address.postal_code
      && !$scope.delivery_address.city && !$scope.delivery_address.state && !$scope.delivery_address.country){
      $scope.duplicateAddress.value = true;
    }

    var submit_data = {
      line1: $scope.delivery_address.line1,
      line2: $scope.delivery_address.line2,
      line3: $scope.delivery_address.line3,
      postal_code: $scope.delivery_address.postal_code,
      city: $scope.delivery_address.city,
      state: $scope.delivery_address.state,
      country: $scope.delivery_address.country
    };
    if(!!$scope.duplicateAddress.value){
      $scope.costCenterDetails.delivery_address_id = $scope.companyDetails.corresponding_address._id;
    }

    addressList.post(
      submit_data,
      function(resource) {
        if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
          $scope.costCenterDetails.delivery_address_id = resource.content.data._id;
          $scope.updateCostCenter();
        }
        else {
          toastr.error("Delivery address failed to add");
        }
      },
      function(error){
        // Check the error is Object or string
        // If String then load the message
        // else Loop the message object
        if (typeof error.data.message === 'string') {
          toastr.error(error.data.message);
        }else {
          // loop the error object
          angular.forEach(error.data.message, function (errorDatas) {
            // Get the object key
            angular.forEach(errorDatas, function () {
              // show the array value of the Error from the json
              toastr.error(errorDatas[0]);
            });

          });
        }
      }
    );
  }

  function saveDeliveryAddressChanges(){
    //To set default to follow corresponding
    if(!$scope.delivery_address.line1 && !$scope.delivery_address.postal_code
      && !$scope.delivery_address.city && !$scope.delivery_address.state && !$scope.delivery_address.country){
      $scope.duplicateAddress.value = true;
    }

      var update_data = {
        line1: $scope.delivery_address.line1,
        line2: $scope.delivery_address.line2,
        line3: $scope.delivery_address.line3,
        postal_code: $scope.delivery_address.postal_code,
        city: $scope.delivery_address.city,
        state: $scope.delivery_address.state,
        country: $scope.delivery_address.country
      };

      singleAddress.put(
        {
          id: $scope.delivery_address._id
        },
        update_data,
        function (resource) {
          if (!!resource._id) {
            $scope.costCenterDetails.delivery_address_id = resource._id;
          }
          $scope.updateCostCenter();
        },
        function (error) {
          // Check the error is Object or string
          // If String then load the message
          // else Loop the message object
          if (typeof error.data.message === 'string') {
            toastr.error(error.data.message);
          } else {
            // loop the error object
            angular.forEach(error.data.message, function (errorDatas) {
              // Get the object key
              angular.forEach(errorDatas, function () {
                // show the array value of the Error from the json
                toastr.error(errorDatas[0]);
              });

            });
          }
          $scope.updateCostCenter();
        }
      );
  }

  function validateInput(){
    if (!!$scope.costCenterDetails.descr && !!$scope.costCenterDetails.descr.length
      && !!$scope.costCenterDetails.code && !!$scope.costCenterDetails.code.length){
      return true;
    }

    if (!$scope.duplicateAddress.value){
      if(!!$scope.delivery_address.line1 && !!$scope.delivery_address.line1.length
      && !!$scope.delivery_address.postal_code && !!$scope.delivery_address.postal_code.length
      && !!$scope.delivery_address.city && !!$scope.delivery_address.city.length
      && !!$scope.delivery_address.state && !!$scope.delivery_address.state.length
      && !!$scope.delivery_address.country && !!$scope.delivery_address.country.length){
        return true;
      }
    }
    return false;
  }

  function updateChanges(){
    $scope.submitted = true;
    if(validateInput() && !$scope.duplicateAddress.value) {
      if(!$scope.delivery_address._id){
        saveDeliveryAddress();
      }
      else if(!!$scope.delivery_address._id === !!$scope.companyDetails.corresponding_address._id){
        saveDeliveryAddress();
      }
      else {
        saveDeliveryAddressChanges();
      }
    }
    else if(!!$scope.duplicateAddress.value){
      $scope.costCenterDetails.delivery_address_id = $scope.companyDetails.corresponding_address._id;
      $scope.updateCostCenter();
    }
    else{
      return false;
    }
  }

  $scope.updateCostCenter = function(){
    var update_data = {
      _id: $scope.costCenterDetails._id,
      descr: $scope.costCenterDetails.descr,
      corresponding_address_id: $scope.costCenterDetails.corresponding_address_id,
      billing_addresses_ids: globalFunc.getArrayOfKeyValues($scope.costCenterDetails.billing_addresses, '_id'),
      delivery_addresses_ids: globalFunc.getArrayOfKeyValues($scope.costCenterDetails.delivery_addresses, '_id')
    };
    CostCenters.put(
      {
        id: $scope.costCenterDetails._id
      }, update_data ,
      function(){
        toastr.success('The Cost Center was updated successfully');
        $uibModalInstance.close($scope.costCenterDetails);
      },
      function(){
        toastr.error('Failed to update the Cost Center');
      }
    );
  };

  function deleteCostCenter(){
    var id = $scope.costCenterDetails._id;
    swal({
        title: "Confirm delete Cost Center?",
        text: "This Cost Center will be deleted. Please confirm",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function() {
        CostCenters.delete(
          {
            id: id
          },
          function() {
            toastr.success('Deleted cost center');
            for (var i in $scope.companyDetails.costCenters) {
              if ($scope.companyDetails.costCenters[i]._id === id) {
                $scope.companyDetails.costCenters.splice(i, 1);
              }
            }
            $uibModalInstance.close();
          },
          function() {
            toastr.error('Failed to delete cost center');
          }
        )
      });
  }

  function addressesList(id) {
    cancel();
    $state.go('main.user.companiesMgmt.costCenterDetail', {companyId: $scope.companyDetails._id, id: id });
  }

  /**
   * Navigate to cost center editing page
   *
   * @param {string} costCenterId Cost center id to be edited
   */
  function editCostCenterUsers(costCenterId) {
    cancel();
    $state.go('main.user.companiesMgmt.detailCompanies.updateCostCenter', {costCenterId: costCenterId});
  }
}

costCenterDetailCtrl.$inject = ['$scope', '$state', 'toastr', 'costCenterDetails', 'CostCenters',
                                '$uibModalInstance', 'singleAddress', 'addressList', 'globalFunc'];

angular
  .module('metabuyer')
  .controller('costCenterDetailCtrl', costCenterDetailCtrl);

'use strict';
/**
 * @name newAddressCtrl
 * @desc Controller for new address controller
 */
function newAddressCtrl(
  $scope, $uibModalInstance, addressType, toastr, addressList, globalFunc, costCenterDetails,
  CostCenters, company
) {

  $scope.addressType = addressType;
  $scope.company = company;
  $scope.cancel = cancel;
  $scope.saveNewAddress = saveNewAddress;
  $scope.duplicatingAddress = duplicatingAddress;
  $scope.address = {};
  $scope.countries = globalFunc.countryCode();
  $scope.MYStates = globalFunc.malaysiaState();
  $scope.onSelectedState = onSelectedState;
  $scope.onSelectedCountry = onSelectedCountry;

  function cancel() {
    $uibModalInstance.close();
  }

  /**
   * To check selected state and country
   */

  function onSelectedState(state){
    $scope.address.state = state.descr;
  }

  function onSelectedCountry(country){
    $scope.address.state = undefined;
    $scope.address.country = country.descr;
    if(country.descr === "Malaysia"){
      $scope.selectedMalaysia = true;
    }
    else
    {
      $scope.selectedMalaysia = false;
    }
  }

  /**
   * To save address to address book endpoint
   */
  function saveNewAddress(addressType) {
    if(validate($scope.address)){
      var data = angular.copy($scope.address);
      data['companyCode'] = $scope.company.code;
      addressList.post(data,
        function(resource){
          if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
            $scope.address['type'] = addressType;
            $scope.address['_id'] = resource.content.data._id;
            $scope.address['reference'] = resource.content.data.reference;
            saveAddressToCostCenter($scope.address);
          }
        }, function(error){
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      toastr.error("Fill the required field");
    }
  }

  /**
   * Save address id (mongoId) to the cost center
   * @param addressType (billing or delivery)
   */
  function saveAddressToCostCenter(addressData){

    var update_data = {};
    update_data['delivery_addresses_ids'] = [];
    update_data['billing_addresses_ids'] = [];

    if(!!costCenterDetails.delivery_addresses){
      _.forEach(costCenterDetails.delivery_addresses, function(deliveryAddress){
        update_data['delivery_addresses_ids'].push(deliveryAddress._id);
      });
    }

    if(!!costCenterDetails.billing_addresses){
      _.forEach(costCenterDetails.billing_addresses, function(billingAddress){
        update_data['billing_addresses_ids'].push(billingAddress._id);
      });
    }

    if(addressData.type === 'billing') {
      update_data['billing_addresses_ids'].push(addressData._id);
    } else {
      update_data['delivery_addresses_ids'].push(addressData._id);
    }

    CostCenters.put(
      {
        id: costCenterDetails._id,
        descr: costCenterDetails.descr
      }, update_data ,
      function(){
        toastr.success('The address was added successfully');
        addressData.selected = true;
        $uibModalInstance.close(addressData);
        if(!$scope.company.related_addresses_ids){
          $scope.company.related_addresses_ids = [];
        }
        $scope.company.related_addresses_ids.push(addressData._id);
      },
      function(){
        toastr.error('Failed to add address');
      }
    );
  }

  function validate() {
    return ($scope.address.line1 && $scope.address.postal_code && $scope.address.state &&
    $scope.address.city && $scope.address.country && $scope.address.phone);

  }

  function duplicatingAddress(checkDuplicate){
    var companyDetails = costCenterDetails.company.data.corresponding_address.data;
    if(checkDuplicate){
      $scope.address.line1 = companyDetails.line1;
      $scope.address.line2 = companyDetails.line2;
      $scope.address.line3 = companyDetails.line3;
      $scope.address.city = companyDetails.city;
      $scope.address.state = companyDetails.state;
      $scope.address.country = companyDetails.country;
      $scope.address.postal_code = companyDetails.postal_code;
    } else {
      $scope.address = {};
    }
  }

}

newAddressCtrl.$inject = [
  '$scope', '$uibModalInstance', 'addressType', 'toastr', 'addressList', 'globalFunc',
  'costCenterDetails', 'CostCenters', 'company'
];

angular
  .module('metabuyer')
  .controller('newAddressCtrl', newAddressCtrl);

'use strict';
/**
 * @name costCenterAddressesCtrl
 * @desc Controller for addresses list controller
 */
function costCenterAddressesCtrl(
  $scope, $state, $uibModal, toastr, costCenterDetails, companyDetails, companyCostCentersList, addresses, CostCenters,
  pathConstants
) {

  $scope.addressList = {};
  $scope.costCenterDetails = costCenterDetails.data;
  $scope.company = companyDetails.data;
  $scope.companyCostCentersList = companyCostCentersList.data;
  $scope.allAddresses = addresses;
  $scope.deliveryAddressActive = false;
  $scope.billingAddressActive = true;
  $scope.importLink = pathConstants.apiUrls.addresses.import;

  $scope.back = back;
  $scope.newAddress = newAddress;
  $scope.addressActiveTab = addressActiveTab;
  $scope.detailAddress = detailAddress;
  $scope.beforeSave = beforeSave;
  $scope.saveSelection = saveSelection;
  $scope.updateAddressModel = updateAddressModel;

  function back() {
    window.history.back();
  }

  function addressActiveTab(type){
    if(type === 'billing'){
      $scope.deliveryAddressActive = false;
      $scope.billingAddressActive = true;
    } else {
      $scope.deliveryAddressActive = true;
      $scope.billingAddressActive = false;
    }
  }

  function backToListingCompanies() {
    $state.go("main.user.companiesMgmt.manageCompanies");
  }

  function setActiveTab() {
    $scope.tabData.active = _.find($scope.tabData, function (tab) {
      if (!!tab.menu && tab.menu.length){
        return _.find(tab.menu, function (item) {
          return item.params.action === "companies";
        });
      }
      else{
        return tab.params.action === "companies";
      }
    });

    if (!!$scope.tabData){
      $scope.tabData.active.active = true;
    }
  }

  function newAddress(type){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/companiesManagement/costcenters/address/addAddress.html',
      controller: 'newAddressCtrl',
      backdrop: 'static',
      keyboard: false,
      resolve:{
        addressType: function() {
          return type;
        },
        costCenterDetails: function() {
          return $scope.costCenterDetails;
        },
        company: function() {
          return $scope.company;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        if(newValue.type === 'billing'){
          $scope.addressList.billing_addresses.push(newValue);
        } else if(newValue.type === 'delivery') {
          $scope.addressList.delivery_addresses.push(newValue);
        }
      }
    }, function () {
      // do nothing for now, the best that this function can do
    });
  }

  function detailAddress(address, type){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/companiesManagement/costcenters/address/editAddress.html',
      controller: 'editAddressCostCenterCtrl',
      backdrop: 'static',
      keyboard: false,
      resolve:{
        addressType: function() {
          return type;
        },
        addressDetail: function() {
          return angular.copy(address);
        },
        costCenterDetails: function() {
          return $scope.costCenterDetails;
        },
        updateFunction: function(){
          return $scope.updateAddressModel;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      var deletedIndex = null;
      var index = 0;

      if(!!newValue){
        if(newValue.type === 'billing'){

          deletedIndex = null;
          index = 0;
          _.forEach($scope.addressList.billing_addresses, function(billing){
            if(billing._id === newValue.id){
              deletedIndex = index;
            }
            index++;
          });

          if (index > -1) {
            $scope.addressList.billing_addresses.splice(deletedIndex, 1);
          }

        } else if(newValue.type === 'delivery') {
          deletedIndex = null;
          index = 0;
          _.forEach($scope.addressList.delivery_addresses, function(delivery){
            if(delivery._id === newValue.id){
              deletedIndex = index;
            }
            index++;
          });

          if (index > -1) {
            $scope.addressList.delivery_addresses.splice(deletedIndex, 1);
          }
        }
      }
    }, function () {
      // do nothing for now, the best that this function can do
    });
  }

  function getIndexFromObject(objects, value){
    var index = 0;
    _.forEach(objects, function(object){
      if(object._id === value){
        return index;
      }
      index++;
    });
  }

  function initialize() {
    setActiveTab();
    /**
     * loading all available addresses in the list
     * @type {Array}
     */
    $scope.addressList.billing_addresses = angular.copy($scope.allAddresses);
    $scope.addressList.delivery_addresses = angular.copy($scope.allAddresses);

    /**
     * checking for the selected Addresses
     */
    checkSelectedAddresses($scope.costCenterDetails);
  }


  function checkSelectedAddresses(costCenters) {

    if (!!costCenters.billing_addresses) {
      for (var i in $scope.addressList.billing_addresses) {
        for (var k in costCenters.billing_addresses) {
          if ($scope.addressList.billing_addresses[i]._id === costCenters.billing_addresses[k]._id) {
            $scope.addressList.billing_addresses[i].selected = true;
          }
        }
      }
    }

    if (!!costCenters.delivery_addresses) {
      for (var i in $scope.addressList.delivery_addresses) {
        for (var k in costCenters.delivery_addresses) {
          if ($scope.addressList.delivery_addresses[i]._id === costCenters.delivery_addresses[k]._id) {
            $scope.addressList.delivery_addresses[i].selected = true;
          }
        }
      }
    }
  }


  /**
   * function to update the Address after being edited in the edit modal
   * @param address
   * @param type
     */
  function updateAddressModel(address, type){
    if(type === 'delivery') {
      for (var i in $scope.addressList.delivery_addresses) {
        if ($scope.addressList.delivery_addresses[i]._id === address._id) {
          $scope.addressList.delivery_addresses[i] = address;
        }
      }
    }
    else {
      for (var i in $scope.addressList.billing_addresses) {
        if ($scope.addressList.billing_addresses[i]._id === address._id) {
          $scope.addressList.billing_addresses[i] = address;
        }
      }
    }
  }

  function beforeSave(ckSelected) {
    if (!ckSelected) {
      swal({
        title: 'Unassign Address',
        text: 'Are you sure you want to unassign this address from the cost center?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        closeOnConfirm: true
      }, function(isConfirm) {
        if(isConfirm) {
          saveSelection();
        } else {
          $state.reload();
        }
      });
    } else {
      saveSelection();
    }
  }


  /**
   * saving the Addresses
   */
  function saveSelection() {

    var update_data = {};
    update_data['delivery_addresses_ids'] = [];
    update_data['billing_addresses_ids'] = [];

    if (!!$scope.addressList.delivery_addresses) {
      _.forEach($scope.addressList.delivery_addresses, function (deliveryAddress) {
        if (!!deliveryAddress.selected) {
          update_data['delivery_addresses_ids'].push(deliveryAddress._id);
        }
      });
    }

    if (!!$scope.addressList.billing_addresses) {
      _.forEach($scope.addressList.billing_addresses, function (billingAddress) {
        if (billingAddress.selected) {
          update_data['billing_addresses_ids'].push(billingAddress._id);
        }
      });
    }
    CostCenters.put(
      {
        id: $scope.costCenterDetails._id,
        descr: $scope.costCenterDetails.descr
      }, update_data,
      function () {
        toastr.success('The addresses were updated successfully');
      },
      function () {
        toastr.error('Failed to update addresses');
        $state.reload();
      }
    );
  }
  initialize();
}

costCenterAddressesCtrl.$inject = [
  '$scope', '$state', '$uibModal', 'toastr', 'costCenterDetails', 'companyDetails', 'companyCostCentersList', 'addresses',
  'CostCenters', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('costCenterAddressesCtrl', costCenterAddressesCtrl);

'use strict';

/**
 * @name editAddressCostCenterCtrl
 * @desc Controller for edit address controller
 */
function editAddressCostCenterCtrl(
  $scope, $uibModalInstance, addressType, toastr, singleAddress, globalFunc, CostCenters, addressDetail,
  costCenterDetails, updateFunction
) {

  $scope.addressType = addressType;
  $scope.updateAddressModel = updateFunction;
  $scope.onUpdatedState = onUpdatedState;
  $scope.onUpdatedCountry = onUpdatedCountry;

  $scope.cancel = cancel;
  $scope.saveEditAddress = saveEditAddress;
  $scope.deleteAddress = deleteAddress;

  function cancel() {
    $uibModalInstance.close();
  }

  function onUpdatedCountry(country){
    $scope.address.state = undefined;
    $scope.address.country = country.descr;
    if(country.descr === "Malaysia"){
      $scope.selectedMalaysia = true;
    }
    else
    {
      $scope.selectedMalaysia = false;
    }
  }

  function onUpdatedState(state){
    $scope.address.state = state.descr;
  }

  /**
   * To save the changes address to address book endpoint
   */
  function saveEditAddress() {
    $scope.submitted = true;
    if(validate($scope.address)){
      singleAddress.put({
          id: addressDetail._id
        },$scope.address,
        function(resource){
          toastr.success("Successfully updated the address");
          $scope.updateAddressModel($scope.address, $scope.addressType);
          cancel();
        }, function(error){
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      toastr.error("Fill the required field");
    }
  }

  function validate() {
    return ($scope.address.line1 && $scope.address.postal_code && $scope.address.state &&
    $scope.address.city && $scope.address.country && $scope.address.phone);
  }

  function deleteAddress(addressType){
    // delete address from array cost center address
    var update_data = {};
    var dataToUpdate = {};

    if(addressType === 'billing'){
      update_data['billing_addresses_ids'] = [];

      if(!!costCenterDetails.billing_addresses){
        _.forEach(costCenterDetails.billing_addresses, function(billingAddress){
          if(addressDetail._id !== billingAddress._id && addressType === 'billing')
            update_data['billing_addresses_ids'].push(billingAddress._id);
        });
      }
    } else if(addressType === 'delivery'){
      update_data['delivery_addresses_ids'] = [];

      if(!!costCenterDetails.delivery_addresses){
        _.forEach(costCenterDetails.delivery_addresses, function(deliveryAddress){
          if(addressDetail._id !== deliveryAddress._id && addressType === 'delivery')
            update_data['delivery_addresses_ids'].push(deliveryAddress._id);
        });
      }
    }

    // to define action
    dataToUpdate['type'] = addressType;
    dataToUpdate['id'] = addressDetail._id;

    CostCenters.put(
      {
        id: costCenterDetails._id,
        descr: costCenterDetails.descr
      }, update_data ,
      function(){
        toastr.success('The address was deleted successfully');
        $uibModalInstance.close(dataToUpdate);
      },
      function(){
        toastr.error('Failed to delete address');
      }
    );
  }

  function initialize(){
    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();
    $scope.address = addressDetail;

    if($scope.address.country === 'Malaysia')
    {
      $scope.selectedMalaysia = true;
    }else {
      $scope.selectedMalaysia = false;
    }
  }

  initialize();

}

editAddressCostCenterCtrl.$inject = [
  '$scope', '$uibModalInstance', 'addressType', 'toastr', 'singleAddress', 'globalFunc', 'CostCenters',
  'addressDetail', 'costCenterDetails', 'updateFunction'
];

angular
  .module('metabuyer')
  .controller('editAddressCostCenterCtrl', editAddressCostCenterCtrl);

'use strict';
/**
 * @name addCostCenterCtrl
 * @desc Controller to add cost center for a company
 */
function addCostCenterCtrl(
  $scope, AddCostCenters, toastr, globalFunc, companyUsers, costCenterData, costCenterUsers
) {
  $scope.submitted = false;
  $scope.costcenter = {};
  $scope.delivery_address = {};
  $scope.costcenter.delivery_address_id = '';
  $scope.addNewAddress = false;
  $scope.billing = {};
  $scope.delivery = {};
  $scope.states = {
    MY: $scope.MYStates
  };
  $scope.duplicateAddress = {
    value: true
  };
  $scope.companyUsers = companyUsers;
  $scope.selectedUsers = [];
  $scope.costCenterUsers = costCenterUsers;
  $scope.costCenterData = costCenterData;
  $scope.isEditingMode = (!!$scope.costCenterData && !!$scope.costCenterData._id);
  $scope.followCompanyAddress = {
    billing: false,
    delivery: false
  };

  $scope.checkAddress = checkAddress;
  $scope.duplicationCheck = duplicationCheck;
  $scope.addCostCenter = addCostCenter;
  $scope.back = back;
  $scope.selectUser = selectUser;
  $scope.removeUser = removeUser;
  $scope.removeAllSelectedUsers = removeAllSelectedUsers;
  $scope.addAllCompanyUsers = addAllCompanyUsers;
  $scope.saveCostCenter = saveCostCenter;

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model, field, value, checker) {
    globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
      switch (callback) {
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  /**
   * Validation before adding cost center
   *
   * @returns {boolean}
   */
  function validateAddCostCenter() {
    $scope.selectedUserIds = _.chain($scope.selectedUsers).pluck('_id').unique().value();

    if (!$scope.costcenter)
      return false;

    if (!$scope.costcenter.descr || !$scope.costcenter.code || !$scope.costcenter.billingAddressId ||
      !$scope.costcenter.deliveryAddressId) {
      globalFunc.objectErrorMessage('Please fill in the required fields.');
      return false;
    }

    if (!!$scope.codeCheck) {
      globalFunc.objectErrorMessage('The code is already taken.');
      return false;
    }

    return true;
  }

  /**
   * Validation for editing cost center
   *
   * @returns {boolean}
   */
  function validateEditedCostCenter() {
    $scope.selectedUserIds = _.chain($scope.selectedUsers).pluck('_id').unique().value();

    if (!$scope.costCenterData || !$scope.costCenterData.code) {
      globalFunc.objectErrorMessage('Cost center code is required.');
      return false;
    }

    return true;
  }

  /**
   * Send request to add the new cost center
   */
  function addCostCenter() {
    $scope.submitted = true;

    var tempBillingArray = [];
    tempBillingArray.push($scope.costcenter.billingAddressId);
    var tempDeliveryArray = [$scope.costcenter.deliveryAddressId];
    if (!!validateAddCostCenter()) {
      var submit_data = {
        descr: $scope.costcenter.descr,
        code: $scope.costcenter.code,
        company_name: $scope.companyDetails.descr,
        company_code: $scope.companyDetails.code,
        billing_addresses_ids: tempBillingArray,
        delivery_addresses_ids: tempDeliveryArray,
        user_ids: $scope.selectedUserIds
      };

      AddCostCenters.post(
        {},
        submit_data,
        function (resource) {
          var temp = {};
          temp._id = resource._id;
          temp.descr = $scope.costcenter.descr;
          temp.code = $scope.costcenter.code;
          $scope.companyDetails.costCenters.push(temp);
          toastr.success('Cost Center added successfully.');
          back();
        },
        function (error) {
          $scope.submitted = false;
          globalFunc.objectErrorMessage(error)
        }
      );
    }
  }

  function checkAddress(type, value) {
    if (type === 'billing') {
      if (value) {
        $scope.costcenter.billingAddressId = $scope.companyDetails.corresponding_address._id;
      } else {
        $scope.costcenter.billingAddressId = null;
      }
    } else {
      if (value) {
        $scope.costcenter.deliveryAddressId = $scope.costcenter.billingAddressId;
      } else {
        $scope.costcenter.deliveryAddressId = null;
      }
    }
  }

  /**
   * Navigate back to previous page
   */
  function back(){
    window.history.back();
  }

  /**
   * Add user into selected user list
   *
   * @param {object} selectedUser User to be added
   */
  function selectUser(selectedUser) {
    $scope.companyUsers = globalFunc.removeValueFromArray($scope.companyUsers, '_id', selectedUser._id);
    $scope.selectedUsers.push(selectedUser);
  }

  /**
   * Remove user from selected user list
   *
   * @param {object} selectedUser User to be removed
   */
  function removeUser(selectedUser) {
    $scope.selectedUsers = globalFunc.removeValueFromArray($scope.selectedUsers, '_id', selectedUser._id);
    $scope.companyUsers.push(selectedUser);
  }

  /**
   * Remove all company user(s) from selected user list
   */
  function removeAllSelectedUsers() {
    swal({
      title: 'Confirm remove all selected user(s)?',
      text: 'All selected user(s) will be deselected.',
      showCancelButton: true,
      confirmButtonColor: '#1ab394',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    }, function () {
      $scope.companyUsers = $scope.companyUsers.concat($scope.selectedUsers);
      $scope.selectedUsers = [];
      toastr.success('All selected user(s) was deselected.');
    });
  }

  /**
   * Add all company user(s) to the selected user list
   */
  function addAllCompanyUsers() {
    swal({
      title: 'Confirm add all selected user(s)?',
      text: 'All company user(s) will be selected.',
      showCancelButton: true,
      confirmButtonColor: '#1ab394',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    }, function () {
      $scope.selectedUsers = $scope.selectedUsers.concat($scope.companyUsers);
      $scope.companyUsers = [];
      toastr.success('All selected user(s) was selected.');
    });
  }

  /**
   * Send request to update the cost center
   */
  function saveCostCenter() {
    if (!!validateEditedCostCenter()) {
      var submitData = {
        code: $scope.costCenterData.code,
        user_ids: $scope.selectedUserIds
      };

      AddCostCenters.put(
        {},
        submitData,
        function () {
          toastr.success('Changes saved successfully.');
        },
        function (error) {
          globalFunc.objectErrorMessage(error)
        }
      );
    }
  }

  /**
   * Function to be run on page load
   */
  function initialize() {
    // if is editing cost center
    if (!!$scope.isEditingMode) {
      $scope.costcenter = $scope.costCenterData;
      $scope.selectedUsers = $scope.costCenterUsers;

      _.forEach($scope.selectedUsers, function (user) {
        $scope.companyUsers = globalFunc.removeValueFromArray($scope.companyUsers, '_id', user._id);
      });
    }
  }

  initialize();
}

addCostCenterCtrl.$inject = [
  '$scope', 'AddCostCenters', 'toastr', 'globalFunc', 'companyUsers', 'costCenterData', 'costCenterUsers'
];

angular
  .module('metabuyer')
  .controller('addCostCenterCtrl', addCostCenterCtrl);

'use strict';
/**
 * @name companyUsers
 * @desc Controller for users list in companies
 */

function companyUsersCtrl($scope, companyDetails, companyUsers, $uibModal, Users, $state, $rootScope) {
  $scope.companyUsers = companyUsers.data;
  $scope.meta = companyUsers.meta;
  $scope.companyDetails = companyDetails.data;
  $scope.userManageService = Users;
  $scope.viewRoles = viewRoles;
  $scope.viewManagers = viewManagers;
  $scope.viewPositions = viewPositions;
  $scope.viewCostCenter = viewCostCenter;
  $scope.getStatusName = getStatusName;

  $scope.showColumn = showColumn;

  $scope.back = back;

  $scope.storageKey = 'companies-users-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }


  function getStatusName(number){
    /**
     * Pending = 0
     *
     * Active = 1
     *
     * Inactive = 2
     *
     * Rejected = 3
     */
    if(number === 0){
      return 'Pending';
    }
    if(number === 1){
      return 'Active';
    }
    if(number === 2){
      return 'Inactive';
    }
    if(number === 3){
      return 'Rejected';
    }
    return 'N/A';
  }

  function back() {
    if (!!$scope.companyDetails && !!$scope.companyDetails._id)
      $state.go('main.user.companiesMgmt.detailCompanies', {id: $scope.companyDetails._id});
    else
      window.history.back();
  }

  function viewCostCenter(listCostCenters, name) {
    /**
     * formatting the cost centers as the return from the backend is not consistent
     * @type {Array}
     */
    var formattedCCs = [];
    var temp;
    for(var i in listCostCenters) {
      temp = {
        code: listCostCenters[i].code,
        descr: listCostCenters[i].descr
      };
      formattedCCs.push(temp);
    }
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showCostCenters-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showCostCenterCtrl,
      resolve: {
        listCostCenters: function () {
          return formattedCCs;
        },
        company: function () {
          return name;
        }}
    })
  }

  function viewRoles(listRoles, name) {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showRoles-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showRolesCtrl,
      resolve: {
        listRoles: function () {
          return listRoles;
        },
        company: function () {
          return name;
        }}
    })
  }

  function viewManagers(listManagers, name) {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showManagers-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showManagersCtrl,
      resolve: {
        listManagers: function () {
          return listManagers;
        },
        company: function () {
          return name;
        }}
    })
  }

  function viewPositions(listPositions, name) {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showPositions-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showPositionsCtrl,
      resolve: {
        listPositions: function () {
          return listPositions;
        },
        company: function () {
          return name;
        }}
    })
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();

}

companyUsersCtrl.$inject = [
  '$scope', 'companyDetails', 'companyUsers', '$uibModal', 'Users', '$state', '$rootScope'
];

angular.module('metabuyer')
  .controller('companyUsersCtrl', companyUsersCtrl);

'use strict';
/**
 * @name manageCompanyCtrl
 * @desc Controller for manage companies
 */
function manageCompanyCtrl($scope, $stateParams, companies, $location, pathConstants, $uibModal, HighlightId) {
  //TODO: safely remove the 3 useless variables (Ahmed Saleh, 25/7/2016)
  $scope.status = $stateParams.status;
  $scope.paramId = $stateParams.bu_id ? $stateParams.bu_id : $stateParams.industry_id;

  $scope.gotoCompaniesList = gotoCompaniesList;
  $scope.back = back;
  $scope.importCompanies = importCompanies;
  $scope.importAddresses = importAddresses;
  $scope.showColumn = showColumn;
  $scope.companies = companies.data;
  $scope.meta = companies.meta;

  $scope.companyImportLink = pathConstants.apiUrls.companies.import;
  $scope.addressImportLink = pathConstants.apiUrls.addresses.import;
  $scope.highlightId = HighlightId.getId();
  if (!!$scope.highlightId) {
    HighlightId.setId(null);
  }

  function back(){
    window.history.back();
  }

  function gotoCompaniesList() {
    $location.url($location.path());
  }

  function importCompanies() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.companyImportLink;
        },
        title: function () {
          return "Companies";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }


  function importAddresses(){
    $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.addressImportLink;
        },
        title: function () {
          return "Addresses";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  $scope.storageKey = 'company-management-listing-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }
}

manageCompanyCtrl.$inject = [
  '$scope','$stateParams', 'companies', '$location', 'pathConstants', '$uibModal', 'HighlightId'
];
manageCompanyCtrl.PazeSize = 50;

angular.module('metabuyer')
  .controller('manageCompanyCtrl', manageCompanyCtrl);

'use strict';
/**
 * @name companyExchangeRateCtrl
 * @desc Controller for account code list in companies
 */
function companyExchangeRateCtrl($scope, companyDetails, currenciesList, $state, companyExchangeRate, $rootScope) {
  $scope.exchangeRate = companyExchangeRate;
  $scope.currenciesExchange = currenciesList;
  $scope.companyDetails = companyDetails.data;

  $scope.back = back;

  function back(){
    if (!!$scope.companyDetails && !!$scope.companyDetails._id)
      $state.go('main.user.companiesMgmt.detailCompanies', {id: $scope.companyDetails._id});
    else
      window.history.back();
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

companyExchangeRateCtrl.$inject = [
  '$scope', 'companyDetails', 'currenciesList', '$state', 'companyExchangeRate', '$rootScope'
];

angular.module('metabuyer')
  .controller('companyExchangeRateCtrl', companyExchangeRateCtrl);

'use strict';
/**
 * @name viewCurrenciesCtrl
 * @desc Controller to see currencies for a company
 */
function viewCurrenciesCtrl($scope, viewCurrencies, company, $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.viewCurrencies = viewCurrencies;
  $scope.company_name = company;

  function closeModal() {
    $uibModalInstance.close();
  }
}

viewCurrenciesCtrl.$inject = ['$scope', 'viewCurrencies', 'company', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('viewCurrenciesCtrl', viewCurrenciesCtrl);

'use strict';
/**
 * @name companiesDetailCtrl
 * @desc Controller for Companies detail
 */
function companyDetailCtrl(
  $scope, $state, companyDetails, Companies, $uibModal, toastr, currenciesList, BUs, industryList, metabuyerCache,
  singleAddress, $filter, pathConstants, companiesDetailImage, $auth, globalFunc, companyCurrencies, companies,
  $rootScope, companyGlobalFunc, expenseTypesList, exportSearch, companyCostCentersAddress, companyBudgetSetting,
  HighlightId) {

  var backupCorrespondingAddress = {
    line1: companyDetails.data.corresponding_address.line1,
    line2: companyDetails.data.corresponding_address.line2,
    line3: companyDetails.data.corresponding_address.line3,
    postal_code: companyDetails.data.corresponding_address.postal_code,
    city: companyDetails.data.corresponding_address.city,
    state: companyDetails.data.corresponding_address.state,
    country: companyDetails.data.corresponding_address.country,
    phone: companyDetails.data.corresponding_address.phone
  };

  $scope.companyDetails = companyDetails.data;
  $scope.tabActive = "companies";
  $scope.parentCompany = [];
  $scope.BUs = BUs.data;
  $scope.industries = industryList.data;
  $scope.currencies = currenciesList;
  $scope.expenseTypes = expenseTypesList;
  $scope.companyCurrencies = companyCurrencies.data;
  $scope.companyDetails.corresponding_address_id = "";
  $scope.preferredCurrencyList = [];
  $scope.selectedCompanyCurrencies = [];
  $scope.selectedPreferredCurrency = {};
  $scope.importLink = pathConstants.apiUrls.costCenters.import;
  $scope.countries = [];
  $scope.MYStates = [];
  $scope.extraSettingCurrencies = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
    buttonDefaultText: 'Select currency'
  };
  $scope.extraSettingExpenseTypes = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
    buttonDefaultText: 'Select Expense type'
  };
  $scope.extraSettingPreferredCurrencies = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    enableSearch: true,
    selectionLimit: 1
  };
  $scope.POInitialStatuses = companyGlobalFunc.getPOInitialStatuses();
  $scope.budgetModuleToggle = null;
  $scope.budgetExceedToggle = null;
  $scope.budgetNotificationToggle = null;
  $scope.budgetThreshold = {
    normal: {
      low: null
    },
    range: {}
  };

  var formatToPercentage = function (value) {
    return value + '%';
  };

  $scope.budgetThreshold.normal.options = {
    floor: 0,
    ceil: 100,
    translate: formatToPercentage,
    showSelectionBar: true,
    getSelectionBarColor: function (value) {
      if (value <= 30)
        return '#2AE02A';
      if (value <= 60)
        return 'yellow';
      if (value <= 80)
        return 'orange';
      return 'red';
    }
  };

  $scope.budgetThreshold.range.options = {
    floor: 0,
    ceil: 100,
    translate: formatToPercentage
  };

  // config flowjs
  $scope.flowConfig = new Flow({
    target: companiesDetailImage.uploadImagePath($scope.companyDetails._id),
    singleFile: true,
    testChunks: false,
    chunkSize: 10000000,
    headers: {
      'Authorization': 'Bearer ' + $auth.getToken()
    }
  });

  /**
   * provide the preferred currency data
   * from selectedCurrencies
   */
  $scope.selectCurrencies = {
    onItemSelect: function (selectedCurrencies) {
      var selectedCurrency = globalFunc.findInArray($scope.currencies, '_id', selectedCurrencies._id);
      $scope.companyCurrencies = globalFunc.removeValueFromArray($scope.companyCurrencies, '_id', selectedCurrencies._id);
      $scope.companyCurrencies.push(selectedCurrency);
      $scope.preferredCurrencyList = $scope.companyCurrencies;
    },
    onItemDeselect: function (deselectedCurrencies) {
      $scope.preferredCurrencyList = globalFunc.removeValueFromArray(
        $scope.preferredCurrencyList, '_id', deselectedCurrencies._id
      );

      if (!!$scope.selectedPreferredCurrency && !!$scope.selectedPreferredCurrency._id) {
        if ($scope.selectedPreferredCurrency._id === deselectedCurrencies._id) {
          $scope.selectedPreferredCurrency = {};
        }
      }
    },
    onDeselectAll: function () {
      $scope.preferredCurrencyList = [];
      $scope.selectedPreferredCurrency = {};
    }
  };

  //$scope.selectPreferredCurrencies = {
  //  onItemSelect: function(selectedCurrencies){
  //    var selectedCurrency = globalFunc.findInArray($scope.currencies, 'code', selectedCurrencies.id);
  //    $scope.selectedPreferredCurrency = selectedCurrency;
  //  }
  //};

  $scope.setActiveTab = setActiveTab;
  $scope.back = back;
  $scope.onSaveCompanyDetails = onSaveCompanyDetails;
  $scope.saveCorrespondingAddressChanges = saveCorrespondingAddressChanges;
  $scope.addCostCenterModal = addCostCenterModal;
  $scope.costCenterDetails = costCenterDetails;
  $scope.viewCurrencies = viewCurrencies;
  $scope.loadParentCompany = loadParentCompany;
  $scope.loadBUs = loadBUs;
  $scope.loadIndustry = loadIndustry;
  $scope.loadApproverOptions = loadApproverOptions;
  $scope.saveBu = saveBu;
  $scope.isUploadImageSuccess = isUploadImageSuccess;
  $scope.importCostCentersModal = importCostCentersModal;
  $scope.onSelectedState = onSelectedState;
  $scope.onSelectedCountry = onSelectedCountry;
  $scope.getPrintLogoSetting = getPrintLogoSetting;
  $scope.duplicationCheck = duplicationCheck;
  $scope.budgetSettingChanges = budgetSettingChanges;
  $scope.budgetSettingToggle = budgetSettingToggle;
  $scope.saveBudgetSetting = saveBudgetSetting;
  $scope.exportCostCenterAddresses = exportCostCenterAddresses;
  $scope.isCostCenterMode = isCostCenterMode;

  /**
   * Generate CSV for address of all cost centers
   */
  function exportCostCenterAddresses() {
    companyCostCentersAddress.get({
        companyId: $scope.companyDetails._id
      },
      function(resource) {
        if (!!resource.content && !!resource.content.data) {
          var newUrl = $filter('format')(pathConstants.apiUrls.reports.download, {
            id: resource.content.data
          });
          window.open(newUrl, '_self');
        } else {
          globalFunc.objectErrorMessage('An error occurred.');
        }
      }, function(error) {
        globalFunc.objectErrorMessage(error);
      }
    )

  }

  function back() {
    if (!!$scope.companyDetails && !!$scope.companyDetails._id) {
      HighlightId.setId($scope.companyDetails._id);
    }
    window.history.back();
  }

  // Set Manage tab active
  function setActiveTab() {
    $scope.tabData.active = _.find($scope.tabData, function (tab) {
      if (!!tab.menu && tab.menu.length) {
        return _.find(tab.menu, function (item) {
          return item.params.action === "companies";
        });
      }
      else {
        return tab.params.action === "companies";
      }
    });

    if (!!$scope.tabData) {
      $scope.tabData.active.active = true;
    }
  }

  function onSelectedCountry(self,country){
    $scope.companyDetails.corresponding_address.state = undefined;
    if(!!self.$data) {
      $scope.companyDetails.corresponding_address.country = self.$data;
      if (self.$data === "Malaysia") {
        $scope.selectedMalaysia = true;
      }
      else {
        $scope.selectedMalaysia = false;
      }
    }
  }

  function onSelectedState(self,state){
    if(!!state) {
      $scope.companyDetails.corresponding_address.state = self.$data;
    }
  }

  function saveCorrespondingAddressChanges() {
    if(validate()) {
      var updateData = {
        line1: $scope.companyDetails.corresponding_address.line1,
        line2: $scope.companyDetails.corresponding_address.line2,
        line3: $scope.companyDetails.corresponding_address.line3,
        postal_code: $scope.companyDetails.corresponding_address.postal_code,
        city: $scope.companyDetails.corresponding_address.city,
        state: $scope.companyDetails.corresponding_address.state,
        country: $scope.companyDetails.corresponding_address.country,
        phone: $scope.companyDetails.phone
      };

      if (!_.isEqual(updateData, backupCorrespondingAddress)) {
        singleAddress.put(
          {
            id: $scope.companyDetails.corresponding_address._id
          },
          updateData,
          function () {
            onSaveCompanyDetails($scope.companyDetails);
          },
          function (error) {
            globalFunc.objectErrorMessage(error);
          }
        )
      } else {
        onSaveCompanyDetails($scope.companyDetails);
      }
    }
  }

  function prepareCompanyChangedData(companyData) {
    /**
     * check if the GST was update and if its available
     */
    var companyDataChanges = {};
    var companyCurrency = [];
    var preferredCurrency = '';
    if (!!$scope.companyCurrencies && !!$scope.selectedPreferredCurrency) {
      companyCurrency = reformatCurrenciesSelected();
      preferredCurrency = $scope.selectedPreferredCurrency.code;
    }
    if ($scope.companyDetails.gst_code !== $scope.tempGST) {
      companyDataChanges.gst_code = $scope.companyDetails.gst_code;
    }
    companyDataChanges.descr = companyData.descr;
    companyDataChanges.print_logo = companyData.print_logo.value;
    companyDataChanges.parent_company_id = (!!companyData.parent_company && !!companyData.parent_company.length > 0) ? companyData.parent_company[0]._id : null;
    companyDataChanges.currencies = companyCurrency;
    companyDataChanges.currency_code = preferredCurrency;
    companyDataChanges.fax = companyData.fax;
    companyDataChanges.email = companyData.email;
    companyDataChanges.phone = companyData.phone;
    companyDataChanges.corresponding_address_id = $scope.companyDetails.corresponding_address._id;
    companyDataChanges.PO_initial_status = companyData.PO_initial_status.value;
    companyDataChanges.expense_types = globalFunc.getArrayOfKeyValues(companyData.expense_types, '_id');
    companyDataChanges.allowedToHoldPR = $scope.companyDetails.config.allowedToHoldPR;
    companyDataChanges.billingCompanies = $scope.companyDetails.billingCompanies;
    companyDataChanges.defaultBillingCompany = $scope.companyDetails.defaultBillingCompany;
    companyDataChanges.budget_setting = $scope.companyDetails.budget_setting;

    return companyDataChanges;
  }

  function onSaveCompanyDetails(companyData) {
    var companyDataChanges = prepareCompanyChangedData(companyData);
    Companies.put(
      {
        id: companyData._id
      }, companyDataChanges,
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.message) {
          toastr.success(resource.content.message);
          //todo: update addresses correctly without using state reload
          $state.reload();
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        $state.reload();
      }
    );
  }

  /**
   * Navigate to add cost center page
   */
  function addCostCenterModal() {
    $state.go('main.user.companiesMgmt.detailCompanies.addCostCenter');
  }

  /**
   * To check if currently is in cost center mode
   */
  function isCostCenterMode() {
    return $state.includes('main.user.companiesMgmt.detailCompanies.addCostCenter') ||
      $state.includes('main.user.companiesMgmt.detailCompanies.updateCostCenter');
  }

  function costCenterDetails(costCenterId) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/companiesManagement/costcenters/details/details.html',
      controller: 'costCenterDetailCtrl',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      resolve: {
        costCenterDetails: function ($q, CostCenters) {
          var deferred = $q.defer();
          CostCenters.get(
            {
              id: costCenterId
            },
            function (resource) {
              deferred.resolve(resource.content.data || []);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        },
        companyDetails: function(){
          return $scope.companyDetails;
        }
      }
    });
    modalInstance.result.then(function (newValue) {
      if (!!newValue) {
        _.forEach($scope.companyDetails.costCenters, function (dataList) {
          if (dataList._id === newValue._id) {
            dataList.descr = newValue.descr;
            dataList.corresponding_address_id = newValue.delivery_address_id;
          }
        });
      }
    }, function () {
    });
  }

  function viewCurrencies(companyCurrencies, company){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/companiesManagement/companies/details/viewCurrencies-modalTemplate.html',
      controller: 'viewCurrenciesCtrl',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        viewCurrencies: function (){
          return companyCurrencies;
        },
        company: function (){
          return company.descr;
        }
      }
    });
  }

  function saveBu(dataChanges) {
    var newData = prepareCompanyChangedData(dataChanges);
    newData.bu_code = dataChanges.business_unit.code;
    newData.industry_code = dataChanges.industry.code;

    Companies.put(
      {
        id: dataChanges._id
      }, newData,
      function (resource) {
        toastr.success((!!resource.content && !!resource.content.message && _.isString(resource.content.message))
          ? resource.content.message : 'Successfully updated' );
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * To send request to backend and save budget setting
   */
  function saveBudgetSetting(dataChanges) {
    var newData = prepareCompanyChangedData(dataChanges);
    newData.budget_setting = {
      'enable': $scope.budgetModuleToggle,
      'allow_pr_overbudget': $scope.budgetExceedToggle,
      'threshold_notification': {
        'enable': $scope.budgetNotificationToggle,
        'threshold': $scope.budgetThreshold.normal.low
      }
    };

    Companies.put(
      {
        id: dataChanges._id
      }, newData,
      function (resource) {
        toastr.success((!!resource.content && !!resource.content.message && _.isString(resource.content.message))
          ? resource.content.message : 'Successfully updated');
        $scope.companyDetails.budget_setting.enable = $scope.budgetModuleToggle;
        $scope.companyDetails.budget_setting.allow_pr_overbudget = $scope.budgetExceedToggle;
        $scope.companyDetails.budget_setting.threshold_notification.enable = $scope.budgetNotificationToggle;
        $scope.companyDetails.budget_setting.threshold_notification.threshold = $scope.budgetThreshold.normal.low;
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function getPrintLogoSetting(printLogoValue){
     switch(printLogoValue){
       case 0:
         return 'No logo';
         break;
       case 1:
         return 'Tenant Logo';
         break;
       case 2:
         return 'Company Logo';
         break;
     }
  }

  function loadParentCompany() {
    if (!!$scope.companyDetails.parent_company) {
      return $scope.parentCompany = companies.data;
    }
    else {
      return '-';
    }
  }

  function loadBUs() {
    var returnText = "Not set";

    if (!!$scope.companyDetails.business_unit && !!$scope.companyDetails.business_unit.code) {
      var selected = globalFunc.findInArray(BUs.data, 'code', $scope.companyDetails.business_unit.code);

      if ($scope.companyDetails.business_unit.code && !!selected)
        returnText = selected.code + " (" + selected.descr + ")";
    }
    return returnText;
  }

  function loadIndustry() {
    var returnText = "Not set";
    if (!!$scope.companyDetails.industry && !!$scope.companyDetails.industry.code) {
      var selected = globalFunc.findInArray(industryList.data, 'code', $scope.companyDetails.industry.code);

      if ($scope.companyDetails.industry.code && !!selected)
        returnText = selected.code + " (" + selected.descr + ")";
    }
    return returnText;
  }

  function loadApproverOptions() {
    var returnText = 'No';
    if(!!$scope.companyDetails.config.allowedToHoldPR) {
      returnText = 'Yes';
    }
    return returnText;
  }




  function isUploadImageSuccess(file, message) {
    if (message) {
      var response = JSON.parse(message);
      toastr.success(response.content.message);
    }
  }

  function initialize() {
    budgetSettingToggle('reset');
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    $scope.printLogoOptions = [
      {
        descr: 'No Logo',
        value: 0
      },
      {
        descr: 'Tenant Logo',
        value: 1
      },
      {
        descr: 'Company Logo',
        value: 2
      }
    ];

    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();

    $scope.companyDetails.currency_code = globalFunc.findInArray($scope.companyCurrencies, 'code', $scope.companyDetails.currency_code);

    // storing the initial GST to use it for duplication check later on.
    $scope.tempGST = null;
    if(!!$scope.companyDetails.gst_code){
      $scope.tempGST = $scope.companyDetails.gst_code;
    }

    $scope.selectedMalaysia = ($scope.companyDetails.corresponding_address && $scope.companyDetails.corresponding_address.country === 'Malaysia');

    $scope.companyDetails.PO_initial_status = globalFunc.findInArray(
      $scope.POInitialStatuses, 'value', $scope.companyDetails.PO_initial_status
    );

    $scope.imageBasePath = pathConstants.apiUrls.image.user;
    setActiveTab();
//    companyCurrenciesData();
    preferredCurrencyInitValue();
    loadApproverOptions();

    //set params to send company id for export
    var params = {
      module: 'cost-centers',
      offset: 0,
      'criteria[company_code]': $scope.companyDetails.code
    };
    exportSearch.setParams(params);
  }

  /**
   * initial value for preferred currency
   */
  function preferredCurrencyInitValue(){
    $scope.preferredCurrencyList = $scope.companyCurrencies;
    $scope.selectedPreferredCurrency = globalFunc.findInArray(
      $scope.preferredCurrencyList, 'code', $scope.companyDetails.currency_code.code
    );
  }

  /**
   * Reformat Currencies Selected
   * reformat after the ng-dropdown-multiselect
   * to follow the endpoint format
   */
  function reformatCurrenciesSelected(){
    var companyCurrency = [];
    _.forEach($scope.companyCurrencies, function(currency){
      companyCurrency.push(currency.code);
    });

    return companyCurrency;
  }

  /**
   * To import Cost Centers by uploading csv file
   */
  function importCostCentersModal() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "Cost Centers";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'rocCheckTrue':
          $scope.rocCheck = true;
          break;
        case 'gstCheckTrue':
          $scope.gstCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
        case 'rocCheckFalse':
          $scope.rocCheck = false;
          break;
        case 'gstCheckFalse':
          $scope.gstCheck = false;
          break;
      }
    });
  }

  /**
   * To check if budget setting is changed by the user
   */
  function budgetSettingChanges() {
    return ($scope.budgetModuleToggle !== $scope.companyDetails.budget_setting.enable) ||
    ($scope.budgetExceedToggle !== $scope.companyDetails.budget_setting.allow_pr_overbudget) ||
    ($scope.budgetNotificationToggle !== $scope.companyDetails.budget_setting.threshold_notification.enable) ||
    ($scope.budgetThreshold.normal.low !== ($scope.companyDetails.budget_setting.threshold_notification.threshold || 0)) ?
      true : false;
  }

  /**
   * Events to trigger when budget setting update by user
   * module : if budget module is set to off, sub setting will be set to null
   * notification : if budget notification is turn off, threshold will be set to null
   * reset : reset the initial setting of the budget setting
   */
  function budgetSettingToggle(type) {
    if ($scope.budgetModuleToggle === false && type === 'module') {
      $scope.budgetExceedToggle = false;
      $scope.budgetNotificationToggle = false;
      $scope.budgetThreshold.normal.low = null;
    }
    if (type === 'notification') {
      if ($scope.budgetNotificationToggle === false) {
        $scope.budgetThreshold.normal.low = null;
      } else {
        $scope.budgetThreshold.normal.low =
          (!!$scope.companyDetails.budget_setting &&
          !!$scope.companyDetails.budget_setting.threshold_notification &&
          !!$scope.companyDetails.budget_setting.threshold_notification.threshold) ?
            !!$scope.companyDetails.budget_setting.threshold_notification.threshold : 80; // initialize value to 80
      }
    }
    if (type === 'reset') {
      $scope.budgetModuleToggle = $scope.companyDetails.budget_setting.enable;
      $scope.budgetExceedToggle = $scope.companyDetails.budget_setting.allow_pr_overbudget;
      $scope.budgetNotificationToggle = $scope.companyDetails.budget_setting.threshold_notification.enable;
      $scope.budgetThreshold.normal.low = $scope.companyDetails.budget_setting.threshold_notification.threshold;
    }
  }

  /**
   * validate the entries of the company
   * @returns {boolean}
   */
  function validate() {
    /**
     * validate the gst code
     */
    if ($scope.gstCheck === true) {
      $scope.companyDetails.gst_code = $scope.tempGST;
      toastr.error('The GST number is registered to another company');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address){
      toastr.error('The Address is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.line1){
      toastr.error('The Address First line field is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.postal_code){
      toastr.error('The Address Postal code field is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.city){
      toastr.error('The Address City field is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.state){
      toastr.error('The Address State field is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.country){
      toastr.error('The Address Country field is required');
      return false;
    }
    if(!$scope.companyDetails.phone){
      toastr.error('The phone field is required');
      return false;
    }
    if(!$scope.companyDetails.corresponding_address.state){
      toastr.error('The Address State field is required');
      return false;
    }
    if (!$scope.companyCurrencies ||
      (!!$scope.companyCurrencies && !$scope.companyCurrencies.length)
    ){
      toastr.error('The Company Currency is required');
      return false;
    }
    if (!$scope.selectedPreferredCurrency ||
      (!!$scope.selectedPreferredCurrency && !$scope.selectedPreferredCurrency.code)
    ){
      toastr.error('The Preferred Currency is required');
      return false;
    }
    if(!$scope.companyDetails.expense_types || !$scope.companyDetails.expense_types.length){
      toastr.error('The expense type is required');
      return false;
    }
    return true;
  }

  initialize();

}
companyDetailCtrl.$inject = [
  '$scope', '$state', 'companyDetails', 'Companies', '$uibModal', 'toastr', 'currenciesList', 'BUs', 'industryList',
  'metabuyerCache', 'singleAddress', '$filter', 'pathConstants', 'companiesDetailImage', '$auth', 'globalFunc',
  'companyCurrencies', 'companies', '$rootScope', 'companyGlobalFunc', 'expenseTypesList', 'exportSearch', 'companyCostCentersAddress',
  'companyBudgetSetting', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('companyDetailCtrl', companyDetailCtrl);

'use strict';

/**
 * @name companyContentCtrl
 * @desc Controller for managing company placeholder
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2018 Metacloud Sdn. Bhd.
 */
function companyContentCtrl($scope, $rootScope, $state, globalFunc, Companies,
                            companyGlobalFunc, toastr, pdfPreview, $filter, pathConstants) {

  $scope.back = back;
  $scope.saveTermsAndConditions = saveTermsAndConditions;

  /**
   * Goes back to company details
   */
  function back() {
    if (!!$scope.companyDetails && !!$scope.companyDetails._id)
      $state.go('main.user.companiesMgmt.detailCompanies', {id: $scope.companyDetails._id});
    else
      window.history.back();
  }

  /**
   * Save the terms and conditions
   *
   * @param {string} termsAndConditionsLevel
   * @param {string} customTermsAndConditions
   * @param {boolean} isPreview
   */
  function saveTermsAndConditions(termsAndConditionsLevel, customTermsAndConditions, isPreview) {
    var submitData = {};
    submitData.descr = $scope.companyDetails.descr;
    submitData.print_logo = $scope.companyDetails.print_logo.value;
    submitData.parent_company_id = (!!$scope.companyDetails.parent_company && !!$scope.companyDetails.parent_company.length > 0) ? companyData.parent_company[0]._id : null;
    submitData.currencies = companyGlobalFunc.reformatCurrenciesSelected($scope.companyDetails);
    submitData.currency_code = $scope.companyDetails.currency_code.code;
    submitData.fax = $scope.companyDetails.fax;
    submitData.email = $scope.companyDetails.email;
    submitData.phone = $scope.companyDetails.phone;
    submitData.corresponding_address_id = $scope.companyDetails.corresponding_address._id;
    submitData.PO_initial_status = $scope.companyDetails.PO_initial_status.value;
    submitData.expense_types = globalFunc.getArrayOfKeyValues($scope.companyDetails.expense_types, '_id');
    submitData.allowedToHoldPR = $scope.companyDetails.config.allowedToHoldPR;
    submitData.billingCompanies = $scope.companyDetails.billingCompanies;
    submitData.defaultBillingCompany = $scope.companyDetails.defaultBillingCompany;
    submitData.budget_setting = $scope.companyDetails.budget_setting;
    submitData.terms_and_conditions_level = termsAndConditionsLevel;
    submitData.terms_and_conditions = customTermsAndConditions;

    Companies.put(
      {
        id: $scope.companyDetails._id
      }, submitData,
      function (resource) {
        toastr.success((!!resource.content && !!resource.content.message && _.isString(resource.content.message))
          ? resource.content.message : 'Company updated.');
        if (!!isPreview) {
          previewPDF(termsAndConditionsLevel);
        }
        else {
          $state.go('main.user.companiesMgmt.detailCompanies', {id: $scope.companyDetails._id});
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * Generates a preview pdf
   *
   * @param {string} termsAndConditionsLevel
   */
  function previewPDF(termsAndConditionsLevel) {
    pdfPreview.post(
      {
        id: termsAndConditionsLevel === 'tenant' ? $scope.companyDetails.tenant_id : $scope.companyDetails._id
      },
      {
        terms_and_conditions_level: termsAndConditionsLevel
      },
      function (resource) {
        var newUrl = $filter('format')(pathConstants.apiUrls.globalPDFHashDownload, {
          pdf_hash: resource.url
        });

        setTimeout(function () {
          window.open(newUrl, '_blank')
        }, 1001);
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function initialize() {
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    $scope.companyDetails = companyGlobalFunc.getCompanyData();
    $scope.termsAndConditionsLevel = $scope.companyDetails.terms_and_conditions_level;
    $scope.tenantTermsAndConditions = $scope.companyDetails.tenant_terms_and_conditions;
    $scope.customTermsAndConditions = $scope.companyDetails.terms_and_conditions;
  }

  initialize();
}

companyContentCtrl.$inject = [
  '$scope', '$rootScope', '$state', 'globalFunc', 'Companies', 'companyGlobalFunc',
  'toastr', 'pdfPreview', '$filter', 'pathConstants'
];

angular.module('metabuyer')
  .controller('companyContentCtrl', companyContentCtrl);

'use strict';
/**
 * @name addCompanyCtrl
 * @desc Controller for add companies
 */
function addCompanyCtrl(
  $scope, $q, $resource, $state, pathConstants, Companies, toastr, currenciesList, globalFunc, BU, industryList, addressList,
  $http, searchModule, $rootScope, companyGlobalFunc, expenseTypesList
) {

  $scope.BU = BU.data;
  $scope.industries = industryList.data;
  $scope.submitted = false;
  $scope.company = {};
  $scope.corresponding_address_id = '';
  $scope.corresponding_address = {};
  $scope.selectedCurrencies = [];
  $scope.response_error = {};
  $scope.parentCompanies = [];
  $scope.uploader = {};
  $scope.companyCurrencies = currenciesList;
  $scope.selectedCompanyCurrencies = [];
  $scope.selectedExpenseTypes = [];
  $scope.selectedPreferredCurrency = {};
  $scope.expenseTypes = expenseTypesList;
  $scope.extraSettingCurrencies = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
    buttonDefaultText: 'Select currency'
  };
  $scope.extraSettingExpenseTypes = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
    buttonDefaultText: 'Select expense type'
  };
  $scope.extraSettingPreferredCurrencies = {
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    scrollable: true,
    scrollableHeight: '200px',
    enableSearch: true,
    selectionLimit: 1
  };
  $scope.options = {
    parent_co: [],
    add_fields: []
  };
  $scope._ = {
    isEmpty: _.isEmpty
  };
  $scope.duplicateAddress = {
    value: false
  };
  $scope.selected_options = {
    parent_co: {},
    add_fields: []
  };
  $scope.defaultAddFieldButtonText = {
    buttonDefaultText: "Add Field"
  };
  $scope.POInitialStatuses = companyGlobalFunc.getPOInitialStatuses();

  $scope.onSelectedBU = onSelectedBU;
  $scope.onSelectedIndustry = onSelectedIndustry;
  $scope.saveCorrespondingAddress = saveCorrespondingAddress;
  $scope.addNewCompany = addNewCompany;
  $scope.duplicationCheck = duplicationCheck;
  $scope.remove = remove;
  $scope.changeItem = changeItem;
  $scope.loadOptions = loadOptions;
  $scope.loadOptionsSimple = loadOptionsSimple;
  $scope.cancelAddCompany = cancelAddCompany;
  $scope.validateInputData = validateInputData;
  $scope.saveCompany = saveCompany;
  $scope.uploadFile = uploadFile;
  $scope.onSelectedCountry = onSelectedCountry;
  $scope.onSelectedState   = onSelectedState;
  $scope.countries = [];
  $scope.MYStates = [];
  //setting for add-field multi-select dropdown list
  $scope.settingAddField = {
    smartButtonMaxItems: 1,
    scrollable: true,
    externalIdProp: "",
    displayProp: "name",
    smartButtonTextConverter: function(itemText, originalItem) { return "Add Field"; }
  };

  function remove(item){
    _.remove($scope.selected_options.add_fields, function(selected_item){
      return item === selected_item;
    });
  }

  function changeItem(sub, item){
    item.custom_name = sub;
  }

  function onSelectedState(state){
    $scope.corresponding_address.state = state.descr;
  }

  function onSelectedCountry(country){
    $scope.corresponding_address.state = undefined;
    $scope.corresponding_address.country = country.descr;
    if(country.descr === "Malaysia"){
         $scope.selectedMalaysia = true;
      }
    else
    {
     $scope.selectedMalaysia = false;
    }
  }

  //load option
  function loadOptions(url, params, options, paramValues, scopeOptionName) {
    if ($scope.options[scopeOptionName].length > 0) {
      return $scope.options[scopeOptionName];
    }

    var deferred = $q.defer();
    $resource(
      url,
      params,
      options
    ).get(
      paramValues,
      function (resource) {
        $scope.options[scopeOptionName] = resource.content.data;
        deferred.resolve(resource.data);

      }
    );

    return deferred.promise;
  }

  function loadOptionsSimple(url, scopeOptionName) {
    return $scope.loadOptions(url, {}, {}, {}, scopeOptionName);
  }

  function getCompanies(){
    searchModule.get(
      {
        module: 'companies',
        offset: 0,
        order: 1,
        order_by: 'descr'
      },
      function(resource) {
        if(!!resource.content) {
          $scope.parentCompanies = resource.content.data;
        }else {
          $scope.parentCompanies = [];
        }

        $scope.parentCompanies.unshift({id: null, descr: 'None'});
        $scope.company.parent_company_id = $scope.parentCompanies[0];
      }
    )
  }

  function onSelectedBU(bu){
    $scope.company.bu_code = bu.code;
  }

  function onSelectedIndustry(industry) {
    $scope.company.industry_code = industry.code;
  }

  function validateInputData(){

    if (!$scope.company.name || !$scope.company.name.length) {
      return false;
    }

    if (!$scope.company.code || !$scope.company.code.length) {
      return false;
    }

    if (!$scope.company.reg_no || !$scope.company.reg_no.length) {
      return false;
    }

    if (!$scope.selectedCurrencies) {
      return false;
    }

    if (!$scope.selectedPreferredCurrency) {
      return false;
    }

    if (!$scope.selectedExpenseTypes || !$scope.selectedExpenseTypes.length) {
      return false;
    }

    if (!$scope.company.email || !$scope.company.email.length) {
      return false;
    }

    return true;
  }

  function cancelAddCompany(){
    $state.go('main.user.companiesMgmt.manageCompanies');
  }

  function saveCorrespondingAddress(){
    $scope.corresponding_address.phone = $scope.company.phone;
    addressList.post(
      $scope.corresponding_address,
      function(resource) {
        if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
          $scope.corresponding_address_id = resource.content.data._id;
          saveCompany();
        }
        else {
          toastr.error("Corresponding address failed to add");
        }
      },
        function(error){
          globalFunc.objectErrorMessage(error);
        }
      );
  }

  //function to upload company logo after adding company
  function uploadFile(companyID) {
    var fd = new FormData();
    fd.append("file", $scope.companyFile);
    $http.post(pathConstants.apiUrls.companies.list + '/' + companyID + '/image', fd, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).then(function onSuccess(){
      toastr.success("Company logo uploaded successfully");
      $state.go('main.user.companiesMgmt.manageCompanies');
    }).catch(function onError (){
      toastr.error("Company logo failed to add");
    });
  }

  //upload company detail
  function saveCompany(){
    var companyCurrency = [];
    var preferredCurrency = '';
    var expenseTypes = [];

    $scope.company_detail_form.company_name.$dirty = true;

    if(!!$scope.selectedCurrencies){
      companyCurrency = globalFunc.getArrayOfKeyValues($scope.selectedCurrencies, 'code');
      preferredCurrency = $scope.selectedPreferredCurrency.code;
    }

    if (!!$scope.selectedExpenseTypes) {
      expenseTypes = globalFunc.getArrayOfKeyValues($scope.selectedExpenseTypes, '_id');
    }

    if(!$scope.company.allowedToHoldPR) {
      $scope.company.allowedToHoldPR = false;
    }

    var submitData = {
      descr: $scope.company.name,
      bu_code: $scope.company.bu_code,
      industry_code: $scope.company.industry_code,
      code: $scope.company.code,
      currencies: companyCurrency,
      currency_code: preferredCurrency,
      fax: $scope.company.fax,
      email: $scope.company.email,
      phone: $scope.company.phone,
      reg_no: $scope.company.reg_no,
      corresponding_address_id: $scope.corresponding_address_id,
      gst_code: $scope.company.gst_code,
      PO_initial_status: $scope.company.PO_initial_status.value,
      expense_types: expenseTypes,
      allowedToHoldPR: $scope.company.allowedToHoldPR
    };
    if(angular.isDefined($scope.company.parent_company_id))
      submitData['parent_company_id'] = $scope.company.parent_company_id._id;

    Companies.post(
      {},
      submitData,
      function(resource){
      toastr.success("Company has been added");
      $state.go('main.user.companiesMgmt.manageCompanies');
        //Upload image after company added
        if(!!resource._id && angular.isDefined($scope.companyFile)) {
          $scope.uploadFile(resource._id);
        }
      },
      function(error){
        if(!!error.data && !!error.data.message){
          toastr.error(error.data.message);
        }
      }
    );
  }


  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'rocCheckTrue':
          $scope.rocCheck = true;
          break;
        case 'gstCheckTrue':
          $scope.gstCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
        case 'rocCheckFalse':
          $scope.rocCheck = false;
          break;
        case 'gstCheckFalse':
          $scope.gstCheck = false;
          break;
      }
    });
  }

  function addNewCompany(){
    $scope.submitted = true;
    if($scope.validateInputData() == false){
      toastr.error('Please fill all required fields before proceeding');
      return;
    }

    saveCorrespondingAddress();
  }

  /**
   * provide the preferred currency data
   * from selectedCurrencies
   */
  $scope.selectCurrencies = {
    onItemSelect: function(selectedCurrencies){
      $scope.selectedCompanyCurrencies.push(selectedCurrencies);
    },
    onItemDeselect: function(deselectedCurrencies){
      $scope.selectedCompanyCurrencies = globalFunc.removeValueFromArray(
        $scope.selectedCompanyCurrencies, '_id', deselectedCurrencies._id
      );

      if(!!$scope.selectedPreferredCurrency && !!$scope.selectedPreferredCurrency._id){
        if($scope.selectedPreferredCurrency._id === deselectedCurrencies._id){
          $scope.selectedPreferredCurrency = {};
        }
      }
    },
    onDeselectAll: function(){
      $scope.selectedCompanyCurrencies = [];
      $scope.selectedPreferredCurrency = {};
    }
  };

  function initialize(){

    var tabData = {
      tab: $scope.$parent.tabData[3],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();
    $scope.company.PO_initial_status = globalFunc.findInArray($scope.POInitialStatuses, 'value', 0);
    getCompanies();
  }

  initialize();

}

addCompanyCtrl.$inject = [
  '$scope', '$q', '$resource', '$state', 'pathConstants', 'Companies', 'toastr', 'currenciesList', 'globalFunc',
  'BU', 'industryList', 'addressList', '$http', 'searchModule', '$rootScope', 'companyGlobalFunc', 'expenseTypesList'
];

angular
  .module('metabuyer')
  .controller('addCompanyCtrl', addCompanyCtrl);



'use strict';
/**
 * @name companyAccountCodeCtrl
 * @desc Controller for account code list in companies
 */
function companyAccountCodeCtrl($scope, companyDetails, companyAccountCodes, $state, $rootScope) {
  $scope.accountCodes = companyAccountCodes;
  $scope.companyDetails = companyDetails.data;

  $scope.back = back;

  function back(){
    if (!!$scope.companyDetails && !!$scope.companyDetails._id)
      $state.go('main.user.companiesMgmt.detailCompanies', {id: $scope.companyDetails._id});
    else
      window.history.back();
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

companyAccountCodeCtrl.$inject = [
  '$scope', 'companyDetails', 'companyAccountCodes', '$state', '$rootScope'
];

angular.module('metabuyer')
  .controller('companyAccountCodeCtrl', companyAccountCodeCtrl);

'use strict';
/**
 * @name manageBUCtrl
 * @desc Controller for managing BU
 */
function manageBUCtrl($scope, $filter, $stateParams, BU, listingBusinessUnits, pathConstants, $uibModal, HighlightId) {
  $scope.status = $stateParams.status;
  $scope.title = $stateParams.title;
  $scope.dataList = BU.data;
  $scope.meta = BU.meta;
  $scope.listingBUService = listingBusinessUnits;
  $scope.highlightId = HighlightId.getId();
  if (!!$scope.highlightId) {
    HighlightId.setId(null);
  }
  $scope.showColumn = showColumn;
  $scope.importBU = importBU;
  $scope.importLink = pathConstants.apiUrls.BusinessUnits.import;
  $scope.getTextualIsActive = getTextualIsActive;

  function importBU() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "Business Unit";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };
        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  $scope.storageKey = 'business-unit-listing-selected-columns';

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getTextualIsActive(code){
    /**
     * DEACTIVATED = 0; 
     * ACTIVE = 1; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    return 'N/A';
  }

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

}

manageBUCtrl.$inject = ['$scope', '$filter','$stateParams', 'BU', 'listingBusinessUnits',
                        'pathConstants','$uibModal', 'HighlightId'];

angular.module('metabuyer')
  .controller('manageBUCtrl', manageBUCtrl);

'use strict';
/**
 * @name BUDetailCtrl
 * @desc Controller for BU detail
 */
function BUDetailCtrl($scope, $state, toastr, BUDetails, singleBU, globalFunc, $rootScope, HighlightId) {

  $scope.BUDetails = BUDetails.data;
  $scope.editBu = false;
  $scope.setActiveTab = setActiveTab;
  $scope.updateChanges = updateChanges;
  $scope.revertUpdate = revertUpdate;
  $scope.cancelUpdate = cancelUpdate;
  $scope.back = back;
  $scope.editableBu = editableBu;
  $scope.deleteBu = deleteBu;
  $scope.updateBU = updateBU;
  $scope.newBUDetails = {};
  $scope.getStatusTextualRepresentation = getStatusTextualRepresentation;

  // Statuses for dropdown in object
  $scope.buStatuses = [
    { id: 1, label: 'Active' },
    { id: 0, label: 'Deactivated' }
  ];

  function back() {
    if (!!$scope.BUDetails && !!$scope.BUDetails._id) {
      HighlightId.setId($scope.BUDetails._id);
    }
    window.history.back();
  }

  /**
   * returns the is_active name
   * @param code
   * @returns {*}
   */
  function getStatusTextualRepresentation(code){
    /**
     * DEACTIVATED = 0; 
     * ACTIVE = 1; 
     */
    if (code === 0 || code === 'DEACTIVATED') {
      return 'Deactivated'
    }
    if (code === 1 || code === 'ACTIVE') {
      return 'Active'
    }
    return 'N/A';
  }

  function editableBu() {
    angular.copy($scope.BUDetails, $scope.newBUDetails);
    $scope.editBu = true;
  }

  // Set Manage tab active
  function setActiveTab() {
    $scope.tabData.active = _.find($scope.tabData, function (tab) {
      if (!!tab.menu && tab.menu.length){
        return _.find(tab.menu, function (item) {
          return item.params.action == "businessunit";
        });
      }
      else{
        return tab.params.action == "businessunit";
      }
    });

    if (!!$scope.tabData){
      $scope.tabData.active.active = true;
    }
  }

  // Run setActiveTab()
  setActiveTab();

  function validateInputData(){
    if(!$scope.newBUDetails.descr || !$scope.newBUDetails.descr.length || $scope.newBUDetails.descr.trim() === '') {
      return false;
    }

    else if(!$scope.newBUDetails.code || !$scope.newBUDetails.code.length || $scope.newBUDetails.code.trim() === '') {
      return false;
    }

    return true;
  }

  function updateChanges(){

    $scope.submitted = true;
    if(validateInputData() === false){
      toastr.error('Please fill the required fields before proceeding');
    }else {
      updateBU();
    }
  }

  function revertUpdate() {
    angular.copy($scope.BUDetails, $scope.newBUDetails);
  }

  function cancelUpdate() {
    $scope.editBu = false;
  }
  function getUpdateData(){
    var update_data = {
      _id: $scope.BUDetails._id
    };

    if(!!$scope.newBUDetails.descr){
      update_data.descr = $scope.newBUDetails.descr;
    }
    if(!!$scope.newBUDetails.code && $scope.newBUDetails.code.trim() !== ''){
      update_data.code = $scope.newBUDetails.code;
    }

    // Get new status value
    update_data.is_active = $scope.newBUDetails.is_active;

    return update_data;
  }

  function updateBU() {

    singleBU.put(
      {
        id: $scope.BUDetails._id
      }, getUpdateData() ,
      function(){
        toastr.success('The Business Unit was updated successfully');
        $state.go('main.user.companiesMgmt.manageBusinessUnits');
      },
      function(e){
        globalFunc.objectErrorMessage(e);
        revertUpdate();
        cancelUpdate();
      }
    );
  }

  function deleteBu() {
    swal(
      {
        title: "Confirm delete Business Unit?",
        text: "This Business Unit will be deleted by you",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function(isConfirm) {
        if(isConfirm){
          singleBU.delete(
            {
              id: $scope.BUDetails._id
            },
            function(){
              toastr.success('The Business Unit was deleted successfully');
              $state.go('main.user.companiesMgmt.manageBusinessUnits');
            },
            function(error){
              globalFunc.objectErrorMessage(error);
            }
          );
        }
      }
    );
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

BUDetailCtrl.$inject = [
  '$scope', '$state', 'toastr', 'BUDetails', 'singleBU', 'globalFunc', '$rootScope', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('BUDetailCtrl', BUDetailCtrl);

'use strict';
/**
 * @name addBUCtrl
 * @desc Controller for add BU
 */
function addBUCtrl($scope, $q, $resource, $state, $location, $anchorScroll, pathConstants, listingBusinessUnits,
                                 toastr, globalFunc, $rootScope) {

  $scope.submitted = false;
  $scope.duplicationCheck = duplicationCheck;
  $scope.cancelAddBU = cancelAddBU;

  $scope.BU = {};

  $scope.response_error = {};

  function validateInputData(){

    if(!$scope.BU.name || !$scope.BU.name.length) {
      return false;
    }

    if(!$scope.BU.code || !$scope.BU.code.length) {
      return false;
    }

    return true;
  }

  function cancelAddBU(){
    $state.go('main.user.companiesMgmt.manageBusinessUnits');
  };

  //upload company detail
  $scope.addBU = function(){

    $scope.submitted = true;

    if(validateInputData() == false){
      toastr.error('Please fill all required fields before proceeding');
      return;
    }

    var submit_data = {
      descr: $scope.BU.name,
      code: $scope.BU.code
      };

    listingBusinessUnits.post(
      {},
      submit_data,
      function (resource) {
        toastr.success("Business Unit has been added");
        $state.go("main.user.companiesMgmt.manageBusinessUnits");
      },
      function (err) {
        if (typeof err.data.message === 'string') {
          toastr.error(err.data.message);
        } else {
          // loop the error object
          angular.forEach(err.data.message, function (errorDatas) {
            // Get the object key
            angular.forEach(errorDatas, function () {
              // show the array value of the Error from the json
              toastr.error(errorDatas[0]);
            });
          });
        }
      }
    )
  };

  $scope._ = {
    isEmpty: _.isEmpty
  };

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'codeCheckTrue':
          $scope.codeCheck = true;
          break;
        case 'codeCheckFalse':
          $scope.codeCheck = false;
          break;
      }
    });
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[3],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

addBUCtrl.$inject = ['$scope', '$q', '$resource', '$state', '$location', '$anchorScroll',
  'pathConstants', 'listingBusinessUnits', 'toastr', 'globalFunc', '$rootScope'];

angular
  .module('metabuyer')
  .controller('addBUCtrl', addBUCtrl);



'use strict';

/**
 * @name prVersionCtrl
 * @desc The controller for PR version
 */
function prVersionCtrl($scope, currentPR, previousVersion, $uibModalInstance, versionNumber, globalFunc) {

  $scope.lineItemDiff     = [];

  $scope.version          = versionNumber;
  $scope.currentPR        = currentPR;
  $scope.prevPR           = previousVersion;

  // Function list
  $scope.close = close;

  function close() {
    $uibModalInstance.close();
  }

  /**
   * diff two arrays with defining the field to compare
   * @param prevArr
   * @param newArr
   * @param fieldToCompare
   * @returns {Array}
   */
  function diffArray(prevArr, newArr, fieldToCompare) {
    var diff = [];

    // get deleted data
    // and get updated data
    _.forEach(prevArr, function(prev) {
      var deleted = globalFunc.findInArray(newArr, fieldToCompare, prev[fieldToCompare]);
      if (!deleted) {
        prev.diffStatus = 'deleted';
        diff.push(prev);
      } else {
        deleted.diffStatus = 'updated';
        deleted.prevVersion = prev;
        diff.push(deleted);
      }
    });

    // get added data
    // and get updated data
    _.forEach(newArr, function(item) {
      var added = globalFunc.findInArray(prevArr, fieldToCompare, item[fieldToCompare]);
      if (!added) {
        item.diffStatus = 'added';
        diff.push(item);
      }
      // if exist in prevArr (updated) and not exist in diff
      else if (!!added && !globalFunc.findInArray(diff, fieldToCompare, item[fieldToCompare])) {
        item.diffStatus = 'updated';
        item.prevVersion = added;
        diff.push(item);
      }
    });

    return diff;
  }

  function initialize(){
    if (!!$scope.currentPR && !!$scope.prevPR)
      $scope.lineItemDiff = diffArray($scope.prevPR.pr_items, $scope.currentPR.pr_items, '_id');
  }

  initialize();
}

prVersionCtrl.$inject = ['$scope', 'currentPR', 'previousVersion', '$uibModalInstance', 'versionNumber', 'globalFunc'];

angular.module('metabuyer')
  .controller('prVersionCtrl', prVersionCtrl);

/**
 * @name CatalogItemDetailCtrl
 *
 * @description
 *
 * Controller for showing an item Details and listing the available variations of the item
 * Also, enables the editing in case of a Non Catalog item
 *
 * @requires $scope
 * @requires $rootScope
 * @requires item (resolved from caller controller, represents the main item)
 * @requires itemDetails (resolved from caller controller, represents the list of details an item has)
 * @requires pr (resolved from caller controller, represents the PR)
 * @requires $uibModalInstance
 * @requires paymentTermsList
 * @require prFunction (Metabuyer service)
 *
 *
 * @function detailAddToPR
 * adds the item to the PR, once successful its updates the PR
 *
 * @function close
 * closes the modal
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

function CatalogItemDetailCtrl (
  $scope, item, itemDetails,$uibModalInstance, addItemToPRFunction, prFunction, globalFunc, starringItem, $rootScope,
  paymentTerms
) {

  $scope.mainItem = item;
  $scope.itemDetails = itemDetails;
  $scope.itemCommodity = !!itemDetails[0] ? itemDetails[0].commodity : null;

  $scope.checkPaymentTerm = checkPaymentTerm;
  $scope.itemStarring = itemStarring;
  $scope.close = close;
  $scope.addItemToPR = addItemToPR;
  $scope.checkLoading = checkLoading;

  function addItemToPR(item){
    var pr = prFunction.getPRData();
    var validateLumpSum = prFunction.validateLumpSum(item, -1);

    if (!checkPaymentTerm(item)) {
      swal({
        title: 'Invalid Payment Term',
        text: 'The payment term for this item is inactive. Please check.',
        type: 'info',
        showCancelButton: true,
        showConfirmButton: false
      });
    }
    else {
      if (!!pr.lump_sum_discount && !validateLumpSum.status) {
        swal({
          title: 'Confirm add item?',
          text: validateLumpSum.message,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Confirm',
          closeOnConfirm: true
        }, function (isConfirm) {
          if (isConfirm) {
            // remove lump sum
            prFunction.removeLumpSum(pr._id, function (resource) {
              if (!!resource)
                sendingAddNewItemRequest(item);
            })
          }
        });
      }
      else
        sendingAddNewItemRequest(item);
    }
  }

  function sendingAddNewItemRequest(item) {
    addItemToPRFunction(item).$promise.then(function(resource){
      if (!!resource && !!resource.content && !!resource.content.data)
        prFunction.setPRData(resource.content.data);

      prFunction.setLoading('lineItemTable', false);
      prFunction.setLoading('addingItem', false);
    },function (e){
      globalFunc.objectErrorMessage(e);
      prFunction.setLoading('lineItemTable', false);
      prFunction.setLoading('addingItem', false);
    });
  }

  function itemStarring (product, productId) {
    starringItem.update(
      {
        user_id: $rootScope.currentUser._id,
        item_id: productId
      },
      function (resource) {
        if (product.starred)
          product.starred = false;
        else {
          product.starred = true;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      })
  }

  /**
   * get loading value from prFunction service
   * @param loadingObject
   * @returns {*|{}}
   */
  function checkLoading(loadingObject) {
    return prFunction.getLoading(loadingObject);
  }


  function close () {
    $uibModalInstance.close();
  }

  function checkPaymentTerm(item) {
    var isPaymentTermValid = false;
    if (!!item.payment_term.code) {
      if (globalFunc.findInArray($scope.validPaymentTerm, 'code',
          item.payment_term.code)) {
        isPaymentTermValid = true;
      }
    }
    return isPaymentTermValid;
  }

  function initialize(){
    $scope.validPaymentTerm = paymentTerms;
    $scope.lastCommodity = $scope.itemCommodity;
  }

  initialize();
}

CatalogItemDetailCtrl.$injecct = [
  '$scope', 'item', 'itemDetails','$uibModalInstance', 'addItemToPRFunction', 'prFunction', 'globalFunc', 'starringItem',
  '$rootScope', 'paymentTerms'
];

angular
  .module('metabuyer')
  .controller('CatalogItemDetailCtrl',CatalogItemDetailCtrl);

'use strict';

/**
 *
 * @name catalogPanelCtrl
 *
 * @description Controller for Catalog Panel, it takes care of loading the items, assigning the tabs
 * as well as requesting the detailed information about an item
 *
 *
 * @requires $scope
 * @requires $rootScope
 * @requires catalogShoppingSearch
 * @requires $http
 * @requires pathConstants
 * @requires globalFunc
 * @requires $filter
 * @requires purchaseRequisitionsServices
 * @requires registerViewedItem
 * @requires $uibModal
 * @requires prFunction
 * @requires starringItem
 *
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

function catalogHeaderCtrl(
  $scope, $rootScope,catalogShoppingSearch, $http, pathConstants, globalFunc, $filter, purchaseRequisitionsServices,
  registerViewedItem, $uibModal, prFunction, starringItem, itemsCategories, metabuyerCache, paymentTerms, $anchorScroll
) {


 function showItemDetails(item) {

   $uibModal.open({
     templateUrl: 'components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/detailsTemplate.html',
     controller: 'CatalogItemDetailCtrl',
     backdrop: 'static',
     keyboard: false,
     windowClass: 'item-details-modal',
     resolve: {
       item: function () {
         return item;
       },
       itemDetails: function () {
         return item.details;
       },
       addItemToPRFunction: function () {
         return addItemToPRResource;
       },
       paymentTerms: function () {
         return paymentTerms.data;
       }
     }
   });

   /**
    * add to the list of recently viewed items
    */
   registerViewedItem.put({
     user_id: $rootScope.currentUser._id,
     item_id: item.item_id
   });
 }


  /**
   * function to prepare the breadCrumb on case of category selection
   * @param code
   * @param previousBreadCrumb
   * @returns {{}}
   */
  function prepareBreadCrumb(code, previousBreadCrumb) {


    var breadCrumb = {};
    var familyCode = '';

    var segmentCode = code.substring(0, 2).concat('000000');
    var segment = globalFunc.findInArray($scope.categories, 'code', segmentCode);

    // type Segment
    if (code.substring(2) === '000000') {
      breadCrumb.current = segment;
      breadCrumb.childern = segment.families;
    }
    // type Family
    else if (code.substring(4) === '0000') {
      breadCrumb.parent = segment;
      breadCrumb.current = globalFunc.findInArray(segment.families, 'code', code);
      breadCrumb.childern = breadCrumb.current.classes;
    }
    // type Class
    else if (code.substring(6) === '00') {
      familyCode = code.substring(0, 4).concat('0000');
      breadCrumb.grandParent = segment;
      breadCrumb.parent = globalFunc.findInArray(segment.families, 'code', familyCode);
      breadCrumb.current = globalFunc.findInArray(globalFunc.findInArray(segment.families, 'code', familyCode).classes, 'code', code);
      breadCrumb.childern = globalFunc.findInArray(globalFunc.findInArray(segment.families, 'code', familyCode).classes, 'code', code).commodities;

    }
    // type Commodity
    else
      breadCrumb = previousBreadCrumb;

    return breadCrumb;
  }


  /**
   * function that posts the Item to add to the PR
   * @param itemDetailsInfo
   * @returns {*|{method, params, url}}
   */
  function addItemToPRResource(itemDetailsInfo) {
    prFunction.setLoading('lineItemTable', true);
    prFunction.setLoading('addingItem', true);
    prFunction.setLoading('updatePRField', true);
    return purchaseRequisitionsServices.setItem({
     id: $scope.PR._id,
     action: 'add'
    }, {
      'item_details_id': itemDetailsInfo.detail_id
    });
  }

  /**
   * function to call the resource and update the html when adding items to the PR
   * @param item
   */
  function addItemToPR(item){
    var pr = prFunction.getPRData();
    var validateLumpSum = prFunction.validateLumpSum(item, -1);

    if (!checkPaymentTerm(item)) {
      swal({
        title: 'Invalid Payment Term',
        text: 'The payment term for this item is inactive. Please check.',
        type: 'info',
        showCancelButton: true,
        showConfirmButton: false
      });
    }
    else {
      if (!!pr.lump_sum_discount && !validateLumpSum.status) {
        swal({
          title: 'Confirm add item?',
          text: validateLumpSum.message,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Confirm',
          closeOnConfirm: true
        }, function (isConfirm) {
          if (isConfirm) {
            // remove lump sum
            prFunction.removeLumpSum(pr._id, function (resource) {
              if (!!resource)
                sendingAddNewItemRequest(item);
            })
          }
        });
      }
      else
        sendingAddNewItemRequest(item);
    }
  }

  /**
   * validate new item
   * if the pr got lump sum
   * @param item
   */
  function sendingAddNewItemRequest(item) {
    addItemToPRResource(item).$promise.then(function(resource){
      if (!!resource && !!resource.content && !!resource.content.data) {
        $rootScope.$broadcast('itemAdded');
        prFunction.setPRData(resource.content.data);
        refreshAddCartButton();
      }

      prFunction.setLoading('lineItemTable', false);
      prFunction.setLoading('addingItem', false);
    },function (error){
      globalFunc.objectErrorMessage(error);
      prFunction.setLoading('lineItemTable', false);
      prFunction.setLoading('addingItem', false);
    });
  }

  /**
   * the type ahead for the supplier search
   * @param val
   * @returns {*|webdriver.promise}
   */
  function supplierListing(val) {
    if(!!val && val.length > 2) {
      $scope.loading = true;

      var moduleParam = {
        module: 'suppliers'
      };

      var additionalParams = {
        'criteria[0][descr]': val,
        'criteria[0][archive_of]': '',
        'criteria[0][draft_status]': 3,
        'criteria[0][approval_status]': 1,
        'criteria[0][status]': 1,
        criteria_operator: 'and',
        offset: 10
      };

      additionalParams['criteria[1][bu_status|' + $scope.PR.company.bu_code + '|status]'] = 1;
      additionalParams['criteria[1][is_global_supplier]'] = 'true';
      additionalParams['criteria[1][$operator]'] = 'or';

      return $http.get($filter('format')(pathConstants.apiUrls.genericSearch.search, moduleParam), {
        params: additionalParams
      }).then(function (response) {
        $scope.loading = false;
        return response.data.content.data.map(function (item) {
          $scope.loading = false;
          return item;
        });
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
    }
  }


  /**
   * view or hide the Category list
   */
  function setCategoriesView() {
    if (!metabuyerCache.get('categories')) {
      itemsCategories.get(
        {
          code: 'all',
          groupIds: [prFunction.getCatalogGroup()]
        },
        function (resource) {
          if (!!resource.content && !!resource.content.data) {
            metabuyerCache.put('categories', resource.content.data);
            $scope.categories = resource.content.data;
            divideCategories();
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      $scope.categories = metabuyerCache.get('categories');
      divideCategories();
    }
  }

  /**
   * validate and set which display for the catalog is active
   * @param code
   * @param value
   */
  function setCatalogDisplay (value, code){
    $scope.supplierSearchDisplay = (code === 'supplier');
    $scope.catalogDisplayHandler = value;
  }

  /**
   * selected a filter and update the filter message
   * @param filter
   */
  function selectFilter(filter) {
    $scope.selectedFilter = filter;
    $scope.selectedFilter.text = 'Search ' + filter.label + ' catalog';
  }


  /**
   * prepare the payload to be searched
   * @param query
   */
  function searchCatalog(query) {
    $scope.searchActivated = true;
    $scope.selectedTab = 'search_results';
    $scope.paramsSource.code = $scope.selectedFilter.code;
    $scope.paramsSource.query = query;
    $scope.paramsSource.mb_supplier_code = null;

    if ($scope.selectedFilter.type === 'root')
      $scope.paramsSource.type = 'search';

    if ($scope.selectedFilter.type === 'tab') {
      $scope.paramsSource.type = $scope.selectedFilter.code;
      loadItems($scope.paramsSource.type, false, query, $scope.selectedFilter.code);
    } else if ($scope.selectedFilter.type === 'supplier') {
      $scope.paramsSource.code = null;
      $scope.paramsSource.mb_supplier_code = $scope.selectedFilter.code;
      loadItems('search', $scope.selectedFilter.code, query, false);
    }
    else
      loadItems('search', false, query, false, $scope.selectedFilter.code);
  }


  /**
   * the main function for loading items
   * @param type
   * @param supplierCode
   * @param query
   * @param tab
   * @param code
   */
  function loadItems(type, supplierCode, query, tab, code) {
    $scope.catalogList = [];
    $scope.meta = {};
    $scope.catalogDisplayHandler = 'showMessage';
    $scope.message = 'Loading items';
    catalogShoppingSearch.get(
      {
        user_id: $rootScope.currentUser._id,
        type: type,
        mb_supplier_code: !!supplierCode ? supplierCode : null,
        query: !!query ? query : null,
        group: !!tab ? tab : null,
        code: !!code ? code : null,
        groupIds: [prFunction.getCatalogGroup()]
      },
      function (resource) {
        $scope.showLoadingMessage = false;

        if (!!resource.content && !!resource.content.data) {
          $scope.catalogDisplayHandler = 'showItems';
          $scope.meta = resource.content.meta;
          $scope.catalogList = resource.content.data;
        } else {
          //TODO: handle the error
        }

        if (!$scope.catalogList || $scope.catalogList.length < 1) {
          $scope.catalogDisplayHandler = 'showMessage';
          $scope.message = 'There are no Items under the selected category at the moment!';
        }
      },
      function (error) {
        $scope.catalogDisplayHandler = '';
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * updated the drop down for the list to be searched
   * @param code
   * @param label
   * @param type
   */
  function refreshSearchFilters(code, label, type, makeAllAsDefault) {
    $scope.searchFilter = [];
    /**
     * add the All option and setting it for the search filter
     */
    $scope.searchFilter.push(
      {
        label: 'All',
        code: '00000000',
        type: 'root'
      }
    );
    selectFilter($scope.searchFilter[0]);

    if (!!label && !!code) {
      $scope.searchFilter.push({
        label: label,
        code: code,
        type: type
      });

    if(!makeAllAsDefault)
      selectFilter($scope.searchFilter[1]);
    }
  }


  /**
   * this function is the main to be called as it calls each other individually to perform different tasks
   * @param code
   * @param label
   * @param doNotLoadItems
   * @param type
   * @param makeAllAsDefault
   */
  function browseCatalog(code, label, doNotLoadItems, type, makeAllAsDefault) {
    $scope.search.title = '';
    $scope.paramsSource.query = '';

    setCatalogDisplay('showItems', type);

    refreshSearchFilters(code, label, type, makeAllAsDefault);

    if (!doNotLoadItems) {
      if (type === 'supplier') {
        $scope.paramsSource.type = 'search';
        $scope.paramsSource.mb_supplier_code = code;
        $scope.paramsSource.code = null;
        loadItems('search', code);
      } else {
        $scope.paramsSource.type = code;
        $scope.paramsSource.mb_supplier_code = null;
        loadItems(code);
      }
    }

    if (type === 'category')
      $scope.currentCategory = prepareBreadCrumb(code, $scope.currentCategory);

    $scope.searchActivated = false;
  }

  /**
   * get loading value from prFunction service
   * @param loadingObject
   * @returns {*|{}}
   */
  function checkLoading(loadingObject) {
    return prFunction.getLoading(loadingObject);
  }

  /**
   * check if the item has been added to the PR previously
   * @param id
   * @returns {boolean}
   */
  function checkItemInCart(id) {
    return prFunction.getPRItemsIDs().indexOf(id) !== -1;
  }

  /**
   * watcher to apply the selection for the item, and updates in case of a pagination occurred
   */
  $scope.$watch('catalogList', function(){
    refreshAddCartButton();
  });

  function refreshAddCartButton() {
    if (!!$scope.catalogList) {
      _.forEach($scope.catalogList, function (product) {
        if (product.default)
          product.selected = checkItemInCart(product.default.detail_id);
      })
    }
  }

  function itemStarring (product, productId) {
    starringItem.update(
      {
        user_id: $rootScope.currentUser._id,
        item_id: productId
      },
      function (resource) {
        if (product.starred)
          product.starred = false;
        else {
          product.starred = true;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      })
  }

  /**
   * function for clearing the search
   * it clears the text as well as requests for items from all suppliers
   */
  function clearSupplierSearch(){
    $scope.searchedSupplier = {
      text: ''
    };
    browseCatalog('', '', false, 'supplier');
  }

  /**
   * divide the Categories into Segments and Families for display
   */
  function divideCategories() {
    if ($scope.categories) {
      $scope.segments = [];
      _.forEach($scope.categories, function (category) {
        var temp = {
          'code': category.code,
          'title': category.title,
          'families': category.families
        };
        $scope.segments.push(temp);
      });
      setCatalogDisplay('showCategories');
    }
  }

  function checkPaymentTerm(item) {
    var isPaymentTermValid = false;
    if (!!item.payment_term.code) {
      if (globalFunc.findInArray($scope.validPaymentTerm, 'code',
          item.payment_term.code)) {
        isPaymentTermValid = true;
      }
    }
    return isPaymentTermValid;
  }

  function initialize() {
    $scope.validPaymentTerm = paymentTerms.data;
    // start the catalog browsing with the Starred
    $scope.selectedTab = 'starred';
    browseCatalog('starred', 'Starred Items', false, 'tab', true);

    // set addItem loading status as false
    prFunction.setLoading('addingItem', false);
  }

  /**
   *  Receive broadcast for updated embedded pagination data to update on controller side
   */
  $scope.$on('updateEmbeddedPagination', function(events, content){
    if(!!content && !!content.meta)
    $scope.meta = content.meta;

    $anchorScroll();
  });

  $scope.selectFilter               = selectFilter;
  $scope.browseCatalog              = browseCatalog;
  $scope.setCategoriesView          = setCategoriesView;
  $scope.supplierListing            = supplierListing;
  $scope.addItemToPR                = addItemToPR;
  $scope.showItemDetails            = showItemDetails;
  $scope.searchCatalog              = searchCatalog;
  $scope.checkLoading               = checkLoading;
  $scope.itemStarring               = itemStarring;
  $scope.clearSupplierSearch        = clearSupplierSearch;
  $scope.checkPaymentTerm           = checkPaymentTerm;

  $scope.searchFilter = [];
  $scope.selectedFilter = {};
  $scope.catalogDisplayHandler = '';
  $scope.segments = [];
  $scope.showMessage = false;
  $scope.itemsService = catalogShoppingSearch;
  $scope.paramsSource = {
    user_id: $rootScope.currentUser._id,
    pr_cc: $scope.PR.cost_center.code,
    type: 'starred',
    offset: 20,
    groupIds: [prFunction.getCatalogGroup()]
  };
  $scope.supplierSearchDisplay = false;
  $scope.loading = false;
  $scope.searchActivated = false;
  $scope.searchedSupplier = {
    text: ''
  };
  $scope.search = {
    title: ''
  };


  /**
   * bind the PR to the Parent Object (main PR)
   */
  $scope.PR = prFunction.getPRData();
  $scope.categories = [];

  initialize();

}

catalogHeaderCtrl.$inject = [
  '$scope', '$rootScope', 'catalogShoppingSearch', '$http', 'pathConstants', 'globalFunc', '$filter',
  'purchaseRequisitionsServices', 'registerViewedItem', '$uibModal', 'prFunction', 'starringItem', 'itemsCategories',
  'metabuyerCache', 'paymentTerms', '$anchorScroll'
];

angular
  .module('metabuyer')
  .controller('catalogHeaderCtrl', catalogHeaderCtrl);

'use strict';

function purchaseRequisitionsHeaderCtrl(
  $scope, prFunction, purchaseRequisitionsServices, globalFunc, $rootScope, $uibModal, $state, HighlightId
) {

  $scope.back           = back;
  $scope.updatePRTitle  = updatePRTitle;
  $scope.PRData         = PRData;
  $scope.starringPR     = starringPR;
  $scope.checkStarred   = checkStarred;
  $scope.openRevision   = openRevision;

  $scope.originalPRTitle = angular.copy($scope.PR.title);

  $scope.templateUrl = $rootScope.isMobileMode ?
    'components/purchaseRequisitionComponents/prHeader/purchaseRequisitionHeaderTemplate-mobile.html':
    'components/purchaseRequisitionComponents/prHeader/purchaseRequisitionHeaderTemplate.html';

  function back() {
    if ($scope.shoppingModeStatus){
      if(!!PRData().original_pr){
        window.history.back();
      }
      else {
        $state.go('main.user.purchaseRequisitions.details', {id: PRData()._id, PR: {data: PRData()}});
      }
    }
    else {
      var prStatus = PRData().status;
      if(PRData().status === 'on_hold' || PRData().status === 'edit'){
        prStatus = 'pending';
      }
      $state.go('main.user.purchaseRequisitions.manage', {
        status: prStatus,
        tab: prStatus === 'pending' ? 'waiting' : null,
        extraFilterKey: prStatus === 'pending' ? 'criteria[waiting_on][]' : null,
        extraFilterValue: prStatus === 'pending' ? $rootScope.currentUser._id : null,
        cursor: null
      });
      if(!!PRData().original_pr){
        HighlightId.setId(PRData().original_pr._id);
      }
      else{
        window.history.back();
        HighlightId.setId($scope.PR._id);
      }
    }
  }

  // function backToPRDetails() {
  //   console.log($scope.PRData._id);
  //   $state.go('main.user.purchaseRequisitions.details', {id: $scope.PRData._id});
  // }

  function starringPR(pr, isStarred) {
    prFunction.requisitionStarring(pr, !isStarred).$promise
      .then(function () {
        if (isStarred)
          pr.starred_users = _.pull(pr.starred_users, $rootScope.currentUser._id);
        else {
          pr.starred_users = [];
          pr.starred_users.push($rootScope.currentUser._id);
        }
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  function checkStarred(pr) {
    if(!!pr.starred_users && pr.starred_users.length > 0){
      return (pr.starred_users.indexOf($rootScope.currentUser._id) > -1);
    }
  }

  function updatePRTitle(prTitle) {
    if (!!prTitle) {
      purchaseRequisitionsServices.updateTitle(
        {
          id: $scope.PR._id
        },{
          title : prTitle
        },function(){
          $scope.PR.title = prTitle;
          $scope.originalPRTitle = angular.copy($scope.PR.title);
        },function (error){
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      // If input field is empty, fill empty input by previous data
      $scope.PR.title = angular.copy($scope.originalPRTitle);
    }
  }

  function PRData(){
    return prFunction.getPRData();
  }

  /**
   * Open PR comparison with the old version in modal
   * @param currentPR
   * @param previousId
   * @param version (version number)
   */
  function openRevision(currentPR, previousId, version) {
    $uibModal.open({
      templateUrl: 'components/purchaseRequisitionComponents/revision/revision.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'prVersionCtrl',
      size: 'lg',
      windowClass: 'revision-wrapper',
      resolve: {
        currentPR: function(){
          return currentPR;
        },
        previousVersion: function($q, purchaseRequisitionsServices){
          var deferred = $q.defer();
          purchaseRequisitionsServices.getSinglePR(
            {
              id: previousId
            },
            function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data)
                deferred.resolve(resource.content.data);
              else
                deferred.resolve({});
            },
            function (error) {
              deferred.resolve({});
              globalFunc.objectErrorMessage(error);
            }
          );

          return deferred.promise;
        },
        versionNumber: function () {
          return version;
        }
      }
    });
  }

  /**
   * need to reformat the revision data
   * because the data from backend is in object and hard to read by ng-repeat
   */
  function preparePRRevisions() {
    $scope.PRData().revisions = globalFunc.reformatFromObjectToArray($scope.PRData().revisions);
  }

  function initialize() {
    preparePRRevisions();
  }

  initialize();

}

purchaseRequisitionsHeaderCtrl.$inject = [
  '$scope', 'prFunction', 'purchaseRequisitionsServices', 'globalFunc', '$rootScope', '$uibModal', '$state', 'HighlightId'
];

angular
  .module('metabuyer')
  .directive('purchaseRequisitionHeader',function() {
    return {
      restrict: 'E',
      scope: {
        editingState: '=',
        PR: '=pr',
        costCenters: '=',
        shoppingModeStatus: '='
      },
      template: '<div ng-include="templateUrl"></div>',
      controller: 'purchaseRequisitionsHeaderCtrl'
    }
  })
  .controller('purchaseRequisitionsHeaderCtrl',  purchaseRequisitionsHeaderCtrl);

'use strict';


/**
 * //TODO: document
 * @param $scope
 * @param $uibModal
 * @param $element
 * @param searchModule
 * @param metabuyerCache
 * @param $q
 */
function nonCatalogItemDirectiveCtrl($scope, $uibModal, $element, searchModule, metabuyerCache, $q, Currencies) {

  function panel() {
    $uibModal.open({
      templateUrl: 'components/purchaseRequisitionComponents/nonCatalog/nonCatalogItemTemplate.html',
      controller: catalogNonCatalogItemCtrl,
      backdrop :'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        paymentTermsList: function () {
          return loadData({
            module: 'payment-term',
            'criteria[is_active]': 1,
            offset: 0
          }, 'payment-term');
        },
        taxesList: function () {
          return loadData({
            module: 'tax',
            offset: 0
          }, 'taxes');
        },
        item: function() {
          return $scope.item || {};
        },
        currencies: function ($q, Currencies) {
          var deferred = $q.defer();
          Currencies.get(function (resource) {
              deferred.resolve(resource.content);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    });
  }

  $element.bind('click', function () {
    panel();
  });


  function loadData(params, cacheKey) {

    var deferred = $q.defer();

    if (!!metabuyerCache.get(cacheKey)) {
      deferred.resolve(metabuyerCache.get(cacheKey));
    } else {
      searchModule.get(
        params
        ,
        function (resource) {
          if (!!resource.content) {
            metabuyerCache.put(cacheKey, resource.content.data);
            deferred.resolve(metabuyerCache.get(cacheKey));
          } else {
            //TODO: handle the error
            deferred.resolve([]);
          }

        },
        function (error) {
          deferred.resolve([]);
          //TODO: handle the error
        });
    }
    return deferred.promise;
  }


}

nonCatalogItemDirectiveCtrl.$inject = ['$scope', '$uibModal', '$element', 'searchModule', 'metabuyerCache', '$q', 'Currencies'];

angular
  .module('metabuyer')
  .directive('nonCatalogItem',function() {
    return {
      restrict: 'A',
      scope: {
        item: '=?'
      },
      controller: 'nonCatalogItemDirectiveCtrl'
      }
  })
  .controller('nonCatalogItemDirectiveCtrl', nonCatalogItemDirectiveCtrl);

'use strict';


/**
 * //TODO: document
 * @param $scope
 * @param taxesList
 * @param paymentTermsList
 * @param pathConstants
 * @param $http
 * @param globalFunc
 * @param $filter
 * @param supplierGlobalFunc
 * @param searchModule
 * @param purchaseRequisitionsServices
 * @param $rootScope
 * @param toastr
 * @param prFunction
 * @param $uibModalInstance
 * @param listChild
 * @param lang
 * @param item
 * @param currencies
 */
function catalogNonCatalogItemCtrl(
  $scope, taxesList, paymentTermsList, pathConstants, $http, globalFunc, $filter, supplierGlobalFunc, searchModule,
  purchaseRequisitionsServices, $rootScope, toastr, prFunction, $uibModalInstance, listChild, lang, item, currencies
) {

  $scope.paymentTermsList             = paymentTermsList;
  $scope.taxesList                    = taxesList;
  $scope.currenciesList               = currencies.data;
  $scope.PR                           = prFunction.getPRData();

  $scope.uomSearching                 = false;
  $scope.supplierSearching            = false;
  $scope.commoditySearching           = false;
  $scope.editingState                 = false;
  $scope.formSubmitted                = false;
  $scope.commodityLevel               = [4];
  $scope.nonCatalog                   = {};
  $scope.invalidSupplierSelected      = false;

  $scope.formatModel                  = formatModel;
  $scope.searchUOM                    = searchUOM;
  $scope.searchSuppliers              = searchSuppliers;
  $scope.searchCommodityCode          = searchCommodityCode;
  $scope.submitNonCatalogItem         = submitNonCatalogItem;
  $scope.openChildCommodityCode       = openChildCommodityCode;
  $scope.onUOMSelect                  = onUOMSelect;
  $scope.validationUOMSelection       = validationUOMSelection;
  $scope.onSupplierSelect             = onSupplierSelect;
  $scope.validationSupplierSelection  = validationSupplierSelection;
  $scope.getCurrencyList              = getCurrencyList;
  $scope.close                        = close;

  function createNonCatalogItem() {
    $scope.submitted = true;
    var params = prepareNonCatalogData();
    purchaseRequisitionsServices.createNonCatalogItem(
      {
        id: $rootScope.currentUser._id
      },
      params
    ).$promise
      .then(function (success) {
        if (!!success.content && !!success.content.data && !!success.content.data.default
          && !!success.content.data.default._id) {
          if ($scope.nonCatalog.image) {
            uploadNonCatalogImage(success.content.data).then(
              function () {
                addNonCatalogToPR(success.content.data.default._id, $scope.nonCatalog.qty);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                $scope.submitted = false;
              }
            );
          }
          else
            addNonCatalogToPR(success.content.data.default._id, $scope.nonCatalog.qty);
        } else {
          globalFunc.objectErrorMessage('Failed to create a non catalog item');
        }
      },
      function (err) {
        $scope.submitted = false;
        globalFunc.objectErrorMessage(err);
      }
    );
  }

  function addNonCatalogToPR(itemId, qty) {
    purchaseRequisitionsServices.setItem({
      id: $scope.PR._id,
      action: 'add'
    }, {
      'item_details_id': itemId,
      'qty': qty
    }, function (resource) {
      if (!!resource.content && !!resource.content.data) {
        prFunction.setPRData(resource.content.data);
        $scope.submitted = false;
        toastr.success($scope.nonCatalog.item_details.item_name + ' has been added.');
        close();
      }
    }, function (error) {
      $scope.submitted = false;
      globalFunc.objectErrorMessage(error);
    });
  }

  function updateNonCatalogItem(nonCatalogItem) {
    var params = prepareUpdateNonCatalogData();
    $scope.submitted = true;
    purchaseRequisitionsServices.setItem({
        id: nonCatalogItem._id,
        action: 'item-details'
      },
      {
        item_data: params
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          prFunction.setPRData(resource.content.data);
          $rootScope.$broadcast('updateDetailsData', globalFunc.findInArray(
            resource.content.data.pr_items, '_id', nonCatalogItem._id)
          );

          //update the image in case the user added an image
          var item =  globalFunc.findInArray(resource.content.data.pr_items, '_id', nonCatalogItem._id);
          if(!!$scope.nonCatalog.image && item && item._id){
            updateNonCatalogImage(item).then(function(resource){

              if (!!resource.data && !!resource.data.content && !!resource.data.content.data) {
                prFunction.setPRData(resource.data.content.data);
                $rootScope.$broadcast('updateDetailsData', globalFunc.findInArray(
                  resource.data.content.data.pr_items, '_id', nonCatalogItem._id)
                );
              }
            }, function(error){
              globalFunc.objectErrorMessage(error);
            });
          }
        }
        else
          globalFunc.objectErrorMessage('An error occurred');

        $scope.submitted = false;
        close();
      },
      function (error) {
        $scope.submitted = false;
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function prepareNonCatalogItem(item) {

    //find Index
    var index = null;
    var prItems = prFunction.getPRData().pr_items;
    for (var i in prItems) {
      if (prItems[i]._id === item._id) {
        index = i;
      }
    }

    if (index === null) {
      globalFunc.objectErrorMessage('An error occurred');
      return;
    }

    var validateLumpSum = prFunction.validateLumpSum(item, index);
    if (!!prFunction.getPRData().lump_sum_discount && !validateLumpSum.status) {
      swal({
        title: 'Are you sure you want to update the item?',
        text: validateLumpSum.message,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes, update it!',
        closeOnConfirm: true
      }, function (isConfirm) {
        if (isConfirm) {
          // remove lump sum
          prFunction.removeLumpSum(prFunction.getPRData()._id, function (resource) {
            if (!!resource.content && !!resource.content.data) {
              prFunction.setPRData(resource.content.data);
              updateNonCatalogItem(item);
            } else {
              globalFunc.objectErrorMessage('An error occurred');

            }
          })
        }
      });
    }
    else
      updateNonCatalogItem(item);
  }

  function prepareNonCatalogData() {
    return {
      'itemName'        : $scope.nonCatalog.item_details.item_name,
      'internalPartNo'  : '',
      'description'     : $scope.nonCatalog.item_details.description,
      'supplierId'      : !!$scope.nonCatalog.supplier ? $scope.nonCatalog.supplier._id : '',
      'supplier_name'   : !!$scope.nonCatalog.supplier ? $scope.nonCatalog.supplier.descr : '',
      'supplierPartNo'  : $scope.nonCatalog.item_details.supplier_part_no,
      'quantity'        : !!$scope.nonCatalog.qty ? $scope.nonCatalog.qty : 1,
      'unitPrice'       : ($scope.nonCatalog.unit_price > -1) ? $scope.nonCatalog.unit_price : 0,
      'currencyId'      : (!!$scope.nonCatalog.currency && !!$scope.nonCatalog.currency._id) ?
        $scope.nonCatalog.currency._id : '',
      'uomId'           : (!!$scope.nonCatalog.UOM && !!$scope.nonCatalog.UOM._id) ? $scope.nonCatalog.UOM._id : '',
      'commodity_title' : (!!$scope.nonCatalog.commodity_code && !!$scope.nonCatalog.commodity_code.descr) ?
        $scope.nonCatalog.commodity_code.descr : '',
      'commodityCode'   : (!!$scope.nonCatalog.commodity_code && !!$scope.nonCatalog.commodity_code.code) ?
        $scope.nonCatalog.commodity_code.code : '',
      'paymentTermId'   : (!!$scope.nonCatalog.payment_term && !!$scope.nonCatalog.payment_term._id) ?
        $scope.nonCatalog.payment_term._id : '',
      'taxId'           : (!!$scope.nonCatalog.tax && !!$scope.nonCatalog.tax._id) ? $scope.nonCatalog.tax._id : '',
      'pr_cc'           : (!!$scope.PR && !!$scope.PR.cost_center) ? $scope.PR.cost_center._id : '',
      'uomCode'         : (!!$scope.nonCatalog.UOM && !!$scope.nonCatalog.UOM.code) ? $scope.nonCatalog.UOM.code : '',
      'catalog_group_ids': prFunction.getCatalogGroup()
    };
  }

  /**
   * this function prepare the data differently from the Items endpoint, this will be the standard
   * @returns
   * {{item_name: *, description, supplier_id: string, currency_id: string, uom_id: string,
   * commodity_id: string, string, payment_term_id: string}}
   */
  function prepareUpdateNonCatalogData() {
    return  {
      'item_name': $scope.nonCatalog.item_details.item_name,
      'description': $scope.nonCatalog.item_details.description,
      'supplier_id': !!$scope.nonCatalog.supplier ? $scope.nonCatalog.supplier._id : '',
      'currency_id': (!!$scope.nonCatalog.currency && !!$scope.nonCatalog.currency._id) ?
        $scope.nonCatalog.currency._id : '',
      'uom_id': (!!$scope.nonCatalog.UOM && !!$scope.nonCatalog.UOM._id) ? $scope.nonCatalog.UOM._id : '',
      'commodity_id': (!!$scope.nonCatalog.commodity_code && !!$scope.nonCatalog.commodity_code._id) ?
        $scope.nonCatalog.commodity_code._id : '',
      'payment_term_id': (!!$scope.nonCatalog.payment_term && !!$scope.nonCatalog.payment_term._id) ?
        $scope.nonCatalog.payment_term._id : '',
      'supplier_part_no': $scope.nonCatalog.item_details.supplier_part_no
    };
  }

  function nonCatalogValidation() {

    // validate image type
    if (!!$scope.nonCatalog.image) {
      if (/^image\/*/.test($scope.nonCatalog.image.type) === false) {
        toastr.error('Item image' + lang.validation.upload.onlyImage);
        return false;
      }
    }

    if (!$scope.nonCatalog.item_details.item_name) {
      toastr.error(lang.validation.required.input + 'item Name');
      return false;
    }

    if (!$scope.nonCatalog.item_details.description) {
      toastr.error(lang.validation.required.input + 'item Description');
      return false;
    }

    if (!!$scope.nonCatalog.qty && isNaN($scope.nonCatalog.qty) === true) {
      toastr.error(lang.validation.number.isNumber + ' for quantity');
      return false;
    }
    if (Number($scope.nonCatalog.qty) === 0) {
      toastr.error(lang.validation.required.input + 'more than 0');
      return false;
    } else if (!$scope.nonCatalog.qty) {
      toastr.error(lang.validation.required.input + 'a Quantity');
      return false;
    }

    if (!$scope.nonCatalog.UOM) {
      toastr.error(lang.validation.required.input + 'a Unit of Measurement');
      return false;
    }

    if(!!$scope.nonCatalog.UOM && !$scope.nonCatalog.UOM.is_fraction && $scope.nonCatalog.qty % 1 !== 0) {
      toastr.error('Unit of Measurement ' + lang.validation.number.noFraction);
      $scope.decimalError = true;
      return false;
    }

    if (!!$scope.nonCatalog.supplier &&
      (!$scope.nonCatalog.supplierStatus || $scope.nonCatalog.supplierStatus.toLowerCase() !== 'active')) {
      toastr.error('The selected Supplier is not Valid, please select other supplier');
      return false;
    } else if (!$scope.nonCatalog.supplier) {
      toastr.error(lang.validation.required.selection + 'a Supplier');
      return false;
    }

    if (!$scope.nonCatalog.commodity_code) {
      toastr.error(lang.validation.required.selection + 'a Commodity');
      return false;
    }

    if (!$scope.nonCatalog.currency) {
      toastr.error(lang.validation.required.selection + 'a Currency');
      return false;
    }

    if ($scope.nonCatalog.unit_price < 0) {
      toastr.error(lang.validation.required.input + 'a Unit Price');
      return false;
    }

    if (!$scope.nonCatalog.payment_term) {
      toastr.error(lang.validation.required.selection + 'a Payment Term');
      return false;
    }

    return true;
  }

  /**
   * upload non catalog image
   * the image is uploaded after the item has been created
   * use the item id and item_details id
   *
   * @param itemData
   */
  function uploadNonCatalogImage(itemData) {

    var fd = new FormData();
    fd.append('itemImage', $scope.nonCatalog.image);
    return $http.post($filter('format')(pathConstants.apiUrls.items.imagesUpload, {
      user_id: $rootScope.currentUser._id,
      item_id: itemData.item_id,
      detail_id: itemData.detail_id
    }), fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    });
  }

  /**
   * update the nonCatalog image
   * @param itemData
   */
  function updateNonCatalogImage(itemData) {
    var fd = new FormData();
    fd.append('item_image', $scope.nonCatalog.image);
    return $http.post($filter('format')(pathConstants.apiUrls.purchaseRequisitions.updateNonCatalogImage, {
      id: itemData._id
    }), fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    });
  }


  function submitNonCatalogItem(action, item) {
    $scope.formSubmitted = true;
    if (nonCatalogValidation()) {
      if (action === 'create')
        createNonCatalogItem();
      else
        prepareNonCatalogItem(item);
    }
  }

  function searchCommodityCode(keyword) {
    if (!!keyword && keyword.length > 1) {
      $scope.commoditySearching = true;
      $scope.commodityCodes = [];
      searchModule.get(
        {
          module: 'commodity',
          'criteria[0][code]': keyword,
          'criteria[0][descr]': keyword,
          'criteria[0][$operator]': 'or',
          'criteria[1][is_active]': 1,
          order: 1,
          order_by: 'code',
          offset: 0
        }, function (resource) {
          $scope.commoditySearching = false;
          if (!!resource && !!resource.content && !!resource.content.data)
            $scope.commodityCodes = resource.content.data;
        }, function () {
          $scope.commoditySearching = false;
          $scope.commodityCodes = [];
        });
    }
  }

  /**
   * Get children data for commodity Code
   * @param cc
   */
  function openChildCommodityCode(cc){
    listChild.get({
      code: cc
    }, function(resource){
      if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0)
        $scope.commodityCodes = resource.content.data;
      else
        toastr.error('There are no child on this commodity code');
    }, function(){
      toastr.error('Failed to get Commodity Codes data');
    })
  }

  function onUOMSelect(UOM) {
    $scope.validUOMSelected = true;
    $scope.nonCatalog.UOM = UOM;
    $scope.nonCatalog.UOMText = UOM.code + ' < ' + UOM.descr + ' >';
  }

  /**
   * Validate the Selection for the Type-a-head
   * @param text
   */
  function validationUOMSelection(text) {
    if (!$scope.validUOMIsSelected || (!!text && text.length < 2)) {
      $scope.nonCatalog.UOM = null;
      $scope.nonCatalog.UOMText = '';
    }
  }

  /**
   * 1- validate the status of the supplier
   * 2- auto select default Tax if not selected
   * 3- auto select default Payment Terms if not selected
   * @param supplier
   */
  function onSupplierSelect(supplier) {
    var text;
    $scope.invalidSupplierSelected = false;
    if (!supplier || (!!supplier.status && supplier.status.toLowerCase() !== 'active')) {
      if (supplier.status.toLowerCase() === 'pending')
        text = 'The selected Supplier is pending approval, please select another supplier.';
      else if (supplier.status.toLowerCase() === 'black_listed')
        text = 'The selected Supplier is blacklisted, please select another supplier.';
      else
        text = 'The selected Supplier is not valid, please select another supplier.';

      globalFunc.objectErrorMessage(text);
      $scope.nonCatalog.supplier_display_name = '';
      $scope.nonCatalog.supplier = null;
      $scope.invalidSupplierSelected = true;
      return false;
    }

    $scope.nonCatalog.supplier        = supplier;
    $scope.nonCatalog.supplierStatus  = supplier.status;

    // auto assign the default Tax if its not already selected
    if (!$scope.nonCatalog.tax && !!supplier.tax_id)
      $scope.nonCatalog.tax = globalFunc.findInArray($scope.taxesList, '_id', supplier.tax_id);

    // select the Payment Term of the supplier as the supplier selection returns code only
    if (!!supplier.pay_terms_code && !!$scope.paymentTermsList)
      $scope.nonCatalog.payment_term = globalFunc.findInArray($scope.paymentTermsList, 'code', supplier.pay_terms_code);
  }

  /**
   * Validate the Selection for the Type-a-head
   * @param text
   */
  function validationSupplierSelection(text) {
    if (!$scope.validSupplierIsSelected || (text.length < 3)) {
      $scope.nonCatalog.supplier = null;
      $scope.nonCatalog.supplierName = '';
    }
  }

  /**
   * Function to format the ng-model after typeahead selected
   */
  function formatModel(model) {
    var indexOfHtml = model.indexOf('<');
    $scope.nonCatalog.supplierName = model.substring(0, indexOfHtml);
  }

  /**
   * Function to modify supplier object and pass label class as html
   */
  function modifySupplierObject(suppliers) {
    suppliers.status = supplierGlobalFunc.getSupplierStatus(
      suppliers.status, suppliers.approval_status, suppliers.draft_status, 'val'
    );
    switch (suppliers.status.toLowerCase()) {
      case 'black_listed':
        suppliers.labelStatus = 'black';
        break;
      case 'inactive':
        suppliers.labelStatus = 'warning';
        break;
    }

    return suppliers;
  }


  function searchSuppliers(val) {
    if (!!val && val.length > 2) {
      $scope.supplierSearching = true;

      var moduleParam = {
        module: 'suppliers'
      };

      var additionalParams = {
        'criteria[0][descr]': val,
        'criteria[0][archive_of]': '',
        'criteria[0][draft_status]': 3,
        'criteria[0][approval_status]': 1,
        criteria_operator: 'and',
        offset: 10
      };

      return $http.get($filter('format')(pathConstants.apiUrls.genericSearch.search, moduleParam), {
        params: additionalParams,
        ignoreLoadingBar: true
      }).then(function (response) {
        if (response.data.content.data.length === 0) {
          $scope.supplierSearching = false;
          return [];
        } else {
          return response.data.content.data.map(function (item) {
            $scope.supplierSearching = false;
            return modifySupplierObject(item);
          });
        }
      });
    }
  }

  function getCurrencyList() {
    return $scope.currenciesList;
  }


  function searchUOM(val) {

    if (!!val && val.length > 1) {
      $scope.uomSearching = true;

      return $http.get(pathConstants.apiUrls.uom.list, {
        params: {
          query: val
        },
        ignoreLoadingBar: true
      }).then(function (response) {
        $scope.uomSearching = false;
        return response.data.content.data.map(function (item) {
          return item;
        });
      }).catch(function(error){
        $scope.uomSearching = false;
        globalFunc.objectErrorMessage(error);
      })
    }
  }


  function close(){
    $uibModalInstance.close();
  }

  function initialize() {
    // init value for non catalog
    // the variable name is following the pr_items naming
    // to make it easier on editing
    $scope.nonCatalog.unit_price        = 0;
    $scope.nonCatalog.qty               = 1;
    $scope.nonCatalog.item_details      = {};

    // if item is exist (editing mode)
    // modify some of the value to fit to the nonCatalog controller and template
    if (!!item && !!item._id) {
      if (!item.commodity && !!item.item && !!item.item.commodity)
        item.commodity = item.item.commodity;

      $scope.editingState               = true;
      $scope.nonCatalog                 = _.cloneDeep(item);
      // display supplier name on the supplier search box
      $scope.nonCatalog.supplierName    = item.supplier.descr;
      // to display the selected commodity in the commodity search box
      $scope.commodityKeyword           = item.commodity.code + ' ' + item.commodity.descr;
      // // the commodity code data to send to endpoint
      $scope.nonCatalog.commodity_code  = $scope.nonCatalog.commodity;
      //correction for the incorrect set Ids
      if(!$scope.nonCatalog.commodity_code._id){
        $scope.nonCatalog.commodity_code._id = $scope.nonCatalog.commodity_code.id;
      }

      // if the supplier was selected the Supplier will always initially be active as the PR handles the data
      if(!!$scope.nonCatalog.supplier)
        $scope.nonCatalog.supplierStatus = 'active';

      // if the UOM is set it will be active as the PR handles the errors
      if(!!$scope.nonCatalog.UOM)
      {
        $scope.nonCatalog.UOMText = $scope.nonCatalog.UOM.code + ' < ' + $scope.nonCatalog.UOM.descr + ' >';
        $scope.validUOMIsSelected = true;
      }
    }
  }

  initialize();

}

catalogNonCatalogItemCtrl.$inject =  [
  '$scope', 'taxesList', 'paymentTermsList', 'pathConstants', '$http', 'globalFunc', '$filter', 'supplierGlobalFunc',
  'searchModule', 'purchaseRequisitionsServices', '$rootScope', 'toastr', 'prFunction', '$uibModalInstance', 'listChild',
  'lang', 'item', 'currencies'
];

angular
  .module('metabuyer')
  .controller('catalogNonCatalogItemCtrl', catalogNonCatalogItemCtrl);

'use strict';

function purchaseRequisitionsItemListCtrl (
  $scope, prFunction, purchaseRequisitionsServices, globalFunc, pathConstants, toastr, lang,
  $rootScope, $q, $uibModal
) {

  // PR data used in local controller
  var localPRData = {};

  $scope.imageBasePath            = pathConstants.apiUrls.image.pr;
  $scope.minDateItem              = new Date();
  $scope.currentUser              = $rootScope.currentUser || {_id: null};
  $scope.accountCodes             = [];
  $scope.itemMainCheckBox         = {
    selected : false
  };
  $scope.itemOthersDetail         = [
    {code :'needed_by_date',name : 'needed_by_date'},
    {code :'delivery_address',name : 'delivery_address'},
    {code :'note',name : 'note'},
    {code :'account_code',name : 'account_code'},
    {code :'freights',name : 'freights'},
    {code :'transportation',name : 'transportation'},
    {code :'branch',name : 'supplier_branch'}
  ];
  $scope.itemMainCheckBox = {};
  var fieldNameConversion = {
    qty: {
      name: 'Qty',
      type: 'number'
    },
    price: {
      name: 'price',
      type: 'number'
    },
    discount: {
      name: 'discount',
      type: 'numberPercentage'
    },
    tax: {
      name: 'tax_id',
      type: 'string'
    },
    'needed-by': {
      name: 'needed_by_date',
      type: 'string'
    },
    note: {
      name: 'note',
      type: 'string'
    },
    'delivery-address': {
      name: 'delivery_address_id',
      type: 'string'
    },
    'set-supplier-branch': {
      name: 'branch',
      type: 'string'
    },
    'unset-supplier-branch': {
      name: 'branch',
      type: 'string'
    },
    'account-code': {
      name: 'account_code_id',
      type: 'string'
    },
    freights: {
      amount: {
        name: 'amount',
        type: 'numberPercentage'
      },
      discount: {
        name: 'discount',
        type: 'numberPercentage'
      },
      tax_id: {
        name: 'tax_id',
        type: 'string'
      }
    },
    transportation: {
      amount: {
        name: 'amount',
        type: 'numberPercentage'
      },
      discount: {
        name: 'discount',
        type: 'numberPercentage'
      },
      tax_id: {
        name: 'tax_id',
        type: 'string'
      }
    }
  };

  $scope.getTemplateUrl                 = getTemplateUrl;
  $scope.PRData                         = PRData;
  $scope.differentCurrencyChecker       = differentCurrencyChecker;
  $scope.setLoading                     = setLoading;
  $scope.checkLoading                   = checkLoading;
  $scope.updateItem                     = updateItem;
  $scope.removeItems                    = removeItems;
  $scope.duplicateItem                  = duplicateItem;
  $scope.addingDiscount                 = addingDiscount;
  $scope.addLumpSum                     = addLumpSum;
  $scope.updateLumpSum                  = updateLumpSum;
  $scope.addingLumpSum                  = addingLumpSum;
  $scope.addOthers                      = addOthers;
  $scope.checkOthersValue               = checkOthersValue;
  $scope.isPRCreator                    = isPRCreator;
  $scope.allowEditingPR                 = allowEditingPR;
  $scope.openDatePicker                 = openDatePicker;
  $scope.updateNeededByDate             = updateNeededByDate;
  $scope.removeOtherValue               = removeOtherValue;
  $scope.getDeliveryAddresses           = getDeliveryAddresses;
  $scope.onSelectDeliveryAddress        = onSelectDeliveryAddress;
  $scope.getAccountCodes                = getAccountCodes;
  $scope.onSelectAccountCode            = onSelectAccountCode;
  $scope.itemMainCheckboxClicked        = itemMainCheckboxClicked;
  $scope.updateMultiItems               = updateMultiItems;
  $scope.addingFreightsTransport        = addingFreightsTransport;
  $scope.updateFreightTransport         = updateFreightTransport;
  $scope.removeFreightOrTransportation  = removeFreightOrTransportation;
  $scope.removeTax                      = removeTax;
  $scope.showLumpSumButton              = showLumpSumButton;
  $scope.updateItemTax                  = updateItemTax;
  $scope.taxList                        = getTaxData;
  $scope.canEditPR                      = canEditPR;
  $scope.supplierBranchModal            = supplierBranchModal;
  $scope.onSelectSupplierBranch         = onSelectSupplierBranch;
  $scope.updateDiscountInputFocus       = updateDiscountInputFocus;
  $scope.Unchecked                      = Unchecked;

  function supplierBranchModal(pr, index, branch) {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/purchaseRequisitionComponents/branchPrListing/branchPrListing.html',
      controller: 'branchPrListingCtrl',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      size: 'lg',
      resolve: {
        branchSelection: function ($q, supplierBranches) {
          var deferred = $q.defer();
          var params = {
            id : pr,
            mode : 'active'
          };
          supplierBranches.get(
            params,
            function (resource) {
              if (!!resource && !!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        },
        onSelectSupplierBranch : function() {
          return $scope.onSelectSupplierBranch;
        },
        itemIndex : index,
        backupBranch : branch
      }
    });
  }

  function onSelectSupplierBranch(supplierBranch, itemIndex, backupBranch) {

      if (!!backupBranch) {
        backupBranch = null;
      }

      var pr = prFunction.getPRData();

      pr.pr_items[itemIndex].branch = supplierBranch;

      var payload = {
        supplier_id: pr.pr_items[itemIndex].supplier._id,
        branch_id: supplierBranch._id
      }

      var validateLumpSum = prFunction.validateLumpSum(pr.pr_items[itemIndex], itemIndex);

      if (!!pr.lump_sum_discount && !validateLumpSum.status) {
        swal({
          title: "Are you sure to add supplier branch?",
          text: validateLumpSum.message,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, add it!",
          closeOnConfirm: true
        }, function (isConfirm) {
          if (isConfirm) {
            // remove lump sum
            prFunction.removeLumpSum(pr._id, function (resource) {
              if (!!resource)
                updateItem(itemIndex, 'set-supplier-branch', false, payload, '');
            })
          }
          else
            $scope.PRData().pr_items[itemIndex].branch = backupBranch;
        });
      }
      else {
        updateItem(itemIndex, 'set-supplier-branch', false, payload, '');
      }
      return true;
  }

  /**
   * function to handle the main check box, in case of selected or unselected
   * @param value
   */
  function itemMainCheckboxClicked(value){
    if(value){
      selectAllItems();
    }else{
      $scope.itemMainCheckBox.selected = false;
      unSelectAllItems();
    }
  }

  /**
   * makes all the items' checkboxes selected
   */
  function selectAllItems(){
    for (var i in $scope.PRData().pr_items){
      $scope.PRData().pr_items[i].selected = true;
    }
  }

  /**
   * makes all the items' checkboxes unselected
   */
  function unSelectAllItems(){
    for (var i in $scope.PRData().pr_items){
      $scope.PRData().pr_items[i].selected = false;
    }
  }

  /**
   * makes the main checkbox uncheck if one item unselected
   */
  function Unchecked(){
    $scope.itemMainCheckBox.selected = false;
  }


  function getTemplateUrl(state) {
    if (!$rootScope.isMobileMode) {
      switch (state) {
        case 'editable':
          $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/itemList/prItemList.EditableTemplate.html';
          break;
        case 'notEditable' :
          $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/itemList/prItemList.NonEditableTemplate.html';
          break;
      }
    }

    if ($rootScope.isMobileMode) {
      $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/itemList/prItemList.NonEditableTemplate-mobile.html';
    }
  }

  $scope.$watch('editingState', function (newValue) {
    getTemplateUrl(newValue);
  });

  /**
   * function to open date picker
   * @param $event
   * @param itemIndex
   */
  function openDatePicker($event, itemIndex) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.PRData().pr_items[itemIndex].datePicker = true;
  }

  /**
   * get delivery addresses from prFunction
   * shared by pr header
   * @returns {*}
   */
  function getDeliveryAddresses() {
    return prFunction.getCostCenterDeliveryAddresses();
  }

  /**
   * on selecting delivery address in line item
   * @param address
   * @param itemIndex
   * @param backupAddress
   */
  function onSelectDeliveryAddress(address, itemIndex, backupAddress) {
    var pr = prFunction.getPRData();
    pr.pr_items[itemIndex].delivery_address = address;
    var validateLumpSum = prFunction.validateLumpSum(pr.pr_items[itemIndex], itemIndex);

    if (!!pr.lump_sum_discount && !validateLumpSum.status) {
      swal({
        title: "Are you sure to add delivery address?",
        text: validateLumpSum.message,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, add it!",
        closeOnConfirm: true
      }, function(isConfirm){
        if (isConfirm) {
          // remove lump sum
          prFunction.removeLumpSum(pr._id, function(resource) {
            if (!!resource)
              updateItem(itemIndex, 'delivery-address', false, address._id, '');
          })
        }
        else
          $scope.PRData().pr_items[itemIndex].delivery_address = backupAddress;
      });
    }
    else
      updateItem(itemIndex, 'delivery-address', false, address._id, '');
  }

  /**
   * updating account code
   */
  function onSelectAccountCode(selectedAccountCode, itemIndex) {
    updateItem(itemIndex, 'account-code', false, selectedAccountCode._id, '');
  }

  /**
   * Update needed by date value
   * @param itemIndex
   * @param date
   * @param dateBackup
   */
  function updateNeededByDate(itemIndex, date, dateBackup) {
    var milliTime = globalFunc.convertDateToTimestamp(date),
        milliTimeBackup = globalFunc.convertDateToTimestamp(dateBackup);
    updateItem(itemIndex, 'needed-by', false, milliTime, milliTimeBackup);
  }

  /**
   * check if the user is PRCreator
   * @returns {boolean}
   */
  function isPRCreator() {
    return ($scope.currentUser._id === $scope.PRData().creator._id);
  }

  /**
   * Check if current approver is a PA
   * @returns {*}
   */
  function allowEditingPR() {
    if (prFunction.getPRData().status === 'pending')
      return prFunction.checkCurrentApproverIsPA(!!prFunction.getPRData() ? prFunction.getPRData().waiting_on : null, !!$scope.currentUser  ? $scope.currentUser._id : null,
        $scope.currentUser  ? $scope.currentUser.roles : null);
    else
      return false
  }

  function removeOtherValue(item, field, itemIndex) {
    var tempFieldName = field;

    if (field === 'needed-by')
      tempFieldName = 'needed_by_date';
    if (field === 'account-code')
      tempFieldName = 'account_code';
    if (field === 'branch')
      tempFieldName = 'branch';

    if (!!item.selecting_others && !!item.selecting_others.length) {
      var arrayIndex = item.selecting_others.indexOf(tempFieldName);
      if (arrayIndex > -1)
        item.selecting_others.splice(arrayIndex, 1);
    }

    if (!!item[tempFieldName]) {
      if (field === 'delivery_address')
        field = 'delivery-address';

      if (field === 'branch')
        field = 'unset-supplier-branch';

      updateItem(itemIndex, field, false, null, item[tempFieldName]);
    }
  }

  function removeTax(itemIndex, othersType){
    updateFreightTransport(itemIndex, othersType, 'tax', 'tax_id', {_id:null});
  }

  function removeFreightOrTransportation(field, itemIndex) {

    var item = $scope.PRData().pr_items[itemIndex];
    var param = {};
    var backupField = 'backup_' + field;
    var backupValue = item[field][backupField];

    param.amount = null;
    param.discount = null;
    param.tax_id = null;

    sendingUpdateItem (itemIndex, item, field, param, backupValue);
  }

  /**
   * To get PR Data from service
   * and store the data also in localPRData
   * @returns {{}}
   */
  function PRData() {
    localPRData = prFunction.getPRData();
    return localPRData;
  }

  /**
   * adding state on adding others value
   * set an array called selecting_others
   * and push the field value to the array
   * @param field
   * @param itemIndex
   */
  function addOthers(field, itemIndex){
    var item = $scope.PRData().pr_items[itemIndex];
    if (!item.selecting_others)
      item.selecting_others = [];
    if (item.selecting_others.indexOf(field) === -1)
      item.selecting_others.push(field);

    localPRData.pr_items[itemIndex] = item;
    prFunction.setPRData(localPRData);
    $scope.PRData().pr_items[itemIndex] = item;
  }

  function updateItemTax(itemIndex, field, isDecimal, newValue, backupValue) {
    var pr = prFunction.getPRData();
    pr.pr_items[itemIndex].tax = newValue;
    var validateLumpSum = prFunction.validateLumpSum(pr.pr_items[itemIndex], itemIndex);

    if (!!pr.lump_sum_discount && !validateLumpSum.status) {
      swal({
        title: "Are you sure to change the tax?",
        text: validateLumpSum.message,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, add it!",
        closeOnConfirm: true
      }, function(isConfirm){
        if (isConfirm) {
          // remove lump sum
          prFunction.removeLumpSum(pr._id, function(resource) {
            if (!!resource)
              updateItem(itemIndex, field, isDecimal, newValue, backupValue);
          })
        }
        // change back to the prev tax
        else
          $scope.PRData().pr_items[itemIndex].tax = backupValue;
      });
    }
    else
      updateItem(itemIndex, field, isDecimal, newValue, backupValue);
  }

  /**
   * Check if the others field in editing state
   * @param item
   * @param field
   * @returns {boolean}
   */
  function checkOthersValue(item, field) {
    if (field === 'freights' || field === 'transportation')
      return (item[field].amount > 0 ||
        (!!item.selecting_others && !!item.selecting_others.length && item.selecting_others.indexOf(field) > -1));
    else if (!!item[field])
      return (!!item[field]);
    else if (!!item.selecting_others && !!item.selecting_others.length)
      return (item.selecting_others.indexOf(field) > -1);
  }

  /**
   * adding lumpsum state
   * to indicate user is adding or editing lumpsum
   * @param value
   */
  function addLumpSum(value) {
    localPRData.lump_sum_discount = value;
    localPRData.lump_sum_discount_entry = value;
    prFunction.setPRData(localPRData);
  }

  /**
   * Update lump sum value
   * @param value
   * @param backupValue
   */
  function updateLumpSum(value, backupValue) {
    var param = {};

    if (value == backupValue)
      return;

    if (value !== null) {
      var validateValue = lineItemValidation(value, 'numberPercentage', true);
      if (!!validateValue) {
        setLineItemBackupValue(false, 'lump_sum_discount', false, backupValue, false);
        return false;
      }

      var convertValToStr = value.toString();
      if (convertValToStr.indexOf('%') > -1)
        param.lump_sum_percent = Number(convertValToStr.replace('%', ''));
      else
        param.lump_sum_net = Number(value);
    }

    prFunction.setLoading('lineItemTable', true);
    prFunction.setLoading('updatePRField', true);
    purchaseRequisitionsServices.setLumpSum({
      id: localPRData._id
    }, param, function(resource) {
      if (!!resource && !!resource.content && !!resource.content.data)
        prFunction.setPRData(resource.content.data);

      prFunction.setLoading('lineItemTable', false);
    }, function(error) {
      setLineItemBackupValue(false, 'lump_sum_discount', false, backupValue, false);
      prFunction.setLoading('lineItemTable', false);
      globalFunc.objectErrorMessage(error);
    });
  }

  /**
   * Check param currency code with pr currency code
   * @param currencyCode
   * @returns {boolean}
   */
  function differentCurrencyChecker(currencyCode) {
    return (localPRData.currency.code !== currencyCode);
  }

  /**
   * Set loading value in prFunction service
   * @param loadingObject
   * @param loadingValue
   */
  function setLoading(loadingObject, loadingValue) {
    prFunction.setLoading(loadingObject, loadingValue);
  }

  /**
   * get loading value from prFunction service
   * @param loadingObject
   * @returns {*|{}}
   */
  function checkLoading(loadingObject) {
    return prFunction.getLoading(loadingObject);
  }

  function addingDiscount(itemIndex) {
    // Update data
    PRData();
    localPRData.pr_items[itemIndex].addingDiscount = true;
    prFunction.setPRData(localPRData);
  }

  /**
   * Updating the discount input field to blur
   */
  function updateDiscountInputFocus(index) {
    angular.element('#discountInput' + index).blur();
  }

  /**
   * state on adding freight or transportation
   * @param itemIndex
   * @param type
   * @param state
   */
  function addingFreightsTransport(itemIndex, type, state) {
    // Update data
    PRData();
    localPRData.pr_items[itemIndex][type][state] = true;
    prFunction.setPRData(localPRData);
  }

  function addingLumpSum() {
    // Update data
    PRData();
    localPRData.addingLumpSum = true;
    prFunction.setPRData(localPRData);
  }

  /**
   * Duplicating line item
   * @param item
   */
  function duplicateItem(item) {
    if (!!item) {
      var itemId = item._id;

      prFunction.setLoading('lineItemTable', true);
      prFunction.setLoading('updatePRField', true);
      purchaseRequisitionsServices.setItem({
        id: itemId,
        action: 'duplicate'
      }, function(resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          prFunction.setPRData(resource.content.data);

        prFunction.setLoading('lineItemTable', false);
      }, function(error) {
        prFunction.setLoading('lineItemTable', false);
        globalFunc.objectErrorMessage(error);
      });
    }
  }

  /**
   * Remove item(s) by id, the function receives an array
   * @param arr
   */
  function removeItems(arr) {
    if (!!arr && _.isArray(arr) && arr.length > 0) {
      var item = arr[arr.length - 1];
      if (!!item) {
        prFunction.setLoading('lineItemTable', true);
        prFunction.setLoading('updatePRField', true);
        prFunction.removeItem(item._id).$promise.then(function (resource) {
          if (!!resource.content && !!resource.content.data)
            prFunction.setPRData(resource.content.data);
          else {
            globalFunc.objectErrorMessage('something went wrong');
            return;
          }
          arr.pop();
          removeItems(arr);
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        });
      }
      else {
        prFunction.setLoading('lineItemTable', false);
        prFunction.setLoading('updatePRField', false);
        $scope.itemMainCheckBox.selected = false;
      }
    } else {
      prFunction.setLoading('lineItemTable', false);
      prFunction.setLoading('updatePRField', false);
      $scope.itemMainCheckBox.selected = false;
    }
  }

  /**
   * Update Freight Item
   * @param itemIndex
   * @param othersType (freights or transportation)
   * @param fieldEntry - Field name for entry is using 'entry'
   * @param field
   * @param tax
   */
  function updateFreightTransport(itemIndex, othersType, fieldEntry, field, tax) {
    var item = $scope.PRData().pr_items[itemIndex];
    var param = {};
    var backupField = 'backup_' + othersType;
    var newValue = item[othersType][fieldEntry];
    var backupValue = item[backupField][fieldEntry];

    if (!!tax)
      newValue = tax._id;

    // validate input
    if (newValue == backupValue)
      return;

    if (!!lineItemValidation(newValue, fieldNameConversion[othersType][field].type, false)) {
      setLineItemBackupValue(item, field, itemIndex, backupValue, false);
      return false;
    }

    // send all the information (amount, discount, tax) in one request
    var amount_entry = item[othersType].entry.toString();
    if (amount_entry.indexOf('%') > -1)
      param.amount_percentage = Number(amount_entry.replace('%', ''));
    else
      param.amount = Number(amount_entry);

    param.discount = null;
    if (!!item[othersType].discount_entry) {
      var discount_entry = item[othersType].discount_entry.toString();
      if (discount_entry.indexOf('%') > -1)
        param.discount_percentage = Number(discount_entry.replace('%', ''));
      else
        param.discount = Number(discount_entry);
    }

    if (!!tax)
      param.tax_id = tax._id;
    else
      param.tax_id = item[othersType].tax_id;

    sendingUpdateItem (itemIndex, item, othersType, param, backupValue);
  }

  /**
   * Update Item value (QTY, discount, tax)
   * @param itemIndex
   * @param field
   * @param isDecimal
   * @param newValue
   * @param backupValue
   */
  function updateItem(itemIndex, field, isDecimal, newValue, backupValue) {
    var item = localPRData.pr_items[itemIndex];
    var fieldToSend = field;
    var param = {};
    var zeroAllowed = field === 'price';
    if (newValue == backupValue)
      return;

    if (!!lineItemValidation(newValue, fieldNameConversion[field].type, isDecimal, zeroAllowed)) {
      setLineItemBackupValue(item, field, itemIndex, backupValue, false);
      return false;
    }

    if (field in fieldNameConversion)
      fieldToSend = fieldNameConversion[field].name;

    param[fieldToSend] = newValue;

    if (field === 'tax')
      param[fieldToSend] = newValue._id;

    // set is_percentage for discount
    if (field === 'discount') {
      newValue = newValue.toString();
      param.is_percentage = (newValue.indexOf('%') > -1);
      param[fieldToSend] = Number(newValue.replace('%', ''));
    }

    if (field === 'freight' || field === 'transportation') {
      newValue = newValue.toString();
      if (!!param[fieldToSend])
        delete param[fieldToSend];
      if (newValue.indexOf('%') > -1)
        param.amount_percentage = Number(newValue.replace('%', ''));
      else
        param.amount = Number(newValue);
    }

    sendingUpdateItem (itemIndex, item, field, param, backupValue);
  }

  /**
   * Sending updateItem request
   * @param itemIndex
   * @param item
   * @param field
   * @param param
   * @param backupValue
   */
  function sendingUpdateItem(itemIndex, item, field, param, backupValue) {
    if (!!item) {
      prFunction.setLoading('lineItemTable', true);
      prFunction.setLoading('updatePRField', true);
      purchaseRequisitionsServices.setItem({
        id: item._id,
        action: field
      }, param, function(resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          prFunction.setPRData(resource.content.data);

        // Set backup value
        prFunction.setLoading('lineItemTable', false);
      }, function(error) {
        setLineItemBackupValue(item, field, itemIndex, backupValue, false);
        prFunction.setLoading('lineItemTable', false);
        globalFunc.objectErrorMessage(error);
      });
    }
  }

  /**
   * updating item for mass edit
   * using recursive function to send the request one by one
   *
   * @param items
   * @param field
   * @param newValue
   * @param itemIndex
   *
   * @returns {string}
   */
  function updateMultiItems(items, field, newValue, itemIndex){

    var fieldToSend = field;
    var param = {};

    var index = itemIndex || 0;
    var verified = true;
    var item = items[index];

    if (lineItemValidation(newValue, fieldNameConversion[field].type, item.UOM.is_fraction)) {
      verified = false;
      return 'error';
    }

    if (field in fieldNameConversion)
      fieldToSend = fieldNameConversion[field].name;

    param[fieldToSend] = newValue;

    if (field === 'tax')
      param[fieldToSend] = newValue._id;

    if (field === 'discount') {
      if (!!newValue) {
        newValue = newValue.toString();
        param.is_percentage = (newValue.indexOf('%') > -1);
        param[fieldToSend] = Number(newValue.replace('%', ''));
        if(newValue > item.amount){
          globalFunc.objectErrorMessage('The discount cannot be more than the Total amount');
          verified = false;
          return 'error';
        }
      } else if (newValue === 0) {
        param.is_percentage = false;
        param[fieldToSend] = 0;
      }
    }

    if(verified) {
      prFunction.setLoading('lineItemTable', true);
      prFunction.setLoading('updatePRField', true);
      purchaseRequisitionsServices.setItem({
        id: item._id,
        action: field
      }, param, function(resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          prFunction.setPRData(resource.content.data);
          addSelectedStatus(items, resource.content.data);
        }

        // go to the next item index
        // and validate if the next index is the last index
        // if not the last, call the updateMultiItems with the new index
        index++;
        if (!!items && items.length !== index)
          updateMultiItems(items, field, newValue, index);
        else
          prFunction.setLoading('lineItemTable', false);
      }, function(error) {
        setLineItemBackupValue(item, field, itemIndex, backupValue, false);
        prFunction.setLoading('lineItemTable', false);
        globalFunc.objectErrorMessage(error);
      });
    }
  }

  /**
   * re-added selected value to the resource data
   * @param prevPRItem
   * @param newPR
   * @returns {*}
   */
  function addSelectedStatus(prevPRItem, newPR) {
    _.forEach(newPR.pr_items, function (item) {
      var checkPrevPR = globalFunc.findInArray(prevPRItem, '_id', item._id);
      if (!!checkPrevPR && !!checkPrevPR.selected)
        item.selected = checkPrevPR.selected;
    });
    return newPR;
  }

  /**
   * Set or Restore the item backup value
   * @param item
   * @param field
   * @param itemIndex
   * @param backupValue
   * @param setValue
   * boolean value to set or to restore
   */
  function setLineItemBackupValue(item, field, itemIndex, backupValue, setValue) {

    // replace the value with backupValue
    var newFieldName = field;
    if (!!setValue)
      newFieldName = 'backup_' + field;

    if (!!item) {
      item[newFieldName] = backupValue;

      if (newFieldName === 'price')
        item.unit_price = backupValue;

      if (newFieldName === 'discount')
        item.discount_entry = backupValue;

      if (newFieldName === 'freights' || newFieldName === 'transportation') {
        var backupField = 'backup_' + newFieldName;
        item[newFieldName] = item[backupField];
      }

      $scope.PRData().pr_items[itemIndex] = item;
    } else {
      $scope.PRData()[newFieldName] = backupValue;
    }
    prFunction.setPRData($scope.PRData());
  }

  /**
   * This validation can be used in general cases
   * todo: can be moved to general function (later)
   * Validate value based on the type
   * and calling function based on the type
   * @param value
   * @param type
   * @param isDecimal
   * @param zeroAllowed
   */
  function lineItemValidation(value, type, isDecimal, zeroAllowed) {
    var message = "";

    if (type === 'number')
      message = numberValidation(isDecimal, value, zeroAllowed);

    if (type === 'numberPercentage')
      message = percentageValidation(value);

    if (!!message)
      toastr.error(message);

    return !!message;
  }

  function percentageValidation(entry) {
    if (!!entry) {
      entry = entry.toString();
      var percentageCount = (entry.match(/%/g) || []).length;
      var dotCount = (entry.match(/\./g) || []).length;

      /**
       * Remove % character from input to pass to check decimal places
       */
      if(entry.indexOf('.') > 1){
        var entryWithoutPercentSign = angular.copy(entry);
        entryWithoutPercentSign = entryWithoutPercentSign.replace('%', '');
        var decimalPlaces = (entryWithoutPercentSign.length - entryWithoutPercentSign.indexOf('.')) - 1;
      }

      if (percentageCount > 1 ||
        (percentageCount === 1 && entry.length <= 1) ||
        (percentageCount === 1 && entry.indexOf("%") !== entry.length - 1) ||
        (dotCount > 1) ||
        (dotCount > 0 && entry.indexOf(".") == 0) ||
        decimalPlaces > 2
      ) {
        return lang.validation.percentage.invalid;
      }

      return false;
    }
  }

  /**
   * Number validation
   * - Positive number only
   * - check if valid Number
   * - check decimal value if isDecimal value is true
   * @param isDecimal
   * @param value
   * @param zeroAllowed
   */
  function numberValidation(isDecimal, value, zeroAllowed) {
    var validFraction = fractionValidation(value);

    if (isNaN(value))
      return lang.validation.number.isNumber;
    if(zeroAllowed) {
      if (!(value >= 0))
        return lang.validation.number.positive;
    }else{
      if (!(value > 0))
        return lang.validation.number.positive;
    }
    if (!isDecimal && !!validFraction)
      return lang.validation.number.noFraction;

    return false;
  }

  function getAccountCodes() {
    return prFunction.getAccountCodes();
  }

  /**
   * Decimal value validation
   * @param value
   */
  function fractionValidation(value) {
    return Number(value) % 1 !== 0;
  }

  function showLumpSumButton() {
    var validateLumpSum = prFunction.validateLumpSum(null, -1);
    return validateLumpSum.status;
  }

  function getTaxData() {
    return prFunction.getTaxData();
  }

  function canEditPR() {
    return prFunction.getPRData().status === 'edit';
  }

  $scope.$on('PRDataUpdated', function(){
    PRData();
  });

  function initialize() {
    $scope.datePickerTimezone = $rootScope.datePickerTimezone;

    if(!prFunction.getPRData() || !prFunction.getPRData()._id){}
      prFunction.setPRData($scope.pr);
  }

  initialize();

}

purchaseRequisitionsItemListCtrl.$inject = [
  '$scope', 'prFunction', 'purchaseRequisitionsServices', 'globalFunc', 'pathConstants', 'toastr', 'lang', '$rootScope',
  '$q', '$uibModal'
];

angular
  .module('metabuyer')
  .directive('prItemList',function() {
    return {
      restrict: 'E',
      scope: {
        editingState: '=',
        pr: '='
      },
      template: '<div ng-include="myTemplateUrl"></div>',
      controller: 'purchaseRequisitionsItemListCtrl'
    }
  })
  .controller('purchaseRequisitionsItemListCtrl', purchaseRequisitionsItemListCtrl);

'use strict';
/**
 * @name itemDetailsCtrl
 *
 * @description
 * Controller for item details
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

function itemDetailsCtrl(
  $scope, details, imgPath, $uibModalInstance, itemDetailsInformation, $rootScope, itemId, globalFunc, enableStarring, prFunction, $state
) {

  $scope.imgBasePath    = imgPath;
  $scope.item           = details;
  $scope.details        = details.item_details;
  $scope.enableStarring = enableStarring;

  $scope.close          = close;
  $scope.getPRState     = getPRState;
  $scope.isShoppingMode = isShoppingMode;

  function close() {
    $uibModalInstance.close();
  }

  function getPRState(){
    return prFunction.getEditingState();
  }

  function isShoppingMode() {
    return $state.includes('main.user.purchaseRequisitions.details.catalog');
  }

  function loadItemDetails() {
    itemDetailsInformation.get({
      user_id: $rootScope.currentUser._id,
      item_id: itemId
    }, function(resource) {
      if (!!resource && !!resource.content && !!resource.content.data)
        $scope.details = resource.content.data;
    }, function(error) {
      $scope.details = {};
      globalFunc.objectErrorMessage(error);
    });
  }

  /**
   * check supplier value in item_details.
   * to support non catalog
   */
  function checkSupplierValue() {
    if (!$scope.details.supplier_descr)
      $scope.details.supplier_descr = $scope.item.supplier.descr;
  }

  function initialize() {
    if (!!itemId && !details)
      loadItemDetails();
    checkSupplierValue();
  }

  // dynamically updating the items view
  $scope.$on('updateDetailsData', function(args, data) {
    if (!!data && data.item_details) {
      $scope.item = data;
      //force the image to reload
      var randomVal = Math.random();
      $scope.item.item.img_url = $scope.item.item.img_url + '?decache=' + randomVal;
      $scope.details = data.item_details;
      initialize();
    }
  });

  initialize();

}
itemDetailsCtrl.$inject = [
  '$scope', 'details', 'imgPath', '$uibModalInstance', 'itemDetailsInformation', '$rootScope', 'itemId', 'globalFunc', 'enableStarring', 'prFunction', '$state'
];

angular
  .module('metabuyer')
  .controller('itemDetailsCtrl', itemDetailsCtrl);

'use strict';

/**
 * @name itemDetails
 *
 * @description
 * itemDetails directive
 *
 * @param details
 * if the details item is provided by the existing item object,
 * just pass the details info
 *
 * @param imgPath
 * imgPath used to display image
 *
 * @id id
 * if the item details is not provided
 * we can use item_id to pass
 * the directive will send request to get the details
 *
 */

angular
  .module('metabuyer')
  .directive('itemDetails',function($uibModal) {
    return{
      restrict: 'AE',
      scope: {
        details         : '=',
        imgPath         : '=',
        id              : '=',
        enableStarring  : '=?'
      },
      link: function($scope, element) {

        function displayPanel() {
          $uibModal.open({
            templateUrl: 'components/purchaseRequisitionComponents/itemDetails/itemDetails.html',
            controller: 'itemDetailsCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
              details: function() {
                return $scope.details;
              },
              imgPath: function() {
                return $scope.imgPath;
              },
              itemId: function() {
                return $scope.id;
              },
              enableStarring: function(){
                return $scope.enableStarring;
              }
            }
          });
        }

        element.bind("click", function(){
          displayPanel();
        });
      }
    };
  });

'use strict';

function purchaseRequisitionsDetailsHeaderCtrl(
  $scope, metabuyerCache, subscriptionCheck, singleAddress, $q, companyExpenseTypes,
  purchaseRequisitionsServices, globalFunc, prFunction, PRAccountCodeList, $rootScope, budgetList
) {

  function copyTheDataToTemporaryModes() {
    $scope.editableData = angular.copy(prFunction.getPRData());
    if (!!$scope.editableData.budget && !$scope.editableData.budget._id) {
      $scope.editableData.budget = $scope.defaultBudgetOption
    }
  }

  /**
   * checking the Subscription of the PR
   * @param requisition
   */
  function checkSubscription(requisition) {
    subscriptionCheck.get(
      {
        object_id: requisition._id,
        class: 'Metabuyer\\PR\\PR'
      },
      function (resource) {
        $scope.PR.notify = resource.subscribed;
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }


  /**
   * Load the Addresses and Caching them
   * @param addresses
   * @param type
   */
  function loadAddressesData (addresses, type) {
    var promises = [];
    var cleanedAddress = [];
    angular.forEach(addresses, function (id) {
      if (!!metabuyerCache.get(id.$id)) {
        cleanedAddress.push(metabuyerCache.get(id.$id));
      } else {
        var promise = singleAddress.get({
            id: id.$id
          }
        );
        promises.push(promise.$promise);
      }
    });
    $q.all(promises).then(function (resource) {
      angular.forEach(resource, function (address) {
        if (!!address && !!address.content && !!address.content.data) {
          cleanedAddress.push(address.content.data);
          metabuyerCache.put(address.content.data._id, address.content.data);
        }
      });
    }).catch().finally(function () {
      if (type === 'billing') {
        $scope.costCenterBillingAddresses = angular.copy(cleanedAddress);
      }
    });
  }

  /**
   * store the available addresses for this PR in variables
   * Also, enables the selection of multiple addresses or not
   * adding the billing address from the Cost Center
   */
  function loadAvailableAddresses(CC) {
    $scope.enableSelectingBillingAddress = false;
    $scope.enableSelectingDelieveryAddress = false;

    if(!CC)
      return;

    var costCenterBillingAddressesIds = globalFunc.removeDuplicateObjects(CC.billing_addresses_ids, '$id');


    loadAddressesData(costCenterBillingAddressesIds, 'billing');

    purchaseRequisitionsServices.getAvailableDeliveryAddresses(
      {
        id: $scope.PR.company._id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.costCenterDeliveryAddresses = resource.content.data;
          prFunction.setCostCenterDeliveryAddresses(resource.content.data);
        } else {
          //error
        }

      }, function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }


  /**
   * loading the list of company expense types
   */
  function loadExpenseTypes() {
    companyExpenseTypes.get(
      {
        id: $scope.PR.company._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.expenseTypes = resource.content.data;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  /**
   * loading the List of available contact persons
   */
  function loadContactPersons() {
    $scope.contactPersonsList = [];
    purchaseRequisitionsServices.getContactPersonsList({
        id: $scope.PR.company._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.contactPersonsList = resource.content.data;
          prFunction.setContactPerson(resource.content.data);
        }
      });
  }

  /**
   * loading the List of available contact persons
   */
  function loadRequestorsList(CC) {
    $scope.requestorsList = [];
    purchaseRequisitionsServices.getAvailableRequestorsList({
        id: CC._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.requestorsList = resource.content.data;

          /**
           * remove the creator from the List and adding it to the start of the list
           */
          $scope.requestorsList = globalFunc.removeValueFromArray($scope.requestorsList, '_id', $scope.PR.creator._id);
          $scope.requestorsList.unshift($scope.PR.creator);

        }else{
          //error
        }

      },function(error){
        //error
      });
  }


  function onSelectDeliveryAddress(address) {
    $scope.editableData.delivery_address = address;
    onUpdatingHeaderInfo();
  }

  function onSelectBillingAddress(address) {
    $scope.editableData.billing_address = address;
    onUpdatingHeaderInfo();
  }

  function onSelectBillingCompany(company) {
    $scope.editableData.alternate_billing_company = !!company ? company : null;
    onUpdatingHeaderInfo();
  }

  /**
   * validation to check account code in line item
   */
  function validateAccountCode(items) {
    var accountCodeExist = [];
    if (!!items && !!items.length) {
      _.forEach(items, function (item) {
        if (!!item.account_code)
          accountCodeExist.push(item._id);
      });
    }
    return accountCodeExist;
  }

  /**
   * on updating cost center
   * needs to validate the account code in line item,
   * warn the user if line item is having account code from existing cost center
   * @param CC
   */
  function onSelectCostCenter(CC){
    var pr = prFunction.getPRData();
    if (!!pr.cost_center && !!pr.cost_center._id !== CC._id) {
      var itemIds = validateAccountCode(pr.pr_items);
      if (!!itemIds && !!itemIds.length) {
        swal({
          title: 'Account code is assigned in a line item!',
          text: 'Updating the Purchase Requisition Cost Center will result in removing the assigned account code.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Proceed',
          closeOnConfirm: true
        }, function(isConfirm){
          if (isConfirm) {
            prFunction.setLoading('lineItemTable', true);
            removeAccountCodes(itemIds, CC);
          }
          else
            $scope.editableData.cost_center = pr.cost_center;
        });
      }
      else
        updatingCostCenter(CC);
    }
    else{
      updatingCostCenter(CC);
    }
  }

  /**
   * remove account codes in all items
   * @param ids
   * @param CC
   */
  function removeAccountCodes(ids, CC) {
    purchaseRequisitionsServices.setItem({
      id: ids[0],
      action: 'account-code'
    }, {
      account_code_id : null
    }, function (resource) {
      if (!!resource && !!resource.content && !!resource.content.data)
        prFunction.setPRData(resource.content.data);

      ids.shift();
      if (!!ids && !!ids.length)
        removeAccountCodes(ids, CC);
      else {
        updatingCostCenter(CC);
        prFunction.setLoading('lineItemTable', false);
      }
    }, function (error) {
      globalFunc.objectErrorMessage(error);
      callback(false);
    });
  }

  /**
   * Updating cost center process
   * @param CC
   */
  function updatingCostCenter(CC) {
    loadRequestorsList(CC);
    loadAccountCode($scope.PR.company.code, CC._id);

    //validate billing address
    var billing = !!globalFunc.findInArray(CC.billing_addresses_ids, '$id', prFunction.getPRData().billing_to_address._id) ? null : '';
    //validate billing address
    var delivery = !!globalFunc.findInArray(CC.delivery_addresses_ids, '$id', prFunction.getPRData().delivery_to_address._id) ? null : '';

    //Remove budget selection when cost center is modified
    $scope.editableData.budget = $scope.defaultBudgetOption;
    $scope.PR.budget = $scope.defaultBudgetOption;

    if (!prFunction.getPRData().cost_center || prFunction.getPRData().cost_center._id || prFunction.getPRData().cost_center._id !== CC._id)
      loadAvailableAddresses(CC);

    onUpdatingHeaderInfo(billing, delivery);
    loadBudgets();
  }

  function onSelectExpenseType(){
    //Remove budget selection when expense type is modified
    $scope.editableData.budget = $scope.defaultBudgetOption;
    $scope.PR.budget = $scope.defaultBudgetOption;
    onUpdatingHeaderInfo();
    loadBudgets();
  }

  function onSelectCurrency(){
    onUpdatingHeaderInfo();
  }

  function onSelectBudget(budget) {
    checkPrItemsToBudget(budget);
  }

  function checkPrItemsToBudget(budget) {
    var info = {
      'budget_id': !!$scope.editableData.budget && !!$scope.editableData.budget._id ?
        $scope.editableData.budget._id : null,
      'budget_assignment': !!$scope.editableData.budget && !!$scope.editableData.budget.assignment_id ?
        $scope.editableData.budget.assignment_id : null
    };

    purchaseRequisitionsServices.checkPRCompanyInfo(
      {
        id: $scope.PR._id
      },{
        budget : info
      },function(){
        $scope.PR.budget = budget;
        onUpdatingHeaderInfo();
      },function (error){
        if (!!error && !!error.data && !!error.data.content && !!error.data.content.error) {
          if (error.data.content.error === 'InvalidPrItems') {
            userToConfirmRemovePrItems(error.data.content.message, budget);
          }
        }
      }
    );
  }

  function userToConfirmRemovePrItems(removedItems, budget) {
    swal(
      {
        title: 'Confirm select budget?',
        text: 'Selecting this budget will remove the following Items:  '.concat(removedItems),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        closeOnConfirm: true
      },
      function (isConfirm) {
        if (isConfirm) {
          $scope.PR.budget = budget;
          onUpdatingHeaderInfo();
        } else {
          $scope.editableData.budget = prFunction.getPRData().budget;
        }
      }
    );
  }

  function onSelectContactPerson(person) {
    var text;
    if(typeof person === 'object'){
      text = person.display_name;
    }else{
      text = person;
    }
    purchaseRequisitionsServices.setPPContactPerson(
      {
        id: $scope.PR._id
      },{
        contact_person : text
      },function(resource){
        $scope.PR.contact_person = text;
      },function (error){
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function onSelectPRRequestor(person) {

    purchaseRequisitionsServices.setRequestedBy(
      {
        id: $scope.PR._id
      },{
        requested_by_id : person._id
      },function(resource){
        $scope.PR.requestor = person;
      },function (error){
       // console.log(error);
      }
    );
  }

  /**
   * Action when remarks is changed
   *
   * @param {string} remarks
   */
  function onChangeRemarks(remarks) {

    purchaseRequisitionsServices.setRemarks(
      {
        id: $scope.PR._id
      },{
        remarks : remarks
      },function(){
        $scope.PR.remarks = remarks;
      },function (error){
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function openDatePicker($event){
    $event.preventDefault();
    $event.stopPropagation();
    $scope.editableData.neededByDatePanel = true;
  }

  /**
   * this function checks the models for the Billing Address, Delivery Address, Cost Center, Expense Type and Currency, then update them as 1 payload in the backend
   * @param billingAddress
   * @param deliveryAddress
   * @param CCId
   * @param expenseType
   * @param currencyId
   * @param alternateBillingCompanyCode
   */
  function onUpdatingHeaderInfo(billingAddress, deliveryAddress, CCId, expenseType, currencyId, alternateBillingCompanyCode){
    prFunction.setLoading('updatePRField', true);
    var info = {
      'company_id': $scope.PR.company._id,
      'billing_to_address_id' : (!!billingAddress || billingAddress === '') ? billingAddress : (!!$scope.editableData.billing_address && !!$scope.editableData.billing_address._id) ?
        $scope.editableData.billing_address._id : $scope.editableData.billing_to_address._id,
      'delivery_to_address_id' : (!!deliveryAddress || deliveryAddress === '') ? deliveryAddress : (!!$scope.editableData.delivery_address && !!$scope.editableData.delivery_address._id) ?
        $scope.editableData.delivery_address._id : $scope.editableData.delivery_to_address._id,
      'cost_center_id' : (!!CCId || CCId ==='') ? CCId : (!!$scope.editableData.cost_center && !!$scope.editableData.cost_center._id) ?
        $scope.editableData.cost_center._id : null,
      'expense_type_id' : (!!expenseType || expenseType === '') ? expenseType :
        (!!$scope.editableData.expense_type && !!$scope.editableData.expense_type._id) ? $scope.editableData.expense_type._id : null,
      'currency_id' : (!!currencyId || currencyId === '') ? currencyId : (!!$scope.editableData.currency && !!$scope.editableData.currency._id) ? $scope.editableData.currency._id : null,
      'alternate_billing_company' : (!!alternateBillingCompanyCode || alternateBillingCompanyCode === '') ? alternateBillingCompanyCode :
        (!!$scope.editableData.alternate_billing_company) ? $scope.editableData.alternate_billing_company : null,
      'budget_id': !!$scope.editableData.budget && !!$scope.editableData.budget._id ?
        $scope.editableData.budget._id : null,
      'budget_assignment': !!$scope.editableData.budget && !!$scope.editableData.budget.assignment_id ?
        $scope.editableData.budget.assignment_id : null
    };

    purchaseRequisitionsServices.updatePRCompanyInfo(
      {
        id: $scope.PR._id
      },{
        company : info
      },function(resource){
        $scope.PR.billing_address = $scope.editableData.billing_address;
        $scope.PR.delivery_address = $scope.editableData.delivery_address;
        $scope.PR.cost_center = $scope.editableData.cost_center;
        $scope.PR.expense_type = $scope.editableData.expense_type;
        $scope.PR.currency = $scope.editableData.currency;
        $scope.PR.alternate_billing_company = $scope.editableData.alternate_billing_company;
        if (!!resource && !!resource.content && !!resource.content.data) {
          prFunction.setPRData(resource.content.data);
          $scope.editableData.billing_to_address = resource.content.data.billing_to_address;
          $scope.editableData.delivery_to_address = resource.content.data.delivery_to_address;
        }
      },function (error){
        globalFunc.objectErrorMessage(error);
      }
    );

  }

  $scope.$watch('editableData.needed_by_date', function (newValue, oldValue) {

    if (!newValue || (newValue === oldValue)) {
        // nothing is needed
    }
    else {
      var milliseconds = globalFunc.convertDateToTimestamp(newValue);

      purchaseRequisitionsServices.setNeededByDate(
        {
          id: $scope.PR._id
        },{
          needed_by_date : milliseconds
        },function(resource){

        },function (error){
          globalFunc.objectErrorMessage(error);
        }
      );
    }

  });

  function loadAccountCode(companyCode, ccId) {
    PRAccountCodeList.get({
      company_code: companyCode,
      cost_center_id: ccId
    }, function(resource) {
      if (!!resource && !!resource.content && !!resource.content.data)
        prFunction.setAccountCodes(resource.content.data)
    })
  }

  // refresh budget drop-down listing
  function loadBudgets() {
    if (!$scope.editableData.cost_center || !$scope.editableData.cost_center.code ||
      !$scope.editableData.expense_type || !$scope.editableData.expense_type.code) {
      return;
    }

    budgetList.get({
        type: 'budget_listing_for_pr_draft',
        company_code: $scope.PR.company.code,
        cost_center: $scope.editableData.cost_center.code,
        expense_type: $scope.editableData.expense_type.code
      }, function (resource) {
        if (!!resource.content && !!resource.content.data && !!resource.content.setting) {
          $scope.budgetListing = resource.content.data;
          $scope.budgetListing.unshift(
            $scope.defaultBudgetOption
          );
          $scope.budgetSetting = resource.content.setting;
        }
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function getCurrencyList() {
    return prFunction.getCurrenciesData();
  }

  function clearNeededByDate($event){
    $event.preventDefault();
    $event.stopPropagation();

    purchaseRequisitionsServices.setNeededByDate(
      {
        id: $scope.PR._id
      },{
        needed_by_date : ''
      },function(){
        $scope.editableData.needed_by_date = null;
        $scope.PR.needed_by_date = null;
      },function (error){
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * check errors field from prFunction.getErrorOnSubmit
   * @param field
   */
  function submissionValidation(field) {
    var errors = prFunction.getErrorsOnSubmit();
    return (errors.indexOf(field) > -1);
  }

  function approvalFlowData() {
    $scope.localApprovalData = prFunction.getApprovalFlow();
    return $scope.localApprovalData;
  }

  function setShowing(section){
    switch (section) {
      case 'bill_to':
        $scope.billToShow = ($scope.billToShow === true) ? false : true;
        break;
      case 'deliver_to':
        $scope.deliverToShow = ($scope.deliverToShow === true) ? false : true;
        break;
      case 'other_details':
        $scope.otherToShow = ($scope.otherToShow === true) ? false : true;
        break;
    }
  }

  function initialize(){

    /**
     * Assign variable for pr data
     */
    var pr = prFunction.getPRData();

    $scope.dateOptions = {
      formatYear: 'yy',
      minDate: new Date(),
      startingDay: 1
    };
    $scope.datePickerTimezone = $rootScope.datePickerTimezone;

    $scope.requestorsList = [];
    $scope.expenseTypes = [];
    $scope.budgetListing = [];
    $scope.billToShow = false;
    $scope.deliverToShow = false;
    $scope.otherToShow = false;
    $scope.defaultBudgetOption = {
      '_id': null,
      'assignment_id': null,
      'descr': 'N/A',
      'code': 'Not Applicable',
      'type': null
    };

    $scope.openDatePicker           = openDatePicker;
    $scope.clearNeededByDate        = clearNeededByDate;
    $scope.onSelectDeliveryAddress  = onSelectDeliveryAddress;
    $scope.onSelectBillingAddress   = onSelectBillingAddress;
    $scope.onSelectCostCenter       = onSelectCostCenter;
    $scope.onSelectBillingCompany   = onSelectBillingCompany;
    $scope.onSelectExpenseType      = onSelectExpenseType;
    $scope.onSelectCurrency         = onSelectCurrency;
    $scope.onSelectContactPerson    = onSelectContactPerson;
    $scope.onUpdatingHeaderInfo     = onUpdatingHeaderInfo;
    $scope.onSelectPRRequestor      = onSelectPRRequestor;
    $scope.submissionValidation     = submissionValidation;
    $scope.getCurrencyList          = getCurrencyList;
    $scope.approvalFlowData         = approvalFlowData;
    $scope.setShowing               = setShowing;
    $scope.onSelectBudget           = onSelectBudget;
    $scope.checkAvailableBudget     = checkAvailableBudget;
    $scope.onChangeRemarks          = onChangeRemarks;

    function checkAvailableBudget(budgetListing) {
      var emptyArray = false;

      _.forEach(budgetListing, function(value) {
        if (!!value._id) {
          emptyArray = true;
        }
      });

      return emptyArray;
    }

    copyTheDataToTemporaryModes();
    checkSubscription($scope.PR);
    if (!!$scope.costCenters && !!$scope.costCenters.length){
      if(!!$scope.PR.cost_center && !!$scope.PR.cost_center._id){
        loadAvailableAddresses(globalFunc.findInArray($scope.costCenters, '_id', $scope.PR.cost_center._id));
      }
    }

    loadExpenseTypes();
    loadContactPersons();
    loadBudgets();

    if(!!pr.cost_center && !!pr.cost_center._id){
      loadRequestorsList(pr.cost_center);
      loadAccountCode(pr.company.code, pr.cost_center._id);
    }

    var billingCompanyArray = globalFunc.findInArray($scope.PR.company.billing_company_codes_list, 'code', $scope.editableData.alternate_billing_company);
    if (!!billingCompanyArray) {
      $scope.editableData.alternate_billing_company = billingCompanyArray;
    }
  }

  initialize();
}


angular
  .module('metabuyer')
  .directive('purchaseRequisitionDetailsHeader',function($rootScope) {
      return {
        restrict: 'E',
        scope: {
          editingState: '=',
          PR: '=pr',
          costCenters: '='
        },
        template: '<div ng-include="myTemplateUrl"></div>',
        controller: 'purchaseRequisitionsDetailsHeaderCtrl',
        link: function ($scope) {
          $scope.getTemplateUrl = getTemplateUrl;

          function getTemplateUrl(state) {
            if ($rootScope.isMobileMode){
              $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.NonEditableTemplate-mobile.html';
            }

            if (!$rootScope.isMobileMode) {
              switch (state) {
                case 'editable':
                  $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.EditableTemplate.html';
                  break;
                case 'notEditable' :
                  $scope.myTemplateUrl = 'components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.NonEditableTemplate.html';
                  break;
              }
            }
          }
          $scope.$watch('editingState', function (newValue) {
            getTemplateUrl(newValue);
          });
        }
      }
    })
  .controller('purchaseRequisitionsDetailsHeaderCtrl',  purchaseRequisitionsDetailsHeaderCtrl);

'use strict';

function createPurchaseRequisitionButtonCtrl($scope, purchaseRequisitionsServices, $rootScope, $state,
                                             prFunction, globalFunc) {

  function createPR(company) {
    $scope.title = 'Loading ...';
    $scope.disabled = true;

    /**
     * add the new field required by the backend
     */
    company.company_id = company._id;

    purchaseRequisitionsServices.createPR({
        company: {company_id : company._id}
      },
      function (resource) {
        prFunction.setPRData({});
        $state.go('main.user.purchaseRequisitions.details', {id: resource.content.data._id, PR: resource.content});
        $scope.title = 'Create PR';
        $scope.disabled = false;
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        $scope.title = 'Create PR';
        $scope.disabled = false;
      }
    );

  }

  /**
   * This function return a boolean to show or hiding the create PR button
   * @returns {boolean}
   */
  function showCreateButton(){
    if($state.current.name.indexOf('purchaseRequisitions') > -1)
      return true;
    else if ($state.current.name.indexOf('suppliersList') > -1)
      return true;
    else if ($state.current.name.indexOf('orders') > -1)
      return true;
    else
      return false;
  }

  $scope.disabled = false;
  $scope.title = 'Create PR';
  $scope.listOfCompanies = $rootScope.listOfCompaniesForLoggedInUser;
  $scope.createPR = createPR;
  $scope.showCreateButton = showCreateButton;
}


createPurchaseRequisitionButtonCtrl.$inject= ['$scope', 'purchaseRequisitionsServices', '$rootScope', '$state',
                                              'prFunction', 'globalFunc'];

angular
  .module('metabuyer')
  .directive('createPurchaseRequisitionButton',function() {
    return{
      restrict: 'E',
      templateUrl: 'components/purchaseRequisitionComponents/createPurchaseRequisitionButton/createPurchaseRequisitionButtonTemplate.html',
      scope: {},
      controller: 'createPurchaseRequisitionButtonCtrl'
    };
  })
  .controller('createPurchaseRequisitionButtonCtrl', createPurchaseRequisitionButtonCtrl);

'use strict';

/**
 * Controller for Modal to display Branch Listing for branch PR selection
 *
 * @param $scope
 * @param $uibModalInstance
 * @param branchSelection
 *
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function branchPrListingCtrl($scope, $uibModalInstance, branchSelection) {
  $scope.branchSelection = branchSelection;
  $scope.closeBranchListing = closeBranchListing;
  $scope.callBackFunction = callBackFunction;

  function closeBranchListing() {
    $uibModalInstance.close();
  }

  function callBackFunction(data) {
    var startNext = $scope.$resolve.onSelectSupplierBranch(data, $scope.$resolve.itemIndex);
    if(!!startNext) {
      $uibModalInstance.close();
    }
  };
}
branchPrListingCtrl.$inject = [
  '$scope', '$uibModalInstance', 'branchSelection'
];
angular.module('metabuyer')
  .controller('branchPrListingCtrl', branchPrListingCtrl);

'use strict';

function purchaseRequisitionsActionCtrl(
  $scope, pathConstants, purchaseRequisitionsServices, $state, HighlightId, prFunction, $rootScope, globalFunc, toastr,
  $stateParams, getPRPDFHash, $filter, UserPermissions, generatePO, notificationSubscriber
){

  $scope.localApprovalData          = {};
  $scope.currentUser                = $rootScope.currentUser || { _id: null };
  $scope.nextPR                     = { context_id: 'loading' };
  $scope.userBasePath               = $rootScope.userImageBasePath;
  $scope.waitingOnUser              = [];
  $scope.templateUrlPath            = 'components/purchaseRequisitionComponents/actions/purchaseRequisitionActions.html';
  $scope.module                     = 'PR';

  if ($rootScope.isMobileMode) {
    $scope.templateUrlPath = 'components/purchaseRequisitionComponents/actions/purchaseRequisitionActions-mobile.html';
    if ($scope.actionType === 'button')
      $scope.templateUrlPath = 'components/purchaseRequisitionComponents/actions/purchaseRequisitionActions-mobile-button.html';
  }

  $scope.deletePR                   = deletePR;
  $scope.generatePurchaseOrder      = generatePurchaseOrder;
  $scope.approvalAction             = approvalAction;
  $scope.submitPurchaseRequisition  = submitPurchaseRequisition;
  $scope.transitionToListingPending = transitionToListingPending;
  $scope.approvalFlowData           = approvalFlowData;
  $scope.checkWaitingOn             = checkWaitingOn;
  $scope.isPRCreator                = isPRCreator;
  $scope.canSubmit                  = canSubmit;
  $scope.canUnHold                  = canUnHold;
  $scope.canApprove                 = canApprove;
  $scope.canDelete                  = canDelete;
  $scope.actionCondition            = actionCondition;
  $scope.refreshPRDetail            = refreshPRDetail;
  $scope.prAction                   = prAction;
  $scope.printPRViaPDF              = printPRViaPDF;
  $scope.notificationToggle         = notificationToggle;
  $scope.duplicatePR                = duplicatePR;
  $scope.moveToDraftPR              = moveToDraftPR;
  $scope.allowEditingPR             = allowEditingPR;
  $scope.setEditableMode            = setEditableMode;
  $scope.canHold                    = canHold;
  $scope.canReject                  = canReject;
  $scope.canWithdraw                = canWithdraw;
  $scope.canGeneratePO              = canGeneratePO;
  $scope.submitEditableDraft        = submitEditableDraft;
  $scope.requestEditableDraft       = requestEditableDraft;
  $scope.cancelEditingPR            = cancelEditingPR;
  $scope.allowedToRevertApproval    = allowedToRevertApproval;
  $scope.revertApproval             = revertApproval;
  $scope.revertApprovalErrorHandler = revertApprovalErrorHandler;
  $scope.canUpdateCollaborators     = canUpdateCollaborators;

  /**
   * Check if the current PR has valid status to update the collaborator
   *
   * @param string currentPrStatus String of PR status
   * @returns {boolean}
   */
  function canUpdateCollaborators(currentPrStatus) {
    var validPRStatus = [
      'draft',
      'pending',
      'on_hold',
      'withdrawn',
      'rejected',
      'approved'
    ];

    return !_.isEmpty(_.intersection(validPRStatus, [currentPrStatus]));
  }

  function allowedToRevertApproval () {
    return $scope.PR.status.toLowerCase() === 'pending' && globalFunc.findInArray($scope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN');
  }

  function revertApproval(extraPayload) {
    return purchaseRequisitionsServices.resetApproval(
      {
        approval_id: $scope.PR.approval_id
      },
      extraPayload
    );
  }

  function revertApprovalErrorHandler(message){
    globalFunc.objectErrorMessage(message);
  }

  function approvalFlowData() {
    $scope.localApprovalData = prFunction.getApprovalFlow();
    if (!!$scope.localApprovalData && !!$scope.localApprovalData.waiting_on && !!$scope.localApprovalData.waiting_on.length)
      globalFunc.getWaitingOnUser($scope.localApprovalData, $scope.waitingOnUser);
    return $scope.localApprovalData;
  }

  function loadNextData() {
    if ($scope.PR.status === 'pending' || $scope.PR.status.toLowerCase() === 'on_hold') {
      /**
       * add the 2 extra params for Hold and Reject PRs
       * @type {any}
       */
      $scope.onHoldPRExtraParams = prepareOnHoldExtraParams();
      $scope.rejectPRExtraParams = {};
      $scope.revertExtraParams = {};
      globalFunc.nextAvailableAction('Metabuyer\\PR\\PR', $scope.PR._id).then(function (data) {
        if (!!data && !!data.waitingOnObject && !!data.waitingOnObject.context_id) {
          $scope.nextPR = data.waitingOnObject;
          $scope.totalPRs = data.count;
        }
        else
          $scope.nextPR = {};
      });
    }
  }

  /**
   * Refresh PR detail page
   */
  function refreshPRDetail(){
    $state.transitionTo($state.current, $stateParams, {
      reload: true,
      inherit: false,
      notify: true
    });
  }

  function notificationToggle() {

    if(!$scope.PR.notify) {
      notificationSubscriber.post({
          object_id: $scope.PR._id, class: 'Metabuyer\\PR\\PR', method: 'subscribe'
        }
        , function (data) {
          $scope.PR.notify = true;
          toastr.success('Turned on notifications successfully');
        }
        , function (error) {
          toastr.error('Failed to turn on notifications');
        });
    }
    else{
      notificationSubscriber.delete({
          object_id: $scope.PR._id, class: 'Metabuyer\\PR\\PR', method: 'unsubscribe'
        }
        , function (data) {
          $scope.PR.notify = false;
          toastr.success('Turned off notifications successfully');
        }
        , function (error) {
          toastr.error('Failed to turn off notifications');
        });
    }

  }

  function duplicatePR() {
    purchaseRequisitionsServices.duplicate({
      id: $scope.PR._id
    }, function (resource) {
      if (!!resource && !!resource.content && !!resource.content.data)
        $state.go('main.user.purchaseRequisitions.details', { id: resource.content.data._id });
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    })
  }

  function moveToDraftPR(){
    purchaseRequisitionsServices.moveToDraft(
      {
        id: $scope.PR._id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          $state.reload();
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      })
  }

  /**
   * Preparing on hold extra params
   * @returns {{user_ids: Array}}
   */
  function prepareOnHoldExtraParams() {
    var userIDArray = [];
    userIDArray.push($scope.PR.creator._id);
    if ($scope.PR.requestor._id !== $scope.PR.creator._id)
      userIDArray.push($scope.PR.requestor._id);

    return {user_ids: userIDArray};
  }

  function isPRCreator() {
    return ($scope.currentUser._id === $scope.PR.creator._id);
  }

  /**
   * check the statuses of the items in which the PR is still approvable
   * a list of string for all the statuses that can be approved
   * @returns {boolean}
   */
  function checkItemsApprovability() {
    var items = prFunction.getPRData().pr_items;
    var approvalableStatuses = ['0', '11', '12', '13', '14', '18', '19'];
    if (!items || items.length < 1) {
      return false;
    }
    for (var i in items) {
      if (_.isUndefined(items[i].item_validity_status))
        return false;

      if (approvalableStatuses.indexOf(items[i].item_validity_status.toString()) === -1)
        return false;
    }
    return true;
  }

  /**
   * Function to check PR data for changes and approvability
   * @returns {boolean}
   */
  function checkPRDataApprovability(){
    var pr = prFunction.getPRData();
    if(!!pr.pr_related_data_changes)
      return false;

    return true;
  }

  function canGeneratePO() {
    return (
      ($scope.PR.status.toLowerCase() === 'approved') &&
      (!$scope.PR.pos || (!!$scope.PR.pos && !$scope.PR.pos.length)) &&
      (
        isPRCreator() ||
        $scope.PR.requestor._id === $scope.currentUser._id ||
        (globalFunc.findInArray($scope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN') ||
        globalFunc.findInArray($scope.currentUser.roles, 'name', 'ADMIN'))
      )
    );
  }

  function canApprove() {
    var checkPRStatus = ($scope.PR.status.toLowerCase() === 'pending');
    var isApprover    = globalFunc.findInArray($scope.localApprovalData.waiting_on, '_id', $rootScope.currentUser._id);
    var PRApprovable  = checkItemsApprovability();
    var PRDataChanged = checkPRDataApprovability();

    return (checkPRStatus && !!isApprover && PRDataChanged && PRApprovable && checkUserAccessToCompany());
  }

  function canUnHold() {
    var approverAbleToHoldPR = true;
    var checkPRStatus = ($scope.PR.status.toLowerCase() === 'on_hold');
    var isApprover = globalFunc.findInArray($scope.localApprovalData.waiting_on, '_id', $scope.currentUser._id);
    var selectedCompany = globalFunc.findInArray($scope.currentUser.companies, '_id', $scope.PR.company._id);

    if (!!selectedCompany && !!selectedCompany.config && !!selectedCompany.config.allowedToHoldPR) {
      approverAbleToHoldPR = selectedCompany.config.allowedToHoldPR;
    }

    return (checkPRStatus && ((approverAbleToHoldPR && !!isApprover && checkUserAccessToCompany()) ||
    !!globalFunc.findInArray($scope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN')));
  }

  function canHold() {
    var approverAbleToHoldPR = true;
    var checkPRStatus = ($scope.PR.status.toLowerCase() === 'pending');
    var isApprover = globalFunc.findInArray($scope.localApprovalData.waiting_on, '_id', $scope.currentUser._id);
    var selectedCompany = globalFunc.findInArray($scope.currentUser.companies, '_id', $scope.PR.company._id);
    if (!!selectedCompany && !!selectedCompany.config && !!selectedCompany.config.allowedToHoldPR) {
      approverAbleToHoldPR = selectedCompany.config.allowedToHoldPR;
    }

    return (checkPRStatus && ((approverAbleToHoldPR && !!isApprover && checkUserAccessToCompany()) ||
    !!globalFunc.findInArray($scope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN')));
  }

  function canReject() {
    var checkPRStatus = ($scope.PR.status.toLowerCase() === 'pending');
    var isApprover    = globalFunc.findInArray($scope.localApprovalData.waiting_on, '_id', $scope.currentUser._id);

    return (checkPRStatus && !!isApprover && checkUserAccessToCompany());
  }

  function canWithdraw() {
    var checkPRStatus = ($scope.PR.status.toLowerCase() === 'pending');
    return (checkPRStatus && ($scope.PR.creator._id === $scope.currentUser._id || (!!$scope.PR.requestor && ($scope.PR.requestor._id === $scope.currentUser._id))));
  }

  function canSubmit() {
    var pr = getUpdatedPRData();
    return (isPRCreator() && (!!pr.pr_items && !!pr.pr_items.length) && pr.status.toLowerCase() === 'draft');
  }

  /**
   * check permission and pr status to delete
   * @returns {*|boolean}
   */
  function canDelete() {
    var pr = getUpdatedPRData();
    return (isPRCreator() && pr.status.toLowerCase() === 'draft');
  }

  function getUpdatedPRData() {
    return prFunction.getPRData();
  }

  function checkWaitingOn() {
    return true;
  }

  function printPRViaPDF() {

    /**
     * Validate the pr items before proceeding
     */
    if (!$scope.PR.pr_items || $scope.PR.pr_items.length < 1) {
      toastr.error('Print PR failed because the PR has no items.');
    }
    else {

      /**
       * Pass current logged in user's timezone
       */
      getPRPDFHash.get(
        {
          id: $scope.PR._id,
          timezone: $scope.currentUser.config.TZ
        }, function (resource) {
          var newUrl = $filter('format')(pathConstants.apiUrls.globalPDFHashDownload, {
            pdf_hash: resource.url
          });

          setTimeout(function () {
            window.open(newUrl, '_blank')
          }, 1001);
        }, function () {
          toastr.error('Failed to print PR');
        }
      );
    }
  }

  /**
   * Function for deleting PR
   */
  function deletePR(){
    swal(
      {
        title: 'Confirm delete PR',
        text: 'This PR will be deleted',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Delete',
        closeOnConfirm: true
      },
      function (isConfirm) {
        if (isConfirm) {
          if (!!$scope.PR) {
            purchaseRequisitionsServices.deleteSinglePR({
              id: $scope.PR._id
            }, function () {
              toastr.success('PR deleted');
              $state.go('main.user.purchaseRequisitions.manage', {status: 'draft', tab: 'all'});
            }, function (error) {
              globalFunc.objectErrorMessage(error);
            })
          }
        }
      }
    );
  }

  /**
   * Function for generating PO manually in cases where PO failed to generate
   * @param PRId
   */
  function generatePurchaseOrder(PRId){
    generatePO.post({
      id: PRId
    }, function (resource) {
      if (!!resource && !!resource.content && !!resource.content.message) {
        toastr.success(resource.content.message);
        $state.reload();
      }
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    })
  }

  /**
   * allow the editing button to appear
   * @returns {*}
   */
  function allowEditingPR() {
    if (prFunction.getPRData().status === 'pending')
      return prFunction.checkCurrentApproverIsPA(!!prFunction.getPRData() ? prFunction.getPRData().waiting_on : null, !!$rootScope.currentUser ? $rootScope.currentUser._id : null,
        !!$rootScope.currentUser ? $rootScope.currentUser.roles : null);
    else
      return false
  }

  function setEditableMode(mode){
    prFunction.setEditableState(mode);
  }

  function prAction(title, action) {
    swal(
      {
        title: title,
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (is_confirm) {
        if (is_confirm) {
          if (action === 1)
            approvalAction('approve', 'You have approved this purchase requisition');
          if (action === 3)
            approvalAction('release', 'You have removed the hold from this purchase requisition', {});
        }
      }
    );
  }

  /**
   * function returns the approval resource so it can be used on other module
   *
   * @param status
   * @param text
   * @param extraPayload in some cases the action needs a comment or such extra payload passed to the backend
   * @returns {*|{method, params, url}}
   */
  function approvalAction(status, text, extraPayload) {

    return purchaseRequisitionsServices.approvalAction(
      {
        approval_id: $scope.PR.approval_id,
        status: status
      },
      extraPayload,
      function () {
        if (!!text)
          toastr.success(text);
        else
          toastr.success('You have submitted this purchase requisition.');
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * the condition to pass to the directive to check if the action is ready to fire
   * @returns {boolean}
   */
  function actionCondition(){
    // check if PA and missing Tax
    // if (checkPurchaseAgentRole() && checkIfMissingTax()) {
    //   toastr.error('Item(s) are missing a Tax. Please complete them before approving');
    //   return false;
    // }
    return true;
  }

  /**
   * Submit PR
   * @param ignoreOverBudget (0-do not ignore over budget; 1-do ignore over budget)
   */
  function submitPurchaseRequisition(ignoreOverBudget) {
    submitValidation();

    return purchaseRequisitionsServices.submitPR({
      id: $scope.PR._id,
      data: {
        ignore_over_budget: ignoreOverBudget
      }
    }, function () {
      transitionToListingPending();
    }, function (error) {
      var message = (!!error.data && !!error.data.content && !!error.data.content.message) ?
        error.data.content.message : null;
      switch (message) {
        // case where over budget detected, but is allowed
        case 'Overbudget is allowed.':
          userToConfirmOverbudget();
          break;
        // case where over budget detected, but is not allowed further action
        case 'Overbudget is not allowed.':
          alertUserOnOverBudgetNotAllowed();
          break;
      }
    });
  }

  /**
   * pop up to ask user if the over budget pr submit is confirmed
   */
  function userToConfirmOverbudget() {
    swal(
      {
        title: 'Confirm submission?',
        text: 'This requisition exceeds the available budget amount, confirm the submission?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        closeOnConfirm: true
      },
      function (isConfirm) {
        if (isConfirm) {
          submitPurchaseRequisition(true);
        }
      }
    );
  }

  /**
   * pop to notify the user over-budget is not allowed
   */
  function alertUserOnOverBudgetNotAllowed() {
    swal(
      {
        title: 'Available budget exceeded.',
        text: 'This requisition exceeds the available budget amount.',
        type: 'info',
        confirmButtonColor: '#D0D0D0',
        confirmButtonText: 'Close',
        closeOnConfirm: true
      }
    );
  }

  function submitValidation() {
    var pr = getUpdatedPRData();
    var errors = [];
    if (!!pr) {
      // validate expense type
      if (!pr.expense_type || (!!pr.expense_type && !pr.expense_type.code)) {
        errors.push('expense_type');
        toastr.error('Expense type is required.');
      }

      if (!pr.contact_person) {
        errors.push('contact_person');
        toastr.error('Contact person is required.');
      }

      if (_.isEmpty(pr.budget))
        errors.push('budget');

      if (_.isEmpty(pr.title)) {
        errors.push('title');
        toastr.error('PR Title is required.');
      }
    }

    prFunction.setErrorsOnSubmit(errors);
    return !!(errors.length);
  }

  function transitionToListingPending(){
    $state.go('main.user.purchaseRequisitions.manage', {status: 'pending', tab: 'all'});
    HighlightId.setId($scope.PR._id);
  }

  function requestEditableDraft(){
    purchaseRequisitionsServices.requestEditableCopy({
      id: prFunction.getPRData()._id
    },{}, function (resource) {
      if(!!resource.content && !!resource.content.data) {
        prFunction.setPRData(resource.content.data);
        setEditableMode('editable');
        // Refresh attachment stuff
        $scope.$emit('loadAtt');
        $rootScope.$broadcast('thisBetterWork');

      }
      else
        globalFunc.objectErrorMessage('Something went wrong')
    }, function (e) {
      globalFunc.objectErrorMessage(e);
    });
  }

  function submitEditableDraft(){
    swal(
      {
        title: 'Confirm submit edited PR?',
        text: 'The approval flow will be restarted',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        closeOnConfirm: true
      },
      function (isConfirm) {
        if (isConfirm) {
          purchaseRequisitionsServices.submitEditableCopy({
            id: prFunction.getPRData()._id
          }, {}, function (resource) {
            if (!!resource.content && !!resource.content.data) {
              prFunction.setPRData(resource.content.data);
              setEditableMode('notEditable');
              $state.reload();
            }
            else
              globalFunc.objectErrorMessage('Something went wrong')
          }, function (e) {
            globalFunc.objectErrorMessage(e);
          });
        }
      }
    );
  }

  function cancelEditingPR() {
    purchaseRequisitionsServices.cancelEditableCopy({
      id: prFunction.getPRData()._id
    }, {}, function (resource) {
      if(!!resource.content && !!resource.content.data) {
        prFunction.setPRData(resource.content.data);
        setEditableMode('notEditable');
        $state.reload();
      }
      else
        globalFunc.objectErrorMessage('Something went wrong')
    }, function (e) {
      globalFunc.objectErrorMessage(e);
    });
  }

  /**
   * Check user access to the company
   * @returns {boolean}
   */
  function checkUserAccessToCompany() {
    return !!globalFunc.findInArray(
      $scope.currentUser.companies,
      'code',
      prFunction.getPRData().company.code
    );
  }

  function initialize() {
    loadNextData();
  }

  initialize();

  $scope.$watch('editingState', function (newValue) {
    // Editing mode on the actions only need to change the title
    // and show hide the button
    $scope.editingState = newValue;
  });
}

purchaseRequisitionsActionCtrl.$inject = [
  '$scope', 'pathConstants', 'purchaseRequisitionsServices', '$state', 'HighlightId', 'prFunction', '$rootScope',
  'globalFunc', 'toastr', '$stateParams', 'getPRPDFHash', '$filter', 'UserPermissions', 'generatePO', 'notificationSubscriber'
];

angular
  .module('metabuyer')
  .directive('purchaseRequisitionActions',function() {
    return {
      restrict: 'E',
      scope: {
        editingState: '=',
        PR: '=pr',
        actionType: '@'
      },
      template: '<div ng-include="templateUrlPath"></div>',
      controller: 'purchaseRequisitionsActionCtrl'
    }
  })
  .controller('purchaseRequisitionsActionCtrl', purchaseRequisitionsActionCtrl);

'use strict';

/**
 * @name exchangeRateDetailsCtrl
 * @desc Controller for master data exchange rate details controller
 */
function exchangeRateDetailsCtrl($scope, $uibModalInstance, exchangeRateDetails,
                                 exchangeRateSpecificRate, toastr, globalFunc, currencyExchange) {
  $scope.exchangeRateDetails = exchangeRateDetails.data;
  $scope.currencyExchange = currencyExchange;
  $scope.editClicked = false;
  $scope.tab = 1;

  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.exchangeRateDetails._id,
      'object[0][object_type]': 'Metabuyer\\Models\\ExchangeRate',
      offset: 5,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.toggleTab          = toggleTab;
  $scope.cancel             = cancel;
  $scope.editExchangeRate   = editExchangeRate;
  $scope.updateExchangeRate = updateExchangeRate;
  $scope.openDatepicker     = openDatepicker;

  function openDatepicker($event, which) {
    // Setting minimum selection for start date to be today
    $scope.startDateOptions.minDate = new Date();

    // Setting the minimum selection for end date to be one day ahead of selected start date
    var startDateClone = _.cloneDeep($scope.exchangeRateDetails.effective_at);
    var startDate = new Date(startDateClone);
    startDate.setDate(startDate.getDate() + 1);
    $scope.endDateOptions.minDate = startDate;

    $event.preventDefault();
    $event.stopPropagation();

    $scope.datepickerOpened[which] = true;
  }

  function cancel() {
    $uibModalInstance.close();
  }

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function editExchangeRate() {
    $scope.editClicked = true;
  }

  function validate(exchangeRate) {
    if (!exchangeRate) {
      return false;
    }
    if (!exchangeRate.code) {
      return false;
    }
    if (!exchangeRate.descr) {
      return false;
    }
    if (!exchangeRate.rate || Number(exchangeRate.rate) === 0) {
      return false;
    }
    if (!exchangeRate.effective_at) {
      return false;
    }
    if (!exchangeRate.expiry_at) {
      return false;
    }
    if (exchangeRate.effective_at >= exchangeRate.expiry_at) {
      return false;
    }
    if (!exchangeRate.exchangeStatus) {
      return false;
    }
    return true;
  }

  function validateEditedRate(rate) {
    return Number(rate) === 0;
  }

  function updateExchangeRate() {
    $scope.submitted = true;
    if (validate($scope.exchangeRateDetails)) {
      swal({
          title: 'Confirm Updating the Exchange Rate',
          text: 'This will update the details for this exchange rate',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {

            // set status in integer to pass it as parameter
            var tempStatus;
            switch ($scope.exchangeRateDetails.exchangeStatus.isActive.toLowerCase()) {
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
              case 'disabled':
                tempStatus = 3;
                break;
            }

            //Formatting the dates before update
            $scope.exchangeRateDetails.effective_at = globalFunc.convertDateToTimestamp($scope.exchangeRateDetails.effective_at);
            $scope.exchangeRateDetails.expiry_at = globalFunc.convertDateToTimestamp($scope.exchangeRateDetails.expiry_at);

            exchangeRateSpecificRate.put(
              {
                id: ($scope.exchangeRateDetails.company_id === '') ? 'global' : $scope.exchangeRateDetails.company_id,
                rate_id: $scope.exchangeRateDetails._id
              },
              {
                code: $scope.exchangeRateDetails.code,
                descr: $scope.exchangeRateDetails.descr,
                multiplier_rate: $scope.exchangeRateDetails.rate,
                source_currency_id: $scope.exchangeRateDetails.source_currency_id,
                target_currency_id: $scope.exchangeRateDetails.target_currency_id,
                effective_at: $scope.exchangeRateDetails.effective_at,
                expiry_at: $scope.exchangeRateDetails.expiry_at,
                is_active: tempStatus
              },
              function (resource) {
                toastr.success('Exchange rate has been updated');
                $uibModalInstance.close(resource.content.data);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                return false;
              }
            );
          } else {
            return false;
          }
        }
      );
    }
    else {
      toastr.error('Please fill up all the required fields first');
    }
  }

  function initialize() {
    // Create new variable to replace exchangeRateDetails.status
    // with object to load and selected the right status
    // on the dropdown list
    if (!!$scope.exchangeRateDetails.is_active) {
      $scope.exchangeRateDetails.exchangeStatus = {isActive: globalFunc.capitalizeFirstCharacter($scope.exchangeRateDetails.is_active)};
    }
    // Statuses for dropdown in object
    $scope.exchangeRateStatuses = [
      {isActive: 'Active'},
      {isActive: 'Deactivated'}
    ];

    $scope.startDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.datepickerOpened = {
      start_date: false,
      end_date: false
    };

    $scope.validateEditedRate = validateEditedRate;
  }

  initialize();
}

exchangeRateDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'exchangeRateDetails', 'exchangeRateSpecificRate', 'toastr', 'globalFunc', 'currencyExchange'
];

angular
  .module('metabuyer')
  .controller('exchangeRateDetailsCtrl', exchangeRateDetailsCtrl);

'use strict';

/**
 * @name compareBudgetVersionCtrl
 * @desc The controller for comparing budget versions data
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function compareBudgetVersionCtrl($scope, $uibModal, $uibModalInstance, currentStatus,
                                  versions, selectedVersion) {

  $scope.close = close;

  /**
   * On modal close
   */
  function close() {
    $uibModalInstance.close();

    // Open budget version modal if currently viewing approved budget
    $uibModal.open({
      templateUrl: 'components/budget/versions/budgetVersions.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        budgetVersions: function () {
          return versions;
        },
        currentStatus: function () {
          return currentStatus;
        }
      },
      controller: 'budgetVersionsCtrl'
    });
  }

  /**
   * Create set of arrays based on given number, for looping purpose
   *
   * @param {number} number Number of arrays
   */
  function createRange(number) {
    var items = [];
    for (var i = 0; i < number; i++) {
      items.push(i);
    }
    return items;
  }

  /**
   * Create looping number for budget assignment
   */
  function createBudgetAssignmentRange() {
    if (!!selectedVersion[0].assignments && !!selectedVersion[1].assignments) {
      $scope.assignmentSize = selectedVersion[0].assignments.length > selectedVersion[1].assignments.length ?
        selectedVersion[0].assignments.length : selectedVersion[1].assignments.length;
    } else if (!!selectedVersion[0].assignments) {
      $scope.assignmentSize = selectedVersion[0].assignments.length;
    } else if (!!selectedVersion[1].assignments) {
      $scope.assignmentSize = selectedVersion[1].assignments.length;
    }

    $scope.assignmentSize = createRange($scope.assignmentSize);
  }

  /**
   * Create looping number for budget item breakdowns
   */
  function createItemBreakdownsRange() {
    if (!!selectedVersion[0].item_breakdowns && !!selectedVersion[1].item_breakdowns) {
      $scope.itemBreakdownsSize = selectedVersion[0].item_breakdowns.length > selectedVersion[1].item_breakdowns.length ?
        selectedVersion[0].item_breakdowns.length : selectedVersion[1].item_breakdowns.length;
    } else if (!!selectedVersion[0].item_breakdowns) {
      $scope.itemBreakdownsSize = selectedVersion[0].item_breakdowns.length;
    } else if (!!selectedVersion[1].item_breakdowns) {
      $scope.itemBreakdownsSize = selectedVersion[1].item_breakdowns.length;
    }

    $scope.itemBreakdownsSize = createRange($scope.itemBreakdownsSize);
  }

  /**
   * Create looping number for budget assignment item breakdowns
   */
  function createAssignmentItemBreakdownsRange() {

    $scope.assignmentItemSize = [];
    var sourceAsssignmentSize = !!selectedVersion[0].assignments ? selectedVersion[0].assignments.length : 0;
    var targetAsssignmentSize = !!selectedVersion[1].assignments ? selectedVersion[1].assignments.length : 0;
    var assignmentSize = 0;

    // Get the assignment size
    if (sourceAsssignmentSize > 0 && targetAsssignmentSize > 0) {
      assignmentSize = sourceAsssignmentSize > targetAsssignmentSize ? sourceAsssignmentSize : targetAsssignmentSize;
    } else if (sourceAsssignmentSize > 0) {
      assignmentSize = sourceAsssignmentSize;
    } else if (targetAsssignmentSize > 0) {
      assignmentSize = targetAsssignmentSize;
    }

    // Get the item breakdowns size for each assignment
    for (var i = 0; i < assignmentSize; i++) {
      $scope.assignmentItemSize[i] = 0;
      if (!!selectedVersion[0].assignments[i] && !!selectedVersion[0].assignments[i].item_breakdowns &&
        !!selectedVersion[1].assignments[i] && !!selectedVersion[1].assignments[i].item_breakdowns) {
        $scope.assignmentItemSize[i] = selectedVersion[0].assignments[i].item_breakdowns.length >
        selectedVersion[1].assignments[i].item_breakdowns.length ?
          selectedVersion[0].assignments[i].item_breakdowns.length :
          selectedVersion[1].assignments[i].item_breakdowns.length;
      } else if (!!selectedVersion[0].assignments[i] && !!selectedVersion[0].assignments[i].item_breakdowns) {
        $scope.assignmentItemSize[i] = selectedVersion[0].assignments[i].item_breakdowns.length;
      } else if (!!selectedVersion[1].assignments[i] && !!selectedVersion[1].assignments[i].item_breakdowns) {
        $scope.assignmentItemSize[i] = selectedVersion[1].assignments[i].item_breakdowns.length;
      }

      $scope.assignmentItemSize[i] = createRange($scope.assignmentItemSize[i]);
    }
  }

  /**
   * Implode the cost center values of budget master
   *
   * @param {array} data Budget data to be processed
   */
  function restructureCostCenterData(data) {
    if (!!data.cost_center && _.isArray(data.cost_center)) {
      data.cost_center = _.pluck(data.cost_center, 'descr').join(', ');
    }
  }

  function initialize() {
    $scope.selectedVersion = selectedVersion;
    $scope.assignmentSize = 0;
    createBudgetAssignmentRange();
    createItemBreakdownsRange();
    createAssignmentItemBreakdownsRange();
    restructureCostCenterData($scope.selectedVersion[0]);
    restructureCostCenterData($scope.selectedVersion[1]);
  }

  initialize();
}

compareBudgetVersionCtrl.$inject = [
  '$scope', '$uibModal', '$uibModalInstance', 'currentStatus', 'versions', 'selectedVersion'
];

angular.module('metabuyer')
  .controller('compareBudgetVersionCtrl', compareBudgetVersionCtrl);

'use strict';

/**
 * @name budgetVersionsCtrl
 * @desc The controller for budget versions
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function budgetVersionsCtrl($scope, $uibModalInstance, $uibModal, budgetVersions, currentStatus) {
  $scope.versions = budgetVersions;
  $scope.checkedVersion = {};
  $scope.currentStatus = currentStatus;

  $scope.close = close;
  $scope.selectVersion = selectVersion;
  $scope.compareVersions = compareVersions;
  $scope.getCheckedVersionLength = getCheckedVersionLength;

  /**
   * Function to select version for comparison,
   * first version selected will be compared to second version selected
   *
   * @param {object} budget   Budget version object selected
   * @param {boolean} checked Boolean check for selected version
   * @param {int} index index of the selected version
   */
  function selectVersion(budget, checked, index) {
    if (!!checked)
      $scope.checkedVersion[index] = budget;
    else {
      if (!!$scope.checkedVersion[index]) {
        delete $scope.checkedVersion[index];
      }
    }
  }

  /**
   * Check number of selected version to compare
   *
   * @returns {Number}
   */
  function getCheckedVersionLength() {
    return Object.keys($scope.checkedVersion).length;
  }

  /**
   * Function to open comparison modal, passes versions, checkedVersions and currentStatus of budget
   */
  function compareVersions() {
    // convert from object to array
    $scope.checkedVersion = _.values($scope.checkedVersion);
    // reverse the order of array
    $scope.checkedVersion.reverse();
    close();
    $uibModal.open({
      templateUrl: 'components/budget/versions/compareBudgetVersion.html',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'revision-wrapper',
      size: 'lg',
      resolve: {
        versions: function() {
          return $scope.versions
        },
        selectedVersion: function() {
          return $scope.checkedVersion;
        },
        currentStatus: function() {
          return $scope.currentStatus;
        }
      },
      controller: 'compareBudgetVersionCtrl'
    });
  }

  function close() {
    $uibModalInstance.close();
  }
}

budgetVersionsCtrl.$inject = ['$scope', '$uibModalInstance', '$uibModal', 'budgetVersions', 'currentStatus'];

angular.module('metabuyer')
  .controller('budgetVersionsCtrl', budgetVersionsCtrl);

'use strict';

/**
 * @name itemListing Directive
 * @desc item listing that is used in the budget
 *
 * @isolatedScope data
 * To synchronize items data
 *
 * @isolatedScope budget
 * To accept budget id that using this directive
 *
 * @isolatedScope assignment
 * To accept budget assignment id that using this directive, optional
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('itemListing', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/budget/itemListing/itemListing.html',
      scope: {
        budget: '=',
        assignment: '='
      },
      controller: function($scope, globalFunc, toastr, budgets) {
        $scope.budgets = budgets;
        $scope.itemData = [];
        $scope.selectedTab = 'used';
        $scope.itemMeta = {};

        $scope.selectTab = selectTab;
        $scope.getItemListing = getItemListing;

        // called when switching type of items
        function selectTab(tab) {
          $scope.selectedTab = tab;
          getItemListing();
        }

        // retrieve items data by type
        function getItemListing() {
          $scope.embeddedParams = {
            id: $scope.budget,
            assignment_id: $scope.assignment,
            item_type: $scope.selectedTab,
            action: 'get-items',
            offset: 10,
            page: null,
            cursor: null
          };

          budgets.get(
            $scope.embeddedParams,
            function (resource) {
              if (!!resource.content && !!resource.content.data) {
                $scope.itemData = resource.content.data;
                $scope.itemMeta = resource.content.meta;
              }
            },
            function (error) {
              if (!!error.data.content && !!error.data.content.message) {
                toastr.error(error.data.content.message.join('</br>'));
              } else {
                globalFunc.objectErrorMessage(error);
              }
            }
          );
        }

        function initialize() {
          getItemListing();
        }

        initialize();
      }
    };
  });

'use strict';

/**
 * @name itemBreakdowns Directive
 * @desc Directive for item breakdowns in budget
 *
 * @isolatedScope budgetData
 * To synchronize items data
 *
 * @isolatedScope budgetMaster
 * Budget master data
 *
 * @isolatedScope budgetItemDetailsError
 * Flag to indicate item details contains any error upon submit
 *
 * @isolatedScope editingMode
 * Whether the budget is in editing mode
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('itemBreakdowns', function () {
    return {
      restrict: 'E',
      template: '<div ng-include="templateUrl"></div>',
      scope: {
        budgetData: '=',
        budgetMaster: '=',
        budgetItemDetailsError: '=',
        editingMode: '=',
        apportionList: '='
      },
      controller: function ($scope, searchModule, listChild, pathConstants, $http, globalFunc, budgetFunctions) {
        $scope.templateUrl = $scope.editingMode === 'editable' ?
          'components/budget/itemBreakdowns/itemBreakdowns.editableTemplate.html' :
          'components/budget/itemBreakdowns/itemBreakdowns.nonEditableTemplate.html';

        $scope.closeTreeSearch = false;
        $scope.commodityLevel = [1, 2, 3, 4];
        $scope.uomSearching = false;

        $scope.addItemBreakdown = addItemBreakdown;
        $scope.deleteItemBreakdown = deleteItemBreakdown;
        $scope.searchCommodityCode = searchCommodityCode;
        $scope.openChildCommodityCode = openChildCommodityCode;
        $scope.validationUOMSelection = validationUOMSelection;
        $scope.isQuantityValid = isQuantityValid;
        $scope.searchUOM = searchUOM;
        $scope.onUOMSelect = onUOMSelect;
        $scope.checkApportionAllocation = checkApportionAllocation;
        $scope.isItemAmountGreaterThanInherited = isItemAmountGreaterThanInherited;
        $scope.canEditOrDeleteItemBreakdown = canEditOrDeleteItemBreakdown;

        /**
         * Function to check if set amount is lower than used + committed amount
         * @returns {boolean}
         */
        function validateAmount(item) {
          if ((!!item.committed_amount || !!item.used_amount) && !!item.allocated_amount) {
            var committedAmount = !!item.committed_amount ? item.committed_amount : 0;
            var usedAmount = !!item.used_amount ? item.used_amount : 0;
            if (item.allocated_amount < (committedAmount + usedAmount)) {
              return true;
            }
          }
          return false
        }

        /**
         * Function to check if item breakdown can be edited
         * @returns {boolean}
         */
        function canEditOrDeleteItemBreakdown(item) {
          if (!item.committed_amount && !item.used_amount) {
            return false;
          }

          return true;
        }
        /**
         * This function is called when user try to add new item
         */
        function addItemBreakdown() {
          $scope.budgetData.item_breakdowns.push(
            {
              descr: null,
              commodity_code: null,
              apportion_type: !!$scope.budgetData.apportion_type ? $scope.budgetData.apportion_type : 'N/A',
              apportion_allocation: [],
              apportion_carry_forward: false,
              allocated_amount: null,
              quantity: null,
              used_amount: null,
              committed_amount: null,
              used_quantity: null,
              committed_quantity: null,
              UOM: null,
              UOMIsFraction: null,
              UOMText: '',
              justification: ''
            }
          );

          // Removing the parent level apportion data
          $scope.budgetData = budgetFunctions.removeParentApportionData($scope.budgetData);
        }

        /**
         * This function is called when user delete an item
         *
         * @param {number} item - index
         */
        function deleteItemBreakdown(item) {
          $scope.budgetData.item_breakdowns.splice(item, 1);
          $scope.commodityCodes[item] = [];
        }

        /**
         * Searching commodity code
         *
         * @param {string} keyword
         * @param {string} index
         * @returns {string}
         */
        function searchCommodityCode(keyword, index) {
          if (!!keyword && keyword.length > 1) {
            searchModule.get(
              {
                module: 'commodity',
                'criteria[0][code]': keyword,
                'criteria[0][descr]': keyword,
                'criteria[0][$operator]': 'or',
                'criteria[1][is_active]': 1,
                order: 1,
                order_by: 'code',
                offset: 0
              }, function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  $scope.commodityCodes[index] = resource.content.data;

                _.forEach($scope.commodityCodes[index], function (item) {
                  item.index = index;
                });
              }, function () {
                $scope.commodityCodes[index] = [];
              });

            return $scope.commodityCodes[index];
          }
        }

        /**
         * Searching child of the provided commodity code
         *
         * @param {string} cc - cost center
         * @param {number} index
         */
        function openChildCommodityCode(cc, index) {
          listChild.get({
              code: cc
            },
            function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0) {
                $scope.commodityCodes[index] = resource.content.data;
                _.forEach($scope.commodityCodes[index], function (item) {
                  item.index = index;
                });
              }
              else {
                toastr.error('There are no child on this commodity code');
              }
            },
            function () {
              toastr.error('Failed to get commodity codes data');
            });
        }

        /**
         * Processing item breakdowns data in the beginning
         *
         * @param {array} data
         */
        function processData(data) {
          $scope.commodityCodes = [];
          var index = 0;
          _.forEach(data, function (item) {
            $scope.commodityCodes[index] = null;
            item.validUOMIsSelected = item.UOMText === '' ? false : true;

            //To initialize commodity code and populate drop downs accordingly
            if (!!item.commodity_code && !!item.commodity_code.code) {
              item.primaryCommodityKeyword = item.commodity_code.code + ' ' + item.commodity_code.descr;
            }
            index++;
          });
        }

        /**
         * Validate the Selection for the Type-a-head
         *
         * @param {array}  budget
         * @param {number} index
         */
        function validationUOMSelection(budget, index) {
          if (!budget.validUOMIsSelected || (!!budget.UOMText && budget.UOMText.length < 2)) {
            $scope.budgetData.item_breakdowns[index].UOM = null;
            $scope.budgetData.item_breakdowns[index].UOMText = '';
            $scope.budgetData.item_breakdowns[index].UOMIsFraction = null;
          }
        }

        /**
         * Check if quantity is valid
         *
         * @param {number} quantity
         * @param {number} index
         */
        function isQuantityValid(quantity, index) {
          var isDecimal = (quantity % 1 !== 0);
          return !($scope.budgetData.item_breakdowns[index].UOMIsFraction === 0 && isDecimal);
        }

        /**
         * Searching for UOM
         *
         * @param {string} val
         */
        function searchUOM(val) {
          if (!!val && val.length > 1) {
            $scope.uomSearching = true;

            return $http.get(pathConstants.apiUrls.uom.list, {
              params: {
                query: val
              },
              ignoreLoadingBar: true
            }).then(function (response) {
              $scope.uomSearching = false;
              return response.data.content.data.map(function (item) {
                return item;
              });
            }).catch(function (error) {
              $scope.uomSearching = false;
              globalFunc.objectErrorMessage(error);
            })
          }
        }

        /**
         * This function is called when UOM is selected
         *
         * @param {array}  UOM
         * @param {number} index
         */
        function onUOMSelect(UOM, index) {
          $scope.budgetData.item_breakdowns[index].validUOMIsSelected = true;
          $scope.budgetData.item_breakdowns[index].UOM = UOM.code;
          $scope.budgetData.item_breakdowns[index].UOMIsFraction = UOM.is_fraction;
        }

        /**
         * To check if apportion allocation values will change due to field changes
         *
         * @param {*}      oldValue   old value of the field
         * @param {*}      newValue   new value of the field
         * @param {string} fieldModel Name of the model to be modified
         * @param {number} index
         */
        function checkApportionAllocation(oldValue, newValue, fieldModel, index) {
          budgetFunctions.checkApportionAllocation(
            oldValue,
            newValue,
            $scope.budgetData.item_breakdowns[index].apportion_allocation).then(function (resource) {
            $scope.budgetData.item_breakdowns[index].apportionRelatedValues = resource;
            $scope.budgetData.item_breakdowns[index][fieldModel] = resource;
            $scope.originalItemBreakdownData[index][fieldModel] = resource;
          });
        }

        /**
         * To check if item breakdown total amounts greater than assignment/budget amount
         */
        function isItemAmountGreaterThanInherited() {
          var totalItemAmount = 0;
          _.forEach($scope.budgetData.item_breakdowns, function (item) {
            if (!!item.allocated_amount) {
              totalItemAmount = budgetFunctions.add(item.allocated_amount, totalItemAmount);
            }
          });

          var availableAmount = budgetFunctions.subtract($scope.budgetData.amount, $scope.budgetData.block_amount);
          if (availableAmount < totalItemAmount) {
            return true;
          }

          return false;
        }

        function initialize() {
          $scope.originalItemBreakdownData = {};
          _.forEach($scope.budgetData.item_breakdowns, function(itemBreakdowns, key){
            $scope.originalItemBreakdownData[key] = _.cloneDeep(itemBreakdowns);
          });

          processData($scope.budgetData.item_breakdowns);

          $scope.$watch('budgetData.apportion_type', function (newValue) {
            if (!!newValue) {
              _.forEach($scope.budgetData.item_breakdowns, function (item, index) {
                if (newValue !== 'N/A') {
                  $scope.budgetData.item_breakdowns[index].apportion_type = newValue;
                }
              });
            }
          });
        }

        initialize();

      }
    };
  });

'use strict';

/**
 * @name budgetDetailsHeader Directive
 * @desc Directive for displaying budget details header, editable and non editable
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('budgetDetailsHeader', function () {
    return {
      restrict: 'E',
      scope: true,
      template: '<div ng-include="budgetTemplateUrl"></div>',
      controller: function ($scope) {
        $scope.getTemplateUrl = getTemplateUrl;
        $scope.showBudgetItems = showBudgetItems;
        $scope.hasParentBudget = hasParentBudget;
        $scope.changeAssignmentDashboardSetting = changeAssignmentDashboardSetting;
        $scope.showItemListing = showItemListing;

        function changeAssignmentDashboardSetting(dashboard) {
          _.forEach($scope.budget.assignments, function (assignment) {
            assignment.pr_dashboard_display = dashboard;
          });
        }

        function showBudgetItems() {
          $scope.showBudgetItemListing = !$scope.showBudgetItemListing;
        }

        /**
         * Check if budget is a revision
         */
        function hasParentBudget() {
          return !!$scope.budget.parent_id;
        }

        /**
         * Indicator to show item listing
         */
        function showItemListing() {
          // don't show if budget is revised budget or status is in pending/on-hold/draft/revision
          return !$scope.budget.parent_id &&
            ['pending', 'on_hold', 'draft', 'revision'].indexOf($scope.budget.status) === -1;
        }

        function getTemplateUrl(state) {
          switch (state) {
            case 'editable':
              $scope.budgetTemplateUrl = 'components/budget/detailsHeader/detailsHeader.editableTemplate.html';
              break;
            case 'notEditable' :
              $scope.budgetTemplateUrl = 'components/budget/detailsHeader/detailsHeader.nonEditableTemplate.html';
              break;
          }
        }

        // Watches the getEditingBudgetState to determine editable/non editable template
        $scope.$watch('getEditingBudgetState()', function (newValue) {
          getTemplateUrl(newValue);
        });
      }
    }
  });

'use strict';

/**
 * @name budget dashboard directive
 * @desc Directive to display budget dashboard
 *
 * @isolatedScope budget
 * Budget
 *
 * @isolatedScope showDashboard
 * To synchronize variable with the calling page, then to hide or to show this directive
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('budgetDashboard', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/budget/dashboard/budgetDashboard.html',
      scope: {
        prBudget: '=',
        prStatus: '=',
        prId: '=',
        showDashboard: '=',
        sourceCurrency: '<',
        sourceCompanyId: '<'
      },
      controller: function ($scope, budgets, ExchangeRate, budgetFunctions, globalFunc) {

        $scope.option = {
          animate: {enabled: false},
          readOnly: true,
          size: 150,
          unit: '%',
          skin: {
            type: 'tron',
            width: 5,
            color: '#1ab394',
            spaceWidth: 3
          },
          barColor: '#1ab394',
          trackWidth: 20,
          barWidth: 20,
          step: 0.01,
          textColor: ''
        };

        $scope.isSourceCurrencyDifferent = isSourceCurrencyDifferent;

        /**
         * Get budget information
         */
        function getBudget() {
          if (!!$scope.prBudget && !!$scope.prBudget._id) {
            budgets.get(
              {
                id: $scope.prBudget._id,
                type: 'budget_dashboard',
                prId: !!$scope.prId ? $scope.prId : '',
                assignmentId: !!$scope.prBudget.assignment_id ? $scope.prBudget.assignment_id: ''
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  $scope.budget = resource.content.data;
                  $scope.showDashboard = _.size($scope.budget) > 0;
                  $scope.totalBudget = resource.content.data.amount - resource.content.data.block_amount;
                  $scope.valueTotalBudget = 100;
                  $scope.currentApportion = null;

                  // If selected budget has apportion, replace the values
                  if (!!resource.content.data.current_apportion) {
                    $scope.currentApportion = resource.content.data.current_apportion;
                    $scope.totalAvailableBudget = resource.content.data.current_apportion.available_balance;
                    $scope.amount = resource.content.data.current_apportion.amount;
                    $scope.totalUsedBudget = resource.content.data.current_apportion.used_amount;
                    $scope.totalCommittedBudget = resource.content.data.current_apportion.committed_amount;
                  } else {
                    $scope.totalAvailableBudget = resource.content.data.available_balance;
                    $scope.amount = (resource.content.data.amount - resource.content.data.block_amount);
                    $scope.totalUsedBudget = resource.content.data.used_amount;
                    $scope.totalCommittedBudget = resource.content.data.committed_amount;
                  }

                  $scope.valueTotalAvailableBudget =
                    budgetFunctions.multiply(
                      budgetFunctions.divide(
                        $scope.totalAvailableBudget,
                        ($scope.amount)
                      ), 100
                    );
                  $scope.valueTotalUsedBudget =
                    budgetFunctions.multiply(
                      budgetFunctions.divide(
                        $scope.totalUsedBudget,
                        $scope.amount
                      ), 100);
                  $scope.valueTotalCommittedBudget =
                    budgetFunctions.multiply(
                      budgetFunctions.divide(
                        $scope.totalCommittedBudget,
                        $scope.amount
                      ), 100
                    );

                  getExchangeRate();
                }
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
          else {
            $scope.showDashboard = false;
          }
        }

        /**
         * Get the exchange rate of source to budget
         */
        function getExchangeRate() {
          if (!!$scope.budget && !!$scope.sourceCompanyId && !!$scope.sourceCurrency && !!$scope.sourceCurrency._id &&
            !!$scope.budget.currency && !!$scope.budget.currency._id) {

            ExchangeRate.get({
              id: $scope.sourceCompanyId,
              source_id: $scope.sourceCurrency._id,
              target_id: $scope.budget.currency._id
            }, function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data) {
                $scope.exchangeRate = resource.content.data;
              }
            }, function (error) {
              globalFunc.objectErrorMessage(error);
            })
          }
        }

        /**
         * Check if source currency is different from the budget currency
         */
        function isSourceCurrencyDifferent() {
          if (!!$scope.budget && !!$scope.sourceCurrency && !!$scope.sourceCurrency._id && !!$scope.budget.currency &&
            !!$scope.budget.currency._id) {
            return $scope.budget.currency._id !== $scope.sourceCurrency._id;
          }
          return false;
        }

        function initialize() {
          getBudget();

          $scope.$watch('sourceCurrency', function () {
            getExchangeRate();
          });

          $scope.$on('PRDataUpdated', function () {
            getBudget();
          });
        }

        initialize();
      }
    };
  });

'use strict';

/**
 * @name createBudgetButton Directive
 * @desc Directive for handling create budget button logic
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('createBudgetButton', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/budget/createBudgetButton/createBudgetButton.html',
      scope: {},
      controller: function ($scope, $rootScope, $state, UserPermissions, budgets, globalFunc) {
        $scope.disabled = false;
        $scope.title = 'Create Budget';
        $scope.listOfCompanies = UserPermissions.getBudgetCompanies($rootScope.currentUser, 'C');

        $scope.createBudget = createBudget;
        $scope.showCreateButton = showCreateButton;

        /**
         * navigate to creation page
         */
        function createBudget(company) {
          $scope.title = 'Loading ...';
          $scope.disabled = true;
          budgets.post(
            {
              company_code: company.code
            },
            function (resource) {
              enableCreateButton();
              if (!!resource.content && !!resource.content.data) {
                var data = resource.content.data;
                $state.go('main.user.budget.details', {id: data._id});
              }
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
              enableCreateButton();
            }
          );
        }

        /**
         * This function enable the create button
         */
        function enableCreateButton () {
          $scope.title = 'Create Budget';
          $scope.disabled = false;
        }

        /**
         * This function return a boolean to show or hiding the create budget button
         * @returns boolean
         */
        function showCreateButton() {
          return $state.current.name.indexOf('budget') > -1;
        }
      }
    };
  });

'use strict';

/**
 * @name budget assignments Directive
 * @desc Directive for assignments in budget
 *
 * @isolatedScope budgetData
 * Budget data
 *
 * @isolatedScope budgetAssignmentDetailsError
 * Flag to indicate assignment details contains any error upon submit
 *
 * @isolatedScope budgetItemDetailsError
 * Flag to indicate item details contains any error upon submit
 *
 * @isolatedScope editingMode
 * Whether the budget is in editing mode
 *
 * @isolatedScope costCenterList
 * List of cost centers to be selected
 *
 * @isolatedScope expenseTypeList
 * List of expense type to be selected
 *
 * @isolatedScope apportionList
 * List of apportion to be selected
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('budgetAssignments', function () {
    return {
      restrict: 'E',
      template: '<div ng-include="templateUrl"></div>',
      scope: {
        budgetData: '=',
        budgetAssignmentDetailsError: '=',
        budgetItemDetailsError: '=',
        editingMode: '=',
        costCenterList: '=',
        expenseTypeList: '=',
        apportionList: '='
      },
      controller: function ($scope, $rootScope, budgetFunctions) {
        $scope.templateUrl = $scope.editingMode === 'editable' ?
          'components/budget/assignments/budgetAssignments.editableTemplate.html' :
          'components/budget/assignments/budgetAssignments.nonEditableTemplate.html';
        $scope.startDateOptions = [];
        $scope.endDateOptions = [];
        $scope.allAssignmentsExpand = false;

        $scope.addBudgetAssignments = addBudgetAssignments;
        $scope.deleteBudgetAssignments = deleteBudgetAssignments;
        $scope.openAssignmentDatepicker = openAssignmentDatepicker;
        $scope.checkApportionAllocation = checkApportionAllocation;
        $scope.isAssignmentAmountGreaterThanMaster = isAssignmentAmountGreaterThanMaster;
        $scope.showAssignmentItems = function(assignment) {
          assignment.toggle = !assignment.toggle;
        };
        $scope.canDelete = canDelete;
        $scope.hasParentBudget = hasParentBudget;
        $scope.toggleAssignmentDisplay = toggleAssignmentDisplay;
        $scope.showItemListing = showItemListing;

        /**
         * Check if budget is a revision
         */
        function hasParentBudget() {
          return !!$scope.budgetData.parent_id;
        }

        /**
         * Add budget Assignment
         */
        function addBudgetAssignments() {
          $scope.budgetData.assignments.push(
            {
              cost_center: [],
              expense_type: !!$scope.budgetData.expense_type ? $scope.budgetData.expense_type : null,
              apportion_type: $scope.budgetData.apportion_type,
              item_breakdowns: [],
              pr_dashboard_display: $scope.budgetData.pr_dashboard_display,
              start_date: !!$scope.budgetData.start_date ? $scope.budgetData.start_date : null,
              end_date: !!$scope.budgetData.end_date ? $scope.budgetData.end_date : null,
              justification: !!$scope.budgetData.justification ? $scope.budgetData.justification : ''
            }
          );

          // Removing the parent level apportion data
          $scope.budgetData = budgetFunctions.removeParentApportionData($scope.budgetData);
        }

        /**
         * Delete Budget Assignment
         *
         * @param {number} index
         */
        function deleteBudgetAssignments(index) {
          $scope.budgetData.assignments.splice(index, 1);
        }

        /**
         * Datepicker for assignment dates selection
         *
         * @param {Object} $event
         * @param {string} which
         * @param {number} index
         */
        function openAssignmentDatepicker($event, which, index) {
          if (!!$scope.budgetData.assignments[index].end_date) {
            $scope.startDateOptions[index] = {
              formatYear: 'yy',
              startingDay: 1
            };
            $scope.startDateOptions[index].maxDate = $scope.budgetData.assignments[index].end_date;
          }

          if (!!$scope.budgetData.assignments[index].start_date) {
            $scope.endDateOptions[index] = {
              formatYear: 'yy',
              startingDay: 1
            };
            $scope.endDateOptions[index].minDate = $scope.budgetData.assignments[index].start_date;
          }

          if ($scope.budgetData.assignments[index].startDatepickerOpened ||
            $scope.budgetData.assignments[index].endDatepickerOpened) {
            $event.preventDefault();
            $event.stopPropagation();
          } else {
            if (which === 'startDateAssignment') {
              $scope.budgetData.assignments[index].startDatepickerOpened = true;
            } else {
              $scope.budgetData.assignments[index].endDatepickerOpened = true;
            }
          }
        }

        /**
         * To check if apportion allocation values will change due to field changes
         *
         * @param {*}      oldValue   old value of the field
         * @param {*}      newValue   new value of the field
         * @param {string} fieldModel Name of the model to be modified
         * @param {number} index
         */
        function checkApportionAllocation(oldValue, newValue, fieldModel, index) {
          budgetFunctions.checkApportionAllocation(
            oldValue,
            newValue,
            $scope.budgetData.assignments[index].apportion_allocation).then(function (resource) {
            $scope.budgetData.assignments[index].apportionRelatedValues = resource;
            $scope.budgetData.assignments[index][fieldModel] = resource;
            $scope.originalAssignmentData[index][fieldModel] = resource;
          });
        }

        /**
         * To check if assignment total amounts greater than master amount
         */
        function isAssignmentAmountGreaterThanMaster() {
          var totalAssignmentAmount = 0;
          _.forEach($scope.budgetData.assignments, function (assignment) {
            if (!!assignment.amount) {
              var assignmentActualAmount = budgetFunctions.subtract(assignment.amount, assignment.block_amount);
              totalAssignmentAmount = budgetFunctions.add(assignmentActualAmount, totalAssignmentAmount);
            }
          });

          var budgetActualAmount = budgetFunctions.subtract($scope.budgetData.amount, $scope.budgetData.block_amount);
          if (budgetActualAmount < totalAssignmentAmount) {
            return true;
          }

          return false;
        }

        /**
         * To check if assignment amount is used before, then can't be removed
         */
        function canDelete (assignment) {
          if ((!!assignment.committed_amount || !!assignment.used_amount) &&
            (assignment.committed_amount > 0 || !!assignment.used_amount > 0)) {
            return false;
          }

          return true;
        }

        /**
         * Toggle between off and on for assignments expansion
         */
        function toggleAssignmentDisplay() {
          $scope.allAssignmentsExpand = !$scope.allAssignmentsExpand;
          $scope.budgetData.assignments = $scope.budgetData.assignments.map(function(assignment) {
            assignment.isOpen = $scope.allAssignmentsExpand;
            return assignment;
          });
        }

        /**
         * Indicator to show item listing
         */
        function showItemListing() {
          // don't show if budget is revised budget or status is in pending/on-hold/draft/revision
          return !$scope.budgetData.parent_id &&
            ['pending', 'on_hold', 'draft', 'revision'].indexOf($scope.budgetData.status) === -1;
        }

        function initialize() {
          $scope.originalAssignmentData = {};
          $scope.budgetData.assignments = $scope.budgetData.assignments.map(function(assignment) {
            assignment.isOpen = false;
            assignment.toggle = false;
            return assignment;
          });
          _.forEach($scope.budgetData.assignments, function(assignment, key){
            $scope.originalAssignmentData[key] = _.cloneDeep(assignment);
          });
        }

        initialize();
      }
    };
  });

'use strict';

/**
 * @name budgetApportionAllocationCtrl
 * @desc Controller for displaying apportion details, editable and non editable
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function budgetApportionAllocationCtrl($scope, apportionType, availableAmount, apportionAllocation,
                                       apportionCarryForward, $uibModalInstance, toastr, parentId) {

  $scope.saveApportion = saveApportion;
  $scope.close = close;
  $scope.getTemplateUrl = getTemplateUrl;
  $scope.getTotalApportionAllocation = getTotalApportionAllocation;
  $scope.validateDateRange = validateDateRange;

  /**
   * Run on saving changes
   */
  function saveApportion() {
    if (!validateBeforeSave()) {
      return;
    }
    var apportionData = {
      apportion_carry_forward: $scope.apportionCarryForward,
      apportion_allocation: $scope.apportionAllocation
    };
    $uibModalInstance.close(apportionData);
  }

  /**
   * Check if total allocation exceeded available allocation amount
   *
   * @returns {boolean}
   */
  function validateBeforeSave() {
    if (getTotalApportionAllocation() - availableAmount > 0) {
      toastr.error('Total allocation exceeded the available allocation amount.');
      return false;
    }
    return true;
  }

  function close() {
    var apportionData = {
      apportion_carry_forward: apportionCarryForward,
      apportion_allocation: apportionAllocation
    };
    $uibModalInstance.close(apportionData);
  }

  function getTotalApportionAllocation() {
    var totalAllocation = 0;
    _.forEach($scope.apportionAllocation, function(allocation) {
      if (!!allocation.amount) {
        totalAllocation = Number(math.format(
          math.add(
            math.bignumber(totalAllocation),
            math.bignumber(allocation.amount)
          ),
          {precision: 64}
        ));
      }
    });

    return totalAllocation;
  }

  /**
   * Validate the date range to determine if amount is able to be edited
   *
   * @param {number} endDate End date in milliseconds
   * @returns {boolean}
   */
  function validateDateRange(endDate) {
    var end = moment(endDate);
    var today = moment();
    // Return true if today more than end date
    return (today > end);
  }

  /**
   * Get template url based on editable state
   *
   * @param {string} state
   */
  function getTemplateUrl(state) {
    switch (state) {
      case 'editable':
        $scope.budgetTemplateUrl = 'components/budget/apportion/apportion.editableTemplate.html';
        break;
      case 'notEditable' :
        $scope.budgetTemplateUrl = 'components/budget/apportion/apportion.nonEditableTemplate.html';
        break;
    }
  }

  // Watches the getEditingBudgetState to determine editable/non editable template
  $scope.$watch('getEditingBudgetState()', function (newValue) {
    getTemplateUrl(newValue);
  });

  function initialize() {
    $scope.apportionAllocation = _.cloneDeep(apportionAllocation);
    $scope.apportionCarryForward = _.cloneDeep(apportionCarryForward);
    $scope.apportionType = _.cloneDeep(apportionType);
    $scope.availableAmount = _.cloneDeep(availableAmount);
    $scope.parentId = _.cloneDeep(parentId);
  }

  initialize();
}

budgetApportionAllocationCtrl.$inject = ['$scope', 'apportionType', 'availableAmount', 'apportionAllocation',
  'apportionCarryForward', '$uibModalInstance', 'toastr', 'parentId'];

angular.module('metabuyer')
  .controller('budgetApportionAllocationCtrl', budgetApportionAllocationCtrl);

angular
  .module('metabuyer')
  .directive('apportion', function () {
    return {
      templateUrl: 'components/budget/apportion/apportionButton.html',
      restrict: 'E',
      scope: {
        apportionType: '=',
        editingMode: '=',
        startDate: '=',
        endDate: '=',
        availableAmount: '=',
        apportionAllocation: '=',
        apportionCarryForward: '=',
        apportionRelatedValues: '=?',
        parentId: '='
      },
      controller: function ($scope, $uibModal, budgetFunctions, globalFunc) {

        $scope.openApportionDetails = openApportionDetails;

        /**
         * Opens the modal for apportion details
         */
        function openApportionDetails() {

          var modalInstance = $uibModal.open({
            templateUrl: function () {
              return $scope.editingMode === 'editable' ?
                'components/budget/apportion/apportionAllocation.editableTemplate.html' :
                'components/budget/apportion/apportionAllocation.nonEditableTemplate.html';
            },
            backdrop: 'static',
            windowClass: 'budget-apportion-details',
            keyboard: false,
            scope: $scope,
            resolve: {
              apportionType: function () {
                return $scope.apportionType;
              },
              availableAmount: function () {
                return $scope.availableAmount;
              },
              apportionAllocation: function () {
                return !!$scope.apportionAllocation ? $scope.apportionAllocation : [];
              },
              apportionCarryForward: function () {
                return $scope.apportionCarryForward;
              },
              parentId: function () {
                return $scope.parentId;
              }
            },
            controller: 'budgetApportionAllocationCtrl'
          });

          modalInstance.result.then(function (apportionData) {
            if (!!apportionData) {
              $scope.apportionAllocation = apportionData.apportion_allocation;
              $scope.apportionCarryForward = apportionData.apportion_carry_forward;
            }
          });
        }

        // Watch the apportion related values for changes and recalculate if changed
        $scope.$watch('apportionRelatedValues', function (newValue) {
          if(!!newValue) {
            getApportionAllocation();
          }
        });

        function getApportionAllocation() {
          var startDate = globalFunc.convertDateToTimestamp(_.cloneDeep($scope.startDate));
          var endDate = globalFunc.convertDateToTimestamp(_.cloneDeep($scope.endDate));
          var isRevisionApportionAllocation = false;
          // If budget has parent id, generate apportion allocation for revision
          if (!!$scope.parentId) {
            isRevisionApportionAllocation = true;
          }
          // Generate apportion allocation from backend if there is budget status
          if (!!$scope.apportionRelatedValues) {
            budgetFunctions.getApportionAllocationData(
              startDate,
              endDate,
              $scope.apportionType,
              $scope.availableAmount,
              isRevisionApportionAllocation,
              $scope.apportionAllocation
            ).then(function (resource) {
              $scope.apportionAllocation = resource;
            });
          }
        }
      }
    }
  });

'use strict';

/**
 * @name budgetActions Directive
 * @desc Directive for displaying budget actions
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular
  .module('metabuyer')
  .directive('budgetActions', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/budget/actions/actions.html',
      scope: {
        data: '=',
        assignments: '=',
        headerDetailsError: '=',
        budgetAssignmentDetailsError: '=',
        budgetItemDetailsError: '=',
        isCreator: '&',
        approvalFlowData: '='
      },
      controller: function (
        $scope, $state, toastr, globalFunc, budgets, $uibModal, $rootScope, purchaseRequisitionsServices, $stateParams,
        approvalPreview, HighlightId, budgetFunctions
      ) {
        $scope.currentUser = $rootScope.currentUser || {_id: null};
        $scope.rejectBudgetExtraParams = {};
        $scope.module = 'budget';

        $scope.back = back;
        $scope.deleteBudget = deleteBudget;
        $scope.deleteBudgetDraft = deleteBudgetDraft;
        $scope.submitBudget = submitBudget;
        $scope.saveBudget = saveBudget;
        $scope.reactivateBudget = reactivateBudget;
        $scope.deactivateBudget = deactivateBudget;
        $scope.createRevisionDraft = createRevisionDraft;
        $scope.showVersionList = showVersionList;
        $scope.canReject = canReject;
        $scope.canHold = canHold;
        $scope.canUnHold = canUnHold;
        $scope.canWithdraw = canWithdraw;
        $scope.canDeactivate = canDeactivate;
        $scope.canReactivate = canReactivate;
        $scope.canApprove = canApprove;
        $scope.canDelete = canDelete;
        $scope.canDeleteDraft = canDeleteDraft;
        $scope.canResubmit = canResubmit;
        $scope.approvalAction = approvalAction;
        $scope.refreshBudgetDetails = refreshBudgetDetails;
        $scope.previewBudgetApproval = previewBudgetApproval;

        // navigate to previous page
        function back() {
          if (!!$scope.data && $scope.data._id) {
            HighlightId.setId($scope.data._id);
          }

          window.history.back();
        }

        // #region Budget action functions
        /**
         * Delete budget by id
         */
        function confirmDeleteBudget() {
          budgets.delete(
            {
              id: $scope.data._id
            },
            function () {
              toastr.success('Budget draft deleted.');
              HighlightId.setId($scope.data._id);
              $state.go('main.user.budget.manage', {status: 'deleted'});
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        /**
         * Submit budget, moves to pending status
         */
        function submitBudget() {
          if (!validateBeforeSubmit($scope.data)) {
            return;
          }

          var submitData = _.cloneDeep($scope.data);

          //Assign selected start date
          submitData['start_date'] = !!submitData['start_date'] ?
            globalFunc.convertDateToTimestamp(submitData['start_date']) : null;

          //Assign selected end date
          submitData['end_date'] = !!submitData['end_date'] ?
            globalFunc.convertDateToTimestamp(submitData['end_date']) : null;

          //Convert dates in the assignments before submit
          _.forEach(submitData['assignments'], function (assignment) {
            assignment['start_date'] = !!assignment['start_date'] ?
              globalFunc.convertDateToTimestamp(assignment['start_date']) : null;
            assignment['end_date'] = !!assignment['end_date'] ?
              globalFunc.convertDateToTimestamp(assignment['end_date']) : null;

            var tempArray = [];
            if (!!assignment.cost_center && !!assignment.cost_center.code) {
              tempArray.push(assignment.cost_center);
              assignment.cost_center = tempArray;
            }

          });

          budgets.post(
            {
              id: $scope.data._id,
              action: 'submit'
            },
            {
              data: submitData
            },
            function (resource) {
              if (!!resource.content && !!resource.content.data) {
                $scope.initialData = _.cloneDeep($scope.data);
              }
              toastr.success('Budget submitted.');
              HighlightId.setId($scope.data._id);
              $state.go('main.user.budget.manage', {status: 'pending'});
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        /**
         * Prepare budget data
         *
         * @param {array} submitData Budget data
         */
        function prepareBudgetBeforeSave(submitData) {
          //Assign selected start date
          submitData['start_date'] = !!submitData['start_date'] ?
            globalFunc.convertDateToTimestamp($scope.data.start_date) : null;

          //Assign selected end date
          submitData['end_date'] = !!submitData['end_date'] ?
            globalFunc.convertDateToTimestamp($scope.data.end_date) : null;

          //Convert dates in the assignments before submit
          _.forEach(submitData['assignments'], function (assignment) {
            assignment['start_date'] = !!assignment['start_date'] ?
              globalFunc.convertDateToTimestamp(assignment['start_date']) : null;
            assignment['end_date'] = !!assignment['end_date'] ?
              globalFunc.convertDateToTimestamp(assignment['end_date']) : null;

            var tempArray = [];
            if (!!assignment.cost_center && !!assignment.cost_center.code) {
              tempArray.push(assignment.cost_center);
              assignment.cost_center = tempArray;
            }
          });
        }

        /**
         * Save budget, passes budget status to be updated
         *
         * @param {string}  status                Budget status
         * @param {boolean} isApprovalFlowPreview Flag indicate if is for approval flow preview usage
         * @returns {boolean}
         */
        function saveBudget(status, isApprovalFlowPreview) {
          $scope.data.status = status;

          var submitData = _.clone($scope.data);
          prepareBudgetBeforeSave(submitData);

          budgets.put(
            {
              id: $scope.data._id
            },
            {
              data: submitData
            },
            function (resource) {
              if (!!resource.content && !!resource.content.data) {
                $scope.data = resource.content.data;
                $scope.data.start_date = !!$scope.data.start_date ? new Date($scope.data.start_date) : null;
                $scope.data.end_date = !!$scope.data.end_date ? new Date($scope.data.end_date) : null;
                $scope.initialData = _.cloneDeep($scope.data);
              }
              if (!isApprovalFlowPreview) {
                toastr.success('Budget updated.');
                $state.reload();
              } else {
                previewApproval();
              }
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        function previewApproval() {
          approvalPreview.get({
            company_code: $scope.data.company.code,
            context_type: 'Metabuyer\\Budget\\Models\\Budget',
            context_id: $scope.data._id
          }, function (resource) {
            $scope.approvalFlowData = resource.content.data;
          }, function (error) {
            $scope.approvalFlowData = [];
            globalFunc.objectErrorMessage(error);
          });
        }

        /**
         * Update to reactivate the budget
         */
        function reactivateBudget() {
          swal({
            title: 'Confirm reactivate budget?',
            text: 'This action will move the budget to pending approval process.\r\n' +
                  'Note: If the budget has expired, it will be moved to the expired budget list instead.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm',
            closeOnConfirm: true
          }, function (isConfirm) {
            if (isConfirm) {
              submitBudget();
            }
          });
        }

        /**
         * Update to deactivate the budget
         */
        function deactivateBudget() {
          swal({
            title: 'Confirm deactivate budget?',
            text: 'This action will disallow raising future purchase requisitions with this budget.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm',
            closeOnConfirm: true
          }, function (isConfirm) {
            if (isConfirm) {
              saveBudget('inactive', false);
            }
          });
        }

        /**
         * To confirm if to delete the budget
         */
        function deleteBudget() {
          swal({
            title: 'Confirm delete budget?',
            text: 'This action will remove the budget from draft.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm',
            closeOnConfirm: true
          }, function (isConfirm) {
            if (isConfirm) {
              confirmDeleteBudget();
            }
          });
        }

        /**
         * To confirm if to delete the budget, this is special for revision draft
         */
        function deleteBudgetDraft() {
          swal({
            title: 'Confirm delete budget draft?',
            text: 'This action will reactivate existing deactivated budget.\r\n' +
                  'Note: If the budget has expired, it will be moved to the expired budget list instead.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm',
            closeOnConfirm: true
          }, function (isConfirm) {
            if (isConfirm) {
              confirmDeleteBudget();
            }
          });
        }

        /**
         * Creates a draft revision of the budget
         */
        function confirmRevisionDraft() {
          budgets.post(
            {},
            {
              type: 'revision',
              parent_id: $scope.data._id
            },
            function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id) {
                toastr.success('Budget revision created.');
                $state.go('main.user.budget.details', {id: resource.content.data._id});
              }
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        /**
         * To confirm user if creating a revision of the budget
         */
        function createRevisionDraft() {
          swal({
            title: 'Confirm revise budget?',
            text: 'This action will deactivate existing active budget.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm',
            closeOnConfirm: true
          }, function (isConfirm) {
            if (isConfirm) {
              confirmRevisionDraft();
            }
          });
        }

        /**
         * Display budget versions list in modal\
         */
        function showVersionList() {
          $uibModal.open({
            templateUrl: 'components/budget/versions/budgetVersions.html',
            backdrop: 'static',
            keyboard: false,
            scope: $scope,
            resolve: {
              budgetVersions: function ($q, budgets, globalFunc) {
                var deferred = $q.defer();
                  budgets.get(
                    {
                      id: $scope.data._id,
                      action: 'revisions'
                    },
                    function (resource) {
                      if (!!resource.content && !!resource.content.data) {
                        deferred.resolve(resource.content.data);
                      }
                    },
                    function (error) {
                      globalFunc.objectErrorMessage(error);
                    }
                  );
                return deferred.promise;
              },
              currentStatus: function () {
                return $scope.data.status;
              }
            },
            controller: 'budgetVersionsCtrl'
          });
        }

        // #endregion

        /**
         * Validation before try to submit
         */
        function validateBeforeSubmit(data) {
          var validData = true;

          if (!data.descr || !data.owner || (!data.expense_type && !data.assignments) || !data.amount ||
            !data.start_date || !data.end_date || (!!data.block_amount && !data.block_amount_reason)) {
            $scope.headerDetailsError = true;
            toastr.error('Please complete all the required fields.');
            validData =  false;
          }

          // Once currency options is available, move this to group checking above
          if (!data.currency) {
            toastr.error('No preferred currency provided.');
            validData = false;
          }

          if (!!$scope.dataItemBreakdownSwitch && !data.cost_center) {
            toastr.error('Cannot add item breakdowns while cost center is empty.');
            validData = false;
          }

          if (data.start_date > data.end_date) {
            toastr.error('Start date must be before end date.');
            validData = false;
          }

          if (!!data.assignments.length && !validateBudgetAssignment(data)) {
            validData = false;
          }

          var assignmentAvailableAmmount = budgetFunctions.subtract(data.amount, data.block_amount);
          if (!!data.item_breakdowns.length &&
            !validateItemBreakdowns(data.item_breakdowns, assignmentAvailableAmmount)
          ) {
            validData = false;
          }

          return validData;
        }

        function validateBudgetAssignment(budget) {
          var validAssignmentData = true;
          var totalAssignmentAmount = 0;
          var totalAssignmentBlockAmount = 0;

          _.forEach(budget.assignments, function (assignment) {

            totalAssignmentAmount = budgetFunctions.add(assignment.amount, totalAssignmentAmount);
            totalAssignmentBlockAmount = budgetFunctions.add(assignment.block_amount, totalAssignmentBlockAmount);

            if (!assignment.descr || !assignment.cost_center || !assignment.expense_type || !assignment.amount ||
              (!!assignment.block_amount && !assignment.block_amount_reason) || !assignment.start_date ||
              !assignment.end_date || !assignment.apportion_type
            ) {
              toastr.error('Please complete all the required fields for budget assignments.');
              validAssignmentData = false;
            }

            if (!!assignment.start_date && !!budget.start_date && assignment.start_date < budget.start_date) {
              toastr.error('Budget assignment start date cannot be prior to budget master start date.');
              validAssignmentData = false;
            }

            if (!!assignment.end_date && !!budget.end_date && assignment.end_date > budget.end_date) {
              toastr.error('Budget assignment end date cannot be after to budget master end date.');
              validAssignmentData = false;
            }

            var assignmentAvailableAmmount = budgetFunctions.subtract(assignment.amount, assignment.block_amount);
            if (!!assignment.item_breakdowns.length &&
              !validateItemBreakdowns(assignment.item_breakdowns, assignmentAvailableAmmount)
            ) {
              validAssignmentData = false;
            }
          });

          var budgetActualAmount = budgetFunctions.subtract(budget.amount, budget.block_amount);
          var assignmentActualAmount = budgetFunctions.subtract(totalAssignmentAmount, totalAssignmentBlockAmount);

          if (budgetActualAmount < assignmentActualAmount) {
            validAssignmentData = false;
            toastr.error('Total budget assignment amount cannot be more than budget master amount.');
          }

          if (!validAssignmentData) {
            $scope.budgetAssignmentDetailsError = true;
          }

          return validAssignmentData;
        }

        /**
         * To validate item
         *
         * @param {array}  items           Item data
         * @param {number} inheritedAmount Inherited amounts
         */
        function validateItemBreakdowns(items, inheritedAmount) {
          var validItemData = true;
          var totalItemAmount = 0;

          _.forEach(items, function (item) {
            if ((item.used_amount + item.committed_amount) > item.allocated_amount) {
              toastr.error('Item breakdown "' + item.descr + '" allocated amount cannot be lower than used and committed amount.');
              validItemData = false;
            }

            totalItemAmount = budgetFunctions.add(item.allocated_amount, totalItemAmount);
            if (!item.descr || !item.commodity_code_descr || !item.apportion_type || !item.allocated_amount ||
              (item.UOMIsFraction === 0 && (item.quantity % 1 !== 0))
            ) {
              $scope.budgetItemDetailsError = true;
              toastr.error('Please complete all the required fields with valid input for item breakdowns.');
              validItemData = false;
            }
          });

          if (inheritedAmount < totalItemAmount) {
            $scope.budgetItemDetailsError = true;
            toastr.error('Total item amount cannot be more than inherited amount.');
            return validItemData = false;
          }

          return validItemData;
        }

        /**
         * Check if reject action can be done
         */
        function canReject() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'pending');
          var isApprover = !!$scope.data.waiting_on ?
            ($scope.data.waiting_on.indexOf($scope.currentUser._id) > -1) : false;

          return (checkBudgetStatus && isApprover);
        }

        /**
         * Check if put on-hold action can be done
         */
        function canHold() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'pending');
          var isApprover = !!$scope.data.waiting_on ?
            ($scope.data.waiting_on.indexOf($scope.currentUser._id) > -1) : false;

          return (checkBudgetStatus && isApprover);
        }

        /**
         * Check if release on-hold budget action can be done
         */
        function canUnHold() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'on_hold');
          var isApprover = !!$scope.data.waiting_on ?
            ($scope.data.waiting_on.indexOf($scope.currentUser._id) > -1) : false;

          return (checkBudgetStatus && isApprover);
        }

        /**
         * Check if withdraw budget action can be done
         */
        function canWithdraw() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'pending');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);

          return (checkBudgetStatus && isCreator);
        }

        /**
         * Check if deactivate budget action can be done
         */
        function canDeactivate() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'approved');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);

          return (checkBudgetStatus && isCreator);
        }

        /**
         * Check if reactivate budget action can be done
         */
        function canReactivate() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'inactive');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);
          var hasRevisingDraft = !!$scope.data.revisingBudgetId;

          return (checkBudgetStatus && isCreator && !hasRevisingDraft);
        }

        /**
         * Check if approve budget action can be done
         */
        function canApprove() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'pending');
          var isApprover = !!$scope.data.waiting_on ?
            ($scope.data.waiting_on.indexOf($scope.currentUser._id) > -1) : false;

          return (checkBudgetStatus && isApprover);
        }

        /**
         * Check if delete budget action can be done
         */
        function canDelete() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'draft');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);
          var parentBudgetExist = !!$scope.data.parent_id;

          return (checkBudgetStatus && isCreator && !parentBudgetExist);
        }

        /**
         * Check if delete budget action can be done, this is special for revision draft
         */
        function canDeleteDraft() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'draft');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);
          var parentBudgetExist = !!$scope.data.parent_id;

          return (checkBudgetStatus && isCreator && parentBudgetExist);
        }

        /**
         * Check if resubmit budget action can be done
         */
        function canResubmit() {
          var checkBudgetStatus = ($scope.data.status.toLowerCase() === 'withdraw' ||
            $scope.data.status.toLowerCase() === 'rejected');
          var isCreator = ($scope.data.created_by._id === $scope.currentUser._id);

          return (checkBudgetStatus && isCreator);
        }

        /**
         * Function to run on action taken
         *
         * @param {string} action       Action to be taken to the budget
         * @param {string} message      Message to be thrown on success
         * @param {object} extraPayload In some cases the action needs extra payload passed to the backend
         * @returns {*}
         */
        function approvalAction(action, message, extraPayload) {

          return purchaseRequisitionsServices.approvalAction(
            {
              approval_id: $scope.data.approval_id,
              status: action
            },
            extraPayload,
            function () {
              if (!!message) {
                toastr.success(message);
              }
            }
          );
        }

        /**
         * Function to refresh budget page
         */
        function refreshBudgetDetails() {
          $state.transitionTo($state.current, $stateParams, {
            reload: true,
            inherit: false,
            notify: true
          });
        }

        /**
         * Function to load next waiting on task for this user on budget
         */
        function loadNextData() {
          if ($scope.data.status === 'pending' || $scope.data.status.toLowerCase() === 'on_hold') {
            $scope.onHoldExtraParams = prepareOnHoldExtraParams();

            globalFunc.nextAvailableAction('Metabuyer\\Budget\\Models\\Budget', $scope.data._id).then(function (resource) {
              if (!!resource && !!resource.waitingOnObject && !!resource.waitingOnObject.context_id) {
                $scope.nextBudget = resource.waitingOnObject;
                $scope.totalBudgetOnHand = resource.count;
              }
              else
                $scope.nextBudget = {};
            });
          }
        }

        /**
         * Preparing on hold extra params
         * @returns {object}
         */
        function prepareOnHoldExtraParams() {
          var userIDArray = [];
          userIDArray.push($scope.data.created_by._id);

          return {user_ids: userIDArray};
        }

        /**
         * Preview budget approval
         */
        function previewBudgetApproval() {
          // using angular.equals instead of _.isEqual because lodash has problem when compare deeper layer
          if (!angular.equals($scope.initialData, $scope.data)) {
            swal({
              title: 'Confirm save changes?',
              text: 'In order to preview the approval flow, changes made to the budget will be saved.',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#1ab394',
              confirmButtonText: 'Confirm',
              closeOnConfirm: true
            }, function (isConfirm) {
              if (isConfirm) {
                saveBudget('draft', true);
              }
            });
          } else {
            previewApproval();
          }
        }

        $scope.$on('saveDraftBudget', function () {
          previewBudgetApproval();
        });

        function initialize() {
          $scope.initialData = _.cloneDeep($scope.data);
          loadNextData();
        }

        initialize();
      }
    };
  });

'use strict';
/**
 * @name addAttachmentCtrl
 *
 * @description
 * Controller for add attachment in attachmentCategory
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

function addAttachmentCtrl(
  $scope, attachmentCategory, globalFunc, $uibModalInstance, searchModule, module, editingData, $rootScope
) {

  $scope.attachment           = {};
  $scope.attachmentCategories = [];
  $scope.attachmentFields     = [];
  $scope.datepickerOpened     = {};
  $scope.editing              = !!editingData;
  $scope.dateOptions          = { formatYear: 'yy', startingDay: 1 };

  $scope.close                = close;
  $scope.onSelectCategory     = onSelectCategory;
  $scope.saveAttachment       = saveAttachment;
  $scope.openDatepicker       = openDatepicker;

  function openDatepicker($event, which) {
    $event.preventDefault();
    $event.stopPropagation();

    $scope.datepickerOpened[which] = true;
  }

  function close() {
    $uibModalInstance.close();
  }

  /**
   * Save the attachment
   */
  function saveAttachment() {
    if (!!$scope.editing)
      saveAttachmentDescription($scope.attachmentFields, $scope.attachment, 'update');
    else
      saveAttachmentDescription($scope.attachmentFields, $scope.attachment, 'add');
  }

  /**
   * save in local variable
   * @param attachmentFields
   * @param attachment
   * @param action
   */
  function saveAttachmentDescription(attachmentFields, attachment, action) {
    var attachmentDescription = {
      attachment_category: attachment.category,
      description_array: prepareAttachmentArray(attachmentFields)
    };
    if (action === 'add' || !!$scope.attachment.file) {
      attachmentDescription.attachment_detail = {
        title: attachment.file.name,
        creator: {
          display_name: $rootScope.currentUser.display_name
        },
        created_at: new Date(),
        file: attachment.file
      };
    } else {
      attachmentDescription.attachment_detail = $scope.attachmentDetail;
    }

    $uibModalInstance.close(attachmentDescription);
  }

  function prepareAttachmentArray(attachmentFields) {
    _.forEach(attachmentFields, function (field) {
      if (field.type.toLowerCase() === 'mongodate' && field.value instanceof Date && !isNaN(field.value.valueOf()))
        field.value = globalFunc.convertDateToTimestamp(field.value);
    });

    return attachmentFields;
  }

  /**
   * On selecting category
   * @param category
   */
  function onSelectCategory(category) {
    attachmentCategory.get({
      id: category._id
    }, function(resource) {
      if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id)
        $scope.attachmentFields = resource.content.data.description_fields;
    }, function(error) {
      globalFunc.objectErrorMessage(error);
    })
  }

  /**
   * get attachment category
   */
  function getAttachmentCategory() {
    var params = {
      module: 'attachment-categories',
      'criteria[host_object_class]': 'Metabuyer\\Models\\' + module,
      order_by: 'name',
      offset: 0,
      order: 1
    };
    searchModule.get(
      params,
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          $scope.attachmentCategories = resource.content.data;

        isEditing();
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function isEditing() {
    if (!!editingData) {
      $scope.attachment.category  = angular.copy(editingData.attachment_category);
      $scope.attachmentFields     = angular.copy(editingData.description_array);

      // Using angular copy causes “TypeError: Illegal invocation”
      $scope.attachmentDetail     =  _.cloneDeep(editingData.attachment_detail);

      $scope.attachment.status    = angular.copy(editingData.status);
    }
  }

  function initialize() {
    getAttachmentCategory();
  }

  initialize();
}
addAttachmentCtrl.$inject = [
  '$scope', 'attachmentCategory', 'globalFunc', '$uibModalInstance', 'searchModule', 'module', 'editingData', '$rootScope'
];

angular
  .module('metabuyer')
  .controller('addAttachmentCtrl', addAttachmentCtrl);

'use strict';

angular
  .module('metabuyer')
  .controller('addApproverCtrl', addApproverCtrl);

addApproverCtrl.$inject = [
  '$scope', 'toastr', '$uibModalInstance', 'companyCode', 'overlays', 'approvalId', 'adhocApprover', '$state',
  'getUsersInCompanies', 'globalFunc', '$rootScope'
];

function addApproverCtrl (
  $scope, toastr, $uibModalInstance, companyCode, overlays, approvalId, adhocApprover, $state, getUsersInCompanies,
  globalFunc, $rootScope
) {

  $scope.cancel = cancel;
  $scope.addApprover = addApprover;
  $scope.getUserName = getUserName;

  $scope.approvalRoles = [];
  $scope.newApprover = {};
  $scope.usersSelected = [];
  $scope.users = [];
  $scope.userSetting = {
    scrollable: true,
    scrollableHeight: '300px',
    showCheckAll: true,
    showUncheckAll: true,
    enableSearch: true,
    buttonDefaultText: 'Select users'
  };


  function cancel() {
    $uibModalInstance.close();
  }

  /**
   * Add new approver to the approval flow step
   */
  function addApprover(){
    var users = [];
    var tempSourceId = overlays.sourceId;
    var tempTargetId = overlays.targetId || '';

    tempSourceId = tempSourceId.split('_');
    tempTargetId = tempTargetId.split('_');

    _.forEach($scope.usersSelected, function(user){
      users.push(user.id);
    });

    var sourceStep = tempSourceId[1];
    var targetStep = tempTargetId[1];

    adhocApprover.post({
      id: approvalId
    }, {
      users: users,
      source_step: sourceStep,
      target_step: targetStep
    }, function(){
      toastr.success('New approver added');
      $state.reload();
      cancel();
    }, function (error){
      globalFunc.objectErrorMessage(error);
    });
  }

  /**
   * To prepare users data list follows ng-dropdown format
   */
  function reformatUsersRole(users){
    if (!!users) {
      _.forEach(users, function(user) {
        user.id = user._id;
        user.label = user.display_name;

        if ($rootScope.currentUser._id !== user._id) {
          $scope.users.push(user);
        }
      });
    }
  }

  /**
   * Get user name based on given userId
   *
   * @param userId
   * @returns {*}
   */
  function getUserName(userId) {
    var user = globalFunc.findInArray($scope.users, 'id', userId);
    return user.label;
  }

  function getUsers() {
    // get all the users in company
    var params = {
      'companyCodes[0]': companyCode
    };

    getUsersInCompanies.get(
      params,
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          reformatUsersRole(resource.content.data);
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function initialize() {
    getUsers();
  }

  initialize();
}

'use strict';
/**
 * @name accountCodeDetailsCtrl
 * @desc Controller for account codes details
 */
function accountCodeDetailsCtrl(
  $scope, $uibModalInstance, accountCode, singleAccountCode, toastr, $state, companyId, accountCodeStatuses, accountEntries,
  accountReceivable, accountType, globalFunc, costCenters
) {
  $scope.editClicked = false;
  $scope.detailedAccountCode = angular.copy(accountCode);

  $scope.accountCodeStatuses = accountCodeStatuses;
  $scope.accountEntries = accountEntries;
  $scope.accountReceivable = accountReceivable;
  $scope.accountType = accountType;
  $scope.costCenters = costCenters;

  $scope.companyId = companyId;
  $scope.cancel = cancel;
  $scope.editAccountCode = editAccountCode;
  $scope.updateAccountCode = updateAccountCode;

  function cancel() {
    $uibModalInstance.close();
  }

  function editAccountCode(){
    $scope.editClicked = true;
  }

  function validate(accountCode){
    return(!!accountCode && !!accountCode.code && !!accountCode.descr);
  }

  function updateAccountCode() {
    if(validate($scope.detailedAccountCode)){
      swal(
        {
          title: "Confirm Updating the Account Code",
          text: "This will update the details for this Account Code",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#1ab394  ",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (confirmed) {
          if (!!confirmed) {
            // set status in integer to pass it as parameter
            var tempStatus;
            switch($scope.detailedAccountCode.accountCodeStatus.isActive.toLowerCase()){
              case 'active':
                tempStatus = 1;
                break;
              case 'deactivated':
                tempStatus = 0;
                break;
            }

            var costCenterIds = prepareCostCenterIds($scope.detailedAccountCode.cost_center);
            singleAccountCode.put(
              {
                id: $scope.companyId,
                accountCode_id: $scope.detailedAccountCode._id
              },
              {
                name: $scope.detailedAccountCode.name,
                descr: $scope.detailedAccountCode.descr,
                account_entries : $scope.detailedAccountCode.account_entries.value,
                account_receivable : $scope.detailedAccountCode.account_receivable.value,
                account_type : $scope.detailedAccountCode.account_type.value,
                cost_center_ids: costCenterIds,
                is_active: tempStatus
              },
              function () {
                toastr.success('The Account Code has been updated');
                $uibModalInstance.close($scope.detailedAccountCode);
              },
              function () {
                toastr.error('Failed to update the Account Code');
              }
            );
          } else {
            return false;
          }
        }
      );
    }
  }

  function prepareCostCenterIds(selectedCostCenters) {
    var ids = [];
    _.forEach(selectedCostCenters, function(cc) {
      ids.push(cc._id);
    });
    return ids;
  }

  function setSelectedCostCenter() {
    var tempSelectedCostCenter = [];
    _.forEach($scope.detailedAccountCode.cost_center, function (selectedCostCenter) {
      var tempCostCenter = globalFunc.findInArray($scope.costCenters, '_id', selectedCostCenter._id);
      if (!!tempCostCenter)
        tempSelectedCostCenter.push(tempCostCenter);
    });

    $scope.detailedAccountCode.cost_center = tempSelectedCostCenter;
  }

  function initialize(){

    if(angular.isDefined($scope.detailedAccountCode.is_active)) {
      $scope.detailedAccountCode.accountCodeStatus = globalFunc.findInArray(
        $scope.accountCodeStatuses, 'value', $scope.detailedAccountCode.is_active
      );
    }

    $scope.detailedAccountCode.account_entries = globalFunc.findInArray(
      $scope.accountEntries, 'value', $scope.detailedAccountCode.account_entries
    );
    $scope.detailedAccountCode.account_type = globalFunc.findInArray(
      $scope.accountType, 'value', $scope.detailedAccountCode.account_type
    );
    $scope.detailedAccountCode.account_receivable = globalFunc.findInArray(
      $scope.accountReceivable, 'value', $scope.detailedAccountCode.account_receivable
    );

    // set selected cost center
    setSelectedCostCenter();
  }

  initialize();

}

accountCodeDetailsCtrl.$inject = [
  '$scope', '$uibModalInstance', 'accountCode', 'singleAccountCode', 'toastr', '$state', 'companyId', 'accountCodeStatuses',
  'accountEntries', 'accountReceivable', 'accountType', 'globalFunc', 'costCenters'
];

angular
  .module('metabuyer')
  .controller('accountCodeDetailsCtrl', accountCodeDetailsCtrl);

'use strict';
/**
 * @name onlineUsersCtrl
 * @desc Controller to View and disconnect active users
 */
function onlineUsersCtrl($scope, $stateParams, activeUsersList, activeUsers, toastr) {
  $scope.dataList = activeUsersList.data;
  $scope.meta = activeUsersList.meta;
  $scope.userManageService = activeUsers;
  $scope.status = $stateParams.status;
  $scope.disconnectUser = disconnectUser;

  function disconnectUser(info, index){
    swal({
        title: "Confirm disconnecting a User",
        text: "This user will be disconnected. Please state reason",
        type: "input",
        showCancelButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
        inputType: "text",
        inputPlaceholder: "Write a comment"
      },
      function(inputValue) {
        if (inputValue === false) {
          return false;
        }
        if(inputValue.indexOf(' ') == 0){
          swal.showInputError("Reason cannot start with white spaces!");
          return false;
        }
        if(inputValue === "") {
          swal.showInputError("You need to state a reason for disconnecting!");
          return false
        }
        activeUsers.delete(
          {
            session_id: info.session_id,
            comment: inputValue
          },
          function (resource) {
            if (!!resource.content) {
              swal.close();
              $scope.dataList.splice(index,1);
              refreshUsersList();
              toastr.success('Disconnected user');
            }
          },
          function (error) {
            if(!!error.data && !!error.data.content)
            {
              toastr.error(error.data.content.error);
            }
            else{
              toastr.error('User disconnection failed');
            }
          }
        );
      });
  }
  function refreshUsersList(){
    activeUsers.get(
      {
        session_id: 'active'
      },
      function (resource) {
        if (!!resource.content) {
          $scope.dataList = resource.content.data;
          $scope.meta = resource.content.meta;
        }
      },
      function (error) {
      }
    );
  }

}

onlineUsersCtrl.$inject = ['$scope', '$stateParams', 'activeUsersList', 'activeUsers', 'toastr'];

angular
  .module('metabuyer')
  .controller('onlineUsersCtrl', onlineUsersCtrl);

'use strict';
/**
 * @name UsersManageCtrl
 * @desc Controller for users manage
 */
function UsersManageCtrl(
  $scope, $stateParams, usersList, Users, pathConstants, $uibModal, action, $filter, HighlightId
) {
  $scope.importAssignments = importAssignments;
  $scope.exportAssignments = exportAssignments;
  $scope.listItem = listItem;
  $scope.getStatusName = getStatusName;
  $scope.importLink = pathConstants.apiUrls.users.importAssignments;
  $scope.showColumn = showColumn;

  $scope.storageKey = 'users-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

   function listItem (list, property) {
    return _.unique(_.map(list, function (item) {
      return item[property];
    })).toString();
  }


  function importAssignments() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "User Assignment";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function exportAssignments() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/exportUserAssignments/exportUserAssignmentsTemplate.html',
      backdrop: 'static',
      keyboard: false,
      controller: 'exportUserAssignmentsCtrl'
    });
  }

  function getStatusName(number){
    /**
     * Pending = 0
     *
     * Active = 1
     *
     * Inactive = 2
     *
     * Rejected = 3
     */
    if(number === 0){
      return 'Pending';
    }
    if(number === 1){
      return 'Active';
    }
    if(number === 2){
      return 'Inactive';
    }
    if(number === 3){
      return 'Rejected';
    }
    return 'N/A';
  }

  function initialize(){
    $scope.dataList = usersList.data;
    $scope.meta = usersList.meta;
    $scope.userManageService = Users;
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;
    $scope.actionType = action;
    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();
}

UsersManageCtrl.$inject = [
  '$scope', '$stateParams', 'usersList', 'Users', 'pathConstants', '$uibModal', 'action', '$filter', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('UsersManageCtrl', UsersManageCtrl);

'use strict';
/**
 * @name UsersImportUserCtrl
 * @desc Controller for users import user
 */
function UsersImportUserCtrl($scope, Users) {

  $scope.params = {
    class: 'Metabuyer\\Models\\Users',
    'additional_params[]': ''
  };

}

UsersImportUserCtrl.$inject = ['$scope', 'Users'];

angular.module('metabuyer')
  .controller('UsersImportUserCtrl', UsersImportUserCtrl);

/**
 * @name escalationModificationPanel
 *
 * @description
 *
 * Controller for the Modal window to List the searched results
 *
 * @requires $scope
 * @requires user (resolved user from the previous state)
 * @requires company (resolved user from the previous state)
 * @requires searchUser (Metabuyer service)
 * @requires toastr
 * @requires $uibModalInstance
 * @requires addEscalation (Metabuyer service)
 * @requires removeEscalation (Metabuyer service)
 *
 *
 * @function selectingUser
 * Uses 'swal' to show a warning message, after the confirmation of Adding the user it confirmation
 * will have the Modal to dismiss as well the selected User will be added to the user's company
 * immediately to show in the HTML
 *
 * @function removeUser
 * Uses 'swal' to show a warning message, after the confirmation of Removing the user it will have the
 * Modal to dismiss as well the selected User will be removed from the user's company immediately
 * to remove it in the HTML
 *
 * @function validate
 * returns true or false, after validating, the User, Company and Selected User
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */


'use strict';

function escalationModificationPanel(
  $scope, user, company, superior, userInfo, searchUser, toastr, $uibModalInstance, addEscalation, removeEscalation,
  globalFunc
) {

  $scope.user = user;
  $scope.company = company;
  $scope.superior = superior;
  $scope.selectingUser = selectingUser;
  $scope.removeUser = removeUser;
  $scope.close = close;
  $scope.usersSearched = [];

  $scope.search = function (text) {
    if(text.length > 2){
      searchUser.get(
        {
          query: text
        },
        function (resource) {
          $scope.searchResults = 0;
          if(!!resource.content && !!resource.content.data){
            $scope.usersSearched = resource.content.data;
          }
        },
        function (error) {
          if(error.status === 404)
          {
            $scope.searchResult = 0;
            $scope.suppliersResults = [];
          }
          else {
            toastr.error("Failed to load a list of superiors");
          }
        }
      );
    }
  };

  function validate(userSelected){
    if(!$scope.user || !$scope.user._id){
      toastr.error('Failed to access the main user');
      return false;
    }
    if(!$scope.company){
      toastr.error('Failed to load the desired company');
      return false;
    }
    if(!userSelected || !userSelected._id || userSelected._id === $scope.user._id){
      toastr.error('Failed to access the escalated to user');
      return false;
    }
    return true;
  }

  function selectingUser(userSelected){
    if(validate(userSelected)) {
      swal({
          title: 'Confirm Selecting an Escalation user in ' + $scope.company.descr,
          text: userSelected.display_name + ' will be selected !',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if (isConfirm) {
            addEscalation.post(
              {
                id: $scope.user._id,
                mid: userSelected._id
              },
              {
                company_code: $scope.company.code,
                class: userInfo.class
              },
              function (resource) {
                toastr.success('User was selected successfully');
                // Return selected user
                $uibModalInstance.close(userSelected);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
      });
    }
  }

  function close(){
    $uibModalInstance.close();
  }

  function removeUser(userSelected) {
    if(validate(userSelected)) {
      swal({
          title: 'Confirm Removing an Escalation user in ' + $scope.company.descr,
          text: userSelected.display_name + ' will be removed !',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if(isConfirm) {
            removeEscalation.delete(
              {
                id: $scope.user._id,
                company_code: $scope.company.code || null,
                class: userInfo.class
              },
              function (success) {
                toastr.success('Escalation option has been removed successfully');
                $scope.superior = null;
                userInfo.superior[0] = null;
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
          $uibModalInstance.close();
        });
    }
  }

  function initialize() {
    // adding the selected manager if existed
    if (!!$scope.superior) {
      $scope.usersSearched.push($scope.superior);
    }

    if (!$scope.company) {
      var className = userInfo.class.replace('Metabuyer\\Models\\', '');

      if (className === 'ImportItemSummary') {
        className = 'Catalog';
      }
      $scope.company = { code: '', descr: className };
    }
  }

  initialize();
}

escalationModificationPanel.$inject = [
  '$scope', 'user', 'company', 'superior', 'userInfo', 'searchUser', 'toastr', '$uibModalInstance', 'addEscalation',
  'removeEscalation', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('escalationModificationPanel', escalationModificationPanel);

/**
 * @name usersEscalationCtrl
 *
 * @description
 *
 * This controller lists All the available users with their own escalation options
 * Some of the users work in multiple companies or none, The Html represents that.
 *
 * @requires $scope
 * @requires usersList (resolved from the State)
 * @requires $uibModal
 *
 * @function modify
 * This function opens the Modal for searching and selecting (as well as deselecting) a User to Escalate to
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';

function usersEscalationCtrl($scope, usersList, $uibModal, pathConstants, globalFunc) {
  $scope.dataList = usersList.data;
  $scope.meta = usersList.meta;
  $scope.offset = 25;
  $scope.modify = modify;
  $scope.importManager = importManager;
  $scope.importLink = pathConstants.apiUrls.users.importManager;

  $scope.showColumn = showColumn;

  $scope.storageKey = 'escalation-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function modify(user, company, superior, userInfo) {

    $uibModal.open({
      templateUrl: 'app/usersManagement/escalation/escalationModificationPanelTemplate.html',
      controller: 'escalationModificationPanel',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      resolve: {
        user: function () {
          return user;
        },
        company: function () {
          return company;
        },
        superior: function () {
          return superior;
        },
        userInfo: function () {
          return userInfo;
        }
      }
    }).result.then(function (superiorSelected) {
      if (!!superiorSelected) {
        userInfo.superior[0] = superiorSelected;
      }
    });
  }

  function importManager() {
    var modalInstance = $uibModal.open({
      templateUrl: "app/masterDataManagement/Import-Template.html",
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return "Managers";
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
      }
    });
  }

  function initialize(){
    // Initialize here
    $scope.params = {
      'class': 'Metabuyer\\Models\\UserSuperior'
    }
  }

  initialize();

}

usersEscalationCtrl.$inject = ['$scope', 'usersList', '$uibModal', 'pathConstants', 'globalFunc'];

angular
  .module('metabuyer')
  .controller('usersEscalationCtrl', usersEscalationCtrl);

'use strict';
/**
 * @name UsersEditCtrl
 * @desc Controller for users edit
 */
function UsersEditCtrl($scope, $q, $resource, $state, globalFunc, toastr, editedUser, $uibModal,
                       companiesForAdminUse, singleUser, companyCostCenters, $rootScope) {

  var currentEmpNo = angular.copy($scope.user.employee_number);

  $scope.selectCostCenter = selectCostCenter;
  $scope.user = editedUser;
  $scope.user.employee_number = $scope.user.emp_no;
  $scope.user.cc_list = [];
  $scope.deselectedCC = {};
  $scope.selectedEmailFrequency = selectedEmailFrequency;
  $scope.duplicationCheck = duplicationCheck;
  $scope.saveDisabled = true;

  $scope.emailFrequency = [
    {descr: 'Immediate', value: true},
    {descr: 'End of Day', value: false}
  ];

  function selectedEmailFrequency(value){
    $scope.user.receive_email_immediate = value;
  }

  function deselectCompany (companyID){
    companyCostCenters.get(
      {
        id: companyID
      },
      function(resource){
        $scope.deselectedCC = resource.content.data;
        for(var k =0;k<$scope.user.cc_list.length;k++)
        {
          for(var l=0; l<$scope.deselectedCC.length;l++)
          {
            if($scope.user.cc_list[k] === $scope.deselectedCC[l].code)
            {
              $scope.user.cc_list.splice(k,1);
            }
          }
        }
      }
    );
  }

  getUserCCList();
  //to prepare the cc list
  function getUserCCList()
  {
    var temp = [];
    for(var i =0; i<$scope.user.costCenters.length; i++){
      temp.push($scope.user.costCenters[i].code);
    }
    $scope.user.cc_list = temp;
  }

//  function removeCCList()
//  {
//    var temp = [];
//    for(var i = 0; i < $scope.user.cc_list.length; i++){
////      if($scope.user.cc_list.code)
//      temp.splice($scope.user.costCenters[i].code);
//    }
//    $scope.user.cc_list = temp;
//  }

  $scope.options = {
    companies: companiesForAdminUse
  };

  $scope.submitted = false;

  $scope.message_error = {};

  $scope.selected_options = {
    companies: $scope.user.companies
  };

  $scope.companyEditEvent = {

    onItemDeselect: function(selected_company_item){
      deselectCompany(selected_company_item._id);
    }
  };
  //setting for company multi-select dropdown list
  $scope.settingCompany = {smartButtonMaxItems: 1,
    scrollable: true,
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    enableSearch: true,
    enableSortOnTop: true,
    closeOnSelect: true,
    smartButtonTextConverter: function(itemText, originalItem) { return "Select/deselect company"; }};

  $scope.defaultCompanyButtonText = {buttonDefaultText: "Select/deselect company"};

  //load option
  $scope.loadOptions = function (url, params, options, paramValues, scopeOptionName) {
    if ($scope.options[scopeOptionName].length > 0) {
      return $scope.options[scopeOptionName];
    }

    var deferred = $q.defer();
    $resource(
      url,
      params,
      options
    ).get(
      paramValues,
      function (resource) {
        $scope.options[scopeOptionName] = resource.content.data;
        deferred.resolve(resource.data);

      }
    );

    return deferred.promise;
  };

  $scope.loadOptionsSimple = function (url, scopeOptionName) {
    return $scope.loadOptions(url, {}, {}, {}, scopeOptionName);
  };

  function selectCostCenter(selected_company){
    $uibModal.open({
      templateUrl: "app/usersManagement/add/user-costcenter-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: userCostCenterCtrl,
      scope: $scope,
      resolve:{
        userCostCenters: function($q,companyCostCenters){
          var deferred = $q.defer();
          companyCostCenters.get(
            {
              id: selected_company._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content.data);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
    })
  }

  function validateInputData() {
    if (!$scope.user.display_name || !$scope.user.employee_number ||
      $scope.empCheck === true || !getSelectedCCList() || $scope.saveDisabled
      || (!!getSelectedCCList() && getSelectedCCList().length === 0)) {
      return false;
    }
    return true;
  }

  $scope.cancelEditUser = function(){
    $state.go($scope.previousState.name, $scope.previousState.params);
  };

  //upload user detail
  $scope.saveUser = function(){
    $scope.submitted = true;

    if(!validateInputData()){
      toastr.error('Please fill all required fields');
      $scope.submitted = false;
      return;
    }
    var submit_data = {
      display_name: $scope.user.display_name,
      cc_list: getSelectedCCList(),
      receive_email_immediate: $scope.user.receive_email_immediate,
      emp_no: (currentEmpNo !== $scope.user.employee_number) ? $scope.user.employee_number : undefined,
      roles: getSelectedRolesList(),
      positions: getSelectedPositionsList(),
      superiors: getSuperiorFormattedInfo()
    };

    singleUser.put(
      {
        id: $scope.user._id
      },
      submit_data,
      function () {
        toastr.success('Changes has been saved');
        $state.go('main.user.users.detail', {id: $scope.user._id});
      },
      function (err) {
        globalFunc.objectErrorMessage(err);
      });
  };

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker) {
    if (currentEmpNo !== value) {
      globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
        switch (callback) {
          case 'empCheckTrue':
            $scope.empCheck = true;
            break;
          case 'empCheckFalse':
            $scope.empCheck = false;
            break;
        }
      });
    }else{
      $scope.empCheck = false;
    }
  }

  function getSelectedCCList(){
    var list = [];
    _.forEach($scope.user.companies, function(company){
      _.forEach(company.CCs.selected, function (costCenter) {
        list.push(costCenter.code);
      });
    });
    return list;
  }

  function getSelectedRolesList() {
    var list = [];
    _.forEach($scope.user.companies, function (company) {
      _.forEach(company.roles.selected, function (role) {
        list.push(role._id);
      });
    });
    return list;
  }

  function getSelectedPositionsList() {
    var list = [];
    _.forEach($scope.user.companies, function (company) {
      _.forEach(company.positions.selected, function (position) {
        list.push(position._id);
      });
    });
    return list;
  }

  function getSuperiorFormattedInfo() {
    var list = {};
    _.forEach($scope.user.companies, function(company) {
      if(!!company.superior.selected && !!company.superior.selected._id) {
        list[company.code] = company.superior.selected._id;
      }
      else {
        if(company.code !== 'system')
        list[company.code] = '';
      }
    });
    return list;
  }

  /**
   * Function to generate system object to display
   * @param userObject
   * Name of the object in user object
   * @param systemArray
   * Name of the array to be used
   */
  function generateSystemArray(userObject, systemArray){
    systemArray = [];
    if(!!$scope.user[userObject] && !!$scope.user[userObject].length){
      for(var i = 0; i < $scope.user[userObject].length ; i++){
        if($scope.user[userObject][i].company_code === null){
          systemArray.push($scope.user[userObject][i]);
        }
      }
      $scope.systemObject[userObject] = systemArray;
    }
  }

  function initialize(){
    $scope.systemObject = {};
    $scope.systemObject.descr = 'System';
    $scope.systemObject.code = 'system';
    $scope.systemObject._id = 'system';
    generateSystemArray('roles', 'systemRoles');
    generateSystemArray('positions', 'systemPositions');

    // Initializing the user companies if exists else create empty array for push
    $scope.user.companies = !!$scope.user.companies ? $scope.user.companies : [];
    $scope.user.companies.push($scope.systemObject);

    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    if(angular.isDefined($scope.user) && angular.isDefined($scope.user.receive_email_immediate)){
      $scope.user.email_notification_frequency = $scope.user.receive_email_immediate;
    }
  }

  initialize();
}

UsersEditCtrl.$inject = ['$scope', '$q', '$resource', '$state', 'globalFunc', 'toastr', 'editedUser',
                         '$uibModal', 'companiesForAdminUse', 'singleUser', 'companyCostCenters', '$rootScope'];

angular
  .module('metabuyer')
  .controller('UsersEditCtrl', UsersEditCtrl);



'use strict';
/**
 * @name showRolesCtrl
 * @desc Controller to see roles for a company
 */
function showRolesCtrl($scope, listRoles, company, $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.listRoles = listRoles;
  $scope.company_name = company;

  function closeModal() {
    $uibModalInstance.close();
  }
}

showRolesCtrl.$inject = ['$scope', 'listRoles', 'company', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('showRolesCtrl', showRolesCtrl);

'use strict';
/**
 * @name showPositionsCtrl
 * @desc Controller to see positions for a user
 */
function showPositionsCtrl($scope, listPositions, company, $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.listPositions = listPositions;
  $scope.company_name = company;

  function closeModal() {
    $uibModalInstance.close();
  }
}

showPositionsCtrl.$inject = ['$scope', 'listPositions', 'company', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('showPositionsCtrl', showPositionsCtrl);

'use strict';
/**
 * @name showManagersCtrl
 * @desc Controller to see managers for a user
 */
function showManagersCtrl($scope, listManagers, company, $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.listManagers = listManagers;
  $scope.company_name = company;

  function closeModal() {
    $uibModalInstance.close();
  }
}

showManagersCtrl.$inject = ['$scope', 'listManagers', 'company', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('showManagersCtrl', showManagersCtrl);

'use strict';
/**
 * @name showCostCenterCtrl
 * @desc Controller to see cost center for a company
 */
function showCostCenterCtrl($scope, listCostCenters, company, $uibModalInstance) {
  $scope.closeModal = closeModal;
  $scope.listCostCenters = listCostCenters;
  $scope.company_name = company;

  function closeModal() {
    $uibModalInstance.close();
  }
}

showCostCenterCtrl.$inject = ['$scope', 'listCostCenters', 'company', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('showCostCenterCtrl', showCostCenterCtrl);

'use strict';
/**
 * @name UsersDetailCtrl
 * @desc Controller for user detail
 */
function UsersDetailCtrl(
  $scope, $uibModal, $state, profile, toastr, singleUser, pathConstants, uploadImage, $auth, $rootScope,
  positionAssignment, HighlightId
) {

  $scope.user = profile;
  $scope.viewCostCenter = viewCostCenter;
  $scope.viewRoles = viewRoles;
  $scope.user.CClist = [];
  $scope.user.roleList = [];
  $scope.back = back;
  $scope.checkLockedUser = checkLockedUser;
  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $scope.user._id,
      'object[0][object_type]': 'Metabuyer\\Models\\Users',
      offset: 10,
      order_by: '-created_at' // Created at, descending
    }
  };

  $scope.isEditMode = false;
  $scope.listCostCenters = [];
  $scope.companyToAdd = {};
  $scope.positionAssign = null;

  // setting for cost center multi-select dropdown list
  $scope.settingCostCenter = {
    dynamicTitle: false,
    smartButtonMaxItems: 1,
    scrollable: true,
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    enableSearch: true,
    enableSortOnTop: true,
    buttonClasses: "btn btn-white"
  };

  if(!$scope.user.status){
    $scope.user.status = '';
  }

  if(!$scope.user.role){
    $scope.user.role = '';
  }

  /**
   * Function to generate arrays for an object in each company
   * @param companyObject
   * Name of the object in companies array
   * @param userObject
   * Name of the object in user object
   */
  function generateArrayPerCompany(companyObject, userObject){
    for (var i = 0; i < $scope.user.companies.length; i++) {
      if(!$scope.user.companies[i][companyObject]){
        $scope.user.companies[i][companyObject] = [];
      }
      for (var j = 0; j < $scope.user[userObject].length; j++) {
        if ($scope.user[userObject][j].company_code === $scope.user.companies[i].code) {
          $scope.user.companies[i][companyObject].push($scope.user[userObject][j]);
        }
      }
    }
  }

  /**
   * Function to generate system object to display
   * @param userObject
   * Name of the object in user object
   * @param systemArray
   * Name of the array to be used
   */
  function generateSystemArray(userObject, systemArray){
    systemArray = [];
    if($scope.user[userObject] && $scope.user[userObject].length){
      for(var i = 0; i < $scope.user[userObject].length ; i++){
        if($scope.user[userObject][i].company_code === null){
          systemArray.push($scope.user[userObject][i]);
        }
      }
      $scope.systemObject[userObject] = systemArray;
    }
  }

  function viewCostCenter(listCostCenters) {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showCostCenters-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showCostCenterCtrl,
      resolve: {
        listCostCenters: function () {
          return listCostCenters;
        },
        company: function () {
          return listCostCenters[0].company_name;
        }}
    })
  }

  function viewRoles(listRoles, company) {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/showRoles-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: showRolesCtrl,
      resolve: {
        listRoles: function () {
          return listRoles;
        },
        company: function () {
          return company.descr;
        }}
    })
  }

  function back() {
    if (!!$scope.user && !!$scope.user._id) {
      HighlightId.setId($scope.user._id);
    }
    window.history.back();
  }

  function checkLockedUser() {
    $uibModal.open({
      templateUrl: "app/usersManagement/detail/admin-unlocking-user-panelTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: adminUnlockUserCtrl,
      scope: $scope
    })
  }


  /*
   * The user is submitted and pending approval.

   PENDING = 0;

   /**
   * The user is active (Approved)

   ACTIVE = 1;

   /**
   * The user is deactivated

   INACTIVE = 2;

   /**
   * The user was not approved

   REJECTED = 3;
   */
  $scope.changeUserStatus = function (newStatus) {
    if (newStatus.toUpperCase() === 'INACTIVE') {
        swal({
            title: "User Deactivation",
            text: "Are you sure to DEACTIVATE this user?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, Deactivate It!",
            closeOnConfirm: true
        }, function(isConfirm){
            if (isConfirm) {
                singleUser.put(
                  {
                      id: $scope.user._id,
                      status: 2
                  },
                  function (resource) {
                      $scope.user.status = 'INACTIVE';
                  },
                  function (error) {
                      toastr.error('Failed to deactivate the user');
                  });
            }
        });
    }
    else if (newStatus.toUpperCase() === 'ACTIVE') {
        swal({
            title: "User Activation",
            text: "Are you sure to ACTIVATE this user?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1AB394",
            confirmButtonText: "Yes, Activate It!",
            closeOnConfirm: true
        }, function(isConfirm){
            if (isConfirm) {
                singleUser.put(
                    {
                        id: $scope.user._id,
                        status: 1
                    },
                    function (resource) {
                        $scope.user.status = 'ACTIVE';
                    },
                    function (error) {
                        toastr.error('Failed to activate the user');
                    });
            }
        });
    }

  };

  $scope.reject = function () {

  };

  // config flowjs
  $scope.flowConfig = new Flow({
    target: uploadImage.uploadImagePath($scope.user._id),
    singleFile: true,
    testChunks: false,
    chunkSize : 10000000,
    headers: {
      'Authorization': 'Bearer ' + $auth.getToken()
    }
  });


  $scope.isUploadImageSuccess = function (file, message) {
    if (message) {
      var response = JSON.parse(message);
      toastr.success(response.content.message);
    }
  };

  function getPosition() {
    positionAssignment.get(
      {
        'sort[0][key]': 'updated_at',
        'sort[0][direction]': 'DESC',
        'filter_groups[1][filters][0][key]': 'assignee_id',
        'filter_groups[1][filters][0][value]': $scope.user._id,
        'filter_groups[1][filters][0][operator]': 'ct',
        'filter_groups[2][filters][0][key]': 'status',
        'filter_groups[2][filters][0][value]': 0,
        'filter_groups[2][filters][0][operator]': 'ct',
        limit: 0,
        page: 0
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.positionAssign = resource.content.data;
        }
      },
      function () {
        toastr.error('Failed to retrieve position information.');
      }
    )
  }

  function initialize() {

    $state.params.status = !!$scope.user.status ? $scope.user.status.toLowerCase() : 'all';

    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    /**
     * Check if user.companies is defined
     */
    if(!$scope.user.companies || angular.isUndefined($scope.user.companies)){
      $scope.user.companies = [];
    }
    $scope.systemObject = {};
    $scope.systemObject.descr = 'System';
    $scope.systemObject.code = 'system';
    $scope.systemObject._id = 'system';
    generateSystemArray('roles', 'systemRoles');
    generateSystemArray('positions', 'systemPositions');

    $scope.user.companies.push($scope.systemObject);

    generateArrayPerCompany('cost_centers', 'costCenters');
    generateArrayPerCompany('roles', 'roles');
    generateArrayPerCompany('positions', 'positions');
    generateArrayPerCompany('managers', 'managers');

    $scope.imageBasePath = pathConstants.apiUrls.image.user;

    getPosition();
  }

  initialize();

}

UsersDetailCtrl.$inject = [
  '$scope', '$uibModal', '$state', 'profile', 'toastr', 'singleUser', 'pathConstants', 'uploadImage', '$auth',
  '$rootScope', 'positionAssignment', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('UsersDetailCtrl', UsersDetailCtrl);

'use strict';
/**
 * @name adminUnlockUserCtrl
 * @desc Controller for Admin to Unlock a locked User
 */
function adminUnlockUserCtrl($scope, adminUnlockUser, toastr, $state, $uibModalInstance) {

  $scope.closeModal = closeModal;
  $scope.unlockUser = unlockUser;
  $scope.confirmUnlockUser = confirmUnlockUser;
  $scope.error = false;
  $scope.unlockedLockedUser = false;
  $scope.wrongFormatError = false;


  function confirmUnlockUser() {
    //clearing all the errors
    $scope.wrongFormatError = false;
    $scope.error = false;
    //checks if they pass all the validation
    if (checkPasswordFormat()) {
    }
    else {
      //message about the required password format
      $scope.wrongFormatError = true;
      $scope.error = true;
    }
    if (!$scope.error) {
      adminUnlockUser.put({
          id: $scope.user._id
        }, {
          password: $scope.password_new
        },
        function (success) {
          $uibModalInstance.close();
          toastr.success("User successfully unlocked");
          $state.go($state.current, {}, {reload: true});
        },
        function (error) {
          if (!!error) {
            toastr.error("There was an error in unlocking this user.");
          }
        });
    }
    else {

    }

  }

  function checkPasswordFormat() {
    var letter = /[a-z]/;
    var capitalLetter = /[A-Z]/;
    var number = /[0-9]/;
    return (letter.test($scope.password_new) && number.test($scope.password_new) && $scope.password_new.length > 7 && capitalLetter.test($scope.password_new));
  }

  function unlockUser() {
    $scope.unlockedLockedUser = true;
  }

  function closeModal() {
    $uibModalInstance.close();
  }
}

adminUnlockUserCtrl.$inject = ['$scope', 'adminUnlockUser', 'toastr', '$state', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('adminUnlockUserCtrl', adminUnlockUserCtrl);

/**
 * @name usersDelegationCtrl
 *
 * @description
 * List all the delegations and redirected to user details page
 * when clicked on the list
 *
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';

function usersDelegationCtrl($scope, delegationList, delegations, HighlightId) {
  $scope.showColumn = showColumn;
  $scope.getDelegationStatus = getDelegationStatus;

  $scope.storageKey = 'delegation-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function getDelegationStatus(status) {
    switch(status) {
      case 0:
        return 'Planned';
      case 1:
        return 'Active';
      case 2:
        return 'Cancelled';
      case 3:
        return 'Finished';
    }
  }

  function initialize(){
    $scope.dataList = delegationList.data;
    $scope.meta = delegationList.meta;
    $scope.delegationsService = delegations;
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
  }

  initialize();

}

usersDelegationCtrl.$inject = ['$scope', 'delegationList', 'delegations', 'HighlightId'];

angular
  .module('metabuyer')
  .controller('usersDelegationCtrl', usersDelegationCtrl);

'use strict';
/**
 * @name userCostCenterCtrl
 * @desc Controller for Admin to select cost center for a user
 */
function userCostCenterCtrl($scope, userCostCenters, $uibModalInstance) {
  $scope.userCostCenters = userCostCenters;
  $scope.closeModal = closeModal;
  $scope.columnCostCenter = {

    selectedItemsLength: function () {

      return _.filter($scope.userCostCenters, function (cc) {
        return cc.selected == true;
      }).length;
    },

    checkAllItems: function () {
      if ($scope.columnCostCenter.selected_all_cc) {
        checkCC_list();
        _.forEach($scope.userCostCenters, function (cc) {
          cc.selected = true;
          $scope.user.cc_list.push(cc.code);
        });
      } else {
        _.forEach($scope.userCostCenters, function (cc) {
          checkCC_list();
          cc.selected = false;
        });
      }
    },

    selectedItem: function (cc) {
      if (!!cc.selected) {
        $scope.columnCostCenter.selected_all_cc = ($scope.userCostCenters.length > 0 &&
          $scope.columnCostCenter.selectedItemsLength() == $scope.userCostCenters.length);
        $scope.user.cc_list.push(cc.code);
      } else {
        $scope.columnCostCenter.selected_all_cc = false;
        for(var i = 0; i < $scope.user.cc_list.length; i++){
          if(cc.code === $scope.user.cc_list[i]){
            $scope.user.cc_list.splice(i,1);
          }
        }
      }
    }

  };

  function checkCC_list(){
    //manually clear the cc_list for the modal
    for(var i =0;i<$scope.user.cc_list.length;i++)
    {
      for(var j=0; j<userCostCenters.length;j++)
      {
        if($scope.user.cc_list[i] === userCostCenters[j].code)
        {
          $scope.user.cc_list.splice(i,1);
        }
      }
    }
  }
  //check if the costCenter has been selected
  var counter = 0;
  for(var i =0;i<$scope.user.cc_list.length;i++)
  {
    for(var j=0; j<userCostCenters.length;j++)
    {
      if($scope.user.cc_list[i] === userCostCenters[j].code)
      {
        userCostCenters[j].selected = true;
        //add a simple counter to make the top value checked in case all Cost Centers were chosen
        counter ++;
      }
    }
  }
  //verify the counter
  if(counter === $scope.userCostCenters.length)
  {
    $scope.columnCostCenter.selected_all_cc = true;
  }
  function closeModal() {
    $uibModalInstance.close();
  }
}

userCostCenterCtrl.$inject = ['$scope', 'userCostCenters', '$uibModalInstance'];

angular
  .module('metabuyer')
  .controller('userCostCenterCtrl', userCostCenterCtrl);

'use strict';
/**
 * @name UsersAddUserCtrl
 * @desc Controller for users details
 */
function UsersAddUserCtrl($scope, $q, $resource, $state, Users, toastr, companiesForAdminUse,
                          $uibModal, globalFunc, companyCostCenters, $rootScope) {

  $scope.selectCostCenter = selectCostCenter;
  $scope.duplicationCheck = duplicationCheck;
  $scope.generatePassword = generatePassword;
  $scope.selectedEmailFrequency = selectedEmailFrequency;
  $scope.randomPassword = false;
  $scope.submitted = false;

  $scope.addUser = addUser;

    $scope.options = {
    companies: companiesForAdminUse,
    user_group: [],
    languages: [],
    timezones: [],
    countries: []
  };

  $scope.emailFrequency = [
    {descr: 'Immediate', value: true},
    {descr: 'End of Day', value: false}
  ];

  function selectedEmailFrequency(value){
    $scope.user.receive_email_immediate = value;
  }

  $scope.submitted = false;

  $scope.user = {};
  $scope.user.companies = [];
  //TODO: remove redundant variables (Ahmed Saleh, 10/07/2017)
  $scope.user.cc_list = [];
  $scope.user.roles = [];
  $scope.user.roles_id = [];
  $scope.deselectedCC = {};

  function deselectCompany (companyID){
    companyCostCenters.get(
      {
        id: companyID
      },
      function(resource){
        $scope.deselectedCC = resource.content.data;
        for(var k =0;k<$scope.user.cc_list.length;k++)
        {
          for(var l=0; l<$scope.deselectedCC.length;l++)
          {
            if($scope.user.cc_list[k] === $scope.deselectedCC[l].code)
            {
              $scope.user.cc_list.splice(k,1);
            }
          }
        }
      }
    );
  }
  $scope.message_error = {};

  $scope.selected_options = {
    companies:[],
    user_group: [],
    languages: [],
    timezones: [],
    countries: []
  };

  //setting for company multi-select dropdown list
  $scope.settingCompany = {smartButtonMaxItems: 1,
    scrollable: true,
    idProp: "_id",
    externalIdProp: "",
    displayProp: "descr",
    enableSearch: true,
    enableSortOnTop: true,
    closeOnSelect: true,
    smartButtonTextConverter: function(itemText, originalItem) { return "Add a company"; }};

  $scope.defaultCompanyButtonText = {buttonDefaultText: "Add a company"};

  $scope.companyItemEvent = {
    onItemSelect: function(selected_company_item){
      $scope.user.companies.push(selected_company_item);
      var current_company = _.find($scope.selected_options.companies, function(company){
        return company._id == selected_company_item._id;
      });
    },

    onItemDeselect: function(selected_company_item){
      deselectCompany(selected_company_item._id);
    }
  };

  //load option
  $scope.loadOptions = function (url, params, options, paramValues, scopeOptionName) {
    if ($scope.options[scopeOptionName].length > 0) {
      return $scope.options[scopeOptionName];
    }

    var deferred = $q.defer();
    $resource(
      url,
      params,
      options
    ).get(
      paramValues,
      function (resource) {
        $scope.options[scopeOptionName] = resource.content.data;
        deferred.resolve(resource.data);

      }
    );

    return deferred.promise;
  };

  $scope.loadOptionsSimple = function (url, scopeOptionName) {
    return $scope.loadOptions(url, {}, {}, {}, scopeOptionName);
  };

  //load user group
  $scope.loadUserGroup = function () {
    //return $scope.loadOptionsSimple(pathConstants.apiUrls.companies.list, 'user_group');

    $scope.options['user_group'] = [{name: "Users", id:1}, {name:"Admin", id:2}, {name: "Procurement Agents", id: 3}];
    $scope.selected_options['user_group'] = [$scope.options.user_group[0]];
  };

  //load countries
  $scope.loadCountries = function () {
    //return $scope.loadOptionsSimple(pathConstants.apiUrls.companies.list, 'countries');

    $scope.options['countries'] = globalFunc.countryCode();

//    $scope.selected_options['country'] = {selected: $scope.options.countries[0]};
  };


  function selectCostCenter(selected_company){
    $uibModal.open({
      templateUrl: "app/usersManagement/add/user-costcenter-modalTemplate.html",
      backdrop: 'static',
      keyboard: false,
      controller: userCostCenterCtrl,
      scope: $scope,
      resolve:{
        userCostCenters: function($q,companyCostCenters){
          var deferred = $q.defer();
          companyCostCenters.get(
            {
              id: selected_company._id
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content.data);
              }
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        }
      }
  })
  }

  $scope.validateInputData = function(){

    //validate password
    if (!$scope.user.password || !$scope.user.password.length)
      return false;
    if (!!$scope.user.password && $scope.user.password.length < 8) {
      $scope.message_error.password_length = true;
      return false;
    }
    if (!$scope.user.name || !$scope.user.email || !$scope.user.employee_number)
      return false;
    if (!$scope.selected_options.country || (!!$scope.selected_options.country && !$scope.selected_options.country.selected))
      return false;

    return true;
  };

  $scope.cancelAddUser = function(){
    $state.go('main.user.users.manage', {status:'active'});
  };

  //upload user detail
  function addUser (){
    $scope.submitted = true;

    if(!$scope.validateInputData()){
      toastr.error('Please fill all required fields');
      $scope.submitted = false;
      return;
    }

    var submit_data = {
      display_name: $scope.user.name,
      email: $scope.user.email,
      send_email: $scope.user.send_email,
      password: $scope.user.password,
      //TODO: remove safely (Ahmed Saleh, 10/07/2017)
      img_url: 'http://lorempixel.com/128/128/people/?16748',
      cc_list: getSelectedCCList(),
      receive_email_immediate: $scope.user.receive_email_immediate,
      emp_no: $scope.user.employee_number,
      config: {
        lang: 'EN-US',
        TZ: 'Asia/Kuala_Lumpur',
        country: $scope.selected_options.country.selected.descr,
        mobile: $scope.user.mobile
      },
      roles: getSelectedRolesList(),
      superiors: getSuperiorFormattedInfo()
    };

    $scope.user.cc_list = getSelectedCCList();
    $scope.user.roles = getSelectedRolesList();

    Users.post(
      {},
    submit_data,
      function () {
        toastr.success('User has been added successfully');
        $state.go('main.user.users.manage', {status: 'Active'});
      },
      function () {
        //TODO: the error from the backend is not clean, fix from backend then update the error to use globalFunc (Ahmed Saleh, 3/2/2017)
        $scope.submitted = false;
        if($scope.user.cc_list.length === 0){
          toastr.error('Selected companies does not have cost centers!');
        }
        else if($scope.user.roles.length === 0){
          toastr.error('There are no roles assigned to user!');
        }
        else{
          toastr.error('User failed to be added');
        }
      });
  }

  function generatePassword(){
    $scope.user.password = globalFunc.generateRandomPassword();
    $scope.randomPassword = true;
    $scope.user.send_email = true;
  }

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model,field,value,checker){
    globalFunc.duplicationCheck(model,field,value,checker, function(callback){
      switch (callback){
        case 'emailCheckTrue':
          $scope.emailCheck = true;
          break;
        case 'empCheckTrue':
          $scope.empCheck = true;
          break;
        case 'emailCheckFalse':
          $scope.emailCheck = false;
          break;
        case 'empCheckFalse':
          $scope.empCheck = false;
          break;
      }
    });
  }

  function getSelectedCCList(){
    var list = [];
    _.forEach($scope.user.companies, function(company){
      _.forEach(company.CCs.selected, function (costCenter) {
          list.push(costCenter.code);
      });
    });
    return list;
  }

  function getSelectedRolesList() {
    var list = [];
    _.forEach($scope.user.companies, function (company) {
      _.forEach(company.roles.selected, function (role) {
        list.push(role._id);
      });
    });
    return list;
  }

  function getSuperiorFormattedInfo() {
    var list = {};
    _.forEach($scope.user.companies, function(company) {
      if(!!company.superior.selected && !!company.superior.selected._id) {
        list[company.code] = company.superior.selected._id;
      }
    });
    return list;
  }

  function initialize(){
    var tabData = {
      tab: $scope.$parent.tabData[1],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();
}

UsersAddUserCtrl.$inject = ['$scope', '$q', '$resource', '$state', 'Users', 'toastr', 'companiesForAdminUse',
                            '$uibModal', 'globalFunc', 'companyCostCenters', '$rootScope'];

angular
  .module('metabuyer')
  .controller('UsersAddUserCtrl', UsersAddUserCtrl);



'use strict';

angular
  .module('metabuyer')
  .controller('UserWaitingOnYouCtrl', UserWaitingOnYouCtrl);

/**
 * @name UserWaitingOnYouCtrl
 * @desc Controller for User Waiting on you
 */
function UserWaitingOnYouCtrl($scope, $state, waitingList, waitingOnUserList, $rootScope) {
  $scope.dataList = waitingList.data;
  $scope.meta = waitingList.meta;
  $scope.waitingService = waitingOnUserList;
  //TODO: 'nofifyWaitingOnFavico' is calling parent parent controller (user.controller) to use the function, have this centralized (Ahmed Saleh)
  $scope.nofifyWaitingOnFavico($rootScope.waitings);
  $rootScope.$broadcast('newWaitingList');
  $scope.redirectTo = function (item) {
    switch (item.context_type) {
      case 'Metabuyer\\PR\\PR':
      {
        $state.go('main.user.purchaseRequisitions.details', {
          id: item.context_id,
          status: 'pending',
          action: 'access_directly',
          from: "waiting-on-you",
          title: undefined
        });
        break;
      }
      case 'Metabuyer\\Models\\Supplier':
      {
        $state.go('main.user.suppliers.detail', {
          id: item.context_id,
          title: undefined
        });
        break;
      }
      case 'Metabuyer\\Models\\ImportItemSummary':
      {
        $state.go('main.user.items.detail', {
          id: item.context_id,
          //assuming waiting on will only results on a pending item import.
          //this is to be fixed once a panel is created to access the archived approved operations
          status: 'pending',
          title: undefined
        });
        break;
      }
      case 'Metabuyer\\Budget\\Models\\Budget': {
        $state.go('main.user.budget.details', {
          id: item.context_id
        });
        break;
      }
    }
  };

  function dataCleanUp() {
    _.forEach($scope.dataList, function (item) {
      if (item.context_type === 'Metabuyer\\Models\\Supplier') {
        item.displayCategory = 'Supplier';
      }
      if (item.context_type === 'Metabuyer\\Models\\ImportItemSummary') {
        item.displayCategory = 'Catalog Approval';
      }
      if (item.context_type === 'Metabuyer\\PR\\PR') {
        item.displayCategory = 'Purchase Requisition';
      }
      if (item.context_type === 'Metabuyer\\Budget\\Models\\Budget') {
        item.displayCategory = 'Budget';
      }
    });
  }

  dataCleanUp();

}
UserWaitingOnYouCtrl.$inject = ['$scope', '$state', 'waitingList', 'waitingOnUserList', '$rootScope'];

'use strict';

/**
 * @name underMaintenanceCtrl
 *
 * @desc Controller for displaying page for underMaintenance
 *
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright  Metacloud Sdn. Bhd. &copy; 2016
 */

function underMaintenanceCtrl($rootScope) {

  //applying CSS for the page on the controller level
  $rootScope.bodyClasses = 'gray-bg';
}

underMaintenanceCtrl.$inject = ['$rootScope'];

angular
  .module('metabuyer')
  .controller('underMaintenanceCtrl', underMaintenanceCtrl);

'use strict';
/**
 * @name unauthorizedBudgetAccessCtrl
 * @desc Controller for displaying page for unauthorized access to budget module
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function unauthorizedBudgetAccessCtrl($scope, $rootScope, $state) {

  //applying CSS for the page on the controller level
  $rootScope.bodyClasses = 'gray-bg';
}

unauthorizedBudgetAccessCtrl.$inject = ['$scope', '$rootScope', '$state'];

angular
  .module('metabuyer')
  .controller('unauthorizedBudgetAccessCtrl', unauthorizedBudgetAccessCtrl);

'use strict';
/**
 * @name passwordResetCtrl
 * @desc Controller for Users to enter their new password after it has been reset
 */
function passwordResetCtrl($scope, $rootScope, passwordUpdate, $state, toastr, ManageLocalStorage, $auth) {
  $scope.updatePassword = updatePassword;

  $scope.isChangePasswordClicked = false;
  $scope.errorFlag = false;
  $scope.missMatchError = false;
  $scope.wrongFormatError = false;

  $scope.logout = logout;

  //TODO: use the services of metabuyer (Ahmed Saleh, 31/5/2016)
  function logout() {
    ManageLocalStorage.clearLocalStorage();
    window.localStorage.removeItem('satellizer_token');
    $auth.logout();
    $rootScope.currentUser = null;
    $state.go('login');
    toastr.clear();
  }

  function updatePassword() {
    //clearing all the errors
    $scope.wrongFormatError = false;
    $scope.missMatchError = false;
    $scope.errorFlag = false;
    //checks if they pass all the validation
    if (checkPasswordFormat()) {
      if (!checkMatchPassword()) {
        //message that the new password didn't match
        $scope.missMatchError = true;
        $scope.errorFlag = true;
      }
    }
    else {
      //message about the required password format
      $scope.wrongFormatError = true;
      $scope.errorFlag = true;
    }
    if (!$scope.errorFlag) {
      passwordUpdate.put({
          password: $scope.password_new,
          password_confirm: $scope.password_confirm

        },
        function (success) {
          toastr.clear();
          toastr.success("Successfully changed password");
          $state.go("main.user.mainMenu.waiting-on-you");
        },
        function (error) {
          if (!!error && !!error.data) {
            if (parseInt(error.data.http_code) === 400) {
              toastr.error((!!error.data.message) ? error.data.message :
                (!!error.data.content && !!error.data.content.error) ? error.data.content.error : 'Failed to change password');
              $scope.errorFlag = true;
            }
          }
        });
    }
    else {

    }

  }

  function checkPasswordFormat() {
    var letter = /[a-z]/;
    var capitalLetter = /[A-Z]/;
    var number = /[0-9]/;
    return (letter.test($scope.password_new) && number.test($scope.password_new) && $scope.password_new.length > 7 && capitalLetter.test($scope.password_new));
  }

  function checkMatchPassword() {
    return $scope.password_new === $scope.password_confirm;
  }

}

passwordResetCtrl.$inject = ['$scope', '$rootScope', 'passwordUpdate', '$state', 'toastr', 'ManageLocalStorage', '$auth'];

angular
  .module('metabuyer')
  .controller('passwordResetCtrl', passwordResetCtrl);

'use strict';

/**
 * @name UserNotificationsCtrl
 * @desc Controller for User Notifications with unread and all
 * @subTabs The two subTabs check for unread or all, when passed will filter based on the parameter
 */
function UserNotificationsCtrl($scope, $rootScope, notificationList, notificationListing, $stateParams, toastr, readNotificationList, globalFunc){

  $scope.notifications = notificationListing.data;
  $scope.service = notificationList;
  $scope.meta = notificationListing.meta;

  $scope.getClassName = getClassName;

  $scope.initialize = initialize;
  var unreadNotification;

  if(!!$rootScope.notifications && !!$rootScope.notifications.data){
    unreadNotification = $rootScope.notifications.data;
  }

  if($stateParams.subTab === 'unread' && $scope.notifications.length > 0) {
    var count = $scope.notifications.length;
    if(!!notificationListing.meta && !!notificationListing.meta.cursor && !!notificationListing.meta.cursor.count){
      count = Number(notificationListing.meta.cursor.count) - count;
      var ids = [];
      _.forEach(unreadNotification, function (notif) {
        if (!!notif._id) {
          ids.push(notif._id);
        }
      });
    }
    if (ids.length > 0) {
      readNotificationList.post({
            notification_ids: ids
          }, function () {
            $rootScope.$broadcast('notificationsHaveBeenRead', count);
          }, function () {
            toastr.error("Can't make notification as read");
          });
    }
  }

  /**
   * Function to get the class name at the end of metabuyer\models\
   * @param string
   * @returns {*}
   */
  function getClassName(string){
    var className = string.substring(string.indexOf('Models') + 7);
    // add space to the front of each capital letter
    return className.replace(/([A-Z]+)/g, ' $1').trim();
  }

  /**
   * function to reformat the PR and Suppliers as the object is not consistent
   * The Escalation Part is calculated in the HTML part
   */
  function reformatNotifications() {
    var additionalInfo;
    for (var i in $scope.notifications) {

      additionalInfo = $scope.notifications[i].additional_info;

      if (!!$scope.notifications[i].changeType && !!$scope.notifications[i].class &&
        ($scope.notifications[i].class.toLowerCase() === 'metabuyer\\pr\\pr' ||
        $scope.notifications[i].class.toLowerCase() === 'metabuyer\\models\\pr')) {

        //getting the Reference Number from the PR object
        var prObject = globalFunc.findObjectInArrayWithKeyValue(additionalInfo, 'pr');
        if (!!prObject)
          $scope.notifications[i].prNumber = prObject.reference;
      } else if (!!$scope.notifications[i].changeType && !!$scope.notifications[i].class &&
        $scope.notifications[i].class.toLowerCase() === 'metabuyer\\models\\supplier') {

        var supplier = globalFunc.findObjectInArrayWithKeyValue(additionalInfo, 'supplier');
        if (!!supplier) {
          $scope.notifications[i].supplierDescr = supplier.descr;
          if (!!supplier.parent_id)
            $scope.notifications[i].object_id = supplier.parent_id;
        }
      } else if (!!$scope.notifications[i].changeType && !!$scope.notifications[i].class &&
        $scope.notifications[i].class.toLowerCase() === 'metabuyer\\budget\\models\\budget') {
        var budget = globalFunc.findObjectInArrayWithKeyValue(additionalInfo, 'budget');
        if (!!budget) {
          $scope.notifications[i].budgetNumber = budget.code;
        }
      }
    }
  }

  function initialize(){
    $scope.selectedListTab = 'unread';

    if($stateParams.subTab === 'all'){
      $scope.selectedListTab = 'all';
    } else if($stateParams.subTab === 'unread'){
      $scope.selectedListTab = 'unread';
    }
    reformatNotifications();
  }
  $scope.initialize();
}

UserNotificationsCtrl.$inject = [
  '$scope', '$rootScope', 'notificationList', 'notificationListing', '$stateParams', 'toastr', 'readNotificationList', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('UserNotificationsCtrl', UserNotificationsCtrl);

'use strict';
/**
 * @name notAuthorizedCtrl
 * @desc Controller for displaying page for unauthorized access
 * @author Justin 29/12/2015
 */
function notAuthorizedCtrl($scope, $rootScope, $state) {

  //applying CSS for the page on the controller level
  $rootScope.bodyClasses = 'gray-bg';
}

notAuthorizedCtrl.$inject = ['$scope', '$rootScope', '$state'];

angular
  .module('metabuyer')
  .controller('notAuthorizedCtrl', notAuthorizedCtrl);

/**
 * @name mainMenuCtrl
 *
 * @requires $scope
 * @requires $rootScope
 * @requires waitingOnUserList (Metabuyer service)
 * @requires unreadNotificationList (Metabuyer service)
 *
 *
 * @description
 *
 * The Main Menu Controller handles the the three main components (Waiting on you, Notifications and Profile)
 *
 * The notifications and waiting on you counts and data are stored in the $rootScope
 * as this data is used as part of the main information
 * and is shown in different panels
 *
 * @listener notificationsHaveBeenRead
 * is used to to update the counter in the Tab of the main menu navigation bar
 *
 * @listener newNotifications
 * is used to update the count of the notifications once new notifications have been received
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */
'use strict';

function mainMenuCtrl($scope, $rootScope, unreadNotificationList, $state) {

  var cNotifications = '';

  var cWaitings = '';
  $scope.tabData = [
    {
      heading: 'Waiting on you ' + cWaitings,
      route: 'main.user.mainMenu.waiting-on-you',
      key: 'waiting'
    },
    {
      heading: 'Notifications ' + cNotifications,
      route: 'main.user.mainMenu.notifications',
      key: 'notification'
    },
    {
      heading: 'Settings',
      route: 'main.user.mainMenu.userProfile',
      key: 'settings'
    }
  ];

  $scope.$emit('pageTitleChanged', $rootScope.currentUser.display_name );

  /**
   * removed from the Resolve to make the list updated dynamically
   */
  unreadNotificationList.get(
    {
      offset: 1000
    },
    function (resource) {
      if (!!resource.content) {
        $rootScope.notifications = resource.content;
        $rootScope.$broadcast('newNotifications');
        initialize();
      }
    },
    function (error) {
      if (error.status === 404) {
      }
    }
  );

  function initialize() {
    if(!!$rootScope.notifications && !!$rootScope.notifications.meta && !!$rootScope.notifications.meta.cursor) {
      cNotifications = $rootScope.notifications.meta.cursor.count ?
      '(' + $rootScope.notifications.meta.cursor.count + ')' : '';
    }

    if(!!$rootScope.waitings && !!$rootScope.waitings.meta && !!$rootScope.waitings.meta.cursor) {
      cWaitings = $rootScope.waitings.meta.cursor.count ?
      '(' + $rootScope.waitings.meta.cursor.count + ')' : '';
    }

    $scope.tabData[1].heading = 'Notifications ' + cNotifications;
    $scope.tabData[0].heading = 'Waiting on you ' + cWaitings;

    if(!!$state.current.name) {
      if (!!$state.current.name && $state.current.name.indexOf('userProfile') > -1) {

        if(!!$scope.$parent)
          $scope.$parent.activatedTab = $scope.tabData[2];
        else
          $scope.activatedTab = $scope.tabData[2];

      } else if (!!$state.current.name && $state.current.name.indexOf('notifications') > -1) {

        if(!!$scope.$parent)
          $scope.$parent.activatedTab = $scope.tabData[1];
        else
          $scope.activatedTab = $scope.tabData[1];

      } else {

        if(!!$scope.$parent)
          $scope.$parent.activatedTab = $scope.tabData[0];
        else
          $scope.activatedTab = $scope.tabData[0];

      }
    }

  }



  //Listeners for notifications listing
  $scope.$on('notificationsHaveBeenRead', function (event, count) {
    if (count > 0) {
      $scope.tabData[1].heading = 'Notifications' + ' (' + count + ')';
    } else {
      $scope.tabData[1].heading = 'Notifications';
    }
    if(!!$rootScope.notifications && !!$rootScope.notifications.meta && !!$rootScope.notifications.meta.cursor){
      if(count > 0) {
        $rootScope.notifications.meta.cursor.count = count;
      }else{
        $rootScope.notifications.meta.cursor.count= null;
      }
    }
  });
  $scope.$on('newNotifications', function () {
    if (!!$rootScope.notifications && !!$rootScope.notifications.meta && !!$rootScope.notifications.meta.cursor) {
      var cNotifications = $rootScope.notifications.meta.cursor.count ?
        '(' + $rootScope.notifications.meta.cursor.count + ')' : '';
    }
    $scope.tabData[1].heading = 'Notifications ' + cNotifications;
  });

  //Listener for waiting on you listing
  $scope.$on('newWaitingList', function () {
    if (!!$rootScope.waitings && !!$rootScope.waitings.meta && !!$rootScope.waitings.meta.cursor) {
      var cWaitings = $rootScope.waitings.meta.cursor.count ?
        '(' + $rootScope.waitings.meta.cursor.count + ')' : '';
    }
    $scope.tabData[0].heading = 'Waiting on you ' + cWaitings;
  });

  initialize();

}
mainMenuCtrl.$inject = ['$scope', '$rootScope', 'unreadNotificationList', '$state'];
angular
  .module('metabuyer')
  .controller('mainMenuCtrl', mainMenuCtrl);

'use strict';

/**
 * @name invalidUrlCtrl
 *
 * @desc Controller for displaying page for invalid url
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright  Metacloud Sdn. Bhd. &copy; 2016
 */

function invalidUrlCtrl($scope, $rootScope, pathConstants) {

  // applying CSS for the page on the controller level
  $rootScope.bodyClasses = 'gray-bg';

  // Get the environment's url for redirection
  $scope.environmentUrl = pathConstants.environmentUrl;
}

invalidUrlCtrl.$inject = ['$scope', '$rootScope', 'pathConstants'];

angular
  .module('metabuyer')
  .controller('invalidUrlCtrl', invalidUrlCtrl);

'use strict';

angular
  .module('metabuyer')
  .controller('UserActivityCtrl', UserActivityCtrl);

/**
 * @name UserActivityCtrl
 * @desc Controller for User Activity
 */
function UserActivityCtrl($scope){

}
UserActivityCtrl.$injecct = ['$scope'];
'use strict';
/**
 * @name accountLockedCtrl
 * @desc Controller for displaying page for locked accounts
 */
function accountLockedCtrl($scope, $rootScope, $state, ManageLocalStorage, $auth) {

  //applying CSS for the page on the controller level
  $rootScope.bodyClasses = 'gray-bg';

  $scope.logout = logout;

  function logout() {
    ManageLocalStorage.clearLocalStorage();
    window.localStorage.removeItem("satellizer_token");
    window.localStorage.removeItem("email");
    $auth.logout();
    $rootScope.currentUser = null;
    $state.go('login');
  }
}

accountLockedCtrl.$inject = ['$scope', '$rootScope', '$state', 'ManageLocalStorage', '$auth'];

angular
  .module('metabuyer')
  .controller('accountLockedCtrl', accountLockedCtrl);

'use strict';

function supplierVersionsController(
  $scope, supplierVersions, $uibModalInstance, $uibModal, supplierStatus, versionType
) {
  $scope.versions = supplierVersions;
  $scope.checkedVersion = [];
  $scope.currentStatus = supplierStatus;
  $scope.versionType = versionType;

  $scope.closeModal = closeModal;
  $scope.selectVersion = selectVersion;
  $scope.compareVersions = compareVersions;

  function selectVersion(supplierId, checked) {
    if (!!checked)
      $scope.checkedVersion.push(supplierId);
    else {
      var valIndex = $scope.checkedVersion.indexOf(supplierId);
      if (valIndex > -1)
        $scope.checkedVersion.splice(valIndex, 1);
    }
  }

  function compareVersions() {
    closeModal();
    $uibModal.open({
      templateUrl: 'app/suppliersManagement/versions/comparison.html',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'revision-wrapper',
      size: 'lg',
      resolve: {
        versions: function() {
          return $scope.versions;
        },
        selectedVersion: function() {
          return $scope.checkedVersion;
        },
        currentStatus: function() {
          return $scope.currentStatus;
        },
        versionType: function() {
          return $scope.versionType;
        }
      },
      controller: 'compareSupplierVersionCtrl'
    });
  }

  function closeModal() {
    $uibModalInstance.close();
  }
}

supplierVersionsController.$inject = [
  '$scope', 'supplierVersions', '$uibModalInstance', '$uibModal', 'supplierStatus', 'versionType'
];

angular.module('metabuyer')
  .controller('supplierVersionsController', supplierVersionsController);

'use strict';

function compareSupplierVersionCtrl(
  $scope, $uibModalInstance, $uibModal, versions, selectedVersion, globalFunc, currentStatus, versionType
) {
  $scope.closeComparisonModal = closeComparisonModal;
  $scope.compareArrayValue = compareArrayValue;
  $scope.compareAttachmentDescriptionVersion = compareAttachmentDescriptionVersion;

  $scope.currentStatus = currentStatus;
  $scope.versionType = versionType;

  function closeComparisonModal() {
    // Remove row highlighting
    clearHasUpdateFlag();

    $uibModalInstance.close();
    $uibModal.open({
      templateUrl: 'app/suppliersManagement/versions/supplier-versions.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        supplierVersions: function() {
          return versions;
        },
        supplierStatus: function() {
          return $scope.currentStatus;
        },
        versionType: function () {
          return versionType;
        }
      },
      controller: 'supplierVersionsController'
    });
  }

  /**
   * compare Arrays value
   * @param array1
   * @param array2
   * @param fieldToCompare
   * @returns {boolean}
   */
  function compareArrayValue(array1, array2, fieldToCompare) {
    var arrIteration;

    if (!array1 || !array2)
      return false;

    if(array1.length !== array2.length)
      return false;

    for (arrIteration in array1) {
      if (array1.hasOwnProperty(arrIteration)) {
        var checkValInArray2 = globalFunc.findInArray(array2, fieldToCompare, array1[arrIteration][fieldToCompare]);
        if (!checkValInArray2)
          return false;
      }
    }

    return true;
  }

  /**
   * comparing attachment description version
   * @param prevAttachment
   * @param newAttachment
   * @return  {boolean}
   */
  function compareAttachmentDescriptionVersion(prevAttachment, newAttachment) {
    var comparison = true;
    if (!prevAttachment || !newAttachment)
      comparison = false;

    if(prevAttachment.length !== newAttachment.length)
      comparison = false;

    _.forEach(prevAttachment, function (prev) {
      // get the same data from newAttachment
      if (!!prev._id) {
        var attachmentDesc = globalFunc.findInArray(newAttachment, '_id', prev._id);
        if (!!attachmentDesc && !!attachmentDesc.attachment_category && !!attachmentDesc.attachment_detail &&
            !!attachmentDesc.description_array && !!prev.attachment_detail && prev.attachment_category &&
            !!attachmentDesc.description_array && !!prev.description_array) {
          // compare the attachment category
          if (attachmentDesc.attachment_category._id !== prev.attachment_category._id) {
            comparison = false;
            return false;
          }

          if (attachmentDesc.attachment_detail._id !== prev.attachment_detail._id) {
            comparison = false;
            return false;
          }

          if (prev.description_array.length !== attachmentDesc.description_array.length) {
            comparison = false;
            return false;
          }

          _.forEach(prev.description_array, function (field) {
            if (!!field._id) {
              var attachmentDescField = globalFunc.findInArray(attachmentDesc.description_array, '_id', field._id);
              if (!!attachmentDescField) {
                if (field.value !== attachmentDescField.value) {
                  comparison = false;
                  return false;
                }
              } else {
                comparison = false;
                return false;
              }
            }
          });
        } else {
          comparison = false;
        }
      }
    });
    return comparison;
  }

  function checkBranchDifferences(array1, array2) {
    // Remove row highlighting
    clearHasUpdateFlag();

    var hasDifferences = !_.isEqual(array1,array2);
    if (!!hasDifferences) {
      _.forEach($scope.supplierVersions[0].branches, function(branch, index){
        if (!_.isEqual(branch,$scope.supplierVersions[1].branches[index])) {
          branch.hasUpdate = true;
        }
      });

      _.forEach($scope.supplierVersions[1].branches, function(branch, index){
        if (!_.isEqual(branch,$scope.supplierVersions[0].branches[index])) {
          branch.hasUpdate = true;
        }
      });

    }
    return hasDifferences;
  }

  /**
   * Set hasUpdate attribute for branch to false to clear the flag
   *
   * @returns void
   */
  function clearHasUpdateFlag() {
    _.forEach($scope.supplierVersions[0].branches, function(branch){
      branch.hasUpdate = false;
    });

    _.forEach($scope.supplierVersions[1].branches, function(branch){
      branch.hasUpdate = false;
    });
  }

  function initialize() {
    $scope.supplierVersions = [];
    _.forEach(versions, function (version) {
      if (selectedVersion.indexOf(version._id) > -1)
        $scope.supplierVersions.push(version);
    });
    $scope.branchChanges = checkBranchDifferences($scope.supplierVersions[0].branches,$scope.supplierVersions[1].branches);
  }

  initialize();
}

compareSupplierVersionCtrl.$inject = [
  '$scope', '$uibModalInstance', '$uibModal', 'versions', 'selectedVersion', 'globalFunc', 'currentStatus',
  'versionType'
];

angular.module('metabuyer')
  .controller('compareSupplierVersionCtrl', compareSupplierVersionCtrl);

'use strict';

function newSupplierCtrl(
  $scope, $q, toastr, taxes, draftSupplier, paymentMethods, paymentTerms, $stateParams, $state, currencies, HighlightId,
  addressList, globalFunc, $http, $filter, pathConstants, searchModule, listChild, supplierGlobalFunc,
  attachmentDescription, ngIntlTelInput
) {

  var supplierAttachment  = [];

  $scope.checkAddress = false;
  $scope.supplier = {};
  $scope.approvals = [];
  $scope.taxes = taxes;
  $scope.paymentMethods = paymentMethods.data;
  $scope.paymentTerms = paymentTerms.data;
  $scope.selectedContactPersons = [];
  $scope.freightTerms = [];
  $scope.supplier.corresponding_address_id = '';
  $scope.currencies = currencies;
  $scope.address = {};
  $scope.closeTreeSearchPrimary = false;
  $scope.closeTreeSearchSecondary = false;
  $scope.commodityLevel = [3,4];
  $scope.supplier.additionalFile = [];
  $scope.status_reason = '';

  $scope.backToListingSupplier = backToListingSupplier;
  $scope.saveNewSupplier = saveNewSupplier;
  $scope.getPaidUpCategory = getPaidUpCategory;
  $scope.onSelectedTax = onSelectedTax;
  $scope.onSelectedBusinessEntity = onSelectedBusinessEntity;
  $scope.onSelectedPaymentTerm = onSelectedPaymentTerm;
  $scope.onSelectedCurrency = onSelectedCurrency;
  $scope.onSelectedPaymentMethod = onSelectedPaymentMethod;
  $scope.onUpdatedContact = onUpdatedContact;
  $scope.onAddedContact = onAddedContact;
  $scope.removeContact = removeContact;
  $scope.saveAddress = saveAddress;
  $scope.addNewSupplier = addNewSupplier;
  $scope.duplicationCheck = duplicationCheck;
  $scope.validateNumbers = validateNumbers;
  $scope.settingContacts = settingContacts;
  $scope.selectedBumiputra = selectedBumiputra;
  $scope.validatePrimaryBusinessNature = validatePrimaryBusinessNature;
  $scope.validateSecondaryBusinessNature = validateSecondaryBusinessNature;
  $scope.onSelectedState = onSelectedState;
  $scope.onSelectedCountry = onSelectedCountry;
  $scope.removeSecondaryCommodity = removeSecondaryCommodity;
  $scope.searchPrimaryCommodityCode = searchPrimaryCommodityCode;
  $scope.searchSecondaryCommodityCode = searchSecondaryCommodityCode;
  $scope.openChildCommodityCodePrimary = openChildCommodityCodePrimary;
  $scope.openChildCommodityCodeSecondary = openChildCommodityCodeSecondary;
  $scope.checkHyphenFirstCharacter = checkHyphenFirstCharacter;

  function checkHyphenFirstCharacter(string, field) {
    if (!!string) {
      $scope.descrFirstCharHyphen = supplierGlobalFunc.checkHyphenFirstCharacter(string);
    }

    return $scope.descrFirstCharHyphen;
  }

  function searchPrimaryCommodityCode(keyword){
    if(!!keyword && keyword.length > 1){
      searchModule.get(
        {
          module: 'commodity',
          'criteria[0][code]': keyword,
          'criteria[0][descr]': keyword,
          'criteria[0][$operator]': 'or',
          'criteria[1][is_active]': 1,
          order: 1,
          order_by: 'code',
          offset: 0
        }, function (resource) {
          if (!!resource && !!resource.content && !!resource.content.data)
            $scope.primaryCommodityCodes = resource.content.data;
        }, function () {
          $scope.primaryCommodityCodes = [];
        });

      return $scope.primaryCommodityCodes;
    }
  }

  function searchSecondaryCommodityCode(keyword){
    if(!!keyword && keyword.length > 1){
      searchModule.get(
        {
          module: 'commodity',
          'criteria[0][code]': keyword,
          'criteria[0][descr]': keyword,
          'criteria[0][$operator]': 'or',
          'criteria[1][is_active]': 1,
          order: 1,
          order_by: 'code',
          offset: 0
        }, function (resource) {
          if (!!resource && !!resource.content && !!resource.content.data)
            $scope.secondaryCommodityCodes = resource.content.data;
        }, function () {
          $scope.secondaryCommodityCodes = [];
        });

      return $scope.secondaryCommodityCodes;
    }
  }

  /**
   * Get child's data for primary commodity
   * @param cc
   */
  function openChildCommodityCodePrimary(cc){
    listChild.get({
        code: cc
      },
      function(resource){
        if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0){
          $scope.primaryCommodityCodes = resource.content.data;
        }
        else{
          toastr.error("There are no child on this commodity code");
        }
      },
      function(){
        toastr.error("Failed to get commodity codes data");
      })
  }

  /**
   * Get child's data for secondary commodity
   * @param cc
   */
  function openChildCommodityCodeSecondary(cc){
    listChild.get({
        code: cc
      },
      function(resource){
        if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0){
          $scope.secondaryCommodityCodes = resource.content.data;
        }
        else{
          toastr.error("There are no child on this commodity code");
        }
      },
      function(){
        toastr.error("Failed to get commodity codes data");
      })
  }

  // The standard list for Business Nature and Business Entity
  $scope.businessNatures = [
    {descr: 'Unspecified Business Nature', shortDescr: 'UNSPECIFIED', value: 0},
    {descr: 'Agent', shortDescr: 'AGENT', value: 1},
    {descr: 'Banking & Financial Services', shortDescr: 'BANKING',  value: 2},
    {descr: 'Consultancy, Advisory & Other Professional Bodies', shortDescr: 'CONSULTANCY',  value: 3},
    {descr: 'Contractor', shortDescr: 'CONTRACTOR',  value: 4},
    {descr: 'Dealer', shortDescr: 'DEALER',  value: 5},
    {descr: 'Distribute', shortDescr: 'DISTRIBUTOR',  value: 6},
    {descr: 'Manufacturer', shortDescr: 'MANUFACTURER',  value: 7},
    {descr: 'Marketing', shortDescr: 'MARKETING',  value: 8},
    {descr: 'Retailer', shortDescr: 'RETAILER',  value: 9},
    {descr: 'Service Provider', shortDescr: 'SERVICE_PROVIDER',  value: 10},
    {descr: 'Sub-Contractor', shortDescr: 'SUB_CONTRACTOR',  value: 11},
    {descr: 'Trading', shortDescr: 'TRADING',  value: 12},
    {descr: 'Other', shortDescr: 'OTHERS',  value: 13}
  ];
  $scope.businessEntities = [
    {descr: 'Berhad (Public Limited)', value: '1'},
    {descr: 'Sendirian Berhad (Private Limited)', value: '2'},
    {descr: 'Sole Proprietor & Enterprise', value: '3'},
    {descr: 'Partnership', value: '4'}
  ];

  $scope.poReceive = [
    {descr: 'System', value: 0},
    {descr: 'System and Email', value: 1},
    {descr: 'System, Email, and Fax', value: 2},
    {descr: 'System, Email, Fax, and Post', value: 3}
  ];

  $scope.bumiputraStatus = [
    {descr: 'Yes', value: 1},
    {descr: 'No', value: 0}
  ];

  $scope.selection = {
    poMethod: {}
  };

  $scope.methodSelected = false;

  function selectedBumiputra(value){
    $scope.supplier.bumiputra_status = value;
    $scope.noBumiStatus = false;
  }

  function backToListingSupplier() {
    $state.go('main.user.suppliers.manage', {status: "pending"});
  }

  //to push a N/A field for taxes
  //var empty = {_id: null, code: 'N/A'};
  //$scope.taxes.unshift(empty);

  function getPaidUpCategory(){
    $scope.paidUpCategoryDescr = supplierGlobalFunc.getPaidUpCategory($scope.supplier.paid_up_capital_amount);
  }

  function onSelectedTax(tax){
    $scope.supplier.tax_id = tax._id;
    if(tax.code === 'NR0 - No Tax'){
      $scope.supplier.gst_code = undefined;
    }
  }

  function onSelectedBusinessEntity(business_entity){
    $scope.supplier.business_entity = business_entity.value;
  }

  function validatePrimaryBusinessNature(primary){
    $scope.primaryBN = primary.value;
    if(angular.isDefined($scope.secondaryBN)){
      if(($scope.secondaryBN === primary.value) && primary.value != 0){
        toastr.error('Primary business nature cannot be the same as secondary business nature');
        $scope.validatedBN = true;
      }
      else{
        $scope.validatedBN = false;
      }
    }
  }

  function validateSecondaryBusinessNature(secondary){
    $scope.secondaryBN = secondary.value;
    if(angular.isDefined($scope.primaryBN)){
      if(($scope.primaryBN === secondary.value) && secondary.value != 0){
        toastr.error('Primary business nature cannot be the same as secondary business nature');
        $scope.validatedBN = true;
      }
      else{
        $scope.validatedBN = false;
      }
    }
  }


  function onSelectedPaymentTerm(payment_term){
    $scope.supplier.pay_terms_code = payment_term.code;
  }


  function onSelectedCurrency(currency){
    $scope.supplier.currency_code = currency.code;
  }

  function onSelectedPaymentMethod(payment_method){
    $scope.supplier.pay_method_code = payment_method.code;
  }

  function onUpdatedContact(contact){
    var index = _.findIndex($scope.selectedContactPersons, function(item){
      return item._id == contact._id;
    });

    $scope.selectedContactPersons.splice(index, 1, contact);
  }

  function onAddedContact(contact){
    $scope.selectedContactPersons.splice($scope.selectedContactPersons.length, 0, contact);
  }

  function removeContact(contact){
    var index = _.findIndex($scope.selectedContactPersons, function(item){
      return item._id == contact._id;
    });

    $scope.selectedContactPersons.splice(index, 1);
  }

  function onSelectedCountry(country){
    $scope.address.state = undefined;
    $scope.address.country = country.descr;
    $scope.selectedMalaysia = (country.descr === "Malaysia");
  }

  function onSelectedState(state){
      $scope.address.state = state.descr;
  }

  /**
   * Save Address before create draft or submit
   * @param action
   */
  function saveAddress(action){

    /**
     * Added phone and fax into address, taken from supplier phone and fax
     */
    $scope.address.phone = $scope.supplier.phone;
    $scope.address.fax = $scope.supplier.fax;

    addressList.post($scope.address,
      function(resource){

        if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
          $scope.supplier.corresponding_address_id = resource.content.data._id;

          //save supplier if success
          saveNewSupplier(action);
        }

      }
      , function(error){
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * @function To set first contact in additional contact as primary, then splice from the array
   */
  function settingContacts(){
    var temp_contact_id = [];
    var temp_contact_object = [];

    /**
     * Loop each selected contact person
     * Push the ids into temp_contact_id array containing ids to pass to payload
     * Push the objects into temp_contact_object array containing the contact objects for display
     */
    _.forEach($scope.selectedContactPersons, function(item){
      if(angular.isDefined(item._id)){
        temp_contact_id.push(item._id);
        temp_contact_object.push(item);
      }
      else{
        temp_contact_id.push(item);
      }
    });

    $scope.supplier.additional_contacts_ids = temp_contact_id;
    $scope.supplier.additional_contacts = temp_contact_object;

    $scope.selectedContactPersons = $scope.supplier.additional_contacts;

    /**
      * Sets the first contact as primary contact and splices the contact from additional contacts
      * to place into contact_person_id to pass to payload
      */
    $scope.supplier.contact_person_id = temp_contact_id[0];
    $scope.supplier.additional_contacts_ids.splice(0 , 1);

  }

  function saveNewSupplier(action) {
    settingContacts();

    var submitData = {};

    // Add the data only if there is a data on it
    if (!!$scope.supplier.additional_contacts_ids)
      submitData['additional_contacts_ids'] = $scope.supplier.additional_contacts_ids;

    if (!!$scope.supplier.business_entity)
      submitData['business_entity'] = $scope.supplier.business_entity;

    if (!!$scope.supplier.select_primary_business_nature && !!$scope.supplier.select_primary_business_nature.shortDescr)
      submitData['primary_business_nature'] = $scope.supplier.select_primary_business_nature.shortDescr;

    if (!!$scope.supplier.select_secondary_business_nature && !!$scope.supplier.select_secondary_business_nature.shortDescr)
      submitData['secondary_business_nature'] = $scope.supplier.select_secondary_business_nature.shortDescr;

    if (!!$scope.supplier.paid_up_capital_amount)
      submitData['paid_up_value'] = $scope.supplier.paid_up_capital_amount;

    if (angular.isDefined($scope.supplier.bumiputra_status))
      submitData['bumi_status'] = $scope.supplier.bumiputra_status;

    if (!!$scope.supplier.first_primary_commodity && !!$scope.supplier.first_primary_commodity.code)
      submitData['primary_commodity_code'] = $scope.supplier.first_primary_commodity.code;

    if (!!$scope.supplier.contact_person_id)
      submitData['contact_person_id'] = $scope.supplier.contact_person_id;

    if (!!$scope.supplier.corresponding_address_id)
      submitData['corresponding_address_id'] = $scope.supplier.corresponding_address_id;

    if (!!$scope.supplier.selectedCurrency && !!$scope.supplier.selectedCurrency.code)
      submitData['currency_code'] = $scope.supplier.selectedCurrency.code;

    if (!!$scope.supplier.descr)
      submitData['descr'] = $scope.supplier.descr;

    if (!!$scope.supplier.selectedPaymentMethod && !!$scope.supplier.selectedPaymentMethod.code)
      submitData['pay_method_code'] = $scope.supplier.selectedPaymentMethod.code;

    if (!!$scope.supplier.selectedPaymentTerms && !!$scope.supplier.selectedPaymentTerms.code)
      submitData['pay_terms_code'] = $scope.supplier.selectedPaymentTerms.code;

    if (!!$scope.supplier.email)
      submitData['email'] = $scope.supplier.email;

    if (!!$scope.supplier.fax)
      submitData['fax'] = $scope.supplier.fax;

    if (!!$scope.supplier.phone)
      submitData['phone'] = $scope.supplier.phone;

    if (!!$scope.receive_via_system)
      submitData['receive_via_system'] = $scope.receive_via_system;

    if (!!$scope.receive_via_email)
      submitData['receive_via_email'] = $scope.receive_via_email;

    if (!!$scope.receive_via_fax)
      submitData['receive_via_fax'] = $scope.receive_via_fax;

    if (!!$scope.receive_via_post)
      submitData['receive_via_post'] = $scope.receive_via_post;

    if (!!$scope.supplier.reg_no)
      submitData['reg_no'] = $scope.supplier.reg_no;

    if (!!$scope.supplier.gst_code)
      submitData['gst_code'] = $scope.supplier.gst_code;

    if (!!$scope.supplier.tax_id)
      submitData['tax_id'] = $scope.supplier.tax_id;

    if (!!$scope.supplier.branches)
      submitData['branches'] = $scope.supplier.branches;

    submitData['is_global_supplier'] = $scope.supplier.is_global_supplier.toString();
    submitData['status_reason'] = $scope.status_reason;

    if(!!($scope.supplier.first_secondary_commodity)){
      submitData.secondary_commodity_code =  $scope.supplier.first_secondary_commodity.code;
    }

    if (!!$scope.supplier.bu_status && !!$scope.supplier.bu_status.length && !$scope.supplier.is_global_supplier)
      submitData.bu_status = supplierGlobalFunc.prepareSupplierGroup($scope.supplier.bu_status);
    else
      submitData.bu_status = {};

    if(!!$scope.supplier.additionalFile && !!$scope.supplier.additionalFile.length)
      prepareAttachmentsDetails(submitData, action, 0);
    else
      createDraftSupplier(submitData, action);
  }

  function submitSupplier(supplierId) {
    draftSupplier.put({
      id: supplierId,
      action: 'submit'
    }, function() {
      toastr.success('The supplier was Submitted');
      HighlightId.setId(supplierId);
      $state.go('main.user.suppliers.manage', { status: 'pending' });
    }, function(error) {
      globalFunc.objectErrorMessage(error);
      supplierAttachment = [];
      $state.go('main.user.suppliers.detail', { id: supplierId });
    });
  }

  /**
   * prepare attachment details for the payload
   * @param submitData
   * @param action
   * @param index (attachment index)
   */
  function prepareAttachmentsDetails(submitData, action, index){
    uploadAttachment($scope.supplier.additionalFile[index].attachment_detail.file)
      .then(
      function (resource) {
        if (!!resource && !!resource.data && !!resource.data.content && !!resource.data.content.data) {
          var params = {
            _id: null,
            attachment_category_id: $scope.supplier.additionalFile[index].attachment_category._id,
            attachment_id: resource.data.content.data._id
          };
          params = globalFunc.reformatArrayToObject(
            $scope.supplier.additionalFile[index].description_array, 'name', 'value', params
          );
          supplierAttachment.push(params);
        }

        if (!!$scope.supplier.additionalFile[++index])
          prepareAttachmentsDetails(submitData, action, index);
        else {
          submitData.attachments_descriptions = supplierAttachment;
          createDraftSupplier(submitData, action);
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        supplierAttachment = [];
      }
    );
  }

  function createDraftSupplier(submitData, action) {
    draftSupplier.post(
      {},
      submitData,
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.status_reason = '';
          if (action === 'draft') {
            toastr.success('The supplier was added successfully');
            if (!!resource && !!resource.content && !!resource.content.data)
              HighlightId.setId(resource.content.data._id);

            // $scope.approvals = resource.content.data.flow;
            $state.go("main.user.suppliers.manage", {status: 'draft'});
          }
          else
            submitSupplier(resource.content.data._id);
        }
      },
      function (err) {
        globalFunc.objectErrorMessage(err);
        supplierAttachment = [];
        $scope.status_reason = '';
      }
    );
  }

  function uploadAttachment(attachmentFile) {
    var fd = new FormData();
    fd.append("file", attachmentFile._file);
    return $http.post(
      pathConstants.apiUrls.attachments.reference, fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }
    );
  }

  function submitSupplierValidation() {
    if (angular.isUndefined($scope.supplier.bumiputra_status)) {
      $scope.noBumiStatus = true;
      return false;
    }

    if ($scope.validatedBN === true) {
      return false;
    }

    if (checkHyphenFirstCharacter($scope.updateDescr, 'descr')) {
      return false;
    }

//    if($scope.validatedCommodity === true){
//      return false;
//    }

    if (!$scope.supplier.descr || !$scope.supplier.descr.length || $scope.descrCheck) {
      return false;
    }

    //if(!$scope.supplier.code || !$scope.supplier.code.length){
    //  return false;
    //}

    if (!$scope.supplier.reg_no || !$scope.supplier.reg_no.length || $scope.rocCheck) {
      return false;
    }

    /**
     * check if tax selected is not NR, then validate gst code exist and gst duplicate
     */
    if ((!$scope.supplier.gst_code &&
        (angular.isDefined($scope.supplier.selectedTax) && $scope.supplier.selectedTax.code != 'NR0 - No Tax')) ||
      $scope.gstCheck) {
      return false;
    }

    /**
     * check if tax selected
     */
    if (!$scope.supplier.selectedTax) {
      return false;
    }

    if (!$scope.supplier.first_primary_commodity) {
      return false;
    }

    if (!$scope.supplier.select_primary_business_nature) {
      return false;
    }

    if (!$scope.receive_via_email && !$scope.receive_via_fax && !$scope.receive_via_post) {
      return false;
    }

    if (!$scope.supplier.select_business_entity) {
      return false;
    }

    if (!$scope.supplier.selectedPaymentTerms) {
      return false;
    }

    if (!$scope.supplier.selectedCurrency) {
      return false;
    }

    if (!$scope.isValidPhoneNo) {
      return false;
    }

    if (!$scope.isValidFaxNo) {
      return false;
    }

    if (!$scope.supplier.phone || !$scope.supplier.phone.length) {
      return false;
    }

    if (!!$scope.receive_via_email) {
      if (!$scope.supplier.email || !$scope.supplier.email.length) {
        return false;
      }
    }

    if (!!$scope.receive_via_fax) {
      if (!$scope.supplier.fax || !$scope.supplier.fax.length) {
        return false;
      }
    }

    if (!$scope.address || !$scope.address.line1 || !$scope.address.city || !$scope.address.state ||
      !$scope.address.country || !$scope.address.postal_code) {
      return false;
    }

    if (!$scope.selectedContactPersons || !$scope.selectedContactPersons.length) {
      return false;
    }

    if (!$scope.supplier.is_global_supplier &&
      (!$scope.supplier.bu_status || (!!$scope.supplier.bu_status && !$scope.supplier.bu_status.length))) {
      return false;
    }

    return true;
  }

  function draftSupplierValidation() {
    if (!$scope.supplier.descr || !!$scope.descrCheck)
      return false;

    if (!$scope.supplier.reg_no || !!$scope.rocCheck)
      return false;

    return true;
  }

  function paymentTermValidation() {
    var validPaymentTerm = false;
    if (!!$scope.supplier.selectedPaymentTerms && !!$scope.supplier.selectedPaymentTerms.code) {
      if(globalFunc.findInArray(paymentTerms.data,'code',$scope.supplier.selectedPaymentTerms.code)) {
        validPaymentTerm = true;
      }
    }
    return validPaymentTerm;
  }

  function paymentMethodValidation() {
    var validPaymentMethod = false;
    if (!!$scope.supplier.selectedPaymentMethod && !!$scope.supplier.selectedPaymentMethod.code) {
      if(globalFunc.findInArray(paymentMethods.data,'code',$scope.supplier.selectedPaymentMethod.code)) {
        validPaymentMethod = true;
      }
    }
    return validPaymentMethod;
  }

  /**
   *
   * @param action
   * draft = to save new supplier as draft
   * submit = to save new supplier as draft then submit
   */
  function addNewSupplier(action){
    $scope.saveAs = action;

    if(action === 'submit' && submitSupplierValidation() === false){
      toastr.error('Please complete all required fields before proceeding');
      return;
    }

    // validation for draft
    if (action === 'draft' && !draftSupplierValidation()) {
      toastr.error('Please complete all required fields before proceeding');
      return;
    }

    if (!paymentMethodValidation()) {
      toastr.error('Invalid payment method.');
      return;
    }

    if (!paymentTermValidation()) {
      toastr.error('Invalid payment term.');
      return;
    }

    // show swal only when submit
    if (action === 'draft') {
      if(!!$scope.address && !!$scope.address.line1)
        saveAddress(action);
      else
        saveNewSupplier(action);
    } else {
      swal(
        {
          title: 'Confirm submit supplier?',
          text: 'This supplier will be submitted by you. Please state a reason.',
          showCancelButton: true,
          type: 'input',
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true,
          inputType: 'text',
          inputPlaceholder: 'Write a reason'
        },
        function (input) {
          if (input !== false) {
            $scope.status_reason = input || '';

            if(!!$scope.address && !!$scope.address.line1)
              saveAddress(action);
            else
              saveNewSupplier(action);
          }
        }
      );
    }
  }

  function removeSecondaryCommodity() {
    if (!!$scope.supplier) {
      $scope.supplier.first_secondary_commodity = null;
      $scope.secondaryCommodityKeyword = null;
    }
  }

  //Initialized values for B. nature, B. entity, Payment Terms and Payment Methods
  function initialize(){
    $scope.paymentMethods = supplierGlobalFunc.filterInactiveCode(paymentMethods.data);
    $scope.paymentTerms = supplierGlobalFunc.filterInactiveCode(paymentTerms.data);
    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();
    $scope.supplier = {
      //selectedPaymentMethod             : globalFunc.findInArray($scope.paymentMethods, 'code', 'NA'),
      selectedCurrency                  : globalFunc.findInArray($scope.currencies, 'code', 'MYR')
    };

    $scope.receive_via_system = true;

    $scope.supplier.currency_code = !!$scope.supplier.selectedCurrency ? $scope.supplier.selectedCurrency.code : '';
    $scope.supplier.bu_status = [];
    $scope.supplier.is_global_supplier = true;
    $scope.supplier.branches = [];
    $scope.firstCharHyphen = false;
    $scope.isValidPhoneNo = true;
    $scope.isValidFaxNo = true;
  }

  initialize();


  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model, field, value, checker) {
    globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
      switch (callback) {
        case 'rocCheckTrue':
          $scope.rocCheck = true;
          break;
        case 'rocCheckFalse':
          $scope.rocCheck = false;
          break;
        case 'gstCheckTrue':
          $scope.gstCheck = true;
          break;
        case 'gstCheckFalse':
          $scope.gstCheck = false;
          break;
        case 'supplierDescrCheckTrue':
          $scope.descrCheck = true;
          break;
        case 'supplierDescrCheckFalse':
          $scope.descrCheck = false;
          break;
      }
    });
  }

  /**
   * Validate number format with given element id and returns boolean in field name
   *
   * @param {string} elementId
   * @param {string} fieldName
   */
  function validateNumbers(elementId, fieldName) {
    $scope[fieldName] = globalFunc.numberFormatValidation(elementId);
  }
}

newSupplierCtrl.$inject = [
  '$scope', '$q', 'toastr', 'taxes', 'draftSupplier', 'paymentMethods', 'paymentTerms', '$stateParams', '$state',
  'currencies', 'HighlightId', 'addressList', 'globalFunc', '$http', '$filter', 'pathConstants',
  'searchModule', 'listChild', 'supplierGlobalFunc', 'attachmentDescription', 'ngIntlTelInput'
];

angular.module('metabuyer')
  .controller('newSupplierCtrl', newSupplierCtrl);

'use strict';

function suppliersManageCtrl(
  $scope, suppliers, $rootScope, action, suppliersList, $stateParams, HighlightId, $window,
  supplierGlobalFunc, $filter, globalFunc)
{
  $scope.showColumn                   = showColumn;
  $scope.getStatusName                = getStatusName;
  $scope.getOriginName                = getOriginName;
  $scope.checkWaitingOnUser           = checkWaitingOnUser;
  $scope.getSelectedSuppliers         = getSelectedSuppliers;
  $scope.multiSelectPendingItems      = multiSelectPendingItems;
  $scope.isCurrentUserSupplierManager = isCurrentUserSupplierManager;

  $scope.storageKey = 'suppliers-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the status name
   * @param supplierStatus
   * @param approvalStatus
   * @param draftingStatus
   *
   * @returns {*}
   */
  function getStatusName(supplierStatus, approvalStatus, draftingStatus){
    var status = supplierGlobalFunc.getSupplierStatus(supplierStatus, approvalStatus, draftingStatus, 'val');
    if (!!status)
      return status;

    return 'N/A';
  }

  /**
   * returns the name of te Original state the supplier was in
   * @param val
   * @returns {*}
   */
  function getOriginName(val){
    if(val === 1){
      return 'Active';
    }
    if(val === 2){
      return 'Blacklisted';
    }
    if(val === 3){
      return 'Inactive';
    }
    return 'N/A';
  }

  /**
   * return if the user is part of the waiting on, for a specific Supplier
   * @param supplier
   * @returns {*}
   */
  function checkWaitingOnUser(supplier) {
    return globalFunc.findInArray(supplier.waiting_on, '_id', $rootScope.currentUser._id);
  }

  /**
   * returns store the selected Suppliers
   * @returns {Array}
   */
  function getSelectedSuppliers() {
    var selectedSuppliers = [];
    _.forEach($scope.suppliers, function (supplier) {
      if (!!supplier.selected) {
        selectedSuppliers.push(supplier);
      }
    });
    return selectedSuppliers;
  }

  /**
   *  auto select/deselect the items for approval action
   * @param status
   */
  function multiSelectPendingItems (status) {
    _.forEach($scope.suppliers, function (supplier) {
      if (checkWaitingOnUser(supplier)) {
        supplier.selected = status;
      }
    });
  }

  /**
   * Check if current user has system role: Supplier Manager
   *
   * @returns {boolean}
   */
  function isCurrentUserSupplierManager () {
    return (supplierGlobalFunc.checkIfUserHasSupplierManagerRole($rootScope.currentUser));
  }

  function initialize(){

    $scope.suppliers = suppliers.data;
    $scope.actionType = action;

    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }
    $scope.meta = suppliers.meta;
    $scope.supplierManageService = suppliersList;
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;

    //set status for parent
    if(!!HighlightId.getId() && HighlightId.getId() != undefined && HighlightId.getId().length) {

      $scope.highlightId = HighlightId.getId();

      if ($scope.highlightId != null && $scope.highlightId != undefined) {

        //scroll the window to top
        $window.scroll(0, 0);
      }

      //clear current id
      HighlightId.setId(null);
    }

  }

  initialize();
}

suppliersManageCtrl.$inject = ['$scope','suppliers', '$rootScope', 'action', 'suppliersList', '$stateParams',
  'HighlightId', '$window', 'supplierGlobalFunc', '$filter', 'globalFunc'];

angular.module('metabuyer')
  .controller('suppliersManageCtrl', suppliersManageCtrl);

'use strict';


function suppliersItemsCtrl($scope, toastr, pathConstants, $http, $filter, globalFunc) {

  $scope.downloadLog = downloadLog;
  $scope.importingSuppliers = importingSuppliers;
  $scope.dataIsArray = dataIsArray;
  $scope.isSuccessfullyImported = isSuccessfullyImported;
  $scope.getLineNumber = getLineNumber;

  function isSuccessfullyImported(str) {
    if (_.isString(str))
      str = str.toLowerCase();
    return str.indexOf('successfully') > -1;
  }

  function downloadLog(hash) {
    var newUrl = $filter('format')(pathConstants.apiUrls.attachments.downloadErrorLog, {
      hash: hash
    });
    window.open(newUrl, '_self');
  }

  /**
   *
   * @param arr
   */
  function dataIsArray(arr) {
    return angular.isArray(arr);
  }

  /**
   * Get the line number based on the CSV file
   *
   * @param lineNumber
   */
  function getLineNumber(lineNumber) {
    return parseInt(lineNumber) +1;
  }

  function importingSuppliers(){
    $scope.uploadError = false;
    $scope.status = null;
    $scope.errorMessage = '';
    $scope.errorArray = [];

    var fd = new FormData();
    fd.append('file',$scope.submit_data.items);
    fd.append('class', 'Metabuyer\\Models\\Supplier');

    $http.post(pathConstants.apiUrls.imports.now, fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    })
      .then(function onSuccess (data,status){
        $scope.status = status;
        if(!!data.data.content){
          if(!!data.data.content.message)
            toastr.success(data.data.content.message);
          else
            toastr.success("File successfully uploaded");
        }
      })
      .catch(function onError (error) {
        $scope.uploadError = true;
        if(!!error.data.content && !!error.data.content.error){
          if (_.isString(error.data.content.error) && !_.isString(error.data.content.message)) {
            $scope.errorMessage = error.data.content.error;
            $scope.errorArray = globalFunc.reformatFromObjectToArray(error.data.content.message);
          } else if(!_.isString(error.data.content.error)) {
            $scope.errorArray = globalFunc.reformatFromObjectToArray(error.data.content.error);
          } else {
            $scope.errorMessage = error.data.content.error;
          }
        }
      });
  }
}

suppliersItemsCtrl.$inject = ['$scope', 'toastr', 'pathConstants', '$http', '$filter', 'globalFunc'];


angular.module('metabuyer')
  .controller('suppliersItemsCtrl', suppliersItemsCtrl);

'use strict';

function supplierDetailCtrl(
  $scope, $q, toastr, supplier, taxes, singleSupplier, paymentMethods, paymentTerms, $state, $location, currencies,
  HighlightId, addressList, singleAddress, Approvals, profile, globalFunc, approvalSupplier, searchAllCommodity,
  listChild, supplierGlobalFunc, draftSupplier, supplierArchives, $uibModal, pathConstants, $http, $rootScope,
  attachmentDetail, $filter
) {

  var supplierAttachment = [];

  $scope.supplier = supplier;
  $scope.supplier.original_status = supplier.status;
  $scope.supplier.status = supplierGlobalFunc.getSupplierStatus(
    supplier.status, supplier.approval_status, supplier.draft_status, 'descr'
  );
  $scope.approvals = [];
  $scope.approvalFlowData = {};
  $scope.waiting_on_user = [];
  $scope.commodityLevel = [3, 4];
  $scope.address = {};
  $scope.taxes = taxes;
  $scope.paymentMethods = paymentMethods.data;
  $scope.paymentTerms = paymentTerms.data;
  $scope.selectedContactPersons = [];
  $scope.selectedBranch = [];
  $scope.currencies = currencies;
  $scope.user = profile;
  $scope.editClicked = false;
  $scope.originalDescr = $scope.supplier.descr;
  $scope.originalROC = $scope.supplier.reg_no;
  $scope.originalGSTCode = $scope.supplier.gst_code;
  $scope.closeTreeSearchPrimary = false;
  $scope.closeTreeSearchSecondary = false;
  $scope.supplierVersions = [];
  $scope.supplierDraftVersions = [];
  $scope.statusUpdatePayload = {};
  $scope.pendingEditClicked = false;

  $scope.bumiputraStatus = [
    {descr: 'Yes', value: 1},
    {descr: 'No', value: 0}
  ];

  // The standard list for Business Nature and Business Entity
  $scope.businessNatures = [
    {descr: 'Unspecified Business Nature', shortDescr: 'UNSPECIFIED', value: 0},
    {descr: 'Agent', shortDescr: 'AGENT', value: 1},
    {descr: 'Banking & Financial Services', shortDescr: 'BANKING', value: 2},
    {descr: 'Consultancy, Advisory & Other Professional Bodies', shortDescr: 'CONSULTANCY', value: 3},
    {descr: 'Contractor', shortDescr: 'CONTRACTOR', value: 4},
    {descr: 'Dealer', shortDescr: 'DEALER', value: 5},
    {descr: 'Distribute', shortDescr: 'DISTRIBUTOR', value: 6},
    {descr: 'Manufacturer', shortDescr: 'MANUFACTURER', value: 7},
    {descr: 'Marketing', shortDescr: 'MARKETING', value: 8},
    {descr: 'Retailer', shortDescr: 'RETAILER', value: 9},
    {descr: 'Service Provider', shortDescr: 'SERVICE_PROVIDER', value: 10},
    {descr: 'Sub-Contractor', shortDescr: 'SUB_CONTRACTOR', value: 11},
    {descr: 'Trading', shortDescr: 'TRADING', value: 12},
    {descr: 'Other', shortDescr: 'OTHERS', value: 13}
  ];
  $scope.businessEntities = [
    {descr: 'Berhad (Public Limited)', shortDescr: 'BERHAD', value: '1'},
    {descr: 'Sendirian Berhad (Private Limited)', shortDescr: 'SENDIRIAN_BERHAD', value: '2'},
    {descr: 'Sole Proprietor & Enterprise', shortDescr: 'SOLE', value: '3'},
    {descr: 'Partnership', shortDescr: 'PARTNERSHIP', value: '4'}
  ];

  $scope.poReceive = [
    {descr: 'System', value: 0},
    {descr: 'System and Email', value: 1},
    {descr: 'System, Email and Fax', value: 2},
    {descr: 'System, Email, Fax and Post', value: 3}
  ];

  $scope.selection = {
    poMethod: {}
  };

  $scope.freightTerms = [];

  $scope.getPaidUpCategory = getPaidUpCategory;
  $scope.backToListingSupplier = backToListingSupplier;
  $scope.onUpdatedContact = onUpdatedContact;
  $scope.onAddedContact = onAddedContact;
  $scope.onUpdatedCountry = onUpdatedCountry;
  $scope.onUpdatedState = onUpdatedState;
  $scope.revertUpdate = revertUpdate;
  $scope.setActiveTab = setActiveTab;
  $scope.removeContact = removeContact;
  $scope.updateAddress = updateAddress;
  $scope.loadCommodityList = loadCommodityList;
  $scope.selectedBumiputra = selectedBumiputra;
  $scope.selectPO = selectPO;
  $scope.updateChanges = updateChanges;
  $scope.validateEmail = validateEmail;
  $scope.validateSelectedTax = validateSelectedTax;
  $scope.validatePrimaryBusinessNature = validatePrimaryBusinessNature;
  $scope.validateSecondaryBusinessNature = validateSecondaryBusinessNature;
  $scope.checkSupplierChanges = checkSupplierChanges;
  $scope.checkWaitingOn = checkWaitingOn;
  $scope.isEditableStatusChange = isEditableStatusChange;
  $scope.loadApprovalFlow = loadApprovalFlow;
  $scope.checkApprove = checkApprove;
  $scope.checkReject = checkReject;
  $scope.duplicationCheck = duplicationCheck;
  $scope.validateNumbers = validateNumbers;
  $scope.removeSecondaryCommodity = removeSecondaryCommodity;
  $scope.searchPrimaryCommodityCode = searchPrimaryCommodityCode;
  $scope.searchSecondaryCommodityCode = searchSecondaryCommodityCode;
  $scope.openChildCommodityCodePrimary = openChildCommodityCodePrimary;
  $scope.openChildCommodityCodeSecondary = openChildCommodityCodeSecondary;
  $scope.updateStatus = updateStatus;
  $scope.editActiveSupplier = editActiveSupplier;
  $scope.showVersionList = showVersionList;
  $scope.editSupplier = editSupplier;
  $scope.reopenDraftSupplier = reopenDraftSupplier;
  $scope.withdrawSupplier = withdrawSupplier;
  $scope.back = back;
  $scope.updateSupplierStatus = updateSupplierStatus;
  $scope.downloadAttachment = downloadAttachment;
  $scope.checkHyphenFirstCharacter = checkHyphenFirstCharacter;
  $scope.requestEditableDraft = requestEditableDraft;
  $scope.submitEditableDraft = submitEditableDraft;
  $scope.cancelEditableDraft = cancelEditableDraft;
  $scope.showDraftVersionList = showDraftVersionList;

  function submitEditableDraft() {
    if (!validateOnUpdate()) {
      toastr.error('Please complete all required fields before proceeding.');
      return;
    }

    if (!paymentMethodValidation()) {
      toastr.error('Invalid payment method.');
      return;
    }

    if (!paymentTermValidation()) {
      toastr.error('Invalid payment term.');
      return;
    }

    var status = 'draft';
    var updateAndSubmit = true;

    //Update supplier to draft
    draftSupplier.put(
      {
        id: $scope.supplier._id,
        action: status
      },
      {
        status_reason: ''
      },
      function () {
        updateChanges(updateAndSubmit);
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function requestEditableDraft() {
    $scope.pendingEditClicked = true;
    $scope.editClicked = true;
  }

  function cancelEditableDraft() {
    revertUpdate();
  }

  function checkHyphenFirstCharacter(string, field) {
    if (!!string) {
      $scope.descrFirstCharHyphen = supplierGlobalFunc.checkHyphenFirstCharacter(string);
    }

    return $scope.descrFirstCharHyphen;
  }

  // Add requestor
  $scope.requestor = {
    '_id': $scope.supplier.created_by._id,
    'display_name': $scope.supplier.created_by.display_name,
    'img_url': ''
  };

  $scope.methodSelected = false;
  $scope.faxChecker = false;
  $scope.emailChecker = false;

  function selectPO(poMethod) {
    $scope.methodSelected = true;
    $scope.faxChecker = false;
    $scope.emailChecker = false;

    if (poMethod === 2 || poMethod === 3)
      $scope.faxChecker = true;

    if (poMethod === 1 || poMethod === 2 || poMethod === 3)
      $scope.emailChecker = true;

  }

  //check user waiting on
  function checkWaitingOn() {
    var find_user = _.find($scope.waiting_on_user, function (approver) {
      return (approver._id === profile._id);
    });

    if (find_user !== undefined) {
      return true;
    }
    return false;
  }

  /**
   * Check if status change allows editing
   *
   * @returns {boolean}
   */
  function isEditableStatusChange() {
    // Return true if newly created draft or edit draft from active supplier
    return ((!$scope.supplier.submitted_from ||
        (!!$scope.supplier.submitted_from && $scope.supplier.submitted_from === 'ACTIVE')) &&
      (!!$scope.supplier.original_status && $scope.supplier.original_status === 'ACTIVE'));
  }

  function getUpdateAddressData() {
    var update_data = {};

    if (!!$scope.address) {
      if (!!$scope.address._id) {
        update_data._id = $scope.address._id;
      }

      update_data.line1 = $scope.address.line1;
      update_data.line2 = $scope.address.line2;
      update_data.line3 = $scope.address.line3;
      update_data.city = $scope.address.city;
      update_data.state = $scope.address.state;
      update_data.postal_code = $scope.address.postal_code;
      update_data.country = $scope.address.country;
      update_data.phone = $scope.update_phone;
      update_data.fax = $scope.update_fax;
    }

    return update_data;
  }

  function updateAddress(updateAndSubmit) {
    if (!!$scope.address && !$scope.address._id) {
      addressList.post(getUpdateAddressData(),
        function(resource){
          if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
            $scope.address._id = resource.content.data._id;
            $scope.updateSupplier(updateAndSubmit);
          }
        }, function (error) {
          toastr.error('Failed to update address');
          globalFunc.objectErrorMessage(error);
        }
      );
      return;
    }

    singleAddress.put(
      {
        id: $scope.address._id
      },
      getUpdateAddressData(),
      function () {
        $scope.updateSupplier(updateAndSubmit);
      }, function (error) {
        toastr.error('Failed to update address');
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * Function for loading the commodity listing based on parameter item for code
   */
  function loadCommodityList(item, callback) {
    listChild.get(
      {
        code: item
      },
      function (resource) {
        $scope.families = resource.content.data;
        if (typeof callback === 'function') {
          callback($scope.families);
        }
      },
      function (error) {
        if (error.status === 404) {
          toastr.error('Could not load families for this segment');
        }
      }
    );
  }

  function searchPrimaryCommodityCode(keyword) {
    if (!!keyword && keyword.length > 2) {
      searchAllCommodity.get({
        keywords: keyword
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          $scope.primaryCommodityCodes = resource.content.data;
      }, function () {
        $scope.primaryCommodityCodes = [];
      });

      return $scope.primaryCommodityCodes;
    }
  }

  function searchSecondaryCommodityCode(keyword) {
    if (!!keyword && keyword.length > 2) {
      searchAllCommodity.get({
        keywords: keyword
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          $scope.secondaryCommodityCodes = resource.content.data;
      }, function () {
        $scope.secondaryCommodityCodes = [];
      });

      return $scope.secondaryCommodityCodes;
    }
  }

  function onAddedContact(contact) {
    var spliceIndex = $scope.selectedContactPersons[0];
    if (!!spliceIndex) {
      $scope.selectedContactPersons.push(contact);
    }
    /**
     * If the first index is null, undefined or empty
     */
    else {
      $scope.selectedContactPersons.splice(spliceIndex, 1, contact);
    }
  }

  /**
   * Get child's data for primary commodity
   * @param cc
   */
  function openChildCommodityCodePrimary(cc) {
    listChild.get({
        code: cc
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0) {
          $scope.primaryCommodityCodes = resource.content.data;
        }
        else {
          toastr.error('There are no child on this commodity code');
        }
      },
      function () {
        toastr.error('Failed to get commodity codes data');
      })
  }

  /**
   * Get child's data for secondary commodity
   * @param cc
   */
  function openChildCommodityCodeSecondary(cc) {
    listChild.get({
        code: cc
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.length > 0) {
          $scope.secondaryCommodityCodes = resource.content.data;
        }
        else {
          toastr.error('There are no child on this commodity code');
        }
      },
      function () {
        toastr.error('Failed to get commodity codes data');
      })
  }

  /**
   * Function for setting bumiputra status
   */
  function selectedBumiputra(value) {
    $scope.supplier.bumiputra_status = value;
    $scope.noBumiStatus = false;
  }

  /**
   * This function is responsible for preparing the payload for PUT request on supplier
   */
  function getUpdateData() {
    var update_data = {
      _id: $scope.supplier._id
    };

    if (angular.isDefined($scope.update_email) &&
      ($scope.update_email !== $scope.supplier.email)) {
      update_data.email = $scope.update_email;
    }

    if (angular.isDefined($scope.update_fax) &&
      ($scope.update_fax !== $scope.supplier.fax)) {
      update_data.fax = $scope.update_fax;
    }

    if (angular.isDefined($scope.update_phone) &&
      ($scope.update_phone !== $scope.supplier.phone)) {
      update_data.phone = $scope.update_phone;
    }

    if (!!$scope.updateDescr) {
      update_data.descr = $scope.updateDescr;
    }

    if (angular.isDefined($scope.updateBranch)) {
      update_data.branches = $scope.updateBranch;
    }

    if (angular.isDefined($scope.update_code) &&
      ($scope.update_code !== $scope.supplier.mb_supplier_code)) {
      update_data.code = $scope.update_code;
    }

    if (!!$scope.updateRegNo) {
      update_data.reg_no = $scope.updateRegNo;
    }


    if (!!$scope.supplier.selectedTax && !!$scope.supplier.selectedTax._id) {
      if (!!$scope.supplier.tax && !!$scope.supplier.tax._id) {
        update_data.tax_id = $scope.supplier.selectedTax._id;
        if ($scope.supplier.selectedTax.code === 'NR0 - No Tax') {
          $scope.update_gst_code = null;
        }
      } else {
        update_data.tax_id = $scope.supplier.selectedTax._id;
      }
    }

    if (angular.isDefined($scope.update_gst_code) && $scope.update_gst_code !== null) {
      update_data.gst_code = $scope.update_gst_code;
    }

    if (angular.isDefined($scope.update_paid_up_capital_amount)) {
      if ($scope.update_paid_up_capital_amount === null) {
        update_data.paid_up_value = null;
      } else {
        update_data.paid_up_value = Number($scope.update_paid_up_capital_amount);
      }
    }

    if (angular.isDefined($scope.supplier.primaryCommodity) &&
      angular.isDefined($scope.supplier.primaryCommodity.code)) {
      if ($scope.supplier.primaryCommodity.code !== $scope.supplier.primary_commodity_code) {
        update_data.primary_commodity_code = $scope.supplier.primaryCommodity.code;
      }
    }

    if (!!$scope.supplier.secondaryCommodity && !!$scope.supplier.secondaryCommodity.code) {
      if ($scope.supplier.secondaryCommodity.code !== $scope.supplier.secondary_commodity_code) {
        update_data.secondary_commodity_code = $scope.supplier.secondaryCommodity.code;
      }
    }

    if (angular.isDefined($scope.supplier.selectedPrimaryBusinessNature) &&
      angular.isDefined($scope.supplier.selectedPrimaryBusinessNature.value)) {
      update_data.primary_business_nature = $scope.supplier.selectedPrimaryBusinessNature.shortDescr;
    }

    if (angular.isDefined($scope.supplier.selectedSecondaryBusinessNature) &&
      angular.isDefined($scope.supplier.selectedSecondaryBusinessNature.value)) {
      update_data.secondary_business_nature = $scope.supplier.selectedSecondaryBusinessNature.shortDescr;
    }

    if (angular.isDefined($scope.supplier.selectedBusinessEntity) &&
      angular.isDefined($scope.supplier.selectedBusinessEntity.value)) {
      update_data.business_entity = $scope.supplier.selectedBusinessEntity.value;
    }

    if (!!$scope.supplier.selectedPaymentTerms && !!$scope.supplier.selectedPaymentTerms.code) {
      if (!!$scope.supplier.pay_terms && !!$scope.supplier.pay_terms.code) {
        if ($scope.supplier.selectedPaymentTerms.code !== $scope.supplier.pay_terms.code) {
          update_data.pay_terms_code = $scope.supplier.selectedPaymentTerms.code;
        }
      } else {
        update_data.pay_terms_code = $scope.supplier.selectedPaymentTerms.code;
      }
    }

    if (!!$scope.supplier.selectedPaymentMethod && !!$scope.supplier.selectedPaymentMethod.code) {
      if (!!$scope.supplier.pay_method && !!$scope.supplier.pay_method.code) {
        if ($scope.supplier.selectedPaymentMethod.code !== $scope.supplier.pay_method.code) {
          update_data.pay_method_code = $scope.supplier.selectedPaymentMethod.code;
        }
      } else {
        update_data.pay_method_code = $scope.supplier.selectedPaymentMethod.code;
      }
    }

    if (!!$scope.supplier.selectedCurrency && ($scope.supplier.selectedCurrency.code !== $scope.supplier.currency_code)) {
      update_data.currency_code = $scope.supplier.selectedCurrency.code;
    }

    if ((!!$scope.address && !$scope.supplier.corresponding_address) ||
      ($scope.supplier.corresponding_address._id && ($scope.supplier.corresponding_address._id !== $scope.address._id))) {
      update_data.corresponding_address_id = $scope.address._id;
    }

    if (checkContactPersonChanges()) {
      var temp_contact_id = [];
      _.forEach($scope.selectedContactPersons, function (item) {
        if (!!item && !!item._id)
          temp_contact_id.push(item._id);
      });

      update_data.additional_contacts_ids = temp_contact_id;

      update_data.contact_person_id = temp_contact_id[0];
      update_data.additional_contacts_ids.splice(0, 1);
    }

    if (angular.isDefined($scope.supplier.bumiputra_status))
      update_data.bumi_status = $scope.supplier.bumiputra_status;

    if (!!$scope.supplier.bu_status && !!$scope.supplier.bu_status.length && !$scope.supplier.is_global_supplier)
      update_data.bu_status = supplierGlobalFunc.prepareSupplierGroup($scope.supplier.bu_status);
    else
      update_data.bu_status = {};

    update_data.receive_via_system = $scope.supplier.receive_via_system;
    update_data.receive_via_email = $scope.supplier.receive_via_email;
    update_data.receive_via_fax = $scope.supplier.receive_via_fax;
    update_data.receive_via_post = $scope.supplier.receive_via_post;
    update_data.is_global_supplier = $scope.supplier.is_global_supplier.toString();

    return update_data;
  }

  $scope.updateSupplier = function (updateAndSubmit) {
    var payload = getUpdateData();
    if (!!$scope.supplier.attachments_descriptions && !!$scope.supplier.attachments_descriptions.length) {
      prepareAttachmentsDetails(payload, updateAndSubmit, 0);
    } else {
      updateDraftSupplier(payload, updateAndSubmit);
    }
  };

  function updateDraftSupplier (params,  updateAndSubmit, index) {
    supplierAttachment = [];
    draftSupplier.put(
      {
        id: $scope.supplier._id
      }, params,
      function (resource) {
        toastr.success('The supplier was updated successfully.');
        $scope.descrTitle = $scope.updateDescr;
        $scope.editClicked = false;
        if (!!$scope.submitted)
          $scope.submitted = false;

        if (!!index)
          $scope.supplier.attachments_descriptions[index]._id = resource.content.data.attachments_descriptions[index]._id;

        if (!!updateAndSubmit)
          updateStatus('submit', updateAndSubmit);
      },
      function (error) {
        toastr.error('Failed to update the supplier!');
        globalFunc.objectErrorMessage(error);
        revertUpdate();
      }
    );
  }

  /**
   * prepare attachment details for the payload
   * @param payload
   * @param updateAndSubmit
   * @param index (attachment index)
   */
  function prepareAttachmentsDetails(payload, updateAndSubmit, index) {
    var attachment = $scope.supplier.attachments_descriptions[index];
    if (!!attachment) {
      if (attachment.attachment_detail.file) {
        uploadAttachment(attachment.attachment_detail.file)
          .then(
            function (resource) {
              if (!!resource && !!resource.data && !!resource.data.content && !!resource.data.content.data)
                supplierAttachmentsPayload(
                  attachment._id,
                  attachment.attachment_category._id,
                  resource.data.content.data._id,
                  attachment.description_array
                );

              prepareAttachmentsDetails(payload, updateAndSubmit, ++index);
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
              supplierAttachment = [];
            }
          );
      } else {
        supplierAttachmentsPayload(
          attachment._id,
          attachment.attachment_category._id,
          attachment.attachment_detail._id,
          attachment.description_array
        );

        prepareAttachmentsDetails(payload, updateAndSubmit, ++index);
      }
    } else {
      payload.attachments_descriptions = supplierAttachment;
      updateDraftSupplier(payload, updateAndSubmit, index);
    }
  }

  function supplierAttachmentsPayload(descriptionId, attachmentCategoryId, attachmentId, descriptionArray) {
    var params = {
      _id: descriptionId,
      attachment_category_id: attachmentCategoryId,
      attachment_id: attachmentId
    };
    params = globalFunc.reformatArrayToObject(
      descriptionArray, 'name', 'value', params
    );
    supplierAttachment.push(params);
  }

  function uploadAttachment(attachmentFile) {
    var fd = new FormData();
    fd.append("file", attachmentFile._file);
    return $http.post(
      pathConstants.apiUrls.attachments.reference, fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }
    );
  }

  function validateEmail(email) {
    var regex = /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }

  function validateSelectedTax(taxModel) {
    if (taxModel.code === 'NR0 - No Tax') {
      $scope.update_gst_code = undefined;
    }
  }

  function validatePrimaryBusinessNature(primary) {
    $scope.primaryBN = primary.value;
    if (angular.isDefined($scope.secondaryBN) ||
      (!!$scope.supplier.selectedSecondaryBusinessNature && !!$scope.supplier.selectedSecondaryBusinessNature.value)) {
      if ((($scope.secondaryBN || $scope.supplier.selectedSecondaryBusinessNature.value) === primary.value) &&
        primary.value !== 0) {
        toastr.error('Primary business nature cannot be the same as secondary business nature');
        $scope.validatedBN = true;
      } else {
        $scope.validatedBN = false;
      }
    }
  }

  function validateSecondaryBusinessNature(secondary) {
    $scope.secondaryBN = secondary.value;
    if (angular.isDefined($scope.primaryBN) ||
      angular.isDefined($scope.supplier.selectedPrimaryBusinessNature.value)) {
      if ((($scope.primaryBN || $scope.supplier.selectedPrimaryBusinessNature.value) === secondary.value) &&
        secondary.value !== 0) {
        toastr.error('Primary business nature cannot be the same as secondary business nature');
        $scope.validatedBN = true;
      } else {
        $scope.validatedBN = false;
      }
    }
  }

  /**
   * Validation for update data
   */
  function validateOnUpdate() {
    if (!$scope.updateDescr || !!$scope.descrCheck)
      return false;

    if (!$scope.updateRegNo || !!$scope.rocCheck)
      return false;

    if (!!$scope.gstCheck)
      return false;

    return true;
  }

  /**
   * Validation for submit
   * @returns {boolean}
   */
  function validate() {

    if (angular.isUndefined($scope.supplier.bumiputra_status)) {
      $scope.noBumiStatus = true;
      return false;
    }

    if ($scope.validatedBN === true) {
      return false;
    }

    if ($scope.validatedCommodity === true) {
      return false;
    }

    if (checkHyphenFirstCharacter($scope.updateDescr, 'descr')) {
      return false;
    }

    if (!$scope.updateDescr || !$scope.updateDescr.length || $scope.descrCheck) {
      return false;
    }

    if (!$scope.updateRegNo || !$scope.updateRegNo.length || $scope.rocCheck) {
      return false;
    }
    /**
     * check if tax selected is not NR, then validate gst code exist and gst duplicate
     */
    if (!$scope.update_gst_code && (!!$scope.supplier.selectedTax && !!$scope.supplier.selectedTax &&
        $scope.supplier.selectedTax.code !== 'NR0 - No Tax') || $scope.gstCheck) {
      return false;
    }

    /**
     * check if tax selected
     */
    if (!$scope.supplier.selectedTax) {
      return false;
    }

    if (!$scope.supplier.primaryCommodity) {
      return false;
    }

    if (!$scope.supplier.selectedPrimaryBusinessNature) {
      return false;
    }

    if (!$scope.supplier.selectedBusinessEntity) {
      return false;
    }

    if (!$scope.supplier.receive_via_email && !$scope.supplier.receive_via_fax && !$scope.supplier.receive_via_post) {
      return false;
    }

    if (!$scope.supplier.selectedPaymentTerms) {
      return false;
    }

    if (!$scope.supplier.selectedPaymentMethod) {
      return false;
    }

    if (!$scope.supplier.selectedCurrency) {
      return false;
    }

    if (!$scope.isValidPhoneNo) {
      return false;
    }

    if (!$scope.isValidFaxNo) {
      return false;
    }

    if (!$scope.update_phone || !$scope.update_phone.length) {
      return false;
    }

    if ((!$scope.supplier.bu_status || (!!$scope.supplier.bu_status && !$scope.supplier.bu_status.length)) && !$scope.supplier.is_global_supplier) {
      return false;
    }

    if (!!$scope.supplier.receive_via_email) {
      if (!$scope.update_email || !$scope.update_email.length) {
        return false;
      }
    }

    if (!!$scope.supplier.receive_via_fax) {
      if (!$scope.update_fax || !$scope.update_fax.length) {
        return false;
      }
    }

    if (!!$scope.update_email && ($scope.update_email !== $scope.supplier.email) && !validateEmail($scope.update_email)) {
      return false;
    }

    if (!$scope.address || !$scope.address.line1 || !$scope.address.city || !$scope.address.state || !$scope.address.country) {
      return false;
    }

    if (!$scope.selectedContactPersons || !$scope.selectedContactPersons.length) {
      return false;
    }

    return true;
  }

  function checkAddressChanges() {
    var address_attrs = ['line1', 'line2', 'line3', 'city', 'state', 'postal_code', 'country'];

    for (var index = 0; index < address_attrs.length; index++) {
      var attr = address_attrs[index];
      if (!!$scope.address && !!$scope.address[attr]) {
        if (!$scope.supplier.corresponding_address) return true;
        if (!!$scope.supplier.corresponding_address &&
          ($scope.address[attr] !== $scope.supplier.corresponding_address[attr])) {
          return true;
        }
      }
    }

    /**
     * If supplier phone or fax is changed, also return true
     */
    if (($scope.update_phone !== $scope.supplier.phone) || ($scope.update_fax !== $scope.supplier.fax)) {
      return true;
    }

    return false;
  }

  function checkContactPersonChanges() {

    if (!!$scope.supplier.additional_contacts && !!$scope.supplier.additional_contacts.data) {
      if ($scope.selectedContactPersons.length !== $scope.supplier.additional_contacts.data.length) {
        return true;
      }

      var temp = _.find($scope.supplier.additional_contacts.data, function (item) {
        var find_item = _.find($scope.selectedContactPersons, function (temp_item) {
          return item._id === temp_item._id;
        });

        if (!!find_item) {
          return false;
        }

        return true;
      });

      if (!!temp) {
        return true;
      }
    }

    if (!!$scope.supplier.additional_contacts && !!$scope.supplier.additional_contacts.data) {
      if ($scope.selectedContactPersons.length !== $scope.supplier.additional_contacts.data.length) {
        return true;
      }

      var temp = _.find($scope.supplier.selectedContactPersons, function (item) {
        var find_item = _.find($scope.additional_contacts.data, function (temp_item) {
          return item._id === temp_item._id;
        });

        if (!!find_item) {
          return false;
        }

        return true;
      });

      if (!!temp) {
        return true;
      }
    }

    return false;
  }

  function checkSupplierChanges() {

    if (checkAddressChanges()) {
      return true;
    }

    if ($scope.updateDescr !== $scope.supplier.descr) {
      return true;
    }

    if ($scope.update_code !== $scope.supplier.mb_supplier_code) {
      return true;
    }

    if ($scope.updateRegNo !== $scope.supplier.reg_no) {
      return true;
    }

    if ($scope.update_gst_code !== $scope.supplier.gst_code) {
      return true;
    }

    if (!!$scope.supplier.selectedTax && !!$scope.supplier.selectedTax._id) {
      if (!!$scope.supplier.tax && !!$scope.supplier.tax._id) {
        if ($scope.supplier.selectedTax._id !== $scope.supplier.tax._id) {
          return true;
        }
      } else {
        return true;
      }
    }

    if (!!$scope.supplier.selectedPaymentTerms && !!$scope.supplier.selectedPaymentTerms.code) {
      if (!!$scope.supplier.pay_terms && !!$scope.supplier.pay_terms.code) {
        if ($scope.supplier.selectedPaymentTerms.code !== $scope.supplier.pay_terms.code) {
          return true;
        }
      } else {
        return true;
      }
    }

    if (!!$scope.supplier.selectedPaymentMethod && !!$scope.supplier.selectedPaymentMethod.code) {
      if (!!$scope.supplier.pay_method && !!$scope.supplier.pay_method.code) {
        if ($scope.supplier.selectedPaymentMethod.code !== $scope.supplier.pay_method.code) {
          return true;
        }
      } else {
        return true;
      }
    }

    if ($scope.update_email !== $scope.supplier.email) {
      return true;
    }

    if ($scope.update_phone !== $scope.supplier.phone) {
      return true;
    }

    if (!!$scope.supplier.selectedCurrency && $scope.supplier.selectedCurrency.code !==
      $scope.supplier.currency_code) {
      return true;
    }

    if ($scope.update_fax !== $scope.supplier.fax) {
      return true;
    }

    if (checkContactPersonChanges()) {
      return true;
    }

    return false;
  }

  function paymentTermValidation() {
    var validPaymentTerm = false;
    if (!!$scope.supplier.selectedPaymentTerms && !!$scope.supplier.selectedPaymentTerms.code) {
      if(globalFunc.findInArray(paymentTerms.data,'code',$scope.supplier.selectedPaymentTerms.code)) {
        validPaymentTerm = true;
      }
    }
    return validPaymentTerm;
  }

  function paymentMethodValidation() {
    var validPaymentMethod = false;
    if (!!$scope.supplier.selectedPaymentMethod && !!$scope.supplier.selectedPaymentMethod.code) {
      if(globalFunc.findInArray(paymentMethods.data,'code',$scope.supplier.selectedPaymentMethod.code)) {
        validPaymentMethod = true;
      }
    }
    return validPaymentMethod;
  }

  function updateChanges(updateAndSubmit) {
    if (!validateOnUpdate()) {
      toastr.error('Please complete all required fields before proceeding');
      return;
    }

    if (!paymentMethodValidation()) {
      toastr.error('Invalid payment method.');
      return;
    }

    if (!paymentTermValidation()) {
      toastr.error('Invalid payment term');
      return;
    }

    if (checkAddressChanges()) {
      $scope.updateAddress(updateAndSubmit);
    } else {
      $scope.updateSupplier(updateAndSubmit);
    }
  }

  //set status for parent
  function setActiveTab() {
    $scope.tabData.active = _.find($scope.tabData, function (tab) {
      if (!!tab.menu && tab.menu.length) {
        return _.find(tab.menu, function (item) {
          return item.params.status == supplier.status.toLowerCase();
        });
      }
      else {
        return tab.params.status == supplier.status.toLowerCase();
      }
    });
    if (!!$scope.tabData.active) {
      $scope.tabData.active.active = true;
    }
  }

  function backToListingSupplier() {
    var supplierStatus = supplierGlobalFunc.getSupplierStatus(
      supplier.status, supplier.approval_status, supplier.draft_status, 'descr'
    );
    var data = $scope.$parent.tabData;

    var tabData = _.find(data[0].menu, function (arr) {
      return (arr.params.status === supplierStatus.toLowerCase());
    });

    $rootScope.$broadcast('loadSpecificTab', {tab: tabData});
  }

  function back() {
    if (!!$scope.supplier && !!$scope.supplier._id) {
      HighlightId.setId($scope.supplier._id);
    }
    window.history.back();
  }

  function editActiveSupplier(currentStatus) {
    var title = 'Editing supplier';
    if (currentStatus === 'inactive' || currentStatus === 'black_listed' || currentStatus === 'rejected')
      title = 'move supplier to draft';

    swal(
      {
        title: 'Confirm ' + title + ' ?',
        text: 'A new draft will be created to be edited and approved',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: false,
        closeOnCancel: true
      },
      function () {
        draftSupplier.post(
          {
            parent_id: $scope.supplier._id,
            status: 1,
            // need to add paid up value and bumi status on creating draft from existing supplier
            // because there is a problem with versions and archive id the value is 0
            paid_up_value: $scope.update_paid_up_capital_amount,
            bumi_status: $scope.supplier.bumiputra_status,
            business_entity: $scope.supplier.selectedBusinessEntity.value,
            bu_status: supplierGlobalFunc.prepareSupplierGroup($scope.supplier.bu_status),
            is_global_supplier: $scope.supplier.is_global_supplier.toString()
          },
          function (resource) {
            if (!!resource && !!resource.content && !!resource.content.data) {
              swal.close();
              $location.search({id: resource.content.data._id});
            }
          },
          function (err) {
            draftExistError(err);
          }
        );
      }
    );
  }

  /**
   * Display Error for existing draft
   * @param err
   */
  function draftExistError(err) {
    if (!!err && !!err.data && !!err.data.content && !!err.data.content.error && !!err.data.content.message && !!err.data.content.message.draft_id) {
      swal(
        {
          title: err.data.content.error,
          type: 'warning',
          html: true,
          showCancelButton: true,
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'View Supplier',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true
        }, function (confirm) {
          if (!!confirm) {
            $state.go('main.user.suppliers.detail', {id: err.data.content.message.draft_id});
          }
        }
      );
    }
    else
      globalFunc.objectErrorMessage(err);
  }

  /**
   * Update the supplier status for action modal
   *
   * @param {string} status
   */
  function updateSupplierStatus (status) {
    var payload = {
      parent_id: $scope.supplier._id,
      status: status,
      status_reason: $scope.statusUpdatePayload.status_reason,
      paid_up_value: $scope.update_paid_up_capital_amount,
      bumi_status: $scope.supplier.bumiputra_status,
      business_entity: $scope.supplier.selectedBusinessEntity.value,
      bu_status: supplierGlobalFunc.prepareSupplierGroup($scope.supplier.bu_status),
      is_global_supplier: $scope.supplier.is_global_supplier.toString()
    };

    if (!!$scope.statusUpdatePayload.attachment) {
      payload.status_attachment_id = $scope.statusUpdatePayload.attachment._id;
    }

    return draftSupplier.post(payload,
      function (resource) {
        // update status
        draftSupplier.put({
          id: resource.content.data._id,
          action: 'submit'
        }, function () {
          $state.go('main.user.suppliers.manage', {status: 'pending'});
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        })
      },
      function (err) {
        draftExistError(err);
      }
    );
  }

  function onUpdatedContact(contact) {
    var index = _.findIndex($scope.selectedContactPersons, function (item) {
      return item._id == contact._id;
    });

    $scope.selectedContactPersons.splice(index, 1, contact);
  }

  /**
   * Function to revert any changes done to the html form by initializing the form to previous values
   */
  function revertUpdate() {
    initialize();

    if ($scope.editClicked === true) {
      $scope.editClicked = false;
      $scope.submitted = false;
      $scope.validatedBN = false;
      $scope.validatedCommodity = false;
      $scope.descrFirstCharHyphen = false;

      toastr.success('Changes reverted!');
      $state.reload();
    } else {
      $state.go('main.user.suppliers.manage');
    }
  }

  function removeContact(contact) {
    var index = _.findIndex($scope.selectedContactPersons, function (item) {
      return item._id == contact._id;
    });

    $scope.selectedContactPersons.splice(index, 1);
  }

  function onUpdatedCountry(country) {
    $scope.address.state = undefined;
    if (!!country.descr) {
      $scope.address.country = country.descr;
      $scope.selectedMalaysia = (country.descr === 'Malaysia');
    }
  }

  function onUpdatedState(state) {
    if (!!state) {
      $scope.address.state = state.descr;
    }
  }

  function loadApprovalFlow() {

    if (!$scope.supplier || !$scope.supplier.approval_id) {
      $scope.approvals = [];
    }

    Approvals.get(
      {
        id: $scope.supplier.approval_id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.approvals = resource.content.data;
          if ($scope.supplier.status.toLowerCase() === 'pending') {
            $scope.approvalFlowData = resource.content.data;
            globalFunc.getWaitingOnUser(resource.content.data, $scope.waiting_on_user);
          }
        } else {
          $scope.approvals = [];
        }
      },
      function () {
        $scope.approvals = [];
      });
  }

  function checkReject() {
    var statusReason = $scope.statusUpdatePayload.status_reason;

    return approvalSupplier.post(
      {
        approval_id: $scope.supplier.approval_id,
        status: 'reject'
      },
      {
        comment: statusReason,
        attachment_id: (!!$scope.statusUpdatePayload.attachment) ? $scope.statusUpdatePayload.attachment._id : null
      },
      function () {
        toastr.success('Supplier rejected.');
        HighlightId.setId($scope.supplier._id);
        $state.go('main.user.suppliers.manage', {status: 'rejected'});
      }, function () {
        toastr.error('Supplier cannot be rejected.');
      }
    );
  }

  /**
   * Function to approve supplier to move to next status
   */
  function checkApprove() {
    var statusReason = $scope.statusUpdatePayload.status_reason;

    return approvalSupplier.post(
      {
        approval_id: $scope.supplier.approval_id,
        status: 'approve'
      },
      {
        comment: statusReason,
        attachment_id: (!!$scope.statusUpdatePayload.attachment) ? $scope.statusUpdatePayload.attachment._id : null
      },
      function () {
        toastr.success('Supplier approved.');
        HighlightId.setId($scope.supplier._id);
        $state.go('main.user.suppliers.manage', {status: 'pending'});
      }, function () {
        toastr.error('Supplier cannot be approved.');
      }
    );
  }

  function getPaidUpCategory() {
    $scope.paidUpCategoryDescr = supplierGlobalFunc.getPaidUpCategory($scope.update_paid_up_capital_amount);
  }

  function updateStatus(action, updateAndSubmit) {
    var supplierFormValidation = validate();
    $scope.submitted = true;

    if (supplierFormValidation === false) {
      toastr.error('Please fill the required fields before proceeding');
      return;
    }

    if (!!updateAndSubmit) {
      draftSupplier.put(
        {
          id: $scope.supplier._id,
          action: action
        },
        {
          status_reason: ''
        },
        function () {
          var actionMessage = 'submitted';
          var redirection = 'pending';

          toastr.success('The supplier was ' + actionMessage + '.');
          HighlightId.setId($scope.supplier._id);
          $state.go('main.user.suppliers.manage', {status: redirection});
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      swal(
        {
          title: 'Confirm submit supplier?',
          text: 'This supplier will be submitted by you. Please state a reason.',
          showCancelButton: true,
          type: 'input',
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true,
          inputType: 'text',
          inputPlaceholder: 'Write a reason'
        },
        function (input) {
          if (input !== false) {
            draftSupplier.put(
              {
                id: $scope.supplier._id,
                action: action
              },
              {
                status_reason: input || ''
              },
              function () {
                var actionMessage = 'submitted';
                var redirection = 'pending';

                toastr.success('The supplier was ' + actionMessage + '.');
                HighlightId.setId($scope.supplier._id);
                $state.go('main.user.suppliers.manage', {status: redirection});
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
        }
      );
    }
  }

  function withdrawSupplier() {
    approvalSupplier.post(
      {
        approval_id: $scope.supplier.approval_id,
        status: 'withdraw'
      },
      {},
      function () {
        toastr.success('The supplier was withdrawn');
        HighlightId.setId($scope.supplier._id);
        $state.go('main.user.suppliers.manage', {status: 'withdrawn'});
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * Get all archived data of the active supplier
   */
  function getArchivesData() {
    // if status pending and it has parent_id, get the parent id
    if ($scope.supplier.status.toLowerCase() === 'pending' && !!$scope.supplier.parent_id) {
      singleSupplier.get({
        id: $scope.supplier.parent_id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          $scope.supplierVersions.push(resource.content.data);

        $scope.supplierVersions.unshift($scope.supplier);
      });
    } else if ($scope.supplier.status.toLowerCase() === 'active') {
      supplierArchives.get({
        id: $scope.supplier._id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.supplierVersions = resource.content.data;
          $scope.supplierVersions = reSortingArray($scope.supplierVersions, 'object_version');
          // add the current version to the supplier versions list
          $scope.supplierVersions.unshift($scope.supplier);
        }
      }, function () {
        $scope.supplierVersions = [];
      });
    }
  }

  /**
   * Get all archived draft version of the pending supplier
   */
  function getDraftArchivesData() {
    supplierArchives.get({
      id: $scope.supplier._id,
      type: 'draft'
    }, function (resource) {
      if (!!resource && !!resource.content && !!resource.content.data) {
        $scope.supplierDraftVersions = resource.content.data;
        // add the current version to the supplier versions list
        $scope.supplierDraftVersions.unshift($scope.supplier);
      }
    }, function () {
      $scope.supplierDraftVersions = [];
    });
  }

  /**
   * Sorting array based on the object key
   * @param array
   * @param key
   * @returns {*}
   */
  function reSortingArray(array, key) {
    return array.sort(function (a, b) {
      return a[key] - b[key];
    });
  }

  /**
   * Display supplier versions list in modal
   */
  function showVersionList() {
    $uibModal.open({
      templateUrl: 'app/suppliersManagement/versions/supplier-versions.html',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      resolve: {
        supplierVersions: function () {
          return $scope.supplierVersions;
        },
        supplierStatus: function () {
          return $scope.supplier.status;
        },
        versionType: function () {
          return '';
        }
      },
      controller: 'supplierVersionsController'
    });
  }

  /**
   * Display supplier draft versions list in modal
   */
  function showDraftVersionList() {
    $uibModal.open({
      templateUrl: 'app/suppliersManagement/versions/supplier-versions.html',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      resolve: {
        supplierVersions: function () {
          return $scope.supplierDraftVersions;
        },
        supplierStatus: function () {
          return $scope.supplier.status;
        },
        versionType: function () {
          return 'draft';
        }
      },
      controller: 'supplierVersionsController'
    });
  }

  /**
   * Move to draft to be able re edit
   * rejected or withdrawn supplier
   * @param currentStatus
   */
  function reopenDraftSupplier(currentStatus) {
    currentStatus = currentStatus.toLowerCase();
    swal({
        title: 'Confirm move ' + currentStatus + ' supplier to draft?',
        text: 'This supplier will be moved from ' + currentStatus + ' status to draft',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (input) {
        if (!!input) {
          draftSupplier.put(
            {
              id: $scope.supplier._id,
              action: 'reopen'
            },
            function () {
              toastr.success('The supplier was moved to draft successfully');
              HighlightId.setId($scope.supplier._id);
              $state.go('main.user.suppliers.manage', {status: 'draft'});
            },
            function (err) {
              draftExistError(err);
            }
          );
        }
      });

  }

  function initialize() {
    $scope.paymentMethods = supplierGlobalFunc.filterInactiveCode(paymentMethods.data);
    $scope.paymentTerms = supplierGlobalFunc.filterInactiveCode(paymentTerms.data);
    $state.params.status = !!$scope.supplier.status ? $scope.supplier.status.toLowerCase() : 'all';

    var statusNeedsRevision = ['active', 'pending'];
    if (statusNeedsRevision.indexOf($scope.supplier.status.toLowerCase()) > -1)
      getArchivesData();

    if ($scope.supplier.status.toLowerCase() === 'pending') {
      getDraftArchivesData();
    }

    //active tab
    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();

    // loadAttachments();

    /**
     * To initialize primary business nature by looping and comparing short descr with returned data
     */
    if (angular.isDefined($scope.supplier.primary_business_nature)) {
      for (var i = 0; i < $scope.businessNatures.length; i++) {
        if ($scope.businessNatures[i].shortDescr === $scope.supplier.primary_business_nature) {
          $scope.supplier.selectedPrimaryBusinessNature = $scope.businessNatures[i];
        }
      }
    }
    else {
      $scope.supplier.selectedPrimaryBusinessNature = $scope.businessNatures[0];
    }

    /**
     * To initialize secondary business nature by looping and comparing short descr with returned data
     */
    if (angular.isDefined($scope.supplier.secondary_business_nature)) {
      for (var j = 0; j < $scope.businessNatures.length; j++) {
        if ($scope.businessNatures[j].shortDescr === $scope.supplier.secondary_business_nature) {
          $scope.supplier.selectedSecondaryBusinessNature = $scope.businessNatures[j];
        }
      }
    }
    else {
      $scope.supplier.selectedSecondaryBusinessNature = $scope.businessNatures[0];
    }

    /**
     * To initialize business entities by looping and comparing short descr with returned data
     */
    if (angular.isDefined($scope.supplier.business_entity)) {
      for (var k = 0; k < $scope.businessEntities.length; k++) {
        if ($scope.businessEntities[k].value === $scope.supplier.business_entity) {
          $scope.supplier.selectedBusinessEntity = $scope.businessEntities[k];
        }
      }
    } else {
      $scope.supplier.selectedBusinessEntity = $scope.businessEntities[0];
    }

    /**
     * To initialize primary commodity code and populate drop downs accordingly
     */
    if (!!$scope.supplier.primary_commodity && !!$scope.supplier.primary_commodity.code) {
      $scope.primaryCommodityKeyword = $scope.supplier.primary_commodity.code + ' ' + $scope.supplier.primary_commodity.descr;
      $scope.supplier.primaryCommodity = $scope.supplier.primary_commodity;
    }

    /**
     * To initialize secondary commodity code and populate drop downs accordingly
     */
    if (!!$scope.supplier.secondary_commodity && $scope.supplier.secondary_commodity.code) {
      $scope.secondaryCommodityKeyword = $scope.supplier.secondary_commodity.code + ' ' + $scope.supplier.secondary_commodity.descr;
      $scope.supplier.secondaryCommodity = $scope.supplier.secondary_commodity;
    }

    $scope.update_email = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.update_email = $scope.supplier.email;
    }

    $scope.update_phone = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.update_phone = $scope.supplier.phone;
    }

    $scope.update_fax = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.update_fax = $scope.supplier.fax;
    }
    $scope.descrTitle = null;
    $scope.updateDescr = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.updateDescr = $scope.supplier.descr;
      $scope.descrTitle = $scope.updateDescr;
    }

    $scope.updateBranch = [];
    if (angular.isDefined($scope.supplier)) {
      $scope.updateBranch = $scope.supplier.branches;
    }

    $scope.update_code = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.update_code = $scope.supplier.mb_supplier_code;
    }

    $scope.updateRegNo = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.updateRegNo = $scope.supplier.reg_no;
    }

    $scope.update_gst_code = null;
    if (angular.isDefined($scope.supplier)) {
      $scope.update_gst_code = $scope.supplier.gst_code;
    }

    $scope.supplier.selectedPaymentTerms = null;
    if (!!$scope.supplier && !!$scope.supplier.pay_terms && !!$scope.supplier.pay_terms._id) {
      $scope.supplier.selectedPaymentTerms = $scope.supplier.pay_terms;
    }

    $scope.supplier.selectedPaymentMethod = null;
    if (!!$scope.supplier && !!$scope.supplier.pay_method && !!$scope.supplier.pay_method._id) {
      $scope.supplier.selectedPaymentMethod = $scope.supplier.pay_method;
    }

    $scope.supplier.selectedTax = null;
    if (!!$scope.supplier && !!$scope.supplier.tax) {
      $scope.supplier.selectedTax = $scope.supplier.tax;
    }

    $scope.selectedContactPersons = null;
    if (!!$scope.supplier && !!$scope.supplier.additional_contacts && !!$scope.supplier.additional_contacts.data) {
      $scope.selectedContactPersons = _.cloneDeep($scope.supplier.additional_contacts.data);
      $scope.selectedContactPersons.unshift($scope.supplier.contact_person);
    }

    $scope.supplier.selectedCurrency = null;
    if (!!$scope.supplier && !!$scope.supplier.currency_code) {
      var temp = _.find($scope.currencies, function (item) {
        return $scope.supplier.currency_code == item.code;
      });

      if (!!temp) {
        $scope.supplier.selectedCurrency = temp;
      }
    }

    $scope.address = {};
    if (!!$scope.supplier && !!$scope.supplier.corresponding_address && !_.isArray($scope.supplier.corresponding_address)) {
      $scope.address = _.cloneDeep($scope.supplier.corresponding_address);
    }

    /**
     * To initialize country by looping and comparing descr with returned data
     */
    if (angular.isDefined($scope.address.country)) {
      if (!!globalFunc.findInArray($scope.countries, 'descr', $scope.address.country)
        && globalFunc.findInArray($scope.countries, 'descr', $scope.address.country).descr ===
        $scope.address.country) {
        $scope.selectedMalaysia = ($scope.address.country === 'Malaysia');
      }
    }

    /* //backup supplier
     $scope.backup_supplier = _.cloneDeep($scope.supplier);*/

    if ($scope.supplier.status.toLowerCase() === 'pending') {
      $scope.loadApprovalFlow();
    }

    if (angular.isDefined($scope.supplier) && angular.isDefined($scope.supplier.paid_up_value)) {
      $scope.update_paid_up_capital_amount = !!$scope.supplier.paid_up_value ?
        Number($scope.supplier.paid_up_value) : null;
      getPaidUpCategory();
    }

    if (angular.isDefined($scope.supplier) && angular.isDefined($scope.supplier.bumi_status)) {
      $scope.supplier.bumiputra_status = $scope.supplier.bumi_status;
    }
    if (angular.isDefined($scope.supplier) && angular.isDefined($scope.supplier.receiving_mode)) {
      switch ($scope.supplier.receiving_mode) {
        case 'SYSTEM':
          $scope.selection.poMethod = 0;
          break;
        case 'EMAIL':
          $scope.selection.poMethod = 1;
          break;
        case 'FAX':
          $scope.selection.poMethod = 2;
          break;
        case 'POST':
          $scope.selection.poMethod = 3;
          break;
      }
    }

    $scope.supplier.comments = globalFunc.translateSupplierHistory($scope.supplier.comments);
    $scope.isValidPhoneNo = true;
    $scope.isValidFaxNo = true;
  }

  initialize();

  /**
   * @function duplicationCheck
   * Calls the global function's duplication check
   * Checks callback function return for assigning scope values for validation
   **/
  function duplicationCheck(model, field, value, checker) {

    globalFunc.duplicationCheck(model, field, value, checker, function (callback) {
      switch (callback) {
        case 'rocCheckTrue':
          if ($scope.updateRegNo !== $scope.originalROC) {
            $scope.rocCheck = true;
          }
          else {
            $scope.rocCheck = false;
          }
          break;
        case 'rocCheckFalse':
          $scope.rocCheck = false;
          break;
        case 'gstCheckTrue':
          if ($scope.update_gst_code !== $scope.originalGSTCode) {
            $scope.gstCheck = true;
          }
          else {
            $scope.gstCheck = false;
          }
          break;
        case 'gstCheckFalse':
          $scope.gstCheck = false;
          break;
        case 'supplierDescrCheckTrue':
          if ($scope.updateDescr !== $scope.originalDescr) {
            $scope.descrCheck = true;
          }
          else {
            $scope.descrCheck = false;
          }
          break;
        case 'supplierDescrCheckFalse':
          $scope.descrCheck = false;
          break;
      }
    });
  }

  /**
   * Validate number format with given element id and returns boolean in field name
   *
   * @param {string} elementId
   * @param {string} fieldName
   */
  function validateNumbers(elementId, fieldName) {
    $scope[fieldName] = globalFunc.numberFormatValidation(elementId);
  }

  function removeSecondaryCommodity() {
    if (!!$scope.supplier) {
      $scope.supplier.secondaryCommodity = undefined;
      $scope.secondaryCommodityKeyword = null;
    }
  }

  function editSupplier() {
    $scope.editClicked = true;
  }

  /**
   * Download attachment
   *
   * @param {object} attachment
   */
  function downloadAttachment(attachment) {
    if (!!attachment) {
      attachmentDetail.get({
        id: attachment._id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          getAttachmentFile(resource.content.data.temporary_url);
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
    }
  }

  /**
   * Get the attachment file
   *
   * @param {string} url
   */
  function getAttachmentFile(url) {
    var newUrl = $filter('format')(pathConstants.apiUrls.attachments.download, {
      hash: url
    });
    $http({
      url: newUrl
    }).then(function () {
      window.open(newUrl, '_self');
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    });
  }
}

supplierDetailCtrl.$inject = [
  '$scope', '$q', 'toastr', 'supplier', 'taxes', 'singleSupplier', 'paymentMethods', 'paymentTerms', '$state',
  '$location', 'currencies', 'HighlightId', 'addressList', 'singleAddress', 'Approvals', 'profile', 'globalFunc',
  'approvalSupplier', 'searchAllCommodity', 'listChild', 'supplierGlobalFunc', 'draftSupplier', 'supplierArchives',
  '$uibModal', 'pathConstants', '$http', '$rootScope', 'attachmentDetail', '$filter'
];

angular.module('metabuyer')
  .controller('supplierDetailCtrl', supplierDetailCtrl);

'use strict';

function supplierTaggingCtrl($scope, $rootScope, globalFunc, supplierTagViaCompany, suppliersList, toastr,
                             getTagsByCompanyCode, companiesList, $stateParams, $filter, UserPermissions,
                             supplierTagHistory)
{
  $scope.selectCompany = selectCompany;
  $scope.loadSupplierTags = loadSupplierTags;
  $scope.selectSupplier = selectSupplier;
  $scope.back = back;
  $scope.createTag = createTag;
  $scope.removeSupplier = removeSupplier;
  $scope.removeAllSelectedSupplier = removeAllSelectedSupplier;
  $scope.hasRemoveSupplierTagAccess = hasRemoveSupplierTagAccess;

  /**
   * Function to assign the scope of company code
   * @param company
   */
  function selectCompany (company) {
    refreshSuppliers();
    $scope.selectedCompanyCode = company.code;
    loadSupplierTags(company.code);
  }

  function loadSupplierTags(companyCode) {
    $scope.loading = true;
    getTagsByCompanyCode.get(
      {
        companyCode: companyCode
      },
      function (resource) {

        if(!!resource && !!resource.content && !!resource.content.data) {
          $scope.loading = false;
          $rootScope.$broadcast('refreshComments');
          var temp = [];
          var tags = resource.content.data;
          _.forEach($scope.suppliersList, function (supplier) {
            _.forEach(tags, function (tag) {
              if (supplier.mb_supplier_code === tag.supplier_code) {
                temp.push(supplier);
              }
            });
          });
          $scope.selectedSuppliers = globalFunc.sortObjectsArray(temp, 'descr');
          if (!!$scope.selectedSuppliers && $scope.selectedSuppliers.length > 0) {
            _.forEach($scope.selectedSuppliers, function (supplier) {
              $scope.suppliersList = globalFunc.removeValueFromArray($scope.suppliersList, '_id', supplier._id);
            })
          }
        }
      });
  }

  function selectSupplier(selectedSupplier) {
    $scope.suppliersList = globalFunc.removeValueFromArray($scope.suppliersList, '_id', selectedSupplier._id);
    $scope.selectedSuppliers.push(selectedSupplier);
    $scope.selectedSuppliers = $filter('orderBy')($scope.selectedSuppliers, 'descr');
  }

  function removeSupplier (selectedSupplier) {
    if (!hasRemoveSupplierTagAccess()) {
      return;
    }

    $scope.selectedSuppliers = globalFunc.removeValueFromArray($scope.selectedSuppliers, '_id', selectedSupplier._id);
    $scope.suppliersList.push(selectedSupplier);
    $scope.suppliersList = $filter('orderBy')($scope.suppliersList, 'descr');
  }

  function removeAllSelectedSupplier () {
    swal({
      title: 'Confirm remove all selected supplier(s)?',
      text: 'All selected supplier(s) will be deselected.',
      showCancelButton: true,
      confirmButtonColor: '#1ab394',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    }, function () {
      $scope.suppliersList = $scope.suppliersList.concat($scope.selectedSuppliers);
      $scope.selectedSuppliers = [];
      $scope.suppliersList = $filter('orderBy')($scope.suppliersList, 'descr');
      toastr.success('All selected supplier(s) was deselected.');
    });
  }

  function hasRemoveSupplierTagAccess() {
    return UserPermissions.checkSupplierTagAccess($rootScope.currentUser, 'D');
  }

  function back (){
    window.history.back();
  }

  function resetAll () {
    $scope.tag.selectedCompany = undefined;
    $scope.selectedCompanyCode = undefined;
    $scope.selectedSuppliers =[];
    refreshSuppliers();
  }

  /**
   * Function to validate input fields
   * @returns {boolean}
   */
  function validate () {
    if (!$scope.selectedCompanyCode) {
      return false;
    }
    return true;
  }

  /**
   * Function to create a supplier tag
   */
  function createTag () {

    if (validate()) {
      var supplierCodesArray = [];
      _.forEach ($scope.selectedSuppliers, function(supplier){
        supplierCodesArray.push(supplier.mb_supplier_code);
      });

      var submitData = {
        companyCode: $scope.selectedCompanyCode,
        supplierCodes: supplierCodesArray
      };

      supplierTagViaCompany.post(
        {},
        submitData,
        function () {
          toastr.success('Supplier tagging created successfully');
          resetAll();
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
    else {
      toastr.error('Please complete the selections for tagging');
    }
  }

  /**
   * Function to prepare the import parameters for supplier tagging
   */
  function prepareImportParams () {
    $scope.params = {
      'class': 'Metabuyer\\Models\\SupplierTag'
    };

    _.forEach ($scope.companiesList, function(company, index){
      var temp = 'additional_params[companyCodes]['+ index+ ']';
      $scope.params[temp] = company.code;
    });
  }

  function refreshSuppliers () {
    $scope.selectedSuppliers = [];
    $scope.suppliersList = [];
    $scope.suppliersList = _.cloneDeep(suppliersList);
  }

  function initialize () {
    $scope.tag = {};
    if (!globalFunc.findInArray($rootScope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN')) {
      $scope.companiesList = $rootScope.currentUser.companies;
    }
    else{
      $scope.companiesList = companiesList.data;
    }

    if (!!$stateParams.companyCode) {
      $scope.tag.selectedCompany = globalFunc.findInArray($scope.companiesList, 'code', $stateParams.companyCode);
      selectCompany($scope.tag.selectedCompany);
    }
    else {
      $scope.selectedSuppliers = [];
      $scope.tag.selectedCompany = undefined;
      $scope.selectedCompanyCode = undefined;
    }

    $scope.suppliersList = _.cloneDeep(suppliersList);
    prepareImportParams();

    $scope.commentService = supplierTagHistory;
  }

  initialize();
}

supplierTaggingCtrl.$inject = [
  '$scope', '$rootScope', 'globalFunc', 'supplierTagViaCompany', 'suppliersList', 'toastr', 'getTagsByCompanyCode',
  'companiesList', '$stateParams', '$filter', 'UserPermissions', 'supplierTagHistory'
];

angular.module('metabuyer')
  .controller('supplierTaggingCtrl', supplierTaggingCtrl);

'use strict';

function suppliersListManageCtrl(
  $scope, suppliers, $rootScope, action, suppliersList, $stateParams, HighlightId, $window, supplierGlobalFunc,
  $filter)
{

  $scope.showColumn = showColumn;
  $scope.getStatusName = getStatusName;

  $scope.storageKey = 'suppliers-list-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the status name
   * @param supplierStatus
   * @param approvalStatus
   * @param draftingStatus
   * @returns {*}
   */
  function getStatusName(supplierStatus, approvalStatus, draftingStatus){
    var status = supplierGlobalFunc.getSupplierStatus(supplierStatus, approvalStatus, draftingStatus, 'val');
    if (!!status)
      return status;

    return 'N/A';
  }


  function initialize(){
    $scope.suppliers = suppliers.data;
    $scope.actionType = action;
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;

    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }

    $scope.meta = suppliers.meta;
    $scope.supplierManageService = suppliersList;
    $scope.status = $stateParams.status;

    if(!!$stateParams.status) {
      $rootScope.$broadcast('setSuppliersListTab', $stateParams.status.toLowerCase());
    }
    //set status for parent
    $scope.highlightId = HighlightId.getId();
    if(!!$scope.highlightId) {
      //scroll the window to top
      $window.scroll(0, 0);
      //clear current id
      HighlightId.setId(null);
    }
  }

  initialize();
}

suppliersListManageCtrl.$inject = [
  '$scope','suppliers', '$rootScope', 'action', 'suppliersList', '$stateParams', 'HighlightId', '$window',
  'supplierGlobalFunc', '$filter'
];

angular.module('metabuyer')
  .controller('suppliersListManageCtrl', suppliersListManageCtrl);

'use strict';

function suppliersListDetailsCtrl(
  $scope, $q, $rootScope, toastr, supplier, currencies, Approvals, profile, globalFunc, listChild, commodities,
  supplierGlobalFunc, $state, HighlightId
) {
  $scope.supplier = supplier;
  $scope.supplier.status = supplierGlobalFunc.getSupplierStatus(
      supplier.status, supplier.approval_status, supplier.draft_status, 'descr'
  );
  $scope.approvals = [];
  $scope.approvalFlowData = {};
  $scope.waiting_on_user = [];
  $scope.checkWaitingOn = checkWaitingOn;
  $scope.back = back;
  $scope.loadCommodityList = loadCommodityList;
  $scope.selectedBumiputra = selectedBumiputra;
  $scope.selectPO = selectPO;
  $scope.address = {};
  $scope.loadApprovalFlow = loadApprovalFlow;
  $scope.currencies = currencies;
  $scope.primarySegments = commodities.data;
  $scope.secondarySegments = commodities.data;
  $scope.secondarySegments.unshift({_id: null, descr: 'N/A', unique_name: null});
  $scope.selectedContactPersons = [];
  $scope.user = profile;
  $scope.editClicked = false;
  $scope.originalROC = $scope.supplier.reg_no;
  $scope.originalGSTCode = $scope.supplier.gst_code;

  $scope.bumiputraStatus = [
    {descr: 'Yes', value: 1},
    {descr: 'No', value: 0}
  ];


  //TODO: move this data to the Global function (Ahmed Saleh, 26/3/2016)
  // The standard list for Business Nature and Business Entity
  $scope.businessNatures = [
    {descr: 'Unspecified Business Nature', shortDescr: 'UNSPECIFIED', value: 0},
    {descr: 'Agent', shortDescr: 'AGENT', value: 1},
    {descr: 'Banking & Financial Services', shortDescr: 'BANKING',  value: 2},
    {descr: 'Consultancy, Advisory & Other Professional Bodies', shortDescr: 'CONSULTANCY',  value: 3},
    {descr: 'Contractor', shortDescr: 'CONTRACTOR',  value: 4},
    {descr: 'Dealer', shortDescr: 'DEALER',  value: 5},
    {descr: 'Distribute', shortDescr: 'DISTRIBUTOR',  value: 6},
    {descr: 'Manufacturer', shortDescr: 'MANUFACTURER',  value: 7},
    {descr: 'Marketing', shortDescr: 'MARKETING',  value: 8},
    {descr: 'Retailer', shortDescr: 'RETAILER',  value: 9},
    {descr: 'Service Provider', shortDescr: 'SERVICE_PROVIDER',  value: 10},
    {descr: 'Sub-Contractor', shortDescr: 'SUB_CONTRACTOR',  value: 11},
    {descr: 'Trading', shortDescr: 'TRADING',  value: 12},
    {descr: 'Other', shortDescr: 'OTHERS',  value: 13}
  ];
  $scope.businessEntities = [
    {descr: 'Unspecified Business Entity', shortDescr: 'UNSPECIFIED', value: 0},
    {descr: 'Berhad (Public Limited)', shortDescr: 'BERHAD',  value: 1},
    {descr: 'Sendirian Berhad (Private Limited)', shortDescr: 'SENDIRIAN_BERHAD',  value: 2},
    {descr: 'Sole Proprietor & Enterprise', shortDescr: 'SOLE', value: 3},
    {descr: 'Partnership', shortDescr: 'PARTNERSHIP', value: 4}
  ];

  $scope.poReceive = [
    {descr: 'System', value: 0},
    {descr: 'System and Email', value: 1},
    {descr: 'System, Email and Fax', value: 2},
    {descr: 'System, Email, Fax and Post', value: 3}
  ];

  $scope.selection = {
    poMethod: {}
  };

  $scope.freightTerms = [];

  // Add requestor
  $scope.requestor = {
    "_id": $scope.supplier.created_by._id,
    "display_name": $scope.supplier.created_by.display_name,
    "img_url":""
  };

  $scope.methodSelected = false;
  $scope.faxChecker = false;
  $scope.emailChecker = false;

  function selectPO(poMethod){
    $scope.methodSelected = true;
    if(poMethod === 2 || poMethod === 3){
      $scope.faxChecker = true;
    }
    else{
      $scope.faxChecker = false;
    }
    if(poMethod === 1 || poMethod === 2 || poMethod === 3){
      $scope.emailChecker = true;
    }
    else{
      $scope.emailChecker = false;
    }
  }

  //check user waiting on
  function checkWaitingOn() {
    var find_user = _.find($scope.waiting_on_user, function (approver) {
      return (approver._id == profile._id);
    });

    if (find_user != undefined) {
      return true;
    }
    return false;
  }

  // Get the waiting on user
  function getWaitingOnUser(approval_flow_data) {
    $scope.waiting_on_user.splice(0, $scope.waiting_on_user.length);
    for (var i = 0; i < approval_flow_data.waiting_on.length; i++) {
      for (var z = 0; z < approval_flow_data.flow.length; z++) {
        for (var k = 0; k < approval_flow_data.flow[z].roles.length; k++) {
          for (var j = 0; j < approval_flow_data.flow[z].roles[k].users.length; j++) {
            if (approval_flow_data.waiting_on[i]._id === approval_flow_data.flow[z].roles[k].users[j]._id) {
              $scope.waiting_on_user.push(approval_flow_data.flow[z].roles[k].users[j]);
            }
          }
        }
      }
    }
    // });
  }

  function back() {
    if(!!$scope.supplier && !!$scope.supplier._id){
      HighlightId.setId($scope.supplier._id);
    }

    window.history.back();
  }

  /**
   * Function for loading the commodity listing based on parameter item for code
   */
  function loadCommodityList(item, callback){
    listChild.get(
      {
        code : item
      },
      function(resource){
        $scope.families = resource.content.data;
        if(typeof callback === 'function'){
          callback($scope.families);
        }
      },
      function(error){
        if (error.status === 404) {
          toastr.error("Could not load families for this segment");
        }
      }
    );
  }

  /**
   * Function for setting bumiputra status
   */
  function selectedBumiputra(value){
    $scope.supplier.bumiputra_status = value;
  }


  /**
   * function for loading the approval
   * @returns {*}
   */
  function loadApprovalFlow() {

    var deferred = $q.defer();

    if (!$scope.supplier || !$scope.supplier.approval_id) {
      $scope.approvals = [];
      deferred.resolve([]);
      return deferred.promise;
    }

    Approvals.get(
      {
        id: $scope.supplier.approval_id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.flow) {
          $scope.approvals = resource.content.data.flow;
          deferred.resolve(resource.content.data.flow);
          if ($scope.supplier.status.toLowerCase() === 'pending') {
            $scope.approvalFlowData = resource.content.data;
            getWaitingOnUser(resource.content.data);
          }
        } else {
          $scope.approvals = [];
          deferred.resolve([]);
        }
      },
      function () {
        $scope.approvals = [];
        deferred.resolve([]);
      });

    return deferred.promise;
  }

  function getPaidUpCategory(){
    $scope.paidUpCategoryDescr = supplierGlobalFunc.getPaidUpCategory($scope.supplier.paid_up_value);
  }

  function initialize(){
    $state.params.status = !!$scope.supplier.status ? $scope.supplier.status.toLowerCase() : 'all';

    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);

    getPaidUpCategory();

    //active tab
    $rootScope.$broadcast('setSuppliersListTab', $scope.supplier.status.toLowerCase());
    $scope.countries = globalFunc.countryCode();
    $scope.MYStates = globalFunc.malaysiaState();

    /**
     * To initialize primary business nature by looping and comparing short descr with returned data
     */
    if(angular.isDefined($scope.supplier.primary_business_nature)){
      for(var i = 0; i < $scope.businessNatures.length ; i++){
        if($scope.businessNatures[i].shortDescr === $scope.supplier.primary_business_nature){
          $scope.supplier.selectedPrimaryBusinessNature = $scope.businessNatures[i];
        }
      }
    }
    else{
      $scope.supplier.selectedPrimaryBusinessNature = $scope.businessNatures[0];
    }

    /**
     * To initialize secondary business nature by looping and comparing short descr with returned data
     */
    if(angular.isDefined($scope.supplier.secondary_business_nature)){
      for(var j = 0; j < $scope.businessNatures.length ; j++){
        if($scope.businessNatures[j].shortDescr === $scope.supplier.secondary_business_nature){
          $scope.supplier.selectedSecondaryBusinessNature = $scope.businessNatures[j];
        }
      }
    }
    else{
      $scope.supplier.selectedSecondaryBusinessNature = $scope.businessNatures[0];
    }

    /**
     * To initialize business entities by looping and comparing short descr with returned data
     */
    if(angular.isDefined($scope.supplier.business_entity)){
      for(var k = 0; k < $scope.businessEntities.length ; k++){
        if($scope.businessEntities[k].value === parseInt($scope.supplier.business_entity)){
          $scope.supplier.selectedBusinessEntity= $scope.businessEntities[k];
        }
      }
    }else{
      $scope.supplier.selectedBusinessEntity = $scope.businessEntities[0];
    }

    $scope.selectedContactPersons = null;
    if(!!$scope.supplier && !!$scope.supplier.additional_contacts &&
       !!$scope.supplier.additional_contacts.data){
      $scope.selectedContactPersons = _.cloneDeep($scope.supplier.additional_contacts.data);
      $scope.selectedContactPersons.unshift($scope.supplier.contact_person);
    }

    $scope.supplier.selectedCurrency = null;
    if(!!$scope.supplier && !!$scope.supplier.currency_code ){
      var temp = _.find($scope.currencies, function(item){
        return $scope.supplier.currency_code == item.code;
      });

      if(!!temp){
        $scope.supplier.selectedCurrency = temp;
      }
    }

    $scope.address = {};
    if(!!$scope.supplier && !!$scope.supplier.corresponding_address &&
       !_.isArray($scope.supplier.corresponding_address)){
      $scope.address = _.cloneDeep($scope.supplier.corresponding_address);
    }

    /**
     * To initialize country by looping and comparing descr with returned data
     */
    if(angular.isDefined($scope.address.country)){
        if(!!globalFunc.findInArray($scope.countries,'descr',$scope.address.country)
            &&globalFunc.findInArray($scope.countries,'descr',$scope.address.country).descr ===
          $scope.address.country){
          if($scope.address.country === "Malaysia")
          {
            $scope.selectedMalaysia = true;
          }
          else {
            $scope.selectedMalaysia = false;
          }
        }
    }

    if ($scope.supplier.status.toLowerCase() === 'pending') {
      $scope.loadApprovalFlow();
    }

    if(angular.isDefined($scope.supplier) && angular.isDefined($scope.supplier.bumi_status)){
      $scope.supplier.bumiputra_status = $scope.supplier.bumi_status;
    }

    if(angular.isDefined($scope.supplier) && angular.isDefined($scope.supplier.receiving_mode)){
      switch($scope.supplier.receiving_mode){
        case 'SYSTEM':
          $scope.selection.poMethod = 0;
          break;
        case 'EMAIL':
          $scope.selection.poMethod = 1;
          break;
        case 'FAX':
          $scope.selection.poMethod = 2;
          break;
        case 'POST':
          $scope.selection.poMethod = 3;
          break;
      }
    }

    $scope.supplier.comments = globalFunc.translateSupplierHistory($scope.supplier.comments);
  }

  initialize();


}

suppliersListDetailsCtrl.$inject = [
  '$scope', '$q', '$rootScope', 'toastr','supplier', 'currencies', 'Approvals' , 'profile', 'globalFunc','listChild',
  'commodities', 'supplierGlobalFunc', '$state', 'HighlightId'
];

angular.module('metabuyer')
  .controller('suppliersListDetailsCtrl', suppliersListDetailsCtrl);

'use strict';

function tenantSettingsCtrl($scope, tenant, globalFunc, $state, toastr, tenantSettings, $auth,
                            tenantLogo, uploadTenantLogo, pathConstants, singleTenantById,
                            $filter, pdfPreview, $rootScope) {

  $scope.tenantSetting = {};
  $scope.submitSettings = submitSettings;
  $scope.saveTenantInfo = saveTenantInfo;
  $scope.cancelSubmit = cancelSubmit;
  $scope.isUploadImageSuccess = isUploadImageSuccess;

  $scope.forexUpdateFreq = [
    {value: 1, descr: 'Daily'},
    {value: 7, descr: 'Weekly'},
    {value: 30, descr: 'Monthly'}
  ];

  // config flowjs
  $scope.flowConfig = new Flow({
    target: uploadTenantLogo.uploadImagePath,
    singleFile: true,
    testChunks: false,
    chunkSize: 10000000,
    headers: {
      'Authorization': 'Bearer ' + $auth.getToken()
    },
    query: {
      tenant_name: 'Sunway Group'
    }
  });

  function isUploadImageSuccess(file, message) {
    if (message) {
      var response = JSON.parse(message);
      toastr.success(response.content.message);
    }
  }

  function submitSettings() {
    var data = {};
    data.config = {};

    data.config.forex_update_freq = angular.copy($scope.tenantSetting.forex.value);
    tenantSettings.put(
      {}, data,
      function () {
        saveTenantInfo(false);
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function saveTenantInfo(printFlag) {
    var submitData = $scope.tenantData;
    submitData.terms_and_conditions = $scope.tenantTermsAndConditions;
    singleTenantById.put(
      {
        id: $scope.tenantData._id
      },
      submitData,
      function () {
        toastr.success('Settings successfully applied.');
        if (!!printFlag) {
          previewTenantPDF();
        }
        else {
          $state.go('main.user.settings.mainPanel');
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function previewTenantPDF() {
    pdfPreview.post(
      {
        id: $scope.tenantData._id
      },
      {
        terms_and_conditions_level: 'tenant'
      },
      function (resource) {
        var newUrl = $filter('format')(pathConstants.apiUrls.globalPDFHashDownload, {
          pdf_hash: resource.url
        });

        setTimeout(function () {
          window.open(newUrl, '_blank')
        }, 1001);
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function cancelSubmit() {
    $state.go('main.user.settings.mainPanel');
  }

  function initialize() {
    if (!!tenant && !!tenant.data && !!tenant.data.config) {
      var settings = tenant.data.config,
        forexSetting = settings.forex_update_freq;

      $scope.tenantSetting.forex = globalFunc.findInArray($scope.forexUpdateFreq, 'value', forexSetting);
    }

    $scope.imageBasePath = pathConstants.apiUrls.image.user;

    singleTenantById.get(
      {
        id: $rootScope.currentUser.tenant_id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.tenantData = resource.content.data;
          if (!!resource.content.data.terms_and_conditions)
          $scope.tenantTermsAndConditions = resource.content.data.terms_and_conditions;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );

    tenantLogo.get(
      {
        tenant_name: 'Sunway Group'
      },
      function (resource) {
        $scope.tenantImgUrl = resource.url;
      }
    )
  }

  initialize();
}

tenantSettingsCtrl.$inject = ['$scope', 'tenant', 'globalFunc', '$state', 'toastr', 'tenantSettings', '$auth',
  'tenantLogo', 'uploadTenantLogo', 'pathConstants', 'singleTenantById', '$filter', 'pdfPreview', '$rootScope'];

angular
  .module('metabuyer')
  .controller('tenantSettingsCtrl', tenantSettingsCtrl);

'use strict';
/**
 * @name approvalFlowCtrl
 * @desc Controller for Approval Flow Management Parent Controller
 */
function mainPanelSettingsCtrl ($scope) {
  $scope.settings = [
    {
      title: 'Company Settings',
      key: 'main.user.settings.PRPOSettings.prefix'
    },
    {
      title: 'Admin Settings',
      key: 'main.user.settings.adminSettings'
    },
    {
      title: 'Tenant Settings',
      key: 'main.user.settings.tenant'
    }
  ];

  //TODO: have this cleaned up with better engineering solution (Ahmed Saleh)
}
mainPanelSettingsCtrl.$inject = ['$scope'];

angular
  .module('metabuyer')
  .controller('mainPanelSettingsCtrl', mainPanelSettingsCtrl);

'use strict';

function adminSettingsCtrl ($scope, settings, adminSettings, globalFunc, $state, toastr) {

  $scope.settings = {};
  $scope.submitSettings = submitSettings;
  $scope.cancelSubmit = cancelSubmit;
  $scope.resetSettings = resetSettings;

  $scope.expiryDates = [
    {value: 60, descr: '60 Days'},
    {value: 90, descr: '90 Days'},
    {value: 120, descr: '120 Days'},
    {value: 150, descr: '150 Days'}
  ];

  $scope.passwordLength = [
    {value: 6, descr: '6 Characters'},
    {value: 8, descr: '8 Characters'},
    {value: 10, descr: '10 Characters'}
  ];

  $scope.inactiveDuration = [
    {value: 60, descr: '60 Days'},
    {value: 90, descr: '90 Days'},
    {value: 120, descr: '120 Days'},
    {value: 150, descr: '150 Days'}
  ];

  $scope.passwordHistory = [
    {value: 2, descr: '2 passwords'},
    {value: 3, descr: '3 passwords'},
    {value: 4, descr: '4 passwords'},
    {value: 5, descr: '5 passwords'}
  ];

  $scope.loginAttempts = [
    {value: 2, descr: '2 retries'},
    {value: 3, descr: '3 retries'},
    {value: 4, descr: '4 retries'},
    {value: 5, descr: '5 retries'}
  ];

  $scope.idleTime = [
    {value: 15, descr:'15 minutes'},
    {value: 30, descr:'30 minutes'},
    {value: 60, descr:'60 minutes'},
    {value: 90, descr:'90 minutes'},
    {value: 120, descr:'120 minutes'}
  ];

  $scope.unlockAfterMinutes = [
    {value: 1, descr:'1 minute'},
    {value: 2, descr:'2 minute'},
    {value: 3, descr:'3 minute'},
    {value: 5, descr:'5 minute'},
    {value: 10, descr:'10 minute'}
  ];

  $scope.booleanArray = [
    {value: true, descr: ' True'},
    {value: false, descr: ' False'}
  ];

  function submitSettings() {
    var data = {
      config: {}
    };

    /**
     * Preparing the password object for payload
     */
    data.config.password = {};
    data.config.password.len = angular.copy($scope.settings.len.value);
    data.config.password.expiry = angular.copy($scope.settings.expiry.value);
    data.config.password.lock_after = angular.copy($scope.settings.lock_after.value);
    data.config.password.history = angular.copy($scope.settings.history.value);
    data.config.password.max_login_attempts = angular.copy($scope.settings.max_login_attempts.value);
    data.config.password.multicase = angular.copy($scope.settings.multicase.value);
    data.config.password.numbers = angular.copy($scope.settings.numbers.value);
    data.config.password.symbols = angular.copy($scope.settings.symbols.value);
    data.config.password.unlock_after_minutes = angular.copy($scope.settings.unlock_after_minutes.value);

    /**
     * Preparing the session timeout field and enable auditing
     */
    data.config.session_timeout = angular.copy($scope.settings.session_timeout.value);

    data.config.enable_auditing = angular.copy($scope.settings.enable_auditing.value);

    adminSettings.put(
      {}, data,
      function () {
        toastr.success('Successfully applied settings');
      },
      function () {
        toastr.error('Failed to apply settings');
      }
    );
  }

  function cancelSubmit() {
    $state.go('main.user.settings.mainPanel');
  }

  function resetSettings() {
    swal({
        title: 'Confirm reset settings?',
        text: 'The admin settings will be reverted to original values.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (isConfirm) {
          var data = {
            config: {}
          };

          /**
           * Preparing the default values in password object for payload
           */
          data.config.password = {};
          data.config.password.len = 8;
          data.config.password.expiry = 90;
          data.config.password.lock_after = 90;
          data.config.password.history = 3;
          data.config.password.max_login_attempts = 5;
          data.config.password.multicase = true;
          data.config.password.numbers = true;
          data.config.password.symbols = false;
          data.config.password.unlock_after_minutes = 1;

          /**
           * Preparing the default session timeout and enable auditing
           */
          data.config.session_timeout = 60;

          data.config.enable_auditing = false;

          adminSettings.put(
            {}, data,
            function () {
              toastr.success('Successfully reverted settings to default values');
              cancelSubmit();
            },
            function () {
              toastr.error('Failed to revert settings to default values');
            }
          );
        }
      });
  }

  function initialize() {
    if (!!settings.data && !!settings.data.config) {
      $scope.settings = settings.data.config.password;
      $scope.settings.session_timeout = settings.data.config.session_timeout;
      $scope.settings.enable_auditing = settings.data.config.enable_auditing;
    }

    /**
     * Initializing the password settings
     */
    $scope.settings.expiry = globalFunc.findInArray(
      $scope.expiryDates, 'value', $scope.settings.expiry
    );
    $scope.settings.lock_after = globalFunc.findInArray(
      $scope.inactiveDuration, 'value', $scope.settings.lock_after
    );
    $scope.settings.history = globalFunc.findInArray(
      $scope.passwordHistory,'value', $scope.settings.history
    );
    $scope.settings.max_login_attempts = globalFunc.findInArray(
      $scope.loginAttempts,'value', $scope.settings.max_login_attempts
    );
    $scope.settings.len = globalFunc.findInArray(
      $scope.passwordLength,'value', $scope.settings.len
    );
    $scope.settings.multicase = globalFunc.findInArray(
      $scope.booleanArray, 'value', $scope.settings.multicase
    );
    $scope.settings.numbers = globalFunc.findInArray(
      $scope.booleanArray, 'value', $scope.settings.numbers
    );
    $scope.settings.symbols = globalFunc.findInArray(
      $scope.booleanArray, 'value', $scope.settings.symbols
    );
    $scope.settings.unlock_after_minutes = globalFunc.findInArray(
      $scope.unlockAfterMinutes, 'value', $scope.settings.unlock_after_minutes
    );

    /**
     * Initializing the session timeout and enable auditing settings
     */
    $scope.settings.session_timeout = globalFunc.findInArray(
      $scope.idleTime, 'value', $scope.settings.session_timeout
    );
    $scope.settings.enable_auditing = globalFunc.findInArray(
      $scope.booleanArray, 'value', $scope.settings.enable_auditing
    );
  }

  initialize();
}
adminSettingsCtrl.$inject = ['$scope', 'settings', 'adminSettings', 'globalFunc', '$state', 'toastr'];

angular
  .module('metabuyer')
  .controller('adminSettingsCtrl', adminSettingsCtrl);

'use strict';
/**
 * @name approvalFlowCtrl
 * @desc Controller for Approval Flow Management Parent Controller
 */
function PRPOSettingsCtrl ($scope) {

  $scope.tabData = [
    {
      heading: 'Company Prefix',
      route: 'main.user.settings.PRPOSettings.prefix'
    }
  ];
}
PRPOSettingsCtrl.$inject = ['$scope'];

angular
  .module('metabuyer')
  .controller('PRPOSettingsCtrl', PRPOSettingsCtrl);

'use strict';
/**
* @name rolesListingCtrl
* @desc Controller for listing the roles for given company
*/

function rolesListingCtrl($scope, dataList, $stateParams, $rootScope) {

  $rootScope.$broadcast('setCompany', $stateParams.code);

  $scope.dataList = dataList;

  $scope.showColumn = showColumn;

  $scope.columns = [
    {id: 'name', label: 'Role Name', unsortable: true, unsearchable: true},
    {id: 'type', label: 'Role Type', unsortable: true, unsearchable: true},
    {id: 'descr', label: 'Role Description', unsortable: true, unsearchable: true},
    {id: 'creator.display_name', label: 'Created By', unsortable: true, unsearchable: true},
    {id: 'created_at', label: 'Created At', unsortable: true, unsearchable: true},
    {id: 'updater.display_name', label: 'Updated By', unsortable: true, unsearchable: true},
    {id: 'updated_at', label: 'Updated At', unsortable: true, unsearchable: true}
  ];
  $scope.storageKey = 'roles-listing-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

}

rolesListingCtrl.$inject = ['$scope', 'dataList', '$stateParams', '$rootScope'];

angular
  .module('metabuyer')
  .controller('rolesListingCtrl', rolesListingCtrl);

'use strict';
/**
 * @name permissionsPanelCtrl
 * @desc Controller for Permissions Modal to select the domain as well as the operation of a certain permission
 */
function permissionsPanelCtrl($scope, permission, $uibModalInstance, permissionsClassList, availableConditions) {
  $scope.permission = permission;
  $scope.permissionsList = permissionsClassList.data;
  $scope.initialize = initialize;
  $scope.domain = availableConditions;
  for (var index in $scope.permissionsList) {
    $scope.permissionsList[index].domain = $scope.domain[0];
  }
  /**
   * fill the checkpoints if its already selected for Each operation
   */
  function initialize() {
    /**
     * coping over the managed conditions
     */
    if(!$scope.managedRole.permissionsConditions) {
      $scope.managedRole.permissionsConditions = [];
      for (var i in $scope.managedRole.permissions_conditions) {
        if (typeof $scope.managedRole.permissions_conditions[i] === 'object') {
          $scope.managedRole.permissionsConditions.push($scope.managedRole.permissions_conditions[i]);
        }
      }
      //FIXME: this is to remove all the object and reformat it, as the backend returns an irregular object (Ahmed Saleh, 20/2/2016)
      $scope.managedRole.permissions_conditions = $scope.managedRole.permissionsConditions;
    }
    /**
     * coping over the managed permission list for Update them later
     */
    if(!$scope.managedRole.permissions) {
      $scope.managedRole.permissions = [];
      for (var i in $scope.managedRole.permissions_list) {
        $scope.managedRole.permissions.push($scope.managedRole.permissions_list[i]._id);
      }
    }
    if ($scope.managedRole.permissionsConditions.length > 0) {
      for (index in $scope.managedRole.permissionsConditions) {
        /**
         * assigning the True and False value to assign the checkboxes
         */
        for (var i in $scope.permissionsList) {
          if (Object.keys($scope.managedRole.permissionsConditions[index])[0] === $scope.permissionsList[i]._id) {
            $scope.permissionsList[i].checked = true;
            /**
             * assigning the selected domain
             */
            for (var key in $scope.managedRole.permissionsConditions[index]) {
              for (var v in $scope.domain) {
                if ($scope.managedRole.permissionsConditions[index][key] === $scope.domain[v].value) {
                  $scope.permissionsList[i].domain = $scope.domain[v];
                }
              }
            }
          }
        }
      }
    }

  }

  $scope.saveSelection = function () {
    /**
     * matching the permissions so the ID of the permission is added to the new Role
     * the id will be added then the array
     */
    var tempCondition = {};
    var tempId = {};
    if (!$scope.managedRole.permissions) {
      $scope.managedRole.permissions = [];
    }
    if (!$scope.managedRole.permissionsConditions) {
      $scope.managedRole.permissionsConditions = [];
    }
    for (var index in $scope.permissionsList) {
      /**
       * if its checked it will be added
       */
      if (!!$scope.permissionsList[index].checked) {
        tempCondition = {};
        tempId = {};
        $scope.managedRole.permissions.push($scope.permissionsList[index]._id);
        tempId = $scope.permissionsList[index]._id;
        tempCondition[tempId] = $scope.permissionsList[index].domain.value;
        $scope.managedRole.permissionsConditions.push(tempCondition);
      }
      else {
        /**
         * if its Not checked, a validation is run in case if it was removed
         */
        var temp = $scope.managedRole.permissions.indexOf($scope.permissionsList[index]._id);
        if (temp > -1) {
          $scope.managedRole.permissions.splice(temp, 1);
        }

        for (var i in  $scope.managedRole.permissionsConditions) {
          if (Object.keys($scope.managedRole.permissionsConditions[i]).toString() === $scope.permissionsList[index]._id.toString()) {
            $scope.managedRole.permissionsConditions.splice(i, 1);
          }
        }

        for (var i in  $scope.managedRole.permissions_conditions) {
            if (Object.keys($scope.managedRole.permissions_conditions[i]).toString() === $scope.permissionsList[index]._id.toString()) {
              $scope.managedRole.permissions_conditions.splice(i, 1);
            }
        }

      }
    }
    $uibModalInstance.close();
  };

  $scope.close = function () {
    $uibModalInstance.close();
  };
  initialize();

}
permissionsPanelCtrl.$inject = ['$scope', 'permission', '$uibModalInstance', 'permissionsClassList', 'availableConditions'];

angular
  .module('metabuyer')
  .controller('permissionsPanelCtrl', permissionsPanelCtrl);

'use strict';

/**
 * @name securityManageCtrl
 * @desc Controller for security for Viewing and Adding Roles
 */
function securityManageCtrl($scope, managedRole, permissionsList, rolesList , globalFunc, classes,
                            $state, toastr, $stateParams, $rootScope) {

  $scope.back = back;
  $scope.submitRole = submitRole;
  $scope.enableEditing = enableEditing;
  $scope.disableEditing = disableEditing;
  $scope.editCheck = editCheck;
  $scope.editDropDown = editDropDown;
  $scope.cancelEditing = cancelEditing;
  $scope.back = back;
  $scope.deleteRole = deleteRole;

  $scope.managedRole = managedRole.data;
  $scope.classPermissionsList = classes;
  $scope.backUpManagedRole = angular.copy(managedRole.data);
  $scope.managedRole.permissionsConditions = reformatPermissionsConditions($scope.managedRole.permissions_conditions);
  $scope.managedRole.permissions = reformatPermissions($scope.managedRole.permissions_list);
  $scope.rolePreview = formatRole($scope.managedRole);

  $scope.historyDependencies = {
    embeddedParams: {
      'object[0][object_id]': $stateParams.id,
      'object[0][object_type]': 'Metabuyer\\Models\\Role',
      offset: 10,
      order_by: '-created_at' // Created at, descending
    }
  };

  function generateTenantSuperAdminPermissionsList(){

    /**
     * Variables for looping index
     */
    var classPermissionIndex;
    var classValueIndex;
    var classDropdownIndex;

    for (classPermissionIndex in $scope.classPermissionsList) {
      for (classValueIndex in $scope.classPermissionsList[classPermissionIndex].val) {
        if ($scope.classPermissionsList[classPermissionIndex].val[classValueIndex].subjectAction !== 'Approve') {
          if ($scope.classPermissionsList[classPermissionIndex].dropdown.length > 1) {
            for (classDropdownIndex in $scope.classPermissionsList[classPermissionIndex].dropdown) {
              if ($scope.classPermissionsList[classPermissionIndex].dropdown[classDropdownIndex].name === 'Company') {
                $scope.classPermissionsList[classPermissionIndex].val[classValueIndex].domain = $scope.classPermissionsList[classPermissionIndex].dropdown[classDropdownIndex];
              }
            }
          } else {
            $scope.classPermissionsList[classPermissionIndex].val[classValueIndex].checked = true;
          }
        }
      }
    }
  }

  /**
   * apply the checks and conditions on the permissions list for previewing and editing
   * @param role
   */
  function applyRoleOnPermissionsList(role) {
    refreshPermissionsList();
    for (var i in $scope.classPermissionsList) {
      for (var j in role) {
        if (!!role[j].className) {
          if ($scope.classPermissionsList[i].className.toLowerCase() === globalFunc.translateSecurityClasses(role[j].className).toLowerCase()) {
            for (var k in $scope.classPermissionsList[i].val) {
              for (var z in role[j].actions) {
                if (!!role[j].actions[z].permissions) {
                  if ($scope.classPermissionsList[i].val[k]._id === role[j].actions[z].permissions._id) {
                    if ($scope.classPermissionsList[i].dropdown.length > 1) {
                      for (var y in $scope.classPermissionsList[i].dropdown) {
                        if ($scope.classPermissionsList[i].dropdown[y].name === role[j].actions[z].domain) {
                          $scope.classPermissionsList[i].val[k].domain = $scope.classPermissionsList[i].dropdown[y];
                        }
                      }
                    } else {
                      $scope.classPermissionsList[i].val[k].checked = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * format the role to an object that can be displayed in the html view
   * @param role
   * @returns {Array}
   */
  function formatRole(role){
    var formattedRole = [];
    var temp = {};
    var tempDomain = {};
    var flag = false;
    for(var i in role.permissions_list) {
      temp = {};
      flag = false;
      tempDomain = findDomain(role.permissions_conditions, role.permissions_list[i]._id);
      temp.permissions = angular.copy(role.permissions_list[i]);
      temp.domain = angular.copy(tempDomain);
      temp.actionType = temp.permissions.subjectAction;
      temp.className = angular.copy(findClassName(role.permissions_list[i].subjectClass));

      for (var j in formattedRole) {
        if (formattedRole[j].className === temp.className) {
          flag = true;
          if (!formattedRole[j].actions) {
            formattedRole[j].actions = [];
          }
          formattedRole[j].actions.push(temp);
          break;
        }
      }
      if (!flag) {
        var tempClass = {
          className: temp.className,
          actions: [temp]
        };
        formattedRole.push(tempClass)
      }
    }
    return formattedRole;
  }

  function reformatConditionsToSubmit(conditions){
    var tempConditions = {};
    _.forEach(conditions, function(condition){
      var objKey = Object.keys(condition);
      objKey = objKey[0];
      tempConditions[objKey] = condition[objKey].value;
    });

    return tempConditions;
  }

  function submitRole(message, id) {
    if (validate(message)) {

      var reformatPermissionsConditions = reformatConditionsToSubmit($scope.managedRole.permissionsConditions);

        rolesList.put(
          {
            id: $scope.managedRole._id
          },
          {
            name: $scope.managedRole.name,
            descr: $scope.managedRole.descr,
            permissions_list: $scope.managedRole.permissions,
            permissions_conditions: reformatPermissionsConditions,
            company_code: $scope.activeCompany.code,
            type: 1
          },
          function (resource) {
            /**
             * update the role that was just updated in the List
             */
            toastr.success('The role has been '+ message);
            $scope.backUpManagedRole = angular.copy($scope.managedRole);
            disableEditing();
          },
          function (error) {
            //TODO: use the error function (Ahmed Saleh, 18/2/2016)
            toastr.error('Failed to update the Role');
          }
        )
    }
  }

  function deleteRole() {
    rolesList.delete({
      id: $scope.managedRole._id
    }, function (success) {
      toastr.success('Role has been deleted successfully');
      disableEditing();
      $state.go('main.user.security.rolesListing', {code: $scope.activeCompany.code})
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    });
  }

  function enableEditing(){
    $scope.editMode = true;
  }

  function cancelEditing(){
    $state.reload();
  }

  function disableEditing(){
    $scope.editMode = false;
  }

  /**
   * clear the selection for any Role
   */
  function refreshPermissionsList() {
    for (var i in $scope.classPermissionsList) {
      for (var k in $scope.classPermissionsList[i].val) {
        $scope.classPermissionsList[i].val[k].checked = null;
        /**
         * fix to auto fill the not Allowed dropdown
         */
        $scope.classPermissionsList[i].val[k].domain = {
          name: 'not allowed',
          value: 'null'
        };
      }
    }
  }

  /**
   * Store the Role to be Edited
   * as well as preview
   */
  function roleSelected(role) {
    $state.go('main.user.security.edit', {'id': role._id});
  }

  /**
   * get the class name of a permission
   * @param words
   * @returns {*}
   */
  function findClassName(words) {
    var n = words.split("\\");
    return n[n.length - 1];

  }



  /**
   * get and clean up the domain of each permission
   * @param conditions
   * @param id
   * @returns {*}
   */
  function findDomain(conditions, id) {
    var temp = null;
    id = String(id);
    if (!!conditions[id]) {
      if(conditions[id] === '(@__OWN__)'){
        temp = 'Self';
      }else if (conditions[id].indexOf('@__COMPANY_') > -1){
        temp = 'Company';
      }else if (conditions[id].indexOf('@__COST_CENTER__') > -1){
        temp = 'Cost Center';
      }else if(conditions[id].indexOf('1==1') > -1){
        temp = 'Company';
      }
      return temp;
    }
    return temp;
  }

  function searchRoleNameDuplication(roleName, id){
    for(var i in $scope.roles){
      if($scope.roles[i].name.toLowerCase() === roleName.toLowerCase()){
        if($scope.roles[i]._id !== id) {
          if (!!$scope.roles[i].company_code) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * validate the selection
   */
  //TODO: check if the name is not spaces (Ahmed Saleh)
  function validate(message) {
    if (!$scope.activeCompany || !$scope.activeCompany.code) {
      toastr.error('Please select a company for this role');
      return false;
    }
    if (!$scope.managedRole.name) {
      toastr.error('Please enter a name for this role');
      return false;
    }
    if (!$scope.managedRole.descr) {
      toastr.error('Please enter a description for this role');
      return false;
    }
    if(message !== 'updated') {
      if (searchRoleNameDuplication($scope.managedRole.name, $scope.managedRole._id)) {
        toastr.error('Please enter another name for this role, this Role name is already taken');
        return false;
      }
    }
    /**
     * if Role is edited, just check against if all permissions selection were removed
     */
    if (message === 'updated') {
      if ((!$scope.managedRole.permissions_list || $scope.managedRole.permissions_list.length < 1) && (!$scope.managedRole.permissions || $scope.managedRole.permissions.length < 1)) {
        toastr.error('Please assign at least 1 permission');
        return false;
      }
    }
    /**
     * if Role is new, just check if there were permissions selected
     */
    else {
      if (!$scope.managedRole.permissions || $scope.managedRole.permissions.length < 1) {
        toastr.error('Please assign at least 1 permission');
        return false;
      }
    }
    return true;
  }

  function back(){
    window.history.back();
  }

  function formatThePermissions() {
    /**
     * this to reformat the permissions so they can be used
     * this function might not be needed later on if the return from the backend is in a usable format
     */
    $scope.permissionsList = [];
    var temp = permissionsList.data;
    for (var i = 0; i < temp.length; i++) {
      var temp2 = temp[i].name.slice(0, 1);
      var temp3 = temp[i].name.slice(2);
      var temp4 = {
        _id: temp[i]._id,
        operation: temp2,
        name: temp3
      };
      $scope.permissionsList.push(temp4);
    }
  }

  /**
   * cleaning the messy object and make it an array, so that permissions conditions can be appended/removed
   * @returns {Array}
   */

  function reformatPermissionsConditions(conditions){
    var tempArray = [];
    _.forEach(conditions, function(condition, key){
      if(!!condition){
        var tempCondition = {};
        if((condition.indexOf('@__OWN') > -1) ||
          (condition.indexOf('@__COMPANY') > -1) ||
          (condition.indexOf('@__COST_CENTER__') > -1))
        {
          if (condition.indexOf('@__OWN') > -1) {
            tempCondition[key] = {
              name: "Self",
              value: condition
            };
          } else if (condition.indexOf('@__COST_CENTER__') > -1) {
            tempCondition[key] = {
              name: "Cost Center",
              value: condition
            };
          } else {
            tempCondition[key] = {
              name: "Company",
              value: condition
            };
          }
        }else{
          tempCondition[key] = {
            name: "Self",
            value: condition
          };
        }
        tempArray.push(tempCondition);
      }
    });

    return tempArray;
  }

  /**
   * cleaning the messy object and make it an array, so that permissions can be appended/removed
   * @returns {Array}
   */
  function reformatPermissions(permissions){
    var tempArray = [];
    for(var i in permissions){
      if(typeof permissions[i] === 'object'){
        tempArray.push(permissions[i]._id);
      }
    }
    return tempArray;
  }

  /**
   * cleaning the permissions array
   * @param id
   */
  function removePermissionFromPermissionsList(id){
    for (var i in $scope.managedRole.permissions) {
      if($scope.managedRole.permissions[i] === id){
        $scope.managedRole.permissions.splice(i,1);
      }
    }
  }

  /**
   * cleaning the permissions conditions array
   * @param id
   */
  function removePermissionConditionFromPermissionsConditions(id){
    for (var i in $scope.managedRole.permissionsConditions) {
      if(Object.keys($scope.managedRole.permissionsConditions[i])[0] === id){
        $scope.managedRole.permissionsConditions.splice(i,1);
      }
    }
  }

  /**
   * add/remove a permission with the check boxes
   * @param perm
   */
  function editCheck(perm) {
    if (perm.checked === true) {
      removePermissionFromPermissionsList(perm._id);
      removePermissionConditionFromPermissionsConditions(perm._id);
      $scope.managedRole.permissions.push(perm._id);
      var tempCondition = {};
      tempCondition[perm._id] = {
        name: 'Self',
        value: '(1==1)'
      };
      $scope.managedRole.permissionsConditions.push(tempCondition);
    }else{
      removePermissionFromPermissionsList(perm._id);
      removePermissionConditionFromPermissionsConditions(perm._id);
    }
  }

  /**
   * add/remove a permission with the dropdown
   * @param perm
   */
  function editDropDown(perm){
    if(!!perm.domain){
      if(perm.domain.value === null){
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
      }else if(perm.domain.value === '(@__OWN__)'){
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
        $scope.managedRole.permissions.push(perm._id);

        var tempCondition = {};
        tempCondition[perm._id] = perm.domain;
        $scope.managedRole.permissionsConditions.push(tempCondition);
      }else{
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
        $scope.managedRole.permissions.push(perm._id);

        var tempCondition = {};
        tempCondition[perm._id] = perm.domain;
        $scope.managedRole.permissionsConditions.push(tempCondition);
      }
    }
  }

  function initialize(){
    if(!$scope.managedRole.permissionsConditions){
      $scope.managedRole.permissionsConditions = [];
    }
    if(!$scope.managedRole.permissions){
      $scope.managedRole.permissions = [];
    }
    $scope.userPerms = [];
    $scope.adminPerms = [];

    for(var i in $scope.rolePreview){
      if($scope.rolePreview[i].className === 'PR'){
        $scope.group = 'user';
        $scope.userPerms.push($scope.rolePreview[i]);
      }
      else if($scope.rolePreview[i].className === 'PO'){
        $scope.group = 'user';
        $scope.userPerms.push($scope.rolePreview[i]);
      }
      else{
        $scope.group = 'admin';
        $scope.adminPerms.push($scope.rolePreview[i]);
      }
    }

    $scope.rolePreview.title = $scope.managedRole.name;

    /**
     * If managed role is tenant super admin, generate the preview via hardcoding,
     * else for other roles, generate the preview based on permissions_list and permissions_condition
     */
    if(!!$scope.managedRole && !!$scope.managedRole.name && $scope.managedRole.name === 'TENANT_SUPER_ADMIN') {
      generateTenantSuperAdminPermissionsList();
    }
    else{
      applyRoleOnPermissionsList($scope.rolePreview);
    }

    formatThePermissions();
    $rootScope.$broadcast('setCompany', $stateParams.code);
  }

  initialize();
}

securityManageCtrl.$inject = [
  '$scope', 'managedRole', 'permissionsList', 'rolesList', 'globalFunc', 'classes',
  '$state', 'toastr', '$stateParams', '$rootScope'
];

angular
  .module('metabuyer')
  .controller('securityManageCtrl', securityManageCtrl);

'use strict';
/**
 * @name addRolesCtrl
 * @desc Controller for adding a new role
 */

function addRolesCtrl($stateParams, $rootScope) {

  $rootScope.$broadcast('setCompany', $stateParams.code);

}

addRolesCtrl.$inject = ['$stateParams', '$rootScope'];

angular
  .module('metabuyer')
  .controller('addRolesCtrl', addRolesCtrl);

'use strict';
/**
 * @name reportsLogCtrl
 * @desc Controller for Logs of report
 */

function reportsLogCtrl (
  $scope, logList, $filter, reports, $stateParams,downloadReport,pathConstants, toastr, $window, HighlightId,
  globalFunc, reportTypes
) {
  $scope.logs = logList.data;
  $scope.meta = logList.meta;
  $scope.reportService = reports;
  $scope.changeStringCase = changeStringCase;
  $scope.logDetail = logDetail;
  $scope.getReport = getReport;
  $scope.getStatusName = getStatusName;
  $scope.getReportType = getReportType;
  $scope.status = $stateParams.status;

  /**
   * To change the Case of the status and remove the underscore
   * @param string
   * @returns {*}
   */
  function changeStringCase(string){
    var newString = string.replace('_', ' ');
    newString = $filter('titleCase')(newString);
    return newString;
  }

  $scope.showColumn = showColumn;

  $scope.columns = [
    {id: 'requestor_user.display_name', label: 'Requestor', unsortable: true},
    {id: 'date', label: 'Date Generated'},
    {id: 'done_at', label: 'Done At'},
    {id: 'type', label: 'Report Type'},
    {id: 'status', label: 'Status', unsortable: true}
  ];

  $scope.storageKey = 'reports-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * returns the name of the status
   * @param code
   * @returns {*}
     */
  function getStatusName(code) {

    /**
     PENDING = 0
     IN_PROGRESS = 1
     DONE = 2
     FAILED = 3
     CANCELLED = 4
     */
    if (code === 0) {
      return 'Pending'
    }
    if (code === 1) {
      return 'In Progress'
    }
    if (code === 2) {
      return 'Done'
    }
    if (code === 3) {
      return 'Failed'
    }
    if (code === 4) {
      return 'Cancelled'
    }
  }

  /**
   * returns the name of the report type
   * @param reportType int
   * @returns {*}
   */
  function getReportType(reportType) {
    var reportTypeString = globalFunc.findInArray(reportTypes.getReportTypes(), 'code', reportType);
    if (!reportTypeString)
      reportTypeString.descr = 'Report';
    return reportTypeString.descr;
  }

  function logDetail(log){
    if(!!log.status && log.status === 2) {
      reports.get({
          id: log._id
        },
        function (success) {
          if(!!success.content && !!success.content.data && success.content.data.hash){
            getReport(success.content.data.hash);
          }
        },
        function (error) {
          toastr.error('Failed to generate report');
        })
    }
  }

  function getReport(hash) {

    var newUrl = $filter('format')(pathConstants.apiUrls.reports.download, {
      id: hash
    });
    window.open(newUrl, '_self');

  }

  function initialize() {
    if(!!$scope.$parent)
      $scope.$parent.activatedTab = $scope.$parent.tabData[0];
    else
      $scope.activatedTab = $scope.tabData[0];

    //highlight row
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      //scroll the window to top
      $window.scroll(0, 0);
      //clear current id
      HighlightId.setId(null);
    }

  }
    initialize();
}

reportsLogCtrl.$inject = [
  '$scope', 'logList','$filter', 'reports', '$stateParams','downloadReport','pathConstants','toastr', '$window',
  'HighlightId', 'globalFunc', 'reportTypes'
];

angular
  .module('metabuyer')
  .controller('reportsLogCtrl', reportsLogCtrl);

'use strict';

/**
 * @name reportsGenerationCtrl
 * @desc Controller for Reports generation
 */

function reportsGenerationCtrl ($scope, reports, toastr, businessList, singleBU, $timeout, $filter, profile, globalFunc,
  checkReportStatus, $interval, pathConstants, reportTypes, $state, searchModule, suppliersActiveList, UserPermissions) {

  //region Variable and scope declaration
  var usersCompaniesCode = [],
      usersCompanies = profile.companies,
      usersPerms = profile.view_perms,
      usersBUCode = [];
  var allBUs = {
      descr: 'All Available Business Units',
      _id: 'all'
  };
  $scope.reports = {};
  $scope.business = businessList;
  // Used for sorting business units when displaying them in a list
  $scope.businessId = {};
  $scope.selectedCompanies = [];
  $scope.selectedCostCenters = [];
  $scope.selectedSuppliers = [];
  $scope.selectedBudgetType = {};
  $scope.selectedBudgetType.list = null;
  $scope.costCenterList = [];
  $scope.companyList = [];
  $scope.company_ids = [];
  $scope.companyCodes = [];
  $scope.supplierCodes = [];
  $scope.date_type = [
    {id: 'receivedDate', name: 'Received'},
    {id: 'GRNDate', name: 'GRN'}
  ];
  $scope.spend_date_type = [
    {id: 'PODate', name: 'PO Date'},
    {id: 'PRDate', name: 'PR Date'}
  ];
  $scope.budgetType = [
    {id: 'master', descr: 'Master'},
    {id: 'assignment', descr: 'Assignment'},
    {id: 'itemBreakdown', descr: 'Item Breakdown'}
  ];

  $scope.getCompanies = getCompanies;
  $scope.generateReports = generateReports;
  $scope.hasSupplierTagPermission = hasSupplierTagPermission;
  $scope.generateOptionsBasedOnReportType = generateOptionsBasedOnReportType;
  $scope.onSelectBusinessUnit = onSelectBusinessUnit;
  $scope.openDatepicker = openDatepicker;
  $scope.onSelectDateType = onSelectDateType;
  $scope.sortedBusiness = sortedBusiness;
  $scope.getSelectedCompanies = getSelectedCompanies;
  $scope.onSelectedCompanyChanges = onSelectedCompanyChanges;
  $scope.onSelectSingle = onSelectSingle;
  $scope.onSelectAll = onSelectAll;
  $scope.onSelectNone = onSelectNone;

  $scope.reportTypes = reportTypes.getReportTypes();

  $scope.datepickerOpened = {
    startDate: false,
    endDate: false
  };

  //endregion

  // Return string of selected company
  function getSelectedCompanies(array, key) {
    return globalFunc.createStringBasedOnObjectKeyInArray(array, key);
  }

  // Function for sorting BU on list
  function sortedBusiness (business) {
    if (business.descr === 'All Available Business Units') {
      return -1;
    }
    return business.descr;
  }

  //region On select functions

  // Set selection based on field type
  function onSelectSingle(fieldType, selection) {
    switch (fieldType) {
      case 'company':
        $scope.selectedCompanies = selection;
        break;
      case 'costCenter':
        $scope.selectedCostCenters = selection;
        break;
      case 'supplier':
        $scope.selectedSuppliers = selection;
        break;
    }
  }

  // Set selection to all based on field type
  function onSelectAll(fieldType, selectionList) {
    switch (fieldType) {
      case 'company':
        $scope.selectedCompanies = selectionList;
        break;
      case 'costCenter':
        $scope.selectedCostCenters = selectionList;
        break;
      case 'supplier':
        $scope.selectedSuppliers = selectionList;
        break;
    }
  }

  // Set selection to none based on field type
  function onSelectNone(fieldType) {
    switch (fieldType) {
      case 'company':
        $scope.selectedCompanies = [];
        break;
      case 'costCenter':
        $scope.selectedCostCenters = [];
        break;
      case 'supplier':
        $scope.selectedSuppliers = [];
        break;
    }
  }

  function generateOptionsBasedOnReportType (reportType) {
    $scope.selectedCompanies = [];
    $scope.selectedSuppliers = [];
    switch (reportType.code) {
      case 'SPEND':
        $scope.buSelect = true;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = true;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = true;
        $scope.companyListSelect = false;
        break;
      case 'RECEIVING':
        $scope.buSelect = true;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = true;
        $scope.dateSelect = true;
        $scope.companyListSelect = false;
        break;
      case 'REQUISITION_COUNTER':
        $scope.buSelect = false;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = false;
        $scope.companyListSelect = false;
        break;
      case 'REQUISITION':
        $scope.buSelect = true;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = true;
        $scope.companyListSelect = false;
        break;
      case 'SUPPLIER_TAGGING':
        $scope.buSelect = true;
        $scope.supplierSelect = true;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = false;
        $scope.companyListSelect = false;
        getSuppliers();
        break;
      case 'BUDGET':
        $scope.buSelect = true;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = true;
        $scope.companyListSelect = true;
        break;
      default :
        $scope.buSelect = false;
        $scope.supplierSelect = false;
        $scope.spendReportBasedOn = false;
        $scope.dateTypeSelect = false;
        $scope.dateSelect = false;
        $scope.companyListSelect = false;
        break;
    }
  }

  function onSelectBusinessUnit (businessUnit) {
    $scope.selectedCompanies = [];
    $scope.businessUnitSelected = true;
    $scope.inputId = businessUnit._id;

    getCompanies($scope.inputId);
  }

  function onSelectDateType (type) {
    $scope.input_date_type = type;
  }
  //endregion

  function openDatepicker($event, which) {
    if($scope.datepickerOpened[which]){
      $event.preventDefault();
      $event.stopPropagation();
    }
    else{
      $timeout(function(){
        $scope.datepickerOpened[which] = true;
      })
    }

    if (!!$scope.endDate && !!$scope.endDate.date) {
      $scope.startDateOptions = {
        formatYear: 'yy',
        maxDate: $scope.endDate.date
      };
    }

    if (!!$scope.startingDate && !!$scope.startingDate.date) {
      $scope.endDateOptions = {
        formatYear: 'yy',
        minDate: $scope.startingDate.date
      };
    }

    if (!!$scope.reports.type && !!$scope.reports.type.code && $scope.reports.type.code !== 'BUDGET') {
      $scope.startDateOptions.maxDate = new Date();
      $scope.endDateOptions.maxDate = new Date();
    }
  }

  //region Functions for generating array for payload
  function extractCompanyId (){
    $scope.company_ids = [];
    _.forEach($scope.selectedCompanies, function(company){
      if (!!company && !!company._id)
        $scope.company_ids.push(company._id);
    });
  }

  function extractCompanyCode (){
    $scope.companyCodes = [];
    _.forEach($scope.selectedCompanies, function(company){
      if (!!company && !!company.code)
        $scope.companyCodes.push(company.code);
    });
  }

  function extractSupplierCode (){
    $scope.supplierCodes = [];
    _.forEach($scope.selectedSuppliers, function(supplier){
      if (!!supplier && !!supplier.mb_supplier_code)
        $scope.supplierCodes.push(supplier.mb_supplier_code);
    });
  }

  /**
   * Extract cost center code
   */
  function extractCostCenterCode() {
    $scope.costCenterCodes = [];
    _.forEach($scope.selectedCostCenters, function (costCenter) {
      if (!!costCenter && !!costCenter.code)
        $scope.costCenterCodes.push(costCenter.code);
    });
  }
  //endregion

  //region Functions for getting companies and supplier listing
  function getCompanies(businessUnit){
    var param = {};
    var resource;
    if (businessUnit === 'all') {
      resource = searchModule;
      param.offset = 0;
      param.module = 'companies';
      param.order = 1;
      param.order_by = 'descr';
    } else {
      resource = singleBU;
      param.id = businessUnit;
    }

    resource.get(param,
      function (success) {
        if (!!success.content.data.companies) {
          $scope.companyList = success.content.data.companies;
        } else {
          $scope.companyList = success.content.data;
        }

        if (!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN') && checkForGlobalReportRole() === false) {
          $scope.companyList = filterUsersData($scope.companyList, 'code', usersCompaniesCode, true);
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function getSuppliers () {
    if (!!JSON.parse(window.localStorage.getItem('activeSuppliersForTagging'))){
      $scope.suppliersList = (JSON.parse(window.localStorage.getItem('activeSuppliersForTagging')));
    }
    else {
      suppliersActiveList.get(
        {},
        function(resource) {
          if(!!resource && !!resource.content && !!resource.content.data){
            window.localStorage.setItem('activeSuppliersForTagging', JSON.stringify(resource.content.data));
            $scope.suppliersList = resource.content.data;
          }
        },
        function(error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
  }
  //endregion

  //region Functions for checking permission and validation
  function hasSupplierTagPermission () {
    return (!!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') &&
      !!UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag'));
  }

  function checkForGlobalReportRole(){
    var role = globalFunc.findInArray(profile.roles, 'name', 'Report Manager');
    if(!role)
      return false;

    if(!!role.company_code && role.company_code.length > 0)
      return false;

    return true;
  }

  /**
   * validation for report generation form
   * @returns {boolean}
   */
  function validate(){
    extractCompanyId();
    extractCompanyCode();
    extractSupplierCode();
    extractCostCenterCode()
    if(!$scope.reports.type){
      return false;
    }

    /**
     * Only validate for spend report or receiving details report type
     */
    if ($scope.reports.type.code === 'SPEND' || $scope.reports.type.code === 'RECEIVING' ||
      $scope.reports.type.code === 'BUDGET') {
      if ($scope.company_ids.length === 0) {
        return false;
      }

      if (!$scope.startingDate || !$scope.startingDate.date || !$scope.endDate || !$scope.endDate.date) {
        return false;
      }

      if ($scope.startingDate > $scope.endDate) {
        toastr.error('Ending date must be older than starting date');
        return false;
      }
      if (($scope.reports.type.code === 'SPEND' || $scope.reports.type.code === 'RECEIVING') &&
          (!$scope.input_date_type || !$scope.input_date_type.id)) {
        return false;
      }
    }
    if (($scope.reports.type.code === 'REQUISITION' || $scope.reports.type.code === 'BUDGET') &&
      (!$scope.company_ids || $scope.company_ids.length === 0)) {
      return false;
    }
    if ($scope.reports.type.code === 'SUPPLIER_TAGGING') {
      if ($scope.company_ids.length === 0 && $scope.selectedSuppliers.length === 0) {
        return false;
      }
      else if ($scope.company_ids.length === 0 && $scope.selectedSuppliers.length > 0) {
        return true;
      }
      else if ($scope.company_ids.length > 0 && $scope.selectedSuppliers.length === 0) {
        return true;
      }
    }

    if ($scope.reports.type.code === 'BUDGET') {
      if (!$scope.selectedBudgetType.list || !$scope.selectedBudgetType.list.id) {
        return false;
      }
    }

    return true;
  }
  //endregion

  //region Functions for generating report and check
  function downloadReport(hash){
    var newUrl = $filter('format')(pathConstants.apiUrls.reports.download, {
      id: hash
    });
    window.open(newUrl, '_self');
  }

  /**
   * Function to check the export status with intervals
   * @param id
   */
  function checkReport(id){

    checkReportStatus.get(
      {
        id: id
      },
      function(resource){
        if(!!resource.content && !!resource.content.data &&
          !!resource.content.message && !!resource.content.data.status &&
          !!resource.content.data.hash){

          /**
           * Clearing the toastr before every call for status checking to simulate 'refreshing' the toastr
           */
          toastr.clear();

          var checkingStatus = true;

          /**
           * Status for report generation
           * 0 = PENDING
           * 1 = IN_PROGRESS
           * 2 = DONE
           * 3 = FAILED
           * 4 = CANCELLED
           */
          switch(resource.content.data.status){
            case 0:
              toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
              break;
            case 1:
              toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
              break;
            case 2:
              toastr.success(resource.content.message,
                {timeOut: 1500, extendedTimeOut: 0, onClose: downloadReport(resource.content.data.hash)});
              checkingStatus = false;
              $interval.cancel($scope.startChecking);
              break;
            case 3:
              toastr.error(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
              checkingStatus = false;
              $interval.cancel($scope.startChecking);
              break;
            case 4:
              toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
              checkingStatus = false;
              $interval.cancel($scope.startChecking);
              break;
          }
          $scope.checkingReportStatus = checkingStatus;
        }
      },
      function(error){
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  /**
   * Report Generation
   */
  function generateReports(startDate, endDate){
     $scope.checkingReportStatus = true;
     startDate = globalFunc.convertDateToTimestamp(startDate);
     endDate = globalFunc.convertDateToTimestamp(endDate);

    if(!validate()){
      toastr.error('Please fill all fields before proceeding');
      $scope.checkingReportStatus = false;
    }
    else {
      var inputDateType = '';
      if ($scope.reports.type.code === 'RECEIVING' || $scope.reports.type.code === 'SPEND') {
        inputDateType = $scope.input_date_type.id;
      }

      var submitData = {
        reportType: $scope.reports.type.code,
        dateFrom: startDate,
        dateTo: endDate,
        companyCodes: $scope.companyCodes,
        supplierCodes: $scope.supplierCodes,
        companyIDs: $scope.company_ids,
        costCenterCodes: !!$scope.costCenterCodes ? $scope.costCenterCodes : [],
        budgetType: !!$scope.selectedBudgetType.list && !!$scope.selectedBudgetType.list.id ?
          $scope.selectedBudgetType.list.id : null,
        dateType: inputDateType
      };

      reports.post({},
        submitData,
        function(resource) {
          toastr.info('Report is being generated. The download will start automatically', {timeOut: 0, extendedTimeOut: 0});
          $scope.startChecking = $interval(function () {
            checkReport(resource.content.data[0]);
          }, 5000);
          $scope.input_date_type = '';
          $scope.supplierSelect = '';
          $scope.selectedSuppliers = '';
          $scope.buSelect = '';
          $scope.reports.type = '';
          $scope.reports.businessId = '';
          $scope.selectedCompanies = '';
          $scope.spendReportBasedOn = false;
          $scope.dateTypeSelect = false;
          $scope.dateSelect = false;
          $scope.startingDate = {
            date: new Date()
          };
          $scope.endDate      = {
            date:  new Date()
          };
          $scope.selectedCostCenters = [];
          $scope.selectedBudgetType.list = null;
          $scope.companyList = [];
        },
        function(error) {
          $scope.checkingReportStatus = false;
          globalFunc.objectErrorMessage(error);
        }
      )
    }
  }
  //endregion

  //region Functions for filtering data
  /**
   * filter data based on the params
   * @param array
   * @param filteredKey
   * @param filterData
   * @param reject
   * true or false to reject data
   * @returns {*}
   */
  function filterUsersData(array, filteredKey, filterData, reject) {
    if (filterData.length === 0) return array;

    return _.reject(array, function(val){
      if (!!reject)
        return filterData.indexOf(val[filteredKey]) === -1;
      else
        return filterData.indexOf(val[filteredKey]) > -1;
    });
  }

  function dataFilter() {
    if(!!usersPerms) {
      // check the permissions for reportLog
      if (!!usersPerms.ReportLog && usersPerms.ReportLog.hasOwnProperty('C')) {
        // get the report permission to companies
        usersCompaniesCode = usersPerms.ReportLog.C;

        // get the BUs data belongs to user
        // based on the user permissions
        if (usersCompaniesCode.length > 0) {
          usersBUCode = filterUsersData(usersCompanies, 'code', usersCompaniesCode, true);
          usersBUCode = globalFunc.arrayOfObjectToString(usersBUCode, 'bu_code');
        }
      }
    }
  }
  //endregion

  /**
   * Get cost center list when any selected company changes
   */
  function onSelectedCompanyChanges() {
    $scope.costCenterList = [];

    //stop when no company is selected or is not in budget report
    if (!$scope.selectedCompanies.length || $scope.reports.type.code !== 'BUDGET') {
      return;
    }

    extractCompanyCode();

    var params = {
      module: 'cost-center',
      offset: 0,
      criteria_operator: 'or',
      order_by: 'descr',
      order: 1
    };

    _.forEach($scope.companyCodes, function (companyCode, index) {
      params['criteria[company_code][' + index + ']'] = companyCode;
    });

    searchModule.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.costCenterList = resource.content.data;
          _.forEach($scope.costCenterList, function (costcenter) {
            costcenter.descr = costcenter.descr + ' [' + costcenter.company_name + ']';
          });
        }
      }
    )
  }

  function initialize(){
    $scope.$watch('selectedCompanies.length', function () {
      onSelectedCompanyChanges();
    });

    if (!!$scope.$parent)
      $scope.$parent.activatedTab = $scope.$parent.tabData[1];
    else
      $scope.activatedTab = $scope.tabData[1];

    $scope.startingDate = {
      date: new Date()
    };
    $scope.endDate      = {
      date:  new Date()
    };

    $scope.startDateOptions = {
      formatYear: 'yy',
      maxDate: new Date(),
      startingDay: 1
    };
    $scope.endDateOptions = {
      formatYear: 'yy',
      maxDate: new Date(),
      startingDay: 1
    };

    dataFilter();
    if(!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN') && checkForGlobalReportRole() === false)
      $scope.business = filterUsersData($scope.business, 'code', usersBUCode, true);

    $scope.business.unshift(allBUs);

    $scope.multiselectTranslation       = {
      selectAll       : 'Select all',
      selectNone      : 'Select none',
      reset           : 'Reset',
      search          : 'Type here to search...',
      nothingSelected : 'Select'
    };
  }

  initialize();
}

reportsGenerationCtrl.$inject = [
  '$scope', 'reports', 'toastr', 'businessList', 'singleBU', '$timeout','$filter', 'profile',
  'globalFunc', 'checkReportStatus', '$interval', 'pathConstants', 'reportTypes', '$state', 'searchModule',
  'suppliersActiveList', 'UserPermissions'
];

angular
  .module('metabuyer')
  .controller('reportsGenerationCtrl', reportsGenerationCtrl);

'use strict';
/**
 * @name requisitionsManageCtrl
 *
 * @param $scope
 * @param dataList
 * @param status
 * @param purchaseRequisitionsServices
 * @param $rootScope
 * @param globalFunc
 * @param $state
 * @param $stateParams
 * @param HighlightId
 * @param $window
 * @param $filter
 * @param toastr
 * @param prFunction
 */
function requisitionsManageCtrl(
  $scope, dataList, status, purchaseRequisitionsServices, $rootScope, globalFunc, $state, $stateParams, HighlightId,
  $window, $filter, toastr, prFunction, Approvals, $q
) {

  /**
   * return true if show details is clicked
   * @param id
   * @returns boolean
   */
  function showDetails(id) {
    return (id === $scope.selectedDetail) ? true : false;
  }

  /**
   * set value of selectedDetail
   * @param id
   * @param option (set to show/hide details)
   */
  function setShowDetailsId(id, option) {
    if (option === 'show') {
      _.forEach($scope.dataList, function (item) {
        if (item['_id'] === id) {
          $scope.PR = item;
        }
      });
      $scope.selectedDetail = id;
      setPRItem();
      loadApprovalFlow();
      checkIfPRIsEditable();
    }
    if (option === 'hide')
      $scope.selectedDetail = null;
  }

  /**
   * function returns checker for the states to hide or show the PR details
   * @returns {*|boolean}
   */
  function isShoppingMode() {
    $scope.PR = prFunction.getPRData();
    return $state.includes('main.user.purchaseRequisitions.details.catalog');
  }

  function getEditingPRState() {
    return prFunction.getEditingState();
  }

  /**
   * this function will check the state of the PR
   * as well as the Type of the logged in user
   */
  function checkIfPRIsEditable() {
    prFunction.setEditableState(($scope.PR.status === 'draft') ? 'editable' : 'notEditable');
    if ($rootScope.currentUser._id !== $scope.PR.creator._id)
      prFunction.setEditableState('notEditable');
  }

  function loadApprovalFlow() {
    if ($scope.PR.status !== 'draft') {
      Approvals.get({
        id: $scope.PR.approval_id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          prFunction.setApprovalFlow(resource.content.data);
        }
      });
    }
  }

  function setPRItem() {
    var deferred = $q.defer();
    purchaseRequisitionsServices.getSinglePR(
      {
        id: $scope.PR._id
      }, function (resource) {
        if (!!resource.content) {
          deferred.resolve(resource.content);
          prFunction.initializePRData(resource.content.data);
        } else {
          deferred.resolve([]);
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }


  function showColumn(id) {
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if (!!$scope.columns[i].conditional) {
          if ($scope.status === $scope.columns[i].condition) {
            return $scope.columns[i].selected;
          }
          if ($scope.columns[i].condition instanceof Array) {
            for (var j in $scope.columns[i].condition) {
              if ($scope.status === $scope.columns[i].condition[j]) {
                return $scope.columns[i].selected;
              }
            }
          }
        } else {
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * function to navigate between the sub tabs
   * @param tab
   */
  function tabSelection(tab) {
    switch (tab) {
      case 'all': {
        $scope.selectedListTab = tab;
        $state.go('main.user.purchaseRequisitions.manage', {
          status: $scope.status,
          tab: tab,
          extraFilterKey: null,
          extraFilterValue: null,
          cursor: null
        });
        break;
      }
      case 'yours': {
        $scope.selectedListTab = tab;
        $state.go('main.user.purchaseRequisitions.manage', {
          status: $scope.status,
          tab: tab,
          extraFilterKey: 'criteria[creator|_id][][]',
          extraFilterValue: $rootScope.currentUser._id,
          cursor: null
        });
        break;
      }
      case 'shared': {
        $scope.selectedListTab = tab;
        $state.go('main.user.purchaseRequisitions.manage', {
          status: $scope.status,
          tab: tab,
          extraFilterKey: 'criteria[collaborators_ids][]',
          extraFilterValue: $rootScope.currentUser._id,
          cursor: null
        });
        break;
      }
      case 'waiting': {
        $scope.selectedListTab = tab;
        $state.go('main.user.purchaseRequisitions.manage', {
          status: $scope.status,
          tab: tab,
          extraFilterKey: 'criteria[waiting_on][]',
          extraFilterValue: $rootScope.currentUser._id,
          cursor: null
        });
        break
      }
    }
  }

  /**
   * return if the user is part of the waiting on, for a specific PR
   * @param requisition
   * @returns {*}
   */
  function checkWaitingOnUser(requisition) {
    if(requisition.status === 'pending')
      return globalFunc.findInArray(requisition.waiting_on, '_id', $rootScope.currentUser._id);
    else
      return false;
  }


  /**
   * returns store the selected PRs
   * @returns {Array}
   */
  function getSelectedRequisitions() {
    var selectedPRs = [];
    _.forEach($scope.dataList, function (pr) {
      if (!!pr.selected) {
        selectedPRs.push(pr);
      }
    });
    return selectedPRs;
  }

  function starringPR(pr, isStarred) {
    prFunction.requisitionStarring(pr, !isStarred).$promise
      .then(function () {
        if (isStarred)
          pr.starred_users = _.pull(pr.starred_users, $rootScope.currentUser._id);
        else {
          pr.starred_users = [];
          pr.starred_users.push($rootScope.currentUser._id);
        }
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  function deletePR(prID) {
    swal({
        title: 'Confirm delete this Draft Purchase Requisition?',
        text: 'This Draft Purchase Requisition will be deleted',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (isConfirm) {
          purchaseRequisitionsServices.deleteSinglePR(
            {
              id: prID
            },
            function () {
              toastr.success('Draft Purchase Requisition deleted');
              $state.reload();
            }, function () {
              toastr.error('This Draft PR cannot be deleted.');
            }
          );
        }
      });
  }

  function checkStarred(pr) {
    if(!!pr.starred_users && pr.starred_users.length > 0) {
      return (pr.starred_users.indexOf($rootScope.currentUser._id) > -1);
    }
  }


  /**
   *  auto select/deselect the items for approval action
   * @param status
   */
  function multiSelectPendingItems (status) {
    _.forEach($scope.dataList, function (requisition) {
      if (checkWaitingOnUser(requisition)) {
        requisition.selected = status;
      }
    });
  }

  $scope.deletePR                     = deletePR;
  $scope.showColumn                   = showColumn;
  $scope.tabSelection                 = tabSelection;
  $scope.starringPR                   = starringPR;
  $scope.checkStarred                 = checkStarred;
  $scope.checkWaitingOnUser           = checkWaitingOnUser;
  $scope.getSelectedRequisitions      = getSelectedRequisitions;
  $scope.multiSelectPendingItems      = multiSelectPendingItems;
  $scope.showDetails                  = showDetails;
  $scope.setShowDetailsId             = setShowDetailsId;
  $scope.isShoppingMode               = isShoppingMode;
  $scope.getEditingPRState            = getEditingPRState;


  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.status = status;
  $scope.loadingPRMainParams = {
    module: 'PR',
    offset: 20,
    'criteria[status]': $scope.status,
    cursor: null
  };
  /**
   * to be used in the HTML validation
   */
  $scope.currentUser                  = $rootScope.currentUser;
  $scope.storageKey                   = 'purchase-requisitions-management-selected-columns';
  $scope.selectedDetail               = '';
  $scope.PR                           = [];

  function initialize(){
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;

    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }

    $scope.selectedListTab = $stateParams.tab;
    if(!$scope.selectedListTab){
      $scope.selectedListTab = 'all';
    }
    /**
     * Id highlight
     */
    $scope.highlightId = HighlightId.getId();
    if(!!$scope.highlightId) {
      //scroll the window to top
      $window.scroll(0, 0);
      //clear current id
      HighlightId.setId(null);
    }
  }

  initialize();

}

requisitionsManageCtrl.$inject = [
  '$scope', 'dataList', 'status', 'purchaseRequisitionsServices', '$rootScope', 'globalFunc', '$state', '$stateParams',
  'HighlightId', '$window', '$filter', 'toastr', 'prFunction', 'Approvals', '$q'
];

angular
  .module('metabuyer')
  .controller('requisitionsManageCtrl', requisitionsManageCtrl);

'use strict';
/**
 * @name requisitionsDetailsCtrl
 *
 * @description
 *
 * Controller for the requisitions details state
 *
 *
 * @authors Justin <justin.cty90@gmail.com> Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */

function requisitionsDetailsCtrl(
  $scope, purchaseRequisition, metabuyerCache, $rootScope, $state, companyCurrencies, PRNewComments, prFunction,
  approvalPreview, globalFunc, profile, Approvals, searchModule, singleCommentsHistory, NewPRFirstLoad, PRNewAttachments,
  $filter, pathConstants
) {

  $scope.PR                           = purchaseRequisition.data;
  $scope.editingPRState               = 'editable';
  $scope.commentService               = PRNewComments;
  $scope.deleteService                = singleCommentsHistory;
  $scope.singleAttachmentService      = PRNewAttachments;
  $scope.attachmentParam              = {
    pr_id: prFunction.getPRData()._id,
    attachmentId: null
  };
  $scope.attachmentUrl                = $filter('format')(pathConstants.apiUrls.attachments.listPRNewAttachment,
                                        {pr_id: prFunction.getPRData()._id});
  $scope.waiting_on_user              = [];
  $scope.approvals                    = {};
  $scope.currentUser                  = $rootScope.currentUser || {_id:null};
  $scope.prAttachments                = [];
  $scope.isFirstCreate                = NewPRFirstLoad.isFirstLoad;
  $scope.profile                      = profile;

  $scope.getUpdatePRField             = getUpdatePRField;
  $scope.isShoppingMode               = isShoppingMode;
  $scope.back                         = back;
  $scope.getContactPerson             = getContactPerson;
  $scope.approvalsPreview             = approvalsPreview;
  $scope.checkWaitingOn               = checkWaitingOn;
  $scope.getEditingPRState            = getEditingPRState;
  $scope.isCurrentUserIsPAInApproval  = isCurrentUserIsPAInApproval;

  /**
   * this function will check the state of the PR
   * as well as the Type of the logged in user
   */
  function checkIfPRIsEditable(){
    prFunction.setEditableState(($scope.PR.status === 'draft') ? 'editable' : 'notEditable');
    if ($scope.currentUser._id !== $scope.PR.creator._id)
      prFunction.setEditableState('notEditable');
  }

  /**
   * function returns checker for the states to hide or show the PR details
   * @returns {*|boolean}
   */
  function isShoppingMode() {
    $scope.PR = prFunction.getPRData();
    return $state.includes('main.user.purchaseRequisitions.details.catalog');
  }

  function back () {

    var prStatus = $scope.PR.status;
    if($scope.PR.status === 'on_hold'){
      prStatus = 'pending';
    }

    $state.go('main.user.purchaseRequisitions.manage', {
      status: prStatus,
      tab: 'waiting',
      extraFilterKey: prStatus === 'pending' ? 'criteria[waiting_on][]' : null,
      extraFilterValue: prStatus === 'pending' ? $rootScope.currentUser._id : null,
      cursor: null
    });
  }

  function getUpdatePRField() {
    return prFunction.getLoading('updatePRField');
  }

  /**
   * Load All available costCenters fro the user profile and cache them
   * @returns {Array}
   */
  function loadCostCenters() {
    var allCostCenters = [];
    if (metabuyerCache.get('userCostCenters')) {
      allCostCenters = metabuyerCache.get('userCostCenters');
    } else {
      allCostCenters = $rootScope.currentUser.costCenters;
      metabuyerCache.put('userCostCenters', allCostCenters);
    }
    return allCostCenters;
  }

  /**
   * refine the list of Cost Centers to the ones available within the Company of the PR
   * the cost centers object in the User only holds the company Code, not ID, so the matching is using the unique code of the Company
   * @param allCostCenters
   * @returns {Array}
   */
  function loadSelectableCostCenters(allCostCenters) {
    var costCenters = [];

    angular.forEach(allCostCenters, function (CC) {
      if (!!$scope.PR && !!$scope.PR.company &&
        (CC.company_code === $scope.PR.company.code)) {
        costCenters.push(CC);
      }
    });

    return costCenters;
  }

  function loadApprovalFlow() {
    if ($scope.PR.status !== 'draft') {
      Approvals.get({
        id: $scope.PR.approval_id
      }, function(resource){
        if(!!resource && !!resource.content && !!resource.content.data){
          $scope.approvals = resource.content.data;
          $scope.approvalFlowData = resource.content.data;
          globalFunc.getWaitingOnUser(resource.content.data, $scope.waiting_on_user);
          prFunction.setApprovalFlow(resource.content.data);
        }
        else
          $scope.approvals = [];
      }, function (){
        $scope.approvals = [];
      });
    }
  }

  /**
   * Loading the Currencies options for the Company of the PR to select from
   * @param company
   */
  function loadCurrencies(company) {

    if (!!company._id) {
      companyCurrencies.get({
          id: company._id
        },
        function (resource) {
          if (!!resource.content && !!resource.content.data) {
            prFunction.setCurrenciesData(resource.content.data);
          }
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        });
    }
  }

  /**
   * get the approval flow to display it in draft
   */
  function approvalsPreview(){
    approvalPreview.get({
      company_code: $scope.PR.company.code,
      context_type: 'Metabuyer\\PR\\PR',
      context_id: $scope.PR._id
    }, function(resource){
      // send to action directive
      $scope.approvalFlowData = resource.content.data;
      $scope.approvals = resource.content.data;
      prFunction.setLoading('updatePRField', false);
    }, function(error){
      globalFunc.objectErrorMessage('Failed to preview the approval flow');
      globalFunc.objectErrorMessage(error);
      prFunction.setLoading('updatePRField', true);
    });
  }

  function loadTax() {
    var localStorageTaxes = JSON.parse(window.localStorage.getItem('taxes'));
    if (!localStorageTaxes) {
      searchModule.get(
        {
          module: 'tax',
          'criteria[is_active]': 1,
          offset: 0
        },
        function (resource) {
          if (!!resource.content && !!resource.content.data) {
            window.localStorage.setItem('taxes', JSON.stringify(resource.content.data));
            prFunction.setTaxData(resource.content.data);
          }
        }
      );
    }
    else
      prFunction.setTaxData(localStorageTaxes);
  }

  /**
   * check the waiting on value
   * @returns {boolean}
   */
  function checkWaitingOn() {
    var find_user = _.find($scope.waiting_on_user, function (approver) {
      return (approver._id === profile._id);
    });

    return (find_user !== undefined);
  }

  /**
   * get the contact persons from service
   * the contactPerson setter is in the header directive
   * @returns {*}
   */
  function getContactPerson() {
    return prFunction.getContactPerson();
  }

  function getPRAttachment() {
    PRNewAttachments.getListPRAttachment({
      pr_id: prFunction.getPRData()._id
    }, function(resource) {
      if (!!resource && !!resource.content)
        $scope.prAttachments = resource.content.data;
    }, function(error) {
      globalFunc.objectErrorMessage(error);
    })
  }

  /**
   * get the editable state for
   * @returns {*}
   */
  function getEditingPRState(){
    return prFunction.getEditingState();
  }

  function activateTab(){
    var status = prFunction.getPRData().status.toLowerCase();

    if (status === 'on_hold')
      status = 'pending';

    var tab = globalFunc.findInArray($scope.$parent.tabData, 'key', status);
    if(!tab)
      tab = globalFunc.findInArray($scope.$parent.tabData.more, 'key', status);
    return !!tab ? tab : $scope.$parent.tabData[0];
  }

  function isCurrentUserIsPAInApproval() {
    return (globalFunc.checkIfUserHasPARole($rootScope.currentUser));
  }

  function initialize(){

    $state.params.status = $scope.PR.status.toLowerCase();
    if ($scope.PR.status.toLowerCase() === 'on_hold')
      $state.params.status = 'pending';

    $scope.prBudgetId = (!!$scope.PR.budget && !!$scope.PR.budget._id) ? $scope.PR.budget._id : null;

    var tabData = {
      tab: activateTab(),
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
    checkIfPRIsEditable();
    loadApprovalFlow();
    getPRAttachment();

    loadTax();

    var allCostCenters =  loadCostCenters();

    $scope.costCenters = loadSelectableCostCenters(allCostCenters);
    loadCurrencies($scope.PR.company);
    // prepare the list of items in the main PR object to the children objects
    if (!$scope.PR.pr_items)
      $scope.PR.pr_items = [];

    // clean up the error messages
    prFunction.setErrorsOnSubmit([]);
    NewPRFirstLoad.unset();
  }

  initialize();

}
requisitionsDetailsCtrl.$inject = [
  '$scope', 'purchaseRequisition', 'metabuyerCache', '$rootScope', '$state', 'companyCurrencies', 'PRNewComments',
  'prFunction', 'approvalPreview', 'globalFunc', 'profile', 'Approvals', 'searchModule', 'singleCommentsHistory',
  'NewPRFirstLoad', 'PRNewAttachments', '$filter', 'pathConstants'
];

angular
  .module('metabuyer')
  .controller('requisitionsDetailsCtrl', requisitionsDetailsCtrl);

'use strict';
/**
 * @name positionManagementCtrl
 * @desc Controller for listing of positions
 */
function positionManagementCtrl($scope, $uibModal, positionManagementListing, positionManagement, toastr,
                                positionManagementSingle, globalFunc, pathConstants, $http, $filter) {

  $scope.importParams = {
    class: 'Metabuyer\\ApprovalFlow\\Positions\\Models\\Position',
    'additional_params[]': ''
  };

  $scope.columns = [
    {id: 'row', label: '#', unsortable: true},
    {id: 'code', label: 'Code'},
    {id: 'name', label: 'Position'},
    {id: 'position_type', label: 'Type'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updated_by', label: 'Updated By', unsortable: true, unsearchable: true},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'created_by', label: 'Created By', unsortable: true, unsearchable: true},
    {id: 'status', label: 'Status'}
    // {id: 'remove', label: 'Remove', unsortable: true}
  ];

  $scope.processedData = [];
  $scope.meta = [];
  $scope.positionName = '';
  $scope.positionCode = '';
  $scope.editClicked = false;
  $scope.page = 0;
  $scope.limit = 30;
  $scope.currentStatus = {
    col: null,
    order: null
  };
  $scope.timezoneDiff = '';
  $scope.colSorting = null;
  $scope.colOrder = null;
  $scope.storageKey = 'position-management-manage-selected-columns';
  $scope.statusListing = [
    {
      code: '0',
      descr: 'Active'
    },
    {
      code: '1',
      descr: 'Inactive'
    }
  ];
  $scope.status = {};
  $scope.status.list = [];

  $scope.visibleColumn = visibleColumn;
  $scope.showDetails = showDetails;
  $scope.add = add;
  $scope.processData = processData;
  $scope.returnDate = returnDate;
  $scope.returnStatus = returnStatus;
  $scope.search = search;
  $scope.removePosition = removePosition;
  $scope.exportPosition = exportPosition;
  $scope.resetSelection = resetSelection;

  function visibleColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function showDetails(data) {
    $scope.editClicked = false;
    $uibModal.open({
      templateUrl: 'app/positionManagement/manage/details.html',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      controller: 'positionDetailsController',
      resolve: {
        isEditable: function () {
          return false;
        },
        data: function () {
          return data;
        },
        positionHistory: function ($q, approvalTemplateHistory) {
          var deferred = $q.defer();
          approvalTemplateHistory.get(
            {
              'sort[1][key]': 'created_at',
              'sort[1][direction]': 'DESC',
              'filter_groups[0][filters][0][key]': 'auditable_id',
              'filter_groups[0][filters][0][value]': data.id,
              'filter_groups[0][filters][0][operator]': 'eq',
              'filter_groups[1][filters][0][key]': 'auditable_type',
              'filter_groups[1][filters][0][value]': 'Api\\Positions\\Models\\Position',
              'filter_groups[1][filters][0][operator]': 'eq',
              limit: 10,
              page: 0
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              deferred.resolve([]);
            }
          );
          return deferred.promise;
        },
        isEditWindow: function () {
          return true;
        }
      }
    });
  }

  function add() {
    $scope.editClicked = true;
    $uibModal.open({
      templateUrl: 'app/positionManagement/manage/details.html',
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      controller: 'positionDetailsController',
      resolve: {
        isEditable: function () {
          return true;
        },
        data: function () {
          return [];
        },
        positionHistory: function () {
          return null;
        },
        isEditWindow: function () {
          return false;
        }
      }
    });
  }

  function processData() {
    $scope.processedData = [];
    $scope.processedData = $scope.positionData.position;
    $scope.meta['currentPageNumber'] = $scope.positionData['meta']['current'];
    $scope.meta['totalPageNumber'] = $scope.positionData['meta']['pages'];
    $scope.meta['totalRec'] = $scope.positionData['meta']['count'];
    $scope.meta['startRecNo'] = $scope.limit * $scope.page + 1;
    $scope.meta['endRecNo'] = $scope.meta['totalRec'] - ((1 + $scope.meta['currentPageNumber']) * $scope.limit) >= 0 ?
      (1 + $scope.meta['currentPageNumber']) * $scope.limit :
      (($scope.meta['currentPageNumber']) * $scope.limit) + $scope.meta['totalRec'] % $scope.limit;
    $scope.positionData = $scope.processedData;
  }

  function returnDate(date) {
    return globalFunc.convertToLocalDate(date);
  }

  function returnStatus(status) {
    var statusString = '';
    switch (status) {
      case 0:
        statusString = 'Active';
        break;
      case 1:
        statusString = 'Inactive';
        break;
    }
    return statusString;
  }

  function search(page, sortingCol, sortingOrder) {
    $scope.page = page;
    $scope.colSorting = sortingCol;
    $scope.colOrder = sortingOrder;
    positionManagement.get(
      {
        'sort[0][key]': sortingCol,
        'sort[0][direction]': sortingOrder,
        'sort[1][key]': 'updated_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'name',
        'filter_groups[0][filters][0][value]': !!$scope.positionName ? $scope.positionName : '',
        'filter_groups[0][filters][0][operator]': 'ct',
        'filter_groups[0][filters][1][key]': 'code',
        'filter_groups[0][filters][1][value]': !!$scope.positionCode ? $scope.positionCode : '',
        'filter_groups[0][filters][1][operator]': 'ct',
        'filter_groups[0][filters][2][key]': 'status',
        'filter_groups[0][filters][2][value]': !!$scope.status.list.code ? $scope.status.list.code : '',
        'filter_groups[0][filters][2][operator]': 'ct',
        limit: $scope.limit,
        page: page
      }
    ).$promise.then(
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.positionData = resource.content.data;
          $scope.positionData['meta'] = resource.content.meta.cursor;
          processData();
        }
      },
      function (resource) {
        if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        }
        else {
          toastr.error('Failed to search.');
        }
      }
    );
  }

  function removePosition(position) {
    swal({
        title: 'Warning!',
        text: 'Are you sure you want to delete position \'' + position.name + '\' ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (isConfirm) {
          positionManagementSingle.delete(
            {
              id: position.id
            }
          ).$promise.then(
            function () {
              search($scope.meta['currentPageNumber']);
              toastr.success('Position has been successfully deleted.');
            },
            function (resource) {
              if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
                toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
              }
              else {
                toastr.error('Failed to delete selected position.');
              }
            }
          );
        }
      });
  }

  function exportPosition() {
    $http({
      method: 'POST',
      url: pathConstants.apiUrls.approvalEngine.position.export,
      params: {
        'sort[0][key]': $scope.colSorting,
        'sort[0][direction]': $scope.colOrder,
        'sort[1][key]': 'updated_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'name',
        'filter_groups[0][filters][0][value]': !!$scope.positionName ? $scope.positionName : '',
        'filter_groups[0][filters][0][operator]': 'ct',
        'filter_groups[0][filters][1][key]': 'code',
        'filter_groups[0][filters][1][value]': !!$scope.positionCode ? $scope.positionCode : '',
        'filter_groups[0][filters][1][operator]': 'ct',
        'filter_groups[0][filters][2][key]': 'status',
        'filter_groups[0][filters][2][value]': !!$scope.status.list.code ? $scope.status.list.code : '',
        'filter_groups[0][filters][2][operator]': 'ct'
      }
    }).then(function (response) {
      var blob = new Blob([response.data]);
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Position ' + $filter('date')(new Date(), 'dd-MMM-yyyy') +'.csv';
      link.click();
      toastr.success('Position file has been successfully generated.');
    }, function () {
      toastr.error('Failed to generate position file.');
    });
  }

  function resetSelection() {
    $scope.positionName = '';
    $scope.positionCode = '';
    $scope.status.list = [];
  }

  function initialize() {
    $scope.timezoneDiff = globalFunc.getTimezoneDiff();
    $scope.positionData = positionManagementListing.data;
    $scope.positionData['meta'] = positionManagementListing.meta.cursor;
    processData();
  }

  initialize();

}

positionManagementCtrl.$inject = ['$scope', '$uibModal', 'positionManagementListing', 'positionManagement',
  'toastr', 'positionManagementSingle', 'globalFunc', 'pathConstants', '$http', '$filter'];

angular
  .module('metabuyer')
  .controller('positionManagementCtrl', positionManagementCtrl);


'use strict';

/**
 * @name positionDetailsController
 * @desc Controller for master data position details controller
 */
function positionDetailsController(
  $scope, $uibModalInstance, toastr, isEditable, data, positionManagement, $rootScope, isEditWindow,
  positionManagementSingle, positionHistory, approvalTemplateHistory, $filter, globalFunc
) {

  $scope.editClicked = isEditable;
  $scope.positionDetails = [];
  $scope.positionDetails.code = data.code;
  $scope.positionDetails.description = data.description;
  $scope.positionDetails.id = data.id;
  $scope.positionDetails.name = data.name;
  $scope.positionDetails.position_type = data.position_type;
  $scope.positionDetails.status = data.status;
  $scope.positionDetails.status_desc = data.status_desc;
  $scope.inEditMode = isEditWindow;
  $scope.tab = 1;
  $scope.limitDetail = 10;
  $scope.metaDetail = [];
  $scope.pageDetail = 0;

  $scope.toggleTab = toggleTab;
  $scope.cancel = cancel;
  $scope.editPosition = editPosition;
  $scope.updatePosition = updatePosition;
  $scope.addPosition = addPosition;
  $scope.isAddPositionMode = isAddPositionMode;
  $scope.validateBeforeCreate = validateBeforeCreate;
  $scope.searchHistory = searchHistory;

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  $scope.status = [
    {
      id: 0,
      name: "Active"
    },
    {
      id: 1,
      name: "Inactive"
    }
  ];

  $scope.type = [
    {
      id: "approver",
      name: "Approver"
    },
    {
      id: "watcher",
      name: "Watcher"
    }
  ];

  function editPosition() {
    $scope.editClicked = true;
  }

  function updatePosition() {
    if (validateBeforeCreate()) {
      var param = {
        code: $scope.positionDetails.code,
        name: $scope.positionDetails.name,
        position_type: $scope.positionDetails.position_type,
        status: $scope.positionDetails.status,
        description: $scope.positionDetails.description,
        updated_by: $rootScope.currentUser.display_name
      }
      positionManagementSingle.put(
        {
          'position': param,
          id: $scope.positionDetails.id
        }
      ).$promise.then(
        function () {
          $scope.search($scope.meta['currentPageNumber']);
          cancel();
          toastr.success('Position has been successfully updated.');
        },
        function (resource) {
          if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
            toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
          }
          else {
            toastr.error('Failed to update selected position.');
          }
        }
      );
    }
  }

  function addPosition() {
    if (!!validateBeforeCreate()) {
      var param = {
        code: $scope.positionDetails.code,
        name: $scope.positionDetails.name,
        status: $scope.positionDetails.status,
        created_by: $rootScope.currentUser.display_name,
        description: $scope.positionDetails.description,
        position_type: $scope.positionDetails.position_type
      }
      positionManagement.post(
        {
          'position': param
        }
      ).$promise.then(
        function () {
          $scope.search($scope.meta['currentPageNumber']);
          cancel();
          toastr.success('New position has been successfully created.');
        },
        function (resource) {
          if (!!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
            toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
          }
          else {
            toastr.error('Failed to create new position.');
          }
        }
      );
    }
  }

  function isAddPositionMode() {
    return !!_.isEmpty($scope.positionDetails.id) ? true : false;
  }

  function validateBeforeCreate() {
    if (!!_.isEmpty($scope.positionDetails.name) || !!_.isEmpty($scope.positionDetails.code) || !!_.isEmpty($scope.positionDetails.position_type) ||
      typeof $scope.positionDetails.status !== 'number') {
      toastr.error('Please fill in all the fields.');
      return false;
    }
    return true;
  }

  function populateLog(data) {
    _.forEach(data, function (historyData) {
      historyData.log = [];

      if (historyData.event === 'updated') {
        if (typeof(historyData.new_values.name) !== 'undefined' && typeof(historyData.old_values.name) !== 'undefined') {
          historyData.log.push('name : ' + historyData.old_values.name + ' => ' + historyData.new_values.name);
        }
        if (typeof(historyData.new_values.description) !== 'undefined' && typeof(historyData.old_values.description) !== 'undefined') {
          historyData.log.push('description : ' + historyData.old_values.description + ' => ' + historyData.new_values.description);
        }
        if (typeof(historyData.new_values.position_type) !== 'undefined' && typeof(historyData.old_values.position_type) !== 'undefined') {
          historyData.log.push('type : ' + historyData.old_values.position_type + ' => ' + historyData.new_values.position_type);
        }
        if (typeof(historyData.new_values.status) !== 'undefined' && typeof(historyData.old_values.status) !== 'undefined') {
          historyData.log.push('status : ' + (historyData.old_values.status === '0' || historyData.old_values.status === 0 ?
              'active' : 'inactive') + ' => ' + (historyData.new_values.status === '0' ? 'active' : 'inactive'));
        }
      }
      historyData.logForExport = historyData.log.join('\r\n');
    })
    return data;
  }

  function processData() {
    $scope.positionHistoryData = populateLog($scope.positionHistoryData);
    $scope.metaDetail['currentPageNumber'] = $scope.positionHistoryData['meta']['current'];
    $scope.metaDetail['totalPageNumber'] = $scope.positionHistoryData['meta']['pages'];
    $scope.metaDetail['totalRec'] = $scope.positionHistoryData['meta']['count'];
    $scope.metaDetail['startRecNo'] = $scope.limitDetail * $scope.pageDetail + 1;
    $scope.metaDetail['endRecNo'] = $scope.metaDetail['totalRec'] - ((1 + $scope.metaDetail['currentPageNumber']) * $scope.limitDetail) >= 0 ?
      (1 + $scope.metaDetail['currentPageNumber']) * $scope.limitDetail :
      (($scope.metaDetail['currentPageNumber']) * $scope.limitDetail) + $scope.metaDetail['totalRec'] % $scope.limitDetail;
  }

  function searchHistory(pageDetail, callFrom) {
    var isExport = !!callFrom && callFrom === 'export' ? true : false
    $scope.pageDetail = !!pageDetail ? pageDetail : $scope.pageDetail;
    approvalTemplateHistory.get(
      {
        'sort[1][key]': 'created_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'auditable_id',
        'filter_groups[0][filters][0][value]': data.id,
        'filter_groups[0][filters][0][operator]': 'eq',
        'filter_groups[1][filters][0][key]': 'auditable_type',
        'filter_groups[1][filters][0][value]': 'Api\\Positions\\Models\\Position',
        'filter_groups[1][filters][0][operator]': 'eq',
        limit: isExport ? 0 : $scope.limitDetail,
        page: isExport ? 0 : pageDetail
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          if (isExport) {
            $scope.positionHistoryDataExport = resource.content.data;
            $scope.positionHistoryDataExport = populateLog($scope.positionHistoryDataExport);
            exportCSV();
          } else {
            $scope.positionHistoryData = resource.content.data;
            $scope.positionHistoryData['meta'] = resource.content.meta.cursor;
            processData();
          }
        }
      },
      function (resource) {
        if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        }
        else {
          toastr.error('Failed to load history.');
        }
      }
    )
  }

  function exportCSV() {
    $scope.arrayData = [['Username', 'Action', 'Date', 'Changes']];
    _.forEach($scope.positionHistoryDataExport, function (data) {
      $scope.arrayData.push([
        (!!data.user && !!data.user.display_name ? data.user.display_name : ''),
        data.event,
        $filter('date')(globalFunc.convertToLocalDate(data.created_at), 'dd MMM yyyy h:mm a'),
        data.logForExport
      ])
    });
    $scope.fileName = globalFunc.getCsvFilenameWithDate('Position - ' + $scope.positionDetails.code);
    $scope.triggerHistoryExport = true;
  }

  function cancel() {
    $uibModalInstance.close();
  }

  function initialize(){
    if (!!positionHistory && !!positionHistory.data) {
      $scope.positionHistoryData = positionHistory.data;
      $scope.positionHistoryData['meta'] = positionHistory.meta.cursor;
      processData();
    }
  }

  initialize();
}

positionDetailsController.$inject = [
  '$scope', '$uibModalInstance', 'toastr', 'isEditable', 'data', 'positionManagement', '$rootScope', 'isEditWindow',
  'positionManagementSingle', 'positionHistory', 'approvalTemplateHistory', '$filter', 'globalFunc'
];

angular
  .module('metabuyer')
  .controller('positionDetailsController', positionDetailsController);

'use strict';
/**
 * @name positionAssignCtrl
 * @desc Controller for listing of position assignment
 */
function positionAssignCtrl(
  $scope, $uibModal, companies, positions, positionAssignment, positionAssignmentListing, globalFunc,
  searchModule, positionAssignmentSingle, toastr, $http, pathConstants, $filter
) {

  $scope.importParams = {
    class: 'Metabuyer\\ApprovalFlow\\Positions\\Models\\PositionAssignment',
    'additional_params[]': ''
  };

  $scope.columns = [
    {id: 'row', label: '#', unsortable: true},
    {id: 'code', label: 'Code', unsortable: true},
    {id: 'position', label: 'Position', unsortable: true},
    {id: 'company', label: 'Company', unsortable: true},
    {id: 'cost_center', label: 'Cost Center', unsortable: true},
    {id: 'assignee_name', label: 'User'},
    {id: 'type', label: 'Type', unsortable: true},
    {id: 'effective_date', label: 'Effective Date'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'created_by', label: 'Created By', unsortable: true, unsearchable: true},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updated_by', label: 'Updated By', unsortable: true, unsearchable: true},
    {id: 'status', label: 'Status'}
    // {id: 'remove', label: 'Remove', unsortable: true}
  ];

  $scope.positionAssign = [];
  $scope.meta = [];
  $scope.page = 0;
  $scope.limit = 30;
  $scope.currentStatus = {
    col: null,
    order: null
  };
  $scope.timezoneDiff = '';
  $scope.colSorting = null;
  $scope.colOrder = null;
  $scope.storageKey = 'position-management-assign-selected-columns';
  $scope.disableSearch = false;

  $scope.positionListing = !!positions && positions.data && !!positions.data.position ? positions.data.position : null;
  $scope.companyListing = [];
  $scope.companyListing.push({
    code: 'SYSTEM',
    descr: 'System Wide'
  });
  if (!!companies && !!companies.data) {
    [].push.apply($scope.companyListing, companies.data)
  }
  //$scope.costCenterListing = !!costCenter && !!costCenter.data ? costCenter.data : null;
  $scope.costCenterListing = null;
  $scope.userListing = [];

  $scope.uiCompany = {};
  $scope.uiCompany.list = [];
  $scope.uiPosition = {};
  $scope.uiPositionCode = {};
  $scope.uiPosition.list = [];
  $scope.uiPositionCode.list = [];
  $scope.uiCostCenter = {};
  $scope.uiCostCenter.list = [];
  $scope.uiUsername = {};
  $scope.uiUsername.list = [];
  $scope.statusListing = [
    {
      code: '0',
      descr: 'Active'
    },
    {
      code: '1',
      descr: 'Inactive'
    }
  ];
  $scope.status = {};
  $scope.status.list = [];

  $scope.visibleColumn = visibleColumn;
  $scope.processData = processData;
  $scope.returnDate = returnDate;
  $scope.returnStatus = returnStatus;
  $scope.search = search;
  $scope.exportPosition = exportPosition;
  $scope.addPositionAssign = addPositionAssign;
  $scope.isCompanySelected = isCompanySelected;
  $scope.processCostCenterList = processCostCenterList;
  $scope.showDetails = showDetails;
  $scope.removePositionAssign = removePositionAssign;
  $scope.resetSelection = resetSelection;

  function visibleColumn(id) {
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if (!!$scope.columns[i].conditional) {
          if ($scope.status === $scope.columns[i].condition) {
            return $scope.columns[i].selected;
          }
          if ($scope.columns[i].condition instanceof Array) {
            for (var j in $scope.columns[i].condition) {
              if ($scope.status === $scope.columns[i].condition[j]) {
                return $scope.columns[i].selected;
              }
            }
          }
        } else {
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function processData() {
    $scope.processedData = [];
    $scope.processedData = $scope.positionAssign;
    $scope.meta['currentPageNumber'] = $scope.positionAssign['meta']['current'];
    $scope.meta['totalPageNumber'] = $scope.positionAssign['meta']['pages'];
    $scope.meta['totalRec'] = $scope.positionAssign['meta']['count'];
    $scope.meta['startRecNo'] = $scope.limit * $scope.page + 1;
    $scope.meta['endRecNo'] = $scope.meta['totalRec'] - ((1 + $scope.meta['currentPageNumber']) * $scope.limit) >= 0 ?
      (1 + $scope.meta['currentPageNumber']) * $scope.limit :
      (($scope.meta['currentPageNumber']) * $scope.limit) + $scope.meta['totalRec'] % $scope.limit;
    $scope.positionAssign = $scope.processedData;
  }

  function returnDate(date) {
    return globalFunc.convertToLocalDate(date);
  }

  function returnStatus(status) {
    var statusString = '';
    switch (status) {
      case 0:
        statusString = 'Active';
        break;
      case 1:
        statusString = 'Inactive';
        break;
    }
    return statusString;
  }

  function getOrganizationId() {
    //convert to single string for cost_center / company searching
    var organizationId = '';
    if (!!$scope.uiCompany.list.code) {
      organizationId += _.isEmpty(organizationId) ? '' : ';';
      organizationId += ($scope.uiCompany.list.code.toLowerCase() === 'system' ? 'all' : $scope.uiCompany.list.code);
    }
    if (!!$scope.uiCostCenter.list.code) {
      organizationId = $scope.uiCostCenter.list.code;
    }
    return organizationId;
  }

  function search(page, sortingCol, sortingOrder) {
    $scope.page = page;
    $scope.colSorting = sortingCol;
    $scope.colOrder = sortingOrder;
    var params = {
      'sort[0][key]': sortingCol,
      'sort[0][direction]': sortingOrder,
      'sort[1][key]': 'status',
      'sort[1][direction]': 'ASC',
      'sort[2][key]': 'updated_at',
      'sort[2][direction]': 'DESC',
      'filter_groups[0][or]': 1,
      'filter_groups[0][filters][0][key]': 'organizationId',
      'filter_groups[0][filters][0][value]': getOrganizationId(),
      'filter_groups[0][filters][0][operator]': 'in',
      'filter_groups[1][filters][0][key]': 'status',
      'filter_groups[1][filters][0][value]': !!$scope.status.list.code ? $scope.status.list.code : '',
      'filter_groups[1][filters][0][operator]': 'ct',
      'filter_groups[2][filters][0][key]': 'position',
      'filter_groups[2][filters][0][value]': !!$scope.uiPosition.list.code ? $scope.uiPosition.list.code : '',
      'filter_groups[2][filters][0][operator]': 'eq',
      'filter_groups[3][filters][0][key]': 'position',
      'filter_groups[3][filters][0][value]': !!$scope.uiPositionCode.list.code ? $scope.uiPositionCode.list.code : '',
      'filter_groups[3][filters][0][operator]': 'eq',
      limit: $scope.limit,
      page: page
    };

    if (!!$scope.uiUsername.list && !!$scope.uiUsername.list._id) {
      params['filter_groups[4][filters][0][key]'] = 'assignee_id';
      params['filter_groups[4][filters][0][value]'] = $scope.uiUsername.list._id;
      params['filter_groups[4][filters][0][operator]'] = 'ct';
    }

    positionAssignment.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.positionAssign = resource.content.data;
          $scope.positionAssign['meta'] = resource.content.meta.cursor;
          processData();
        }
      },
      function (resource) {
        if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        }
        else {
          toastr.error('Failed to search.');
        }
      }
    )
  }

  function exportPosition() {
    $http({
      method: 'POST',
      url: pathConstants.apiUrls.approvalEngine.positionAssign.export,
      params: {
        'sort[0][key]': $scope.sortingCol,
        'sort[0][direction]': $scope.sortingOrder,
        'sort[1][key]': 'updated_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][or]': 1,
        'filter_groups[0][filters][0][key]': 'organizationId',
        'filter_groups[0][filters][0][value]': getOrganizationId(),
        'filter_groups[0][filters][0][operator]': 'ct',
        'filter_groups[1][filters][0][key]': 'assignee_id',
        'filter_groups[1][filters][0][value]': !!$scope.uiUsername.list._id ? $scope.uiUsername.list._id : '',
        'filter_groups[1][filters][0][operator]': 'ct',
        'filter_groups[2][filters][0][key]': 'status',
        'filter_groups[2][filters][0][value]': !!$scope.status.list.code ? $scope.status.list.code : '',
        'filter_groups[2][filters][0][operator]': 'ct',
        'filter_groups[3][filters][0][key]': 'position',
        'filter_groups[3][filters][0][value]': !!$scope.uiPosition.list.code ? $scope.uiPosition.list.code : '',
        'filter_groups[3][filters][0][operator]': 'eq',
        'filter_groups[4][filters][0][key]': 'position',
        'filter_groups[4][filters][0][value]': !!$scope.uiPositionCode.list.code ? $scope.uiPositionCode.list.code : '',
        'filter_groups[4][filters][0][operator]': 'eq'
      }

      // TODO ~HAN~ include position in searching
    }).then(function (response) {
      var blob = new Blob([response.data]);
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Position-Assignment ' + $filter('date')(new Date(), 'dd-MMM-yyyy') + '.csv';
      link.click();
      toastr.success('Position assignment file has been successfully generated.');
    }, function () {
      toastr.error('Failed to generate position assignment file.');
    });
  }

  function addPositionAssign() {
    $uibModal.open({
      templateUrl: "app/positionManagement/assign/details.html",
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      controller: 'positionAssignDetailsController',
      resolve: {
        isEditable: function () {
          return true;
        },
        data: function () {
          return [];
        },
        assignHistory: function () {
          return null;
        },
        isEditWindow: function () {
          return false;
        }
      }
    });
  }

  function isCompanySelected() {
    return !($scope.uiCompany.list.code);
  }

  function processCostCenterList() {
    $scope.uiCostCenter.list = [];
    //stop when no company is selected
    if ($scope.uiCompany.list.length === 0) {
      $scope.costCenterListing = [];
      return;
    }

    var params = {
      module: 'cost-center',
      offset: 0,
      criteria_operator: 'and',
      order_by: 'descr',
      order: 1
    };

    if ($scope.uiCompany.list.code !== 'SYSTEM')
      params['criteria[company_code]'] = $scope.uiCompany.list.code;

    searchModule.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.costCenterListing = resource.content.data;
        }
      }
    )
  }

  function showDetails(data) {
    $scope.editClicked = false;
    var modalInstance = $uibModal.open({
      templateUrl: "app/positionManagement/assign/details.html",
      backdrop: 'static',
      keyboard: false,
      scope: $scope,
      controller: 'positionAssignDetailsController',
      resolve: {
        isEditable: function () {
          return false;
        },
        data: function () {
          return data;
        },
        assignHistory: function ($q, approvalTemplateHistory) {
          var deferred = $q.defer();
          approvalTemplateHistory.get(
            {
              'sort[1][key]': 'created_at',
              'sort[1][direction]': 'DESC',
              'filter_groups[0][filters][0][key]': 'auditable_id',
              'filter_groups[0][filters][0][value]': data.id,
              'filter_groups[0][filters][0][operator]': 'eq',
              'filter_groups[1][filters][0][key]': 'auditable_type',
              'filter_groups[1][filters][0][value]': 'Api\\Positions\\Models\\UserAssignment',
              'filter_groups[1][filters][0][operator]': 'eq',
              limit: 10,
              page: 0
            },
            function (resource) {
              if (!!resource.content) {
                deferred.resolve(resource.content);
              }
            },
            function (error) {
              deferred.resolve([]);
            }
          );
          return deferred.promise;
        },
        isEditWindow: function () {
          return true;
        }
      }
    });

    modalInstance.result.then(function (newValue) {
      if(!!newValue){
        _.forEach($scope.positionAssign, function(dataList) {
          if (dataList.id === newValue.id) {
            dataList.status = newValue.status;
            dataList.effective_date = newValue.effective_date;
          }
        });
      }
    }, function () {
    });
  }

  function removePositionAssign(position) {
    swal({
        title: 'Warning!',
        text: 'Are you sure you want to delete? \n Position: ' + position.position_assignment.position.description +
          '\n Company: ' + position.company.descr + '\n Cost Center: ' + position.cost_center.descr +
          '\n User: ' + position.assignee_name,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (isConfirm) {
          positionAssignmentSingle.delete(
            {
              id: position.id
            },
            function () {
              search($scope.meta['currentPageNumber']);
              toastr.success('Position assignment has been successfully deleted.');
            },
            function (resource) {
              if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
                toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
              }
              else {
                toastr.error('Failed to delete selected position assignment.');
              }
            }
          )
        }
      });
  }

  function resetSelection() {
    $scope.uiCompany.list = [];
    $scope.uiPosition.list = [];
    $scope.uiPositionCode.list = [];
    $scope.uiCostCenter.list = [];
    $scope.uiUsername.list = [];
    $scope.status.list = [];
  }

  function loadUsersData()
  {
    $scope.disableSearch = true;
    searchModule.get(
      {
        module: 'users',
        offset: 0,
        order_by: 'display_name',
        order: 1
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.userListing = resource.content.data;
        }
        $scope.disableSearch = false;
      },
      function (error) {
        $scope.disableSearch = false;
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function initialize() {
    $scope.timezoneDiff = globalFunc.getTimezoneDiff();
    $scope.positionAssign = positionAssignmentListing.data;
    $scope.positionAssign['meta'] = positionAssignmentListing.meta.cursor;
    processData();
    loadUsersData();
  }

  initialize();

}

positionAssignCtrl.$inject = [
  '$scope', '$uibModal', 'companies', 'positions', 'positionAssignment',
  'positionAssignmentListing', 'globalFunc', 'searchModule', 'positionAssignmentSingle', 'toastr', '$http',
  'pathConstants', '$filter'
];

angular
  .module('metabuyer')
  .controller('positionAssignCtrl', positionAssignCtrl);


'use strict';
/**
 * @name positionAssignDetailsController
 * @desc Controller for edit details of position assignment
 */
function positionAssignDetailsController(
  $scope, $uibModalInstance, searchModule, positionAssignment, toastr, isEditWindow, isEditable, data,
  positionAssignmentSingle, globalFunc, assignHistory, approvalTemplateHistory, $filter, getUsersInCompanies
) {

  var backupPositionAssignment = angular.copy(data);

  $scope.editClicked = isEditable;
  $scope.inEditMode = isEditWindow;
  $scope.data = data;
  $scope.costCenterListing = [];
  $scope.uiSelectCompanies = {};
  $scope.uiSelectCompanies.list = [];
  $scope.uiSelectCostCenter = {};
  $scope.uiSelectCostCenter.list = [];
  $scope.uiUsernameList = [];
  $scope.selectedUsername = null;
  $scope.selectedPosition = null;
  $scope.costCenterLimit = undefined;
  $scope.companyLimit = undefined;
  $scope.status = [
    {id: 0, name: "Active"},
    {id: 1, name: "Inactive"}
  ];
  $scope.tab = 1;
  $scope.limitDetail = 10;
  $scope.metaDetail = [];
  $scope.pageDetail = 0;
  $scope.uiEffectiveDate = !!data.effective_date ? new Date(data.effective_date) : null;
  $scope.startDateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.datepickerOpened = false;

  $scope.toggleTab = toggleTab;
  $scope.selectCompany = selectCompany;
  $scope.selectCostCenter = selectCostCenter;
  $scope.addPositionAssign = addPositionAssign;
  $scope.cancel = cancel;
  $scope.editPositionAssign = editPositionAssign;
  $scope.updatePositionAssign = updatePositionAssign;
  $scope.searchHistory = searchHistory;
  $scope.openDatepicker = openDatepicker;
  $scope.checkPositionIsAdhoc = checkPositionIsAdhoc;
  $scope.converToLocalDate = converToLocalDate;

  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  function selectCompany(action) {
    if ((action === 'assign' && $scope.uiSelectCompanies.list.length > 1) ||
      (!!$scope.uiSelectCompanies.list[$scope.uiSelectCompanies.list.length - 1] &&
      $scope.uiSelectCompanies.list[$scope.uiSelectCompanies.list.length - 1].code === 'SYSTEM')) {
      $scope.costCenterLimit = 0;
      $scope.uiSelectCostCenter.list = [];
      $scope.costCenterListing = [];
    } else if (action === 'unassign' && $scope.uiSelectCompanies.list.length <= 1 && $scope.costCenterLimit === 0) {
      $scope.costCenterLimit = undefined;
    }

    if (!!$scope.uiSelectCompanies.list[$scope.uiSelectCompanies.list.length - 1] &&
      $scope.uiSelectCompanies.list[$scope.uiSelectCompanies.list.length - 1].code === 'SYSTEM') {
      $scope.companyLimit = 0;
      $scope.uiSelectCompanies.list = [];
      $scope.uiSelectCompanies.list = [{
        code: 'SYSTEM',
        descr: 'System Wide'
      }];
    } else {
      $scope.companyLimit = undefined;
    }
    loadCostCenter();
    loadUsers();
  }

  function selectCostCenter() {
    loadUsers();
  }

  function loadUsers() {
    //stop when no cost center is selected
    if ($scope.uiSelectCostCenter.list.length === 0 && $scope.uiSelectCompanies.list.length === 0) {
      $scope.selectedUsername = null;
      $scope.uiUsernameList = [];
      return;
    }

    var params = {};
    _.forEach($scope.uiSelectCompanies.list, function (company, index) {
      var temp = 'companyCodes[' + index + ']';
      if (company.code !== 'SYSTEM') {
        params[temp] = company.code;
      }
    });

    getUsersInCompanies.get(
      params,
      function (resource) {
        $scope.uiUsernameList = (!!resource && !!resource.content && !!resource.content.data) ?
          resource.content.data : [];

        var exist = false;
        if (globalFunc.findInArray($scope.uiUsernameList, '_id', $scope.selectedUsername)) {
          exist = true;
        }
        if (!exist)
          $scope.selectedUsername = null;

      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        $scope.users = [];
      }
    );
  }

  function loadCostCenter() {

    //stop when no company is selected OR when no cost center is allowed
    if ($scope.uiSelectCompanies.list.length === 0 || $scope.costCenterLimit === 0) {
      $scope.uiSelectCostCenter.list = [];
      $scope.costCenterListing = [];
      return;
    }

    var params = {
      module: 'cost-center',
      offset: 0,
      criteria_operator: 'and',
      order_by: 'descr',
      order: 1
    };

    $scope.companiesArray = [];
    _.forEach($scope.uiSelectCompanies.list, function (company, index) {
      $scope.companiesArray[index] = company.code;
    });
    params['criteria[company_code][]'] = $scope.companiesArray;

    searchModule.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.costCenterListing = resource.content.data;
        }
      }
    )
  }

  function checkPositionIsAdhoc(selectedPosition) {
    if (!selectedPosition) {
      return false;
    }

    var position = globalFunc.findInArray($scope.positionListing, 'id', selectedPosition);
    return (position.position_type === 'ad-hoc');
  }

  function validateBeforeCreate() {

    if (_.isEmpty($scope.uiSelectCompanies.list) || _.isEmpty($scope.selectedUsername)) {
      if (typeof $scope.selectedPosition === 'number') {
        var selectedPositionDetail = globalFunc.findInArray($scope.positionListing, 'id', $scope.selectedPosition);
        if (selectedPositionDetail.position_type === 'ad-hoc') {
          return true;
        }
      }

      toastr.error('Please fill in all the fields.');
      return false;
    }

    if (typeof $scope.selectedPosition !== 'number') {
      toastr.error('Please fill in all the fields.');
      return false;
    }

    return true;
  }

  function addPositionAssign() {
    var date = !_.isNull($scope.uiEffectiveDate) ? $filter('date')(new Date($scope.uiEffectiveDate), 'dd-MM-yyyy') : null;
    var status = _.isNull($scope.uiEffectiveDate) ? 'active' : 'inactive';

    if (!!validateBeforeCreate()) {

      var param = [];

      //if SYSTEM is selected
      if ($scope.uiSelectCompanies.list[0].code === 'SYSTEM') {
        param.push({
          position_id: $scope.selectedPosition,
          assignee_email: $scope.selectedUsername,
          organization_type: 'system',
          organization_code: 'system',
          effective_date: date,
          status: status
        })
      }
      //if cost center is needed
      else if (!_.isEmpty($scope.uiSelectCostCenter.list)) {
        _.forEach($scope.uiSelectCostCenter.list, function (cc) {
          param.push({
            position_id: $scope.selectedPosition,
            assignee_email: $scope.selectedUsername,
            organization_type: 'cost_center',
            organization_code: cc.code,
            effective_date: date,
            status: status
          })
        });
      }
      //if only company selected
      else {
        _.forEach($scope.uiSelectCompanies.list, function (company) {
          param.push({
            position_id: $scope.selectedPosition,
            assignee_email: $scope.selectedUsername,
            organization_type: 'company',
            organization_code: company.code,
            effective_date: date,
            status: status
          })
        });
      }

      positionAssignment.post(
        {
          'assignment': param
        },
        function () {
          $scope.search($scope.metaDetail['currentPageNumber']);
          cancel();
          toastr.success('New position has been successfully created.');
        },
        function (resource) {
          if (!!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
            toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
          } else if (!!resource.data.content && !!resource.data.content.message) {
            toastr.error(resource.data.content.message.join('\n'));
          } else {
            toastr.error('Failed to create new position.');
          }
        }
      )
    }

  }

  function editPositionAssign() {
    $scope.editClicked = true;
  }

  function updatePositionAssign() {
    var param = {
      position_assignment_id: data.position_assignment.id,
      assignee_id: data.assignee_id,
      assignee_name: data.assignee_name,
      effective_date: !_.isNull($scope.uiEffectiveDate) ? $filter('date')(new Date($scope.uiEffectiveDate), 'dd-MM-yyyy') : null,
      status: data.status
    }
    positionAssignmentSingle.put(
      {
        id: data.id,
        'assignment': param
      },
      function () {
        $scope.search($scope.metaDetail['currentPageNumber']);
        cancel();
        toastr.success('Position has been successfully updated.');
      },
      function (resource) {
        if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        } else if (!!resource.data.content && !!resource.data.content.message) {
          toastr.error(resource.data.content.message.join('\n'));
        } else {
          toastr.error('Failed to update selected position assignment.');
        }

        $scope.data = backupPositionAssignment;
        $scope.uiEffectiveDate = !!$scope.data.effective_date ? new Date($scope.data.effective_date) : null;
      }
    )
  }

  function populateLog(data) {
    _.forEach(data, function (historyData) {
      historyData.log = [];
      if (historyData.event === 'updated') {
        if (typeof(historyData.new_values.status) !== 'undefined' && typeof(historyData.old_values.status) !== 'undefined') {
          historyData.log.push('status : ' + (historyData.old_values.status === '0' || historyData.old_values.status === 0 ?
              'active' : 'inactive') + ' => ' + (historyData.new_values.status === '0' ? 'active' : 'inactive'));
        }
        if (typeof(historyData.new_values.effective_date) !== 'undefined' && typeof(historyData.old_values.effective_date) !== 'undefined') {
          historyData.log.push('effective date : ' +
            (_.isNull(historyData.old_values.effective_date) ? ' - ' : $filter('date')(new Date(historyData.old_values.effective_date), 'dd MMM yyyy')) +
            ' => ' +
            (_.isNull(historyData.new_values.effective_date) ? ' - ' : $filter('date')(new Date(historyData.new_values.effective_date), 'dd MMM yyyy')));
        }
      }
    })
    return data;
  }

  function processData() {
    $scope.assignHistoryData = populateLog($scope.assignHistoryData);
    $scope.metaDetail['currentPageNumber'] = $scope.assignHistoryData['meta']['current'];
    $scope.metaDetail['totalPageNumber'] = $scope.assignHistoryData['meta']['pages'];
    $scope.metaDetail['totalRec'] = $scope.assignHistoryData['meta']['count'];
    $scope.metaDetail['startRecNo'] = $scope.limitDetail * $scope.pageDetail + 1;
    $scope.metaDetail['endRecNo'] = $scope.metaDetail['totalRec'] - ((1 + $scope.metaDetail['currentPageNumber']) * $scope.limitDetail) >= 0 ?
      (1 + $scope.metaDetail['currentPageNumber']) * $scope.limitDetail :
      (($scope.metaDetail['currentPageNumber']) * $scope.limitDetail) + $scope.metaDetail['totalRec'] % $scope.limitDetail;
  }

  function searchHistory(pageDetail, callFrom) {
    var isExport = !!callFrom && callFrom === 'export' ? true : false
    $scope.pageDetail = !!pageDetail ? pageDetail : $scope.pageDetail;
    approvalTemplateHistory.get(
      {
        'sort[1][key]': 'created_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'auditable_id',
        'filter_groups[0][filters][0][value]': data.id,
        'filter_groups[0][filters][0][operator]': 'eq',
        'filter_groups[1][filters][0][key]': 'auditable_type',
        'filter_groups[1][filters][0][value]': 'Api\\Positions\\Models\\UserAssignment',
        'filter_groups[1][filters][0][operator]': 'eq',
        limit: isExport ? 0 : $scope.limitDetail,
        page: isExport ? 0 : pageDetail
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          if (isExport) {
            $scope.assignHistoryDataExport = resource.content.data;
            $scope.assignHistoryDataExport = populateLog($scope.assignHistoryDataExport);
            exportCSV();
          } else {
            $scope.assignHistoryData = resource.content.data;
            $scope.assignHistoryData['meta'] = resource.content.meta.cursor;
            processData();
          }
        }
      },
      function (resource) {
        if (!!resource.data && !!resource.data.content && !!resource.data.content.message && !!resource.data.content.message.errors) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        }
        else {
          toastr.error('Failed to load history.');
        }
      }
    )
  }

  function openDatepicker($event) {
    $scope.startDateOptions.minDate = new Date();
    $scope.startDateOptions.minDate.setDate($scope.startDateOptions.minDate.getDate() + 1);
    $event.preventDefault();
    $event.stopPropagation();
    $scope.datepickerOpened = true;
  }

  function exportCSV() {
    $scope.arrayData = [['Username', 'Action', 'Date', 'Changes']];
    _.forEach($scope.assignHistoryDataExport, function (data) {
      $scope.arrayData.push([
        (!!data.user && !!data.user.display_name ? data.user.display_name : ''),
        data.event,
        $filter('date')(globalFunc.convertToLocalDate(data.created_at), 'dd MMM yyyy h:mm a'),
        data.log
      ])
    });
    $scope.fileName = globalFunc.getCsvFilenameWithDate('Position Assignment - ' + $scope.data.position_assignment.position.code);
    $scope.triggerHistoryExport = true;
  }

  function converToLocalDate(date){
    return globalFunc.convertToLocalDate(date);
  }

  function cancel() {
    $uibModalInstance.close(backupPositionAssignment);
  }

  function initialize(){
    if (!!assignHistory && !!assignHistory.data) {
      $scope.assignHistoryData = assignHistory.data;
      $scope.assignHistoryData['meta'] = assignHistory.meta.cursor;
      processData();
    }
  }

  initialize();

}

positionAssignDetailsController.$inject = [
  '$scope', '$uibModalInstance', 'searchModule', 'positionAssignment', 'toastr', 'isEditWindow', 'isEditable', 'data',
  'positionAssignmentSingle', 'globalFunc', 'assignHistory', 'approvalTemplateHistory', '$filter', 'getUsersInCompanies'
];

angular
  .module('metabuyer')
  .controller('positionAssignDetailsController', positionAssignDetailsController);

'use strict';

function OrdersManageCtrl($scope, $state, $stateParams, $filter, Orders, orders, $window, HighlightId,
                          pathConstants, $resource, $rootScope) {

  var checkedListItem = [];
  $scope.check = check;
  $scope.checkAll = checkAll;
  $scope.formatPercentage = formatPercentage;
  $scope.changeStringCase = changeStringCase;
  $scope.checkStar = checkStar;

  $scope.showColumn = showColumn;

  $scope.storageKey = 'orders-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  /**
   * Function to return whether po is starred by current user or not
   * @param order
   * @returns {boolean}
   */
  function checkStar(order) {
    if (order.stared_by !== null) {
      for (var i in order.stared_by) {
        if ($rootScope.currentUser._id === order.stared_by[i]) {
          order.isStarred = true;
        }
      }
    }
  }

  // Trigger if any item is checked. Display action button.
  function check(requisition) {
    checkedListItem.splice(0, checkedListItem.length);
    $scope.showAction = false;
    for (var index = 0; index < $scope.orders.length; ++index) {
      var item = $scope.orders[index];
      if (!item.selected) {
        continue;
      }
      $scope.showAction = true;
      checkedListItem.push(item);
    }
  }
  // Check all item.
  function checkAll() {
    if ($scope.selectedAll) {
      $scope.showAction = $scope.selectedAll = true;
    } else {
      $scope.showAction = $scope.selectedAll = false;
    }
    checkedListItem.splice(0, checkedListItem.length);
    angular.forEach($scope.orders, function (item) {
      item.selected = $scope.selectedAll;
      if (item.selected)
        checkedListItem.push(item);
    });
  }

  function formatPercentage(value){
    return value * 100;
  }

  function changeStringCase(string){
    var newString = string.replace('_', ' ');
    newString = $filter('titleCase')(newString);
    return newString;
  }

  function initialize(){

    $stateParams.status = !!$stateParams.status ? $stateParams.status.toUpperCase() : '';
    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;
    $scope.orders = orders.data;
    $scope.meta = orders.meta;
    $scope.mangeOrderService = Orders;

    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }

    //TODO: have an extra filter for Closed  and Delivered for now they are both Closed (Ahmed Saleh, 9/3/2016)
    if(!!$scope.status && $scope.status.toLowerCase() === 'fully_delivered'){
      $scope.status = 'CLOSED';
    }
    //highlight row
    if(!!HighlightId.getId() && HighlightId.getId() != undefined && HighlightId.getId().length) {

      $scope.highlightId = HighlightId.getId();

      if ($scope.highlightId != null && $scope.highlightId != undefined) {

        //scroll the window to top
        $window.scroll(0, 0);
      }

      //clear current id
      HighlightId.setId(null);
    }

    angular.forEach($scope.orders, function(order) {
      checkStar(order);
    });

    //progress piety chart
    $scope.peiChart = {
      options:{
        fill: ['#1ab394', "#eeeeee"]
      }
    };
  }

  initialize();
}

OrdersManageCtrl.$inject = ['$scope', '$state', '$stateParams', '$filter', 'Orders', 'orders', '$window',
                            'HighlightId', 'pathConstants', '$resource', '$rootScope'];

angular.module('metabuyer')
  .controller('OrdersManageCtrl', OrdersManageCtrl);

'use strict';

function OrdersDetailCtrl(
  $scope, $q, globalFunc, $state, $location, $anchorScroll, order, pathConstants, Orders, profile, starringPO, $rootScope, toastr, purchaseRequisitionsServices, HighlightId, POSubscriptionCheck, getPOPDFHash, $filter,
  notificationSubscriber, POComments, UserPermissions, $timeout
) {

  $scope.po = order;
  $scope.service = POComments;
  $scope.po.notify = POSubscriptionCheck.subscribed;
  $scope.profile = profile;
  $scope.notificationToggle = notificationToggle;
  $scope.imageBasePath = pathConstants.apiUrls.image.pr;
  $scope.userBasePath = $rootScope.userImageBasePath;
  $scope.checkGRNAccess = checkGRNAccess;
  $scope.checkCancelButton = checkCancelButton;
  $scope.canUpdatePO = canUpdatePO;
  $scope.selectedAction = selectedAction;
  $scope.parseConditions = parseConditions;
  $scope.disableResendPO = disableResendPO;
  $scope.status_mapping =
    {
      'DELIVERY_DATE_UNCONFIRMED': 3,
      'DECLINED': 4,
      'AWAITING_DELIVERY': 5
    };


  function getStatusOptions() {
    $scope.poStatusOptions = [];
    switch ($scope.po.status) {
      case 'DECLINED': {
        $scope.poStatusOptions.push(
        {
          status: 3,
          descr: 'Supplier couldn\'t confirm delivery date'
        },
        {
          status: 5,
          descr: 'Supplier accepted PO'
        })
      }
      break;
      case 'SUBMITTED': {
        $scope.poStatusOptions.push(
        {
          status: 5,
          descr: 'Supplier accepted PO'
        },
        {
          status: 3,
          descr: 'Supplier couldn\'t confirm delivery date'
        },
        {
          status: 4,
          descr: 'Supplier declined PO'
        })
      }
      break;
      case 'DELIVERY_DATE_UNCONFIRMED': {
        $scope.poStatusOptions.push(
        {
          status: 5,
          descr: 'Supplier Accepted PO'
        },
        {
          status: 4,
          descr: 'Supplier Declined PO'
        })
      }
      break;
    }
  }

  $scope.printPO = function() {

    getPOPDFHash.get(
      {
        id: $scope.po._id,
        timezone: $rootScope.currentUser.config.TZ
      }
    ).$promise.then(
      function (resource) {
        var newUrl = $filter('format')(pathConstants.apiUrls.po.pdfHash, {
          pdf_hash: resource.url
        });

        setTimeout(function () {
          window.open(newUrl, '_blank')
        }, 1001);
      },
      function(){
        toastr.error('Failed to print PO');
      }
    );
  };

  $scope.backToListingPO = backToListingPO;
  $scope.starred = starred;
  $scope.scrollTo = scrollTo;
  $scope.scrollToClosedLineItemComment = scrollToClosedLineItemComment;
  $scope.loadContactPersons = loadContactPersons;

  // Check and assign the right status for details page
  $scope.accessStatus = $scope.po.status;
  if(angular.isUndefined($scope.accessStatus) || $scope.accessStatus === null) {
    $scope.accessStatus = $scope.previousState.params.status;
  } else if ($scope.previousState.params.status !== null) {
    if ($scope.previousState.params.status === 'STARRED')
      $scope.accessStatus = $scope.previousState.params.status;
  }

  function selectedAction(item) {

    //check if current status was set
    if(item.status === $scope.status_mapping[$scope.po.status]) {
      toastr.success('The status has been set');
      return;
    }
    /**
     * If statement only for decision 'Decline PO'
     */
    if(item.status === 4) {
      swal(
      {
        title: 'Reason for supplier declined PO?',
        text: 'Please state a reason for supplier declined PO',
        type: 'input',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: false,
        closeOnCancel: true,
        inputType: 'text',
        inputPlaceholder: 'Write a reason'
      },
      function(inputValue) {
        if (!!inputValue) {
          var trimmedValue = inputValue.trim();
        }

        if (!inputValue || trimmedValue === '') {
          swal.showInputError('You need to state a reason for supplier decline PO!');
          return false;
        }

        Orders.setPOStatus(
          {
            id: order._id
          },
          {
            status: item.status,
            comment: inputValue
          },
          function(success) {
            toastr.success('Supplier declined PO');
            swal.close();
            //check if supplier declined the po
            if (item.status === $scope.status_mapping['DECLINED']) {
              HighlightId.setId($scope.po._id);
              $rootScope.$broadcast('loadSpecificTab', {tab: activateTab('declined')});
              return;
            }
          },
          function (error) {
            toastr.error('Failed to submit status due to ' + error.data.message);
          });
      });
    }
    else {
      Orders.setPOStatus(
        {
          id: order._id
        },
        {
          status: item.status
        },
        function (success) {
          /**
           * status 5 for accepting PO
           * setting the status of the PO
           */
          if (item.status === $scope.status_mapping['AWAITING_DELIVERY']) {
            toastr.success('The supplier has accepted the PO');
            $scope.po.status = 'AWAITING_DELIVERY';
            $rootScope.$broadcast('loadSpecificTab', {tab: activateTab('awaiting_delivery'), noTransition: true});
          }

          if (item.status === $scope.status_mapping['DELIVERY_DATE_UNCONFIRMED']) {
            toastr.success('The status has been set');
            $scope.po.status = 'DELIVERY_DATE_UNCONFIRMED';

            //update history
            $rootScope.$broadcast('refreshComments');
            $rootScope.$broadcast('loadSpecificTab', {tab: activateTab('submitted'), noTransition: true});
          }

          getStatusOptions();
          labelStatus();

        },
        function (error) {
          toastr.error('Failed to submit status due to ' + error.data.message);
        });
    }
  }

  function backToListingPO() {
      window.history.back();
      HighlightId.setId($scope.po._id);
  }

  function starred(po) {
    starringPO.update(
      {
        id: po._id,
        action: !!po.is_starred ? 'unstar' : 'star'
      }
    ).
      $promise.then(function (v) {
        //successful
        if (!!po.is_starred) {
          po.is_starred = false;
        }
        else {
          po.is_starred = true;
        }
      },
      function (error) {
        toastr.error(error.message);
      }
    );
  }

  function scrollTo(id) {
    var old_hash = $location.hash();
    $location.hash(id);
    $anchorScroll();
    $location.hash(old_hash);
  }

  function notificationToggle() {

    if(!$scope.po.notify) {
      notificationSubscriber.post({
          object_id: $scope.po._id, class: 'Metabuyer\\Models\\PO', method: 'subscribe'
        }
        , function (data) {
          $scope.po.notify = true;
          toastr.success('Turned on notifications successfully');
        }
        , function (error) {
          toastr.error('Failed to turn on notifications');
        });
    }
    else{
      notificationSubscriber.delete({
          object_id: $scope.po._id, class: 'Metabuyer\\Models\\PO', method: 'unsubscribe'
        }
        , function (data) {
          $scope.po.notify = false;
          toastr.success('Turned off notifications successfully');
        }
        , function (error) {
          toastr.error('Failed to turn off notifications');
        });
    }

  }


  function scrollToClosedLineItemComment(id){
    $rootScope.$broadcast('scrollToClosedLineItemComment', {id: id});
  }

  function loadContactPersons(company) {

    if(!company || !company._id){
      return;
    }
    var defer = $q.defer();

    purchaseRequisitionsServices.getContactPersonsList(
      {
        id: company._id
      }, function (resource) {
        var contactPersons = (typeof resource.content !== 'undefined' &&
                              typeof resource.content.data !== 'undefined') ? resource.content.data : [];
        $scope.options['contact_persons'] = contactPersons;
        defer.resolve(contactPersons);
      }, function (error) {
        defer.reject(error);
      }
    );

    $scope.datalists = defer.promise;
  }

  function checkGRNAccess() {
    return (UserPermissions.checkPermissionsAccess(profile, 'C', 'GRN') ||
      UserPermissions.checkPermissionsAccess(profile, 'U', 'GRN'));
  }

  function canUpdatePO () {
    return (UserPermissions.checkPermissionsAccess(profile, 'U', 'PO'));
  }

  function parseConditions(condition,poStatus) {
    var returnValue = '';
    switch(condition) {
      case 1:
        returnValue = (['DECLINED','SUBMITTED', 'AWAITING_CONFIRMATION','DELIVERY_DATE_UNCONFIRMED'].indexOf(poStatus));
        break;
      case 2:
        returnValue = (['PARTIALLY_DELIVERED', 'AWAITING_DELIVERY','IN_PORT','CLOSED'].indexOf(poStatus));
        break;
      case 3:
        returnValue = (['FULLY_DELIVERED', 'CLOSED','PARTIALLY_DELIVERED'].indexOf(poStatus));
        break;
      case 4:
        returnValue = (['SUBMITTED', 'AWAITING_CONFIRMATION','DELIVERY_DATE_UNCONFIRMED','AWAITING_DELIVERY'].indexOf(poStatus));
        break;
      case 5:
        returnValue = (['PARTIALLY_DELIVERED', 'AWAITING_DELIVERY','IN_PORT'].indexOf(poStatus));
        break;
      case 6:
        returnValue = (['SUBMITTED'].indexOf(poStatus));
        break;
      case 7:
        returnValue = (['DELIVERY_DATE_UNCONFIRMED'].indexOf(poStatus));
        break;
      case 8:
        returnValue = (['DECLINED'].indexOf(poStatus));
        break;
    }
    return returnValue > -1;
  }

  function labelStatus() {
    if(!!$scope.po.status) {
      switch($scope.po.status) {
        case 'CANCELLED':
          $scope.po.generalStatus ='Cancelled';
          $scope.po.specificStatus ='Cancelled';
          break;
        case 'ACCEPTED':
          $scope.po.generalStatus ='Accepted';
          $scope.po.specificStatus ='Accepted';
          break;
        case 'CONFIRMED':
          $scope.po.generalStatus ='Confirmed';
          $scope.po.specificStatus ='Confirmed';
          break;
        case 'CLOSED':
          $scope.po.generalStatus ='Closed';
          $scope.po.specificStatus ='Closed';
          break;
        case 'FULLY_DELIVERED':
          $scope.po.generalStatus ='Delivered';
          $scope.po.specificStatus ='Delivered';
          break;
        case 'DECLINED':
          $scope.po.generalStatus ='Declined';
          $scope.po.specificStatus ='Declined';
          break;
        case 'DELIVERY_DATE_UNCONFIRMED':
          $scope.po.generalStatus ='Submitted';
          $scope.po.specificStatus ='Delivery Date Unconfirmed';
          break;
        case 'SUBMITTED':
          $scope.po.generalStatus ='Submitted';
          $scope.po.specificStatus ='Submitted';
          break;
        case 'AWAITING_CONFIRMATION':
          $scope.po.generalStatus ='Submitted';
          $scope.po.specificStatus ='Awaiting Confirmation';
          break;
        case 'AWAITING_DELIVERY':
          $scope.po.generalStatus ='Awaiting Delivery';
          $scope.po.specificStatus ='Awaiting Delivery';
          break;
        case 'PARTIALLY_DELIVERED':
          $scope.po.generalStatus ='Awaiting Delivery';
          $scope.po.specificStatus ='Partially Delivered ( ' +
            $filter('formatDecimal')($scope.po.received_percentage*100, 2) + '% )';
          break;
        case 'IN_PORT':
          $scope.po.generalStatus ='Awaiting Delivery';
          $scope.po.specificStatus ='Awaiting Delivery';
          break;
      }
    }
  }

  function activateTab(tab){
    var status = tab;
    if(!status)
      status = _.cloneDeep($scope.po.status.toLowerCase());

    //amend the status name to match the keys
    if(status === 'awaiting_confirmation')
      status = 'submitted';
    else if (status === 'partially_delivered')
      status = 'awaiting_delivery';
    else if (status === 'delivered')
      status = 'closed';
    else if (status === 'fully_delivered')
      status = 'closed';
    else if (status === 'delivery_date_unconfirmed')
      status = 'submitted';

    tab = globalFunc.findInArray($scope.$parent.tabData, 'key', status);
    if(!tab)
      tab = globalFunc.findInArray($scope.$parent.tabData.more, 'key', status);

    return !!tab ? tab : $scope.$parent.tabData[0];
  }

  function disableResendPO(){
    var allowableStatus = [
      'SUBMITTED',
      'CONFIRMED',
      'AWAITING_CONFIRMATION',
      'DELIVERY_DATE_UNCONFIRMED',
      'AWAITING_DELIVERY',
      'PARTIALLY_DELIVERED',
      'IN_PORT',
      'FULLY_DELIVERED',
      'CLOSED'
    ];

    return allowableStatus.indexOf($scope.po.status) >= 0;
  }

  function initialize() {

    if($scope.po.status === 'AWAITING_CONFIRMATION')
      $state.params.status = 'SUBMITTED';
    else if ($scope.po.status === 'PARTIALLY_DELIVERED')
      $state.params.status = 'AWAITING_DELIVERY';
    else if ($scope.po.status === 'DELIVERED')
      $state.params.status = 'CLOSED';
    else if ($scope.po.status === 'FULLY_DELIVERED')
      $state.params.status = 'CLOSED';
    else if ($scope.po.status === 'DELIVERY_DATE_UNCONFIRMED')
      $state.params.status = 'SUBMITTED';

    var tabData = {
      tab: activateTab(),
      noTransition: true
    };

    //HACK: as the tabdata controller doesn't load in time and the the tabs will be deleted in the new design,
    //this is a work around to only load it after 300 milisecond
    // TODO: remove this with the new design, Ahmed Saleh (25/9/2017)
    $timeout(function() {
      $rootScope.$broadcast('loadSpecificTab', tabData);
    }, 300);

    $scope.options = {
      contact_persons: []
    };

    loadContactPersons($scope.po.billing.company);
    getStatusOptions();
    labelStatus();

    // Support old format of delivery address in PO
    if (!!$scope.po.delivery.address && !!$scope.po.delivery.address.details && !$scope.po.delivery.address.line1) {
      $scope.po.delivery.address.line1 = $scope.po.delivery.address.details.line1;
      $scope.po.delivery.address.line2 = $scope.po.delivery.address.details.line2;
      $scope.po.delivery.address.line3 = $scope.po.delivery.address.details.line3;
      $scope.po.delivery.address.postal_code = $scope.po.delivery.address.details.postal_code;
      $scope.po.delivery.address.city = $scope.po.delivery.address.details.city;
      $scope.po.delivery.address.state = $scope.po.delivery.address.details.state;
      $scope.po.delivery.address.country = $scope.po.delivery.address.details.country;
    }

    //clean up old notes structure
    if(!!$scope.po.notes && _.isArray($scope.po.notes)){
      $scope.po.notes = $scope.po.notes[0];
    }
  }

  /**
   * check the creator or requestor to cancel
   * @returns {boolean}
   */
  function checkCancelButton() {
    if (!$scope.po.creator) {
      return false;
    }

    if ($scope.po.creator._id !== $rootScope.currentUser._id) {
      if (!$scope.po.requestor || $scope.po.requestor._id !== $rootScope.currentUser._id) {
        return false;
      }
    }
    return true;
  }

  initialize();
}

OrdersDetailCtrl.$inject = ['$scope', '$q', 'globalFunc', '$state', '$location', '$anchorScroll',
  'order', 'pathConstants', 'Orders', 'profile', 'starringPO', '$rootScope',
  'toastr', 'purchaseRequisitionsServices', 'HighlightId', 'POSubscriptionCheck', 'getPOPDFHash',
  '$filter', 'notificationSubscriber', 'POComments', 'UserPermissions', '$timeout'];

angular.module('metabuyer')
  .controller('OrdersDetailCtrl', OrdersDetailCtrl);

'use strict';

function ItemsManageCtrl($scope, $state, $q, $stateParams, toastr, items, deleteItems, action,
                         globalFunc, $rootScope, HighlightId, $window, $filter) {

  $scope.showColumn              = showColumn;
  $scope.getImportStatusName     = getImportStatusName;
  $scope.checkWaitingOnUser      = checkWaitingOnUser;
  $scope.getSelectedItems        = getSelectedItems;
  $scope.viewCatalog             = viewCatalog;
  $scope.multiSelectPendingItems = multiSelectPendingItems;

  $scope.storageKey = 'catalog-management-selected-columns';

  function showColumn(id) {
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if (!!$scope.columns[i].conditional) {
          if ($scope.status === $scope.columns[i].condition) {
            return $scope.columns[i].selected;
          }
          if ($scope.columns[i].condition instanceof Array) {
            for (var j in $scope.columns[i].condition) {
              if ($scope.status === $scope.columns[i].condition[j]) {
                return $scope.columns[i].selected;
              }
            }
          }
        } else {
          return $scope.columns[i].selected;
        }
      }
    }
  }


  /**
   *  auto select/deselect the items for approval action
   * @param status
   */
  function multiSelectPendingItems (status) {
    _.forEach($scope.items, function (item) {
      if (checkWaitingOnUser(item)) {
        item.selected = status;
      }
    });
  }


  /**
   * returns the status name
   * @param status
   * @returns {*}
   */
  function getImportStatusName(status) {
    /**
     Compose = 0
     Pending = 1
     Approved = 2
     Deleted = 3
     Expired = 4
     Rejected = 5
     Active = 6
     Deactivated = 7
     Error = 8
     */
    if (status === 0) {
      return 'Compose'
    }
    if (status === 1) {
      return 'Pending'
    }
    if (status === 2) {
      return 'Approved'
    }
    if (status === 3) {
      return 'Deleted'
    }
    if (status === 4) {
      return 'Expired'
    }
    if (status === 5) {
      return 'Rejected'
    }
    if (status === 6) {
      return 'Active'
    }
    if (status === 7) {
      return 'Inactive'
    }
    if (status === 8) {
      return 'Error'
    }
    return 'N/A';
  }

  /**
   * return if the user is part of the waiting on, for a specific Supplier
   * @param item
   * @returns {*}
   */
  function checkWaitingOnUser(item) {
    return globalFunc.findInArray(item.waiting_on, '_id', $rootScope.currentUser._id);
  }

  /**
   * returns store the selected Suppliers
   * @returns {Array}
   */
  function getSelectedItems() {
    var selectedItems = [];
    _.forEach($scope.items, function (item) {
      if (!!item.selected) {
        selectedItems.push(item);
      }
    });
    return selectedItems;
  }


  function viewCatalog(catalog){
    /**
     * If import status is 8/ error, redirect to select file for import and pass catalog object
     */
    if(catalog.import_status === 8){
      $state.go('main.user.items.import.select_file',
        {
          importID : catalog._id,
          catalogGroupID : catalog.catalog_group[0]._id,
          supplierID : catalog.supplier[0]._id,
          catalogCodeID : catalog.catalog_code[0]._id
        });
    }
    else{
      $state.go('main.user.items.detail', ({id: catalog._id}));
    }
  }

  // Put everything here to run it on first load
  function initialize() {

    $scope.status = $stateParams.status;
    $scope.$parent.status = $stateParams.status;
    $scope.title = $stateParams.title;
    $scope.items = items.data;
    $scope.meta = items.meta;
    $scope.itemManageService = items;

    $scope.actionType = action;
    if($stateParams.type === 'date'){
      var ms = Number($stateParams.query[1]*1000);
      $scope.title = $filter('date')(new Date(ms), 'dd MMM yyyy');
    }
    else{
      $scope.title = $stateParams.query;
    }

    //TODO: remove this once the states Search and Manage are combined (Ahmed Saleh, 4/10/2016)
    $rootScope.$broadcast('activateTab', $scope.$parent.tabData[0]);

    if (!!HighlightId.getId() && HighlightId.getId() != undefined && HighlightId.getId().length) {

      $scope.highlightId = HighlightId.getId();

      if ($scope.highlightId != null && $scope.highlightId != undefined) {

        //scroll the window to top
        $window.scroll(0, 0);
      }

      //clear current id
      HighlightId.setId(null);
    }
  }

  // Run initialize function
  initialize();

}

ItemsManageCtrl.$inject = ['$scope', '$state', '$q', '$stateParams', 'toastr', 'items',
                           'deleteItems', 'action', 'globalFunc', '$rootScope', 'HighlightId',
                           '$window', '$filter'];

angular.module('metabuyer')
  .controller('ItemsManageCtrl', ItemsManageCtrl);

'use strict';


function importItemsCtrl(
  $scope, toastr, pathConstants, $http, $filter, $q, changeStatusCatalog, BUs, searchSupplier, $state, Approvals,
  checkImport, itemDetailsListing, getCatalogCodeListing, $timeout, searchModule, globalFunc, singleSupplier, catalogCode
) {

  $scope.disableSubmitting = true;
  $scope.success = false;
  $scope.error = false;
  $scope.saveImage = saveImage;
  $scope.saveFile = saveFile;
  $scope.checkImportFile = checkImportFile;
  $scope.importingItems = importingItems;
  $scope.getItemListing = getItemListing;
  $scope.selectCatalogGroup = selectCatalogGroup;
  $scope.selectSupplier = selectSupplier;
  $scope.getCatalogCodeList = getCatalogCodeList;
  $scope.backToSelectSupplier = backToSelectSupplier;
  $scope.onSelectedCatalogCode = onSelectedCatalogCode;
  $scope.openDatePicker = openDatePicker;
  $scope.setEffectiveDate = setEffectiveDate;
  $scope.search = search;
  $scope.approvals = [];
  $scope.limit = 10;

  $scope.dateOptions = {
    formatYear: 'yy',
    minDate: new Date(),
    startingDay: 1
  };
  $scope.datepickerOpened = {
    startDate: false
  };

  $scope.catalogCodeSelected = false;

  // Add select All
  $scope.BUs = BUs.data;

  //TODO: remove this to a service of its own (Ahmed Saleh, 9/5/2016)
  $scope.column = {
    columns: [
      {id: 'item_name', label: 'Item Name'},
      {id: 'supplier_part_no', label: 'Supplier Part Number'},
      {id: 'tax_rate', label: 'Tax Rate'},
      {id: 'payment_terms', label: 'Payment Term'},
      {id: 'currency', label: 'Currency'},
      {id: 'unit_price', label: 'Unit Price'},
      {id: 'uom', label: 'UOM'},
      {id: 'effective_at', label: 'Effective Date'},
      {id: 'expiry_at', label: 'Expiry Date'}
    ],
    selectedColumns: [],
    buttonText: {buttonDefaultText: 'Columns'},
    setting: {
      buttonClasses: 'btn btn-white',
      smartButtonMaxItems: 3,
      showCheckAll: false,
      showUncheckAll: false
    },
    events: {
      onItemSelect: function (item) {
        $scope.column.saveSelectedColumn($scope.column.selectedColumns);
      },
      onItemDeselect: function (item) {
        $scope.column.saveSelectedColumn($scope.column.selectedColumns);
      }
    },
    showColumn: function (name) {
      for (var index = 0; index < $scope.column.selectedColumns.length; ++index) {
        var item = $scope.column.selectedColumns[index];
        if (item.id == name) {
          return true;
        }
      }
      return false
    },
    saveSelectedColumn: function (columns) {
      window.localStorage.setItem('item-listing-selected-columns',
        JSON.stringify(_.map(columns, function (item) {
          return item.id || item
        })));
    },
    loadSelectedColumn: function () {
      return JSON.parse(window.localStorage.getItem('item-listing-selected-columns')) || [];
    }
  };
  // Apply selected column
  var selectedColumn = $scope.column.loadSelectedColumn();
  if (selectedColumn.length == 0) { // Default column
    for (var index = 0; index < $scope.column.columns.length; ++index) {
      $scope.column.selectedColumns.push($scope.column.columns[index]);
    }
  }
  else {
    for (index = 0; index < selectedColumn.length; ++index) {
      var column = _.find($scope.column.columns, function (item) {
        return item.id == selectedColumn[index];
      });
      if (!!column)
        $scope.column.selectedColumns.push(column);
    }
  }

  var valid = function () {
    if (!$scope.selectedSupplier) {
      toastr.error('Please Choose a Supplier');
      return false;
    }
    if (!$scope.selectedCatalogGroup || (!!$scope.selectedCatalogGroup && !$scope.selectedCatalogGroup._id)) {
      toastr.error('Please Choose a Catalog Group');
      return false
    }
    return true;
  };

  $scope.cancelCatalog = function()
  {
    changeStatusCatalog.put(
      {
        status: 'cancel',
        id: $scope.importId
      },
      function(resource)
      {
        $state.go('main.user.items.import.select_file');
        toastr.error('Catalog successfully cancelled');
      },
      function(error)      {
        toastr.error('Cancelling the catalog failed');
      }
    );

  };

  $scope.submitCatalog = function()
  {
    if(!$scope.importId){
      toastr.error('Please reupload the catalog!');
    }
    else{
      changeStatusCatalog.put(
        {
          status: 'submit',
          id: $scope.importId
        },
        function (resource) {
          $state.go('main.user.items.manageCatalog', {'status': 'pending'});
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
  };

  function search(text) {

      // Search only the active supplier
      var params = {
        module: 'suppliers',
        'criteria[descr]': text,
        'criteria[archive_of]': '',
        'criteria[draft_status]': 3,
        'criteria[status]': 1,
        criteria_operator: 'and',
        'criteria[approval_status]': 1
      };

      searchModule.get(
        params,
        function (resource) {
          $scope.searchResult = 0;
          if(resource.content.data.length > 0){
            $scope.suppliersResults = resource.content.data;
            $scope.searchResult = resource.content.data.length;
          }
        },
        function (error) {
            globalFunc.objectErrorMessage(error);
        }
      );
  }

  /**
   *  Function to call endpoint to list item details based on status
   *  @params status: 10 New, 11 Updated, 12 Deleted, 13 Total
   */

  function getItemListing(status) {
    $scope.showItemDetails = true;
    $scope.itemDetailsStatus = status;

    itemDetailsListing.get(
      {
        summary_id: $scope.data._id,
        status: status
      },
      function (resource) {
        if(!!resource && !!resource.content && !!resource.content.data) {
          $scope.itemDetailService = itemDetailsListing;
          $scope.itemDetailsList = resource.content.data;
          $scope.itemDetailsMeta = resource.content.meta;
          $scope.itemDetailsLoaded = true;
          switch (status) {
            case 10:
              $scope.itemDetailTitle = 'New Item(s)';
              break;
            case 11:
              $scope.itemDetailTitle = 'Updated Item(s)';
              break;
            case 12:
              $scope.itemDetailTitle = 'Deleted Item(s)';
              break;
            case 13:
              $scope.itemDetailTitle = 'Total Items';
              break;
          }
          $scope.embeddedParams = {
            id: $scope.data.id,
            offset: 10
          };
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  function selectCatalogGroup(catalogGroupID){
    $scope.selectedCatalogGroup = globalFunc.findInArray($scope.BUs, '_id', catalogGroupID);
  }

  function backToSelectSupplier(){
    $scope.catalogCodeSelected = false;
    $scope.newCatalogCodeSelected = false;
    if(!!$state.params){
      window.history.back();
    }
    else{
      $state.go('main.user.items.import.select_supplier');
    }
  }

  function getCatalogCodeList(){
    searchModule.get(
      {
        module: 'catalog-code',
        offset: 0,
        'criteria[is_active]': 1
      },
      function(resource){
        $scope.catalogCodeList = resource.content.data;
      },
      function(error){
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function onSelectedCatalogCode(selectedCatCode){
    $scope.selectedCatalogCode = selectedCatCode;
    $scope.catalogCodeSelected = true;
    $scope.newCatalogCodeSelected = false;
  }

  function openDatePicker($event, which) {
    $event.preventDefault();
    $event.stopPropagation();

    $scope.datepickerOpened[which] = true;
  }

  function setEffectiveDate(effective_at){
    $scope.importEffectiveDate = globalFunc.convertDateToTimestamp(effective_at);
  }

  /**
   *  Receive broadcast for updated embedded pagination data to update on controller side
   */
  $scope.$on('updateEmbeddedPagination', function(events, content){
    if(!!content && !!content.data)
    $scope.itemDetailsList = content.data;
  });

  function selectSupplier(supplier) {
    $scope.selectedSupplier = supplier;
  }


  // Check Radio button has a value or not.
  $scope.isRadioSelected = function(index) {
    return index === 1;
  };

  // Import and save CSV file
  function saveFile(items, images, effective_date, catalog_code_id) {

    var fd = new FormData();
    fd.append('file', items);
    fd.append('supplier_id', $scope.selectedSupplier._id);
    fd.append('catalog_group_id', $scope.selectedCatalogGroup._id);
    fd.append('catalog_code_id', catalog_code_id);
    fd.append('import_effective_date', effective_date);
    if(!!$scope.errorImportID){
      fd.append('import_summary_id', $scope.errorImportID);
    }

    $http.post($filter('format')(pathConstants.apiUrls.items.import), fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    })
      .then(function onSuccess (dataCatalog, status) {
        $scope.success = true;
        $scope.error = false;
        $scope.status = status;

        //prepare the success Message
        var data = dataCatalog.data;
        $scope.message = {};
        if (!!data && !!data.content) {
          $scope.data = data.content.data;
          $scope.message.header = $scope.data.file_header;
          $scope.message.version = $scope.data.import_version;
          $scope.message.importInfo = $scope.data.import_info;
          $scope.importId = $scope.data._id;
          getItemListing(13);

          if($scope.data.attachment.length === 0) {
            toastr.error('Failed to upload file.');
          } else {
            $scope.importSummaryId = $scope.data.attachment[0].import_summary_id;

            toastr.success('File successfully uploaded');
            $scope.disableSubmitting = false;

            // Check image empty or not
            // If empty, redirected to next step
            if(!!images) {
              $scope.saveImage(images, $scope.importSummaryId);
            }else{
              $state.go('main.user.items.import.confirmation');
              //checkConfirmationPage();
            }

            // Run loadApprovalFlow function
            loadApprovalFlow($scope.data.approval_id);
            $scope.requestor = {
              '_id': '',
              'display_name': $scope.data.created_by,
              'img_url':''
            };
          }

        } else {
          // No data received
          toastr.error('Failed to upload file.');
        }

      }, function onError (errorMessage) {

        $scope.success = false;
        $scope.error = true;
        $scope.data = null;

        if (!!errorMessage.data) {
          $scope.errorMessageType = '';

          /**
           * If error is a MBSecurityException, then display this error instead
           */
          var errorContent = [];
          var temp;
          //securityError
            if (!!errorMessage.data.error && !!errorMessage.data.error.type &&
                !!errorMessage.data.error.type.indexOf('MBSecurityException') > -1) {
                temp = {
                    key: 'error',
                    value: errorMessage.data.error.message
                };
                errorContent.push(temp);
                $scope.message = errorContent;
            }
            //wrongTemplateMessage
            else if (!!errorMessage.data.content && !!errorMessage.data.content.error &&
                (typeof errorMessage.data.content.error.error === 'string')) {
                temp = {
                    key: 'error',
                    value: errorMessage.data.content.error.error
                };
                errorContent.push(temp);
                $scope.message = errorContent;
            }
            //wrongFileType
            else if (!!errorMessage.data.content && !!errorMessage.data.content.error &&
                (typeof errorMessage.data.content.error === 'string')) {
                temp = {
                    key: 'error',
                    value: errorMessage.data.content.error
                };
                errorContent.push(temp);
                $scope.message = errorContent;
            }
            //normalError object
            else if (!!errorMessage.data.content && !!errorMessage.data.content.error && !!errorMessage.data.content.error.error &&
                (typeof errorMessage.data.content.error.error === 'object') && (typeof errorMessage.data.content.error.error.content === 'object')) {
                errorContent = errorMessage.data.content.error.error.content;
                errorContent = globalFunc.reformatFromObjectToArray(errorContent);
                _.forEach(errorContent, function (n) {
                    n.value = n.value[0];
                });
                $scope.message = errorContent;
            }
            //normalError
            else if (!!errorMessage.data.content && !!errorMessage.data.content.error && !!errorMessage.data.content.error.error &&
                (Array.isArray(errorMessage.data.content.error.error.data))) {
                var errorData = errorMessage.data.content.error.error.data;
                var count = 1;
                _.forEach(errorData, function (n) {
                    temp = {
                        key: 'error'.count,
                        value: n
                    };
                    errorContent.push(temp);
                    count++;
                });
                $scope.message = errorContent;
            }
            //UI form error
            else if (typeof errorMessage.data.content.error === 'object') {
                errorContent = errorMessage.data.content.error;
                errorContent = globalFunc.reformatFromObjectToArray(errorContent);
                _.forEach(errorContent, function (n) {
                    n.value = n.value[0];
                });
                $scope.message = errorContent;
            }

            $scope.disableSubmitting = true;
      }
      });
  }

  // Import and save Image file
  function saveImage(images, summaryId) {
    if(!!images) {
      var fd = new FormData();
      fd.append('file', images);
      $http.post($filter('format')(pathConstants.apiUrls.items.imagesImport + summaryId), fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .then(function onSuccess () {
          toastr.success('Images successfully uploaded');
          $state.go('main.user.items.import.confirmation');
          //checkConfirmationPage();
        })
        .catch(function onError () {
          toastr.error('Failed to submit the Images');
        });
    }
  }

  // Action to save Import file
  function importingItems(items, images, effective_date, catalog_code_id) {
    $scope.error = null;
    $scope.status = null;

    //uploading the CSV file
    if(valid())
      saveFile(items, images, effective_date, catalog_code_id);
  }

  // Approval Flow Data
  function loadApprovalFlow(approvalId){

    var deferred = $q.defer();

    if(!approvalId){
      $scope.approvals = [];
      deferred.resolve([]);
      return deferred.promise;
    }

    Approvals.get(
      {
        id: approvalId
      },
      function(resource){
        if(!!resource && !!resource.content && !!resource.content.data &&
          !!resource.content.data.flow){
          $scope.approvals = resource.content.data.flow;
          deferred.resolve(resource.content.data.flow);
        } else {
          $scope.approvals = [];
          deferred.resolve([]);
        }
      },
      function (error){
        $scope.approvals = [];
        deferred.resolve([]);
      });

    return deferred.promise;
  }

  // Check the same Import file
  // that not approved yet
  function checkImportFile(item, images){
    var catalog_code_id;

    if(!!$scope.catalogCodeSelected)
      catalog_code_id = $scope.selectedCatalogCode._id;

    if(valid()) {
      checkImport.get(
        {
          supplier_id: $scope.selectedSupplier._id,
          BU: $scope.selectedCatalogGroup._id,
          catalog_code_id: catalog_code_id
        },
        function (resource) {
          // Check the message
          // If empty
          if (!!resource.content  && !!resource.content.message) {
            // Show the message in alert Confirmation
            // if the user choose ok then continue to import file
            // if the user choose cancel redirect to catalog list
            swal(
              {
                title: 'Import alert!',
                text: resource.content.message,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true,
                closeOnCancel: true
              },
              function (is_confirm) {
                if (is_confirm) {
                  importingItems(item, images, $scope.importEffectiveDate, catalog_code_id);
                } else {
                  $state.go('main.user.items.manageCatalog', {'status': 'pending'});
                }
              }
            );
          }
          else{
            importingItems(item, images, $scope.importEffectiveDate, catalog_code_id);
          }
        },
        function (error) {
          //failed to load
          toastr.error('Failed to check the import file');
        }
      );
    }
  }

  function initialize(){
    if(!!$state.params.importID && !!$state.params.catalogGroupID &&
      !!$state.params.supplierID && !!$state.params.catalogCodeID){
      $scope.errorImportID = $state.params.importID;
      selectCatalogGroup($state.params.catalogGroupID);
      singleSupplier.get(
        {
          id:$state.params.supplierID
        },
        function(resource){
          if(!!resource && !!resource.content && !!resource.content.data){
            selectSupplier(resource.content.data);
          }
          else{
            toastr.error('Invalid supplier');
            window.history.back();
          }
        },
        function(error){
          globalFunc.objectErrorMessage(error);
        }
      );
      catalogCode.get(
        {
          id: $state.params.catalogCodeID
        },
        function(resource){
          if(!!resource && !!resource.content && !!resource.content.data){
            onSelectedCatalogCode(resource.content.data);
          }
          else{
            toastr.error('Invalid catalog code');
            window.history.back();
          }
        },
        function(error){
          globalFunc.objectErrorMessage(error);
        }
      );
    }
    else{
      $scope.errorImportID = undefined;
      $scope.selectedCatalogGroup = undefined;
      $scope.selectedSupplier = undefined;
      $scope.selectedCatalogCode = undefined;
    }
  }

  initialize();
}

importItemsCtrl.$inject = [
  '$scope', 'toastr', 'pathConstants', '$http', '$filter', '$q', 'changeStatusCatalog', 'BUs', 'searchSupplier',
  '$state', 'Approvals', 'checkImport', 'itemDetailsListing', 'getCatalogCodeListing', '$timeout', 'searchModule',
  'globalFunc', 'singleSupplier', 'catalogCode'
];

angular.module('metabuyer')
  .controller('importItemsCtrl', importItemsCtrl);

'use strict';

function itemDetailCtrl($scope, toastr, managedItem, $q, $stateParams, $state, catalogVersion,
                        downloadFile, $filter, pathConstants, $http, $uibModal, changeStatusCatalog,
                        Approvals, profile, items, manageItemDetail,
                        HighlightId, itemDetailsListing, $rootScope, searchModule, globalFunc) {

  $scope.approvals = [];
  $scope.approvalFlowData = {};
  $scope.rejector = {};
  $scope.waiting_on_user = [];
  $scope.checkWaitingOn = checkWaitingOn;
  $scope.approveItem = approveItem;
  $scope.rejectItem = rejectItem;
  $scope.changeStatus = changeStatus;
  $scope.viewHistoryDetails = viewHistoryDetails;
  $scope.getItemListing = getItemListing;
  $scope.viewSingleItemDetails = viewSingleItemDetails;
  $scope.downloadImportCatalogCSV = downloadImportCatalogCSV;
  $scope.downloadImageFileZip = downloadImageFileZip;
  $scope.getImportCatalogCSVTitle = getImportCatalogCSVTitle;
  $scope.uploadImageFileModal = uploadImageFileModal;
  $scope.back = back;
  $scope.showColumn = showColumn;

  // Get Items Detail
  $scope.itemDetail = managedItem.data;
  $scope.status = $scope.itemDetail.import_status;
  $scope.requestor = {
    "_id": "",
    "display_name": $scope.itemDetail.created_by,
    "img_url": ""
  };

  $scope.columns = [
    {id: 'item_name', label: 'Item Name'},
    {id: 'description', label: 'Description'},
    {id: 'supplier.descr', label: 'Supplier'},
    {id: 'supplier_part_no', label: 'Supplier Part Number'},
    {id: 'tax.rate', label: 'Tax Rate'},
    {id: 'payment_term.descr', label: 'Payment Term'},
    {id: 'currency.code', label: 'Currency'},
    {id: 'unit_price', label: 'Unit Price'},
    {id: 'Uom.code', label: 'UOM'},
    {id: 'effective_at', label: 'Effective Date', type: 'date'},
    {id: 'expiry_at', label: 'Expiry Date', type: 'date'}
  ];
  $scope.storageKey = 'item-details-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function back() {

    var data = $scope.$parent.tabData;
    var statusPendingApproval = $scope.status;

    if($scope.status === 'PENDING'){
      statusPendingApproval = 'Pending Approval';
    }else if ($scope.status === 'DEACTIVATED'){
      statusPendingApproval = 'Inactive';
    }
    var tabData = globalFunc.findInArray(data[0].menu, 'heading', statusPendingApproval, true);

    if (!!$scope.itemDetail && !!$scope.itemDetail._id) {
      HighlightId.setId($scope.itemDetail._id);
    }
    $rootScope.$broadcast('loadSpecificTab', {tab: tabData});
  }

  // Import History
  // Get from another endpoint
  function getItemsVersion() {

    catalogVersion.get(
      {
        summary_id: managedItem.data._id
      },
      function (resource) {
        $scope.dataHistory = resource.content.data;
      },
      function (error) {

      }
    );
  }

  // Run the getItemsVersion function
  getItemsVersion();

  /**
   * Function to download the imported catalog csv
   * @param attachmentArray
   */
  function downloadImportCatalogCSV (attachmentArray) {
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'csv'){
        downloadFile.download({
          summary_id: attachment.import_summary_id,
          attachment_id: attachment._id
        }).$promise.then(
          function (resource) {
            var newUrl = $filter('format')(pathConstants.apiUrls.items.download, {
              summary_id: attachment.import_summary_id,
              attachment_id: attachment._id
            });
            window.open(newUrl, '_self');
            // Set a return here to break the forEach loop
            return true;
          }, function (error) {
            globalFunc.objectErrorMessage(error);
            // Set a return here to break the forEach loop
            return true;
          });
      }
    });
  }

  /**
   * Function to download the uploaded image file
   *
   * @param attachmentArray
   */
  function downloadImageFileZip (attachmentArray) {
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'zip'){
        downloadFile.download({
          summary_id: attachment.import_summary_id,
          attachment_id: attachment._id
        }).$promise.then(
          function (resource) {
            var newUrl = $filter('format')(pathConstants.apiUrls.items.download, {
              summary_id: attachment.import_summary_id,
              attachment_id: attachment._id
            });
            window.open(newUrl, '_self');
            // Set a return here to break the forEach loop
            return true;
          }, function (error) {
            globalFunc.objectErrorMessage(error);
            // Set a return here to break the forEach loop
            return true;
          });
      }
    });
  }

  /**
   * Function to get the import catalog title
   * @param attachmentArray
   * @returns {string}
   */
  function getImportCatalogCSVTitle(attachmentArray) {
    var title = '';
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'csv') {
        title = attachment.title;
        // Set a return here to break the forEach loop
        return true;
      }
    });
    return title;
  }

  /**
   * Function to upload the image file
   * @param summaryId
   */
  function uploadImageFileModal (summaryId) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/importImage.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        dataSummaryId: function () {
          return summaryId;
        }
      },
      controller: function (dataSummaryId, $scope, $uibModalInstance) {
        $scope.summaryId = angular.copy(dataSummaryId);
        $scope.cancel = cancel;
        $scope.importImage = importImage;

        function cancel () {
          $uibModalInstance.close();
        }

        // Save import image
        function importImage (images, summaryId) {
          if (!!images) {
            var fd = new FormData();
            fd.append('file', images);
            $http.post($filter('format')(pathConstants.apiUrls.items.imagesImport + summaryId), fd,
              {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
              })
              .then(function onSuccess () {
                toastr.success('Images successfully uploaded');
                getItemsVersion();
                $uibModalInstance.close();
              })
              .catch(function onError (error) {
                globalFunc.objectErrorMessage(error);
              });
          } else {
            toastr.error('No file chosen');
          }
        }
      }
    });
  }

  function viewHistoryDetails(summaryId, dataHistory, itemDetail, status){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/historyDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        dataSummaryId: function () {
          return summaryId;
        },
        dataHistory: function() {
          return dataHistory;
        },
        itemDetail: function() {
          return itemDetail;
        },
        status: function() {
          return status;
        }
      },
      controller: function (dataSummaryId, $scope, $uibModalInstance,
                            viewHistoryDetails, dataHistory, itemDetail, status) {
        $scope.submitCatalog = submitCatalog;
        $scope.dataHistory = dataHistory;
        $scope.itemDetail = itemDetail;
        $scope.status = status;

        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        function submitCatalog(){
          changeStatusCatalog.put(
            {
              status: 'submit',
              id: dataSummaryId
            },
            function (resource) {
              toastr.success('Catalog submitted');
              $uibModalInstance.close();
              for(var i = 0; i < $scope.dataHistory.length; i++){
                if($scope.dataHistory[i]._id === resource.content.data._id){
                  $scope.dataHistory[i].import_status = resource.content.data.import_status;
                }
                if($scope.dataHistory[i]._id === $scope.itemDetail._id){
                  $scope.status = resource.content.data.import_status;
                }
              }
            },
            function (error) {
              toastr.error('Catalog submit failed');
            }
          );
        }

        viewHistoryDetails.get(
          {
            summary_id: dataSummaryId
          },
          function(resource){
            $scope.itemHistory = resource.content.data;
          },
          function(){
            toastr.error('Unable to view history detail');
          }
        )
      }
    });
  }

  /**
   *  Function to call endpoint to list item details based on status
   *  @params status: 10 New, 11 Updated, 12 Deleted, 13 Total
   */

  function getItemListing(status) {

    $scope.showItemDetails = true;
    $scope.itemDetailsStatus = status;
    /**
     * If selected status is not get total items listing
     */
    if(status !== 13){
      searchModule.get(
        {
          module: 'catalog-details',
          offset: 20,
          'criteria[import_summary_id]': $scope.itemDetail._id,
          'criteria[data_status]': status,
          criteria_operator: 'and'
        },
        function (resource) {
          $scope.itemDetailService = searchModule;
          $scope.embeddedParams = {
            module: 'catalog-details',
            offset: 20,
            'criteria[import_summary_id]': $scope.itemDetail._id,
            'criteria[data_status]': status,
            criteria_operator: 'and'
          };
          $scope.itemDetailsList = resource.content.data;
          $scope.itemDetailsMeta = resource.content.meta;
          $scope.itemDetailsLoaded = true;
          switch (status) {
            case 10:
              $scope.itemDetailTitle = 'New/Latest';
              break;
            case 11:
              $scope.itemDetailTitle = 'Updated';
              break;
            case 12:
              $scope.itemDetailTitle = 'Deleted';
              break;
            case 13:
              $scope.itemDetailTitle = 'Total';
              break;
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
    /**
     * If selected status is get total items listing
     */
    else{
      searchModule.get(
        {
          module: 'catalog-details',
          offset: 20,
          'criteria[import_summary_id]': $scope.itemDetail._id,
          'criteria[data_status][0]': 10,
          'criteria[data_status][1]': 11,
          'criteria[data_status][2]': 14,
          criteria_operator: 'and'
        },
        function (resource) {
          $scope.itemDetailService = searchModule;
          $scope.embeddedParams = {
            module: 'catalog-details',
            offset: 20,
            'criteria[import_summary_id]': $scope.itemDetail._id,
            'criteria[data_status][0]': 10,
            'criteria[data_status][1]': 11,
            'criteria[data_status][2]': 14,
            criteria_operator: 'and'
          };
          $scope.itemDetailsList = resource.content.data;
          $scope.itemDetailsMeta = resource.content.meta;
          $scope.itemDetailsLoaded = true;
          switch (status) {
            case 10:
              $scope.itemDetailTitle = 'New/Latest';
              break;
            case 11:
              $scope.itemDetailTitle = 'Updated';
              break;
            case 12:
              $scope.itemDetailTitle = 'Deleted';
              break;
            case 13:
              $scope.itemDetailTitle = 'Total';
              break;
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
  }

  /**
   *  Receive broadcast for updated embedded pagination data to update on controller side
   */
  $scope.$on('updateEmbeddedPagination', function(events, content){
    if(!!content && !!content.data)
    $scope.itemDetailsList = content.data;
  });

  function viewSingleItemDetails(data){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/singleItemDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        data: function(){
          return data;
        }
      },
      controller: function ($scope, $uibModalInstance, data, singleItemDetails) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        singleItemDetails.get(
          {
            summary_id: data.import_summary_id,
            import_item_id: data._id
          },
          function(resource){
            $scope.singleItemDetail = resource.content.data;
          },
          function(){
            toastr.error('Unable to view item detail');
          }
        )
      }
    });
  }

  // Change Status of the catalog
  function changeStatus(status, summaryId) {
    changeStatusCatalog.put(
      {
        status: status,
        id: summaryId
      },
      function () {
        toastr.success('Successfully changed status of catalog');
        HighlightId.setId(summaryId);
        if(status === 'activate' || status === 'deactivate' || status === 'submit' || status === 'cancel')
          $state.go('main.user.items.manageCatalog', {
            'status'    : 'pending',
            'order_by'  : 'updated_at',
            'order'     : 0
          });
        else
          $state.go('main.user.items.manageCatalog', {'status': status});
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  // Approval Flow Data
  function loadApprovalFlow() {

    if (!$scope.itemDetail || !$scope.itemDetail.approval_id) {
      $scope.approvals = [];
    }

    Approvals.get(
      {
        id: $scope.itemDetail.approval_id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.approvals = resource.content.data;
          $scope.requestor.display_name = resource.content.data.requested_by.display_name;
          if ($scope.status.toLowerCase() === 'pending') {
            $scope.approvalFlowData = resource.content.data;
            globalFunc.getWaitingOnUser(resource.content.data, $scope.waiting_on_user);
          }
          else if($scope.status.toLowerCase() === 'rejected'){
            for(var i in $scope.approvals){
              if(!!$scope.approvals[i].step_status && $scope.approvals[i].step_status.toLowerCase() === 'rejected'){
                $scope.rejector = $scope.approvals[i].rejectedRoles[0];
              }
            }
          }
        } else {
          $scope.approvals = [];
        }
      },
      function () {
        $scope.approvals = [];
      });
  }

  // If the import status is pending approved
  // Run loadApprovalFlow function
  if ($scope.status.toLowerCase()=== 'pending' || $scope.status.toLowerCase()=== 'rejected') {
    loadApprovalFlow();
  }

  //check user waiting on
  function checkWaitingOn() {
    var find_user = _.find($scope.waiting_on_user, function (approver) {
      return (approver._id == profile._id);
    });

    if (find_user != undefined) {
      return true;
    }

    return false;
  }

  // Approve Item
  function approveItem() {
    items.approve(
      {
        approval_id: $scope.itemDetail.approval_id,
        status: 'approve'
      },
      {},
      function () {
        toastr.success('You have approved this catalog.');

        // Get the item details
        // and check the new status
        manageItemDetail.get({id: $scope.itemDetail._id},
          function (resource) {
            if (!!resource && !!resource.content && !!resource.content.data &&
                !!resource.content.data.import_status) {

              var importStatus = resource.content.data.import_status;
              //Store item Import id to fadeout on approved table
              HighlightId.setId($scope.itemDetail._id);
              $state.go('main.user.items.manageCatalog', { status: importStatus.toLowerCase() });
            } else {
              $state.go('main.user.items.manageCatalog', {status: 'pending'});
            }
          },
          function () {
            //Store catalog id to fadeout on pending table
            HighlightId.setId($scope.itemDetail._id);
            $state.go('main.user.items.manageCatalog', {status: 'pending'});
          }
        );

      }, function () {
        toastr.error('Catalog cannot be approved.');
      }
    );
  }

  // Reject Item
  function rejectItem() {
    swal({
        title: 'Confirm reject item?',
        text: 'This item will be rejected by you. Please write a reason',
        type: 'input',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: false,
        closeOnCancel: true,
        inputType: 'text',
        inputPlaceholder: 'Write a reason'
      },
      function(inputValue) {
        if(!!inputValue){
          var trimmedValue = inputValue.trim();
        }

        if (!inputValue) {
          swal.showInputError('You need to write a reason for rejecting!');
          return false;
        }

        if(trimmedValue === '') {
          swal.showInputError('You need to write a reason for rejecting!');
          return false
        }
        items.approve(
          {
            approval_id: $scope.itemDetail.approval_id,
            status: 'reject'
          },
          {
            comment: inputValue
          },
          function () {
            toastr.success('Rejected catalog');

            // Get the item details
            // and check the new status
            manageItemDetail.get({id: $scope.itemDetail._id},
              function (resource) {
                swal.close();
                if (!!resource && !!resource.content && !!resource.content.data &&
                  !!resource.content.data.import_status) {

                  //Store Item Import id to fadeout on approved table
                  HighlightId.setId($scope.itemDetail._id);

                  if (resource.content.data.import_status === 'APPROVED') {
                    $state.go('main.user.items.manageCatalog', {status: 'approved'});
                  } else if (resource.content.data.import_status === 'PENDING') {
                    $state.go('main.user.items.manageCatalog', {status: 'pending'});
                  } else {
                    $state.go('main.user.items.manageCatalog', {status: 'rejected'});
                  }
                } else {
                  $state.go('main.user.items.manageCatalog', {status: 'pending'});
                }
              },
              function (error) {
                //Store catalog id to fadeout on pending table
                HighlightId.setId($scope.itemDetail._id);
                $state.go('main.user.items.manageCatalog', {status: 'pending'});
              }
            );
          }, function (error) {
            toastr.error('Catalog cannot be rejected.');
          }
        );
    });
  }

  function initialize(){

    $state.params.status = !!$scope.itemDetail.import_status ? $scope.itemDetail.import_status.toLowerCase() : 'all';

    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();

}

itemDetailCtrl.$inject = ['$scope', 'toastr', 'managedItem', '$q', '$stateParams', '$state',
                          'catalogVersion', 'downloadFile', '$filter', 'pathConstants', '$http',
                          '$uibModal', 'changeStatusCatalog', 'Approvals', 'profile',
                          'items', 'manageItemDetail', 'HighlightId', 'itemDetailsListing',
                          '$rootScope', 'searchModule', 'globalFunc'];

angular.module('metabuyer')
  .controller('itemDetailCtrl', itemDetailCtrl);

'use strict';
/**
 * @name exportsLogCtrl
 * @desc Controller for Logs of report
 */

function exportsLogCtrl ($scope, $filter, $stateParams,pathConstants,
                         toastr, exports) {

  $scope.selectedExportType = false;

  $scope.status = $stateParams.status;
  $scope.exportService = exports;

  $scope.onSelectedExportModule = onSelectedExportModule;
  $scope.downloadExport = downloadExport;

  /**
   * @type {{descr: string, value: number, type: string}[]}
   * The type is for determining what to pass into the listing parameters
   */
  $scope.exportModules = [
    { descr: 'Account Code', value: 3, type: 'AccountCode' },
    { descr: 'Business Units', value: 20, type: 'BusinessUnit' },
    { descr: 'Catalogs', value: 13, type: 'ImportItemSummary' },
    { descr: 'Catalog Items', value: 16, type: 'ImportItemDetail' },
    { descr: 'Commodity code', value: 10, type: 'Commodity' },
    { descr: 'Company', value: 1, type: 'Company' },
    { descr: 'Cost Center', value: 2, type: 'CostCenter' },
    { descr: 'Currencies', value: 0, type: 'Currencies' },
    { descr: 'Exchange Rate', value: 4, type: 'ExchangeRate' },
    { descr: 'Expense Types', value: 9, type: 'ExpenseTypes' },
    { descr: 'Industries', value: 19, type: 'Industry' },
    { descr: 'Payment Methods', value: 7, type: 'PaymentMethod' },
    { descr: 'Payment Terms', value: 6, type: 'PaymentTerm' },
    { descr: 'Purchase Requisitions', value: 17, type: 'PR' },
    { descr: 'Purchase Orders', value: 18, type: 'PO' },
    { descr: 'Suppliers', value: 11, type: 'Supplier' },
    { descr: 'Tax', value: 8, type: 'Tax' },
    { descr: 'UOM', value: 5, type: 'UOM' },
    { descr: 'Users', value: 12, type: 'Users' }
  ];

  function onSelectedExportModule(selectedModule){
    getExportListByType(selectedModule.type);
    $scope.selectedTitle = selectedModule.descr;
    $scope.selectedExportType = true;
  }

  function getExportListByType(selectedType) {
    exports.get(
      {
        type: selectedType
      },
      function (resource) {
        $scope.type = selectedType;
        $scope.embeddedParams = {
          type: $scope.type,
          offset: 10
        };
        $scope.logs = resource.content.data;
        $scope.meta = resource.content.meta;
      },
      function (error) {
        toastr.error('Failed to get export list');
      }
    );
  }

  /**
   *  Receive broadcast for updated embedded pagination data to update on controller side
   */
  $scope.$on('updateEmbeddedPagination', function(events, content){
    if(!!content && !!content.data)
    $scope.logs = content.data;
  });

  function downloadExport(logObject){
    if(!!logObject.status && logObject.status.toLowerCase() === 'done') {
      var newUrl = $filter('format')(pathConstants.apiUrls.export.download, {
        export_hash: logObject.hash
      });
      window.open(newUrl, '_self');
    }
  }

}

exportsLogCtrl.$inject = [
  '$scope','$filter', '$stateParams','pathConstants','toastr', 'exports'
];

angular
  .module('metabuyer')
  .controller('exportsLogCtrl', exportsLogCtrl);

'use strict';

/**
 * Controller for email items listing
 * @param $scope
 * @param dataList
 */

function emailLogsManageCtrl($scope, dataList) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.showColumn = showColumn;

  function showColumn (id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

}

emailLogsManageCtrl.$inject = ['$scope', 'dataList'];

angular.module('metabuyer')
  .controller('emailLogsManageCtrl', emailLogsManageCtrl);

'use strict';

/**
 * Controller for catalog items listing
 * @param $scope
 * @param dataList
 * @param $uibModal
 * @param toastr
 */

function viewCatalogItemsCtrl($scope, dataList, $uibModal, toastr) {

  $scope.dataList = dataList.data;
  $scope.meta = dataList.meta;
  $scope.catalogItemsManageService = dataList;
  $scope.viewCatalogItemDetails = viewCatalogItemDetails;

  $scope.showColumn = showColumn;

  function showColumn(id) {
    var i;
    var columns = $scope.columns;
    for (i in columns) {
      if(columns.hasOwnProperty(i)) {
        if (id === columns[i].id) {
          if(!!columns[i].conditional) {
            if($scope.status === columns[i].condition)
              return columns[i].selected;
            if(columns[i].condition instanceof Array) {
              var j;
              var columnCondition = $scope.columns[i].condition;
              for(j in columnCondition) {
                if(columnCondition.hasOwnProperty(j)) {
                  if($scope.status === columnCondition[j]) {
                    return columns[i].selected;
                  }
                }
              }
            }
          }
          else
            return columns[i].selected;
        }
      }
    }
  }

  function viewCatalogItemDetails(data) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/singleItemDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        data: function() {
          return data;
        }
      },
      controller: function ($scope, $uibModalInstance, data, singleItemDetails) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        singleItemDetails.get(
          {
            summary_id: data.import_summary_id,
            import_item_id: data._id
          },
          function(resource) {
            $scope.singleItemDetail = resource.content.data;
          },
          function() {
            toastr.error('Unable to view item detail');
          }
        )
      }
    });
  }

}

viewCatalogItemsCtrl.$inject = ['$scope', 'dataList', '$uibModal', 'toastr'];

angular.module('metabuyer')
  .controller('viewCatalogItemsCtrl', viewCatalogItemsCtrl);

'use strict';

/**
 * Controller for budget listing
 * @description
 * Contains functions for handling showing table columns and viewing details
 *
 * @param $scope
 * @param dataList
 * @param $stateParams
 * @param $state
 * @param $rootScope
 * @param budgets
 * @param toastr
 * @param HighlightId
 * @param $window
 *
 * @function viewBudgetDetail
 * Function to navigate to budget details by id state
 *
 * @function showColumn
 * Function to display selected available columns
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

function budgetListCtrl($scope, dataList, $stateParams, $state, $rootScope, budgets, toastr, HighlightId, $window) {

  $scope.currentUser = $rootScope.currentUser || {_id: null};

  $scope.viewBudgetDetail = viewBudgetDetail;
  $scope.showColumn = showColumn;
  $scope.canDelete = canDelete;
  $scope.deleteBudget = deleteBudget;
  $scope.checkWaitingOnUser = checkWaitingOnUser;
  $scope.multiSelectPendingItems = multiSelectPendingItems;
  $scope.getSelectedBudgets = getSelectedBudgets;

  function showColumn(id) {
    var i;
    var columns = $scope.columns;
    for (i in columns) {
      if(columns.hasOwnProperty(i)) {
        if (id === columns[i].id) {
          if(!!columns[i].conditional) {
            if($scope.status === columns[i].condition)
              return columns[i].selected;
            if(columns[i].condition instanceof Array) {
              var j;
              var columnCondition = $scope.columns[i].condition;
              for(j in columnCondition) {
                if(columnCondition.hasOwnProperty(j)) {
                  if($scope.status === columnCondition[j]) {
                    return columns[i].selected;
                  }
                }
              }
            }
          }
          else
            return columns[i].selected;
        }
      }
    }
  }

  function viewBudgetDetail(data) {
    $state.go('main.user.budget.details' , {id : data._id});
  }

  /**
   * Check if delete budget action can be done
   *
   * @param {string} creator Creator id
   * @param {string} status  Status of the budget
   */
  function canDelete(creator, status) {
    var checkBudgetStatus = (status === 'draft');
    var isApprover = (creator === $scope.currentUser._id);

    return (checkBudgetStatus && isApprover);
  }

  /**
   * To confirm if to delete the budget
   *
   * @param {string} budgetId Budget Id
   */
  function deleteBudget(budgetId) {
    swal({
      title: 'Confirm delete budget?',
      text: 'This action will remove the budget from draft.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm',
      closeOnConfirm: true
    }, function (isConfirm) {
      if (isConfirm) {
        confirmDeleteBudget(budgetId);
      }
    });
  }

  /**
   * Delete budget by id
   *
   * @param {string} budgetId Budget Id
   */
  function confirmDeleteBudget(budgetId) {

    budgets.delete(
      {
        id: budgetId
      },
      function () {
        toastr.success('Budget draft deleted.');
        $state.reload();
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  /**
   * return if the user is part of the waiting on
   * @param {array} budget Budget data
   * @returns {boolean}
   */
  function checkWaitingOnUser(budget) {
    return budget.status === 'pending' && !!budget.waiting_on ?
      (budget.waiting_on.indexOf($scope.currentUser._id) > -1) : false;
  }

  /**
   *  Select/deselect all the items in listing for approval action
   * @param {string} status Status of the current tab
   */
  function multiSelectPendingItems(status) {
    _.forEach($scope.dataList, function (budget) {
      if (checkWaitingOnUser(budget)) {
        budget.selected = status;
      }
    });
  }

  /**
   * Return selected budgets
   * @returns {array}
   */
  function getSelectedBudgets() {
    var selectedBudgets = [];
    _.forEach($scope.dataList, function (budget) {
      if (!!budget.selected) {
        selectedBudgets.push(budget);
      }
    });

    return selectedBudgets;
  }

  function initialize() {
    if (!!HighlightId.getId() && HighlightId.getId() !== undefined && HighlightId.getId().length) {

      $scope.highlightId = HighlightId.getId();

      if ($scope.highlightId !== null && $scope.highlightId !== undefined) {

        //scroll the window to top
        $window.scroll(0, 0);
      }

      //clear current id
      HighlightId.setId(null);
    }

    $scope.$parent.status = $stateParams.status;
    $scope.status = $stateParams.status;
    $scope.dataList = dataList.data;
    $scope.meta = dataList.meta;
    $scope.budgetManagementService = dataList;
    $scope.storageKey = 'budget-management-selected-columns';
    $scope.params = 'budget';
  }

  initialize();

}

budgetListCtrl.$inject = ['$scope', 'dataList', '$stateParams', '$state', '$rootScope', 'budgets', 'toastr',
  'HighlightId', '$window'];

angular.module('metabuyer')
  .controller('budgetListCtrl', budgetListCtrl);

'use strict';

/**
 * Controller for budget details
 * @description
 * Contains functions for handling budget information and editing
 *
 * @param $scope
 * @param toastr
 * @param companyExpenseTypes
 * @param userBudget
 * @param globalFunc
 * @param budgetData
 * @param singleCommentsHistory
 * @param budgetCommentList
 * @param attachmentsByReference
 * @param singleAttachment
 * @param $rootScope
 * @param $filter
 * @param pathConstants
 * @param $stateParams
 * @param budgetFunctions
 * @param Approvals
 * @param companyCurrencies
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function budgetDetailsCtrl(
  $scope, toastr, companyExpenseTypes, userBudget, globalFunc, budgetData, singleCommentsHistory,
  budgetCommentList, attachmentsByReference, singleAttachment, $rootScope, $filter, pathConstants, $stateParams,
  budgetFunctions, Approvals, companyCurrencies, $timeout
) {

  $scope.costCenterList = [];
  $scope.expenseTypeList = [];

  $scope.apportionList = [
    'N/A',
    'monthly',
    'quarterly',
    'yearly'
  ];

  $scope.ownerList = [];

  $scope.startDateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.endDateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.datepickerOpened = {
    start_date: false,
    end_date: false,
    start_date_assignment: false,
    end_date_assignment: false
  };

  $scope.commodityLevel = [1, 2, 3, 4];
  $scope.budgetAssignSwitch = false;
  $scope.showItemListing = false;

  $scope.commentService = budgetCommentList;
  $scope.deleteService = singleCommentsHistory;

  $scope.singleAttachmentService = singleAttachment;
  $scope.attachmentParam = {
    referenceId: budgetData._id
  };
  $scope.attachmentUrl = $filter('format')(pathConstants.apiUrls.attachments.reference,
    {referenceId: budgetData._id});
  $scope.headerDetailsError = false;
  $scope.budgetAssignmentDetailsError = false;
  $scope.budgetItemDetailsError = false;
  $scope.currencyList = [];
  $scope.costCenterExtraSettings = {
    scrollable: true,
    idProp: '_id',
    externalIdProp: '',
    displayProp: 'descr',
    enableSearch: true,
    showCheckAll: true,
    showUncheckAll: true,
    closeOnSelect: true
  };

  $scope.getCostCenter = getCostCenter;
  $scope.openDatepicker = openDatepicker;
  $scope.getBudgetOwner = getBudgetOwner;
  $scope.isCreator = isCreator;
  $scope.isWaitingOnCurrentUser = isWaitingOnCurrentUser;
  $scope.getEditingBudgetState = getEditingBudgetState;
  $scope.showItems = showItems;
  $scope.toggleSwitch = toggleSwitch;
  $scope.checkApportionAllocation = checkApportionAllocation;
  $scope.approvalsPreview = approvalsPreview;
  $scope.getAssignmentRemovableState = getAssignmentRemovableState;
  $scope.getItemBreakdownRemovableState = getItemBreakdownRemovableState;

  /**
   * Check if item breakdown is able to be turned off
   */
  function getItemBreakdownRemovableState() {
    return budgetFunctions.getItemBreakdownRemovableState();
  }

  /**
   * Get cost center listing
   */
  function getCostCenter() {
    _.forEach($rootScope.currentUser.costCenters, function (costCenter) {
      if (!!$scope.budget.company.code && $scope.budget.company.code === costCenter.company_code) {
        $scope.costCenterList.push(
          {
            'descr': costCenter.descr,
            'code': costCenter.code,
            '_id': costCenter._id
          }
        );
      }
    });
  }

  /**
   * For date picker
   *
   * @param {Object} $event
   * @param {string} which - start or end date
   */
  function openDatepicker($event, which) {
    $event.preventDefault();
    $event.stopPropagation();

    if (!!$scope.budget.end_date) {
      $scope.startDateOptions.maxDate = $scope.budget.end_date;
    }

    $scope.endDateOptions.minDate = new Date();

    $scope.datepickerOpened[which] = true;
  }

  /**
   * Get budget owner listing
   *
   * @param {string} companyCode
   */
  function getBudgetOwner(companyCode) {
    userBudget.get(
      {
        company_code: companyCode,
        user_group: 'owner'
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.ownerList = resource.content.data;
        }
      },
      function () {
        toastr.error('Failed to retrieve budget owner listing.');
      }
    )
  }

  /**
   * Get currency listing
   *
   * @param {string} companyId
   */
  function getCurrencies(companyId) {
    if (budgetData.status !== 'draft') {
      return;
    }

    companyCurrencies.get({
        id: companyId
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.currencyList = resource.content.data;
        }
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  /**
   * Get budget attachments
   */
  function getBudgetAttachments() {
    attachmentsByReference.get({
      referenceId: $scope.budget._id
    }, function(resource) {
      if (!!resource && !!resource.content)
        $scope.budgetAttachments = resource.content.data;
    }, function(error) {
      globalFunc.objectErrorMessage(error);
    })
  }

  /**
   * Check if current user is budget creator
   *
   * @returns {boolean}
   */
  function isCreator() {
    return $rootScope.currentUser._id === $scope.budget.created_by._id;
  }

  /**
   * Check if approval is waiting on current user
   *
   * @returns {boolean}
   */
  function isWaitingOnCurrentUser() {
    // TODO: Add approval related logic for showing buttons in globalFunc in new approval (Justin 11/9/17)
    return (1 === 1);
  }

  /**
   * Set budget editable state
   */
  function setBudgetEditableState(){
    budgetFunctions.setEditableState(($scope.budget.status === 'draft') ? 'editable' : 'notEditable');
    if (!isCreator())
      budgetFunctions.setEditableState('notEditable');
  }

  /**
   * Set budget assignment removable state
   */
  function setAssignmentRemovableState() {
    var usedInPR = false;
    if (!!$scope.budget.assignments) {
      _.forEach($scope.budget.assignments, function (assignment) {
        if ((!!assignment.used_amount && assignment.used_amount > 0) ||
          (!!assignment.committed_amount && assignment.committed_amount > 0)
        ) {
          usedInPR = true;
        }
      });
    }

    if (getEditingBudgetState() === 'editable' && !usedInPR) {
      budgetFunctions.setAssignmentRemovableState(true);
    } else {
      budgetFunctions.setAssignmentRemovableState(false);
    }
  }

  /**
   * Get the current state for the budget, either editable or not
   *
   * @returns {*}
   */
  function getEditingBudgetState(){
    return budgetFunctions.getEditingState();
  }

  /**
   * Get the current state for the budget assignment, either removable or not
   *
   * @returns {*}
   */
  function getAssignmentRemovableState(){
    return budgetFunctions.getAssignmentRemovableState();
  }

  /**
   * Retrieves the expense types
   *
   * @param {string} companyId
   */
  function getExpenseTypes(companyId) {
    companyExpenseTypes.get(
      {
        id: companyId
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.expenseTypeList = resource.content.data;
        }
      },
      function () {
        toastr.error('Failed to retrieve expense type listing.');
      }
    )
  }

  /**
   * Flag to show item to be shown or not
   */
  function showItems() {
    $scope.showItemListing = !$scope.showItemListing;
  }

  /**
   * Run when toggle value change for budget assignment
   *
   * @param {boolean} toggle Switch to on/off
   * @param {string}  type   Is either assignment or itembreakdowns
   */
  function toggleSwitch(toggle, type) {
    if (!toggle &&
      ((type === 'assignment' && !!$scope.budget.assignments.length) ||
      (type === 'itembreakdown' && !!$scope.budget.item_breakdowns.length))
    ) {
      swal({
        title: 'Confirm turn off the section?',
        text: 'Turn off this will erase the ' + type + ' data?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Confirm',
        closeOnConfirm: true
      }, function (isConfirm) {
        if (isConfirm) {
          if (type === 'assignment') {
            $scope.budget.assignments = [];
          } else {
            $scope.budget.item_breakdowns = [];
          }
        } else {
          if (type === 'assignment') {
            $scope.budgetAssignSwitch = true;
          } else {
            $scope.budgetItemBreakdownSwitch = true;
          }
          $scope.$apply();
        }
      });
    }
  }

  /**
   * To check if apportion allocation values will change due to field changes
   *
   * @param {*}      oldValue   old value of the field
   * @param {*}      newValue   new value of the field
   * @param {string} fieldModel Name of the model to be modified
   * @returns {boolean}
   */
  function checkApportionAllocation(oldValue, newValue, fieldModel) {
    budgetFunctions.checkApportionAllocation(
      oldValue,
      newValue,
      ($scope.budget.apportion_allocation)).then(function (resource) {
      $scope.apportionRelatedValues = resource;
      $scope.budget[fieldModel] = resource;
      $scope.originalBudgetData[fieldModel] = resource;
    });
  }

  /**
   * Run to get approval flow data for this budget
   */
  function getApprovalFlow() {
    if ($scope.budget.status !== 'draft' && $scope.budget.status !== 'deleted') {
      Approvals.get({
        id: $scope.budget.approval_id
      }, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.approvalFlowData = resource.content.data;
        }
        else
          $scope.approvalFlowData = [];
      }, function () {
        toastr.error('Failed to get approval flow data for this budget.');
      });
    }
  }

  function activateTab(tab){
    var status = tab;
    if(!status)
      status = _.cloneDeep($scope.budget.status.toLowerCase());

    tab = globalFunc.findInArray($scope.$parent.tabData, 'key', status);
    if(!tab)
      tab = globalFunc.findInArray($scope.$parent.tabData.more, 'key', status);

    return !!tab ? tab : $scope.$parent.tabData[0];
  }

  /**
   * Get the approval flow to display it in draft
   */
  function approvalsPreview() {
    $rootScope.$broadcast('saveDraftBudget');
  }

  function convertToLocalDate (date) {
    return new Date (date);
  }

  function initialize() {
    $scope.originalBudgetData = _.cloneDeep(budgetData);
    $scope.budget = _.cloneDeep(budgetData);
    $scope.$parent.status = $stateParams.status;

    var tabData = {
      tab: activateTab(),
      noTransition: true
    };

    // TODO: remove this with the new design (Justin 27/11/17)
    $timeout(function() {
      $rootScope.$broadcast('loadSpecificTab', tabData);
    }, 300);

    setBudgetEditableState();
    setAssignmentRemovableState();
    if (!!$scope.budget.item_breakdowns) {
      budgetFunctions.setItemBreakdownRemovableState($scope.budget.item_breakdowns);
    }
    $scope.budget.start_date = !!budgetData.start_date ? convertToLocalDate(budgetData.start_date) : null;
    $scope.budget.end_date = !!budgetData.end_date ? convertToLocalDate(budgetData.end_date) : null;
    $scope.budgetItemBreakdownSwitch = !!$scope.budget.item_breakdowns.length;
    $scope.budgetAssignSwitch = !!$scope.budget.assignments.length;
    getExpenseTypes(budgetData.company._id);
    getCostCenter();
    getBudgetOwner(budgetData.company.code);
    getCurrencies(budgetData.company._id);

    if (!!$scope.budget.assignments) {
      _.forEach($scope.budget.assignments, function (budgetAssignment, index) {
        budgetAssignment.start_date = !!budgetData.assignments[index].start_date ?
          convertToLocalDate(budgetData.assignments[index].start_date) : null;
        budgetAssignment.end_date = !!budgetData.assignments[index].end_date ?
          convertToLocalDate(budgetData.assignments[index].end_date) : null;
      });
    }

    getBudgetAttachments();
    getApprovalFlow();

    $scope.$watch('budget.cost_center.length', function () {
      _.forEach($scope.budget.assignments, function (budgetAssignment, index) {
        if (!!budgetAssignment.cost_center) {
          var temp = globalFunc.findInArray($scope.budget.cost_center, '_id', budgetAssignment.cost_center._id);
        }
        if (!temp) {
          $scope.budget.assignments[index].cost_center = [];
        }
      });
    });

    $scope.$watch('budget.expense_type', function (newValue) {
      if (!!newValue) {
        _.forEach($scope.budget.assignments, function (budgetAssignment, index) {
          $scope.budget.assignments[index].expense_type = newValue;
        });
      }
    });

    $scope.$watch('budget.apportion_type', function (newValue) {
      if (!!newValue) {
        _.forEach($scope.budget.assignments, function (budgetAssignment, index) {
          if (newValue !== 'N/A') {
            $scope.budget.assignments[index].apportion_type = newValue;
          }
        });
      }
    });
  }

  initialize();

}

budgetDetailsCtrl.$inject = [
  '$scope', 'toastr', 'companyExpenseTypes', 'userBudget', 'globalFunc',
  'budgetData', 'singleCommentsHistory', 'budgetCommentList', 'attachmentsByReference', 'singleAttachment',
  '$rootScope', '$filter', 'pathConstants', '$stateParams', 'budgetFunctions', 'Approvals', 'companyCurrencies', '$timeout'
];

angular.module('metabuyer')
  .controller('budgetDetailsCtrl', budgetDetailsCtrl);


'use strict';
/**
 * @name approvalFlowDetailController
 * @desc Controller for Approval Flow Detail
 */

function approvalFlowPreviewController($scope, globalFunc, companies, searchModule, companyExpenseTypes,
                                       companyCurrencies, toastr, approvalPreviewByData) {

  $scope.uiCompany = {};
  $scope.uiCompany.list = {};
  $scope.companyListing = companies.data;
  $scope.uiCostCenter = {};
  $scope.uiCostCenter.list = {};
  $scope.expenseTypesListing = null;
  $scope.uiExpense = {};
  $scope.uiExpense.list = {};
  $scope.uiAmount = 0;
  $scope.uiItemType = {};
  $scope.uiItemType.list = [];
  $scope.itemTypeListing = [
    {
      code: 'IT',
      descr: 'Information Technology'
    },
    {
      code: 'CP',
      descr: 'Car Purchase'
    },
    {
      code: 'ME',
      descr: 'M&E'
    },
    {
      code: 'FB',
      descr: 'Food, Beverages and Tobacco'
    }
  ];
  $scope.currencyListing = [];
  $scope.uiCurrency = {};
  $scope.uiCurrency.list = {};
  $scope.uiCatalog = {};
  $scope.uiCatalog.list = {};
  $scope.catalogListing = [
    {
      code: 'catalog',
      descr: 'Catalog Only'
    },
    {
      code: 'noncatalog',
      descr: 'Catalog & Non Catalog'
    }
  ];
  $scope.uiType = {};
  $scope.uiType.list = {};
  $scope.typeListing = [];
  $scope.templateTypes = [
    {
      code: 'PR',
      descr: 'PR'
    },
    {
      code: 'Supplier',
      descr: 'Supplier'
    },
    {
      code: 'Catalog',
      descr: 'Catalog'
    },
    {
      code: 'Budget',
      descr: 'Budget'
    }
  ];
  $scope.approvals = null;

  $scope.processCostCenterList = processCostCenterList;
  $scope.preview = preview;
  $scope.resetSelection = resetSelection;

  function loadCurrencies() {
    companyCurrencies.get({
        id: $scope.uiCompany.list._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.currencyListing = resource.content.data;
        }
      }, function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  function loadExpenseTypes() {
    companyExpenseTypes.get(
      {
        id: $scope.uiCompany.list._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.expenseTypesListing = resource.content.data;
          if (!!$scope.uiType.list && $scope.uiType.list.code === 'Budget') {
            $scope.expenseTypesListing.unshift({'code': 'all', 'descr': 'All'});
          }
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function processCostCenterList() {
    $scope.uiCostCenter.list = {};
    $scope.uiExpense.list = [];

    //stop when no company is selected
    if (!$scope.uiCompany.list.code) {
      $scope.costCenterListing = [];
      return;
    }

    loadExpenseTypes();
    loadCurrencies();

    var params = {
      module: 'cost-center',
      offset: 0,
      criteria_operator: 'and',
      order_by: 'descr',
      order: 1
    };

    if ($scope.uiCompany.list.code !== 'SYSTEM')
      params['criteria[company_code]'] = $scope.uiCompany.list.code;

    searchModule.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.costCenterListing = resource.content.data;
          $scope.costCenterListing.unshift({'code':'all', 'descr':'All'});
        }
      }
    )
  }

  function validationBeforePreview() {
    //non-PR types are not required to fill in the rest of the fields
    if (!!$scope.uiType.list.code && $scope.uiType.list.code !== 'PR' && $scope.uiType.list.code !== 'Budget') {
      return true;
    }

    switch ($scope.uiType.list.code) {
      case 'PR':
        if (!$scope.uiCompany.list.code || !$scope.uiCostCenter.list.code || !$scope.uiExpense.list.code ||
          $scope.uiAmount <= 0 || !$scope.uiCurrency.list.code || !$scope.uiCatalog.list.code ||
          !$scope.uiType.list.code
        ) {
          toastr.error('Please fill in all the required fields and total amount must be greater than 0.');
          return false;
        }
        break;

      case 'Budget':
        if (!$scope.uiCompany.list.code || !$scope.uiCostCenter.list.code || !$scope.uiExpense.list.code ||
          $scope.uiAmount <= 0 || !$scope.uiCurrency.list.code
        ) {
          toastr.error('Please fill in all the required fields and total amount must be greater than 0.');
          return false;
        }
        break;
    }
    return true;
  }

  function preview() {
    $scope.approvals = null;

    if (!validationBeforePreview())
      return;

    var param = {
      type: $scope.uiType.list.code,
      company: $scope.uiCompany.list.code,
      cost_center: !!$scope.uiCostCenter.list.code ? $scope.uiCostCenter.list.code : 'all',
      expense: $scope.uiExpense.list.code,
      total_amount: $scope.uiAmount,
      item_type: !!$scope.uiItemType.list.length ? _.pluck($scope.uiItemType.list, 'code').join(",") : '',
      currency: $scope.uiCurrency.list.code,
      catalog: $scope.uiCatalog.list.code
    }

    approvalPreviewByData.get(
      {
        data: param
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.approvals = resource.content.data;
          generatePrint();
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  /**
   * Function that reset searching fields
   * @param {boolean} isResetButton  Calling from either 'reset button' or on type selecting
   * @param {boolean} resetTypeField Whether to reset Type searching field
   */
  function resetSelection(isResetButton, resetTypeField) {
    if ((!!isResetButton) ||
      (!isResetButton && !!$scope.uiType && !!$scope.uiType.list && !!$scope.uiType.list.code &&
      $scope.uiType.list.code !== 'PR')) {
      $scope.uiCompany.list = [];
      $scope.uiCostCenter.list = {};
      $scope.uiExpense.list = [];
      $scope.uiAmount = 0;
      $scope.uiItemType.list = [];
      $scope.uiCurrency.list = [];
      $scope.uiCatalog.list = [];
      if (!!resetTypeField) {
        $scope.uiType.list = [];
      }
    }
  }
}

approvalFlowPreviewController.$inject = ['$scope', 'globalFunc', 'companies', 'searchModule', 'companyExpenseTypes',
  'companyCurrencies', 'toastr', 'approvalPreviewByData'];

angular
  .module('metabuyer')
  .controller('approvalFlowPreviewController', approvalFlowPreviewController);

'use strict';
/**
 * @name approvalFlowManagementController
 * @desc Controller for Approval Flow Management for listing All the available tabs and functions of the Approval Flow
 */

function approvalFlowManagementController (
  $scope, approvalTemplateListing, approvalTemplates, globalFunc, approvalTemplateSingle, toastr, $state, searchModule,
  $uibModal, companies, companyExpenseTypes, HighlightId
) {

  $scope.importParams = {
    class: 'Metabuyer\\ApprovalFlow\\Templates\\Models\\ApprovalTemplate',
    'additional_params[]': ''
  };

  $scope.columns = [
    { id: 'number', label: '#', unsortable: true, unsearchable: true, unSelectable: true },
    { id: 'type', label: 'Type' },
    { id: 'code', label: 'Code' },
    { id: 'title', label: 'Title' },
    { id: 'company', label: 'Company' , unsortable: true, unsearchable: true},
    { id: 'cost_center', label: 'Cost Center' , unsortable: true, unsearchable: true},
    { id: 'expense_type', label: 'Expense Type' , unsortable: true, unsearchable: true},
    { id: 'effective_at', label: 'Effective At', unsortable: true, unsearchable: true},
    { id: 'created_at', label: 'Created At' },
    { id: 'updated_at', label: 'Updated At' },
    { id: 'created_by', label: 'Created By', unsortable: true, unsearchable: true},
    { id: 'updated_by', label: 'Updated By', unsortable: true, unsearchable: true},
    { id: 'status', label: 'Status' },
    // { id: 'remove', label: 'Remove', unsortable: true, unsearchable: true, unSelectable: true }
  ];

  $scope.meta = [];
  $scope.page = 0;
  $scope.limit = 10;
  $scope.currentStatus = {
    col: null,
    order: null
  };
  $scope.timezoneDiff = '';
  $scope.colSorting = null;
  $scope.colOrder = null;
  $scope.storageKey = 'approval-templates-manage-selected-columns';
  $scope.companies = [];
  $scope.uiCompanySelect = {};
  $scope.uiCompanySelect.list = {};
  $scope.uiCostCenterSelect = {};
  $scope.uiCostCenterSelect.list = {};
  $scope.uiExpenseSelect = {};
  $scope.uiExpenseSelect.list = {};
  $scope.companyListing = companies.data;
  $scope.expenseTypesListing = null;
  $scope.checkTemplateType = checkTemplateType;

  $scope.templateTypes = [
    {
      code: 'PR',
      descr: 'PR'
    },
    {
      code: 'Supplier',
      descr: 'Supplier'
    },
    {
      code: 'Catalog',
      descr: 'Catalog'
    },
    {
      code: 'Budget',
      descr: 'Budget'
    }
  ];
  $scope.uiType = {};
  $scope.uiType.list = [];
  $scope.uiCode = null;
  $scope.uiTitle = null;
  $scope.uiExpense = null;
  $scope.statusListing = [
    {
      code: '0',
      descr: 'Active'
    },
    {
      code: '1',
      descr: 'Inactive'
    }
  ];
  $scope.status = {};
  $scope.status.list = [];

  $scope.visibleColumn = visibleColumn;
  $scope.search = search;
  $scope.removeTemplate = removeTemplate;
  $scope.exportTemplate = exportTemplate;
  $scope.search = search;
  $scope.resetSelection = resetSelection;
  $scope.processCostCenterList = processCostCenterList;

  function checkTemplateType() {
    if ($scope.uiType.list.code !== 'PR') {
      $scope.uiCompanySelect.list = null;
      $scope.uiCostCenterSelect.list = null;
      $scope.uiExpenseSelect.list = null;
    }
  }

  function visibleColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function prepareMeta() {
    $scope.processedData = [];
    $scope.processedData = $scope.dataList;
    $scope.meta.currentPageNumber = $scope.dataList.meta.current;
    $scope.meta.totalPageNumber = $scope.dataList.meta.pages;
    $scope.meta.totalRec = $scope.dataList.meta.count;
    $scope.meta.startRecNo = $scope.limit * $scope.page + 1;
    $scope.meta.endRecNo = $scope.meta.totalRec - ((1 + $scope.meta.currentPageNumber) * $scope.limit) >= 0 ?
      (1 + $scope.meta.currentPageNumber) * $scope.limit :
      (($scope.meta.currentPageNumber) * $scope.limit) + $scope.meta.totalRec % $scope.limit;
    $scope.dataList = $scope.processedData;
  }

  function getStatus(status) {
    var statusString = '';
    switch (status) {
      case 0:
        statusString = 'Active';
        break;
      case 1:
        statusString = 'Inactive';
        break;
    }
    return statusString;
  }

  function search(page, sortingCol, sortingOrder) {
    $scope.page = page;
    $scope.colSorting = sortingCol;
    $scope.colOrder = sortingOrder;
    approvalTemplates.get(
      {
        'sort[0][key]': sortingCol,
        'sort[0][direction]': sortingOrder,
        'sort[1][key]': 'status',
        'sort[1][direction]': 'ASC',
        'sort[2][key]': 'updated_at',
        'sort[2][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'module',
        'filter_groups[0][filters][0][value]': !!$scope.uiType.list.code ? $scope.uiType.list.code : '',
        'filter_groups[0][filters][0][operator]': 'ct',
        'filter_groups[1][filters][0][key]': 'code',
        'filter_groups[1][filters][0][value]': !!$scope.uiCode ? $scope.uiCode : '',
        'filter_groups[1][filters][0][operator]': 'ct',
        'filter_groups[2][filters][0][key]': 'title',
        'filter_groups[2][filters][0][value]': !!$scope.uiTitle ? $scope.uiTitle : '',
        'filter_groups[2][filters][0][operator]': 'ct',
        'filter_groups[3][filters][0][key]': 'status',
        'filter_groups[3][filters][0][value]': !!$scope.status.list.code ? $scope.status.list.code : '',
        'filter_groups[3][filters][0][operator]': 'ct',
        'filter_groups[4][filters][0][key]': 'rule',
        'filter_groups[4][filters][0][value]': [
          !!$scope.uiCompanySelect.list && !!$scope.uiCompanySelect.list.code ? 'company:' + $scope.uiCompanySelect.list.code : '',
          !!$scope.uiCostCenterSelect.list && !!$scope.uiCostCenterSelect.list.code ? 'cost_center:' + $scope.uiCostCenterSelect.list.code : '',
          !!$scope.uiExpenseSelect.list && !!$scope.uiExpenseSelect.list.code ? 'expense_type:' + $scope.uiExpenseSelect.list.code : ''
        ].join(),
        'filter_groups[4][filters][0][operator]': 'ct',
        limit: $scope.limit,
        page: page
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.dataList = resource.content.data;
          $scope.dataList.meta = resource.content.meta.cursor;
          prepareMeta();
          prepareDataList();
        }
      },
      function (resource) {
        if (
          !!resource.data &&
          !!resource.data.content &&
          !!resource.data.content.message &&
          !!resource.data.content.message.errors
        ) {
          toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
        }
        else {
          toastr.error('Failed to search');
        }
      }
    )
  }

  function prepareDataList() {
    _.forEach($scope.dataList, function(approval) {
      approval.status = getStatus(approval.status);
      approval.created_at = globalFunc.convertToLocalDate(approval.created_at);
      approval.updated_at = globalFunc.convertToLocalDate(approval.updated_at);
      approval.effective_date = globalFunc.convertToLocalDate(approval.effective_date);
    });
  }

  function removeTemplate(approval) {
    swal(
      {
        title: 'Warning!',
        text: 'Are you sure you want to delete \'' + approval.title + '\' ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (isConfirm) {
          approvalTemplateSingle.delete({
            id: approval.id
          }, function (resource) {
            // search($scope.meta['currentPageNumber']);
            toastr.success('Approval template has been successfully deleted.');
            $state.reload();
          }, function (error) {
            if (
              !!resource.data &&
              !!resource.data.content &&
              !!resource.data.content.message &&
              !!resource.data.content.message.errors
            ) {
              toastr.error(_.map(resource.data.content.message.errors, _.property('detail')).toString());
            } else {
              toastr.error('Failed to delete selected approval template.');
            }
          });
        }
      }
    );
  }

  function exportTemplate() {
    $uibModal.open({
      templateUrl: 'app/approvalFlow/manage/export.html',
      controller: 'exportTemplateController',
      backdrop: 'static',
      keyboard: false,
      resolve:{
        companies: function() {
          return $scope.companies;
        }
      }
    });
  }

  function getCompanies() {
    $scope.disableExportButton = true;
    searchModule.get(
      {
        module: 'companies',
        offset: 0,
        order_by: 'descr',
        order: 1
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.companies = resource.content.data;
          $scope.disableExportButton = false;
        }
      }
    );
  }

  function resetSelection() {
    $scope.uiType.list = [];
    $scope.uiCode = null;
    $scope.uiTitle = null;
    $scope.uiCompanySelect.list = null;
    $scope.uiCostCenterSelect.list = null;
    $scope.uiExpenseSelect.list = null;
    $scope.status.list = [];
  }

  function processCostCenterList() {
    $scope.uiCostCenterSelect.list = {};
    $scope.uiExpenseSelect.list = [];

    //stop when no company is selected
    if (!$scope.uiCompanySelect.list.code) {
      $scope.costCenterListing = [];
      return;
    }

    loadExpenseTypes();

    var params = {
      module: 'cost-center',
      offset: 0,
      criteria_operator: 'and',
      order_by: 'descr',
      order: 1
    };

    if ($scope.uiCompanySelect.list.code !== 'SYSTEM')
      params['criteria[company_code]'] = $scope.uiCompanySelect.list.code;

    searchModule.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.costCenterListing = resource.content.data;
          $scope.costCenterListing.unshift({'code':'all', 'descr':'All'});
        }
      }
    )
  }

  function loadExpenseTypes() {
    companyExpenseTypes.get(
      {
        id: $scope.uiCompanySelect.list._id
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.expenseTypesListing = resource.content.data;
        }
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    )
  }

  function initialize() {
    $scope.timezoneDiff = globalFunc.getTimezoneDiff();
    $scope.dataList = approvalTemplateListing.data;
    $scope.dataList.meta = approvalTemplateListing.meta.cursor;
    $scope.highlightId = HighlightId.getId();
    if (!!$scope.highlightId) {
      HighlightId.setId(null);
    }
    prepareMeta();
    prepareDataList();
    getCompanies();
  }

  initialize();
}

approvalFlowManagementController.$inject = [
  '$scope', 'approvalTemplateListing', 'approvalTemplates', 'globalFunc', 'approvalTemplateSingle', 'toastr', '$state',
  'searchModule', '$uibModal', 'companies', 'companyExpenseTypes', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('approvalFlowManagementController', approvalFlowManagementController);

'use strict';

/**
 * @name exportTemplateController
 * @desc Controller for approval flow export
 */
function exportTemplateController (
  $scope, companies, $uibModalInstance, toastr, approvalTemplateExport, globalFunc, pathConstants, $http, $filter
) {

  $scope.companies = companies;
  $scope.template = {};
  $scope.templateTypes = [
    {
      code: 'PR',
      descr: 'PR'
    },
    {
      code: 'Supplier',
      descr: 'Supplier'
    },
    {
      code: 'Catalog',
      descr: 'Catalog'
    },
    {
      code: 'Budget',
      descr: 'Budget'
    }
  ];
  $scope.modulesWithCompany = ['PR', 'Budget'];

  $scope.close = close;
  $scope.exportTemplate = exportTemplate;

  function close() {
    $uibModalInstance.close();
  }

  function exportTemplate() {
    if (exportValidation()) {
      var params = {
        module: $scope.template.type.code,
        only_active: (!!$scope.template.onlyActive) ? 1 : 0
      };

      if ($scope.modulesWithCompany.indexOf($scope.template.type.code) > -1) {
        params.company_code = $scope.template.company.code;
      }

      $http({
        method: 'POST',
        url: pathConstants.apiUrls.approvalEngine.approvalTemplate.export,
        params: params
      }).then(function (response) {
        var blob = new Blob([response.data]);
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Template-' +
          $scope.template.type.code +
          (!!$scope.template.company && !!$scope.template.company.code ? '-' + $scope.template.company.code + '-' : '') +
          $filter('date')(new Date(), 'dd-MMM-yyyy') +'.csv';
        link.click();
        toastr.success('Template file has been successfully generated.');
      }, function () {
        toastr.error('Failed to generate template file.');
      });
    }
  }

  function exportValidation() {
    if (!!$scope.template) {
      if (!$scope.template.type || !$scope.template.type.code) {
        toastr.error('The type field is required');
        return false;
      }

      if (($scope.modulesWithCompany.indexOf($scope.template.type.code) > -1) &&
        (!$scope.template.company || !$scope.template.company.code)) {
        toastr.error('The company field is required');
        return false;
      }
    }

    return true;
  }
}

exportTemplateController.$inject = [
  '$scope', 'companies', '$uibModalInstance', 'toastr', 'approvalTemplateExport', 'globalFunc', 'pathConstants',
  '$http', '$filter'
];

angular
  .module('metabuyer')
  .controller('exportTemplateController', exportTemplateController);

'use strict';
/**
 * @name approvalFlowDetailController
 * @desc Controller for Approval Flow Detail
 */

function approvalFlowDetailController (
  $scope, approvalFlowDetail, globalFunc, $stateParams, $filter, approvalTemplateHistory, approvalTemplateInfo, $state,
  toastr, HighlightId
) {

  $scope.approvalTemplate = approvalFlowDetail;
  $scope.timezoneDiff = globalFunc.getTimezoneDiff();
  $scope.limit = 10;
  $scope.meta = [];
  $scope.page = 0;
  $scope.costCenterListing = null;
  $scope.uiCostCenter = {};
  $scope.uiCostCenter.list = null;
  $scope.expenseTypeListing = null;
  $scope.uiExpense = {};
  $scope.uiExpense.list = null;
  $scope.uiTemplate = {};
  $scope.uiTemplate.list = null;
  $scope.uiStatus = {};
  $scope.uiStatus.list = null;
  $scope.availableApprovals = null;
  $scope.templateListing = null;
  $scope.templateStatus = [
    {
      code: 0,
      descr: 'Active'
    },
    {
      code: 1,
      descr: 'Inactive'
    }
  ];
  $scope.modulesWithCompanyCode = ['pr', 'budget'];

  $scope.back = back;
  $scope.getPosition = getPosition;
  $scope.checkStep = checkStep;
  $scope.returnDate = returnDate;
  $scope.exportCSV = exportCSV;
  $scope.checkStepPosition = checkStepPosition;
  $scope.printApprovalFlow = printApprovalFlow;
  $scope.filterAvailableApprovals = filterAvailableApprovals;
  $scope.navigateTemplate = navigateTemplate;
  $scope.clearSearch = clearSearch;
  $scope.getTemplateHistory = getTemplateHistory;
  $scope.getStatus = getStatus;

  function back() {
    if (!!$scope.approvalTemplate && !!$scope.approvalTemplate.id) {
      HighlightId.setId($scope.approvalTemplate.id);
    }
    window.history.back();
  }

  function checkStep(step) {
    var userFound = false;
    _.forEach(step.step_positions, function (stepPosition) {
      userFound = false;
      if (stepPosition.position.position_type !== 'ad-hoc') {
        _.forEach(stepPosition.position_assignments, function (assignment) {
          userFound = !!assignment.active_users.length > 0 ? true : userFound;
        });
      } else {
        userFound = true;
      }
      if (!userFound)
        return false;
    });

    return userFound;
  }

  function checkStepPosition(stepPosition) {
    var userFound = false;
    if (stepPosition.position.position_type === 'ad-hoc') {
      return true;
    }
    _.forEach(stepPosition.position_assignments, function (assignment) {
      userFound = !!assignment.active_users.length > 0 ? true : userFound;
    });

    return userFound;
  }

  function getPosition(assignments) {
    var userAssignment = [];

    _.forEach(assignments, function (assignment) {

      if (!assignment.active_users.length) {
        userAssignment.push(false);
      } else {
        userAssignment.push(true);
      }
    });

    if (userAssignment.indexOf(true) === -1) {
      return 'There are no users assigned to the position';
    }
  }

  function prepareDetailData() {
    $scope.approvalTemplate.created_at = globalFunc.convertToLocalDate($scope.approvalTemplate.created_at);
    $scope.approvalTemplate.updated_at = globalFunc.convertToLocalDate($scope.approvalTemplate.updated_at);
    $scope.approvalTemplate.effective_date = (!!$scope.approvalTemplate.effective_date) ?
      globalFunc.convertToLocalDate($scope.approvalTemplate.effective_date) : '-';
  }

  function returnDate(date) {
    return globalFunc.convertToLocalDate(date);
  }

  function processData() {
    $scope.meta['currentPageNumber'] = $scope.approvalHistoryData['meta']['current'];
    $scope.meta['totalPageNumber'] = $scope.approvalHistoryData['meta']['pages'];
    $scope.meta['totalRec'] = $scope.approvalHistoryData['meta']['count'];
    $scope.meta['startRecNo'] = $scope.limit * $scope.page + 1;
    $scope.meta['endRecNo'] = $scope.meta['totalRec'] - ((1 + $scope.meta['currentPageNumber']) * $scope.limit) >= 0 ?
      (1 + $scope.meta['currentPageNumber']) * $scope.limit :
      (($scope.meta['currentPageNumber']) * $scope.limit) + $scope.meta['totalRec'] % $scope.limit;
  }

  function constructHistoryLogExport(data) {
    var returnData = '';

    if (data.event === 'created') {
      return returnData;
    }

    returnData += !!data.new_values.module ? 'module : ' + data.new_values.module + '\r\n' : '';
    returnData += !!data.new_values.company ? 'company : ' + data.new_values.company + '\r\n' : '';
    returnData += !!data.new_values.title ? 'title : ' + data.new_values.title + '\r\n' : '';
    returnData += !!data.new_values.code ? 'code : ' + data.new_values.code + '\r\n' : '';
    returnData += !!data.new_values.status ? 'status : ' + data.new_values.status ? 'Active' : 'Inactive' + '\r\n' : '';
    returnData += !!data.new_values.effective_date ? 'effective date : ' + data.new_values.effective_date + '\r\n' : '';
    returnData += !!data.new_values.cost_center ? 'cost center  : ' + data.new_values.cost_center + '\r\n' : '';
    returnData += !!data.new_values.expense_type ? 'expense type : ' + data.new_values.expense_type + '\r\n' : '';

    _.forEach(data.new_values.steps, function (stepValue) {
      returnData += 'step : ' + stepValue.seq;
      if (stepValue.changes === 'removed' || stepValue.changes === 'added') {
        returnData += ' ** ' + stepValue.changes + ' **';
      } else if (stepValue.changes === '') {
        returnData += ' ** no changes **';
      }
      returnData += '\r\n';
      returnData += !!stepValue.min_approver ? 'min approver : ' + stepValue.min_approver + '\r\n' : '';

      _.forEach(stepValue.positions, function (positionValue) {
        if (!!positionValue.changes && positionValue.changes !== '') {
          returnData += '   position : ' + positionValue.position_code;

          if (!!positionValue.changes && (positionValue.changes === 'removed' || positionValue.changes === 'added')) {
            returnData += '   **' + positionValue.changes + '**';
          }
          returnData += '\r\n';

          _.forEach(positionValue.rules, function (ruleValue, ruleKey) {
            if (!!ruleValue.value) {
              returnData += '      rule ' + (ruleKey + 1) + ' : ' + ruleValue.name + ruleValue.operator +
                ruleValue.value + '\r\n';
            }
          });
        }
      });
    });

    return returnData;
  }

  function processHistoryLogExport(data) {
    _.forEach(data, function (item, itemKey) {
      if (!!item.new_values) {
        data[itemKey].exportChanges = constructHistoryLogExport(item);
      }
    });
  }

  function searchAvailableTemplates() {

    var params = {
      limit: 0,
      page: 0,
      'module': $scope.approvalTemplate.module,
      'code': $scope.approvalTemplate.code
    }
    if ($scope.modulesWithCompanyCode.indexOf($scope.approvalTemplate.module.toLowerCase()) > -1) {
      params.company = $scope.approvalTemplate.organization.company.code;
    }

    approvalTemplateInfo.get(
      params,
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $scope.availableApprovals = prepareAvailableTemplates(resource.content.data);
          $scope.templateListing = $scope.availableApprovals;
        }
      },
      function () {
        toastr.error('Failed to load available templates.');
      }
    )
  }

  function getTemplateHistory(page) {
    $scope.page = page;
    approvalTemplateHistory.get(
      {
        'sort[1][key]': 'created_at',
        'sort[1][direction]': 'DESC',
        'filter_groups[0][filters][0][key]': 'auditable_id',
        'filter_groups[0][filters][0][value]': $stateParams.id,
        'filter_groups[0][filters][0][operator]': 'eq',
        'filter_groups[1][filters][0][key]': 'auditable_type',
        'filter_groups[1][filters][0][value]': 'Api\\Templates\\Models\\Template',
        'filter_groups[1][filters][0][operator]': 'eq',
        limit: 10,
        page: page
      },
      function (resource) {
        if (!!resource.content) {
          $scope.approvalHistoryData = resource.content.data;
          $scope.approvalHistoryData['meta'] = resource.content.meta.cursor;
          prepareDetailData();
          processData();
        }
      },
      function () {
        toastr.error('Failed to retrieve history logs.');
      }
    )
  }

  /**
   * Replace status number to be text
   *
   * @param status
   * @returns {*}
   */
  function getStatus(status) {
    if (!!status) {
      status = status.replace('0', 'Active');
      status = status.replace('1', 'Inactive');
    }

    return status;
  }

  function prepareAvailableTemplates(data){
    var finalData = [];
    _.forEach(data, function (item) {

      if (!!item.organization.cost_center && item.organization.cost_center === 'all') {
        item.organization.cost_center = {'code':'all', 'descr':'All'};
      }

      finalData.push({
        'template_id': item.id,
        'title': item.title,
        'cost_center': !!item.organization.cost_center && !!item.organization.cost_center.code ?
          item.organization.cost_center.descr + ' (' + item.organization.cost_center.code + ')' : '',
        'expense_type': !!item.organization.expense_type && !!item.organization.expense_type.code ?
          item.organization.expense_type.descr + ' (' + item.organization.expense_type.code + ')' : '',
        'status': item.status
      });
    });

    $scope.costCenterListing = _.chain(finalData).pluck('cost_center').unique().value();
    $scope.expenseTypeListing = _.chain(finalData).pluck('expense_type').unique().value();

    return finalData;
  }

  function exportCSV() {
    processHistoryLogExport($scope.approvalHistoryData);

    $scope.arrayData = [['Username', 'Action', 'Date', 'Changes']];
    _.forEach($scope.approvalHistoryData, function (data) {
      $scope.arrayData.push([
        (!!data.user && !!data.user.display_name ? data.user.display_name : ''),
        data.event,
        $filter('date')(returnDate(data.created_at), 'dd MMM yyyy h:mm a'),
        data.exportChanges
      ])
    });
    $scope.fileName = globalFunc.getCsvFilenameWithDate('Approval Template - ' + $scope.approvalTemplate.code);
    $scope.triggerHistoryExport = true;
  }

  function printApprovalFlow() {
    window.print();
  }

  function filterAvailableApprovals() {
    if (!_.isEmpty($scope.availableApprovals)) {
      $scope.templateListing = _.filter($scope.availableApprovals, function (item) {
        return (!!$scope.uiExpense.list && item.expense_type ? item.expense_type === $scope.uiExpense.list : true) &&
          (!!$scope.uiCostCenter.list && item.cost_center ? item.cost_center === $scope.uiCostCenter.list : true) &&
          (!!$scope.uiStatus.list ? item.status === $scope.uiStatus.list.code : true);
      });
    }

    $scope.uiTemplate.list = null;
  }

  function navigateTemplate() {
    if (!!$scope.uiTemplate.list && !!$scope.uiTemplate.list.template_id) {
      $state.go('main.user.approvalFlow.detail', {
        id: $scope.uiTemplate.list.template_id
      });
    }
    else {
      toastr.error('Please select a template to continue.');
    }
  }

  function clearSearch() {
    $scope.uiExpense.list = null;
    $scope.uiCostCenter.list = null;
    $scope.uiStatus.list = null;
    filterAvailableApprovals();
  }

  /**
   * To remove duplicated users in the position assignment
   */
  function removeDuplicatedUser() {
    _.forEach($scope.approvalTemplate.steps, function (step) {
      _.forEach(step.step_positions, function (stepPosition) {
        var tempUsers = [];
        _.forEach(stepPosition.position_assignments, function (assignment) {
          var newActiveUsers = [];
          _.forEach(assignment.active_users, function (user) {
            if (!!user && !!user.assignee_id) {
              if (tempUsers.indexOf(user.assignee_id) === -1) {
                newActiveUsers.push(user);
                tempUsers.push(user.assignee_id);
              }
            }
          })
          assignment.active_users = newActiveUsers;
        })
      })
    })
  }

  function initialize() {
    getTemplateHistory(0);
    if (!!$scope.approvalTemplate && $scope.approvalTemplate.module)
    {
      searchAvailableTemplates();
      removeDuplicatedUser();
    }
  }

  initialize();
}

approvalFlowDetailController.$inject = [
  '$scope', 'approvalFlowDetail', 'globalFunc', '$stateParams', '$filter', 'approvalTemplateHistory',
  'approvalTemplateInfo', '$state', 'toastr', 'HighlightId'
];

angular
  .module('metabuyer')
  .controller('approvalFlowDetailController', approvalFlowDetailController);

'use strict';
angular
  .module('metabuyer')
  .directive('withdraw',function($uibModal, Orders, toastr) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {
        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/withdraw/withdrawTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'WithdrawCtrl',
            scope: scope
          });
        };

        //loading the panel
        scope.showWithdraw = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('WithdrawCtrl', function (
    $scope, $uibModalInstance, purchaseRequisitionsServices, toastr, HighlightId, $state, globalFunc
  ) {

    $scope.commentText = '';

    $scope.cancelWithdraw = cancelWithdraw;
    $scope.withdraw = withdraw;

    //cancel action
    function cancelWithdraw(){
      $uibModalInstance.close();
    }

    //withdraw action
    function withdraw(){
      var module = !!$scope.module ? $scope.module : 'PR';
      var approvalId = (module === 'budget') ? $scope.data.approval_id : $scope.PR.approval_id;

      purchaseRequisitionsServices.approvalAction(
        {
          approval_id: approvalId,
          status: 'withdraw'
        },
        {comment: $scope.commentText},
        function (resource) {
          $uibModalInstance.close();
          $scope.sending = false;

          if (module === 'budget') {
            $state.reload();
          } else {
            HighlightId.setId($scope.PR._id);
            $state.go('main.user.purchaseRequisitions.manage', {status: 'withdrawn', tab: 'withdrawn'});
          }

          toastr.success('The ' + module + ' has been withdrawn.');
          $scope.message_error = {};

        }, function (error) {
          $uibModalInstance.close();
          $scope.sending = false;
          globalFunc.objectErrorMessage(error);
        }
      );

      $scope.sending = true;
    }
  });

/**
 * Controller for the user delegation modal
 * @param $scope
 * @param $uibModalInstance
 * @param $rootScope
 * @param massDelegate
 * @param toastr
 * @param globalFunc
 * @param selectedCompanies
 * @param getUsersInCompanies
 */

function userDelegationModalCtrl($scope, $uibModalInstance, $rootScope, massDelegate, toastr, globalFunc,
                                 selectedCompanies, getUsersInCompanies) {

  /**
   * Function to get the users array for ui-select based on company(s)
   */
  function getUsersArray() {
    var params = {};
    _.forEach(selectedCompanies, function (companyCode, index) {
      var temp = 'companyCodes[' + index + ']';
      params[temp] = companyCode;
    });

    getUsersInCompanies.get(
      params,
      function (resource) {
        $scope.users = (!!resource && !!resource.content && !!resource.content.data) ?
          resource.content.data : [];

        removeLoggedUserAndEditUser();
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
        $scope.users = [];
      }
    );
  }

  /**
   * Function to remove current logged in user and current edit user from user array
   */
  function removeLoggedUserAndEditUser() {
    var currentLoggedInUser = _.findIndex($scope.users, function (user) {
      return user._id === $rootScope.currentUser._id;
    });

    if (currentLoggedInUser !== -1)
      $scope.users.splice(currentLoggedInUser, 1);

    // If the current user not editing himself i.e. admin editing a user
    if ($scope.user._id !== $rootScope.currentUser._id) {
      var currentEditUser = _.findIndex($scope.users, function (user) {
        return user._id === $scope.user._id;
      });
      $scope.users.splice(currentEditUser, 1);
    }
  }

  function openDatePicker($event, which) {

    /**
     * Setting minimum selection for start date to be today
     */
    $scope.startDateOptions.minDate = new Date();

    /**
     * Setting the minimum selection for end date to be one day ahead of selected start date
     */
    var startDateClone = _.cloneDeep($scope.delegation.startDate);
    var startDate = new Date(startDateClone);
    startDate.setDate(startDate.getDate() + 1);
    $scope.endDateOptions.minDate = startDate;

    $event.preventDefault();
    $event.stopPropagation();

    $scope.datepickerOpened[which] = true;
  }

  function closeModal() {
    $uibModalInstance.close();
  }

  function onUserSelect(userObject) {
    $scope.selectedUser = userObject;
  }

  /**
   * function to check the submitted data
   */
  function checkToSubmit() {

    /**
     * Assign selected start date
     */
    var start_time = globalFunc.convertDateToTimestamp($scope.delegation.startDate);

    /**
     * Assign selected end date
     */
    var end_time = globalFunc.convertDateToTimestamp($scope.delegation.endDate);

    delegate(start_time, end_time, $scope.selectedUser._id);

  }

  /**
   * function to Delegate to another user
   * @param start_time
   * @param end_time
   * @param delegateeID
   * @returns {*}
   */
  function delegate(start_time, end_time, delegateeID) {

    return massDelegate.post(
      {
        userId: (!!$scope.user && !!$scope.user._id) ? $scope.user._id : $rootScope.currentUser._id
      },
      {
        delegatee_id: delegateeID,
        reason: $scope.delegation.reason,
        company_codes: selectedCompanies,
        start_date: start_time,
        end_date: end_time
      },
      function (resource) {
        if (!!resource.content && !!resource.content.data) {
          $uibModalInstance.close('success');
        }
        toastr.success(resource.content.message);
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      });
  }

  function initialize() {

    $scope.datePickerTimezone = $rootScope.datePickerTimezone;
    $scope.delegation = {};

    $scope.onUserSelect = onUserSelect;
    $scope.openDatePicker = openDatePicker;
    $scope.startDateOptions = {
      formatYear: 'yy',
      minDate: new Date(),
      startingDay: 1
    };
    $scope.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };
    $scope.datepickerOpened = {
      start_date: false,
      end_date: false
    };

    $scope.closeModal = closeModal;

    $scope.checkToSubmit = checkToSubmit;

    getUsersArray();
  }

  initialize();
}

userDelegationModalCtrl.$inject = [
  '$scope', '$uibModalInstance', '$rootScope', 'massDelegate', 'toastr', 'globalFunc',
  'selectedCompanies', 'getUsersInCompanies'
];

angular
  .module('metabuyer')
  .controller('userDelegationModalCtrl', userDelegationModalCtrl);

/**
 * @name userDelegation
 *
 * @requires $scope
 * @requires $state
 * @requires $stateParams
 * @requires pathConstants (Metabuyer service)
 * @requires toastr
 * @requires $http
 * @requires $rootScope
 * @requires delegatedToAUser (Metabuyer service)
 * @requires massDelegate (Metabuyer service)
 * @requires delegations (Metabuyer service)
 *
 * @description Directive for delegation settings under profile and user management
 * This directive is for any delegation logic involved
 *
 * Logic involved:
 * search users from the available users, and delegate the tasks to certain user for a period of time
 *
 * @function users
 * Function to get list of users by email or username for typeahead
 *
 * @function delegate
 * Function to Delegate to another user
 *
 * @function checkToSubmit
 * Function to check the submitted data
 *
 * @function removeDelegationFunction
 * Function to remove Delegation
 *
 * @listener:
 * $watcher for disabling the Delegation
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>, Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('userDelegation', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/userDelegation/userDelegationTemplate.html',
      scope: {
        source: '@',
        user: '=?'
      },
      controller: function ($scope, $state, $stateParams, pathConstants, toastr, $http, $rootScope, delegatedToAUser, delegations,
                            globalFunc, $uibModal, massRemoveDelegation) {

        /**
         * Function to generate delegatee object
         * @param data
         */
        function generateDelegateeObject(data) {
          if (!!data && !!data.length) {
            _.forEach($scope.user.companies, function (company) {
              var delegation = globalFunc.findInArray(data, 'company_code', company.code);
              if (!!delegation) {
                company.delegation_id = delegation._id;
                company.delegatee = delegation.delegatee;
                company.delegatedReason = delegation.reason;
                company.delegateStatus = delegation.status;
                company.delegateStartDate = delegation.start_date;
                company.delegateEndDate = delegation.end_date;
              }
            })
          }
        }

        /**
         * returns selected Companies as an array of company codes
         * @returns {Array}
         */
        function getSelectedCompanies() {
          var selectedCompanies = {};
          selectedCompanies.codes = [];
          selectedCompanies.companies = [];
          selectedCompanies.delegationIds = [];

          _.forEach($scope.user.companies, function (company) {
            if (!!company.selected) {
              selectedCompanies.codes.push(company.code);
              selectedCompanies.companies.push(company);

              if (!!company.delegation_id) {
                selectedCompanies.delegationIds.push(company.delegation_id);
              }
            }
          });

          return selectedCompanies;
        }

        /**
         * Function to select all companies
         * @param select
         */
        function selectAllCompanies(select) {
          _.forEach($scope.user.companies, function (company) {
            if(company.descr !== 'System') {
              // Set all selected to true or false
              company.selected = select;
            }
          });
        }

        /**
         * Function to open the delegation modal
         */
        function openDelegationModal() {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/userDelegation/userDelegationModal.html',
            backdrop: 'static',
            keyboard: false,
            scope: $scope,
            controller: userDelegationModalCtrl,
            resolve: {
              selectedCompanies: function () {
                return getSelectedCompanies().codes;
              }
            }
          });

          modalInstance.result.then(function (newValue) {
            if (!!newValue) {
              loadDelegations();
            }
          });
        }

        /**
         * Function to check selected company to add or remove
         * @param action
         * @returns {boolean}
         */
        function checkSelectedCompany(action) {
          var selectedCompanies = getSelectedCompanies();
          var countCompanyHasDelegation = selectedCompanies.delegationIds.length;
          selectedCompanies = selectedCompanies.companies.length;

          if (action === 'add') {
            return (countCompanyHasDelegation === 0 && !!selectedCompanies);
          } else if (action === 'remove') {
            return (!!selectedCompanies && selectedCompanies === countCompanyHasDelegation);
          }
        }

        /**
         * Function to mass remove delegation
         */
        function massRemove() {
          var delegationIds = getSelectedCompanies().delegationIds;

          if (!!delegationIds.length) {
            swal(
              {
                title: 'Confirm remove Delegations',
                text: 'Selected Delegations will be removed',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ed5565',
                confirmButtonText: 'Remove',
                closeOnConfirm: true
              },
              function (confirm) {
                if (!!confirm) {
                  massRemoveDelegation.delete({
                    'ids[]': delegationIds
                  }, function (resource) {
                    if (!!resource && !!resource.content) {
                      clearSelectedCompaniesData();
                      toastr.success(resource.content.message);
                    }
                  }, function (error) {
                    globalFunc.objectErrorMessage(error.data);
                  });
                }
              }
            );
          } else {
            toastr.error('There is no item selected')
          }
        }

        /**
         * Function to clear data for removed delegations
         */
        function clearSelectedCompaniesData() {
          _.forEach(getSelectedCompanies().codes, function (selectedCompanyCode) {
            _.forEach($scope.user.companies, function (company) {
              if (company.code === selectedCompanyCode) {
                company.selected = false;
                company.delegation_id = undefined;
                company.delegatee = undefined;
                company.delegatedReason = undefined;
                company.delegateStatus = undefined;
                company.delegateStartDate = undefined;
                company.delegateEndDate = undefined;
              }
            });
          });
        }

        /**
         * Function to load the delegations
         */
        function loadDelegations() {
          var companyCodes = [];
          _.forEach($scope.user.companies, function (company) {
            if (!!company && !!company.code) {
              companyCodes.push(company.code);
            }
          });

          if (companyCodes.length > 0) {
            delegatedToAUser.get(
              {
                userId: $scope.user._id,
                'company_codes[]': companyCodes
              },
              function (resource) {
                if (!!resource && !!resource.content && (resource.content.data instanceof Array)) {
                  generateDelegateeObject(resource.content.data);
                }
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
        }

        function initialize() {
          $scope.delegation = {};

          $scope.getSelectedCompanies = getSelectedCompanies;
          $scope.selectAllCompanies = selectAllCompanies;
          $scope.openDelegationModal = openDelegationModal;
          $scope.checkSelectedCompany = checkSelectedCompany;
          $scope.massRemove = massRemove;
          loadDelegations();
        }

        initialize();
      }
    }
  });

/**
 * @name userAssignment
 *
 * @description
 * Directive to assign user to company, cost center, roles, position, and superior
 *
 * @param setting
 * Setting is for multiselect setting.
 * Using multiselect inside a custom directive needs to define the setting in controller level
 *
 * @author Deniel Ariesta
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('userAssignment', function (
    companyCostCenters, globalFunc, $q, rolesList, searchModule, userPendingApproval, $uibModal
  ) {
    return {
      restrict: 'E',
      templateUrl: 'components/userAssignment/userAssignmentTemplate.html',
      scope: {
        userId: '=?',
        selectedCompanies: '=',
        selectedCostCenters: '=?',
        companies: '=',
        selectedRoles: '=?',
        selectedSuperiors: '=?',
        selectedPositions: '=?',
        saveDisabled: '='
      },
      controller: function ($scope) {

        $scope.query                        = '';
        $scope.companies                    = $scope.companies || [];
        $scope.selectedCompanies            = $scope.selectedCompanies || [];
        $scope.selectedCostCenters          = $scope.selectedCostCenters || [];
        $scope.selectedCompaniesForListing  = [];
        $scope.usersSuperior                = [];
        $scope.loading                      = false;
        $scope.promisesCount                = 0;
        $scope.multiselectTranslation       = {
          selectAll       : 'Select all',
          selectNone      : 'Select none',
          reset           : 'Reset',
          search          : 'Type here to search...',
          nothingSelected : 'Select'
        };

        $scope.updateQuery              = updateQuery;
        $scope.removeCompany            = removeCompany;
        $scope.onSelectCompany          = onSelectCompany;
        $scope.userId                   = $scope.userId || null;
        $scope.checkPendingApproval     = checkPendingApproval;

        /**
         * run when selecting company
         * @param company
         * @param autoFill for initializing the data
         */
        function onSelectCompany(company, autoFill) {
          if (!!company.ticked) {
            $scope.loading = true;
            ++$scope.promisesCount;
            var tempCompany = angular.copy(company);
            var promises = {
              costCenters: getCompanyCostCenters(tempCompany._id),
              roles: getCompanyRoles(tempCompany.code),
              superior: getCompanyUsers(tempCompany.code)
            };

            // Load promises data
            $q.all(promises).then(
              function (resource) {
                tempCompany.CCs.list = resource.costCenters;
                tempCompany.roles.list = filterArray(resource.roles, 'type', 'unequal', 'ORG_ROLE');
                tempCompany.positions.list = filterArray(resource.roles, 'type', 'equal', 'ORG_ROLE');
                tempCompany.superior.list = resource.superior;

              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            ).catch().finally(function () {

              if(autoFill){
                assignSelectedInfo(tempCompany);
              }

              $scope.selectedCompanies.push(tempCompany);
              // wait for promises to finish load then only insert loaded data
              --$scope.promisesCount;
              if ($scope.promisesCount === 0) {
                $scope.loading = false;
                $scope.saveDisabled = false;
              }

            });
          } else if (!company.ticked) {
            removeCompany(company._id);
          }
        }

        /**
         * Filter Roles based on the type
         * @param array
         * @param key
         * @param operation
         * @param roleType
         */
        function filterArray(array, key, operation, roleType) {
          var tempArr = [];
          _.forEach(array, function (arr) {
            if (operation === 'equal') {
              if (arr[key] === roleType)
                tempArr.push(arr);
            } else {
              if (arr[key] !== roleType)
                tempArr.push(arr);
            }

          });
          return tempArr;
        }

        /**
         * added system to the companies list
         */
        function addSystemToCompanies() {
          var system = {
            _id: 'system',
            code: 'system',
            descr: 'System'
          };
          $scope.companies.unshift(system);
        }

        function addCompaniesInitVal(companies) {
          _.forEach(companies, function (company) {
            // Cost Center init value
            company.CCs = {
              list: [],
              selected: []
            };

            // Roles init value
            company.roles = {
              list: [],
              selected: []
            };

            // Position init value
            company.positions = {
              list: [],
              selected: []
            };

            // Superior init value
            company.superior = {
              list: []
            };
          })
        }

        /**
         * Check all pending approval flow
         * @param {string} companyId
         * @param {string} companyCode
         */
        function checkPendingApproval(companyId, companyCode) {
          userPendingApproval.get(
            {
              userId: $scope.userId,
              companyCode: companyCode
            }, function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data &&
                resource.content.data.length > 0) {
                $uibModal.open({
                  templateUrl: 'components/userAssignment/pendingApprovalList.html',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    approvalFlows: function () {
                      return resource.content.data;
                    }
                  },
                  controller: function ($scope, approvalFlows, $uibModalInstance) {
                    $scope.cancel = cancel;
                    $scope.approvalFlows = approvalFlows;

                    function cancel() {
                      $uibModalInstance.close();
                    }
                  }
                });
              } else {
                removeCompany(companyId, companyCode);
              }
            }, function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        /**
         * remove company manually from the list
         * @param companyId
         * @param {string} companyCode Company code
         */
        function removeCompany(companyId, companyCode) {
          _.forEach($scope.companies, function (company) {
            if (company._id === companyId) {
              company.ticked = false;

              // remove from selected companies in listing
              $scope.selectedCompaniesForListing = globalFunc.removeValueFromArray(
                $scope.selectedCompaniesForListing, '_id', companyId
              );

              // remove from selected companies in selected
              $scope.selectedCompanies = globalFunc.removeValueFromArray(
                $scope.selectedCompanies, '_id', companyId
              );
            }
          });
        }

        /**
         * To update the query value manually
         * @param query
         */
        function updateQuery(query) {
          $scope.query = query;
        }

        /**
         * Retrieve company's cost centers
         * @param companyId
         * @returns {Array}
         */
        function getCompanyCostCenters(companyId) {
          if (!!companyId && companyId !== 'system') {
            var deferred = $q.defer();
            companyCostCenters.get({
              id: companyId
            }, function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data) {
                deferred.resolve(resource.content.data);
              }
            }, function () {
              deferred.resolve([]);
            });
            return deferred.promise;
          }
        }

        /**
         * get company's Roles and Position
         * @param companyCode
         * @returns {Array}
         */
        function getCompanyRoles(companyCode) {
          var deferred = $q.defer();
          var roles = [];
          if (!!companyCode) {
            rolesList.get(
              {
                company_code: companyCode,
                offset: 0
              },
              function (companyRoles) {
                if (!!companyRoles && !!companyRoles.content && !!companyRoles.content.data) {
                  roles = companyRoles.content.data;
                  deferred.resolve(roles);
                }
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
          }
          return deferred.promise;
        }

        /**
         * get company's users
         * @param companyCode
         * @returns {Array}
         */
        function getCompanyUsers(companyCode) {
          if (!!companyCode && companyCode !== 'system') {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'users',
                'criteria[companies][]': companyCode,
                'criteria[status][]': 1, // Get only user with active status
                offset: 0
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content.data || []);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          }
        }

        function assignSelectedInfo(company) {

            if(!!$scope.selectedCostCenters) {
              _.forEach($scope.selectedCostCenters, function (CC) {
                var temp = globalFunc.findInArray(company.CCs.list, '_id', CC._id);
                if (!!temp) {
                  company.CCs.selected.push(temp);
                }
              });
            }

            if(!!$scope.selectedRoles) {
              _.forEach($scope.selectedRoles, function (role) {
                var temp = globalFunc.findInArray(company.roles.list, '_id', role._id);
                if (!!temp) {
                  company.roles.selected.push(temp);
                }
              });
            }

            if(!!$scope.selectedSuperiors) {
              _.forEach($scope.selectedSuperiors, function (superior) {
                if(superior.company_code === company.code) {
                  var temp = globalFunc.findInArray(company.superior.list, '_id', superior._id);
                  if (!!temp) {
                    company.superior.selected = temp;
                  }
                }
              });
            }


            if(!!$scope.selectedPositions) {
              _.forEach($scope.selectedPositions, function (position) {
                var temp = globalFunc.findInArray(company.positions.list, '_id', position._id);
                if (!!temp) {
                  company.positions.selected.push(temp);
                }
              });
            }
        }

        function initialize() {
          addSystemToCompanies();
          addCompaniesInitVal($scope.companies);

          //prepare the list and assigning the data
          if(!!$scope.selectedCompanies){
            var temp = _.cloneDeep($scope.selectedCompanies);
            $scope.selectedCompanies = [];
            _.forEach(temp, function(tempCompany){
              var company = globalFunc.findInArray($scope.companies, '_id', tempCompany._id);
              company.ticked = true;
              tempCompany.ticked = true;
              addCompaniesInitVal([tempCompany]);
              onSelectCompany(tempCompany, true);
            });

          }
        }

        initialize();
      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('tricheckbox', ['$filter', '$document', '$compile', '$parse',
    function ($filter, $document, $compile, $parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attribute) {
          jQuery(element).checkboxX();
        }
      };
    }]);

'use strict';

angular
  .module('metabuyer')
  .directive('treeSelection', function($timeout, $rootScope) {
    return {
      restrict: 'EA',
      scope: {
        model: '=ngModel',
        data: '=data',
        title: '=title',
        selectable: '=selectable',
        level: '=level',
        action: '=action',
        closeTreeSearch: '=closeTreeSearch'
      },
      replace: true,
      templateUrl: 'components/tree-selection/tree-selection.template.html',
      link: function($scope, $element, $attrs) {
        $scope.commodityCodeList = [];
        $scope.ccSelected = {};
        $scope.openingChild = false;
        $scope.openingParent = false;
        $scope.currentParrent = {};

        $scope.selectCC = selectCC;
        $scope.checkLevel = checkLevel;
        $scope.openChildCC = openChildCC;
        $scope.openParent = openParent;
        $scope.randomDate = Date.now();

        /**
         * Open and get child
         * @param cc
         */
        function openChildCC(cc){
          $scope.openingChild = true;
          $scope.openingParent = false;
          $scope.currentParrent = angular.copy(cc);
          $scope.action(cc.unique_name, cc.index);
        }

        function openParent(cc){
          $scope.openingChild = false;
          $scope.openingParent = true;
          $scope.action(cc.parent_unique_name, cc.index);
        }

        //TODO: have a deselect OR reset for the Radio button is the selection could be removed from a parent scope, that if the Radio is still the choice (Ahmed Saleh, 28/4/2016)
        /**
         * To change and send CC data to the parent
         * @param selectedCC
         */
        function selectCC(selectedCC){
          if(!!selectedCC){
            $scope.model = selectedCC;
            $scope.title = selectedCC.code + ' ' + selectedCC.descr;
            $scope.closeTreeSearch= true;
          }
        }

        function checkLevel(ccLevel){
          if($scope.level.indexOf(ccLevel) > -1) return true;
          return false;
        }

        $scope.$watch('data', function(newData){
          $scope.commodityCodeList = newData;
        });
      }
    }
  });

'use strict';

angular
  .module('metabuyer')
  .directive('hoverApprovalFlow', function($compile, $interpolate){
    return{
      restrict: 'C',
      link: function(scope,element,attrs){
        scope.tooltipApproval = function() {
          var content = $(element).find('.tooltip-content');
          // Delete interpolate,
          // return $interpolate(content.html())(scope);
          return content.html();
        };
      }
    }
  });

'use strict';

angular.module('metabuyer')
  .directive('textShowLessMore', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/textShowLessMore/textShowLessMoreTemplate.html',
      scope: {
        model: '=',
        type: '@',
        length: '@',
        breakOnWords: '@?' // split by character case, true: keep the last word
      },
      link: function (scope, element, attribute) {
        scope.$watch('model', function (newValue, oldValue) {
          if (!!newValue) {
            switch (scope.type) {
              default:
              case 'word':
              case 'words': {
                if (!scope.length) scope.length = 25;

                if (!!scope.model) {
                  var inputLines = scope.model.split(/\n/);

                  if (inputLines.length === 1) {
                    var inputWords = scope.model.split(/\s+/);

                    if (inputWords.length > scope.length) {
                      scope.showExpander = true;
                      scope.updatedModel = inputWords.slice(0, scope.length).join(' ') + '...';
                    } else {
                      scope.showExpander = false;
                      scope.updatedModel = undefined;
                    }
                  } else {
                    inputWords = 0;
                    _.forEach(inputLines, function (line, index) {
                      var wordsInLine = line.split(/\s+/);
                      inputWords += wordsInLine.length;
                      if (inputWords > scope.length) {
                        scope.showExpander = true;
                        var inputLines = scope.model.split(/\n/);
                        scope.updatedModel = inputLines.slice(0, index).join('\r\n');
                        scope.updatedModel += '...';
                        return false;
                      }
                    })
                  }
                }

                return scope.model;
              }

              case 'character':
              case 'char':
              case 'characters': {
                if (!scope.length) scope.length = 100;

                if (scope.model && scope.model.length > scope.length) {
                  scope.showExpander = true;
                  scope.updatedModel = scope.model.substring(0, scope.length);
                  if (!scope.breakOnWords)
                    scope.breakOnWords = true;
                  if (!scope.breakOnWords) {
                    var lastSpace = scope.updatedModel.lastIndexOf(' ');
                    if (lastSpace !== -1) {
                      scope.updatedModel = scope.updatedModel.substr(0, lastSpace);
                    }
                  } else {
                    while (scope.updatedModel.charAt(scope.updatedModel.length - 1) === ' ') {
                      scope.updatedModel = scope.updatedModel.substr(0, scope.updatedModel.length - 1);
                    }
                  }
                  return scope.updatedModel += '...';
                }

                if (scope.model && scope.model.length <= scope.length) {
                  scope.showExpander = false;
                  scope.updatedModel = scope.model.substring(0, scope.length);
                  if (!scope.breakOnWords)
                    scope.breakOnWords = true;
                  if (!scope.breakOnWords) {
                    var lastSpace = scope.updatedModel.lastIndexOf(' ');
                    if (lastSpace !== -1) {
                      scope.updatedModel = scope.updatedModel.substr(0, lastSpace);
                    }
                  } else {
                    while (scope.updatedModel.charAt(scope.updatedModel.length - 1) === ' ') {
                      scope.updatedModel = scope.updatedModel.substr(0, scope.updatedModel.length - 1);
                    }
                  }
                  return scope.updatedModel;
                }

                return scope.model;
              }
            }
          }
        });
      }
    }
  });

/**
 * @name tableHeader
 *
 *
 * @description
 *
 * Directive to handle the Sorting in listing (Manage) pages
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('tableHeader', function () {
    return {
      scope: {
        availableHeaders: '=',
        condition: '=?',
        multiSelectAction: '&?',
        searchFunction: '&',
        isApprovalEngine: '=',
        currentStatus: '='
      },
      templateUrl: 'components/tableHeader/tableHeaderTemplate.html',
      restrict: 'A',
      controller: 'tableHeaderCtrl'
    }
  })

  /**
   * @name tableHeaderCtrl
   *
   * @description
   * The controller of the tableHeader directive handles sorting/resetting
   *
   * @author Ahmed Saleh <a.saleh@vventures.asia>
   * @copyright Sunway Metacloud &copy; 2016
   */
  .controller('tableHeaderCtrl', function($scope, $state, $stateParams) {
    $scope.sort = sort;
    $scope.checkSelectionAndCondition = checkSelectionAndCondition;

    function sort(col) {
      /**
       * check if the header is a sortable type or not
       */
      if(!col.unsortable) {

        var orderBy;
        var order;
        if ($stateParams.order_by !== col.id) {
          /**
           * a new header is selected
           */
          orderBy = col.id;
          order = 1;
        } else if ($scope.order === 0) {
          /**
           * the same header is selected and the sort needs to be discarded
           */
          orderBy = null;
          order = null;
        } else {
          /**
           * the same header is selected and the sort needs to be ascending
           */
          orderBy = col.id;
          order = ($scope.order === null ? 1 : 0);
        }

        if ($scope.isApprovalEngine){
          if ($scope.currentStatus.order === 'ASC' && $scope.currentStatus.col === col.id ){
            $scope.currentStatus.order = 'DESC';//if same col press second time
            $scope.order = 0;
          } else if ($scope.currentStatus.order === 'DESC' && $scope.currentStatus.col === col.id ){
            $scope.currentStatus.order = null;//if same col press third time
            $scope.currentStatus.col = null;
            $scope.order = null;
          } else if (($scope.currentStatus.order === null && $scope.currentStatus.col === null) ||
            ($scope.currentStatus.col !== col.id)) {
            $scope.currentStatus.order = 'ASC';//if col first time being press
            $scope.currentStatus.col = col.id;
            $scope.order = 1;
          } else {
            $scope.currentStatus.order = null;
            $scope.currentStatus.col = null;
            $scope.order = null;
          }

          $scope.searchFunction({page: 0, sortingCol: $scope.currentStatus.col, sortingOrder: $scope.currentStatus.order});
          $scope.sortedCol = $scope.currentStatus.col;
        }
        else{
          $state.go($state.current, {order_by: orderBy, order: order, cursor: null});
          getSortingInformation();
        }
      }
    }

    function checkSelectionAndCondition(col) {
      if(col.id === 'check box')
        return false;

      if (col.conditional === true) {
        if (col.condition === $scope.condition) {
          return col.selected;
        }

        if(col.condition instanceof Array){
          for(var i in col.condition){
            if(col.condition[i] === $scope.condition){
              return col.selected;
            }
          }
        }
        return false;
      } else {
        return col.selected;
      }
    }


    function getSortingInformation() {
      $scope.sortedCol = $stateParams.order_by;
      $scope.order = Number($stateParams.order);
      if ($scope.order !== 0 && $scope.order !== 1) {
        $scope.order = null;
      }
    }

    function initialize() {
      getSortingInformation();
    }

    initialize();
  });

'use strict';

/**
 * @name tabDropDown
 *
 * @description
 *
 * A directive for the drop down in the modules
 * the Module can receive a broadcast to activate specific tab with or without transition
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2016
 */

function tabDropDownCtrl ($scope, $state, $location, globalFunc, $rootScope) {

  if (!$scope.tabs) {
    throw new Error('\'data\' attribute not defined, please check documentation for how to use this directive.');
  }

  if (!_.isArray($scope.tabs)) {
    throw new Error('\'data\' attribute must be an array of tab data with at least one tab defined.');
  }

  /**
   * activate the selected tab
   * @param key
   */
  function activate (key) {

    _.forEach($scope.tabs, function (tab) {
      tab.active = false;
      tab.active = tab.key === key;
    });
  }

  /**
   * remove the dynamic tabs addition
   */
  function cleanMoreTabs() {
    _.forEach($scope.tabs.more, function (tab) {
      _.forEach($scope.tabs, function (mainTab) {
        if (tab.key === mainTab.key) {
          $scope.tabs.pop();
          return false;
        }
      });
    });
  }

  /**
   * tabs selection
   * @param tab
   * @param noTransition
   */
  function changeTab(tab, noTransition) {

    if(!$rootScope.isMobileMode) {
      if (tab.type === 'more') {
        cleanMoreTabs();
        $scope.tabs.push(tab);
      }
    }

    if (_.isArray(tab.params)) {
      activate(tab.key);
      if(!noTransition)
        $state.go(tab.route, tab.params[0], tab.options);
    } else {
      activate(tab.key);
      if(!noTransition)
        $state.go(tab.route, tab.params, tab.options);
    }
  }

  /**
   * receives a broadcast to load the previous tab in case the module failed to load data
   */
  $scope.$on('loadPreviousTab', function(){
    if(!!previousTab)
      changeTab(previousTab, true);
  });

  /**
   * receives a broadcast to load the specific tab
   */
  $scope.$on('loadSpecificTab', function(args, data){
    if(!!data && data.tab && data.tab.key)
      changeTab(data.tab, data.noTransition);
  });


  /**
   * activate the tabs in case the params changes
   * Metabuyer has too many options within tabs, so instead of calling them separably,
   * we activate the tab according to the activation key passed
   */
  $scope.$watch(function(){
    return $location.search();
  }, function(value) {
    if (!value || !$scope.activationKey)
      return;

    var tab = globalFunc.findInArray($scope.tabs, 'key', value[$scope.activationKey], true);
    if(!tab && $scope.tabs.more)
      tab = globalFunc.findInArray($scope.tabs.more, 'key', value[$scope.activationKey], true);
    if(!tab)
      return;
    changeTab(tab, true);
  });

  /**
   * activate the tabs in case the state changes
   * we activate the tab according to the state name
   */
  $rootScope.$on('$stateChangeSuccess',
    function (event, state) {
    if(!!$scope.activationKey || !state.name)
      return;

      var tab = globalFunc.findInArray($scope.tabs, 'route', state.name, true);
      if(!tab)
        return;
      changeTab(tab, true);
    });


  function initialize() {
    previousTab = null;
    if(!$scope.tabs || $scope.tabs.length < 1)
      return;

    _.forEach($scope.tabs, function (tab) {
      tab.active = false;
    });

    if(!!$scope.activatedTab && $scope.activatedTab.key)
      changeTab($scope.activatedTab, true);
    else
      changeTab($scope.tabs[0], true);
  }

  initialize();

  $scope.changeTab = changeTab;
  var previousTab = null;
}


angular.module('metabuyer')
  .directive('tabDropDown',function () {
    return {
      restrict: 'E',
      scope: {
        tabs: '=data',
        activeKey: '=',
        activatedTab: '=?',
        activationKey: '=?'
      },
      controller: tabDropDownCtrl,
      templateUrl: function (element, attributes) {
        return attributes.templateUrl || 'ui-router-tabs-default-template.html';
      }
    };
  })
  .run(['$templateCache',
  function ($templateCache) {
    var DEFAULT_TEMPLATE = '<div>' +
      '<tabset class="tab-container">' +
      '  <tab class="tab" ng-repeat="tab in tabs track by $index" heading="{{tab.heading}}" active="tab.active" ng-click="changeTab(tab)" />' +
      '</tabset>' +
      '</div>';

    $templateCache.put('ui-router-tabs-default-template.html', DEFAULT_TEMPLATE);
  }]);

'use strict';
angular.module('metabuyer')
  .directive('supplierNote', function()  {
    return {
      restrict: 'E',
      template: '<div ng-include="template"></div>',
      scope: {
        prid: '=',
        editable: '=',
        status: '=',
        items: '='
      },
      controller: function ($scope, toastr, userImage, supplierNote, prSupplier, prFunction, purchaseRequisitionsServices,
                            globalFunc, $rootScope) {
        $scope.suppliersList = [];
        $scope.supplierId = [];
        $scope.selectedSuppliers = [];
        $scope.notes = [];
        $scope.noteMessage = '';
        $scope.messageExists = false;
        var backupNote = '';
        var backupSuppliers = [];
        $scope.extraSetting = {
          showCheckAll: false
        };
        $scope.textSetting = {
          selectionCount: ' selected',
          buttonDefaultText: 'Select Supplier(s)',
          dynamicButtonTextSuffix: ' selected'
        };

        $scope.submitted = submitted;

        /**
         * To get the supplier list in the PR
         */
        function getListSuppliers() {
          return prFunction.getPRSuppliers();
        }

        /**
         * adding a new Note
         * @param noteMessage
         * @param suppliers
         */
        function addNewNote(noteMessage, suppliers) {
          purchaseRequisitionsServices.addSupplierNote({
            id: prFunction.getPRData()._id
          }, {
            suppliers_ids: suppliers,
            note: noteMessage
          }, function (resource) {
            if (!!resource.content && !!resource.content.data) {
              prFunction.setPRData(resource.content.data);
            }
            $rootScope.$broadcast('refreshComments');
            initialize();
          }, function (error) {
            if (error.content.error !== 'Supplier Ids should be set') {
              globalFunc.objectErrorMessage(error);
            }
          });
        }

        /**
         * updating/removing old note
         * @param noteMessage
         * @param suppliers
         */
        function updateNote(noteMessage, suppliers) {
          purchaseRequisitionsServices.updateSupplierNote({
            id: prFunction.getPRData()._id
          }, {
            note_id: 0,
            suppliers_ids: suppliers,
            note: noteMessage
          }, function (resource) {
            if (!!resource.content && !!resource.content.data) {
              prFunction.setPRData(resource.content.data);
            }
            $rootScope.$broadcast('refreshComments');
            initialize();
          }, function (error) {
            if (error.content.error !== 'Supplier Ids should be set') {
              globalFunc.objectErrorMessage(error);
            }
          });
        }

        /**
         * validating the submission
         * @param noteMessage
         */
        function submitted(noteMessage) {
          var suppliers = reformatSupplierId();
          if (validate(noteMessage)) {
            if (!backupNote) {
              addNewNote(noteMessage, suppliers);
            } else {
              updateNote(noteMessage, suppliers);
            }
          }
        }

        /**
         * checking multiple conditions for vaildation
         * @param noteMessage
         * @returns {boolean}
         */
        function validate(noteMessage) {
          /**
           * no message was typed
           */
          if (!noteMessage || noteMessage === '')
            return false;

          /**
           * no Old message exists
           */
          if (backupNote !== noteMessage) {
            return true;
          }

          /**
           * no supplier is selected yet
           */
          if (!$scope.selectedSuppliers || $scope.selectedSuppliers.length < 1) {
            return false;
          }


          /**
           * the amount of suppliers changed that the note written for
           */
          if ($scope.selectedSuppliers.length !== backupSuppliers.length) {
            return true;
          }

          /**
           * the suppliers changed
           */
          for (var i in $scope.selectedSuppliers) {
            if ($scope.selectedSuppliers[i]._id !== backupSuppliers[i]._id) {
              return true;
            }
          }
          return false;
        }

        /**
         * list of events for the dropdown lists
         * @type {{onItemSelect: Function, onItemDeselect: Function}}
         */
        $scope.noteEvents = {
          onItemSelect: function () {
            submitted($scope.noteMessage);
          },
          onItemDeselect: function (supplier) {
            /**
             * in case all previous note, had suppliers being deselected
             */
            if (!$scope.selectedSuppliers.length && !!$scope.noteMessage) {
              //add a warning
              swal({
                title: 'Delete note',
                text: 'Are you sure you want to delete the note to supplier?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                closeOnConfirm: true,
                closeOnCancel: true
              }, function (isConfirm) {
                if (isConfirm) {
                  $scope.noteMessage = '';
                  updateNote('', []);
                } else {
                  $scope.selectedSuppliers.push(globalFunc.findInArray($scope.suppliersList, 'id', supplier.id));
                }
              });
            } else {
              submitted($scope.noteMessage);
            }
          }
        };

        /**
         * getting the list of suppliers to push the Note too
         * @returns {Array}
         */
        function reformatSupplierId() {
          var suppliers = [];
          _.forEach($scope.selectedSuppliers, function (supplier) {
            /**
             * check if the supplier id is still valid and an item is for that supplier is still there
             */
            if(globalFunc.findInArray(getListSuppliers(), 'id', supplier.id)) {
              suppliers.push(supplier.id);
            }
          });

          return suppliers;
        }

        // To update selected supplier list on item changed/deleted
        function updateSelectedSupplier() {
          $scope.selectedSuppliers = _.intersection($scope.selectedSuppliers, $scope.suppliersList);
        }

        /**
         * init function to load the list of suppliers Then the notes to prepare the drop-down list
         */
        function initialize() {
          $scope.suppliersList = getListSuppliers();
          $scope.template = $rootScope.isMobileMode ? 'components/supplierNotes/supplier-note-mobile.html' :
            'components/supplierNotes/supplier-note.html';
          /**
           * setting the note as well as the suppliers selected
           */
          if (!!prFunction.getPRData().notes_to_suppliers && !!prFunction.getPRData().notes_to_suppliers[0]) {

            /**
             * preparing the data for display
             * @type {*}
             */
            $scope.noteMessage = prFunction.getPRData().notes_to_suppliers[0].note;
            $scope.selectedSuppliers = [];
            _.forEach(prFunction.getPRData().notes_to_suppliers[0].suppliers_ids, function (supplierId) {
              $scope.selectedSuppliers.push(globalFunc.findInArray($scope.suppliersList, 'id', supplierId) || []);
            });

            /**
             * storing back up data for submitting
             * @type {*}
             */
            backupSuppliers = _.cloneDeep($scope.selectedSuppliers);
            backupNote = _.cloneDeep($scope.noteMessage);
          } else {
            backupSuppliers = null;
            backupNote = null;
          }
        }

        initialize();


        $scope.$watch('items', function () {
          initialize();
          updateSelectedSupplier();
        });
      }
    }
  });

/**
 * @name supplierGroup
 *
 * @description
 * Directive for supplier groups used in add and edit supplier
 *
 * @param hideReason (boolean)
 * to show/hide the reason
 *
 * @param editable (boolean)
 * editable status
 *
 * @param data (array)
 * supplier group status data. two ways binding
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('supplierGroup', function (searchModule, globalFunc, $q) {
    return {
      restrict: 'E',
      replace: 'true',
      templateUrl: 'components/supplierGroups/supplierGroups.html',
      scope: {
        hideReason: '=',
        editable: '=',
        data: '=',
        isGlobal: '='
      },
      link: function ($scope) {

        $scope.query                    = '';
        $scope.groups                   = [];
        $scope.selectedGroupForListing  = [];
        $scope.multiselectTranslation   = {
          selectAll       : 'Select all',
          selectNone      : 'Select none',
          reset           : 'Reset',
          search          : 'Type here to search...',
          nothingSelected : 'Select'
        };
        $scope.groupStatuses = [
          {
            status: 1,
            descr: 'active'
          },
          {
            status: 2,
            descr: 'black_listed'
          },
          {
            status: 6,
            descr: 'inactive'
          }
        ];

        $scope.updateQuery          = updateQuery;
        $scope.removeGroup          = removeGroup;
        $scope.onSelectGroup        = onSelectGroup;
        $scope.search               = search;
        $scope.onSelectAll          = onSelectAll;
        $scope.onSelectNone         = onSelectNone;

        function onSelectNone() {
          $scope.selectedGroupForListing = [];
          setDataValue();
        }

        function checkIsGlobalSupplier() {
          var checkStatus = true;

          _.forEach($scope.selectedGroupForListing, function(groupListing) {
            if (Number(groupListing.supplierGroupStatus) !== 1)
              checkStatus = false;
          });

          $scope.isGlobal = checkStatus;
          if (!!$scope.selectedGroupForListing.length)
            $scope.isGlobal = checkStatus && ($scope.groups.length === $scope.selectedGroupForListing.length);
        }

        function onSelectAll() {
          _.forEach($scope.groups, function (group) {
            group.supplierGroupStatus = 1;
            var checkCurrentStatus = globalFunc.findInArray($scope.selectedGroupForListing, '_id', group._id);
            if (!!checkCurrentStatus && !!checkCurrentStatus.supplierGroupStatus)
              group.supplierGroupStatus = Number(checkCurrentStatus.supplierGroupStatus);
          });
          $scope.selectedGroupForListing = angular.copy($scope.groups);
          setDataValue();
        }

        function search(data) {
          if (!data)
            return;
          return (angular.lowercase(data.code).indexOf(angular.lowercase($scope.query)) > -1 ||
            angular.lowercase(data.descr).indexOf(angular.lowercase($scope.query)) > -1);
        }

        /**
         * run when selecting company
         * @param group
         */
        function onSelectGroup(group) {
          if (!!group.ticked) {
            group.supplierGroupStatus = 1;
            $scope.selectedGroupForListing.push(group);
            setDataValue();
          } else if (!group.ticked) {
            removeGroup(group._id);
          }
        }

        /**
         * Load Supplier Group Data
         */
        function loadBUGroup() {
          var params = {
            module: 'business-units',
            offset: 0
          };

          searchModule.get(
            params,
            function(resource) {
              if (!!resource && !!resource.content) {
                $scope.groups = resource.content.data;
                initialSupplierGroup();
                checkIsGlobalSupplier();
              }
            },
            function() {
              $scope.companies = [];
            }
          );
        }

        /**
         * remove company manually from the list
         * @param groupId
         */
        function removeGroup(groupId) {
          _.forEach($scope.groups, function(group) {
            if (group._id === groupId) {
              group.ticked = false;

              // remove from selected Group in listing
              $scope.selectedGroupForListing = globalFunc.removeValueFromArray(
                $scope.selectedGroupForListing, '_id', groupId
              );
            }
          });
          setDataValue();
        }

        /**
         * To update the query value manually
         * @param query
         */
        function updateQuery(query) {
          $scope.query = query;
        }

        function initialSupplierGroup() {
          if ((!!$scope.data && $scope.data.constructor === Array && $scope.data.length === 0) ||
              !$scope.data ||
              $scope.data.constructor === Object)
            $scope.selectedGroupForListing = convertDataToArray($scope.data);
          else
            $scope.selectedGroupForListing = $scope.data;
          setDataValue();
        }

        /**
         * Convert object to array for supplier group
         * @param supplierGroup
         * @returns {Array}
         */
        function convertDataToArray(supplierGroup) {
          var i;
          var group = [];
          for (i in supplierGroup) {
            if (supplierGroup.hasOwnProperty(i)) {
              var buGroup = globalFunc.findInArray($scope.groups, 'code', i);
              if (!!buGroup) {
                buGroup.supplierGroupStatus = Number(supplierGroup[i].status);
                if (!!supplierGroup[i].reason)
                  buGroup.reason = supplierGroup[i].reason;
                group.push(buGroup);
                // set ticked value for multiselect
                $scope.groups = globalFunc.modifyArrayValue($scope.groups, 'code', i, 'ticked', true);
              }
            }
          }
          return group;
        }

        function setDataValue() {
          $scope.data = $scope.selectedGroupForListing;
        }

        function initialize() {
          loadBUGroup();
        }

        initialize();

        $scope.$watch('data', function (newVal, oldVal) {
          if (newVal != oldVal)
            checkIsGlobalSupplier();
        }, true);
      }
    }
  });

'use strict';
//TODO: remove the PR action directives and migrate to action-modal instead (Ahmed Saleh, 3/2/2017)
angular
  .module('metabuyer')
  .directive('submitPr',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/submitPR/submitPRTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'SubmitPRCtrl',
            scope: scope,
            size: "lg",
            resolve: {
              approvals: function($q, $state, $stateParams, Approvals){

                var deferred = $q.defer();

                Approvals.getReviewApproval(
                  {
                    id: $stateParams.id
                  },
                  function(resource){
                    if(!!resource && !!resource.content && !!resource.content.data){
                      deferred.resolve(resource.content.data);
                    } else {
                      deferred.resolve([]);
                    }
                  },
                  function (error){
                    deferred.resolve([]);
                  });

                return deferred.promise;
              }
            }
          });
        };

        function submitPrAction(){
          swal({title: "Submit requisition?",
              showCancelButton: true,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              closeOnConfirm: true,
              closeOnCancel: true
            },
            function(is_confirm){
              if (is_confirm) {
                scope.submitPR();
              }
            });
        }
        //loading the panel
        scope.showSubmitPR = function () {

          scope.onSubmitPR();

          if (scope.validatePR() == false) {

            return;
          }

          if(scope.checkPartialItem()){
            swal({
              title: "You have partial item",
              text: "Are you sure filled the correct data?",
              showCancelButton: true,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function(is_confirm){
              if (is_confirm) {
                submitPrAction();
              }
            });
          } else {
            submitPrAction();
          }

          //panel();
        };
      }
    };
  });

'use strict';

function SubmitPRCtrl($scope, $uibModalInstance, toastr, $q, approvals){

  $scope.approvals = approvals;

  //cancel action
  $scope.cancel = function(){
    $uibModalInstance.close();
  };

  //proceed action
  $scope.confirm = function(){
    $uibModalInstance.close();
    $scope.submitPR();
  };
}

SubmitPRCtrl.$inject = ["$scope", "$uibModalInstance", "toastr", "$q", "approvals"];

angular.module('metabuyer')
  .controller('SubmitPRCtrl', SubmitPRCtrl);

'use strict';

angular
  .module('metabuyer')
  .directive('uppercase', function(uppercaseFilter, $parse) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (!!inputValue) {
            var capitalized = inputValue.toUpperCase();
            if(capitalized !== inputValue) {
              modelCtrl.$setViewValue(capitalized);
              modelCtrl.$render();
            }
            return capitalized;
          }
        }
        var model = $parse(attrs.ngModel);
        modelCtrl.$parsers.push(capitalize);
        capitalize(model(scope));
      }
    };
  });

'use strict';

angular
  .module('metabuyer')
  .directive('ucwords', function(uppercaseFilter, $parse, globalFunc) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (!!inputValue) {
            var capitalized = globalFunc.capitalizeFirstCharacter(inputValue);
            if(capitalized !== inputValue) {
              modelCtrl.$setViewValue(capitalized);
              modelCtrl.$render();
            }
            return capitalized;
          }
        }
        var model = $parse(attrs.ngModel);
        modelCtrl.$parsers.push(capitalize);
        capitalize(model(scope));
      }
    };
  });

/**
 * @name shoppingCart
 *
 * @requires $scope
 * @requires $state
 * @requires $stateParams
 *
 * @description Directive for shopping cart in PR detail
 * This directive is for displaying the html of shopping cart and the logic involved with shopping cart
 *
 * Logic involved:
 * Adding item to cart
 * Removing item from cart
 * Updating the quantity of items in the cart
 *
 * @isolatedScope prItems
 * Isolated scope for parent scope's array of items, pr.items
 * @bindingType Two way binding
 *
 * @isolatedScope prStatus
 * Isolated scope for parent scope's status, pr.status
 * @bindingType Two way binding
 *
 *
 * @isolatedScope grandTotalAmount
 * Isolated scope for parent scope's grand total, grandTotalAmount
 * @bindingType Two way binding
 *
 *
 * @isolatedScope openLineItemDetails
 * Isolated scope for parent scope's function to view line item details, openLineItemDetails(item)
 * @bindingType Expression binding
 *
 * @function isShoppingMode
 * Function to check if PR is in shopping mode state, if yes will display different shopping cart html
 *
 * @function backToDetailPr
 * Function to return to PR details from shopping mode on shopping cart
 *
 * @author Justin Cheong Tian Yee<justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('shoppingCart',function() {
    return{
      restrict: 'EA',
      templateUrl: 'components/shoppingCart/shoppingCartTemplate.html',
      scope: {
        prBilling: '=',
        grandTotalAmount: '=',
        openLineItemDetails: '&',
        prCurrency: '=',
        editingState: '='
      },
      controller: function(
        $scope, $state, $stateParams, toastr, prFunction, pathConstants, purchaseRequisitionsServices, globalFunc,
        $timeout
      ){

        $scope.imageBasePath      = pathConstants.apiUrls.image.pr;

        $scope.submitAmount       = submitAmount;
        $scope.isShoppingMode     = isShoppingMode;
        $scope.backToDetailPR     = backToDetailPR;
        $scope.getPRItems         = getPRItems;
        $scope.getPRStatus        = getPRStatus;
        $scope.openCart           = openCart;
        $scope.PRData             = PRData;
        $scope.viewCart           = viewCart;
        $scope.calculateCartTotal = calculateCartTotal;

        $scope.updateQuantityShoppingCart = updateQuantityShoppingCart;
        $scope.removeItemShoppingCart = removeItemShoppingCart;
        $scope.openLineItemDetailsShoppingCart = openLineItemDetailsShoppingCart;

        function isShoppingMode() {
          return $state.includes('main.user.purchaseRequisitions.details.catalog');
        }


        /**
         * force the form to Blur to bypass the $event.stopPropagation()
         * validate the entry with UOM, and reset
         * @param field
           * @param originalAmount
           * @param uom
           */
        function submitAmount(field, originalAmount, uom) {
          if (validateEntry(field.$data, uom)) {
            field.$form.$submit();
          } else {
            field.$data = originalAmount;
            field.$form.$cancel();
          }
        }

        /**
         * validate the entry with the UOM for the Fraction
         * @param amount
         * @param uom
         * @returns {boolean}
           */
        function validateEntry(amount, uom) {
          if (!amount) {
            toastr.error('Please insert a valid number');
            return false;
          }
          if ((angular.isDefined(uom) && !!uom) && (uom.is_fraction === 0 || !uom.is_fraction)) {
            if (amount % 1 !== 0) {
              toastr.error('This Unit of Measurement does not accept Fractions');
              return false;
            }
          }
          return true;
        }

        function backToDetailPR() {
          if (!!PRData().original_pr) {
            window.history.back();
          } else {
            $state.go('main.user.purchaseRequisitions.details', {id: PRData()._id, PR: {data: PRData()}});
          }
        }

        /**
         * @param item object
         * @param qty
         */
        function updateQuantityShoppingCart(item, qty){
          purchaseRequisitionsServices.setItem({
            id: item._id,
            action: 'qty'
          }, {
            Qty: qty
          }, function(resource) {
            if (!!resource && !!resource.content && !!resource.content.data)
              prFunction.setPRData(resource.content.data);

          }, function(error) {
            globalFunc.objectErrorMessage(error);
            //TODO: handle the error similar to itemList
          });
        }

        /**
         * @param item
         */
        function removeItemShoppingCart(item) {
          prFunction.removeItem(item._id).$promise.then(function (resource) {
            if (!!resource && !!resource.content && !!resource.content.data)
              prFunction.setPRData(resource.content.data);
          }, function (error) {
            globalFunc.objectErrorMessage(error);
            //TODO: handle the error similar to itemList
          });
        }
        /**
         * @param item object
         */
        function openLineItemDetailsShoppingCart(item){
          $scope.openLineItemDetails()(item);
        }

        function getPRItems(){
          return prFunction.getPRData().pr_items;
        }

        function getPRStatus() {
          return prFunction.getPRData().status;
        }

        function PRData() {
          return prFunction.getPRData();
        }


        /**
         * function to ensure the popup cart stays active
         */
        function openCart() {
          $('.dropdown-menu').click(function (event) {
            event.stopPropagation();
          });
        }

        /**
         * opening the Cart from the 'view cart message'
         */
        function viewCart(){
          $scope.itemAdded = false;
          $('#shoppingCartDirective').click(function (event) {
            event.stopPropagation();
            $('#shoppingCartPanel').addClass('show');
          });

        }

        /**
         * remove the pop up once the mouse is out
         */
        $scope.removeClass = function(){
          $('#shoppingCartPanel').removeClass('show');
        };

        /**
         * listener to activate the popup once an item is added
         */
        $scope.$on('itemAdded', function(){
          $scope.itemAdded = true;
          $scope.timer = $timeout(function(){
            $scope.itemAdded = false;
          }, 3000);
        });

        /**
         * calculate the Cart total without adding Taxes or Lump sum
         * @returns {number}
         */
        function calculateCartTotal(){
          var total = 0;
          _.forEach(getPRItems(), function (item) {
            total += item.amount_pr_currency;
          });
          return total;
        }
      }
    }
});

'use strict';
/**
 * @name searchBar Directive
 *
 * @desc Directive for searchBars
 *
 * placeholder: is to accept placeholder
 * searchState: to determine which state to search
 * searchOrderBy: to determine what is the order by of the search results, based on the sortable fields
 * searchOrder: to determine what is the order of the search results, 0 for descending 1 for ascending
 * searchStatus: to determine what status to send on search
 * typeOfQuery: to determine what type of query( query or title )
 * textModel: placing the searched text in case of the page refreshed
 * filters: array of filters to list down the filters for each manage page
 * searchFilter: the selected filter, to set it in case of refresh
 * condition: the conditions in of the filters based on the selected state
 * parentState: the state to back to once a reset function is called
 * parentStateParams: the parameters to be passed to the state of the parent state (removing both Filter and Query)
 *
 *
 * @authors Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */
angular
  .module('metabuyer')
  .directive('searchBar',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/searchBar/searchBarTemplate.html',
      scope: {
        placeholder: '@',
        searchState: '@',
        searchOrderBy: '@',
        searchOrder: '@',
        searchStatus: '@',
        textModel: '@?',
        filters: '=?',
        searchFilter: '@?',
        condition: '=?',
        parentState: '@?',
        parentStateParams: '=?'
      },
      controller: function ($scope, $state) {

        $scope.selectFilter = selectFilter;
        $scope.openDatepicker = openDatepicker;
        $scope.reset = reset;
        $scope.search = search;
        $scope.searchDate = {
          open: false
        };


        function reset() {
          $scope.query = '';
          $scope.searchDate.value = null;
          if(!!$scope.parentState){

            if(!!$scope.parentStateParams) {
              $scope.parentStateParams.filter = null;
              $scope.parentStateParams.query = null;
              $scope.parentStateParams.type = null;
            }
            $state.go($scope.parentState, $scope.parentStateParams);
          }
        }

        function search(query) {
          var tab = {};
          var params;
          tab.route = $scope.searchState;
          tab.heading = 'Search';
          tab.params = {
            status: $scope.searchStatus
          };
          var arr = [];

          if (!!query) {
            params = _.cloneDeep($scope.parentStateParams);
            params.filter = !!$scope.selectedFilter ? $scope.selectedFilter.id : null;
            params.query = query;
            params.cursor = null;
            params.type = undefined;
            params.status = (!$scope.searchStatus ? 'all' : $scope.searchStatus);

            $scope.active = true;
            var double = !!$scope.selectedFilter ? $scope.selectedFilter.type === 'double' : false;
            if(!params.filter || !double || !params.query)
              $state.go($scope.searchState, params);
            else {

              var baseAmount = params.query;
              var number = baseAmount.toString().split('.')[0];
              var decimals = baseAmount.toString().split('.')[1];
              var startDecimals;
              var endDecimals;
              if (!!decimals) {
                if (decimals.length === 1) {
                  startDecimals = decimals + '000';
                  endDecimals = decimals + '999';
                } else if (decimals.length === 2) {
                  startDecimals = decimals + '00';
                  endDecimals = decimals + '99';
                } else if (decimals.length === 3) {
                  startDecimals = decimals + '0';
                  endDecimals = decimals + '9';
                } else {
                  startDecimals = decimals;
                  endDecimals = decimals;
                }
              } else {
                startDecimals = '0000';
                endDecimals = '9999';
              }
              arr =[];
              arr.push(number+'.'+startDecimals);
              arr.push(number+'.'+endDecimals);
              params.query = arr;
              params.type = 'double';
                $state.go($scope.searchState, params);
            }
          }
          /**
           * in case the search was using Date
           */
          else if (!!$scope.searchDate.value) {
            arr = [];
            var startOfDay = (Date.parse(moment($scope.searchDate.value).startOf('day')) / 1000);
            var endOfDay = (Date.parse(moment($scope.searchDate.value).endOf('day')) / 1000);
            arr.push(startOfDay);
            arr.push(endOfDay);

            params = {
              status: tab.params.status,
              query: arr,
              type: 'date',
              filter: !!$scope.selectedFilter ? $scope.selectedFilter.id : null
            };

            $scope.active = true;
            $state.go($scope.searchState, params);
          }

        }

        /**
         * remove the searched test or date and activate which Input to show
         * @param item
         */
        function selectFilter(item) {
          if (!!item.type && $scope.searchType !== item.type) {
            $scope.query = '';
            $scope.searchDate = {};
          }
          $scope.searchType = !!item.type ? item.type : 'text';
          $scope.selectedFilter = item;
        }

        /**
         * filter the dropdown based on the sortable and condition
         */
        function prepareFilteredList(){

          if (!!$scope.filters) {
            $scope.filtersList = [];
            for (var i in $scope.filters) {
              /**
               * the condition to check if unsearchable column as well as the date
               * the dates will have a different treatment once supported
               */
              if (!$scope.filters[i].unsearchable) {
                if ($scope.filters[i].conditional) {
                  for(var j in $scope.filters[i].condition){
                    if ($scope.condition === $scope.filters[i].condition[j]) {
                      $scope.filtersList.push($scope.filters[i]);
                    }
                  }
                }
                else {
                  $scope.filtersList.push($scope.filters[i]);
                }
              }
            }
            $scope.filtersList.splice(0, 0, {
              label: 'All filters',
              id: null
            });
            selectFilter($scope.filtersList[0]);
          }
        }

        function openDatepicker($event) {

          $event.preventDefault();
          $event.stopPropagation();
          $scope.searchDate.open = true;
        }

        function initialize() {

          prepareFilteredList();

          /**
           * setting the selected dropdown option in case of Refresh
           */
          for (var i in $scope.filtersList) {
            if ($scope.filtersList[i].id === $scope.searchFilter) {
              selectFilter($scope.filtersList[i]);
              break;
            }
          }

          if (!!$scope.selectedFilter && $scope.selectedFilter.type === 'date') {
            $scope.searchType = 'date';
          }
          else if (!!$scope.selectedFilter && $scope.selectedFilter.type === 'double') {
            $scope.searchType = 'double';
          }
          else {
            $scope.searchType = 'text';
          }
          /**
           * checking if the data can be parsed into an array or is it a text
           */
          if ($scope.searchType === 'double') {
            $scope.query = Number($scope.textModel);
          } else {
            try {
              $scope.searchDate.value = (JSON.parse($scope.textModel)[0]) * 1000;
            } catch (e) {
              $scope.query = $scope.textModel;
            }
          }
        }

        initialize();

        /**
         * listener to change the list in case of a change of a status in the manage screen
         */
        $scope.$watch('condition', function(newV, oldV){
          if(oldV !== newV) {
            $scope.selectedFilter = {};
            prepareFilteredList();
          }
        });

        /**
         * listener to change the list in case of a change of a status in the manage screen
         */
        $scope.$watch('filters', function(newV, oldV){
          if(!!newV && newV !== oldV) {
            $scope.query = '';
            $scope.searchDate = {};
            prepareFilteredList();
          }
        });

      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('scoreChart', [function() {
    return {
      restrict: 'AE',
      scope: {
        score: '='
      },
      templateUrl: 'components/scorechart/scorechartTemplate.html',
      link: function (scope, el, attrs, ctrl) {
        scope.score = parseInt(scope.score);

        if(isNaN(scope.score)){
          scope.score = 0;
        }

        scope.style = {
          height: scope.score + '%'
        };
      }
    };
  }]);

'use strict';
angular
    .module('metabuyer')
    .directive('rolesSelectionPanel',function($uibModal) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, element, attrs) {
        var panel = function (selectedCompany) {
          $uibModal.open({
            templateUrl: 'components/rolesSelectionPanel/rolesSelectionTemplate.html',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              user: function(){
                return scope.user
              },
              selected_company: function() {
                return scope.selected_company
              },
              companyRoles: function ($q, rolesList) {
                var deferred = $q.defer();
                rolesList.get(
                  {
                    company_code: selectedCompany.code,
                    offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content.data);
                    }
                  },
                  function (error) {
                    if (error.status === 404) {
                      deferred.resolve([]);
                    }
                  }
                );
                return deferred.promise;
              },
              semanticRoles: function ($q, rolesList) {
                var deferred = $q.defer();
                rolesList.get(
                  {
                    company_code: 'system',
                    offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content.data);
                    }
                  },
                  function (error) {
                    if (error.status === 404) {
                      deferred.resolve([]);
                    }
                  }
                );
                return deferred.promise;
              }
            },
            controller: 'roleSelectionCtrl'
          });
        };
        scope.openRolesModal = function (selectedCompany) {
          panel(selectedCompany);
        }
      }
    };
  })
  .controller('roleSelectionCtrl',
    function ($scope, user, selected_company, rolesList, singleUser, semanticRoles, companyRoles, $state, userPosition,
              toastr, $uibModalInstance) {
      $scope.rolesList = semanticRoles.concat(companyRoles);
      $scope.user = user;
      $scope.selected_company = selected_company;
      $scope.addNewRole = addNewRole;
      $scope.removeRole = removeRole;
      $scope.closeModal = closeModal;
      $scope.state = $state.current.name;
      function closeModal() {
        $uibModalInstance.close();
      }

      function addNewRole(newRole) {
        swal({
            title: "Confirmation",
            text: "Confirm add new role?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function(isConfirm) {
            if (isConfirm) {
              var tempRolesIds = [];
              //move the ids of the Roles in  a new array to push to the backend right now the User list returned from
              // the backend is just text and wil be updated to an object of id
              for(var i in $scope.user.roles){
                if( newRole._id === $scope.user.roles[i]._id){
                  toastr.error('Cannot add same role again');
                  return false;
                }
                else {
                  tempRolesIds.push($scope.user.roles[i]._id);
                }
              }
              tempRolesIds.push(newRole._id);
              if($scope.state === 'main.user.users.add'){
                toastr.success('Role added successfully');
                user.roles.push(newRole);
                $scope.user.roles_id.push(newRole._id);
              }
              else {
                singleUser.put(
                  {
                    id: user._id
                  },
                  {
                    roles: tempRolesIds
                  }, function () {
                    toastr.success('Role added successfully');
                    user.roles.push(newRole);
                  },
                  function () {
                    toastr.error('Failed to add role');
                    return false;
                  }
                );
              }
            }
          }
        );
      }

      /**
       * Filter the roles returned by the type === 'ORG_ROLE'
       * ORG_ROLE is for position and used in approval flow
       */
      function filterRoles(){
        var tempRoles = [];
        _.forEach($scope.rolesList, function(role){
          if(role.type !== 'ORG_ROLE')
            tempRoles.push(role);
        });
        $scope.rolesList = tempRoles;
      }

      function removeRole(index) {

        swal({
            title: "Confirmation",
            text: "Confirm remove role?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function(isConfirm) {
            var newRole = {};
            if(!!isConfirm){
              var tempRolesIds = [];
              //move the ids of the Roles in  a new array to push to the backend right now the User list returned from
              // the backend is just text and wil be updated to an object of id
              for(var i in $scope.user.roles){
                $scope.user.roles[i]._id ? tempRolesIds.push($scope.user.roles[i]._id) : null;
              }

              newRole = $scope.user.roles[index];
              tempRolesIds.splice(index, 1);

              if($scope.state === 'main.user.users.add'){
                toastr.success('Role removed');
                user.roles.splice(index, 1);
                $scope.user.roles_id.splice(index, 1);
              } else {
                singleUser.put(
                  {
                    id: user._id
                  },
                  {
                    roles: tempRolesIds
                  }, function () {
                    toastr.success('Role removed');
                    user.roles.splice(index, 1);
                  },
                  function () {
                    toastr.error('Role remove failed');
                    return false;
                  }
                );
              }
            }
          }
        );
      }

      function initialize(){
        filterRoles();
      }

      initialize();
    }
  );

'use strict';
angular
  .module('metabuyer')
  .directive('reverseGoods',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/reverseGoods/reverseGoodsTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ReverseGoodsCtrl',
            scope: scope,
            windowClass: 'reverse-goods-modal'
          });
        };

        //loading the panel
        scope.showReverseGoods = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('ReverseGoodsCtrl', function ($scope, $uibModalInstance, Orders, toastr, HighlightId, pathConstants,
                                            $http, $filter, $state) {
    $scope.next_reverse_goods = true;
    $scope.back_reverse_goods = false;
    $scope.enable_next = false;
    $scope.submit_data = {};

    $scope.reverse_goods_data = [];

    $scope.nextReverseGoods = nextReverseGoods;
    $scope.cancel = cancel;
    $scope.backReverseGoods = backReverseGoods;
    $scope.processReverseGoods = processReverseGoods;
    $scope.initialize = initialize;
    $scope.convertToInt = convertToInt;

    //next action
    function nextReverseGoods(){
      $scope.next_reverse_goods = false;
      $scope.back_reverse_goods = true;
    }

    function convertToInt(number) {
      return Number(number);
    }

    //cancel action
    function cancel(){
      $uibModalInstance.close();
    }

    //back action
    function backReverseGoods(){
      $scope.next_reverse_goods = true;
      $scope.back_reverse_goods = false;
    }

    $scope.$watch("reverse_goods_data", function(value){
      var fill_up_wrong = _.find($scope.reverse_goods_data, function(item){
        return Number(item.reversed_amount) != 0 &&
          (Number(item.reversed_amount) > Number(item.po_item.quantity) ||
          Number(item.reversed_amount) > Number(item.po_item.order.delivered));
      });

      if(fill_up_wrong != undefined){
        $scope.enable_next = false;
      }
      else{
        var fill_up_right = _.find($scope.reverse_goods_data, function(item){
          return !!item.reversed_amount && item.reversed_amount != 0;
        });

        if(fill_up_right != undefined){
          $scope.enable_next = true;
        } else {
          $scope.enable_next = false;
        }
      }
    }, true);

    function checkFraction(item) {
      if(!!item.po_item && !!item.po_item.uom) {
        if (!item.po_item.uom.is_fraction || item.po_item.uom.is_fraction === 0) {
          if (item.reversed_amount % 1 !== 0) {
            toastr.error('Unit of Measurement of item number ' + (Number(item.POIndex) + 1) +' does not allow amount in fraction');
            return false;
          }
        }
      }
      return true;
    }
    //proceed action
    function processReverseGoods(){

      var fd = new FormData();
      var validFraction = true;
      for(var i in $scope.reverse_goods_data) {
        var item = $scope.reverse_goods_data[i];
        if (item.reversed_amount && (item.reversed_amount <= item.po_item.quantity
          || item.reversed_amount <= item.po_item.order.delivered)) {
          validFraction = checkFraction(item);
          if (!validFraction) {
            break;
          }
          fd.append("items[" + item.POIndex + "]", item.reversed_amount);
        }
      }

      if(!!$scope.submit_data.comment){
        fd.append('comment', $scope.submit_data.comment);
      }

      if(validFraction) {
        $uibModalInstance.close();

        $http.post($filter('format')(pathConstants.apiUrls.po.reverse, {po_id: $scope.po._id}), fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          })
          .then(function onSuccess () {
            toastr.success('PO has been reversed');

            HighlightId.setId($scope.po._id);
            $state.go('main.user.orders.manage', {status: 'AWAITING_DELIVERY'});
          })
          .catch(function onError () {
            toastr.error('Failed to reverse PO');
          });
      }
    }

    function initialize(){
      _.forEach($scope.po.items, function(item, i){
        $scope.reverse_goods_data.push({po_item: item, reversed_amount: 0, POIndex: i});
      });
    }

    $scope.initialize();
  });

'use strict';
angular
  .module('metabuyer')
  .directive('resetField', ['$compile', '$timeout', function ($compile, $timeout) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        right: '=?',
        resetField: '&resetField',
        ngModel: '=?'
      },
      link: function (scope, el, attrs, ctrl) {
        // limit to input element of specific types
        var inputTypes = /text|search|tel|url|email|password|number/i;
        if (el[0].nodeName !== "INPUT") {
          throw new Error("resetField is limited to input elements");
        }
        if (!inputTypes.test(attrs.type)) {
          throw new Error("Invalid input type for resetField: " + attrs.type);
        }
        if (!scope.right)
          scope.right = 0;
        // compiled reset icon template
        var template = $compile('<i ng-show="enabled" ng-mousedown="reset()" class="fa fa-remove" style="position: absolute; right: ' + scope.right+ 'px; top: 0; bottom: 0; height: 14px; margin: auto; font-size: 14px; cursor: pointer; color: #ccc; z-index: 999"></i>')(scope);
        el.after(template);

        scope.reset = function () {
          ctrl.$setViewValue(null);
          ctrl.$render();
          if (typeof scope.resetField == 'function') {
            scope.resetField();
          }
          $timeout(function () {
            el[0].focus();
          }, 0, false);
        };

        scope.watchNgModel = scope.$watch("ngModel", function(value) {
          scope.enabled = !ctrl.$isEmpty(value);
        });

        scope.$on('$destroy', function() {
          scope.watchNgModel();
        });

        el.bind('input', function () {
          scope.enabled = !ctrl.$isEmpty(el.val());
        })
          .bind('focus', function () {
            scope.enabled = !ctrl.$isEmpty(el.val());
            _.defer(function() {
              scope.$apply();
            });
          })
          .bind('blur', function () {
           // scope.enabled = false;
            _.defer(function() {
              scope.$apply();
            });
          });
      }
    };
  }]);

'use strict';
angular
  .module('metabuyer')
  .directive('resendPo',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/resendPO/resendPOTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ResendPOCtrl',
            scope: scope
          });
        };

        //loading the panel to comment
        scope.showResendPO = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('ResendPOCtrl', function ($scope, $rootScope, $uibModalInstance, Orders, toastr) {

    //cancel
    $scope.cancelResendPO = cancelResendPO;
    $scope.resend = resend;

    function cancelResendPO(){
      $uibModalInstance.close();
    }

    //send action
    function resend(poid){

      $uibModalInstance.close();

      Orders.resendPO({id: poid}, function(){
        toastr.success('Resent to supplier');

        //emit refresh history
        $rootScope.$broadcast('refreshComments');

      }, function(){
        toastr.error('Failed to resent to supplier');
      });
    }
  });


'use strict';
angular
  .module('metabuyer')
  .directive('receiveGoods',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/receiveGoods/receiveGoodsTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ReceiveGoodsCtrl',
            scope: scope,
            windowClass: 'receive-goods-modal'
          });

        };
        //loading the panel
        scope.showReceiveGoods = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('ReceiveGoodsCtrl', function (
    $scope, $uibModalInstance, Orders, toastr, HighlightId, pathConstants, $http, $filter,$timeout,$state,globalFunc
  ) {
    $scope.next_receive_goods = true;
    $scope.back_receive_goods = false;
    $scope.check_for_all = false;
    $scope.enable_upload_do = true;
    $scope.submit_data = {};
    $scope.do_uploader = {};
    $scope.received_date = null;
    $scope.receive_goods_data = [];
    $scope.reopenStatus = false;
    $scope.copyCommentData = $scope.commentData;
    $scope.do_dates = { do_date: {}};
    $scope.doDatepickerOpened = false;
    $scope.submitted = false;

    $scope.uploadPO = uploadPO;
    $scope.cancel = cancel;
    $scope.backOnReceiveGoods = backOnReceiveGoods;
    $scope.checkAllItemReceived = checkAllItemReceived;
    $scope.doneReceiveGoods = doneReceiveGoods;
    $scope.reopenItem = reopenItem;
    $scope.getClosedDetail = getClosedDetail;
    $scope.openDatePicker = openDatePicker;
    $scope.parseToInt = parseToInt;
    $scope.doCheck = false;
    $scope.dateCheck = false;

    //Variable to capture current date
    var currentDate = new Date();
    $scope.tempcurrentDate = currentDate;
    //Formatting the current date to MMM dd, yyyy
    $scope.formattedCurrentDate = currentDate;

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: new Date
    };

    $scope.datePicker = {
      openDatepicker: function($event,index) {
        if($scope.receive_goods_data[index].datepickerOpened) {
          $event.preventDefault();
          $event.stopPropagation();
        }
        else{
          $scope.receive_goods_data[index].datepickerOpened = true;
        }
      }
    };

    function openDatePicker($event) {
      if($scope.doDatepickerOpened){
        $event.preventDefault();
        $event.stopPropagation();
      }
      else{
        $timeout(function(){
          $scope.doDatepickerOpened = true;
        })
      }
    }

    //next action
    function uploadPO(){
      $scope.next_receive_goods = false;
      $scope.back_receive_goods = true;
    }

    //cancel action
    function cancel(){
      $uibModalInstance.close();
    }

    //back action
    function backOnReceiveGoods(){
      $scope.next_receive_goods = true;
      $scope.back_receive_goods = false;
    }

    function parseToInt(number) {
      return Number(number);
    }

    function checkAllItemReceived(){
      if($scope.check_for_all){
        _.forEach($scope.receive_goods_data, function(item, key){
          item.received_amount = Number(item.po_item.remaining_quantity);
          //ensure the item closed flag is removed
          reopenItem(key);
        });
      } else {
        _.forEach($scope.receive_goods_data, function(item){
          item.received_amount = 0;
        });
      }
    }

    $scope.$watch('receive_goods_data', function(value){
      var fill_up_wrong = _.find($scope.receive_goods_data, function(item){
        return item.received_amount != 0 &&
          (item.received_amount > item.po_item.remaining_quantity);
      });

      if(fill_up_wrong != undefined){
        $scope.enable_upload_do = false;
      }
      else{
        var fill_up_right = _.find($scope.receive_goods_data, function(item){
          return (angular.isDefined(item.received_amount && item.received_amount != 0));
        });

        if(fill_up_right != undefined){
          $scope.enable_upload_do = true;
        } else {
          $scope.enable_upload_do = false;
        }
      }

      //enable check for all
      var validateCheckAll = _.find($scope.receive_goods_data, function(item){
        return Number(item.received_amount) + Number(item.po_item.order.delivered) != item.po_item.quantity;
      });

      $scope.check_for_all = (validateCheckAll === undefined);

    }, true);


    function validateFileType(){
      if(angular.isDefined($scope.submit_data.do_file)){
        var extensions = ['application/pdf','image/png','application/msword','image/jpg',
                          'image/jpeg','text/plain'];
        var fileType = $scope.submit_data.do_file.type;
        for(var i = 0; i < extensions.length; i++){
          if(fileType === extensions[i]){
            return true;
          }
        }
        return false;
      }else
      {
        /**
         * no file is uploaded, its not Mandatory so no need to verify
         */
        return true;
      }
    }

    //done action
    function doneReceiveGoods(){
      $scope.submitted = true;

      if(validateFileType() === false){
        toastr.error('Invalid file format! Allowed extensions are: .pdf,.png,.doc,.jpg,.jpeg,.txt');
        $scope.submit_data.do_file = {};
        return;
      }

      if(validateEntries() === false){
        return;
      }


        var fd = new FormData();

        if (angular.isDefined($scope.do_dates.do_date) && angular.isDefined($scope.submit_data.do_number)) {
          var doDate = new Date($scope.do_dates.do_date);
          fd.append('do_date', doDate.getTime());
        }

        if (angular.isDefined($scope.submit_data.do_file)) {
          fd.append('do_file', $scope.submit_data.do_file);
        }

        if (angular.isDefined($scope.submit_data.do_number)) {
          fd.append('do_number', $scope.submit_data.do_number);
        }

        if (!$scope.check_for_all) {
          _.forEach($scope.receive_goods_data, function (item) {

            if (item.received_amount && (item.received_amount <= item.po_item.remaining_quantity)) {
              fd.append('items[' + item.POIndex + ']', item.received_amount);
            }

          });
        } else {
          fd.append('items', 'all');
        }

        _.forEach($scope.receive_goods_data, function (item) {
          if (item.received_amount && (item.received_amount <= item.po_item.remaining_quantity)) {
            var receivedDate = new Date(item.received_date);
            fd.append('items_dates[' + item.POIndex + ']', receivedDate.getTime());
          }
        });

      if (angular.isDefined($scope.submit_data.comment)) {
          fd.append('comment', $scope.submit_data.comment);
        }



        $http.post($filter('format')(pathConstants.apiUrls.po.receive, {po_id: $scope.po._id}), fd, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        })
          .then(function onSuccess () {
            toastr.success('DO has been submitted');
            /**
             * Loops for each receive goods item
             */
            for(var i in $scope.receive_goods_data) {
              /**
               * Check if the PO is still partially delivered, break out of loop if true
               */
              var totalAmountReceived = math.subtract(math.bignumber($scope.receive_goods_data[i].received_amount),
                math.bignumber($scope.receive_goods_data[i].po_item.order.delivered));
              totalAmountReceived = math.format(totalAmountReceived, {precision: 64});
              if (totalAmountReceived < Number($scope.receive_goods_data[i].po_item.quantity)) {
                /**
                 * If PO is still partially delivered, state transition to awaiting delivery
                 */
                HighlightId.setId($scope.po._id);
                $state.go('main.user.orders.manage', {status: 'AWAITING_DELIVERY'});
                $uibModalInstance.close();
                return false;
              }
            }
            $uibModalInstance.close();
            HighlightId.setId($scope.po._id);
            $state.go('main.user.orders.manage', {status: 'CLOSED'});
          })
          .catch(function onError (error) {
            if(!!error.data.content && angular.isDefined(error.data.content.error) && !!error.data.content.error) {
              if(typeof error.data.content.error === 'string') {
                var errorstr = error.data.content.error.toLowerCase();
                if (errorstr.indexOf('do number') > -1 && errorstr.indexOf('used') > -1) {
                  $scope.doCheck = true;
                  $scope.backupDONumber = angular.copy($scope.submit_data.do_number);
                }

                if (errorstr.indexOf('date') > -1)
                  $scope.dateCheck = true;

                toastr.error(error.data.content.error);

              }
              else
                globalFunc.objectErrorMessage(error);
            }
            else{
              toastr.error('Failed to submit DO');
            }
          });
    }

    function reopenItem(index) {
      $scope.receive_goods_data[index].po_item.closed = false;
    }

    function getClosedDetail(id) {
      if(typeof id !== undefined || typeof id !== null){
        var closedItemComment = _.find($scope.copyCommentData, function(comment){
          return comment._id == id;
        });

        if(typeof closedItemComment !== undefined || typeof closedItemComment !== null) {
          if(_.has(closedItemComment, 'updated_at')){
            var _date = $filter('date')(new Date(closedItemComment.updated_at), 'dd MMM yyyy');
            return _date + ', ' + 'by: ' + closedItemComment.commentator.data.display_name;
          }
        } else
          return '';
      }
      return '';
    }

    function initialize(){
      _.forEach($scope.po.items, function(item, i){
        item.remaining_quantity = math.subtract(math.bignumber(item.quantity), math.bignumber(item.order.delivered));
        item.remaining_quantity = math.format(item.remaining_quantity, {precision: 64});

        if(item.remaining_quantity <= 0)
          return;

        $scope.received_date = $scope.formattedCurrentDate;
        $scope.do_dates.do_date = $scope.formattedCurrentDate;

        $scope.receive_goods_data.push(
          {
            po_item: item,
            received_amount: 0,
            received_date: $scope.received_date,
            POIndex: i
          }
        );
      });
    }

    /**
     * function to validation the Amount existed as well as the if the fraction is valid for a specific UOM
     * @param amount
     * @param uom
     * @returns {boolean}
       */
    function validateAmountAndFraction(amount, uom) {
      if(!amount){
        toastr.error('please add amount of good received');
        return false;
      }
      if (!uom.is_fraction || uom.is_fraction === 0) {
        if (amount % 1 !== 0) {
          toastr.error('Unit of Measurement does not allow amount in fraction');
          return false;
        }
      }
      return true;
    }

    /**
     * Loop on all GRN and validate each GRN entry
     * @returns {boolean}
     */
    function validateEntries() {

      if (!$scope.submit_data.do_number || !$scope.submit_data.do_number.length) {
        return false;
      }

      if (!$scope.do_dates.do_date) {
        return false;
      }

      if ($scope.receive_goods_data.length === 1 && Number($scope.receive_goods_data[0].received_amount) === 0)
        return false;

      for (var i in $scope.receive_goods_data) {
        if (Number($scope.receive_goods_data[i].received_amount) !== 0)
          return validateAmountAndFraction(
            $scope.receive_goods_data[i].received_amount,
            $scope.receive_goods_data[i].po_item.uom
          );
      }
    }

    initialize();

  });


'use strict';

function reLogInCtrl ($scope, $uibModalInstance, $uibModalStack, $auth, $state, currentStateData, email, ManageLocalStorage, $rootScope, message) {
  $scope.currentStateData = currentStateData;
  $scope.email = email;
  $scope.message = message;
  $scope.attempt = true;
  $scope.login = function () {
    $scope.error = null;
    $auth.login({email: $scope.email, password: $scope.password})
      .then(function () {
        $rootScope.reLoginDialogOpen = false;
        $uibModalInstance.close(false);
        $state.go(currentStateData.name, currentStateData.params);
      })
      .catch(function (response) {
        if (!!response && !!response.data && !!response.data.message) {
          $scope.error = response.data.message;
          $scope.errorCount = response.data.login_attempts_remaining;
        } else {
          $scope.error = 'An unexpected error has occurred. Please try again later.';
        }
      });
  };

  $scope.logout = function () {
    ManageLocalStorage.clearLocalStorage();
    $auth.logout().then(function () {
      $rootScope.reLoginDialogOpen = false;
      $uibModalStack.dismissAll();
    });
    $scope.password = '';
    $state.go('login');
  };

}

reLogInCtrl.$inject = ['$scope', '$uibModalInstance', '$uibModalStack', '$auth', '$state', 'currentStateData', 'email', 'ManageLocalStorage', '$rootScope', 'message'];

angular.module('metabuyer')
  .controller('reLogInCtrl', reLogInCtrl);

'use strict';
angular
  .module('metabuyer')
  .directive('progressItem', function(notify, $stateParams, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        value: '=',
        default: '='
      },
      template: '<progressbar value="progress" type="{{checkType(progress)}}" animate="true">{{ progress }}%</progressbar>',
      link: function ($scope, $element, $attrs, $controller) {
        $scope.progress = 0;

        $timeout(function(){
          $scope.progress = !$scope.value ? 0 : parseDecimal($scope.value);
        }, 300);

        $scope.checkType = function(progress){
          var types = ['danger', 'warning', 'navy'];

          if(typeof($attrs.default) !== 'undefined'){
            return $attrs.default != '' ? $attrs.default : types[2];
          }

          var index = parseInt(progress/33);
          if(index > types.length-1){
            return types[types.length-1];
          }
          return types[index];
        }

        function parseDecimal(value){
          return parseInt(value.toFixed(0));
        }
      }
    };
  });


/**
 * @name prWarningBlock
 *
 * @requires $scope
 * @requires itemDetailsInformation
 *
 * @description Directive for displaying a warning block on PR if conditions are met
 *
 * @isolatedScope data
 * Two way binded scope for pr items
 *
 * @isolatedScope pr
 * Two way binded scope for pr
 *
 * @isolatedScope unavailableItems
 * Two way binded scope for unavailable items
 *
 * @function getNumberOfIncompleteItem
 * Function to get the number of incomplete items (currently unused 1/12/16)
 *
 * @function getNumberOfNonCatalogItem
 * Function to get the number of non catalog items in the PR
 *
 * @function getNumberOfMissingData
 * Function to get number of missing data from incomplete items in more detail (currently unused 1/12/16)
 *
 * @function getNumberOfItemsChanged
 * Function to get number of items with changed data
 *
 * @function getNumberOfZeroPriceItems
 * Function to get number of items with zero price
 *
 * @author Justin Cheong Tian Yee<justin.cty90@gmail.com>
 *         Udhayan Nair
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('prWarningBlock', function ($rootScope) {
    return {
      restrict: 'E',
      templateUrl: function(){
        return $rootScope.isMobileMode ? 'components/prWarningBlock/prWarningBlockTemplate-mobile.html' :
          'components/prWarningBlock/prWarningBlockTemplate.html';
      },
      scope: {
        data: '=',
        pr: '=',
        unavailableItems: '='
      },
      controller: function ($scope, itemDetailsInformation, prFunction) {

        //TODO: Have a function for when incomplete item is implemented (Justin 30/11/16)

        function getNumberOfZeroPriceItems() {
          var zeroPrice = _.filter($scope.data, function (item) {
            return item.unit_price === 0;
          });

          $scope.numberOfZeroPriceItem = zeroPrice.length;
        }

        /**
         * Function to get pr_related_data_changes
         * 1 for billing address
         * 2 for delivery address
         * 3 for creator deletion
         * 4 for creator deactivation
         * 5 for requestor deletion
         * 6 for requestor deactivation
         * 7 for expense type deactivated
         * 8 for expense type deleted
         */
        function getPRDataChanged(){
          if(!!$scope.pr.pr_related_data_changes){
            _.forEach($scope.pr.pr_related_data_changes, function(prChanges){
              switch (prChanges) {
                case 1:
                  $scope.prDeliveryAddressChanged = true;
                  break;
                case 2:
                  $scope.prBillingAddressChanged = true;
                  break;
                case 3:
                  $scope.prCreatorDeleted = true;
                  break;
                case 4:
                  $scope.prCreatorDeactivated = true;
                  break;
                case 5:
                  $scope.prRequestorDeleted = true;
                  break;
                case 6:
                  $scope.prRequestorDeactivated = true;
                  break;
                case 7 :
                  $scope.prExpenseTypeDeleted = true;
                  break;
                case 8 :
                  $scope.prExpenseTypeDeactivated = true;
                  break;
                case 13 :
                  $scope.prCurrencyDeactivated = true;
                  break;
                case 14 :
                  $scope.prCurrencyDeleted = true;
                  break;
                case 15 :
                  $scope.prCurrencyUnassignedFromCompany = true;
                  break;
                case 18 :
                  $scope.prCostCenterDeleted = true;
                  break;
                case 19 :
                  $scope.prBillAddressUnassigned = true;
                  break;
                case 20 :
                  $scope.prDeliveryAddressUnassigned = true;
                  break;
                case 21 :
                  $scope.prExpenseTypesUnassigned = true;
                  break;
                }
            });
          }
        }

        function getNumberOfNonCatalogItem() {
          var nonCatalog = _.filter($scope.data, function (item) {
            return item.item_details.is_stock === 0;
          });

          $scope.numberOfNonCatalogItem = nonCatalog.length;
        }

        function getNumberOfItemsChanged() {
          $scope.numberOfCatalogItemChanged = 0;
          $scope.arrayOfDataChangedItems = [];

          _.forEach($scope.data, function (item) {

            /**
             * Check if item_validity_status is null, break out of loop
             */
            if(item.item_validity_status === null){
              return false;
            }

            if (item.item_validity_status !== 0) {
              $scope.arrayOfDataChangedItems.push(item);
              $scope.numberOfCatalogItemChanged += 1;
              //TODO: change messages to be more specific (Ahmed Saleh, 16/1/2017)
              if (item.item_validity_status === 1 || item.item_validity_status === 2 ||
                  item.item_validity_status === 4 || item.item_validity_status === 9 || item.item_validity_status === 10 ||
                  item.item_validity_status === 11 || item.item_validity_status === 12 ||
                  item.item_validity_status === 13 || item.item_validity_status === 14 ) {
                item.catalogRemovedItems = true;
              }
              if (!!item.data_change) {
                _.forEach(item.data_change, function (dataChanged) {
                  switch(dataChanged) {
                    case 'TaxRateModified':
                      item.taxRateChanged = true;
                      break;
                    case 'PriceChanged':
                      item.catalogPriceChanged = true;
                      break;
                    case 'DescriptionChanged':
                      item.catalogDescriptionChanged = true;
                      break;
                    case 'ItemTypeChanged':
                      item.itemTypeChanged = true;
                      break;
                    case 'CurrencyChanged':
                      item.catalogCurrencyChanged = true;
                      break;
                    case 'TaxDeactivated': // Fall through
                    case 'TaxDeleted':
                      item.taxUnavailable = true;
                      break;
                    case 'PaymentTermDeactivated': // Fall through
                    case 'PaymentTermDeleted':
                      item.paymentTermUnavailable = true;
                      break;
                    case 'UomDeactivated': // Fall through
                    case 'UomDeleted':
                      item.uomUnavailable = true;
                      break;
                    case 'CurrencyDeactivated': // Fall through
                    case 'CurrencyDeleted':
                    case 'CurrencyUnassignedFromCompany':
                      item.currencyUnavailable = true;
                      break;
                    case 'ExchangeRateDeactivated': // Fall through
                    case 'ExchangeRateDeleted':
                      item.exchangeRateUnavailable = true;
                      break;
                    case 'ItemExpired':
                      item.itemExpired = true;
                      break;
                    case 'SupplierBranchDeactivated':
                      item.supplierBranchDeactivated = true;
                      break;
                    case 'SupplierBranchUpdated':
                      item.supplierBranchUpdated = true;
                      break;
                    case 'SupplierBlackListed':
                      item.supplierBlackListed = true;
                      break;
                    case 'SupplierInactive':
                      item.supplierInactive = true;
                      break;
                  }
                });
              }
            }
          });
        }

        function invalidItemReason(item) {
          var response = '';
          switch(item.item_validity_status[item.item_validity_status.length -1]) {
            case 1:
              response = 'item was deleted.';
              break;
            case 2:
              response = 'item has expired.';
              break;
            case 3:
              response = 'item was updated.';
              break;
            case 4:
              response = 'supplier of the item was blacklisted.';
              break;
            case 5:
              response = 'currency of the item was updated.';
              break;
            case 6:
              response = 'price of the item was updated.';
              break;
            case 7:
              response = 'item type was updated.';
              break;
            case 8:
              response = 'tax rate of the item was updated.';
              break;
            case 81:
              response = 'tax rate of the item was deactivated.';
              break;
            case 82:
              response = 'tax rate of the item was updated.';
              break;
            case 9:
              response = 'supplier of the item was deactivated.';
              break;
            case 10:
              response = 'supplier of the item is not found.';
              break;
            case 11:
              response = 'payment term was deactivated.';
              break;
            case 12:
              response = 'payment term was deleted.';
              break;
            case 13:
              response = 'UOM was deactivated.';
              break;
            case 14:
              response = 'UOM was deleted.';
              break;
            case 15:
              response = 'currency was deactivated.';
              break;
            case 16:
              response = 'currency was deleted.';
              break;
            case 17:
              response = 'UOM was unassigned from company.';
              break;
            case 18:
              response = 'exchange rate was deleted.';
              break;
            case 19:
              response = 'exchange rate was deactivated.';
              break;
            case 20:
              response = 'supplier branch ('+ item.branch.descr +') was deactivated.';
              break;
            case 21:
              response = 'supplier branch ('+ item.branch.descr +') was deleted.';
              break;
            case 22:
              response = 'supplier branch ('+ item.branch.descr +') details was updated.';
              break;
            case 23:
              response = 'item was deactivated.';
              break;
            case 24:
              response = 'item description was updated.';
              break;
            default:
              response = 'changes in the item.';
          }

          return response;
        }

        function getNumberOfUnavailableItems(unavailable_items) {
          $scope.numberOfUnavailableItems = unavailable_items.length;
        }

        function checkForErrors() {
          var errorsFound = false;

          if($scope.pr.status === 'draft' || $scope.pr.status === 'pending' || $scope.pr.status === 'on_hold') {
            if ($scope.numberOfCatalogItemChanged > 0)
              errorsFound = true;
            if ($scope.numberOfUnavailableItems > 0)
              errorsFound = true;
            if ($scope.numberOfZeroPriceItem > 0)
              errorsFound = true;
            if ($scope.numberOfIncompleteItem > 0)
              errorsFound = true;
            if (!!$scope.prDeliveryAddressChanged)
              errorsFound = true;
            if (!!$scope.prBillingAddressChanged)
              errorsFound = true;
            if (!!$scope.prCreatorDeleted)
              errorsFound = true;
            if (!!$scope.prCreatorDeactivated)
              errorsFound = true;
            if (!!$scope.prRequestorDeleted)
              errorsFound = true;
            if (!!$scope.prRequestorDeactivated)
              errorsFound = true;
            if (!!$scope.prExpenseTypeDeactivated)
              errorsFound = true;
            if (!!$scope.prExpenseTypeDeleted)
              errorsFound = true;
            if (!!$scope.prCurrencyDeactivated)
              errorsFound = true;
            if (!!$scope.prCurrencyDeleted)
              errorsFound = true;
            if (!!$scope.prCurrencyUnassignedFromCompany)
              errorsFound = true;
            if (!!$scope.prCostCenterDeleted)
              errorsFound = true;
            if (!!$scope.prBillAddressUnassigned)
              errorsFound = true;
            if (!!$scope.prDeliveryAddressUnassigned)
              errorsFound = true;
            if (!!$scope.prExpenseTypesUnassigned)
              errorsFound = true;
          }

          prFunction.setDisplayWarningBlock(errorsFound);
          return errorsFound;
        }

        function initialize(){

          $scope.numberOfNonCatalogItem = 0;
          $scope.numberOfIncompleteItem = 0;
          $scope.checkForErrors = checkForErrors;
          $scope.invalidItemReason = invalidItemReason;

          /**
           * Check for unavailable item lines if pr is in draft
           */
          if(angular.isDefined($scope.unavailableItems) && $scope.pr.status.toLowerCase() === 'draft'){
            getNumberOfUnavailableItems($scope.unavailableItems);
          }

          getNumberOfNonCatalogItem();
          getNumberOfItemsChanged();
          getNumberOfZeroPriceItems();
          getPRDataChanged();
        }
        initialize();

        /**
         * Watcher for pr items when item is added/removed
         */
        $scope.$watch('data', function (newData, oldData) {
          if (!!newData && !!oldData) {
              $scope.data = newData;

              /**
               * Check for unavailable item lines if pr is in draft
               */
              if(angular.isDefined($scope.unavailableItems) && $scope.pr.status.toLowerCase() === 'draft'){
                getNumberOfUnavailableItems($scope.unavailableItems);
              }

              getNumberOfNonCatalogItem();
              getNumberOfItemsChanged();
              getNumberOfZeroPriceItems();
              getPRDataChanged();
            }
        }, true);

      }
    }
  });

'use strict';
angular
    .module('metabuyer')
    .directive('positionsSelectionPanel',function($uibModal) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, element, attrs) {
        var panelPosition = function (selectedCompany) {
          $uibModal.open({
            templateUrl: 'components/positionsSelectionPanel/positionsSelectionTemplate.html',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              user: function(){
                return scope.user
              },
              selected_company: function() {
                return scope.selected_company
              },
              companyRoles: function ($q, rolesList) {
                var deferred = $q.defer();
                rolesList.get(
                  {
                    company_code: selectedCompany.code,
                    //TODO: this offset is temporary to make sure we get the ADMIN role, remove later (Ahmed Saleh)
                    offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content.data);
                    }
                  },
                  function (error) {
                    if (error.status === 404) {
                      deferred.resolve([]);
                    }
                  }
                );
                return deferred.promise;
              },
              semanticRoles: function ($q, rolesList) {
                var deferred = $q.defer();
                rolesList.get(
                  {
                    company_code: 'system',
                    offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content.data);
                    }
                  },
                  function (error) {
                    if (error.status === 404) {
                      deferred.resolve([]);
                    }
                  }
                );
                return deferred.promise;
              }
            },
            controller: 'positionSelectionCtrl'
          });
        };
        scope.openPositionModal = function (selectedCompany) {
          panelPosition(selectedCompany);
        }
      }
    };
  })
  .controller('positionSelectionCtrl',
    function ($scope, user, selected_company, rolesList, singleUser, semanticRoles, companyRoles, $state, userPosition,
              toastr, $uibModalInstance) {
      // todo: use role selectin panel instead of create new one
      $scope.rolesList = semanticRoles.concat(companyRoles);
      $scope.user = user;
      $scope.selected_company = selected_company;
      $scope.addNewPosition = addNewPosition;
      $scope.removePosition = removePosition;
      $scope.closeModal = closeModal;
      $scope.$state = $state.current.name;
      function closeModal() {
        $uibModalInstance.close();
      }

      function addNewPosition(newRole) {
        swal({
            title: "Confirmation",
            text: "Confirm add new position?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function(isConfirm) {
            if (isConfirm) {
              var tempRolesIds = [];
              //move the ids of the Roles in  a new array to push to the backend right now the User list returned from
              // the backend is just text and wil be updated to an object of id
              for(var i in $scope.user.positions){
                if( newRole._id === $scope.user.positions[i]._id){
                  toastr.error('Cannot add same position again');
                  return false;
                }
                else {
                  tempRolesIds.push($scope.user.positions[i]._id);
                }
              }
              tempRolesIds.push(newRole._id);
              if($scope.$state === 'main.user.users.add'){
                toastr.success('Position added');
              } else {
                userPosition.put({
                  id: user._id,
                  positionId: newRole._id
                }, function(){
                  removePositionOnLocalStorage(newRole._id);
                  toastr.success('Position added');
                  $scope.user.positions.push(newRole);
                }, function(error){
                  var warningMessage = "";
                  if(!!error && !!error.data.content)
                    warningMessage = error.data.content.error;
                  toastr.error(warningMessage);
                  return false;
                });
              }
            }
          }
        );
      }

      /**
       * Filter the roles returned by the type === 'ORG_ROLE'
       * ORG_ROLE is for position and used in approval flow
       */
      function filterRoles(){
        var tempRoles = [];
        _.forEach($scope.rolesList, function(role){
          if(role.type === 'ORG_ROLE')
            tempRoles.push(role);
        });
        $scope.rolesList = tempRoles;
      }

      function removePosition(role, index) {

        swal({
            title: "Confirmation",
            text: "Confirm remove position?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function(isConfirm) {
            var newRole = {};
            if(!!isConfirm){

              if($scope.$state === 'main.user.users.add'){
                toastr.success('Position removed');
                user.positions.splice(index, 1);
                $scope.user.roles_id.splice(index, 1);
              } else {
                userPosition.delete({
                  id: user._id,
                  positionId: role._id
                }, function(){
                  removePositionOnLocalStorage(role._id);
                  toastr.success('Position removed');
                  user.positions.splice(index, 1);
                }, function(){
                  toastr.error("Failed to delete position");
                });
              }
            }
          }
        );
      }

      /**
       * to remove a position based position id in the localstorage
       * @param id
       */
      function removePositionOnLocalStorage(id) {
        var usersPosition = JSON.parse(window.localStorage.getItem('roleUsers'));
        if(!!usersPosition && !!usersPosition[id]){
          delete usersPosition[id];
          window.localStorage.setItem('roleUsers', JSON.stringify(usersPosition));
        }
      }

      function initialize(){
        filterRoles();
      }

      initialize();
    }
  );

'use strict';

angular
  .module('metabuyer')
  .directive('poItemlistPanel', ['$document', '$window', '$location', 'ExchangeRate', 'toastr',
    function ($document, $window, $location, ExchangeRate, toastr) {
      return {
        restrict: 'E',
        templateUrl: 'components/poItemList/poItemlistTemplate.html',
        controller: function ($scope, $element) {
          //<editor-fold desc="Total">

          /* Calculations:
           Amount = Quantity * Unit price
           Discount = an array of (a number or (Amount * Discount (%)))
           Tax = (Amount - Discount) * Tax (%)
           Total Amount = Amount - Discount + Tax
           */

          /* Notes:
           total_ (totalAmount) totalAmount field in the UI
           sum_ (sumDiscount) sum of objects in arrays
           grand_ (grandAmount, grandDiscount, grandTotalAmount, grandTax) fields last line in itemList
           */

          var calcTotal = function() {
            $scope.grandAmount = 0;
            $scope.grandDiscount = 0;
            $scope.grandTax = 0;
            $scope.newTotalAmount = 0;
            $scope.grandTotalAmount = 0;
            $scope.totalLumpSum = 0;
            $scope.lumpsumTax = 0;

            var tempLumpSumTax;

            if ($scope.po.items != null) {
              for (var i = 0; i < $scope.po.items.length; i++) {
                var currentIndexPO = $scope.po.items[i];

                if (_.isEmpty(currentIndexPO.backup_discount)) {
                  currentIndexPO.backup_discount = [];
                }

                //<editor-fold desc="Calculate item's amount, discount, tax & totalAmount">
                // Calculate item's amount
                currentIndexPO.amount = currentIndexPO.unit_price * currentIndexPO.quantity;

                // Calculate item's discount array
                if (!!currentIndexPO.discount && Number(currentIndexPO.discount !== 0) &&
                      currentIndexPO.discount !== null) {
                  currentIndexPO.sumDiscount = 0;
                  calculateItemDiscount(currentIndexPO);

                  $scope.grandDiscount += (currentIndexPO.sumDiscount  || 0);
                }
                else{
                  currentIndexPO.sumDiscount = 0;
                }

                // Calculate item's tax
                if (!!currentIndexPO.taxes && !!currentIndexPO.taxes[0]) {
                  currentIndexPO.taxes[0].calculated = (currentIndexPO.amount - (currentIndexPO.sumDiscount || 0))
                    * parseFloat(currentIndexPO.taxes[0].rate) / 100;
                }

                // Calculate item's totalAmount
                currentIndexPO.totalAmount = currentIndexPO.amount - (currentIndexPO.sumDiscount || 0);

                // Calculate grandAmount, grandDiscount, grandTax & grandTotalAmount
                $scope.grandAmount += currentIndexPO.amount;
                //$scope.grandDiscount is calculated when loop currentIndexPO.discount array
                $scope.grandTax += ((!!currentIndexPO.taxes && currentIndexPO.taxes[0]) ? currentIndexPO.taxes[0].calculated || 0 : 0);
                $scope.newTotalAmount += (currentIndexPO.amount - currentIndexPO.sumDiscount);
                $scope.grandTotalAmount += (currentIndexPO.amount - (currentIndexPO.sumDiscount || 0) +
                  ((!!currentIndexPO.taxes && currentIndexPO.taxes[0]) ? currentIndexPO.taxes[0].calculated || 0 : 0));
                //</editor-fold>

                //<editor-fold desc="Calculate item's freights amount, discount, tax and totalAmount">
                if (!!currentIndexPO.freight) {
                  _.forEach(currentIndexPO.freight, function (freightItem) {

                    var newFreightAmount;
                    if(!!freightItem.is_percentage){
                      newFreightAmount = Number((freightItem.amount*currentIndexPO.amount)/100);
                    }
                    else{
                      newFreightAmount = Number(freightItem.amount);
                    }

                    // calculate freight displayAmount
                    freightItem.displayAmount = freightItem.amount;
                    if (!!freightItem.is_percentage) {
                      freightItem.displayAmount = freightItem.amount + "%";
                    }

                    // Calculate freightItem's discount
                    if (!_.isEmpty(freightItem.discount)) {
                      if(!!currentIndexPO.exchangeRate){
                        freightItem.discount.calculated = Number(freightItem.discount.amount)*currentIndexPO.exchangeRate;
                        if (!!freightItem.discount.is_percentage) {
                          freightItem.discount.calculated = Number(newFreightAmount) *
                            (freightItem.discount.amount / 100);
                          freightItem.discount.displayAmount = freightItem.discount.amount + "%";
                          var newFreightDiscount = freightItem.discount.calculated;
                        }
                        else{
                          freightItem.discount.calculated = freightItem.discount.amount*currentIndexPO.exchangeRate;
                          newFreightDiscount = freightItem.discount.calculated;
                        }
                      }
                      else{
                        if (!!freightItem.discount.is_percentage) {
                          freightItem.discount.calculated = Number(newFreightAmount) *
                            (freightItem.discount.amount / 100);
                          freightItem.discount.displayAmount = freightItem.discount.amount + "%";
                          newFreightDiscount = freightItem.discount.calculated;
                        }
                        else{
                          freightItem.discount.calculated = freightItem.discount.amount*currentIndexPO.exchangeRate;
                          newFreightDiscount = freightItem.discount.amount;
                        }
                      }
                    }
                    else{
                      newFreightDiscount = 0;
                    }

                    // Calculate freightItem's tax
                    if (!_.isEmpty(freightItem.tax)) {
                      freightItem.tax.calculated = Number((Number(newFreightAmount) - (
                        freightItem.discount ? freightItem.discount.calculated || 0 : 0
                        )) * (parseFloat(freightItem.tax.rate) || 0) / 100);
                    }

                    /**
                     * Freight's total amount is calculated here
                     */
                    freightItem.totalAmount = Number(newFreightAmount) - Number(newFreightDiscount);

                    if(angular.isDefined(freightItem.tax)) {
                      var newFreightTax = Number(freightItem.tax.calculated);
                      if (!!currentIndexPO.exchangeRate) {
                        newFreightTax = Number(newFreightTax * Number(currentIndexPO.exchangeRate));
                      }
                    }
                    else{
                      newFreightTax = 0;
                    }

                    // Calculate grandAmount, grandDiscount, grandTax & grandTotalAmount
                    $scope.grandAmount += Number(newFreightAmount);
                    $scope.grandDiscount += Number(newFreightDiscount);
                    $scope.grandTax += Number(newFreightTax);
                    // Delete totalAmount + tax
                    // (freightItem.tax ? freightItem.tax.calculated || 0 : 0)
                    $scope.grandTotalAmount += Number(newFreightAmount - newFreightDiscount);
                    $scope.newTotalAmount += freightItem.totalAmount;
                  });
                }

                if (!!currentIndexPO.transportation) {
                  _.forEach(currentIndexPO.transportation, function (transportationItem) {

                    var newTransportationAmount;
                    if(!!transportationItem.is_percentage){
                      newTransportationAmount = Number((transportationItem.amount*currentIndexPO.amount)/100);
                    }
                    else{
                      newTransportationAmount = Number(transportationItem.amount);
                    }

                    transportationItem.displayAmount = transportationItem.amount;
                    if (!!transportationItem.is_percentage) {
                      transportationItem.displayAmount = transportationItem.amount + "%";
                    }

                    // Calculate transportationItem's discount
                    if (!_.isEmpty(transportationItem.discount)) {
                      var newTransportationDiscount;
                      if(!!currentIndexPO.exchangeRate){
                        transportationItem.discount.calculated = Number(transportationItem.discount.amount)*currentIndexPO.exchangeRate;
                        if (!!transportationItem.discount.is_percentage) {
                          transportationItem.discount.calculated = Number(newTransportationAmount) *
                            (transportationItem.discount.amount / 100);
                          transportationItem.discount.displayAmount = transportationItem.discount.amount + "%";
                          newTransportationDiscount = transportationItem.discount.calculated;
                        }
                        else{
                          transportationItem.discount.calculated = transportationItem.discount.amount*currentIndexPO.exchangeRate;
                          newTransportationDiscount = transportationItem.discount.calculated;
                        }
                      }
                      else{
                        if (!!transportationItem.discount.is_percentage) {
                          transportationItem.discount.calculated = Number(newTransportationAmount) *
                            (transportationItem.discount.amount / 100);
                          transportationItem.discount.displayAmount = transportationItem.discount.amount + "%";
                          newTransportationDiscount = transportationItem.discount.calculated;
                        }
                        else{
                          transportationItem.discount.calculated = transportationItem.discount.amount*currentIndexPO.exchangeRate;
                          newTransportationDiscount = transportationItem.discount.amount;
                        }
                      }
                    }
                    else{
                      newTransportationDiscount = 0;
                    }

                    // Calculate transportationItem's tax
                    if (!_.isEmpty(transportationItem.tax)) {
                      transportationItem.tax.calculated = Number((Number(newTransportationAmount) - (
                        transportationItem.discount ? transportationItem.discount.calculated || 0 : 0
                        )) * (parseFloat(transportationItem.tax.rate) || 0) / 100);
                    }

                    /**
                     * Transportation's total amount is calculated here
                     */
                    transportationItem.totalAmount = Number(newTransportationAmount) - Number(newTransportationDiscount);

                    if(angular.isDefined(transportationItem.tax)) {
                      var newTransportationTax = Number(transportationItem.tax.calculated);
                      if (!!currentIndexPO.exchangeRate) {
                        newTransportationTax = Number(newTransportationTax * Number(currentIndexPO.exchangeRate));
                      }
                    }
                    else{
                      newTransportationTax = 0;
                    }

                    // Calculate grandAmount, grandDiscount, grandTax & grandTotalAmount
                    $scope.grandAmount += Number(newTransportationAmount);
                    $scope.grandDiscount += Number(newTransportationDiscount);
                    $scope.grandTax += Number(newTransportationTax);
                    // Delete totalAmount + tax
                    // (freightItem.tax ? freightItem.tax.calculated || 0 : 0)
                    $scope.grandTotalAmount += Number(newTransportationAmount- newTransportationDiscount);
                    $scope.newTotalAmount += transportationItem.totalAmount;
                  });
                }
                //</editor-fold>
              }

              // calculate the lump sum discount After the grand total
              if(!!$scope.po.lump_sum_discount && !!$scope.po.lump_sum_discount.amount) {
                if ($scope.po.lump_sum_discount.is_percentage) {
                  $scope.totalLumpSum = (Number($scope.po.lump_sum_discount.amount)/100 * $scope.grandAmount);
                } else {
                  $scope.totalLumpSum = $scope.po.lump_sum_discount.amount;
                }

                $scope.grandTotalAmount = $scope.grandTotalAmount - $scope.totalLumpSum;

                // calculate tax in lump sum
                if(!!$scope.po.lump_sum_discount.tax){
                  tempLumpSumTax = (Number($scope.po.lump_sum_discount.tax.rate)/100 * $scope.totalLumpSum);
                  $scope.lumpsumTax = tempLumpSumTax;
                  $scope.grandTotalAmount = $scope.grandTotalAmount - tempLumpSumTax;
                }
              }
            }
          };

          var backupDiscountEntry;
          var calculateItemDiscount = function(item){
            if (!!item.discount) {
              for (var i = 0; i < item.discount.length; i++) {
                var itemDiscount = item.discount[i];
                if (!item.backup_discount[i]) {
                  item.backup_discount[i] = _.cloneDeep(item.discount[i]);
                }

                var entryIsPercentage;

                // first load, set itemDiscount.entry
                if (!itemDiscount.amount) {
                  itemDiscount.amount = 0;
                  itemDiscount.is_percentage = false;
                }

                if (!itemDiscount.entry) {
                  itemDiscount.entry = itemDiscount.amount + (!!itemDiscount.is_percentage ? '%' : '');
                  backupDiscountEntry = itemDiscount.entry;
                } else if (itemDiscount.entry == '') {
                  itemDiscount.amount = 0;
                  itemDiscount.is_percentage = false;
                } else {
                  if (itemDiscount.entry != '') {
                    entryIsPercentage = itemDiscount.entry.indexOf('%') > -1;
                    itemDiscount.is_percentage = entryIsPercentage;
                  }

                  // calculate itemDiscount.amount
                  var tempAmount;
                  if (entryIsPercentage) {
                    tempAmount = itemDiscount.entry.substring(0, itemDiscount.entry.length - 1);
                    itemDiscount.amount = _.isNaN(parseFloat(tempAmount)) ? 0 : tempAmount;
                  } else {
                    tempAmount = parseFloat(itemDiscount.entry);
                    itemDiscount.amount = _.isNaN(tempAmount)? 0 : tempAmount;
                  }
                }

                if (!!itemDiscount.is_percentage) {
                  item.sumDiscount += item.amount * itemDiscount.amount / 100;
                } else {
                  item.sumDiscount += itemDiscount.amount;
                }
              }
            }
          };
          //</editor-fold>

          //<editor-fold desc="Run on init">
          calcTotal();

          $scope.$watch('po.billing.currency', function(newCurrency) {
            if (!!newCurrency && !!newCurrency.code) {
              $scope.newCurrencyCode = newCurrency.code;
              if (!_.isEmpty($scope.po.items) && newCurrency.code !== $scope.po.items[0].currency.code) {
                ExchangeRate.get({
                  id: $scope.po.billing.company._id,
                  source_id: $scope.po.items[0].currency._id,
                  target_id: newCurrency._id
                }, function(resource) {
                  // TODO: check !resource && !!resource.content && !!resource.content.data! && !!resource.content.data.status
                  if (!!resource && !!resource.content){
                    if(resource.content.data !== false){
                      $scope.exchangeRate = parseFloat(resource.content.data);

                      _.forEach($scope.po.items, function(item) {
                        if (!item.original_unit_price) {
                          item.original_unit_price = item.unit_price;
                        }
                        item.unit_price = item.original_unit_price;
                      });
                    } else {
                      toastr.error(resource.content.message);
                      _.forEach($scope.po.items, function(item) {
                        if (!item.original_unit_price) {
                          item.original_unit_price = item.unit_price;
                        } else {
                          item.unit_price = item.original_unit_price;
                        }
                      });
                    }

                  }
                }, function(error) {
                  console.log(error);
                });
              } else {
                _.forEach($scope.po.items, function(item) {

                  if (!item.original_unit_price) {
                    item.original_unit_price = item.unit_price;
                  } else {
                    item.unit_price = item.original_unit_price;
                  }
                });
              }
            }
          });

          $scope.$watch('po.items', function (newValue, oldValue) {
            calcTotal();

            if (!!newValue && !!oldValue) {
              if (newValue.length > oldValue.length) {
                _.forEach($scope.po.items, function(item) {
                  if (!item.original_unit_price) {
                    item.original_unit_price = item.unit_price;
                  }
                  if (!!$scope.exchangeRate) {
                    item.unit_price = item.original_unit_price;
                  }
                })
              }
            }
          }, true);
          //</editor-fold>
        }
      };
    }
  ]);

'use strict';

angular.module('metabuyer').directive('poAttachmentsBlock', function () {
  return {
    restrict: 'E',
    templateUrl: 'components/poAttachment/poattachmentTemplate.html',
    scope: {
      disableAttaching : '=?'
    },
    controller: function (
      $scope, Attachments, AttachmentSingle, $uibModal, $stateParams, $auth, toastr, pathConstants, $filter, $http
    ) {

      $scope.showDropZone = false;

      Attachments.getListPOAttachment(
        {
          po_id: $stateParams.id
        },
        function (resource) {
          if(!!resource && !!resource.content && !!resource.content.data){
            if(_.isArray(resource.content.data)){
              $scope.files = resource.content.data.reverse();
            }
          }

          if($scope.files.length == 0 && !$scope.disableAttaching){
            $scope.showDropZone = true;
          }
        });

      $scope.download = function (file_id) {

        AttachmentSingle.getSinglePOAttachment({
          po_id: $stateParams.id,
          attachment_id: file_id
        }).$promise.then(
          function (resource) {
            var newUrl = $filter("format")(pathConstants.apiUrls.po.downloadAttachment, {
              hash: resource.url
            });

            // Use HTTP to allow and use the application/json
            // and download with the newUrl
            $http({
              url: newUrl
            }).then(function (response) {
              window.open(newUrl, "_self");
            }, function (response) {
            });
          }, function (error) {
            toastr.error("Failed to download attachment.");
          });
      };

      $scope.dropzoneConfig = {
        options: {
          // passed into the Dropzone constructor
          //maxFilesize in MB
          maxFilesize: 10,
          url: $filter('format')(pathConstants.apiUrls.po.listAttachment, {po_id: $stateParams.id}) + "?descr=ABC",
          headers: {
            'Authorization': 'Bearer ' + $auth.getToken()
          },
          previewTemplate: '<div class="dz-preview dz-file-preview">' +
          '<div class="dz-details">' +
          '<div class="dz-filename"><span data-dz-name></span></div>' +
          '<div class="dz-size" data-dz-size></div>' +
          '<img data-dz-thumbnail />' +
          '</div>' +
          '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
          '<div style="z-index: 999; position: absolute; width: 30px; height: 30px; font-size: 25px; text-align: center; ' +
          'right: -10px; top: -10px;"><a data-dz-remove type="button" class="btn-xs btn-white pull-right"><i class="fa fa-trash-o"></i></a>' +
          '</div>' +
          '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
          '</div>',
          acceptedFiles: '.xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg'
        },

        eventHandlers: {

          processing: function(file) {
            this.options.url = $filter('format')(pathConstants.apiUrls.po.listAttachment, {po_id: $stateParams.id}) + "?descr=Add title";
          },

          sending: function (file, formData, xhr) {

          },
          error: function (file, error) {
            toastr.error(error);
          },
          success: function (file, response) {
            var _this = this;
            setTimeout(function () {
              _this.removeFile(file);
            }, 1000);

            toastr.success("Upload attachment successfully.");

            if(!!response && !!response.content && !!response.content.data){
              $scope.files.splice(0, 0, response.content.data);
            }
          }
        }
      };

      $scope.update = function (file) {

        if(file.edit_file_name == null || file.edit_file_name == undefined){
          file.edit_file_name = file.descr;
          return;
        }

        if(file.edit_file_name == file.descr){
          return;
        }

        AttachmentSingle.updateSinglePOAttachment(
          {
            po_id: $stateParams.id,
            attachment_id: file._id
          },
          {
            descr: file.edit_file_name
          }).$promise.then(
          function () {
            file.descr = file.edit_file_name;
          }, function (error) {
            toastr.error("Failed to update attachment.");
            file.edit_file_name = file.descr;
          });
      };
      $scope.delete = function (file) {
        var file_index = _.findIndex($scope.files, function(file_item){
          return file._id == file_item._id;
        });

        $scope.files.splice(file_index, 1);

        AttachmentSingle.deleteSinglePOAttachment(
          {
            po_id: $stateParams.id,
            attachment_id: file._id
          }).$promise.then(
          function() {
            if($scope.files.length == 0){
              $scope.showDropZone = true;
            }
          }, function (error) {
            toastr.error("Failed to delete attachment.");
            $scope.files.splice(file_index, 0, file);
          });
      };
    }
  };
});

'use strict';
/**
 * @name passwordResetModal Directive
 * @desc Directive for modal to change passwords
 * data is for profile data
 * oldPasswordField is to determine modal to have old password field
 */
angular
  .module('metabuyer')
  .directive('passwordResetModal',function($uibModal) {
    return {
      restrict: 'A',
      scope: {
        data: '=',
        oldPasswordField: '='
      },
      link: function ($scope, element) {

        var panel = function () {
          $uibModal.open({
            templateUrl: 'components/passwordResetModal/passwordResetModalTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'passwordResetModalCtrl',
            scope: $scope,
            resolve: {
              profile: function(){
                return $scope.data;
              }
            }
          });
        };

        //loading the panel
        $scope.showPasswordModal = function () {
          panel();
        };

        element.bind("click", function(){
          $scope.showPasswordModal();
        });

      }
    }
  });

'use strict';

function passwordResetModalCtrl($scope, profile, $uibModalInstance, toastr, singleUser, globalFunc) {

  $scope.createNewPassword = createNewPassword;
  $scope.closeModal = closeModal;
  $scope.error = false;
  $scope.missMatchError = false;
  $scope.wrongFormatError = false;
  $scope.profile = profile;

  function createNewPassword() {
    $scope.submitted = true;
    //clearing all the errors
    $scope.wrongFormatError = false;
    $scope.missMatchError = false;
    $scope.error = false;
    //checks if they pass all the validation
    if(!!$scope.oldPasswordField){
      if(!$scope.password_old.length){
        $scope.error = true;
      }
    }
    if (checkPasswordFormat()) {
      if (!checkMatchPassword()) {
        //message that the new password didn't match
        $scope.missMatchError = true;
        $scope.error = true;
      }
    }
    else {
      //message about the required password format
      $scope.wrongFormatError = true;
      $scope.error = true;
    }
    if (!$scope.error) {
      if(!!$scope.oldPasswordField){
        singleUser.put({
            id: 'me'
          },
          {
            old_password: $scope.password_old,
            password: $scope.password_new,
            password_confirm: $scope.password_confirm
          },
          function () {
            $uibModalInstance.close();
            toastr.success("User's password successfully changed");
          },
          function (error) {
            globalFunc.objectErrorMessage(error);
          });
      }
      else{
        singleUser.put({
            id: $scope.profile._id
          }, {
            password: $scope.password_new,
            password_confirm: $scope.password_confirm,
            send_email : $scope.send_email
          },
          function () {
            $uibModalInstance.close();
            toastr.success("User's password successfully changed");
          },
          function (error) {
            globalFunc.objectErrorMessage(error);
          });
      }
    }
    else{
      toastr.error("Please fill in the required fields");
    }
  }

  function checkPasswordFormat() {
    var letter = /[a-z]/;
    var capitalLetter = /[A-Z]/;
    var number = /[0-9]/;
    return (letter.test($scope.password_new) && number.test($scope.password_new) &&
      $scope.password_new.length > 7 && capitalLetter.test($scope.password_new));
  }

  function checkMatchPassword() {
    return $scope.password_new === $scope.password_confirm;
  }

  function closeModal() {
    $uibModalInstance.close();
  }

}

passwordResetModalCtrl.$inject = ['$scope', 'profile', '$uibModalInstance', 'toastr', 'singleUser', 'globalFunc'];

angular.module('metabuyer')
  .controller('passwordResetModalCtrl', passwordResetModalCtrl);

'use strict';
angular
  .module('metabuyer')
  .directive('approvalEnginePagination', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/pagination/paginationForAE.html',
      scope: {
        callbackSearch: '&callbackSearch',
        startRecNo: '=startRecNo',
        endRecNo: '=endRecNo',
        totalRec: '=totalRec',
        totalPageNumber: '=totalPageNumber',
        currentPageNumber: '=currentPageNumber'
      },
      controller: function ($scope) {

        $scope.goNextPage = goNextPage;
        $scope.goPreviousPage = goPreviousPage;

        function goNextPage() {
          $scope.currentPageNumber += 1;
          $scope.callbackSearch({page: $scope.currentPageNumber});
        }

        function goPreviousPage() {
          $scope.currentPageNumber -= 1;
          $scope.callbackSearch({page: $scope.currentPageNumber});
        }
      }
    };
  });

'use strict';
angular
  .module('metabuyer')
  .directive('paginationService',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/pagination/paginationTemplate.html',
      scope: {
        cursor: '=',
        list: '=',
        service: '=',
        id: '=',
        status: '=',
        paramsSource: '=?params',
        offset: '=?offset'
      },
      controller: function ($scope, $location) {
        $scope.disablePaginationButtons = false;
        $scope.pageCount = 0;
        $scope.goNextPage = goNextPage;
        $scope.goPreviousPage = goPreviousPage;

        var params = {};

        function initialize(){
          //TODO: prepare the data accordingly in case of a support of pages (at this moment only Elements) (Ahmed Saleh)
          if(!!$scope.cursor) {
            $scope.currentPageCode = $scope.cursor.current;
            $scope.nextPageCode = $scope.cursor.next;
            $scope.previousPageCode = $scope.cursor.prev;

            if (!!$scope.cursor.current) {
              $scope.currentCountStart = atob($scope.cursor.current);
            } else {
              $scope.currentCountStart = 1;
            }

            if ($scope.offset === undefined) {
              $scope.offset = $scope.list.length;
            }
            if (!$scope.previousPageCode) {
              $scope.currentCountStart = 1;
            } else {
              //TODO: determine the page count in which the count should start from (Ahmed Saleh)
            }

            if ($scope.cursor.count !== $scope.list.length) {
              $scope.currentCountEnd = $scope.list.length + Number($scope.currentCountStart);
              /**
               * in case the number starts with 1, it will add an extra digit incorrectly
               */
              if(Number($scope.currentCountStart)===1) {
                $scope.currentCountEnd--;
              }
              else{
                $scope.currentCountStart ++;
              }
            } else {
              $scope.currentCountEnd = $scope.list.length;
            }
            $scope.totalCount = $scope.cursor.count;

            params = {
              status: $scope.status,
              id: $scope.id,
              offset: $scope.offset
            };

          } else {
            $scope.currentPageCode = null;
            $scope.nextPageCode = null;
            $scope.previousPageCode = null;

            $scope.currentCountStart = 0;

            $scope.offset = 20;
            $scope.currentCountStart = 0;

          }
        }

        function goNextPage() {
          var nextCursor = { cursor: $scope.nextPageCode };
          angular.extend(params, $scope.paramsSource, nextCursor);
          $scope.disablePaginationButtons = true;
          $location.search('cursor', $scope.nextPageCode);

          //$scope.service.get( params ,
          //  function (resource) {
          //    if (!!resource.content) {
          //      console.log($location);
          //      $scope.list = resource.content.data;
          //      $scope.disablePaginationButtons = false;
          //      if (!!resource.content.meta) {
          //        if (!!resource.content.meta.cursor) {
          //          $scope.pageCount++;
          //          $scope.currentCountStart = $scope.pageCount * $scope.offset + 1;
          //          $scope.currentCountEnd = $scope.currentCountStart + $scope.offset;
          //          if ($scope.currentCountEnd > $scope.totalCount) {
          //            $scope.currentCountEnd = $scope.totalCount;
          //          }
          //          $scope.currentPageCode = resource.content.meta.cursor.current;
          //          $scope.nextPageCode = resource.content.meta.cursor.next;
          //          $scope.previousPageCode = resource.content.meta.cursor.prev;
          //        }
          //      }
          //    }
          //  },
          //  function (error) {
          //    $scope.disablePaginationButtons = false;
          //    //something went wrong
          //  }
          //);
        }

        function goPreviousPage() {
          var prevCursor = { cursor: $scope.previousPageCode };
          angular.extend(params, $scope.paramsSource, prevCursor);
          $scope.disablePaginationButtons = true;
          $location.search('cursor', $scope.previousPageCode);
          //$scope.service.get( params ,
          //  function (resource) {
          //    if (!!resource.content) {
          //      $location.search('cursor', $scope.previousPageCode);
          //      $scope.list = resource.content.data;
          //      $scope.disablePaginationButtons = false;
          //      if (!!resource.content.meta) {
          //        if (!!resource.content.meta.cursor) {
          //          $scope.pageCount--;
          //          $scope.currentCountStart = $scope.pageCount * $scope.offset + 1;
          //          $scope.currentCountEnd = $scope.currentCountStart + $scope.offset - 1;
          //          if ($scope.currentCountEnd > $scope.totalCount) {
          //            $scope.currentCountEnd = $scope.totalCount;
          //          }
          //          $scope.currentPageCode = resource.content.meta.cursor.current;
          //          $scope.nextPageCode = resource.content.meta.cursor.next;
          //          $scope.previousPageCode = resource.content.meta.cursor.prev;
          //        }
          //      }
          //    }
          //  },
          //  function (error) {
          //    $scope.disablePaginationButtons = false;
          //    //something went wrong
          //  }
          //);
        }

        // Receive the broadcast for pagination
        // used for promised data
        $scope.$on('pagination', function (event, args) {
          $scope.list = args.data;
          $scope.cursor = args.meta.cursor;
          initialize();
        });

        // Run initialize function in the first load
        initialize()
      }
    };
  });

'use strict';
angular.module('metabuyer')
  .directive('onlyNumber', function () {
    return {
      restrict: 'EA',
      require: 'ngModel',
      scope:{
        onlyNumber: "=onlyNumber"
      },
      link: function (scope, element, attrs, ngModel) {
        scope.$watch("onlyNumber", function(newValue, oldValue) {

          newValue = String(newValue).trim();

          if(attrs.isDigit == "true"){
            scope.onlyNumber = newValue.replace(/[^0-9]/g, '');
            return;
          }

          var spiltArray = String(newValue).split("");

          if(spiltArray.length == 0){
            scope.onlyNumber = "";
            return;
          }

          if(attrs.allowNegative == "false") {
            if(spiltArray[0] == '-') {
              newValue = newValue.replace("-", "");
              scope.onlyNumber = newValue;
              return;
            }
          }

          if(attrs.allowDecimal == "false") {
            if(attrs.allowNegative != "false"){
              if (spiltArray.length === 1 && (spiltArray[0] == '-')){
                return;
              } else if(spiltArray.length > 1 && (spiltArray[0] == '-')){
                var n = newValue.substr(1);
                if (isNaN(n)) {
                  if(isNaN(oldValue)){
                    return;
                  }
                  scope.onlyNumber = oldValue;
                  return;
                }
              }
            }

            newValue = parseInt(newValue);
            scope.onlyNumber = newValue;
            return;
          }

          if(attrs.allowDecimal != "false") {
            if(attrs.allowNegative != "false"){
              if (spiltArray.length === 1 && (spiltArray[0] == '-')){
                return;
              } else if(spiltArray.length > 1) {
                if(spiltArray[0] == '-'){
                  var n = newValue.substr(1);
                  if (isNaN(n)) {
                    if(isNaN(oldValue)){
                      return;
                    }
                    scope.onlyNumber = oldValue;
                    return;
                  }
                }
              }

              if (isNaN(newValue)) {
                if(isNaN(oldValue)){
                  scope.onlyNumber = "";
                  return;
                }
                scope.onlyNumber = oldValue;
                return;
              }
            }

            if(attrs.decimalUpto) {
              var n = String(newValue).split(".");
              if(n[1]) {
                var n2 = n[1].slice(0, attrs.decimalUpto);
                newValue = [parseInt(n[0]), n2].join(".");
                scope.onlyNumber = newValue;
              }
            } else {
              if(String(newValue).indexOf(".") == -1){
                newValue = parseInt(newValue);
                scope.onlyNumber = newValue;
              }
            }
          }

          if (isNaN(newValue)) {
            if(isNaN(oldValue)){
              return;
            }
            scope.onlyNumber = oldValue;
            return;
          }

          scope.onlyNumber = newValue;
        });
      }
    };
});

'use strict';
angular
  .module('metabuyer')
  .directive('ngrnPanel',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {

        var panel = function(ngrn_id, selectedPo) {

          var modalInstance = $uibModal.open({
            templateUrl: 'components/ngrn/ngrnTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ngrnCtrl',
            scope: scope,
            size: "lg",
            resolve: {
              ngrn: function($q, getGRN){
                var defered = $q.defer();
                if(!ngrn_id){
                  defered.resolve({});
                  return defered.promise;
                }

                getGRN.get({id: ngrn_id},
                  function(resource){
                    if(!!resource && !!resource.content && !!resource.content.data){
                      defered.resolve(resource.content.data);
                    }else{
                      defered.resolve({});
                    }
                  }, function(error){
                    defered.resolve({});
                  });

                return defered.promise;
              },
              po: function(){
                return selectedPo;
              }            }
          });
        };

        //loading the panel to comment
        scope.showNGRNInfo = function(ngrn_id, selectedPo) {
          panel(ngrn_id, selectedPo);
        };
      }
    };
  });

'use strict';

function ngrnCtrl($scope,  $uibModalInstance, ngrn, po, getGRNPDFHash, $filter, toastr, pathConstants, $rootScope){

  $scope.ngrn = ngrn;
  $scope.po = po;

  $scope.cancel = cancel;
  $scope.printNGRN = printNGRN;

  function cancel(){
    $uibModalInstance.close();
  }
  function printNGRN() {

    var tabWindow = window.open('', '_blank');

    getGRNPDFHash.get(
      {
        id: $scope.ngrn._id,
        timezone: $rootScope.currentUser.config.TZ
      }
    ).$promise.then(
      function (resource) {
        var newUrl = $filter('format')(pathConstants.apiUrls.po.pdfHash, {
          pdf_hash: resource.url
        });

        setTimeout(function (){
            tabWindow.location.href = newUrl;
          },
          1001
        );
      },
      function(){
        toastr.error('Failed to print NGRN');
      }
    );

  }
}

ngrnCtrl.$inject = ['$scope', '$uibModalInstance', 'ngrn', 'po', 'getGRNPDFHash', '$filter', 'toastr', 'pathConstants' , '$rootScope'];

angular.module('metabuyer')
  .controller('ngrnCtrl', ngrnCtrl);

'use strict';

angular.module('metabuyer')
  .directive('ngfileModel', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.ngfileModel);
        var isMultiple = attrs.multiple;
        var modelSetter = model.assign;

        element.bind('change', function () {
          var values = [];
          angular.forEach(element[0].files, function (item) {
            var value = {
              // File Name
              name: item.name,
              //File Size
              size: item.size,
              // File Input Value
              _file: item
            };
            values.push(value);
          });

          scope.$apply(function () {
            var val = values;
            if (!isMultiple)
              val = values[0];

            modelSetter(scope, val);
          });
        });
      }
    };
  }
  ]);

'use strict';
angular.module('metabuyer')
  .directive('ngEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if(event.which === 13) {
          scope.$apply(function (){
            scope.$eval(attrs.ngEnter);
          });

          event.preventDefault();
        }
      });
    };
  });

'use strict';

var directiveModule = angular.module('custom-angularjs-dropdown-multiselect', []);

directiveModule.directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse',
    function ($filter, $document, $compile, $parse) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                iconClass: '=',
                groupBy: '@',
                orientation: "@?"
            },
            template: function (element, attrs) {
                var checkboxes = attrs.checkboxes ? true : false;
                var groups = attrs.groupBy ? true : false;
                var orientation = !!attrs.orientation ? attrs.orientation: null;

                var template = '<div class="multiselect-parent btn-group dropdown-multiselect">';
                template += '<button type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}<i ng-class="iconClass"></i>&nbsp;<span class="fa fa-caret-down"></span></button>';

                //check orientation
                if(!!orientation && orientation == "ltr"){
                  template += '<ul class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll; left: auto;" >';
                } else {
                  template += '<ul class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: hidden; left: auto; right: 0" >';
                }

                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a data-ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll"><a data-ng-click="deselectAll();"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
                template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';
                template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                template += '<li ng-show="settings.enableSearch" class="divider"></li>';

                if (groups) {
                    template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                    template += '<li ng-repeat-end role="presentation">';
                } else {
                    template += '<li role="presentation" ng-show="(option.visible == null) || option.visible" ng-repeat="option in options | filter: searchFilter">';
                }

                template += '<a role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp))">';

                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                } else {
                    template += '<span data-ng-class="{\'fa fa-check\': isChecked(getPropertyForObject(option,settings.idProp))}"></span> {{getPropertyForObject(option, settings.displayProp)}}</a>';
                }

                template += '</li>';

                template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function ($scope, $element, $attrs) {
                var $dropdownTrigger = $element.children()[0];

                $scope.sortOnTop = function(){
                  $scope.options = _.sortBy($scope.options, function(option){
                    var find_item = _.find($scope.selectedModel, function(selected_item){

                      return option[$scope.settings.idProp] == selected_item[$scope.settings.idProp];
                    });

                    if(find_item != undefined){

                      //place on top
                      return false;
                    }

                    return true;
                  });
                };

                $scope.toggleDropdown = function () {
                    $scope.open = !$scope.open;
                    if($scope.open && $scope.settings.enableSortOnTop){
                        $scope.sortOnTop();
                    }
                };

                $scope.checkboxClick = function ($event, id) {
                    $scope.setSelectedItem(id);
                    $event.stopImmediatePropagation();
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop,
                    onShowDropdown: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 0,
                    showCheckAll: false,
                    showUncheckAll: false,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-white',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop,
                    enableSortOnTop: false
                };

                $scope.texts = {
                    checkAll: 'Check All',
                    uncheckAll: 'Uncheck All',
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: 'Search...',
                    buttonDefaultText: 'Select',
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }


              /**
               * remove the pop up once the mouse is out
               */
              $scope.removeDropdown = function () {
                $scope.open = false;
              };

              $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue);
                    }

                    return groupValue;
                };

                $scope.getButtonText = function () {
                    if(!!$scope.iconClass)
                    {
                      return null;
                    }

                    if($scope.selectedModel === undefined){
                        $scope.selectedModel = [];
                    }

                    if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {
                            var itemsText = [];

                            angular.forEach($scope.options, function (optionItem) {
                                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                    itemsText.push(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                //itemsText.push('...');
                            }

                            return itemsText.join(', ');
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            } else {
                                return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                            }
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };

                $scope.selectAll = function () {
                    //$scope.deselectAll(false);
                    $scope.externalEvents.onSelectAll();

                    angular.forEach($scope.options, function (value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true);
                    });
                };

                $scope.deselectAll = function (sendEvent) {
                    sendEvent = sendEvent || true;

                    if (sendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    }
                };

                $scope.setSelectedItem = function (id, dontRemove) {
                    var findObj = getFindObj(id);
                    var finalObj = null;

                    if ($scope.settings.externalIdProp === '') {
                        finalObj = _.find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                        angular.extend($scope.selectedModel, finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);

                        return;
                    }

                    dontRemove = dontRemove || false;

                    var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

                    if (!dontRemove && exists) {
                        $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
                        $scope.externalEvents.onItemDeselect(findObj);
                    } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                        $scope.selectedModel.push(finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                    }
                };

                $scope.isChecked = function (id) {
                    if ($scope.singleSelection) {
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                    }

                    return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.externalEvents.onInitDone();
            }
        };
}]);

'use strict';

/**
 * controller for preparing the data to pass it to the actionModal directive
 *
 * @param $scope
 * @param multiApprovalActions
 * @param globalFunc
 * @param $state
 * @param toastr
 */

function multiApprovalActionCtrl ($scope, multiApprovalActions, globalFunc, $state, toastr) {

  /**
   * list the Approval IDs for the selected PRs
   * @returns {{approval_ids: Array}}
   */
  function getApprovalIDs() {
    var IDs = [];
    _.forEach($scope.getSelectedItems() , function (item) {
      if (!!item.approval_id) {
        IDs.push(item.approval_id);
      }
    });
    return {approval_ids: IDs};
  }

  /**
   * return the resource function for the directive
   * @param action
   * @param text
   * @param extraPayload
   * @returns {*}
   */
  function getMultiActionFunction(action, text, extraPayload) {
    return multiApprovalActions.post(
      {
        action: action
      },
      extraPayload,
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.message) {
          if (_.isObject(resource.content.message)) {
            if (!!resource.content.message.failed)
              displayFailedErrorData(action, resource.content.message.failed);
          } else {
            toastr.success(resource.content.message);
          }
        } else {
          toastr.success('The action was performed successfully');
        }
      }, function (errors) {
        errors = errors.data;
        // cannot use global error message
        // it is using different data format
        // the error message returns approval id and the error message
        if (!!errors && !!errors.content && !!errors.content.error && !!errors.content.error.message) {
          displayFailedErrorData(action, errors.content.error.message);
        }
      }
    );
  }

  /**
   * Display error for failed data
   *
   * @param action
   * @param data
   */
  function displayFailedErrorData(action, data) {
    var contents = $scope.getSelectedItems();
    _.forEach(data, function (error) {
      var object = globalFunc.findInArray(contents, 'approval_id', error.approval_id);

      if (!!object) {
        var objectName = object.reference || object.descr || object.catalog_descr;
        toastr.error('Failed to ' + action + ' ' + objectName + ': '+ error.message);
      }
    })
  }

  /**
   * return handler for the multiAction
   * @returns {*|void|promise}
   */
  function getMultiActionHandler(){
    return $state.reload();
  }

  /**
   * prepare any extra params for each action once the <span> is clicked
   */
  function prepareExtraParams(){
    $scope.extraParams = getApprovalIDs();
  }

  $scope.getMultiActionFunction       = getMultiActionFunction;
  $scope.getMultiActionHandler        = getMultiActionHandler;
  $scope.prepareExtraParams           = prepareExtraParams;
}

/**
 * @name multiApprovalAction
 * @desc directive for performing Approval action on multiple items
 * this directive uses the action modal directive
 *
 */
angular
  .module('metabuyer')
  .controller('multiApprovalActionCtrl', multiApprovalActionCtrl)
  .directive('multiApprovalAction',function() {
    return {
      restrict: 'EA',
      templateUrl: 'components/multiApprovalAction/multiApprovalActionTemplate.html',
      controller: 'multiApprovalActionCtrl',
      scope: {
        getSelectedItems: '&',
        showOnHold: '@?',
        type: '@'
      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('monitorDate',function() {
    return{
      restrict: 'A',
      scope: {
        monitor_date: "=monitorDate",
        onChangedDate: "&"
      },
      link: function(scope, element, attrs) {

        var is_first_called = true;
        scope.$watch('monitor_date', function(new_value, old_value){
          if(is_first_called){
            is_first_called = false;
            return;
          }

          scope.onChangedDate();
        });
      }
    };
  });

/**
 * @name modalMore
 *
 * @requires $uibModal
 *
 * @description
 * This directive is modal to display more from limited content.
 * can contain String and Array (to be table)
 *
 * @attr title
 * @attr subtitle
 * @attr type (string or array)
 * @attr data
 * @attr filter
 * sample data for array
 * {
 *   name: 'Deniel',
 *   address: 'Petaling Jaya',
 *   age: 24
 * },
 * {
 *   name: 'ini ibu budi',
 *   address: 'Sunway Damansara',
 *   age: 26
 * }
 * array can has more key and value
 *
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('modalMore',function($uibModal) {
    return{
      restrict: 'E',
      scope: {
        title: '@',
        subtitle: '@',
        type: '@',
        data: '=',
        filter: '='
      },
      link: function(scope, element) {

        function panel() {
          $uibModal.open({
            templateUrl: 'components/modalMore/modal-more.html',
            backdrop: 'static',
            keyboard: false,
            controller: "modalMoreController",
            resolve: {
              title: function(){
                return scope.title;
              },
              subtitle: function(){
                return scope.subtitle;
              },
              type: function() {
                return scope.type;
              },
              modalData: function() {
                return scope.data;
              },
              filter: function() {
                return scope.filter;
              }
            }
          });
        }

        element.bind("click", function($event){
          panel();
        });

      }
    };
  });

'use strict';

function modalMoreController ($scope, $uibModalInstance, title, subtitle, type, modalData, filter) {
  $scope.close = close;
  $scope.title = title;
  $scope.subtitle = subtitle;
  $scope.modalContents = modalData;
  $scope.dataType = type;
  $scope.listAllKey = listAllKey;
  $scope.filterArrayData = filterArrayData;

  function close() {
    $uibModalInstance.close();
  }

  function listAllKey(array) {
    var header = [];

    _.forEach(array[0], function(arr, key){
      header.push(key);
    });

    return header;
  }

  function filterArrayData(array, filter) {
    var newArr = [];

    _.forEach(array, function(arr) {
      var newObj = {};

      _.forEach(arr, function(value, key) {
        if(filter.indexOf(key) > -1)
          newObj[key] = value;
      });

      newArr.push(newObj);
    });

    return newArr;
  }

  function initialize() {
    // filter the data shown
    if($scope.dataType === 'array')
      $scope.modalContents = filterArrayData($scope.modalContents, filter);

    if($scope.dataType === 'array')
      $scope.tableHeader = listAllKey($scope.modalContents);
  }

  initialize();
}

modalMoreController.$inject = ['$scope', '$uibModalInstance', 'title', 'subtitle', 'type', 'modalData', 'filter'];

angular.module('metabuyer')
  .controller('modalMoreController', modalMoreController);

'use strict';
/**
 * @name mobileSearchBar Directive
 * @desc Directive for search bar in mobile version
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2017
 */
angular
  .module('metabuyer')
  .directive('mobileSearchBar',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/mobileSearchBar/mobileSearchBar-template.html',
      controller: function ($scope, $state) {
        $scope.search = search;

        function search(query) {
          var param = {};
          param.query = query;
          if (!!$state.current.name && $state.current.name.indexOf('purchaseRequisitions') > -1) {
            $state.go('main.user.purchaseRequisitions.manage', param);
          }
          else if ((!!$state.current.name && $state.current.name.indexOf('orders') > -1)) {
            $state.go('main.user.orders.manage', param);
          }
        }
      }
    }
  });

'use strict';

angular.module('metabuyer').directive('masterImportAttachment', function(){
  return {
    restrict: 'E',
    templateUrl: 'components/masterImportAttachment/masterImport-attachmentTemplate.html',
    scope: {
      uploadlink: '=',
      companyid: '=',
      params: '='
    },
    controller: function(
      $scope, Attachments, AttachmentSingle, $uibModal, $stateParams, $auth, toastr, pathConstants, $filter, $http,
      globalFunc, $state
    ) {

      $scope.file_id = '';
      $scope.showDropZone = false;

      function importErrorMessages(err) {
        var errorText = '';
        if (!!err && !!err.content) {
          var errorMessages = err.content.error,
              errorHash,
              errorLine = 0,
              errorRow = 0,
              downloadLink,
              errorLimit = 5;

          if (typeof errorMessages !== 'string') {
            if (!!errorMessages.hash){
              errorHash = errorMessages.hash;
              delete errorMessages.hash;

              downloadLink = $filter('format')(pathConstants.apiUrls.attachments.downloadErrorLog, {
                hash: errorHash
              });
            }

            _.forEach(errorMessages, function (errorData, key) {
              if (errorLine < errorLimit) {
                if (typeof errorData !== 'string') {
                  _.forEach(errorData, function (val, objKey) {
                    if (errorRow < errorLimit)
                      errorText += objKey + ' in line ' + key + ': ' + val + '<br>';
                    errorRow++;
                  });
                }
              }
              errorLine++;
            });

            if (!!errorHash && (errorRow > errorLimit || errorLine > errorLimit))
              errorText += '<br><a target="_self" href="' + downloadLink + '">Click here to download full error log file</a>';

          } else {
            errorText = errorMessages;
          }
        }

        swal({
          title: 'Oops! An error has occurred',
          text: errorText,
          type: 'warning',
          html: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: true
        });
      }

      window.submitAttachment = function(elem){

        var file = elem.files[0];
        var fd = new FormData();

        if(!!file){
          fd.append('file', file);
        } else {
          return;
        }

        // todo: fix this code. redundant code
        if(!!$scope.companyid) {
          $http.post($filter('format')($scope.uploadlink, {id: $scope.companyid }), fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          })
            .then(function onSuccess (response) {
              $(elem).val("");
              swal({
                title: "CSV uploaded",
                text: response.data.message,
                type: "info",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Close",
                closeOnConfirm: true
              });
              $scope.file_id = response.data.message._id;
            })
            .catch(function onError (error) {
              if (!!error.data.message)
                toastr.error(error.data.message);
              else
                toastr.error("Failed to submit the file");

              importErrorMessages(error.data);
            });
        } else {
          if (!!$scope.params){
            var paramIteration;
            for (paramIteration in $scope.params) {
              if ($scope.params.hasOwnProperty(paramIteration)) {
                fd.append(paramIteration, $scope.params[paramIteration]);
              }
            }
          }

          $http.post($filter('format')($scope.uploadlink), fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
          }).then(function onSuccess (response) {
            $scope.message = response.data.message;
            var limit = 5,
                errorLine = 0;

            if(!!response.data.content){
              if(!!response.data.content.message){
                toastr.success(response.data.content.message);
                $scope.message = response.data.content.message;
                $scope.messageData = response.data.content.data;
              }else{
                toastr.success("File successfully uploaded");
              }
            }

            if (!!$scope.messageData) {
              $scope.message += '<br>';
              _.forEach($scope.messageData, function (errorData, key) {
                if (errorLine < limit) {
                  $scope.message += 'Line ' + key + ': ' + errorData;
                }
                errorLine++;
              });
            }

            swal({
              title: "CSV uploaded",
              text: $scope.message,
              type: "info",
              html: true,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Close",
              closeOnConfirm: true
            });
            if(!!response.data.message && !!response.data.message._id)
              $scope.file_id = response.data.message._id;
            $state.reload();
          })
            .catch(function onError (error) {
              if (!!error.data && !!error.data.message)
                toastr.error(error.data.message);
              else
                toastr.error("Failed to submit the file");

              importErrorMessages(error.data);
            });
        }
      };
    }
  };
});

'use strict';
/**
 * @name masterExport Directive
 * @desc Directive for generating export CSV
 *
 * @isolatedScope moduleName
 * To accept the module name to be displayed with button
 *
 * @isolatedScope collection
 * To determine which module to generate CSV for
 *
 * @isolatedScope companyId
 * Exclusive for company exchange rate, to pass company id for exporting
 *
 * @isolatedScope companyCode
 * Exclusive for company exchange rate, to pass company code for exporting
 *
 * @isolatedScope checkingList
 * To determine whether the PR list exist for exporting
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */
angular
  .module('metabuyer')
  .directive('masterExport',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/masterExportCSV/masterExportCSV-template.html',
      scope: {
        moduleName: '@',
        collection: '@',
        companyId: '=?',
        companyCode: '=?',
        disableButton: '=?'
      },
      controller: function ($scope, $state, toastr, exports, checkExportStatus, $interval, pathConstants,
                            $filter, globalFunc, $stateParams, exportSearch) {

        $scope.generateExportCSV = generateExportCSV;
        /**
         * Function to download the export, this will be called automatically once generation is done
         * @param hash
         */
        function downloadExport(hash){
          var newUrl = $filter('format')(pathConstants.apiUrls.export.download, {
            export_hash: hash
          });
          window.open(newUrl, '_self');
        }

        /**
         * Function to check the export status with intervals
         * @param id
         */
        function checkExport(id){

          checkExportStatus.get(
            {
              id: id
            },
            function(resource){
              if(!!resource.content && !!resource.content.data &&
                !!resource.content.message && !!resource.content.data.status){

                /**
                 * Clearing the toastr before every call for status checking to simulate 'refreshing' the toastr
                 */
                toastr.clear();

                var checkingStatus = true;

                /**
                 * Status for export CSV
                 * 0 = PENDING
                 * 1 = IN_PROGRESS
                 * 2 = DONE
                 * 3 = FAILED
                 * 4 = CANCELLED
                 */
                switch(resource.content.data.status){
                  case 0:
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    break;
                  case 1:
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    break;
                  case 2:
                    /**
                     * If has is returned
                     */
                    if(!!resource.content.data.hash){
                      toastr.success(resource.content.message,
                        {timeOut: 0, extendedTimeOut: 0, onClose: downloadExport(resource.content.data.hash)});
                    }
                    /**
                     * Else condition to handle case if hash not returned by backend
                     */
                    else{
                      toastr.error('There was an error with the export. Please try again');
                    }
                    checkingStatus = false;
                    $interval.cancel($scope.startChecking);
                    break;
                  case 3:
                    checkingStatus = false;
                    toastr.error(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    $interval.cancel($scope.startChecking);
                    break;
                  case 4:
                    checkingStatus = false;
                    toastr.info(resource.content.message, {timeOut: 0, extendedTimeOut: 0});
                    $interval.cancel($scope.startChecking);
                    break;
                }

                $scope.checkingExportStatus = checkingStatus;
              }
            },
            function(error){
              globalFunc.objectErrorMessage(error);
            }
          )
        }

        /**
         * @function generateExportCSV
         * This function is to generate the export CSV with parameters
         *
         * @params collection
         * Values:
         *         0 for Currencies
         *         1 for Companies
         *         2 for CostCenters
         *         3 for AccountCodes
         *         4 for ExchangeRates
         *         5 for UOMs
         *         6 for PaymentTerms
         *         7 for PaymentMethods
         *         8 for Taxes
         *         9 for ExpenseTypes
         *         10 for Suppliers
         *         101 for Supplier Tags
         *         11 for Commodities
         *         12 for Users
         *         13 for Catalogs
         *         16 for Catalog Items
         *         17 for PR
         *         18 for PO
         *         19 for Industries
         *         20 for Business Units
         */
        function generateExportCSV(){
          $scope.checkingExportStatus = true;

          var params = {};
          /**
           * To check if there are params set before the export, in order to pass criteria
           */
          if(!!exportSearch.getParams()) {
            params = exportSearch.getParams();
          }
          else {
            params['criteria[company_id]'] = (($scope.collection === '4' || $scope.collection === '2') ? (!!$scope.companyId ?
              $scope.companyId : '') : null);
            params['criteria[company_code]'] = (($scope.collection === '2' || $scope.collection === '3') ?
              (!!$scope.companyCode ? $scope.companyCode : '') : null);
          }

          /**
           * Criteria[company_id] is passed only when exporting exchange rate
           * If exchange rate is company level, pass the id, else pass empty string to indicate tenant level
           */
          exports.post(
              params,
              {
                collection: $scope.collection
              },
              function (resource) {
                if(!!resource.content && !!resource.content.data && !!resource.content.message){

                  toastr.info('Data is being exported. The download will start automatically', {timeOut: 0, extendedTimeOut: 0});

                  /**
                   * Calling the function checkExport with interval of 5 seconds
                   * Set the promise to a scope in order to cancel the call once generation is complete
                   */
                    //TODO: Support multiple interval calling
                  $scope.startChecking = $interval(function () {
                    checkExport(resource.content.data._id)
                  }, 5000);
                }
              },
              function (error) {
                $scope.checkingExportStatus = false;
                toastr.error('Data failed to be exported');
              }
            )
        }
      }
    }
  });

/**
 * @name loadingFullWidth
 *
 * @description
 *
 * Loading with full width to prevent an user action
 * todo: move to active/nonactive this directive to http-request
 *
 */

'use strict';

angular
  .module('metabuyer')
  .directive('loadingFullWidth',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/loadingFullWidth/loading-full-width.html',
      scope: {
        data: '='
      },
      controller: function () {
        // nothing to do now, only html
      }
    }
  });

/**
 * @name loading
 *
 * @description
 * Directive to display loading process
 *
 * sample setting
 * $scope.loadingSetting = {
 *   text: 'Saving...',
 *   show: false, // boolean
 *   fontSize: 18, // optional, if empty will follow the element font size
 *   color: '#000000' // optional, if empty will follow the element color
 * };
 *
 * To use the directive
 * pass the setting configuration to the setting param
 * <loading setting="loadingSetting"></loading>
 *
 * @author Deniel
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('loading', function ($timeout) {
    return {
      restrict: 'E',
      replace: 'true',
      templateUrl: 'components/loading/loading.html',
      scope: {
        setting: '='
      },
      link: function ($scope, element, attrs) {
        $scope.text = $scope.setting.text;

        function changeStatus(show) {
          if(!!show)
            showText();
          else
            hideText();
        }

        function showText() {
          element.css('display', 'block');
          element.css('opacity', '1');
          element.css('height', 'auto');
        }

        function hideText() {
          $timeout(function() {
            element.css('opacity', '0');
            element.css('height', '0');
          }, 1000);
        }

        function initialize() {
          if (!!$scope.setting) {
            if (!!$scope.setting.fontSize)
              element.css('font-size', Number($scope.setting.fontSize));

            if (!$scope.setting.show)
              element.css('display', 'none');

            if (!!$scope.setting.color)
              element.css('color', $scope.setting.color);
          }
        }

        initialize();

        $scope.$watch('setting', function(newData){
          $scope.text = newData.text;
          changeStatus(newData.show);
        }, true);
      }
    }
  });


'use strict';

/**
 * @name itemMultiSelectCtrl
 *
 * @requires $scope
 * @requires $uibModal
 * @requires prFunction
 * @requires globalFunc
 *
 *
 * @description the Controller for mass edit, to prepare and show the common selection in each type as well as removing them.
 *
 *
 * @authors Ahmed Saleh
 * @copyright Sunway Metacloud &copy; 2016
 */

function itemMultiSelectCtrl ($scope, prFunction, globalFunc, $uibModal, $rootScope) {

  $scope.minDateItem              = new Date();
  $scope.datePickerTimezone       = $rootScope.datePickerTimezone;
  $scope.neededByInfo             = {};
  var selectedItemsIndexes        = [];

  $scope.getSelectedItemsIndexes  = getSelectedItemsIndexes;
  $scope.openMultiOptions         = openMultiOptions;
  $scope.close                    = close;
  $scope.updateItemsInformation   = updateItemsInformation;
  $scope.multiDatePicker          = multiDatePicker;
  $scope.getDeliveryAddresses     = getDeliveryAddresses;
  $scope.getAccountCodes          = getAccountCodes;
  $scope.getPR                    = getPR;
  $scope.getTaxesList             = getTaxesList;
  $scope.onSelectDeliveryAddress  = onSelectDeliveryAddress;
  $scope.onSelectNeededDate       = onSelectNeededDate;
  $scope.cancelSelectedItems      = cancelSelectedItems;
  $scope.deleteItems              = deleteItems;


  function getAccountCodes() {
    return prFunction.getAccountCodes();
  }

  function onSelectDeliveryAddress(address){
    updateItemsInformation('delivery-address', address._id);
  }

  function getPR(){
    return prFunction.getPRData();
  }

  function getDeliveryAddresses(){
    return prFunction.getCostCenterDeliveryAddresses();
  }

  function getTaxesList (){
    return prFunction.getTaxData();
  }

  function onSelectNeededDate(date) {
    var miliTime = globalFunc.convertDateToTimestamp(date);
    updateItemsInformation('needed-by', miliTime);
  }


  /**
   * TODO: combine the getSelectedItemsIndexes and getSelectedItems into one and manipulate the return data (Ahmed Saleh)
   */

  /**
   * function to returns the selected items Indexes
   * @returns {Array}
   */
  function getSelectedItemsIndexes() {
    var result = document.getElementsByClassName("scroll-fix-header");
    var wrappedResult = angular.element(result);

    selectedItemsIndexes = [];
    if (!!$scope.items && $scope.items.length > 0) {
      for (var i in $scope.items) {
        if ($scope.items[i].selected === true) {
          selectedItemsIndexes.push(i);
        }
      }
    }

    if (selectedItemsIndexes.length > 0)
      wrappedResult.css('top', '62px');
    else
      wrappedResult.css('top', '0');

    return selectedItemsIndexes;
  }

  /**
   * returns the selected Items
   * @returns {Array}
   */
  function getSelectedItems() {
    var selectedItems = [];
    if (!!$scope.items && $scope.items.length > 0) {
      for (var i in $scope.items) {
        if ($scope.items[i].selected === true) {
          selectedItems.push($scope.items[i]);
        }
      }
    }
    return selectedItems;
  }

  /**
   * function for cancelling the Selection for items
   */
   function cancelSelectedItems () {
    $scope.unSelectAllItems({
      value: false
    });
  }

  /**
   * deleting items
   */
   function deleteItems () {
    $scope.removeItems({
      data: getSelectedItems()
    });
  }


  /**
   * TODO: combine all the "check" function as they follow new structure, its possible to enhance them and it a single function (Ahmed Saleh)
   */

  /**
   *  function to check Notes on each item if they exist
   * @returns {{}}
   */
  function checkItemsNote() {

    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameNotesChecker = false;
      data.note = null;
      return data;
    }

    data.sameNotesChecker = true;
    var baseNote = $scope.items[indexes[0]].note;

    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].note || $scope.items[index].note !== baseNote) {
        data.sameNotesChecker = false;
        data.note = null;
        break;
      }
    }

    if (!!data.sameNotesChecker) {
      data.note = baseNote;
    }

    return data;

  }

  /**
   *  function to check needed by on each item if they exist
   * @returns {{}}
   */
  function checkItemsNeededBy() {


    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameNeededByChecker = false;
      data.neededBy = null;
      return data;
    }

    data.sameNeededByChecker = true;
    var baseDate = $scope.items[indexes[0]].needed_by_date;

    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].needed_by_date || $scope.items[index].needed_by_date !== baseDate) {
        data.sameNeededByChecker = false;
        data.neededBy = null;
        break;
      }
    }

    if (!!data.sameNeededByChecker) {
      data.neededBy = baseDate;
    }

    return data;
  }

  /**
   *  function to check Account Code on each item if they exist
   * @returns {{}}
   */
  function checkItemsAccountCode() {

    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameAccountCodeChecker = false;
      data.account_code = null;
      return data;
    }

    var baseAccountCode = $scope.items[indexes[0]].account_code;
    if (!baseAccountCode) {
      data.sameAccountCodeChecker = false;
      data.account_code = null;
      return data;
    }

    data.sameAccountCodeChecker = true;
    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].account_code || $scope.items[index].account_code._id !== baseAccountCode._id) {
        data.sameAccountCodeChecker = false;
        data.account_code = null;
        break;
      }
    }

    if (!!data.sameAccountCodeChecker) {
      data.account_code = baseAccountCode;
    }

    return data;
  }

  /**
   *  function to check Delivery Addresses on each item if they exist
   * @returns {{}}
   */
  function checkItemsDeliveryAddress() {
    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameDeliveryAddressChecker = false;
      data.deliveryAddress = null;
      return data;
    }

    data.sameDeliveryAddressChecker = true;
    var baseDeliveryAddress = $scope.items[indexes[0]].delivery_address;

    if (!baseDeliveryAddress || !baseDeliveryAddress._id) {
      data.sameDeliveryAddressChecker = false;
      data.deliveryAddress = null;
      return data;
    }

    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].delivery_address || $scope.items[index].delivery_address._id !== baseDeliveryAddress._id) {
        data.sameDeliveryAddressChecker = false;
        data.deliveryAddress = null;
        break;
      }
    }

    if (!!data.sameDeliveryAddressChecker) {
      data.deliveryAddress = baseDeliveryAddress;
    }

    return data;
  }

  /**
   *  function to check Delivery Addresses on each item if they exist
   * @returns {{}}
   */
  function checkItemsQuantity() {
    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameQtyChecker = false;
      data.qty = null;
      return data;
    }

    data.sameQtyChecker = true;
    var baseQty = $scope.items[indexes[0]].qty;

    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].qty || $scope.items[index].qty !== baseQty) {
        data.sameQtyChecker = false;
        data.qty = null;
        break;
      }
    }

    if (!!data.sameQtyChecker) {
      data.qty = baseQty;
    }

    return data;
  }

  /**
   * check for the Discount if its added and if its the same to the selected items
   * @returns {{}}
   */
  function checkItemsDiscount() {
    var data = {};
    var indexes = getSelectedItemsIndexes();

    if (!indexes || indexes.length < 1) {
      data.sameDiscountChecker = false;
      data.discount_entry = null;
      return data;
    }

    data.sameDiscountChecker = true;
    var baseQty = $scope.items[indexes[0]].discount;
    var basePercentage = $scope.items[indexes[0]].discount_percentage;
    var index;

    /**
     * validate in for both percentage and amount to be matched
     */
    if (!!basePercentage) {
      for (var i in indexes) {
        index = Number(indexes[i]);
        if (!$scope.items[index].discount || $scope.items[index].discount !== baseQty || (basePercentage !== $scope.items[indexes[0]].discount_percentage)) {
          data.sameDiscountChecker = false;
          data.discount_entry = null;
          break;
        }
      }
    } else {
      for (var i in indexes) {
        index = Number(indexes[i]);
        if (!$scope.items[index].discount || $scope.items[index].discount !== baseQty) {
          data.sameDiscountChecker = false;
          data.discount_entry = null;
          break;
        }
      }
    }

    if (!!data.sameDiscountChecker) {
      if(!!basePercentage){
        data.discount_entry = basePercentage + '%';
      }else{
        data.discount_entry = baseQty;
      }
    }

    return data;
  }

  /**
   * check if the Taxes has been selected and if they are the same to display 1 entry that represent all
   * @returns {{}}
   */
  function checkItemsTax() {
    var data = {};
    var indexes = getSelectedItemsIndexes();
    var baseTax = $scope.items[indexes[0]].tax;

    if (!indexes || indexes.length < 1 || !baseTax) {
      data.sameTaxChecker = false;
      data.tax = null;
      return data;
    }

    data.sameTaxChecker = true;

    for (var i in indexes) {
      var index = Number(indexes[i]);
      if (!$scope.items[index].tax || $scope.items[index].tax._id !== baseTax._id) {
        data.sameTaxChecker = false;
        data.tax = null;
        break;
      }
    }

    if (!!data.sameTaxChecker) {
      data.tax = baseTax;
    }

    return data;
  }

  /**
   * function that checks if the Prices are available in order to perform further actions
   * @returns {boolean}
   */
  function checkItemsPricesEntry() {
    var indexes = getSelectedItemsIndexes();
    var index;
    for (var i in indexes){
      index = indexes[i];
      if(!$scope.items[index].unit_price){
        return false;
      }
    }
    return true;
  }

  /**
   *  function to open each panel and load the needed data
   * @param option
   */
  function openMultiOptions(option) {
    var template = null;
    $scope.neededByInfo = null;
    $scope.deliverAddressInfo = null;
    $scope.acountCodeInfo = null;
    $scope.noteInfo = null;
    $scope.quantityInfo = null;

    switch (option) {
      case 1:
        template = 'components/itemMultiSelect/multiNeededByModalTemplate.html';
        $scope.neededByInfo = checkItemsNeededBy();
        $scope.neededByInfo.open = false;
        if ($scope.neededByInfo.sameNeededByChecker) {
          $scope.neededByInfo.multiNeededBy = $scope.neededByInfo.neededBy;
        }
        break;
      case 2:
        $scope.eventHandler = true;
        $scope.deliveryAddressInfo = checkItemsDeliveryAddress();
        if ($scope.deliveryAddressInfo.sameDeliveryAddressChecker) {
          $scope.deliveryAddressInfo.multiDeliveryAddress = $scope.deliveryAddressInfo.deliveryAddress;
        }
        break;
      case 3:
        $scope.eventHandler = false;
        template = 'components/itemMultiSelect/multiAccountCodModalTemplate.html';
        $scope.accountCodeInfo = checkItemsAccountCode();
        if ($scope.accountCodeInfo.sameAccountCodeChecker) {
          $scope.accountCodeInfo.multiAccountCode = $scope.accountCodeInfo.account_code;
        }
        break;
      case 4:
        template = 'components/itemMultiSelect/multiNoteModalTemplate.html';
        $scope.noteInfo = checkItemsNote();
        if ($scope.noteInfo.sameNotesChecker) {
          $scope.noteInfo.multiNote = $scope.noteInfo.note;
        }
        if (!$scope.noteInfo.note) {
          $scope.noteInfo.focus = true;
        }
        break;
      case 5:
        template = 'components/itemMultiSelect/multiQuantityModalTemplate.html';
        $scope.quantityInfo = checkItemsQuantity();
        if ($scope.quantityInfo.sameQtyChecker) {
          $scope.quantityInfo.multiQuantity = $scope.quantityInfo.qty;
        }
        break;
      case 6:
        template = 'components/itemMultiSelect/multiDiscountModalTemplate.html';
        $scope.discountInfo = checkItemsDiscount();
        $scope.allowEditing = checkItemsPricesEntry();
        if ($scope.discountInfo.sameDiscountChecker) {
          $scope.discountInfo.multiDiscount = $scope.discountInfo.discount_entry;
        }
        break;
      case 7:
        template = 'components/itemMultiSelect/multiTaxModalTemplate.html';
        $scope.taxInfo = checkItemsTax();
        $scope.allowEditing = checkItemsPricesEntry();
        if ($scope.taxInfo.sameTaxChecker) {
          $scope.taxInfo.multiTax = $scope.taxInfo.tax;
        }
        break;
    }
    if (!!template) {
      $scope.modal = $uibModal.open({
        backdrop: 'static',
        keyboard: false,
        templateUrl: template,
        scope: $scope
      });
    }
  }


  /**
   * dismissing the modal
   */
  function close() {
    $scope.modal.close();
  }


  /**
   * updating every time that is supported in the mass edit
   * @param field
   * @param newValue
   */
  function updateItemsInformation(field, newValue){
    if(!field){
      return;
    }

    $scope.updateMultiItems({
      items: getSelectedItems(),
      field: field,
      value: newValue
    });
    close();
  }

  /**
   * opening datepicker
   * @param $event
   */
  function multiDatePicker($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.neededByInfo.open = true;
  }

}

/**
 * @name itemMultiSelect
 *
 * @requires $uibModal
 *
 * @requires $scope
 *
 * @description This directive is for the header at the PR for selecting multiple options for multiple items
 *
 *
 * @authors Ahmed Saleh
 * @copyright Sunway Metacloud &copy; 2016
 */

angular
  .module('metabuyer')
  .controller(itemMultiSelectCtrl, 'itemMultiSelectCtrl')
  .directive('itemMultiSelect',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/itemMultiSelect/itemMultiSelectTemplate.html',
      scope: {
        items: '=',
        updateItems: '&',
        addressList: '=',
        unSelectAllItems: '&',
        removeItems: '&',
        updateMultiItems: '&'
      },
      controller: itemMultiSelectCtrl
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('imageError',function(Orders, toastr) {
    return{
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.bind('error', function() {
          if (attrs.src != attrs.imageError) {
            attrs.$set('src', attrs.imageError);
          }
        });
      }
    };
  });

'use strict';

angular
  .module('metabuyer')
  .directive('icheck', ['$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
          return $timeout(function () {
            var value;
            value = $attrs['value'];

            $scope.$watch($attrs['ngModel'], function (newValue) {
              $(element).iCheck('update');
            });

            $(element).iCheck({
              checkboxClass: 'icheckbox_minimal-grey',
              radioClass: 'iradio_square-green'
            }).on('ifChanged', function (event) {
              if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                $scope.$apply(function () {
                  ngModel.$setViewValue(event.target.checked);
                  $scope.$eval($attrs.ngChange);
                  $scope.$eval($attrs.ngClick);
                });
              }
              if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                return $scope.$apply(function () {
                  ngModel.$setViewValue(value);
                  $scope.$eval($attrs.ngChange);
                  $scope.$eval($attrs.ngClick);
                });
              }
            });
            var lastCheckIndex =-1;
            $('tbody .iCheck-helper').click(function (evt) {
              var $this = $(this);
              var element = $this.prev('input[type="checkbox"]');
              var parent = $this.closest('tr');
              if (element.length) {

                var pIndex = parent.index();
                if (evt.shiftKey) {
                  if (lastCheckIndex >= 0) {
                    var isChecked,
                    //last_checked = $('tbody input[type="checkbox"]:nth(' + lastCheckIndex.last + ')').prop('checked'),
                      current_checked = ! $('tbody input[type="checkbox"]:nth(' + pIndex + ')').prop('checked');
                    // here, current checkbox has already been clicked, that's why we use the opposite
                    //console.log(last_checked, current_checked);
                    isChecked = current_checked ? 'uncheck' : 'check';
                    $('tbody input[type="checkbox"]').each(function(i, e) {

                      if ((i - pIndex) * (i - lastCheckIndex) <= 0) {
                        // this checkbox is in the range
                        $(e).iCheck(isChecked);
                      }
                    });
                  }
                } else {
                  lastCheckIndex = pIndex;
                }
                lastCheckIndex = pIndex;
              }
            });

          });
        }
      };
    }]);

'use strict';

/**
 * @name history directive
 *
 * @requires globalFunc
 *
 * @description
 * Directive to display the history of the module
 *
 * @copyright MetaCloud Sdn. Bhd. &copy; 2016
 */

angular
  .module('metabuyer')
  .directive('history', function (globalFunc, $filter, auditList) {
    return {
      restrict: 'E',
      scope: {
        dependencies: '='
      },
      replace: true,
      templateUrl: 'components/history/history.html',
      controller: function ($scope) {
        $scope.getActionBy = getActionBy;
        $scope.getAction = getAction;
        $scope.prepareHistoryData = prepareHistoryData;

        $scope.embeddedParams = $scope.dependencies.embeddedParams;
        $scope.service = auditList;
        $scope.historyData = [
          {data: [{loading: true}]}
        ];

        /**
         * Gets the value of 'action_by'.
         *
         * @param {Object} history Single history
         * @returns {*}
         */
        function getActionBy(history) {
          if (!!history && !!history.action_by && history.action_by !== 'system') {
            return history.action_by.display_name;
          } else {
            return history.action_by
          }
        }

        /**
         * Get the value for 'action'.
         *
         * @param {Object} history Single history
         * @returns {string}
         */
        function getAction(history) {
          return (!!history && !!history.action) ? history.action : '';
        }

        /**
         * Filter the history data.
         *
         * @param {Object} historyData Multiple histories
         * @returns {Array}
         */
        function prepareHistoryData(historyData) {
          var preparedData = [];

          _.forEach(historyData, function (history) {
            history.created_at = transformCreatedAt(history.created_at);
            history.changes = recursiveTransformDates(history.changes);
            history.changeArray = transformChanges(history.changes);
            preparedData.push(history);
          });

          return preparedData;
        }

        /**
         * Transform the createdAt timestamp to an object of date and time
         *
         * @param {string} createdAt Created at timestamp string
         * @returns {*}
         */
        function transformCreatedAt(createdAt) {
          if (typeof createdAt !== 'object' && !!createdAt) {
            createdAt = createdAt.replace('__timestamp_', '');
            createdAt = {
              'date': $filter('date')(createdAt, 'dd MMM yyyy'),
              'time': $filter('date')(createdAt, 'h:mm a')
            };
          }

          return createdAt;
        }

        /**
         * Recursively iterate through the history data and converts timestamps to date string.
         *
         * @param {Object} history Single history
         * @returns {*}
         */
        function recursiveTransformDates(history) {
          for (var fieldName in history) {
            if (typeof history[fieldName] === 'object') {
              history[fieldName] = recursiveTransformDates(history[fieldName]);
            } else if (typeof history[fieldName] === 'string' && history[fieldName].indexOf('__timestamp_') > -1) {
              history[fieldName] = history[fieldName].replace('__timestamp_', '');
              history[fieldName] = $filter('date')(history[fieldName], 'dd MMM yyyy');
            }
          }

          return history;
        }

        /**
         * Transform the changes subarray to an array of strings.
         *
         * @param {Array} historyChanges Single history's 'changes' array
         * @returns {Array}
         */
        function transformChanges(historyChanges) {
          var transformedChanges = [];
          if(_.isEmpty(historyChanges)) {
            transformedChanges.push('<i>Internal changes</i>');
          } else {
            _.forEach(historyChanges, function (change) {
              var str = change.field + ': ';
              if (!!change.added) {
                str += '<b>Added:</b> ' + change.added.join(', ') + '. ';
              }
              if (!!change.removed) {
                str += '<b>Removed:</b> ' + change.removed.join(', ') + '. ';
              }
              if (!!change.changed) {
                str += buildChangedString(change.changed);
              }
              transformedChanges.push(str);
            });
          }

          return transformedChanges;
        }

        /**
         * Build the log string if the type is "changed".
         *
         * @param {Array} changeArray Changed subarray
         * @returns {string}
         */
        function buildChangedString(changeArray) {
          var str = '<b>Changed</b>';

          if (!_.isEmpty(changeArray)) {
            str += ': ';
            str += changeArray[0] === '' || _.isNull(changeArray[0]) ? '<i>empty</i>' : changeArray[0];
            str += ' => ';
            str += changeArray[1] === '' || _.isNull(changeArray[1]) ? '<i>empty</i>' : changeArray[1];
          } else {
            str += '.';
          }

          return str;
        }

        /**
         * Get the history data.
         */
        function getHistoryData() {
          auditList.get(
            $scope.dependencies.embeddedParams,
            {}, // payload
            function (resource) {
              if (!!resource.content) {
                $scope.historyData = resource.content.data;
                $scope.meta = resource.content.meta;
              }
            },
            function () {
              $scope.historyData = [];
            }
          );
        }

        function initialize() {
          getHistoryData();
          $scope.$broadcast('pagination', {
            data: $scope.historyData,
            meta: $scope.meta
          });
        }

        initialize();
      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('grnPanel',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope, element, attrs) {

        var panel = function(grn_id, selectedPo) {

          var modalInstance = $uibModal.open({
            templateUrl: 'components/grn/grnTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'grnCtrl',
            scope: scope,
            size: "lg",
            resolve: {
              grn: function($q, getGRN){
                var defered = $q.defer();
                if(!grn_id){
                  defered.resolve({});
                  return defered.promise;
                }

                getGRN.get({id: grn_id},
                  function(resource){
                    if(!!resource && !!resource.content && !!resource.content.data){
                      defered.resolve(resource.content.data);
                    }else{
                      defered.resolve({});
                    }
                  }, function(error){
                    defered.resolve({});
                  });

                return defered.promise;
              },
              po: function(){
                return selectedPo;
              }
            }
          });
        };

        //loading the panel to comment
        scope.showGRNInfo = function(grn_id, selectedPo) {
          panel(grn_id, selectedPo);
        };
      }
    };
  });

'use strict';

function grnCtrl($scope,  $uibModalInstance, grn, po, getGRNPDFHash, $filter, toastr, pathConstants, $rootScope) {

  $scope.grn = grn;
  $scope.po = po;

  $scope.cancel = cancel;
  $scope.printGRN = printGRN;

  function cancel(){
    $uibModalInstance.close();
  }

  function printGRN() {

    var tabWindow = window.open('', '_blank');

    getGRNPDFHash.get(
      {
        id: $scope.grn._id,
        timezone: $rootScope.currentUser.config.TZ
      }
    ).$promise.then(
      function (resource) {
        var newUrl = $filter('format')(pathConstants.apiUrls.po.pdfHash, {
          pdf_hash: resource.url
        });

        setTimeout(function (){
            tabWindow.location.href = newUrl;
          },
          1001
        );
      },
      function(){
        toastr.error('Failed to print GRN');
      }
    );
  }
}

grnCtrl.$inject = ['$scope', '$uibModalInstance', 'grn', 'po', 'getGRNPDFHash', '$filter', 'toastr', 'pathConstants', '$rootScope'];

angular.module('metabuyer')
  .controller('grnCtrl', grnCtrl);

'use strict';
/**
 * @name genericImport Directive
 * @desc Directive for generic import CSV across multiple modules
 *
 * @isolatedScope moduleName
 * To accept the module name to be displayed with button
 *
 * @isolatedScope params
 * To determine which module to generate CSV for
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */
angular
  .module('metabuyer')
  .directive('genericImport', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/genericImport/genericImport-template.html',
      scope: {
        moduleName: '@',
        params: '='
      },
      controller: function ($scope, $http, $uibModal, $filter, $state) {

        $scope.importCSVModal = importCSVModal;

        /**
         * @function importCSV
         * This function is to import CSV with parameters
         *
         */
        function importCSVModal() {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/genericImport/genericImport-modal.html',
            backdrop: 'static',
            keyboard: false,
            scope: $scope,
            controller: function ($scope, globalFunc, pathConstants, toastr, $uibModalInstance) {
              $scope.close = close;
              $scope.importCSV = importCSV;
              $scope.disableImportButton = false;
              var maxErrorMessage = 5;

              $scope.downloadErrorMessage = [
                'Approval Template', 'Position', 'Position Assignment'
              ];

              function close() {
                $uibModalInstance.close();
              }

              /**
               * Function to handle the many import error messages and formats
               * @param errorData
               */
              function importErrorMessages(errorData) {
                // for display purpose
                var errorText = '';
                // for text that automatically downloaded
                var errorFile = '';
                if (!!errorData) {
                  if (typeof errorData !== 'string') {
                    _.forEach(errorData, function (errorMessage, key) {
                      if (typeof errorMessage !== 'string') {
                        if (_.isArray(errorMessage)) {
                          _.forEach(errorMessage, function (errorArray) {
                            errorText += 'Error in row ' + key + ': ' + errorArray + '<br>';
                          })
                        }
                        else {
                          errorText += 'Error in row ' + key + ': ' + errorMessage + '<br>';
                        }
                      }
                      // Ignore the error if it is 'Successfully imported'
                      else if (errorMessage !== 'Successfully imported') {
                        if ($scope.downloadErrorMessage.indexOf($scope.moduleName) > -1) {
                          if (key < maxErrorMessage) {
                            errorText += errorMessage + '<br>';
                          }
                          else if (key === maxErrorMessage) {
                            errorText += '+' + (errorData.length - maxErrorMessage) + ' more error(s)' + '<br>';
                          }
                          errorFile += errorMessage + '\r\n';
                        } else {
                          errorText += errorMessage + '<br>';
                        }
                      }
                    });

                  } else {
                    errorText = errorData;
                  }
                }

                if ($scope.downloadErrorMessage.indexOf($scope.moduleName) > -1 && errorData.length > 0) {
                  downloadErrorFile(errorFile);
                }

                swal({
                  title: 'Import Failed',
                  text: errorText,
                  type: 'warning',
                  html: true,
                  confirmButtonColor: '#1ab394',
                  confirmButtonText: 'Close',
                  closeOnConfirm: true
                });
              }

              function downloadErrorFile(data) {
                var blob = new Blob([data]);
                var link = document.createElement('a');
                document.body.appendChild(link);
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Error Message-' + $filter('date')(new Date(), 'dd-MMM-yyyy') +'.txt';
                link.click();
              }

              function importCSV(csvFile) {
                $scope.disableImportButton = true;
                var fd = new FormData();

                /**
                 * Check if file is selected in the form
                 */
                if (!!csvFile) {
                  fd.append('file', csvFile);
                } else {
                  $scope.disableImportButton = false;
                  toastr.error('Please select a file first');
                  return false;
                }

                if (!!$scope.params) {
                  var paramIteration;
                  for (paramIteration in $scope.params) {
                    if ($scope.params.hasOwnProperty(paramIteration)) {
                      fd.append(paramIteration, $scope.params[paramIteration]);
                    }
                  }
                }

                $http.post(
                  $filter('format')(pathConstants.apiUrls.imports.now), fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                  }
                )
                  .then(function onSuccess(resource) {
                    if (!!resource.data.content) {
                      if (!!resource.data.content.message)
                        toastr.success(resource.data.content.message);
                      else
                        toastr.success($scope.moduleName + ' successfully uploaded');

                      $state.reload();
                    }
                    $uibModalInstance.close();
                  })
                  .catch(function onError(error) {
                    if (!!error.data && !!error.data.content && !!error.data.content.error) {
                      if (_.isString(error.data.content.error) && !_.isString(error.data.content.message)) {
                        if (error.data.content.error !== 'The import was partially successful') {
                          toastr.error(error.data.content.error);
                        }
                        else {
                          toastr.error('Failed to upload CSV file');
                        }
                        importErrorMessages(error.data.content.message);
                      } else if (!_.isString(error.data.content.error)) {
                        importErrorMessages(error.data.content.error);
                      } else {
                        toastr.error('Failed to upload CSV file');
                      }
                    }
                    else {
                      toastr.error('Failed to upload CSV file');
                    }
                    $scope.disableImportButton = false;
                  });
              }
            }
          });
        }
      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .directive('focusInput',function($uibModal, Orders, toastr, $timeout) {
    return{
      restrict: 'A',
      scope: {
        focusInput: "=focusInput"
      },
      link: function(scope, element, attrs) {
        scope.$watch("focusInput", function(value){
          if(!!value){
            $timeout(function(){
              element[0].focus();
            });
          }
        })
      }
    };
  });

/**
 * @name fixHeader
 *
 * @description Directive to make the header on fix position
 *
 * @param height
 * height limit to set as fix header
 * @param width
 * width (boolean), true if want to use the existing width, false to set to auto
 * @param padding
 * fill in with value. to add additional padding
 * @param top
 * set top value
 *
 * @author Deniel
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('fixHeader', function ($window) {
    return {
      restrict: 'A',
      scope:{
        height: '=',
        width: '=',
        padding: '=',
        top: '='
      },
      link: function ($scope, element, attrs) {
        var initBackground,
            initPadding,
            initTop,
            initWidth;

        var fixHeaderElement = document.getElementById('fixHeaderDirective');

        function setFixHeader() {
          var result = document.getElementsByClassName('item-action-scrollfix');
          var wrappedResult = angular.element(result);

          angular.element(fixHeaderElement).css('transition', 'all linear .5s');
          angular.element(fixHeaderElement).css('position', 'fixed');
          angular.element(fixHeaderElement).css('background', 'white');
          angular.element(fixHeaderElement).css('top', '0');
          angular.element(fixHeaderElement).css('z-index', '100');
          angular.element(fixHeaderElement).css('padding', '10px');
          angular.element(fixHeaderElement).css('border-bottom', '#dcdcdc 2px solid');
          if(!!document.getElementById('fixHeaderViewWidth'))
            angular.element(fixHeaderElement).css('width', angular.element(document.getElementById('fixHeaderViewWidth')).prop('offsetWidth') + 'px');
          if (!!wrappedResult && !!wrappedResult.length)
            angular.element(fixHeaderElement).css('top', '62px');

          if (!!$scope.padding)
            angular.element(fixHeaderElement).css('padding', $scope.padding);
          if (!document.getElementById('fixHeaderViewWidth'))
            angular.element(fixHeaderElement).css('width', initWidth);
          if (!!$scope.top)
            angular.element(fixHeaderElement).css('top', $scope.top);
        }

        function removeFixHeader() {
          angular.element(fixHeaderElement).css('position', '');
          angular.element(fixHeaderElement).css('border-bottom', '');
          angular.element(fixHeaderElement).css('z-index', '');
          angular.element(fixHeaderElement).css('background', initBackground);
          angular.element(fixHeaderElement).css('width', '');

          if (!!$scope.padding)
            element.css('padding', initPadding);
          if (!!$scope.top)
            element.css('top', initTop);
        }

        function initialize() {
          initBackground = angular.element(fixHeaderElement).css('backgroundColor');
          initWidth = angular.element(fixHeaderElement).css('width');
          initPadding = angular.element(fixHeaderElement).css('padding');
          initTop = angular.element(fixHeaderElement).css('top');
        }

        initialize();

        /**
         * Event on window scroll
         */
        var timer;
        angular.element($window).bind('scroll', function() {
          if(timer) {
            $window.clearTimeout(timer);
          }

          /**
           * Set a delay of 100ms before calling the set/remove header
           * @type {number}
           */
          timer = window.setTimeout(function() {

            /**
             * Set fix header when scroll is more than 25% of window height
             */
            if (this.pageYOffset >= ($window.innerHeight/4)){
              setFixHeader();
            }
            /**
             * Remove fix header when scroll is less than 10% of window height
             */
            else if(this.pageYOffset < ($window.innerHeight/10)){
              removeFixHeader();
            }

            // to avoid error $digest already in progress
            _.defer(function() {
              $scope.$apply();
            });
          }, 100);

        });
      }
    }
  });

'use strict';
angular
  .module('metabuyer')
  .filter('noFractionCurrency',
  ['$filter', '$locale', function(filter, locale) {
    var currencyFilter = filter('formatDecimal');
    var formats = locale.NUMBER_FORMATS;
    return function(amount) {
      var value = currencyFilter(amount);
      var sep = value.indexOf(formats.DECIMAL_SEP);
      if(amount >= 0) {
        return value.substring(0, sep);
      }
      return value.substring(0, sep) + ')';
    };
  }])
  .filter('decimalCurrency',
  ['$filter', '$locale', function(filter, locale) {
    var currencyFilter = filter('formatDecimal');
    var formats = locale.NUMBER_FORMATS;
    return function(amount) {
      var value = currencyFilter(amount);
      var sep = value.indexOf(formats.DECIMAL_SEP);
      if(amount >= 0) {
        return '.' + value.split(formats.DECIMAL_SEP)[1];
      }
    };
  }]);
'use strict';
angular
  .module('metabuyer')
  .directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function(){
        scope.$apply(function(){
          modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
}]);

'use strict';
angular
  .module('metabuyer')
  .directive('fadeoutRow',function() {
    return {
      restrict: "A",
      scope: {
        enable: "=fadeoutRow"
      },
      link: function (scope, elem, attrs) {

        if (scope.enable) {
          elem.effect("highlight", {}, 1000 * 60 * 60 * 12);
        }
      }
    }
  });

'use strict';
/**
 * @name exportUserAssignmentsCtrl
 *
 * @description
 * Controller for exporting multiple users' assignments
 *
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

function exportUserAssignmentsCtrl(
  $scope, $http, $uibModalInstance, pathConstants, globalFunc, exportUserAssignments, $filter
) {
  $scope.selectedUsers = [];
  $scope.loading = false;

  $scope.searchUsers = searchUsers;
  $scope.close = close;
  $scope.onSelectUser = onSelectUser;
  $scope.exportAssignments = exportAssignments;
  $scope.removeUser = removeUser;

  function searchUsers(query) {

    $scope.loading = true;
    return $http.get(pathConstants.apiUrls.genericSearch.searchBasePath + '/users', {
      params: {
        module: 'users',
        'criteria[1][display_name]': query,
        'criteria[1][email]': query,
        'criteria[0][status]': 1,
        criteria_operator: 'or'
      }
    }).then(function (response) {
      $scope.loading = false;
      if (!!response.data && !!response.data.content && !!response.data.content.data) {
        return response.data.content.data.map(function (item) {
          $scope.loading = false;
          return item;
        });
      } else {
        return null;
      }
    });

  }

  function onSelectUser(user) {
    if (!globalFunc.findInArray($scope.selectedUsers, '_id', user._id)) {
      $scope.selectedUsers.push(user);
      $scope.collaboratorsTextFiled = {
        input: ''
      }
    }
  }

  function exportAssignments() {
    if (!$scope.selectedUsers) {
      globalFunc.objectErrorMessage('Please select at least 1 user')
    }

    var ids = [];
    _.forEach($scope.selectedUsers, function (user) {
      ids.push(user._id);
    });

    exportUserAssignments.get({
      usersIds: [ids]
    }, function (resource) {
      if (!!resource.content && !!resource.content.data) {
        var newUrl = $filter('format')(pathConstants.apiUrls.reports.download, {
          id: resource.content.data
        });

        window.open(newUrl, '_self');
      } else {
        globalFunc.objectErrorMessage('An error occurred.');
      }
    }, function(error) {
      globalFunc.objectErrorMessage(error);
    });
  }

  function removeUser(user) {
    $scope.selectedUsers = globalFunc.removeValueFromArray($scope.selectedUsers, '_id', user._id);
  }

  function close() {
    $uibModalInstance.close();
  }

}

exportUserAssignmentsCtrl.$inject = [
  '$scope', '$http', '$uibModalInstance', 'pathConstants', 'globalFunc', 'exportUserAssignments', '$filter'
];

angular
  .module('metabuyer')
  .controller('exportUserAssignmentsCtrl', exportUserAssignmentsCtrl);

'use strict';
angular
  .module('metabuyer')
  .directive('exportArrayToCsv', function () {
    return {
      restrict: 'E',
      scope: {
        arrayData: '=arrayData',
        fileName: '=fileName',
        trigger: '=trigger'
      },
      controller: function ($scope) {

        function convertToLineText() {
          var finalVal = '';
          for (var i = 0; i < $scope.arrayData.length; i++) {
            var value = $scope.arrayData[i];
            for (var j = 0; j < value.length; j++) {
              var innerValue = value[j] === null ? '' : value[j].toString();
              var result = innerValue.replace(/"/g, '""');
              if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
              if (j > 0)
                finalVal += ',';
              finalVal += result;
            }

            finalVal += '\n';
          }
          return finalVal;
        }

        function exportCsv() {
          var finalVal = convertToLineText();
          var blobLog = new Blob([finalVal]);
          var linkLog = document.createElement('a');
          document.body.appendChild(linkLog);
          linkLog.href = window.URL.createObjectURL(blobLog);
          linkLog.download = $scope.fileName + '.csv';
          linkLog.click();
          $scope.trigger = false;
        }

        $scope.$watch('trigger', function (trigger) {
          if (trigger == true)
            exportCsv();
        });

      }
    };
  });

'use strict';
/**
 * @name exchangeRate
 * @desc directive for the Exchange Rate within a Company
 */
angular
  .module('metabuyer')
  .directive('exchangeRate',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/exchangeRate/exchangeRateTemplate.html',
      scope: {
        data: '=',
        currencies: '=',
        id: '='
      },
      controller: function($scope, $stateParams, $uibModal, toastr,
                           exchangeRateMasterDataList, exchangeRateSearch, ExchangeRate,
                           globalFunc, Currencies, $q, $filter, pathConstants, $rootScope) {

        function onSelectedFromCurrency(selected_data){
          $scope.exchangeRate.source_currency_id = selected_data._id;
        }

        function onSelectedToCurrency(selected_data){
          $scope.exchangeRate.target_currency_id = selected_data._id;
        }

        function openDatepicker($event, which) {
          /**
           * Setting minimum selection for start date to be today
           */
          $scope.startDateOptions.minDate = new Date();

          /**
           * Setting the minimum selection for end date to be one day ahead of selected start date
           */
          var startDateClone = _.cloneDeep($scope.exchangeRate.effective_at);
          var startDate = new Date(startDateClone);
          startDate.setDate(startDate.getDate() + 1);
          $scope.endDateOptions.minDate = startDate;

          $event.preventDefault();
          $event.stopPropagation();

          $scope.datepickerOpened[which] = true;
        }

        $scope.getExchangeRate = function (source_id, target_id) {
          var deferred = $q.defer();

          ExchangeRate.getExchangeRate({
            source_id: source_id,
            target_id: target_id
          }, function(resource) {
            // TODO: check !resource && !!resource.content && !!resource.content.data! && !!resource.content.data.status
            if(!!resource && !!resource.content && !!resource.content.data){
              source_id.rate = resource.content.data;
              deferred.resolve(source_id);
            }
          }, function() {
            deferred.resolve(source_id);
          });

          return deferred.promise;
        };


        $scope.columns= [
          {id: 'code', label: 'Code'},
          {id: 'descr', label: 'Description'},
          {id: 'multiplier_rate', label: 'Rate'},
          {id: 'updated_at', label: 'Updated At'},
          {id: 'updater.display_name', label: 'Updated By'},
          {id: 'created_at', label: 'Created At'},
          {id: 'creator.display_name', label: 'Created By'},
          {id: 'effective_at', label: 'Effective At'},
          {id: 'expiry_at', label: 'Expire At'},
          {id: 'is_active', label: 'Status'}
        ];

        $scope.storageKey = 'companies-exchange-rate-management-selected-columns';

        function showColumn(id){
          for (var i in $scope.columns) {
            if (id === $scope.columns[i].id) {
              if(!!$scope.columns[i].conditional){
                if($scope.status === $scope.columns[i].condition){
                  return $scope.columns[i].selected;
                }
                if($scope.columns[i].condition instanceof Array){
                  for(var j in $scope.columns[i].condition){
                    if($scope.status === $scope.columns[i].condition[j]){
                      return $scope.columns[i].selected;
                    }
                  }
                }
              }else{
                return $scope.columns[i].selected;
              }
            }
          }
        }


        /**
         * returns the is_active name
         * @param code
         * @returns {*}
         */
        function getActiveStatusName(code){
          /**
           DEACTIVATED = 0; 
           ACTIVE = 1; 
           DELETED = 2; 
           DISABLED = 3; 
           */
          if (code === 0 || code === 'DEACTIVATED') {
            return 'Deactivated'
          }
          if (code === 1 || code === 'ACTIVE') {
            return 'Active'
          }
          if (code === 2 || code === 'DELETED') {
            return 'Deleted'
          }
          if (code === 3 || code === 'DISABLED') {
            return 'Disabled'
          }
          return 'N/A';
        }

        function importExchangeRate() {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/exchangeRate/Import-Template.html',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              importLink: function () {
                return $scope.importLink;
              },
              title: function () {
                return 'Exchange Rate';
              },
              id: function() {
                return $scope.id;
              }
            },
            controller: function ($scope, $uibModalInstance, importLink, title, id) {
              $scope.cancel = function () {
                $uibModalInstance.close();
              };

              $scope.importLink = importLink;
              $scope.title = title;
              $scope.id = id;
            }
          });
        }

        function search() {
          // Do not support pagination yet
          var query = $scope.searchText;
          exchangeRateSearch.get(
            {
              id: $scope.id,
              query: query
            },
            function (resource) {
              if (!!resource.content) {
                $scope.dataList = resource.content.data;
                $scope.meta = resource.content.meta;
                $scope.exchangeRateService = exchangeRateMasterDataList;
                $scope.query = query;
              }
            },
            function (error) {
              // not found
            }
          );
        }

        function clearForm(){
          $scope.submitted = false;
          $scope.exchangeRate.descr = '';
          $scope.exchangeRate.status = '';
          $scope.exchangeRate.multiplier_rate = '';
          $scope.exchangeRate.effective_at = '';
          $scope.exchangeRate.expiry_at = '';
          $scope.exchangeRate.fromCurrency = undefined;
          $scope.exchangeRate.toCurrency = undefined;
          $scope.exchangeRate.source_currency_id = undefined;
          $scope.exchangeRate.target_currency_id = undefined;
        }

          function validate(exchangeRate){
              if(!exchangeRate.fromCurrency || !exchangeRate.toCurrency ||
                  (exchangeRate.fromCurrency === exchangeRate.toCurrency)){
                  return false;
              }
              if(!exchangeRate.multiplier_rate || Number(exchangeRate.multiplier_rate) === 0){
                  return false;
              }
              if(!exchangeRate.descr){
                  return false;
              }
              if(!exchangeRate.effective_at || !exchangeRate.expiry_at){
                  return false;
              }

              if(exchangeRate.effective_at >= exchangeRate.expiry_at){
                  return false;
              }

              return true;
          }

        $scope.validateExchangeRate = validateExchangeRate;
        function validateExchangeRate(multiplier_rate) {
            return Number(multiplier_rate) === 0;
        }

        function newExchangeRate() {
          $scope.submitted = true;

          if(!!validate($scope.exchangeRate)) {
            if(!!$scope.exchangeRate){
              $scope.exchangeRate.status = 2;
            }
            //Formatting the dates before posting
            $scope.exchangeRate.effective_at = globalFunc.convertDateToTimestamp($scope.exchangeRate.effective_at);
            $scope.exchangeRate.expiry_at = globalFunc.convertDateToTimestamp($scope.exchangeRate.expiry_at);

            var submit_data = {
              descr: $scope.exchangeRate.descr,
              status: $scope.exchangeRate.status,
              multiplier_rate: $scope.exchangeRate.multiplier_rate,
              effective_at: $scope.exchangeRate.effective_at,
              expiry_at: $scope.exchangeRate.expiry_at,
              source_currency_id: $scope.exchangeRate.source_currency_id,
              target_currency_id: $scope.exchangeRate.target_currency_id
            };

            exchangeRateMasterDataList.post(
              {
                id: $scope.id
              },
              submit_data,
              function (resource) {
                toastr.success('Exchange rate was added successfully');
                if (!!resource.content) {
                  if (!!resource.content.data) {
                    var addedExchangeRate = resource.content.data;
                    $scope.dataList.unshift({
                      _id: addedExchangeRate._id,
                      code: addedExchangeRate.code,
                      descr: addedExchangeRate.descr,
                      multiplier_rate: addedExchangeRate.rate,
                      effective_at: addedExchangeRate.effective_at,
                      expiry_at: addedExchangeRate.expiry_at,
                      created_at: addedExchangeRate.created_at,
                      updated_at: addedExchangeRate.updated_at,
                      updater: [$rootScope.currentUser],
                      creator: [$rootScope.currentUser],
                      is_active: 1
                    });
                  }
                }

                clearForm();
                $scope.submitted = false;
              },
              function (error) {
                clearForm();
                toastr.error('Failed to add exchange rate');
                globalFunc.objectErrorMessage(error);
              }
            )
          }
          else{
            toastr.error('Please fill in all the fields');
          }
        }

        function exchangeRateDetail(exchangeRate) {
          var exchangeRateId = $scope.dataList[exchangeRate]._id;
          var modalInstance = $uibModal.open({
            templateUrl: 'components/exchangeRate/details/details.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'exchangeRateDetailsCtrl',
            size: 'lg',
            resolve: {
              currencyExchange: function(){
                return $scope.currencyExchange;
              },
              exchangeRateDetails: function($q, exchangeRateSpecificRate) {
                var deferred = $q.defer();
                exchangeRateSpecificRate.get(
                  {
                    rate_id: exchangeRateId,
                    id: $scope.id
                  },
                  function (resource) {
                    deferred.resolve(resource.content || {data: []});
                  },
                  function (error) {
                    if (error.status === 404) {
                      deferred.resolve([]);
                    }
                  }
                );
                return deferred.promise;
              }
            }
          });
          modalInstance.result.then(function (newValue) {
            if(!!newValue){
              _.forEach($scope.dataList, function(dataList){
                if(dataList._id === newValue._id){
                  dataList.code = newValue.code;
                  dataList.descr = newValue.descr;
                  dataList.multiplier_rate = newValue.rate;
                  dataList.effective_at = newValue.effective_at;
                  dataList.expiry_at = newValue.expiry_at;
                  dataList.is_active = newValue.is_active;
                  dataList.updater[0].display_name = newValue.updated_by;
                  dataList.updated_at = newValue.updated_at;
                }
              });
            }
          });
        }

        function reset (){
          $scope.query = false;
          exchangeRateMasterDataList.get(
            {
              id: $scope.id
            },
            function (resource) {
              if(!!resource.content){
                if(!!resource.content.data) {
                  $scope.dataList = resource.content.data;
                }
              }
            },
            function (error) {
              toastr.error(error);
            });
        }

        function initialize() {
          $scope.dataList = $scope.data.data;
          $scope.meta = $scope.data.meta;
          $scope.accountCodesListService = exchangeRateMasterDataList;
          $scope.newExchangeRate = newExchangeRate;
          $scope.exchangeRateDetail = exchangeRateDetail;
          $scope.search = search;
          $scope.reset = reset;
          $scope.showColumn = showColumn;
          $scope.getActiveStatusName = getActiveStatusName;
          $scope.importExchangeRate = importExchangeRate;
          $scope.importLink = pathConstants.apiUrls.exchangeRate.import;
          $scope.exchangeRate = {};

          // Datepicker
          $scope.openDatepicker = openDatepicker;
          $scope.startDateOptions = {
            formatYear: 'yy',

            startingDay: 1
          };

          $scope.endDateOptions = {
            formatYear: 'yy',
            startingDay: 1
          };

          $scope.datepickerOpened = {
            start_date: false,
            end_date: false
          };
          $scope.currencyExchange = $scope.currencies.data;

          $scope.onSelectedFromCurrency = onSelectedFromCurrency;
          $scope.onSelectedToCurrency = onSelectedToCurrency;
        }

        initialize();
      }
    }
  });

/**
 * @name escalationBlock
 *
 *
 * @requires $scope
 * @requires $http
 * @requires pathConstants (Metabuyer service)
 *
 * @description
 *
 * The Escalation directive in the User Profile, Will list the users from the depending on the company
 * adding an escalation option is Not mandatory
 *
 * @variable data
 * in data the user is passed, the naming 'data' is not to have the variables confusion as in the user profile
 * the variable 'user' is already taken
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';

angular
  .module('metabuyer')
  .directive('escalationBlock',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/escalationBlock/escalationBlockTemplate.html',
      scope: {
        data: '='
      },
      controller: function ($scope, pathConstants, $http) {
        $scope.delay = 500;
        $scope.onSelect = onSelect;
        $scope.users = function (val, loading) {
          loading = true;
          return $http.get(pathConstants.apiUrls.users.search, {
            params: {
              query: val
            }
          }).then(function (response) {
            loading = false;
            return response.data.content.data.map(function (item) {
              $scope.loading = false;
              return item;
            });
          });
        };
        function onSelect(user, company){
          console.log(user, company);
        }
      }
    }
  });

/**
 * @name embeddedTableHeader
 *
 *
 * @description
 *
 * Directive to handle the Sorting in listing (detail) pages
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('embeddedTableHeader', function () {
    return {
      scope: {
        availableHeaders: '=',
        list: '=',
        service: '=',
        paramsSource: '='
      },
      templateUrl: 'components/embeddedTableHeader/embeddedTableHeaderTemplate.html',
      restrict: 'A',
      controller: 'embeddedTableHeaderCtrl'
    }
  })

  /**
   * @name embeddedTableHeaderCtrl
   *
   * @description
   * The controller of the tableHeader directive handles sorting/resetting in an embedded page
   *
   * @author Ahmed Saleh <a.saleh@vventures.asia>
   * @copyright Sunway Metacloud &copy; 2016
   */
  .controller('embeddedTableHeaderCtrl', function($scope,$rootScope) {
    $scope.sort = sort;
    $scope.checkSelectionAndCondition = checkSelectionAndCondition;

    function sort(col) {
      /**
       * check if the header is a sortable type or not
       */
      if (!col.unsortable) {
        var orderBy;
        var order;
        if ($scope.orderBy !== col.id) {
          /**
           * a new header is selected
           */
          orderBy = col.id;
          order = 1;
        } else if ($scope.order === 0) {
          /**
           * the same header is selected and the sort needs to be discarded
           */
          orderBy = null;
          order = null;
        } else {
          /**
           * the same header is selected and the sort needs to be ascending
           */
          orderBy = col.id;
          order = ($scope.order === null ? 1 : 0);
        }
        var params = $scope.paramsSource;
        angular.extend(params, {order: order}, {order_by: orderBy});
        $scope.service.get(
          params,
          function (resource) {
            if (!!resource.content) {
              $scope.list = resource.content.data;
              setSortingInformation(orderBy, order);
              $rootScope.$broadcast('resetPagination', resource.content);
              $rootScope.$broadcast('updateListing', $scope.list);
            }
          },
          function () {
            setSortingInformation(orderBy, order);
          }
        );
      }
    }

    function checkSelectionAndCondition(col) {
      if (col.conditional === true) {
        if (col.condition === $scope.condition) {
          return col.selected;
        }
        return false;
      } else {
        return col.selected;
      }
    }


    function setSortingInformation(orderBy, order) {
      $scope.sortedCol = orderBy;
      $scope.orderBy = orderBy;
      $scope.order = Number(order);
      if ($scope.order !== 0 && $scope.order !== 1) {
        $scope.order = null;
      }
    }

  });

/**
 * @name embeddedPaginationService
 *
 * @requires $scope
 * @requires $rootScope
 *
 * @description
 *
 * Directive for embedded pagination used without supporting URL
 * This pagination is different from the Pagination service as it depends on loading the data within a different module
 *
 * @listener embeddedPaginationUpdate
 * reinitialize the directive with the new set of data
 *
 * @listener checkPages
 * used to check the state of the page if its a first page or not, in order to reset the pages to first page or not
 * this listener broadcast a message back to the directive using it
 *
 * @Listener addToCountEnd
 *  updates the page end count to provide a single page addition to data without reloading the data
 *
 * $watcher
 * to check if new Data has been sent into the directive in order to refresh the count, as well as initializes it
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';
angular
  .module('metabuyer')
  .directive('embeddedPaginationService',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/pagination/paginationTemplate.html',
      scope: {
        list: '=',
        service: '=',
        type: '=',
        paramsSource: '=?',
        offset: '=?offset',
        meta: '='
      },
      controller: function ($scope, $rootScope) {
        $scope.disablePaginationButtons = false;
        $scope.pageCount = 0;
        $scope.goNextPage = goNextPage;
        $scope.goPreviousPage = goPreviousPage;
        if(!!$scope.meta && !!$scope.meta.cursor) {
          $scope.cursor = $scope.meta.cursor;
        }
        function initialize(){
          //TODO: prepare the data accordingly in case of a support of pages (at this moment only Elements) (Ahmed Saleh)
          if(!!$scope.cursor) {
            $scope.currentPageCode = $scope.cursor.current;
            $scope.nextPageCode = $scope.cursor.next;
            $scope.previousPageCode = $scope.cursor.prev;

            if (!!$scope.cursor.current) {
              $scope.currentCountStart = atob($scope.cursor.current);
            } else {
              $scope.currentCountStart = 1;
            }

            if ($scope.offset === undefined) {
              $scope.offset = $scope.list.length;
            }
            if (!$scope.previousPageCode) {
              $scope.currentCountStart = 1;
            } else {
            }

            if ($scope.cursor.count !== $scope.list.length) {
              $scope.currentCountEnd = $scope.list.length +
                (Number($scope.currentCountStart) !== 1 ? Number($scope.currentCountStart) : 0);
            } else {
              $scope.currentCountEnd = $scope.list.length;
            }
            $scope.totalCount = $scope.cursor.count;

          } else {
            $scope.currentPageCode = null;
            $scope.nextPageCode = null;
            $scope.previousPageCode = null;

            $scope.currentCountStart = 0;
            $scope.currentCountStart = 0;

          }
        }

        function goNextPage(resetCursor) {
          if(!resetCursor) {
            $scope.paramsSource['cursor'] = $scope.nextPageCode;
          }
          else{
            $scope.paramsSource['cursor'] = null;
          }
          $scope.disablePaginationButtons = true;

          $scope.service.get( $scope.paramsSource ,
            function (resource) {
              if (!!resource.content) {
                $scope.list = resource.content.data;
                $scope.disablePaginationButtons = false;
                if (!!resource.content.meta) {
                  if (!!resource.content.meta.cursor) {
                    $scope.meta.cursor = null;
                    $scope.meta.cursor = resource.content.meta.cursor;
                    $scope.pageCount++;
                    $scope.currentCountStart = Number(atob(resource.content.meta.cursor.current)) + 1;
                    $scope.currentCountEnd = $scope.currentCountStart + $scope.list.length - 1;
                    if ($scope.currentCountEnd > $scope.totalCount) {
                      $scope.currentCountEnd = $scope.totalCount;
                    }
                    $scope.currentPageCode = resource.content.meta.cursor.current;
                    $scope.nextPageCode = resource.content.meta.cursor.next;
                    $scope.previousPageCode = resource.content.meta.cursor.prev;
                  }
                }
                $rootScope.$broadcast('updateEmbeddedPagination', resource.content);
              }
            },
            function () {
              $scope.disablePaginationButtons = false;
            }
          );
        }

        function goPreviousPage() {
          $scope.paramsSource['cursor'] = $scope.previousPageCode;
          $scope.disablePaginationButtons = true;
          $scope.service.get( $scope.paramsSource ,
            function (resource) {
              if (!!resource.content) {
                $scope.list = resource.content.data;
                $scope.disablePaginationButtons = false;
                if (!!resource.content.meta) {
                  if (!!resource.content.meta.cursor) {
                    $scope.pageCount--;
                    $scope.currentCountStart = Number(atob(resource.content.meta.cursor.current)) + 1;
                    $scope.currentCountEnd = $scope.currentCountStart + $scope.list.length - 1;
                    if ($scope.currentCountEnd > $scope.totalCount) {
                      $scope.currentCountEnd = $scope.totalCount;
                    }
                    $scope.currentPageCode = resource.content.meta.cursor.current;
                    $scope.nextPageCode = resource.content.meta.cursor.next;
                    $scope.previousPageCode = resource.content.meta.cursor.prev;
                  }
                }
              }
              $rootScope.$broadcast('updateEmbeddedPagination', resource.content);
            },
            function () {
              $scope.disablePaginationButtons = false;
            }
          );
        }

        /**
         *  Receive the broadcast for pagination
         *  used for promised data
         *  in case of a second page, supporting only meta update
         */
        /**
         * TODO: this is being called by multiple directives concurrently, needs to investigate and come up with a better solution (Ahmed Saleh, 31/10/2016)
         */
        $scope.$on('embeddedPaginationUpdate', function (event, args) {
          if(!!args.data) {
            $scope.list = args.data;
          }
          if(!!args.meta) {
            $scope.cursor = args.meta.cursor;
          }
          $scope.offset = args.offset;
          initialize();
        });
        $scope.$on('checkPages', function () {
          if(!!$scope.meta && !!$scope.meta.cursor && $scope.meta.cursor.prev !== null) {
             goNextPage(true);
          }
          else{
            $rootScope.$broadcast('firstPageIsTrue');
          }
        });

        /**
         *  Receive broadcast for initializing the pagination
         */
        $scope.$on('initializePagination', function(){
          initialize()
        });
        /**
         *  Receive broadcast for updating the end count of a page
         */
        $scope.$on('addToCountEnd', function(){
          $scope.currentCountEnd ++;
        });

        /**
         *  Receive broadcast for get the new list and reset the counts
         */
        $scope.$on('resetPagination', function(event, args){
          if(!!args.data) {
            $scope.list = args.data;
          }
          if(!!args.meta){
            $scope.cursor = args.meta.cursor;
          }
          $scope.offset = args.offset;
          $scope.pageCount = 0;
          initialize();
        });

        $scope.$watch('meta', function(meta){
          if(!!meta) {
            $scope.cursor = meta.cursor;
            /**
             * resetting all the data as its a new set of pagination
             * @type {null}
               */
            $scope.currentCountEnd = null;
            $scope.pageCount = 0;
            $scope.totalCount = null;
            $scope.currentPageCode = null;
            $scope.nextPageCode = null;
            $scope.previousPageCode = null;
          }
          initialize();
        });
      }
    };
  });

(function(){
  'use strict';

  angular.module('metabuyer')
    .directive('editableFocus', function() {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          focus: '=',
          isTextarea: '=',
          textPlaceholder: '=',
          inputPlaceholder: '=',
          updateFunction: '&',
          enableShowLessShowMore: '='
        },
        templateUrl: 'components/editableFocus/editableFocusTemplate.html',
        controller: function($scope) {
          $scope._ = {
            isEmpty: _.isEmpty // check empty string && null && undefined
          };
        },
        link: function(scope, element, attr){
          var input;
          if(!scope.isTextarea) {
            input = element.find('input');
            input.bind('keydown', function (event) {
              if (event.which === 13 || event.keyCode === 13) {
                event.preventDefault();
                scope.focus = false;
                scope.$apply();
              }

            });

            element.find('textarea').remove();
          } else if(!!scope.isTextarea) {
            input = element.find('textarea');
            input.addClass('google-contact-textarea');
            if(!!scope.model) {
              input[0].style.height = '200px';
            }
            input.on('keyup', function() {
              this.style.height = "5px";
              this.style.height = (this.scrollHeight)+"px";
            });

            element.find('input').remove();
          }

          input.on('blur', function (event) {
            scope.focus = false;
            scope.updateFunction();
            scope.$apply();
          });
        }
      }
    })
})();

'use strict';
angular
  .module('metabuyer')
  .directive('editContact',function($uibModal, toastr) {
    return{
      restrict: 'A',
      scope: {
        editContact: '=editContact',
        updatedContact: '&'
      },
      link: function(scope, element, attrs) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/editContact/editContactTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'editContactCtrl',
            scope: scope
          });
        };
        //loading the panel
        scope.showEditAddress = function () {
          panel();
        };

        element.bind('click', function($event){
          scope.showEditAddress();
        });
      }
    };
  });

'use strict';

function editContactCtrl($scope, $uibModalInstance, toastr, Contacts, globalFunc) {

  //cancel action
  $scope.cancel = function () {
    $uibModalInstance.close();
  };

  function validateContact() {
    if (!$scope.edit_data.first_name) {
      return false;
    }

    if (!$scope.edit_data.phone) {
      return false;
    }

    if (!$scope.isValidPhoneNo) {
     return false;
    }

    // temporary fix
    // if (!$scope.isValidFaxNo) {
    //   return false;
    // }

    return true;
  }

  /**
   * Validate number format with given element id and returns boolean in field name
   *
   * @param {string} elementId
   * @param {string} fieldName
   */
  function validateNumbers(elementId, fieldName) {
    $scope[fieldName] = globalFunc.numberFormatValidation(elementId);
  }

  //proceed action
  function updateContactInfo() {
    $scope.clicked_submit = true;
    if (!validateContact()) {
      toastr.error('Please fill all required fields');
      return;
    }

    if (!!$scope.edit_data.email && !globalFunc.emailFormatValidation($scope.edit_data.email)) {
      toastr.error('Please enter a valid email address');
      return;
    }
    Contacts.updateContact({id: $scope.editContact._id}, $scope.edit_data,
      function (success) {
        toastr.success('Contact updated');
        $scope.edit_data._id = $scope.editContact._id;

        $scope.updatedContact({contact: $scope.edit_data});

        $uibModalInstance.close();
      }, function (error) {
        globalFunc.objectErrorMessage(error);
        $uibModalInstance.close();
      });

  }

  function initialize() {
    $scope.edit_data = _.cloneDeep($scope.editContact);
    $scope.validateContact = validateContact;
    $scope.validateNumbers = validateNumbers;
    $scope.updateContactInfo = updateContactInfo;
    $scope.emailFormatValidation = globalFunc.emailFormatValidation;
    $scope.isValidPhoneNo = true;
    $scope.isValidFaxNo = true;
  }

  initialize();
}

editContactCtrl.$inject = ['$scope', '$uibModalInstance', 'toastr', 'Contacts', 'globalFunc'];

angular.module('metabuyer')
  .controller('editContactCtrl', editContactCtrl);

'use strict';
angular
  .module('metabuyer')
  .directive('editAddress',function($uibModal, toastr) {
    return{
      restrict: 'A',
      scope: {
        editAddress: "=editAddress",
        updatedAddress: "&"
      },
      link: function(scope, element) {

        var panel = function () {
          $uibModal.open({
            templateUrl: 'components/editAddress/editAddressTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'editAddressCtrl',
            scope: scope
          });
        };
        //loading the panel
        scope.showEditAddress = function () {
          panel();
        };

        element.bind("click", function($event){
          scope.showEditAddress();
        });
      }
    };
  });

'use strict';

function editAddressCtrl($scope, $uibModalInstance, toastr, $q, addressList, singleAddress) {
  $scope.edit_data = {};
  if(!_.isArray($scope.editAddress) && !!$scope.editAddress){
    $scope.edit_data = _.cloneDeep($scope.editAddress);
  }

  //cancel action
  $scope.cancel = function(){
    $uibModalInstance.close();
  };

  $scope.validateEditAddress = function(){
    if(!$scope.edit_data.line1){
      return false;
    }

    if(!$scope.edit_data.state){
      return false;
    }

    if(!$scope.edit_data.city){
      return false;
    }

    if(!$scope.edit_data.country){
      return false;
    }

    return true;
  };

  function getUpdateData(){
    var update_data = {line1: $scope.edit_data.line1
      , city: $scope.edit_data.city
      , state: $scope.edit_data.state
      , country: $scope.edit_data.country};

    if(!!$scope.edit_data.line2){
      update_data.line2 = $scope.edit_data.line2;
    }

    if(!!$scope.edit_data.line3){
      update_data.line3 = $scope.edit_data.line3;
    }

    if(!!$scope.edit_data.postal_code){
      update_data.postal_code = $scope.edit_data.postal_code;
    }

    return update_data;
  }

  //proceed action
  $scope.update = function(){
    if($scope.validateEditAddress() == false){
      toastr.error("Please fill all required fields");
      return;
    }

    if(!$scope.editAddress || !$scope.editAddress._id){
      addressList.post(getUpdateData(),
        function(resource){

          toastr.success('Updated address');
          $uibModalInstance.close();

          if(!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id){
            $scope.edit_data._id = resource.content.data._id;
          }

          $scope.updatedAddress({address: $scope.edit_data});

        }, function(error){

        });

      return;
    }

    singleAddress.put({id: $scope.editAddress._id}, getUpdateData(),
      function(success){
        toastr.success("Updated address");

        $uibModalInstance.close();

        $scope.updatedAddress({address: $scope.edit_data});

      }, function(error){
        toastr.error('Failed to update address');
        $uibModalInstance.close();
      });
  };
}

editAddressCtrl.$inject = ['$scope', '$uibModalInstance', 'toastr', '$q', 'addressList', 'singleAddress'];

angular.module('metabuyer')
  .controller('editAddressCtrl', editAddressCtrl);

/**
 * @name dynamicHeight
 *
 * @requires $rootScope
 *
 * @description Directive to handling the height and detect the device height
 *
 * @author Deniel
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('dynamicHeight', function ($window) {
    return {
      restrict: 'A',
      link: function ($scope, element, attrs) {

        var dynamicHeight = document.getElementById('dynamicHeightTable');

        function setHeight() {
          var windowsHeight = window.innerHeight;
          var headerHeight = 207;
          var additionalHeight = 50;
          var newHeight = windowsHeight - headerHeight - additionalHeight;

          angular.element(dynamicHeight).css('max-height', newHeight + 'px');
          angular.element(dynamicHeight).css('display', 'block');
        }

        angular.element($window).bind('resize', function() {
          setHeight();

          // to avoid error $digest already in progress
          _.defer(function() {
            $scope.$apply();
          });
        });

        setHeight();
      }
    }
  });

'use strict';

angular.module('dropzone', []).directive('dropzone', function () {
  return function (scope, element, attrs) {
    var config, dropzone;

    config = scope[attrs.dropzone];

    // create a Dropzone for the element with the given options
    dropzone = new Dropzone(element[0], config.options);

    // bind the given event handlers
    angular.forEach(config.eventHandlers, function (handler, event) {
      dropzone.on(event, handler);
    });
  };
});
 
'use strict';

/**
 * @name diffVersion directive
 *
 * @description
 * to display diff between two value
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

angular
  .module('metabuyer')
  .directive('diffVersion', function() {
    return {
      restrict: 'E',
      scope: {
        prevVal: '=',
        newVal: '=',
        filterDecimal: '=',
        lineBreak: '='
      },
      replace: true,
      templateUrl: 'components/diffVersion/diffVersion.html',
      link: function($scope) {

      }
    }
  });

/**
 * @name companyGroupsManagement
 *
 * @requires $uibModal
 *
 * @description
 * A directive to display the company group management modal
 *
 *
 *
 * @authors Ahmed Saleh (a.s.alsalali@gmail.com
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('companyGroupsManagement',function($uibModal) {
    return{
      restrict: 'EA',
      scope: {},
      link: function(scope, element) {

        function panel() {
          $uibModal.open({
            templateUrl: 'components/companyGroupsManagement/companyGroupsManagementTemplate.html',
            controller: 'companyGroupsManagementCtrl',
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            resolve: {
              dataList: function ($q, searchModule, globalFunc) {
                var deferred = $q.defer();
                searchModule.get({
                  module: 'catalog-groups',
                  offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content);
                    } else {
                      deferred.resolve([]);
                    }
                  }, function (error) {
                    globalFunc.objectErrorMessage(error);
                    deferred.resolve([]);
                  });
                return deferred.promise;
              },
              companyGroup: function($q, searchModule, globalFunc) {
                var deferred = $q.defer();

                searchModule.get(
                  {
                    module: 'companies',
                    offset: 0
                  },
                  function (resource) {
                    if (!!resource.content) {
                      deferred.resolve(resource.content);
                    } else {
                      deferred.resolve([]);
                    }
                  },
                  function (error) {
                    globalFunc.objectErrorMessage(error);
                    deferred.resolve([]);
                  }
                );
                return deferred.promise;
              }
            }
          });
        }

        element.bind('click', function($event){
          panel();
        });

      }
    };
  });

/**
 * @name companyGroupsManagementCtrl
 *
 * @requires $scope
 * @requires searchModule
 * @requires $timeout
 * @requires $uibModalInstance
 * @requires globalFunc
 * @requires dataList
 * @requires companyGroupsList
 * @requires companyGroupsAction
 *
 * @description Controller for the Modal of Company Groups Management
 *
 *
 * @authors Ahmed Saleh (a.s.alsalali@gmail.com)
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

function companyGroupsManagementCtrl ($scope, dataList, companyGroup, $timeout, companyGroupsList, $uibModalInstance, companyGroupsAction, globalFunc, pathConstants, $uibModal, toastr) {

  $scope.importLink = pathConstants.apiUrls.imports.now;

  function close(){
    $uibModalInstance.close();
  }

  /**
   * adding groups function
   * @param title
   */
  function addGroup(code, descr) {
    $scope.saving = true;
    companyGroupsList.post({
      code: code,
      descr: descr
    }, function (resource) {
      $scope.saving = false;
      if (!!resource.content && !!resource.content.data) {
        $scope.selectedGroup = resource.content.data;
        $scope.groupsList.push($scope.selectedGroup);
      }
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    });
  }

  /**
   * add a new object for groups to work with
   */
  function createGroup() {
    $scope.selectedGroup = [];
  }

  /**
   * update the title for the group
   * @param title
   * @param id
   */
  function updateGroupTitle(descr, id){
    $scope.saving = true;
    companyGroupsList.put({
      groupId: id,
      code: $scope.selectedGroup.code,
      descr: descr
    }, function (resource) {
      $scope.saving = false;
      var temp = findIndex();
      if(temp > 0) {
        $scope.groupsList[temp].descr = descr
      }
    }, function (error) {
      $scope.saving = false;
      /**
       * returning data to original state
       */
      var temp = findIndex();
      if(temp > 0) {
        $scope.groupsList[temp].code = dataList[temp].code;
        $scope.groupsList[temp].descr = dataList[temp].descr;
      }
      globalFunc.objectErrorMessage(error);
    });
  }


  /**
   * assign the selected group as active one to work with
   * @param group
   */
  function selectGroup(group) {
    $scope.selectedGroup = angular.copy(group);
    loadGroupsCompanies(group);
  }

  /**
   * load the companies once a group is selected
   * @param group
   */
  function loadGroupsCompanies(group) {
    $scope.selectedGroup.companies = [];
    var temp;
    _.forEach($scope.companies, function (company) {
      temp = checkCompany(company, group);
      if (!!temp) {
        $scope.selectedGroup.companies.push(temp);
      }
    });
    $scope.selectedGroup.companies = globalFunc.sortObjectsArray($scope.selectedGroup.companies, 'descr');
  }

  /**
   * check inside the company array
   * @param company
   * @param group
   * @returns {*}
   */
  function checkCompany(company, group) {
    var temp = null;
    if (!!company.catalog_groups) {
      _.forEach(company.catalog_groups, function (companyGroup) {
        if (companyGroup._id === group._id) {
          temp = company;
        }
      });
    }
    return temp;
  }

  /**
   * add / remove a company from a group
   * @param data
   * @param action
   */
  function updateCompanies(data, action){
    if(!!$scope.selectedGroup && !!$scope.selectedGroup._id) {
      $scope.saving = true;
      companyGroupsAction.put({
          groupId: $scope.selectedGroup._id,
          companyId: data.code
        },
        {
          action: action
        },
        function (resource) {
          if(action === 'assign')
            toastr.success('Company assigned');
          else
            toastr.success('Company unassigned');

          $scope.saving = false;
          if (!data.catalog_groups) {
            data.catalog_groups = [];
          }
          /**
           * adding/removing the group to/from the company model, so there is no need to reload the data
           */
          if(action === 'assign') {
            data.catalog_groups.push($scope.selectedGroup);
          }
          else{
            data.catalog_groups = globalFunc.removeValueFromArray(data.catalog_groups, '_id', $scope.selectedGroup._id);
          }
          data.catalog_groups = globalFunc.sortObjectsArray(data.catalog_groups, 'descr')
        },
        function (error) {
          $scope.saving = false;
          /**
           * returning data to original state
           */
          var temp = findIndex();
          if (temp > 0) {
            $scope.groupsList[temp].companies = dataList[temp].companies;
          }

          globalFunc.objectErrorMessage(error);
        });
    }
  }

  function importCatalogGroup() {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/masterDataManagement/Import-Template.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        importLink: function () {
          return $scope.importLink;
        },
        title: function () {
          return 'Catalog Group Assignment';
        }
      },
      controller: function ($scope, $uibModalInstance, importLink, title) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.importLink = importLink;
        $scope.title = title;
        $scope.params = {
          class: 'Metabuyer\\Models\\CatalogGroup',
          'additional_params[]': ''
        };
      }
    });
  }


  /**
   * cool down timer to update the selected Group
   * @param type
   * @param data
   */
  function saveChanges(code, descr){

    $timeout.cancel(countdown);
    countdown =
      $timeout(function(){
        /**
         * Adding different Actions here.
         */

          if(!code || code.trim() === ''){
            globalFunc.objectErrorMessage('Please Add a code');
          }else if(!descr || descr.trim() === ''){
            globalFunc.objectErrorMessage('Please Add a description');
          }
          else {
            if(!$scope.selectedGroup._id){
              addGroup(code, descr);
            }else{
              updateGroupTitle(descr,$scope.selectedGroup._id);
            }
          }

      }, 3000);
  }

  /**
   * deleting the groups and remove it from the List
   */
  function deleteGroup(){
    $scope.saving = true;
    companyGroupsList.delete({
      groupId: $scope.selectedGroup._id
    }, function (resource) {
      $scope.saving = false;
      var temp = findIndex();
      if(temp > 0) {
        $scope.groupsList.splice(temp, 1);
      }
    }, function (error) {
      globalFunc.objectErrorMessage(error);
    });
  }

  function findIndex(){
    for(var i in $scope.groupsList){
      if ($scope.groupsList[i]._id === $scope.selectedGroup._id){
        return i;
      }
    }
    return -1;
  }


  function initialize(){
    $scope.showDeleteButton = false;
  }

  initialize();

  $scope.groupsList         = dataList.data;
  $scope.companies          = companyGroup.data;
  $scope.selectGroup        = selectGroup;
  $scope.deleteGroup        = deleteGroup;
  $scope.saveChanges        = saveChanges;
  $scope.createGroup        = createGroup;
  $scope.importCatalogGroup = importCatalogGroup;
  $scope.updateCompanies    = updateCompanies;
  $scope.close              = close;
  var countdown;


}

companyGroupsManagementCtrl.$inject = ['$scope', 'dataList', 'companyGroup', '$timeout', 'companyGroupsList', '$uibModalInstance', 'companyGroupsAction', 'globalFunc', 'pathConstants', '$uibModal', 'toastr'];

angular.module('metabuyer')
  .controller('companyGroupsManagementCtrl', companyGroupsManagementCtrl);

'use strict';

/**
 * @name companyBillingOptions directive
 *
 * @description
 * The directive is to set the additional billing options for purchase requisitions that belong to the company
 *
 * @author Ahmed Saleh (a.saleh@metabuyer.com)
 * @copyright Sunway Metacloud &copy; 2016
 */

angular
  .module('metabuyer')
  .directive('companyBillingOptions', function() {
    return {
      restrict: 'E',
      scope: {
        company: '='
      },
      templateUrl: 'components/companyBillingOptions/companyBillingOptionsTemplate.html',
      controller: function ($scope, searchModule, globalFunc, Companies, toastr, $state) {

        $scope.availableCompanies = [];
        $scope.defaultBilledCompany = {
          selected: null
        };
        $scope.selectedBilledToCompanies = [];
        $scope.addToBillingCompanies = addToBillingCompanies;
        $scope.selectDefaultBillingCompany = selectDefaultBillingCompany;
        $scope.removeFromBillingCompanies = removeFromBillingCompanies;
        $scope.enableEditMode = enableEditMode;
        $scope.submit = submit;
        $scope.cancel = cancel;

        function setBillingInfo() {
          $scope.selectedBillingCompanies = [];
          $scope.defaultBilledCompany.selected = null;
          if (!!$scope.company.billingCompanies) {
            _.forEach($scope.company.billingCompanies, function (companyCode) {
              var temp = globalFunc.findInArray($scope.availableCompanies,
                'code', companyCode);
              if (!!temp) {
                $scope.selectedBillingCompanies.push(temp);
              }
            });

          }

          if (!!$scope.company.defaultBillingCompany) {
            $scope.defaultBilledCompany.selected =
              globalFunc.findInArray($scope.availableCompanies,
                'code', $scope.company.defaultBillingCompany);
          }
        }

        function initialize() {
          $scope.editMode = false;

          /**
           * load all companies
           */
          searchModule.get(
            {
              module: 'companies',
              offset: 0,
              order: 1,
              order_by: 'descr'
            },
            function (resource) {
              if (!!resource.content) {
                $scope.availableCompanies = resource.content.data;
                setBillingInfo();
              } else {
                globalFunc.objectErrorMessage('An error occurred');
              }
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        function addToBillingCompanies(com) {
          if (!globalFunc.findInArray($scope.selectedBillingCompanies, '_id', com._id))
            $scope.selectedBillingCompanies.push(com);

          if ($scope.selectedBillingCompanies.length === 1 && $scope.defaultBilledCompany.selected == null) {
            $scope.defaultBilledCompany.selected = com;
          }
        }

        function removeFromBillingCompanies(com) {
          $scope.selectedBillingCompanies =
            globalFunc.removeValueFromArray($scope.selectedBillingCompanies, '_id', com._id);
          if (!!$scope.defaultBilledCompany.selected && $scope.defaultBilledCompany.selected._id === com._id) {
            $scope.defaultBilledCompany.selected = null;
          }

          if ($scope.selectedBillingCompanies.length === 1 && $scope.defaultBilledCompany.selected == null) {
            $scope.defaultBilledCompany.selected = $scope.selectedBillingCompanies[0];
          }
        }

        function selectDefaultBillingCompany(com) {
          $scope.defaultBilledCompany = com;
        }

        function enableEditMode() {
          $scope.editMode = true;
        }

        function prepareCompanyChangedData() {
          var companyCodes = [];

          _.forEach($scope.selectedBillingCompanies, function (company) {
            companyCodes.push(company.code);
          });

          /**
           * re-fill up the required data to avoid errors
           */
          var companyDataChanges = {};
          companyDataChanges.fax = $scope.company.fax;
          companyDataChanges.email = $scope.company.email;
          companyDataChanges.phone = $scope.company.phone;
          companyDataChanges.corresponding_address_id = $scope.company.corresponding_address._id;
          companyDataChanges.PO_initial_status = $scope.company.PO_initial_status.value;
          companyDataChanges.expense_types = globalFunc.getArrayOfKeyValues($scope.company.expense_types, '_id');
          companyDataChanges.allowedToHoldPR = $scope.company.config.allowedToHoldPR;
          companyDataChanges.billingCompanies = companyCodes;
          companyDataChanges.defaultBillingCompany = !!$scope.defaultBilledCompany.selected ?
            $scope.defaultBilledCompany.selected.code : null;
          companyDataChanges.budget_setting = $scope.company.budget_setting;

          return companyDataChanges;
        }

        function submit() {
          var newData = prepareCompanyChangedData();
          Companies.put(
            {
              id: $scope.company._id
            }, newData,
            function () {
              toastr.success('Successfully updated');
              //todo: update company billing to correctly without using state reload
              $state.reload();
            },
            function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }

        function cancel() {
          setBillingInfo();
          //todo: update company billing to correctly without using state reload
          $state.reload();
        }

        initialize();
      }
    }
  });

/**
 * @name commentsPanel
 *
 * @requires $rootScope
 * @requires toastr
 *
 * @description Directive for handling comments and history
 * This directive is for displaying the html as well as handling logic for comments and history
 *
 * Logic involved:
 * Display comments and history with pagination
 * Add comments
 * Tag users via @ mentio
 * Creator of comments can delete comments
 *
 * @isolatedScope commentsObject
 * Isolated scope for parent scope's comments object, e.g. pr or po object
 * @bindingType Two way binding
 *
 * @isolatedScope commentsBackupObject
 * Isolated scope for parent scope's backup object, e.g. backup_pr
 * @bindingType Two way binding
 *
 * @isolatedScope commentsModule
 * Isolated scope to determine which module is the directive being called
 * @bindingType Attribute binding
 *
 * @isolatedScope commentsService
 * Isolated scope for parent scope's comment service to be used for the methods
 * @bindingType Two way binding
 *
 * @isolatedScope deleteService
 * Isolated scope parent scope's delete service to be used for delete method
 * @bindingType Two way binding
 *
 * @isolatedScope contactOptions
 * Isolated scope for parent scope's options.contact_persons for mentioning
 * @bindingType Two way binding
 *
 * @isolatedScope disableComment
 * Isolated scope for disable comment flag
 * @bindingType Two way binding
 *
 * @author Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .directive('commentsPanel', function () {
    return {
      scope: {
        commentsObject: '=?',
        commentsBackupObject: '=?',
        commentsModule: '@?',
        commentsService: '=?',
        deleteService: '=',
        contactOptions: '=?',
        disableComment: '=?'
      },
      template: '<div ng-include="template"></div>',
      restrict: 'E',
      controller: function ($scope, $rootScope, toastr, globalFunc) {

        if ($scope.commentsModule === 'PR') {
          $scope.pr = $scope.commentsObject;
        }
        if ($scope.commentsModule === 'PO') {
          $scope.po = $scope.commentsObject;
        }
        $scope.usersList = [];
        $scope.tag_contact_person = [];
        $scope.tag_collaborator = [];
        $scope.commentsAndHistory = [];
        $scope.userBasePath = $rootScope.userImageBasePath;
        $scope.user = $rootScope.currentUser;
        $scope.commentSize = 10;
        $scope.commentPageCount = 0;
        $scope.meta = {};
        $scope.mentions = [];

        $scope.selectTagName = selectTagName;
        $scope.postComment = postComment;
        $scope.readMoreComment = readMoreComment;
        $scope.deleteComments = deleteComments;
        $scope.getGRNNumber = getGRNNumber;
        $scope.getCommentAction = getCommentAction;
        $scope.getClosedItemIndex = getClosedItemIndex;
        $scope.disabled = $scope.disableComment;
        $scope.comment = {
          text: ''
        };

        getHeaderTitle();

        /**
         *  Receive broadcast for updated embedded pagination data to update on controller side
         */
        $scope.$on('updateEmbeddedPagination', function (event, content) {
          if(!!content && !!content.data)
          $scope.commentsAndHistory = content.data;
        });

        $scope.template = $rootScope.isMobileMode ? 'components/comments/comments-panel-mobile.html' :
          'components/comments/comments-panel.html';

        $scope.$on('refreshComments',function(){
          refreshHistory();
        });

        $scope.$on('collaboratorAdjusted', function (event, args) {
          refreshHistory();
        });

        function refreshHistory() {
          $scope.meta = {};
          $scope.commentsAndHistory.splice(0, $scope.commentsAndHistory.length);
          $scope.readMoreComment();
        }

        if (!$scope.isFirstCreate) {
          $scope.meta = {};
          $scope.commentsAndHistory.splice(0, $scope.commentsAndHistory.length);
          $scope.readMoreComment();
        }

        //tag on contact_person
        $scope.$watch('contactOptions', function (newValue) {
          $scope.tag_contact_person.splice(0, $scope.tag_contact_person.length);
          _.forEach(_.forEach(newValue, function (person) {
            person.label = person.display_name
          }), function (item) {
            $scope.tag_contact_person.push(item);

            $scope.usersList = $scope.tag_contact_person;
            $scope.usersList = _.uniq($scope.usersList, function (item) {
              return item._id;
            });
            $scope.usersList.unshift(
              {
                _id: '_all_',
                label: 'all'
              }
            );

          });
        }, true);

        function deleteComments(activity) {
          swal({
            title: 'Confirm delete comment?',
            showCancelButton: true,
            confirmButtonColor: '#1ab394',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            closeOnConfirm: true,
            closeOnCancel: true
          }, function (isConfirm) {
            if (isConfirm) {
              var deleteCommentService = $scope.deleteService;
              var params = {
                commentId: activity._id
              };

              deleteCommentService.delete(
                params ,
                function () {
                  refreshHistory();
                },
                function(error) {
                  globalFunc.objectErrorMessage(error);
                  refreshHistory();
                }
              )
            }
          });
        }

        function getGRNNumber(value) {
          if (!!value) {
            var index = value.indexOf('(');

            if (index !== -1) {
              return value.substr(index, value.length);
            }
          }

          return '';
        }

        function getCommentAction(activity) {
          if (!activity) {
            return '';
          }

          var moduleName;
          switch($scope.commentsModule) {
            case 'PR':
              moduleName = 'purchase requisition';
              break;
            case 'PO':
              moduleName = 'purchase order';
              break;
            case 'Budget':
              moduleName = 'budget';
              break;
            case 'SupplierTag':
              moduleName = 'supplier tag';
              break;
          }

          // TODO: Update the switch case after CommentHistory refactor for PR/PO(Justin 7/9/17)
          switch(activity.action) {
            case 'AWAITING_DELIVERY':
              return ' set the PO to awaiting delivery';
              break;
            case 'DELIVERY_DATE_UNCONFIRMED':
              return ' set the delivery date to unconfirmed';
              break;
            case 'CANCELLED':
              return ' cancelled PO';
              break;
            case 'RESENT':
              return activity.comment;
              break;
            case 'Received goods':
              return ' commented on received goods';
              break;
            case 'Reversed goods':
              if(!!activity.comment) {
                return ' reversed goods. Set PO to awaiting delivery';
              }
              else {
                return ' commented on reverse goods';
              }
              break;
            case 'LINE ITEM CLOSED':
              return ' closed line item (' + ($scope.getClosedItemIndex(activity._id) + 1) + ')';
              break;
            case 'ATTACHED':
              return ' attached ' + activity.comment + ' to the PO';
              break;
            case 'ATTACHMENT UPDATED':
              return ' updated attachment';
              break;
            case 'EMAIL_SEND_FAILED':
              return ' ' + activity.comment;
              break;
            case 'REMOVE_ATTACHMENT':
              return ' removed ' + activity.comment + ' from the PO';
              break;
            case 'SUBMITTED':
              return activity.comment;
              break;
            case 'created':
              return ' created this ' + moduleName;
              break;
            case 'created_comment':
              return ' commented';
              break;
            case 'fully_approved':
              return 'fully approved this ' + moduleName;
              break;
            case 'added_collaborators':
              return 'added a collaborator: ' + activity.collaborator.display_name;
              break;
            case 'removed_collaborators':
              return 'removed a collaborator: ' + activity.collaborator.display_name;
              break;
            case 'escalated':
              return ' has been escalated in this ' + moduleName;
              break;
            case 'delegated':
              return ' has been delegated in this ' + moduleName;
              break;
            case 'expired':
              return moduleName + ' has expired';
              break;
            case 'expired_delegated':
              return ' is no longer being delegated for this ' + moduleName;
              break;
            case 'rollback':
              return ' has rolled back this ' + moduleName;
              break;
            case 'resubmit':
              return ' has edited and resubmitted this ' + moduleName;
              break;
            case 'on_hold':
              return ' placed this ' + moduleName + ' on hold';
              break;
              //TODO: get the action of releasing hold on a module's approval (Justin 12/9/17)
            case 'release':
              return ' released the hold on this ' + moduleName;
              break;
            case 'added_attachments':
              return activity.comment;
              break;
            case 'removed_attachments':
              return activity.comment;
              break;
            case 'tagged_supplier':
              return ' tagged supplier: ' + activity.supplier_descr;
              break;
            case 'untagged_supplier':
              return ' untagged supplier: ' + activity.supplier_descr;
              break;
            case 'tagged_supplier_via_po':
              return ' Supplier: ' + activity.supplier_descr + ' was tagged via PO: ' + activity.reference;
              break;
            case 'added_supplier_note':
              return ' added a note to supplier';
              break;
            case 'updated_supplier_note':
              return ' updated the note to supplier';
              break;
            case 'deleted_supplier_note':
              return ' deleted the note to supplier';
              break;
            case 'deactivated_for_revision':
              return ' created a revision draft for this ' + moduleName + ' and deactivated the parent ' + moduleName;
              break;
            case 'created_revision':
              return ' fully approved a revision for this ' + moduleName;
              break;
            case 'deleted_revision':
              return ' deleted a revision draft for this ' + moduleName + ' and reactivated the parent ' + moduleName;
              break;
            case undefined:
              return ' commented';
              break;
            case 'added_adhoc_approver':
            case 'removed_adhoc_approver':
              return activity.comment;
              break;
            default:
              if (!!activity.action) {
                if ($scope.commentsModule === 'PO') {
                  return ' set the PO to ' + activity.action.toLowerCase();
                }
                else {
                  return activity.action + ' this ' + moduleName;
                }
              }
              break;
          }
        }

        function getClosedItemIndex(comment_id){
          if($scope.commentsModule === 'PO'){
            return _.findIndex($scope.commentsObject.items, function(item){
              return item.closing_comment_id == comment_id;
            });
          }
        }

        function readMoreComment(doNotRefreshData) {

          $scope.embeddedParams = {
            offset: $scope.commentSize
          };
          //TODO: remove this from here, its a generic directive (Ahmed Saleh, 2017/8/9)
          if($scope.commentsModule === 'SupplierTag') {
            $scope.embeddedParams['companyCode'] = $scope.commentsObject;
          }
          else {
            $scope.embeddedParams['referenceId'] =  $scope.commentsObject._id;
          }

          $scope.is_loading_comment = true;
          $scope.commentsService.get(
            $scope.embeddedParams,
            function (resource) {
              $scope.is_loading_comment = false;
              /**
               * using the doNotRefreshData variable, it is determined which page is the comments are on:
               * in case the comment was in the first page, no need to reload.
               * Just updating the meta by broadcasting to the embedded pagination directive
               * in case its not on the first page, will pass the whole data to the embedded pagination directive
               */
              if (!!resource && !!resource.content && !!resource.content.data) {
                if (doNotRefreshData) {
                  $scope.meta = resource.content.meta;
                  $rootScope.$broadcast('embeddedPaginationUpdate', {meta: $scope.meta, offset: $scope.commentSize});
                } else {
                  $scope.commentsAndHistory = resource.content.data;
                  $scope.meta = resource.content.meta;
                  $rootScope.$broadcast('embeddedPaginationUpdate', {data: $scope.commentsAndHistory,
                    meta: $scope.meta, offset: $scope.commentSize});
                }

                // If updated_at is less than 1 month ago from current time: show [time] ago,
                // else show date
                // Adding change the image user to call the user image endpoint
                _.forEach($scope.commentsAndHistory, function (comment) {
                  var tempDate = new Date(comment.updated_at);
                  tempDate.setMonth(tempDate.getMonth() + 1);
                })
              }
            }, function (error) {
              $scope.is_loading_comment = false;
            }
          );
        }

        function postComment(text) {
          if (!!text && text !== '') {
            $scope.disabled = true;
            // handle text before submit

            verifyMentions(text);
            var content = replaceContent(text);
            var mentionedUsersArray = [];

            $scope.commentsService.post(
              {
                referenceId: $scope.commentsObject._id
              },
              {
                comment: content,
                mentionedUserIds: $scope.mentionedIdArray
              }
            ).
              $promise.then(function (resource) {
                $scope.mentions = [];
                $scope.mentionedIdArray = [];
                mentionedUsersArray = [];
                //successful
                $scope.disabled = false;
                $scope.comment = {
                  text: ''
                };
                /**
                 * in case the user is not in page 1, reset it
                 * fix the total count for the embedded pagination
                 */
                if (!!$scope.meta && !!$scope.meta.cursor && !$scope.meta.cursor.prev) {
                  /**
                   * pushing the message in frontend only, in case of the first page,
                   * else reloading data
                   */
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    $scope.commentsAndHistory.splice(0, 0, resource.content.data);
                  }
                  $rootScope.$broadcast('addToCountEnd');
                }
                refreshHistory();
              },
              function () {
                toastr.error('Failed to submit comment');
                $scope.disabled = false;
              }
            );
          }
        }

        function replaceContent(text) {
          var content = angular.copy(text);
          for (var index in $scope.mentions) {
            var item = $scope.mentions[index];
            content = content.replace(
              new RegExp('@' + item.label, 'g'),
                '@' + item.label
            );
          }
          return content;
        }

        function verifyMentions(text) {
          if (!$scope.mentionedIdArray)
            return;

          //verifying the specific mentions
          for (var i = 0;i < $scope.usersList.length; i++) {
            var label = '@' + $scope.usersList[i].label;
            if (text.indexOf(label) === -1 && label !== '@all') {
              var index = $scope.mentionedIdArray.indexOf($scope.usersList[i]._id);
              if (index > -1) {
                $scope.mentionedIdArray.splice(index, 1);
              }
            }
          }

          //verifying the all mention, pushing all the users back for true case
          label = '@all';
          if(text.indexOf(label) > -1){
            for (i = 0; i < $scope.usersList.length; i++) {
              //push all users Ids except current and _all_
              if ($scope.usersList[i]._id !== $rootScope.currentUser._id
                && $scope.usersList[i]._id !== '_all_') {
                //pushing without duplicates
                index = $scope.mentionedIdArray.indexOf($scope.usersList[i]._id);
                if (index === -1) {
                  $scope.mentionedIdArray.push($scope.usersList[i]._id);
                }
              }
            }
          }
        }

        function selectTagName(item) {
          $scope.selectedTag = item;

          var isExisting = false;
          for (var index in $scope.mentions) {
            if ($scope.mentions[index]._id === item._id) {
              isExisting = true;
            }
          }
          if (!isExisting) {
            $scope.mentions.push(item);
          }

          if(!!$scope.mentions && !!$scope.mentions.length){
            $scope.mentionedIdArray = [];

            if(globalFunc.findInArray($scope.mentions, '_id', '_all_')){
              for (var i = 0; i < $scope.usersList.length; i++) {
                //push all users Ids except current and _all_
                if ($scope.usersList[i]._id !== $rootScope.currentUser._id
                  && $scope.usersList[i]._id !== '_all_') {
                  $scope.mentionedIdArray.push($scope.usersList[i]._id);
                }
              }
            }else {
              for (i = 0; i < $scope.mentions.length; i++) {
                $scope.mentionedIdArray.push($scope.mentions[i]._id);
              }
            }
          }
          else{
            $scope.mentionedIdArray = [];
          }

          return '@' + item.label;
        }

        /**
         * Function to get the header title for the directive
         */
        function getHeaderTitle() {
          switch($scope.commentsModule) {
            case 'SupplierTag':
              $scope.headerTitle = 'History';
              break;
            default:
              $scope.headerTitle = 'Comments & History';
              break;
          }
        }
      }
    }
  });

/**
 * @name columnsSelector
 *
 *
 * @description
 *
 * Directive to handle the Selection, Storing and Loading of the headers in the manage/list pages
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 *
 */

'use strict';

angular.module('metabuyer')
  .directive('columnsSelector', function () {
    return {
      scope: {
        availableColumns: '=',
        storageKey: '=',
        condition: '=?'
      },
      templateUrl: 'components/columnsSelector/columnsSelectorTemplate.html',
      restrict: 'E',
      controller: 'columnsSelectorCtrl'
    }
  })


  /**
   * @name columnsSelectorCtrl
   *
   * @description
   * The controller of the columnsSelector directive handles the data of the button and the events, as well as storing
   * the data and retrieving from local storage
   *
   * @author Ahmed Saleh <a.saleh@vventures.asia>
   * @copyright Sunway Metacloud &copy; 2016
   */
  .controller('columnsSelectorCtrl', function($scope, globalFunc) {

    /**
     * function to filter the columns to be selected or not
     * @param columnList
     * @param condition
     * @returns {Array}
     */
    function filterColumns(columnList, condition) {
      var columns = [];
      _.forEach(columnList, function (col) {
        if (!!col.conditional) {
          if (col.condition === condition) {
            columns.push(col);
          }
          if (col.condition instanceof Array) {
            for (var i in col.condition) {
              if (col.condition[i] === condition) {
                columns.push(col);
              }
            }
          }
        } else {
          columns.push(col);
        }
      });
      return columns;
    }

    /**
     * Columns data
     * @type {Array}
     */
    $scope.selectedColumns = [];
    $scope.buttonText = {
      buttonDefaultText: 'Columns'
    };
    $scope.columnsSettings = {
      buttonClasses: 'btn btn-white',
      smartButtonMaxItems: 3
    };

    $scope.columnsEvents = {
      onItemSelect: function (selected) {
        for (var i in $scope.columns) {
          if (selected.id === $scope.columns[i].id) {
            $scope.columns[i].selected = true;
          }
        }
        refreshSelectedColumns();
      },
      onItemDeselect: function (selected) {
        for (var i in $scope.columns) {
          if (selected.id === $scope.columns[i].id) {
            $scope.columns[i].selected = false;
          }
        }
        refreshSelectedColumns();
      }
    };

    function refreshSelectedColumns() {
      $scope.selectedColumns = [];
      for (var i in $scope.columns) {
        if ($scope.columns[i].selected === true) {
          $scope.selectedColumns.push($scope.columns[i]);
        }
      }
      /**
       * storing in the local storage
       */
      window.localStorage.setItem($scope.storageKey, JSON.stringify(_.map($scope.selectedColumns, function (item) {
        return item.id
      })));
    }

    /**
     * loading the selected columns
     */
    function loadSelectedColumns() {

      var tempItems = JSON.parse(window.localStorage.getItem($scope.storageKey));
      if (!!tempItems) {
        for (var i in $scope.columns) {
          for (var j in tempItems) {
            if (tempItems[j] === $scope.columns[i].id) {
              $scope.columns[i].selected = true;
              $scope.selectedColumns.push($scope.columns[i]);
            }
          }
        }
      } else {
        for (var i in $scope.columns) {
          $scope.columns[i].selected = true;
          $scope.selectedColumns.push($scope.columns[i]);
        }
      }
    }

    function initialize() {
      $scope.columns = filterColumns($scope.availableColumns, $scope.condition);
      loadSelectedColumns();
      $scope.columnOptions =  globalFunc.removeValueFromArray($scope.columns, 'unSelectable', true);
    }

    initialize();
  });

'use strict';

/**
 * @name collaboratorsCtrl
 * @desc controller for Adding and removing Collaborators
 *
 * @param $scope
 * @param purchaseRequisitionsServices
 * @param $uibModalInstance
 * @param globalFunc
 * @param $rootScope
 * @param prFunction
 * @param $http
 * @param pathConstants
 * @param toastr
 */

function collaboratorsCtrl($scope, purchaseRequisitionsServices, $uibModalInstance, globalFunc, $rootScope, prFunction, $http, pathConstants, toastr) {

  $scope.loading = false;
  $scope.delay = 500;
  $scope.collaboratorsTextFiled = {};
  $scope.collaboratorsTextFiled.input = null;
  $scope.collaborators = prFunction.getPRData().collaborators;
  $scope.pr = prFunction.getPRData();
  $scope.profile = $rootScope.currentUser;
  $scope.loggedInUserIsAnApprover = globalFunc.findInArray(prFunction.getPRData().waiting_on, '_id', $rootScope.currentUser._id);
  $scope.removeCollaborator = removeCollaborator;
  $scope.onSelect = onSelect;
  $scope.searchUsers = searchUsers;
  $scope.close = close;
  $scope.canUpdateCollaborators = canUpdateCollaborators;

  /**
   * Check if the current PR has valid status to update the collaborator
   *
   * @param string currentPrStatus String of PR status
   * @returns {boolean}
   */
  function canUpdateCollaborators(currentPrStatus) {
    var validPRStatus = [
      'draft',
      'pending',
      'on_hold',
      'withdrawn',
      'rejected',
      'approved'
    ];

    return !_.isEmpty(_.intersection(validPRStatus, [currentPrStatus]));
  }

  /**
   * check if the logged in user is a creator/requestor/current approver of the PR
   * @returns {boolean|*}
   */
  function allowedToPerformAction() {
    return ((!!$scope.pr.requestor && $scope.pr.requestor._id === $scope.profile._id) ||
    (!!$scope.pr.creator && $scope.pr.creator._id === $scope.profile._id) ||
    $scope.loggedInUserIsAnApprover);
  }

  /**
   * delete collaborator
   * @param collaborator
   */
  function removeCollaborator(collaborator) {

    if (allowedToPerformAction()) {

      purchaseRequisitionsServices.removeCollaborator(
        {
          id: $scope.pr._id,
          collaborator_id: collaborator._id
        },
        function (resource) {
          if (!!resource.content && !!resource.content.data) {
            prFunction.setPRData(resource.content.data);
            $scope.collaborators = prFunction.getPRData().collaborators;
          }
          /**
           * add the collaborator removal to the history
           * @type {{creator: *, collaborator: *}}
           */
          var history = {
            creator: $scope.profile,
            collaborator: collaborator
          };
          $rootScope.$broadcast('collaboratorAdjusted', [history, 'removed']);
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        });
    } else {
      toastr.error('Only PR requester/approver can edit collaborators');
    }
  }


  function onSelect(user) {
    addCollaborator(user);
  }

  function searchUsers(query) {

    $scope.loading = true;
    return $http.get(pathConstants.apiUrls.genericSearch.searchBasePath + '/users', {
      params: {
        module: 'users',
        'criteria[1][display_name]': query,
        'criteria[1][email]': query,
        'criteria[0][status]': 1,
        'criteria[2][companies][]': $scope.pr.company.code,
        'criteria[1][$operator]': 'or',
        criteria_operator: 'and'
      }
    }).then(function (response) {
      $scope.loading = false;
      return response.data.content.data.map(function (item) {
        $scope.loading = false;
        return item;
      });
    });

  }

  /**
   * validate the selected new collaborators
   * @param newCollaborator
   * @returns {boolean}
   */
  function validate(newCollaborator) {
    if (newCollaborator._id === $scope.pr.creator._id) {
      toastr.warning('You cannot add the creator as a collaborator');
      return false;
    }
    if ($scope.collaborators != null) {
      for (var i = 0; i < $scope.collaborators.length; i++) {
        if ($scope.collaborators[i]._id === newCollaborator._id) {
          toastr.error('This Collaborator has already been added!');
          return false;
        }
      }
    }
    else {
      $scope.collaborators = [];
    }
    return true;
  }

  /**
   * adding a collaborator
   * @param newCollaborator
   */
  function addCollaborator(newCollaborator) {

    if (allowedToPerformAction()) {

      if (validate(newCollaborator)) {

        purchaseRequisitionsServices.addCollaborator(
          {id: $scope.pr._id},
          {collaborator_id: newCollaborator._id},
          function (resource) {
            if (!!resource.content && !!resource.content.data) {
              prFunction.setPRData(resource.content.data);
              $scope.collaborators = prFunction.getPRData().collaborators;
            }

            /**
             * add the collaborator Addition to the history
             * @type {{creator: *, collaborator: *}}
             */
            var history = {
              creator: $scope.profile,
              collaborator: newCollaborator
            };
            $scope.collaboratorsTextFiled.input = null;
            $rootScope.$broadcast('collaboratorAdjusted', [history, 'added']);
          }, function (error) {
            globalFunc.objectErrorMessage(error);
          });
      }
      else {
        $scope.collaboratorsTextFiled.input = null;
      }
    } else {
      toastr.error('Only PR requester/approver can edit collaborators');
    }
  }


  function close() {
    $uibModalInstance.close();
  }
}

angular
  .module('metabuyer')
  .controller('collaboratorsCtrl', collaboratorsCtrl)
  .directive('collaboratorsPanel',function($uibModal) {
    return {
      restrict: 'A',
      link: function (scope) {
        var panel = function () {
          $uibModal.open({
            templateUrl: 'components/collaborator/collaboratorTemplate.html',
            controller: 'collaboratorsCtrl',
            backdrop: 'static',
            keyboard: false
          });
        };

        //loading the panel to search
        scope.inviteCollaborator = function () {
          panel();
        };

      }
    };
  });

'use strict';
angular
  .module('metabuyer')
  .directive('closePo',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/closePO/closePOTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ClosePOCtrl',
            scope: scope
          });
        };
        //loading the panel
        scope.showClosePO = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('ClosePOCtrl', function ($scope, $uibModalInstance, Orders, toastr, HighlightId, $interval, $state) {
    $scope.next_close = true;
    $scope.back_close = false;
    $scope.commentText = "";
    $scope.enable_next = false;
    $scope.check_for_all = false;
    $scope.close_po_data = [];

    $scope.next = next;
    $scope.cancel = cancel;
    $scope.backOnClosePO = backOnClosePO;
    $scope.checkedLineItem = checkedLineItem;
    $scope.checkedAllLineItems = checkedAllLineItems;
    $scope.proceedClosePO = proceedClosePO;
    $scope.initialize = initialize;

    //next action
    function next(){
      $scope.next_close = false;
      $scope.back_close = true;
    }

    //cancel action
    function cancel(){
      $uibModalInstance.close();
    }

    //back action
    function backOnClosePO(){
      $scope.next_close = true;
      $scope.back_close = false;
    }

    function checkedLineItem(item){
      //check all selected line items
      var unselected_item = _.find($scope.close_po_data, function(item){
        return !item.selected;
      });

      if(unselected_item != undefined){
        $scope.check_for_all = false;
      }

      //check enable next
      var selected_item = _.find($scope.close_po_data, function(item){
        return item.selected;
      });

      if(selected_item != undefined){
        $scope.enable_next = true;
      } else {
        $scope.enable_next = false;
      }

    }

    //check all line items
    function checkedAllLineItems(){
      if($scope.check_for_all){
        $scope.enable_next = true;

      } else {
        $scope.enable_next = false;
      }

      _.forEach($scope.close_po_data, function(item){
        if(!!item.po_item) {
          if(!!item.po_item.order && !!item.po_item.order.delivered) {
            if (!item.po_item.closed && (item.po_item.order.delivered !== item.po_item.quantity)) {
              item.selected = $scope.enable_next;
            }
          }
          else {
            /**
             * no delivery occurred
             * @type {boolean}
             */
            item.selected = $scope.enable_next;
          }
        }
      });
    }

    //proceed action
    function proceedClosePO(){

      var indexes = [];
      _.forEach($scope.close_po_data, function(item){
        if(!item.selected){
          return;
        }
        indexes.push(item.itemIndex);
      });
      var i = 0;
      var flagErrorOccurred = false;
      /**
       * extra check to prevent the closing in case of data not being updated
       */
      if(indexes.length<1) {
        toastr.error('something went wrong, you can\'t close the PO at the moment');
        return;
      }
      /**
       * set the interval for closing multiple items
       */
      var closing = $interval(function () {
        Orders.closeLineItem({po_id: $scope.po._id, item_id: indexes[i], comment: $scope.commentText},
          function (success) {
          },
          function (error) {
            flagErrorOccurred = true;
            $interval.cancel(closing);
          });
        i++;
      }, 300, indexes.length).then(function(){

      if(flagErrorOccurred === false){
        toastr.success('The PO / line items is closed');
        HighlightId.setId($scope.po._id);
        if(indexes.length === $scope.close_po_data.length){
          $state.go('main.user.orders.manage', {status: 'CLOSED'});
        } else {
          $state.go('main.user.orders.manage', {status: 'AWAITING_DELIVERY'});
        }
      }else{
        toastr.error('Failed to close the PO / line items');
      }
        $uibModalInstance.close();
      });
    }

    function initialize() {
      _.forEach($scope.po.items, function(item, i){
        item.remaining_quantity = math.subtract(math.bignumber(item.quantity), math.bignumber(item.order.delivered));
        item.remaining_quantity = math.format(item.remaining_quantity, {precision: 64});
        $scope.close_po_data.push(
          {
            po_item: item,
            itemIndex: i
          }
        );
      });
    }

    initialize();
  });

'use strict';

//TODO: move those actions to the Action Modal (Ahmed Saleh, 16/12/16)
angular
  .module('metabuyer')
  .directive('cancelPo',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {
        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/cancelPO/cancelPOTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'CancelPOCtrl',
            scope: scope
          });
        };

        //loading the panel
        scope.showCancelPO = function () {
          panel();
        };
      }
    };
  });

'use strict';

angular.module('metabuyer')
  .controller('CancelPOCtrl', function ($scope, $uibModalInstance, Orders, toastr, HighlightId, $state, globalFunc) {

    $scope.cancel_reason = "Others";
    $scope.commentText = "";
    $scope.cancel = cancel;
    $scope.cancelPO = cancelPO;

    //cancel action
    function cancel(){
      $uibModalInstance.close();
    }

    //cancel action
    function cancelPO(){

      $uibModalInstance.close();

      Orders.setPOStatus({id: $scope.po._id}, {status: 9, reason: $scope.cancel_reason, comment: $scope.commentText})
        .$promise.then(
        function(resource) {
          toastr.success('This PO is cancelled');

          if (!!resource.content && !!resource.content.data) {
            HighlightId.setId(resource.content.data._id);
          }

          $state.go('main.user.orders.manage', {status: 'Cancelled'});

        }, function(error){
          globalFunc.objectErrorMessage(error);
        });
    }
  });

'use strict';

/**
 * @name supplierBranching
 *
 * @description
 * Directive for supplier branching used in add and edit supplier
 *
 * @param data (array)
 * to pass branch data to directive
 *
 * @param editable (boolean)
 * editable status
 *
 * @param searchable (boolean)
 * param to activate search bar
 *
 * @param selectedSupplierBranch (array)
 * Selected supplier branch. call back access parent function
 *
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright Sunway Metacloud &copy; 2017
 */
angular.module('metabuyer')
  .directive('branchListing', function (searchModule, globalFunc, $q, $uibModal,
                                        validateSupplierBranchDeletion, toastr) {
    return {
      restrict: 'E',
      templateUrl: 'components/branchListing/branchListing.html',
      scope: {
        data: '=',
        editable: '=',
        searchable: '=',
        selectable: '=',
        selectedSupplierBranch: '&'
      },
      link: function ($scope) {
        $scope.branchDetailsModal = branchDetailsModal;
        $scope.deleteBranches = deleteBranches;
        $scope.addBranchesModal = addBranchesModal;
        $scope.selectedSupplierBranch = selectedSupplierBranch;

        var indexDeletedRows =[];
        var branchIDs = [];

        function consolidateRemainingBranches(remainingBranches) {
          $scope.data = remainingBranches.slice();
        }

        function deleteBranches() {
          indexDeletedRows =[];
          branchIDs =[];
          var remainingBranches = [];

          _.forEach($scope.data, function(data, index) {
            if(data.checked == true) {
              indexDeletedRows.push(index);
              if(!!data._id) {
                branchIDs.push(data._id);
              }
            } else {
              remainingBranches.push($scope.data[index]);
            }
          });

          if(branchIDs.length > 0) {
            validateSupplierBranchDeletion.get({
              id: $scope.$parent.supplier._id,
              branches: branchIDs.toString(),
              supplierId : $scope.$parent.supplier._id
            }, function(resource) {
              var beingUsedBranches = [];

              _.forEach(resource, function(data, index) {
                if (data === false) {
                  beingUsedBranches.push($scope.data.filter(function(el) {
                    if (el._id === index) {
                      return {descr: el.descr};
                    }
                  }));
                }
              });

              if (beingUsedBranches.length > 0) {
                var listInString = '';
                _.forEach(beingUsedBranches, function(branch, index) {
                  if(index !== 0){
                    listInString += ' ,';
                  }
                  listInString += branch[0].descr;
                });
                swal(
                  {
                    title: 'Branch Deletion Aborted',
                    text: 'You can not delete the branches below due to their ' +
                    ' relationship with existing PRs. Please check the lists below: ' +
                    listInString,
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: "#1ab394",
                    confirmButtonText: "Okay",
                    closeOnConfirm: true
                  });
              } else {
                consolidateRemainingBranches(remainingBranches);
              }

            }, function () {
              toastr.error('Branch Deletion Failed');
            });
          } else {
            consolidateRemainingBranches(remainingBranches);
          }
        }

        function selectedSupplierBranch(branch) {
          $scope.$parent.callBackFunction(branch);
        }

        function addBranchesModal() {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/suppliersManagement/branches/add/add.html',
            controller: 'addSupplierBranches',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
              branches: function () {
                return $scope.data;
              }
            }
          });
          modalInstance.result.then(function (branchValue) {
            if(!!branchValue) {
              $scope.data.push(branchValue);
            }
          });
        }

        function branchDetailsModal(branch,index) {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/suppliersManagement/branches/details/details.html',
            controller: 'supplierBranchDetailCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
              param: function () {
                return branch;
              },
              editable: function () {
                return $scope.editable;
              },
              // Return all branches related to this supplier
              branches: function () {
                return $scope.data;
              },
              // Return the branch index
              branchIndex: function() {
                return index;
              }
            }
          });
          modalInstance.result.then(function (branchDetails) {
            if(!!branchDetails) {
              $scope.data[index] = branchDetails;
            }
          });
        }
      }
    }
  });

'use strict';

/**
 * @name attachmentCategory
 *
 * @requires $uibModal
 *
 * @description
 * Attachment directive with category and fields based on the category
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

function attachmentCategory($uibModal, globalFunc, attachmentDetail, pathConstants, $http, $filter, $timeout,
  attachmentCategory, attachmentDescription
) {
  return{
    restrict: 'E',
    scope: {
      module: '@',
      data: '=',
      editable: '=',
      comparison: '=',
      objectId: '=?',
      hostClass: '@'
    },
    templateUrl: 'components/attachmentCategory/attachmentCategory.html',
    controller: function($scope) {

      $scope.attachments        = $scope.data || [];

      $scope.addAttachment      = addAttachment;
      $scope.downloadAttachment = downloadAttachment;
      $scope.editAttachment     = editAttachment;
      $scope.deleteAttachment   = deleteAttachment;

      /**
       * Load modal to add attachment
       */
      function addAttachment() {
        var modalInstance = $uibModal.open({
          templateUrl: 'components/attachmentCategory/addAttachment/addAttachment.html',
          backdrop: 'static',
          keyboard: false,
          controller: 'addAttachmentCtrl',
          resolve: {
            module: function () {
              return $scope.module;
            },
            editingData: function () {
              return false;
            }
          }
        });
        modalInstance.result.then(function (newValue) {
          if (!!newValue) {
            $scope.attachments.push(newValue);
            saveAttachmentData();
          }
        });
      }

      /**
       * check attachment_detail
       * if temporary_url is exist and not null
       * then directly download
       * @param attachment
       */
      function downloadAttachment(attachment) {
        if (!!attachment && !!attachment.attachment_detail && !!attachment.attachment_detail.temporary_url) {
          getAttachmentFile(attachment.attachment_detail.temporary_url);
        } else {
          attachmentDetail.get({
            id: attachment.attachment_detail._id
          }).$promise.then(
            function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data)
                getAttachmentFile(resource.content.data.temporary_url);
            }, function (error) {
              globalFunc.objectErrorMessage(error);
            }
          );
        }
      }

      /**
       * get the attachment file
       */
      function getAttachmentFile(url) {
        var newUrl = $filter('format')(pathConstants.apiUrls.attachments.download, {
          hash: url
        });
        $http({
          url: newUrl
        }).then(function () {
          window.open(newUrl, '_self');
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        });
      }

      function editAttachment(attachment, index) {
        var modalInstance = $uibModal.open({
          templateUrl: 'components/attachmentCategory/addAttachment/addAttachment.html',
          backdrop: 'static',
          keyboard: false,
          controller: 'addAttachmentCtrl',
          resolve: {
            module: function () {
              return $scope.module;
            },
            editingData: function () {
              return attachment;
            }
          }
        });
        modalInstance.result.then(function (newValue) {
          if (!!newValue) {
            $scope.attachments[index] = newValue;
            saveAttachmentData();
          }
        });
      }

      function deleteAttachment (attachment, index) {
        swal({
          title: 'Are you sure?',
          text: 'Your attachment will not be recoverable',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Yes, delete it!',
          closeOnConfirm: true
        }, function (isConfirm) {
          if (!!isConfirm) {
              if (!!attachment._id && !!$scope.objectId && !!$scope.hostClass) {
                attachmentDescription.delete(
                  {
                    id: attachment._id,
                    host_class: $scope.hostClass,
                    object_id: $scope.objectId
                  }, function (resource) {
                    $scope.attachments = globalFunc.removeValueFromArray($scope.attachments, '_id', attachment._id);
                    saveAttachmentData();
                  }, function (error){
                    globalFunc.objectErrorMessage(error);
                  });
              } else {
                $scope.attachments.splice(index, 1);
                saveAttachmentData();
              }
          }
        });
      }

      /**
       * save the attachments data and pass to the directive's attribute
       */
      function saveAttachmentData() {
        $scope.data = $scope.attachments;
      }

      /**
       * combine description array
       * @param descriptionArray
       * @param attachment
       * @returns {*}
       */
      function combineDescriptionArray(descriptionArray, attachment) {
        _.forEach(descriptionArray, function (description) {
          description.value = attachment[description.name];
        });
        return descriptionArray;
      }


      /**
       * Load attachments details
       * and prepare the data for display
       */
      function loadAttachments() {
        if (!!$scope.attachments && !!$scope.attachments.length) {
          _.forEach($scope.attachments, function (attachmentDescription) {
            // convert description_array to array
            attachmentCategory.get({
              id: attachmentDescription.attachment_category_id
            }, function(resource) {
              if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data._id)
                attachmentDescription.description_array = combineDescriptionArray(
                  resource.content.data.description_fields, attachmentDescription
                );
            }, function(error) {
              globalFunc.objectErrorMessage(error);
            });

            // get the attachment details
            attachmentDetail.get({
              id: attachmentDescription.attachment_id
            }, function (resource) {
              if (!!resource && !!resource.content && !!resource.content.data)
                attachmentDescription.attachment_detail = resource.content.data;
            });
          });
        }
      }

      function initialize() {
        loadAttachments();
      }

      initialize();

    }
  };
}

attachmentCategory.$inject = [
  '$uibModal', 'globalFunc', 'attachmentDetail', 'pathConstants', '$http', '$filter', '$timeout', 'attachmentCategory', 'attachmentDescription'
];

angular
  .module('metabuyer')
  .directive('attachmentCategory', attachmentCategory);

'use strict';

/**
 * @name attachmentsBlock Directive
 *
 * @desc Directive for showing and adding attachments
 *
 * @requires $scope
 * @requires $stateParams
 * @requires $auth
 * @requires toastr
 * @requires pathConstants
 * @requires $filter
 * @requires $http
 * @requires globalFunc
 * @requires $rootScope
 *
 * @isolatedScope disableEdit
 * Flag for disable edit attachment
 * @bindingType Two way binding
 *
 * @isolatedScope isFirstCreate
 * Flag for if PR is first create
 * @bindingType Two way binding
 *
 * @isolatedScope profile
 * Profile for current user
 * @bindingType Two way binding
 *
 * @isolatedScope singleAttachmentService
 * Service for single attachment
 * @bindingType Two way binding
 *
 * @isolatedScope attachmentParam
 * Parameters to be passed into attachment endpoint
 * @bindingType Two way binding
 *
 * @isolatedScope attachmentUrl
 * URL for attachment endpoint
 * @bindingType Two way binding
 *
 * @isolatedScope attachmentModel
 * String for the attachment model to determine storage path back end
 * @bindingType Attribute binding
 *
 * @isolatedScope hideIsVisibleToSupplier
 * Flag to hide is visible to supplier
 * @bindingType Two way binding
 *
 * @isolatedScope files
 * Array of files to be displayed in attachments
 * @bindingType Two way binding
 */
angular.module('metabuyer').directive('attachmentsBlock', function ($rootScope) {
  return {
    restrict: 'E',
    scope:{
      disableEdit: '=?',
      isFirstCreate: '=?',
      profile: '=?',
      singleAttachmentService: '=',
      attachmentParam: '=',
      attachmentUrl: '=',
      attachmentModel: '@',
      hideIsVisibleToSupplier: '=?',
      files: '='
    },
    templateUrl: function () {
      return $rootScope.isMobileMode ? 'components/attachment/attachmentTemplate-mobile.html' :
        'components/attachment/attachmentTemplate.html';
    },
    controller: function (
      $scope, $stateParams, $auth, toastr, pathConstants, $filter, $http, globalFunc, $rootScope
    ) {

      $scope.showDropZone = true;
      $scope.file_id = '';

      $scope.download = download;
      $scope.update = update;
      $scope.delete = deleteFile;

      _.forEach($scope.files, function (file) {
        file.edit_description = file.description;
      });

      var attachmentParameters = $scope.attachmentParam;

      /**
       * Function to download specific file
       * @param file_id
       */
      function download(file_id) {
        attachmentParameters['attachmentId'] = file_id;
        $scope.singleAttachmentService.get(
          attachmentParameters
        ).$promise.then(
          function (resource) {
            if (!!resource && !!resource.content && !!resource.content.data && !!resource.content.data.temporary_url) {
              var newUrl = $filter('format')(pathConstants.apiUrls.attachments.downloadAttachment, {
                hash: resource.content.data.temporary_url
              });
            }
            // Use HTTP to allow and use the application/json
            // and download with the newUrl
            $http({
              url: newUrl
            }).then(function () {
              window.open(newUrl, '_self');
            }, function (response) {
            });
          }, function () {
            toastr.error('Failed to download attachment');
          }
        );
      }

      $scope.dropzoneConfig = {
        options: {
          // passed into the Dropzone constructor
          //maxFilesize in MB
          maxFilesize: 30,
          url: $scope.attachmentUrl,
          init: function() {
            /**
             * Append attachment model name to the form data
             */
            this.on('sending', function(file, xhr, formData){
              formData.append('model', $scope.attachmentModel);
            });
          },
          headers: {
            'Authorization': 'Bearer ' + $auth.getToken()
            //'mb_request_id': Date.now()
          },
          previewTemplate: '<div class="dz-preview dz-file-preview">' +
          '<div class="dz-details">' +
          '<div class="dz-filename"><span data-dz-name></span></div>' +
          '<div class="dz-size" data-dz-size></div>' +
          '<img data-dz-thumbnail />' +
          '</div>' +
          '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
          '<div style="z-index: 999; position: absolute; width: 30px; height: 30px; font-size: 25px; text-align: center; right: -10px; top: -10px;">' +
          '<a data-dz-remove type="button" class="btn-xs btn-white pull-right"><i class="fa fa-trash-o"></i></a>' +
          '</div>' +
          '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
          '</div>',
          acceptedFiles: '.xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg'
        },
        eventHandlers: {
          sending: function (file, formData, xhr) {

          },
          error: function (file, error) {
            globalFunc.objectErrorMessage(error);
            this.removeFile(file);
          },
          success: function (file, resource) {
            $scope.$emit('changedField');
            $rootScope.$broadcast('refreshComments');

            var _this = this;
            setTimeout(function () {
              _this.removeFile(file);
            }, 1000);
            toastr.success('Attachment successfully uploaded');

            if (!!resource && !!resource.content && !!resource.content.data) {
              $scope.files.splice(0, 0, resource.content.data);
            }
            if (!!$scope.files.length) {
              $scope.showDropZone = false;
            }
          }
        }
      };

      /**
       * Function to update specific attachment
       * @param file
       * @param edit_is_visible_to_supplier
       */
      function update(file, edit_is_visible_to_supplier) {
        if (!edit_is_visible_to_supplier)
          edit_is_visible_to_supplier = false;

        attachmentParameters['attachmentId'] = file._id;

        $scope.singleAttachmentService.put(
          attachmentParameters,
          {
            description: file.description,
            is_visible_to_supplier: edit_is_visible_to_supplier
          }).$promise.then(
          function () {
            toastr.success('Attachment successfully updated');
          }, function () {
            file.edit_description = file.description;
            toastr.error('Failed to update attachment');
          }
        );
      }

      /**
       * Function to delete specific attachment
       * @param file
       */
      function deleteFile(file) {
        var file_index = _.findIndex($scope.files, function (file_item) {
          return file._id === file_item._id;
        });

        $scope.files.splice(file_index, 1);
        attachmentParameters['attachmentId'] = file._id;

        $scope.singleAttachmentService.delete(
          attachmentParameters
          ).$promise.then(
          function (resource) {
            toastr.success(resource.content.message);
            $rootScope.$broadcast('refreshComments');
            if (!$scope.files.length) {
              $scope.showDropZone = true;
            }
          }, function () {
            toastr.error('Failed to delete attachment');
            $scope.files.splice(file_index, 0, file);
          });
      }

    }
  };
});

'use strict';
angular
.module('metabuyer')
.directive('approvalFlowTemp', function(notify,$stateParams){
  return {
    restrict: 'E',
    scope: {
      data: "=data"
    },
    controller: function ($scope) {
      if (!!$scope.data) {

        var setCurrentStep = false;
        var steps = _.keys($scope.data);

        for (var index = steps.length - 1; index >= 0; --index) {
          var approvals = $scope.data[steps[index]];
          var currentStep = _.all(approvals, function (item) {
            return !!item.status
          });
          if (currentStep && !setCurrentStep) {
            approvals.current = true;
          }
          approvals.current = false;
        }

        if (!setCurrentStep && !!steps[0]) {
          $scope.data[steps[0]].current = true;
        }
      }
    },
    replace: true,
    templateUrl: 'components/approvalflow/approvalflow-panel.html'
  };
});

'use strict';
/**
 * @name approvalWaitingOn
 * @desc directive for the approval waiting on
 * //TODO: added documentation explaining this directive (Ahmed Saleh)
 */
angular
  .module('metabuyer')
  .directive('approvalWaitingOn',function() {
    return {
      restrict: 'EA',
      template : '<div ng-include="template"></div>',
      scope: {
        data: '='
      },
      controller: function ($scope, $location, $anchorScroll, $rootScope) {
        $scope.waiting_on_user = '';
        $scope.moreMin = false;
        $scope.scrollTo = scrollTo;
        $scope.template= $rootScope.isMobileMode ? 'components/approvalWaitingOn/approvalWaitingOnTemplate-mobile.html':
          'components/approvalWaitingOn/approvalWaitingOnTemplate.html';

        function scrollTo(id) {
          var old_hash = $location.hash();
          $location.hash(id);
          $anchorScroll();
          $location.hash(old_hash);
        }
        function checkIfUserIsOriginalApprover(user, unapprovedRoles){
          var check = false;
          for(var i in unapprovedRoles){
            for(var j in unapprovedRoles[i].users)
            {
              if(unapprovedRoles[i].users[j]._id === user._id){
                check = true;
              }
            }
          }
          return check;
        }

        $scope.initialize = function () {
          if (!$scope.data || !$scope.data.waiting_on) {
            return false;
          }
          else {
            var waiting_on_list = [];
            var temp_waiting_on_list = '';
            var min;
            var currentStep;
            var unapprovedRoles = [];
            /**
             * determining the step and minimum
             */
            for (var i = 0; i < $scope.data.steps.length ; i++) {
              if (Number($scope.data.steps[i].seq) === Number($scope.data.current_step)) {
                currentStep = $scope.data.steps[i];
              }
            }

            if(!!currentStep && !!currentStep.min){
              min = currentStep.min;
            }

            /**
             * determining the unapproved roles
             */
            var currentRoles = [];
            if (!!currentStep && !!currentStep.roles) {
              for(var j = 0; j < currentStep.roles.length; j++){
                currentRoles.push(currentStep.roles[j].role_id.toString());
              }
            }
            if (!!currentStep && !!currentStep.approvedRoles) {
              var approvedRoles = Object.keys(currentStep.approvedRoles);
              var index;
              if(approvedRoles.length === 0){
                unapprovedRoles = currentRoles;
              }
              else{
                for(k = 0; k < approvedRoles.length; k++){
                  index = currentRoles.indexOf(approvedRoles[k]);
                  if(index > -1){
                    currentRoles.splice(index, 1);
                  }
                }
                unapprovedRoles = currentRoles;
              }
            }
            else {
              unapprovedRoles = currentRoles;
            }

            /**
             * check if escalated
             */
            var escalated = false;
            for(var k = 0; k < $scope.data.waiting_on.length; k++) {
              if (checkIfUserIsOriginalApprover($scope.data.waiting_on[k], unapprovedRoles) === false) {
                escalated = true;
                break;
              }
            }
            /**
             * creating the list of the waiting on users in case it was not escalated
             */
            //TODO: filter the waiting on by their roles to create a text right now this only reads from the flow,
            //TODO: which will give a wrong display in case of Escalation(Ahmed Saleh)
            if(!escalated) {
              for (i = 0; i < unapprovedRoles; i++) {
                for (j = 0; j < unapprovedRoles[i].users.length; j++) {
                  if (unapprovedRoles[i].users.length > 1 && Number(j) === 0) {
                    temp_waiting_on_list += '('
                  }
                  if (unapprovedRoles[i].users.length > 1 && Number(j) !== 0 && unapprovedRoles[i].users.length > j) {
                    temp_waiting_on_list += ' or '
                  }
                  temp_waiting_on_list += unapprovedRoles[i].users[j].display_name;
                  if (unapprovedRoles[i].users.length === Number(j) + 1) {
                    if (unapprovedRoles[i].users.length !== 1) {
                      temp_waiting_on_list += ')';
                    }
                    waiting_on_list.push(temp_waiting_on_list);
                    temp_waiting_on_list = '';
                  }
                }
              }
            }
            /**
             * its escalated so the viewing will be simple
             * TODO: update this once Backend updates (Ahmed Saleh)
             */
              else {
              for (i= 0; i < $scope.data.waiting_on.length; i++) {
                  waiting_on_list.push($scope.data.waiting_on[i].display_name);
                  temp_waiting_on_list = '';
              }
            }

           /**
            * To formulate the join condition
            */
            var waiting_on_text = '';
            var join_condition;
            for (i = 0; i < waiting_on_list.length; i++) {
              if (waiting_on_list.length <= min) {
                join_condition = ' & '
              }
              else {
                join_condition = ' or '
              }
              waiting_on_text += waiting_on_list[i];
              if (i !== waiting_on_list.length - 1 && waiting_on_list.length !== 1) {
                waiting_on_text += join_condition;
              }
            }
            $scope.waiting_on_user = waiting_on_text;
            if (!!$scope.data.onHoldBy && !!$scope.data.onHoldBy.display_name) {
              $scope.onHoldBy = $scope.data.onHoldBy.display_name;
            }

            $scope.watcher  = $scope.data.watcher || [];
          }
        };
        $scope.$watch('data', function () {
          $scope.initialize();
        }, true);

      }
    }
});

'use strict';

/**
 * @name approval-flow.directive
 *
 * @requires $element
 * @requires attrs
 *
 * @description Directive to display the approval flow.
 *
 * @function restructuringData
 * This function is to restructure the data passed for display purposes on the desktop version
 *
 * @function restructuringDataMobile
 * This function is to restructure the data passed for display purposes on the mobile version
 *
 * @function tooltipApproval
 * This function is to display tooltip based on step status
 *
 * @function handleChart
 * This function is to handle the drawing and connections for the approval flow (jsPlumb)
 *
 * @authors Justin Cheong Tian Yee (justin.cty90@gmail.com), Deniel Ariesta (deniel@vventures.asia)
 * @copyright Sunway Metacloud &copy; 2016
 */

angular
  .module('metabuyer')
  .directive('approvalFlow', function (
    $timeout, $rootScope, $uibModal, globalFunc, $sce, $filter, removeAdhocApprover, toastr, $state
  ) {
    return {
      restrict: 'EA',
      scope: {
        data: '=',
        requestor: '=',
        preparer: '=',
        context: '=',
        preview: '&',
        ischanged: '=',
        waitingon: '='
      },
      replace: true,
      templateUrl: function () {
        return $rootScope.isMobileMode ? 'components/approval-flow/approval-flow-mobile.html' :
          'components/approval-flow/approval-flow.html';
      },
      link: function ($scope, $element, $attrs) {

        //#region Variables declaration

        // JsPlumb Instance
        // Using StateMachine as the graph
        // Arrow as the Connection Overlays
        var instance = null;
        var isAddingAdHoc = false;

        function initiateJSPlumbInstance() {
          instance = jsPlumb.getInstance({
            connector: 'StateMachine',
            DragOptions: {
              cursor: 'pointer',
              zIndex: 2000
            },
            ConnectionOverlays: [
              ['Arrow', {
                location: 1,
                width: 8,
                length: 10
              }]
            ],
            Container: 'approval-flow'
          });
        }

        initiateJSPlumbInstance();

        if (!$attrs.type) {
          $scope.type = 'horizontal';
        }

        if (!!$scope.context && !!$scope.context.status) {
          $scope.contextStatus = $scope.context.status;
        }

        $scope.groups = [];
        $scope.drawGroups = [];
        $scope.firstStepMin = 0;
        $scope.isChangedField = true;
        $scope.firstLoad = true;
        $scope.transformedData = [];
        $scope.isRequestor = false;
        $scope.currentUser = $rootScope.currentUser;
        $scope.positionIndex = 0;

        $scope.approvalPreview = approvalPreview;
        $scope.tooltipApproval = tooltipApproval;
        $scope.addNewApprover = addNewApprover;
        $scope.deleteAdhoc = deleteAdhoc;
        //#endregion

        /**
         * Function for displaying tooltip
         * @param position
         * @param stepStatus
         * @returns {*}
         */
        function tooltipApproval(position, stepStatus) {
          if (!_.isEmpty(position.action) && !!position.action.date && !!position.action.status) {
            return $sce.trustAsHtml(position.name + '<p>' +
              (position.action.status.toLowerCase() === 'approved' ? 'Approved at: ' : 'Rejected at: ') +
              $filter('date')(position.action.date, 'dd MMM yyyy hh:mm a') + '</p>');
          }

          return (stepStatus.toLowerCase() !== 'pending' ? stepStatus : '');
        }

        //#region Restructuring the passed data
        /**
         * To restructure the data for display purposes
         */
        function restructuringData() {

          if (!!$scope.data && !!$scope.data.requested_by && !!$scope.data.created_by) {
            // Add requestedBy and createdBy to approval flow
            var requestedBy = $scope.data.requested_by;
            var createdBy = $scope.data.created_by;

            if (!!requestedBy._id) {
              $scope.isRequestor = (requestedBy._id === $rootScope.currentUser._id);
            }

            if (!!createdBy._id) {
              $scope.isRequestor = (createdBy._id === $rootScope.currentUser._id);
            }

            // add additional node to add adhoc approver in the same step
            // only for pending step and if the approval flow exist (submitted context)
            _.forEach($scope.data.steps, function (step) {
              if (step.step_status.toLowerCase() === 'pending' && !!$scope.data._id) {
                var tempId = 'adhoc_' + step.seq;
                step.positions.push({
                  'id': tempId,
                  'name': 'Add approver',
                  'position_type': 'ad-hoc',
                  'action': [],
                  'node_sub': {
                    'sourceId': 'node-sub_' + step.seq
                  }
                });
              }
            });

            var requestorObject = {
              'seq': 0,
              'positions': [
                {
                  'id': !!requestedBy._id ? requestedBy._id : 0,
                  'name': 'Requestor',
                  'position_type': 'requestor',
                  'action': {},
                  'users': [
                    {
                      '_id': requestedBy._id,
                      'display_name': requestedBy.display_name,
                      'email': requestedBy.email,
                      'img_url': requestedBy.img_url,
                      'prepared_by': createdBy
                    }
                  ]
                }
              ],
              'min_approver': 0,
              'step_progress': 0,
              'step_status': 'requestor'
            };

            // Pushing requestor object into the first step
            $scope.data.steps.splice(0, 0, requestorObject);
          }
        }

        /**
         * To select status color
         */
        function returnStatusColor(action) {
          var statusColor = '';
          switch (action) {
            case 'rejected':
              statusColor = 'rejected-role';
              break;
            case 'approved':
              statusColor = 'approved-role';
              break;
            default:
              statusColor = 'status-color-default';
          }
          return statusColor;
        }

        /**
         * get the position level styling
         */
        function processingPositionStatusStyling (position, index, temp) {
          switch (temp['step'][index]['position'][position.id]['status']) {
            case 'approved':
              temp['step'][index]['position'][position.id]['status_color'] = 'status-color-approved';
              temp['step'][index]['position'][position.id]['border_style'] = 'border-style-approved';
              break;
            case 'rejected':
              temp['step'][index]['position'][position.id]['status_color'] = 'status-color-rejected';
              temp['step'][index]['position'][position.id]['border_style'] = 'border-style-rejected';
              break;
            case 'escalated':
              temp['step'][index]['position'][position.id]['status_color'] = 'status-color-escalated';
              break;
            case 'pending':
              temp['step'][index]['position'][position.id]['status_color'] = 'status-color-pending';
              break;
          }
          return temp;
        }

        /**
         * split up this section to process user level and below
         */
        function processingUserLevelData (position, index, temp) {
          temp['step'][index]['position'][position.id]['user'] = {};
          _.forEach(position.users, function (user) {
            var tempStatus = 'pending';
            if (!_.isEmpty(position.action.status) && position.action.user._id === user._id){
              tempStatus = position.action.status;
            }
            temp['step'][index]['position'][position.id]['user'][user._id] = {
              'id': user._id,
              'name': user.display_name,
              'status': tempStatus,
              'status_color': returnStatusColor(tempStatus),
              'log': {}
            };

            _.forEach(user.logs, function (log, currIndex) {
              var tempStatus = 'pending';
              if (!_.isEmpty(position.action.status) && position.action.user._id === log.to_user._id){
                tempStatus = position.action.status;
              }
              temp['step'][index]['position'][position.id]['user'][user._id]['log'][currIndex] = {
                'id': log.to_user._id,
                'name': log.to_user.display_name,
                'action': log.action.toLowerCase(),
                'status': tempStatus,
                'status_color': returnStatusColor(tempStatus)
              }
            });
          });
          return temp;
        }

        /**
         * To structure data to be display in mobile
         */
        var restructuringDataMobile = function () {

          var temp = [];
          temp['step'] = [];

          _.forEach($scope.data.steps, function (step, index) {
            index++;
            temp['step'][index] = [];
            temp['step'][index]['seq'] = step.seq;
            temp['step'][index]['step_status'] = step.step_status;

            temp['step'][index]['position'] = {};
            _.forEach(step.positions, function (position) {
              temp['step'][index]['position'][position.id] = {};
              temp['step'][index]['position'][position.id]['id'] = position.id;
              temp['step'][index]['position'][position.id]['name'] = position.name;
              temp['step'][index]['position'][position.id]['status'] = (!!position.action && !!position.action.status) ?
                position.action.status.toLowerCase() : step.step_status.toLowerCase();
              temp['step'][index]['position'][position.id]['end_at'] = position.action.date;
              temp['step'][index]['position'][position.id]['status_color'] = 'status-color-default';
              temp['step'][index]['position'][position.id]['border_style'] = '';

              temp = processingPositionStatusStyling(position, index, temp);
              temp = processingUserLevelData(position, index, temp);

            });
          });
          $scope.transformedData = temp;
        };
        //#endregion

        //#region Drawing the chart and connections
        /**
         * Function responsible to handle the drawing of the connections
         */
        var handleChart = function () {

          var options = {
            radius: 0.5,
            stroke: {
              lineWidth: 2,
              outlineWidth: 2
            },
            color: {
              transparent: 'transparent',
              red: '#FF0000',
              blue: '#0000FF',
              white: '#FFFFFF',
              green: '#7AB02C',
              darkBlue: '#216477',
              lightBlue: '#61B7CF',
              lightGray: '#C3C3C3',
              approved: '#1AB394',
              basic: '#C3C3C3',
              skipped: '#878787',
              rejected: '#FF2A2A'
            }
          };

          // Variables for connection types
          var connectorPaintStyle = {
              lineWidth: options.stroke.lineWidth,
              strokeStyle: options.color.lightGray,
              joinstyle: 'round',
              outlineColor: options.color.white,
              outlineWidth: options.stroke.outlineWidth
            },
            connectorBasic = {
              connector: 'StateMachine',
              paintStyle: {
                strokeStyle: options.color.basic,
                lineWidth: options.stroke.lineWidth
              }
            },
            connectorApproved = {
              connector: 'StateMachine',
              paintStyle: {
                strokeStyle: options.color.approved,
                lineWidth: options.stroke.lineWidth
              }
            },
            connectorRejected = {
              connector: 'StateMachine',
              paintStyle: {
                strokeStyle: options.color.rejected,
                lineWidth: options.stroke.lineWidth
              }
            };

          // Register the connection types to be called with toggleType
          instance.registerConnectionType('basic', connectorBasic);
          instance.registerConnectionType('approved', connectorApproved);
          instance.registerConnectionType('rejected', connectorRejected);

          // Suspend drawing and initialise.
          instance.batch(function () {

            var nodes = jsPlumb.getSelector('.node');

            var container = {
              width: instance.getContainer().offsetWidth,
              height: instance.getContainer().offsetHeight
            };
            var config = {
              margin: 15,
              distance: 75
            };

            var start = config.margin;

            // Looping for each step
            for (var k = 0; k < $scope.data.steps.length; k++) {

              // Get current step and next step(if any)
              var currentStep = $scope.data.steps[k];
              var nextStep = !!$scope.data.steps[k + 1] ? $scope.data.steps[k + 1] : undefined;

              var node = $(nodes[k]);

              var width = node.width(),
                height = node.height();

              switch ($scope.type) {
                case 'horizontal': {
                  node.css({
                    left: start,
                    top: parseInt((container.height - height) / 2)
                  });
                  start += width + config.distance;
                  break;
                }
                default: { // vertical
                  node.css({
                    left: parseInt((container.width - width) / 2),
                    top: start
                  });

                  start += height + config.distance;
                  break;
                }
              }

              // Looping for each position in current step
              for (var l = 0; l < currentStep.positions.length; l++) {

                var sourceForCurrentStep = 'node-sub_' + currentStep.seq + '_' + currentStep.positions[l].id;

                // If there is next step, loop for each position in next step
                if (!!nextStep) {
                  var line;
                  for (var m = 0; m < nextStep.positions.length; m++) {
                    var targetForCurrentStep = 'node-sub_' + nextStep.seq + '_' + nextStep.positions[m].id;

                    // Assign variable line as a connection
                    line = instance.connect({
                      source: sourceForCurrentStep,
                      target: targetForCurrentStep,
                      anchor: ['LeftMiddle', 'RightMiddle'],
                      maxConnections: -1,
                      connector: ['Flowchart', {
                        stub: [0, 0],
                        gap: 0,
                        cornerRadius: 5,
                        alwaysRespectStubs: true
                      }],
                      connectorStyle: connectorPaintStyle,
                      overlays: [
                        ['Custom', {
                          create: function (component) {
                            return $('<div id="myDropDown"> + </div>');
                          },
                          id: 'addApprover',
                          events: {
                            click: function (labelOverlay, originalEvent) {
                              if (!isAddingAdHoc) {
                                addNewApprover(labelOverlay.component);
                              }
                            }
                          }
                        }]
                      ]
                    });

                    // Switch case to toggle connection type based on step status
                    switch (currentStep.step_status.toLowerCase()) {
                      case 'requestor':
                        line.toggleType('approved');
                        line.removeOverlay('addApprover');
                        break;
                      case 'pending':
                        line.toggleType('basic');
                        if (($scope.contextStatus === 'draft' && (!$scope.waitingon || !$scope.isRequestor)) ||
                          $scope.contextStatus === 'rejected' || $scope.contextStatus === 'on_hold') {
                          line.removeOverlay('addApprover');
                        }
                        break;
                      case 'approved':
                        if (k < $scope.data.current_step) {
                          line.toggleType('approved');
                          line.removeOverlay('addApprover');
                        } else {
                          line.toggleType('basic');
                        }
                        break;
                      case 'rejected':
                        line.toggleType('rejected');
                        line.removeOverlay('addApprover');
                        break;
                      case 'on_hold':
                      case 'escalated':
                      case 'delegated':
                        line.removeOverlay('addApprover');
                        break;
                    }

                    if (l !== 0 || m !== 0) {
                      line.removeOverlay('addApprover');
                    }
                  }
                }

                // Looping for each user in current step's position
                _.forEach(currentStep.positions[l].users, function (user) {
                  user.is_active = true;
                  if (!!user.logs && user.logs.length > 0) {
                    var lastLog = user.logs.slice(-1)[0];
                    var lastTwoLog = user.logs.slice(-2)[0];

                    if (lastLog.action === 'escalate' ||
                      (!!lastTwoLog && lastTwoLog.action === 'escalate' && lastLog.action === 'delegate')) {
                      user.is_active = false;
                    }
                  }
                });
              }
            }
          });

          jsPlumb.fire('jsPlumbDemoLoaded', instance);
        };

        /**
         * to get the approval flow in draft
         */
        function approvalPreview() {
          $scope.firstLoad = false;
          instance.reset(); // to reset the jsplumb instance before re draw
          $scope.preview();
        }

        /**
         * Add New Approver (Adhoc approver)
         * @param overlaysData
         * overlays data from the click event (jsplumb)
         */
        function addNewApprover(overlaysData) {
          if (!!overlaysData) {
            var modalInstance = $uibModal.open({
              templateUrl: 'components/approval-flow/add-approver/add-approver.html',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                companyCode: function () {
                  isAddingAdHoc = true;
                  if (!!$scope.context && !!$scope.context.company && !!$scope.context.company.code ) {
                    return $scope.context.company.code;
                  }
                },
                overlays: function () {
                  return overlaysData;
                },
                approvalId: function () {
                  if (!!$scope.data && !!$scope.data._id) {
                    return $scope.data._id;
                  }
                }
              },
              controller: 'addApproverCtrl'
            });

            modalInstance.result.then(function () {
              isAddingAdHoc = false;
            });
          }
        }

        function deleteAdhoc(step, positionId) {
          swal(
            {
              title: 'Confirm remove adhoc approver?',
              text: 'Selected adhoc approver will be removed',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#ed5565',
              confirmButtonText: 'Remove',
              closeOnConfirm: true
            },
            function (confirm) {
              if (!!confirm) {
                removeAdhocApprover.delete({
                  id: $scope.data._id,
                  step: step,
                  positionId: positionId
                }, function(){
                  toastr.success('Adhoc approver has been removed.');
                  $state.reload();
                }, function (error){
                  globalFunc.objectErrorMessage(error);
                })
              }
            }
          );
        }

        function action() {
          instance.reset(); // to reset the jsplumb instance before re draw
          if (!$rootScope.isMobileMode) {
            restructuringData();
          } else {
            restructuringDataMobile();
          }
          initiateJSPlumbInstance();

          if (!!$scope.data && !!$scope.data.steps) {
            $timeout(handleChart);
          }
        }
        //#endregion

        //#region Watchers
        $scope.$watch('data', function (newData) {
          $scope.data = newData;
          action();
        });

        $scope.$watch('ischanged', function (isChangedField) {
          $scope.isChangedField = isChangedField;
        });
        //#endregion

        function initialize() {
          initiateJSPlumbInstance();
        }

        initialize();
      }
    }
  });

(function(){
  'use strict';

  angular.module('metabuyer')
    .directive('allowPattern', function() {
      return {
        restrict: 'A',
        compile: function() {
          return function(scope, element, attrs) {
            element.bind('keypress', function(event) {
              var keyCode = event.which || event.keyCode;
              var keyCodeChar = String.fromCharCode(keyCode);

              if(event.charCode === 0){
                return true;
              } else if(!keyCodeChar.match(new RegExp(attrs.allowPattern, 'i'))) { // 'i' case-sensitive
                event.preventDefault();
                return false;
              }

            })
          }
        }
      }
    })
})();

'use strict';

/**
 * @name addressesPanel
 *
 * @description
 * Function that returns the addressesPanel directive
 * Directive that can be embedded in modules for Selecting available address or adding new ones
 *
 *  @params
 *  selectedAddressId (mandatory):
 *  2-way-binded, to return the selected address or assign the new address
 *
 *  addressType (optional):
 *  optional, in case of need to add a billing or delivery type for the newly created addresses
 *
 *  cacheKey (mandatory):
 *  the list of addresses has to be cached before opening the directive to avoid multiple server calls to supplier loading the directive multiple times on a single panel
 *  the address list is loaded in a 2-way so that any addition is not removed from the session, and can be used in a different identical directive
 *
 * @authors Ahmed Saleh (a.s.alsalali@gmail.com)
 * @copyright Sunway Metacloud &copy; 2016
 */
function addressesPanel() {
  return {
    restrict: 'EA',
    scope: {
      selectedAddressId: '=',
      addressType: '@?',
      cacheKey: '@',
      companyCode: '='
    },
    replace: true,
    templateUrl: 'components/addressesPanel/addressesPanelTemplate.html',
    controller: 'addressPanelCtrl'
  }
}

/**
 * @name addressPanelCtrl
 *
 * @description
 * Function that returns the addressPanelCtrl Controller
 * Controller for the  addressesPanel Directive
 *
 * @param $scope
 * @param metabuyerCache
 * @param globalFunc
 * @param addressList
 *
 *
 */
function addressPanelCtrl($scope, metabuyerCache, globalFunc, addressList) {

  /**
   * toggling which tab is active
   * @param tab
   * @returns {*}
   */
  function toggleTab(tab) {
    return $scope.tab = tab;
  }

  /**
   * validate the entries before submitting a new Address
   * @param address
   * @returns {boolean}
   */
  function validate(address) {

    if (!address)
      return false;

    if (!address.line1)
      return false;

    if (!address.postal_code)
      return false;

    if (!address.city)
      return false;

    if (!address.country || !address.country.descr)
      return false;

    if (!address.phone)
      return false;

    if (!address.state)
      return false;

    return true;

  }

  /**
   * assigning the newly selected address without binding
   * @param address
   */
  function selectAddress(address) {
    $scope.selectedAddress = angular.copy(address);
    $scope.selectedAddressId = address._id;
  }

  /**
   * adding the new address to the top of the list
   * @param address
   */
  function setAddressAsSelected(address){
    if ($scope.addressesList.length > 0)
      $scope.addressesList.unshift(address);
    else
      $scope.addressesList.push(address);
  }

  /**
   * adding new address to the server
   */
  function addAddress() {
    $scope.submittedAddress = true;

    if (validate($scope.newAddress)) {

      var data = angular.copy($scope.newAddress);
      data.country = data.country.descr;
      data.companyCode = $scope.companyCode;
      addressList.post(data,
        function (resource) {
          if (!!resource.content && !!resource.content.data) {
            $scope.newAddress.type = $scope.addressType;
            $scope.newAddress._id = resource.content.data._id;
            $scope.newAddress.reference = resource.content.data.reference;
            selectAddress($scope.newAddress);
            setAddressAsSelected($scope.newAddress);
            toggleTab(1);
            // clean up the form
            $scope.newAddress = {};
            $scope.submittedAddress = false;
            $scope.addressForm.$setPristine();
            $scope.addressForm.$setUntouched();
          } else {
            globalFunc.objectErrorMessage('Something went wrong.');
          }
        }, function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    } else {
      globalFunc.objectErrorMessage('Fill the required field.');
    }
  }

  /**
   * checking if the contry selected has list of states or not
   * @param country
   * @returns {boolean}
   */
  function onSelectedCountry(country) {
    $scope.newAddress.state = null;
    return country.descr === 'Malaysia' ? $scope.selectedMalaysia = true : $scope.selectedMalaysia = false;
  }

  function onSelectedState(state) {
    $scope.newAddress.state = state.descr;
  }

  $scope.newAddress         = {};
  $scope.tab                = 1;
  $scope.addressesList      = metabuyerCache.get($scope.cacheKey) || [];
  $scope.countries          = globalFunc.countryCode();
  $scope.MYStates           = globalFunc.malaysiaState();

  $scope.toggleTab          = toggleTab;
  $scope.selectAddress      = selectAddress;
  $scope.addAddress         = addAddress;
  $scope.onSelectedCountry  = onSelectedCountry;
  $scope.onSelectedState    = onSelectedState;



}
addressPanelCtrl.$inject =['$scope', 'metabuyerCache', 'globalFunc', 'addressList'];

angular
  .module('metabuyer')
  .controller('addressPanelCtrl', addressPanelCtrl)
  .directive('addressesPanel', addressesPanel);


'use strict';

/**
 * @name Address Insertion
 *
 * @description
 * Directive to insert and update address
 *
 * @param data
 * data is two ways binding variable that used to fill in the address data
 * and can be used in the controller
 *
 * @param country
 * @param selector
 * selector is country selector 'key' to get state data
 * @param state
 * State must be object and array inside the object
 * state has relation with country selection.
 * example state data
 * {
 *    'MY': [], // state data of MY
 *    'SG': [] // state data of SG
 * }
 * with this data when user select the country it will load the array of the selected object
 *
 * @copyright Sunway Metacloud &copy; 2016
 */

angular
  .module('metabuyer')
  .directive('addressInsertion', function() {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        countries: '=',
        selector: '@',
        states: '='
      },
      replace: true,
      templateUrl: 'components/addressInsertion/addressInsertion.html',
      link: function($scope) {
        $scope.countryStates = [];
        $scope.onSelectedCountry = onSelectedCountry;
        $scope.stateIsExist = false;

        function onSelectedCountry(selectedCountry) {
          var code = selectedCountry[$scope.selector];
          $scope.stateIsExist = validateStateIsExist($scope.states, code);
          $scope.countryStates = $scope.stateIsExist;
          $scope.data.state = '';
          if(!!$scope.stateIsExist)
            $scope.data.state = {};
        }

        function validateStateIsExist(states, selector) {
          return states[selector];
        }
      }
    }
  });

'use strict';

angular.module('metabuyer')
  .filter('adddressBookFilter', ['$filter', function ($filter) {
    return function (address_books, values, scope) {
      var filters = [];
      _.forEach(address_books, function(address_book){

        //company city, state filter
        if(!!values.city_state){

          if(!address_book.city || !address_book.state) {
            return;
          }

          var is_found = false;
          if(address_book.city.toLowerCase().indexOf(values.city_state.toLowerCase()) !== -1){
            is_found = true;
          }

          if(address_book.state.toLowerCase().indexOf(values.city_state.toLowerCase()) !== -1){
            is_found = true;
          }

          if(!is_found){
            return;
          }
        }

        //Company postal code filter
        if(!!values.postal_code){

          if(!address_book.postal_code) {
            return;
          }

          var is_found = false;
          if(address_book.postal_code.toLowerCase().indexOf(values.postal_code.toLowerCase()) !== -1){
            is_found = true;
          }

          if(!is_found){
            return;
          }
        }

        //company address filter
        if(!!values.address){

          if(!address_book) {
            return;
          }

          if(!address_book.line1 && !address_book.line2
            && !address_book.line3) {
            return;
          }

          var is_found = false;
          if(values.isShownAddressLine("address_line_1") &&
             address_book.line1.toLowerCase().indexOf(values.address.toLowerCase()) !== -1){
            is_found = true;
          }

          if(values.isShownAddressLine("address_line_2") &&
             address_book.line2.toLowerCase().indexOf(values.address.toLowerCase()) !== -1){
            is_found = true;
          }

          if(values.isShownAddressLine("address_line_3") &&
             address_book.line3.toLowerCase().indexOf(values.address.toLowerCase()) !== -1){
            is_found = true;
          }

          if(!is_found){
            return;
          }
        }

        filters.push(address_book);
      });

      return filters;
    }
  }]);

/**
 * @name addressBook
 *
 * @requires $uibModal
 *
 * @description This directive is for the address book popup to select an address
 *
 * @isolatedScope addressBook
 * Isolated scope for parent scope's address object
 * @bindingType One way binding
 *
 * @isolatedScope addressList
 * Isolated scope for parent scope's list of address
 * @bindingType Two way binding
 *
 * @isolatedScope onSelectedAddressBook
 * Isolated scope for parent scope's function on select address
 * @bindingType Expression binding
 *
 * @isolatedScope accessFrom
 * Isolated scope for determining directive is accessed from which feature
 * @bindingType One way binding
 *
 * @isolatedScope eventHandler
 * Isolated scope for determining when to call the directive
 * @bindingType Two way binding
 *
 *
 * @authors Justin Cheong Tian Yee
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';
angular
  .module('metabuyer')
  .directive('addressBook',function($uibModal, toastr, Orders) {
    return{
      restrict: 'A',
      scope: {
        addressBook: '@?',
        addressList: '=',
        onSelectedAddressBook: '&',
        accessFrom: '@',
        eventHandler: '=',
        lumpSum: '=?',
        removeLumpSum: '&?',
        prDeliveryAddress: '=?',
        selectedItemsIndexes: '=?',
        multiDeletionFunction: '&?'
      },
      link: function(scope, element, attrs) {
        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/addressBook/addressBookTemplate.html',
            controller: "AddressBookCtrl",
            backdrop: 'static',
            keyboard: false,
            scope: scope,
            size: 'lg'
          });
        };

        //loading address book
        scope.showAddressBook = function () {
          panel();
        };

        element.bind('click' , function($event){
          if(scope.eventHandler){
            scope.showAddressBook();
          }
        });

      }
    };
  });

'use strict';

//TODO: reformat the file to standard

angular.module('metabuyer')
  .controller('AddressBookCtrl', function ($scope, $uibModalInstance, toastr) {
    $scope.column = {
      columns: [
        {id: 'address_line_1', label: 'Address Line 1', visible: true},
        {id: 'address_line_2', label: 'Address Line 2', visible: true},
        {id: 'address_line_3', label: 'Address Line 3', visible: true},
        {id: 'postal_code'   , label: 'Postcode'      , visible: true},
        {id: 'city_state'    , label: 'City, State'   , visible: true},
        {id: 'phone'         , label: 'Phone'         , visible: true},
        {id: 'fax'           , label: 'Fax'           , visible: true}
      ],
      selectedColumns: [],
      buttonText: {buttonDefaultText: 'Columns'},
      setting: {
        buttonClasses: "btn btn-white",
        smartButtonMaxItems: 3,
        showCheckAll: false,
        showUncheckAll: false
      },
      events: {
        onItemSelect: function (item) {
          $scope.column.saveSelectedColumn($scope.column.selectedColumns);
        },
        onItemDeselect: function (item) {
          $scope.column.saveSelectedColumn($scope.column.selectedColumns);
        }
      },
      showColumn: function (name) {
        for (var index = 0; index < $scope.column.selectedColumns.length; ++index) {
          var item = $scope.column.selectedColumns[index];
          if (!!item && item.id == name) {
            return true;
          }
        }
        return false
      },
      saveSelectedColumn: function (columns) {
        window.localStorage.setItem("address-book-selected_columns", JSON.stringify(_.map(columns, function (item) {
          return item.id || item
        })));
      },
      loadSelectedColumn: function () {
        return JSON.parse(window.localStorage.getItem("address-book-selected_columns")) || [];
      }
    };

    // Apply selected column
    var selectedColumn = $scope.column.loadSelectedColumn();
    if (selectedColumn.length == 0) { // Default column
      for (var index = 0; index < $scope.column.columns.length; ++index) {
        $scope.column.selectedColumns.push($scope.column.columns[index]);
      }
    }
    else {
      for (var index = 0; index < selectedColumn.length; ++index) {
        var column = _.find($scope.column.columns, function (item) {
          return item.id == selectedColumn[index];
        });
        if (!!column)
          $scope.column.selectedColumns.push(column);
      }
    }

    //select address item
    $scope.selectAddressBook = function(cost_center) {
      /**
       * check for a lump sum before showing a warning
       */
      if (!!$scope.lumpSum) {
        if ($scope.accessFrom === 'lineItemDeliveryAddress' || $scope.accessFrom === 'multiSelectPanel') {
          swal(
            {
              title: 'Confirm add delivery address to this line item?',
              text: "Adding a different delivery address on line item will remove lump sum discount. Proceed?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              closeOnConfirm: true,
              closeOnCancel: true
            },
            function (isConfirm) {
              if (isConfirm) {
                /**
                 * removing the lump sum discount then adding the new delivery address
                 */
                $uibModalInstance.close();
                $scope.removeLumpSum().$promise.then(function (success) {
                  //item selected before, nothing to do
                  if ($scope.addressBook == cost_center._id) {
                    return;
                  }
                  $scope.onSelectedAddressBook({address_book: _.cloneDeep(cost_center)});
                });
              }
            }
          );
        }
        else {
          $uibModalInstance.close();
          //item selected before, nothing to do
          if ($scope.addressBook == cost_center._id) {
            return;
          }
          if( $scope.accessFrom === 'multiSelectPanel'){
            $scope.onSelectedAddressBook()(cost_center, $scope.selectedItemsIndexes);
          }else {
            $scope.onSelectedAddressBook({address_book: _.cloneDeep(cost_center)});
          }
        }
      }
      else {
        $uibModalInstance.close();
        //item selected before, nothing to do
        if ($scope.addressBook == cost_center._id) {
          return;
        }
        if( $scope.accessFrom === 'multiSelectPanel'){
          $scope.onSelectedAddressBook()(cost_center, $scope.selectedItemsIndexes);
        }else {
          $scope.onSelectedAddressBook({address_book: _.cloneDeep(cost_center)});
        }
      }
    };

    //close address book modal
    $scope.closeAddressBook = function(){
      $uibModalInstance.close();
    };

    //move selected item on top
    $scope.setSelectedItemOnTop = function(){

      if(!$scope.addressBook){
        return;
      }

      var index = _.findIndex($scope.addressList, function(item){
        return item._id == $scope.addressBook;
      });

      if(index != -1){

        $scope.addressList.splice(0, 0, $scope.addressList[index]);
        $scope.addressList.splice(index + 1, 1);
      }
    };

    $scope.search = {
      isShownAddressLine: $scope.column.showColumn
    };

    $scope.setSelectedItemOnTop();

    $scope.removeMultiAddresses = function(){
      $scope.multiDeletionFunction();
      $scope.closeAddressBook();
    }

  });


'use strict';

angular.module('metabuyer').directive('addField', ['$filter', '$document', '$compile', '$parse',
    function ($filter, $document, $compile, $parse) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                groupBy: '@'
            },
            template: function (element, attrs) {
                var checkboxes = attrs.checkboxes ? true : false;
                var groups = attrs.groupBy ? true : false;

                var template = '<div class="multiselect-parent btn-group dropdown-multiselect">';
                template += '<button type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}&nbsp;<span class="fa fa-caret-down"></span></button>';
                template += '<ul class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll" >';
                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a data-ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll"><a data-ng-click="deselectAll();"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
                template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';
                template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                template += '<li ng-show="settings.enableSearch" class="divider"></li>';

                if (groups) {
                    template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                    template += '<li ng-repeat-end role="presentation">';
                } else {
                    template += '<li role="presentation" ng-repeat="option in options | filter: searchFilter">';
                }

                template += '<a role="menuitem" tabindex="-1" ng-click="setSelectedItem(option)">';

                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                } else {
                    template += '{{getPropertyForObject(option, settings.displayProp)}}</a>';
                }

                template += '</li>';

                template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function ($scope, $element, $attrs) {
                var $dropdownTrigger = $element.children()[0];

                $scope.sortOnTop = function(){
                  $scope.options = _.sortBy($scope.options, function(option){
                    var find_item = _.find($scope.selectedModel, function(selected_item){

                      return option[$scope.settings.idProp] == selected_item[$scope.settings.idProp];
                    });

                    if(find_item != undefined){

                      //place on top
                      return false;
                    }

                    return true;
                  });
                }

                $scope.toggleDropdown = function () {
                    $scope.open = !$scope.open;
                    if($scope.open && $scope.settings.enableSortOnTop){
                        $scope.sortOnTop();
                    }
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop,
                    onShowDropdown: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 0,
                    showCheckAll: false,
                    showUncheckAll: false,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop,
                    enableSortOnTop: false
                };

                $scope.texts = {
                    checkAll: 'Check All',
                    uncheckAll: 'Uncheck All',
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: 'Search...',
                    buttonDefaultText: 'Select',
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function (e) {
                        var target = e.target.parentElement;
                        var parentFound = false;

                        while (angular.isDefined(target) && target !== null && !parentFound) {
                            if (_.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                if(target === $dropdownTrigger) {
                                    parentFound = true;
                                }
                            }
                            target = target.parentElement;
                        }

                        if (!parentFound) {
                            $scope.$apply(function () {
                                $scope.open = false;
                            });
                        }
                    });
                }

                $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue);
                    }

                    return groupValue;
                };

                $scope.getButtonText = function () {
                    if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {
                            var itemsText = [];

                            angular.forEach($scope.options, function (optionItem) {
                                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                    itemsText.push(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                //itemsText.push('...');
                            }

                            return itemsText.join(', ');
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            } else {
                                return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                            }
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };


                $scope.setSelectedItem = function(item) {

                      var copy_item = {};
                      angular.extend(copy_item, item);

                      $scope.selectedModel.push(copy_item);

                      $scope.externalEvents.onItemSelect(copy_item);
                };

                $scope.isChecked = function (id) {
                    if ($scope.singleSelection) {
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                    }

                    return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.externalEvents.onInitDone();
            }
        };
}]);

'use strict';
angular
  .module('metabuyer')
  .directive('addContact',function($uibModal, toastr) {
    return{
      restrict: 'A',
      scope: {
        addedContact: '&'
      },
      link: function(scope, element, attrs) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/addContact/addContactTemplate.html',
            controller: 'addContactCtrl',
            backdrop: 'static',
            keyboard: false,
            scope: scope
          });
        };
        //loading the panel
        scope.showAddContact = function () {
          panel();
        };

        element.bind('click', function($event){
          scope.showAddContact();
        });
      }
    };
  });

'use strict';

function addContactCtrl($scope, $uibModalInstance, toastr, $q, Contacts, globalFunc) {

  //cancel action
  $scope.cancel = function(){
    $uibModalInstance.close();
  };

  function validateContact(){
    if(!$scope.add_data.first_name){
      return false;
    }

    if(!$scope.add_data.phone){
      return false;
    }

    if (!$scope.isValidPhoneNo) {
      return false;
    }

    // if (!$scope.isValidFaxNo) {
    //   return false;
    // }

    return true;
  }

  /**
   * Validate number format with given element id and returns boolean in field name
   *
   * @param {string} elementId
   * @param {string} fieldName
   */
  function validateNumbers(elementId, fieldName) {
    $scope[fieldName] = globalFunc.numberFormatValidation(elementId);
  }

  //proceed action
  $scope.addContact = function(){
    $scope.clicked_submit = true;
    if(!validateContact()){
      toastr.error('Please fill all required fields');
      return;
    }

    if(!!$scope.add_data.email && !globalFunc.emailFormatValidation($scope.add_data.email)) {
      toastr.error('Please enter a valid email address');
      return;
    }

    Contacts.addContact({}, $scope.add_data,
      function(success){
        toastr.success('Contact added');

        if(!!success._id){
          $scope.add_data._id = success._id;
        }

        $scope.addedContact({contact: $scope.add_data});

        $uibModalInstance.close();
      }, function(error){
        globalFunc.objectErrorMessage(error);
        $uibModalInstance.close();
      });
  };

  function initialize() {
    $scope.add_data = {};
    $scope.validateContact = validateContact;
    $scope.emailFormatValidation = globalFunc.emailFormatValidation;
    $scope.validateNumbers = validateNumbers;
    $scope.isValidPhoneNo = true;
    $scope.isValidFaxNo = true;
  }

  initialize();
}

addContactCtrl.$inject = ['$scope', '$uibModalInstance', 'toastr', '$q', 'Contacts', 'globalFunc'];

angular.module('metabuyer')
  .controller('addContactCtrl', addContactCtrl);

'use strict';
angular
  .module('metabuyer')
  .directive('actionScrollFix',function($window) {
  return {
    restrict: "A",
    link: function (scope, elem, attrs) {
      var windowElem = angular.element($window);

      var is_fix = false;
      var get_fix_offset = false;

      var fix_offset = 0;

      //bind scroll event
      windowElem.bind("scroll", function () {

        if(get_fix_offset == false){
          get_fix_offset = true;
          fix_offset = elem.offset().top;
        }

        var current_offset = elem.offset().top;

        if (windowElem.scrollTop() > current_offset + 60) {

          if (is_fix == false) {
            elem.addClass("action-scroll-fix");

            is_fix = true;
          }
        } else {
          if (is_fix == true && windowElem.scrollTop() <= fix_offset) {
            elem.removeClass("action-scroll-fix");
            is_fix = false;
          }
        }
      });

      //bind resize event
      windowElem.bind("resize", function(){

        get_fix_offset = false;

        elem.removeClass("action-scroll-fix");

        var current_offset = elem.offset().top;

        if(windowElem.scrollTop() > current_offset + 60) {
          get_fix_offset = true;
          is_fix = true;
          fix_offset = current_offset;
          elem.addClass("action-scroll-fix");
        }
      });
    }
  }
});

/**
 * @name actionModal
 *
 * @description
 * Directive that loads the Action modal for Approval and handles the success, error, and redirection
 *
 *
 * @requires $uibModal
 *
 * @authors Ahmed Saleh (a.s.alsalali@gmail.com)
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular
  .module('metabuyer')
  .directive('actionModal', function($uibModal, preventDoubleClickingService) {
    return {
      restrict: 'A',
      scope: {
        title: '@',
        actionFunction: '&',
        nextActionId: '@?',
        actionCondition: '&?',
        module: '@',
        successHandler: '&?',
        errorHandler: '&?',
        modalBodyUrl: '@?',
        commentBlock: '@?',
        commentPlaceHolder: '@?',
        extraParams: '=?',
        nextActionAmount : '=?',
        allActionsCompleted: '=?',
        sendEmail: '=?',
        commentKey: '@?',
        bodyMessage: '@?',
        enableAttachment: '=?'
      },
      link: function ($scope, element, attrs) {

        var panel = function () {

          $uibModal.open({
            templateUrl: 'components/actionModal/actionModalTemplate.html',
            scope: $scope,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'action-modal',
            controller: 'actionModalCtrl',
            resolve: {
              successHandler: function () {
                return !!attrs.successHandler ? $scope.successHandler : undefined;
              },
              errorHandler: function () {
                return !!attrs.errorHandler ? $scope.errorHandler : undefined;
              }
            }
          });
        };

        element.bind('click', function () {
          if (preventDoubleClickingService.checkClick())
            panel();
        });
      }
    }
  });

/**
 * @name actionModalCtrl
 *
 * @description the controller for the modal for listing actions
 * in case of a successful request, the controller will check for the redirection, in case its set to true,
 * transition to the next ID provided.
 * else the success handler (if passed) will activate
 *
 *
 * @requires $scope
 * @requires $uibModalInstance
 * @requires $state
 *
 * @authors Ahmed Saleh (a.s.alsalali@gmail.com)
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

function actionModalCtrl (
  $scope, $uibModalInstance, $state, successHandler, errorHandler, globalFunc, pathConstants, $http
) {

  $scope.state        = '';
  $scope.modalHasBody = false;
  $scope.submitted    = false;
  $scope.attachment   = {};

  $scope.confirm = confirm;
  $scope.cancel = cancel;
  $scope.checkNextAction = checkNextAction;

  /**
   * function to add the extra comment to the payload passed back to the PR
   */
  function prepareExtraParams() {

    var key = !!$scope.commentKey ? $scope.commentKey : 'comment';
    if (!!$scope.extraParams) {
      var temp = {
        email: $scope.sendEmail
      };
      temp[key] = $scope.commentText;
      angular.extend($scope.extraParams, temp);
    }
  }

  function confirm() {
    if (!!$scope.attachment && !!$scope.attachment.file) {
      uploadAttachment($scope.attachment.file)
        .then(
          function (resource) {
            if (!!resource && !!resource.data && !!resource.data.content && !!resource.data.content.data) {
              angular.extend($scope.extraParams, {
                'attachment': resource.data.content.data
              });
              afterConfirm();
            }
          },
          function (error) {
            globalFunc.objectErrorMessage(error);
          }
        );
    } else {
      afterConfirm();
    }
  }

  function afterConfirm() {
    $scope.submitted = true;
    if(!!$scope.commentBlock) {
      prepareExtraParams();
    }

    $scope.actionFunction().$promise.then(function (resource) {
      $uibModalInstance.close();
      /**
       * transition to the Next Action if its selected
       */

      if (!!$scope.nextActionId && !!$scope.goNextAction) {
        /**
         * In case the get for next action ids still loading and confirm is pressed
         */
        if($scope.nextActionId === 'loading')
          successHandler(resource);
        /**
         * Normal condition when transition is selected
         */
        else
          $state.go($scope.state, {id: $scope.nextActionId});
      }
      /**
       * In case it is the last approvable action, show modal to notify user
       */
      else if (!$scope.nextActionId && !!$scope.allActionsCompleted) {

        successHandler(resource);
        swal(
          {
            title: 'All PRs Approved',
            text: 'Good work, all your PRs have been approved',
            type: 'info',
            confirmButtonColor: '#D0D0D0',
            confirmButtonText: 'Close',
            closeOnConfirm: true
          }
        );
      }
      /**
       * use the success handler in case the transition not selected
       */
      else if (!!$scope.successHandler) {
        $scope.successHandler({resource: resource});
      }
    }, function (error) {
      $uibModalInstance.close();
      if (!!errorHandler) {
        errorHandler(error.content);
      } else {
        globalFunc.objectErrorMessage(error);
      }
    })
  }

  /**
   * Upload attachment
   *
   * @param {object} attachmentFile
   */
  function uploadAttachment(attachmentFile) {
    var fd = new FormData();
    fd.append('file', attachmentFile._file);
    return $http.post(
      pathConstants.apiUrls.attachments.reference, fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }
    );
  }

  function cancel() {
    $uibModalInstance.close();
  }

  function checkNextAction(value){
    $scope.goNextAction = value;
  }

  function initialize() {
    /**
     * preparing the data for the transition and messages
     */
    if (!!$scope.module && $scope.module.toLowerCase() === 'pr') {
      $scope.state = 'main.user.purchaseRequisitions.details';
      $scope.message = 'purchase requisition';
    } else if (!!$scope.module && $scope.module.toLowerCase() === 'budget') {
      $scope.state = 'main.user.budget.details';

      if (!!$scope.$parent.nextActionAmount && ($scope.$parent.nextActionAmount - 1) > 1) {
        $scope.message = 'budgets';
      } else {
        $scope.message = 'budget';
      }
    }

    /**
     * auto select the Next as
     * TODO: this will be updated once we apply user preferences (8/9/2016, Ahmed Saleh)
     */
    if (!!$scope.nextActionId) {
      $scope.goNextAction = true;
    }

    /**
     * embed the URL to the body of the Modal
     */
    if (!!$scope.modalBodyUrl) {

    }

    if(!!$scope.commentBlock){
      $scope.commentText = '';
    }
  }

  initialize();

}

actionModalCtrl.$inject = [
  '$scope', '$uibModalInstance', '$state', 'successHandler', 'errorHandler', 'globalFunc', 'pathConstants', '$http'
];

angular.module('metabuyer')
  .controller('actionModalCtrl', actionModalCtrl);

'use strict';

angular
  .module('metabuyer')
  .directive('actionModalMobile', function ($uibModal, preventDoubleClickingService) {
    return {
      restrict: 'A',
      scope: {
        title: '@',
        actionFunction: '&',
        nextActionId: '@?',
        actionCondition: '&?',
        module: '@',
        successHandler: '&?',
        errorHandler: '&?',
        modalBodyUrl: '@?',
        commentBlock: '@?',
        commentPlaceHolder: '@?',
        extraParams: '=?',
        nextActionAmount: '=?',
        allActionsCompleted: '=?'
      },
      link: function ($scope, element, attrs) {

        var panel = function () {

          $uibModal.open({
            templateUrl: 'components/actionModal/actionModalTemplate-mobile.html',
            scope: $scope,
            backdrop: 'static',
            keyboard: false,
            windowClass: 'action-modal-mobile',
            controller: 'actionModalCtrl',
            resolve: {
              successHandler: function () {
                return !!attrs.successHandler ? $scope.successHandler : undefined;
              },
              errorHandler: function () {
                return !!attrs.errorHandler ? $scope.errorHandler : undefined;
              }
            }
          });
        };

        element.bind('click', function () {
          if (preventDoubleClickingService.checkClick())
            panel();
        });
      }
    }
  });

'use strict';
/**
 * @name accountCode
 * @desc directive for the Account Codes within a Company
 */
angular
  .module('metabuyer')
  .directive('accountCodes',function() {
    return {
      restrict: 'E',
      templateUrl: 'components/accountCode/accountCodeTemplate.html',
      scope: {
        data: '=',
        code: '=',
        costCenters: '='
      },
      controller: function(
        $scope, accountCodesList, accountCodeSearch, singleAccountCode, toastr, $rootScope, $uibModal, pathConstants,
        globalFunc, searchModule, $location, $stateParams
      ) {
        $scope.dataList = $scope.data.data;
        $scope.meta = $scope.data.meta;
        $scope.accountCodesListService = accountCodesList;
        $scope.parent = {};
        $scope.submitted = false;
        $scope.root = {
          id: '',
          code: ''
        };
        $scope.parentCode = {
          status: '',
          code: ''
        };

        $scope.addNewAccountCode = addNewAccountCode;
        $scope.accountCodeDetail = accountCodeDetail;
        $scope.search = search;
        $scope.importAccountCodes = importAccountCodes;
        $scope.getAccountTypeName = getAccountTypeName;
        $scope.getAccountEntriesName = getAccountEntriesName;
        $scope.getAccountReceivableName = getAccountReceivableName;
        $scope.getActiveStatusName = getActiveStatusName;
        $scope.showColumn = showColumn;

        $scope.importLink = pathConstants.apiUrls.accountCode.import;
        $scope.columns = [
            {id: 'name', label: 'Name'},
            {id: 'code', label: 'Code'},
            {id: 'descr', label: 'Description'},
            {id: 'account_entries', label: 'Account Entries'},
            {id: 'account_receivable', label: 'Account Receivable'},
            {id: 'account_type', label: 'Account Type'},
            {id: 'cost_centers', label: 'Cost Centers'},
            {id: 'updated_at', label: 'Updated At'},
            {id: 'updater.display_name', label: 'Updated By'},
            {id: 'created_at', label: 'Created At'},
            {id: 'creator.display_name', label: 'Created By'},
            {id: 'is_active', label: 'Status'},
            {id: 'edit', label: 'Edit', unsortable: true}
          ];

        $scope.storageKey = 'company-management-account-codes-selected-columns';

        function showColumn(id){
          for (var i in $scope.columns) {
            if (id === $scope.columns[i].id) {
              if(!!$scope.columns[i].conditional){
                if($scope.status === $scope.columns[i].condition){
                  return $scope.columns[i].selected;
                }
                if($scope.columns[i].condition instanceof Array){
                  for(var j in $scope.columns[i].condition){
                    if($scope.status === $scope.columns[i].condition[j]){
                      return $scope.columns[i].selected;
                    }
                  }
                }
              }else{
                return $scope.columns[i].selected;
              }
            }
          }
        }

        /**
         * returns the is_active name
         * @param code
         * @returns {*}
         */
        function getActiveStatusName(code){
          /**
           DEACTIVATED = 0; 
           ACTIVE = 1; 
           DELETED = 2; 
           DISABLED = 3; 
           */
          if (code === 0 || code === 'DEACTIVATED') {
            return 'Deactivated'
          }
          if (code === 1 || code === 'ACTIVE') {
            return 'Active'
          }
          if (code === 2 || code === 'DELETED') {
            return 'Deleted'
          }
          if (code === 3 || code === 'DISABLED') {
            return 'Disabled'
          }
          return 'N/A';
        }

        function getAccountTypeName(num){
          for(var i in $scope.accountType){
            if($scope.accountType[i].value === num){
              return $scope.accountType[i].descr;
            }
          }
          return 'N/A';
        }

        function getAccountEntriesName(num){
          for(var i in $scope.accountType){
            if($scope.accountEntries[i].value === num){
              return $scope.accountEntries[i].descr;
            }
          }
          return 'N/A';
        }

        function getAccountReceivableName(num){
          for(var i in $scope.accountType){
            if($scope.accountReceivable[i].value === num){
              return $scope.accountReceivable[i].descr;
            }
          }
          return 'N/A';
        }

        function importAccountCodes() {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/accountCode/Import-Template.html',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              importLink: function () {
                return $scope.importLink;
              },
              title: function () {
                return "Account Code";
              },
              id: function() {
                return $scope.id;
              }
            },
            controller: function ($scope, $uibModalInstance, importLink, title, id) {
              $scope.cancel = function () {
                $uibModalInstance.close();
              };

              $scope.importLink = importLink;
              $scope.title = title;
              $scope.id = id;
            }
          });
        }

        $scope.accountCodeStatuses = [
          { isActive: 'Active', value: 1},
          { isActive: 'Deactivated' , value: 0 }
        ];

        $scope.accountEntries = [
          {value: 0, descr: 'UNSPECIFIED'},
          {value: 1, descr: 'CREDIT'     },
          {value: 2, descr: 'DEBIT'      }
        ];

        $scope.accountReceivable = [
          {value: 0, descr: 'UNSPECIFIED'          },
          {value: 1, descr: 'RETAINED EARNING'     },
          {value: 2, descr: 'CURRENT YEAR EARNINGS'},
          {value: 3, descr: 'ACCOUNT RECEIVABLE'   },
          {value: 4, descr: 'BANK'                 },
          {value: 5, descr: 'ACCOUNT PAYABLE'      }
        ];

        $scope.accountType = [
          {value: 0, descr: 'UNSPECIFIED'},
          {value: 1, descr: 'EQUITY'     },
          {value: 2, descr: 'ASSET'      },
          {value: 3, descr: 'LIABILITY'  },
          {value: 4, descr: 'INCOME'     },
          {value: 5, descr: 'EXPENDITURE'}
        ];


        function addNewAccountCode() {
          $scope.submitted = true;
          if (validate($scope.newAccountCode)) {
            var costCenterIds = prepareCostCenterIds($scope.newAccountCode.cost_centers);

            singleAccountCode.post(
              {
                id: $stateParams.id
              },
              {
                code: $scope.newAccountCode.code,
                name: $scope.newAccountCode.name,
                descr: $scope.newAccountCode.descr,
                account_entries : $scope.newAccountCode.account_entries.value,
                account_receivable : $scope.newAccountCode.account_receivable.value,
                account_type : $scope.newAccountCode.account_type.value,
                cost_center_ids: costCenterIds,
                is_active: 1
              },
              function (success) {
                toastr.success('A new account code has been added successfully');
                if(!!success.content) {
                  if (!!success.content.data) {
                    var addedAccountCode = success.content.data;
                    $scope.dataList.unshift({
                      _id: addedAccountCode._id,
                      code: addedAccountCode.code,
                      descr: addedAccountCode.descr,
                      name: addedAccountCode.name,
                      account_entries: $scope.newAccountCode.account_entries.value,
                      account_receivable: $scope.newAccountCode.account_receivable.value,
                      account_type: $scope.newAccountCode.account_type.value,
                      created_at: addedAccountCode.created_at,
                      updated_at: addedAccountCode.updated_at,
                      cost_center: addedAccountCode.cost_centers,
                      updater: [$rootScope.currentUser],
                      creator: [$rootScope.currentUser],
                      is_active: 1
                    });
                  }
                }
                $scope.newAccountCode.name = '';
                $scope.newAccountCode.code = '';
                $scope.newAccountCode.account_entries = '';
                $scope.newAccountCode.account_receivable = '';
                $scope.newAccountCode.account_type = '';
                $scope.newAccountCode.descr = '';
                $scope.newAccountCode.cost_centers = [];
                $scope.submitted = false;
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                $scope.submitted = false;
              }
            );
          }
        }

        function prepareImportParams () {
            $scope.params = {
                'class': 'Metabuyer\\Models\\AccountCode'
            };
            _.forEach ($scope.dataList, function(account, index){
                var temp = 'additional_params[]['+ index+ ']';
                $scope.params[temp] = account.code;
            });
        }

        prepareImportParams();


        function prepareCostCenterIds(selectedCostCenters) {
          var ids = [];
          _.forEach(selectedCostCenters, function(cc) {
            ids.push(cc._id);
          });
          return ids;
        }

        function search(query) {
          $location.search({query: query});
        }

        function validate(accountCode) {
          var validationError = 0;
          if (!!accountCode) {
            if (!accountCode.code ||
              !accountCode.name ||
              !accountCode.descr ||
              !accountCode.account_entries ||
              !accountCode.account_type ||
              !accountCode.account_receivable
            )
              validationError++;

            if (validationError > 0) {
              globalFunc.objectErrorMessage('Please complete all required fields before proceeding');
              return false;
            }
          }

          return true;
        }

        function accountCodeDetail(accountCode) {
          var modalInstance = $uibModal.open({
            templateUrl: "components/accountCode/details/details.html",
            backdrop: 'static',
            keyboard: false,
            controller: 'accountCodeDetailsCtrl',
            resolve: {
              accountCode: function() {
                return accountCode;
              },
              companyId: function(){
                return $stateParams.id;
              },
              accountCodeStatuses: function(){
                return $scope.accountCodeStatuses;
              },
              accountEntries: function(){
                return $scope.accountEntries;
              },
              accountReceivable: function(){
                return $scope.accountReceivable;
              },
              accountType: function(){
                return $scope.accountType;
              },
              costCenters: function() {
                return $scope.costCenters;
              }
            }
          });
          modalInstance.result.then(function (newValue) {
            if(!!newValue){
              _.forEach($scope.dataList, function(dataList){
                if(dataList._id === newValue._id){
                  dataList.name = newValue.name;
                  dataList.code = newValue.code;
                  dataList.descr = newValue.descr;
                  dataList.account_entries = newValue.account_entries.value;
                  dataList.account_receivable = newValue.account_receivable.value;
                  dataList.account_type = newValue.account_type.value;
                  dataList.cost_center = newValue.cost_center;
                  dataList.is_active = newValue.accountCodeStatus.value;
                  dataList.updated_at = newValue.updated_at;
                  dataList.updater[0].display_name = newValue.updater[0].display_name;
                  dataList.parent_code = newValue.parent_code;
                }
              });
            }
          });
        }
      }
    }
  });

'use strict';
/**
 * @name UsersCtrl
 * @desc Controller for users
 */
function UsersCtrl($scope, $state, Users, profile, $rootScope, UserPermissions) {
  $scope.$emit('pageTitleChanged', 'Manage Users');


  $scope.tabData = [
    {
      heading: 'Manage Users',
      route: 'main.user.users.manage',
      key: 'manageUsers',
      menu: [
        {
          heading: 'All Users',
          route: 'main.user.users.manage',
          key: 'manageUsers',
          params: {
            status: 'all',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Active Users',
          route: 'main.user.users.manage',
          key: 'manageUsers',
          params: {
            status: 'active',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Pending Approval Users',
          route: 'main.user.users.manage',
          key: 'manageUsers',
          params: {
            status: 'pending',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Inactive Users',
          route: 'main.user.users.manage',
          key: 'manageUsers',
          params: {
            status: 'inactive',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Rejected Users',
          route: 'main.user.users.manage',
          key: 'manageUsers',
          params: {
            status: 'rejected',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    },
    {
      heading: 'Add',
      route: 'main.user.users.add',
      key: 'addUser',
      menu: [
        {
          heading: 'Add a User',
          key: 'addUser',
          route: 'main.user.users.add'
        },
        {
          heading: 'Import Users',
          key: 'addUser',
          route: 'main.user.users.import'
        }
      ]
    },
    {
      heading: 'Escalation',
      route: 'main.user.users.escalation',
      key: 'escalation',
      cursor: null,
      filter: null,
      query: null,
      type: null
    },
    {
      heading: 'Delegation',
      route: 'main.user.users.delegation',
      key: 'delegation',
      cursor: null,
      filter: null,
      query: null,
      type: null
    }
  ];
  var onlineUsersTab = {
    heading: 'Online Users',
    route: 'main.user.users.onlineUsers',
    key: 'online'
  };
  if (!!UserPermissions.checkUserSessionAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkUserSessionAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkUserSessionAccess(profile, 'D', $rootScope.changeWorkSpace)) {
    $scope.tabData.push(onlineUsersTab);
  }

  /**
   * making sure the Stats and placeHolder changes if the Child scope changed
   */

  $scope.$on('$stateChangeStart', function( event, data, toParams ) {

    if (!!data.name && data.name.indexOf('escalation')> -1) {
      $scope.searchState = 'main.user.users.escalation';
      $scope.searchPlaceholder = 'Search users in escalation';
      $scope.parentState = 'main.user.users.escalation';
      $scope.parentStateParams = toParams;
      $scope.columns = escalationColumns;

    }
    else if (!!data.name && data.name.indexOf('delegation')> -1) {
      $scope.searchState = 'main.user.users.delegation';
      $scope.searchPlaceholder = 'Search delegations';
      $scope.parentState = 'main.user.users.delegation';
      $scope.parentStateParams = toParams;
      $scope.columns = delegationColumns;

    }
    else {

      $scope.searchState = 'main.user.users.manage';
      $scope.searchPlaceholder = 'Search users';
      $scope.parentState = 'main.user.users.manage';
      $scope.parentStateParams = toParams;
      $scope.columns = userColumns;
    }

    if(!!toParams.status){
      $scope.status = toParams.status;
      $scope.parentStateParams = toParams;
    }
  });

  var userColumns = [
    {id: 'display_name', label: 'Full Name'},
    {id: 'email', label: 'Email'},
    {id: 'emp_no', label: 'Employee Number'},
    {id: 'company', label: 'Company(s)', unsortable: true,  unsearchable: true},
    {id: 'costCenter', label: 'Cost Center(s)', unsortable: true,  unsearchable: true},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'role', label: 'Role', unsortable: true, unsearchable: true},
    {id: 'status', label: 'Status', conditional: true, condition: 'all'}
  ];

  var escalationColumns = [
    {id: 'user.display_name', label: 'Full Name'},
    {id: 'user.email', label: 'Email'},
    {id: 'company.descr', label: 'Company'},
    {id: 'superior.display_name', label: 'Superior Name'},
    {id: 'superior.email', label: 'Superior Email'}
    ];

  var delegationColumns = [
    {id: 'creator.display_name', label: 'Creator'},
    {id: 'user.display_name', label: 'Delegator'},
    {id: 'delegatee.display_name', label: 'Delegatee'},
    {id: 'company_code', label: 'Company Code'},
    {id: 'company.descr', label: 'Company Name'},
    {
      id: 'start_date',
      label: 'Start Date',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'end_date',
      label: 'End Date',
      type: 'date',
      unsearchable: true
    },
    {id: 'reason', label: 'Reason', unsortable: true,  unsearchable: true},
    {id: 'status', label: 'Status', unsearchable: true}
  ];

  function initialize(){

    if (!!$state.current.name && $state.current.name.indexOf('escalation')> -1) {
      $scope.searchState = 'main.user.users.escalation';
      $scope.searchPlaceholder = 'Search users in escalation';
      $scope.parentState = 'main.user.users.escalation';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[2];
      $scope.columns = escalationColumns;
    }
    else if (!!$state.current.name && $state.current.name.indexOf('add')> -1) {
      $scope.searchState = 'main.user.users.manage';
      $scope.searchPlaceholder = 'Search users';
      $scope.parentState = 'main.user.users.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
      $scope.columns = userColumns;
    }
    else if (!!$state.current.name && $state.current.name.indexOf('delegation')> -1) {
      $scope.searchState = 'main.user.users.delegation';
      $scope.searchPlaceholder = 'Search delegations';
      $scope.parentState = 'main.user.users.delegation';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[3];
      $scope.columns = delegationColumns;
    }
    else if (!!$state.current.name && $state.current.name.indexOf('onlineUsers')> -1) {
      $scope.searchState = 'main.user.users.manage';
      $scope.searchPlaceholder = 'Search users';
      $scope.parentState = 'main.user.users.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = onlineUsersTab;
      $scope.columns = userColumns;
    }
    else {
      $scope.searchState = 'main.user.users.manage';
      $scope.searchPlaceholder = 'Search users';
      $scope.parentState = 'main.user.users.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[0];
      $scope.columns = userColumns;
    }

    if(!!$state.params && !!$state.params.status){
      $scope.status = $state.params.status;
    }
    if(!!$state.params && !!$state.params.filter){
      $scope.searchFilter = $state.params.filter;
    }

    if(!!$state.params && !!$state.params.query){
      $scope.searchText = $state.params.query;
    }
    else{
      $scope.searchText = '';
    }
  }

  initialize();
}
UsersCtrl.$inject = ['$scope', '$state', 'Users', 'profile', '$rootScope', 'UserPermissions'];

angular
  .module('metabuyer')
  .controller('UsersCtrl', UsersCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider, pathConstants) {
    //TODO: rename the states from to 'users' to something more readable (Ahmed Saleh)
    $stateProvider
      .state('main.user.users', {
        url: '/users',
        controller: 'UsersCtrl',
        templateUrl: 'app/usersManagement/usersManagement.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            var check = false;
            if (!!profile.roles && profile.roles.length > 0) {
              for (var index in profile.roles) {
                if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
                  profile.roles[index].name.toLowerCase() === 'tenant_super_admin'){
                  check = true;
                }
              }
            }
            if (!check) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.users.search', {
        url: '/manage/search?{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        templateUrl: 'app/usersManagement/manage/manage.html',
        controller: 'UsersManageCtrl',
        resolve: {
          action: function () {
            return "search";
          },
          usersList: function ($q, searchModule, $stateParams, globalFunc, exportSearch) {
            var deferred = $q.defer();

            var params = {};
            var status = globalFunc.availableStatuses('users', $stateParams.status);

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User - search" + (!!$stateParams.query ? " - " + $stateParams.query : "");
          }
        }
      })
      .state('main.user.users.manage', {
        url: '/manage?{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        templateUrl: 'app/usersManagement/manage/manage.html',
        controller: 'UsersManageCtrl',
        resolve: {
          action: function ($stateParams) {
            if($stateParams.query){
              return 'search';
            }
            else{
              return 'show';
            }
          },
          usersList: function ($q, searchModule, $stateParams, globalFunc, exportSearch) {

            var status = globalFunc.availableStatuses('users', $stateParams.status);
            var deferred = $q.defer();
            var params = {};

            /**
             * First determine if search or listing
             */
            if(!!$stateParams.query){
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {

                var temp = 'criteria[' + $stateParams.filter + ']';
                params = {
                  module: 'users',
                  criteria_operator: !!$stateParams.status ? 'and' : null,
                  'criteria[1][status]': $stateParams.status !== 'all' ? status : null,
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                };

                if ($stateParams.type === 'date') {
                  temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[0][' + $stateParams.filter + ']'] = $stateParams.query;
                }

              }
              /**
               * If searching without filter
               */
              else {
                params = {
                  module: 'users',
                  'criteria[0][display_name]': $stateParams.query,
                  'criteria[0][email]': $stateParams.query,
                  'criteria[0][emp_no]': $stateParams.query,
                  'criteria[0][creator.display_name]': $stateParams.query,
                  'criteria[0][updater.display_name]': $stateParams.query,
                  'criteria[1][status]': $stateParams.status !== 'all' ? status : null,
                  'criteria[0][$operator]': !!$stateParams.query ? 'or' : null,
                  criteria_operator: !!$stateParams.query ? 'and' : null,
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                }
              }
            }
            /**
             * For listing
             */
            else{
              params = {
                module: 'users',
                'criteria[status]': $stateParams.status !== 'all' ? status : null,
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User - listing" + (!!$stateParams.status ? " - " + $stateParams.status : "");
          }
        }
      })
      .state('main.user.users.escalation', {
        url: '/escalation?{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        templateUrl: 'app/usersManagement/escalation/escalationTemplate.html',
        controller: 'usersEscalationCtrl',
        resolve: {
          usersList: function ($q, searchModule, $stateParams, exportSearch) {

            var deferred = $q.defer();
            var params = {
              module: 'user-superior',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: !!$stateParams.order_by ? $stateParams.order_by : 'user.display_name',
              order: !!$stateParams.order ? $stateParams.order : 1
            };

            /**
             * First determine if search or listing
             */
            if(!!$stateParams.query) {
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {
                params['criteria[' + $stateParams.filter + ']'] = $stateParams.query;
              }
              /**
               * Searching in all filters
               */
              else{
                params['criteria[user.display_name]'] = $stateParams.query;
                params['criteria[user.email]'] = $stateParams.query;
                params['criteria[superior.display_name]'] = $stateParams.query;
                params['criteria[superior.email]'] = $stateParams.query;
                params['criteria[company.descr]'] = $stateParams.query;
                params['criteria_operator'] = 'or';
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Escalation Listing";
          }
        }
      })
      .state('main.user.users.delegation', {
        url: '/delegation?{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        templateUrl: 'app/usersManagement/delegations/delegations.html',
        controller: 'usersDelegationCtrl',
        resolve: {
          delegationList: function ($q, searchModule, $stateParams) {

            var deferred = $q.defer();
            var params = {
              module: 'delegations',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * First determine if search or listing
             */
            if(!!$stateParams.query) {
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {

                if ($stateParams.type === 'date') {
                  var temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[0][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * Searching in all filters
               */
              else{
                params['criteria[0][user.display_name]'] = $stateParams.query;
                params['criteria[0][delegatee.display_name]'] = $stateParams.query;
                params['criteria[0][company_code]'] = $stateParams.query;
                params['criteria[0][company.descr]'] = $stateParams.query;
                params['criteria[0][reason]'] = $stateParams.query;
                params['criteria_operator'] = 'or';
              }
            }

            searchModule.get(params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Delegations Listing';
          }
        }
      })
      .state('main.user.users.onlineUsers', {
        url: '/online_users',
        templateUrl: 'app/usersManagement/onlineUsers/onlineUsersTemplate.html',
        controller: 'onlineUsersCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkUserSessionAccess(profile, 'C', $rootScope.changeWorkSpace)
              && !UserPermissions.checkUserSessionAccess(profile, 'U', $rootScope.changeWorkSpace)
              && !UserPermissions.checkUserSessionAccess(profile, 'D', $rootScope.changeWorkSpace)) {
              $state.go('notAuthorized');
            }
          },
          activeUsersList: function ($q, activeUsers) {
            var deferred = $q.defer();
            activeUsers.get(
              {
                session_id: 'active'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'all online users';
          }
        }
      })
      .state('main.user.users.add', {
        url: '/add-user',
        templateUrl: 'app/usersManagement/add/add.html',
        controller: 'UsersAddUserCtrl',
        resolve: {
          companiesForAdminUse: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order: 1,
                order_by: 'descr'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User-Mgmt - add - user";
          }
        }
      })
      .state('main.user.users.edit', {
        url: '/edit-user?{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/usersManagement/edit/edit.html',
        controller: 'UsersEditCtrl',
        resolve: {
          editedUser: function ($q, $stateParams, singleUser) {
            var deferred = $q.defer();
            singleUser.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companiesForAdminUse: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order: 1,
                order_by: 'descr'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User-Mgmt - edit" + (!!$stateParams.status ? " - " + $stateParams.status : "");
          }
        }
      })
      .state('main.user.users.import', {
        url: '/import-user',
        templateUrl: 'app/usersManagement/import/import.html',
        controller: 'UsersImportUserCtrl',
        resolve: {
          $title: function ($stateParams) {
            return "User-Mgmt - import - user";
          }
        }
      })
      .state('main.user.users.setting', {
        url: '/setting',
        templateUrl: 'app/usersManagement/settings/settings.html',
        controller: 'UsersSettingCtrl',
        resolve: {
          $title: function ($stateParams) {
            return "User-Mgmt - setting";
          }
        }
      })
      .state('main.user.users.detail', {
        url: '/{id:.+}',
        templateUrl: 'app/usersManagement/detail/detail.html',
        controller: 'UsersDetailCtrl',
        resolve: {
          profile: function ($q, $stateParams, singleUser) {
            var deferred = $q.defer();
            singleUser.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content.data);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User-Mgmt - details" + (!!$stateParams.status ? " - " + $stateParams.status : "");
          }
        }
      });
  }]);

'use strict';
/**
 * @name userCtrl
 * @desc The controller to load the user once logged in to the system
 */
function userCtrl($scope, reLoginService, $auth, $state, $rootScope, Account, toastr,
                  anTinycon, ManageLocalStorage, authenticated,
                  pathConstants, UserPermissions, profile, $interval, unreadNotificationList,
                  waitingOnUserList, budgetFunctions) {

  $rootScope.changeWorkSpace = changeWorkSpace;

  $rootScope.navOptions = {
    pr: {
      'key': 'main.user.purchaseRequisitions.manage',
      'title': 'Purchase Requisitions',
      'icon': 'fa-pr',
      'description': 'Purchase Requisitions',
      'status': !!$rootScope.isMobileMode ? 'pending' : 'draft',
      'extraFilterKey': !!$rootScope.isMobileMode ? 'criteria[waiting_on][]' : null,
      'extraFilterValue': !!$rootScope.isMobileMode ? profile._id : null,
      'tab': !!$rootScope.isMobileMode ? 'waiting' : 'all',
      'id': 'prSidebarIcon'
    },
    po: {
      'key': 'main.user.orders.manage',
      'title': 'Purchase Orders',
      'icon': 'fa-po',
      'description': 'Purchase Orders',
      'status': 'SUBMITTED',
      'id': 'poSidebarIcon'
    },
    suppliersListing: {
      'key': 'main.user.suppliersList.manage',
      'title': 'Suppliers List',
      'icon': 'fa-truck',
      'description': 'Suppliers List',
      'status': 'active',
      'id': 'suppliersListingSidebarIcon'
    },
    budget: {
      'key': 'main.user.budget.manage',
      'title': 'Budget',
      'icon': 'fa-budget',
      'description': 'Budget',
      'id': 'budgetSidebarIcon',
      'status': 'draft'
    },
    itemsManagement: {
      'key': 'main.user.items.manageCatalog',
      'title': 'Catalog',
      'icon': 'fa-th-list',
      'description': 'Catalog',
      'status': 'approved',
      'id': 'itemsSidebarIcon'
    },
    catalogItemView: {
      'key': 'main.user.catalogView.catalogItemList',
      'title': 'Catalog',
      'icon': 'fa-th-list',
      'description': 'Catalog',
      'id': 'viewCatalogItemsSidebarIcon'
    },
    exploreApps: {
      'key': 'main.user.explore-apps',
      'title': 'Explore Apps',
      'icon': 'fa-th',
      'description': 'Explore Apps'
    },
    more: {
      'key': 'main.user.more',
      'title': 'More',
      'icon': 'fa-ellipsis-v',
      'description': 'More',
      'id': 'moreSidebarIcon'
    },
    Companies: {
      'key': 'main.user.companiesMgmt.manageCompanies',
      'title': 'Companies',
      'icon': 'fa-user',
      'description': 'Companies',
      'id': 'companiesSidebarIcon'
    },
    Users: {
      'key': 'main.user.users.manage',
      'title': 'Users',
      'icon': 'fa-user',
      'description': 'Users',
      'status': 'active',
      'id': 'usersSidebarIcon'
    },
    supplier: {
      'key': 'main.user.suppliers.manage',
      'title': 'Suppliers',
      'icon': 'fa-user',
      'description': 'Suppliers',
      'status': 'active',
      'id': 'suppliersSidebarIcon'
    },
    masterData: {
      'key': '',
      'title': 'Master Data',
      'icon': 'fa-th-list',
      'description': 'Master Data',
      'status': '',
      'id': 'masterDataSidebarIcon'
    },
    approvalFlow: {
      'key': 'main.user.approvalFlow.manage',
      'title': 'Approval Flow',
      'icon': 'fa-th-list',
      'description': 'Approval Flow',
      'id': 'approvalFlowSidebarIcon'
    },
    security: {
      'key': 'main.user.security.manage',
      'title': 'Security',
      'icon': 'fa-users',
      'description': 'Security',
      'id': 'securitySidebarIcon'
    },
    settings: {
      'key': 'main.user.settings.mainPanel',
      'title': 'Settings',
      'icon': 'fa-cogs',
      'description': 'Settings',
      'id': 'settingsSidebarIcon'
    },
    reports: {
      'key': 'main.user.reports.generate',
      'title': 'Reports',
      'icon': 'fa-cogs',
      'description': 'Reports',
      'id': 'reportsSidebarIcon'
    },
    exports: {
      'key': 'main.user.exports.log',
      'title': 'Exports',
      'icon': 'fa-cogs',
      'description': 'Exports',
      'id': 'exportsSidebarIcon'
    },
    position: {
      'key': 'main.user.positionManagement.assign',
      'title': 'Position Management',
      'icon': 'fa-th-list',
      'description': 'Position Management',
      'id': 'positionSidebarIcon'
    },
    emails: {
      'key': 'main.user.emailLogs.emailLogsList',
      'title': 'Email Logs',
      'icon': 'fa-th-list',
      'description': 'Email Logs',
      'id': 'emailsSidebarIcon'
    }
  };

  /**
   * This function called to refresh the user Notifications list, the Interval can be changed if its too fast or too slow
   */
  var time = 180000;
  $scope.intervalPromise = $interval(loadWaitingsAndNotifications, time);

  function loadWaitingsAndNotifications() {
    if ($auth.isAuthenticated()) {
      //To get updated number of unread notifications per interval
      unreadNotificationList.get(
        {},
        function (resource) {
          if (!!resource.content) {
            if (!!resource.content.data && !!resource.content.data.length > 0) {
              $rootScope.notifications = resource.content;
              $rootScope.$broadcast('newNotifications');
            }
          }
        },
        function (error) {
          if (error.status === 404) {
          }
        }
      );

      //To get updated number of waiting on you per interval
      waitingOnUserList.get(
        {},
        function (resource) {
          if (!!resource.content) {
            $rootScope.waitings = resource.content;
            $rootScope.$broadcast('newWaitingList');
            $scope.nofifyWaitingOnFavico($rootScope.waitings);
          }
        },
        function (error) {
          if (error.status === 404) {
          }
        }
      );
    } else if (!!$rootScope.currentUser && !!$rootScope.currentUser.email) {
      var currentStateData = {
        name: $state.current.name,
        params: $state.params,
        url: $state.href($state.current.name, $state.params)
      };
      reLoginService(currentStateData, $rootScope.currentUser.email, 'The session has expired');
    }
  }
  // adding base path for user image
  $rootScope.userImageBasePath = pathConstants.apiUrls.image.user;

  // notify amount of items waiting on user on favico
  $scope.nofifyWaitingOnFavico = function (waitings) {
    if (!!waitings) {
      if (!!waitings.meta) {
        if (!!waitings.meta.cursor) {
          $scope.nofifyWaiting = waitings.meta.cursor.count;
          if ($scope.nofifyWaiting > 0) {
            anTinycon.bind($scope, 'nofifyWaiting');
          }
        }
      }
    }
    else {
      anTinycon.setBubble(0);
    }
  };
  $scope.nofifyWaitingOnFavico($rootScope.waitings);

  var resetActionButtonStates = function () {
    angular.forEach($scope.actions, function (action) {
      if (action.disabled) {
        action.disabled = false;
      }
    })
  };

  $rootScope.showDialog = false;

  //$scope.$on('actionsChanged', function (event, data) {
  //  $scope.actions = data;
  //});

  $rootScope.$on('$stateChangeSuccess', function () {
    resetActionButtonStates();
  });

  $rootScope.$on('$stateChangeError', function () {
    resetActionButtonStates();
  });


  //TODO: remove this hardcoding after getting support from backend (Ahmed Saleh, 10/3/2016)
  function checkUserRole(role){
    var userProfile = profile.roles;
    for (var index in userProfile) {
      if(userProfile.hasOwnProperty(index)){
        if (userProfile[index].name === role) {
          return true;
        }
      }
    }
    return false;
  }

  $scope.getProfile = function (companyWorkSpace) {
    var getNavLinkByRole = function () {
      var navLinks = {
        nonAdministrative: [],
        administrative: []
      };
      if (!!UserPermissions.checkPRAccess(profile, 'L', companyWorkSpace)) {
        navLinks.nonAdministrative.push($rootScope.navOptions.pr);
      }
      if (!!UserPermissions.checkPOAccess(profile, 'L', companyWorkSpace)) {
        navLinks.nonAdministrative.push($rootScope.navOptions.po);
      }
      if (!!UserPermissions.checkSupplierAccess(profile, 'L', companyWorkSpace) &&
        !!UserPermissions.checkSupplierAccess(profile, 'O', companyWorkSpace)) {
        navLinks.nonAdministrative.push($rootScope.navOptions.suppliersListing);
      }
      if ((!!UserPermissions.ImportItemSummary(profile, 'L', companyWorkSpace) &&
        !!UserPermissions.ImportItemSummary(profile, 'O', companyWorkSpace)) &&
        (!!UserPermissions.ImportItemDetail(profile, 'L', companyWorkSpace) &&
        !!UserPermissions.ImportItemDetail(profile, 'O', companyWorkSpace))) {
        navLinks.nonAdministrative.push($rootScope.navOptions.catalogItemView);
      }

      if (((!!UserPermissions.checkPermissionsAccess(profile, 'C', 'Budget') ||
        !!UserPermissions.checkPermissionsAccess(profile, 'L', 'Budget') ||
        !!UserPermissions.checkPermissionsAccess(profile, 'O', 'Budget') ||
        !!UserPermissions.checkPermissionsAccess(profile, 'U', 'Budget') ||
        !!UserPermissions.checkPermissionsAccess(profile, 'D', 'Budget') ||
        !!UserPermissions.checkPermissionsAccess(profile, 'A', 'Budget')) &&
        !!budgetFunctions.getHasBudgetSettingOn()) ||
        !!checkUserRole('TENANT_SUPER_ADMIN')) {
        navLinks.nonAdministrative.push($rootScope.navOptions.budget);
      }

      /**
       * list all the companies that a user can create a PR from
       * @type {Array}
       */
      $rootScope.listOfCompaniesForLoggedInUser = [];
      for(var i = 0; i < profile.companies.length; i++){
        if(!!UserPermissions.checkPRAccess(profile,'C',profile.companies[i].code)){
          $rootScope.listOfCompaniesForLoggedInUser.push(profile.companies[i]);
        }
      }

      //loading the admin panel
      //TODO: Clean up the permissions to access the panels later on this time its 'OR' for Create, Delete, Update (Ahmed Saleh)
      if (!!UserPermissions.ImportItemDetail(profile, 'C', companyWorkSpace) && !!UserPermissions.ImportItemDetail(profile, 'U', companyWorkSpace)
        && !!UserPermissions.ImportItemDetail(profile, 'D', companyWorkSpace) && !!UserPermissions.ImportItemSummary(profile, 'C', companyWorkSpace)
        && !!UserPermissions.ImportItemSummary(profile, 'D', companyWorkSpace) && !!UserPermissions.ImportItemSummary(profile, 'U', companyWorkSpace)) {
        navLinks.administrative.push($rootScope.navOptions.itemsManagement);
      }

      if ((!!UserPermissions.checkSupplierAccess(profile, 'C', companyWorkSpace) ||
        !!UserPermissions.checkSupplierAccess(profile, 'U', companyWorkSpace) ||
        !!UserPermissions.checkSupplierAccess(profile, 'D', companyWorkSpace)) || !!checkUserRole('TENANT_SUPER_ADMIN')) {
        navLinks.administrative.push($rootScope.navOptions.supplier);
      }
      /**
       * check makes sure that only add the first option of the master data to add the state with it so it transit to the correct tab
       */
      if (!!UserPermissions.checkCurrenciesAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkCurrenciesAccess(profile, 'U', companyWorkSpace)
        || !!UserPermissions.checkCurrenciesAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.currency';
          $rootScope.navOptions.masterData.status = 'currency';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if(!!UserPermissions.checkExpenseTypeAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkExpenseTypeAccess(profile, 'U', companyWorkSpace)
      || !!UserPermissions.checkExpenseTypeAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.expenseTypes';
          $rootScope.navOptions.masterData.status = 'expense_types';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if(!!UserPermissions.checkPaymentTermsAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkPaymentTermsAccess(profile, 'U', companyWorkSpace)
      || !!UserPermissions.checkPaymentTermsAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.paymentTerms';
          $rootScope.navOptions.masterData.status = 'payment_term';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if(!!UserPermissions.checkPaymentMethodAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkPaymentMethodAccess(profile, 'U', companyWorkSpace)
      || !!UserPermissions.checkPaymentMethodAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.paymentMethods';
          $rootScope.navOptions.masterData.status = 'payment_method';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if(!!UserPermissions.checkTaxesManagementAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkTaxesManagementAccess(profile, 'U', companyWorkSpace)
      || !!UserPermissions.checkTaxesManagementAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.taxes';
          $rootScope.navOptions.masterData.status = 'taxes';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if (!!UserPermissions.checkUOMAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkUOMAccess(profile, 'U', companyWorkSpace)
        || !!UserPermissions.checkUOMAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.uom';
          $rootScope.navOptions.masterData.status = 'uom';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }
      else if(
        !!UserPermissions.checkCommodityCodeAccess(profile, 'C', companyWorkSpace) || !!UserPermissions.checkCommodityCodeAccess(profile, 'U', companyWorkSpace)
        || !!UserPermissions.checkCommodityCodeAccess(profile, 'D', companyWorkSpace)) {
          $rootScope.navOptions.masterData.key = 'main.user.masterData.commodityCode';
          $rootScope.navOptions.masterData.status = 'commodity_code';
          navLinks.administrative.push($rootScope.navOptions.masterData);
      }

      if(!!UserPermissions.checkApprovalTemplateAccess(profile, 'C') &&
        !!UserPermissions.checkApprovalTemplateAccess(profile, 'L') &&
        !!UserPermissions.checkApprovalTemplateAccess(profile, 'O') &&
        !!UserPermissions.checkApprovalTemplateAccess(profile, 'U') &&
        !!UserPermissions.checkApprovalTemplateAccess(profile, 'D') && !checkUserRole('User')) {
        navLinks.administrative.push($rootScope.navOptions.approvalFlow);
        navLinks.administrative.push($rootScope.navOptions.position);
      }

      //TODO: once userPermissions are cleared up for exports, update here (Justin 4/5/2016)
      if(!!UserPermissions.checkExportLogAccess(profile, 'C') && !!UserPermissions.checkExportLogAccess(profile, 'L') &&
        !!UserPermissions.checkExportLogAccess(profile, 'O') && !!UserPermissions.checkExportLogAccess(profile, 'U') &&
        !!UserPermissions.checkExportLogAccess(profile, 'D') && !checkUserRole('User')) {
        navLinks.administrative.push($scope.navOptions.exports);
      }

      if(!!UserPermissions.checkReportLogAccess(profile, 'C') && !!UserPermissions.checkReportLogAccess(profile, 'L') &&
        !!UserPermissions.checkReportLogAccess(profile, 'O') && !!UserPermissions.checkReportLogAccess(profile, 'U') &&
        !!UserPermissions.checkReportLogAccess(profile, 'D') && !checkUserRole('User')) {
        navLinks.administrative.push($scope.navOptions.reports);
      }

      if(!!profile.roles && profile.roles.length > 0) {
        for (var index in profile.roles) {
          if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
            profile.roles[index].name.toLowerCase() === 'tenant_super_admin') {
            //FIXME: this is temporally until we get the security roles for the settings (Ahmed Saleh 17/2/2016)
            navLinks.administrative.push($scope.navOptions.settings);
            /**
             * Companies, Users and Security do not have permissions, so only available for the ADMIN user
             */
            navLinks.administrative.push($rootScope.navOptions.Users);
            navLinks.administrative.push($rootScope.navOptions.Companies);
            navLinks.administrative.push($scope.navOptions.security);
            navLinks.administrative.push($rootScope.navOptions.emails);

            break;
          }
        }
      }

      return navLinks;
    };
    if (!!authenticated && !$rootScope.isMobileMode) {
      $rootScope.navlinks = {};
      $rootScope.navlinks = getNavLinkByRole();
      $scope.user = profile;
    }

    if(!!authenticated && $rootScope.isMobileMode){
      $rootScope.navlinks = {};
      $rootScope.navlinks.nonAdministrative = [];
      if (!!UserPermissions.checkPRAccess(profile, 'L', companyWorkSpace)) {
        $rootScope.navlinks.nonAdministrative.push($rootScope.navOptions.pr);
      }
      if (!!UserPermissions.checkPOAccess(profile, 'L', companyWorkSpace)) {
        $rootScope.navlinks.nonAdministrative.push($rootScope.navOptions.po);
      }
      $scope.user = profile;
    }
  };


  $scope.isSidebarCollapsed = function () {
    return angular.element('body').hasClass('mini-navbar');
  };

  $scope.isProfileDropdownOpen = function () {
    return angular.element('.profile-element').hasClass('open');
  };

  $scope.getProfile($scope.companyWorkSpace);


  if ($state.current.name === 'main') {
    $state.go('main.user.mainMenu.waiting-on-you');
  }

  var unwatchSidebar = $rootScope.$watch(
    function () {
      // also check against 'pace-done' class in body
      // to ensure the animation only starts after all other stuffs are loaded
      // otherwise it would be too quick and the animation would not be smooth
      var body = $('body');
      return $('.navbar-minimalize') && body.hasClass('pace-done') && body.hasClass('mini-navbar');
    },
    function (newValue, oldValue) {
      if (newValue === true) {
        unwatchSidebar();
      }
    });

  $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
    event.preventDefault();//prevent file from uploading
  });
  function changeWorkSpace(newCompany) {
    window.localStorage.setItem('workSpace', JSON.stringify(newCompany));
    $rootScope.companyWorkSpace = newCompany;
    //TODO: for now the user will be in the same page, only reload, this could be enhanced later (Ahmed Saleh)
    if ($state.current.name === 'main.user.mainMenu.waiting-on-you') {
      //TODO: need to figure out what do if the workspace changed in the main page ! (Ahmed Saleh)
      //$state.reload();
    }
    else {
      $state.go('main.user.mainMenu.waiting-on-you');
    }
  }
  $rootScope.bodyClasses = '';
  $('body').addClass('mini-navbar');
  loadWaitingsAndNotifications();
}

userCtrl.$inject = [
  '$scope', 'reLoginService', '$auth', '$state', '$rootScope', 'Account', 'toastr',
  'anTinycon', 'ManageLocalStorage', 'authenticated', 'pathConstants',
  'UserPermissions', 'profile', '$interval', 'unreadNotificationList', 'waitingOnUserList', 'budgetFunctions'
];

angular.module('metabuyer')
  .controller('userCtrl', userCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user', {
        url: 'user',
        abstract: true,
        controller: 'userCtrl',
        template: '<ui-view></ui-view>',
        resolve: {
          profile: function ($q, userSettings, $state, $filter, $rootScope, updateProfile, $auth, $location, toastr, Rollbar) {
            var deferred = $q.defer();

            /**
             * check the authentication and store the url for redirection after a successful login
             * redirect the user to Login page
             */
            if (!$auth.isAuthenticated()) {
              $rootScope.redirectUrl = $location.url();
              $state.go('login');
            }

            /**
             * loading the user profile
             */
            updateProfile.get({},
              function (resource) {
              if (!!resource.content && !!resource.content.data) {
                /**
                 * store the user in the rootScope
                 * store the user in the Rollbar configuration
                 */
                $rootScope.currentUser = resource.content.data;

                  Rollbar.configure({
                    payload: {
                      person: {
                        id: $rootScope.currentUser._id,
                        username: $rootScope.currentUser.display_name,
                        email: $rootScope.currentUser.email
                      }
                    }
                  });

                  /**
                   * checking if the workspace has been selected and saved
                   */
                  if (!JSON.parse(window.localStorage.getItem('workSpace'))) {
                    if (!resource.content.data.default_company) {
                      $rootScope.companyWorkSpace = resource.content.data.companies[0];
                    }
                    else {
                      $rootScope.companyWorkSpace = resource.content.data.default_company;
                    }
                  }
                  else {
                    $rootScope.companyWorkSpace = JSON.parse(window.localStorage.getItem('workSpace'));
                  }

                  deferred.resolve(resource.content.data);
                } else {
                  Rollbar.error('an error occurred while logging in, user info: ' + $auth.getPayload());
                  toastr.info('an error occurred');
                  userSettings.loggedOut();
                  $state.go('login');
                }
              },
              function (error) {
                //failed to get profile information, console logging to get the data.
                console.log(data);
                console.log(status);
                console.log(headers);
                console.log(config);
              });

            return deferred.promise;
          }
        }
      })
    .state('main.user.mainMenu', {
        url: '',
        templateUrl: 'app/user/mainMenu/mainMenuTemplate.html',
        controller: 'mainMenuCtrl',
        abstract: true
    })
      .state('main.user.mainMenu.waiting-on-you', {
        url: '/waiting-on-you?{cursor:[^~,]}',
        template: '<div ng-include="waitingTemplate"></div>',
        controller: 'UserWaitingOnYouCtrl',
        resolve: {
          waitingList: function ($q, waitingOnUserList, $stateParams, $rootScope) {
            var deferred = $q.defer();
            waitingOnUserList.get(
              {
                cursor: $stateParams.cursor
              },
              function (resource) {
                if (!!resource.content) {
                  $rootScope.waitings = resource.content;
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "User - waiting on you";
          },
          findTemplate: function ($rootScope) {
            $rootScope.waitingTemplate = $rootScope.isMobileMode ? 'app/user/waiting-on-you/waiting-on-you-mobile.html'
              : 'app/user/waiting-on-you/waiting-on-you.html';
          }
        }
      })
      .state('main.user.mainMenu.notifications', {
        url: '/notifications?{subTab:[a-zA-Z0-9]+}&{cursor:[^~,]}',
        templateUrl: 'app/user/notifications/notifications.html',
        controller: 'UserNotificationsCtrl',
        resolve: {
          notificationListing : function ($q, unreadNotificationList, notificationList, $stateParams) {
            if (!$stateParams.subTab) {
              $stateParams.subTab = 'unread';
            }
            var deferred = $q.defer();
            if($stateParams.subTab == 'all'){
              notificationList.get(
                {
                  cursor: $stateParams.cursor
                },
                function (resource) {
                  if (!!resource.content) {
                    deferred.resolve(resource.content);
                  }
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
            }
            else if($stateParams.subTab == 'unread'){
              unreadNotificationList.get(
                {
                  offset: 1000
                },
                function (resource) {
                  if (!!resource.content) {
                    deferred.resolve(resource.content);
                  }
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
            }

            return deferred.promise;
          },
          $title: function($stateParams){
            return "User - notifications";
          }
        }
      })
      .state('main.user.mainMenu.userProfile', {
        url: '/profile',
        templateUrl: 'app/user/settings/userProfile/userProfileTemplate.html',
        controller: 'userProfileCtrl',
        resolve: {
          $title: function($stateParams){
            return "User - profile";
          }
        }
      })
  }]);

'use strict';

function suppliersCtrl($scope, UserPermissions, profile, $state) {
  $scope.tabData = [
    {
      heading: 'Manage Suppliers',
      route: 'main.user.suppliers.manage',
      key: 'suppliers',
      id: 'manageSuppliersTab',
      menu: [
        {
          heading: 'All',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'allSuppliersTab',
          params: {
            status: 'all',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Draft',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'draftSuppliersTab',
          params: {
            status: 'draft',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Active',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'activeSuppliersTab',
          params: {
            status: 'active',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Pending Approval',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'pendingSuppliersTab',
          params: {
            status: 'pending',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Blacklisted',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'blacklistedSuppliersTab',
          params: {
            status: 'black_listed',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Rejected',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'rejectedSuppliersTab',
          params: {
            status: 'rejected',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Withdrawn',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'withdrawnSuppliersTab',
          params: {
            status: 'withdrawn',
            cursor: null,
            order_by: 'descr',
            order: 1,
            query: null,
            filter: null
          }
        },
        {
          heading: 'Inactive',
          route: 'main.user.suppliers.manage',
          key: 'suppliers',
          id: 'inactiveSuppliersTab',
          params: {
            status: 'inactive',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    },
    {
      heading: 'Suppliers Group',
      route:  'main.user.suppliers.supplierGroups',
      key: 'supplierGroups',
      id: 'supplierGroupsTab',
      menu: [
        {
          heading: 'Global Suppliers',
          route:  'main.user.suppliers.supplierGroupDetail',
          key: 'supplierGroups',
          id: 'globalSuppliersTab',
          params:{
            bu_code: 'Global',
            status: 'all',
            order_by: 'descr',
            order: 1,
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Supplier Business Units',
          route:  'main.user.suppliers.supplierGroups',
          key: 'supplierGroups',
          id: 'supplierBusinessUnitsTab',
          params:{
            order_by: 'code',
            order: 1,
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Companies Tagged to Supplier',
          route: 'main.user.suppliers.tagsBySupplier',
          key: 'supplierGroups',
          params: {
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Suppliers Tagged to Company',
          route: 'main.user.suppliers.tagsByCompany',
          key: 'supplierGroups',
          params: {
            order_by: 'descr',
            order: 1,
            cursor: null,
            filter: null,
            query: null
          }
        }
      ]
    }
  ];

  /**
   * Tab for creating suppliers, check user permissions
   */
  if (!!UserPermissions.checkSupplierAccess(profile, 'C')) {
    var addSupplierTab = {
      heading: 'Add Suppliers',
      route: 'main.user.suppliers.newSupplier',
      key: 'createSupplier',
      id: 'addSupplierTab',
      menu: [
        {
          heading: 'Create Single Supplier',
          route:  'main.user.suppliers.newSupplier',
          key: 'createSupplier',
          id: 'createSupplierTab',
          params:{
            status: 'addNew',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Upload Suppliers',
          route:  'main.user.suppliers.import',
          key: 'createSupplier',
          id: 'importSupplierTab',
          params:{
            status: 'import',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    };
    $scope.tabData.push(addSupplierTab);
  }

  /**
   * Tab for supplier tagging, checks the permissions of the user
   */
  if (!!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') &&
    !!UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag')) {
    var supplierTagTab = {
      heading: 'Supplier Tagging',
      route: 'main.user.suppliers.supplierTagging',
      key: 'supplierTagging',
      id: 'supplierTaggingTab',
      params: {
        status: 'tag',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    };
    $scope.tabData.push(supplierTagTab);
  }

  function initialize(){

    if(!!$state.current.name && $state.current.name.indexOf('supplierGroups') > -1){
      $scope.columns = supplierGroupColumns;
      $scope.searchPlaceholder = 'Search Supplier Business Units';
      $scope.searchState = 'main.user.suppliers.supplierGroups';
      $scope.parentState = 'main.user.suppliers.supplierGroups';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierGroupDetail') > -1){
      $scope.columns = supplierByGroupColumns;
      $scope.searchPlaceholder = 'Search Suppliers in Business Unit';
      $scope.searchState = 'main.user.suppliers.supplierGroupDetail';
      $scope.parentState = 'main.user.suppliers.supplierGroupDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('tagsBySupplier')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.tagsBySupplier';
      $scope.parentState = 'main.user.suppliers.tagsBySupplier';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagsBySupplierDetail')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies Tagged to Supplier';
      $scope.searchState = 'main.user.suppliers.supplierTagsBySupplierDetail';
      $scope.parentState = 'main.user.suppliers.supplierTagsBySupplierDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('tagsByCompany')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies';
      $scope.searchState = 'main.user.suppliers.tagsByCompany';
      $scope.parentState = 'main.user.suppliers.tagsByCompany';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagsByCompanyDetail')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers Tagged to Company';
      $scope.searchState = 'main.user.suppliers.supplierTagsByCompanyDetail';
      $scope.parentState = 'main.user.suppliers.supplierTagsByCompanyDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagging') > -1){
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.manage';
      $scope.parentState = 'main.user.suppliers.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[3];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('import') > -1){
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.manage';
      $scope.parentState = 'main.user.suppliers.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[2];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('newSupplier') > -1){
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.manage';
      $scope.parentState = 'main.user.suppliers.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[2];
    }
    else{
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.manage';
      $scope.parentState = 'main.user.suppliers.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[0];
    }

    if(!!$state.params && !!$state.params.query){
      $scope.searchText = $state.params.query;
    }
    else{
      $scope.searchText = '';
    }

    if(!!$state.params && !!$state.params.status){
      $scope.status = $state.params.status
    }
    if(!!$state.params && !!$state.params.filter){
      $scope.searchFilter = $state.params.filter;
    }
  }

  var supplierColumns = [
    {id: 'check box', title: '', unsortable: true, unsearchable: true, conditional: true, condition: ['pending'], unSelectable: true},
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'blacklisted_by', label: 'Blacklisted By', conditional: true, condition: 'black_listed'},
    {id: 'blacklisted_reason', label: 'Blacklisting Reason', conditional: true, condition: 'black_listed'},
    {id: 'submittedFrom', label: 'Submitted From', conditional: true, condition: 'black_listed'},
    {id: 'status', label: 'Status', conditional: true, condition: 'all'}
  ];

  var supplierByGroupColumns = [
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'bu_status', label: 'Status', unsearchable: true, unsortable: true,
      conditional: true, condition: 'all'}
  ];

  var supplierGroupColumns = [
    {id: 'code', label: 'Code'},
    {id: 'descr', label: 'Description'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'}
  ];

  var supplierTagsBySupplierColumns = [
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'status', label: 'Supplier Status'}
  ];

  var supplierTagsByCompanyColumns = [
    {id: 'descr', label: 'Company Name'},
    {id: 'code', label: 'Company Code'},
    {id: 'reg_no', label: 'Registration Code'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'business_unit.descr', label: 'Business Unit'},
    {id: 'industry.descr', label: 'Industry'},
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    }
  ];

  /**
   * making sure the Stats and placeHolder changes if the Child scope changed
   */
  $scope.$on('$stateChangeStart', function( event, data, toParams ) {
    if(!!data.name && data.name.indexOf('supplierGroups')> -1){
      $scope.columns = supplierGroupColumns;
      $scope.searchPlaceholder = 'Search Supplier Business Units';
      $scope.searchState = 'main.user.suppliers.supplierGroups';
      $scope.parentState = 'main.user.suppliers.supplierGroups';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierGroupDetail')> -1){
      $scope.columns = supplierByGroupColumns;
      $scope.searchPlaceholder = 'Search Suppliers in Business Units';
      $scope.searchState = 'main.user.suppliers.supplierGroupDetail';
      $scope.parentState = 'main.user.suppliers.supplierGroupDetail';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('tagsBySupplier')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.tagsBySupplier';
      $scope.parentState = 'main.user.suppliers.tagsBySupplier';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierTagsBySupplierDetail')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies Tagged to Supplier';
      $scope.searchState = 'main.user.suppliers.supplierTagsBySupplierDetail';
      $scope.parentState = 'main.user.suppliers.supplierTagsBySupplierDetail';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('tagsByCompany')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies';
      $scope.searchState = 'main.user.suppliers.tagsByCompany';
      $scope.parentState = 'main.user.suppliers.tagsByCompany';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierTagsByCompanyDetail')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers Tagged to Company';
      $scope.searchState = 'main.user.suppliers.supplierTagsByCompanyDetail';
      $scope.parentState = 'main.user.suppliers.supplierTagsByCompanyDetail';
      $scope.parentStateParams = $state.params;
    }
    else{
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliers.manage';
      $scope.parentState = 'main.user.suppliers.manage';
      $scope.parentStateParams = $state.params;
    }
    if(!!toParams.status){
      $scope.parentStateParams = toParams;
    }
  });

  initialize();

  $scope.$emit('pageTitleChanged', 'Manage Suppliers');
  //TODO: have this cleaned up with better engineering solution (Ahmed Saleh)
  $scope.$emit('actionsChanged', []);

}
suppliersCtrl.$inject = ['$scope', 'UserPermissions', 'profile', '$state'];

angular.module('metabuyer')
  .controller('suppliersCtrl', suppliersCtrl);


'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider) {

    $stateProvider
      .state('main.user.suppliers', {
        url: '/suppliers',
        controller: 'suppliersCtrl',
        templateUrl: 'app/suppliersManagement/suppliersManagement.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkSupplierAccess(profile, 'U')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.suppliers.manage', {
        templateUrl: 'app/suppliersManagement/manage/manage.html',
        url: '/manage?{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&' +
        '{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'suppliersManageCtrl',
        resolve: {
          action: function ($stateParams) {
            if ($stateParams.query) {
              return 'search';
            }
            else {
              return 'show';
            }
          },
          suppliers: function ($q, $state, $stateParams, Orders, authenticated, searchModule, globalFunc,
                               supplierGlobalFunc, exportSearch) {
            var deferred = $q.defer();
            var status = supplierGlobalFunc.getSupplierListStatus($stateParams.status);
            var statusWithoutArchiveOf = ['draft', 'pending', 'withdraw'];

            var params = {
              module: 'suppliers',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: !!$stateParams.order_by ? $stateParams.order_by : 'descr',
              order: !!$stateParams.order ? $stateParams.order : 1
            };

            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }

            /**
             * First determine if search or listing
             */
            if (!!$stateParams.query) {
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {

                params['criteria_operator'] = 'and';

                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[0][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * If searching without filter
               */
              else {
                params['criteria_operator'] = !!$stateParams.query ? 'and' : null;
                params['criteria[0][descr]'] = $stateParams.query;
                params['criteria[0][mb_supplier_code]'] = $stateParams.query;
                params['criteria[0][reg_no]'] = $stateParams.query;
                params['criteria[0][email]'] = $stateParams.query;
                params['criteria[0][contact_person.first_name]'] = $stateParams.query;
                params['criteria[0][contact_person.email]'] = $stateParams.query;
                params['criteria[0][primary_business_nature]'] = $stateParams.query;
                params['criteria[0][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[0][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[0][currency_code]'] = $stateParams.query;
                params['criteria[0][creator.display_name]'] = $stateParams.query;
                params['criteria[0][updater.display_name]'] = $stateParams.query;
                params['criteria[0][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
              if (!!status && !!status.length) {
                if (status[0] !== '*')
                  params['criteria[1][status]'] = status[0];

                if (status[1] !== '*')
                  params['criteria[1][approval_status]'] = status[1];

                if (status[2] !== '*')
                  params['criteria[1][draft_status]'] = status[2];
              }
              else if ($stateParams.status === 'all') {
                params['criteria[1][status]'] = null;
                params['criteria[1][approval_status]'] = null;
                params['criteria[1][draft_status]'] = null;
              }
              // to exclude archived supplier
              if (statusWithoutArchiveOf.indexOf($stateParams.status) === -1) {
                params['criteria[1][archive_of]'] = '';
              }
            }
            /**
             * For listing
             */
            else {

              if (!!status && !!status.length) {
                if (status[0] !== '*') {
                  params['criteria[0][status]'] = status[0];
                }

                if (status[1] !== '*') {
                  params['criteria[0][approval_status]'] = status[1];
                }

                if (status[2] !== '*') {
                  params['criteria[0][draft_status]'] = status[2];
                }
              }
              else if ($stateParams.status === 'all') {
                params['criteria[0][status]'] = null;
                params['criteria[0][approval_status]'] = null;
                params['criteria[0][draft_status]'] = null;
              }

              // to exclude archived supplier
              if (statusWithoutArchiveOf.indexOf($stateParams.status) === -1) {
                params['criteria[0][archive_of]'] = '';
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve({data: []});
                }
              },
              function (error) {
              }
            );

            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - listing' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })

      /**
       * State to list supplier groups a.k.a. business units
       */
      .state('main.user.suppliers.supplierGroups', {
        templateUrl: 'app/suppliersManagement/supplierGroups/manage/manage.html',
        url: '/supplierGroups?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&' +
        '{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierGroupsCtrl',
        resolve: {
          dataList: function ($q, searchModule, $stateParams) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'business-units',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Supplier Groups';
          }
        }
      })

      /**
       * State to list suppliers by a specific supplier group / global supplier
       */
      .state('main.user.suppliers.supplierGroupDetail', {
        templateUrl: 'app/suppliersManagement/supplierGroups/detail/detail.html',
        url: '/supplierGroups/detail?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&' +
        '{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}&' +
        '{bu_code:[a-zA-Z0-9]+}&{bu_descr:[a-zA-Z0-9]+}&{status:[a-zA-Z0-9]+}',
        controller: 'supplierGroupDetailCtrl',
        resolve: {
          suppliersByGroup: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();
            var params = {
              module: 'suppliers',
              'criteria[1][approval_status]': 1,
              'criteria[1][archive_of]': '',
              'criteria[1][draft_status]': 3,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * First determine if search or listing
             */
            if (!!$stateParams.query) {
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {

                params['criteria_operator'] = 'and';

                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[2][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[2][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * If searching without filter
               */
              else {
                params['criteria_operator'] = !!$stateParams.query ? 'and' : null;
                params['criteria[2][descr]'] = $stateParams.query;
                params['criteria[2][mb_supplier_code]'] = $stateParams.query;
                params['criteria[2][reg_no]'] = $stateParams.query;
                params['criteria[2][email]'] = $stateParams.query;
                params['criteria[2][contact_person.first_name]'] = $stateParams.query;
                params['criteria[2][contact_person.email]'] = $stateParams.query;
                params['criteria[2][primary_business_nature]'] = $stateParams.query;
                params['criteria[2][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[2][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[2][currency_code]'] = $stateParams.query;
                params['criteria[2][creator.display_name]'] = $stateParams.query;
                params['criteria[2][updater.display_name]'] = $stateParams.query;
                params['criteria[2][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            var bu_param = 'criteria[0][bu_status|' + $stateParams.bu_code + '|status]';

            /**
             * Check if selected business unit or global
             * Switch case to handle the bu status params
             */
            if ($stateParams.bu_code.toLowerCase() !== 'global') {
              /**
               * Params for business unit status
               */
              switch ($stateParams.status) {
                case 'all':
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][0]'] = 1;
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][1]'] = 2;
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][2]'] = 6;
                  params['criteria[0][$operator]'] = 'or';
                  break;
                case 'active':
                  params[bu_param] = 1;
                  break;
                case 'black_listed':
                  params[bu_param] = 2;
                  break;
                case 'inactive':
                  params[bu_param] = 6;
                  break;
              }
            }
            else {
              /**
               * Params for global suppliers
               */
              params['criteria[0][is_global_supplier]'] = 'true';
              switch ($stateParams.status) {
                case 'all':
                  break;
                case 'active':
                  params['criteria[0][status]'] = 1;
                  params['criteria[0][$operator]'] = 'and';
                  break;
                case 'black_listed':
                  params['criteria[0][status]'] = 2;
                  params['criteria[0][$operator]'] = 'and';
                  break;
                case 'inactive':
                  params['criteria[0][status]'] = 6;
                  params['criteria[0][$operator]'] = 'and';
                  break;
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Supplier Business Unit - Supplier Listing';
          }
        }
      })
      .state('main.user.suppliers.import', {
        templateUrl: 'app/suppliersManagement/import/suppliersImportTemplate.html',
        url: '/import',
        controller: 'suppliersItemsCtrl',
        resolve: {
          $title: function ($stateParams) {
            return 'Supplier - Import Supplier';
          }
        }
      })
      .state('main.user.suppliers.newSupplier', {
        templateUrl: 'app/suppliersManagement/newSupplier/newSupplier.html',
        url: '/newSupplier',
        controller: 'newSupplierCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkSupplierAccess(profile, 'C')) {
              $state.go('notAuthorized');
            }
          },
          taxes: function (searchModule, $q) {
            var deferred = $q.defer();
            if (!JSON.parse(window.localStorage.getItem('taxes'))) {
              searchModule.get(
                {
                  module: 'tax',
                  offset: 0
                },
                function (resource) {
                  if (!!resource.content && !!resource.content.data) {
                    deferred.resolve(resource.content.data);
                    window.localStorage.setItem('taxes', JSON.stringify(resource.content.data));
                  }
                  else {
                    deferred.resolve([]);
                  }
                },
                function () {
                  deferred.resolve([]);
                }
              );
            } else {
              deferred.resolve(JSON.parse(window.localStorage.getItem('taxes')));
            }
            return deferred.promise;
          },
          paymentMethods: function (searchModule, $q) {
            var deferred = $q.defer();
            //load the paymentMethods
            if (!JSON.parse(window.localStorage.getItem('paymentMethods'))) {
              searchModule.get(
                {
                  module: 'payment-method',
                  offset: 0
                },
                function (resource) {
                  if (!!resource && !!resource.content) {
                    deferred.resolve(resource.content);
                    window.localStorage.setItem('paymentMethods', JSON.stringify(resource.content));
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
              return deferred.promise;
            }
            else {
              return JSON.parse(window.localStorage.getItem('paymentMethods'));
            }
          },
          paymentTerms: function (searchModule, $q) {
            var deferred = $q.defer();
            //load the paymentTerms
            searchModule.get(
              {
                module: 'payment-term',
                'criteria[is_active]': 1,
                offset: 0
              },
              function (resource) {
                if (!!resource && !!resource.content) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                deferred.resolve([]);
              });
            return deferred.promise;
          },
          currencies: function ($stateParams, $q, searchModule) {
            var deferred = $q.defer();

            if (!!JSON.parse(window.localStorage.getItem('currencies')) && !!JSON.parse(window.localStorage.getItem('currencies')).length) {
              deferred.resolve(JSON.parse(window.localStorage.getItem('currencies')));
            } else {
              searchModule.get(
                {
                  module: 'currencies',
                  offset: 0
                },
                function (resource) {
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    window.localStorage.setItem('currencies', JSON.stringify(resource.content.data));
                    deferred.resolve(resource.content.data);
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
            }

            return deferred.promise;
          },
          commodities: function ($q, listChild) {
            var deferred = $q.defer();

            listChild.get(
              {
                code: 'All'
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                }
                else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - New Supplier' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })
      .state('main.user.suppliers.detail', {
        templateUrl: 'app/suppliersManagement/detail/detail.html',
        url: '/detail?{id:[a-zA-Z0-9]+}',
        controller: 'supplierDetailCtrl',
        resolve: {
          supplier: function ($q, $state, $stateParams, $filter, authenticated, singleSupplier, $rootScope, toastr) {
            var deferred = $q.defer();
            singleSupplier.get(
              {id: $stateParams.id},
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content.data);
                } else {
                  deferred.resolve({});
                }
              },
              function (error) {
                toastr.error('Supplier not found');
                $state.go($rootScope.previousState.name, $rootScope.previousState.params);
              }
            );
            return deferred.promise;
          },
          taxes: function (searchModule, $q) {
            var deferred = $q.defer();
            if (!JSON.parse(window.localStorage.getItem('taxes'))) {
              searchModule.get(
                {
                  module: 'tax',
                  offset: 0
                },
                function (resource) {
                  if (!!resource.content && !!resource.content.data) {
                    deferred.resolve(resource.content.data);
                    window.localStorage.setItem('taxes', JSON.stringify(resource.content.data));
                  }
                  else {
                    deferred.resolve([]);
                  }
                },
                function () {
                  deferred.resolve([]);
                }
              );
            }
            else {
              deferred.resolve(JSON.parse(window.localStorage.getItem('taxes')));
            }
            return deferred.promise;
          },
          paymentMethods: function (searchModule, $q) {
            var deferred = $q.defer();
            //load the paymentMethods
            if (!JSON.parse(window.localStorage.getItem('paymentMethods'))) {
              searchModule.get(
                {
                  module: 'payment-method',
                  offset: 0
                },
                function (resource) {
                  if (!!resource && !!resource.content) {
                    deferred.resolve(resource.content);
                    window.localStorage.setItem('paymentMethods', JSON.stringify(resource.content));
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
              return deferred.promise;
            }
            else {
              return JSON.parse(window.localStorage.getItem('paymentMethods'));
            }
          },
          paymentTerms: function (searchModule, $q) {
            var deferred = $q.defer();
            //load the paymentTerms
            searchModule.get(
              {
                module: 'payment-term',
                'criteria[is_active]': 1,
                offset: 0
              },
              function (resource) {
                if (!!resource && !!resource.content) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                deferred.resolve([]);
              });
            return deferred.promise;
          },
          currencies: function ($stateParams, $q, searchModule) {
            var deferred = $q.defer();

            if (!!JSON.parse(window.localStorage.getItem('currencies'))) {
              deferred.resolve(JSON.parse(window.localStorage.getItem('currencies')));
            } else {
              searchModule.get(
                {
                  module: 'currencies',
                  offset: 0
                },
                function (resource) {
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    window.localStorage.setItem('currencies', JSON.stringify(resource.content.data));
                    deferred.resolve(resource.content.data);
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
            }

            return deferred.promise;
          },
          commodities: function ($q, listChild) {
            var deferred = $q.defer();

            listChild.get(
              {
                code: 'All'
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                }
                else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Details' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })
      .state('main.user.suppliers.supplierTagging', {
        templateUrl: 'app/suppliersList/supplierTagging/supplierTagging-template.html',
        url: '/SupplierTagging?{companyCode:[a-zA-Z0-9]+}',
        controller: 'supplierTaggingCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') ||
              !UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag')) {
              $state.go('notAuthorized');
            }
          },
          companiesList: function ($q, searchModule, authenticated) {
            var deferred = $q.defer();

            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }

            searchModule.get(
              {
                module: 'companies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          // Resolve the suppliers list for ui-select multiple
          suppliersList: function ($q, suppliersActiveList) {
            var deferred = $q.defer();

            /**
             * Setting list of active suppliers to local storage to reduce loading times
             */
            if (!!JSON.parse(window.localStorage.getItem('activeSuppliersForTagging'))) {
              deferred.resolve(JSON.parse(window.localStorage.getItem('activeSuppliersForTagging')));
            }
            else {
              suppliersActiveList.get(
                {},
                function (resource) {
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    var tempList = [];
                    _.forEach(resource.content.data, function (supplier) {
                      tempList.push({
                        _id: supplier._id,
                        descr: supplier.descr,
                        mb_supplier_code: supplier.mb_supplier_code
                      });
                    });
                    window.localStorage.setItem('activeSuppliersForTagging', JSON.stringify(tempList));
                    deferred.resolve(tempList);
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
            }
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Tag Suppliers';
          }
        }
      })
      // TODO: rethink of a better state name to describe these lists (Justin 25/5/17)
      .state('main.user.suppliers.tagsBySupplier', {
        templateUrl: 'app/suppliersList/supplierTagsBySupplier/manage/manage.html',
        url: '/tagsBySupplier?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsBySupplierCtrl',
        resolve: {
          detailState: function () {
            return 'main.user.suppliers.supplierTagsBySupplierDetail';
          },
          suppliersList: function ($q, searchModule, authenticated, $stateParams) {
            var deferred = $q.defer();

            var params = {
              module: 'suppliers',
              'criteria[0][archive_of]': '',
              'criteria[0][draft_status]': 3,
              'criteria[0][status]': 1,
              'criteria[0][$operator]': 'and',
              'criteria[0][approval_status]': 1,
              criteria_operator: 'and',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }

            if (!!$stateParams.query) {

              if (!!$stateParams.filter) {
                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = $stateParams.query;
                params['criteria[1][mb_supplier_code]'] = $stateParams.query;
                params['criteria[1][reg_no]'] = $stateParams.query;
                params['criteria[1][email]'] = $stateParams.query;
                params['criteria[1][contact_person.first_name]'] = $stateParams.query;
                params['criteria[1][contact_person.email]'] = $stateParams.query;
                params['criteria[1][primary_business_nature]'] = $stateParams.query;
                params['criteria[1][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][currency_code]'] = $stateParams.query;
                params['criteria[1][creator.display_name]'] = $stateParams.query;
                params['criteria[1][updater.display_name]'] = $stateParams.query;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Supplier List';
          }
        }
      })
      .state('main.user.suppliers.supplierTagsBySupplierDetail', {
        templateUrl: 'app/suppliersList/supplierTagsBySupplier/detail/detail.html',
        url: '/supplierTagsBySupplierDetail?{supplierCode:[a-zA-Z0-9]+}&{supplierName:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsBySupplierDetailCtrl',
        resolve: {
          supplierName: function ($stateParams) {
            return $stateParams.supplierName;
          },
          companiesTaggedToSupplier: function ($q, searchModule, getTagsBySupplierCode, exportSearch, $stateParams) {
            var deferred = $q.defer();

            /**
             * Setting the params to prepare for exporting
             */
            var exportParams = {
              module: 'supplier-tags',
              'criteria[supplier_code]': $stateParams.supplierCode
            };

            exportSearch.setParams(exportParams);

            var params = {
              module: 'companies',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order,
              criteria_operator: 'and',
              'criteria[0][supplier_tags.supplier_code]': $stateParams.supplierCode
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = 'criteria[1][' + $stateParams.filter + ']';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params[temp] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][reg_no]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][currency_code]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Companies Tagged to Supplier';
          }
        }
      })
      .state('main.user.suppliers.tagsByCompany', {
        templateUrl: 'app/suppliersList/supplierTagsByCompany/manage/manage.html',
        url: '/tagsByCompany?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsByCompanyCtrl',
        resolve: {
          detailState: function () {
            return 'main.user.suppliers.supplierTagsByCompanyDetail';
          },
          companiesList: function ($q, searchModule, profile, $stateParams, authenticated, globalFunc) {
            var deferred = $q.defer();
            var userCompanyCodes = [];

            _.forEach(profile.companies, function (company) {
              userCompanyCodes.push(company.code);
            });

            var params = {
              module: 'companies',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = 'criteria[0][' + $stateParams.filter + ']';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params[temp] = $stateParams.query;
                }
              }
              else {
                params['criteria[0][descr]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][reg_no]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][currency_code]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][$operator]'] = !!$stateParams.query ? 'or' : null;
              }

              if (!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN')) {
                params['criteria[1][code][]'] = userCompanyCodes;
                params['criteria_operator'] = 'and';
              }
            }
            else {
              if (!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN')) {
                params['criteria[0][code][]'] = userCompanyCodes;
                params['criteria_operator'] = 'and';
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Company List';
          }
        }
      })
      .state('main.user.suppliers.supplierTagsByCompanyDetail', {
        templateUrl: 'app/suppliersList/supplierTagsByCompany/detail/detail.html',
        url: '/supplierTagsByCompanyDetail?{companyId:[a-zA-Z0-9]+}&{companyCode:[a-zA-Z0-9]+}&' +
        '{companyName:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsByCompanyDetailCtrl',
        resolve: {
          canEditSupplierTag: function (profile, UserPermissions) {
            return (!!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') &&
            !!UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag'));
          },
          detailState: function () {
            return 'main.user.suppliers.supplierTagging';
          },
          companyName: function ($stateParams) {
            return $stateParams.companyName;
          },
          suppliersTaggedToCompany: function ($q, searchModule, getTagsByCompanyCode, exportSearch, $stateParams) {
            var deferred = $q.defer();

            /**
             * Setting the params to prepare for exporting
             */
            var exportParams = {
              module: 'supplier-tags',
              'criteria[company_code]': $stateParams.companyCode
            };

            exportSearch.setParams(exportParams);

            var params = {
              module: 'suppliers',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order,
              'criteria[0][archive_of]': '',
              'criteria[0][draft_status]': 3,
              'criteria[0][status]': 1,
              'criteria[0][$operator]': 'and',
              'criteria[0][approval_status]': 1,
              criteria_operator: 'and',
              'criteria[0][supplier_tags.company_code]': $stateParams.companyCode
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = $stateParams.query;
                params['criteria[1][reg_no]'] = $stateParams.query;
                params['criteria[1][email]'] = $stateParams.query;
                params['criteria[1][contact_person.first_name]'] = $stateParams.query;
                params['criteria[1][contact_person.email]'] = $stateParams.query;
                params['criteria[1][primary_business_nature]'] = $stateParams.query;
                params['criteria[1][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][currency_code]'] = $stateParams.query;
                params['criteria[1][creator.display_name]'] = $stateParams.query;
                params['criteria[1][updater.display_name]'] = $stateParams.query;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Suppliers Tagged to Company';
          }
        }
      });
  }]);

'use strict';

function suppliersListCtrl($scope ,$state, profile, UserPermissions) {
  $scope.tabData = [
    {
      heading: 'Suppliers',
      route: 'main.user.suppliersList.manage',
      key: 'suppliers',
      menu: [
        {
          heading: 'All',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'all',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Active Suppliers',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'active',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Pending Suppliers',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'pending',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Blacklisted Suppliers',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'black_listed',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Rejected Suppliers',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'rejected',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Inactive Suppliers',
          route: 'main.user.suppliersList.manage',
          key: 'suppliers',
          params: {
            status: 'inactive',
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    },
    {
      heading: 'Suppliers Group',
      route:  'main.user.suppliersList.supplierGroups',
      key: 'supplierGroups',
      menu: [
        {
          heading: 'Global Suppliers',
          route:  'main.user.suppliersList.supplierGroupDetail',
          key: 'supplierGroups',
          params:{
            bu_code: 'Global',
            status: 'all',
            order_by: 'descr',
            order: 1,
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Supplier Business Units',
          route:  'main.user.suppliersList.supplierGroups',
          key: 'supplierGroups',
          params:{
            order_by: 'code',
            order: 1,
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Companies Tagged to Supplier',
          route: 'main.user.suppliersList.tagsBySupplier',
          key: 'supplierGroups',
          params: {
            cursor: null,
            order_by: 'descr',
            order: 1,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Suppliers Tagged to Company',
          route: 'main.user.suppliersList.tagsByCompany',
          key: 'supplierGroups',
          params: {
            order_by: 'descr',
            order: 1,
            cursor: null,
            filter: null,
            query: null
          }
        }
      ]
    }
  ];

  /**
   * Tab for supplier tagging, checks the permissions of the user
   */
  if (!!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') &&
    !!UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag')) {
    var supplierTagTab = {
      heading: 'Supplier Tagging',
      route: 'main.user.suppliersList.supplierTagging',
      key: 'supplierTagging',
      id: 'supplierTaggingTab',
      params: {
        status: 'tag',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    };
    $scope.tabData.push(supplierTagTab);
  }

  function initialize(){

    if(!!$state.current.name && $state.current.name.indexOf('supplierGroups') > -1){
      $scope.columns = supplierGroupColumns;
      $scope.searchPlaceholder = 'Search Supplier Business Units';
      $scope.searchState = 'main.user.suppliersList.supplierGroups';
      $scope.parentState = 'main.user.suppliersList.supplierGroups';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierGroupDetail') > -1){
      $scope.columns = supplierByGroupColumns;
      $scope.searchPlaceholder = 'Search Suppliers in Business Unit';
      $scope.searchState = 'main.user.suppliersList.supplierGroupDetail';
      $scope.parentState = 'main.user.suppliersList.supplierGroupDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('tagsBySupplier')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliersList.tagsBySupplier';
      $scope.parentState = 'main.user.suppliersList.tagsBySupplier';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagsBySupplierDetail')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies Tagged to Supplier';
      $scope.searchState = 'main.user.suppliersList.supplierTagsBySupplierDetail';
      $scope.parentState = 'main.user.suppliersList.supplierTagsBySupplierDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('tagsByCompany')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies';
      $scope.searchState = 'main.user.suppliersList.tagsByCompany';
      $scope.parentState = 'main.user.suppliersList.tagsByCompany';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagsByCompanyDetail')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers Tagged to Company';
      $scope.searchState = 'main.user.suppliersList.supplierTagsByCompanyDetail';
      $scope.parentState = 'main.user.suppliersList.supplierTagsByCompanyDetail';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    }
    else if(!!$state.current.name && $state.current.name.indexOf('supplierTagging') > -1){
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliersList.manage';
      $scope.parentState = 'main.user.suppliersList.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[2];
    }
    else{
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliersList.manage';
      $scope.parentState = 'main.user.suppliersList.manage';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[0];
    }

    if(!!$state.params && !!$state.params.query){
      $scope.searchText = $state.params.query;
    }
    else{
      $scope.searchText = '';
    }
    if(!!$state.params && !!$state.params.status){
      $scope.status = $state.params.status
    }
    if(!!$state.params && !!$state.params.filter){
      $scope.searchFilter = $state.params.filter;
    }

  }

  var supplierColumns = [
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'status', label: 'Status', conditional: true, condition: 'all'}
  ];

  var supplierByGroupColumns = [
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'bu_status', label: 'Status', unsearchable: true, unsortable: true,
      conditional: true, condition: 'all'}
  ];

  var supplierGroupColumns = [
    {id: 'code', label: 'Code'},
    {id: 'descr', label: 'Description'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'}
  ];

  var supplierTagsBySupplierColumns = [
    {id: 'descr', label: 'Supplier Name'},
    {id: 'mb_supplier_code', label: 'Supplier Code'},
    {id: 'reg_no', label: 'ROC/ROB/NRIC'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'email', label: 'Email'},
    {id: 'contact_person.first_name', label:'Contact person\'s name'},
    {id: 'contact_person.email', label: 'Contact person\'s email'},
    {id: 'contact_person.phone', label: 'Contact person\'s phone'},
    {id: 'primary_business_nature', label: 'Primary Business Nature'},
    {id: 'primary_commodity.descr', label: 'Primary Commodity'},
    {id: 'secondary_commodity.descr', label: 'Secondary Commodity'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'status', label: 'Supplier Status', unsearchable: true, unsortable: true}
  ];

  var supplierTagsByCompanyColumns = [
    {id: 'descr', label: 'Company Name'},
    {id: 'code', label: 'Company Code'},
    {id: 'reg_no', label: 'Registration Code'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'business_unit.descr', label: 'Business Unit'},
    {id: 'industry.descr', label: 'Industry'},
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    }
  ];

  $scope.$on('$stateChangeStart', function( event, data, toParams ) {
    if(!!data.name && data.name.indexOf('supplierGroups')> -1){
      $scope.columns = supplierGroupColumns;
      $scope.searchPlaceholder = 'Search Supplier Business Units';
      $scope.searchState = 'main.user.suppliersList.supplierGroups';
      $scope.parentState = 'main.user.suppliersList.supplierGroups';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierGroupDetail')> -1){
      $scope.columns = supplierByGroupColumns;
      $scope.searchPlaceholder = 'Search Suppliers in Business Units';
      $scope.searchState = 'main.user.suppliersList.supplierGroupDetail';
      $scope.parentState = 'main.user.suppliersList.supplierGroupDetail';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('tagsBySupplier')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliersList.tagsBySupplier';
      $scope.parentState = 'main.user.suppliersList.tagsBySupplier';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierTagsBySupplierDetail')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies Tagged to Supplier';
      $scope.searchState = 'main.user.suppliersList.supplierTagsBySupplierDetail';
      $scope.parentState = 'main.user.suppliersList.supplierTagsBySupplierDetail';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('tagsByCompany')> -1){
      $scope.columns = supplierTagsByCompanyColumns;
      $scope.searchPlaceholder = 'Search Companies';
      $scope.searchState = 'main.user.suppliersList.tagsByCompany';
      $scope.parentState = 'main.user.suppliersList.tagsByCompany';
      $scope.parentStateParams = $state.params;
    }
    else if(!!data.name && data.name.indexOf('supplierTagsByCompanyDetail')> -1){
      $scope.columns = supplierTagsBySupplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers Tagged to Company';
      $scope.searchState = 'main.user.suppliersList.supplierTagsByCompanyDetail';
      $scope.parentState = 'main.user.suppliersList.supplierTagsByCompanyDetail';
      $scope.parentStateParams = $state.params;
    }
    else{
      $scope.columns = supplierColumns;
      $scope.searchPlaceholder = 'Search Suppliers';
      $scope.searchState = 'main.user.suppliersList.manage';
      $scope.parentState = 'main.user.suppliersList.manage';
      $scope.parentStateParams = $state.params;
    }
    if(!!toParams.status){
      $scope.parentStateParams = toParams;
    }
  });

  initialize();

  $scope.$emit('pageTitleChanged', 'Suppliers List');

}
suppliersListCtrl.$inject = ['$scope', '$state', 'profile', 'UserPermissions'];

angular.module('metabuyer')
  .controller('suppliersListCtrl', suppliersListCtrl);


'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider) {

    $stateProvider
      .state('main.user.suppliersList', {
        url: '/suppliersList',
        controller: 'suppliersListCtrl',
        templateUrl: 'app/suppliersList/suppliersList.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkSupplierAccess(profile, 'L') ||
              !UserPermissions.checkSupplierAccess(profile, 'O')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.suppliersList.manage', {
        templateUrl: 'app/suppliersList/manage/manage.html',
        url: '/manage?{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'suppliersListManageCtrl',
        resolve: {
          action: function ($stateParams) {
            if ($stateParams.query) {
              return 'search';
            }
            else {
              return 'show';
            }
          },
          suppliers: function ($q, $state, $stateParams, Orders, authenticated, searchModule, globalFunc,
                               supplierGlobalFunc) {
            var deferred = $q.defer();
            var status = supplierGlobalFunc.getSupplierListStatus($stateParams.status);
            var statusWithoutArchiveOf = ['draft', 'pending', 'withdraw'];

            var params = {
              module: 'suppliers',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }

            if (!!$stateParams.query) {

              if (!!$stateParams.filter) {

                params['criteria_operator'] = 'and';

                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[0][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              else {
                params['criteria_operator'] = !!$stateParams.query ? 'and' : null;
                params['criteria[0][descr]'] = $stateParams.query;
                params['criteria[0][mb_supplier_code]'] = $stateParams.query;
                params['criteria[0][reg_no]'] = $stateParams.query;
                params['criteria[0][email]'] = $stateParams.query;
                params['criteria[0][contact_person.first_name]'] = $stateParams.query;
                params['criteria[0][contact_person.email]'] = $stateParams.query;
                params['criteria[0][primary_business_nature]'] = $stateParams.query;
                params['criteria[0][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[0][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[0][currency_code]'] = $stateParams.query;
                params['criteria[0][creator.display_name]'] = $stateParams.query;
                params['criteria[0][updater.display_name]'] = $stateParams.query;
                params['criteria[0][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
              if (!!status && !!status.length) {
                if (status[0] !== '*')
                  params['criteria[1][status]'] = status[0];

                if (status[1] !== '*')
                  params['criteria[1][approval_status]'] = status[1];

                if (status[2] !== '*')
                  params['criteria[1][draft_status]'] = status[2];
              }
              else if ($stateParams.status === 'all') {
                params['criteria[1][status]'] = null;
                params['criteria[1][approval_status]'] = null;
                params['criteria[2][draft_status][0]'] = 1;
                params['criteria[2][draft_status][1]'] = 3;
                params['criteria[2][draft_status][2]'] = 4;
                params['criteria[2][$operator]'] = 'or';
              }
              // to exclude archived supplier
              if (statusWithoutArchiveOf.indexOf($stateParams.status) === -1) {
                params['criteria[1][archive_of]'] = '';
              }
            }
            /**
             * For listing
             */
            else {

              if (!!status && !!status.length) {
                if (status[0] !== '*') {
                  params['criteria[0][status]'] = status[0];
                }

                if (status[1] !== '*') {
                  params['criteria[0][approval_status]'] = status[1];
                }

                if (status[2] !== '*') {
                  params['criteria[0][draft_status]'] = status[2];
                }
              }
              else if ($stateParams.status === 'all') {
                params['criteria[0][status]'] = null;
                params['criteria[0][approval_status]'] = null;
                params['criteria[1][draft_status][0]'] = 1;
                params['criteria[1][draft_status][1]'] = 3;
                params['criteria[1][draft_status][2]'] = 4;
                params['criteria[1][$operator]'] = 'or';
              }

              // to exclude archived supplier
              if (statusWithoutArchiveOf.indexOf($stateParams.status) === -1) {
                params['criteria[0][archive_of]'] = '';
              }
            }

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve({data: []});
                }
              },
              function (error) {
              }
            );

            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - listing' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })
      /**
       * State to list supplier groups a.k.a. business units
       */
      .state('main.user.suppliersList.supplierGroups', {
        templateUrl: 'app/suppliersList/supplierGroups/manage/manage.html',
        url: '/supplierGroups?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&' +
        '{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierListGroupsCtrl',
        resolve: {
          dataList: function ($q, searchModule, $stateParams) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'business-units',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Supplier Groups';
          }
        }
      })

      /**
       * State to list suppliers by a specific supplier group / global supplier
       */
      .state('main.user.suppliersList.supplierGroupDetail', {
        templateUrl: 'app/suppliersList/supplierGroups/detail/detail.html',
        url: '/supplierGroups/detail?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&' +
        '{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}&' +
        '{bu_code:[a-zA-Z0-9]+}&{bu_descr:[a-zA-Z0-9]+}&{status:[a-zA-Z0-9]+}',
        controller: 'supplierListGroupDetailCtrl',
        resolve: {
          suppliersByGroup: function ($q, searchModule, $stateParams) {
            var deferred = $q.defer();

            var params = {
              module: 'suppliers',
              'criteria[1][approval_status]': 1,
              'criteria[1][archive_of]': '',
              'criteria[1][draft_status]': 3,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: !!$stateParams.order_by ? $stateParams.order_by : 'descr',
              order: !!$stateParams.order ? $stateParams.order : 1
            };

            /**
             * First determine if search or listing
             */
            if (!!$stateParams.query) {
              /**
               * If searching , check if searching with filter
               */
              if (!!$stateParams.filter) {

                params['criteria_operator'] = 'and';

                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[2][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params['criteria[2][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * If searching without filter
               */
              else {
                params['criteria_operator'] = !!$stateParams.query ? 'and' : null;
                params['criteria[2][descr]'] = $stateParams.query;
                params['criteria[2][mb_supplier_code]'] = $stateParams.query;
                params['criteria[2][reg_no]'] = $stateParams.query;
                params['criteria[2][email]'] = $stateParams.query;
                params['criteria[2][contact_person.first_name]'] = $stateParams.query;
                params['criteria[2][contact_person.email]'] = $stateParams.query;
                params['criteria[2][primary_business_nature]'] = $stateParams.query;
                params['criteria[2][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[2][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[2][currency_code]'] = $stateParams.query;
                params['criteria[2][creator.display_name]'] = $stateParams.query;
                params['criteria[2][updater.display_name]'] = $stateParams.query;
                params['criteria[2][$operator]'] = !!$stateParams.query ? 'or' : null;

              }
            }

            var bu_param = 'criteria[0][bu_status|' + $stateParams.bu_code + '|status]';

            /**
             * Check if selected business unit or global
             * Switch case to handle the bu status params
             */
            if ($stateParams.bu_code.toLowerCase() !== 'global') {
              /**
               * Params for business unit status
               */
              switch ($stateParams.status) {
                case 'all':
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][0]'] = 1;
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][1]'] = 2;
                  params['criteria[0][bu_status|' + $stateParams.bu_code + '|status][2]'] = 6;
                  params['criteria[0][$operator]'] = 'or';
                  break;
                case 'active':
                  params[bu_param] = 1;
                  break;
                case 'black_listed':
                  params[bu_param] = 2;
                  break;
                case 'inactive':
                  params[bu_param] = 6;
                  break;
              }
            }
            else {
              /**
               * Params for global suppliers
               */
              params['criteria[0][is_global_supplier]'] = 'true';
              switch ($stateParams.status) {
                case 'all':
                  break;
                case 'active':
                  params['criteria[0][status]'] = 1;
                  params['criteria[0][$operator]'] = 'and';
                  break;
                case 'black_listed':
                  params['criteria[0][status]'] = 2;
                  params['criteria[0][$operator]'] = 'and';
                  break;
                case 'inactive':
                  params['criteria[0][status]'] = 6;
                  params['criteria[0][$operator]'] = 'and';
                  break;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Supplier Business Unit - Supplier Listing';
          }
        }
      })
      .state('main.user.suppliersList.detail', {
        templateUrl: 'app/suppliersList/detail/detail.html',
        url: '/detail?{id:[a-zA-Z0-9]+}',
        controller: 'suppliersListDetailsCtrl',
        resolve: {
          supplier: function ($q, $state, $stateParams, $filter, authenticated, singleSupplier, $rootScope, toastr) {
            var deferred = $q.defer();
            singleSupplier.get(
              {id: $stateParams.id},
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content.data);
                } else {
                  deferred.resolve({});
                }
              },
              function (error) {
                toastr.error('Supplier not found');
                $state.go($rootScope.previousState.name, $rootScope.previousState.params);
              }
            );
            return deferred.promise;
          },
          currencies: function ($stateParams, $q, Currencies) {
            var deferred = $q.defer();

            if (!!JSON.parse(window.localStorage.getItem('currencies'))) {
              deferred.resolve(JSON.parse(window.localStorage.getItem('currencies')));
            } else {
              Currencies.get(
                {},
                function (resource) {
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    window.localStorage.setItem('currencies', JSON.stringify(resource.content.data));
                    deferred.resolve(resource.content.data);
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
            }

            return deferred.promise;
          },
          commodities: function ($q, listChild) {
            var deferred = $q.defer();

            listChild.get(
              {
                code: 'All'
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                }
                else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Supplier - Details' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })
      .state('main.user.suppliersList.supplierTagging', {
        templateUrl: 'app/suppliersList/supplierTagging/supplierTagging-template.html',
        url: '/SupplierTagging?{companyCode:[a-zA-Z0-9]+}',
        controller: 'supplierTaggingCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') ||
              !UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag')) {
              $state.go('notAuthorized');
            }
          },
          companiesList: function ($q, searchModule, authenticated) {
            var deferred = $q.defer();

            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }

            searchModule.get(
              {
                module: 'companies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          // Resolve the suppliers list for ui-select multiple
          suppliersList: function ($q, suppliersActiveList) {
            var deferred = $q.defer();

            /**
             * Setting list of active suppliers to local storage to reduce loading times
             */
            if (!!JSON.parse(window.localStorage.getItem('activeSuppliersForTagging'))) {
              deferred.resolve(JSON.parse(window.localStorage.getItem('activeSuppliersForTagging')));
            }
            else {
              suppliersActiveList.get(
                {},
                function (resource) {
                  if (!!resource && !!resource.content && !!resource.content.data) {
                    var tempList = [];
                    _.forEach(resource.content.data, function (supplier) {
                      tempList.push({
                        _id: supplier._id,
                        descr: supplier.descr,
                        mb_supplier_code: supplier.mb_supplier_code
                      });
                    });
                    window.localStorage.setItem('activeSuppliersForTagging', JSON.stringify(tempList));
                    deferred.resolve(tempList);
                  } else {
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  deferred.resolve([]);
                });
            }
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Tag Suppliers';
          }
        }
      })
      // TODO: rethink of a better state name to describe these lists (Justin 25/5/17)
      .state('main.user.suppliersList.tagsBySupplier', {
        templateUrl: 'app/suppliersList/supplierTagsBySupplier/manage/manage.html',
        url: '/tagsBySupplier?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsBySupplierCtrl',
        resolve: {
          detailState: function () {
            return 'main.user.suppliersList.supplierTagsBySupplierDetail';
          },
          suppliersList: function ($q, searchModule, authenticated, $stateParams) {
            var deferred = $q.defer();

            var params = {
              module: 'suppliers',
              'criteria[0][archive_of]': '',
              'criteria[0][draft_status]': 3,
              'criteria[0][status]': 1,
              'criteria[0][$operator]': 'and',
              'criteria[0][approval_status]': 1,
              criteria_operator: 'and',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            if (!!$stateParams.query) {

              if (!!$stateParams.filter) {
                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = $stateParams.query;
                params['criteria[1][mb_supplier_code]'] = $stateParams.query;
                params['criteria[1][reg_no]'] = $stateParams.query;
                params['criteria[1][email]'] = $stateParams.query;
                params['criteria[1][contact_person.first_name]'] = $stateParams.query;
                params['criteria[1][contact_person.email]'] = $stateParams.query;
                params['criteria[1][primary_business_nature]'] = $stateParams.query;
                params['criteria[1][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][currency_code]'] = $stateParams.query;
                params['criteria[1][creator.display_name]'] = $stateParams.query;
                params['criteria[1][updater.display_name]'] = $stateParams.query;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Supplier List';
          }
        }
      })
      .state('main.user.suppliersList.supplierTagsBySupplierDetail', {
        templateUrl: 'app/suppliersList/supplierTagsBySupplier/detail/detail.html',
        url: '/supplierTagsBySupplierDetail?{supplierCode:[a-zA-Z0-9]+}&{supplierName:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsBySupplierDetailCtrl',
        resolve: {
          supplierName: function ($stateParams) {
            return $stateParams.supplierName;
          },
          companiesTaggedToSupplier: function ($q, searchModule, getTagsBySupplierCode, $stateParams) {
            var deferred = $q.defer();

            /**
             * Setting the params to prepare for exporting
             */
            var exportParams = {
              module: 'supplier-tags',
              'criteria[supplier_code]': $stateParams.supplierCode
            };

            var params = {
              module: 'companies',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order,
              criteria_operator: 'and',
              'criteria[0][supplier_tags.supplier_code]': $stateParams.supplierCode
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = 'criteria[1][' + $stateParams.filter + ']';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params[temp] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][reg_no]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][currency_code]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Companies Tagged to Supplier';
          }
        }
      })
      .state('main.user.suppliersList.tagsByCompany', {
        templateUrl: 'app/suppliersList/supplierTagsByCompany/manage/manage.html',
        url: '/tagsByCompany?{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsByCompanyCtrl',
        resolve: {
          detailState: function () {
            return 'main.user.suppliersList.supplierTagsByCompanyDetail';
          },
          companiesList: function ($q, searchModule, profile, $stateParams, globalFunc) {
            var deferred = $q.defer();
            var userCompanyCodes = [];

            _.forEach(profile.companies, function (company) {
              userCompanyCodes.push(company.code);
            });

            var params = {
              module: 'companies',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = 'criteria[0][' + $stateParams.filter + ']';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params[temp] = $stateParams.query;
                }
              }
              else {
                params['criteria[0][descr]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][reg_no]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][currency_code]'] = !!$stateParams.query ? $stateParams.query : null;
                params['criteria[0][$operator]'] = !!$stateParams.query ? 'or' : null;
              }

              if (!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN')) {
                params['criteria[1][code][]'] = userCompanyCodes;
                params['criteria_operator'] = 'and';
              }
            }
            else {
              if (!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN')) {
                params['criteria[0][code][]'] = userCompanyCodes;
                params['criteria_operator'] = 'and';
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Company List';
          }
        }
      })
      .state('main.user.suppliersList.supplierTagsByCompanyDetail', {
        templateUrl: 'app/suppliersList/supplierTagsByCompany/detail/detail.html',
        url: '/supplierTagsByCompanyDetail?{companyId:[a-zA-Z0-9]+}&{companyCode:[a-zA-Z0-9]+}&' +
        '{companyName:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]*}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&' +
        '{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'supplierTagsByCompanyDetailCtrl',
        resolve: {
          canEditSupplierTag: function (profile, UserPermissions) {
            return (!!UserPermissions.checkPermissionsAccess(profile, 'C', 'SupplierTag') &&
            !!UserPermissions.checkPermissionsAccess(profile, 'U', 'SupplierTag'));
          },
          detailState: function () {
            return 'main.user.suppliersList.supplierTagging';
          },
          companyName: function ($stateParams) {
            return $stateParams.companyName;
          },
          suppliersTaggedToCompany: function ($q, searchModule, getTagsByCompanyCode, $stateParams) {
            var deferred = $q.defer();

            /**
             * Setting the params to prepare for exporting
             */
            var exportParams = {
              module: 'supplier-tags',
              'criteria[company_code]': $stateParams.companyCode
            };

            var params = {
              module: 'suppliers',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order,
              'criteria[0][archive_of]': '',
              'criteria[0][draft_status]': 3,
              'criteria[0][status]': 1,
              'criteria[0][$operator]': 'and',
              'criteria[0][approval_status]': 1,
              criteria_operator: 'and',
              'criteria[0][supplier_tags.company_code]': $stateParams.companyCode
            };

            if (!!$stateParams.query) {
              if (!!$stateParams.filter) {
                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              else {
                params['criteria[1][descr]'] = $stateParams.query;
                params['criteria[1][reg_no]'] = $stateParams.query;
                params['criteria[1][email]'] = $stateParams.query;
                params['criteria[1][contact_person.first_name]'] = $stateParams.query;
                params['criteria[1][contact_person.email]'] = $stateParams.query;
                params['criteria[1][primary_business_nature]'] = $stateParams.query;
                params['criteria[1][primary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][secondary_commodity.descr]'] = $stateParams.query;
                params['criteria[1][currency_code]'] = $stateParams.query;
                params['criteria[1][creator.display_name]'] = $stateParams.query;
                params['criteria[1][updater.display_name]'] = $stateParams.query;
                params['criteria[1][$operator]'] = !!$stateParams.query ? 'or' : null;
              }
            }

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Supplier - Suppliers Tagged to Company';
          }
        }
      });
  }]);

'use strict';
/**
 * @name approvalFlowCtrl
 * @desc Controller for Approval Flow Management Parent Controller
 */
function settingsCtrl ($scope) {

  $scope.$emit('pageTitleChanged', 'Settings');
  $scope.$emit('actionsChanged', []);
}
settingsCtrl.$inject = ['$scope'];

angular
  .module('metabuyer')
  .controller('settingsCtrl', settingsCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.settings', {
        url: '/system-settings',
        controller: 'settingsCtrl',
        templateUrl: 'app/settings/settingsTemplate.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            var check = false;
            if (!!profile.roles && profile.roles.length > 0) {
              for (var index in profile.roles) {
                if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
                  profile.roles[index].name.toLowerCase() === 'tenant_super_admin') {
                  check = true;
                }
              }
            }
            if (!check) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.settings.mainPanel', {
        url: '/main',
        controller: 'mainPanelSettingsCtrl',
        templateUrl: 'app/settings/mainPanel/mainPanelSettingsTemplate.html',
        resolve:{
          $title: function(){
            return "Settings";
          }
        }
      })
      .state('main.user.settings.adminSettings',{
        url: '/admin-settings',
        controller: 'adminSettingsCtrl',
        templateUrl: 'app/settings/adminSettings/adminSettings.html',
        resolve:{
          settings: function($q, adminSettings) {
            var deferred = $q.defer();
            adminSettings.get(
              {},
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          }
        }
      })
      .state('main.user.settings.PRPOSettings', {
        url: '/PR-PO-Settings',
        controller: 'PRPOSettingsCtrl',
        abstract: true,
        templateUrl: 'app/settings/PR-POSettings/PRPOSettingsTemplate.html'
      })
      .state('main.user.settings.tenant',{
        url: '/tenant',
        controller: 'tenantSettingsCtrl',
        templateUrl: 'app/settings/tenantSettings/tenantSettings.html',
        resolve:{
          tenant: function($q, tenantSettings) {
            var deferred = $q.defer();
            tenantSettings.get(
              {},
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function(){
            return "Tenant Settings";
          }
        }
      })
      .state('main.user.settings.PRPOSettings.prefix', {
        url: '/Prefix',
        controller: 'PRPOPrefixCtrl',
        templateUrl: 'app/settings/PR-POSettings/prefix/PRPOPrefixTemplate.html',
        resolve:{
          companies: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order: 1,
                order_by: 'descr'
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function(){
            return "Company Prefix";
          }
        }
      })
  }]);

'use strict';
/**
 * @name securityCtrl
 * @desc Controller for Security controller
 */
function securityCtrl(
  $scope, companies, rolesList, permissions, $uibModal, toastr, classesList, $state, globalFunc, pathConstants,
  permissionsParameters, classes) {

  $scope.$emit('pageTitleChanged', 'Security');
  $scope.companies = companies.data;
  $scope.companies =  globalFunc.sortObjectsArray($scope.companies, 'descr');
  $scope.permissionsClasses = classesList.data;
  $scope.selectedCompany = true;
  $scope.selectedPermission = false;
  $scope.disableCompaniesDropDown = false;
  $scope.editMode = false;
  $scope.permissionsList = [];
  $scope.classPermissionsList = classes;
  $scope.backUpClassPermissionsList = [];
  $scope.openPermissionPanel = openPermissionPanel;
  $scope.selectCompany = selectCompany;
  $scope.managedRole = {};
  $scope.managedRole.permissions = reformatPermissions($scope.managedRole.permissions_list);
  $scope.managedRole.permissionsConditions = reformatPermissionsConditions($scope.managedRole.permissions_conditions);
  $scope.importLink = pathConstants.apiUrls.imports.now;
  $scope.createNewRole = createNewRole;
  $scope.submitRole = submitRole;
  $scope.editCheck = editCheck;
  $scope.editDropDown = editDropDown;
  $scope.cancelAddingARole = cancelAddingARole;

  var companyConditions =  globalFunc.securityConditions();

  function openPermissionPanel(title, permClass) {
    var availableConditions = [];
    var temp = {
      name: 'Self',
      value: '(@__OWN__)'
    };
    availableConditions.push(temp);

    /**
     * adding Company option of its supplied from the backend
     */
    for(var i in companyConditions){
      if(permClass === companyConditions[i].class){
        if(!!companyConditions[i].value){
          temp = {
            name: 'Company',
            value: companyConditions[i].value
          };
        availableConditions.push(temp);
        break;
        }
      }
    }
    $uibModal.open({
      templateUrl: 'app/security/permissionsPanel/permissionsPanelTemplate.html',
      backdrop: 'static',
      keyboard: false,
      controller: permissionsPanelCtrl,
      scope: $scope,
      resolve: {
        permission: function () {
          return title;
        },
        permissionsClassList: function (permissionsParameters, $q) {
          var deferred = $q.defer();
          permissionsParameters.get(
            {
              class: permClass
            },
            function (resource) {
              deferred.resolve(resource.content);
            },
            function (error) {
              if (error.status === 404) {
                deferred.resolve([]);
              }
            }
          );
          return deferred.promise;
        },
        availableConditions: function(){
          return availableConditions;
        }
      }
    });
  }

  /**
   * cleaning the messy object and make it an array, so that permissions can be appended/removed
   * @returns {Array}
   */
  function reformatPermissions(permissions){
    var tempArray = [];
    for(var i in permissions){
      if(typeof permissions[i] === 'object'){
        tempArray.push(permissions[i]._id);
      }
    }
    return tempArray;
  }

  /**
   * cleaning the messy object and make it an array, so that permissions conditions can be appended/removed
   * @returns {Array}
   */

  function reformatPermissionsConditions(conditions){
    var tempArray = [];
    _.forEach(conditions, function(condition, key){
      if(!!condition){
        var tempCondition = {};
        if((condition.indexOf('@__OWN') > -1) || (condition.indexOf('@__COMPANY') > -1)) {
          if (condition.indexOf('@__OWN') > -1) {
            tempCondition[key] = {
              name: "Self",
              value: condition
            };

          } else {
            tempCondition[key] = {
              name: "Company",
              value: condition
            };
          }
        }
        else{
          tempCondition[key] = {
            name: "Self",
            value: condition
          };
        }
        tempArray.push(tempCondition);
      }
    });

    return tempArray;
  }

  function createNewRole() {
    if(!!$scope.activeCompany) {
      refreshPermissionsList();
      $scope.managedRole = {};
      $scope.managedRole.permissions = [];
      $scope.managedRole.permissionsConditions = [];
      $state.go('main.user.security.add', {code: $scope.activeCompany.code});
    }
  }

  /**
   * clear the selection for any Role
   */
  function refreshPermissionsList() {
    for (var i in $scope.classPermissionsList) {
      for (var k in $scope.classPermissionsList[i].val) {
        $scope.classPermissionsList[i].val[k].checked = null;
        /**
         * fix to auto fill the not Allowed dropdown
         */
        $scope.classPermissionsList[i].val[k].domain = {
          name: 'not allowed',
          value: 'null'
        };
      }
    }
  }

  function searchRoleNameDuplication(roleName, id){
    for(var i in $scope.roles){
      if($scope.roles[i].name.toLowerCase() === roleName.toLowerCase()){
        if($scope.roles[i]._id !== id) {
          if (!!$scope.roles[i].company_code) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * add/remove a permission with the dropdown
   * @param perm
   */
  function editDropDown(perm){
    if(!!perm.domain){
      if(perm.domain.value === null){
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
      }else if(perm.domain.value === '(@__OWN__)'){
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
        $scope.managedRole.permissions.push(perm._id);

        var tempCondition = {};
        tempCondition[perm._id] = perm.domain;
        $scope.managedRole.permissionsConditions.push(tempCondition);
      }else{
        removePermissionFromPermissionsList(perm._id);
        removePermissionConditionFromPermissionsConditions(perm._id);
        $scope.managedRole.permissions.push(perm._id);

        var tempCondition = {};
        tempCondition[perm._id] = perm.domain;
        $scope.managedRole.permissionsConditions.push(tempCondition);
      }
    }
  }

  function editCheck(perm) {
    if (perm.checked === true) {
      removePermissionFromPermissionsList(perm._id);
      removePermissionConditionFromPermissionsConditions(perm._id);
      $scope.managedRole.permissions.push(perm._id);
      var tempCondition = {};
      tempCondition[perm._id] = {
        name: 'Self',
        value: '(1==1)'
      };
      $scope.managedRole.permissionsConditions.push(tempCondition);
    }else{
      removePermissionFromPermissionsList(perm._id);
      removePermissionConditionFromPermissionsConditions(perm._id);
    }
  }

  /**
   * cleaning the permissions array
   * @param id
   */
  function removePermissionFromPermissionsList(id){
    for (var i in $scope.managedRole.permissions) {
      if($scope.managedRole.permissions[i] === id){
        $scope.managedRole.permissions.splice(i,1);
      }
    }
  }

  /**
   * cleaning the permissions conditions array
   * @param id
   */
  function removePermissionConditionFromPermissionsConditions(id){
    for (var i in $scope.managedRole.permissionsConditions) {
      if(Object.keys($scope.managedRole.permissionsConditions[i])[0] === id){
        $scope.managedRole.permissionsConditions.splice(i,1);
      }
    }
  }

  /**
   * validate the selection
   */
    //TODO: check if the name is not spaces (Ahmed Saleh)
  function validate(message) {
    if (!$scope.activeCompany || !$scope.activeCompany.code) {
      toastr.error('Please select a company for this role');
      return false;
    }
    if (!$scope.managedRole.name) {
      toastr.error('Please enter a name for this role');
      return false;
    }
    if (!$scope.managedRole.descr) {
      toastr.error('Please enter a description for this role');
      return false;
    }
    if(message !== 'updated') {
      if (searchRoleNameDuplication($scope.managedRole.name, $scope.managedRole._id)) {
        toastr.error('Please enter another name for this role, this Role name is already taken');
        return false;
      }
    }
    /**
     * if Role is edited, just check against if all permissions selection were removed
     */
    if (message === 'updated') {
      if ((!$scope.managedRole.permissions_list || $scope.managedRole.permissions_list.length < 1) && (!$scope.managedRole.permissions || $scope.managedRole.permissions.length < 1)) {
        toastr.error('Please assign at least 1 permission');
        return false;
      }
    }
    /**
     * if Role is new, just check if there were permissions selected
     */
    else {
      if (!$scope.managedRole.permissions || $scope.managedRole.permissions.length < 1) {
        toastr.error('Please assign at least 1 permission');
        return false;
      }
    }
    return true;
  }

  function reformatConditionsToSubmit(conditions){
    var tempConditions = {};
    _.forEach(conditions, function(condition){
      var objKey = Object.keys(condition);
      objKey = objKey[0];
      tempConditions[objKey] = condition[objKey].value;
    });

    return tempConditions;
  }

  function submitRole(message) {
    if (validate(message)) {

      var reformatPermissionsConditions = reformatConditionsToSubmit($scope.managedRole.permissionsConditions);

      rolesList.post(
          {
            name: $scope.managedRole.name,
            descr: $scope.managedRole.descr,
            permissions_list: $scope.managedRole.permissions,
            permissions_conditions: reformatPermissionsConditions,
            company_code: $scope.activeCompany.code,
            company_id: $scope.activeCompany._id,
            type: 1
          },
          function (resource) {
            if(!!resource) {
              $scope.managedRole._id = resource._id;
              toastr.success('New role has been ' + message);
              $scope.backUpManagedRole = angular.copy($scope.managedRole);
              $state.go('main.user.security.rolesListing', {code: $scope.activeCompany.code});
            }
          },
          function (error) {
            globalFunc.objectErrorMessage(error);
          }
        )
    }
  }

  function cancelAddingARole(){
    $state.go('main.user.security.rolesListing', {code: $scope.activeCompany.code});
  }

  function selectCompany(company) {
    $scope.managedRole = {};
    $scope.activeCompany = company;
    $state.go('main.user.security.rolesListing', {code: company.code});
  }

  $scope.$on('setCompany', function(args, code) {
    /**
     * finding which company is active/selected
     */
    if (!!code) {
      $scope.company = globalFunc.findInArray($scope.companies, 'code', code);
      $scope.activeCompany = globalFunc.findInArray($scope.companies, 'code', code);
    }
  });

  function prepareImportParams() {
    $scope.params = {
      class: 'Metabuyer\\Models\\RolesPermissionsImporter'
    };
  }

  function initialize () {
    prepareImportParams();
  }

  initialize();

}
securityCtrl.$inject = [
  '$scope', 'companies', 'rolesList', 'permissions', '$uibModal', 'toastr', 'classesList', '$state', 'globalFunc',
  'pathConstants', 'permissionsParameters', 'classes'
];

angular
  .module('metabuyer')
  .controller('securityCtrl', securityCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.security', {
        url: '/security',
        controller: 'securityCtrl',
        abstract: true,
        templateUrl: 'app/security/security.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            var check = false;
            if (!!profile.roles && profile.roles.length > 0) {
              for (var index in profile.roles) {
                if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
                  profile.roles[index].name.toLowerCase() === 'tenant_super_admin'){
                  check = true;
                }
              }
            }
            if (!check) {
              $state.go('notAuthorized');
            }
          },
          classesList: function(permissionsParameters, $q){
            var deferred = $q.defer();
            permissionsParameters.get(
              {},
              function (resource) {
                deferred.resolve(resource);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          classes: function(classesList, permissionsParameters, globalFunc, $q) {
            var deferred = $q.defer();
            var array = [];
            var promises = [];
            var companyConditions =  globalFunc.securityConditions();

            /**
             * Get Conditions List of the Class.
             *
             * @param permClass
             * @returns {Array}
             */
            function getConditionsList(permClass){
              var availableConditions = [],
                checkCondition = globalFunc.findInArray(companyConditions, 'class', permClass);

              var temp = {
                name: 'Self',
                value: '(@__OWN__)'
              };

              availableConditions.push(temp);

              if(!!checkCondition && !!checkCondition.value) {
                availableConditions.push({
                  name: 'Company',
                  value: checkCondition.value
                });

                if (permClass.toLowerCase() === 'po') {
                  availableConditions.push({
                    name: 'Cost Center',
                    value: '(@__COST_CENTER__)'
                  });
                }

                /**
                 * adding Not Allowed in case of 2 or more options
                 */
                if(availableConditions.length > 1){
                  temp = {
                    name: 'not allowed',
                    value: 'null'
                  };
                  availableConditions.push(temp);
                }
              }


              return availableConditions;
            }

            /**
             * To get permissions list for all classes
             * and define it in new object of array
             */
            _.forEach(classesList.data, function (permClass) {

              var promise = permissionsParameters.get(
                {
                  class: Object.keys(permClass)
                });
              promises.push(promise.$promise);
            });


            $q.all(promises).then(function (resource) {
              angular.forEach(resource, function (singleClass) {
                if(!!singleClass.content && !!singleClass.content.data) {
                  // Var for specific order of the subjectAction
                  var specificOrderArray = ['Create', 'Read', 'Update', 'Delete', 'Approve'];
                  // Sorts the return data from the promise based on the specific order
                  var data = singleClass.content.data.sort(function(first, second) {
                    return specificOrderArray.indexOf(first.subjectAction) - specificOrderArray.indexOf(second.subjectAction);
                  });
                  array.push({
                    className: globalFunc.translateSecurityClasses(data[0].subjectClass.split('\\').pop()),
                    val: data,
                    dropdown: getConditionsList(data[0].subjectClass.split('\\').pop())
                  });
                }
              });
            }).catch().finally(function () {
              deferred.resolve(array);
            });

            return deferred.promise;
          },
          companies: function(searchModule, $q) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          permissions: function(permissionsList, $q){
            var deferred = $q.defer();
            permissionsList.get(
              {
                offset: 10000
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          }
        }
      })
      .state('main.user.security.rolesListing', {
        templateUrl: 'app/security/rolesListing/rolesListing.html',
        url: '/rolesListing/{code:[a-zA-Z0-9]+}?{order:[a-zA-Z0-9]+}&{order_by:[a-zA-Z0-9]+}',
        controller: 'rolesListingCtrl',
        resolve: {
          dataList: function($q, $stateParams, searchModule){
            var deferred = $q.defer();
            /**
             * Loading company roles
             */
            searchModule.get({
                module: 'role',
                'criteria[0][company_code][1]': '',
                'criteria[0][company_code][2]': $stateParams.code,
                'criteria[0][$operator]': 'or',
                'criteria[1][type]': 1,
                offset: 0,
                order: $stateParams.order,
                order_by: $stateParams.order_by
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content.data);
                }
              },
              function(error){
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function(){
            return "Security - Roles Listing";
          }
        }
      })
      .state('main.user.security.manage', {
        templateUrl: 'app/security/manage/manageTemplate.html',
        url: '/manage',
        resolve: {
          $title: function(){
            return "Security - Manage";
          }
        }
      })
      .state('main.user.security.add', {
        templateUrl: 'app/security/add/add-roleTemplate.html',
        url: '/add/{code:[a-zA-Z0-9]+}',
        controller: 'addRolesCtrl',
        resolve: {
          $title: function(){
            return "Security - Add Role";
          }
        }
      })
      .state('main.user.security.edit', {
        templateUrl: 'app/security/manage/manageTemplate.html',
        url:'/edit?{code:[a-zA-Z0-9]+}/{id:[a-zA-Z0-9]+}',
        controller: 'securityManageCtrl',
        resolve: {
          managedRole: function(rolesList, $q, $stateParams) {
            var deferred = $q.defer();
            rolesList.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          permissionsList: function(permissions){
            return permissions
          },
          classes: function(classesList, permissionsParameters, globalFunc, $q) {
            var deferred = $q.defer();
            var array = [];
            var promises = [];
            var companyConditions =  globalFunc.securityConditions();

            /**
             * Get Conditions List of the Class.
             *
             * @param permClass
             * @returns {Array}
             */
            function getConditionsList(permClass){
              var availableConditions = [],
                checkCondition = globalFunc.findInArray(companyConditions, 'class', permClass);

              var temp = {
                name: 'Self',
                value: '(@__OWN__)'
              };

              availableConditions.push(temp);

              if(!!checkCondition && !!checkCondition.value) {
                availableConditions.push({
                    name: 'Company',
                    value: checkCondition.value
                });

                if (permClass.toLowerCase() === 'po') {
                  availableConditions.push({
                    name: 'Cost Center',
                    value: '(@__COST_CENTER__)'
                  });
                }

                /**
                 * adding Not Allowed in case of 2 or more options
                 */
                if(availableConditions.length > 1){
                  temp = {
                    name: 'not allowed',
                    value: 'null'
                  };
                  availableConditions.push(temp);
                }
              }
              return availableConditions;
            }

            /**
             * To get permissions list for all classes
             * and define it in new object of array
             */
            _.forEach(classesList.data, function (permClass) {
              var promise = permissionsParameters.get({
                class: Object.keys(permClass)
              });
              promises.push(promise.$promise);
            });

            $q.all(promises).then(function (resource) {
              angular.forEach(resource, function (singleClass) {
                if(!!singleClass.content && !!singleClass.content.data) {
                  var data = singleClass.content.data;
                  array.push({
                    className: globalFunc.translateSecurityClasses(data[0].subjectClass.split('\\').pop()),
                    val: data,
                    dropdown: getConditionsList(data[0].subjectClass.split('\\').pop())
                  });
                }
              });
            }).catch().finally(function () {
              deferred.resolve(array);
            });

            return deferred.promise;
          },
          $title: function(){
            return "Security - Edit Role";
          }
        }
      })
      .state('main.user.security.view', {
        templateUrl: 'app/security/edit/permissionsViewTemplate.html',
        url:'/view/{id:[a-zA-Z0-9]+}',
        resolve: {
          $title: function(){
            return "Security - Role";
          }
        }
      })
  }]);


'use strict';
/**
 * @name reportsCtrl
 * @desc Controller for reports main Controller
 */
function reportsCtrl ($scope, $state) {

  $scope.$emit('pageTitleChanged', 'Reports');

  $scope.tabData = [
    {
      heading: 'Logs',
      route: 'main.user.reports.log',
      key: 'logs',
      params: {
        order_by: 'done_at',
        order: '0'
      }
    },
    {
      heading: 'Reports',
      route: 'main.user.reports.generate',
      key: 'reports'
    }
  ];
}
reportsCtrl.$inject = ['$scope', '$state'];

angular
  .module('metabuyer')
  .controller('reportsCtrl', reportsCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.reports', {
        url: '/reports',
        controller: 'reportsCtrl',
        templateUrl: 'app/reports/reports.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkReportLogAccess(profile, 'C') ||
              !UserPermissions.checkReportLogAccess(profile, 'L') ||
              !UserPermissions.checkReportLogAccess(profile, 'O') ||
              !UserPermissions.checkReportLogAccess(profile, 'U') ||
              !UserPermissions.checkReportLogAccess(profile, 'D')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.reports.log', {
        templateUrl: 'app/reports/logs/logs.html',
        url: '/logs?{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'reportsLogCtrl',
        resolve: {
          logList: function ($q, searchModule, $stateParams, profile) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'reports',
                'criteria[requestor_user._id]': profile._id,
                cursor: $stateParams.cursor,
                offset: 20,
                order_by: !!$stateParams.order_by ? $stateParams.order_by : 'done_at',
                order: !!$stateParams.order ? $stateParams.order : 0
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Reports - Logs';
          }
        }
      })
      .state('main.user.reports.generate', {
        templateUrl: 'app/reports/generate/generate.html',
        url: '/generate',
        controller: 'reportsGenerationCtrl',
        resolve: {
          $title: function(){
            return 'Reports - Generate';
          },
          businessList: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'business-units',
                offset: 0,

                // Get only active BU = 1
                'criteria[is_active]': 1
              },
              function (resource) {
                deferred.resolve(resource.content.data);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          }
        }
      })
  }]);


'use strict';
/**
 * @name purchaseRequisitionsMainCtrl
 *
 * @description
 *
 * Main controller for the requisitions State
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

function purchaseRequisitionsMainCtrl($scope, $state, globalFunc, $rootScope) {
  var tempState = _.cloneDeep($state.params);

  if (!$rootScope.isMobileMode) {
    $scope.tabData = [
      {
        heading: 'Draft',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'draft',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'draft',
          tab: 'all',
          cursor: null
        })
      },
      {
        heading: 'Pending Approval',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'pending',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'pending',
          tab: 'waiting',
          extraFilterKey: 'criteria[waiting_on][]',
          extraFilterValue: $rootScope.currentUser._id,
          cursor: null
        })
      },
      {
        heading: 'Approved',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'approved',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'approved',
          tab: 'all',
          cursor: null
        })
      }
    ];

    $scope.tabData.more = [
      {
        heading: 'Deleted',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'deleted',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'deleted',
          tab: null,
          cursor: null
        })
      },
      {
        heading: 'Withdrawn',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'withdrawn',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'withdrawn',
          tab: null,
          cursor: null
        })
      },
      {
        heading: 'Starred',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'starred',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'starred',
          tab: null,
          cursor: null
        })
      },
      {
        heading: 'Rejected',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'rejected',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'rejected',
          tab: null,
          cursor: null
        })
      }
    ];
  }

  if ($rootScope.isMobileMode) {
    $scope.tabData = [
      {
        heading: 'Pending Approval',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'pending',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'pending',
          tab: 'waiting',
          extraFilterKey: 'criteria[waiting_on][]',
          extraFilterValue: $rootScope.currentUser._id,
          cursor: null
        })
      },
      {
        heading: 'Approved',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'approved',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'approved',
          tab: 'all',
          cursor: null
        })
      },
      {
        heading: 'Deleted',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'deleted',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'deleted',
          tab: null,
          cursor: null
        })
      },
      {
        heading: 'Starred',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'starred',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'starred',
          tab: null,
          cursor: null
        })
      },
      {
        heading: 'Rejected',
        route: 'main.user.purchaseRequisitions.manage',
        key: 'rejected',
        type: 'more',
        params: globalFunc.filterUrlParams(tempState, {
          status: 'rejected',
          tab: null,
          cursor: null
        })
      }
    ];
  }


  function initialize() {

    $scope.$emit('pageTitleChanged', 'Purchase Requisitions');
    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }
    if (!!$state.params && !!$state.params.status) {
      $scope.status = $state.params.status;


      //set the default tab on refreshing
      var tempIndex = _.findIndex($scope.tabData, function(tab){return tab.key === $state.params.status.toLowerCase()});
      if(tempIndex < 0 && !$rootScope.isMobileMode) {
        tempIndex = _.findIndex($scope.tabData.more, function (tab) {
          return tab.key === $state.params.status.toLowerCase()
        });
        if(!!tempIndex)
          $scope.activatedTab = $scope.tabData.more[tempIndex];
          }
      else
        $scope.activatedTab = $scope.tabData[tempIndex];
    }
    if (!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }

    $scope.searchPlaceholder = 'Search Purchase Requisition';
    $scope.searchState = 'main.user.purchaseRequisitions.manage';
    $scope.parentState = 'main.user.purchaseRequisitions.manage';
    $scope.parentStateParams = $state.params;

  }

  if (!$rootScope.isMobileMode) {
    $scope.columns = [
      {
        id: 'check box',
        title: '',
        unsortable: true,
        unsearchable: true,
        conditional: true,
        condition: ['pending'],
        unSelectable: true
      },
      {id: 'star', label: 'Favorite', unsortable: true, unsearchable: true, unSelectable: true},
      {id: 'reference', label: 'PR#'},
      {id: 'title', label: 'Title'},
      {
        id: 'waiting_on',
        label: 'Waiting on',
        conditional: true,
        condition: ['pending'],
        unsortable: true,
        unsearchable: true
      },
      {id: 'pos', label: 'PO#', conditional: true, condition: ['approved'], unsortable: true, unsearchable: true},
      {
        id: 'grand_total',
        label: 'Amount',
        type: 'double',
        unsearchable: true
      },
      {id: 'closed_at', label: 'Approved Date', conditional: true, condition: ['approved'], unsearchable: true},
      {
        id: 'submitted_at',
        label: 'Submitted Date',
        conditional: true,
        condition: ['pending', 'approved'],
        type: 'date',
        unsearchable: true
      },
      {
        id: 'progress',
        label: 'Progress',
        conditional: true,
        condition: ['pending', 'approved'],
        unsortable: true,
        unsearchable: true
      },
      {
        id: 'needed_by_date',
        label: 'Needed By',
        type: 'date',
        unsearchable: true
      },
      {id: 'creator|display_name', label: 'Creator'},
      {id: 'requestor|display_name', label: 'Requestor'},
      {
        id: 'created_at',
        label: 'Created At',
        type: 'date',
        unsearchable: true
      },
      {
        id: 'updated_at',
        label: 'Updated At',
        type: 'date',
        unsearchable: true
      },
      {id: 'company|descr', label: 'Company'},
      {id: 'cost_center|descr', label: 'Cost Center'},
      {id: 'status', label: 'Status', unsortable: true, unsearchable: true},
      {
        id: 'withdrawn_at',
        label: 'Withdrawn date',
        conditional: true,
        condition: ['withdrawn'],
        type: 'date',
        unsearchable: true
      },
      {id: 'withdrawer|display_name', label: 'Withdrawn by', conditional: true, condition: ['withdrawn']},
      {
        id: 'deleted_at',
        label: 'Deleted Date',
        conditional: true,
        condition: ['deleted'],
        type: 'date',
        unsearchable: true
      },
      {
        id: 'delete_button',
        label: '',
        unsortable: true,
        conditional: true,
        condition: ['draft'],
        unsearchable: true,
        unSelectable: true
      }
    ];
  }
  else {
    $scope.columns = [
      {id: 'star', label: 'Favorite', unsortable: true, unsearchable: true, unSelectable: true},
      {id: 'reference', label: 'Company/PR#'},
      {id: 'title', label: 'Title'},
      {
        id: 'grand_total',
        label: 'Amount',
        type: 'double',
        unsearchable: true
      },
      {id: 'showMore', label: '', type: 'boolean'}
    ];
  }

  $scope.$on('$stateChangeStart', function (event, toState, toParams) {
    if (!!toParams.status) {
      $scope.parentStateParams = toParams;
      $scope.status = toParams.status;
    }
  });

  initialize();
}
purchaseRequisitionsMainCtrl.$inject = ['$scope', '$state', 'globalFunc', '$rootScope'];

angular
  .module('metabuyer')
  .controller('purchaseRequisitionsMainCtrl', purchaseRequisitionsMainCtrl);

'use strict';
/**
 *
 * @description
 *
 * State for the purchase requisitions module
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
    /**
     * @description
     *
     * Main state for the purchase requisitions,
     * Abstract and only handles the access to the Module
     *
     */
      .state('main.user.purchaseRequisitions', {
        url: '/requisitions',
        controller: 'purchaseRequisitionsMainCtrl',
        template: '<div ng-include="purchaseRequisitionsTemplate"></div>',
        abstract: true,
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkPRAccess(profile, 'O') || !UserPermissions.checkPRAccess(profile, 'L')) {
              $state.go('notAuthorized');
            }
          },
          findTemplate: function ($rootScope) {
            $rootScope.purchaseRequisitionsTemplate = $rootScope.isMobileMode ?
              'app/purchaseRequisitions/purchaseRequisitions-mobile.html' :
              'app/purchaseRequisitions/purchaseRequisitions.html';
          }
        }
      })
      .state('main.user.purchaseRequisitions.manage', {
        url: '/manage?{status:[a-zA-Z0-9]+}&{tab:[a-zA-Z0-9]+}&{extraFilterKey:[a-zA-Z0-9]+}&' +
        '{extraFilterValue:[a-zA-Z0-9]+}&{cursor:[^~,]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}&' +
        '{query:[a-zA-Z0-9]+}&{order:[0-9]+}&{order_by:[a-zA-Z0-9]+}',
        controller: 'requisitionsManageCtrl',
        template: '<div ng-include="PRManageTemplate"></div>',
        resolve: {
          dataList: function ($q, searchModule, $stateParams, profile, exportSearch) {
            var deferred = $q.defer();
            var params;
            /**
             * searching
             */
            if(!!$stateParams.query) {

              /**
               * searching with a specific filter
               */
              if (!!$stateParams.filter) {
                params = {
                  module: 'PR',
                  offset: 20,
                  'criteria[2][creator|_id][]': ($stateParams.extraFilterKey === 'criteria[creator|_id][][]') ?
                    $stateParams.extraFilterValue : null,
                  'criteria[2][collaborators_ids][]': ($stateParams.extraFilterKey === 'criteria[collaborators_ids][]') ?
                    $stateParams.extraFilterValue : null,
                  'criteria[2][waiting_on][]': ($stateParams.extraFilterKey === 'criteria[waiting_on][]') ?
                    $stateParams.extraFilterValue : null,
                  criteria_operator: 'and',
                  'criteria[0][status][2]' : $stateParams.status === 'pending' ? 'on_hold' : null,
                  'criteria[0][$operator]' : 'or',
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                };

                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                //TODO: To have backend support searching double or change it (Justin)
                else if ($stateParams.type === 'double') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * searching all filters
               */
              else {
                params = {
                  module: 'PR',
                  offset: 20,
                  'criteria[2][creator|_id][]': ($stateParams.extraFilterKey === 'criteria[creator|_id][][]') ?
                    $stateParams.extraFilterValue : null,
                  'criteria[2][collaborators_ids][]': ($stateParams.extraFilterKey === 'criteria[collaborators_ids][]') ?
                    $stateParams.extraFilterValue : null,
                  'criteria[2][waiting_on][]': ($stateParams.extraFilterKey === 'criteria[waiting_on][]') ?
                    $stateParams.extraFilterValue : null,
                  'criteria[1][reference]': $stateParams.query,
                  'criteria[1][title]': $stateParams.query,
                  'criteria[1][creator|display_name]': $stateParams.query,
                  'criteria[1][requestor|display_name]': $stateParams.query,
                  'criteria[1][company|descr]': $stateParams.query,
                  'criteria[1][cost_center|descr]': $stateParams.query,
                  'criteria[1][withdrawer|display_name]': $stateParams.status === 'withdrawn' ? $stateParams.query : null,
                  'criteria[1][$operator]': !!$stateParams.query ? 'or' : null,
                  'criteria[0][status][2]' : $stateParams.status === 'pending' ? 'on_hold' : null,
                  'criteria[0][$operator]' : 'or',
                  criteria_operator: !!$stateParams.query ? 'and' : null,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                };
              }
            }
            /**
             * listing
             */
            else {
              params = {
                module: 'PR',
                offset: 20,
                'criteria[1][creator|_id][]': ($stateParams.extraFilterKey === 'criteria[creator|_id][][]') ?
                                            $stateParams.extraFilterValue : null,
                'criteria[1][collaborators_ids][]': ($stateParams.extraFilterKey === 'criteria[collaborators_ids][]') ?
                                                  $stateParams.extraFilterValue : null,
                'criteria[1][waiting_on][]': ($stateParams.extraFilterKey === 'criteria[waiting_on][]') ?
                                           $stateParams.extraFilterValue : null,
                'criteria[0][status][2]' : $stateParams.status === 'pending' ? 'on_hold' : null,
                'criteria[0][$operator]' : 'or',
                criteria_operator: 'and',
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }

            if ($stateParams.status === 'starred')
              params['criteria[0][starred_users][]'] = profile._id;
            else if($stateParams.status === 'pending')
              params['criteria[0][status][1]'] = $stateParams.status;
            else
              params['criteria[0][status]'] = $stateParams.status;

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                //TODO: handle the error
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          status: function ($stateParams) {
            return !!$stateParams.status ? $stateParams.status.toLowerCase() : '';
          },
          $title: function () {
            return 'Purchase Requisitions'
          },
          findTemplate: function ($rootScope) {
            $rootScope.PRManageTemplate = $rootScope.isMobileMode ?
              'app/purchaseRequisitions/manage/manage-mobile.html' :
              'app/purchaseRequisitions/manage/manage.html';
          }
        }
      })
      /**
       * @description
       *
       * details state for the purchase requisitions,
       * Resolves the main PR in which passed to the rest of the components
       *
       */
      .state('main.user.purchaseRequisitions.details', {
        url: '/{id:[a-zA-Z0-9]+}',
        controller: 'requisitionsDetailsCtrl',
        template: '<div ng-include="PRDetailsTemplate"></div>',
        params: {PR: null},
        resolve: {
          purchaseRequisition: function($q, purchaseRequisitionsServices, $stateParams, prFunction, globalFunc) {

            var deferred = $q.defer();
            /**
             * the PR data is available, no need for a call to the backend to get the PR info
             */
            if (!!$stateParams.PR && !!$stateParams.PR.data && $stateParams.PR.data._id === $stateParams.id) {
              if (!prFunction.getPRData() || !prFunction.getPRData()._id || prFunction.getPRData()._id !== $stateParams.id) {
                //clean set of the PR object
                prFunction.initializePRData($stateParams.PR.data);
              }
              $stateParams.PR.data = prFunction.getPRData();
              deferred.resolve($stateParams.PR);
            }
            /**
             * the PR data is missing, transition is from a list or a Url
             */
            else {
              purchaseRequisitionsServices.getSinglePR(
                {
                  id: $stateParams.id
                },
                function (resource) {
                  if (!!resource.content) {
                    deferred.resolve(resource.content);
                    prFunction.initializePRData(resource.content.data);
                  } else {
                    //TODO: it was successful but something is a miss, Have the best way to redirect in a globalFunc all resolved errors
                    deferred.resolve([]);
                  }
                },
                function (error) {
                  globalFunc.objectErrorMessage(error);
                }
              );
            }
            return deferred.promise;
          },
          $title: function(){
            return 'PR - Details';
          },
          findTemplate: function ($rootScope) {
            $rootScope.PRDetailsTemplate = $rootScope.isMobileMode ?
              'app/purchaseRequisitions/details/details-mobile.html' :
              'app/purchaseRequisitions/details/details.html';
          }
        }
      })
      .state('main.user.purchaseRequisitions.details.catalog', {
        url: '/catalog',
        abstract: true,
        templateUrl: 'components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/catalogPanelTemplate.html',
        controller: 'catalogHeaderCtrl',
        resolve: {
          purchaseRequisition: function (purchaseRequisition) {
            return purchaseRequisition;
          },
          paymentTerms: function ($q, searchModule) {
            var deferred = $q.defer();
            //load the paymentTerms
            searchModule.get(
              {
                module: 'payment-term',
                'criteria[is_active]': 1,
                offset: 0
              },
              function (resource) {
                if (!!resource && !!resource.content) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve([]);
                }
              },
              function (error) {
                deferred.resolve([]);
              });
            return deferred.promise;
          }
        }
      })
      .state('main.user.purchaseRequisitions.details.catalog.tab', {
        url: '/',
        templateUrl: 'components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/catalog.html',
        scope: false,
        resolve: {
          $title: function(){
            return "PR - detail - catalog";
          }
        }
      });
  }]);

'use strict';
/**
 * @name positionManagementMainCtrl
 * @desc Controller for Position Management Parent Controller
 */
function positionManagementMainCtrl($scope, $state) {

  $scope.$emit('pageTitleChanged', 'Position Management');

  $scope.tabData = [
    {
      heading: 'Positions',
      route: 'main.user.positionManagement.manage',
      key: 'manage'
    },
    {
      heading: 'Position Assignment',
      route: 'main.user.positionManagement.assign',
      key: 'assign'
    }
  ];

  function initialize() {

    if (!!$state.current.name) {
      if ($state.current.name.indexOf('assign') > -1) {
        $scope.parentState = 'main.user.positionManagement.assign';
        $scope.parentStateParams = $state.params;
        $scope.activatedTab = $scope.tabData[1];
     } else  {
        $scope.parentState = 'main.user.positionManagement.manage';
        $scope.parentStateParams = $state.params;
        $scope.activatedTab = $scope.tabData[0];
      }
    }

    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    } else {
      $scope.searchText = '';
    }

    if (!!$state.params && !!$state.params.code) {
      $scope.code = $state.params.code
    }

    if (!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }
  }

  initialize();
}
positionManagementMainCtrl.$inject = ['$scope', '$state'];

angular
  .module('metabuyer')
  .controller('positionManagementMainCtrl', positionManagementMainCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider) {

    $stateProvider
      .state('main.user.positionManagement', {
        url: '/position-management',
        controller: 'positionManagementMainCtrl',
        templateUrl: 'app/positionManagement/positionManagement.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkApprovalTemplateAccess(profile, 'C') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'L') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'O') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'U') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'D')
            ) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.positionManagement.manage', {
        url: '/manage',
        controller: 'positionManagementCtrl',
        templateUrl: 'app/positionManagement/manage/positionManage.html',
        resolve: {
          positionManagementListing: function ($q, positionManagement) {
            var deferred = $q.defer();
            positionManagement.get(
              {
                limit: 30,
                page: 0,
                'sort[0][key]': 'updated_at',
                'sort[0][direction]': 'DESC'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Position Management - Manage';
          }
        }
      })
      .state('main.user.positionManagement.assign', {
        url: '/assign',
        controller: 'positionAssignCtrl',
        templateUrl: 'app/positionManagement/assign/positionAssign.html',
        resolve: {
          companies: function ($q, $stateParams, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order_by: 'descr',
                order: 1
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          positions: function ($q, positionManagement) {
            var deferred = $q.defer();
            positionManagement.get(
              {
                'sort[0][key]': 'name',
                'sort[0][direction]': 'ASC'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          positionAssignmentListing: function ($q, positionAssignment) {
            var deferred = $q.defer();
            positionAssignment.get(
              {
                limit: 30,
                page: 0,
                'sort[0][key]': 'status',
                'sort[0][direction]': 'ASC',
                'sort[1][key]': 'updated_at',
                'sort[1][direction]': 'DESC'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Position Management - Assign';
          }
        }
      })
  }]);


'use strict';

function OrdersCtrl($scope, $state, $rootScope, Orders, starringPO, toastr, globalFunc) {

  $scope.starred = starred;

  var tempState = _.cloneDeep($state.params);
  $scope.tabData = [
    {
      heading: 'Submitted',
      route: 'main.user.orders.manage',
      key: 'submitted',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'SUBMITTED',
        cursor: null
      })
    },
    {
      heading: 'Awaiting Delivery',
      route: 'main.user.orders.manage',
      key: 'awaiting_delivery',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'AWAITING_DELIVERY',
        cursor: null
      })
    },
    {
      heading: 'Closed',
      route: 'main.user.orders.manage',
      key: 'closed',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'CLOSED',
        cursor: null
      })
    }
  ];

  $scope.tabData.more = [
    {
      heading: 'Declined',
      route: 'main.user.orders.manage',
      key: 'declined',
      type: 'more',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'DECLINED',
        cursor: null
      })
    },
    {
      heading: 'Starred',
      route: 'main.user.orders.manage',
      key: 'starred',
      type: 'more',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'STARRED',
        cursor: null
      })
    },
    {
      heading: 'Cancelled',
      route: 'main.user.orders.manage',
      key: 'cancelled',
      type: 'more',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'CANCELLED',
        cursor: null
      })
    }
  ];



  function starred(po) {

    starringPO.update(
      {
        id: po._id,
        action: !!po.isStarred ? 'unstar' : 'star'
      }
    ).
      $promise.then(function (v) {
        //successful
        if (!!po.isStarred) {
          po.isStarred = false;
          po.starred_by = [];
        }
        else {
          po.isStarred = true;
          po.starred_by = [];
          po.starred_by.push($rootScope.currentUser._id);
        }
      },
      function (error) {
        toastr.error(error.message);
      }
    );
  }

  function initialize(){
    if(!!$state.params && !!$state.params.query){
      $scope.searchText = $state.params.query;
    }
    else{
      $scope.searchText = '';
    }
    if(!!$state.params && !!$state.params.status){
      $scope.status = $state.params.status;
      //set the default tab on refreshing
      var tempIndex = _.findIndex($scope.tabData, function(tab){return tab.key === $state.params.status.toLowerCase()});
      if(tempIndex < 0) {
        tempIndex = _.findIndex($scope.tabData.more, function (tab) {
          return tab.key === $state.params.status.toLowerCase()
        });
        if(!!tempIndex)
          $scope.activatedTab = $scope.tabData.more[tempIndex];
      }
      else
        $scope.activatedTab = $scope.tabData[tempIndex];
    }
    if(!!$state.params && !!$state.params.filter){
      $scope.searchFilter = $state.params.filter;
    }
    $scope.searchPlaceholder = 'Search Orders';
    $scope.searchState = 'main.user.orders.manage';
    $scope.parentState = 'main.user.orders.manage';
    $scope.parentStateParams = $state.params;
  }

  $scope.columns = [
    {id: 'starred', label: 'Star', unsortable: true, unsearchable: true, unSelectable: true},
    {id: 'po_number', label: 'PO #'},
    {id: 'pr_number', label: 'PR #'},
    {id: 'title', label: 'PR Title'},
    {id: 'billing|company|descr', label: 'Company'},
    {id: 'supplier.descr', label: 'Supplier'},
    {
      id: 'needed_at',
      label: 'Needed by',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'created_at',
      label: 'PO Date',
      type: 'date',
      unsearchable: true
    },
    {id: 'received_percentage', label: 'Received %', conditional: true, condition: 'AWAITING_DELIVERY', unsearchable: true},
    {id: 'do_number', label: 'DO #', conditional: true, condition: ['CLOSED', 'FULLY_DELIVERED']},
    {
      id: 'status_date',
      label: 'Closed PO Date',
      conditional: true,
      condition: ['CLOSED', 'FULLY_DELIVERED'],
      type: 'date',
      unsearchable: true
    },
    {
      id: 'status_date',
      label: 'Cancelled PO Date',
      conditional: true,
      condition: 'CANCELLED',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'net_total',
      label: 'Amount',
      type: 'double',
      unsearchable: true
    },
    {id: 'updated_at', label: 'Updated At', conditional: true, condition: 'AWAITING_DELIVERY'},
    {id: 'status', label: 'Status', conditional: true, condition: ['ALL']}
  ];

  initialize();

  $scope.$emit('pageTitleChanged', 'Purchase Orders');

  $scope.$on('$stateChangeStart', function(event, toState, toParams){
    if(!!toParams.status){
      $scope.parentStateParams = toParams;
    }
  });

}
OrdersCtrl.$inject = ['$scope', '$state', '$rootScope', 'Orders', 'starringPO', 'toastr', 'globalFunc'];

angular.module('metabuyer')
  .controller('OrdersCtrl', OrdersCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider, pathConstants) {

    $stateProvider
      .state('main.user.orders', {
        url: '/orders',
        controller: 'OrdersCtrl',
        templateUrl: 'app/orders/orders.html',
        resolve : {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkPOAccess(profile, 'O') || !UserPermissions.checkPOAccess(profile, 'L')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.orders.manage', {
        templateUrl: 'app/orders/manage/manage.html',
        url: '/manage?{query:[a-zA-Z0-9]+}&{status:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'OrdersManageCtrl',
        resolve: {
          orders: function ($rootScope, $q, $state, $stateParams, Orders, searchModule, profile, globalFunc, exportSearch) {
            var deferred = $q.defer();
            var params = {};

            var status = globalFunc.availableStatuses('po', $stateParams.status);

            /**
             * First determine if search or listing
             */
            if (!!$stateParams.query) {
            /**
             * If searching , check if searching with filter
             */
            if (!!$stateParams.filter) {
              params = {
                module: 'PO',
                offset: 20,
                criteria_operator: 'and',
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              }
              else if ($stateParams.type === 'double') {
                temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              }
              else {
                params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
              }
            }
            /**
             * Else for listing and sorting without filter
             * Pass criteria[status] in an array with or condition based on status
             * Submitted tab will list submitted, delivery_date_unconfirmed and awaiting_confirmation status
             * Awaiting delivery tab will list awaiting_delivery, partially_delivered and in_port status
             * Closed tab will list closed and delivered status
             * Declined tab will list declined status
             * Cancelled tab will list cancelled status
             * Starred tab will list PO if stared_by current user
             */
            else {
              params = {
                module: 'PO',
                offset: 20,
                'criteria[1][po_number]': $stateParams.query,
                'criteria[1][pr_number]': $stateParams.query,
                'criteria[1][title]': $stateParams.query,
                'criteria[1][supplier.descr]': $stateParams.query,
                'criteria[1][billing|company|descr]': $stateParams.query,
                'criteria[1][do_number]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'and' : null,
                'criteria[1][$operator]': 'or',
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }
          }
            /**
             * Else for listing
             */
          else{
            params = {
              module: 'PO',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            }
          }

            if (!!status) {
              /**
               * Pass param into status based on tab status
               */
              switch(status){
                case 'SUBMITTED':
                  params['criteria[0][status][0]'] = 'SUBMITTED';
                  params['criteria[0][status][1]'] = 'DELIVERY_DATE_UNCONFIRMED';
                  params['criteria[0][status][2]'] = 'AWAITING_CONFIRMATION';
                  params['criteria[0][$operator]'] = 'or';
                  break;
                case 'AWAITING_DELIVERY':
                  params['criteria[0][status][0]'] = 'AWAITING_DELIVERY';
                  params['criteria[0][status][1]'] = 'PARTIALLY_DELIVERED';
                  params['criteria[0][status][2]'] = 'IN_PORT';
                  params['criteria[0][$operator]'] = 'or';
                  break;
                case 'CLOSED':
                  params['criteria[0][status][0]'] = 'CLOSED';
                  params['criteria[0][status][1]'] = 'FULLY_DELIVERED';
                  params['criteria[0][$operator]'] = 'or';
                  break;
                case 'DECLINED':
                  params['criteria[0][status][0]'] = 'DECLINED';
                  break;
                case 'CANCELLED':
                  params['criteria[0][status][0]'] = 'CANCELLED';
                  break;
                case 'STARRED':
                  params['criteria[0][stared_by][]'] = profile._id;
                  break;
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "PO - listing" + (!!$stateParams.status ? " - " +
              $stateParams.status.toLowerCase() : "");
          }
        }
      })
      .state('main.user.orders.detail', {
        templateUrl: 'app/orders/detail/detail.html',
        url: '/{id:[a-zA-Z0-9]+}?{title:[a-zA-Z0-9]*}&{action:[a-zA-Z0-9]*}',
        controller: 'OrdersDetailCtrl',
        resolve: {
          order: function ($rootScope, $q, $state, toastr, $stateParams, $filter, Orders,
                           authenticated) {
            var deferred = $q.defer();

            if (!authenticated) {
              deferred.resolve({});
              return deferred.promise;
            }

            var method = Orders.get;
            method(
              {id: $stateParams.id},
              function (resource) {
                if(!!resource && !!resource.content && !!resource.content.data){
                  deferred.resolve(resource.content.data);
                } else {
                  deferred.resolve({});
                }
              },
              function (error) {
                toastr.error("PO not found");
                if(!!$rootScope.previousState && !!$rootScope.previousState.name){
                  $state.go($rootScope.previousState.name, $rootScope.previousState.params);
                } else {
                  $state.go('main.user.orders.manage', {status: $stateParams.status || "SUBMITTED"});
                }
              }
            );
            return deferred.promise;
          },
          POSubscriptionCheck: function($q, order, subscriptionCheck){
            var deferred = $q.defer();
            subscriptionCheck.get(
              {
                object_id: order._id,
                class: 'Metabuyer\\Models\\PO'
              },
              function (resource) {
                deferred.resolve(resource);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function($stateParams){
            return "PO - detail" + (!!$stateParams.id? " - " + $stateParams.id : "");
          }
        }
      });
  }]);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider, pathConstants) {

    $stateProvider
      .state('main.user.masterData', {
        url: '/master-data',
        controller: 'MasterDataCtrl',
        abstract: true,
        templateUrl: 'app/masterDataManagement/master-data.html'
      })
      .state('main.user.masterData.currency', {
        templateUrl: 'app/masterDataManagement/currency/manage/manage.html',
        url: '/currency?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'MasterDataManageCurrencyCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkCurrenciesAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkCurrenciesAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkCurrenciesAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();
            var params = {
              module: 'currencies',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              criteria_operator: !!$stateParams.query ? 'or' : null,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Currencies - Master Data';
          }
        }
      })
      .state('main.user.masterData.exchangeRate', {
        templateUrl: 'app/masterDataManagement/exchangeRate/manage/manage.html',
        url: '/exchangerate?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'MasterDataManageExchangeRateCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkExchangeRateAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkExchangeRateAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkExchangeRateAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();
            var params = {
                module: 'exchange-rate',
                'criteria[1][code]': $stateParams.query,
                'criteria[1][descr]': $stateParams.query,
                'criteria[1][$operator]': !!$stateParams.query ? 'or' : null,
                criteria_operator: !!$stateParams.query ? 'and' : null,
                offset: 20,
                'criteria[0][company_id]': '',
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          currencies: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'currencies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Exchange Rates - Master Data';
          }
        }
      })
      .state('main.user.masterData.uom', {
        templateUrl: 'app/masterDataManagement/uom/manage/manage.html',
        url: '/uom?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'MasterDataManageUOMCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
          if (!UserPermissions.checkUOMAccess(profile, 'C', $rootScope.changeWorkSpace) &&
            !UserPermissions.checkUOMAccess(profile, 'U', $rootScope.changeWorkSpace) &&
            !UserPermissions.checkUOMAccess(profile, 'D', $rootScope.changeWorkSpace))  {
            $state.go('notAuthorized');
          }
        },
          uomList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            var params = {
                module: 'uom',
                'criteria[code]': $stateParams.query,
                'criteria[descr]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Units of Measurement - Master Data';
          }
        }
      })
      .state('main.user.masterData.paymentTerms', {
        templateUrl: 'app/masterDataManagement/paymentTerms/manage/manage.html',
        url: '/payment-terms?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'masterDataManagePaymentTermsCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkPaymentTermsAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkPaymentTermsAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkPaymentTermsAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            var params = {
              module: 'payment-term',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              criteria_operator: !!$stateParams.query ? 'or' : null,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Payment Terms - Master Data';
          }
        }
      })
      .state('main.user.masterData.paymentMethods', {
        templateUrl: 'app/masterDataManagement/paymentMethods/manage/manage.html',
        url: '/payment-methods?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'masterDataPaymentMethodsCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkPaymentMethodAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkPaymentMethodAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkPaymentMethodAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            var params = {
              module: 'payment-method',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              criteria_operator: !!$stateParams.query ? 'or' : null,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Payment Methods - Master Data';
          }
        }
      })
      .state('main.user.masterData.commodityCode', {
        templateUrl: 'app/masterDataManagement/commodityCode/manage/manage.html',
        url: '/commodity-code?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&{parentUniqueName:[^~,]}',
        controller: 'masterDataCommodityCodeCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkCommodityCodeAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkCommodityCodeAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkCommodityCodeAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            /**
             * pass parent_unique_name as All in order to list segments
             * Strict field is for determining if search criteria is strict searching, 1 for true 0 for false(default)
             * If parentUniqueName was passed into state parameters, list child instead with strict 1
             */
            var params = {
              module: 'commodity',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              'criteria[parent_unique_name]': !!$stateParams.query ? null : ($stateParams.parentUniqueName ? $stateParams.parentUniqueName : 'All'),
              criteria_operator: !!$stateParams.query ? 'or' : null,
              strict: $stateParams.parentUniqueName ? 1: 0,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if(!!resource.content) {
                  deferred.resolve(resource.content);
                }else{
                  deferred.resolve([]);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Commodity Codes - Master Data';
          }
        }
      })
      .state('main.user.masterData.taxes', {
        templateUrl: 'app/masterDataManagement/taxes/manage/manage.html',
        url: '/taxes?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'MasterDataManageTaxesCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkTaxesManagementAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkTaxesManagementAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkTaxesManagementAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            var params = {
              module: 'tax',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              criteria_operator: !!$stateParams.query ? 'or' : null,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Taxes - Master Data';
          }
        }
      })
      .state('main.user.masterData.expenseTypes', {
        templateUrl: 'app/masterDataManagement/expenseTypes/manage/manage.html',
        url: '/expense-types?{query:[^~,]}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        controller: 'MasterDataManageExpenseTypesCtrl',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkExpenseTypeAccess(profile, 'C', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkExpenseTypeAccess(profile, 'U', $rootScope.changeWorkSpace) &&
              !UserPermissions.checkExpenseTypeAccess(profile, 'D', $rootScope.changeWorkSpace))  {
              $state.go('notAuthorized');
            }
          },
          dataList: function ($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();

            var params = {
              module: 'expense-type',
              'criteria[code]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              criteria_operator: !!$stateParams.query ? 'or' : null,
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Expense Types - Master Data';
          }
        }
      })
  }]);

'use strict';
/**
 * @name MasterDataCtrl
 * @desc Controller for master data controller The tabs will be pushed according to the access rights of the user's profile
 */
function MasterDataCtrl($scope, profile, UserPermissions, $rootScope, $stateParams, $state) {

  $scope.$emit('pageTitleChanged', 'Master Data');
  $scope.status = true;
  $scope.$broadcast('setStatus', $stateParams.status);


  $scope.tabData = [];
  var currencyTab = {
    heading: 'Currencies',
    route: 'main.user.masterData.currency',
    key: 'currency',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkCurrenciesAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkCurrenciesAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkCurrenciesAccess(profile, 'D', $rootScope.changeWorkSpace)) {
    $scope.tabData.push(currencyTab);
  }
  var exchangeRateTab = {
    heading: 'Exchange Rates',
    route: 'main.user.masterData.exchangeRate',
    key: 'exchangeRate',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkExchangeRateAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkExchangeRateAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkExchangeRateAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(exchangeRateTab);
  }

  var uomTab = {
    heading: 'UOM',
    route: 'main.user.masterData.uom',
    key: 'uom',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkUOMAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkUOMAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkUOMAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(uomTab);
  }

  var paymentTermsTab = {
    heading: 'Payment Terms',
    route: 'main.user.masterData.paymentTerms',
    key: 'paymentTerms',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkPaymentTermsAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkPaymentTermsAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkPaymentTermsAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(paymentTermsTab);
  }

  var paymentMethodsTab = {
    heading: 'Payment Methods',
    route: 'main.user.masterData.paymentMethods',
    key: 'paymentMethods',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkPaymentMethodAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkPaymentMethodAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkPaymentMethodAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(paymentMethodsTab);
  }

  var commodityCodesTab = {
    heading: 'Commodity Codes',
    route: 'main.user.masterData.commodityCode',
    key: 'commodityCodes',
    params: {
      cursor: null,
      parentUniqueName: 'All'
    }
  };
  if (!!UserPermissions.checkCommodityCodeAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkCommodityCodeAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkCommodityCodeAccess(profile, 'D', $rootScope.changeWorkSpace)) {
    $scope.tabData.push(commodityCodesTab);
  }

  var taxesTab = {
    heading: 'Taxes',
    route: 'main.user.masterData.taxes',
    key: 'taxes',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkTaxesManagementAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkTaxesManagementAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkTaxesManagementAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(taxesTab);
  }

  var expenseTypesTab = {
    heading: 'Expense Types',
    route: 'main.user.masterData.expenseTypes',
    key: 'expenseTypes',
    params: {
      cursor: null
    }
  };
  if (!!UserPermissions.checkExpenseTypeAccess(profile, 'C', $rootScope.changeWorkSpace) || !!UserPermissions.checkExpenseTypeAccess(profile, 'U', $rootScope.changeWorkSpace)
    || !!UserPermissions.checkExpenseTypeAccess(profile, 'D', $rootScope.changeWorkSpace)) {

    $scope.tabData.push(expenseTypesTab);
  }

  function initialize() {
    if (!!$state.current.name) {
      if ($state.current.name.indexOf('currency') > -1) {
        $scope.activatedTab = currencyTab;
      } else if ($state.current.name.indexOf('exchangeRate') > -1) {
        $scope.activatedTab = exchangeRateTab;
      } else if ($state.current.name.indexOf('uom') > -1) {
        $scope.activatedTab = uomTab;
      } else if ($state.current.name.indexOf('paymentTerms') > -1) {
        $scope.activatedTab = paymentTermsTab;
      } else if ($state.current.name.indexOf('paymentMethods') > -1) {
        $scope.activatedTab = paymentMethodsTab;
      } else if ($state.current.name.indexOf('commodityCode') > -1) {
        $scope.activatedTab = commodityCodesTab;
      } else if ($state.current.name.indexOf('taxes') > -1) {
        $scope.activatedTab = taxesTab;
      } else if ($state.current.name.indexOf('expenseTypes') > -1) {
        $scope.activatedTab = expenseTypesTab;
      }
    }
  }

  initialize();

}
MasterDataCtrl.$inject = ['$scope', 'profile', 'UserPermissions', '$rootScope', '$stateParams', '$state'];

angular
  .module('metabuyer')
  .controller('MasterDataCtrl', MasterDataCtrl);

'use strict';
/**
 * @name MainCtrl
 * @desc The main controller in which the the main panels are loaded NOT including the user information
 */
function MainCtrl($scope, $state, $auth, userSettings, pathConstants, $rootScope, budgetFunctions, globalFunc, $http) {

  $rootScope.imageBasePath = pathConstants.apiUrls.image.pr;

  /**
   * Setting the date picker input's timezone to be in UTC.
   * To be passed to ng-model options
   * Example: ng-model-options = "datepickerTimezone"
   * @type {{timezone: string}}
   */
  $rootScope.datePickerTimezone = {timezone: 'UTC'};

  $scope.logout = logout;
  $scope.navigateSideBar = navigateSideBar;
  $scope.activateSidePanel = activateSidePanel;
  $scope.toggleSearchBar = toggleSearchBar;
  $scope.devInfo = '';
  $scope.isDevEnvironment = '';

  function getTemplateUrl(isMobileBrowser) {
    switch (!!isMobileBrowser) {
      case true:
          $scope.navbarTemplateUrl = 'components/navbar/navbar-mobile.html';
          $scope.sidebarTemplateUrl = 'components/sidebar/sidebar-mobile.html';
          $scope.mobileClass = 'remove-padding-main';
        break;
      case false :
        $scope.navbarTemplateUrl = 'components/navbar/navbar.html';
        $scope.sidebarTemplateUrl = 'components/sidebar/sidebar.html';
        break;
    }
  }

  function logout() {

    swal({
        title: 'Log out',
        text: 'Are you sure you want to log out?',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (!!isConfirm) {
          userSettings.loggedOut();
          $auth.logout();
          $state.go('login');
        }
      }
    );
  }

  /**
   * The sidebar button
   * @param link
   */
  function navigateSideBar(link) {
    $state.go(link.key, {
      status: link.status,
      tab: link.tab,
      order_by: link.order_by,
      order: link.order,
      extraFilterKey: link.extraFilterKey,
      extraFilterValue: link.extraFilterValue
    });
  }

  /**
   * Activates the sidebar styling
   * @param option
   * @return {boolean}
   */
  function activateSidePanel (option) {
    return ($state.includes('main.user.purchaseRequisitions') && option.key.indexOf('main.user.purchaseRequisitions') > -1) ||
      ($state.includes('main.user.orders') && option.key.indexOf('main.user.orders') > -1) ||
      ($state.includes('main.user.mainMenu.waiting-on-you') && option.key.indexOf('main.user.mainMenu.waiting-on-you') > -1
      && !!$rootScope.isMobileBrowser) ||
      ($state.includes('main.user.mainMenu.notifications') && option.key.indexOf('main.user.mainMenu.notifications') > -1
      && !!$rootScope.isMobileBrowser) ||
        /**
         * work around to avoid duplicating the name check
         * as .includes interprets .suppliersList similar to .suppliers
         */
      ($state.current.name.indexOf('main.user.suppliers.') > -1 && option.key.indexOf('main.user.suppliers.') > -1) ||
      ($state.includes('main.user.suppliersList') && option.key.indexOf('main.user.suppliersList') > -1) ||
      ($state.includes('main.user.users') && option.key.indexOf('main.user.users') > -1) ||
      ($state.includes('main.user.items') && option.key.indexOf('main.user.items') > -1) ||
      ($state.includes('main.user.companiesMgmt') && option.key.indexOf('main.user.companiesMgmt') > -1) ||
      ($state.includes('main.user.auditTrail') && option.key.indexOf('main.user.auditTrail') > -1) ||
      ($state.includes('main.user.security') && option.key.indexOf('main.user.security') > -1) ||
      ($state.includes('main.user.reports') && option.key.indexOf('main.user.reports') > -1) ||
      ($state.includes('main.user.exports') && option.key.indexOf('main.user.exports') > -1) ||
      ($state.includes('main.user.settings') && option.key.indexOf('main.user.settings') > -1) ||
      ($state.includes('main.user.approvalFlowManagement') && option.key.indexOf('main.user.approvalFlowManagement') > -1) ||
      ($state.includes('main.user.positionManagement') && option.key.indexOf('main.user.positionManagement') > -1) ||
      ($state.includes('main.user.masterData') && option.key.indexOf('main.user.masterData') > -1) ||
      ($state.includes('main.user.catalogView.catalogItemList') && option.key.indexOf('main.user.catalogView.catalogItemList') > -1);
  }

  function toggleSearchBar() {
    $scope.displaySearchBar = !$scope.displaySearchBar;
  }

  $scope.$on('pageTitleChanged', function (event, data) {
    $scope.pageTitle = data;
    if(!!$rootScope.isMobileBrowser) {
      if ((!!$state.current.name && $state.current.name.indexOf('purchaseRequisitions') > -1) ||
        (!!$state.current.name && $state.current.name.indexOf('orders') > -1)) {
        $scope.enableMobileSearching = true;
      }
      else {
        $scope.enableMobileSearching = false;
      }
    }
  });

  $scope.$on('actionsChanged', function (event, data) {
    $scope.actions = data;
  });

  function initialize () {
    // Display dev string
    if (!!pathConstants.RollbarConfiguration)  {
      var environment = pathConstants.RollbarConfiguration.environment;
      $scope.isDevEnvironment = environment === 'local' || environment === 'development';

      if (!!$scope.isDevEnvironment && $scope.devInfo === '') {
        $http.get(pathConstants.apiUrls.devInfo)
          .then(function (response) {
            if(typeof response.data === 'string') {
              $scope.devInfo = response.data;
            }
          });
      }
    }

    // Initialize budget setting for company to false
    budgetFunctions.setHasBudgetSettingOn(false);
    // Set true if tenant super admin
    if(!!$rootScope.currentUser && !!globalFunc.findInArray($rootScope.currentUser.roles, 'name', 'TENANT_SUPER_ADMIN')) {
      budgetFunctions.setHasBudgetSettingOn(true);
    }
    _.forEach($rootScope.currentUser.companies, function(company) {
      if (!!company.budget_setting.enable) {
        budgetFunctions.setHasBudgetSettingOn(true);
        return false;
      }
    });

    getTemplateUrl($rootScope.isMobileBrowser);
    //Hide sidebar by default if is mobile browser
    if(!!$rootScope.isMobileBrowser) {
      $(document).ready(function(){
        $('body').removeClass('mini-navbar mobile-navbar');
        $('body').addClass('mobile');
      });

      if ((!!$state.current.name && $state.current.name.indexOf('purchaseRequisitions') > -1) ||
        (!!$state.current.name && $state.current.name.indexOf('orders') > -1)) {
        $scope.enableMobileSearching = true;
      }
      else {
        $scope.enableMobileSearching = false;
      }

      $scope.waitingOnYouLink = {
        key : 'main.user.mainMenu.waiting-on-you'
      };
      $scope.notificationsLink = {
        key : 'main.user.mainMenu.notifications'
      };
      $scope.userProfileLink = {
        key : 'main.user.mainMenu.userProfile'
      };
    }
  }

  initialize();
}

MainCtrl.$inject = [
  '$scope', '$state', '$auth', 'userSettings', 'pathConstants', '$rootScope', 'budgetFunctions', 'globalFunc', '$http'
];

angular.module('metabuyer')
  .controller('MainCtrl', MainCtrl);

'use strict';

angular.module('metabuyer')
  .controller('LoginCtrl', function ($scope, $auth, $location, $rootScope, ManageLocalStorage, $state) {

    $scope.isLoginClicked = false;

    $scope.login = function() {
      $scope.isLoginClicked = true;
      $scope.error = null;
      $scope.errorCount = null;

      $auth.login({ email: $scope.email, password: $scope.password })
        .then(function() {

          /**
           * verify the cached data
           */
          var cachedEmail = window.localStorage.getItem('email');
          if (!cachedEmail || cachedEmail !== $scope.email) {
            ManageLocalStorage.clearLocalStorage('All');
          }else {
            ManageLocalStorage.clearLocalStorage();
          }

          window.localStorage.setItem('email', $scope.email);
          if (!!$rootScope.redirectUrl) {
            var tempUrl  = angular.copy($rootScope.redirectUrl);
            $rootScope.redirectUrl = null;
            $location.url(tempUrl);
          }
        })
        .catch(function(response) {
          $scope.isLoginClicked = false;
          if (response && response.data && response.data.message) {
            $scope.error = response.data.message;
            $scope.errorCount = response.data.login_attempts_remaining;
          } else if (response.data === null) {
            $scope.error = 'An unexpected error has occurred. Please try again later.';
          }
        });
    };

  });

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.items', {
        url: '/items',
        controller: 'ItemsCtrl',
        templateUrl: 'app/items/items.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.ImportItemDetail(profile, 'O')
              && !UserPermissions.ImportItemDetail(profile, 'U') && !UserPermissions.ImportItemDetail(profile, 'D')) {
              $state.go('notAuthorized');
            }
            if (!UserPermissions.ImportItemSummary(profile, 'O')
              && !UserPermissions.ImportItemSummary(profile, 'U') && !UserPermissions.ImportItemSummary(profile, 'D')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.items.manageCatalog', {
        templateUrl: 'app/items/manage/manage.html',
        url: '/manage?{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'ItemsManageCtrl',
        resolve: {
          action: function ($stateParams) {
            if($stateParams.query){
              return 'search';
            }
            else{
              return 'show';
            }
          },
          items: function ($q, $state, $stateParams, searchModule, globalFunc, exportSearch) {

            var deferred = $q.defer();
            var status = globalFunc.availableStatuses('catalogs', $stateParams.status);
            var params = {};

            /**
             * First determine if search or listing
             */
            if(!!$stateParams.query){
              /**
               * If searching , check if searching with filter
               */
            if (!!$stateParams.filter) {
              params = {
                module: 'catalogs',
                criteria_operator: !!$stateParams.status ? 'and' : null,
                'criteria[1][import_status]': $stateParams.status !== 'all' ? status : null,
                offset: 20,
                cursor: $stateParams.cursor
              };

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[0][' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                params['criteria[0][' + $stateParams.filter + ']'] = $stateParams.query;
              }
            }
            /**
             * If searching without filter
             */
            else {
              params = {
                module: 'catalogs',
                offset: 20,
                'criteria[0][catalog_group.descr]': $stateParams.query,
                'criteria[0][catalog_code.code]': $stateParams.query,
                'criteria[0][catalog_code.descr]': $stateParams.query,
                'criteria[0][supplier.descr]': $stateParams.query,
                'criteria[0][creator.display_name]': $stateParams.query,
                'criteria[1][import_status]': $stateParams.status !== 'all' ? status : null,
                'criteria[0][$operator]': !!$stateParams.query ? 'or' : null,
                criteria_operator: !!$stateParams.query ? 'and' : null,
                cursor: $stateParams.cursor
              };
            }
          }
            /**
             * For listing
             */
            else{
              params = {
                module: 'catalogs',
                'criteria[import_status]': $stateParams.status ? status : null,
                offset: 20,
                cursor: $stateParams.cursor
              };
            }

            params.order_by = !!$stateParams.order_by ? $stateParams.order_by : 'catalog_code.updated_at';
            params.order =  !!$stateParams.order ? $stateParams.order : 0;

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if(!!resource && !!resource.content && !!resource.content.data){
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve({data: []});
                }
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },

          $title: function($stateParams){
            return "Catalog - listing" + (!!$stateParams.status? " - " + $stateParams.status : "");
          }
        }
      })
      .state('main.user.items.catalogGroup', {
        templateUrl: 'app/items/catalog-group/manage/manage.html',
        url: '/catalog-group/manage?&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'manageCatalogGroupCtrl',
        resolve: {
          dataList: function ($q, globalFunc, $stateParams, searchModule) {

            var deferred = $q.defer();
            var params = {};
            if(!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.filter);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                temp = 'criteria[0][' + $stateParams.filter + ']';
                params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
              }

              params = {
                module: 'catalog-groups',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
            }
            else {
              params = {
                module: 'catalog-groups',
                offset: 20,
                'criteria[0][code]': $stateParams.query,
                'criteria[0][descr]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }

            searchModule.get(
              params,
              function (resource) {
                if(!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content);
                else
                  deferred.resolve({data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          $title: function(){
            return "Catalog - Group - listing";
          }
        }
      })
      .state('main.user.items.createCatalogGroup', {
        templateUrl: 'app/items/catalog-group/add/addCatalogGroup.html',
        url: '/catalog-group/create',
        controller: 'createCatalogGroupCtrl',
        resolve: {
          $title: function(){
            return "Create - Catalog Group";
          }
        }
      })
      .state('main.user.items.editCatalogGroup', {
        templateUrl: 'app/items/catalog-group/edit/editCatalogGroup.html',
        url: '/catalog-group/edit/{id:[a-zA-Z0-9]+}',
        controller: 'editCatalogGroupCtrl',
        resolve: {
          catalogGroupDetails: function($q, $stateParams, companyGroupsList){
            var deferred = $q.defer();
            companyGroupsList.get(
              {
                groupId: $stateParams.id
              },
              function(resource){
                deferred.resolve(resource.content || {data: []});
              },
              function(){
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          companies: function($q, $stateParams, searchModule){
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0
              },
              function(resource){
                deferred.resolve(resource.content || {data: []});
              },
              function(){
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function(){
            return "Edit - Catalog Group";
          }
        }
      })
      .state('main.user.items.catalogCode', {
        templateUrl: 'app/items/catalog-code/manage/ManageCatalogCode.html',
        url: '/catalog-code/manage?&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'ManageCatalogCodeCtrl',
        resolve: {
          dataList: function ($q, globalFunc, $stateParams, searchModule) {

            var deferred = $q.defer();
            var params = {};
            if(!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.filter);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                temp = 'criteria[0][' + $stateParams.filter + ']';
                params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
              }

              params = {
                module: 'catalog-code',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
            }
            else {
              params = {
                module: 'catalog-code',
                offset: 20,
                'criteria[0][code]': $stateParams.query,
                'criteria[0][descr]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }


            searchModule.get(
              params,
              function (resource) {
                if(!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content);
                else
                  deferred.resolve({data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          $title: function(){
            return "Catalog - Code - listing";
          }
        }
      })
      .state('main.user.items.catalogItems', {
        templateUrl: 'app/items/catalog-items/manage/manage.html',
        url: '/catalog-items/manage?&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'manageCatalogItemsCtrl',
        resolve: {
          dataList: function ($q, globalFunc, $stateParams, searchModule, exportSearch) {

            var deferred = $q.defer();
            var params = {};
            if (!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.filter);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else if ($stateParams.type === 'double') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                temp = 'criteria[' + $stateParams.filter + ']';
                params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
              }

              params = {
                module: 'catalog-details',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
            } else {
              params = {
                module: 'catalog-details',
                offset: 20,
                'criteria[0][item_name]': $stateParams.query,
                'criteria[0][description]': $stateParams.query,
                'criteria[0][commodity_code]': $stateParams.query,
                'criteria[0][commodity_descr]': $stateParams.query,
                'criteria[0][supplier.descr]': $stateParams.query,
                'criteria[0][supplier_part_no]': $stateParams.query,
                'criteria[0][payment_term.descr]': $stateParams.query,
                'criteria[0][currency.code]': $stateParams.query,
                'criteria[0][Uom.code]': $stateParams.query,
                'criteria[0][creator.display_name]': $stateParams.query,
                'criteria[0][updater.display_name]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content);
                else
                  deferred.resolve({data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          $title: function(){
            return "Catalog - Items - listing";
          }
        }
      })
      .state('main.user.items.import', {
        templateUrl: 'app/items/import/itemsImportTemplate.html',
        abstract: true,
        controller: 'importItemsCtrl',
        resolve: {
          BUs: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'catalog-groups',
                offset: 0
              },
              function (resource) {
                if(!!resource.content){
                  deferred.resolve(resource.content);
                }else{
                  deferred.resolve([]);
                }
              },
              function () {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function(){
            return "Catalog - Import";
          }
        }
      })
      .state('main.user.items.import.select_bu', {
        templateUrl: 'app/items/import/selectBUTemplate.html',
        url: '/importItems/select_bu'
      })
      .state('main.user.items.import.select_supplier', {
        templateUrl: 'app/items/import/selectSupplierTemplate.html',
        url: '/importItems/select_supplier'
      })
      .state('main.user.items.import.select_file', {
        templateUrl: 'app/items/import/selectFile.html',
        url: '/importItems/select_file?&{importID:[a-zA-Z0-9]+}&{catalogGroupID:[a-zA-Z0-9]+}&' +
             '{supplierID:[a-zA-Z0-9]+}&{catalogCodeID:[a-zA-Z0-9]+}'
      })
      .state('main.user.items.import.confirmation', {
        templateUrl: 'app/items/import/confirmation.html',
        url: '/importItems/confirmation'
      })
      .state('main.user.items.detail', {
        url: '/{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/items/details/details.html',
        controller: 'itemDetailCtrl',
        resolve: {
          managedItem: function ($q, $stateParams, manageItemDetail, authenticated, toastr, $rootScope, $state) {
            var deferred = $q.defer();
            if (!authenticated) {
              deferred.resolve(undefined);
              return deferred.promise;
            }
            manageItemDetail.get({id: $stateParams.id},
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function () {
                toastr.error('Catalog not found');

                if(!!$rootScope.previousState && !!$rootScope.previousState.name){
                  $state.go($rootScope.previousState.name, $rootScope.previousState.params);
                }
              }
            );
            return deferred.promise;
          },
          $title: function($stateParams){
            return "Catalog - detail" + (!!$stateParams.id? " - " + $stateParams.id : "");
          }
        }
      })
  }]);

'use strict';

function ItemsCtrl($scope, $state) {

  $scope.tabData = [
    {
      heading: 'Manage Catalog Uploads',
      route: 'main.user.items.manageCatalog',
      key: 'uploads',
      menu: [
        {
          heading: 'All',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'all',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Approved',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'approved',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Compose',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'compose',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Expired',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'expired',
            query: null
          }
        },
        {
          heading: 'Error',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'error',
            cursor: null,
            query: null
          }
        },
        {
          heading: 'Inactive',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'inactive',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Pending Approval',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'pending',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Rejected',
          route: 'main.user.items.manageCatalog',
          key: 'uploads',
          params: {
            status: 'rejected',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    },
    {
      heading: 'Manage Catalog',
      route: 'main.user.items.catalogGroup',
      key: 'catalog',
      menu: [
        {
          heading: 'Catalog Group',
          route: 'main.user.items.catalogGroup',
          key: 'catalog',
          params: {
            status: '',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Catalog Code',
          route: 'main.user.items.catalogCode',
          key: 'catalog',
          params: {
            status: '',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        },
        {
          heading: 'Catalog Items',
          route: 'main.user.items.catalogItems',
          key: 'catalog',
          params: {
            status: '',
            cursor: null,
            filter: null,
            query: null,
            type: null
          }
        }
      ]
    },
    {
      heading: 'Import Catalog',
      route: 'main.user.items.import.select_bu',
      key: 'import',
      params: {
        status: 'import',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  /**
   * making sure the Stats and placeHolder changes if the Child scope changed
   */
  $scope.$on('$stateChangeStart', function( event, data ) {
    if(!!data.name && data.name.indexOf('manageCatalog')> -1){
      $scope.searchPlaceholder = 'Search Catalogs';
      $scope.searchState = 'main.user.items.manageCatalog';
      $scope.parentState = 'main.user.items.manageCatalog';
      $scope.parentStateParams = $state.params;
      $scope.columns = manageCatalogColumns;
    }
    else if(!!data.name && data.name.indexOf('catalogGroup') > -1){
      $scope.searchPlaceholder = 'Search Catalog Groups';
      $scope.searchState = 'main.user.items.catalogGroup';
      $scope.parentState = 'main.user.items.catalogGroup';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogGroupColumns;
    }
    else if(!!data.name && data.name.indexOf('catalogCode') > -1){
      $scope.searchPlaceholder = 'Search Catalog Code';
      $scope.searchState = 'main.user.items.catalogCode';
      $scope.parentState = 'main.user.items.catalogCode';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogCodeColumns;
    }
    else if(!!data.name && data.name.indexOf('catalogItems') > -1){
      $scope.searchPlaceholder = 'Search Catalog Items';
      $scope.searchState = 'main.user.items.catalogItems';
      $scope.parentState = 'main.user.items.catalogItems';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogItemColumns;
    }
  });

  function initialize(){
    if(!!$state.params && !!$state.params.query){
      $scope.searchText = $state.params.query;
    }
    else{
      $scope.searchText = '';
    }

    if(!!$state.current.name && $state.current.name.indexOf('manageCatalog') > -1) {
      $scope.searchPlaceholder = 'Search Catalogs';
      $scope.searchState = 'main.user.items.manageCatalog';
      $scope.parentState = 'main.user.items.manageCatalog';
      $scope.parentStateParams = $state.params;
      $scope.columns = manageCatalogColumns;
      $scope.activatedTab = $scope.tabData[0]
    }
    else if(!!$state.current.name && ($state.current.name.indexOf('catalogGroup') > -1)
        || ($state.current.name.indexOf('createCatalogGroup') > -1)
        || ($state.current.name.indexOf('editCatalogGroup') > -1)){
      $scope.searchPlaceholder = 'Search Catalog Groups';
      $scope.searchState = 'main.user.items.catalogGroup';
      $scope.parentState = 'main.user.items.catalogGroup';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogGroupColumns;
      $scope.activatedTab = $scope.tabData[1]
    }
    else if(!!$state.current.name && $state.current.name.indexOf('catalogCode') > -1){
      $scope.searchPlaceholder = 'Search Catalog Code';
      $scope.searchState = 'main.user.items.catalogCode';
      $scope.parentState = 'main.user.items.catalogCode';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogCodeColumns;
      $scope.activatedTab = $scope.tabData[1]
    }
    else if(!!$state.current.name && $state.current.name.indexOf('catalogItems') > -1) {
      $scope.searchPlaceholder = 'Search Catalog Items';
      $scope.searchState = 'main.user.items.catalogItems';
      $scope.parentState = 'main.user.items.catalogItems';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogItemColumns;
      $scope.activatedTab = $scope.tabData[1]
    }
    else if(!!$state.current.name && $state.current.name.indexOf('import') > -1) {
        $scope.searchPlaceholder = 'Search Catalogs';
        $scope.searchState = 'main.user.items.manageCatalog';
        $scope.parentState = 'main.user.items.manageCatalog';
        $scope.parentStateParams = $state.params;
        $scope.activatedTab = $scope.tabData[2]
    }
    else{
      $scope.searchPlaceholder = 'Search Catalogs';
      $scope.searchState = 'main.user.items.manageCatalog';
      $scope.parentState = 'main.user.items.manageCatalog';
      $scope.parentStateParams = $state.params;
      $scope.columns = manageCatalogColumns;
      $scope.activatedTab = $scope.tabData[0];
    }

    if(!!$state.params && !!$state.params.status){
      $scope.status = $state.params.status
    }

    if(!!$state.params && !!$state.params.filter){
      $scope.searchFilter = $state.params.filter;
    }


  }

  var manageCatalogColumns = [
    {id: 'check box', title: '', unsortable: true, unsearchable: true, conditional: true, condition: ['pending']},
    {id: 'catalog_group.descr', label: 'Catalog Group'},
    {id: 'catalog_code.code', label: 'Catalog Code'},
    {id: 'catalog_code.descr', label: 'Catalog Description'},
    {id: 'supplier.descr', label: 'Supplier'},
    {
      id: 'file_header|itemcount',
      label: '# item',
      type: 'double',
      unsearchable: true
    },
    {
      id: 'import_effective_date',
      label: 'Effective At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Creator'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'import_status', label: 'Status', conditional: true, condition: 'all'}
  ];

  var catalogGroupColumns = [
    {id: 'code', label: 'Code'},
    {id: 'descr', label: 'Description'},
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'is_active', label: 'Status', unsearchable: true}
  ];

  var catalogCodeColumns = [
    {id: 'code', label: 'Catalog Code'},
    {id: 'descr', label: 'Catalog Code Description'},
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'is_active', label: 'Status', unsearchable: true}
  ];

  var catalogItemColumns = [
    {id: 'item_name', label: 'Item Name'},
    {id: 'description', label: 'Description'},
    {id: 'commodity_code', label: 'Commodity Code'},
    {id: 'commodity_descr', label: 'Commodity Description'},
    {id: 'supplier.descr', label: 'Supplier'},
    {id: 'supplier_part_no', label: 'Supplier Part Number'},
    {id: 'tax.rate', label: 'Tax Rate', unsortable: true},
    {id: 'payment_term.descr', label: 'Payment Term'},
    {id: 'currency.code', label: 'Currency'},
    {
      id: 'unit_price',
      label: 'Unit Price',
      type: 'double',
      unsearchable: true
    },
    {id: 'Uom.code', label: 'UOM'},
    {
      id: 'effective_at',
      label: 'Effective Date',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'expiry_at',
      label: 'Expiry Date',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true},
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    }
  ];

  initialize();

  $scope.$emit('pageTitleChanged', 'Manage Catalog');

  $scope.$on('$stateChangeStart', function(event, toState, toParams){
    if(!!toParams.status){
      $scope.parentStateParams = toParams;
    }
  });
}
ItemsCtrl.$inject = ['$scope', '$state'];


angular.module('metabuyer')
  .controller('ItemsCtrl', ItemsCtrl);

/**
 * @name forgotPasswordCtrl
 *
 * @requires $scope
 * @requires forgottenPassword (Metabuyer service)
 * @requires toastr
 *
 * @description
 *
 * Controller to enable the users request a new password to their email
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Metacloud Sdn. Bhd. &copy; 2016
 */

'use strict';

function forgotPasswordCtrl($scope, forgottenPassword, toastr) {
  
  $scope.sendEmail = sendEmail;
  $scope.passwordResent = false;

  /**
   * function to send an email to the server for a request to send a new password to the email of the user.
   * @param email
   */
  function sendEmail(email) {
    forgottenPassword.post({
        email: email
      }
      , function (success) {
        $scope.passwordResent = true;
        if (!!success.content) {
          $scope.message = success.content.message;
        }
      }
      , function (error) {
        if(!!error.data && !!error.data.content){
          toastr.error(error.data.content.error);
        }
      });
  }

}

forgotPasswordCtrl.$inject = ['$scope', 'forgottenPassword', 'toastr'];

angular
  .module('metabuyer')
  .controller('forgotPasswordCtrl', forgotPasswordCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.exports', {
        url: '/exports',
        controller: 'exportsCtrl',
        templateUrl: 'app/exportsListing/exportsListing.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $rootScope, $state) {
            if (!UserPermissions.checkExportLogAccess(profile, 'C') ||
              !UserPermissions.checkExportLogAccess(profile, 'L') ||
              !UserPermissions.checkExportLogAccess(profile, 'O') ||
              !UserPermissions.checkExportLogAccess(profile, 'U') ||
              !UserPermissions.checkExportLogAccess(profile, 'D')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.exports.log', {
        templateUrl: 'app/exportsListing/logs/logs.html',
        url: '/logs',
        controller: 'exportsLogCtrl',
        resolve: {
          $title: function(){
            return 'Exports - Logs';
          }
        }
      })
  }]);


'use strict';
/**
 * @name exportsCtrl
 * @desc Controller for exports main Controller
 */
function exportsCtrl ($scope) {

  $scope.$emit('pageTitleChanged', 'Exports');

  $scope.tabData = [
    {
      heading: 'Exports Log',
      route: 'main.user.exports.log'
    }
  ];

  $scope.$emit('actionsChanged', []);
}
exportsCtrl.$inject = ['$scope'];

angular
  .module('metabuyer')
  .controller('exportsCtrl', exportsCtrl);

'use strict'

angular
  .module('metabuyer')
  .controller('ExploreAppsCtrl', ExploreAppsCtrl);

function ExploreAppsCtrl($scope, $state){
  $scope.$emit('pageTitleChanged', 'Explore Apps');
  $scope.$emit('actionsChanged', []);

  $scope.apps = [
    { title: 'Analytic' },
    { title: 'Budbget' },
    { title: 'Admin Console' },
    { title: 'Purchase Requisition' },
    { title: 'Purchase Order' },
    { title: 'Inventory' },
    { title: 'Receiving' },
    { title: 'Invoice' },
    { title: '' }
  ];

  $scope.sortableOptions = {
    'ui-floating': true,
    update: function(event, ui){
      console.log('update', ui);
    },
    stop: function(event, ui){
      console.log('stop', ui);
    }
  }
}
ExploreAppsCtrl.$inject = ['$scope', '$state'];

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('main.user.emailLogs', {
        url: '/email-logs',
        controller: 'emailLogsCtrl',
        templateUrl: 'app/emailLogs/emailLogs.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            var check = false;
            if (!!profile.roles && profile.roles.length > 0) {
              for (var index in profile.roles) {
                if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
                  profile.roles[index].name.toLowerCase() === 'tenant_super_admin'){
                  check = true;
                }
              }
            }
            if (!check) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.emailLogs.emailLogsList', {
        templateUrl: 'app/emailLogs/manage/manage.html',
        url: '/manage?&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'emailLogsManageCtrl',
        resolve: {
          dataList: function ($q, globalFunc, $stateParams, searchModule) {

            var deferred = $q.defer();
            var params = {};
            if (!!$stateParams.filter) {
              // Check status
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.filter);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else if ($stateParams.type === 'double') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                temp = 'criteria[0][' + $stateParams.filter + ']';
                params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
              }

              params = {
                module: 'email-logs',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
            } else {
              params = {
                module: 'email-logs',
                offset: 20,
                'criteria[0][receiver_email]': $stateParams.query,
                'criteria[0][subject]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content);
                else
                  deferred.resolve({data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          $title: function() {
            return 'Email Logs';
          }
        }
      })
  }]);

'use strict';

function emailLogsCtrl($scope, $state) {

  $scope.tabData = [
    {
      heading: 'Email Logs',
      route: 'main.user.emailLogs.emailLogsList',
      key: 'emails',
      params: {
        status: '',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  function initialize() {
    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }

    $scope.searchPlaceholder = 'Search Email';
    $scope.searchState = 'main.user.emailLogs.emailLogsList';
    $scope.parentState = 'main.user.emailLogs.emailLogsList';
    $scope.parentStateParams = $state.params;
  }

  $scope.columns = [
    {id: 'receiver_email', label: 'Receiver Email'},
    {id: 'subject', label: 'Subject'},
    {id: 'created_at', label: 'Email sent', unsearchable: true},
    {id: 'updated_at', label: 'Email updated', unsearchable: true},
    {id: 'status', label: 'Status', unsearchable: true}
  ];

  initialize();

  $scope.$emit('pageTitleChanged', 'Email Logs');
}

emailLogsCtrl.$inject = ['$scope', '$state'];

angular.module('metabuyer')
  .controller('emailLogsCtrl', emailLogsCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', 'pathConstants', function ($stateProvider) {

    $stateProvider
      .state('main.user.companiesMgmt', {
        url: '/companies',
        controller: 'CompaniesCtrl',
        templateUrl: 'app/companiesManagement/companiesManagement.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            var check = false;
            if (!!profile.roles && profile.roles.length > 0) {
              for (var index in profile.roles) {
                if ((profile.roles[index].name.toLowerCase() === 'admin' && profile.roles[index].company_code === null) ||
                profile.roles[index].name.toLowerCase() === 'tenant_super_admin') {
                  check = true;
                }
              }
            }
            if (!check) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      //Start of company states
      .state('main.user.companiesMgmt.addCompany', {
        url: '/add-company',
        templateUrl: 'app/companiesManagement/companies/add/add.html',
        controller: 'addCompanyCtrl',
        resolve:{
          BU: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'business-units',
                offset: 0
              },
              function(resource) {
                deferred.resolve(resource.content);
              },
              function(error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          industryList: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'industries',
                offset: 0
              },
              function(resource) {
                deferred.resolve(resource.content);
              },
              function(error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          currenciesList: function ($q, Currencies) {
            var deferred = $q.defer();
            if (!JSON.parse(window.localStorage.getItem('currencies'))) {
              Currencies.get(
                {},
                function (resource) {
                  window.localStorage.setItem("currencies", JSON.stringify(resource.content.data));
                  deferred.resolve(resource.content.data);
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
            }
            else{
              var content = JSON.parse(window.localStorage.getItem('currencies'));
              if(!!content){
                deferred.resolve(content);
              }
              else{
                deferred.resolve([]);
              }

            }
            return deferred.promise;
          },
          expenseTypesList: function($q, metabuyerCache, expenseTypeUserList, globalFunc) {
            var deferred = $q.defer();
            if (!!metabuyerCache.get('expenseTypes')) {
              deferred.resolve(metabuyerCache.get('expenseTypes'));
            } else {
              expenseTypeUserList.get({},
                function (resource) {
                  if (!!resource.content && !!resource.content.data) {
                    deferred.resolve(resource.content.data);
                    metabuyerCache.put('expenseTypes', resource.content.data)
                  }
                }, function (error) {
                  globalFunc.objectErrorMessage(error);
                  deferred.resolve([]);
                }
              )
            }
            return deferred.promise;
          },
          $title: function () {
            return "Companies - Add";
          }
        }
      })
      .state('main.user.companiesMgmt.manageCompanies', {
        url: '/manage?{industry_code:[a-zA-Z0-9]+}&{bu_code:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        templateUrl: 'app/companiesManagement/companies/manage/manage.html',
        controller: 'manageCompanyCtrl',
        resolve: {
          companies: function($q, $stateParams, searchModule) {
            var deferred = $q.defer();
            //For listing companies for a particular BU by id
            if (!!$stateParams.bu_code) {
              searchModule.get(
                {
                  module: 'companies',
                  'criteria[bu_code]': $stateParams.bu_code
                },
                function (resource) {
                  deferred.resolve(resource.content || {data: []});
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
              return deferred.promise;
            }
            //For listing companies for a particular industry by id
            else if (!!$stateParams.industry_code) {
              searchModule.get(
                {
                  module: 'companies',
                  'criteria[industry_code]': $stateParams.industry_code
                },
                function (resource) {
                  deferred.resolve(resource.content || {data: []});
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
              return deferred.promise;
            }
            //For listing companies
            else {
              searchModule.get(
                {
                  module: 'companies',
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                },
                function (resource) {
                  deferred.resolve(resource.content);
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
              return deferred.promise;
            }
          },
          $title: function () {
            return "Companies - listing";
          }
        }
      })
      .state('main.user.companiesMgmt.searchCompanies', {
        url: '/search?{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        templateUrl: 'app/companiesManagement/companies/manage/manage.html',
        controller: 'manageCompanyCtrl',
        resolve: {
          action: function(){
            return "search";
          },
          companies: function($q, searchModule, $stateParams, exportSearch) {
            var deferred = $q.defer();
            var params = {};
            if(!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.query);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = 'criteria[0][' + $stateParams.filter + ']';
              params = {
                module: 'companies',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };

              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                params[temp] = (!!statusCode || statusCode === 0 ) ? statusCode : $stateParams.query;
              }
            }
            else{
              params = {
                module: 'companies',
                offset: 20,
                'criteria[0][code]': $stateParams.query,
                'criteria[0][descr]': $stateParams.query,
                'criteria[0][reg_no]': $stateParams.query,
                'criteria[0][currency_code]': $stateParams.query,
                criteria_operator: 'or',
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                if(!!resource && !!resource.content && !!resource.content.data){
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve({data: []});
                }
              },
              function () {
                deferred.resolve({data: []});
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return "Companies - search";
          }
        }
      })
      .state('main.user.companiesMgmt.detailCompanies', {
        url: '/{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/companiesManagement/companies/details/details.html',
        controller: 'companyDetailCtrl',
        resolve: {
          companyDetails: function($q, Companies, $stateParams, toastr, companyGlobalFunc) {
            var deferred = $q.defer();
            Companies.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
                companyGlobalFunc.setCompanyData(resource.content.data);
              },
              function (error) {
                if(!!error.data&& !!error.data.content){
                  toastr.error(error.data.content.error);
                }
              }
            );
            return deferred.promise;
          },
          companies: function($q, searchModule, $stateParams, toastr) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                toastr.error('Error, Failed to get the companies');
              }
            );
            return deferred.promise;
          },
          currenciesList: function ($q, Currencies) {
            var deferred = $q.defer();
            if (!JSON.parse(window.localStorage.getItem('currencies'))) {
              Currencies.get(
                {},
                function (resource) {
                  window.localStorage.setItem("currencies", JSON.stringify(resource.content.data));
                  deferred.resolve(resource.content.data);
                },
                function (error) {
                  if (error.status === 404) {
                    deferred.resolve([]);
                  }
                }
              );
            }
            else{
              var content = JSON.parse(window.localStorage.getItem('currencies'));
              if(!!content){
                deferred.resolve(content);
              }
              else{
                deferred.resolve([]);
              }

            }
            return deferred.promise;
          },
          BUs: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'business-units',
                offset: 0,

                // Get only active BU = 1
                'criteria[is_active]': 1
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          industryList: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'industries',
                offset: 0
              },
              function(resource) {
                deferred.resolve(resource.content);
              },
              function(error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyCurrencies: function($q, companyCurrencies, $stateParams) {
            var deferred = $q.defer();
            companyCurrencies.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          expenseTypesList: function($q, metabuyerCache, expenseTypeUserList, globalFunc) {
            var deferred = $q.defer();
            if (!!metabuyerCache.get('expenseTypes')) {
              deferred.resolve(metabuyerCache.get('expenseTypes'));
            } else {
              expenseTypeUserList.get({},
                function (resource) {
                  if (!!resource.content && !!resource.content.data) {
                    deferred.resolve(resource.content.data);
                    metabuyerCache.put('expenseTypes', resource.content.data)
                  }
                }, function (error) {
                  globalFunc.objectErrorMessage(error);
                  deferred.resolve([]);
                }
              )
            }
            return deferred.promise;
          },
          $title: function () {
            return "Companies - details";
          }
        }
      })
      .state('main.user.companiesMgmt.companiesExchangeRate', {
        url: '/manage/{id:[a-zA-Z0-9]+}/exchange-rate?{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}',
        templateUrl: 'app/companiesManagement/companies/exchangeRate/manage.html',
        controller: 'companyExchangeRateCtrl',
        resolve: {
          //TODO: have this endpoint child of the company details so that the loading is not done twice (Ahmed Saleh, 25/7/2016)
          companyDetails: function($q, Companies, $stateParams) {
            var deferred = $q.defer();
            Companies.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyExchangeRate: function($q, companyDetails, searchModule,$stateParams, exportSearch){
            var deferred = $q.defer();

            var params = {
              module: 'exchange-rate',
              offset: 20,
              'criteria[company_id]': companyDetails.data._id,
              cursor: $stateParams.cursor,
              order_by: $stateParams.order_by,
              order: $stateParams.order
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          currenciesList: function($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'currencies',
                offset: 0
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Exchange Rate";
          }
        }
      })
      .state('main.user.companiesMgmt.companiesContent', {
        url: '/{id:[a-zA-Z0-9]+}/content',
        templateUrl: 'app/companiesManagement/companies/content/content.html',
        controller: 'companyContentCtrl',
        resolve: {
          $title: function () {
            return 'Companies - Content Management';
          }
        }
      })
      .state('main.user.companiesMgmt.companiesUsers', {
        url: '/manage/{id:[a-zA-Z0-9]+}/users?{code:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{query:[a-zA-Z0-9]+}&{filter:[^~,]}&{type:[^~,]}',
        templateUrl: 'app/companiesManagement/companies/users/manage.html',
        controller: 'companyUsersCtrl',
        resolve: {
          companyDetails: function($q, Companies, $stateParams) {
            var deferred = $q.defer();
            Companies.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyUsers: function($q, searchModule, $stateParams, globalFunc) {
            var deferred = $q.defer();
            var params = {};
            if(!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.query);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = 'criteria[1][' + $stateParams.filter + ']';
              params = {
                module: 'users',
                'criteria[0][companies][]': $stateParams.code,
                'criteria_operator': 'and',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                params[temp] = (!!statusCode || statusCode === 0 ) ? statusCode : $stateParams.query;
              }
            }else{
              params = {
                module: 'users',
                'criteria[0][companies][]': $stateParams.code,
                'criteria[1][display_name]': $stateParams.query,
                'criteria[1][email]': $stateParams.query,
                'criteria[1][emp_no]': $stateParams.query,
                'criteria[1][$operator]': !!$stateParams.query ? 'or' : null,
                'criteria_operator': 'and',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              }
            }
            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                  deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Users";
          }
        }
      })
      .state('main.user.companiesMgmt.companiesAccountCode', {
        url: '/manage/{id:[a-zA-Z0-9]+}/account-code?{query:[^~,]}+{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&{code:[^~,]}',
        templateUrl: 'app/companiesManagement/companies/accountCode/manage.html',
        controller: 'companyAccountCodeCtrl',
        resolve: {
          companyDetails: function($q, Companies, $stateParams) {
            var deferred = $q.defer();
            Companies.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyAccountCodes: function($q, companyDetails, searchModule, $stateParams, exportSearch){
            var deferred = $q.defer();

            var params = {
              module: 'account-code',
              'criteria[name]': $stateParams.query,
              'criteria[descr]': $stateParams.query,
              'criteria[company_code]':  companyDetails.data.code,
              order_by: $stateParams.order_by,
              order: $stateParams.order,
              offset: 20
            };

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return "Companies - details";
          }
        }
      })
      //End of company states

      //Start of business unit states
      .state('main.user.companiesMgmt.addBU', {
        url: '/add-BU',
        templateUrl: 'app/companiesManagement/businessUnits/add/add.html',
        controller: 'addBUCtrl',
        resolve: {
          $title: function ($stateParams) {
            return "Companies - Business Unit - Add";
          }
        }
      })
      .state('main.user.companiesMgmt.manageBusinessUnits', {
        url: '/businessUnits/manage?{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&{code:[^~,]}&{query:[^~,]}&{filter:[^~,]}&{type:[^~,]}',
        templateUrl: 'app/companiesManagement/businessUnits/manage/manage.html',
        controller: 'manageBUCtrl',
        resolve: {
          BU: function($q, searchModule, $stateParams, globalFunc, exportSearch) {
            var deferred = $q.defer();
            var params = {};
            if (!!$stateParams.query) {

              if (!!$stateParams.filter) {
                /**
                 * check for the status
                 */
                if ($stateParams.filter.toLowerCase() === 'status') {
                  var statusCode = globalFunc.getStatusCode($stateParams.query);
                  if (statusCode === null) {
                    statusCode = 1;
                  }
                }
                var temp = 'criteria[0][' + $stateParams.filter + ']';
                params = {
                  module: 'business-units',
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                };
                if ($stateParams.type === 'date') {
                  temp = 'criteria[' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params[temp] = (!!statusCode || statusCode === 0 ) ? statusCode : $stateParams.query;
                }
              } else {
                params = {
                  module: 'business-units',
                  'criteria[0][code]': $stateParams.query,
                  'criteria[0][descr]': $stateParams.query,
                  criteria_operator: !!$stateParams.query ? 'or' : null,
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                }
              }
            }
            else{
              params = {
                module: 'business-units',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function(resource) {
                deferred.resolve(resource.content);
              },
              function(error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Business Unit - Listing";
          }
        }
      })
      .state('main.user.companiesMgmt.detailBusinessUnits', {
        url: '/manage/businessUnits/{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/companiesManagement/businessUnits/details/details.html',
        controller: 'BUDetailCtrl',
        resolve: {
          BUDetails: function($q, singleBU, $stateParams) {
            var deferred = $q.defer();
            singleBU.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Business Unit - Details";
          }
        }
      })
      //End of business unit states

      //Start of industries states
      .state('main.user.companiesMgmt.addIndustry', {
        url: '/add-industry',
        templateUrl: 'app/companiesManagement/industries/add/add.html',
        controller: 'addIndustryCtrl',
        resolve: {
          $title: function ($stateParams) {
            return "Companies - Industry - Add";
          }
        }
      })
      .state('main.user.companiesMgmt.manageIndustries', {
        url: '/industries/manage?{cursor:[^~,]}&{order_by:[^~,]}&{order:[^~,]}&{query:[^~,]}&{filter:[^~,]}&{type:[^~,]}',
        templateUrl: 'app/companiesManagement/industries/manage/manage.html',
        controller: 'manageIndustryCtrl',
        resolve: {
          industryList: function($q, searchModule, $stateParams, globalFunc, exportSearch) {
            var deferred = $q.defer();
            var params = {};
            if(!!$stateParams.query) {
              if (!!$stateParams.filter) {
                /**
                 * check for the status
                 */
                if ($stateParams.filter.toLowerCase() === 'status') {
                  var statusCode = globalFunc.getStatusCode($stateParams.query);
                  if (statusCode === null) {
                    statusCode = 1;
                  }
                }
                var temp = 'criteria[0][' + $stateParams.filter + ']';
                params = {
                  module: 'industries',
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                };
                if ($stateParams.type === 'date') {
                  temp = 'criteria[' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                } else {
                  params[temp] = (!!statusCode || statusCode === 0 ) ? statusCode : $stateParams.query;
                }
              } else {
                params = {
                  module: 'industries',
                  'criteria[code]': $stateParams.query,
                  'criteria[descr]': $stateParams.query,
                  criteria_operator: !!$stateParams.query ? 'or' : null,
                  offset: 20,
                  cursor: $stateParams.cursor,
                  order_by: $stateParams.order_by,
                  order: $stateParams.order
                }
              }
            }
            else{
              params = {
                module: 'industries',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              }
            }

            /**
             * Setting the params to prepare for exporting
             */
            exportSearch.setParams(params);

            searchModule.get(
              params,
              function(resource) {
                deferred.resolve(resource.content);
              },
              function(error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Industries - Listing";
          }
        }
      })
      .state('main.user.companiesMgmt.detailIndustries', {
        url: '/manage/industries/{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/companiesManagement/industries/details/details.html',
        controller: 'industryDetailCtrl',
        resolve: {
          industryDetails: function($q, singleIndustry, $stateParams) {
            var deferred = $q.defer();
            singleIndustry.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return "Companies - Industry - Details";
          }
        }
      })
      //end of industries states

      .state('main.user.companiesMgmt.costCenterDetail', {
        url: '/manage/{companyId:[a-zA-Z0-9]+}/manage/cost-center/{id:[a-zA-Z0-9]+}',
        templateUrl: 'app/companiesManagement/costcenters/address/manage.html',
        controller: 'costCenterAddressesCtrl',
        resolve: {
          costCenterDetails: function($q, CostCenters, $stateParams) {
            var deferred = $q.defer();
            CostCenters.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyDetails: function($q, Companies, $stateParams) {
            var deferred = $q.defer();
            Companies.get(
              {
                id: $stateParams.companyId
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          companyCostCentersList: function($q, companyCostCenters, $stateParams) {
            var deferred = $q.defer();
            companyCostCenters.get(
              {
                id: $stateParams.companyId
              },
              function (resource) {
                deferred.resolve(resource.content || {data: []});
              },
              function (error) {
                if (error.status === 404) {
                  deferred.resolve([]);
                }
              }
            );
            return deferred.promise;
          },
          addresses: function($q, singleAddress, companyDetails) {
            var deferred = $q.defer();
            if (!!companyDetails && !!companyDetails.data && !!companyDetails.data.related_addresses_ids && !!companyDetails.data.related_addresses_ids.length) {
              var promises = [];
              angular.forEach(companyDetails.data.related_addresses_ids, function (id) {
                var promise = singleAddress.get({
                    id: id
                  }
                );
                promises.push(promise.$promise);
              });
              var cleanedAddress = [];
              $q.all(promises).then(function (resource) {
                angular.forEach(resource, function (address) {
                  if (!!address && !!address.content && !!address.content.data) {
                    cleanedAddress.push(address.content.data);
                  }
                });
              }).catch().finally(function () {
                deferred.resolve(cleanedAddress);
              });
            } else {
              deferred.resolve([]);
            }
            return deferred.promise;

          },
          $title: function ($stateParams) {
            return "Companies - Cost Center - Addresses - List";
          }
        }
      })
      .state('main.user.companiesMgmt.detailCompanies.addCostCenter', {
        url: '/cost-center',
        templateUrl: 'app/companiesManagement/costcenters/add/add.html',
        params: {costCenterId: null},
        controller: 'addCostCenterCtrl',
        resolve: {
          companyUsers: function ($q, purchaseRequisitionsServices, globalFunc, $stateParams) {
            var deferred = $q.defer();

            purchaseRequisitionsServices.getContactPersonsList(
              {
                id: $stateParams.id
              }, function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content.data || []);
              }, function (error) {
                globalFunc.objectErrorMessage(error);
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          costCenterData: function () {
            return [];
          },
          costCenterUsers: function () {
            return [];
          }
        }
      })
      .state('main.user.companiesMgmt.detailCompanies.updateCostCenter', {
        url: '/cost-center/{costCenterId:[a-zA-Z0-9]+}?',
        templateUrl: 'app/companiesManagement/costcenters/add/add.html',
        controller: 'addCostCenterCtrl',
        resolve: {
          companyUsers: function ($q, companyActiveUsers, globalFunc, $stateParams) {
            var deferred = $q.defer();

            companyActiveUsers.get(
              {
                id: $stateParams.id
              }, function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content.data || []);
              }, function (error) {
                globalFunc.objectErrorMessage(error);
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          costCenterData: function ($q, CostCenters, $stateParams) {
            var deferred = $q.defer();

            CostCenters.get(
              {
                id: $stateParams.costCenterId
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content.data || []);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          costCenterUsers: function ($q, purchaseRequisitionsServices, globalFunc, $stateParams) {
            var deferred = $q.defer();

            purchaseRequisitionsServices.getAvailableRequestorsList(
              {
                id: $stateParams.costCenterId
              },
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content.data || []);
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          }
        }
      });
  }]);

'use strict';
/**
 * @name CompaniesCtrl
 * @desc Controller for companies
 */
function CompaniesCtrl($scope, $state, globalFunc) {
  $scope.$emit('pageTitleChanged', 'Manage Companies');
  var tempState = _.cloneDeep($state.params);


  /**
   * making sure the Stats and placeHolder changes if the Child scope changed
   */
  $scope.$on('$stateChangeStart', function (event, data, toParams) {
    if (!!data.name && data.name.indexOf('BusinessUnits') > -1) {
      $scope.columns = BUColumns;
      $scope.searchState = 'main.user.companiesMgmt.manageBusinessUnits';
      $scope.searchPlaceHolder = 'Search Business Units';
      $scope.parentState = 'main.user.companiesMgmt.manageBusinessUnits';
      $scope.parentStateParams = $state.params;
    }
    else if (!!data.name && data.name.indexOf('Industries') > -1) {
      $scope.columns = industryColumns;
      $scope.searchState = 'main.user.companiesMgmt.manageIndustries';
      $scope.searchPlaceHolder = 'Search Industries';
      $scope.parentState = 'main.user.companiesMgmt.manageIndustries';
      $scope.parentStateParams = $state.params;
    }
    else if (!!data.name && data.name.indexOf('Users') > -1) {
      $scope.columns = companyUsersColumns;
      $scope.searchState = 'main.user.companiesMgmt.companiesUsers';
      $scope.searchPlaceHolder = 'Search Company Users';
      $scope.parentState = 'main.user.companiesMgmt.companiesUsers';
      $scope.parentStateParams = $state.params;
    }
    else if (!!data.name && data.name.indexOf('Companies') > -1) {
      $scope.columns = companyColumns;
      $scope.searchState = 'main.user.companiesMgmt.searchCompanies';
      $scope.searchPlaceHolder = 'Search Companies';
      $scope.parentState = 'main.user.companiesMgmt.manageCompanies';
      $scope.parentStateParams = $state.params;
    }
    if (!!toParams.status) {
      $scope.parentStateParams = toParams;
    }
  });


  $scope.tabData = [
    {
      heading: 'Companies',
      route: 'main.user.companiesMgmt.manageCompanies',
      key: 'companies',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'companies',
        action: 'companies',
        cursor: null
      })
    },
    {
      heading: 'Business Units',
      route: 'main.user.companiesMgmt.manageBusinessUnits',
      key: 'businessunit',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'businessunit',
        action: 'businessunit',
        cursor: null
      })
    },
    {
      heading: 'Industries',
      route: 'main.user.companiesMgmt.manageIndustries',
      key: 'industries',
      params: globalFunc.filterUrlParams(tempState, {
        status: 'industries',
        action: 'industries',
        cursor: null
      })
    },
    {
      heading: 'Add',
      key: 'add',
      menu: [
        {
          heading: 'Add Company',
          route: 'main.user.companiesMgmt.addCompany',
          key: 'add'
        },
        {
          heading: 'Add Business Unit',
          route: 'main.user.companiesMgmt.addBU',
          key: 'add'
        },
        {
          heading: 'Add Industries',
          route: 'main.user.companiesMgmt.addIndustry',
          key: 'add'
        }
      ]
    }
  ];

  function initialize() {

    if (!!$state.current.name && $state.current.name.indexOf('BusinessUnits') > -1) {
      $scope.columns = BUColumns;
      $scope.searchState = 'main.user.companiesMgmt.manageBusinessUnits';
      $scope.searchPlaceHolder = 'Search Business Units';
      $scope.parentState = 'main.user.companiesMgmt.manageBusinessUnits';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[1];
    } else if (!!$state.current.name && $state.current.name.indexOf('Industries') > -1) {
      $scope.columns = industryColumns;
      $scope.searchState = 'main.user.companiesMgmt.manageIndustries';
      $scope.searchPlaceHolder = 'Search Industries';
      $scope.parentState = 'main.user.companiesMgmt.manageIndustries';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[2];
    }
    else if (!!$state.current.name && $state.current.name.indexOf('companiesUsers') > -1) {
      $scope.columns = companyUsersColumns;
      $scope.searchState = 'main.user.companiesMgmt.companiesUsers';
      $scope.searchPlaceHolder = 'Search Company Users';
      $scope.parentState = 'main.user.companiesMgmt.companiesUsers';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[0];
    }
    else if (!!$state.current.name && $state.current.name.indexOf('add') > -1) {
      $scope.columns = companyColumns;
      $scope.searchState = 'main.user.companiesMgmt.searchCompanies';
      $scope.searchPlaceHolder = 'Search Companies';
      $scope.parentState = 'main.user.companiesMgmt.manageCompanies';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[3];
    }
    else if (!!$state.current.name && $state.current.name.indexOf('Companies') > -1){
      $scope.columns = companyColumns;
      $scope.searchState = 'main.user.companiesMgmt.searchCompanies';
      $scope.searchPlaceHolder = 'Search Companies';
      $scope.parentState = 'main.user.companiesMgmt.manageCompanies';
      $scope.parentStateParams = $state.params;
      $scope.activatedTab = $scope.tabData[0];
    }

    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }
    if (!!$state.params && !!$state.params.status) {
      $scope.status = $state.params.status
    }
    if (!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }

  }

  var companyColumns = [
    {id: 'descr', label: 'Company'},
    {id: 'code', label: 'Code'},
    {id: 'reg_no', label: 'Registration Code'},
    {id: 'currency_code', label: 'Preferred Currency'},
    {id: 'business_unit.descr', label: 'Business Unit'},
    {id: 'industry.descr', label: 'Industry'},
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    }
  ];

  var BUColumns = [
    {id: 'descr', label: 'Business Unit'},
    {id: 'code', label: 'Code'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'is_active',
      label: 'Status',
      unsearchable: true
    }
  ];

  var industryColumns = [
    {id: 'descr', label: 'Industry'},
    {id: 'code', label: 'Industry Code'},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    }
  ];

  var companyUsersColumns = [
    {id: 'display_name', label: 'Full Name'},
    {id: 'email', label: 'Email'},
    {id: 'emp_no', label: 'Employee Number'},
    {id: 'role', label: 'Role(s)', unsortable: true},
    {id: 'manager', label: 'Superior', unsortable: true},
    {id: 'position', label: 'Position', unsortable: true},
    {id: 'cc_list', label: 'Cost Center(s)', unsortable: true},
    {
      id: 'created_at',
      label: 'Created At',
      type: 'date',
      unsearchable: true
    },
    {id: 'creator.display_name', label: 'Created By'},
    {
      id: 'updated_at',
      label: 'Updated At',
      type: 'date',
      unsearchable: true
    },
    {id: 'updater.display_name', label: 'Updated By'},
    {id: 'status', label: 'Status'}
  ];


  initialize();

}
CompaniesCtrl.$inject = ['$scope', '$state', 'globalFunc'];

angular
  .module('metabuyer')
  .controller('CompaniesCtrl', CompaniesCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('main.user.catalogView', {
        url: '/catalogView',
        controller: 'catalogViewCtrl',
        templateUrl: 'app/catalogView/catalogView.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.ImportItemDetail(profile, 'L')
              && !UserPermissions.ImportItemDetail(profile, 'O')) {
              $state.go('notAuthorized');
            }
            if (!UserPermissions.ImportItemSummary(profile, 'L')
              && !UserPermissions.ImportItemSummary(profile, 'O')) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.catalogView.catalogItemList', {
        templateUrl: 'app/catalogView/manage/manage.html',
        url: '/manage?&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'viewCatalogItemsCtrl',
        resolve: {
          dataList: function ($q, globalFunc, $stateParams, searchModule) {

            var deferred = $q.defer();
            var params = {};
            if (!!$stateParams.filter) {
              /**
               * check for the status
               */
              if ($stateParams.filter.toLowerCase() === 'status') {
                var statusCode = globalFunc.getStatusCode($stateParams.filter);
                if (statusCode === null) {
                  statusCode = 1;
                }
              }

              var temp = '';
              if ($stateParams.type === 'date') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else if ($stateParams.type === 'double') {
                temp = 'criteria[' + $stateParams.filter + '][0][]';
                params[temp] = [$stateParams.query[0], $stateParams.query[1]];
              } else {
                temp = 'criteria[0][' + $stateParams.filter + ']';
                params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
              }

              params = {
                module: 'catalog-details',
                offset: 20,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
              params[temp] = (!!statusCode || statusCode === 0) ? statusCode : $stateParams.query;
            } else {
              params = {
                module: 'catalog-details',
                offset: 20,
                'criteria[0][item_name]': $stateParams.query,
                'criteria[0][description]': $stateParams.query,
                'criteria[0][commodity_code]': $stateParams.query,
                'criteria[0][commodity_descr]': $stateParams.query,
                'criteria[0][supplier.descr]': $stateParams.query,
                'criteria[0][supplier_part_no]': $stateParams.query,
                'criteria[0][payment_term.descr]': $stateParams.query,
                'criteria[0][currency.code]': $stateParams.query,
                'criteria[0][Uom.code]': $stateParams.query,
                'criteria[0][creator.display_name]': $stateParams.query,
                'criteria[0][updater.display_name]': $stateParams.query,
                criteria_operator: !!$stateParams.query ? 'or' : null,
                cursor: $stateParams.cursor,
                order_by: $stateParams.order_by,
                order: $stateParams.order
              };
            }

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data)
                  deferred.resolve(resource.content);
                else
                  deferred.resolve({data: []});
              },
              function () {
                deferred.resolve([]);
              }
            );

            return deferred.promise;
          },
          $title: function() {
            return 'Catalog - Items - listing';
          }
        }
      })
  }]);

'use strict';

function catalogViewCtrl($scope, $state) {

  $scope.tabData = [
    {
      heading: 'Catalog Items',
      route: 'main.user.catalogView.catalogItemList',
      key: 'catalog',
      params: {
        status: '',
        cursor: null,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  function initialize() {
    if(!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }

    if(!!$state.current.name && $state.current.name.indexOf('catalogItemList') > -1) {
      $scope.searchPlaceholder = 'Search Catalog Items';
      $scope.searchState = 'main.user.catalogView.catalogItemList';
      $scope.parentState = 'main.user.catalogView.catalogItemList';
      $scope.parentStateParams = $state.params;
      $scope.columns = catalogViewItemColumns;
    }

    if(!!$state.params && !!$state.params.status) {
      $scope.status = $state.params.status
    }

    if(!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }

  }

  var catalogViewItemColumns = [
    {id: 'item_name', label: 'Item Name'},
    {id: 'description', label: 'Description'},
    {id: 'commodity_code', label: 'Commodity Code'},
    {id: 'commodity_descr', label: 'Commodity Description'},
    {id: 'supplier.descr', label: 'Supplier'},
    {id: 'supplier_part_no', label: 'Supplier Part Number'},
    {id: 'tax.rate', label: 'Tax Rate', unsortable: true},
    {id: 'payment_term.descr', label: 'Payment Term'},
    {id: 'currency.code', label: 'Currency'},
    {
      id: 'unit_price',
      label: 'Unit Price',
      type: 'double',
      unsearchable: true
    },
    {id: 'Uom.code', label: 'UOM'},
    {
      id: 'effective_at',
      label: 'Effective Date',
      type: 'date',
      unsearchable: true
    },
    {
      id: 'expiry_at',
      label: 'Expiry Date',
      type: 'date',
      unsearchable: true
    }
  ];

  initialize();

  $scope.$emit('pageTitleChanged', 'Catalog List');
}
catalogViewCtrl.$inject = ['$scope', '$state'];

angular.module('metabuyer')
  .controller('catalogViewCtrl', catalogViewCtrl);

'use strict';

/**
 * Budget management states
 * @description
 * Contains the states in budget and handles the resolve for data
 *
 * @states main.user.budget.manage
 * State for budget listing
 *
 * @states main.user.budget.details
 * State for budget details by id
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('main.user.budget', {
        url: '/budgetManagement',
        controller: 'budgetManagementCtrl',
        templateUrl: 'app/budgetManagement/budgetManagement.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state, budgetFunctions, globalFunc) {
            // Initialize budget setting for company to false
            budgetFunctions.setHasBudgetSettingOn(false);
            // Set true if tenant super admin
            if(!!profile && !!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN')) {
              budgetFunctions.setHasBudgetSettingOn(true);
            }
            _.forEach(profile.companies, function(company) {
              if (!!company.budget_setting.enable) {
                budgetFunctions.setHasBudgetSettingOn(true);
                return false;
              }
            });

            if (!UserPermissions.checkPermissionsAccess(profile, 'L', 'Budget') ||
              !UserPermissions.checkPermissionsAccess(profile, 'O', 'Budget')) {
              $state.go('notAuthorized');
            } else if (!budgetFunctions.getHasBudgetSettingOn()) {
              $state.go('unauthorizedBudgetAccess');
            }
          }
        }
      })
      .state('main.user.budget.manage', {
        templateUrl: 'app/budgetManagement/manage/manage.html',
        url: '/manage?&{status:[a-zA-Z0-9]+}&{query:[a-zA-Z0-9]+}&{cursor:[^~,]}&{order_by:[^~,]}&' +
        '{order:[0-1]}&{filter:[a-zA-Z0-9]+}&{type:[a-zA-Z0-9]+}',
        controller: 'budgetListCtrl',
        resolve: {
          dataList: function ($q, $stateParams, searchModule, budgetFunctions) {
            var deferred = $q.defer();
            var status = budgetFunctions.getBudgetStatus($stateParams.status);

            var params = {
              module: 'budgets',
              offset: 20,
              cursor: $stateParams.cursor,
              order_by: !!$stateParams.order_by ? $stateParams.order_by : 'updated_at',
              order: !!$stateParams.order ? $stateParams.order: 0
            };

            /**
             * searching
             */
            if(!!$stateParams.query) {
              /**
               * searching with a specific filter
               */
              if (!!$stateParams.filter) {
                params['criteria_operator'] = 'and';
                var temp = '';
                if ($stateParams.type === 'date') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else if ($stateParams.type === 'double') {
                  temp = 'criteria[1][' + $stateParams.filter + '][0][]';
                  params[temp] = [$stateParams.query[0], $stateParams.query[1]];
                }
                else {
                  params['criteria[1][' + $stateParams.filter + ']'] = $stateParams.query;
                }
              }
              /**
               * searching all filters
               */
              else {
                params['criteria[1][code]'] = $stateParams.query;
                params['criteria[1][descr]'] = $stateParams.query;
                params['criteria[1][company|descr]'] = $stateParams.query;
                params['criteria[1][cost_center|descr]'] = $stateParams.query;
                params['criteria[1][creator.display_name]'] = $stateParams.query;
                params['criteria[1][updater.display_name]'] = $stateParams.query;
                params['criteria[1][$operator]'] = 'or';
                params['criteria_operator'] = 'and';
              }
            }

            if (status === undefined) {
              params['criteria[0][status][]'] = [0, 1, 2, 3, 4, 5, 6, 7, 8]; // Every status except revision (9)
            }
            else {
              params['criteria[0][status]'] = status;
            }

            searchModule.get(
              params,
              function (resource) {
                if (!!resource && !!resource.content && !!resource.content.data) {
                  deferred.resolve(resource.content);
                } else {
                  deferred.resolve({data: []});
                }
              },
              function (error) {
                deferred.resolve({data: []});
              }
            );
            return deferred.promise;
          },
          $title: function ($stateParams) {
            return 'Budget - Listing' + (!!$stateParams.status ? ' - ' + $stateParams.status : '');
          }
        }
      })
      .state('main.user.budget.details', {
        templateUrl: 'app/budgetManagement/details/details.html',
        url: '/details/{id:[a-zA-Z0-9]+}',
        controller: 'budgetDetailsCtrl',
        resolve: {
          budgetData: function ($q, budgets, $stateParams, globalFunc, toastr, $location) {
            var deferred = $q.defer();
            budgets.get(
              {id: $stateParams.id},
              function (resource) {
                if (!!resource.content && !!resource.content.data) {
                  // if the budget with revision status, redirect to parent budget
                  if (!!resource.content.data.status && resource.content.data.status === 'revision' &&
                    !!resource.content.data.parent_id
                  ) {
                    $location.path('/user/budgetManagement/details/' + resource.content.data.parent_id).search('').replace();
                    $state.reload();
                  }
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                globalFunc.objectErrorMessage(error);
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Budget - Details';
          }
        }
      })
  }]);

'use strict';

/**
 * Controller for budget management
 * @description
 * Contains functions for handling tabs and table columns logic
 *
 * @param $scope
 * @param $state
 *
 * @watch $stateChangeStart
 * Watches on the start of state change, set status and params
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function budgetManagementCtrl($scope, $state, globalFunc) {
  $scope.$emit('pageTitleChanged', 'Budgets List');
  $scope.tabData = [
    {
      heading: 'Draft',
      route: 'main.user.budget.manage',
      key: 'draft',
      id: 'draftBudgetsTab',
      params: {
        status: 'draft',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    },
    {
      heading: 'Pending',
      route: 'main.user.budget.manage',
      key: 'pending',
      id: 'pendingBudgetsTab',
      params: {
        status: 'pending',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    },
    {
      heading: 'Approved',
      route: 'main.user.budget.manage',
      key: 'approved',
      id: 'approvedBudgetsTab',
      params: {
        status: 'approved',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  $scope.tabData.more = [
    {
      heading: 'Expired',
      route: 'main.user.budget.manage',
      key: 'expired',
      id: 'expiredBudgetsTab',
      type: 'more',
      params: {
        status: 'expired',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Withdrawn',
      route: 'main.user.budget.manage',
      key: 'withdraw',
      id: 'withdrawnBudgetsTab',
      type: 'more',
      params: {
        status: 'withdraw',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Rejected',
      route: 'main.user.budget.manage',
      key: 'rejected',
      id: 'rejectedBudgetsTab',
      type: 'more',
      params: {
        status: 'rejected',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Inactive',
      route: 'main.user.budget.manage',
      key: 'inactive',
      id: 'inactiveBudgetsTab',
      type: 'more',
      params: {
        status: 'inactive',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'On Hold',
      route: 'main.user.budget.manage',
      key: 'on hold',
      id: 'onHoldBudgetsTab',
      type: 'more',
      params: {
        status: 'on hold',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Deleted',
      route: 'main.user.budget.manage',
      key: 'deleted',
      id: 'deletedBudgetsTab',
      type: 'more',
      params: {
        status: 'deleted',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    }
  ];

  function initialize() {

    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }
    if (!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }

    if (!!$state.params && !!$state.params.status) {
      $scope.status = $state.params.status;
      //set the default tab on refreshing
      var tempIndex = _.findIndex($scope.tabData, function(tab){
        return tab.params.status === $state.params.status.toLowerCase();
      });

      if(tempIndex < 0) {
        var tempIndex2 = _.findIndex($scope.tabData.more, function (tab) {
          return tab.params.status === $state.params.status
        });
          if(tempIndex2 >= 0) {
          $scope.activatedTab = $scope.tabData.more[tempIndex2];
        }
      }
      else
        $scope.activatedTab = $scope.tabData[tempIndex];
    }

    $scope.searchPlaceholder = 'Search Budgets';
    $scope.searchState = 'main.user.budget.manage';
    $scope.parentState = 'main.user.budget.manage';
    $scope.parentStateParams = $state.params;
  }

  $scope.columns = [
    {
      id: 'check box',
      title: ' ',
      unsortable: true,
      unsearchable: true,
      conditional: true,
      condition: ['pending'],
      unSelectable: true
    },
    {id: 'code', label: 'Budget Code'},
    {id: 'descr', label: 'Title'},
    {id: 'company|descr', label: 'Company'},
    {id: 'cost_center|descr', label: 'Cost Center(s)', unsortable: true},
    {id: 'status', label: 'Status', unsearchable: true},
    {id: 'progress', label: 'Progress',
      condition: 'pending', conditional: true},
    {id: 'start_date', label: 'Start Date', type: 'date', unsearchable: true},
    {id: 'end_date', label: 'End Date', type: 'date', unsearchable: true},
    {id: 'amount', label: 'Amount', type: 'double', unsearchable: true},
    {id: 'used_amount', label: 'Used Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'committed_amount', label: 'Committed Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'block_amount', label: 'Block Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'available_balance', label: 'Available Balance',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'created_at', label: 'Created At', type: 'date', unsearchable: true},
    {id: 'creator.display_name', label: 'Created By'},
    {id: 'updated_at', label: 'Updated At', type: 'date', unsearchable: true},
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'delete_button',
      label: '',
      unsortable: true,
      unsearchable: true,
      unSelectable: true
    }
  ];

  $scope.$on('$stateChangeStart', function( event, toState, toParams ) {
    if(!!toParams.status){
      $scope.status = toParams.status;
      $scope.parentStateParams = toParams;
    }
  });

  initialize();
}
budgetManagementCtrl.$inject = ['$scope', '$state', 'globalFunc'];

angular.module('metabuyer')
  .controller('budgetManagementCtrl', budgetManagementCtrl);

'use strict';

angular.module('metabuyer')
  .config(['$stateProvider', function ($stateProvider) {

    $stateProvider
      .state('main.user.approvalFlow', {
        url: '/approval-flow',
        controller: 'approvalFlowController',
        templateUrl: 'app/approvalFlow/approvalFlow.html',
        resolve: {
          accessRights: function (profile, UserPermissions, $state) {
            if (!UserPermissions.checkApprovalTemplateAccess(profile, 'C') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'L') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'O') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'U') ||
              !UserPermissions.checkApprovalTemplateAccess(profile, 'D')
            ) {
              $state.go('notAuthorized');
            }
          }
        }
      })
      .state('main.user.approvalFlow.manage', {
        templateUrl: 'app/approvalFlow/manage/manage.html',
        url: '/manage',
        controller: 'approvalFlowManagementController',
        resolve: {
          approvalTemplateListing: function($q, approvalTemplates) {
            var deferred = $q.defer();
            approvalTemplates.get(
              {
                limit: 10,
                page: 0,
                'sort[0][key]': 'status',
                'sort[0][direction]': 'ASC',
                'sort[1][key]': 'updated_at',
                'sort[1][direction]': 'DESC'
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          companies: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order_by: 'descr',
                order: 1
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function() {
            return 'Approval Flow - Manage';
          }
        }
      })
      .state('main.user.approvalFlow.detail', {
        templateUrl: 'app/approvalFlow/detail/detail.html',
        url: '/detail/{id:[a-zA-Z0-9]+}',
        controller: 'approvalFlowDetailController',
        resolve: {
          approvalFlowDetail: function($q, approvalTemplateSingle, $stateParams) {
            var deferred = $q.defer();
            approvalTemplateSingle.get(
              {
                id: $stateParams.id
              },
              function (resource) {
                if (!!resource.content) {
                  deferred.resolve(resource.content.data);
                }
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function() {
            return 'Approval Flow - Detail';
          }
        }
      })
      .state('main.user.approvalFlow.preview', {
        templateUrl: 'app/approvalFlow/preview/detail.html',
        url: '/preview',
        controller: 'approvalFlowPreviewController',
        resolve: {
          companies: function ($q, searchModule) {
            var deferred = $q.defer();
            searchModule.get(
              {
                module: 'companies',
                offset: 0,
                order_by: 'descr',
                order: 1
              },
              function (resource) {
                deferred.resolve(resource.content);
              },
              function (error) {
                deferred.resolve([]);
              }
            );
            return deferred.promise;
          },
          $title: function () {
            return 'Approval Flow - Preview';
          }
        }
      })
  }]);

'use strict';

/**
 * @name approvalFlowController
 * @desc Controller for Approval Flow Parent Controller
 */
function approvalFlowController ($scope, $state) {

  $scope.$emit('pageTitleChanged', 'Approval Flow');

  $scope.tabData = [
    {
      heading: 'Approval Flow',
      route: 'main.user.approvalFlow.manage',
      key: 'approvalFlow'
    },
    {
      heading: 'Approval Flow Preview',
      route: 'main.user.approvalFlow.preview',
      key: 'preview'
    }
  ];

  function initialize() {
    if (!!$state.current.name) {
      if ($state.current.name.indexOf('preview') > -1) {
        $scope.parentState = 'main.user.approvalFlow.preview';
        $scope.parentStateParams = $state.params;
        $scope.activatedTab = $scope.tabData[1];
      } else {
        $scope.parentState = 'main.user.approvalFlow.manage';
        $scope.parentStateParams = $state.params;
        $scope.activatedTab = $scope.tabData[0];
      }
    }
  }

  initialize();
}
approvalFlowController.$inject = ['$scope', '$state'];

angular
  .module('metabuyer')
  .controller('approvalFlowController', approvalFlowController);

'use strict';

angular.module('metabuyer.services.waitingOnUserList', ['ngResource'])
  .factory('waitingOnUserList', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.waitingOnUser.list,
      {
        category: '@category',
        offset: '@offset'
      },
      {
        'get': {
          method: 'GET',
          ignoreLoadingBar: true
        }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.users', ['ngResource'])
  .factory('Users', function($resource, $filter, pathConstants){
    //TODO: refactor and simplify this part as well as update the function that uses this resource (Ahmed Saleh)
    var Users = $resource(
      pathConstants.apiUrls.users.list,
      {
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'}
      }
    );
    return Users;
  })
  .factory('searchUser', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.search,
      {
        query: '@text'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('singleUser', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.single,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('passwordUpdate',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.updatingPassword,
      {
      },
      {
        'put': { method: 'PUT' }
      }
    );
  })
  .factory('forgottenPassword',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.forgottenPassword,
      {
      },
      {
        'post': { method: 'POST' }
      }
    );
  })
  .factory('activeUsers', function($resource, $filter, pathConstants){
    return $resource(
      pathConstants.apiUrls.users.activeUsers,
      {

      },
      {
        'get': {method: 'GET'},
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('adminUnlockUser', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.adminUnlockUser,
      {
        id: '@id'
      },
      {
        'put': { method: 'PUT' }
      }
    );
  })
  .factory('userImage', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.image,
      {
        id: '@id'
      },
      {
        'get': { method: 'get' }
      }
    );
  })
  .factory('uploadImage', function($resource, $filter, pathConstants) {
    return{
      uploadImagePath: function (userID) {
        var path = pathConstants.apiUrls.users.image;
        return path.replace(":id", userID);
      }
    }
  })
  .factory('exportUserAssignments', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.exportAssignments,
      {},
      {
        'get': { method: 'get' }
      }
    );
  })
  .factory('userBudget', function ($resource, $filter, pathConstants) {
    var budgetUsers = $resource(
      pathConstants.apiUrls.users.budgets,
      {},
      {
        'get': {method: 'GET'}
      }
    );
    return budgetUsers;
  })
  .factory('userPendingApproval', function ($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.pendingApproval,
      {
        userId: '@userId',
        companyCode: '@companyCode'
      },
      {
        'get': {method: 'GET'}
      }
    );
  });

/**
 * @name userSettings
 *
 * @description
 *
 * This service handles storing, modifying and removing the user's settings across Metabuyer. Also, storing and verifying the data in the local storage.
 *
 * @requires anTinycon
 * @requires $rootScope
 * @requires ManageLocalStorage (Metabuyer service)
 *
 *
 * @function loggedIn
 * This function 'will' be used once a preference is stored and will be applied on the System
 *
 * @function loggedOut
 * This function is called once a user logging out, or forced to logged out.
 * this function will clean the following:
 * 1- favicon, reset it to 0
 * 2- local storage (which can be updated upon once the user has the ability to store preferences)
 * 3- remove the Cached profile as well as the Cost Center
 * 4- remove the Token
 *
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';

function userSettings (anTinycon, $rootScope, ManageLocalStorage, metabuyerCache) {

  var settings = {};
  settings.loggedIn = loggedIn;
  settings.loggedOut = loggedOut;

  function loggedIn() {
  }

  function loggedOut() {
    anTinycon.setBubble(0);
    $rootScope.currentUser = {};
    metabuyerCache.removeAll();
    ManageLocalStorage.clearLocalStorage();
    window.localStorage.removeItem('satellizer_token');
  }
  return settings;
}
userSettings.$inject = ['anTinycon', '$rootScope', 'ManageLocalStorage', 'metabuyerCache'];

angular
  .module('metabuyer')
  .factory('userSettings',userSettings);

'use strict';

function UpdatePRInterceptor($q, $rootScope){
  var interceptor = {
    'response': function (response) {
      //PR detail will catch it for alert message
      $rootScope.$broadcast("changedField");
      return response;
    },

    'responseError': function (rejection) {
      return $q.reject(rejection);
    }
  };

  return interceptor;
}

UpdatePRInterceptor.$inject = ['$q', '$rootScope'];

angular
  .module('metabuyer')
  .factory('UpdatePRInterceptor', UpdatePRInterceptor);



'use strict';

angular.module('metabuyer.services.uoms', ['ngResource'])
  .factory('singleUom',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.uom.single,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' },
        'post': { method: 'POST' },
        'put': { method: 'PUT' }
      }
    );
  })
  .factory('uoms',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.uom.single,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('uomList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.uom.list,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('uomSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.uom.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.taxes', ['ngResource'])
  .factory('taxList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('taxesMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.masterList,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('taxesSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tax.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.suppliersManagement', ['ngResource'])
  .factory('suppliersList',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.list,
        {},
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('suppliersActiveList',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.listActive,
        {},
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('singleSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.single,
        {
          id: '@supplier_id'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'}
        }
      );
    })
  .factory('searchSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.search,
        {
          status: '@status'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('newSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.new,
        {},
        {
          'post': {method: 'POST'},
          'getContactPersons': {
            method: 'GET',
            params: {},
            url: pathConstants.apiUrls.contactPersons.contacts
          },
          'addContactPersons': {
            method: 'POST',
            params: {},
            url: pathConstants.apiUrls.contactPersons.contacts
          }
        }
      );
    })
  .factory('supplierTagViaCompany',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.tagViaCompany,
        {},
        {
          'post': {method: 'POST'}
        }
      );
    })
  .factory('getTagsBySupplierCode',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.tagBySupplierCode,
        {
          supplierCode: '@supplierCode'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('getTagsByCompanyCode',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.tagByCompanyCode,
        {
          companyCode: '@companyCode'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('changeStatus',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.status,
        {
          id: '@id',
          status: '@status'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'}
        }
      );
    })
  .factory('approvalSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvals.status,
        {
          approval_id: '@approval_id',
          status: '@status'
        },
        {
          'post': {method: 'POST'}
        }
      );
    })
  .factory('blackListSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.blackList,
        {
          supplier_id: '@supplier_id',
          comment: '@comment'
        },
        {
          'put': {method: 'PUT'}
        }
      );
    })
  .factory('unBlackListSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.unBlackList,
        {
          supplier_id: '@supplier_id',
          comment: '@comment'
        },
        {
          'put': {method: 'PUT'}
        }
      );
    })
  .factory('draftSupplier',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.draft,
        {
          id: '@id',
          action: '@action'
        },
        {
          'post': {method: 'POST'},
          'put': {method: 'PUT'}
        }
      );
    })
  .factory('supplierArchives',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.archives,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('validateSupplierBranchDeletion',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.suppliers.validateBranchDeletion,
        {
          id:'@id',
          branches: '@branchIDs',
          supplierID: '@supplierId'
        },
        {
          'get': { method: 'GET' }
        }
      )
    })
.factory('supplierBranches',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.suppliers.branches,
      {
        id:'@id'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.notes', ['ngResource'])

.factory('supplierNote',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.purchaseRequisitions.supplierNotes,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET'},
        'patch': { method: 'PATCH'}
      }
    );
  })
  .factory('prSupplier',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.purchaseRequisitions.suppliers,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    });

/**
 * @name supplierGlobalFunc
 *
 * @description Service for supplier global functions
 * This service is for functions that are re-used in supplier modules, to minimize redundancy
 *
 * @function getPaidUpCategory
 * This function is to get the paid up category based on provided paid up amount
 *
 * @function checkHyphenFirstCharacter
 * This function is to check if first character of string is a hyphen "-"
 *
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Deniel Ariesta <deniel.ariesta@gmail.com>
 * @copyright 2016 Metacloud Sdn. Bhd.
 */

'use strict';

function supplierGlobalFunc (globalFunc){
  var supplierStatuses = [
    { val: 1, descr: 'active' },
    { val: 2, descr: 'black_listed' },
    { val: 6, descr: 'inactive' }
  ];
  var supplierApprovalStatuses  = [
    { val: 0, descr: 'pending' },
    { val: 1, descr: 'approved' },
    { val: 2, descr: 'rejected' },
    { val: 3, descr: 'on_hold' }
  ];
  var supplierDraftingStatuses  = [
    { val: 0, descr: 'draft' },
    { val: 1, descr: 'submitted' },
    { val: 2, descr: 'withdrawn' },
    { val: 3, descr: 'approved' },
    { val: 4, descr: 'disproved'}
  ];

  /**
   * To get supplier status List based on supplier status, supplier approval status, and supplier drafting status
   * the supplier status sequence is
   * supplierStatuses, supplierApprovalStatuses, supplierDraftingStatuses
   * means it can be any status
   * @param key
   */
  function generateSupplierStatusList(key) {
    return {
      draft:        [ '*', '*', supplierDraftingStatuses[0][key] ],
      withdrawn:    [ '*', '*', supplierDraftingStatuses[2][key] ],
      pending:      [ '*', supplierApprovalStatuses[0][key], supplierDraftingStatuses[1][key] ],
      active:       [ supplierStatuses[0][key], supplierApprovalStatuses[1][key], '*' ],
      black_listed:  [ supplierStatuses[1][key], supplierApprovalStatuses[1][key], '*' ],
      rejected:     [ '*', supplierApprovalStatuses[2][key], supplierDraftingStatuses[4][key] ],
      inactive:     [ supplierStatuses[2][key], supplierApprovalStatuses[1][key], '*' ],
      approved:     [ '*', supplierApprovalStatuses[1][key], '*' ]
    };
  }

  return {
    getPaidUpCategory: function(paidUpValue) {
      var paidUpCategoryDesc;

      if(!!paidUpValue) {
        if ((paidUpValue >= 1) && (paidUpValue <= 50000))
          paidUpCategoryDesc = '(from 1 to 50,000)';
        else if ((paidUpValue > 50000) && (paidUpValue <= 100000))
          paidUpCategoryDesc = '(from 50,001 to 100,000)';
        else if ((paidUpValue > 100000) && (paidUpValue <= 250000))
          paidUpCategoryDesc = '(from 100,001 to 250,000)';
        else if ((paidUpValue > 250000) && (paidUpValue <= 500000))
          paidUpCategoryDesc = '(from 250,001 to 500,000)';
        else if ((paidUpValue > 500000) && (paidUpValue <= 1000000))
          paidUpCategoryDesc = '(from 500,001 to 1,000,000)';
        else if (paidUpValue > 1000000)
          paidUpCategoryDesc = '(above 1,000,001)';
      }

      return paidUpCategoryDesc;
    },
    /**
     * Get supplier status for status in supplier controller
     * @param supplierStatus
     * @param approvalStatus
     * @param draftingStatus
     * @param statusType
     * @returns {string}
     */
    getSupplierStatus: function(supplierStatus, approvalStatus, draftingStatus, statusType) {

      if (statusType === 'descr'){
        supplierStatus = supplierStatus.toLowerCase();
        approvalStatus = approvalStatus.toLowerCase();
        draftingStatus = draftingStatus.toLowerCase();
      } else if (statusType === 'val') {
        var tempSupplierStatus = globalFunc.findInArray(supplierStatuses, 'val', supplierStatus);
        var tempApprovalStatus = globalFunc.findInArray(supplierApprovalStatuses, 'val', approvalStatus);
        var tempDraftingStatus = globalFunc.findInArray(supplierDraftingStatuses, 'val', draftingStatus);

        if(!!tempSupplierStatus) supplierStatus = tempSupplierStatus.descr;
        if(!!tempApprovalStatus) approvalStatus = tempApprovalStatus.descr;
        if(!!tempDraftingStatus) draftingStatus = tempDraftingStatus.descr;
      }

      if(draftingStatus === 'draft' || draftingStatus === 'withdrawn')
        return draftingStatus;

      if(approvalStatus === 'rejected' || approvalStatus === 'pending')
        return approvalStatus;

      if(approvalStatus === 'approved'){
        if(supplierStatus === 'active' || supplierStatus === 'black_listed' || supplierStatus === 'inactive')
           return supplierStatus;
        else
          return approvalStatus;
      }

      return 'archived';
    },
    /**
     * get the status list based on string status (pending, draft, etc)
     * @param status
     * @returns {Array}
     */
    getSupplierListStatus: function(status) {
      status = status.toLowerCase();
      var supplierStatusList = generateSupplierStatusList('val');
      if (!!supplierStatusList.hasOwnProperty(status))
        return supplierStatusList[status];
      else
        return [];
    },

    /**
     * Preparing supplier group data to send
     * @param groups
     * @returns {{}}
     */
    prepareSupplierGroup: function (groups) {
      var supplierGroup = {};
      _.forEach(groups, function(group) {
        var groupCode = group.code;
        supplierGroup[groupCode] = {
          status: Number(group.supplierGroupStatus)
        };

        if (!!group.reason)
          supplierGroup[groupCode].reason = group.reason;
      });

      return supplierGroup;
    },

    /**
     * Filter inactive payment code
     * @param data
     * @returns object
     */
    filterInactiveCode: function (data) {
      for (var i=0;data.length>i;i++) {
        if (data[i].is_active === 0) {
          data.splice(i,1);
        }
      }
      return data;
    },

    checkHyphenFirstCharacter: function (string) {
      return (!!string && string.substring(0, 1) === '-');
    },
    /**
     * Check if user has system role: Supplier Manager
     *
     * @param {object} user
     * @returns {boolean}
     */
    checkIfUserHasSupplierManagerRole: function (user) {
      if (!user || !user.roles) {
        return false;
      }

      var result = false;
      _.forEach(user.roles, function (role) {
        if (role.name === 'Supplier Manager' && role.company_code === null) {
          result = true;
        }
      });
      return result;
    }
  }
}

supplierGlobalFunc.$inject = ['globalFunc'];

angular
  .module('metabuyer')
  .factory('supplierGlobalFunc',supplierGlobalFunc);

'use strict';

angular.module('metabuyer.services.starringServices', ['ngResource'])
  .factory('prStarring',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.purchaseRequisitions.starring,
        {
          id: '@id'
        },
        {
          'post': { method: 'POST' },
          'delete': { method: 'DELETE' }
        }
      );
    }
  )
  .factory('starringPO',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.starring.listPO,
        {
          id: '@id',
          action: '@action'
        },
        {
          'update': {method: 'PUT'},
          'getStar': {
            method: 'GET',
            params: {
              id: '@id'
            },
            url: pathConstants.apiUrls.users.listPOStar
          }
        }
      );
    }
  );

'use strict';

angular.module('metabuyer.services.roles', ['ngResource'])
  .factory('usersRoles',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.roles.userList,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }
  )
  .factory('rolesList',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.roles.list,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }
  )
  .factory('userPosition',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.roles.position,
        {
          id: '@id',
          positionId: '@positionId'
        },
        {
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }
  )
  .factory('getPermissionsListForRoles',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.roles.listPermissions,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }
  )
  .factory('manageSinglePermissionForRoles',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.roles.managePermissions,
        {
          id: '@id',
          pid: '@pid'
        },
        {
          'post': { method: 'POST' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }
  )
  .factory('roleUsers',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.roles.users,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }
  );

'use strict';

angular.module('metabuyer.services.reports', ['ngResource'])
  .factory('reports', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.reports.generate,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('downloadReport', function($resource, $filter, pathConstants){
    return $resource(
      pathConstants.apiUrls.reports.download,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'download': {
          method: "GET",
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.reports.download
        }
      }
    );
  })
  .factory('checkReportStatus', function($resource, $filter, pathConstants){
    return $resource(
      pathConstants.apiUrls.reports.checkStatus,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('reportTypes', function(){
    var reportTypes = [
      {
        code: 'SPEND',
        descr: 'Spend'
      },
      {
        code: 'RECEIVING',
        descr: 'Receiving Details'
      },
      {
        code: 'REQUISITION_COUNTER',
        descr: 'PR / PO Count Per Status Per Company'
      },
      {
        code: 'REQUISITION',
        descr: 'PR Report'
      },
      {
        code: 'BUDGET',
        descr: 'Budget'
      },
      {
        code: 'SUPPLIER_TAGGING',
        descr: 'Supplier Tags'
      }
    ];

    return {
      getReportTypes: function() {
        return reportTypes;
      }
    }
  });

/**
 * @name reLoginService
 *
 * @description
 *
 * This service prompt the user with a re-Login modal
 *
 *
 * @requires $uibModal
 * @requires $rootScope
 * @requires currentStateData: mandatory when calling the service to redirect in case of successful re-login
 * @requires email: mandatory when calling the service for passing it to the server along with the password to re-login
 * @requires message: mandatory when calling the service to display the reason for re-logining in
 *
 *
 * @function showModal
 * Returns the modal that calls the template and controller with resolved data
 *
 *
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright  Metacloud Sdn. Bhd. &copy; 2016
 */

'use strict';

function reLoginService ($uibModal, $rootScope) {

  function showModal(currentStateData, email, message) {
    if(!$rootScope.reLoginDialogOpen) {
      $rootScope.reLoginDialogOpen = true;
      $uibModal.open({
        templateUrl: 'components/reLogInModal/reLogInModalTemplate.html',
        backdrop: 'static',
        keyboard: false,
        controller: reLogInCtrl,
        resolve: {
          scope: function () {
            return $rootScope;
          },
          currentStateData: function () {
            return currentStateData;
          },
          email: function () {
            return email;
          },
          message: function () {
            return message;
          }
        }
      });
    }
  }

  return showModal;
}

reLoginService.$inject = ['$uibModal', '$rootScope'];

angular
  .module('metabuyer')
  .factory('reLoginService',reLoginService);

'use strict';

angular.module('metabuyer.services.purchaseRequisitions', ['ngResource'])
  .factory('purchaseRequisitionsServices', function($resource, pathConstants){
    return $resource(
      pathConstants.apiUrls.purchaseRequisitions,
      {},
      {
        'getSinglePR': {
          method: 'GET',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.getSinglePR
        },
        'deleteSinglePR': {
          method: 'DELETE',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.getSinglePR
        },
        'searchPRs': {
          method: 'GET',
          params: {},
          url: pathConstants.apiUrls.purchaseRequisitions.searchPRs
        },
        'createPR': {
          method: 'POST',
          params: {},
          url: pathConstants.apiUrls.purchaseRequisitions.createPR
        },
        'updatePRCompanyInfo': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.updatePRCompanyInfo
        },
        'checkPRCompanyInfo': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.checkPRCompanyInfo
        },
        'setPPContactPerson': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setPRContactPerson
        },
        'getContactPersonsList': {
          method: 'GET',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.getPRContactPersons
        },
        'getAvailableDeliveryAddresses': {
          method: 'GET',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.getAvailableDeliveryAddresses
        },
        'getAvailableRequestorsList': {
          method: 'GET',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.getAvailableRequestorsList
        },
        'setExpenseType': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setExpenseType
        },
        'setPaymentTerm': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setPaymentTerm
        },
        'setRequestedBy': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setRequestedBy
        },
        'setNeededByDate': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setNeededByDate
        },
        'updateTitle': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setPRTitle
        },
        'setRemarks': {
          method: 'PUT',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.setRemarks
        },
        'submitPR': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.submitPR
        },
        'withdrawPR': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.withdrawPR
        },
        'setItem': {
          method: 'POST',
          params: {
            id: '@id',
            action: '@action'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.item
        },
        'deleteItem': {
          method: 'DELETE',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.item
        },
        'createNonCatalogItem': {
          method: 'POST',
          params: {
            id: '@user_id'
          },
          url: pathConstants.apiUrls.items.nonCatalog
        },
        'setLumpSum': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.lumpSum
        },
        'addCollaborator': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.collaborators
        },
        'removeCollaborator': {
          method: 'DELETE',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.collaborators
        },
        'approvalAction': {
          method: 'POST',
          params: {
            approval_id: '@approval_id',
            status: '@status'
          },
          url: pathConstants.apiUrls.approvals.status
        },
        'printPdf': {
          method: 'GET',
          params: {
            approval_id: '@approval_id',
            status: '@status'
          },
          url: pathConstants.apiUrls.approvals.status
        },
        'duplicate': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.duplicate
        },
        'addSupplierNote': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.supplierNotes
        },
        'updateSupplierNote': {
          method: 'PUT',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.supplierNotes
        },
        'moveToDraft': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.moveToDraft
        },
        'requestEditableCopy': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.requestEditableCopy
        },
        'submitEditableCopy': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.submitEditedCopy
        },
        'cancelEditableCopy': {
          method: 'POST',
          params: {
            id: '@id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.cancelEditedCopy
        },
        'resetApproval' : {
          method: 'POST',
          params: {
            approval_id: '@approval_id'
          },
          url: pathConstants.apiUrls.purchaseRequisitions.resetApproval
        }
      }
    );

  })
  .factory('getPRPDFHash',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.purchaseRequisitions.pdfHash,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    });

/**
 * @name preventDoubleClickingService
 *
 * @description
 * Small service used in controller to prevent clicking on the same link (anchor) twice
 *
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright  Metacloud Sdn. Bhd. &copy; 2017
 */

'use strict';

function preventDoubleClickingService ($interval) {

  //The time is set to 300 milliseconds
  //TODO: move the value of the time to a configuration file once available (Ahmed Saleh, 18/1/17)
  var globalTimer = 300;
  var allowClicking = true;
  return {
    checkClick: function () {
      if (allowClicking) {
        allowClicking = false;

        $interval(function () {
          allowClicking = true;
        }, globalTimer, 0);

        return true
      } else {
        return false;
      }
    }
  }
}

preventDoubleClickingService.$inject = ['$interval'];

angular
  .module('metabuyer')
  .factory('preventDoubleClickingService',preventDoubleClickingService);

'use strict';

/**
 * @name prFunction
 *
 * @requires $state
 *
 * @description Service for PR functions
 * This service is for functions that are re-used in PR modules, to minimize redundancy
 *
 * @function validateLumpSum
 * This function will return a message in case there is an error in the lump sum,
 * then the controllers will remove that from their respectively
 *
 * @authors Ahmed Saleh
 * @copyright Sunway Metacloud &copy; 2016
 */

function prFunction(purchaseRequisitionsServices, $q, prStarring, lang, globalFunc, $rootScope) {

  var globalPRData = {};
  var loading = {};
  var contactPerson = [];
  var mentionUsers = [];
  var approvalFlow = {};
  var taxes = [];
  var submitErrors = [];
  var costCenterDeliveryAddresses = [];
  var accountCodes = [];
  var currencyList = [];
  var PREditableState = 'editable';
  var isShoppingMode = false;
  var itemErrorsFound = false;

  return {
    initializePRData: function (pr) {
      this.clearPRData();
      this.setPRData(pr);
    },
    clearPRData: function() {
      globalPRData = {};
      loading = {};
      contactPerson = [];
      mentionUsers = [];
      approvalFlow = {};
      taxes = [];
      submitErrors = [];
      costCenterDeliveryAddresses = [];
      accountCodes = [];
      currencyList = [];
      PREditableState = 'editable';
      isShoppingMode = false;
      itemErrorsFound = false;
    },
    /**
     * @function validateLumpSum
     * this function will return a message in case there is an error in the lump sum,
     * then the controllers will remove that from their respectively
     *
     * @param newItem
     * new Item that is tested before adding
     * @param index
     * item index
     *
     * @returns {{}}
     */
    validateLumpSum: function (newItem, index) {
      var items = angular.copy(globalPRData.pr_items) || [];
      var prevSupplier = '';
      var prevPaymentTerm = '';
      var prevTax = '';
      var prevDeliveryAddress = '';
      var prevSupplierBranch = '';
      var errorMessage = {
        status: true,
        message: ''
      };

      // adding item temporally to the list to evaluate it
      if (!!newItem && index === -1) {
        if (!newItem.tax && !!newItem.tax_id)
          newItem.tax = {_id: newItem.tax_id};
        items.push(newItem);
      }
      else if (!!newItem && index > -1)
        items[index] = newItem;

      if (!items || (!!items && !items.length))
        return errorMessage;

      if (!!items && !!items.length) {
        _.forEach(items, function (item) {
          // validate supplier
          // check if the supplier exist (non catalog)
          if (!item.supplier) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.notHaving + 'supplier';
            return true;
          }
          else if (!!item && !!item.supplier && !prevSupplier)
            prevSupplier = item.supplier._id;

          // check if the items having the same supplier
          if (item.supplier._id !== prevSupplier) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.different + 'supplier';
            return true;
          }

          // validate payment term
          // check if the payment term exist (non catalog)
          if (!item.payment_term) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.notHaving + 'payment term';
            return true;
          }
          else if (!!item && !!item.payment_term && !prevPaymentTerm)
            prevPaymentTerm = item.payment_term._id;

          // check if the items having the same payment term
          if (item.payment_term._id !== prevPaymentTerm) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.different + 'payment term';
            return true;
          }

          // validate tax
          // check if the tax exist (non catalog)
          if (!item.payment_term) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.notHaving + 'tax';
            return true;
          }
          else if (!!item && !!item.tax && !prevTax)
            prevTax = item.tax._id;

          // check if the items having the same payment term
          if (!!item.tax && item.tax._id !== prevTax) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.different + 'tax';
            return true;
          }

          // set initial delivery address
          if (!!item.delivery_address && !!item.delivery_address._id && !prevDeliveryAddress)
            prevDeliveryAddress = item.delivery_address;

          // check if the items having the same delivery address
          if ((!!item.delivery_address && item.delivery_address._id !== prevDeliveryAddress) ||
            (!item.delivery_address && !!prevDeliveryAddress)) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.different + 'delivery address';
            return true;
          }

          // set initial supplier branch
          if (!!item.branch && !!item.branch._id && !prevSupplierBranch) {
            prevSupplierBranch = item.branch._id;
          }

          // check if the items have the same branch
          if ((!!item.branch && item.branch._id !== prevSupplierBranch) ||
            (!item.branch && !!prevSupplierBranch)) {
            errorMessage.status = false;
            errorMessage.message = lang.validation.lumpSum.different + 'supplier branch';
            return true;
          }
        });

        return errorMessage;
      }
    },
    removeLumpSum: function (prId, callback) {
      var self = this;
      self.setLoading('lineItemTable', true);
      self.setLoading('updatePRField', true);
      purchaseRequisitionsServices.setLumpSum({
        id: prId
      }, {}, function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data)
          self.setPRData(resource.content.data);

        self.setLoading('lineItemTable', false);
        callback(true);
      }, function (error) {
        self.setLoading('lineItemTable', false);
        globalFunc.objectErrorMessage(error);
        callback(false);
      });
    },
    /**
     * To set PR data and update to local variable
     * @param pr
     */
    setPRData: function (pr) {
      globalPRData = this.updatePRData(pr);
      $rootScope.$broadcast('PRDataUpdated');
    },

    /**
     * to return the globalPRData value
     * use this service to share data between directives in PR
     * @returns {{}}
     */
    getPRData: function () {
      return globalPRData;
    },

    /**
     * set loading object in PR
     * @param loadingObject
     * @param loadingValue
     */
    setLoading: function (loadingObject, loadingValue) {
      loading[loadingObject] = loadingValue;
    },

    /**
     * get loading data
     * @param loadingObject
     * @returns {{}}
     */
    getLoading: function (loadingObject) {
      return loading[loadingObject];
    },
    setContactPerson: function (contactPersons) {
      contactPerson = contactPersons;
    },
    getContactPerson: function () {
      return contactPerson;
    },
    setApprovalFlow: function (approvalFlowData) {
      approvalFlow = approvalFlowData;
    },
    getApprovalFlow: function () {
      return approvalFlow;
    },
    setTaxData: function (taxData) {
      taxes = taxData;
    },
    getTaxData: function () {
      return taxes;
    },
    setCurrenciesData: function (currencyData) {
      currencyList = currencyData;
    },
    getCurrenciesData: function () {
      return currencyList;
    },
    setErrorsOnSubmit: function (errors) {
      submitErrors = errors;
    },
    getErrorsOnSubmit: function () {
      return submitErrors;
    },
    setCostCenterDeliveryAddresses: function (addresses) {
      costCenterDeliveryAddresses = addresses;
    },
    getCostCenterDeliveryAddresses: function () {
      return costCenterDeliveryAddresses;
    },
    setAccountCodes: function (accountCodesData) {
      accountCodes = accountCodesData;
    },
    getAccountCodes: function () {
      return accountCodes;
    },
    setEditableState: function (state) {
      PREditableState = state;
    },
    getEditingState: function () {
      return PREditableState;
    },
    setShoppingModeStatus: function (mode) {
      isShoppingMode = mode;
    },
    getShoppingModeStatus: function () {
      return isShoppingMode;
    },
    removeItem: function (itemId) {
      return purchaseRequisitionsServices.deleteItem({
        id: itemId
      });
    },
    setItem: function (item, field, param) {
      return purchaseRequisitionsServices.setItem({
        id: item._id,
        action: field
      }, param);
    },
    refreshPRData: function () {
      var deferred = $q.defer();
      purchaseRequisitionsServices.getSinglePR(
        {
          id: this.getPRData()._id
        }, function (resource) {
          deferred.resolve(resource);
        }, function (error) {
          deferred.resolve([]);
        });
      return deferred.promise;
    },
    /**
     * lis the the IDs into an array so that its easy to handle later on
     * @returns {Array}
     */
    getPRItemsIDs: function () {
      var tempArray = [];
      _.forEach(this.getPRData().pr_items, function (item) {
        if (!!item.item_details) {
          tempArray.push(item.item_details._id);
        }
      });
      return tempArray;
    },
    getPRSuppliers: function () {
      var items = angular.copy(globalPRData.pr_items) || [];
      var suppliers = [];
      var newFormat = {};
      _.forEach(items, function (item) {
        if (!!item.supplier) {
          newFormat = {
            id: item.supplier._id,
            label: item.supplier.descr,
            code: item.supplier.code
          };

          if (!globalFunc.findInArray(suppliers, 'id', newFormat.id)) {
            suppliers.push(newFormat);
          }
        }
      });
      return suppliers;
    },
    /**
     * Starring PRs service
     * @param req
     * @param addStar
     * @returns {*|{method, params, url}|{method}}
     */
    requisitionStarring: function (req, addStar) {
      if (addStar) {
        return prStarring.post(
          {
            id: req._id
          }
        );
      } else {
        return prStarring.delete(
          {
            id: req._id
          }
        );
      }
    },
    /**
     * checked for the conditions:
     * 1- Waiting on user
     * 2- is PA
     * 3- is PA System Level
     * @param waitings
     * @param userId
     * @param roles
     * @returns {boolean}
     */
    checkCurrentApproverIsPA: function (waitings, userId, roles) {
      if (!waitings || !_.isArray(waitings) || !userId || !roles || !_.isArray(roles))
        return false;

      if (waitings.indexOf(userId) === -1)
        return false;

      var validRole = false;

      _.forEach(roles, function (role) {
        if (role.name === 'PA' && role.company_code === null) {
          validRole = true;
        }
      });

      return validRole;
    },
    /**
     * To modify pr data for backup and input entry
     * @param pr
     */
    updatePRData: function (pr) {
      _.forEach(pr.pr_items, function (item) {
        // Set discount_entry
        item.discount_entry = item.discount;
        if (!!item.discount_percentage)
          item.discount_entry = item.discount_percentage + '%';

        // set freight entry
        item.freights.entry = item.freights.amount;
        if (!!item.freights.amount_percentage)
          item.freights.entry = item.freights.amount_percentage + '%';

        // set freight discount
        item.freights.discount_entry = item.freights.discount_amount;
        if (!!item.freights.discount_percentage)
          item.freights.discount_entry = item.freights.discount_percentage + '%';

        // set transportation entry
        item.transportation.entry = item.transportation.amount;
        if (!!item.transportation.amount_percentage)
          item.transportation.entry = item.transportation.amount_percentage + '%';

        // set transportation discount
        item.transportation.discount_entry = item.transportation.discount_amount;
        if (!!item.transportation.discount_percentage)
          item.transportation.discount_entry = item.transportation.discount_percentage + '%';

        // set backup value
        item.backup_discount = angular.copy(item.discount_entry);
        item.backup_qty = angular.copy(Number(item.qty));
        item.backup_unit_price = angular.copy(Number(item.unit_price));
        item.backup_needed_by_date = angular.copy(item.needed_by_date);
        item.backup_note = angular.copy(item.note);
        item.backup_tax = angular.copy(item.tax);
        item.backup_freights = angular.copy(item.freights);
        item.backup_transportation = angular.copy(item.transportation);
      });

      // Update Lumpsum discount_entry
      pr.lump_sum_discount_entry = (pr.lump_sum_discount > -1 ? pr.lump_sum_discount : null);
      if (!!pr.lump_sum_discount_percentage)
        pr.lump_sum_discount_entry = pr.lump_sum_discount_percentage + '%';

      pr.backup_lump_sum_discount = angular.copy(pr.lump_sum_discount);

      return pr;
    },
    setDisplayWarningBlock: function (errors) {
      itemErrorsFound = errors;
    },
    getDisplayWarningBlock: function () {
      return itemErrorsFound;
    },
    /**
     * return an array of the catalog group ids within the PR company, by reading the User's companies
     * @returns {Array}
     */
    getCatalogGroup: function () {
      var company = globalFunc.findInArray($rootScope.currentUser.companies, '_id', this.getPRData().company._id);
      var ids = [];
      _.forEach(company.catalog_groups, function(group){
        ids.push(group._id);
      });
      return ids;
    }
  }
}

prFunction.$inject = ['purchaseRequisitionsServices', '$q', 'prStarring', 'lang', 'globalFunc', '$rootScope'];


angular
  .module('metabuyer')
  .factory('prFunction', prFunction);

'use strict';

angular.module('metabuyer.services.permissions', ['ngResource'])
  .factory('usersPermissions',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.permissions.userList,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('permissionsList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.permissions.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('permissionsParameters',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.permissions.parameters,
      {
        class: '@class'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.pdfPreview', ['ngResource'])
  .factory('pdfPreview', function ($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.pdfPreview.preview,
      {
        id: '@id'
      },
      {
        'post': {method: 'POST'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.paymentTerms', ['ngResource'])
  .factory('paymentTermsList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentTerms.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
.factory('paymentTermsMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentTerms.masterList,
      {
      },
      {
        'get': { method: 'GET' },
        'post': {method: 'POST'}
      }
    );
  })
  .factory('singlePaymentTerm',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentTerms.single,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' },
        'put': {method: 'PUT'},
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('searchPaymentTerms',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentTerms.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.paymentMethods', ['ngResource'])
  .factory('paymentMethodsList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentMethods.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('paymentMethodsMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentMethods.masterList,
      {
      },
      {
        'get': { method: 'GET' },
        'post': {method: 'POST'}
      }
    );
  })
  .factory('searchPaymentMethods',
    function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.paymentMethods.search,
      {
        query: '@query'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('singlePaymentMethod',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.paymentMethods.single,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'delete': {method: 'DELETE'}
        }
      );
    });

'use strict';

angular.module('metabuyer.services.orders', ['ngResource'])
  .factory('Orders', function ($resource, pathConstants) {
    var Orders = $resource(
      pathConstants.apiUrls.po.single,
      {
        id: '@id',
        status: '@status'
      },
      {
        'search': {
          method: 'GET',
          url: pathConstants.apiUrls.po.search
        },

        'resendPO': {
          method: 'PUT',
          params:{
            id: "@id"
          },
          url: pathConstants.apiUrls.po.resend
        },
        'setPOStatus': {
          method: 'PUT',
          params:{
            id: "@id"
          },
          url: pathConstants.apiUrls.po.single
        },
        'closeLineItem': {
          method: 'PUT',
          params:{
            po_id: "@po_id",
            item_id: "@item_id"
          },
          url: pathConstants.apiUrls.po.closeLineItem
        }
      }
    );
    return Orders;
  })
  .factory('generatePO',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.po.single,
      {
        id: '@id'
      },
      {
        'post': { method: 'POST' }
      }
    );
  })
  .factory('getPOPDFHash',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.po.hash,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('listPOs',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.po.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.notification', ['ngResource'])
  .factory('notificationCount',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.notification.count,
      {},
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('notificationSubscriber',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.notification.subscribe,
      {
        method: '@method'
      },
      {
        'post': {method: 'POST'},
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('subscriptionCheck',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.notification.subscriptionCheck,
      {
        object_id: '@object_id',
        class: '@class'
      },
      {
        'get': {method: 'get'}
      }
    );
  })
  .factory('notificationList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.notifications,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET',
          ignoreLoadingBar: true
        },
        'delete': {method: 'DELETE',
          ignoreLoadingBar: true}
      }
    );
  })
  .factory('unreadNotificationCount',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.countUnreadNotifications,
      {},
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('unreadNotificationList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.unreadNotifications,
      {},
      {
        'get': {method: 'GET',
          ignoreLoadingBar: true}
        ,
        'delete': {method: 'DELETE'}
      }
    );
  }).factory('readNotificationList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.users.readNotifications,
      {},
      {
        'post': {method: 'POST',
          ignoreLoadingBar: true
        }
      }
    );
  });

'use strict';

angular.module('metabuyer')
  .factory('NewPRFirstLoad', function() {
    var newPRFirstLoad = {};

    newPRFirstLoad.isFirstLoad = false;

    newPRFirstLoad.set = function() {
      return newPRFirstLoad.isFirstLoad = true;
    };

    newPRFirstLoad.unset = function() {
      return newPRFirstLoad.isFirstLoad = false;
    };

    return newPRFirstLoad;
  });

/**
 * @name metabuyerClockChecker
 *
 * @description
 *
 * This service manages the clock functions needed
 *
 *
 * @requires toastr
 *
 *
 *
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Metacloud Sdn. Bhd. &copy; 2016
 */

'use strict';

function metabuyerClockChecker (toastr) {

  var clockChecker = {};


  return clockChecker;
}
metabuyerClockChecker.$inject = ['toastr'];

angular
  .module('metabuyer')
  .factory('metabuyerClockChecker',metabuyerClockChecker);

/**
 * @name metabuyerInterceptor
 *
 * @requires $q
 * @requires $rootScope
 * @requires $injector
 *
 *
 * @description
 *
 * This Interceptors handles All the Success and Rejection requests as well as setting up the User Company in the header
 *
 * mb_company is the variable in which the workspace Company is stored, it accepts a company ID
 *
 * In case of Successful requests the header Authorization will be updated, unless its the Automatic updates for the notifications
 * The Authorization is not refreshed in case of the Notifications by checking the endpoint is 'api/users/notifications/unread'
 *
 * rejection codes:
 * 409: for user getting kicked out when other user login with the same user data
 * 306: password reset is required
 * 423: account is locked by the Admin
 * 401: invalid verified by having the token stored and not removed it means the session has expired
 * 401: invalid verified by Not having a token stored which means the redirect was not correct
 * 503: Metabuyer is under maintenance
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright  Metacloud Sdn. Bhd. &copy; 2016
 */

'use strict';
function metabuyerInterceptor ($q, $rootScope, $injector) {
  return {
    'request': function (config) {
      /**
       * Adding the Company code to the header after a successful log in
       */
      if (!!$rootScope.companyWorkSpace) {
        // Add header if any here
      }

      // added parameter in url
      // for backend to debugging
      // if(config.url.indexOf('http://localhost:8000') > -1){
      //   var debugKey = 'metabuyer';
      //   if(config.url.indexOf('?') > -1)
      //     config.url += '&';
      //   else
      //     config.url += '?';
      //
      //   config.url += 'XDEBUG_SESSION_START=' + debugKey;
      // }

      return config;
    },
    'response': function (response) {
      /**
       * The session to be updated only if the user clicked on anything, in case if its the automatic notification it should be ignored
       */
      if (!!response.config) {
        if (String(response.config.url.indexOf('api/users/notifications/unread')) < 1 && String(response.config.url.indexOf('api/waiting')) < 1) {
          if (!!response.headers('authorization')) {
            $injector.get('$auth').setToken(response.headers('authorization'), true);
          }
        }
      }

      return response;
    },

    'responseError': function (rejection) {
      var auth = $injector.get('$auth');
      var reLoginService = $injector.get('reLoginService');

      /**
       * 401: invalid verified by Not having a token stored which means the redirect was not correct
       */
      if (rejection.status === 401 && !window.localStorage.satellizer_token && !$rootScope.reLoginDialogOpen) {
        $injector.get('$state').go('login');
      }

      /**
       * handling the cases where a  reLogin modal is needed
       */
      if (!$rootScope.reLoginDialogOpen) {

        var message = '';
        var email = window.localStorage.getItem('email');
        var currentStateData = {
          name: $injector.get('$state').current.name,
          params: $injector.get('$state').params,
          url: $injector.get('$state').href($injector.get('$state').current.name, $injector.get('$state').params)
        };


        /**
         * checking for a kicked out state
         */
        if (rejection.status === 409) {
          if(!!rejection.data && !!rejection.data.message){
            message = rejection.data.message;
          }
          else{
            message = 'Another Login was made using this user or was kicked out by the Admin. Please Contact the Admin if this is wrong';
          }
          reLoginService(currentStateData, window.localStorage.email, message);

        }

        /**
         * 401: invalid verified by having the token stored and not removed it means the session has expired by the Admin
         */
        if (rejection.status === 401 && !!window.localStorage.satellizer_token) {
          message = 'The session has expired';
          reLoginService(currentStateData, window.localStorage.email, message);
        }
      }


      /**
       * redirect to the reset page state
       */
      if (rejection.status === 306) {
        $injector.get('$state').go('passwordReset');
      }

      /**
       * redirect to under maintenance page state
       */
      if (rejection.status === 503) {
        $injector.get('$state').go('underMaintenance');

        /**
         * ensure the token is removed so more calls is being fired since the system is under maintenance
         */
        auth.logout();
      }

      /**
       * redirect to account locked page state
       */
      if (rejection.status === 423) {
        $injector.get('$state').go('accountLocked');
      }

      return $q.reject(rejection);
    }
  }
}

metabuyerInterceptor.$inject = ['$q', '$rootScope', '$injector'];
angular
  .module('metabuyer')
  .factory('metabuyerInterceptor',metabuyerInterceptor);


/**
 * @name metabuyerCache
 *
 * @description
 *
 * This service will create the cache variable with only one ID
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

function metabuyerCache ($cacheFactory) {

  return $cacheFactory('metabuyer');
}
metabuyerCache.$inject = ['$cacheFactory'];

angular
  .module('metabuyer')
  .factory('metabuyerCache',metabuyerCache);

/**
 * @name ManageLocalStorage
 *
 * @requires metabuyerCache (metabuyer service)
 *
 * @description This is a service for removing the stored data in the local storage
 *
 *
 * @authors Ahmed Saleh
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

angular.module('metabuyer')
  .factory('ManageLocalStorage', function(metabuyerCache) {

    var manageLocalStorage = {};
    manageLocalStorage.clearLocalStorage = clearLocalStorage;

    /**
     * list of Sensitive data to be removed on all cases
     * @type {string[]}
     */
    var sensitiveKeys = ['currencies', 'expenseTypes', 'paymentMethods', 'taxes', 'uoms', 'workSpace', 'roles',
      'activeSuppliersForTagging'];

    /**
     * removing either Sensitive data or All data (including Cache), in both Cases the satellizer_token is Not removed
     * @param flag
     */
    function clearLocalStorage(flag) {

      if (flag === 'All') {

        metabuyerCache.removeAll();

        for (var key in localStorage) {
          if (key !== 'satellizer_token')
            window.localStorage.removeItem(key);
        }
      } else {
        angular.forEach(sensitiveKeys, function (key) {
          window.localStorage.removeItem(key);
        });
      }
    }

    return manageLocalStorage;
  });

'use strict';

angular.module('metabuyer.services.itemsCategoriesServices', ['ngResource'])
    .factory('itemsCategories', ['$resource', 'pathConstants',
        function($resource, pathConstants) {
          return $resource(
            pathConstants.apiUrls.itemsCategories.list,
            {
              code: '@code'
            }, {
              'get': {method: 'GET'}
            });
        }]);

'use strict';

angular.module('metabuyer.services.itemsServices', ['ngResource'])
    .factory('items',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.items.list,
        {
          status:'@status'
        },
        {
          'update': { method: 'PUT' },
          'get': { method: 'GET'},
          'post': {method: 'POST'},
          'approve': {
            method: 'POST',
            params: {
              approval_id: '@approval_id',
              status: '@status'
            },
            url: pathConstants.apiUrls.approvals.status
          }
        }
      );
    })
  .factory('createNonCatalogItem',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.nonCatalog,
      {
        id:'@user_id'
      },
      {
        'post': {method: 'POST'}
      }
    );
  })
  .factory('updateNonCatalogItem',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.manageNonCatalog,
      {
        user_id:'@user_id',
        item_id: '@item_id',
        action: '@action',
        pr_cc: '@pr_cc'
      },
      {
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('deleteNonCatalogItem',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.manageNonCatalog,
      {
        user_id:'@user_id',
        item_id: '@item_id',
        action: '@action',
        itemName: '@itemName',
        pr_cc: '@pr_cc'
      },
      {
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('manageItemDetail',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.detail,
      {
        id: '@id'
      },
      {
        'update': { method: 'PUT' },
        'get': { method: 'GET'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('deleteItems',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.delete,
      {
        id: '@id'
      },
      {
        'delete': { method: 'DELETE' }
      }
    );
  })
  .factory('importItems', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.import,
      {
        attachmentFile: '@attachmentFile',
        img_url: '@img_url'
      },
      {
        'post': {method: 'POST'}
      }
    );
  })
  .factory('changeStatusCatalog', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.changeStatus,
      {
        status: '@status',
        id: '@id'
      },
      {
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('catalogVersion', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.catalogVersion,
      {
        supplier_id: '@supplier_id',
        BU: '@BU'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('downloadFile', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.download,
      {
        supplier_id: '@supplierId',
        company_id: '@companyId'
      },
      {
        'get': {
          method: 'GET'
        },
        'download': {
          method: "GET",
          params: {
            summary_id: "@summary_id",
            attachment_id: "@attachment_id"
          },
          url: pathConstants.apiUrls.items.download
        }
      }
    );
  })
  .factory('checkImport', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.checkImport,
      {
        supplier_id: '@supplier_id',
        BU: '@BU'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('itemDetailStarring',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.items.itemDetailStarring,
        {
          user_id: '@user_id',
          item_id: '@item_id',
          group: '@group'
        }, {

          'update': { method: 'PUT' }

        });
    })
  .factory('uploadImage', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.imagesUpload,
      {
        user_id: '@user_id',
        item_id: '@item_id',
        detail_id: '@detail_id'
      },
      {
        'post': {method: 'POST'}
      }
    );
  })
  .factory('viewHistoryDetails',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.historyDetails,
      {
        summary_id: '@summary_id'
      },
      {
        'get': { method: 'GET' }
      });
  })
  .factory('itemDetailsListing',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.itemDetailsListing,
      {
        summary_id: '@summary_id',
        status: '@status'
      },
      {
        'get': { method: 'GET' }
      });
  })
  .factory('singleItemDetails',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.singleItemDetails,
      {
        summary_id: '@summary_id',
        import_item_id: '@import_item_id'
      },
      {
        'get': { method: 'GET' }
      });
  })
  .factory('getCatalogCodeListing',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.items.listCatalogCode,
      {
        supplier_id: '@supplier_id',
        BU: '@BU'
      },
      {
        'get': { method: 'GET' }
      });
  })
  .factory('registerViewedItem', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.items.registerViewedItem,
        {
          user_id: '@user_id',
          item_id: '@item_id'
        }, {
          put: { method: 'PUT', ignoreLoadingBar: true }
        });
    }]);



'use strict';

angular.module('metabuyer.services.industries', ['ngResource'])
  .factory('listingIndustries',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.industry.list,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('newIndustry',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.industry.new,
      {
      },
      {
        'post': { method: 'POST' }
      }
    );
  })
  .factory('singleIndustry',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.industry.single,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' },
        'put': { method: 'PUT' },
        'delete': { method: 'DELETE' }
      }
    );
  });

'use strict';

angular.module('metabuyer')
  .factory('HighlightId', function(){

      var highlightPRId = {};

    highlightPRId.setId = function (value) {
      this.id = value;
    };

    highlightPRId.getId = function () {
      return this.id;
    };

    return highlightPRId;
  });

'use strict';

angular.module('metabuyer.services.GRN', ['ngResource'])
  .factory('getGRN',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.po.grn,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('getGRNPDFHash',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.po.getGRNPDFHash,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'}
        }
      );
    });

/**
 * @name globalFunc
 *
 * @requires $state
 * @requires availability
 *
 * @description Service for global functions
 * This service is for functions that are re-used in multiple modules, to minimize redundancy
 *
 * @function objectErrorMessage
 * This function is to check if error is object or string and returns the toastr accordingly
 *
 * @function countryCode
 * This function is to populate the country code listing
 *
 * @function duplicationCheck
 * This function is to check for duplicate values for the model, field, value
 *
 * @function validateLumpSum
 * This function will return a message in case there is an error in the lump sum,
 * then the controllers will remove that from their respectively
 *
 * @function availableStatuses
 * This function will validate and return the available statuses for the Modules
 *
 * @function reformatFromObjectToArray
 * This function will return a formatted Array from an Object
 *
 * @function convertDateToTimestamp
 * convert Date into timestamp milisecond
 *
 * @function capitalizeFirstCharacter
 * gets a string capitalize the first character
 *
 * @function sortObjectsArray
 * sorts the arrays that are an Objects based
 *
 * @function translateSecurityClasses
 * Function returns a formatted name for the security classes
 *
 * @function nextAvailableAction
 * Find the next available action from each module and return the next object
 *
 * @function getStatusCode
 * function returns the code for each status
 *
 * @function getImportSummaryStatusCode
 * function to return the import status code
 *
 * @function filterUrlParams
 * function to prepare the tabData params
 *
 * @function removeDuplicateObjects
 * removed duplicated objects in arrays
 *
 * @function findObjectInArrayWithKeyValue
 * function returns an object that is inside an array that has a key
 *
 * @function getArrayOfKeyValues
 * function to return key values in an array, from an array of objects
 *
 * @function isMobileBrowser
 * function to return if current browser is on a mobile platform
 *
 * @function emailFormatValidation
 * function to return true or false if email has the correct format
 *
 * @function checkIfUserHasPARole
 * function to check in a user's roles for a PR role
 *
 * @function createStringBasedOnObjectKeyInArray
 * function to return a string based on selected object key in the array
 * join by comma separated
 *
 * @function toFixedDecimalPlaces
 * function to return a string for number to fixed decimal places (does not do any rounding)
 *
 * @author Deniel Ariesta <deniel.ariesta@gmail.com>
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Hafiz Suhaimi <pisyek@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

'use strict';

function globalFunc (toastr, availability, $q, waitingOnUserList, $filter) {
  return {
    objectErrorMessage: function (err) {
      // Check the error is Object or string
      // If String then load the message
      // else Loop the message object
      // added new condition to handle different format of error
      if (typeof err === 'string') {
        return toastr.error(err);
      } else if (!!err.data && !!err.data.message && (typeof err.data.message === 'string')) {
        return toastr.error(err.data.message);
      } else if (!!err && !!err.message && (typeof err.message === 'string')) {
        return toastr.error(err.message);
      }
      else if (!!err && !!err.content && !!err.content.error && (typeof err.content.error === 'string')) {
        return toastr.error(err.content.error);
      } else if (!!err.data && (!!err.data.content && (!!err.data.content.message || err.data.content.error) &&
          ((typeof err.data.content.message) === 'string' || (typeof err.data.content.error) === 'string'))) {
        return toastr.error(err.data.content.message || err.data.content.error);
      } else if (!!err.data && (!!err.data.error && (!!err.data.error.message || err.data.error.error) &&
          ((typeof err.data.error.message) === 'string' || (typeof err.data.error.error) === 'string'))) {
        return toastr.error(err.data.error.message || err.data.error.error);
      }
      else {
        var errorObject = (!!err.content && !!err.content.error) ? err.content.error :
          (!!err.data && !!err.data.message) ? err.data.message :
            (!!err.data && !!err.data.content && !!err.data.content.error) ? err.data.content.error :
            (!!err.data && !!err.data.content && !!err.data.content.message) ? err.data.content.message : [];
        // loop the error object
        _.forEach(errorObject, function (errorData, key) {
          // Get the object key
          if (typeof errorData !== 'string') {
            angular.forEach(errorData, function (val, objKey) {
              // show the array value of the Error from the json
              return toastr.error(objKey + ' line ' + key + ': ' + val);
            });
          } else {
            return toastr.error(errorData);
          }
        });
      }
    },

    // list State code
    malaysiaState: function () {
      var malaysiaState = [];
      var malaysiaStateObject = {
        'MY-01': 'Johor',
        'MY-02': 'Kedah',
        'MY-03': 'Kelantan',
        'MY-04': 'Melaka',
        'MY-05': 'Negeri Sembilan',
        'MY-06': 'Pahang',
        'MY-07': 'Perak',
        'MY-08': 'Perlis',
        'MY-09': 'Penang',
        'MY-10': 'Selangor',
        'MY-11': 'Terengganu',
        'MY-12': 'Sabah',
        'MY-13': 'Sarawak',
        'MY-14': 'WP Kuala Lumpur',
        'MY-15': 'WP Labuan',
        'MY-16': 'WP Putrajaya'
      };

      for (var key in malaysiaStateObject) {
        if (malaysiaStateObject.hasOwnProperty(key)) {
          var temp = {
            code: key,
            descr: malaysiaStateObject[key]
          };
          malaysiaState.push(temp);
        }
      }

      return malaysiaState;

    },

    // list Country Code
    countryCode: function () {
      var countryCode = [];
      var countryCodeObject = {
        'AF': 'Afghanistan',
        'AX': 'Åland Islands',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AS': 'American Samoa',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AQ': 'Antarctica',
        'AG': 'Antigua and Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AW': 'Aruba',
        'AU': 'Australia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BJ': 'Benin',
        'BM': 'rBermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia',
        'BA': 'Bosnia and Herzegovina',
        'BW': 'Botswana',
        'BV': 'Bouvet Island',
        'BR': 'Brazil',
        'IO': 'British Indian Ocean Territory',
        'BN': 'Brunei Darussalam',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'CV': 'Cape Verde',
        'KY': 'Cayman Islands',
        'CF': 'Central African Republic',
        'TD': 'Chad',
        'CL': 'Chile',
        'CN': 'China',
        'CX': 'Christmas Island',
        'CC': 'Cocos (Keeling) Islands',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CG': 'Congo',
        'CD': 'Congo, The Democratic Republic of The',
        'CK': 'Cook Islands',
        'CR': 'Costa Rica',
        'CI': 'Cote D\'ivoire',
        'HR': 'Croatia',
        'CU': 'Cuba',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'EC': 'Ecuador',
        'EG': 'Egypt',
        'SV': 'El Salvador',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'ET': 'Ethiopia',
        'FK': 'Falkland Islands (Malvinas)',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'FR': 'France',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'DE': 'Germany',
        'GH': 'Ghana',
        'GI': 'Gibraltar',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GG': 'Guernsey',
        'GN': 'Guinea',
        'GW': 'Guinea-bissau',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HM': 'Heard Island and Mcdonald Islands',
        'VA': 'Holy See (Vatican City State)',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'ID': 'Indonesia',
        'IR': 'Iran, Islamic Republic of',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IM': 'Isle of Man',
        'IL': 'Israel',
        'IT': 'Italy',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JE': 'Jersey',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KP': 'Korea, Democratic People\'s Republic of',
        'KR': 'Korea, Republic of',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': 'Lao People\'s Democratic Republic',
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libyan Arab Jamahiriya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MO': 'Macao',
        'MK': 'Macedonia, The Former Yugoslav Republic of',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MQ': 'Martinique',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'YT': 'Mayotte',
        'MX': 'Mexico',
        'FM': 'Micronesia, Federated States of',
        'MD': 'Moldova, Republic of',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'AN': 'Netherlands Antilles',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'NU': 'Niue',
        'NF': 'Norfolk Island',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestinian Territory, Occupied',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Reunion',
        'RO': 'Romania',
        'RU': 'Russian Federation',
        'RW': 'Rwanda',
        'SH': 'Saint Helena',
        'KN': 'Saint Kitts and Nevis',
        'LC': 'Saint Lucia',
        'PM': 'Saint Pierre and Miquelon',
        'VC': 'Saint Vincent and The Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome and Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SL': 'Sierra Leone',
        'SG': 'Singapore',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'GS': 'South Georgia and The South Sandwich Islands',
        'ES': 'Spain',
        'LK': 'Sri Lanka',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SJ': 'Svalbard and Jan Mayen',
        'SZ': 'Swaziland',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SY': 'Syrian Arab Republic',
        'TW': 'Taiwan, Province of China',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania, United Republic of',
        'TH': 'Thailand',
        'TL': 'Timor-leste',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad and Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TC': 'Turks and Caicos Islands',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
        'GB': 'United Kingdom',
        'US': 'United States',
        'UM': 'United States Minor Outlying Islands',
        'UY': 'Uruguay',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VE': 'Venezuela',
        'VN': 'Vietnam',
        'VG': 'Virgin Islands, British',
        'VI': 'Virgin Islands, U.S.',
        'WF': 'Wallis and Futuna',
        'EH': 'Western Sahara',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe'
      };

      for (var key in countryCodeObject) {
        if (countryCodeObject.hasOwnProperty(key)) {
          var temp = {
            code: key,
            descr: countryCodeObject[key]
          };
          countryCode.push(temp);
        }
      }

      return countryCode;
    },

    /**
     *  Function to validate the Statues for the Manage screens
     *  In case of the the status was not valid the first one will be selected from the available ones as standard
     *  All statuses are returned base on the information provided by the backend
     *
     * @param module
     * @param status
     * @returns {string}
     */
    availableStatuses: function (module, status) {
      var statusesList;
      var usersStatuses = [
        {
          name: 'pending',
          value: 0
        },
        {
          name: 'active',
          value: 1
        },
        {
          name: 'inactive',
          value: 2
        },
        {
          name: 'rejected',
          value: 3
        }
      ];

      var poStatuses = [
        {
          name: 'submitted',
          value: 'SUBMITTED'
        },
        {
          name: 'delivery_date_unconfirmed',
          value: 'DELIVERY_DATE_UNCONFIRMED'
        },
        {
          name: 'awaiting_confirmation',
          value: 'AWAITING_CONFIRMATION'
        },
        {
          name: 'partially_delivered',
          value: 'PARTIALLY_DELIVERED'
        },
        {
          name: 'awaiting_delivery',
          value: 'AWAITING_DELIVERY'
        },
        {
          name: 'in_port',
          value: 'IN_PORT'
        },
        {
          name: 'closed',
          value: 'CLOSED'
        },
        {
          name: 'delivered',
          value: 'DELIVERED'
        },
        {
          name: 'cancelled',
          value: 'CANCELLED'
        },
        {
          name: 'declined',
          value: 'DECLINED'
        },
        {
          name: 'starred',
          value: 'STARRED'
        }
      ];
      var prStatuses = [
        {
          name: 'draft',
          value: 'DRAFT'
        },
        {
          name: 'pending',
          value: 'PENDING'
        },
        {
          name: 'approved',
          value: 'APPROVED'
        },
        {
          name: 'deleted',
          value: 'DELETED'
        }, {
          name: 'withdrawn',
          value: 'WITHDRAWN'
        },
        {
          name: 'starred',
          value: 'STARRED'
        },
        {
          name: 'rejected',
          value: 'REJECTED'
        }
      ];

      var catalogImportStatuses = [
        {
          name: 'all',
          value: null
        },
        {
          name: 'compose',
          value: 0
        },
        {
          name: 'pending',
          value: 1
        },
        {
          name: 'approved',
          value: 2
        },
        {
          name: 'deleted',
          value: 3
        },
        {
          name: 'expired',
          value: 4
        },
        {
          name: 'rejected',
          value: 5
        },
        {
          name: 'active',
          value: 6
        },
        {
          name: 'inactive',
          value: 7
        },
        {
          name: 'error',
          value: 8
        },
        {
          name: 'NEW_ITEM',
          value: 10
        },
        {
          name: 'UPDATED_ITEM',
          value: 11
        },
        {
          name: 'DELETED_ITEM',
          value: 12
        },
        {
          name: 'TOTAL_ITEM',
          value: 13
        },
        {
          name: 'NO_UPDATE',
          value: 14
        }
      ];

      //TODO: Pass the correct value for All when backend provides
      var supplierStatuses = [
        {
          name: 'all',
          value: 'ALL'
        },
        {
          name: 'active',
          value: 1
        },
        {
          name: 'draft',
          value: 4
        },
        {
          name: 'pending',
          value: 0
        },
        {
          name: 'black_listed',
          value: 2
        },
        {
          name: 'rejected',
          value: 3
        },
        {
          name: 'withdrawn',
          value: 5
        },
        {
          name: 'inactive',
          value: 6
        },
        {
          name: 'archived',
          value: 'ARCHIVED'
        }];


      if (module === 'users') {
        statusesList = usersStatuses;
      }
      if (module === 'po') {
        statusesList = poStatuses;
      }
      if (module === 'pr') {
        statusesList = prStatuses;
      }
      if (module === 'catalogs') {
        statusesList = catalogImportStatuses;
      }
      if (module === 'suppliers') {
        statusesList = supplierStatuses;
      }

      if (!!status) {
        for (var i in statusesList) {
          if (status.toLowerCase() === statusesList[i].name) {
            return statusesList[i].value;
          }
        }
      }

      return statusesList[0].value;

    },
    /**
     * @function duplicationCheck
     * Uses availability service to check if value provided already exists for the field inside the model
     *
     * @params model
     * For the module/class to be validated
     *
     * @params field
     * For the field being validated for duplicated value
     *
     * @params value
     * For the value to be checked for duplicate
     *
     * @params checker
     * To determine what field for the html side for validations/error messages/red highlights
     *
     * @params callback
     * For callback function to pass value to controller to be used in html
     **/
    duplicationCheck: function (model, field, value, checker, callback) {
      if (!!value) {
        var params = {
          model: model,
          field: field,
          value: value
        };
        if (model.toLowerCase() === 'supplier' && field === 'descr')
          params['ignore_dots'] = 1;

        availability.get(
          params,
          function (resource) {
            if (!!resource) {
              switch (checker) {
                case 'code':
                  callback('codeCheckFalse');
                  break;
                case 'roc':
                  callback('rocCheckFalse');
                  break;
                case 'gst':
                  callback('gstCheckFalse');
                  break;
                case 'email':
                  callback('emailCheckFalse');
                  break;
                case 'emp':
                  callback('empCheckFalse');
                  break;
                case 'supplierDescr':
                  callback('supplierDescrCheckFalse');
                  break;
              }
            }
          },
          function (error) {
            if (!!error) {
              switch (checker) {
                case 'code':
                  callback('codeCheckTrue');
                  break;
                case 'roc':
                  callback('rocCheckTrue');
                  break;
                case 'gst':
                  callback('gstCheckTrue');
                  break;
                case 'email':
                  callback('emailCheckTrue');
                  break;
                case 'emp':
                  callback('empCheckTrue');
                  break;
                case 'supplierDescr':
                  callback('supplierDescrCheckTrue');
                  break;
              }
            }
          }
        );
      }
    },
    /**
     * @function generateRandomPassword
     * Generates a random password string
     **/
    generateRandomPassword: function () {
      var numbers = "0123456789";
      var smallLetters = "abcdefghijklmnopqrstuvwxyz";
      var capitalLetters = smallLetters.toUpperCase();

      var length = 8;
      var generatedPassword = [];

      var series = [numbers, smallLetters, capitalLetters];

      function getRandomChar(string) {
        var position = Math.floor(Math.random() * string.length);
        return string.charAt(position);
      }

      generatedPassword.push(getRandomChar(smallLetters));
      generatedPassword.push(getRandomChar(capitalLetters));
      generatedPassword.push(getRandomChar(numbers));

      for (var i = 3; i < length; i++) {
        var position = Math.floor(Math.random() * series.length);
        generatedPassword.push(getRandomChar(series[position]));
      }
      return (generatedPassword).join('');

    },
    securityConditions: function () {
      var conditions = [];
      var companiesCondition = {
        AccountCode: '(company_code==@__COMPANY_CODE__)',
        Address: null,
        Budget: '(company._id==@__COMPANY__)',
        BusinessUnit: null,
        Commodity: null,
        Contact: null,
        Currencies: null,
        ExchangeRate: '(company_id==@__COMPANY__)',
        ExpenseTypes: null,
        ImportItemDetail: null,
        ImportItemSummary: null,
        Item: null,
        ItemDetail: null,
        PaymentMethod: null,
        PaymentTerm: null,
        PO: '(billing.company._id==@__COMPANY__)',
        PR: '(company._id==@__COMPANY__)',
        Supplier: null,
        Tax: null,
        UNSPSC: null,
        UOM: null
      };
      for (var key in companiesCondition) {
        if (companiesCondition.hasOwnProperty(key)) {
          var temp = {
            class: key,
            value: companiesCondition[key]
          };
          conditions.push(temp);
        }
      }
      return conditions;
    },
    /**
     * To find key value in Array
     * Filter array by the key and the value (keyword)
     *
     * @param array
     * the array you want to filter
     *
     * @param key
     * array key
     *
     * @param value
     *
     * var arr = [
     *   key: value,
     *   key2: value2
     * ]
     *
     * @param checkLowerCase
     * Boolean flag to determine to check lower case or not, only applies to strings
     */
    findInArray: function (array, key, value, checkLowerCase) {
      return _.find(array, function (arr) {
        return (checkLowerCase && typeof arr[key] === 'string' && typeof value === 'string') ?
        arr[key].toLowerCase() === value.toLowerCase() : arr[key] === value;
      });
    }
    ,
    /**
     * To remove item in Array
     *
     * the Params is the same with findArray
     *
     */
    removeValueFromArray: function (array, key, value) {
      return _.reject(array, function (arr) {
        return arr[key] === value;
      });
    },
    /**
     * Modify array value by key
     * @param array
     * @param key
     * @param keyword
     * @param newKey
     * @param newValue
     * @returns {*}
     */
    modifyArrayValue: function (array, key, keyword, newKey, newValue) {
      _.forEach(array, function (arr) {
        if (arr[key] === keyword)
          arr[newKey] = newValue
      });

      return array;
    },
    /**
     * format an object key to an Array of Key and Value
     *
     * @param toBeFormattedObject
     * the desired object
     *
     * @returns {Array}
     */
    reformatFromObjectToArray: function (toBeFormattedObject) {
      var tempArray = [];
      var tempIndex;
      for (var i in toBeFormattedObject) {
        tempIndex = {};
        tempIndex.key = i;
        tempIndex.value = toBeFormattedObject[i];
        tempArray.push(tempIndex);
      }
      return tempArray;
    },
    /**
     * Opposite function of reformatFromObjectToArray
     * based on the key and value in parameter
     * @param array
     * @param keyName
     * @param valuesField
     * @param existingObject
     *
     * @returns {{}}
     */
    reformatArrayToObject: function (array, keyName, valuesField, existingObject) {
      var tempObject = existingObject || {};
      _.forEach(array, function (arr) {
        tempObject[arr[keyName]] = arr[valuesField];
      });
      return tempObject;
    },
    convertDateToTimestamp: function (date) {
      var milliTime = new Date(date);
      /**
       * The getTimezoneOffset() method returns the time difference between UTC time and local time, in minutes.
       * getTimezoneOffset is for offsetting the time to UTC/GMT + 0
       */
      return (milliTime.getTime());
    },
    /**
     * convert array of object into array of string
     * @param array
     * @param keyToConvert
     */
    arrayOfObjectToString: function (array, keyToConvert) {
      var newArray = [];
      _.forEach(array, function (val) {
        newArray.push(val[keyToConvert]);
      });

      return newArray;
    },
    /**
     * gets a string and capitalize only the first Character
     * @param input
     * @returns {string}
     */
    capitalizeFirstCharacter: function (input) {
      if (!!input && typeof input === 'string') {
        input = input.toLowerCase().split(' ');
        for (var i in input) {
          input[i] = input[i].charAt(0).toUpperCase() + input[i].substring(1);
        }
        return input.join(' ');
      }

    },
    /**
     * sorting an array of objects based on the key selected
     * @param array
     * @param key
     * @returns {*}
     */
    sortObjectsArray: function (array, key) {
      function compare(first, second) {

        if (!!first[key] && !!second[key]) {

          if (typeof first[key] === 'number' || typeof second[key] === 'number') {
            if (first[key] < second[key]) {
              return -1;
            }
            if (first[key] > second[key]) {
              return 1;
            }
          }
          else if (typeof first[key] === 'string' && typeof second[key] === 'string') {
            if (first[key].toLowerCase() < second[key].toLowerCase()) {
              return -1;
            }
            if (first[key].toLowerCase() > second[key].toLowerCase()) {
              return 1;
            }
          }
          else {
            return 0;
          }

        }
        return 0;
      }

      array.sort(compare);

      return array;
    },
    /**
     * function to fix the inconsistency in the naming of the Security Classes
     * @param name
     * @returns {*}
     */
    translateSecurityClasses: function (name) {
      if (name === 'PR') {
        return 'Purchase Requisition';
      }
      if (name === 'PO') {
        return 'Purchase Order';
      }
      if (name.toLowerCase() === 'exchangerate') {
        return 'Exchange Rate';
      }
      if (name.toLowerCase() === 'importitemsummary') {
        return 'Import Catalog (Header)';
      }
      if (name.toLowerCase() === 'importitemdetail') {
        return 'Import Catalog (Details)';
      }
      if (name.toLowerCase() === 'itemdetail') {
        return 'Item Detail';
      }
      if (name.toLowerCase() === 'paymentterm') {
        return 'Payment Term';
      }
      if (name.toLowerCase() === 'paymentmethod') {
        return 'Payment Method';
      }
      if (name.toLowerCase() === 'address') {
        return 'Address Book';
      }
      if (name.toLowerCase() === 'accountcode') {
        return 'Account Code';
      }
      if (name.toLowerCase() === 'budget') {
        return 'Budget';
      }
      if (name.toLowerCase() === 'expensetypes') {
        return 'Expense Types';
      }
      if (name.toLowerCase() === 'businessunit') {
        return 'Business Unit';
      }
      if (name.toLowerCase() === 'reportlog') {
        return 'Reports';
      }
      if (name.toLowerCase() === 'grn') {
        return 'Goods Received Note';
      }
      if (name.toLowerCase() === 'suppliertag') {
        return 'Supplier Tag';
      }

      return name;
    },
    getWaitingOnUser: function (approval_flow_data, waiting_on_user_scope) {
      waiting_on_user_scope.splice(0, waiting_on_user_scope.length);
      for (var i in approval_flow_data.waiting_on) {
        waiting_on_user_scope.push(approval_flow_data.waiting_on[i]);
      }
    },
    /**
     * Find the next available action from each module and return the next object
     * as well as return the count of the action available
     * in case the current action was the last one, the first action is returned
     * this function uses the waiting-on endpoint
     *
     * @param category
     * @param currentId
     * @returns {*}
     */
    nextAvailableAction: function (category, currentId) {

      var deferred = $q.defer();

      waitingOnUserList.get(
        {
          category: category,
          offset: 0
        },
        function (resource) {
          var results = {};
          if (!!resource.content.data && !!resource.content.meta && !!resource.content.meta.cursor) {
            /**
             * store the count
             */
            results.count = resource.content.meta.cursor.count;
            /**
             * find the next action
             */
            var k = 0;
            for (var i in resource.content.data) {
              if (currentId === resource.content.data[i].context_id) {
                k = _.cloneDeep(i);
                k++;
                if (!!resource.content.data[k]) {
                  results.waitingOnObject = resource.content.data[k];
                } else {
                  /**
                   * ensure its not the first one and last one
                   */
                  if (!(currentId === resource.content.data[0].context_id))
                    results.waitingOnObject = resource.content.data[0];
                }
                break;
              }
            }
          }
          deferred.resolve(results);
        }, function () {
          deferred.resolve([]);
        });
      return deferred.promise;
    },
    /**
     * function returns the code for each status
     * @param name
     * @returns {*}
     */
    getStatusCode: function (name) {
      /**
       DEACTIVATED = 0; 
       ACTIVE = 1; 
       INACTIVE = 2; 
       DISABLED = 3; 
       */
      if (!!name && typeof name === 'string') {
        if (name.toLowerCase() === 'deactivated') {
          return 0;
        }
        if (name.toLowerCase() === 'active') {
          return 1;
        }
        if (name.toLowerCase() === 'inactive') {
          return 2;
        }
        if (name.toLowerCase() === 'disabled') {
          return 3;
        }
        return null;
      }
      return null;
    },
    /**
     * function to return the import status code
     * @param name
     * @returns {*}
     */
    getImportSummaryStatusCode: function (name) {
      /**
       Compose = 0;
       Pending = 1; 
       Approved = 2;
       Expired = 4;
       Rejected = 5;
       Inactive = 7; 
       */
      if (!!name && typeof name === 'string') {
        if (name.toLowerCase() === 'compose') {
          return 0;
        }
        if (name.toLowerCase() === 'pending') {
          return 1;
        }
        if (name.toLowerCase() === 'approved') {
          return 2;
        }
        if (name.toLowerCase() === 'expired') {
          return 4;
        }
        if (name.toLowerCase() === 'rejected') {
          return 5;
        }
        if (name.toLowerCase() === 'inactive') {
          return 7;
        }
        return null;
      }
      return null;
    },
    /**
     * function to clean up the params for the tabData and return the new params
     * @param oldParams
     * @param newParams
     * @returns {{}}
     */
    filterUrlParams: function (oldParams, newParams) {
      var filteredParams = {};

      for (var i in oldParams) {
        oldParams[i] = null
        filteredParams[i] = oldParams[i];
      }
      for (i in newParams) {
        filteredParams[i] = newParams[i];
      }
      return filteredParams;
    },
    /**
     * function to remove the duplicated objects in an array
     * those needs to have a key identifying the object in order to detect duplication
     * @param array
     * @param key
     * @returns {Array}
     */
    removeDuplicateObjects: function (array, key) {
      var target = [];

      for(var i in array) {
        if (!this.findInArray(target, key, array[i][key]))
          target.push(array[i]);
      }

      return target;

    },
    /**
     * function to find the object key if its inside an array
     * @param array
     * @param key
     * @returns {*}
     */
    findObjectInArrayWithKeyValue: function (array, key) {
      if (!array)
        return;
      if (!key)
        return;

      var object = null;
      _.forEach(array, function (item) {
        if (!!Object.keys(item) && Object.keys(item)[0] === key)
          object = item[key];
      });
      return object;
    },

    /**
     * function to return key values of array of objects
     * @param array
     * @param key
     * @returns {Array}
     */
    getArrayOfKeyValues: function (array, key) {
      var temp = [];
      _.forEach(array, function (arr) {
        temp.push(arr[key]);
      });
      return temp;
    },
    /**
     * function to identify if the browser is running on mobile resolution
     */
    isMobileBrowser: function () {
      window.mobilecheck = function () {
        var check = false;
        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      };
      return mobilecheck();
    },
    /**
     * function to validate email formatting
     * @param email
     * @returns {boolean}
     */
    emailFormatValidation: function (email) {
      var regex = /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;
      return regex.test(email);
    },
    numberFormatValidation: function (elementId) {
      return $("#" + elementId).intlTelInput('isValidNumber');
    },
    getTimezoneDiff: function () {
      var minutesDiff = new Date().getTimezoneOffset();
      minutesDiff /= 60;

      var timezoneDiff = String(minutesDiff);
      timezoneDiff += '00';

      if (timezoneDiff.length === 4) {
        timezoneDiff = timezoneDiff.replace('-', '-0');
        timezoneDiff = timezoneDiff.replace('+', '+0');
      }
      return timezoneDiff;
    },
    convertToLocalDate: function (date) {
      if (!date)
        return '';
      date += 'Z';
      return new Date(date);
    },
    getCsvFilenameWithDate: function (title) {
      return title + ' ' + $filter('date')(new Date(), 'dd-MMM-yyyy') + '.csv';
    },
    /**
     * check if a specific user has a the role PA
     * @param user
     * @returns {boolean}
     */
    checkIfUserHasPARole: function (user) {
      if (!user || !user.roles) {
        return false;
      }

      var result = false;
      _.forEach(user.roles, function (role) {
        if (role.name === 'PA' && role.company_code === null) {
          result = true;
        }
      });
      return result;
    },
    /**
     * Return a string based on selected object key in the array
     * join by comma separated
     *
     * @param array
     * @param key
     * @returns {*}
     */
    createStringBasedOnObjectKeyInArray: function (array, key) {
      if (!!array && _.isArray(array)) {
        return array.map(function (elem) {
          return elem[key];
        }).join(', ');
      } else {
        return array;
      }
    },
    /**
     * Function to return a string for number to fixed decimal places (does not do any rounding)
     *
     * @param {number} number        the number to be truncated
     * @param {number} decimalPlaces number of decimal places to truncate the number
     * @returns {string} Returns the fixed number as string
     */
    toFixedDecimalPlaces: function (number, decimalPlaces) {
      var fixedNumber = new RegExp('^-?\\d+(?:\.\\d{0,' + (decimalPlaces || -1) + '})?');
      return number.toString().match(fixedNumber)[0];
    },
    /**
     * Translation for the bad comments of the supplier
     * @param comments
     * @returns {*}
     */
    translateSupplierHistory: function(comments) {

      if (!comments.data)
        return [];

      for (var i = 0; i < comments.data.length; i++) {
        //TODO: change the case for blacklist and pending to string when backend changes and also use toLowerCase
        switch (comments.data[i].action) {
          case 1:
            comments.data[i].actionText = ' approved this supplier to active ';
            comments.data[i].comment = ' Supplier changed to active ';
            break;
          case 2:
            comments.data[i].actionText = ' approved this supplier to blacklisted ';
            comments.data[i].comment = ' Supplier changed to blacklisted ';
            break;
          case 0:
            comments.data[i].actionText = ' approved this supplier to pending ';
            comments.data[i].comment = ' Supplier changed to pending ';
            break;
          case 6:
            comments.data[i].actionText = ' approved this supplier to inactive ';
            comments.data[i].comment = ' Supplier changed to inactive ';
            break;
          case 'CREATED':
            if (i === 0)
              comments.data[i].actionText = ' created this supplier';
            else {
              comments.data[i].actionText = ' updated this supplier';
              comments.data[i].comment = comments.data[i].comment.replace('created', 'updated');
            }
            break;
          case 'UPDATED':
            comments.data[i].actionText = ' updated this supplier';
            break;
          case 'REJECTED':
            var i2 = i-1;
            var previousAction = comments.data[i2].action.split(' ');
            if (previousAction.length > 1) {
              if (previousAction[previousAction.length - 4] === 'from') {
                previousAction = previousAction.slice(previousAction.length - 4, previousAction.length);
                previousAction = previousAction.join(' ');
              } else {
                previousAction = 'status';
              }
            } else {
              previousAction = 'status';
            }
            comments.data[i].actionText = ' rejected the request to move this supplier ' + previousAction;
            break;
          case 'APPROVED':
            comments.data[i].actionText = ' approved this supplier';
            break;
          case 'FULLY_APPROVED':
            comments.data[i].actionText = ' fully approved this supplier';

            break;
          default:
            comments.data[i].actionText = comments.data[i].action;
            break;
        }
      }

      return comments;
    }
  }
}

angular
  .module('metabuyer')
  .factory('globalFunc',globalFunc);

/**
 * @name metabuyer.services.genericSearch
 *
 * @description
 *
 * Service for adding and removing escalation
 *
 * @requires $resource
 * @requires pathConstants (Metabuyer service)
 *
 * @factory searchModule
 * @param module
 * the module selected to be searched
 *
 *
 * @author Ahmed Saleh <a.s.alsalali@gmail.com>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2016
 */

'use strict';

angular.module('metabuyer.services.genericSearch', ['ngResource'])
  .factory('searchModule',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.genericSearch.search,
        {
          module: '@module'
        },
        {
          'get': {method: 'GET'}
        }
      );
    });

/**
 * @name exportSearch
 *
 * @description
 * This service is for passing the search criteria when exporting after searching
 *
 * @authors Justin Cheong
 * @copyright Sunway Metacloud &copy; 2016
 */

'use strict';

function exportSearch () {
  var exportParams = {};
  return {
    setParams: function(params) {
      exportParams = angular.copy(params);
      exportParams.module = null;
      exportParams.offset = null;
    },
    getParams: function(){
      return exportParams;
    }
  }
}

angular
  .module('metabuyer')
  .factory('exportSearch',exportSearch);

'use strict';

angular.module('metabuyer.services.export', ['ngResource'])
  /**
   * @factory exports
   * @payload
   * collection :
   * 0 for Currencies
   * 1 for Company
   * 2 for CostCenter
   * 3 for AccountCode
   * 4 for ExchangeRate
   * 5 for UOM
   * 6 for PaymentTerm
   * 7 for PaymentMethod
   * 8 for Tax
   * 9 for ExpenseTypes
   * 10 for Supplier
   * 11 for Commodity
   * 12 for Users
   * 13 for Catalogs
   * 16 for Catalog Items
   * 17 for PR
   * 18 for PO
   * 19 for Industries
   * 20 for Business Units
   */
  .factory('exports', function($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.export.generate,
      {

      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('downloadExportCSV', function($resource, $filter, pathConstants){
    return $resource(
      pathConstants.apiUrls.export.download,
      {
        export_hash: '@export_hash'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('checkExportStatus', function($resource, $filter, pathConstants){
    return $resource(
      pathConstants.apiUrls.export.checkStatus,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.expenseTypes', ['ngResource'])
  .factory('expenseTypeMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.expenseTypes.masterList,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('expenseTypeSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.expenseTypes.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('expenseTypeUserList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.expenseTypes.list,
      {},
      {
        ignoreLoadingBar: true,
        'get': {method: 'GET'}
      }
    );
  })
  .factory('companyExpenseTypes',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.companies.expenseTypes,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }
  );

'use strict';

angular.module('metabuyer')
  .factory('ExchangeRate', function($resource, pathConstants) {
    var ExchangeRate = $resource(
      pathConstants.apiUrls.exchangeRate.single,
      {
        id: '@id',
        source_id: '@source_id',
        target_id: '@target_id'
      },
      {
        get: { method: 'GET' }
      }
    );

    return ExchangeRate;
  })
  /**
   * To get and post global level exchange rate, send 'global' for company_id
   */
  .factory('exchangeRateMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.exchangeRate.masterList,
      {
        company_id: '@company_id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('exchangeRateSpecificRate',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.exchangeRate.rate,
      {
        id: '@id',
        rate_id: '@rate_id'
      },
      {
        'get': {method: 'GET'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('exchangeRateSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.exchangeRate.search,
      {
        company_id: '@company_id',
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

/**
 * @name metabuyer.services.escalation
 *
 * @description
 *
 * Service for adding and removing escalation
 *
 * @requires $resource
 * @requires pathConstants (Metabuyer service)
 *
 * @factory addEscalation
 * @param id
 * the ID of the intended user to have an escalation from
 * @param mid
 * the ID of the user to be escalated to
 * @payload company_code
 * the company code where the escalation is taking place
 *
 * @factory removeEscalation
 * @param id
 * the ID of the intended user to remove the escalation option
 * @payload company_code
 * the company code where the escalation is taking place
 *
 *
 * @author Ahmed Saleh <a.saleh@vventures.asia>
 * @copyright Verve Technologies Sdn. Bhd. &copy; 2015
 */

'use strict';

angular.module('metabuyer.services.escalation', ['ngResource'])
  .factory('addEscalation',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.escalation.add,
      {
        id: '@id',
        mid: '@mid'
      },
      {
        'post': {method: 'POST'}
      }
    );
  })
  .factory('removeEscalation',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.escalation.delete,
      {
        id: '@id'
      },
      {
        'delete': {method: 'DELETE'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.delegation', ['ngResource'])
  .factory('massDelegate',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.delegation.massDelegate,
        {
          userId: '@userId'
        },
        {
          'post': { method: 'POST' }
        }
      );
    }
  )
  .factory('delegatedToAUser',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.delegation.delegatedToAUser,
        {
          userId: '@userId',
          company_code: '@company_code'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }
  )
  .factory('delegatedFromAUser',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.delegation.delegatedFromAUser,
        {
          userId: '@userId'
        },
        {
          'get': { method: 'GET'}
        }
      );
    }
  )
  .factory('delegations',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.delegation.list,
        {
          delegationId: '@delegationId'
        },
        {
          'get': { method: 'GET' },
          'delete': { method: 'DELETE'}
        }
      );
    }
  )
  .factory('massRemoveDelegation',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.delegation.list,
        {},
        {
          'delete': { method: 'DELETE'}
        }
      );
    }
  );

'use strict';

angular.module('metabuyer')
  .factory('Currencies',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.currencies.list,
      {
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('currenciesMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.currencies.masterList,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'post': {method: 'POST'},
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('currenciesSearch',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.currencies.search,
      {
        query: '@query'
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.costcenters', ['ngResource'])
  .factory('CostCenters', function($resource, $filter, pathConstants){
    var CostCenters = $resource(
      pathConstants.apiUrls.costCenters.single,
      {
        id: '@id'
      },
      {
        'put': { method: 'PUT' },
        'get': { method: 'GET' },
        'delete': { method: 'DELETE' }
      }
    );

    return CostCenters;
  })
  .factory('AddCostCenters', function($resource, $filter, pathConstants){
    var AddCostCenters = $resource(
      pathConstants.apiUrls.costCenters.new,{},
      {
        'put': { method: 'PUT' },
        'post': { method: 'POST' }
      }
    );

    return AddCostCenters;
  });

'use strict';

angular.module('metabuyer')
  .factory('Contacts',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.contactPersons.contacts,
      {
      },
      {
        'getContact': {
          method: 'GET',
          params: {
          },
          url: pathConstants.apiUrls.contactPersons.contacts
        },
        'updateContact': {
          method: 'PUT',
          params: {
            id: "@id"
          },
          url: pathConstants.apiUrls.contactPersons.single
        },
        'addContact': {
          method: 'POST',
            params:{
          },
          url: pathConstants.apiUrls.contactPersons.contacts
        },
        'removeContact': {
          method: 'DELETE',
          params:{
          },
          url: pathConstants.apiUrls.contactPersons.single
        }
      }
    );
  });

'use strict';

/**
 * @name companyGlobalFunc
 *
 * @description Service for company global functions
 * This service is for functions that are re-used in company modules, to minimize redundancy
 *
 * @author Deniel Ariesta <deniel.ariesta@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

function companyGlobalFunc (){
  var globalCompanyData = {};
  var POInitialStatuses = [
    {
      descr: 'Submitted',
      value: 0
    },
    {
      descr: 'Awaiting Delivery',
      value: 5
    }
  ];

  return {
    reformatCurrenciesSelected: function (company) {
      var companyCurrency = [];
      _.forEach(company.currencies, function (currency) {
        companyCurrency.push(currency.code);
      });
      return companyCurrency;
    },
    setCompanyData: function (company) {
      globalCompanyData = company;
    },
    getCompanyData: function () {
      return globalCompanyData;
    },
    getPOInitialStatuses: function () {
      return POInitialStatuses;
    }
  }
}

companyGlobalFunc.$inject = [];

angular
  .module('metabuyer')
  .factory('companyGlobalFunc',companyGlobalFunc);

'use strict';

angular.module('metabuyer.services.companies', ['ngResource'])
  .factory('Companies', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.single,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'put': {method: 'PUT'},
        'delete': {method: 'DELETE'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('companyCostCenters', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.costCenters,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('CompanyAccountCode', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.accountCode,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('companyUsers', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.users,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('companyActiveUsers', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.activeUsers,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('getUsersInCompanies', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.usersInCompanies,
      {
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('companyCurrencies', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.currencies,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  //companies image factory with function to upload
  .factory('companiesDetailImage', function ($resource, pathConstants) {
  return{
    uploadImagePath: function (companyID) {
      var path = pathConstants.apiUrls.companies.image;
      return path.replace(":id", companyID);
    }
  }
  })
  .factory('searchCompany', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.search,
      {
        query: '@query'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('companyReferenceCounter', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.referenceCounter,
      {
        companyId: '@companyId',
        referenceId: '@referenceId',
        action: '@action'
      },
      {
        'get': {method: 'GET'},
        'put': {method: 'PUT'},
        'delete': {method: 'DELETE'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('companyReferenceCounterSearch', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.referenceCounterSearch,
      {
        query: '@query'
      },
      {
        'get': {method: 'GET'}
      }
    );
    })
  .factory('companyGroupsList',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalogGroups.list,
        {
          groupId: '@groupId',
          companyId: '@companyId'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'post': {method: 'POST'},
          'delete': {method: 'DELETE'}
        }
      );
    })
  .factory('companyBudgetSetting', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.companies.budgetSetting,
      {
        id: '@id'
      },
      {
        'put': {method: 'PUT'}
      }
    );
  })
  .factory('companyGroupsAction',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalogGroups.assignment,
        {
          groupId: '@groupId',
          companyId: '@companyId'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'post': {method: 'POST'}
        }
      );
    })
  .factory('companyCostCentersAddress',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.companies.costCentersAddress,
        {
          companyId: '@companyId'
        },
        {
          'get': {method: 'GET'}
        }
      );
    });


'use strict';

angular.module('metabuyer.services.commodity', ['ngResource'])
/**
 * Factory for commodity listing
 * This endpoint returns list with offset
 */
  .factory('commodityList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.commodity.list,
      {
        code: '@code'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })

/**
 * Factory for listing child, can list segments by passing code = 'All'
 * This endpoint returns list for nonCatalog and supplier's primary commodity
 */
  .factory('listChild',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.commodity.listChild,
      {
        code: '@code'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('commodityMasterDataList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.commodity.masterList,
      {

      },
      {
        'get': { method: 'GET' },
        'post': {method: 'POST'}
      }
    );
  })
  .factory('searchCommodity',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.commodity.search,
      {
        query: '@query'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('singleCommodity',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.commodity.single,
      {
        id: '@id'
      },
      {
        'get': {method: 'GET'},
        'put': {method: 'PUT'},
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('searchAllCommodity',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.commodity.searchAllLevel,
        {
          keywords: '@keywords'
        },
        {
          'get': {method: 'GET'}
        }
      );
    }
  );

'use strict';

angular.module('metabuyer.services.commentsServices', ['ngResource'])
  .factory('PRNewComments',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.listPRNewComment,
        {
          referenceId: '@referenceId'
        },
        {
          'get': {method: 'GET'},
          post: {
            method: 'POST',
            params: {
              referenceId: '@referenceId'
            },
            url: pathConstants.apiUrls.comments.savePRNewComment
          },
          delete: {
            method: 'DELETE',
            params: {
              referenceId: '@referenceId',
              commentId: '@commentId'
            },
            url: pathConstants.apiUrls.comments.savePRNewComment
          }
        }
      )
    })
  .factory('POComments',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.listPOComment,
        {
          referenceId: '@referenceId'
        },
        {
          'get': {method: 'GET'},
          'post': {method: 'POST'},
          delete: {
            method: 'DELETE',
            params: {
              referenceId: '@referenceId',
              comment_id: '@comment_id'
            },
            url: pathConstants.apiUrls.comments.savePOComment
          }
        }
      );
    })
  .factory('supplierTagHistory',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.listSupplierTagHistory,
        {
          companyCode: '@companyCode'
        },
        {
          'get': {method: 'GET'}
        }
      );
    })
  .factory('commentsHistory',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.reference,
        {
          referenceId: '@referenceId'
        },
        {
          'get': {method: 'GET'},
          'post': {method: 'POST'}
        }
      );
    })
  .factory('singleCommentsHistory',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.single,
        {
          commentId: '@commentId'
        },
        {
          'put': {method: 'PUT'},
          'delete': {method: 'DELETE'}
        }
      );
    });


'use strict';

angular.module('metabuyer.services.catalogServices', ['ngResource'])
.factory('itemList', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalog.list,
        {
          user_id: '@user_id',
          code: '@code',
          cc: '@cc',
          supplier_id: '@supplier_id'
        });
    }])
  .factory('itemDetailsInformation', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalog.details,
        {
          user_id: '@user_id',
          item_id: '@item_id'
        });
    }])
  .factory('searching', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalog.searching,
        {
          user_id: '@user_id',
          supplier_id: '@supplier_id'
        });
    }])
  .factory('starringItem', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalog.starringItem,
        {
          user_id: '@user_id',
          item_id: '@item_id'
        }, {

          'update': { method: 'PUT' }

        });
    }])
  .factory('catalogShoppingSearch', ['$resource', 'pathConstants',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalog.search,
        {
          user_id: '@user_id',
          type: '@type'
        });
    }]);

'use strict';
//TODO: remove safely (Ahmed Saleh, 16/3/2017)

angular.module('metabuyer')
    .factory('Cart', function($rootScope) {

        var cart = {
            items: [],

            //the case for default adding (not from details)
            defaultAddToCart: function (product, type, quantity, supplier) {
                    product.ordered_supplier = supplier;
                    product.ordered_type = product.default.pricing;
                    product.ordered_quantity = quantity;
                    product.calculations = {};
                    cart.items.push(product);

            },
            detailAddToCart: function (product, quantity, detail) {

                product.ordered_supplier = detail.supplier_name;
                product.ordered_type = detail.pricing;
                product.detailId = detail._id;
                product.ordered_quantity = quantity;
                product.calculations = {};
                cart.items.push(product);

            },
            removeFromCart: function(index){
                cart.items.splice(index,1);
            },
            emptyCart: function()
            {
                cart.items =[];
            },
            validateProduct: function(product, detail)
            {
                //checking for duplication
                //default item
                if(detail== null) {
                    for (var i = 0; i < cart.items.length; i++) {
                        if (product._id == cart.items[i]._id) {
                            return false;
                        }

                    }
                }
                //detailed Item
                else
                {
                    for (var i = 0; i < cart.items.length; i++) {
                        if (detail._id == cart.items[i].detailId) {

                            return false;
                        }

                    }

                }
                return true;
            }
        };

        return cart;
    });

'use strict';

angular.module('metabuyer.services.BusinessUnits', ['ngResource'])
  .factory('listingBusinessUnits',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.BusinessUnits.list,
      {
      },
      {
        'get': { method: 'GET' },
        'post': { method: 'POST' }
      }
    );
  })
  .factory('singleBU',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.BusinessUnits.single,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' },
        'put': { method: 'PUT' },
        'delete': { method: 'DELETE' }
      }
    );
  });

'use strict';

/**
 * @name budgetFunctions
 *
 * @description Service for Budget functions
 * This service is for functions that are re-used in budget modules, to minimize redundancy
 *
 * @requires globalFunc
 * @requires $q
 *
 * @function getBudgetStatus
 * Function to convert budget status string to integer
 *
 * @function setEditableState
 * Function to set editable state
 *
 * @function setAssignmentRemovableState
 * Function to set assignment removable state
 *
 * @function getEditableState
 * Function to get editable state
 *
 * @function getAssignmentRemovableState
 * Function to get assignment removable state
 *
 * @function getItemBreakdownRemovableState
 * Function to get editable state for item breakdown
 *
 * @function setItemBreakdownRemovableState
 * Function to set editable state for item breakdown
 *
 * @function getQuarterOfYear
 * Function to return the quarter of the year with provided month
 *
 * @function convertMonthToTextualRepresentation
 * Function to convert given month to textual representation
 *
 * @function checkApportionAllocation
 * Function to check if apportion allocation values will change due to field changes
 *
 * @function getApportionAllocationData
 * Function to get apportion allocation data, based on apportion type calls respective functions
 *
 * @function removeParentApportionData
 * Function to remove parent apportion data (apportion_allocation and apportion_carry_forward)
 *
 * @authors Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

function budgetFunctions(globalFunc, $q, apportionAllocation) {

  var budgetEditableState = 'editable';
  var assignmentRemovableState = false;
  var itemBreakdownRemovableState = false;
  var budgetSetting = false;

  return {
    /**
     * Converts budget status string to integer representation
     *
     * @param {string} status String representation of budget status
     * Values:
     *         0 for pending
     *         1 for approved
     *         2 for rejected
     *         3 for on_hold
     *         4 for draft
     *         5 for withdraw
     *         6 for inactive
     *         7 for expired
     *         8 for deleted
     *         9 for revision
     */
    getBudgetStatus: function (status) {
      var budgetStatusArray = {
        'pending': 0,
        'approved': 1,
        'rejected': 2,
        'on hold': 3,
        'draft': 4,
        'withdraw': 5,
        'inactive': 6,
        'expired': 7,
        'deleted': 8,
        'revision': 9
      };

      return budgetStatusArray[status];
    },
    setEditableState: function (state) {
      budgetEditableState = state;
    },
    setAssignmentRemovableState: function (state) {
      assignmentRemovableState = state;
    },
    getEditingState: function () {
      return budgetEditableState;
    },
    getAssignmentRemovableState: function () {
      return assignmentRemovableState;
    },
    setItemBreakdownRemovableState: function(itemsBreakdown) {
      for (var i = 0; i < itemsBreakdown.length; i++) {
        if (!!itemsBreakdown[i].committed_amount || !!itemsBreakdown[i].used_amount) {
          itemBreakdownRemovableState = true;
        }
      }
    },
    getItemBreakdownRemovableState: function() {
      return itemBreakdownRemovableState;
    },
    /**
     * To check if apportion allocation values will change due to field changes and returns the value
     * for recalculations
     *
     * @param {*}     oldValue
     * @param {*}     newValue
     * @param {array} apportionAllocation
     * @returns {*} Returns the newValue if apportion allocation will be affected
     */
    checkApportionAllocation: function (oldValue, newValue, apportionAllocation) {
      var deferred = $q.defer();
      // If new value is not equal to old value and old value is not null and apportion allocation is not empty
      if (newValue !== oldValue && !!oldValue && !_.isEmpty(apportionAllocation)) {
        swal(
          {
            title: 'Confirm Apportion allocation',
            text: 'This action will affect the apportion allocation',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1ab394',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function (isConfirm) {
            if (!!isConfirm) {
              deferred.resolve(newValue);
            }
            else {
              deferred.resolve(oldValue);
            }
          }
        );
      }
      // Else if old value is null or apportion allocation is empty
      else if (!oldValue || _.isEmpty(apportionAllocation)) {
        deferred.resolve(newValue);
      }
      return deferred.promise;
    },
    /**
     * Generates the apportion allocation array based on start date, end date, apportion type and amount
     * Will not be called if existing apportion allocation exists
     *
     * @param {Date}    startDate                     Start date for apportion
     * @param {Date}    endDate                       End date for apportion
     * @param {string}  apportionType                 Apportion's type
     * @param {number}  availableAmount               Budget available amount
     * @param {boolean} isRevisionApportionAllocation Flag for revision apportion
     * @param {array}   existingApportionAllocations  Existing apportion allocation
     * @returns {Array}
     */
    getApportionAllocationData: function (startDate, endDate, apportionType, availableAmount,
                                          isRevisionApportionAllocation, existingApportionAllocations) {
      var deferred = $q.defer();

      apportionAllocation.post(
        {
          startDate: startDate,
          endDate: endDate,
          apportionType: apportionType,
          availableAmount: availableAmount,
          isRevisionApportionAllocation: isRevisionApportionAllocation,
          existingApportionAllocations: existingApportionAllocations
        },
        function (resource) {
          if (!!resource && !!resource.content && !!resource.content.data) {
            deferred.resolve(resource.content.data);
          }
          else {
            deferred.resolve([]);
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
          deferred.resolve([]);
        }
      );

      return deferred.promise;
    },
    /**
     * Remove the parent apportion allocation and set apportion carry forward to false
     */
    removeParentApportionData: function (parentData) {
      parentData.apportion_allocation = [];
      parentData.apportion_carry_forward = false;
      return parentData;
    },
    setHasBudgetSettingOn: function (flag) {
      budgetSetting = flag;
    },
    getHasBudgetSettingOn: function () {
      return budgetSetting;
    },

    /**
     * Function to divide number
     *
     * @param {number} numerator    dividend
     * @param {number} denominators divisor
     * @returns {number}
     */
    divide: function (numerator, denominators) {
      return Number(math.format(
        math.divide(numerator, denominators),
        {precision: 64}
      ));
    },

    /**
     * Function to multiply numbers
     *
     * @param {number} firstNumber  first number to be multiplied
     * @param {number} secondNumber second number to be multiplied
     * @returns {number}
     */
    multiply: function (firstNumber, secondNumber) {
      return Number(math.format(
        math.multiply(firstNumber, secondNumber),
        {precision: 64}
      ));
    },

    /**
     * Function to subtract numbers
     *
     * @param {number} subtrahend number to be subtracted
     * @param {number} minuend    number to be subtracted from
     * @returns {number}
     */
    subtract: function (subtrahend, minuend) {
      return Number(math.format(
        math.subtract(subtrahend || 0, minuend || 0),
        {precision: 64}
      ));
    },

    /**
     * Function to add numbers
     *
     * @param {number} firstNumber  first number to be added
     * @param {number} secondNumber second number to be added
     * @returns {number}
     */
    add: function (firstNumber, secondNumber) {
      return Number(math.format(
        math.add(firstNumber || 0, secondNumber || 0),
        {precision: 64}
      ));
    }
  };
}

budgetFunctions.$inject = ['globalFunc', '$q', 'apportionAllocation'];

angular
  .module('metabuyer')
  .factory('budgetFunctions', budgetFunctions);

'use strict';

/**
 * @name budget services
 *
 * @description service for budget endpoint calls
 * This service is calling budget endpoints
 *
 * @requires $resource
 * @requires $filter
 * @requires pathConstants
 *
 * @authors Justin Cheong Tian Yee <justin.cty90@gmail.com>
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */

angular.module('metabuyer.services.budgets', ['ngResource'])
  .factory('budgets', function ($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.budget.single,
      {
        id: '@id',
        action: '@action'
      },
      {
        'get': {method: 'GET'},
        'put': {method: 'PUT'},
        'delete': {method: 'DELETE'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('budgetCommentList',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.comments.listBudgetComment,
        {
          referenceId: '@referenceId'
        },
        {
          get: {method: 'GET'},
          post: {
            method: 'POST',
            params: {
              referenceId: '@referenceId'
            },
            url: pathConstants.apiUrls.comments.saveBudgetComment
          }
        }
      )
    })
  .factory('budgetList', function ($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.budget.list,
      {
        action: '@action'
      },
      {
        'get': {method: 'GET'}
      }
    );
  })
  .factory('apportionAllocation', function ($resource, $filter, pathConstants) {
    return $resource(
      pathConstants.apiUrls.budget.apportionAllocation,
      {},
      {
        'post': {method: 'POST'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.availability', ['ngResource'])
  .factory('availability',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.available.single,
      {
        model: '@model',
        field: '@field',
        value: '@value'
      },
      {
        'get': { method: 'GET'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.auditTrail', ['ngResource'])
  .factory('auditTrailList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.auditTrail.list,
      {
        type: '@type'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('singleAuditTrail',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.auditTrail.single,
      {
        id: '@id'
      },
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('auditControllers',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.auditTrail.controllers,
        {},
        {
          'get': { method: 'GET' }
        }
      );
    })
  .factory('auditControllersActions',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.auditTrail.actions,
      {
        controller: '@controller'
      },
      {
        'get': {method: 'GET'}
      }
    );
  });

'use strict';

angular.module('metabuyer.services.auditTrail', ['ngResource'])
  .factory('auditList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.auditList.get,
      {
      },
      {
        'get': { method: 'GET' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.attachmentCategory', ['ngResource'])
  .factory('attachmentCategory',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.attachments.category,
        {
          id: '@id',
          host_class: '@host_class',
          object_id: '@object_id'
        },
        {
          'get': { method: 'GET' },
          'delete': { method: 'DELETE' }
        }
      );
    }
  )
  .factory('attachmentDescription',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.attachments.description,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' },
          'put': { method: 'put' },
          'delete': { method: 'delete' }
        }
      );
    }
  )
  .factory('attachmentDetail',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.attachments.detail,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' }
        }
      );
    }
  );

'use strict';

angular.module('metabuyer.services.attachments', ['ngResource'])
  .factory('Attachments', function ($resource, pathConstants) {
    var Attachments = $resource(
      pathConstants.apiUrls.attachments.listPRAttachment,
      {
        pr_id: '@pr_id'
      },
      {
        'get': {
          method: 'GET'
        }, //get attachment list
        'submit': {
          method: 'POST'
        },
        'getListPRAttachment': {
          method: 'GET',
          params: {
            pr_id: '@pr_id'
          },
          url: pathConstants.apiUrls.attachments.listPRAttachment
        },
        'getListPOAttachment': {
          method: 'GET',
          params: {
            po_id: '@po_id'
          },
          url: pathConstants.apiUrls.po.listAttachment
        },
        'getListSupplierAttachment': {
          method: 'GET',
          params: {
            po_id: '@po_id'
          },
          url: pathConstants.apiUrls.suppliers.listAttachment
        }
      }
    );
    return Attachments;
  })
  .factory('attachmentsByReference',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.attachments.reference,
        {
          referenceId: '@referenceId'
        },
        {
          'get': {method: 'GET'},
          'post': {method: 'POST'}
        }
      );
    })
  .factory('singleAttachment',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.attachments.single,
        {
          attachmentId: '@attachmentId'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'delete': {method: 'DELETE'}
        }
      );
    })
  // TODO: Refactor PO side for attachments (Justin 7/9/17)
  .factory('AttachmentSingle', function ($resource, pathConstants) {
    var AttachmentSingle = $resource(
      pathConstants.apiUrls.attachments.single,
      {
        pr_id: '@pr_id',
        attachment_id: '@attachment_id'
      },
      {
        'get': {
          method: 'GET'
        }, //get single attachment detail
        'update': {
          method: 'PUT'
        },
        'getSinglePOAttachment': {
          method: 'GET',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.po.singleAttachment
        },
        'updateSinglePOAttachment': {
          method: 'PUT',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.po.singleAttachment
        },
        'deleteSinglePOAttachment': {
          method: 'DELETE',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.po.singleAttachment
        },
        'getSingleSupplierAttachment': {
          method: 'GET',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.suppliers.singleAttachment
        },
        'updateSingleSupplierAttachment': {
          method: 'PUT',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.suppliers.singleAttachment
        },
        'deleteSingleSupplierAttachment': {
          method: 'DELETE',
          params: {
            po_id: '@po_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.suppliers.singleAttachment
        }
      }
    );
    return AttachmentSingle;
  })
  .factory('PRNewAttachments', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.attachments.listPRNewAttachment,
      {
        pr_id: '@pr_id'
      },
      {
        'getListPRAttachment': {
          method: 'GET'
        }, //get attachment list
        'post': {
          method: 'POST'
        },
        'get': {
          method: 'GET',
          params: {
            pr_id: '@pr_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.attachments.singlePRNewAttachment
        },
        'delete': {
          method: 'DELETE',
          params: {
            pr_id: '@pr_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.attachments.singlePRNewAttachment
        },
        'put': {
          method: 'PUT',
          params: {
            pr_id: '@pr_id',
            attachment_id: '@attachment_id'
          },
          url: pathConstants.apiUrls.attachments.singlePRNewAttachment
        }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.approvalEngine.positionManage', ['ngResource'])
  .factory('positionManagement', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.position.get,
        {
          limit: '@limit',
          page: '@page',
          sort: '@sort',
          includes: '@includes',
          filter_groups: '@filter_groups',
          position: '@position'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' },
          'put': { method: 'PUT' }
        }
      );
    }])
  .factory('positionManagementSingle', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.position.single,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }])
  .factory('positionManagementExport', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.position.export,
        {},
        {
          'post': { method: 'POST' }
        }
      );
    }])
'use strict';

angular.module('metabuyer.services.approvalEngine.positionAssign', ['ngResource'])
  .factory('positionAssignment', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.positionAssign.get,
        {
          limit: '@limit',
          page: '@page',
          sort: '@sort',
          includes: '@includes',
          filter_groups: '@filter_groups',
          position: '@position'
        },
        {
          'get': { method: 'GET' },
          'post': { method: 'POST' },
          'put': { method: 'PUT' }
        }
      );
    }])
  .factory('positionAssignmentSingle', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.positionAssign.single,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }])
'use strict';

angular.module('metabuyer.services.approvalEngine.approvalTemplates', ['ngResource'])
  .factory('approvalTemplates', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplate.get,
        {
          limit: '@limit',
          page: '@page',
          sort: '@sort',
          includes: '@includes',
          filter_groups: '@filter_groups',
          position: '@position'
        },
        {
          'get': { method: 'GET' }
        }
      );
    }])
  .factory('approvalTemplateSingle', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplate.detail,
        {
          id: '@id'
        },
        {
          'get': { method: 'GET' },
          'put': { method: 'PUT' },
          'delete': { method: 'DELETE' }
        }
      );
    }])
  .factory('approvalTemplateExport', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplate.export,
        {
          id: '@id'
        },
        {
          'post': { method: 'POST' }
        }
      );
    }])
'use strict';

angular.module('metabuyer.services.approvalEngine.approvalTemplateHistory', ['ngResource'])
  .factory('approvalTemplateHistory', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplateHistory.get,
        {
          limit: '@limit',
          page: '@page',
          sort: '@sort',
          includes: '@includes',
          filter_groups: '@filter_groups'
        },
        {
          'get': {method: 'GET'},
          'post': {method: 'POST'},
          'put': {method: 'PUT'}
        }
      );
    }])
  .factory('approvalTemplateHistorySingle', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplateHistory.single,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'delete': {method: 'DELETE'}
        }
      );
    }])
  .factory('approvalTemplateInfo', ['$resource', 'pathConstants',
    function ($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.approvalEngine.approvalTemplate.info,
        {},
        {
          'get': {method: 'GET'}
        }
      );
    }])


'use strict';

angular.module('metabuyer.services.approval', ['ngResource'])
  .factory('Approvals', function($resource, pathConstants){
    return $resource(
      pathConstants.apiUrls.approvals.single,
      {
        id: '@id'
      }
    );
  })
  .factory('adhocApprover', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.approvals.addApprover,
      {
        id: '@id'
      },
      {
        'post': { method: 'POST' }
      }
    );
  })
  .factory('removeAdhocApprover', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.approvals.removeAdhoc,
      {
        id: '@id',
        step: '@step',
        positionId: '@positionId'
      },
      {
        'delete': { method: 'DELETE' }
      }
    );
  })
  .factory('approvalPreview', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.approvals.draftPreview,
      {},
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('approvalPreviewByData', function ($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.approvals.dataPreview,
      {},
      {
        'get': { method: 'GET' }
      }
    );
  })
  .factory('multiApprovalActions', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.approvals.multiApprovalActions,
      {
        action: '@action'
      },
      {
        'post': { method: 'POST' }
      }
    );
  });

'use strict';

angular.module('metabuyer.services.adminSettings', ['ngResource'])
  .factory( 'adminSettings', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.security.password,
      {

      },
      {
        'get'   : {method: 'GET'},
        'put'   : {method: 'PUT'},
        'delete': {method: 'DELETE'}
      }
    );
  })
  .factory('tenantLogo', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tenant.image,
      {

      },
      {
        'get'   : {method: 'GET'}
      }
    );
  })
  .factory('singleTenantById', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.tenant.singleTenantById,
      {
        id: '@id'
      },
      {
        'get'   : {method: 'GET'},
        'put'   : {method: 'PUT'}
      }
    );
  })
  .factory('uploadTenantLogo', function ($resource, pathConstants) {
    return{
      uploadImagePath: function () {
        return pathConstants.apiUrls.tenant.image;
      }
    }
  })
  .factory( 'tenantSettings', function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.security.tenant,
      {

      },
      {
        'get'   : {method: 'GET'},
        'put'   : {method: 'PUT'},
        'delete': {method: 'DELETE'}
      }
    );
  });


'use strict';

angular.module('metabuyer.services.address' , ['ngResource'])
  .factory('addressList',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.addresses.list,
      {
      },
      {
        'get' : {method: 'GET'},
        'post': {method: 'POST'}
      }
    );
  })
  .factory('singleAddress',
  function($resource, pathConstants) {
    return $resource(
      pathConstants.apiUrls.addresses.single,
      {
        id: '@id'
      },
      {
        'put': {method: 'PUT'}
      }
    );
  });


'use strict';

angular.module('metabuyer.services.accountCodes', ['ngResource'])
  .factory('accountCodesList',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.accountCode.list,
        {
          company_id: '@company_id'
        },
        {
          'get': {method: 'GET'}
        }
      );
    }
  )
  .factory('accountCodeSearch',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.accountCode.search,
        {
          company_id: '@company_id',
          query: '@query'
        },
        {
          'get': {method: 'GET'}
        }
      );
    }
  )
  .factory('singleAccountCode',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.accountCode.single,
        {
          id: '@id',
          company_id: '@company_id'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'},
          'post': {method: 'POST'}
        }
      );
    }
  )
  .factory('PRAccountCodeList',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.accountCode.prList,
        {
          company_code: '@company_code',
          cost_center_id: '@cost_center_id',
          parent_code: '@parent_code'
        },
        {
          'get': {method: 'GET'}
        }
      );
    }
  );

'use strict';

angular.module('metabuyer')
  .factory('Account', function($http, $auth, pathConstants) {
    return {
      getProfile: function() {
        return $http.get(pathConstants.apiUrls.profile);
      },
      updateProfile: function(profileData) {
        return $http.put(pathConstants.apiUrls.profile, profileData);
      },
      uploadImagePath: function (userID) {
        var path = pathConstants.apiUrls.users.single + "/image";
        return path.replace(":id", userID);
      }
    };
  })
  //TODO: rename this to be single profile factory (Ahmed Saleh)
  .factory('updateProfile', function($resource, $filter, pathConstants) {
    return $resource(
        pathConstants.apiUrls.profile,
        {
          id: '@id'
        },
        {
          'get': {method: 'GET'},
          'put': {method: 'PUT'}
        }
    )
  });

'use strict';

function UserPermissions ($rootScope, globalFunc) {

  function validatePermission(profile, permission) {

    if(!!profile && !!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN'))
      return true;

    if (!profile) {
      return false;
    }

    if (!profile.view_perms) {
      return false;
    }

    if (profile.view_perms.length < 1) {
      return false;
    }

    if (!_.isString(permission)) {
      return false;
    }


    return true;
  }

  // get list of companies by permission, domain and profile
  function getCompaniesByPermission(profile, domain, permission) {
    return !!profile.view_perms[domain] && !!profile.view_perms[domain][permission] ?
      profile.view_perms[domain][permission] : [];
  }

  /**
   * types of permissions:
   *
   * C: Create
   * L: List
   * O: Open
   * U: Update
   * D: Delete
   *
   * @param profile
   * @param domain
   * @param permission
   * @param companyCode
   * @returns {boolean}
     */
  //TODO: document and rewrite this section to be clear (Ahmed Saleh 11/2/2016)
  function hasPermission(profile, domain, permission, companyCode) {

    if (!!globalFunc.findInArray(profile.roles, 'name', 'TENANT_SUPER_ADMIN'))
      return true;

    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    if(!!companyCode) {
      if (!!profile.view_perms[domain]) {
        if (permission in profile.view_perms[domain]) {
          if (!!profile.view_perms[domain][permission]) {
            if (!!profile.view_perms[domain][permission][0] && findInCompanyCodes(profile.view_perms[domain][permission], companyCode)) {
              return true;
            }
          }
        }
      }
    }
    else if(!!profile.view_perms[domain]) {
      if (permission in profile.view_perms[domain]) {
        if (!!profile.view_perms[domain][permission]) {
          return true;
        }
      }
    }

    return false;
  }

  function findInCompanyCodes(profileCodes, companyCode){
    if(!!profileCodes && !!companyCode) {
      for (var i in profileCodes) {
        if (!!profileCodes[i] && (profileCodes[i].toLowerCase() === companyCode.toLowerCase())) {
            return true;
        }
      }
    }
    return false;
  }

  //check permission on approval
  function checkApprovalTemplateAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ApprovalTemplate', permission)
  }

  //check permission on attachment
  function checkAttachmentAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Attachment', permission)
  }

  //check permission on company
  function checkCompaniesManagementAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Company', permission)
  }

  //check permission on costcenter
  function checkCostCentersManagementAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'CostCenter', permission)
  }

  //check permission on currency
  function checkCurrenciesAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Currencies', permission)
  }

  //check permission on ExchangeRate
  function checkExchangeRateAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ExchangeRate', permission)
  }

  //check permission on ExpenseType
  function checkExpenseTypeAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ExpenseTypes', permission)
  }

  //check permission on History
  function checkHistoryAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'History', permission)
  }

  //check permission on item
  function checkItemAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Item', permission)
  }

  //check permission on ItemDetail
  function checkItemDetailAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ItemDetail', permission)
  }

  //check permission on item import
  function ImportItemDetail(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ImportItemDetail', permission)
  }

  //check permission on Item import summary
  function ImportItemSummary(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ImportItemSummary', permission)
  }


  //check permission on PO
  function checkPOAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'PO', permission)
  }

  //check permission on PR
  function checkPRAccess(profile, permission, companyCode) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }
    if(permission.toLowerCase() !== 'c' && permission.toLowerCase() !== 'a'){
      companyCode = null;
    }
    return userPermission.hasPermission(profile, 'PR', permission, companyCode)
  }

  //check permission on Permission
  function checkPermissionAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Permission', permission)
  }

  //check permission on Role
  function checkRoleAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Role', permission)
  }

  //check permission on Supplier
  function checkSupplierAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Supplier', permission)
  }

  //check permission on Tax
  function checkTaxesManagementAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Tax', permission)
  }

  //check permission on Tenant
  function checkTenantAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Tenant', permission)
  }

  //check permission on UNSPSC
  function checkUNSPSCAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'UNSPSC', permission)
  }

  //check permission on UOM
  function checkUOMAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'UOM', permission)
  }

  //check permission on Users
  function checkUsersManagementAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Users', permission)
  }

  //check permission on Commodity Codes
  function checkCommodityCodeAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'Commodity', permission)
  }

  //check permission on Payment Terms
  function checkPaymentTermsAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'PaymentTerm', permission)
  }

  //check permission on Payment Methods
  function checkPaymentMethodsAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'PaymentMethod', permission)
  }

  //check permission on Report Logs
  function checkReportLogAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ReportLog', permission)
  }

  //check permission on Report Logs
  function checkSupplierTagAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'SupplierTag', permission)
  }

  //TODO: get the exact permission for exports log rather than use ReportLog's permissions (Justin 4/5/2016)
  //check permission on Exports Log
  function checkExportLogAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'ReportLog', permission)
  }

  //check permission on user sessions
  function checkUserSessionAccess(profile, permission) {
    if (userPermission.validatePermission(profile, permission) === false) {
      return false;
    }

    return userPermission.hasPermission(profile, 'UserSession', permission)
  }

  // Function to check permissions by module
  // todo: remove all the functions above and use this instead
  function checkPermissionsAccess(profile, permission, module) {
    if (userPermission.validatePermission(profile, permission) === false)
      return false;

    return userPermission.hasPermission(profile, module, permission);
  }

  // get list of companies by permission and profile on budget
  function getBudgetCompanies(profile, permission) {

    var companiesWithPermission = userPermission.getCompaniesByPermission(profile, 'Budget', permission);
    var budgetEnabledCompanies = [];

    _.forEach(profile.companies, function(company) {
      if (!!company.budget_setting.enable && companiesWithPermission.includes(company.code)) {
        budgetEnabledCompanies.push(company);
      }
    });

    return budgetEnabledCompanies;
  }

  var userPermission = {};
  userPermission.validatePermission = validatePermission;
  userPermission.getCompaniesByPermission = getCompaniesByPermission;
  userPermission.hasPermission = hasPermission;
  userPermission.checkApprovalTemplateAccess = checkApprovalTemplateAccess;
  userPermission.checkAttachmentAccess = checkAttachmentAccess;
  userPermission.checkCompaniesManagementAccess = checkCompaniesManagementAccess;
  userPermission.checkCostCentersManagementAccess = checkCostCentersManagementAccess;
  userPermission.checkCurrenciesAccess = checkCurrenciesAccess;
  userPermission.checkExchangeRateAccess = checkExchangeRateAccess;
  userPermission.checkExpenseTypeAccess = checkExpenseTypeAccess;
  userPermission.checkHistoryAccess = checkHistoryAccess;
  userPermission.checkItemAccess = checkItemAccess;
  userPermission.checkItemDetailAccess = checkItemDetailAccess;
  userPermission.ImportItemDetail = ImportItemDetail;
  userPermission.ImportItemSummary = ImportItemSummary;
  userPermission.checkPOAccess = checkPOAccess;
  userPermission.checkPRAccess = checkPRAccess;
  userPermission.checkPermissionAccess = checkPermissionAccess;
  userPermission.checkRolesAccess = checkRoleAccess;
  userPermission.checkSupplierAccess = checkSupplierAccess;
  userPermission.checkTaxesManagementAccess = checkTaxesManagementAccess;
  userPermission.checkTenantAccess = checkTenantAccess;
  userPermission.checkUNSPSCAccess = checkUNSPSCAccess;
  userPermission.checkUOMAccess = checkUOMAccess;
  userPermission.checkUsersManagementAccess = checkUsersManagementAccess;
  userPermission.checkPaymentTermsAccess = checkPaymentTermsAccess;
  userPermission.checkPaymentMethodAccess = checkPaymentMethodsAccess;
  userPermission.checkCommodityCodeAccess = checkCommodityCodeAccess;
  userPermission.checkUserSessionAccess = checkUserSessionAccess;
  userPermission.checkReportLogAccess = checkReportLogAccess;
  userPermission.checkExportLogAccess = checkExportLogAccess;
  userPermission.checkPermissionsAccess = checkPermissionsAccess;
  userPermission.checkSupplierTagAccess = checkSupplierTagAccess;
  userPermission.getBudgetCompanies = getBudgetCompanies;

  return userPermission;
}
UserPermissions.$inject = ['$rootScope', 'globalFunc'];
angular
  .module('metabuyer')
  .factory('UserPermissions',UserPermissions);



'use strict';

angular.module('metabuyer.services.catalogCode' , ['ngResource'])
  .factory('catalogCode',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalogCode.single,
        {
          id      : '@id',
          action  : '@action'
        },
        {
          'get'   : { method : 'GET' },
          'post'  : { method : 'POST' },
          'delete': { method : 'DELETE' },
          'put'   : { method : 'PUT' }
        }
      );
    })
  .factory('catalogCodeList',
    function($resource, pathConstants) {
      return $resource(
        pathConstants.apiUrls.catalogCode.list, {},
        {
          'get'   : { method : 'GET' }
        }
      );
    });

'use strict';

/**
 * Language file
 * first step of i18n
 */

angular.module('metabuyer').constant('lang', (function() {
  return {
    validation: {
      number: {
        isNumber: 'Please enter only numbers',
        positive: 'Value must be positive',
        noFraction: 'Value can not be fraction',
        notValidFraction: 'Fraction value is not valid'
      },
      percentage: {
        invalid: 'Invalid discount value'
      },
      lumpSum: {
        notHaving: 'The lump sum discount will be removed due to not having a ',
        different: 'The lump sum discount will be removed, due to having different '
      },
      required: {
        input: 'Please enter ',
        selection: 'Please select '
      },
      upload: {
        onlyImage: ' only accepts image file'
      }
    }
  }
})());

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7
 *
 * Custom scripts
 */

$(document).ready(function () {

  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = $('#wrapper').height() - 61;
    $('.sidebar-panel').css('min-height', heightWithoutNavbar + 'px');

    var navbarHeight = $('nav.navbar-default').height();
    var wrapperHeight = $('#page-wrapper').height();

    //$('.sidebar-panel').css('min-height', wrapperHeigh - 61 + 'px');

    if(navbarHeight > wrapperHeight){
      $('#page-wrapper').css('min-height', navbarHeight + 'px');
    }

    if(navbarHeight < wrapperHeight){
      $('#page-wrapper').css('min-height', $(window).height()  + 'px');
    }

    if ($('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        $('#page-wrapper').css('min-height', navbarHeight + 'px');
      } else {
        $('#page-wrapper').css('min-height', $(window).height() - 60 + 'px');
      }
    }

  }


  $(window).bind('load resize scroll', function() {
    if(!$('body').hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  $(window).scroll(function(){
    if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav') ) {
      $('#right-sidebar').addClass('sidebar-top');
    } else {
      $('#right-sidebar').removeClass('sidebar-top');
    }
  });


  setTimeout(function(){
    fix_height();
  })
});

// Minimalize menu when screen is less than 768px
$(window).bind('load resize', function () {
  if ($(document).width() < 769) {
    $('body').addClass('body-small')
  } else {
    $('body').removeClass('body-small')
  }
});

'use strict';

angular.module('metabuyer')
  .filter('toDate', ['$filter', function ($filter) {
    return function (value) {
      if (!value) return value;
      return Date.parse(value);
    }
  }])
  .filter('aging', ['$filter', function ($filter) {
    return function (value) {
      if (!value) return value;
      var hours = $filter('amDifference')(value, null, 'hours') * -1
      if (hours > 24)
        return $filter('amDifference')(value, null, 'days') * -1 + "d";
      return hours + "h"
    }
  }])
  .filter('unique', [function () {
    return function (value, property, alternateProperty) {
      var properties = !!property ? property.split('.') : [];
      var alternateProperties = !!alternateProperty ? alternateProperty.split('.') : [];
      return _.unique(_.map(value, function (item) {
        var newValue = item;
        for (var index = 0; index < properties.length && !!newValue; ++index)
          newValue = newValue[properties[index]];
        if (!!newValue)
          return newValue;
        newValue = item;
        for (var index = 0; index < alternateProperties.length && !!newValue; ++index)
          newValue = newValue[alternateProperties[index]];
        return newValue
      }));
    }
  }])
  .filter('list', [function () {
    return function (value, property, alternateProperty) {
      var properties = !!property ? property.split('.') : [];
      var alternateProperties = !!alternateProperty ? alternateProperty.split('.') : [];
      return _.map(value, function (item) {
        var newValue = item;
        for (var index = 0; index < properties.length && !!newValue; ++index)
          newValue = newValue[properties[index]];
        if (!!newValue)
          return newValue;
        newValue = item;
        for (var index = 0; index < alternateProperties.length && !!newValue; ++index)
          newValue = newValue[alternateProperties[index]];
        return newValue
      });
    }
  }])
  .filter('max', [function () {
    return function (value, property, alternateProperty) {
      var properties = !!property ? property.split('.') : [];
      var alternateProperties = !!alternateProperty ? alternateProperty.split('.') : [];
      return _.max(_.map(value, function (item) {
        var newValue = item;
        for (var index = 0; index < properties.length && !!newValue; ++index)
          newValue = newValue[properties[index]];
        if (!!newValue)
          return newValue;
        newValue = item;
        for (var index = 0; index < alternateProperties.length && !!newValue; ++index)
          newValue = newValue[alternateProperties[index]];
        return newValue
      }));
    }
  }])
  .filter('min', [function () {
    return function (value, property, alternateProperty) {
      var properties = !!property ? property.split('.') : [];
      var alternateProperties = !!alternateProperty ? alternateProperty.split('.') : [];
      return _.max(_.map(value, function (item) {
        var newValue = item;
        for (var index = 0; index < properties.length && !!newValue; ++index)
          newValue = newValue[properties[index]];
        if (!!newValue)
          return newValue;
        newValue = item;
        for (var index = 0; index < alternateProperties.length && !!newValue; ++index)
          newValue = newValue[alternateProperties[index]];
        return newValue
      }));
    }
  }])
  .filter('unixTime', [function () {
    return function (value) {
      if (!value)
        return value;
      var mili_time = new Date(value * 1000);
      var ret = mili_time.getTime();
      return ret;
    };
  }])
  .filter('emptyStringPlaceholder', [function() {
    return function(msg, placeholderString) {
      if (msg.trim().length === 0 || msg === null) {
        msg = placeholderString;
      }
      return msg;
    };
  }])
  .filter('newlineToBr', ['$sanitize', function($sanitize) {
    var tag = (/xhtml/i).test(document.doctype) ? '<br />' : '<br>';
    return function(msg) {
      // ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
      msg = (msg + '').replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, tag + '$1');
      return $sanitize(msg);
    };
  }])
  .filter('isoCurrency', ['$filter', function($filter) {
    var formatDecimalFilter = $filter('formatDecimal');
    return function(amount, currencyCode, fractionSize) {

      // default to 2 decimal places
      if (fractionSize === null) {
        fractionSize = 2;
      }

      // if null or undefined pass it through
      return (amount === null || amount === 0)
        ? amount + ' ' + currencyCode
        : $filter('number')(amount, fractionSize) + ' ' + currencyCode;
    };
  }])
  .filter('joinWaitingCondition', function(){
    return function (array) {

      var format_display_name = [];

      format_display_name = _.map(array, function(item){
        return item.display_name;
      });

      return format_display_name.join(" & ");
    }
  })
  .filter('titleCase', function(){
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase();});
    };
  })
  .filter('formatDecimal', function($filter) {
    // TODO: use $locale to get $locale.NUMBER_FORMATS.GROUP_SEP & .DECIMAL_SEP
    return function(input, maxDecimal) {
      if (!!input || input === 0) {
        // Check if the input is object
        if (typeof input === 'object') {
          input = input.active;
        }

        // decimal format
        input = parseFloat(input);

        input = Number(input).toFixed(maxDecimal || 4);
        return $filter("thousandSeparator")(input);
      }
    };
  })
  .filter('thousandSeparator', function() {
    return function(number) {
      number += '';
      var wholeNumber = number.split('.');
      var integerPart = wholeNumber[0];
      var factionalPart = wholeNumber.length > 1 ? '.' + wholeNumber[1] : '';
      var regex = /(\d+)(\d{3})/;
      while (regex.test(integerPart)) {
        integerPart = integerPart.replace(regex, '$1' + ',' + '$2');
      }
      return integerPart + factionalPart;
    }
  })
  .filter('escapeHtml', function() {
    return function(input) {
      if (!!input) {

        // TODO: check other characters if needed
        if (input.indexOf('<') > -1) {
          input = input.replace(/\</g, '&lt;')
        }
        if (input.indexOf('>') > -1) {
          input = input.replace(/\>/g, '&gt;')
        }
      }

      return input;
    }
  })
  .filter('reverse', function() {
    return function(items) {
      return items.slice().reverse();
    };
  })
  .filter('positive', function() {
    return function(input) {
      if (!input) {
        return 0;
      }

      return Math.abs(input);
    };
  })
  .filter('capitalize', function() {
    return function (input) {
      if (input != null)
        return input.toLowerCase().substring(0, 1).toUpperCase() + input.substring(1);
    }
  })
  .filter('changeStringCase', function($filter) {
    return function(input){
      var newString = input.replace(/_/g, ' ');
      newString = $filter('titleCase')(newString);
      return newString;
    }
  })
  .filter('toArray', function() {
    return function(obj) {
      if (!(obj instanceof Object)) return obj;
      return _.map(obj, function(val, key) {
        return Object.defineProperty(val, '$key', {__proto__: null, value: key});
      });
    }
  })
  .filter('roundDecimals', function(){
    return function(number){
      return math.round(number, 4);
    }
  })
  .filter('excludeMetabuyerModel', function(){
    return function(input){
      if (!!input) {
        var newString = input.replace('Metabuyer\\Models\\', '');
        newString = newString.replace('Metabuyer\\PR\\', '');

        if (newString === 'ImportItemSummary') {
          newString = 'Catalog';
        }
        return newString;
      }

      return input;
    }
  });

/**
 * INSPINIA - Responsive Admin Theme
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *  - bootstrapTagsinput
 *  - passwordMeter
 *
 */


/**
 * pageTitle - Directive for set Page title - mata title
 */
function pageTitle($rootScope, $timeout) {
  return {
    link: function(scope, element) {
      var listener = function(event, toState, toParams, fromState, fromParams) {
        // Default title - load on Dashboard 1
        var title = 'INSPINIA | Responsive Admin Theme';
        // Create your own title pattern
        if (toState.data && toState.data.pageTitle) title = 'INSPINIA | ' + toState.data.pageTitle;
        $timeout(function() {
          element.text(title);
        });
      };
      $rootScope.$on('$stateChangeStart', listener);
    }
  }
};

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
function sideNavigation($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      // Call the metisMenu plugin and plug it to sidebar navigation
      $timeout(function(){
        $('#side-menu').metisMenu();

      });

      // Enable initial fixed sidebar
      if ($("body").hasClass('fixed-sidebar')) {
        var sidebar = element.parent();
        sidebar.slimScroll({
          height: '100%',
          railOpacity: 0.9
        });
      }
    }
  };
};

/**
 * responsibleVideo - Directive for responsive video
 */
function responsiveVideo() {
  return {
    restrict: 'A',
    link:  function(scope, element) {
      var figure = element;
      var video = element.children();
      video
        .attr('data-aspectRatio', video.height() / video.width())
        .removeAttr('height')
        .removeAttr('width')

      //We can use $watch on $window.innerWidth also.
      $(window).resize(function() {
        var newWidth = figure.width();
        video
          .width(newWidth)
          .height(newWidth * video.attr('data-aspectRatio'));
      }).resize();
    }
  }
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxTools($timeout) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'views/common/ibox_tools.html',
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest('div.ibox');
        var icon = $element.find('i:first');
        var content = ibox.children('.ibox-content');
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        $timeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest('div.ibox');
        ibox.remove();
      }
    }
  };
}

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreen($timeout) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'views/common/ibox_tools_full_screen.html',
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest('div.ibox');
        var icon = $element.find('i:first');
        var content = ibox.children('.ibox-content');
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        $timeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest('div.ibox');
        ibox.remove();
      };
      // Function for full screen
      $scope.fullscreen = function () {
        var ibox = $element.closest('div.ibox');
        var button = $element.find('i.fa-expand');
        $('body').toggleClass('fullscreen-ibox-mode');
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        ibox.toggleClass('fullscreen');
        setTimeout(function() {
          $(window).trigger('resize');
        }, 100);
      }
    }
  };
}

/**
 * minimalizaSidebar - Directive for minimalize sidebar
 */
function minimalizaSidebar($timeout) {
  return {
    restrict: 'A',
    template: '<a id="burgerMenuToggle" class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ' +
    'ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
    controller: function ($scope, $element, globalFunc) {
      $scope.minimalize = minimalize;
      function minimalize() {
        $('body').toggleClass('mini-navbar');

        if ((!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) &&
        !globalFunc.isMobileBrowser()) {
          // Hide menu in order to smoothly turn on when maximize menu
          $('#side-menu').hide();
          // To smoothly turn on menu
          setTimeout(
            function () {
              $('#side-menu').fadeIn(400);
            }, 200);
        } else if ($('body').hasClass('fixed-sidebar')){
          $('#side-menu').hide();
          setTimeout(
            function () {
              $('#side-menu').fadeIn(400);
            }, 100);
        }
        // If is mobile browser
        else if (globalFunc.isMobileBrowser()) {
          $('body').toggleClass('mini-navbar mobile-navbar');
          // To smoothly turn on menu
          setTimeout(
            function () {
              $('#side-menu').fadeIn();
            }, 200);
        }
        else {
          // Remove all inline style from jquery fadeIn function to reset menu state
          $('#side-menu').removeAttr('style');
        }
      }
    }
  };
}

function closeOffCanvas() {
  return {
    restrict: 'A',
    template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
    controller: function ($scope, $element) {
      $scope.closeOffCanvas = function () {
        $("body").toggleClass("mini-navbar");
      }
    }
  };
}

/**
 * vectorMap - Directive for Vector map plugin
 */
function vectorMap() {
  return {
    restrict: 'A',
    scope: {
      myMapData: '=',
    },
    link: function (scope, element, attrs) {
      var map = element.vectorMap({
        map: 'world_mill_en',
        backgroundColor: "transparent",
        regionStyle: {
          initial: {
            fill: '#e4e4e4',
            "fill-opacity": 0.9,
            stroke: 'none',
            "stroke-width": 0,
            "stroke-opacity": 0
          }
        },
        series: {
          regions: [
            {
              values: scope.myMapData,
              scale: ["#1ab394", "#22d6b1"],
              normalizeFunction: 'polynomial'
            }
          ]
        },
      });
      var destroyMap = function(){
        element.remove();
      };
      scope.$on('$destroy', function() {
        destroyMap();
      });
    }
  }
}


/**
 * sparkline - Directive for Sparkline chart
 */
function sparkline() {
  return {
    restrict: 'A',
    scope: {
      sparkData: '=',
      sparkOptions: '=',
    },
    link: function (scope, element, attrs) {
      scope.$watch(scope.sparkData, function () {
        render();
      });
      scope.$watch(scope.sparkOptions, function(){
        render();
      });
      var render = function () {
        $(element).sparkline(scope.sparkData, scope.sparkOptions);
      };
    }
  }
};

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, element, $attrs, ngModel) {
      return $timeout(function() {
        var value;
        value = $attrs['value'];

        $scope.$watch($attrs['ngModel'], function(newValue){
          $(element).iCheck('update');
        });

        return $(element).iCheck({
          checkboxClass: 'icheckbox_minimal-grey',
          radioClass: 'iradio_square-green'

        }).on('ifChanged', function(event) {
          if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
            $scope.$apply(function() {
              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    }
  };
}

/**
 * ionRangeSlider - Directive for Ion Range Slider
 */
function ionRangeSlider() {
  return {
    restrict: 'A',
    scope: {
      rangeOptions: '='
    },
    link: function (scope, elem, attrs) {
      elem.ionRangeSlider(scope.rangeOptions);
    }
  }
}

/**
 * dropZone - Directive for Drag and drop zone file upload plugin
 */
function dropZone() {
  return {
    restrict: 'C',
    link: function(scope, element, attrs) {

      var config = {
        url: 'http://localhost:8080/upload',
        maxFilesize: 100,
        paramName: "uploadfile",
        maxThumbnailFilesize: 10,
        parallelUploads: 1,
        autoProcessQueue: false
      };

      var eventHandlers = {
        'addedfile': function(file) {
          scope.file = file;
          if (this.files[1]!=null) {
            this.removeFile(this.files[0]);
          }
          scope.$apply(function() {
            scope.fileAdded = true;
          });
        },

        'success': function (file, response) {
        }

      };

      dropzone = new Dropzone(element[0], config);

      angular.forEach(eventHandlers, function(handler, event) {
        dropzone.on(event, handler);
      });

      scope.processDropzone = function() {
        dropzone.processQueue();
      };

      scope.resetDropzone = function() {
        dropzone.removeAllFiles();
      }
    }
  }
}

/**
 * chatSlimScroll - Directive for slim scroll for small chat
 */
function chatSlimScroll($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      $timeout(function(){
        element.slimscroll({
          height: '234px',
          railOpacity: 0.4
        });

      });
    }
  };
}

/**
 * customValid - Directive for custom validation example
 */
function customValid(){
  return {
    require: 'ngModel',
    link: function(scope, ele, attrs, c) {
      scope.$watch(attrs.ngModel, function() {

        // You can call a $http method here
        // Or create custom validation

        var validText = "Inspinia";

        if(scope.extras == validText) {
          c.$setValidity('cvalid', true);
        } else {
          c.$setValidity('cvalid', false);
        }

      });
    }
  }
}


/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout){
  return {
    restrict: 'A',
    link: function(scope, element) {
      $timeout(function(){
        element.slimscroll({
          height: '100%',
          railOpacity: 0.9
        });

      });
    }
  };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScroll($timeout){
  return {
    restrict: 'A',
    scope: {
      boxHeight: '@'
    },
    link: function(scope, element) {
      $timeout(function(){
        element.slimscroll({
          height: scope.boxHeight,
          railOpacity: 0.9
        });

      });
    }
  };
}

/**
 * clockPicker - Directive for clock picker plugin
 */
function clockPicker() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.clockpicker();
    }
  };
};


/**
 * landingScrollspy - Directive for scrollspy in landing page
 */
function landingScrollspy(){
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.scrollspy({
        target: '.navbar-fixed-top',
        offset: 80
      });
    }
  }
}

/**
 * fitHeight - Directive for set height fit to window height
 */
function fitHeight(){
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.css("height", $(window).height() + "px");
      element.css("min-height", $(window).height() + "px");
    }
  };
}

/**
 * truncate - Directive for truncate string
 */
function truncate($timeout){
  return {
    restrict: 'A',
    scope: {
      truncateOptions: '='
    },
    link: function(scope, element) {
      $timeout(function(){
        element.dotdotdot(scope.truncateOptions);

      });
    }
  };
}


/**
 * touchSpin - Directive for Bootstrap TouchSpin
 */
function touchSpin() {
  return {
    restrict: 'A',
    scope: {
      spinOptions: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch(scope.spinOptions, function(){
        render();
      });
      var render = function () {
        $(element).TouchSpin(scope.spinOptions);
      };
    }
  }
};

/**
 * markdownEditor - Directive for Bootstrap Markdown
 */
function markdownEditor() {
  return {
    restrict: "A",
    require:  'ngModel',
    link:     function (scope, element, attrs, ngModel) {
      $(element).markdown({
        savable:false,
        onChange: function(e){
          ngModel.$setViewValue(e.getContent());
        }
      });
    }
  }
};


/**
 * passwordMeter - Directive for jQuery Password Strength Meter
 */
function passwordMeter() {
  return {
    restrict: 'A',
    scope: {
      pwOptions: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch(scope.pwOptions, function(){
        render();
      });
      var render = function () {
        $(element).pwstrength(scope.pwOptions);
      };
    }
  }
};

/**
 *
 * Pass all functions into module
 */
angular
  .module('metabuyer')
  .directive('pageTitle', pageTitle)
  .directive('sideNavigation', sideNavigation)
  .directive('iboxTools', iboxTools)
  .directive('minimalizaSidebar', minimalizaSidebar)
  .directive('vectorMap', vectorMap)
  .directive('sparkline', sparkline)
  .directive('icheck', icheck)
  .directive('ionRangeSlider', ionRangeSlider)
  .directive('dropZone', dropZone)
  .directive('responsiveVideo', responsiveVideo)
  .directive('chatSlimScroll', chatSlimScroll)
  .directive('customValid', customValid)
  .directive('fullScroll', fullScroll)
  .directive('closeOffCanvas', closeOffCanvas)
  .directive('clockPicker', clockPicker)
  .directive('landingScrollspy', landingScrollspy)
  .directive('fitHeight', fitHeight)
  .directive('iboxToolsFullScreen', iboxToolsFullScreen)
  .directive('slimScroll', slimScroll)
  .directive('truncate', truncate)
  .directive('touchSpin', touchSpin)
  .directive('markdownEditor', markdownEditor)
  .directive('passwordMeter', passwordMeter);

'use strict';

angular.module('metabuyer').constant('pathConstants', (function() {
  var ip = 'BACKEND_IP';

  /**
   * Rollbar variables
   * possible environment value: production, staging, stg, development, local, sit
   * DEVELOPERS MUST USE local on their local machine.
   * Optional: for developers you can change the value of 'verbose' to true to check the Rollbar errors in the console log
   * the Initial values are for development
   */
  var token = 'ROLLBAR_TOKEN';
  var captureUncaught = true;
  var environment = 'local';
  var buildNumber = 'BUILD_NUMBER';
  var verbose = false;

  return {
    environmentUrl: ip,
    RollbarConfiguration:{
      token: token,
      captureUncaught: captureUncaught,
      environment: environment,
      verbose: verbose,
      buildNumber: buildNumber
    },
    baseUrl: '/',
    apiUrls: {
      login: ip + '/api/users/login',
      profile: ip + '/api/users/me',
      po: {
        list: ip + '/api/po',
        single: ip + '/api/po/:id',
        delete: ip + '/api/po/deleted/:id',
        status: ip + '/api/po/:id/:status',
        search: ip + '/api/po/search?example[creator]=:title',
        resend: ip + '/api/po/:id/resend',
        comment: ip + '/api/po/:id/comment/:comment_id',
        listAttachment: ip + '/api/po/:po_id/attach',
        singleAttachment: ip + '/api/po/:po_id/attach/:attachment_id',
        downloadAttachment: ip + '/api:hash',
        hash: ip + '/api/po/:id/pdf',
        pdfHash: ip + '/api:pdf_hash',
        receive: ip + '/api/po/:po_id/receive',
        reverse: ip + '/api/po/:po_id/reverse',
        closeLineItem: ip + '/api/po/:po_id/items/:item_id',
        grn: ip + '/api/grn/:id',
        getGRNPDFHash: ip + '/api/grn/:id/pdf'
      },
      users: {
        list: ip + '/api/users',
        search: ip + '/api/users/search?:text&response_form=users',
        single: ip + '/api/users/:id',
        status: ip + '/api/users/:id/:status',
        listPOStar: ip + '/api/users/:id/stared_pos',
        suppliersSearch: ip + '/api/suppliers/search',
        updatingPassword: ip + '/api/users/pass_reset',
        adminUnlockUser: ip + '/api/users/unlock/:id',
        activeUsers: ip + '/api/users/sessions/:session_id',
        image: ip + '/api/users/:id/image',
        notifications: ip + '/api/users/notifications/:id',
        unreadNotifications: ip + '/api/users/notifications/unread',
        readNotifications: ip + '/api/users/notifications/read',
        countUnreadNotifications: ip + '/api/users/notifications/unread/count',
        forgottenPassword: ip + '/api/users/forgot_password',
        importManager: ip + '/api/users/import_manager',
        importAssignments: ip + '/api/users/import_user_roles',
        exportAssignments: ip + '/api/users/export-user-assignments',
        budgets: ip + '/api/users/budgets',
        pendingApproval: ip + '/api/users/:userId/pending-approval/:companyCode'
      },
      companies: {
        list: ip + '/api/companies',
        single: ip + '/api/companies/:id',
        costCenters: ip + '/api/companies/:id/costcenters',
        accountCode: ip + '/api/companies/:id/account_code',
        currencies: ip + '/api/companies/:id/currencies',
        users: ip + '/api/companies/:id/users',
        activeUsers: ip + '/api/companies/:id/active-users',
        usersInCompanies: ip + '/api/companies/users',
        image: ip + '/api/companies/:id/image',
        search: ip + '/api/companies/search?query=:query',
        referenceCounter: ip + '/api/companies/:companyId/reference_counter/:referenceId/:action',
        referenceCounterSearch: ip + '/api/companies/:companyId/reference_counter/search',
        import: ip + '/api/companies/import',
        expenseTypes: ip + '/api/companies/:id/expense_types',
        costCentersAddress: ip + '/api/companies/:companyId/export-cost-centers'
      },
      costCenters: {
        new: ip + '/api/costcenters/',
        list: ip + '/api/costcenters',
        single: ip + '/api/costcenters/:id',
        import: ip + '/api/costcenters/import'
      },
      expenseTypes: {
        masterList: ip + '/api/expense_types/:id',
        list: ip + '/api/expense_types/list/all',
        search: ip + '/api/expense_types/search/?query=:query',
        import: ip + '/api/expense_types/import'
      },
      currencies: {
        list: ip + '/api/currencies/list/all',
        all: ip + '/api/currencies',
        masterList: ip + '/api/currencies/:id',
        search: ip + '/api/currencies/search/?query=:query',
        import: ip + '/api/currencies/import'
      },
      usersBehalfOf: {
        list: ip + '/api/costcenters/:id/users'
      },
      contactPersons: {
        list: ip + '/api/companies/:id/users',
        contacts: ip + '/api/contact',
        single: ip + '/api/contact/:id'
      },
      companyAddress: {
        single: ip + '/api/address/:company_id'
      },
      comments: {
        listPRNewComment: ip + '/api/prsNew/:referenceId/comment',
        listPOComment: ip + '/api/po/:referenceId/comment',
        listSupplierTagHistory: ip + '/api/supplierTag/:companyCode/comment',
        savePOComment: ip + '/api/po/:referenceId/comment/:comment_id',
        savePRNewComment: ip + '/api/prsNew/:referenceId/comment/:commentId',
        reference: ip + '/api/comments-history/:referenceId',
        listBudgetComment: ip + '/api/budgets/:referenceId/comments',
        saveBudgetComment: ip + '/api/budgets/:referenceId/comments/:commentId',
        single: ip + '/api/comments-history/:commentId'
      },
      attachments: {
        listPRNewAttachment: ip + '/api/prsNew/:pr_id/attachment',
        singlePRNewAttachment: ip + '/api/prsNew/:pr_id/attachment/:attachmentId',
        downloadAttachment: ip + '/api/attachment/download/:hash',
        downloadErrorLog: ip + '/api/attachment/download/log/:hash',
        category: ip + '/api/attachment-category/:id',
        description: ip + '/api/attachment-description/:id/host_class/:host_class/object_id/:object_id',
        field: ip + '/api/attachment-cat/:id',
        file: ip + '/api/attachment',
        detail: ip + '/api/attachment/:id',
        download: ip + '/api/attachment/download/:hash',
        reference: ip + '/api/attachments/:referenceId',
        single: ip + '/api/attachment/:attachmentId'
      },
      starring: {
        listPO: ip + '/api/po/:id/:action'
      },
      catalog: {
        list: ip + '/api/users/:user_id/items/:code',
        search: ip + '/api/users/:user_id/items/:type',
        details: ip + '/api/users/:user_id/items/:item_id/details',
        searching: ip + '/api/users/:user_id/items/search/',
        starringItem: ip + '/api/users/:user_id/items/:item_id/starred'
      },
      items: {
        list: ip + '/api/items/:status',
        delete: ip + '/api/items/:id',
        detail: ip + '/api/items/:id/details',
        import: ip + '/api/items/import',
        changeStatus: ip + '/api/items/:status/:id',
        imagesImport: ip + '/api/items/images/',
        nonCatalog: ip + '/api/users/:id/item',
        manageNonCatalog: ip + '/api/users/:user_id/item/:item_id/:action?itemName=:itemName&pr_cc=:pr_cc',
        itemDetailStarring: ip + '/api/users/:user_id/items/:item_id/:group',
        catalogVersion: ip + '/api/items/:summary_id/history',
        download: ip + '/api/items/:summary_id/attachment/:attachment_id',
        singleItemDetail: ip + '/api/items/:status/:summary_id/details/:import_item_id',
        checkImport: ip + '/api/items/import/validate/:supplier_id/:BU/:catalog_code_id',
        imagesUpload: ip + '/api/users/:user_id/item/:item_id/details/:detail_id/image',
        historyDetails: ip + '/api/items/:summary_id/details/',
        itemDetailsListing: ip + '/api/items/:summary_id/details/:status',
        singleItemDetails: ip + '/api/items/:summary_id/details/:import_item_id/info',
        listCatalogCode: ip + '/api/items/catalog_code/:supplier_id/:BU',
        registerViewedItem: ip + '/api/users/:user_id/viewed-item/:item_id'
      },
      itemsCategories: {
        list: ip + '/api/commodity/list/:code'
      },
      notification: {
        count: ip + '/api/notifications/count',
        subscribe: ip + '/api/notifications/:method',
        subscriptionCheck: ip + '/api/notifications/is_subscribed'
      },
      waitingOnUser: {
        list: ip + '/api/waiting'
      },
      tax: {
        list: ip + '/api/tax/list/all',
        masterList: ip + '/api/tax/:id',
        search: ip + '/api/tax/search/?query=:query',
        import: ip + '/api/tax/import'
      },
      uom: {
        list: ip + '/api/uoms/list/all?query=:query',
        single: ip + '/api/uoms/:id',
        search: ip + '/api/uoms/search/',
        import: ip + '/api/uoms/import'
      },
      suppliers: {
        list: ip + '/api/suppliers',
        listActive: ip + '/api/activeSuppliers',
        draft: ip + '/api/suppliers/draft/:id/:action',
        archives: ip + '/api/suppliers/archives/:id',
        single: ip + '/api/suppliers/:id',
        import: ip + '/api/suppliers/import',
        new: ip + '/api/suppliers',
        tagViaCompany: ip + '/api/supplier_tag/companyCode',
        tagBySupplierCode: ip + '/api/supplier_tag/:supplierCode/suppliercode',
        tagByCompanyCode: ip + '/api/supplier_tag/:companyCode/companycode',
        search: ip + '/api/suppliers/:status',
        status: ip + '/api/suppliers/:id/status/:status',
        singleAttachment: ip + '/api/suppliers/:supplier_id/attach/:attachment_id',
        downloadAttachment: ip + '/api/:hash',
        blackList: ip + '/api/suppliers/:supplier_id/status/2?comment=:comment',
        unBlackList: ip + '/api/suppliers/:supplier_id/status/0?comment=:comment',
        validateBranchDeletion: ip + '/api/suppliers/draft/:id/validate_branch_deletion',
        branches: ip + '/api/suppliers/:id/branches'
      },
      paymentMethods: {
        list: ip + '/api/payment_method/list/all',
        masterList: ip + '/api/payment_method/',
        single: ip + '/api/payment_method/:id',
        search: ip + '/api/payment_method/search/?query=:query',
        import: ip + '/api/payment_method/import'
      },
      BusinessUnits: {
        list: ip + '/api/business_units/',
        single: ip + '/api/business_units/:id',
        import: ip + '/api/business_units/import'
      },
      industry: {
        list: ip + '/api/industries',
        new: ip + '/api/industry',
        single: ip + '/api/industry/:id',
        import: ip + '/api/industry/import'
      },
      paymentTerms: {
        list: ip + '/api/payment_term/list/all',
        masterList: ip + '/api/payment_term/',
        single: ip + '/api/payment_term/:id',
        search: ip + '/api/payment_term/search/?query=:query',
        import: ip + '/api/payment_term/import'
      },
      commodity: {
        list: ip + '/api/commodity?code=:code',
        listChild: ip + '/api/commodity/list/child?code=:code',
        masterList: ip + '/api/commodity',
        single: ip + '/api/commodity/:id',
        search: ip + '/api/commodity/search/?query=:query',
        searchAllLevel: ip + '/api/commodity/list/search?keywords=:keywords',
        import: ip + '/api/commodity/import'
      },
      exchangeRate: {
        single: ip + '/api/companies/:id/exchange_rate/:source_id/:target_id',
        masterList: ip + '/api/companies/:id/exchange_rate/',
        search: ip + '/api/companies/:id/exchange_rate/search/?query=:query',
        rate: ip + '/api/companies/:id/exchange_rate/:rate_id',
        import: ip + '/api/companies/:id/exchange_rate/import'
      },
      globalExchangeRate: {
        import: ip + '/api/companies/global/exchange_rate/import'
      },
      addresses: {
        list: ip + '/api/address',
        single: ip + '/api/address/:id',
        import: ip + '/api/address/import'
      },
      approvals: {
        single: ip + '/api/approval/:id',
        draftPreview: ip + '/api/approval-preview',
        dataPreview: ip + '/api/approval-data-preview',
        status: ip + '/api/approval/:approval_id/action/:status',
        addApprover: ip + '/api/approval/:id/ad-hoc-approver',
        removeAdhoc: ip + '/api/approval/:id/step/:step/position/:positionId',
        multiApprovalActions: ip + '/api/approval/mass-action/:action'
      },
      available: {
        single: ip + '/api/available/:model/:field/:value'
      },
      auditList: {
        get: ip + '/api/audits'
      },
      accountCode: {
        list: ip + '/api/companies/:id/account_code/list/child?code=:code',
        prList: ip + '/api/account_code?company_code=:company_code&cost_center_id=:cost_center_id&parent_code=:parent_code',
        single: ip + '/api/companies/:id/account_code/:accountCode_id',
        search: ip + '/api/companies/:id/account_code/search/?query=:query',
        add: ip + '/api/companies/:id/account_code/',
        import: ip + '/api/companies/:id/account_code/import/'
      },
      image: {
        pr: ip + '/api/items/images/',
        user: ip + '/api'
      },
      permissions: {
        userList: ip + '/api/users/:id/permissions',
        list: ip + '/api/permissions/',
        parameters: ip + '/api/permissions/class/:class'
      },
      roles: {
        userList: ip + '/api/users/:id/roles',
        list: ip + '/api/roles/:id',
        position: ip + '/api/users/:id/:positionId',
        managePermissions: ip + '/api/roles/:id/permissions/:pid',
        listPermissions: ip + '/api/roles/:id/permissions',
        users: ip + '/api/roles/:id/users',
        importUserRoles: ip + '/api/roles/import'
      },
      escalation: {
        add: ip + '/api/users/:id/manager/:mid',
        delete: ip + '/api/users/:id/manager/'
      },
      reports: {
        generate: ip + '/api/reports/:id',
        download: ip + '/api/reports/download/:id',
        checkStatus: ip + '/api/reports/:id/check'
      },
      security: {
        password: ip + '/api/sys_conf/mb_security',
        tenant: ip + '/api/sys_conf/tenant'
      },
      delegation: {
        delegateToAUser: ip + '/api/users/:userId/delegate/:delegateeId',
        massDelegate: ip + '/api/users/:userId/mass-delegate',
        delegatedToAUser: ip + '/api/users/:userId/delegatees',
        delegatedFromAUser: ip + '/api/users/:userId/delegators',
        list: ip + '/api/delegations/:delegationId'
      },
      export: {
        generate: ip + '/api/exports',
        download: ip + '/api/exports/download/:export_hash',
        checkStatus: ip + '/api/exports/:id/check'
      },
      genericSearch: {
        searchBasePath: ip + '/api/search',
        search: ip + '/api/search/:module'
      },
      tenant: {
        image: ip + '/api/tenants/image',
        singleTenantById: ip + '/api/tenants/:id'
      },
      purchaseRequisitions: {
        getSinglePR: ip + '/api/prsNew/:id',
        searchPRs: ip + '/api/prsNew/search',
        createPR: ip + '/api/prsNew/',
        updatePRCompanyInfo: ip + '/api/prsNew/:id/company',
        checkPRCompanyInfo: ip + '/api/prsNew/:id/company-check',
        getAvailableDeliveryAddresses: ip + '/api/companies/:id/delivery-addresses',
        setPRTitle: ip + '/api/prsNew/:id/title',
        setRemarks: ip + '/api/prsNew/:id/remarks',
        setPRContactPerson: ip + '/api/prsNew/:id/contact-person',
        pdfHash: ip + '/api/prsNew/:id/pdf',
        getPRContactPersons: ip + '/api/companies/:id/users',
        getAvailableRequestorsList: ip + '/api/costcenters/:id/users',
        setExpenseType: ip + '/api/prsNew/:id/expense-type',
        setPaymentTerm: ip + '/api/prsNew/:id/payment-term',
        setRequestedBy: ip + '/api/prsNew/:id/requested-by',
        setNeededByDate: ip + '/api/prsNew/:id/needed-by-date',
        lumpSum: ip + '/api/prsNew/:id/lump-sum-discount',
        submitPR: ip + '/api/prsNew/:id/submit',
        withdrawPR: ip + '/api/prsNew/:id/withdraw',
        collaborators: ip + '/api/prsNew/:id/collaborators',
        item: ip + '/api/pr-items/:id/:action',
        starring: ip + '/api/prsNew/:id/star/:action',
        supplierNotes: ip + '/api/prsNew/:id/supplier_note',
        duplicate: ip + '/api/prsNew/:id/duplicate',
        moveToDraft: ip + '/api/prsNew/:id/to_draft',
        nonCatalogImage: ip + '/api/pr-items/:id/noncatalog-details',
        updateNonCatalogImage: ip + '/api/pr-items/:id/non-catalog-image',
        requestEditableCopy: ip + '/api/prsNew/:id/requestEditableCopy',
        submitEditedCopy: ip + '/api/prsNew/:id/submitEditedCopy',
        cancelEditedCopy: ip + '/api/prsNew/:id/cancelEditedCopy',
        resetApproval: ip + '/api/approval/:approval_id/reset-step'
      },
      imports: {
        now: ip + '/api/imports/now/'
      },
      catalogGroups: {
        list: ip + '/api/catalog_group/:groupId',
        assignment: ip + '/api/catalog_group/:groupId/company/:companyId',
        import: ip + '/api/catalog_group/import'
      },
      catalogCode: {
        single: ip + '/api/catalog_code/:id/:action',
        list: ip + '/api/catalog_code/list'
      },
      approvalEngine: {
        position: {
          get: ip + '/api/positions',
          single: ip + '/api/positions/:id',
          export: ip + '/api/positions/export'
        },
        positionAssign: {
          get: ip + '/api/position-assignments',
          single: ip + '/api/position-assignments/:id',
          export: ip + '/api/position-assignments/export'
        },
        approvalTemplate: {
          get: ip + '/api/approval-templates/',
          detail: ip + '/api/approval-templates/:id',
          info: ip + '/api/approval-templates-info',
          export: ip + '/api/approval-templates/export'
        },
        approvalTemplateHistory: {
          get: ip + '/api/approval-history',
          single: ip + '/api/approval-history/:id',
          all: ip + '/api/approval-history-template'
        }
      },
      budget: {
        list: ip + '/api/budgets',
        single: ip + '/api/budgets/:id/:action',
        apportionAllocation: ip + '/api/budget-apportion-allocations'
      },
      pdfPreview: {
        preview: ip + '/api/preview-pdf/:id'
      },
      globalPDFHashDownload: ip + '/api:pdf_hash',
      devInfo: ip + '/api/dev-info'
    }
  }
})());

'use strict';

angular.module('metabuyer').constant('pathConstants', (function() {
  var ip = 'https://stg.metabuyercloud.com';

  /**
   * Rollbar variables
   * possible environment value: production, staging, stg, development, local, sit
   * DEVELOPERS MUST USE local on their local machine.
   * Optional: for developers you can change the value of 'verbose' to true to check the Rollbar errors in the console log
   * the Initial values are for development
   */
  var token = 'ed785352cc8740c6a0420a1195ed87a6';
  var captureUncaught = true;
  var environment = 'stg';
  var buildNumber = '210';
  var verbose = false;

  return {
    environmentUrl: ip,
    RollbarConfiguration:{
      token: token,
      captureUncaught: captureUncaught,
      environment: environment,
      verbose: verbose,
      buildNumber: buildNumber
    },
    baseUrl: '/',
    apiUrls: {
      login: ip + '/api/users/login',
      profile: ip + '/api/users/me',
      po: {
        list: ip + '/api/po',
        single: ip + '/api/po/:id',
        delete: ip + '/api/po/deleted/:id',
        status: ip + '/api/po/:id/:status',
        search: ip + '/api/po/search?example[creator]=:title',
        resend: ip + '/api/po/:id/resend',
        comment: ip + '/api/po/:id/comment/:comment_id',
        listAttachment: ip + '/api/po/:po_id/attach',
        singleAttachment: ip + '/api/po/:po_id/attach/:attachment_id',
        downloadAttachment: ip + '/api:hash',
        hash: ip + '/api/po/:id/pdf',
        pdfHash: ip + '/api:pdf_hash',
        receive: ip + '/api/po/:po_id/receive',
        reverse: ip + '/api/po/:po_id/reverse',
        closeLineItem: ip + '/api/po/:po_id/items/:item_id',
        grn: ip + '/api/grn/:id',
        getGRNPDFHash: ip + '/api/grn/:id/pdf'
      },
      users: {
        list: ip + '/api/users',
        search: ip + '/api/users/search?:text&response_form=users',
        single: ip + '/api/users/:id',
        status: ip + '/api/users/:id/:status',
        listPOStar: ip + '/api/users/:id/stared_pos',
        suppliersSearch: ip + '/api/suppliers/search',
        updatingPassword: ip + '/api/users/pass_reset',
        adminUnlockUser: ip + '/api/users/unlock/:id',
        activeUsers: ip + '/api/users/sessions/:session_id',
        image: ip + '/api/users/:id/image',
        notifications: ip + '/api/users/notifications/:id',
        unreadNotifications: ip + '/api/users/notifications/unread',
        readNotifications: ip + '/api/users/notifications/read',
        countUnreadNotifications: ip + '/api/users/notifications/unread/count',
        forgottenPassword: ip + '/api/users/forgot_password',
        importManager: ip + '/api/users/import_manager',
        importAssignments: ip + '/api/users/import_user_roles',
        exportAssignments: ip + '/api/users/export-user-assignments',
        budgets: ip + '/api/users/budgets',
        pendingApproval: ip + '/api/users/:userId/pending-approval/:companyCode'
      },
      companies: {
        list: ip + '/api/companies',
        single: ip + '/api/companies/:id',
        costCenters: ip + '/api/companies/:id/costcenters',
        accountCode: ip + '/api/companies/:id/account_code',
        currencies: ip + '/api/companies/:id/currencies',
        users: ip + '/api/companies/:id/users',
        activeUsers: ip + '/api/companies/:id/active-users',
        usersInCompanies: ip + '/api/companies/users',
        image: ip + '/api/companies/:id/image',
        search: ip + '/api/companies/search?query=:query',
        referenceCounter: ip + '/api/companies/:companyId/reference_counter/:referenceId/:action',
        referenceCounterSearch: ip + '/api/companies/:companyId/reference_counter/search',
        import: ip + '/api/companies/import',
        expenseTypes: ip + '/api/companies/:id/expense_types',
        costCentersAddress: ip + '/api/companies/:companyId/export-cost-centers'
      },
      costCenters: {
        new: ip + '/api/costcenters/',
        list: ip + '/api/costcenters',
        single: ip + '/api/costcenters/:id',
        import: ip + '/api/costcenters/import'
      },
      expenseTypes: {
        masterList: ip + '/api/expense_types/:id',
        list: ip + '/api/expense_types/list/all',
        search: ip + '/api/expense_types/search/?query=:query',
        import: ip + '/api/expense_types/import'
      },
      currencies: {
        list: ip + '/api/currencies/list/all',
        all: ip + '/api/currencies',
        masterList: ip + '/api/currencies/:id',
        search: ip + '/api/currencies/search/?query=:query',
        import: ip + '/api/currencies/import'
      },
      usersBehalfOf: {
        list: ip + '/api/costcenters/:id/users'
      },
      contactPersons: {
        list: ip + '/api/companies/:id/users',
        contacts: ip + '/api/contact',
        single: ip + '/api/contact/:id'
      },
      companyAddress: {
        single: ip + '/api/address/:company_id'
      },
      comments: {
        listPRNewComment: ip + '/api/prsNew/:referenceId/comment',
        listPOComment: ip + '/api/po/:referenceId/comment',
        listSupplierTagHistory: ip + '/api/supplierTag/:companyCode/comment',
        savePOComment: ip + '/api/po/:referenceId/comment/:comment_id',
        savePRNewComment: ip + '/api/prsNew/:referenceId/comment/:commentId',
        reference: ip + '/api/comments-history/:referenceId',
        listBudgetComment: ip + '/api/budgets/:referenceId/comments',
        saveBudgetComment: ip + '/api/budgets/:referenceId/comments/:commentId',
        single: ip + '/api/comments-history/:commentId'
      },
      attachments: {
        listPRNewAttachment: ip + '/api/prsNew/:pr_id/attachment',
        singlePRNewAttachment: ip + '/api/prsNew/:pr_id/attachment/:attachmentId',
        downloadAttachment: ip + '/api/attachment/download/:hash',
        downloadErrorLog: ip + '/api/attachment/download/log/:hash',
        category: ip + '/api/attachment-category/:id',
        description: ip + '/api/attachment-description/:id/host_class/:host_class/object_id/:object_id',
        field: ip + '/api/attachment-cat/:id',
        file: ip + '/api/attachment',
        detail: ip + '/api/attachment/:id',
        download: ip + '/api/attachment/download/:hash',
        reference: ip + '/api/attachments/:referenceId',
        single: ip + '/api/attachment/:attachmentId'
      },
      starring: {
        listPO: ip + '/api/po/:id/:action'
      },
      catalog: {
        list: ip + '/api/users/:user_id/items/:code',
        search: ip + '/api/users/:user_id/items/:type',
        details: ip + '/api/users/:user_id/items/:item_id/details',
        searching: ip + '/api/users/:user_id/items/search/',
        starringItem: ip + '/api/users/:user_id/items/:item_id/starred'
      },
      items: {
        list: ip + '/api/items/:status',
        delete: ip + '/api/items/:id',
        detail: ip + '/api/items/:id/details',
        import: ip + '/api/items/import',
        changeStatus: ip + '/api/items/:status/:id',
        imagesImport: ip + '/api/items/images/',
        nonCatalog: ip + '/api/users/:id/item',
        manageNonCatalog: ip + '/api/users/:user_id/item/:item_id/:action?itemName=:itemName&pr_cc=:pr_cc',
        itemDetailStarring: ip + '/api/users/:user_id/items/:item_id/:group',
        catalogVersion: ip + '/api/items/:summary_id/history',
        download: ip + '/api/items/:summary_id/attachment/:attachment_id',
        singleItemDetail: ip + '/api/items/:status/:summary_id/details/:import_item_id',
        checkImport: ip + '/api/items/import/validate/:supplier_id/:BU/:catalog_code_id',
        imagesUpload: ip + '/api/users/:user_id/item/:item_id/details/:detail_id/image',
        historyDetails: ip + '/api/items/:summary_id/details/',
        itemDetailsListing: ip + '/api/items/:summary_id/details/:status',
        singleItemDetails: ip + '/api/items/:summary_id/details/:import_item_id/info',
        listCatalogCode: ip + '/api/items/catalog_code/:supplier_id/:BU',
        registerViewedItem: ip + '/api/users/:user_id/viewed-item/:item_id'
      },
      itemsCategories: {
        list: ip + '/api/commodity/list/:code'
      },
      notification: {
        count: ip + '/api/notifications/count',
        subscribe: ip + '/api/notifications/:method',
        subscriptionCheck: ip + '/api/notifications/is_subscribed'
      },
      waitingOnUser: {
        list: ip + '/api/waiting'
      },
      tax: {
        list: ip + '/api/tax/list/all',
        masterList: ip + '/api/tax/:id',
        search: ip + '/api/tax/search/?query=:query',
        import: ip + '/api/tax/import'
      },
      uom: {
        list: ip + '/api/uoms/list/all?query=:query',
        single: ip + '/api/uoms/:id',
        search: ip + '/api/uoms/search/',
        import: ip + '/api/uoms/import'
      },
      suppliers: {
        list: ip + '/api/suppliers',
        listActive: ip + '/api/activeSuppliers',
        draft: ip + '/api/suppliers/draft/:id/:action',
        archives: ip + '/api/suppliers/archives/:id',
        single: ip + '/api/suppliers/:id',
        import: ip + '/api/suppliers/import',
        new: ip + '/api/suppliers',
        tagViaCompany: ip + '/api/supplier_tag/companyCode',
        tagBySupplierCode: ip + '/api/supplier_tag/:supplierCode/suppliercode',
        tagByCompanyCode: ip + '/api/supplier_tag/:companyCode/companycode',
        search: ip + '/api/suppliers/:status',
        status: ip + '/api/suppliers/:id/status/:status',
        singleAttachment: ip + '/api/suppliers/:supplier_id/attach/:attachment_id',
        downloadAttachment: ip + '/api/:hash',
        blackList: ip + '/api/suppliers/:supplier_id/status/2?comment=:comment',
        unBlackList: ip + '/api/suppliers/:supplier_id/status/0?comment=:comment',
        validateBranchDeletion: ip + '/api/suppliers/draft/:id/validate_branch_deletion',
        branches: ip + '/api/suppliers/:id/branches'
      },
      paymentMethods: {
        list: ip + '/api/payment_method/list/all',
        masterList: ip + '/api/payment_method/',
        single: ip + '/api/payment_method/:id',
        search: ip + '/api/payment_method/search/?query=:query',
        import: ip + '/api/payment_method/import'
      },
      BusinessUnits: {
        list: ip + '/api/business_units/',
        single: ip + '/api/business_units/:id',
        import: ip + '/api/business_units/import'
      },
      industry: {
        list: ip + '/api/industries',
        new: ip + '/api/industry',
        single: ip + '/api/industry/:id',
        import: ip + '/api/industry/import'
      },
      paymentTerms: {
        list: ip + '/api/payment_term/list/all',
        masterList: ip + '/api/payment_term/',
        single: ip + '/api/payment_term/:id',
        search: ip + '/api/payment_term/search/?query=:query',
        import: ip + '/api/payment_term/import'
      },
      commodity: {
        list: ip + '/api/commodity?code=:code',
        listChild: ip + '/api/commodity/list/child?code=:code',
        masterList: ip + '/api/commodity',
        single: ip + '/api/commodity/:id',
        search: ip + '/api/commodity/search/?query=:query',
        searchAllLevel: ip + '/api/commodity/list/search?keywords=:keywords',
        import: ip + '/api/commodity/import'
      },
      exchangeRate: {
        single: ip + '/api/companies/:id/exchange_rate/:source_id/:target_id',
        masterList: ip + '/api/companies/:id/exchange_rate/',
        search: ip + '/api/companies/:id/exchange_rate/search/?query=:query',
        rate: ip + '/api/companies/:id/exchange_rate/:rate_id',
        import: ip + '/api/companies/:id/exchange_rate/import'
      },
      globalExchangeRate: {
        import: ip + '/api/companies/global/exchange_rate/import'
      },
      addresses: {
        list: ip + '/api/address',
        single: ip + '/api/address/:id',
        import: ip + '/api/address/import'
      },
      approvals: {
        single: ip + '/api/approval/:id',
        draftPreview: ip + '/api/approval-preview',
        dataPreview: ip + '/api/approval-data-preview',
        status: ip + '/api/approval/:approval_id/action/:status',
        addApprover: ip + '/api/approval/:id/ad-hoc-approver',
        removeAdhoc: ip + '/api/approval/:id/step/:step/position/:positionId',
        multiApprovalActions: ip + '/api/approval/mass-action/:action'
      },
      available: {
        single: ip + '/api/available/:model/:field/:value'
      },
      auditList: {
        get: ip + '/api/audits'
      },
      accountCode: {
        list: ip + '/api/companies/:id/account_code/list/child?code=:code',
        prList: ip + '/api/account_code?company_code=:company_code&cost_center_id=:cost_center_id&parent_code=:parent_code',
        single: ip + '/api/companies/:id/account_code/:accountCode_id',
        search: ip + '/api/companies/:id/account_code/search/?query=:query',
        add: ip + '/api/companies/:id/account_code/',
        import: ip + '/api/companies/:id/account_code/import/'
      },
      image: {
        pr: ip + '/api/items/images/',
        user: ip + '/api'
      },
      permissions: {
        userList: ip + '/api/users/:id/permissions',
        list: ip + '/api/permissions/',
        parameters: ip + '/api/permissions/class/:class'
      },
      roles: {
        userList: ip + '/api/users/:id/roles',
        list: ip + '/api/roles/:id',
        position: ip + '/api/users/:id/:positionId',
        managePermissions: ip + '/api/roles/:id/permissions/:pid',
        listPermissions: ip + '/api/roles/:id/permissions',
        users: ip + '/api/roles/:id/users',
        importUserRoles: ip + '/api/roles/import'
      },
      escalation: {
        add: ip + '/api/users/:id/manager/:mid',
        delete: ip + '/api/users/:id/manager/'
      },
      reports: {
        generate: ip + '/api/reports/:id',
        download: ip + '/api/reports/download/:id',
        checkStatus: ip + '/api/reports/:id/check'
      },
      security: {
        password: ip + '/api/sys_conf/mb_security',
        tenant: ip + '/api/sys_conf/tenant'
      },
      delegation: {
        delegateToAUser: ip + '/api/users/:userId/delegate/:delegateeId',
        massDelegate: ip + '/api/users/:userId/mass-delegate',
        delegatedToAUser: ip + '/api/users/:userId/delegatees',
        delegatedFromAUser: ip + '/api/users/:userId/delegators',
        list: ip + '/api/delegations/:delegationId'
      },
      export: {
        generate: ip + '/api/exports',
        download: ip + '/api/exports/download/:export_hash',
        checkStatus: ip + '/api/exports/:id/check'
      },
      genericSearch: {
        searchBasePath: ip + '/api/search',
        search: ip + '/api/search/:module'
      },
      tenant: {
        image: ip + '/api/tenants/image',
        singleTenantById: ip + '/api/tenants/:id'
      },
      purchaseRequisitions: {
        getSinglePR: ip + '/api/prsNew/:id',
        searchPRs: ip + '/api/prsNew/search',
        createPR: ip + '/api/prsNew/',
        updatePRCompanyInfo: ip + '/api/prsNew/:id/company',
        checkPRCompanyInfo: ip + '/api/prsNew/:id/company-check',
        getAvailableDeliveryAddresses: ip + '/api/companies/:id/delivery-addresses',
        setPRTitle: ip + '/api/prsNew/:id/title',
        setRemarks: ip + '/api/prsNew/:id/remarks',
        setPRContactPerson: ip + '/api/prsNew/:id/contact-person',
        pdfHash: ip + '/api/prsNew/:id/pdf',
        getPRContactPersons: ip + '/api/companies/:id/users',
        getAvailableRequestorsList: ip + '/api/costcenters/:id/users',
        setExpenseType: ip + '/api/prsNew/:id/expense-type',
        setPaymentTerm: ip + '/api/prsNew/:id/payment-term',
        setRequestedBy: ip + '/api/prsNew/:id/requested-by',
        setNeededByDate: ip + '/api/prsNew/:id/needed-by-date',
        lumpSum: ip + '/api/prsNew/:id/lump-sum-discount',
        submitPR: ip + '/api/prsNew/:id/submit',
        withdrawPR: ip + '/api/prsNew/:id/withdraw',
        collaborators: ip + '/api/prsNew/:id/collaborators',
        item: ip + '/api/pr-items/:id/:action',
        starring: ip + '/api/prsNew/:id/star/:action',
        supplierNotes: ip + '/api/prsNew/:id/supplier_note',
        duplicate: ip + '/api/prsNew/:id/duplicate',
        moveToDraft: ip + '/api/prsNew/:id/to_draft',
        nonCatalogImage: ip + '/api/pr-items/:id/noncatalog-details',
        updateNonCatalogImage: ip + '/api/pr-items/:id/non-catalog-image',
        requestEditableCopy: ip + '/api/prsNew/:id/requestEditableCopy',
        submitEditedCopy: ip + '/api/prsNew/:id/submitEditedCopy',
        cancelEditedCopy: ip + '/api/prsNew/:id/cancelEditedCopy',
        resetApproval: ip + '/api/approval/:approval_id/reset-step'
      },
      imports: {
        now: ip + '/api/imports/now/'
      },
      catalogGroups: {
        list: ip + '/api/catalog_group/:groupId',
        assignment: ip + '/api/catalog_group/:groupId/company/:companyId',
        import: ip + '/api/catalog_group/import'
      },
      catalogCode: {
        single: ip + '/api/catalog_code/:id/:action',
        list: ip + '/api/catalog_code/list'
      },
      approvalEngine: {
        position: {
          get: ip + '/api/positions',
          single: ip + '/api/positions/:id',
          export: ip + '/api/positions/export'
        },
        positionAssign: {
          get: ip + '/api/position-assignments',
          single: ip + '/api/position-assignments/:id',
          export: ip + '/api/position-assignments/export'
        },
        approvalTemplate: {
          get: ip + '/api/approval-templates/',
          detail: ip + '/api/approval-templates/:id',
          info: ip + '/api/approval-templates-info',
          export: ip + '/api/approval-templates/export'
        },
        approvalTemplateHistory: {
          get: ip + '/api/approval-history',
          single: ip + '/api/approval-history/:id',
          all: ip + '/api/approval-history-template'
        }
      },
      budget: {
        list: ip + '/api/budgets',
        single: ip + '/api/budgets/:id/:action',
        apportionAllocation: ip + '/api/budget-apportion-allocations'
      },
      pdfPreview: {
        preview: ip + '/api/preview-pdf/:id'
      },
      globalPDFHashDownload: ip + '/api:pdf_hash',
      devInfo: ip + '/api/dev-info'
    }
  }
})());

angular.module("metabuyer").run(["$templateCache", function($templateCache) {$templateCache.put("app/approvalFlow/approvalFlow-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\"> {{tab.heading}} </a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span> {{::tab.heading}} </span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/approvalFlow/approvalFlow.html","<div class=\"state-master-data\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/approvalFlow/approvalFlow-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/budgetManagement/budgetManagement-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n    </li>\n\n    <li>\n      <a data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        More <span class=\"caret\"></span>\n      </a>\n      <ul class=\"dropdown-menu\" role=\"menu\">\n        <li ng-repeat=\"item in tabs.more\">\n          <a ng-click=\"changeTab(item)\">\n            {{::item.heading}}\n          </a>\n        </li>\n      </ul>\n    </li>\n\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" search-order-by=\"{{$parent.searchOrderBy}}\" search-order=\"{{$parent.searchOrder}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/budgetManagement/budgetManagement.html","<div class=\"state-budget-listing\">\n  <tab-drop-down data=\"tabData\" type=\"tabs\" activated-tab=\"activatedTab\" template-url=\"app/budgetManagement/budgetManagement-template.html\" activation-key=\"\'status\'\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/catalogView/catalogView-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" ng-class=\"tab.active=\'active\'\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\"><span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{::item.heading}}</a>\n        </li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/catalogView/catalogView.html","<div class=\"state_items_list\">\n  <tab-drop-down data=\"tabData\" type=\"tabs\" activated-tab=\"activatedTab\" template-url=\"app/catalogView/catalogView-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/companiesManagement/companiesManagement-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\"><span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{::item.heading}}</a></li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceHolder}}\" search-state=\"{{$parent.searchState}}\" search-status=\"all\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" text-model=\"{{$parent.searchText}}\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/companiesManagement/companiesManagement.html","<div class=\"state_users_companies_list\">\n  <tab-drop-down data=\"tabData\" activated-tab=\"activatedTab\" template-url=\"app/companiesManagement/companiesManagement-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/emailLogs/emailLogs-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"active\">\n      <a ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/emailLogs/emailLogs.html","<div class=\"state_items_list\">\n  <tab-drop-down data=\"tabData\" type=\"tabs\" activated-tab=\"activatedTab\" template-url=\"app/emailLogs/emailLogs-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/explore-apps/explore-apps.html","<div class=\"state_explore_apps_list\">\n  <div class=\"container-fluid\">\n    <div class=\"row row-beauty\">\n      <div class=\"apps-list\" ui-sortable=\"sortableOptions\" data-ng-model=\"apps\">\n        <div class=\"app-item\" data-ng-repeat=\"app in apps\">\n          <span>\n            {{ app.title }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/exportsListing/exportsListing-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a>{{tab.heading}}</a>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/exportsListing/exportsListing.html","<div class=\"state_users_companies_list\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/exportsListing/exportsListing-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/forgotPassword/forgotPasswordTemplate.html","\n<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div>\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <span ng-switch=\"passwordResent\">\n      <div ng-switch-when=\"true\" class=\"form-group has-feedback\">\n        <h4>{{message}}</h4>\n      </div>\n    <form ng-switch-default class=\"m-t\" role=\"form\" method=\"post\" ng-submit=\"sendEmail(email)\" name=\"sendNewPassword\">\n      <h5>Enter your email please.</h5>\n      <div class=\"form-group has-feedback\">\n        <label for=\"email\">Email</label>\n        <input type=\"email\" id=\"email\" class=\"form-control input-lg\" ng-model=\"email\" placeholder=\"Email\" required autofocus>\n        <span class=\"form-control-feedback\"></span>\n      </div>\n      <button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"sendNewPassword.$invalid\">Send</button>\n    </form>\n    </span>\n    <div>\n    <a id=\"backToLoginPageButton\" class=\"btn btn-default\" ui-sref=\"login\">Back to login</a>\n    <p class=\"m-t\">\n      <small>\n        Created in Kuala Lumpur<br>\n        Metacloud Sdn. Bhd. &copy; 2015<br>\n      </small>\n    </p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/items/items-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\"><span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{::item.heading}}</a></li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/items/items.html","<div class=\"state_items_list\">\n  <tab-drop-down data=\"tabData\" type=\"tabs\" activated-tab=\"activatedTab\" template-url=\"app/items/items-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/login/login.html","\n<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div>\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <form class=\"m-t\" role=\"form\" method=\"post\" ng-submit=\"login()\" name=\"loginForm\">\n      <input type=\"hidden\" name=\"redirect\" value=\"{{redirect}}\">\n      <div class=\"form-group has-feedback\">\n        <label for=\"mainLoginEmail\">Email</label>\n        <input type=\"email\" id=\"mainLoginEmail\" class=\"form-control input-lg\" ng-model=\"email\" placeholder=\"Email\" required autofocus>\n        <span class=\"form-control-feedback\"></span>\n      </div>\n      <div class=\"form-group has-feedback\">\n        <label for=\"mainLoginPassword\">Password</label>\n        <input type=\"password\" id=\"mainLoginPassword\" class=\"form-control input-lg\" ng-model=\"password\" placeholder=\"Password\" required>\n        <span class=\"form-control-feedback\"></span>\n      </div>\n      <div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!!error\">\n        <span class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></span>\n        <span class=\"sr-only\">Error:</span>\n        {{error}}\n        <span ng-if=\"!!errorCount\"><br>Login attempt(s) remaining: {{errorCount}}</span>\n      </div>\n      <button id=\"loginButton\" type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"loginForm.$invalid || isLoginClicked\">Login</button>\n      <a id=\"forgotPasswordText\" ui-sref=\"forgotPassword\">Forgot password?</a>\n    </form>\n    <p class=\"m-t\">\n      <small>\n        Created in Kuala Lumpur<br>\n        Metacloud Sdn. Bhd. &copy; 2015<br>\n      </small>\n    </p>\n  </div>\n</div>\n");
$templateCache.put("app/main/main.html","<div id=\"wrapper\">\n  <div class=\"screen-section\" ng-include=\"sidebarTemplateUrl\"></div>\n  <div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}} {{mobileClass}}\">\n    <div ng-include=\"navbarTemplateUrl\"></div>\n    <div ui-view></div>\n  </div>\n</div>\n");
$templateCache.put("app/main/prompt-connection.html","<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n\n      <h3 class=\"m-t-none m-b\">Oops! There\'s internet connectivity issues.</h3>\n\n      <p>This is taking longer than usual. Please check your internet connection or try again later.</p>\n\n      <button class=\"btn btn-sm btn-primary m-t-n-xs\" ng-click=\"refresh()\">\n        <strong><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': isRefresh}\"></i> Try Again</strong>\n      </button>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/masterDataManagement/Import-Template.html","<form>\n  <!--Just want to refer to this window style.-->\n  <div class=\"add-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Import {{title}}</h3>\n    </div>\n    <div class=\"ibox-content pr-attachment\">\n      <div class=\"row\">\n        <div class=\"col-lg-6\"><h3 style=\"text-align: left\">Upload a CSV</h3></div>\n\n      </div>\n\n      <br>\n      <master-import-attachment uploadlink=\"importLink\" params=\"params\"></master-import-attachment>\n      <p>Only support for CSV file.</p>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("app/masterDataManagement/master-data-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/masterDataManagement/master-data.html","<div class=\"state-master-data\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/masterDataManagement/master-data-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/orders/orders-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\"><span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n    </li>\n    <li>\n      <a data-toggle=\"dropdown\" class=\"dropdown-toggle\">More <span class=\"caret\"></span></a>\n      <ul class=\"dropdown-menu\" role=\"menu\">\n        <li ng-repeat=\"item in tabs.more track by $index\"> <a ng-click=\"changeTab(item)\">{{::item.heading}}</a></li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" text-model=\"{{$parent.searchText}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" search-status=\"{{ $parent.status }}\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/orders/orders.html","<div class=\"state_orders_list\">\n  <tab-drop-down class=\"screen-section\" data=\"tabData\" template-url=\"app/orders/orders-template.html\" activated-tab=\"activatedTab\" activation-key=\"\'status\'\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/positionManagement/positionManagement-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/positionManagement/positionManagement.html","<div class=\"state-master-data\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/positionManagement/positionManagement-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/purchaseRequisitions/purchaseRequisitions-mobile.html","<div class=\"state_requisitions_list\">\n  <tab-drop-down class=\"screen-section hide-scrollbar\" data=\"tabData\" activation-key=\"\'status\'\" template-url=\"app/purchaseRequisitions/purchaseRequisitions-template-mobile.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/purchaseRequisitions/purchaseRequisitions-template-mobile.html","\n  <ul class=\"nav nav-tabs list\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu track by $index\">\n          <a ng-click=\"changeTab(item)\">{{::item.heading}}</a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n\n\n\n");
$templateCache.put("app/purchaseRequisitions/purchaseRequisitions-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu track by $index\">\n          <a ng-click=\"changeTab(item)\">{{::item.heading}}</a>\n        </li>\n      </ul>\n    </li>\n\n    <li>\n      <a data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        More <span class=\"caret\"></span>\n      </a>\n      <ul class=\"dropdown-menu\" role=\"menu\">\n        <li ng-repeat=\"item in tabs.more\">\n          <a ng-click=\"changeTab(item)\">\n            {{::item.heading}}\n          </a>\n        </li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" search-order-by=\"{{$parent.searchOrderBy}}\" search-order=\"{{$parent.searchOrder}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/purchaseRequisitions/purchaseRequisitions.html","<div class=\"state_requisitions_list\">\n  <tab-drop-down class=\"screen-section\" data=\"tabData\" activation-key=\"\'status\'\" template-url=\"app/purchaseRequisitions/purchaseRequisitions-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/reports/reports-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\"><span>{{::tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{::item.heading}}</a></li>\n      </ul>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/reports/reports.html","<div class=\"state_users_companies_list\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/reports/reports-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/security/security.html","<div class=\"state-security\">\n  <div class=\"col-sm-12\">\n    <div class=\"ibox\">\n      <div class=\"ibox-content\">\n        <div class=\"row\">\n          <div class=\"col-md-7\">\n            <h2>Security</h2>\n          </div>\n          <generic-import module-name=\"Roles & Permissions\" params=\"params\">\n          </generic-import>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-12\">\n            <ui-select ng-model=\"company\" ng-change=\"selectCompany(company)\">\n              <ui-select-match placeholder=\"Select Company\">\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices refresh-delay=\"0\" repeat=\"c in companies | filter: $select.search\">\n                <div ng-bind-html=\"c.descr | highlight: $select.search\"></div>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n\n        <br>\n        <div class=\"row\">\n          <div class=\"col-md-7\">\n          </div>\n          <div class=\"col-md-5 text-right\">\n            <a class=\"btn btn-primary btn-xs\" ng-disabled=\"!activeCompany\" ng-click=\"createNewRole()\">\n              Add a new role\n            </a>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<ui-view></ui-view>\n");
$templateCache.put("app/settings/settingsTemplate.html","<div class=\"state_explore_apps_list\">\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/suppliersList/suppliersList-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs track by $index\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span>{{tab.heading}}</span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu track by $index\"><a ng-click=\"changeTab(item)\">{{item.heading}}</a></li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" search-order-by=\"{{$parent.searchOrderBy}}\" search-order=\"{{$parent.searchOrder}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/suppliersList/suppliersList.html","<div class=\"state_suppliers_list\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/suppliersList/suppliersList-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/suppliersManagement/suppliersManagement-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-if=\"!tab.menu\" id=\"{{tab.id}}\" ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      <a ng-if=\"!!tab.menu\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n        <span>{{tab.heading}}</span> <b class=\"fa fa-caret-down\"></b>\n      </a>\n      <ul ng-if=\"!!tab.menu\" class=\"dropdown-menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{item.heading}}</a></li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" search-order-by=\"{{$parent.searchOrderBy}}\" search-order=\"{{$parent.searchOrder}}\" text-model=\"{{$parent.searchText}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" search-status=\"{{$parent.status}}\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/suppliersManagement/suppliersManagement.html","<div class=\"state_suppliers_list\">\n  <tab-drop-down data=\"tabData\" template-url=\"app/suppliersManagement/suppliersManagement-template.html\" activated-tab=\"activatedTab\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/user/ui-router-tabs-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" ng-show=\"tab.visble == null || tab.visble\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-click=\"changeTab(tab)\" ng-if=\"!tab.menu\">{{tab.heading}}</a>\n      <a data-toggle=\"dropdown\" class=\"dropdown-toggle\" ng-if=\"tab.menu\"><span>{{tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul class=\"dropdown-menu\" ng-if=\"tab.menu\">\n        <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{item.heading}}</a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/usersManagement/usersManagement-template.html","<div>\n  <ul class=\"nav nav-tabs\">\n    <li ng-repeat=\"tab in tabs\" class=\"dropdown {{ tab.active ? \'active\' :\'\'}}\">\n      <a ng-click=\"changeTab(tab)\" ng-if=\"!tab.menu\">{{tab.heading}}</a>\n      <a data-toggle=\"dropdown\" class=\"dropdown-toggle\" ng-if=\"tab.menu\"><span>{{tab.heading}}</span> <b class=\"fa fa-caret-down\"></b></a>\n      <ul class=\"dropdown-menu\">\n         <li ng-repeat=\"item in tab.menu\"><a ng-click=\"changeTab(item)\">{{item.heading}}</a>\n         </li>\n      </ul>\n    </li>\n    <search-bar placeholder=\"{{$parent.searchPlaceholder}}\" search-state=\"{{$parent.searchState}}\" search-order-by=\"{{$parent.searchOrderBy}}\" search-order=\"{{$parent.searchOrder}}\" text-model=\"{{$parent.searchText}}\" search-status=\"{{$parent.status}}\" filters=\"$parent.columns\" search-filter=\"{{$parent.searchFilter}}\" condition=\" $parent.status\" parent-state=\"{{$parent.parentState}}\" parent-state-params=\"$parent.parentStateParams\">\n    </search-bar>\n  </ul>\n</div>\n");
$templateCache.put("app/usersManagement/usersManagement.html","<tab-drop-down data=\"tabData\" template-url=\"app/usersManagement/usersManagement-template.html\" activated-tab=\"activatedTab\">\n</tab-drop-down>\n<ui-view></ui-view>\n");
$templateCache.put("components/accountCode/Import-Template.html","<form>\n  <!--Just want to refer to this window style.-->\n  <div class=\"add-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Import {{title}}</h3>\n    </div>\n    <div class=\"ibox-content pr-attachment\">\n      <div class=\"row\">\n        <div class=\"col-lg-6\"><h3 style=\"text-align: left\">Upload a CSV</h3></div>\n\n      </div>\n\n      <br>\n      <master-import-attachment uploadlink=\"importLink\" companyid=\"id\"></master-import-attachment>\n      <p>Only support for CSV file.</p>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("components/accountCode/accountCodeTemplate.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Account Codes</span>\n        <master-export module-name=\"Account Codes\" collection=\"3\" company-code=\"code\">\n        </master-export>\n        <generic-import module-name=\"Account Codes\" params=\"params\">\n        </generic-import>\n      </div>\n      <form name=\"searchUom\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\">\n            <i class=\"fa fa-search\" ng-click=\"search(searchText)\"></i>\n          </span>\n          <input ng-model=\"searchText\" ng-enter=\"search(searchText)\" class=\"form-control\" placeholder=\"Search Account Code\">\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <span class=\"expense-header\">Add Account Code</span>\n    <form name=\"addAccountCode\" class=\"no-ng-check\" ng-submit=\"addNewAccountCode();\">\n        <div class=\"col-md-3 mt-15\">\n          <input ng-model=\"newAccountCode.code\" class=\"form-control\" placeholder=\"Enter code\" required>\n        </div>\n        <div class=\"col-md-3 mt-15\">\n          <input ng-model=\"newAccountCode.name\" class=\"form-control\" placeholder=\"Enter name\" required>\n        </div>\n        <div class=\"col-md-5 mt-15\">\n          <input ng-model=\"newAccountCode.descr\" class=\"form-control\" placeholder=\"Enter a description\" required>\n        </div>\n        <div class=\"col-md-1 mt-15\">\n          <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n          </columns-selector>\n        </div>\n      <div class=\"col-md-2 mt-15\" ng-class=\"{\'ui-select-error-highlight\': !newAccountCode.account_entries && !!submitted}\">\n        <ui-select ng-model=\"newAccountCode.account_entries\">\n          <ui-select-match placeholder=\"Select account entries...\">\n            {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in accountEntries | filter: $select.search\">\n            <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <span class=\"text-danger\" ng-show=\"!newAccountCode.account_entries && !!submitted\">\n            Account Entries is required\n        </span>\n      </div>\n      <div class=\"col-md-2 mt-15\" ng-class=\"{\'ui-select-error-highlight\': !newAccountCode.account_type && !!submitted}\">\n        <ui-select ng-model=\"newAccountCode.account_type\" required>\n          <ui-select-match placeholder=\"Select account type...\">\n            {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in accountType | filter: $select.search\">\n            <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <span class=\"text-danger\" ng-show=\"!newAccountCode.account_type && !!submitted\">\n            Account Type is required\n        </span>\n      </div>\n      <div class=\"col-md-3 mt-15\" ng-class=\"{\'ui-select-error-highlight\': !newAccountCode.account_receivable && !!submitted}\">\n        <ui-select ng-model=\"newAccountCode.account_receivable\" required>\n          <ui-select-match placeholder=\"Select account receivable...\">\n            {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in accountReceivable | filter: $select.search\">\n            <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <span class=\"text-danger\" ng-show=\"!newAccountCode.account_receivable && !!submitted\">\n            Account receivable is required\n        </span>\n      </div>\n      <div class=\"col-md-2 mt-15\" ng-class=\"{\'ui-select-error-highlight\': !newAccountCode.cost_centers && !!submitted}\">\n        <ui-select multiple=\"multiple\" ng-model=\"newAccountCode.cost_centers\">\n          <ui-select-match placeholder=\"Select cost centers...\">\n            {{ $item.descr }}\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in costCenters | filter: $select.search\">\n            <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <span class=\"text-danger\" ng-show=\"!newAccountCode.cost_centers && !!submitted\">\n            Cost centers is required\n        </span>\n      </div>\n      <div class=\"col-md-1 mt-15\">\n        <input type=\"submit\" value=\"Add\" class=\"btn btn-primary\">\n      </div>\n      <div class=\"col-md-2 mt-15\">\n        <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"accountCodesListService\" id=\"id\">\n        </pagination-service>\n      </div>\n    </form>\n  </div>\n\n\n  <a class=\"fa fa-times\" ng-click=\"reset()\" ng-if=\"!!query\">\n    Reset search\n  </a>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table st-table=\"dataList\" class=\"table\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\" ng-if=\"!query\">There are no data for now.</td>\n          <td colspan=\"9\" ng-if=\"!!query\">There are no data matching with search result.</td>\n        </tr>\n        <!--<tr ng-click= \"accountCodeDetail(data)\" title=\"Click to view child\" ng-repeat=\"data in dataList\" track by $index>-->\n        <tr title=\"Click to view child\" ng-repeat=\"data in dataList track by $index\">\n          <td ng-show=\"showColumn(\'name\')\">{{data.name}}</td>\n          <td ng-show=\"showColumn(\'code\')\">{{data.code}}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{data.descr || \'Not specified\'}}</td>\n          <td ng-show=\"showColumn(\'account_entries\')\">{{getAccountEntriesName(data.account_entries)}}</td>\n          <td ng-show=\"showColumn(\'account_receivable\')\">{{getAccountReceivableName(data.account_receivable)}}</td>\n          <td ng-show=\"showColumn(\'account_type\')\">{{getAccountTypeName(data.account_type)}}</td>\n          <td ng-show=\"showColumn(\'cost_centers\')\">\n            <span ng-if=\"!!data.cost_center && !!data.cost_center.length\">\n              {{ data.cost_center[0].descr }}\n            </span>\n            <span ng-if=\"data.cost_center.length > 1\">, </span>\n            <modal-more ng-if=\"data.cost_center.length > 1\" title=\"{{ data.name }}\" subtitle=\"Cost centers\" type=\"array\" data=\"data.cost_center\" filter=\"[\'code\', \'descr\']\">\n              <a>more</a>\n            </modal-more>\n          </td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ data.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ data.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ data.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ data.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{getActiveStatusName(data.is_active)}}</td>\n          <td ng-click=\"accountCodeDetail(data)\" class=\"text-center\"><a><i class=\"fa fa-pencil\"></i></a></td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/actionModal/actionModalTemplate-mobile.html","<div class=\"inmodal action-pr\">\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{title}}</h3>\n  </div>\n  <div class=\"modal-body\" ng-if=\"!!commentBlock\">\n    <textarea class=\"action-pr-text form-control\" ng-class=\"{\'empty-reason\': $parent.commentText.length === 0}\" ng-attr-placeholder=\"{{commentPlaceHolder}}\" ng-model=\"$parent.commentText\" rows=\"5\" cols=\"10\" id=\"holdPR\">\n    </textarea>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"form-group text-center\">\n      <div class=\"row\">\n        <div class=\"col-xs-6 col-sm-6 text-middle\">\n          <button id=\"confirmActionModal\" type=\"button\" class=\"btn btn-primary\" ng-click=\"confirm()\" ng-disabled=\"(!!commentBlock && !commentText) || submitted\">\n            Confirm\n          </button>\n        </div>\n        <div class=\"col-xs-6 col-sm-6 text-middle\">\n          <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\" ng-disabled=\"submitted\">\n            Cancel\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/actionModal/actionModalTemplate.html","<div class=\"inmodal action-pr\">\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{title}}</h3>\n  </div>\n  <div class=\"modal-body\" ng-if=\"!!commentBlock\">\n    <h5 ng-if=\"!!bodyMessage\">\n      {{bodyMessage}}\n    </h5>\n    <textarea class=\"action-modal-text-area\" ng-attr-placeholder=\"{{commentPlaceHolder}}\" ng-model=\"$parent.commentText\" rows=\"5\" cols=\"10\" id=\"holdPR\">\n    </textarea>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"form-group text-center\">\n      <div ng-if=\"!!enableAttachment\" class=\"row mb-10\">\n        <div class=\"col-md-12 attachment-category\">\n          <input type=\"file\" class=\"attachment-box text-center\" ngfile-model=\"attachment.file\">\n          <span class=\"color-grey pull-left m-b mt-15\">\n            <b>Supported files : .xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg, .zip</b>\n          </span>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-6 text-right\">\n          <button id=\"confirmActionModal\" type=\"button\" class=\"btn btn-primary\" ng-click=\"confirm()\" ng-disabled=\"(!!commentBlock && !commentText) || submitted\">\n            Confirm\n          </button>\n        </div>\n        <div class=\"col-md-6 text-left\">\n          <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\" ng-disabled=\"submitted\">\n            Cancel\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group text-center\">\n      <div class=\"row\">\n        <div class=\"col-md-12\" ng-if=\"!!nextActionId && nextActionId === \'loading\'\">\n          <i class=\"fa fa-spinner fa-pulse fa-fw\"></i> Loading the next pending {{message}} available\n        </div>\n        <div class=\"col-md-12\" ng-if=\"!!nextActionId && nextActionId !== \'loading\'\">\n          <h5>{{(nextActionAmount | number) - 1 }} more {{message}} pending your approval</h5>\n          <input type=\"checkbox\" icheck ng-model=\"goNextAction\" ng-click=\"checkNextAction(goNextAction)\" id=\"go-next\">\n          <label for=\"go-next\">Move to next {{message}}</label>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group text-center\">\n      <div class=\"row\">\n        <div class=\"col-md-12\" ng-if=\"!!sendEmail\">\n          <input type=\"checkbox\" icheck ng-model=\"sendEmail\" id=\"sendEmail\">\n          <label for=\"go-next\">Send Email</label>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/addContact/addContactTemplate.html","<div class=\"inmodal\">\n  <div class=\"add-contact\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x\n      </button>\n      <h3 class=\"modal-title add-contact-title\">Add new contact</h3>\n    </div>\n    <form ng-submit=\"addContact()\">\n      <div class=\"modal-body\">\n        <div class=\"form-group\">\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Name\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input id=\"addSupplierContactName\" type=\"text\" class=\"form-control\" ng-model=\"add_data.first_name\" ucwords ng-class=\"{\'highlight-error-input\': !add_data.first_name && !!clicked_submit}\" required>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Email\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input id=\"addSupplierContactEmail\" type=\"email\" class=\"form-control\" ng-model=\"add_data.email\">\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Phone\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input id=\"addSupplierContactPhone\" type=\"tel\" ng-class=\"{\'highlight-error-input\': !isValidPhoneNo}\" class=\"form-control\" ng-model=\"add_data.phone\" ng-change=\"validateNumbers(\'addSupplierContactPhone\', \'isValidPhoneNo\')\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-intl-tel-input required>\n              <br>\n              <span class=\"text-danger\" ng-show=\"!add_data.phone && !!clicked_submit\">\n                Phone number is required\n              </span>\n              <span class=\"text-danger\" ng-show=\"!isValidPhoneNo\">\n                Invalid phone number format\n              </span>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Fax\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input type=\"tel\" id=\"addSupplierContactFax\" ng-class=\"{\'highlight-error-input\': !isValidFaxNo}\" class=\"form-control\" ng-model=\"add_data.fax\" ng-change=\"validateNumbers(\'addSupplierContactFax\', \'isValidFaxNo\')\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-intl-tel-input>\n              <br>\n              <span class=\"text-danger\" ng-show=\"!isValidFaxNo\">\n                Invalid fax number format\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button id=\"addSupplierAddContactButton\" type=\"submit\" class=\"btn btn-primary\">Add</button>\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancel</button>\n      </div>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("components/addressBook/addressBookTemplate.html","<div class=\"inmodal address-book\">\n\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"closeAddressBook()\">x</button>\n    <span class=\"modal-title address-book-title\">Address book</span>\n    <!-- Single button -->\n    <span class=\"custom-dropdown-multiselect\" ng-dropdown-multiselect=\"\" options=\"column.columns\" selected-model=\"column.selectedColumns\" icon-class=\"\'fa fa-wrench\'\" extra-settings=\"column.setting\" events=\"column.events\">\n    </span>\n\n\n    <span ng-if=\"!!addressBook\">\n      <button class=\"btn btn-danger btn-md delete-multi-address-button\" uib-tooltip=\"Remove notes\" ng-click=\"removeMultiAddresses()\">\n        <i class=\"fa fa-trash\"></i>\n      </button>\n    </span>\n\n  </div>\n\n  <div class=\"modal-body\">\n    <br>\n    <table class=\"table table-hover\">\n      <thead>\n      <tr>\n        <td ng-show=\"column.showColumn(\'address_line_1\')\">Address Line 1</td>\n        <td ng-show=\"column.showColumn(\'address_line_2\')\">Address Line 2</td>\n        <td ng-show=\"column.showColumn(\'address_line_3\')\">Address Line 3</td>\n        <td ng-show=\"column.showColumn(\'postal_code\')\">Postcode</td>\n        <td ng-show=\"column.showColumn(\'city_state\')\">City, State</td>\n        <td ng-show=\"column.showColumn(\'phone\')\">Phone</td>\n        <td ng-show=\"column.showColumn(\'fax\')\">fax</td>\n      </tr>\n      <tr>\n        <td ng-if=\"column.showColumn(\'address_line_1\') || column.showColumn(\'address_line_2\') ||\n                   column.showColumn(\'address_line_3\')\" colspan=\"3\" class=\"address-book-filter\">\n          <input type=\"text\" placeholder=\"filter address\" ng-model=\"search.address\">\n          <button type=\"button\" class=\"close address-book-remove-filter\" ng-show=\"!!search.address\" ng-click=\"search.address = \'\'\">x</button>\n        </td>\n        <td ng-if=\"column.showColumn(\'postal_code\')\" class=\"address-book-filter\">\n          <input type=\"text\" placeholder=\"filter postal code\" ng-model=\"search.postal_code\">\n          <button type=\"button\" class=\"close address-book-remove-filter\" ng-show=\"!!search.postal_code\" ng-click=\"search.postal_code = \'\'\">x</button>\n        </td>\n        <td ng-if=\"column.showColumn(\'city_state\')\" class=\"address-book-filter\">\n          <input type=\"text\" placeholder=\"filter city, state\" ng-model=\"search.city_state\">\n          <button type=\"button\" class=\"close address-book-remove-filter\" ng-show=\"!!search.city_state\" ng-click=\"search.city_state = \'\'\">\n            <span aria-hidden=\"true\">&times;</span>\n          </button>\n        </td>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"address in addressList | adddressBookFilter: search track by $index\" ng-click=\"selectAddressBook(address)\" ng-class=\"{\'highlight-item\': addressBook == address._id,\n          \'address-primary\': prDeliveryAddress.address._id === address._id}\">\n            <td ng-show=\"column.showColumn(\'address_line_1\')\">\n              {{ !!address.line1 ? address.line1 : \'-\' }}\n            </td>\n            <td ng-show=\"column.showColumn(\'address_line_2\')\">\n              {{ !!address.line2 ? address.line2 : address.line2 }}\n            </td>\n            <td ng-show=\"column.showColumn(\'address_line_3\')\">\n              {{ !!address.line3 ? address.line3 : \'-\' }}\n            </td>\n            <td ng-show=\"column.showColumn(\'postal_code\')\">\n              {{ !!address.postal_code ? address.postal_code : \'-\' }}\n            </td>\n            <td ng-show=\"column.showColumn(\'city_state\')\">\n              {{ !!address.city ? address.city : \'-\'}},\n              {{ !!address.state ? address.state : \'-\' }}\n            </td>\n            <td ng-show=\"column.showColumn(\'phone\')\">\n              {{ !!address.phone ? address.phone : \'-\'}}\n            </td>\n            <td ng-show=\"column.showColumn(\'fax\')\">\n              {{ !!address.fax ? address.fax : \'-\'}}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n</div>\n\n");
$templateCache.put("components/addressInsertion/addressInsertion.html","<div>\n  <div class=\"form-group col-md-12\">\n    <input type=\"text\" ng-model=\"data.line1\" placeholder=\"Address Line 1\" class=\"form-control\" pattern=\"/^[0-9a-zA-Z/,.\\s]{5,}$/\" required ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,80}$\">\n  </div>\n  <div class=\"form-group col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <input type=\"text\" ng-model=\"data.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n      </div>\n      <div class=\"col-md-6\">\n        <input type=\"text\" ng-model=\"data.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <input type=\"text\" ng-model=\"data.postal_code\" placeholder=\"Post Code\" required class=\"form-control\">\n      </div>\n      <div class=\"col-md-6\">\n        <input type=\"text\" ng-model=\"data.city\" required placeholder=\"City\" class=\"form-control\" pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n      </div>\n    </div>\n  </div>\n  <div class=\"form-group col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <ui-select ng-model=\"data.country\" on-select=\"onSelectedCountry(data.country)\" required>\n          <ui-select-match placeholder=\"Select a Country\">\n            {{$select.selected.code}} - {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"country in countries | filter: $select.search\">\n            <span ng-bind-html=\"country.code + \' - \' + country.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n      <div class=\"col-md-6\">\n        <ui-select ng-model=\"data.state\" ng-show=\"!!stateIsExist\" on-select=\"onSelectedState(address.state)\" required>\n          <ui-select-match placeholder=\"Select a state\">\n            {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"state in countryStates | filter: $select.search\">\n            <span ng-bind-html=\"state.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <input ng-show=\"!stateIsExist\" type=\"text\" ng-model=\"data.state\" placeholder=\"State\" required class=\"form-control\" pattern=\"/^[a-zA-Z\\s]{2,}$/\" ng-pattern-restrict=\"^[a-zA-Z\\s]{0,50}$\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/addressesPanel/addressesPanelTemplate.html","<div class=\"\">\n  <div class=\"tabs-container\">\n    <ul class=\"nav nav-tabs\">\n      <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n        <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\"> Available Addresses</a>\n      </li>\n      <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n        <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">Add new Address</a>\n      </li>\n    </ul>\n    <div class=\"tab-content\">\n      <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{active : tab === 1}\">\n        <div class=\"panel-body address-panel-list\">\n          <div class=\"list-group col-md-12\">\n            <a class=\"list-group-item\" ng-repeat=\"address in addressesList track by $index\" ng-click=\"selectAddress(address)\" ng-class=\"{\'selected-address\': address._id === selectedAddress._id}\">\n              {{\'[ \' + (address.reference ? address.reference : \'N/A\') + \' ] - \'\n              + address.line1 + \' , \' + (!!address.line2 ? address.line2 + \' , \' : \'\') + address.postal_code}}\n            </a>\n          </div>\n        </div>\n      </div>\n      <div id=\"tab-2\" class=\"tab-pane\" ng-class=\"{active : tab === 2}\">\n        <div class=\"panel-body\">\n          <form name=\"addressForm\" ng-submit=\"addAddress()\">\n            <div class=\"form-group col-md-12\">\n              <input type=\"text\" ng-model=\"newAddress.line1\" placeholder=\"Address Line 1\" class=\"form-control\" required>\n            </div>\n            <div class=\"form-group col-md-12\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n                </div>\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group col-md-12\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.postal_code\" placeholder=\"Post Code\" required class=\"form-control\">\n                </div>\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.city\" required placeholder=\"City\" class=\"form-control\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group col-md-12\">\n              <div class=\"row\">\n                <div class=\"col-md-6\" ng-class=\"{\'highlight-error-input\': !newAddress.country && submittedAddress}\">\n                  <ui-select ng-model=\"newAddress.country\" on-select=\"onSelectedCountry(newAddress.country)\">\n                    <ui-select-match placeholder=\"Select a Country\">\n                      {{$select.selected.code}} - {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"country in countries | filter: $select.search\">\n                      <span ng-bind-html=\"country.code + \' - \' + country.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n                <div class=\"col-md-6\" ng-class=\"{\'highlight-error-input\': !newAddress.state && submittedAddress}\">\n                  <ui-select ng-model=\"newAddress.state\" ng-show=\"!!selectedMalaysia\" on-select=\"onSelectedState(newAddress.state)\">\n                    <ui-select-match placeholder=\"Select a state\">\n                      {{$select.selected}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"state in MYStates | filter: $select.search\">\n                      <span ng-bind-html=\"state.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <input ng-show=\"!selectedMalaysia\" type=\"text\" ng-model=\"newAddress.state\" placeholder=\"State\" required class=\"form-control\" ng-pattern-restrict=\"^[a-zA-Z\\s]{0,50}$\">\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group col-md-12\">\n              <div class=\"row\">\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.phone\" placeholder=\"Phone\" required class=\"form-control\" ng-pattern=\"/^[0-9A-Za-z\\s]{5,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z\\s]{0,30}$\">\n                </div>\n                <div class=\"col-md-6\">\n                  <input type=\"text\" ng-model=\"newAddress.fax\" placeholder=\"Fax\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n                </div>\n              </div>\n            </div>\n            <button id=\"submit\" class=\"pull-right btn btn-primary address-panel-submit-button\">Add new address</button>\n          </form>\n        </div>\n\n      </div>\n    </div>\n\n\n  </div>\n</div>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n");
$templateCache.put("components/approvalWaitingOn/approvalWaitingOnTemplate-mobile.html","<span>\n  <span ng-if=\"data.status.toLowerCase() ===\'pending\'\" class=\"waiting-on-title\" style=\"font-weight: bold\">\n    Waiting on\n  </span>\n  <span ng-if=\"data.status.toLowerCase() ===\'on_hold\'\" class=\"waiting-on-title\" style=\"font-weight: bold\">\n    On hold by\n  </span>\n  <br>\n  <a style=\"color: #676a6c\">\n    {{waiting_on_user}}\n  </a>\n</span>\n");
$templateCache.put("components/approvalWaitingOn/approvalWaitingOnTemplate.html","<div class=\"pr-action pull-left clear-floating-left pr-btn\" ng-class=\"{\'waiting-on-access-directly\': !status}\">\n  <div class=\"row no-padding approval-waiting-on\">\n    <div ng-if=\"data.status.toLowerCase() ===\'pending\' || data.status.toLowerCase() ===\'on_hold\'\" class=\"waiting-on-title\">\n      Waiting on:\n      <a class=\"btn-link\" ng-click=\"scrollTo(\'approval_id\')\">\n        {{waiting_on_user}}\n      </a>\n    </div>\n    <div ng-if=\"watcher.length > 0\" class=\"text-left\">\n      Watcher:\n      <a class=\"btn btn-link\" ng-click=\"scrollTo(\'approval_id\')\">\n        <span ng-repeat=\"user in watcher\">\n          {{ user.display_name }}\n          <span ng-if=\"!$last\">\n            ,\n          </span>\n        </span>\n      </a>\n    </div>\n  </div>\n\n  <div ng-if=\"data.status.toLowerCase() ===\'on_hold\' && !!onHoldBy\" class=\"row\">\n    <span class=\"waiting-on-title\">\n      On hold by:\n      <a class=\"btn btn-link\" ng-click=\"scrollTo(\'approval_id\')\">\n        {{onHoldBy}}\n      </a>\n    </span>\n  </div>\n</div>\n");
$templateCache.put("components/approvalflow/approvalflow-panel.html","<div class=\"ibox-content\">\n  <h3 style=\"text-align: left\">Approval flow</h3>\n  <div id=\"vertical-timeline\" class=\"vertical-container dark-timeline left-orientation\">\n    <div class=\"vertical-timeline-block\" ng-repeat=\"(index, approvals) in data\">\n      <div class=\"vertical-timeline-icon\" style=\"top: 9px\" ng-class=\"{\'gray-bg\': !approvals.current, \'navy-bg\': approvals.current}\">\n        <i>{{index}}</i>\n      </div>\n      <div class=\"vertical-timeline-content\">\n        <a ng-repeat=\"approval in approvals\" popover=\"{{approval.display_name}} ({{approval.role.name}})\" popover-trigger=\"mouseenter\">\n          <div style=\"display: inline-block; margin-right: 20px\">\n            <img alt=\"image\" with=\"32\" height=\"32\" class=\"img-circle\" ng-show=\"!!approval.img_url\" ng-class=\"{desaturate: !approval.status}\" ng-src=\"{{approval.img_url}}\">\n            <h5>{{approval.display_name}}</h5>\n            </div>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/attachment/attachment-panelTemplate.html","<div class=\"inmodal\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Attach file</h4>\n    </div>\n    <div class=\"modal-body\">\n\n        <div class=\"row\">\n            <div ng-repeat=\"filetype in filetypes\" class=\"col-lg-{{  12 / filetypes.length }}\">\n                <button class=\"btn btn-large-dim dim\" ng-click=\"selectFileType(filetype.title)\" ng-class=\"active(filetype.title)\">\n                    <i ng-class=\"filetype.logo\"></i>\n                </button>\n            </div>\n        </div>\n        <div class=\"table-responsive\">\n            <table class=\"table\">\n                <tbody>\n                    <tr>\n                        <td><strong>upload</strong></td>\n                        <td>\n                            <form class=\"dropzone\" dropzone=\"dropzoneConfig\" id=\"file-dropzone\" style=\"min-height:0px\">\n                                <div class=\"dz-message\" data-dz-message><span>Drop your files here or click</span></div>\n                            </form>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td><strong>title</strong></td>\n                        <td><input ng-model=\"detail.title\" class=\"form-control m-b\" type=\"text\"></td>\n                    </tr>\n                    <tr>\n                        <td><strong>description</strong></td>\n                        <td><input ng-model=\"detail.description\" class=\"form-control m-b\" type=\"text\"></td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(detail)\">Save changes</button>\n    </div>\n\n</div>\n\n");
$templateCache.put("components/attachment/attachmentTemplate-mobile.html","<div class=\"panel panel-default\">\n  <div class=\"ibox-content pr-attachment\">\n    <div class=\"row\">\n      <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 15px; font-weight: bold\">\n        <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px; margin-left: 2px\">\n        </i>\n        Attachments\n      </div>\n    </div>\n    <br>\n\n    <p class=\"text-muted\" ng-show=\"(files.length == 0 && (disableEdit)) ||\n      (!disableEdit && files.length == 0 && showDropZone == false)\">There are no attachments\n    </p>\n\n    <div class=\"row\" ng-repeat=\"file in files\">\n      <div class=\"col-xs-5 col-sm-5\">\n        <div class=\"file\">\n          <a ng-click=\"download(file._id)\">\n            <div class=\"icon\">\n              <i class=\"fa fa-download\" aria-hidden=\"true\">\n              </i>\n            </div>\n          </a>\n        </div>\n      </div>\n      <div class=\"col-xs-7 col-sm-7\">\n        <div class=\"file-name\">\n          <div class=\"pr-attachment-name\">{{::file.title}}\n          </div>\n          <div class=\"file-title\" ng-init=\"edit_is_visible_to_supplier = file.is_visible_to_supplier\">\n            <span class=\"pr-attachment-file-title-disable\" ng-show=\"disableEdit\">\n              <small><em>{{ !!file.description ? file.description : \'\'}}</em></small>\n            </span>\n          </div>\n          <small>Added by {{::file.creator.display_name}} <br> on {{file.created_at | date}}</small>\n        </div>\n        <br>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/attachment/attachmentTemplate.html","<div class=\"ibox-content pr-attachment\">\n  <div class=\"row\">\n    <div class=\"col-lg-6\"><h3 style=\"text-align: left\">Attachments</h3></div>\n    <div class=\"col-lg-6\" ng-hide=\"disableEdit\">\n      <a class=\"pull-right\" ng-click=\"showDropZone = !showDropZone\">{{\n      showDropZone ? \'Hide Uploader\' : \'Uploader\'}}</a>\n    </div>\n  </div>\n\n  <p class=\"text-muted\" ng-show=\"(files.length == 0 && (disableEdit)) ||\n  (!disableEdit && files.length == 0 && showDropZone == false)\">There are no attachments</p>\n\n  <form ng-show=\"!disableEdit && showDropZone\" action=\"\" class=\"dropzone\" dropzone=\"dropzoneConfig\" id=\"file-dropzone\" style=\"min-height: 220px\">\n    <div class=\"dropzone-supported-file-div\">\n      <span class=\"dropzone-supported-file-span\">\n        Supported files : .xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg\n      </span>\n    </div>\n  </form>\n  <br>\n\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"file-box\" ng-repeat=\"file in files track by $index\">\n        <div class=\"file\">\n          <div class=\"file-title text-ellipsis\" ng-init=\"edit_is_visible_to_supplier = file.is_visible_to_supplier\">\n            <span class=\"pr-attachment-file-title-disable\" ng-show=\"disableEdit\">\n              {{ !!file.description ? file.description : \"[Add title]\"}}</span>\n            <span class=\"pr-attachment-file-title\" editable-text=\"file.description\" e-required ng-hide=\"disableEdit\" blur=\"submit\" e-placeholder=\"[Add title]\" buttons=\"no\" e-style=\"display: inline;\" onaftersave=\"update(file, edit_is_visible_to_supplier)\" uib-tooltip=\"{{ file.description  || \'\'}}\" tooltip-placement=\"top-left\">{{ file.description || \"[Add title]\"}}</span>\n            <div>\n          </div>\n\n          </div>\n          <a ng-click=\"download(file._id)\">\n            <div class=\"icon\">\n              <i class=\"fa fa-file\"></i>\n            </div>\n          </a>\n          <div class=\"file-name\">\n            <div class=\"pr-attachment-name\">{{file.title}}</div>\n            <br>\n            <small>Added by {{::file.creator.display_name}} <br> on {{file.created_at | date: \'dd MMM yyyy\'}}</small>\n            <div class=\"pr-attachment-visible-checkbox\">\n              <input type=\"checkbox\" ng-click=\"update(file, edit_is_visible_to_supplier)\" ng-model=\"edit_is_visible_to_supplier\" id=\"visible-to-supplier-{{$index}}\" ng-disabled=\"disableEdit\" ng-hide=\"hideIsVisibleToSupplier\">\n              <label for=\"visible-to-supplier-{{$index}}\" ng-hide=\"hideIsVisibleToSupplier\">Visible to supplier</label>\n              <a type=\"button\" class=\"btn-xs btn-white pull-right pr-attachment-delete\" ng-click=\"delete(file)\" ng-hide=\"disableEdit\"><i class=\"fa fa-trash-o\"></i></a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/attachmentCategory/attachmentCategory.html","<div class=\"row attachment-category\">\n  <div class=\"col-xs-12 col-sm-12 col-md-12 mb-10\" ng-class=\"{ \'col-lg-12\' : comparison, \'col-lg-6\' : !comparison }\" ng-repeat=\"attachment in attachments track by $index\">\n    <div class=\"attachment-files\">\n      <div class=\"row\">\n        <div class=\"col-md-3 mb-15 text-center preview-box\">\n          <div class=\"title\" uib-tooltip=\"{{ attachment.attachment_detail.title }}\">\n            {{ attachment.attachment_detail.title }}\n          </div>\n          <div class=\"preview\">\n            <i class=\"fa fa-file\"></i>\n          </div>\n          <div class=\"title\" uib-tooltip=\"{{ attachment.attachment_detail.creator.display_name }}\">\n            {{ attachment.attachment_detail.creator.display_name }}\n          </div>\n          <div class=\"title\"> {{ attachment.attachment_detail.created_at | date:\'dd MMM yyyy\' }} </div>\n        </div>\n\n        <div class=\"col-md-9\">\n          <div class=\"row\">\n            <div class=\"col-md-12 mb-15 category title\" uib-tooltip=\"{{ attachment.attachment_category.name }}\">\n              {{ attachment.attachment_category.name }}\n            </div>\n            <div ng-repeat=\"description in attachment.description_array\" class=\"col-md-12\">\n              <label class=\"col-md-5 text-left\"> {{ description.name }} </label>\n              <div class=\"col-md-7 title\">\n                <span ng-if=\"description.type.toLowerCase() !== \'mongodate\'\" uib-tooltip=\"{{ description.value }}\">\n                  {{ description.value }}\n                </span>\n                <span ng-if=\"description.type.toLowerCase() === \'mongodate\'\" uib-tooltip=\"{{ description.value | date: \'dd MMM yyyy\' }}\">\n                  {{ description.value | date: \'dd MMM yyyy\' }}\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"action\">\n        <span class=\"pull-left delete-button\" ng-if=\"editable\">\n          <a class=\"color-red\" ng-click=\"deleteAttachment(attachment, $index)\">Delete</a>\n        </span>\n        <span class=\"pull-right\">\n          <button class=\"btn btn-white btn-sm\" ng-click=\"downloadAttachment(attachment)\" ng-if=\"!!attachment.attachment_detail._id\">\n            Download\n          </button>\n          <button class=\"btn btn-white btn-sm\" ng-if=\"editable\" ng-click=\"editAttachment(attachment, $index)\">\n            Edit\n          </button>\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-12\" ng-if=\"editable && !!attachments && !!attachments.length\">\n    &nbsp;\n  </div>\n  <div class=\"col-md-6\" ng-class=\"{ \'mt-15\' : (!!attachments && !!attachments.length) }\" ng-if=\"editable\">\n    <div class=\"attachment-box text-center\" ng-click=\"addAttachment()\">\n      <span><i class=\"fa fa-file\"></i> &nbsp;Click to upload new file</span>\n    </div>\n  </div>\n\n  <div class=\"col-md-12\" ng-if=\"editable\">\n    <span class=\"color-grey pull-left m-b mt-15\">\n      <b>Supported files : .xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg, .zip</b>\n    </span>\n  </div>\n</div>\n");
$templateCache.put("components/branchListing/branchListing.html","<div class=\"row\" style=\"margin : 0 0 0 0px\">\n<div class=\"col-md-4\" style=\"padding-left : 0px\">\n  <button ng-if=\"!!editable && !!(data).length\" class=\"btn btn-danger\" type=\"button\" ng-click=\"deleteBranches()\">\n    Delete Branches\n  </button>\n</div>\n  <table class=\"table multiselect-directive\">\n    <tr>\n      <th> </th>\n      <th> Branch Code </th>\n      <th> Branch Name </th>\n      <th> Branch Phone </th>\n      <th> Branch Email </th>\n      <th> Branch Contact Person </th>\n      <th> Branch Status </th>\n      <th ng-if=\"!!searchable\"> </th>\n    </tr>\n    <tr class=\"no-data\" ng-if=\"!(data).length\">\n      <td colspan=\"9\">There are no supplier branches added.</td>\n    </tr>\n    <tr class=\"cursor-pointer\" ng-repeat=\"branch in data | filter:search track by $index\" ng-click=\"branchDetailsModal(branch,$index)\" ng-class=\"{\'updated-data\': branch.hasUpdate === true}\">\n      <td ng-click=\"$event.stopImmediatePropagation()\">\n        <input type=\"checkbox\" ng-model=\"branch.checked\" ng-if=\"editable\">\n      </td>\n      <td>\n        {{ branch.code }}\n      </td>\n      <td width=\"30%\">\n        {{ branch.descr }}\n      </td>\n      <td>\n        <span ng-if=\"!!branch.phone\">\n          {{ branch.phone }}\n        </span>\n        <span ng-if=\"!branch.phone\">\n          No Phone Number Information\n        </span>\n      </td>\n      <td>\n        <span ng-if=\"!!branch.email\">\n          {{ branch.email }}\n        </span>\n        <span ng-if=\"!branch.email\">\n          No Email Address Information\n        </span>\n      </td>\n      <td>\n        <span ng-if=\"!!branch.contact[0].first_name\">\n          {{ branch.contact[0].first_name }}\n        </span>\n        <span ng-if=\"!branch.contact[0].first_name\">\n          No Contact Person Registered\n        </span>\n      </td>\n      <td>\n        {{ !!branch.isActive ? \'Active\' : \'Inactive \'}}\n      </td>\n      <td ng-show=\"!!selectable\" ng-click=\"$event.stopImmediatePropagation()\">\n        <span class=\"btn btn-primary btn-block\" ng-click=\"selectedSupplierBranch(branch)\">\n          Select Branch\n        </span>\n      </td>\n    </tr>\n  </table>\n  <div class=\"col-md-4 pl-0\">\n    <button ng-if=\"!!editable\" class=\"btn btn-primary btn-block\" type=\"button\" ng-click=\"addBranchesModal()\">\n      Add Branches\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/cancelPO/cancelPOTemplate.html","<div class=\"inmodal\">\n\n  <div class=\"cancel-po\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title cancel-po-title\">Cancel PO</h3>\n    </div>\n\n    <div class=\"modal-body form\">\n      <h4 class=\"row form-group\">You are canceling the PO because</h4>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-1\">\n          <input type=\"radio\" name=\"cancel_po\" value=\"Erroneous information\" ng-model=\"cancel_reason\" ng-change=\"commentText = null\" checked=\"checked\">\n        </div>\n        <div class=\"col-xs-11\">\n          <div>\n            <span>Erroneous information</span>\n          </div>\n          <div>\n          <textarea class=\"cancel-po-texterea\" rows=\"5\" ng-hide=\"cancel_reason != \'Erroneous information\'\" ng-model=\"commentText\" placeholder=\"Please key in more information\"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-1\">\n          <input type=\"radio\" name=\"cancel_po\" value=\"Project cancellation\" ng-model=\"cancel_reason\" ng-change=\"commentText = null\" checked=\"checked\">\n        </div>\n        <div class=\"col-xs-11\">\n          <div>\n            <span>Project cancellation</span>\n          </div>\n          <div>\n          <textarea class=\"cancel-po-texterea\" rows=\"5\" ng-hide=\"cancel_reason != \'Project cancellation\'\" ng-model=\"commentText\" placeholder=\"Please key in more information\"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-1\">\n          <input type=\"radio\" name=\"cancel_po\" value=\"Change in requirements\" ng-model=\"cancel_reason\" ng-change=\"commentText = null\" checked=\"checked\">\n        </div>\n        <div class=\"col-xs-11\">\n          <div>\n            <span>Change in requirements</span>\n          </div>\n          <div>\n          <textarea class=\"cancel-po-texterea\" rows=\"5\" ng-hide=\"cancel_reason != \'Change in requirements\'\" ng-model=\"commentText\" placeholder=\"Please key in more information\"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-1\">\n          <input type=\"radio\" name=\"cancel_po\" value=\"Others\" ng-model=\"cancel_reason\" ng-change=\"commentText = null\" checked=\"checked\">\n        </div>\n        <div class=\"col-xs-11\">\n          <div>\n            <span>Others</span>\n          </div>\n          <div>\n          <textarea class=\"cancel-po-texterea\" rows=\"5\" ng-hide=\"cancel_reason != \'Others\'\" ng-model=\"commentText\" placeholder=\"Please key in more information\"></textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"cancel-po-left-button btn btn-default\" ng-click=\"cancel()\">Back</button>\n      <button class=\"cancel-po-right-button btn btn-danger\" ng-click=\"cancelPO()\">Cancel PO</button>\n    </div>\n  </div>\n\n</div>\n\n\n");
$templateCache.put("components/closePO/closePOTemplate.html","<div class=\"modal-dialog\">\n\n  <div class=\"close-po\" ng-show=\"next_close && !back_close\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title close-po-title\">Close PO / line items</h3>\n    </div>\n\n    <div class=\"modal-body\">\n\n      <div class=\"row\">\n        <table class=\"table\">\n          <colgroup>\n            <col>\n            <col class=\"column-close-goods-description\">\n            <col>\n            <col>\n          </colgroup>\n          <thead>\n          <tr>\n            <td></td>\n            <td class=\"cursor-default\">Item Name & Description</td>\n            <td class=\"cursor-default\">Order</td>\n            <td class=\"cursor-default\">Received</td>\n            <td class=\"cursor-default\">Remaining</td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"item in close_po_data track by $index\">\n            <td>\n              <span ng-if=\"(item.po_item.order.delivered !== item.po_item.quantity) && item.po_item.closed !== true\">\n            <input icheck type=\"checkbox\" ng-click=\"checkedLineItem(item)\" ng-model=\"item.selected\">\n            </span>\n              <span class=\"label label-warning closed-modal-closed-item-label\" uib-tooltip=\"Receive to reopen this line item\" ng-if=\"item.po_item.closed === true\">Closed</span>\n            </td>\n            <td class=\"cursor-default\">\n              {{($index + 1)}}. <b>{{item.po_item.item.name}}</b>\n              <div>\n                <text-show-less-more model=\"item.po_item.item.description\" type=\"word\" length=\"15\" class=\"limit-lines\">\n                </text-show-less-more>\n              </div>\n            </td>\n            <td>{{::item.po_item.quantity}} ({{::item.po_item.uom.descr}})</td>\n            <td>{{::item.po_item.order.delivered}}</td>\n            <td>{{ item.po_item.remaining_quantity | formatDecimal:4 }}</td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <div class=\"close-po-container\">\n        <input icheck type=\"checkbox\" ng-click=\"checkedAllLineItems()\" ng-model=\"check_for_all\">\n        <span class=\"close-po-check-text\">Mark all as closed</span>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"close-po-right-button btn\" ng-class=\"{\'btn-default\': !enable_next, \'btn-primary\': enable_next}\" ng-click=\"next()\" ng-disabled=\"!enable_next\">Next</button>\n    </div>\n\n  </div>\n\n  <div class=\"comment-in-close-po\" ng-show=\"!next_close && back_close\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title comment-in-close-po-title\">Close PO</h3>\n      <div class=\"comment-in-close-po-note\">\n        <span>This PO will be marked as closed with missing items</span>\n      </div>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-1\">\n          <a class=\"pull-left\">\n            <img class=\"comment-in-close-po-img\" ng-src=\"{{::profile.img_url || \'assets/images/default-user.png\'}}\" image-error=\"assets/images/default-user.png\">\n          </a>\n        </div>\n        <div class=\"col-xs-11\">\n          <div class=\"comment-in-close-po-body\">\n            <span class=\"comment-in-close-po-top-arrow\"></span>\n            <span class=\"comment-in-close-po-bottom-arrow\"></span>\n\n            <textarea class=\"comment-in-close-po-text\" placeholder=\"Please enter your comments\" ng-model=\"commentText\" rows=\"5\" cols=\"10\"></textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"comment-in-close-po-left-button btn btn-default\" ng-click=\"backOnClosePO()\">Back</button>\n      <button class=\"comment-in-close-po-right-button btn btn-danger\" ng-click=\"proceedClosePO()\">Proceed</button>\n    </div>\n\n  </div>\n</div>\n\n");
$templateCache.put("components/collaborator/collaboratorTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Collaborators</h4>\n  </div>\n  <div class=\"modal-body\">\n    <table class=\"table table-striped\">\n      <thead>\n      <div class=\"input-group searchfield\" ng-model=\"collaboratorsTextFiled\" ng-if=\"(pr.requestor._id === profile._id || pr.creator._id === profile._id\n      || loggedInUserIsAnApprover) && canUpdateCollaborators(pr.status.toLowerCase())\">\n        <span class=\"input-group-addon\"><i class=\"fa\" ng-class=\"{true:\'fa-spinner fa-spin\', false:\'fa-search\'}[loading]\"></i></span>\n        <input type=\"text\" typeahead-on-select=\"onSelect($item)\" placeholder=\"Select User\" class=\"form-control\" uib-typeahead=\"user.display_name + \' < \' + user.email + \' > \' for user in searchUsers($viewValue)\" ng-model=\"collaboratorsTextFiled.input\" typeahead-wait-ms=\"delay\" aria-autocomplete=\"list\" typeahead-min-length=\"3\">\n      </div>\n      <tr>\n        <th>Name</th>\n        <th>Email</th>\n        <th ng-if=\"(pr.requestor._id === profile._id || pr.creator._id === profile._id\n      || loggedInUserIsAnApprover) && canUpdateCollaborators(pr.status.toLowerCase())\"></th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"collaborator in collaborators\">\n        <td>{{collaborator.display_name}}</td>\n        <td>{{collaborator.email}}</td>\n        <td ng-if=\"(pr.requestor._id === profile._id || pr.creator._id === profile._id\n            || loggedInUserIsAnApprover) && canUpdateCollaborators(pr.status.toLowerCase())\">\n          <a ng-click=\"removeCollaborator(collaborator)\"><i class=\"fa fa-trash text-grey\"></i></a>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("components/columnsSelector/columnsSelectorTemplate.html","<div class=\"pull-right custom-dropdown-multiselect\" ng-dropdown-multiselect=\"\" options=\"columnOptions\" selected-model=\"selectedColumns\" icon-class=\"\'fa fa-wrench\'\" translation-texts=\"buttonText\" extra-settings=\"columnsSettings\" events=\"columnsEvents\">\n</div>\n");
$templateCache.put("components/approval-flow/approval-flow-mobile.html","<div class=\"panel panel-default\">\n\n  <div class=\"screen-section ibox-content-mobile\">\n    <div class=\"row\">\n      <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 15px; font-weight: bold\">\n        <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px; margin-left: 2px\"></i>\n        Approval Flow\n      </div>\n    </div>\n\n\n    <!--An approval flow step-->\n    <table class=\"table\">\n      <tbody>\n      <tr ng-repeat=\"(key,transformed) in transformedData.step track by $index\">\n        <!--Step number td-->\n        <td style=\"padding: 0; vertical-align: top\">\n          <!--Step sequence-->\n          <span style=\"color: #E0E0E0;\n             font-size: 20px;\n             font-weight: bold;\n             text-align: center;\n             margin: 0 0 0 10px\">\n            {{ transformed.seq }}\n        </span>\n        </td>\n\n        <td style=\"padding: 0\">\n          <div ng-repeat=\"position in transformed.position\" style=\"margin-bottom: 13px\">\n            <table class=\"table mobile-approval table-style {{position.border_style}}\">\n              <tbody>\n              <tr class=\"approvalStepHeader\" style=\"border-bottom: 1px solid #BDBDBD\">\n                <td class=\"approvalRole\" style=\"padding: 3px 5px;\n                        font-size: 11px;\n                        color:#555555;\n                        font-weight: bold;\n                        text-align: left;\n                        width: 60%;\n                        line-height: 150%\">\n                  {{position.name}}\n                </td>\n\n                <td style=\"text-align: right\" class=\"no-padding\">\n                  <span class=\"approvalStatus mobile-approval status-label {{position.status_color}}\">\n                    {{position.status.toUpperCase()}}\n                  </span>\n                </td>\n              </tr>\n              <tr>\n                <!--User names-->\n                <td class=\"mobile-approval username\">\n                  <span ng-repeat=\"user in position.user\">\n                    <span class=\"{{user.status_color}}\">\n                      <i ng-if=\"user.status === \'approved\'\" class=\"item-action-icon fa fa-check\"></i>\n                      <i ng-if=\"user.status === \'rejected\'\" class=\"item-action-icon fa fa-times\"></i>\n                      <strike ng-if=\"!!user.log[0] && user.log[0].action === \'escalate\'\">{{user.name}}</strike>\n                      <span ng-if=\"!user.log[0] || (!!user.log[0] && user.log[0].action !== \'escalate\')\">{{user.name}}</span>\n                      <br>\n                    </span>\n\n                    <span ng-repeat=\"log in user.log\" class=\"{{log.status_color}}\">\n                      &nbsp;<i ng-if=\"log.status === \'approved\'\" class=\"item-action-icon fa fa-check\"></i>\n                      <i ng-if=\"log.status === \'rejected\'\" class=\"item-action-icon fa fa-times\"></i>\n                      <strike ng-if=\"!!user.log[$index+1] && user.log[$index+1].action === \'escalate\'\">\n                        <em ng-if=\"log.action === \'escalate\'\">Escalated to : {{log.name}}</em>\n                        <em ng-if=\"log.action === \'delegate\'\">Delegated to : {{log.name}}</em>\n                      </strike>\n                      <span ng-if=\"!user.log[$index+1] || (!!user.log[$index+1] && user.log[$index+1].action !== \'escalate\')\">\n                        <em ng-if=\"log.action === \'escalate\'\">Escalated to : {{log.name}}</em>\n                        <em ng-if=\"log.action === \'delegate\'\">Delegated to : {{log.name}}</em>\n                      </span>\n                      <br>\n                    </span>\n                  </span>\n                </td>\n\n\n                <td class=\"mobile-approval action-date\">\n                  <div ng-if=\"position.status.toLowerCase() === \'approved\'\">\n                    <span class=\"approved-role\">Approved at\n                    {{position.end_at | date: \"dd MMM yyyy h:mma\"}} </span><br>\n                    <!--{{approved_roles.end_at.sec * 1000 | date: \"dd MMM yyyy h:mma\" }}-->\n                  </div>\n                  <div ng-if=\"position.status.toLowerCase() === \'rejected\'\">\n                    <span class=\"rejected-role\" style=\"\">Rejected at\n                      {{position.end_at | date: \"dd MMM yyyy h:mma\"}} </span><br>\n                    <!--{{approved_roles.end_at.sec * 1000 | date: \"dd MMM yyyy h:mma\" }}-->\n                  </div>\n                </td>\n\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n</div>\n");
$templateCache.put("components/approval-flow/approval-flow.html","<div class=\"ibox-content\">\n  <div class=\"col-md-12\">\n    <h3 class=\"pull-left\">\n      Approval flow\n    </h3>\n    <button class=\"btn btn-white pull-right mt-10 approval-preview\" ng-if=\"contextStatus === \'draft\'\" ng-click=\"approvalPreview()\">\n      <i class=\"fa fa-refresh\"></i> Preview\n    </button>\n  </div>\n  <div id=\"approval-flow\" class=\"approval-flow screen-section\">\n    <div class=\"node\" data-ng-repeat=\"step in data.steps\">\n      <div class=\"node-sub m-b-md\" id=\"node-sub_{{step.seq}}_{{position.id}}\" ng-repeat=\"position in step.positions\" ng-class=\"{\'add-adhoc-step\': (position.id.indexOf(\'adhoc_\') > -1)}\" ng-click=\"addNewApprover(position.node_sub)\">\n        <div class=\"delete-adhoc\" ng-if=\"!!position.added_by &&\n               (position.added_by === currentUser._id) &&\n               step.step_status.toLowerCase() === \'pending\' &&\n               !position.action.status\" ng-click=\"deleteAdhoc(step.seq, position.id)\">\n          <i class=\"fa fa-times-circle\"></i>\n        </div>\n        <div class=\"title-role\">\n          <b>({{ position.name }})</b>\n        </div>\n        <div class=\"node-child\" uib-tooltip-html=\"\'{{ tooltipApproval(position, step.step_status) }}\'\">\n        <ul class=\"list-approval-user\" ng-repeat=\"user in position.users\">\n          <li ng-class=\"{\'user-approved\': position.action.status.toLowerCase() === \'approved\' &&\n            (position.action.user._id === user._id ||\n             position.action.user._id === user.delegated_to._id ||\n             position.action.user._id === user.escalated_to._id\n            )}\">\n            <i class=\"fa\" ng-class=\"{\'fa-check approved\': position.action.status.toLowerCase() === \'approved\',\n                 \'fa-ban rejected\': position.action.status.toLowerCase() === \'rejected\'}\" ng-if=\"position.action.user._id === user._id\">\n            </i>\n            <!-- to support the old structure (migrated data) only -->\n            <i class=\"fa\" ng-class=\"{\n                 \'fa-angle-double-right escalated\': (step.step_status.toLowerCase() === \'escalated\' && !!data.origin_id)\n               }\">\n            </i>\n            <span class=\"user\" ng-class=\"{\'grey-text\': !user.is_active,\n                \'colour-black\': user.is_active}\">\n              {{ user.display_name }}\n            </span>\n            <!-- Preparer -->\n            <span ng-if=\"!!user.prepared_by && (user.display_name !== user.prepared_by.display_name)\">\n              <br><small><i>Prepared by: {{user.prepared_by.display_name}}</i></small>\n            </span>\n\n            <!-- Logs -->\n            <span ng-repeat=\"log in user.logs track by $index\" class=\"logs\">\n              <br>\n              <small ng-class=\"{\'grey-text\': (!$last || !!$last && !log.is_active),\n                \'colour-black\': ((!!$last && !!log.is_active) ||\n                  ($index === (user.logs.length - 2) && log.action === \'escalate\' && log.is_active))}\">\n                <i>\n                  <i class=\"fa\" ng-class=\"{\'fa-check approved\': position.action.status.toLowerCase() === \'approved\',\n                     \'fa-ban rejected\': position.action.status.toLowerCase() === \'rejected\'}\" ng-if=\"position.action.user._id === log.to_user._id\">\n                  </i>\n                  {{ log.action | titleCase }} to: {{ log.to_user.display_name }}\n                </i>\n              </small>\n            </span>\n          </li>\n        </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/approval-flow/approval-flow.panel.html","<div class=\"ibox-content\">\n  <h3 style=\"text-align: left\">Approval flow</h3>\n  <div id=\"cy\" class=\"approval-flow-items\"></div>\n</div>\n");
$templateCache.put("components/comments/comments-panel-mobile.html","<div class=\"panel panel-default no-padding\" style=\"margin-bottom: 0px;margin-top: 0px\">\n  <div class=\"screen-section ibox-content-mobile\">\n    <div class=\"row no-padding\">\n      <div class=\"row\">\n        <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 15px; font-weight: bold\">\n          <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px\"></i>{{ headerTitle }}\n        </div>\n        <div class=\"col-xs-4 col-sm-4\">\n          <embedded-pagination-service list=\"commentsAndHistory\" service=\"commentsService\" params-source=\"embeddedParams\" offset=\"commentSize\" meta=\"meta\">\n          </embedded-pagination-service>\n        </div>\n      </div>\n\n      <div class=\"feed-activity-list\">\n        <div class=\"feed-element\">\n          <div class=\"media-body\">\n            <div ng-if=\"commentsModule === \'PR\'\">\n              <div class=\"form-group\">\n                <textarea placeholder=\"Join the discussion.\" type=\"text\" ng-model=\"comment.text\" class=\"form-control\" ng-disabled=\"disabled\" ng-focus=\"focus()\" mentio mentio-typed-text=\"typedTerm\" mentio-select=\"selectTagName(item)\" mentio-typed-term=\"typeTerm\" mentio-items=\"usersList | filter:label\">\n                </textarea>\n              </div>\n              <div ng-show=\"comment.text.length\">\n                <button class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" ng-click=\"postComment(comment.text)\" ng-disabled=\"disabled\">\n                  <strong>Submit</strong>\n                </button>\n              </div>\n            </div>\n\n            <!--Mention feature not available for PO-->\n            <div ng-if=\"commentsModule === \'PO\'\">\n              <div class=\"form-group\">\n                <textarea placeholder=\"Join the discussion.\" type=\"text\" ng-model=\"comment.text\" class=\"form-control\" ng-disabled=\"disabled\" ng-focus=\"focus()\">\n                </textarea>\n              </div>\n              <div ng-show=\"comment.text.length\">\n                <button class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" ng-click=\"postComment(comment.text)\" ng-disabled=\"disabled\">\n                  <strong>Submit</strong>\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"feed-element\" ng-repeat=\"activity in commentsAndHistory track by $index\" ng-hide=\"activity.action === \'Received goods\' && !activity.comment\">\n          <div class=\"media-body mobile show-scrollbar\">\n            <strong>\n              {{activity.commentator.display_name}}\n            </strong>\n\n            <span class=\"prComment\" ng-if=\"commentsModule === \'PR\'\">\n              <i ng-if=\"activity.action === \'fully_approved\'\" class=\"fa fa-check\"></i>\n              {{getCommentAction(activity)}}<br>\n              <strong><small>{{activity.created_at | date: \'dd MMM yyyy @ h:mm a\'}}</small></strong>\n\n              <a class=\"deleteComment\">\n                <i class=\"fa fa-trash-o\" ng-click=\"deleteComments(activity)\" ng-show=\"activity.commentator._id === user._id && activity.type === \'comment\'\"></i>\n              </a>\n            </span><br>\n            <span ng-if=\"commentsModule === \'PO\'\">\n              <span ng-if=\"activity.action === \'GRN ISSUED\'\">\n                received goods\n                <a class=\"btn btn-link po-goods-link-number\" grn-panel ng-click=\"showGRNInfo(activity.reason, po)\">\n                {{getGRNNumber(activity.comment)}}\n                </a>\n              </span>\n              <span ng-if=\"activity.action === \'NGRN ISSUED\'\">\n                reversed goods\n                <a class=\"btn btn-link po-goods-link-number\" ngrn-panel ng-click=\"showNGRNInfo(activity.reason, po)\">\n                  {{getGRNNumber(activity.comment)}}\n                </a>\n              </span>\n              <span ng-bind-html=\"getCommentAction(activity)\" ng-if=\"[\'GRN ISSUED\', \'NGRN ISSUED\'].indexOf(activity.action) === -1\" ng-hide=\"activity.action === \'Received goods\' && !activity.comment\">\n              </span>\n              <a class=\"deleteComment\">\n                <i class=\"fa fa-trash-o\" ng-click=\"deleteComments(activity)\" ng-show=\"activity.commentator._id === user._id && !activity.action\">\n                </i>\n              </a>\n              <br>\n            </span>\n            <span class=\"prComment\" ng-if=\"commentsModule === \'SupplierTag\'\">\n              {{getCommentAction(activity)}}\n              <br>\n            </span>\n            <div class=\"well\" ng-bind-html=\"activity.comment\" ng-if=\"!!activity.comment\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div><!--screen section-->\n</div>\n");
$templateCache.put("components/comments/comments-panel.html","<div class=\"ibox-content screen-section\">\n  <h3 class=\"text-left-align\">{{ headerTitle }}\n    <embedded-pagination-service meta=\"meta\" list=\"commentsAndHistory\" service=\"commentsService\" params-source=\"embeddedParams\" offset=\"commentSize\">\n    </embedded-pagination-service>\n  </h3>\n  <div class=\"feed-activity-list\">\n    <div class=\"feed-element\">\n      <div class=\"pull-left\" ng-hide=\"commentsModule === \'SupplierTag\'\">\n        <img alt=\"image\" class=\"img-circle\" ng-src=\"{{userBasePath}}/{{user.img_url}}\" image-error=\"assets/images/default-user.png\">\n      </div>\n\n      <div class=\"media-body\">\n        <div ng-if=\"(commentsModule === \'PR\' || commentsModule === \'Budget\')\">\n          <div class=\"form-group\">\n            <textarea placeholder=\"Join the discussion.\" type=\"text\" ng-model=\"comment.text\" class=\"form-control\" ng-disabled=\"disabled\" ng-focus=\"focus()\" mentio mentio-typed-text=\"typedTerm\" mentio-select=\"selectTagName(item)\" mentio-typed-term=\"typeTerm\" mentio-items=\"usersList | filter:label\">\n            </textarea>\n            <span class=\"pull-left\">Note: use the \'@\' to tag a user.</span>\n          </div>\n          <div ng-show=\"comment.text.length\">\n            <button class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" ng-click=\"postComment(comment.text)\" ng-disabled=\"disabled\">\n              <strong>Submit</strong>\n            </button>\n          </div>\n        </div>\n\n        <!--Mention feature not available for PO-->\n        <div ng-if=\"commentsModule === \'PO\'\">\n          <div class=\"form-group\">\n            <textarea placeholder=\"Join the discussion.\" type=\"text\" ng-model=\"comment.text\" class=\"form-control\" ng-disabled=\"disabled\" ng-focus=\"focus()\">\n            </textarea>\n          </div>\n          <div ng-show=\"comment.text.length\">\n            <button class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" ng-click=\"postComment(comment.text)\" ng-disabled=\"disabled\">\n              <strong>Submit</strong>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"feed-element\" ng-repeat=\"activity in commentsAndHistory track by $index\" ng-hide=\"activity.action === \'Received goods\' && !activity.comment\">\n      <div class=\"pull-left\" ng-if=\"activity.action === \'created_comment\' || !activity.action\">\n        <img alt=\"image\" class=\"img-circle\" ng-src=\"{{userBasePath}}/{{activity.commentator.img_url}}\" image-error=\"assets/images/default-user.png\">\n      </div>\n\n      <div class=\"media-body\">\n        <small class=\"pull-right\">\n          {{activity.created_at | date: \'dd MMM yyyy @ h:mm a\'}}\n        </small>\n        <div ng-class=\"{\'comment-action-margin\': activity.type !== \'comment\'}\">\n          <strong>\n          <span ng-if=\"activity.action !== \'EMAIL_SEND_FAILED\' && activity.action !== \'SUBMITTED\'\n                      && activity.action !== \'tagged_supplier_via_po\'\">\n            {{activity.commentator.display_name}}</span>\n        </strong>\n        <span class=\"prComment\" ng-if=\"(commentsModule === \'PR\' || commentsModule === \'Budget\')\">\n          <i ng-if=\"activity.action === \'fully_approved\'\" class=\"fa fa-check\"></i>\n          {{getCommentAction(activity)}}\n          <!-- NOTE: this feature is switched off until further requirement -->\n          <!--<a class=\"deleteComment\">-->\n            <!--<i class=\"fa fa-trash-o\"-->\n               <!--ng-click=\"deleteComments(activity)\"-->\n               <!--ng-show=\"activity.commentator._id === user._id && activity.type === \'comment\'\"></i>-->\n          <!--</a>-->\n          <br>\n        </span>\n        <span ng-if=\"commentsModule === \'PO\'\">\n          <span ng-if=\"activity.action === \'GRN ISSUED\'\">\n            received goods\n            <a class=\"btn btn-link po-goods-link-number\" grn-panel ng-click=\"showGRNInfo(activity.reason, po)\">\n              {{getGRNNumber(activity.comment)}}\n            </a>\n          </span>\n          <span ng-if=\"activity.action === \'NGRN ISSUED\'\">\n            reversed goods\n            <a class=\"btn btn-link po-goods-link-number\" ngrn-panel ng-click=\"showNGRNInfo(activity.reason, po)\">\n              {{getGRNNumber(activity.comment)}}\n            </a>\n          </span>\n          <span ng-bind-html=\"getCommentAction(activity)\" ng-if=\"[\'GRN ISSUED\', \'NGRN ISSUED\'].indexOf(activity.action) === -1\" ng-hide=\"activity.action === \'Received goods\' && !activity.comment\">\n          </span>\n            <!-- NOTE: this feature is switched off until further requirement -->\n            <!--<a class=\"deleteComment\">-->\n            <!--<i class=\"fa fa-trash-o\"-->\n            <!--ng-click=\"deleteComments(activity)\"-->\n            <!--ng-show=\"activity.commentator._id === user._id && !activity.action\"></i>-->\n            <!--</a>-->\n          <br>\n          </span>\n            <span class=\"prComment\" ng-if=\"commentsModule === \'SupplierTag\'\">\n            {{getCommentAction(activity)}}\n            <br>\n          </span>\n          <div class=\"well\" ng-bind-html=\"activity.comment\" ng-if=\"!!activity.comment && (activity.type === \'comment\' || activity.action === \'rollback\'\n             || activity.action === \'on_hold\' || activity.action === \'withdrew\' || activity.action === \'rejected\')\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div><!--screen section-->\n");
$templateCache.put("components/companyBillingOptions/companyBillingOptionsTemplate.html","<div class=\"ibox float-e-margins\">\n  <div class=\"ibox-title\">\n    <h5>Billing information</h5>\n    <div class=\"pull-right\">\n      <a class=\"btn btn-white btn-xs\" ng-click=\"enableEditMode()\">Edit</a>\n    </div>\n  </div>\n  <div class=\"ibox-content\">\n    <div class=\"form-horizontal\" ng-show=\"!!editMode\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 col-xs-3\">Bill to:</label>\n        <div class=\"col-sm-9 col-xs-9\">\n          <ui-select multiple=\"multiple\" ng-model=\"selectedBillingCompanies\" remove-selected=\"true\" sortable=\"true\" on-select=\"addToBillingCompanies($item)\" on-remove=\"removeFromBillingCompanies($item)\">\n            <ui-select-match placeholder=\"Select a company...\"> {{$item.descr}} </ui-select-match>\n            <ui-select-choices repeat=\"company in availableCompanies | filter: $select.search\">\n              <div title=\"{{ company.descr }}\" ng-bind-html=\"company.descr | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 col-xs-3\">Default billing:</label>\n        <div class=\"col-sm-9 col-xs-9\">\n          <ui-select ng-model=\"defaultBilledCompany.selected\" remove-selected=\"false\" sortable=\"true\">\n            <ui-select-match placeholder=\"Select a company...\" allow-clear=\"true\"> {{$select.selected.descr}} </ui-select-match>\n            <ui-select-choices repeat=\"company in selectedBillingCompanies track by $index\">\n              {{company.descr}}\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-horizontal\" ng-show=\"!editMode\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 col-xs-3\">Bill to:</label>\n        <div class=\"col-sm-9 col-xs-9\">\n          <div ng-repeat=\"company in selectedBillingCompanies track by $index\">\n            {{company.descr}}\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 col-xs-3\">Default billing:</label>\n        <div class=\"col-sm-9 col-xs-9\">\n          <span>\n            {{defaultBilledCompany.selected.descr}}\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\">\n      <span ng-show=\"!!editMode\">\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"submit()\">\n                Save\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"cancel()\">\n                Cancel\n        </button>\n      </span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/companyGroupsManagement/companyGroupsManagementTemplate.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Manage Groups</h4>\n    <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importCatalogGroup()\">\n      Import Catalog Group Assignment\n    </button>\n  </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-7 company-groups-list-table list-group\">\n          <a ng-repeat=\"d in groupsList track by $index\" class=\"list-group-item\" ng-class=\"{ \'selected-group\': d._id === selectedGroup._id }\" ng-click=\"selectGroup(d)\">{{d.code}}</a>\n        </div>\n        <div class=\"col-md-5\" ng-if=\"!selectedGroup\">\n          <h1 class=\"selectCompaniesGroupText\">\n            Select a group or click on the Create Group button\n          </h1>\n        </div>\n        <div class=\"col-md-5\" ng-if=\"!!selectedGroup\">\n          <div class=\"col-md-12\">\n            <div class=\"form-group\">\n              <label>Catalog Group</label>\n              <span ng-show=\"!!saving\" class=\"pull-right\">Saving <i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\n              <input ng-disabled=\"!!selectedGroup.code && !!selectedGroup._id\" type=\"text\" placeholder=\"Catalog Group\" class=\"form-control\" ng-model=\"selectedGroup.code\" ng-change=\"saveChanges(selectedGroup.code, selectedGroup.descr)\">\n            </div>\n            <div class=\"form-group\">\n              <label>Catalog Group Description</label>\n              <span ng-show=\"!!saving\" class=\"pull-right\">Saving <i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\n              <input type=\"text\" placeholder=\"Catalog Group Description\" class=\"form-control\" ng-model=\"selectedGroup.descr\" ng-change=\"saveChanges(selectedGroup.code, selectedGroup.descr)\">\n            </div>\n            <div class=\"form-group\">\n              <label>Companies</label>\n              <span ng-show=\"!!loadingCompaniesList\"><i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\n\n              <span class=\"label label-info pull-right\">{{selectedGroup.companies.length || 0}}</span>\n\n              <ui-select on-remove=\"updateCompanies($item, \'unassign\')\" on-select=\"updateCompanies($item, \'assign\')\" ui-disable-choice=\"!!loadingCompaniesList || !selectedGroup._id\" multiple=\"multiple\" ng-model=\"selectedGroup.companies\" remove-selected=\"false\" sortable=\"true\" close-on-select=\"true\" reset-search-input=\"true\">\n                <ui-select-match placeholder=\"Select company...\">{{$item.descr}}</ui-select-match>\n                <ui-select-choices repeat=\"company in companies | filter: {descr: $select.search}\">\n                  <div ng-bind-html=\"company.descr | highlight: $select.search\"></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-7\">\n          <!-- should enable the Delete group button once there is a validation for it-->\n          <!--<button class=\"btn btn-outline btn-danger\" ng-if=\"!!selectedGroup._id\"  ng-click=\"deleteGroup()\">Delete group</button>-->\n          <button class=\"btn btn-default pull-right\" ng-click=\"createGroup()\">Create Group</button>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n    </div>\n</div>\n");
$templateCache.put("components/diffVersion/diffVersion.html","<span>\n  <span ng-if=\"prevVal === newVal\">\n    <span ng-if=\"!!filterDecimal\"> {{ newVal | formatDecimal: filterDecimal }} </span>\n    <span ng-if=\"!filterDecimal\"> {{ newVal }} </span>\n  </span>\n  <span ng-if=\"prevVal !== newVal\">\n    <del>\n      <span ng-if=\"!!filterDecimal\"> {{ prevVal | formatDecimal: filterDecimal }} </span>\n      <span ng-if=\"!filterDecimal\"> {{ prevVal }} </span>\n    </del>\n    <span ng-if=\"!!lineBreak\"><br></span>\n    <ins>\n      <span ng-if=\"!!filterDecimal\"> {{ newVal | formatDecimal: filterDecimal }} </span>\n      <span ng-if=\"!filterDecimal\"> {{ newVal }} </span>\n    </ins>\n  </span>\n</span>\n");
$templateCache.put("components/editAddress/editAddressTemplate.html","<div class=\"inmodal\">\n\n  <div class=\"edit-address\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title edit-address-title\">Edit Address</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"form-group\">\n        <label label-default=\"\">Address Line 1<span class=\"asterisk-required\">*</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.line1\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">Address Line 2</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.line2\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">Address Line 3</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.line3\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">City<span class=\"asterisk-required\">*</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.city\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">State<span class=\"asterisk-required\">*</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.state\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">Post code<span class=\"asterisk-required\">*</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.postal_code\">\n      </div>\n      <div class=\"form-group\">\n        <label label-default=\"\">Country<span class=\"asterisk-required\">*</span></label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.country\">\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"update()\">Submit</button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancel</button>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("components/editContact/editContactTemplate.html","<div class=\"inmodal\">\n  <div class=\"edit-contact\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x\n      </button>\n      <h3 class=\"modal-title edit-contact-title\">Edit contact</h3>\n    </div>\n    <form ng-submit=\"updateContactInfo()\">\n      <div class=\"modal-body\">\n        <div class=\"form-group\">\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Name\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"edit_data.first_name\" ucwords ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-class=\"{\'highlight-error-input\': !edit_data.first_name && !!clicked_submit}\" required>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Email\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input type=\"email\" class=\"form-control\" ng-model=\"edit_data.email\">\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Phone\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input type=\"tel\" id=\"editSupplierContactPhone\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !isValidPhoneNo}\" ng-model=\"edit_data.phone\" ng-change=\"validateNumbers(\'editSupplierContactPhone\', \'isValidPhoneNo\')\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-intl-tel-input required>\n              <br>\n              <span class=\"text-danger\" ng-show=\"!edit_data.phone && !!clicked_submit\">\n                Phone number is required\n              </span>\n              <span class=\"text-danger\" ng-show=\"!isValidPhoneNo\">\n                Invalid phone number format\n              </span>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Fax\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <input type=\"tel\" id=\"editSupplierContactFax\" ng-class=\"{\'highlight-error-input\': !isValidFaxNo}\" class=\"form-control\" ng-change=\"validateNumbers(\'editSupplierContactFax\', \'isValidFaxNo\')\" ng-model=\"edit_data.fax\" ng-intl-tel-input>\n              <br>\n              <span class=\"text-danger\" ng-show=\"!isValidFaxNo\">\n                Invalid fax number format\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"submit\" class=\"btn btn-primary\">Update</button>\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancel</button>\n      </div>\n    </form>\n  </div>\n</div>\n\n");
$templateCache.put("components/editableFocus/editableFocusTemplate.html","<span class=\"editable-focus\">\n  <span ng-click=\"focus = true\" ng-hide=\"!!focus\">\n    <text-show-less-more ng-if=\"!!enableShowLessShowMore && !_.isEmpty(model)\" model=\"model\"></text-show-less-more>\n    <span ng-if=\"!enableShowLessShowMore && !_.isEmpty(model)\" class=\"pre-wrap\" ng-bind-html=\"model | escapeHtml\"></span>\n    <span ng-if=\"!!_.isEmpty(model)\" class=\"placeholder\">{{textPlaceholder || \'edit\'}}</span>\n  </span>\n  <span ng-show=\"!!focus\">\n    <textarea ng-model=\"model\" focus-input=\"focus\" class=\"google-contact-textarea\" ng-attr-placeholder=\"{{inputPlaceholder || \'edit\'}}\"></textarea>\n    <input ng-model=\"model\" focus-input=\"focus\" class=\"half-width-input google-contact-input\" placeholder=\"{{inputPlaceholder || \'edit\'}}\">\n  </span>\n</span>\n");
$templateCache.put("components/embeddedTableHeader/embeddedTableHeaderTemplate.html","  <tr>\n    <td ng-repeat=\"col in availableHeaders track by $index\" ng-show=\"checkSelectionAndCondition(col)\" ng-click=\"sort(col)\" ng-class=\"{ \'unsortable-column\': !!col.unsortable}\">{{col.label}}\n    <i ng-class=\"{\'fa fa-sort-up\' : (sortedCol === col.id && order === 1),\n    \'fa fa-sort-desc\' : (sortedCol === col.id && order === 0)}\"></i></td>\n  </tr>\n");
$templateCache.put("components/escalationBlock/escalationBlockTemplate.html","<div class=\"ibox float-e-margins\">\n  <div class=\"ibox-title\">\n    <h5>Escalation</h5>\n  </div>\n  <div class=\"ibox-content\">\n    <div class=\"form-horizontal\">\n      <div ng-repeat=\"company in data.companies track by $index\">\n        <div class=\"col-md-4\">{{company.descr}}</div>\n        <div class=\"input-group col-md-4 searchfield\" ng-model=\"company.escalatedTo\">\n          <input type=\"text\" typeahead-on-select=\"onSelect($item, company)\" placeholder=\"Select User\" class=\"form-control\" uib-typeahead=\"user.display_name + \' < \' + user.email + \' > \' for user in users($viewValue, loading)\" ng-model=\"company.input\" typeahead-wait-ms=\"delay\" aria-autocomplete=\"list\" typeahead-min-length=\"3\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/exchangeRate/Import-Template.html","<form>\n  <!--Just want to refer to this window style.-->\n  <div class=\"add-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Import {{title}}</h3>\n    </div>\n    <div class=\"ibox-content pr-attachment\">\n      <div class=\"row\">\n        <div class=\"col-lg-6\"><h3 style=\"text-align: left\">Upload a CSV</h3></div>\n\n      </div>\n\n      <br>\n      <master-import-attachment uploadlink=\"importLink\" companyid=\"id\"></master-import-attachment>\n      <p>Only support for CSV file.</p>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("components/exchangeRate/exchangeRateTemplate.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <span class=\"expense-header\">List of Exchange Rates</span>\n      <master-export module-name=\"Company Exchange Rate\" collection=\"4\" company-id=\"id\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importExchangeRate()\">\n          Import Exchange Rates\n      </button>\n    </div>\n      <div class=\"col-md-12 mt-15\">\n        <form name=\"searchUom\" ng-submit=\"search()\">\n          <div class=\"input-group\">\n            <span class=\"input-group-addon\">\n            <i class=\"fa fa-search\" ng-click=\"search()\"></i>\n            </span>\n            <input ng-model=\"searchText\" ng-enter=\"search()\" class=\"form-control\" placeholder=\"Search exchange rates\">\n          </div>\n        </form>\n      </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <span class=\"expense-header\">Add Exchange Rate</span>\n    </div>\n    <form name=\"addExchangeRate\" class=\"no-ng-check\" ng-submit=\"newExchangeRate()\">\n      <div class=\"col-md-11 mt-15\">\n        <div class=\"col-md-3\">\n          <ui-select class=\"select-dropdown_width\" ng-model=\"exchangeRate.fromCurrency\" theme=\"bootstrap\" on-select=\"onSelectedFromCurrency(exchangeRate.fromCurrency)\">\n            <ui-select-match placeholder=\"Select source currency\">{{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"c in currencyExchange | filter: $select.search\">\n              <div ng-bind-html=\"c.code  + (!!c.descr ? \' - \' + c.descr : \'\')| highlight: $select.search\">\n              </div>\n            </ui-select-choices>\n          </ui-select>\n          <span class=\"text-danger\" ng-show=\"exchangeRate.fromCurrency == null && !exchangeRate.fromCurrency && !!submitted\">\n             Source currency is required\n           </span>\n        </div>\n        <div class=\"col-md-3\">\n          <ui-select class=\"select-dropdown_width\" ng-model=\"exchangeRate.toCurrency\" theme=\"bootstrap\" on-select=\"onSelectedToCurrency(exchangeRate.toCurrency)\">\n            <ui-select-match placeholder=\"Select target currency\">{{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"c in currencyExchange | filter: $select.search\">\n              <div ng-bind-html=\"c.code  + (!!c.descr ? \' - \' + c.descr : \'\') | highlight: $select.search\">\n              </div>\n            </ui-select-choices>\n          </ui-select>\n          <span class=\"text-danger\" ng-show=\"exchangeRate.toCurrency == null && !exchangeRate.toCurrency && !!submitted\">\n             Target currency is required\n           </span>\n        </div>\n        <div class=\"col-md-2\">\n          <input ng-model=\"exchangeRate.multiplier_rate\" class=\"form-control\" placeholder=\"Enter rate\" ng-pattern=\"/^[0-9.]{0,}$/\" ng-pattern-restrict=\"^[0-9.]{0,10}$\" required>\n          <span class=\"text-danger\" ng-show=\"validateExchangeRate(exchangeRate.multiplier_rate) && submitted\">\n                Multiplier rate cannot be zero\n          </span>\n        </div>\n        <div class=\"col-md-3\">\n          <input ng-model=\"exchangeRate.descr\" class=\"form-control\" placeholder=\"Enter description\" required>\n          <span class=\"text-danger\" ng-show=\"!exchangeRate.descr.length && !!submitted\">\n            Description is required\n          </span>\n        </div>\n      </div>\n      <div class=\"col-md-1 mt-15\">\n        <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n        </columns-selector>\n      </div>\n\n      <div class=\"col-md-11 mt-15\">\n        <div class=\"col-md-4\">\n          <div class=\"input-group\">\n            <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRate.effective_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" class=\"form-control\" required>\n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\">\n                <i class=\"fa fa-calendar\"></i>\n              </button>\n            </span>\n          </div>\n          <span class=\"text-danger\" ng-show=\"!exchangeRate.effective_at && !!submitted\">\n            Effective date is required\n          </span>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"input-group\">\n            <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"Expiry date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRate.expiry_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" class=\"form-control\" required>\n            \n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\">\n                <i class=\"fa fa-calendar\"></i>\n              </button>\n            </span>\n          </div>\n          <span class=\"text-danger\" ng-show=\"!exchangeRate.expiry_at && !!submitted\">\n            Expiry date is required\n          </span>\n        </div>\n        <div class=\"col-md-2\">\n          <input type=\"submit\" value=\"Add\" class=\"btn btn-primary\">\n        </div>\n      </div>\n      <div class=\"col-md-1 mt-15\">\n        <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"exchangeRateService\" id=\"id\">\n        </pagination-service>\n      </div>\n    </form>\n  </div>\n  <a class=\"fa fa-times\" ng-click=\"reset()\" ng-if=\"!!query\">\n    Reset search\n  </a>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no exchange rates for now.</td>\n        </tr>\n\n        <tr ng-repeat=\"exchangeRate in dataList\" ng-click=\"exchangeRateDetail($index)\">\n          <td ng-if=\"showColumn(\'code\')\">{{ exchangeRate.code }}</td>\n          <td ng-if=\"showColumn(\'descr\')\">{{ exchangeRate.descr }}</td>\n          <td ng-if=\"showColumn(\'multiplier_rate\')\">{{ exchangeRate.multiplier_rate }}</td>\n          <td ng-if=\"showColumn(\'updated_at\')\">{{ exchangeRate.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-if=\"showColumn(\'updater.display_name\')\">{{ exchangeRate.updater[0].display_name}}</td>\n          <td ng-if=\"showColumn(\'created_at\')\">{{ exchangeRate.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-if=\"showColumn(\'creator.display_name\')\">{{ exchangeRate.creator[0].display_name}}</td>\n          <td ng-if=\"showColumn(\'effective_at\')\">{{ exchangeRate.effective_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-if=\"showColumn(\'expiry_at\')\">{{ exchangeRate.expiry_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-if=\"showColumn(\'is_active\')\">{{ getActiveStatusName(exchangeRate.is_active) }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/exportUserAssignments/exportUserAssignmentsTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Export User Assignment</h4>\n  </div>\n  <div class=\"modal-body\">\n    <table class=\"table table-striped\">\n      <thead>\n      <div class=\"input-group searchfield\" ng-model=\"collaboratorsTextFiled\">\n        <span class=\"input-group-addon\"><i class=\"fa\" ng-class=\"{true:\'fa-spinner fa-spin\', false:\'fa-search\'}[loading]\"></i></span>\n        <input typeahead-on-select=\"onSelectUser($item)\" placeholder=\"Select User\" class=\"form-control\" uib-typeahead=\"user.display_name + \' < \' + user.email + \' > \' for user in searchUsers($viewValue)\" ng-model=\"collaboratorsTextFiled.input\" typeahead-wait-ms=\"delay\" aria-autocomplete=\"list\" typeahead-min-length=\"3\">\n      </div>\n      <tr>\n        <th>Name</th>\n        <th>Email</th>\n        <th></th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"user in selectedUsers track by $index\">\n        <td>{{user.display_name}}</td>\n        <td>{{user.email}}</td>\n        <td><a ng-click=\"removeUser(user)\"><i class=\"fa fa-trash text-grey\"></i></a>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n      <button class=\"btn btn-primary pull-right btn-xs\" ng-disabled=\"!selectedUsers.length\" ng-click=\"exportAssignments()\">\n        Export User Assignments\n      </button>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("components/genericImport/genericImport-modal.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Import {{ moduleName }}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <input type=\"file\" file-model=\"csvFile\">\n    <i>Only CSV format is supported.</i>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"importCSV(csvFile)\" ng-disabled=\"disableImportButton\">\n      Import CSV\n    </button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">\n      Cancel\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/genericImport/genericImport-template.html","<button class=\"btn btn-primary pull-right btn-xs mr-15 margin-right\" ng-click=\"importCSVModal()\">\n  Import {{moduleName}}\n</button>\n");
$templateCache.put("components/grn/grnTemplate.html","<!--screen section-->\n<div class=\"inmodal grn-detail\" id=\"print-grn-detail\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close screen-section\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">\n        <span aria-hidden=\"true\">&times;</span></button>\n      <h3 class=\"modal-title grn-detail-title\">GRN Information (received goods)</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Receipt Number\n            </label>\n            <div class=\"col-xs-7\">\n              {{grn.grn_number}}\n            </div>\n          </div>\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Delivery Order No\n            </label>\n            <div class=\"col-xs-7\">\n              {{grn.do_number}}\n            </div>\n          </div>\n          <div class=\"row form-group\" ng-if=\"!!grn.do_date\">\n            <label class=\"col-xs-5\">\n              DO received date\n            </label>\n            <div class=\"col-xs-7\">\n              {{grn.do_date | date: \'dd MMM yyyy\'}}\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Purchase Requisition No\n            </label>\n            <div class=\"col-xs-7\">\n              {{po.pr_number}}\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Purchase Order No\n            </label>\n            <div class=\"col-xs-7\">\n              {{grn.po_number}}\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <table class=\"table\">\n          <colgroup>\n            <col class=\"column-index\">\n            <col class=\"column-description\">\n            <col class=\"column-quantity\">\n            <col class=\"column-accepted\">\n            <col class=\"column-rejected\">\n            <col class=\"column-uom\">\n          </colgroup>\n          <thead>\n            <tr>\n              <th>#</th>\n              <th class=\"col-sm-6\">Item Name</th>\n              <th>Qty</th>\n              <th>Accepted</th>\n              <th>Received</th>\n              <th>UOM</th>\n              <th>Date Received</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in grn.items track by $index\" ng-init=\"index = $index\">\n              <td>{{index + 1}}</td>\n              <td><b>{{item.item.name}}</b>\n                <div>\n                  <text-show-less-more model=\"item.item.descr || item.item.description\" type=\"word\" length=\"15\" class=\"limit-lines\">\n                  </text-show-less-more>\n                </div>\n              </td>\n              <td>{{item.quantity | formatDecimal: 4}}</td>\n              <td>{{item.order.delivered | formatDecimal: 4}}</td>\n              <td>{{item.order.last_batch | positive | formatDecimal: 4}}</td>\n              <td>{{item.uom.descr}}</td>\n              <td>{{!!item.order.delivered_on ? (item.order.delivered_on*1000 | date: \'dd MMM yyyy\') : \'Not specified\'}}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"grn-detail-right-button btn btn-default screen-section\" ng-click=\"printGRN()\">Print</button>\n    </div>\n</div><!--screen section-->\n\n\n");
$templateCache.put("components/history/history.html","<div class=\"row\">\n  <div class=\"col-md-12\">\n    <embedded-pagination-service class=\"screen-section\" meta=\"meta\" list=\"historyData\" service=\"service\" offset=\"10\" params-source=\"embeddedParams\">\n    </embedded-pagination-service>\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>Date</th>\n        <th>User</th>\n        <th>Action</th>\n        <th>Log</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-if=\"!!historyData.length && !!historyData[0].loading\">\n        <td colspan=\"4\">Loading...</td>\n      </tr>\n      <tr ng-if=\"!historyData.length\">\n        <td colspan=\"4\">There are no history</td>\n      </tr>\n      <tr ng-repeat=\"history in prepareHistoryData(historyData)\" ng-if=\"!!historyData.length && !historyData[0].loading\">\n        <td>\n          <div>{{ history.created_at.date }}</div>\n          <div>{{ history.created_at.time }}</div>\n        </td>\n        <td>{{ getActionBy(history) }}</td>\n        <td>{{ getAction(history) }}</td>\n        <td>\n          <div class=\"mb-5\" ng-repeat=\"logString in history.changeArray\">\n            <span ng-bind-html=\"logString\"></span>\n          </div>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/itemMultiSelectTemplate.html","<div ng-if=\"getSelectedItemsIndexes().length > 0\" class=\"btn-group-lg item-action-scrollfix screen-section\" role=\"group\">\n  <div class=\"pull-right close-multiselect\">\n    <a class=\"large-size\" ng-click=\"cancelSelectedItems()\">\n      <i class=\"fa fa-times color-white\"></i>\n    </a>\n  </div>\n  <span class=\"pull-right vertical-line\">|</span>\n  <div class=\"pull-right btn multi-item-margin\">\n    <span class=\"selected_item-text\">{{getSelectedItemsIndexes().length}} selected</span>\n  </div>\n  <span class=\"pull-left btn-group-lg multi-item-margin\">\n    <span class=\"btn-group dropdown btn-group-lg\">\n      <a class=\"btn dropdown-toggle\" data-toggle=\"dropdown\">Modify <span class=\"caret\"></span></a>\n      <ul class=\"dropdown-menu\">\n        <li><a ng-click=\"openMultiOptions(1)\">Needed by date</a></li>\n        <li ng-click=\"openMultiOptions(2)\">\n          <a address-book=\"{{deliveryAddressInfo.multiDeliveryAddress._id}}\" address-list=\"getDeliveryAddresses()\" on-selected-address-book=\"onSelectDeliveryAddress(address_book)\" access-from=\"LineItemDeliveryAddress\" event-handler=\"true\" multi-deletion-function=\"updateItemsInformation(\'delivery-address\', null)\">Delivery Address</a>\n        </li>\n        <li><a ng-click=\"openMultiOptions(3)\">Account code</a></li>\n        <li><a ng-click=\"openMultiOptions(4)\">Note</a></li>\n        <li><a ng-click=\"openMultiOptions(5)\">Quantity</a></li>\n        <li><a ng-click=\"openMultiOptions(6)\">Discount</a></li>\n        <li><a ng-click=\"openMultiOptions(7)\">Tax</a></li>\n\n      </ul>\n    </span>\n    <a class=\"btn btn-link\" ng-click=\"deleteItems()\">Delete</a>\n  </span>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiAccountCodModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Account code</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-3 text-right\"><b>Account Code:</b></div>\n      <div class=\"col-md-8\">\n        <ui-select ng-model=\"accountCodeInfo.multiAccountCode\">\n          <ui-select-match placeholder=\"Select account code...\">\n            {{ getPR().company.code + \':\' + getPR().cost_center.code + \':\' + $select.selected.code}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"ac in getAccountCodes() | filter: $select.search\">\n            <span ng-bind-html=\"ac.company_code | highlight: $select.search\"></span>:\n            <span ng-bind-html=\"getPR().cost_center.code | highlight: $select.search\"></span>:\n            <span ng-bind-html=\"ac.code | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n      <div class=\"col-md-1\">\n        <button class=\"btn btn-danger mt-5 btn-xs\" ng-if=\"!!accountCodeInfo.multiAccountCode\" uib-tooltip=\"Remove account codes\" ng-click=\"updateItemsInformation(\'account-code\', null)\">\n          <i class=\"fa fa-trash\"></i></button>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"updateItemsInformation(\'account-code\', accountCodeInfo.multiAccountCode._id)\">\n      Save\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiDiscountModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Discount</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h4>Edit Discount: </h4></div>\n      <div class=\"col-md-12\" ng-if=\"allowEditing\">\n        <input title=\"Add discount\" type=\"text\" class=\"discount-input form-control\" allow-pattern=\"[0-9.%]\" ng-model=\"discountInfo.multiDiscount\">\n      </div>\n      <div class=\"col-md-12\" ng-if=\"!allowEditing\">\n        <b>One or more of the selected Items does not have a unit price yet, Please add the price before proceeding</b>\n      </div>\n      <div class=\"col-md-12 mt-15 text-right\" ng-if=\"allowEditing && !!discountInfo\">\n        <button uib-tooltip=\"Delete discount\" class=\"btn btn-danger btn-xs\" ng-click=\"updateItemsInformation(\'discount\', 0)\">\n          <i class=\"fa fa-trash\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"updateItemsInformation(\'discount\', discountInfo.multiDiscount)\">\n      Save\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiNeededByModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Needed by Date</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"col-md-12\">\n          <b>Needed by date: </b>&nbsp;\n          <button class=\"btn btn-danger btn-xs pull-right cursor-pointer\" uib-tooltip=\"Remove needed by date\">\n            <i class=\"fa fa-trash\" ng-click=\"updateItemsInformation(\'needed-by\', null)\"></i>\n          </button>\n          <span ng-show=\"!neededByInfo.multiNeededBy\">\n            <i>Select date</i>\n          </span>\n          <span ng-show=\"!!neededByInfo.multiNeededBy\">\n            {{ neededByInfo.multiNeededBy | date:\'dd MMM yyyy\' }}\n          </span>\n          <span monitor-date=\"neededByInfo.multiNeededBy\">\n          </span>\n          <button class=\"btn btn-white btn-xs\" ng-click=\"multiDatePicker($event)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"neededByInfo.multiNeededBy\" ng-model-options=\"datePickerTimezone\" is-open=\"neededByInfo.open\" datepicker-options=\"dateOptions\" ng-required=\"true\">\n            <i class=\"fa fa-calendar\"></i>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"onSelectNeededDate(neededByInfo.multiNeededBy)\">\n      Save\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiNoteModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Note</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <h3>Notes (Only for external):</h3>\n        <textarea rows=\"5\" class=\"col-md-12\" ng-model=\"noteInfo.multiNote\">\n        </textarea>\n      </div>\n      <div class=\"col-md-12 mt-15 text-right\" ng-if=\"noteInfo.note\">\n        <button class=\"btn btn-danger btn-md\" uib-tooltip=\"Remove notes\" ng-click=\"updateItemsInformation(\'note\', null)\">\n          <i class=\"fa fa-trash\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"updateItemsInformation(\'note\', noteInfo.multiNote)\">\n      Save\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiQuantityModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Quantity</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\"><h4>Edit Quantity:</h4></div>\n      <div class=\"col-md-12\">\n        <input type=\"text\" step=\"0.00001\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,5})?$/\" class=\"form-control\" ng-enter=\"updateItemsInformation(\'qty\',quantityInfo.multiQuantity)\" ng-model=\"quantityInfo.multiQuantity\">\n      </div>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"updateItemsInformation(\'qty\',quantityInfo.multiQuantity)\">\n      Save\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/itemMultiSelect/multiTaxModalTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Discount</h4>\n  </div>\n  <div class=\"modal-body\">\n    <h4>Edit Tax: 	&nbsp;\n      <span ng-if=\"!allowEditing\">\n        <b>One or more of the selected Items does not have a unit price yet, Please add the price before proceeding</b>\n      </span>\n      <span ng-if=\"allowEditing\">\n        <div class=\"btn-group\" role=\"group\">\n          <a class=\"dropdown-toggle add-gst\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n            {{(!!taxInfo.multiTax && !!taxInfo.multiTax._id) ?\n            (taxInfo.multiTax.code + \" \" + taxInfo.multiTax.rate + \"%\") : \"Add\"}}\n          </a>\n\n          <ul class=\"dropdown-menu taxes-list\">\n            <li ng-repeat=\"tax in getTaxesList()\">\n              <a ng-click=\"updateItemsInformation(\'tax\', tax)\">\n                {{ tax.code + \' \' + tax.rate + \'%\' }}\n              </a>\n            </li>\n          </ul>\n          <div>\n            <button ng-click=\"removeTax(item, $index)\" ng-show=\"(!!item.tax && !!item.tax._id) && item.is_stock === 0\" class=\"btn btn-white btn-xs\">\n              <i class=\"fa fa-trash\" title=\"Delete Tax\"></i>\n            </button>\n          </div>\n        </div>\n      </span>\n    </h4>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("components/loading/loading.html","<div class=\"row loading\">\n  <div class=\"col-md-12\">\n    {{text}}\n  </div>\n</div>\n");
$templateCache.put("components/loadingFullWidth/loading-full-width.html","<div class=\"loading-full-width\">Loading...</div>\n");
$templateCache.put("components/masterExportCSV/masterExportCSV-template.html","<button ng-if=\"collection != \'2\'\" class=\"btn btn-primary pull-right btn-xs mr-15 margin-right\" ng-click=\"generateExportCSV()\" ng-disabled=\"checkingExportStatus || !!disableButton\">\n  Export {{moduleName}}\n</button>\n\n<button ng-if=\"collection === \'2\'\" class=\"btn btn-primary btn-block\" ng-click=\"generateExportCSV()\" ng-disabled=\"checkingExportStatus || !!disableButton\">\n  Export {{moduleName}}\n</button>\n");
$templateCache.put("components/masterImportAttachment/masterImport-attachmentTemplate.html","<div class=\"ibox-content po-attachment\">\n  <form action=\"\">\n    <input type=\"file\" onchange=\"submitAttachment(this)\">\n  </form>\n</div>\n");
$templateCache.put("components/mobileSearchBar/mobileSearchBar-template.html","<input type=\"text\" class=\"mobile-search-bar\" placeholder=\"Search...\" ng-model=\"$parent.query\" ui-keypress=\"{\'enter\':\'search($parent.query)\'}\">\n");
$templateCache.put("components/modalMore/modal-more.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">{{title}}</h4>\n    <h4>{{subtitle}}</h4>\n  </div>\n  <form name=\"currencyUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <p ng-if=\"dataType === \'string\'\">{{modalContents}}</p>\n          <div ng-if=\"dataType === \'array\'\">\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <th ng-repeat=\"header in tableHeader\">{{header}}</th>\n              </tr>\n              </thead>\n              <tbody>\n              <tr ng-repeat=\"content in modalContents\">\n                <td ng-repeat=\"header in tableHeader\">{{content[header]}}</td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("components/multiApprovalAction/multiApprovalActionTemplate.html","<span ng-click=\"prepareExtraParams()\">\n      <!-- Approve -->\n        <a action-modal title=\"{{\'Approve \' + getSelectedItems().length + \' \' + type}}\" action-function=\"getMultiActionFunction(\'approve\', getSelectedItems().length + \' \' + type + \' approved successfully\', extraParams)\" success-handler=\"getMultiActionHandler()\" error-handler=\"getMultiActionHandler()\" extra-params=\"extraParams\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-check\"></i> Approve\n        </a>\n  <!-- On Hold -->\n        <a ng-if=\"!!showOnHold\" action-modal title=\"{{\'Hold \' +  getSelectedItems().length + \' \' + type}}\" action-function=\"getMultiActionFunction(\'on_hold\',  getSelectedItems().length + \' \' + type + \' placed on hold successfully\' , extraParams)\" success-handler=\"getMultiActionHandler()\" error-handler=\"getMultiActionHandler()\" extra-params=\"extraParams\" comment-block=\"true\" comment-place-holder=\"Write a reason for hold\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-pause\"></i> Hold\n        </a>\n  <!-- Reject -->\n        <a action-modal title=\"{{\'Reject \' +  getSelectedItems().length + \' \' + type}}\" action-function=\"getMultiActionFunction(\'reject\',  getSelectedItems().length + \' \' + type + \' rejected successfully\' , extraParams)\" success-handler=\"getMultiActionHandler()\" error-handler=\"getMultiActionHandler()\" extra-params=\"extraParams\" comment-block=\"true\" comment-place-holder=\"Write a reason for rejecting\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon pr-action-icon-del fa fa-times\"></i> Reject\n        </a>\n</span>\n");
$templateCache.put("components/navbar/navbar-mobile.html","<div id=\"navigation-bar-top\" class=\"row\" style=\"margin-bottom: -15px\">\n  <nav class=\"navbar navbar-static-top mobile-bar\" role=\"navigation\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <span class=\"col-xs-3\" minimaliza-sidebar></span>\n          <div class=\"col-xs-5\">\n            <div class=\"navbar-text-mobile btn-group\">\n              <h1>Metabuyer</h1>\n            </div>\n          </div>\n          <span class=\"navbar-text-mobile\">\n            <a ng-if=\"enableMobileSearching\" class=\"mobile-buttons minimalize-styl-2\" ng-click=\"toggleSearchBar()\">\n              <i class=\"fa fa-search\"></i>\n            </a>\n          </span>\n          <span class=\"navbar-text-mobile\">\n            <a ng-click=\"logout()\" class=\"mobile-buttons minimalize-styl-2\">\n              <i class=\"fa fa-power-off\"></i>\n            </a>\n          </span>\n        </div>\n        <div ng-if=\"displaySearchBar && enableMobileSearching\" class=\"row\">\n          <mobile-search-bar></mobile-search-bar>\n        </div>\n      </div>\n    </div>\n  </nav>\n</div>\n");
$templateCache.put("components/navbar/navbar.html","<div id=\"navigation-bar-top\" class=\"row\" style=\"opacity: 0.99\">\n  <nav class=\"navbar navbar-static-top white-bg border-bottom\" role=\"navigation\">\n    <div class=\"navbar-header\">\n      <span minimaliza-sidebar></span>\n\n      <!-- Page Title -->\n      <h1 class=\"navbar-text btn-group\">{{pageTitle}}</h1>\n      <create-purchase-requisition-button></create-purchase-requisition-button>\n      <create-budget-button></create-budget-button>\n    </div>\n    <ul class=\"nav navbar-top-links white-bg navbar-right\">\n      <li ng-if=\"isDevEnvironment\" style=\"margin-top: 15px\">\n        <span id=\"dev-info\">\n          &lt;DEV&gt; {{ devInfo }}\n        </span>\n      </li>\n      <li class=\"dropdown\">\n        <a ui-sref=\"main.user.mainMenu.waiting-on-you\" class=\"count-info\" tooltip-placement=\"bottom\" uib-tooltip=\"Waiting on you\">\n          <i class=\"fa fa-flag\"></i>\n          <span class=\"label label-warning\" ng-if=\"!!waitings.meta.cursor.count\">\n            {{ waitings.meta.cursor.count }}\n          </span>\n        </a>\n      </li>\n      <li class=\"dropdown\">\n        <a ui-sref=\"main.user.mainMenu.notifications\" class=\"count-info\" tooltip-placement=\"bottom\" uib-tooltip=\"Notifications\">\n          <i class=\"fa fa-bell\"></i>\n          <span class=\"label label-primary\" ng-if=\"!!notifications.meta.cursor.count\">\n            {{ notifications.meta.cursor.count }}\n          </span>\n        </a>\n      </li>\n      <li>\n        <a id=\"logoutButton\" ng-click=\"logout()\" class=\"logout-icon\" tooltip-placement=\"bottom\" uib-tooltip=\"Logout\">\n          <i class=\"fa fa-power-off\"></i>\n        </a>\n      </li>\n    </ul>\n  </nav>\n</div>\n");
$templateCache.put("components/ngrn/ngrnTemplate.html","<div class=\"inmodal ngrn-detail\" id=\"print-grn-detail\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close screen-section\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">\n        <span aria-hidden=\"true\">&times;</span></button>\n      <h3 class=\"modal-title ngrn-detail-title\">GRN Information (reversed goods)</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Receipt Number\n            </label>\n            <div class=\"col-xs-7\">\n              {{ngrn.grn_number}}\n            </div>\n          </div>\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Date Reversed\n            </label>\n            <div class=\"col-xs-7\">\n              {{ngrn.created_at | date: \'dd MMM yyyy\'}}\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Purchase Requisition No\n            </label>\n            <div class=\"col-xs-7\">\n              {{po.pr_number}}\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-6\">\n          <div class=\"row form-group\">\n            <label class=\"col-xs-5\">\n              Purchase Order No\n            </label>\n            <div class=\"col-xs-7\">\n              {{ngrn.po_number}}\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <table class=\"table\">\n          <colgroup>\n            <col class=\"column-index\">\n            <col class=\"column-description\">\n            <col class=\"column-quantity\">\n            <col class=\"column-accepted\">\n            <col class=\"column-rejected\">\n            <col class=\"column-uom\">\n          </colgroup>\n          <thead>\n            <tr>\n              <th>#</th>\n              <th class=\"col-sm-6\">Item Name</th>\n              <th>Qty</th>\n              <th>Accepted</th>\n              <th>Reversed</th>\n              <th>UOM</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"item in ngrn.items track by $index\" ng-init=\"index = $index\">\n              <td>{{index + 1}}</td>\n              <td><b>{{item.item.name}}</b>\n                <div>\n                  <text-show-less-more model=\"item.item.descr || item.item.description\" type=\"word\" length=\"15\" class=\"limit-lines\">\n                  </text-show-less-more>\n                </div>\n              </td>\n              <td>{{item.quantity | formatDecimal: 4}}</td>\n              <td>{{item.order.delivered | formatDecimal: 4}}</td>\n              <td>{{item.order.last_batch | positive | formatDecimal: 4}}</td>\n              <td>{{item.uom.descr}}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"ngrn-detail-right-button btn btn-default screen-section\" ng-click=\"printNGRN()\">Print</button>\n    </div>\n</div>\n\n");
$templateCache.put("components/pagination/paginationForAE.html","<div class=\"pagination-template pull-right clear-floating pagination-margin-bottom\">\n  <div class=\"btn-group pull-right clear-floating pagination-focus\">\n    <button type=\"button\" class=\"btn btn-white\" ng-class=\"{disabled: currentPageNumber === 0}\" ng-disabled=\"currentPageNumber === 0\" ng-click=\"goPreviousPage()\">\n      <span aria-hidden=\"true\">&lsaquo;</span>\n    </button>\n    <button class=\"btn btn-white\" ng-class=\"{disabled: currentPageNumber + 1 === totalPageNumber}\" ng-disabled=\"currentPageNumber + 1 === totalPageNumber\" ng-click=\"goNextPage()\">\n      <span aria-hidden=\"true\">&rsaquo;</span>\n    </button>\n  </div>\n  <label id=\"pagination-label\" class=\"pull-right m-t-xs m-r-xs m-b-sm\" ng-if=\"totalPageNumber > 0 \">\n    {{ startRecNo }} - {{ endRecNo }} of {{ totalRec }}\n  </label>\n</div>\n");
$templateCache.put("components/pagination/paginationTemplate.html","<div class=\"pagination-template pull-right clear-floating pagination-margin-bottom\">\n  <div class=\"btn-group pull-right clear-floating pagination-focus\">\n    <button type=\"button\" class=\"btn btn-white\" ng-class=\"{disabled: !previousPageCode || !!disablePaginationButtons}\" ng-disabled=\"!previousPageCode || !!disablePaginationButtons\" ng-click=\"goPreviousPage()\">\n      <span aria-hidden=\"true\">&lsaquo;</span>\n    </button>\n    <button class=\"btn btn-white\" ng-class=\"{disabled: !nextPageCode || !!disablePaginationButtons}\" ng-disabled=\"!nextPageCode || !!disablePaginationButtons\" ng-click=\"goNextPage()\"><span aria-hidden=\"true\">&rsaquo;</span></button>\n  </div>\n  <label id=\"pagination-label\" class=\"pull-right m-t-xs m-r-xs m-b-sm\">\n    {{ totalCount === 0 ? 0 : currentCountStart }} - {{ !!currentCountEnd ? currentCountEnd : 0 }}\n    of {{ !!totalCount ? totalCount : 0 }}\n  </label>\n</div>\n");
$templateCache.put("components/passwordResetModal/passwordResetModalTemplate.html","<form method=\"post\" ng-submit=\"createNewPassword()\" name=\"changePassword\">\n  <div class=\"user_change_password\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\">Change password</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\" ng-show=\"oldPasswordField\">\n          <label class=\"col-sm-5 control-label\">Old Password</label>\n          <div class=\"col-sm-6\">\n            <input id=\"oldPassword\" ng-class=\"{\'highlight-error-input\': wrongFormatError || !password_old.length && submitted}\" type=\"password\" class=\"form-control\" ng-model=\"password_old\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\">\n            <span class=\"text-danger\" ng-if=\"submitted && !password_old.length\">Old password is required!</span>\n          </div>\n        </div>\n        <div class=\"form-group has-feedback\">\n          <label class=\"col-sm-5 control-label\">New Password</label>\n          <div class=\"col-sm-6\">\n            <input id=\"newPassword\" ng-class=\"{\'highlight-error-input\': wrongFormatError}\" type=\"password\" class=\"form-control\" name=\"password_new\" ng-model=\"password_new\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\" required>\n            <span class=\"text-danger\" ng-show=\"!changePassword.password_new.$error.required\n            && changePassword.password_new.$error.pattern && changePassword.password_new.$dirty\">\n             Minimum 8 characters with at least one lower & uppercase letter, and one number\n            </span>\n            <span class=\"text-danger\" ng-if=\"(changePassword.password_new.$error.minlength && !changePassword.password_new.$error.pattern)\">\n              Password must be 8 characters long\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group has-feedback\">\n          <label class=\"col-sm-5 control-label\">Confirm Password</label>\n          <div class=\"col-sm-6\">\n            <input id=\"confirmPassword\" ng-class=\"{\'highlight-error-input\': missMatchError}\" type=\"password\" class=\"form-control\" name=\"password_confirm\" ng-model=\"password_confirm\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\" required>\n            <span class=\"text-danger\" ng-if=\"missMatchError\">Password does not match</span>\n          </div>\n        </div>\n\n        <div class=\"form-group\" ng-show=\"!oldPasswordField\">\n          <span class=\"col-sm-5\"></span>\n          <span class=\"col-sm-7\">Note : This is a temporary password for this user</span>\n        </div>\n        <div class=\"form-group\" ng-show=\"!oldPasswordField\">\n          <span class=\"col-sm-6\"></span>\n          <input type=\"checkbox\" ng-model=\"send_email\" ng-init=\"send_email = true\"> Send password to user via email\n        </div>\n\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button id=\"submitChangePasswordButton\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!password_new || !password_confirm\">Change Password</button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\">Cancel</button>\n    </div>\n  </div>\n</form>\n\n");
$templateCache.put("components/poAttachment/poattachmentTemplate.html","<div class=\"ibox-content po-attachment\">\n  <div class=\"row\">\n    <div class=\"col-lg-6\"><h3 class=\"po-attachment-headding\">Attachments</h3></div>\n    <div class=\"col-lg-6\">\n      <a class=\"pull-right\" ng-click=\"showDropZone = !showDropZone\">{{\n      showDropZone ? \'Hide Uploader\' : \'Uploader\'}}</a>\n    </div>\n  </div>\n  <p class=\"text-muted\" ng-show=\"files.length == 0 && showDropZone == false\">There are no attachments</p>\n  <form ng-show=\"showDropZone\" action=\"\" class=\"dropzone po-attachment-dropzone\" dropzone=\"dropzoneConfig\" id=\"file-dropzone\">\n    <div class=\"dropzone-supported-file-div\">\n      <span class=\"dropzone-supported-file-span\">\n        Supported files : .xls, .doc, .ppt, .txt, .pdf, .jpg, .png, .gif, .bmp, .xlsx, .docx, .pptx, .jpeg\n      </span>\n    </div>\n  </form>\n  <br>\n\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"file-box\" ng-repeat=\"file in files\" ng-init=\"file.edit_file_name = file.descr\">\n        <div class=\"file\">\n          <div class=\"file-title\">\n            <span class=\"po-attachment-file-title\" editable-text=\"file.edit_file_name\" e-required e-placeholder=\"Add title\" buttons=\"no\" e-style=\"display: inline;\" blur=\"submit\" onaftersave=\"update(file)\">{{file.edit_file_name || file.descr || \"Add title\"}}</span>\n            <div ng-show=\"!po.attachments[$index].isDO\">\n              <a type=\"button\" class=\"btn-xs btn-white pull-right po-attachment-delete\" ng-click=\"delete(file)\">\n                <i class=\"fa fa-trash-o\"></i></a>\n            </div>\n\n          </div>\n          <a ng-click=\"download(file._id)\">\n            <div class=\"icon\">\n              <i class=\"fa fa-file\"></i>\n            </div>\n          </a>\n          <div class=\"po-attachment-file-size\">{{::(file.size*1.0/1000)}} Kb</div>\n          <div class=\"file-name\">\n            <div class=\"po-attachment-name\">{{::file.original_file_name}}</div>\n            <br>\n            <small>Added by {{::file.uploader.data.display_name}} <br> on {{::(file.created_at | date)}}</small>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/poItemList/poItemlistTemplate.html","<table class=\"table\">\n  <colgroup>\n    <col class=\"column-image\">\n    <col class=\"column-item-details\" ng-class=\"{\'column-item-details-no-check-box\': !checkIsEditable()}\">\n    <col class=\"column-quantity\">\n    <col class=\"column-unit-price\">\n    <col class=\"column-amount\">\n  </colgroup>\n  <thead>\n  <tr>\n    <th colspan=\"2\" class=\"text-left-align\">Item</th>\n    <th>Qty</th>\n    <th>Unit Price</th>\n    <th>Amount</th>\n    <th>Discount</th>\n    <th>Total Amount</th>\n    <th>GST</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr ng-repeat-start=\"item in po.items track by $index\" ng-init=\"parentIndex = $index\">\n    <td>\n      <div class=\"product-image-wrapper\" ng-switch on=\"!!item.item.img_url\">\n        <img ng-switch-when=\"true\" class=\"img-responsive\" ng-src=\"{{ imageBasePath }}{{item.item.img_url}}\" alt=\"{{item.item.name}}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n        <img ng-switch-default class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item.name}}\">\n      </div>\n    </td>\n    <td class=\"text-left-align\">\n      <span class=\"label label-warning pull-right\" name=\"scrollToClosedItem\" ng-show=\"item.closed == true\" ng-click=\"scrollToClosedLineItemComment(item.closing_comment_id)\">Closed</span>\n      <p>{{parentIndex + 1}}. {{item.item.name}}</p>\n      <text-show-less-more model=\"item.item.desc || item.item.description\" type=\"words\"></text-show-less-more>\n      <p>{{item.supplier.name}}</p>\n      <table ng-if=\"!!item.others\" class=\"table table-condensed table-unbordered\">\n        <colgroup>\n          <col class=\"column-details-value\">\n          <!--<col class=\"column-details-remove\"/>-->\n        </colgroup>\n        <tbody>\n        <tr ng-repeat-start=\"other in item.others track by $index\" ng-if=\"other.type === \'needed_at\'\">\n          <td>Needed By: {{other.date | date:\'dd MMM yyyy\'}}</td>\n          <td></td>\n        </tr>\n        <tr ng-if=\"other.type === \'account_code\'\">\n          <td>\n            Account Code: {{ po.billing.company.code }}:{{ po.billing.cost_center.code }}:{{other.account_code.code}}\n          </td>\n        </tr>\n        <tr ng-if=\"other.type === \'note\'\">\n          <td>Note: <span class=\"pre-line\" ng-bind-html=\"other.text\"></span></td>\n        </tr>\n        <tr ng-if=\"other.type === \'delivery_address\'\">\n          <td>\n            <b>Delivery Address:</b> <br>\n              <span class=\"address-text-format\">{{\n                (other.address.details.line1.length ? other.address.details.line1 + \"\\n\": \"\") +\n                (other.address.details.line2.length ? other.address.details.line2 + \"\\n\": \"\") +\n                (other.address.details.line3.length ? other.address.details.line3 + \"\\n\": \"\") +\n                (other.address.details.postal_code.length ? other.address.details.postal_code : \"\") +\n                (other.address.details.length ? (other.address.details.length ? \" \" : \"\") +\n                other.address.details.city + \"\\n\" : (other.address.details.postal_code.length ? \"\\n\" : \"\")) +\n                (other.address.details.state.length ? other.address.details.state : \"\") +\n                (other.address.details.country.length? (other.address.details.country.length ? \", \" : \"\") +\n                other.address.details.country: \"\") }}\n              </span>\n          </td>\n        </tr>\n        <tr ng-repeat-end ng-if=\"other.type === \'custom\'\">\n          <td>{{other.name}}: {{other.text || \'Click to edit\'}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </td>\n    <td>\n      <div>{{item.quantity}} {{item.uom.code}}</div>\n      <div ng-if=\"(!!item.order.delivered && item.order.delivered != 0)\n      && ([\'PARTIALLY_DELIVERED\', \'AWAITING_DELIVERY\', \'IN_PORT\', \'CLOSED\', \'DELIVERED\'].indexOf(po.status) > -1)\" class=\"grey-text\">\n        {{item.order.delivered}} rcvd\n      </div>\n    </td>\n    <td>\n      <span>\n        <span ng-if=\"!!newCurrencyCode && (newCurrencyCode != item.currency.code)\">\n          {{item.original_unit_price | isoCurrency: item.currency.code: 4}}\n        </span>\n        <span ng-if=\"!newCurrencyCode || (newCurrencyCode == item.currency.code)\">\n          {{item.unit_price | formatDecimal: 4}}\n        </span>\n      </span>\n    </td>\n    <td>\n      <span>{{item.amount | formatDecimal: 2}}</span>\n    </td>\n    <td>\n      <div class=\"row\" ng-repeat=\"discount in item.discount track by $index\">\n        <div class=\"col-xs-12\" ng-if=\"!!discount.is_percentage\">\n          <div>{{discount.entry || discount.amount + \'%\'}}</div>\n          <div>({{item.amount * discount.amount / 100 | formatDecimal: 2}})</div>\n        </div>\n        <div class=\"col-xs-12\" ng-if=\"!discount.is_percentage\">\n          ({{discount.amount}})\n        </div>\n      </div>\n    </td>\n    <td>\n      <span>{{item.totalAmount | formatDecimal: 2}}</span>\n    </td>\n    <td>\n      <div>{{!!item.taxes[0] ? (item.taxes[0].code + \" \" + item.taxes[0].rate + \"%\") : \"\"}}</div>\n      {{item.taxes[0].calculated | formatDecimal: 2}}\n    </td>\n  </tr>\n  <tr ng-if=\"!!item.freight\" ng-repeat=\"freightItem in item.freight\">\n    <td></td>\n    <td class=\"text-left-align\">Freight</td>\n    <td></td>\n    <td></td>\n    <td>\n      <span ng-if=\"!!freightItem.amount && !!freightItem.is_percentage && freightItem.amount !== null\">\n        <span>\n          <div>{{freightItem.amount}}%</div>\n           <div>\n             {{(freightItem.amount*item.amount)/100 | formatDecimal: 2}}\n           </div>\n        </span>\n      </span>\n      <span ng-if=\"!!freightItem.amount && !freightItem.is_percentage && freightItem.amount !== null\">\n        {{freightItem.amount | formatDecimal: 2}}\n      </span>\n    </td>\n    <td>\n      <span ng-if=\"!!freightItem.discount && !!freightItem.discount.is_percentage && freightItem.discount.amount !== null\">\n        <div>\n          {{freightItem.discount.amount}}%\n        </div>\n        <div>\n          ({{freightItem.discount.calculated | formatDecimal: 2}})\n        </div>\n      </span>\n      <span ng-if=\"!!freightItem.discount && !freightItem.discount.is_percentage &&\n                  (!!freightItem.discount.amount || !!freightItem.discount.calculated)\">\n        ({{freightItem.discount.amount || freightItem.discount.calculated | formatDecimal: 2}})\n      </span>\n    </td>\n    <td>{{freightItem.totalAmount | formatDecimal: 2}}</td>\n    <td>\n      <div>{{!!freightItem.tax? (freightItem.tax.code + \" \" + freightItem.tax.rate + \"%\"): \"\"}}</div>\n      {{freightItem.tax.calculated | formatDecimal:2}}\n    </td>\n  </tr>\n  <tr ng-repeat-end ng-if=\"!!item.transportation\" ng-repeat=\"transportationItem in item.transportation\">\n    <td></td>\n    <td class=\"text-left-align\">Transportation</td>\n    <td></td>\n    <td></td>\n    <td>\n      <span ng-if=\"!!transportationItem.amount && !!transportationItem.is_percentage && transportationItem.amount !== null\">\n        <span>\n          <div>{{transportationItem.amount}}%</div>\n           <div>\n             {{(transportationItem.amount*item.amount)/100 | formatDecimal: 2}}\n           </div>\n        </span>\n      </span>\n      <span ng-if=\"!!transportationItem.amount && !transportationItem.is_percentage && transportationItem.amount !== null\">\n        {{transportationItem.amount | formatDecimal: 2}}\n      </span>\n    </td>\n    <td>\n      <span ng-if=\"!!transportationItem.discount && !!transportationItem.discount.is_percentage && transportationItem.discount.amount !== null\">\n        <div>\n          {{transportationItem.discount.amount}}%\n        </div>\n        <div>\n          ({{transportationItem.discount.calculated | formatDecimal: 2}})\n        </div>\n      </span>\n      <span ng-if=\"!!transportationItem.discount && !transportationItem.discount.is_percentage &&\n                  (!!transportationItem.discount.amount || !!transportationItem.discount.calculated)\">\n        ({{transportationItem.discount.amount || transportationItem.discount.calculated | formatDecimal: 2}})\n      </span>\n    </td>\n    <td>{{transportationItem.totalAmount | formatDecimal: 2}}</td>\n    <td>\n      <div>{{!!transportationItem.tax? (transportationItem.tax.code + \" \" + transportationItem.tax.rate + \"%\"): \"\"}}</div>\n      {{transportationItem.tax.calculated | formatDecimal:2}}\n    </td>\n  </tr>\n  </tbody>\n  <tfoot ng-if=\"!!po.items.length\">\n  <tr>\n    <td></td>\n    <td align=\"right\">Total Amount</td>\n    <td></td>\n    <td>\n      <span uib-tooltip=\"Currency\" ng-if=\"!po.currency\">{{po.billing.currency.code}}</span>\n      <span uib-tooltip=\"Currency\" ng-if=\"!!po.currency\">{{po.currency.code}}</span>\n    </td>\n    <td><span uib-tooltip=\"Amount\">{{grandAmount | formatDecimal: 2}}</span></td>\n    <td><span uib-tooltip=\"Discount\" ng-if=\"!!grandDiscount\">\n      ({{grandDiscount | formatDecimal: 2}})</span>\n    </td>\n    <td><span uib-tooltip=\"Total amount\">{{newTotalAmount | formatDecimal: 2}}</span></td>\n    <td><span uib-tooltip=\"GST\">{{grandTax | formatDecimal: 2}}</span></td>\n  </tr>\n  <tr ng-show=\"!!po.lump_sum_discount\">\n    <td><span class=\"table-padding\"></span></td>\n    <td>\n      <span class=\"pull-left text-black table-padding\">Lump sum discount</span>\n    </td>\n    <td><span class=\"table-padding\"></span></td>\n    <td><span class=\"table-padding\"></span></td>\n    <td><span class=\"table-padding\"></span></td>\n    <td>\n      <div class=\"row table-padding\">\n        <span>\n          <span uib-tooltip=\"Lump sum discount\" ng-if=\"!!po.lump_sum_discount.is_percentage\">\n            {{po.lump_sum_discount.amount}}%\n          </span>\n          <span uib-tooltip=\"Lump sum discount\" ng-if=\"!po.lump_sum_discount.is_percentage\">\n            ({{po.lump_sum_discount.amount | formatDecimal: 2}})\n          </span>\n        </span>\n      </div>\n    </td>\n    <td><span class=\"table-padding\"></span></td>\n    <td>\n      <span class=\"table-padding\">\n        <small ng-if=\"!!po.lump_sum_discount && !!po.lump_sum_discount.tax\">\n          {{po.lump_sum_discount.tax.code}} {{po.lump_sum_discount.tax.rate}}%\n        </small>\n        <br>\n        <small ng-if=\"!!po.lump_sum_discount && !!po.lump_sum_discount.tax\">\n          ({{(po.lump_sum_discount.tax.rate/100*totalLumpSum) | formatDecimal: 2}})\n        </small>\n      </span>\n    </td>\n  </tr>\n\n  <!-- Total With lumpSum -->\n  <tr ng-if=\"!!po.lump_sum_discount\">\n    <td></td>\n    <td align=\"right\">Total Amount</td>\n    <td></td>\n    <td>\n      <span uib-tooltip=\"Currency\" ng-if=\"!po.currency\">{{po.billing.currency.code}}</span>\n      <span uib-tooltip=\"Currency\" ng-if=\"!!po.currency\">{{po.currency.code}}</span>\n    </td>\n    <td><span uib-tooltip=\"Amount\">{{grandAmount | formatDecimal: 2}}</span></td>\n    <td><span uib-tooltip=\"Discount\" ng-if=\"!!grandDiscount || !!totalLumpSum\">\n      ({{grandDiscount + totalLumpSum | formatDecimal: 2}})</span>\n    </td>\n    <td><span uib-tooltip=\"Total amount\">{{newTotalAmount - (grandDiscount + totalLumpSum) | formatDecimal: 2}}</span></td>\n    <td><span uib-tooltip=\"GST\">{{grandTax - lumpsumTax | formatDecimal: 2}}</span></td>\n  </tr>\n  <tr>\n    <td ng-show=\"checkIsEditable()\"></td>\n    <td></td>\n    <td></td>\n    <td></td>\n    <td></td>\n    <td colspan=\"3\">Total amount inclusive of GST</td>\n    <td>\n      <span uib-tooltip=\"Total amount inclusive of GST\" class=\"grand-total double-underlines\">\n          {{grandTotalAmount | formatDecimal: 2}}\n        </span>\n    </td>\n  </tr>\n  </tfoot>\n</table>\n");
$templateCache.put("components/positionsSelectionPanel/positionsSelectionTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"closeModal()\">x</button>\n    <h4 class=\"modal-title\">Positions</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div>\n      <ui-select ng-model=\"newRole\" on-select=\"addNewPosition(newRole)\">\n        <ui-select-match placeholder=\"Select a positions...\">\n          {{$select.selected.code}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"option in rolesList | filter: $select.search\">\n          <span>{{::option.name}} - {{(!!option.company_code ? option.company_code : \'System\')}}</span>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <h3>Positions:</h3>\n      </div>\n      <div class=\"col-md-6\">\n        &nbsp;\n      </div>\n    </div>\n    <div class=\"row\">\n      <h5 class=\"col-sm-12\" ng-repeat=\"role in user.positions track by $index\">\n        <div class=\"col-md-6\">\n          <span class=\"col-sm-6\" ng-if=\"role.company_code === selected_company.code || role.company_code === null\">\n            {{role.name}} - {{(!!role.company_code ? role.company_code : \'System\')}}\n            </span>\n        </div>\n        <div class=\"col-md-6\">\n          <span class=\"col-sm-6\" ng-if=\"role.company_code === selected_company.code || role.company_code === null\">\n              <a ng-click=\"removePosition(role, $index);\" class=\"text-danger\">remove</a>\n            </span>\n        </div>\n      </h5>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/prWarningBlock/prWarningBlockTemplate-mobile.html","<div class=\"alert alert-warning alert-non-catalog-item\" ng-if=\"checkForErrors()\">\n  <div class=\"row\">\n    <div class=\"col-xs-2 col-sm-2\">\n      <i id=\"blacklist-warning\" class=\"fa fa-warning fa-3x pull-left\"></i>\n    </div>\n    <div class=\"col-xs-10 col-sm-10\">\n      <!--Items changed section-->\n      <div ng-if=\"numberOfCatalogItemChanged > 0\">\n        <div>\n          {{(numberOfCatalogItemChanged > 1 ?\n          \"There are \" + numberOfCatalogItemChanged + \" items\" + \" that have been updated due to data change.\" :\n          \"There is \" + numberOfCatalogItemChanged + \" item \" + \"that has been updated due to data change.\")}}\n        </div>\n        <ul ng-repeat=\"changedItem in arrayOfDataChangedItems\">\n          <li ng-if=\"!!changedItem.catalogDescriptionChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with description changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogPriceChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with price changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.taxRateChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with tax rate changed.\"}}\n          </li>\n          <li ng-if=\"!!itemTypeChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with item type changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogCurrencyChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with currency changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogRemovedItems\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.taxUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the tax is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.paymentTermUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its payment term is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.uomUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its UOM is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.currencyUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its Currency is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.exchangeRateUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its Exchange Rate is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.itemExpired\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because it is expired.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBranchDeactivated\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because supplier branch (\" +\n            changedItem.branch.descr + \") is deactivated.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBranchUpdated\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because supplier branch (\" +\n            changedItem.branch.descr + \") details was updated.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBlackListed\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the supplier is blacklisted.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierInactive\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the supplier is deactivated.\"}}\n          </li>\n        </ul>\n      </div>\n\n      <!--Unavailable items section-->\n      <div ng-if=\"numberOfUnavailableItems > 0\">\n        <div>\n          {{(numberOfUnavailableItems > 1 ?\n          \"There are \" + numberOfUnavailableItems + \" items\" + \" that are now unavailable.\" :\n          \"There is \" + numberOfUnavailableItems + \" item \" + \"that is now unavailable.\")}}\n        </div>\n        <ul ng-repeat=\"unavailable in unavailableItems\">\n          <li>\n            {{unavailable.item_details.item_name + \" from \" +\n            unavailable.supplier.descr}}\n          </li>\n        </ul>\n      </div>\n\n      <!--Zero price section-->\n      <div ng-if=\"numberOfZeroPriceItem > 0\">\n        {{(numberOfZeroPriceItem > 1 ?\n        \"There are \" + numberOfZeroPriceItem + \" items\" + \" that have unit price of 0.0000\" :\n        \"There is \" + numberOfZeroPriceItem + \" item \" + \"that has unit price of 0.0000\")}}\n      </div>\n\n      <div ng-if=\"!!prDeliveryAddressChanged\">\n        <span>The company\'s selected delivery address has been updated due to data change.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypeDeactivated\">\n        <span>The selected expense type has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypeDeleted\">\n        <span>The selected expense type has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypesUnassigned\">\n        <span>The selected expense type has been unassigned from the company.</span>\n      </div>\n\n      <div ng-if=\"!!prCreatorDeleted\">\n        <span>The PR Creator has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prCreatorDeactivated\">\n        <span>The PR Creator has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prRequestorDeleted\">\n        <span>The PR Requestor has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prRequestorDeactivated\">\n        <span>The PR Requestor has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyDeactivated\">\n        <span>The selected PR Currency has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyDeleted\">\n        <span>The selected PR Currency has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyUnassignedFromCompany\">\n        <span>The company has stopped using the PR\'s currency.</span>\n      </div>\n\n      <div ng-if=\"!!prCostCenterDeleted\">\n        <span>The company\'s selected cost center has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prBillAddressUnassigned\">\n        <span>\n          The company\'s selected Bill Address has been unassigned\n          from the cost center\n        </span>\n      </div>\n\n      <div ng-if=\"!!prDeliveryAddressUnassigned\">\n        <span>\n          The company\'s selected Delivery Address has been unassigned\n          from the cost center\n        </span>\n      </div>\n\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/prWarningBlock/prWarningBlockTemplate.html","<div class=\"alert alert-warning alert-non-catalog-item\" ng-if=\"checkForErrors()\">\n  <div class=\"row\">\n    <div class=\"col-md-1\">\n      <i id=\"blacklist-warning\" class=\"fa fa-warning fa-4x pull-left\"></i>\n    </div>\n    <div class=\"col-md-11\">\n\n      <!--Items changed section-->\n      <div ng-if=\"numberOfCatalogItemChanged > 0\">\n        <div>\n          {{(numberOfCatalogItemChanged > 1 ?\n          \"There are \" + numberOfCatalogItemChanged + \" items\" + \" that have been updated due to data change.\" :\n          \"There is \" + numberOfCatalogItemChanged + \" item \" + \"that has been updated due to data change.\")}}\n        </div>\n        <ul ng-repeat=\"changedItem in arrayOfDataChangedItems\">\n           <li ng-if=\"!!changedItem.catalogDescriptionChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with description changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogPriceChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with price changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.taxRateChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with tax rate changed.\"}}\n          </li>\n          <li ng-if=\"!!itemTypeChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with item type changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogCurrencyChanged\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" with currency changed.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.catalogRemovedItems\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.taxUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the tax is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.paymentTermUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its payment term is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.uomUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its UOM is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.currencyUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its Currency is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.exchangeRateUnavailable\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because its Exchange Rate is unavailable.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.itemExpired\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because it is expired.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBranchDeactivated\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because supplier branch (\" +\n            changedItem.branch.descr + \") is deactivated.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBranchUpdated\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because supplier branch (\" +\n            changedItem.branch.descr + \") details was updated.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierBlackListed\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the supplier is blacklisted.\"}}\n          </li>\n          <li ng-if=\"!!changedItem.supplierInactive\">\n            {{changedItem.item_details.item_name + \" from \" +\n            changedItem.supplier.descr + \" is unavailable because the supplier is deactivated.\"}}\n          </li>\n        </ul>\n      </div>\n\n      <!--Unavailable items section-->\n      <div ng-if=\"numberOfUnavailableItems > 0\">\n        <div>\n          {{(numberOfUnavailableItems > 1 ?\n          \"There are \" + numberOfUnavailableItems + \" items\" + \" that are now unavailable.\" :\n          \"There is \" + numberOfUnavailableItems + \" item \" + \"that is now unavailable.\")}}\n        </div>\n        <ul ng-repeat=\"unavailable in unavailableItems\">\n          <li>\n            {{unavailable.item_details.item_name +  \" from \" +\n            unavailable.supplier.descr + \" due to \" + invalidItemReason(unavailable)}}\n          </li>\n        </ul>\n      </div>\n\n      <!--Zero price section-->\n      <div ng-if=\"numberOfZeroPriceItem > 0\">\n        {{(numberOfZeroPriceItem > 1 ?\n        \"There are \" + numberOfZeroPriceItem + \" items\" + \" that have unit price of 0.0000\" :\n        \"There is \" + numberOfZeroPriceItem + \" item \" + \"that has unit price of 0.0000\")}}\n      </div>\n\n      <div ng-if=\"!!prDeliveryAddressChanged\">\n        <span>The company\'s selected delivery address has been updated due to data change.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypeDeactivated\">\n        <span>The selected expense type has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypeDeleted\">\n        <span>The selected expense type has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prExpenseTypesUnassigned\">\n        <span>The selected expense type has been unassigned from the company.</span>\n      </div>\n\n      <div ng-if=\"!!prCreatorDeleted\">\n        <span>The PR Creator has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prCreatorDeactivated\">\n        <span>The PR Creator has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prRequestorDeleted\">\n        <span>The PR Requestor has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prRequestorDeactivated\">\n        <span>The PR Requestor has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyDeactivated\">\n        <span>The selected PR Currency has been deactivated.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyDeleted\">\n        <span>The selected PR Currency has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prCurrencyUnassignedFromCompany\">\n        <span>The company has stopped using the PR\'s currency.</span>\n      </div>\n\n      <div ng-if=\"!!prCostCenterDeleted\">\n        <span>The company\'s selected cost center has been deleted.</span>\n      </div>\n\n      <div ng-if=\"!!prBillAddressUnassigned\">\n        <span>\n          The company\'s selected Bill Address has been unassigned\n          from the cost center\n        </span>\n      </div>\n\n      <div ng-if=\"!!prDeliveryAddressUnassigned\">\n        <span>\n          The company\'s selected Delivery Address has been unassigned\n          from the cost center\n        </span>\n      </div>\n\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/reLogInModal/reLogInModalTemplate.html","<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n\n      <h3 class=\"m-t-none m-b\">Session expired!</h3>\n\n      <p>{{message}}</p>\n\n      <form role=\"form\" class=\"m-t\" method=\"post\" ng-submit=\"login()\" name=\"reLoginForm\">\n        <div class=\"form-group has-feedback\">\n            <label>Password</label>\n            <input type=\"password\" ng-model=\"password\" placeholder=\"Password\" class=\"form-control\" ng-enter=\"login($event)\" required>\n        </div>\n        <div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!!error\">\n          <span class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></span>\n          <span class=\"sr-only\">Error:</span>\n          {{error}}\n          <span ng-if=\"!!errorCount\">\n            <br>Login attempt(s) remaining: {{errorCount}}\n          </span>\n        </div>\n        <div>\n          <button class=\"btn btn-sm btn-danger m-t-n-xs\" ng-click=\"logout()\">\n            <strong>Log out</strong>\n          </button>\n          <button class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" type=\"submit\">\n            <strong>Log in</strong>\n          </button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/receiveGoods/receiveGoodsTemplate.html","<div class=\"modal-dialog\">\n  <div class=\"receive-goods\" ng-show=\"next_receive_goods && !back_receive_goods\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title receive-goods-title\">Receive goods</h3>\n    </div>\n    <div class=\"modal-body\" ng-show=\"!receive_goods_data.length\">\n      <span>All the items required to be received cannot be received because they are closed or does not exist in the PO</span>\n    </div>\n    <div class=\"modal-body\" ng-show=\"receive_goods_data.length\">\n      <div class=\"row\">\n        <table class=\"table\">\n          <colgroup>\n            <col class=\"column-receive-goods-description\">\n            <col>\n            <col>\n            <col>\n            <col>\n          </colgroup>\n          <thead>\n          <tr>\n            <td class=\"cursor-default\">Item Name & Description</td>\n            <td class=\"cursor-default\">Remaining Quantity</td>\n            <td class=\"cursor-default\">Date Received</td>\n            <td class=\"cursor-default\">Received Quantity</td>\n            <td class=\"cursor-default\">UOM</td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"item in receive_goods_data\">\n            <td class=\"cursor-default\">\n              {{($index + 1)}}. <b>{{item.po_item.item.name}}</b>\n              <div>\n                <text-show-less-more model=\"item.po_item.item.description\" type=\"word\" length=\"15\" class=\"limit-lines\">\n                </text-show-less-more>\n              </div>\n            </td>\n            <td class=\"cursor-default text-right\">\n              {{ item.po_item.remaining_quantity | formatDecimal:4}}\n            </td>\n            <td class=\"cursor-default\">\n              <span class=\"label label-warning\" uib-tooltip=\"{{ getClosedDetail(item.po_item.closing_comment_id) }}\" ng-show=\"item.po_item.closed === true\">\n                Closed item\n              </span>\n              <input type=\"text\" ng-click=\"datePicker.openDatepicker($event,$index)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"item.received_date\" ng-model-options=\"datePickerTimezone\" is-open=\"item.datepickerOpened\" on-open-focus=\"true\" datepicker-options=\"dateOptions\" ng-show=\"item.po_item.closed !== true\" class=\"received-date\" readonly=\"readonly\">\n              \n            </td>\n            <td class=\"cursor-default\">\n              <div class=\"text-center\" ng-show=\"item.po_item.closed === true\">\n                <a class=\"po-action-btn reopen-btn btn-link\" ng-click=\"reopenItem($index)\">\n                  <i class=\"fa fa-undo\" title=\"Reopen item\"></i> Reopen item\n                </a>\n              </div>\n              <!-- If the item status == true -->\n              <div ng-show=\"item.po_item.closed !== true\">\n                <div ng-class=\"{\'highlight-error-input\': (parseToInt(item.received_amount) === 0 && receive_goods_data.length === 1 && submitted)}\">\n                  <input type=\"number\" class=\"receive-goods-input text-center\" ng-model=\"item.received_amount\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,4})?)?$\" allow-negative=\"false\" ng-show=\"item.po_item.closed !== true\" allow-decimal=\"false\">\n                  <span class=\"text-danger\" ng-show=\"item.received_amount > 0 &&\n                    (item.received_amount > item.po_item.remaining_quantity)\">\n                    Invalid\n                  </span>\n                  <span class=\"text-danger pull-right\" ng-if=\"parseToInt(item.received_amount) === 0 && receive_goods_data.length === 1 && submitted\">\n                    Required\n                  </span>\n                </div>\n              </div>\n            </td>\n            <td class=\"cursor-default\">{{item.po_item.uom.code}}</td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"receive-goods-container\">\n        <input id=\"check-all\" icheck type=\"checkbox\" ng-click=\"checkAllItemReceived()\" ng-model=\"check_for_all\">\n        <label for=\"check-all\" class=\"receive-goods-check-text\">Mark all as received</label>\n      </div>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row form-group\">\n        <div class=\"col-xs-3\">\n          <div class=\"pull-left\">\n            <span>Upload DO</span>\n          </div>\n        </div>\n        <div class=\"col-xs-9\">\n          <input type=\"file\" file-model=\"submit_data.do_file\" accept=\".pdf,.png,.doc,.jpg,.jpeg,.txt\">\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-3\">\n          <div class=\"pull-left\">\n            <span>DO number</span>\n          </div>\n        </div>\n        <div class=\"col-xs-9\">\n          <div class=\"comments-in-receive-goods-body\">\n            <input type=\"text\" ng-model=\"submit_data.do_number\" ng-class=\"{\'highlight-error-input\': (!submit_data.do_number.length && submitted) ||\n                       (submit_data.do_number.length && doCheck && (backupDONumber === submit_data.do_number))}\">\n          </div>\n          <span class=\"text-danger\" ng-if=\"!submit_data.do_number.length && submitted\">\n            DO number is mandatory!\n          </span>\n          <span class=\"text-danger\" ng-if=\"submit_data.do_number.length && doCheck && (backupDONumber === submit_data.do_number)\">\n            DO number {{submit_data.do_number}} is already taken for this supplier!\n          </span>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-3\">\n          <div class=\"pull-left\">\n            <span>DO receive date:</span>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"input-group\">\n            <input type=\"input\" ng-click=\"openDatePicker($event)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"do_dates.do_date\" ng-model-options=\"datePickerTimezone\" is-open=\"doDatepickerOpened\" datepicker-options=\"dateOptions\" class=\"received-date\" readonly=\"readonly\" ng-class=\"{\'highlight-error-field\': ( submitted && ((!do_dates.do_date) || (do_dates.do_date > tempcurrentDate)))}\">\n            \n          </div>\n          <span class=\"text-danger\" ng-if=\"dateCheck && (do_dates.do_date >= tempcurrentDate)\">\n              Please enter a valid date\n          </span>\n        </div>\n      </div>\n      <div class=\"comments-in-receive-goods row form-group\">\n        <div class=\"col-xs-1\">\n          <a class=\"pull-left\">\n            <img class=\"comments-in-receive-goods-img\" ng-src=\"{{::profile.img_url || \'assets/images/default-user.png\'}}\" image-error=\"assets/images/default-user.png\">\n          </a>\n        </div>\n        <div class=\"col-xs-11\">\n          <div class=\"comments-in-receive-goods-body\">\n            <span class=\"comments-in-receive-goods-top-arrow\"></span>\n            <span class=\"comments-in-receive-goods-bottom-arrow\"></span>\n\n            <textarea class=\"comments-in-receive-goods-text\" placeholder=\"Please enter your comments\" ng-model=\"submit_data.comment\" rows=\"5\" cols=\"10\">\n            </textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <!-- TODO: rewrite this part (Ahmed Saleh, 23/3/2016)-->\n      <button class=\"comments-in-receive-goods-left-button btn btn-default\" ng-click=\"cancel()\">Close</button>\n      <button class=\"comments-in-receive-goods-right-button btn btn-primary\" ng-click=\"doneReceiveGoods()\">Done</button>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("components/resendPO/resendPOTemplate.html","<div class=\"inmodal resend-po\">\n\n    <div class=\"modal-header\">\n      <h3 class=\"modal-title resend-po-title\">Resend PO</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <h4 class=\"row form-group\">This PO will be re-sent to Supplier {{::po.supplier.descr}} via</h4>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-2\">\n          <div class=\"pull-right\">\n            <span>Email:</span>\n          </div>\n        </div>\n        <div class=\"col-xs-9\">\n          <div>\n            <div class=\"resend-po-item-text\">{{::(po.supplier.email || \"-\")}}</div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-xs-2\">\n          <div class=\"pull-right\">\n            <span>Fax:</span>\n          </div>\n        </div>\n        <div class=\"col-xs-9\">\n          <div>\n            <div class=\"resend-po-item-text\">{{::(po.supplier.fax || \"-\")}}</div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"resend-po-left-button btn btn-primary\" ng-click=\"resend(po._id)\">Send</button>\n      <button class=\"resend-po-right-button btn btn-default\" ng-click=\"cancelResendPO()\">Cancel</button>\n    </div>\n\n</div>\n\n");
$templateCache.put("components/reverseGoods/reverseGoodsTemplate.html","<div class=\"inmodal\">\n  <div class=\"reverse-goods\" ng-show=\"next_reverse_goods && !back_reverse_goods\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title reverse-goods-title\">Reverse goods</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <table class=\"table\">\n          <colgroup>\n            <col class=\"column-reverse-goods-description\">\n            <col class=\"column-received-amount\">\n            <col class=\"column-reversed-amount\">\n            <col>\n          </colgroup>\n          <thead>\n          <tr>\n            <td class=\"cursor-default\">Item Name & Description</td>\n            <td class=\"cursor-default\">Received</td>\n            <td class=\"cursor-default\">Reverse</td>\n            <td class=\"cursor-default\">UOM</td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"item in reverse_goods_data\">\n            <td class=\"cursor-default\">\n              {{($index + 1)}}. <b>{{item.po_item.item.name}}</b>\n              <div>\n                <text-show-less-more model=\"item.po_item.item.description\" type=\"word\" length=\"15\" class=\"limit-lines\">\n                </text-show-less-more>\n              </div>\n            </td>\n            <td class=\"cursor-default text-center\">{{item.po_item.order.delivered}}</td>\n            <td class=\"cursor-default\">\n              <div ng-show=\"item.po_item.order.delivered > 0\">\n                <input type=\"number\" class=\"reverse-goods-input text-center\" ng-model=\"item.reversed_amount\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,4})?)?$\" allow-negative=\"false\" allow-decimal=\"false\">\n                <span class=\"text-danger\" ng-if=\"item.reversed_amount > 0 &&\n                    (item.reversed_amount > convertToInt(item.po_item.quantity) ||\n                    item.reversed_amount > convertToInt(item.po_item.order.delivered))\">\n                  Invalid\n                </span>\n              </div>\n            </td>\n            <td class=\"cursor-default\">{{item.po_item.uom.code}}</td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"reverse-goods-right-button btn\" ng-click=\"nextReverseGoods()\" ng-class=\"{\'btn-primary\': enable_next, \'btn-default\': !enable_next}\" ng-disabled=\"!enable_next\">next</button>\n    </div>\n\n  </div>\n\n  <div class=\"comments-in-reverse-goods\" ng-show=\"!next_reverse_goods && back_reverse_goods\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title comments-in-reverse-goods-title\">Reverse goods</h3>\n      <div class=\"comments-in-reverse-goods-note\">\n        <span>This PO will be marked as awaiting delivery</span>\n      </div>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-1\">\n          <a class=\"pull-left\">\n            <img class=\"comments-in-reverse-goods-img\" ng-src=\"{{::profile.img_url || \'assets/images/default-user.png\'}}\" image-error=\"assets/images/default-user.png\">\n          </a>\n        </div>\n        <div class=\"col-xs-11\">\n          <div class=\"comments-in-reverse-goods-body\">\n            <span class=\"comments-in-reverse-goods-top-arrow\"></span>\n            <span class=\"comments-in-reverse-goods-bottom-arrow\"></span>\n\n            <textarea class=\"comments-in-reverse-goods-text\" placeholder=\"Please enter your comments\" ng-model=\"submit_data.comment\" rows=\"5\" cols=\"10\"></textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"comments-in-reverse-goods-left-button btn btn-default\" ng-click=\"backReverseGoods()\">Back</button>\n      <button class=\"comments-in-reverse-goods-right-button btn btn-danger\" ng-click=\"processReverseGoods()\">Proceed</button>\n    </div>\n\n  </div>\n\n</div>\n\n\n");
$templateCache.put("components/rolesSelectionPanel/rolesSelectionTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"closeModal()\">x</button>\n    <h4 class=\"modal-title\">Roles</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div>\n      <ui-select ng-model=\"newRole\" on-select=\"addNewRole(newRole)\">\n        <ui-select-match placeholder=\"Select a role...\">\n          {{$select.selected.code}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"option in rolesList | filter: $select.search\">\n          <span>{{::option.name}} - {{::option.company_code || \'System Role\'}}</span>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <h3>Roles:</h3>\n      </div>\n      <div class=\"col-md-6\">\n        &nbsp;\n      </div>\n    </div>\n    <div class=\"row\">\n      <h5 class=\"col-sm-12\" ng-repeat=\"role in user.roles track by $index\" ng-if=\"role.company_code === selected_company.code || role.company_code === null\">\n\n        <div class=\"col-md-6\">\n          <span class=\"col-sm-6\">\n            {{role.name}}\n          </span>\n        </div>\n        <div class=\"col-md-6\">\n          <span class=\"col-sm-6\">\n              <a ng-click=\"removeRole($index);\" class=\"text-danger\">remove</a>\n          </span>\n        </div>\n      </h5>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/scorechart/scorechartTemplate.html","<div class=\"your-core-chart\">\n  <div class=\"chart-progress-bar\">\n    <div class=\"chart-progress\">\n      <div class=\"chart-bar\" ng-style=\"style\"></div>\n    </div>\n  </div>\n  <div class=\"chart-info\">\n    <div class=\"chart-value\">{{ score }}%</div>\n    <div class=\"chart-label\">score</div>\n  </div>\n</div>");
$templateCache.put("components/searchBar/searchBarTemplate.html","<div class=\"row\">\n  <div class=\"col-md-4 col-sm-4 col-xs-6\">\n    <div class=\"input-group\">\n      <div class=\"search-input-bar\" ng-switch=\"searchType\">\n        <span ng-switch-when=\"text\">\n        <input reset-field=\"reset()\" right=\"20\" type=\"text\" class=\"form-control\" aria-label=\"...\" placeholder=\"{{placeholder}}\" ng-style=\"{\'border-color\': active ? \'#1ab394\' : \'auto\' }\" ng-model=\"$parent.query\" ui-keypress=\"{\'enter\':\'search($parent.query)\'}\">\n        </span>\n        <span ng-switch-when=\"double\">\n        <input reset-field=\"reset()\" right=\"20\" type=\"number\" class=\"form-control\" aria-label=\"...\" ng-pattern-restrict=\"^[0-9]*(?:\\.[0-9]{0,2})?$\" placeholder=\"{{placeholder}}\" ng-style=\"{\'border-color\': active ? \'#1ab394\' : \'auto\' }\" ng-model=\"$parent.query\" ui-keypress=\"{\'enter\':\'search($parent.query)\'}\">\n        </span>\n        <span ng-switch-when=\"date\">\n          <div id=\"searchDate\" ng-click=\"openDatepicker($event)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"searchDate.value\" ng-model-options=\"datePickerTimezone\" is-open=\"searchDate.open\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" class=\"form-control\">\n            <i ng-show=\"!!searchDate.value\" class=\"remove-button-search-bar fa fa-remove pull-right\" ng-click=\"reset(); $event.stopPropagation()\"></i>\n            <span>{{searchDate.value | date: \'dd MMM yyyy\'}}</span>\n          </div>\n        </span>\n      </div>\n      <div class=\"input-group-btn\">\n        <span class=\"search-dropdown-list-and-button\">\n          <button data-toggle=\"dropdown\" class=\"btn btn-white dropdown-toggle\" aria-expanded=\"true\">\n            {{ selectedFilter.label || \'All filters\'}}\n            <i class=\"fa fa-caret-down\"></i>\n          </button>\n          <ul class=\"dropdown-menu\">\n            <li ng-repeat=\"filter in filtersList track by $index\">\n              <a ng-click=\"selectFilter(filter)\">{{ filter.label }}</a>\n            </li>\n          </ul>\n          <button type=\"button\" class=\"btn btn-normal\" id=\"search\" ng-click=\"search(query)\">\n            <i class=\"fa fa-search\"></i>\n          </button>\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/shoppingCart/shoppingCartTemplate.html","<span id=\"shoppingCartDirective\" class=\"shopping-cart\" ng-click=\"openCart()\">\n\n  <!-- pop up -->\n  <span id=\"notifications\" ng-show=\"itemAdded\">\n    <div class=\"notification deliveryMeter notification-tooltip attachedTop set-notification-shopping\">\n      <div class=\"arrow\"></div>\n      <div class=\"notificationInner withIcon\">\n        <a class=\"close\"></a>\n        <section class=\"itemsInCart\">\n          <div class=\"visual qty\">{{ 1 }}</div>\n          <div class=\"carttext\">\n            Item added to cart <br>\n            <a id=\"viewCart\" ng-click=\"viewCart()\">View my cart</a>\n          </div>\n        </section>\n      </div>\n    </div>\n  </span>\n\n  <!-- Cart in PR details Mode -->\n  <a id=\"shoppingCart\" class=\"pull-right cartPreview\" ng-show=\" (getPRStatus() === \'draft\' || getPRStatus() === \'edit\') && !isShoppingMode()\" tooltip-placement=\"bottom\">\n    <i class=\"fa fa-2x fa-shopping-cart\">\n      <span class=\"badge badge-primary pull-right cart-items\" ng-if=\"getPRItems().length > 0\">\n        {{ getPRItems().length }}\n      </span>\n    </i>&nbsp;&nbsp;\n    <span class=\"font-bold text-total-price\" ng-class=\"{ \'hide\': getPRItems().length > 0 }\">\n      <span ng-if=\"editingState === \'editable\'\">Your cart</span>\n      <span ng-if=\"editingState !== \'editable\'\">{{PRData().grand_total | isoCurrency: PRData().currency.code : 2}}</span>\n    </span>\n    <span class=\"font-bold text-total-price\" ng-class=\"{ \'hide\': getPRItems().length === 0 }\">\n      {{PRData().grand_total | isoCurrency: PRData().currency.code : 2}}\n    </span>\n  </a>\n\n  <!-- Cart in shopping Mode -->\n  <a id=\"shoppingCartShoppingMode\" class=\"pull-right cartPreview\" ng-show=\"(getPRStatus() === \'draft\' || getPRStatus() === \'edit\') && isShoppingMode()\" ng-click=\"viewCart()\" aria-expanded=\"true\">\n    <i class=\"fa fa-2x fa-shopping-cart\">\n      <span class=\"badge badge-primary pull-right cart-items\" ng-if=\"getPRItems().length > 0\">\n        {{ getPRItems().length }}\n      </span>\n    </i>&nbsp;&nbsp;\n    <span class=\"font-bold text-total-price\" ng-class=\"{ \'hide\': getPRItems().length > 0 }\">\n      Your cart\n    </span>\n    <span class=\"font-bold text-total-price\" ng-class=\"{ \'hide\': getPRItems().length === 0 }\">\n      {{PRData().grand_total | isoCurrency: PRData().currency.code : 2}}\n    </span>\n  </a>\n\n  <div class=\"arrow\"></div>\n  <div ng-mouseleave=\"removeClass()\" id=\"shoppingCartPanel\" class=\"layer pull-right dropdown-menu\" ng-class=\"{\'layer-no-item\': getPRItems().length === 0}\">\n    <div class=\"header-myCart\" ui-scrollfix=\"-20\">\n      <div class=\"header-myCart-fix\">\n        <h4>\n          <a class=\"text-navy-bold\">\n            <span>You have </span>\n            <span ng-if=\"getPRItems().length >= 0\">{{getPRItems().length}}</span>\n            <span ng-if=\"getPRItems().length === undefined\">0</span>\n            <span> item(s) in your cart</span>\n          </a>\n          <a id=\"backToPRCheckout\" ng-click=\"backToDetailPR()\" class=\"btn btn-default pull-right instacheckout\">\n            Proceed to PR\n          </a>\n        </h4>\n      </div>\n    </div>\n    <div id=\"cartPreview\">\n      <table class=\"shopping-summary table\">\n        <colgroup>\n          <col class=\"column-image\">\n          <col class=\"column-item-details\">\n          <col class=\"column-quantity\">\n          <col class=\"column-price\">\n          <col class=\"column-remove\">\n        </colgroup>\n        <tbody>\n        <tr class=\"background-white\" ng-repeat=\"item in getPRItems() track by $index\">\n          <td item-details details=\"item\" img-path=\"imageBasePath\">\n            <div class=\"product-image-wrapper\" ng-switch on=\"!!item.item.img_url\">\n              <img ng-switch-when=\"true\" class=\"img-responsive\" ng-src=\"{{ imageBasePath }}{{item.item.img_url}}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item_details.item_name}}\">\n              <img ng-switch-default class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item_details.item_name}}\">\n            </div>\n          </td>\n          <td item-details details=\"item\" img-path=\"imageBasePath\">\n            <div>\n              <h4>\n                <span>{{item.item_details.item_name}}</span>\n              </h4>\n            </div>\n            <div>\n                <span class=\"price\" ng-if=\"item.item_details.pricing.unit_price > 0\">\n                  <!-- Stock Item -->\n                    {{item.item_details.pricing.unit_price | isoCurrency: item.item_details.pricing.currency_code}} / {{item.uom.code}}\n                </span>\n                  <!-- Partial Item -->\n                <span class=\"price\" ng-if=\"item.item_details.pricing.unit_price === 0\">\n                    0.00 {{item.pricing.currency.code}} / {{item.pricing.uom.code}}\n                </span>\n            </div>\n            <div ng-if=\"!!item.payment_term.code\">Payment Term: {{item.payment_term.code}}</div>\n          </td>\n          <td class=\"quantity text-center\">\n            <a class=\"addtocart\">\n                <span class=\"text-navy-bold counter\">\n\n                  <a ng-model=\"item.qty\" editable-number=\"item.quantity\" e-class=\"item-quantity-edit form-control set-padding-input-quantity m-t-sm text-center\" e-ng-blur=\"submitAmount(this,item.quantity,item.uom)\" e-ng-enter=\"submitAmount(this,item.quantity,item.uom)\" buttons=\"no\" e-ng-pattern=\"/^[0-9]+(\\.[0-9]{1,})?$/\" e-maxlength=\"7\" onaftersave=\"updateQuantityShoppingCart(item, item.quantity)\">\n                     {{item.qty}} {{item.uom.code}}\n                  </a>\n                </span>&nbsp;&nbsp;\n            </a>\n          </td>\n          <td>\n            <h4 class=\"font-bold\" ng-if=\"item.item_details.pricing.unit_price > 0\">\n              <div>\n                  {{item.item_details.pricing.unit_price * item.qty |\n                  isoCurrency: item.item_details.pricing.currency_code:2}}\n              </div>\n              <div>\n                <span ng-show=\"!!prCurrency.code &&\n                (item.item_details.pricing.currency_code !== prCurrency.code)\">\n                  <i class=\"grey-text\">{{item.amount_pr_currency |\n                    isoCurrency:prCurrency.code :2}}</i>\n                </span>\n              </div>\n            </h4>\n            <h4 class=\"font-bold\" ng-if=\"item.item_details.pricing.unit_price === 0\">\n              <span>0.00 {{item.item_details.pricing.currency_code}}</span>\n            </h4>\n          </td>\n          <td>\n            <button ng-click=\"removeItemShoppingCart(item);\" ng-disabled=\"disabledDeleteItem\" id=\"removeCatalogItem\" class=\"btn btn-sm btn-white\">\n              <i class=\"fa fa-trash\"></i>\n            </button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</span>\n");
$templateCache.put("components/sidebar/sidebar-mobile.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\" ui-scrollfix>\n  <div class=\"sidebar-collapse\">\n    <ul side-navigation class=\"nav\" id=\"side-menu\">\n\n      <!--Profile (picture and display name)-->\n      <li class=\"nav-header\">\n        <div class=\"dropdown profile-element\">\n          <a ng-click=\"navigateSideBar(userProfileLink)\">\n            <span class=\"nav-label\">\n              <img alt=\"image\" class=\"img-circle profile-photo\" image-error=\"assets/images/default-user.png\" ng-src=\"{{ userImageBasePath }}/{{ currentUser.img_url }}\">\n              <strong id=\"userSidebarMenu\" class=\"font-bold\">\n                {{currentUser.display_name}}\n              </strong>\n            </span>\n          </a>\n        </div>\n      </li>\n\n      <!--Waiting on you -->\n      <li ui-sref-active=\"active\" ng-class=\"{\'active\' : activateSidePanel(waitingOnYouLink)}\">\n        <a tooltip-placement=\"right\" uib-tooltip=\"Waiting On You\" ng-click=\"navigateSideBar(waitingOnYouLink)\">\n          <span class=\"nav-label\">\n            <i class=\"fa fa-flag\"></i>\n            Waiting On You\n            <span class=\"label label-warning-light\" ng-if=\"!!waitings.meta.cursor.count\">\n              {{ waitings.meta.cursor.count }}\n            </span>\n          </span>\n        </a>\n      </li>\n\n      <!-- left sidebar list of non administrative modules -->\n      <li ng-repeat=\"link in navlinks.nonAdministrative\" ui-sref-active=\"active\" id=\"{{link.id}}\" ng-class=\"{\'active\' : activateSidePanel(link)}\">\n        <a ng-if=\"link.title !== \'Admin\' && !link.order_by && !link.order\" ng-click=\"navigateSideBar(link)\" tooltip-placement=\"right\" uib-tooltip=\"{{link.title}}\">\n          <span class=\"nav-label\">\n            <i class=\"fa {{link.icon}}\"></i>\n            {{link.title}}\n          </span>\n        </a>\n      </li>\n\n      <!-- left sidebar list of administrative functions -->\n      <li ng-if=\"!!navlinks.administrative.length\" id=\"adminPanelIcon\">\n        <a class=\"side-bar-admin-panel-icon\">\n          <span class=\"nav-label\">\n            <i class=\"fa fa-cog\"></i>\n            Admin\n          </span>\n        </a>\n        <ul class=\"nav nav-second-level collapse in\">\n          <li ng-repeat=\"option in navlinks.administrative | orderBy : \'title\'\" id=\"{{option.id}}\" ng-class=\"{\'active\' : activateSidePanel(option)}\">\n            <a ng-click=\"navigateSideBar(option)\">\n              {{option.title}}\n            </a>\n          </li>\n        </ul>\n      </li>\n\n      <!--Notifications-->\n      <li ui-sref-active=\"active\" ng-class=\"{\'active\' : activateSidePanel(notificationsLink)}\">\n        <a tooltip-placement=\"right\" uib-tooltip=\"Notifications\" ng-click=\"navigateSideBar(notificationsLink)\">\n          <span class=\"nav-label\">\n            <i class=\"fa fa-bell\"></i>\n            Notifications\n            <span class=\"label label-primary\" ng-if=\"!!notifications.meta.cursor.count\">\n              {{ notifications.meta.cursor.count }}\n            </span>\n          </span>\n        </a>\n      </li>\n\n      <!--Logout button-->\n      <li>\n        <a id=\"logoutButton\" ng-click=\"logout()\" class=\"logout-icon\" tooltip-placement=\"right\" uib-tooltip=\"Logout\">\n          <span class=\"nav-label\">\n            <i class=\"fa fa-power-off\"></i>\n            Logout\n          </span>\n        </a>\n      </li>\n\n      <!--<li>-->\n        <!--<a id=\"viewSwitcher\" ng-click=\"switchToDesktopView()\"-->\n           <!--tooltip-placement=\"right\" uib-tooltip=\"Switch to Desktop View\">-->\n          <!--<span class=\"nav-label\">-->\n                      <!--<i class=\"fa fa-exchange\"></i>-->\n            <!--Switch to Desktop View-->\n          <!--</span>-->\n        <!--</a>-->\n      <!--</li>-->\n    </ul>\n  </div>\n</nav>\n");
$templateCache.put("components/sidebar/sidebar.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\" ui-scrollfix>\n  <div class=\"sidebar-collapse\">\n    <ul side-navigation class=\"nav\" id=\"side-menu\">\n      <li class=\"nav-header-logo\">\n        <div class=\"logo-element-title\">\n          M<span id=\"logo-long-title\">etabuyer</span>\n        </div>\n      </li>\n      <li class=\"nav-header\">\n        <div class=\"dropdown profile-element\">\n          <!-- Picture of user -->\n          <img alt=\"image\" class=\"img-circle profile-photo\" image-error=\"assets/images/default-user.png\" ng-src=\"{{ userImageBasePath }}/{{ currentUser.img_url }}\" data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n          <a data-toggle=\"dropdown\" class=\"dropdown-toggle\">\n            <span class=\"clear\">\n              <span class=\"block m-t-xs\">\n                <strong id=\"userSidebarMenu\" class=\"font-bold\">\n                  {{currentUser.display_name}}\n                  <b class=\"fa fa-caret-down\"></b>\n                </strong>\n              </span>\n            </span>\n          </a>\n          <ul class=\"dropdown-menu animated fadeInRight m-t-xs\">\n            <li>\n              <a ui-sref=\"main.user.mainMenu.waiting-on-you\">\n                Waiting on you\n                <span class=\"label label-warning\" ng-if=\"!!waitings.meta.cursor.count\">\n                  {{ waitings.meta.cursor.count }}\n                </span>\n              </a>\n            </li>\n            <li>\n              <a ui-sref=\"main.user.mainMenu.notifications\">\n                Notifications\n                <span class=\"label label-primary\" ng-if=\"!!notifications.meta.cursor.count\">\n                  {{ notifications.meta.cursor.count }}\n                </span>\n              </a>\n            </li>\n            <li>\n              <a id=\"profileLink\" ui-sref=\"main.user.mainMenu.userProfile\">Profile</a>\n            </li>\n            <li class=\"divider\"></li>\n            <li><a ng-click=\"logout()\">Logout</a></li>\n          </ul>\n          \n        </div>\n      </li>\n      <!-- left sidebar list of non administrative modules -->\n      <li ng-repeat=\"link in navlinks.nonAdministrative\" ui-sref-active=\"active\" id=\"{{link.id}}\" ng-class=\"{\'active\' : activateSidePanel(link)}\">\n        <a ng-if=\"link.title !== \'Admin\' && !link.order_by && !link.order\" ng-click=\"navigateSideBar(link)\" tooltip-placement=\"right\" uib-tooltip=\"{{link.title}}\">\n          <i class=\"fa {{link.icon}}\"></i>\n          <span class=\"nav-label\">{{link.title}}</span>\n        </a>\n      </li>\n\n      <!-- left sidebar list of administrative functions -->\n      <li ng-if=\"!!navlinks.administrative.length\" id=\"adminPanelIcon\">\n        <a class=\"side-bar-admin-panel-icon\">\n          <i class=\"fa fa-cog\"></i> <span class=\"nav-label\">Admin</span>\n        </a>\n        <ul class=\"nav nav-second-level collapse in\">\n          <li ng-repeat=\"option in navlinks.administrative | orderBy : \'title\'\" id=\"{{option.id}}\" ng-class=\"{\'active\' : activateSidePanel(option)}\">\n\n            <a ng-click=\"navigateSideBar(option)\">{{option.title}}</a>\n\n          </li>\n        </ul>\n      </li>\n\n      <!--<li>-->\n        <!--<a id=\"viewSwitcher\" ng-click=\"switchToMobileView()\"-->\n           <!--tooltip-placement=\"right\" uib-tooltip=\"Switch to Mobile View\">-->\n          <!--<i class=\"fa fa-exchange\"></i>-->\n          <!--<span class=\"nav-label\">Switch to Mobile View</span>-->\n        <!--</a>-->\n      <!--</li>-->\n    </ul>\n  </div>\n</nav>\n");
$templateCache.put("components/submitPR/submitPRTemplate.html","<div class=\"inmodal\">\n  <div class=\"close-po\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\">x</button>\n      <h3 class=\"modal-title close-po-title\">Submit the requisition</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <approval-flow class=\"screen-section\" id=\"approval_id\" data=\"approvals\" ng-show=\"pr.status == \'draft\'\"></approval-flow>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"close-po-right-button btn btn-success\" ng-click=\"confirm()\">Confirm</button>\n      <button class=\"close-po-right-button btn btn-white\" ng-click=\"cancel()\">Cancel</button>\n    </div>\n\n  </div>\n\n</div>\n\n");
$templateCache.put("components/supplierGroups/supplierGroups.html","<table class=\"table multiselect-directive\">\n  <tr>\n    <th> Group Name </th>\n    <th> Status </th>\n    <th ng-hide=\"!!hideReason\" width=\"30%\"> Reason </th>\n    <th ng-if=\"!!editable\"> </th>\n  </tr>\n  <!--<tr ng-if=\"!!selectedGroupForListing && !!selectedGroupForListing .length\">-->\n    <!--<td colspan=\"{{ ((editable && hideReason) || (!editable && !hideReason)) ? 3 : 4 }}\">-->\n      <!--<input-->\n        <!--type        = \"text\"-->\n        <!--class       = \"form-control\"-->\n        <!--ng-model    = \"query\"-->\n        <!--placeholder = \"Search Group\"-->\n        <!--ng-enter    = \"false\"-->\n        <!--ng-keyup    = \"updateQuery(query)\">-->\n    <!--</td>-->\n  <!--</tr>-->\n  <tr ng-show=\"!!isGlobal\">\n    <td colspan=\"{{ ((editable && hideReason) || (!editable && !hideReason)) ? 3 : 4 }}\">\n      Global Supplier\n    </td>\n  </tr>\n  <tr ng-show=\"(!!selectedGroupForListing && !selectedGroupForListing.length) && !isGlobal\">\n    <td colspan=\"{{ ((editable && hideReason) || (!editable && !hideReason)) ? 3 : 4 }}\">\n      There is no supplier group selected\n    </td>\n  </tr>\n  <tr ng-repeat=\"group in selectedGroupForListing | filter: search\" ng-hide=\"!!isGlobal\">\n    <td>\n      {{ group.code }} <span ng-if=\"!!group.code\">-</span>\n      <span ng-if=\"!!group.code || !group.code && selectedGroupForListing.length > 1\"> {{ group.descr }} </span>\n    </td>\n    <td>\n      <select class=\"form-control\" ng-model=\"group.supplierGroupStatus\" ng-options=\"option.status as (option.descr | capitalize) for option in groupStatuses\" ng-selected=\"(group.supplierGroupStatus === option.status)\" value=\"{{option.status}}\" ng-disabled=\"!editable\">\n      </select>\n    </td>\n    <td ng-hide=\"!!hideReason\" width=\"30%\">\n      <span ng-show=\"!editable\"> {{ !!group.reason ? group.reason : \'-\' }} </span>\n      <textarea ng-model=\"group.reason\" class=\"form-control\" ng-show=\"!!editable\">\n      </textarea>\n    </td>\n    <td class=\"text-center\" ng-if=\"!!editable\">\n      <i class=\"fa fa-trash color-red cursor-pointer\" ng-if=\"!!group.code\" ng-click=\"removeGroup(group._id)\"></i>\n    </td>\n  </tr>\n  <tr ng-show=\"!!editable && !isGlobal\">\n    <td colspan=\"{{ ((editable && hideReason) || (!editable && !hideReason)) ? 3 : 4 }}\">\n      <isteven-multi-select input-model=\"groups\" output-model=\"selectedGroup\" button-label=\"descr\" item-label=\"descr\" max-labels=\"0\" translation=\"multiselectTranslation\" max-height=\"200px\" helper-elements=\"all none filter\" on-item-click=\"onSelectGroup(data)\" on-select-all=\"onSelectAll()\" on-select-none=\"onSelectNone()\" tick-property=\"ticked\">\n      </isteven-multi-select>\n    </td>\n  </tr>\n</table>\n");
$templateCache.put("components/supplierNotes/supplier-note-mobile.html","<div ng-show=\"!!noteMessage || status.toLowerCase() === \'draft\' || !!editable\" class=\"panel panel-default no-padding\" style=\"margin-bottom: 0px;margin-top: 0px\">\n  <div>\n    <div class=\"ibox-content-mobile\">\n      <div class=\"row\">\n        <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 15px; font-weight: bold\">\n          <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px\"></i>Notes to Suppliers :\n        </div>\n        <div class=\"col-xs-4 col-sm-4\">\n        </div>\n      </div>\n\n      <div class=\"row\" style=\"padding-right: 10px;margin-top: 10px\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <div class=\"supplier-note\">\n          <span ng-if=\"!editable && selectedSuppliers.length > 0\">\n            <pre class=\"textBox\" style=\"margin-right: 5px\">{{ noteMessage || \'Enter your note to suppliers...\' }}</pre>\n          </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/supplierNotes/supplier-note.html","<div ng-show=\"!!noteMessage || status.toLowerCase() === \'draft\' || !!editable\">\n<div class=\"ibox-content\">\n  <h3 class=\"text-left-align\">\n    <span>Note to Suppliers</span>\n    <a class=\"pull-right\" ng-if=\"!!editable\">\n      <div ng-dropdown-multiselect=\"\" options=\"suppliersList\" selected-model=\"selectedSuppliers\" extra-settings=\"extraSetting\" translation-texts=\"textSetting\" events=\"noteEvents\">\n      </div>\n    </a>\n  </h3>\n\n  <div class=\"supplier-note\">\n    <span ng-if=\"!!editable && selectedSuppliers.length > 0\">\n      <div editable-textarea=\"noteMessage\" buttons=\"no\" blur=\"submit\" onaftersave=\"submitted(noteMessage)\" e-ng-disabled=\"!selectedSuppliers.length\">\n        <pre class=\"textBox\">{{ noteMessage || \'Enter your note to suppliers...\' }}</pre>\n      </div>\n    </span>\n    <span ng-if=\"!editable && selectedSuppliers.length > 0\">\n      <pre class=\"textBox\">{{ noteMessage || \'Enter your note to suppliers...\' }}</pre>\n    </span>\n  </div>\n</div>\n</div>\n");
$templateCache.put("components/tableHeader/tableHeaderTemplate.html","  <tr>\n    <td ng-if=\"availableHeaders[0].id === \'check box\' && availableHeaders[0].condition[0] === condition\">\n      <input ng-click=\"multiSelectAction({status: multiSelect.checkBox})\" type=\"checkbox\" icheck ng-model=\"multiSelect.checkBox\">\n    </td>\n    <td ng-repeat=\"col in availableHeaders track by $index\" ng-show=\"checkSelectionAndCondition(col)\" ng-click=\"sort(col)\" ng-class=\"{ \'unsortable-column\': !!col.unsortable}\">{{col.label}}\n    <i ng-class=\"{\'fa fa-sort-up\' : (sortedCol === col.id && order === 1),\n    \'fa fa-sort-desc\' : (sortedCol === col.id && order === 0)}\"></i></td>\n  </tr>\n");
$templateCache.put("components/textShowLessMore/textShowLessMoreTemplate.html","<span class=\"text-show-less-more\">\n    <span ng-if=\"is_shown_less\" class=\"pre-wrap\">{{model}}</span>\n    <span ng-if=\"!is_shown_less\" class=\"pre-wrap\">{{updatedModel || model}}</span>\n    <a ng-click=\"$event.stopPropagation(); is_shown_less = !is_shown_less\" ng-show=\"showExpander\" class=\"btn\">\n        {{is_shown_less? \'[Show less]\': \'[Show more]\'}}\n    </a>\n</span>\n");
$templateCache.put("components/tree-selection/tree-selection.template.html","<div ng-show=\"!closeTreeSearch\" class=\"tree-selection mt-15\">\n  <div class=\"row selection-div\">\n    <div class=\"col-md-12\" ng-if=\"!!openingChild || !!openingParent\">\n      <div class=\"parent\">\n        <b ng-if=\"!!openingChild\">Parent: {{currentParrent.unique_name}} {{currentParrent.descr}}</b>\n        <b ng-if=\"!!openingParent\">\n          <a ng-click=\"openChildCC(currentParrent)\">Prev: {{currentParrent.unique_name}} {{currentParrent.descr}}</a>\n        </b>\n        <span class=\"pull-right\">\n          <a ng-click=\"openParent(currentParrent)\">Up</a>\n        </span>\n      </div>\n    </div>\n    <div class=\"col-md-12 list\" ng-if=\"!!commodityCodeList && commodityCodeList.length > 0\">\n      <div class=\"table-responsive\">\n        <table class=\"table table-striped\">\n          <tbody>\n          <tr ng-repeat=\"cc in commodityCodeList track by $index\">\n            <td>\n              <input ng-if=\"!!checkLevel(cc.level)\" type=\"radio\" id=\"cc_{{$index}}_{{randomDate}}\" name=\"ccSelected\" ng-model=\"ccSelected\" ng-click=\"selectCC(cc)\" value=\"{{cc.code}}\">\n            </td>\n            <td ng-if=\"!posting\">\n              <span ng-if=\"!cc.posting\">\n                <i class=\"fa fa-plus-square-o cursor-pointer\" ng-click=\"openChildCC(cc)\"></i>\n              </span>\n            </td>\n            <td>\n              <label for=\"cc_{{$index}}_{{randomDate}}\">{{cc.unique_name}} {{cc.descr}}</label>\n            </td>\n            <td><label for=\"cc_{{$index}}_{{randomDate}}\">{{cc.unique_name}}</label></td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/userAssignment/pendingApprovalList.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Pending Approval Flow</h4>\n  </div>\n\n  <div class=\"ibox-content\">\n    <div class=\"alert alert-danger\">\n      User has pending approval flow. You are not allowed to remove company from the user.\n    </div>\n    <table class=\"table table-striped\">\n      <thead>\n      <tr>\n        <th>Module</th>\n        <th>Reference number</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat=\"approvalFlow in approvalFlows\">\n        <td>{{ approvalFlow.reference_class | excludeMetabuyerModel }}</td>\n        <td>\n          {{ approvalFlow.context.reference || approvalFlow.context.code ||\n          approvalFlow.context.mb_supplier_code || approvalFlow.context.supplier_code }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("components/userAssignment/userAssignmentTemplate.html","<table class=\"table user-assignment table-responsive\">\n  <tr>\n    <th> Company </th>\n    <th> Cost center </th>\n    <th> Roles </th>\n    <th> Position</th>\n    <th> Superior </th>\n    <th> </th>\n  </tr>\n  <tr ng-if=\"!!selectedCompaniesForListing && !!selectedCompaniesForListing.length\">\n    <td colspan=\"6\">\n      <input type=\"text\" class=\"form-control\" ng-model=\"query\" placeholder=\"Filter selected company\" ng-enter=\"false\" ng-keyup=\"updateQuery(query)\">\n    </td>\n  </tr>\n  <tr ng-repeat=\"company in selectedCompanies | filter:{ descr: query }\">\n    <td> <span ng-if=\"company.code !== \'system\'\">{{ company.code }} -</span> {{ company.descr }} </td>\n    <td>\n      <ui-select multiple=\"multiple\" ng-if=\"company.code !== \'system\'\" ng-model=\"company.CCs.selected\" remove-selected=\"false\" sortable=\"true\">\n        <ui-select-match placeholder=\"Select Cost Center...\"> {{$item.descr}} </ui-select-match>\n        <ui-select-choices repeat=\"cc in company.CCs.list | filter: $select.search | orderBy: \'descr\'\">\n          <div title=\"{{ cc.descr }}\" ng-bind-html=\"cc.descr | highlight: $select.search\"></div>\n        </ui-select-choices>\n      </ui-select>\n    </td>\n    <td>\n      <ui-select multiple=\"multiple\" ng-model=\"company.roles.selected\" remove-selected=\"false\" sortable=\"true\">\n        <ui-select-match placeholder=\"Select Roles...\"> {{$item.name}} </ui-select-match>\n        <ui-select-choices repeat=\"role in company.roles.list | filter: $select.search | orderBy: \'name\'\">\n          <div title=\"{{role.name + \' - \' + ((role.company_code) ? role.company_code : \'System\')}}\" ng-bind-html=\"role.name + \' - \' + ((role.company_code) ? role.company_code : \'System\') | highlight: $select.search\">\n          </div>\n        </ui-select-choices>\n      </ui-select>\n    </td>\n    <td>\n      <ui-select multiple=\"multiple\" ng-model=\"company.positions.selected\" remove-selected=\"false\" sortable=\"true\">\n        <ui-select-match placeholder=\"Select Position...\"> {{$item.name}} </ui-select-match>\n        <ui-select-choices repeat=\"position in company.positions.list | filter: $select.search | orderBy: \'name\'\">\n          <div title=\"{{position.name + \' - \' + ((position.company_code) ? position.company_code : \'System\')}}\" ng-bind-html=\"position.name + \' - \' + ((position.company_code) ? position.company_code : \'System\') | highlight: $select.search\">\n          </div>\n        </ui-select-choices>\n      </ui-select>\n    </td>\n    <td>\n      <ui-select ng-if=\"company.code !== \'system\'\" ng-model=\"company.superior.selected\" sortable=\"true\">\n        <ui-select-match placeholder=\"Select Superior...\" allow-clear=\"true\">\n          {{$select.selected.display_name}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"superior in company.superior.list | filter: {display_name: $select.search} | orderBy: \'display_name\'\">\n          <div ng-bind-html=\"superior.display_name | highlight: $select.search\"></div>\n        </ui-select-choices>\n      </ui-select>\n    </td>\n    <td class=\"text-center\">\n      <i class=\"fa fa-trash color-red cursor-pointer\" ng-click=\"checkPendingApproval(company._id, company.code)\">\n      </i>\n    </td>\n  </tr>\n  <tr ng-if=\"!!loading\">\n    <td colspan=\"6\"><i>Loading...</i></td>\n  </tr>\n  <tr>\n    <td colspan=\"6\">\n      <isteven-multi-select input-model=\"companies\" output-model=\"selectedCompaniesForListing\" button-label=\"descr\" item-label=\"descr\" max-labels=\"0\" translation=\"multiselectTranslation\" max-height=\"200px\" helper-elements=\"filter\" on-item-click=\"onSelectCompany(data)\" tick-property=\"ticked\" disable-property=\"disabled\" is-disabled=\"loading\">\n      </isteven-multi-select>\n    </td>\n  </tr>\n</table>\n");
$templateCache.put("components/userDelegation/userDelegationModal.html","<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n  <h3 class=\"modal-title\">Delegation</h3>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"form-horizontal\">\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 col-xs-3 control-label\">\n        Delegatee: <span class=\"asterisk-required\">*</span>\n      </label>\n      <div class=\"col-sm-8 col-xs-8\">\n        <ui-select ng-model=\"select_delegation_user\" on-select=\"onUserSelect(select_delegation_user)\">\n          <ui-select-match placeholder=\"Select a user\">\n            {{$select.selected.display_name}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"user in users | filter: { display_name: $select.search }\">\n            <div ng-bind-html=\"user.display_name + \' - \' + user.email | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 col-xs-3 control-label\">\n        Reason: <span class=\"asterisk-required\">*</span>\n      </label>\n      <div class=\"col-sm-8 col-xs-8\">\n        <textarea ng-model=\"delegation.reason\" class=\"form-control\">\n        </textarea>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 col-xs-3 control-label\">\n        Start Date: <span class=\"asterisk-required\">*</span>\n      </label>\n      <div class=\"col-sm-8 col-xs-8\">\n        <input type=\"input\" ng-click=\"openDatePicker($event, \'start_date\')\" placeholder=\"Delegation start date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"delegation.startDate\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" class=\"form-control\" required>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 col-xs-3 control-label\">\n        End Date: <span class=\"asterisk-required\">*</span>\n      </label>\n      <div class=\"col-sm-8 col-xs-8\">\n        <input type=\"input\" ng-click=\"openDatePicker($event, \'end_date\')\" placeholder=\"Delegation end date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"delegation.endDate\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" class=\"form-control\" required>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"checkToSubmit()\" ng-disabled=\"!selectedUser || !delegation.reason.length ||\n    !delegation.startDate || !delegation.endDate\">\n    Submit\n  </button>\n</div>\n");
$templateCache.put("components/userDelegation/userDelegationTemplate.html","<div class=\"ibox float-e-margins\">\n  <div class=\"ibox-title\">\n    <h5>Delegations</h5>\n    <div class=\"pull-right\">\n      <button class=\"btn btn-xs btn-primary\" ng-show=\"checkSelectedCompany(\'add\')\" ng-click=\"openDelegationModal()\">\n        Add\n      </button>\n      <button ng-show=\"checkSelectedCompany(\'remove\')\" ng-click=\"massRemove()\" class=\"btn btn-xs btn-danger\">\n        Remove\n      </button>\n    </div>\n  </div>\n  <div class=\"ibox-content\">\n    <table class=\"table user-delegation-table\">\n      <thead>\n      <th>\n        <input type=\"checkbox\" icheck ng-click=\"selectAllCompanies(selectAll)\" ng-model=\"selectAll\">\n      </th>\n      <th>Company</th>\n      <th>Delegatee</th>\n      <th>Delegation Reason</th>\n      <th>Delegation Status</th>\n      <th>Start Date</th>\n      <th>End Date</th>\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"user.companies.length > 0\">\n        <td colspan=\"9\">There are no companies for this user.</td>\n      </tr>\n      <tr ng-repeat=\"company in user.companies\" ng-if=\"company.descr !== \'System\'\">\n        <td>\n          <span>\n            <input type=\"checkbox\" icheck ng-model=\"company.selected\">\n          </span>\n        </td>\n        <td>{{ company.descr }}</td>\n        <td>{{ company.delegatee.display_name ? company.delegatee.display_name : \'N/A\' }}</td>\n        <td>{{ company.delegatedReason ? company.delegatedReason : \'N/A\' }}</td>\n        <td>{{ company.delegateStatus ? company.delegateStatus : \'N/A\' }}</td>\n        <td>{{ company.delegateStartDate ? (company.delegateStartDate | date: \'dd MMM yyyy\') : \'N/A\' }}</td>\n        <td>{{ company.delegateEndDate ? (company.delegateEndDate | date: \'dd MMM yyyy\') : \'N/A\' }}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/withdraw/withdrawTemplate.html","<div class=\"inmodal\">\n\n  <div class=\"comment-in-withdraw\">\n\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancelWithdraw()\">x</button>\n      <h3 class=\"modal-title comment-in-withdraw-title\">Withdraw {{ module | capitalize }}</h3>\n    </div>\n\n    <div class=\"modal-body\">\n      <h4 class=\"row form-group\">This {{ module | capitalize }} will be withdrawn</h4>\n      <div class=\"row\">\n        <div class=\"col-xs-1\">\n          <a class=\"pull-left\">\n            <img class=\"comment-in-withdraw-img\" ng-src=\"{{::profile.img_url || \'assets/images/default-user.png\'}}\" image-error=\"assets/images/default-user.png\">\n          </a>\n        </div>\n        <div class=\"col-xs-11\">\n          <div class=\"comment-in-withdraw-body\">\n            <span class=\"comment-in-withdraw-top-arrow\"></span>\n            <span class=\"comment-in-withdraw-bottom-arrow\"></span>\n\n            <textarea class=\"comment-in-withdraw-text\" placeholder=\"Please enter your comment\" ng-model=\"commentText\" rows=\"5\" cols=\"10\"></textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button class=\"comment-in-withdraw-left-button btn btn-danger\" ng-click=\"withdraw()\" id=\"confirmWithdrawPR\">Withdraw</button>\n      <button class=\"comment-in-withdraw-right-button btn btn-default\" ng-click=\"cancelWithdraw()\">Cancel</button>\n    </div>\n\n  </div>\n</div>\n\n");
$templateCache.put("app/approvalFlow/detail/detail.html","<div class=\"container-fluid general-listing gray-bg approval-flow-header mt-30 screen-section\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-10 mb-10 screen-section\">\n    <span class=\"back-buttons\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n    </div>\n    <div class=\"col-md-2 mb-10 screen-section\">\n      <span class=\"pull-right ml-10\">\n          <a ng-click=\"printApprovalFlow()\">\n            <i class=\"fa fa-print\"></i> Print\n          </a>\n      </span>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-10\">\n      <span class=\"title\">\n        <b> {{ approvalTemplate.title }} </b>\n      </span>\n    </div>\n  </div>\n\n  <div class=\"row mt-15 rule-detail\">\n    <div class=\"col-md-4\">\n      <dl class=\"dl-horizontal\">\n        <dt class=\"template-rule\">Code:</dt>\n        <dd class=\"template-rule\">{{ approvalTemplate.code }}</dd>\n\n        <dt class=\"template-rule\"> Module:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.module }}</dd>\n\n        <span ng-if=\"approvalTemplate.module.toLowerCase() === \'pr\' || approvalTemplate.module.toLowerCase() === \'budget\'\">\n          <dt class=\"template-rule\"> Company:</dt>\n          <dd class=\"template-rule\"> {{ approvalTemplate.organization.company.descr }}</dd>\n\n          <dt class=\"template-rule\"> Cost Center:</dt>\n          <dd class=\"template-rule\">\n            {{\n              (!!approvalTemplate.organization.cost_center.descr) ?\n              approvalTemplate.organization.cost_center.descr : approvalTemplate.organization.cost_center\n            }}\n          </dd>\n\n          <dt class=\"template-rule\"> Expense Type:</dt>\n          <dd class=\"template-rule\">\n            {{\n              (!!approvalTemplate.organization.expense_type.descr) ?\n              approvalTemplate.organization.expense_type.descr : approvalTemplate.organization.expense_type\n            }}\n          </dd>\n        </span>\n\n      </dl>\n    </div>\n\n    <div class=\"col-md-8\" id=\"cluster_info\">\n      <dl class=\"dl-horizontal\">\n        <dt class=\"template-rule\"> Effective date:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.effective_date | date:\'dd MMM yyyy\'}}</dd>\n\n        <dt class=\"template-rule\"> Created by:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.created_by }}</dd>\n\n        <dt class=\"template-rule\"> Created at:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.created_at | date:\'dd MMM yyyy HH:mm:ss\'}}</dd>\n\n        <dt class=\"template-rule\"> Updated by:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.updated_by }}</dd>\n\n        <dt class=\"template-rule\"> Updated at:</dt>\n        <dd class=\"template-rule\"> {{ approvalTemplate.updated_at | date:\'dd MMM yyyy HH:mm:ss\'}}</dd>\n      </dl>\n    </div>\n\n    <div class=\"col-md-12\">\n      <dl class=\"dl-horizontal\">\n        <dt class=\"template-rule\"> Status:</dt>\n        <dd class=\"template-rule\">\n          <span class=\"label\" ng-class=\"{\n              \'label-primary\' : approvalTemplate.status === 0,\n              \'label-default\' : approvalTemplate.status === 1\n            }\">\n            {{ approvalTemplate.status === 0 ? \'Active\' : \'Inactive\' }}\n          </span>\n        </dd>\n      </dl>\n    </div>\n\n    <div class=\"col-md-12 row\">\n      <div class=\"col-md-2\">\n        <div class=\"form-group\">\n          <!--expense type-->\n          <b>Filter by expense type</b>\n          <ui-select ng-model=\"uiExpense.list\" ng-disabled=\"approvalTemplate.module.toLowerCase() !== \'pr\'\" on-select=\"filterAvailableApprovals()\" close-on-select=\"true\">\n            <ui-select-match placeholder=\"expense type...\">\n              {{$select.selected}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"option in expenseTypeListing | filter: $select.search\">\n              <div ng-bind-html=\"option\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n      <div class=\"col-md-2\">\n        <div class=\"form-group\">\n          <!--cost center-->\n          <b>Filter by cost center</b> <br>\n          <ui-select ng-model=\"uiCostCenter.list\" ng-disabled=\"approvalTemplate.module.toLowerCase() !== \'pr\'\" on-select=\"filterAvailableApprovals()\" close-on-select=\"true\">\n            <ui-select-match placeholder=\"cost center...\">\n              {{$select.selected}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"option in costCenterListing | filter: $select.search\">\n              <div ng-bind-html=\"option\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n      <div class=\"col-md-2\">\n        <div class=\"form-group\">\n          <!--Status-->\n          <b>Filter by status</b>\n          <ui-select ng-model=\"uiStatus.list\" on-select=\"filterAvailableApprovals()\" close-on-select=\"true\">\n            <ui-select-match placeholder=\"status...\">\n              {{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"option in templateStatus | filter: $select.search\">\n              <div ng-bind-html=\"option.descr\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n      <div class=\"col-md-1\">\n        <br>\n        <button class=\"btn btn-primary pull-left ng-click-active\" ng-click=\"clearSearch()\">\n          Clear\n        </button>\n      </div>\n    </div>\n\n    <div class=\"col-md-3\">\n      <div class=\"form-group\">\n        <b>Related templates:</b>\n        <!--other templates-->\n        <ui-select ng-model=\"uiTemplate.list\" on-select=\"processCostCenterList()\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"template...\">{{$select.selected.title}}</ui-select-match>\n          <ui-select-choices repeat=\"item in templateListing | filter: {title: $select.search}\">\n            <div ng-bind-html=\"item.title | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-md-1\">\n      <br>\n      <button class=\"btn btn-primary pull-left ng-click-active\" ng-click=\"navigateTemplate()\">\n        Show\n      </button>\n    </div>\n  </div>\n\n  <div class=\"col-md-12 approval-flow-management mb-10\">\n\n    <div class=\"row\">\n      <div class=\"approval-flow-main\">\n        <div class=\"approval-flow-step no-dashed\" ng-repeat=\"step in approvalTemplate.steps track by $index\">\n          <div>\n            <div ng-class=\"{\n              \'bg-primary\': !!checkStep(step),\n              \'bg-red\': !checkStep(step)\n            }\" class=\"circle bg-primary center\">\n              {{ step.seq }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"approval-flow-main\">\n        <!-- Approval Flow Step -->\n        <div class=\"approval-flow-step\" ng-repeat=\"step in approvalTemplate.steps track by $index\">\n          <div class=\"min text-center\">\n            <div class=\"col-md-2 min-text\">Min: </div>\n            <div class=\"col-md-9\">\n              <div class=\"bg-color-lightgrey min-text\">{{ step.min_approver }}</div>\n            </div>\n          </div>\n\n          <div class=\"row box-padding\">\n            <div ng-repeat=\"stepPosition in step.step_positions track by $index\">\n              <div uib-tooltip-html=\"getPosition(stepPosition.position_assignments)\" class=\"approval-position\" ng-class=\"{\n                \'green-border\': !!checkStepPosition(stepPosition),\n                \'red-border\': !checkStepPosition(stepPosition),\n              }\">\n                <div class=\"approval-title bg-color-lightgrey\" ng-class=\"{\n                  \'red-text\': !checkStepPosition(stepPosition)\n                }\">\n                  {{ stepPosition.position.name }}\n                  <span ng-if=\"stepPosition.organization === \'all\'\">\n                    - system\n                  </span>\n                </div>\n                <div class=\"approval-content\">\n                  <!-- User list in Role -->\n                  <div class=\"position-users\">\n                    <div ng-repeat=\"assignment in stepPosition.position_assignments\">\n                      <div ng-repeat=\"user in assignment.active_users\">\n                        {{ user.assignee_name }}\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n                <div class=\"approval-content top-border\">\n                  <h4><a>Rule(s)</a></h4>\n\n                  <!-- rules List -->\n                  <div class=\"position-users\">\n                    <ul ng-repeat=\"rule in stepPosition.step_rules track by $index\">\n                      <!-- Using \'==\' because the data type is changing after edit  -->\n                      <li ng-if=\"rule.name === \'always\'\">{{ rule.name }} </li>\n                      <li ng-if=\"rule.name !== \'always\'\">\n                        {{ rule.name }} {{ rule.pivot.operator }} {{ rule.pivot.value }}\n                      </li>\n                    </ul>\n                  </div>\n\n                </div>\n              </div>\n\n              <hr>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n\n  <!--Audit History-->\n  <div class=\"row m-t-xs m-b-xs\">\n    <div class=\"col-md-12 mb-10\">\n      <export-array-to-csv array-data=\"arrayData\" file-name=\"fileName\" trigger=\"triggerHistoryExport\">\n      </export-array-to-csv>\n      <button class=\"btn btn-primary pull-left btn-xs ng-click-active\" ng-click=\"exportCSV()\">\n        Export Log\n      </button>\n    </div>\n    <div class=\"col-md-12\">\n      <b>Change Log :</b>\n      <approval-engine-pagination callback-search=\"getTemplateHistory(page)\" start-rec-no=\"meta[\'startRecNo\']\" end-rec-no=\"meta[\'endRecNo\']\" total-rec=\"meta[\'totalRec\']\" total-page-number=\"meta[\'totalPageNumber\']\" current-page-number=\"meta[\'currentPageNumber\']\">\n      </approval-engine-pagination>\n    </div>\n  </div>\n\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <div class=\"col-md-12\">\n      <table class=\"table\" ng-class=\"{\'table-hover\' : approvalHistoryData.length > 1}\">\n        <thead class=\"bg-color-lightgrey\">\n        <tr>\n          <th>Seq</th>\n          <th>Username</th>\n          <th>Action</th>\n          <th>Date</th>\n          <th>Changes</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"approvalHistoryData.length > 0\">\n          <td colspan=\"9\">There are no records for now.</td>\n        </tr>\n        <tr ng-repeat=\"data in approvalHistoryData track by $index\">\n          <td>{{$index+1+(10*meta.currentPageNumber)}}</td>\n          <td>{{ data.user.display_name }}</td>\n          <td>{{ data.event }}</td>\n          <td>{{ returnDate(data.created_at) | date:\'dd MMM yyyy HH:mm:ss\' }}</td>\n          <td>\n            <div ng-if=\"data.event !== \'created\'\">\n              <div ng-if=\"!!data.new_values.module\">module : {{ data.new_values.module }} <br></div>\n              <div ng-if=\"!!data.new_values.company\">company : {{ data.new_values.company }} <br></div>\n              <div ng-if=\"!!data.new_values.title\">title : {{ data.new_values.title }} <br></div>\n              <div ng-if=\"!!data.new_values.code\">code : {{ data.new_values.code }} <br></div>\n              <div ng-if=\"!!data.new_values.status\">\n                status : {{ getStatus(data.new_values.status) }} <br>\n              </div>\n              <div ng-if=\"!!data.new_values.effective_date\">\n                effective date : {{ data.new_values.effective_date }} <br>\n              </div>\n              <div ng-if=\"!!data.new_values.cost_center\">cost center : {{ data.new_values.cost_center }} <br></div>\n              <div ng-if=\"!!data.new_values.expense_type\">expense type : {{ data.new_values.expense_type }} <br></div>\n\n              <div ng-repeat=\"stepValue in data.new_values.steps track by $index\">\n                step : {{ stepValue.seq }}\n                <span ng-if=\"stepValue.changes === \'removed\' || stepValue.changes === \'added\'\"><b> {{ stepValue.changes }}</b></span>\n                <span ng-if=\"stepValue.changes === \'\'\"> <b> no changes </b> </span>\n                <br>\n                <div ng-if=\"!!stepValue.min_approver\">min approver : {{ stepValue.min_approver }} <br></div>\n                <div ng-repeat=\"positionValue in stepValue.positions track by $index\">\n                  <div ng-if=\"!!positionValue.changes && positionValue.changes !== \'\'\">\n                    &nbsp; position : {{ positionValue.position_code }}\n                    <span ng-if=\"!!positionValue.changes && (positionValue.changes === \'removed\' || positionValue.changes === \'added\')\">\n                      &nbsp; <b>{{ positionValue.changes }}</b> <br>\n                    </span>\n                    <div ng-repeat=\"ruleValue in positionValue.rules track by $index\">\n                      <div ng-if=\"!!ruleValue.value\">\n                        &nbsp; &nbsp; rule {{$index + 1}} : {{ ruleValue.name }} {{ ruleValue.operator }} {{ ruleValue.value}} <br>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<div class=\"row print-section\">\n  <!--title for print-->\n  <div class=\"col-md-12 mb-10\">\n    <div><h2><b>Approval Template</b></h2></div>\n    <div>\n      <h3>Title: <b> {{ approvalTemplate.title }} </b></h3>\n    </div>\n  </div>\n\n  <!--template details for print-->\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Code</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.code }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Module</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.module }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Company</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.organization.company.descr }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Cost Center</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{\n      (!!approvalTemplate.organization.cost_center.descr) ?\n      approvalTemplate.organization.cost_center.descr : approvalTemplate.organization.cost_center\n      }}\n    </b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Expense Type</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.organization.expense_type.descr }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Effective Date</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.effective_date | date:\'dd MMM yyyy\'}}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Created by</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.created_by }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Created at</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.created_at | date:\'dd MMM yyyy HH:mm:ss\' }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Updated by</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.updated_by }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Updated at</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.updated_at | date:\'dd MMM yyyy HH:mm:ss\' }}</b>\n  </div>\n  <div class=\"col-xs-3 col-md-2\">\n    <b>Status</b>\n  </div>\n  <div class=\"col-xs-9 col-md-10\">\n    <b>: {{ approvalTemplate.status === 0 ? \'Active\' : \'Inactive\' }} </b>\n  </div>\n\n  <div>&nbsp;</div>\n\n  <!--approval flow for print-->\n  <div class=\"col-md-12 mt-30\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th class=\"text-center\">Step</th>\n        <th class=\"text-center\">Position</th>\n        <th class=\"text-center\">Min</th>\n        <th class=\"text-center\">User</th>\n        <th class=\"text-center\">Rules</th>\n      </tr>\n      </thead>\n      <tbody ng-repeat=\"step in approvalTemplate.steps track by $index\" ng-init=\"printIndex = $index\">\n      <tr ng-repeat=\"stepPosition in step.step_positions track by $index\">\n        <td class=\"text-center\">{{ printIndex + 1 }}</td>\n        <td class=\"text-center\">\n          <div class=\"approval-title bg-color-lightgrey\" ng-class=\"{\'red-text\': !checkStepPosition(stepPosition)}\">\n            {{ stepPosition.position.name }}\n            <span ng-if=\"stepPosition.organization === \'all\'\">\n              - system\n            </span>\n          </div>\n        </td>\n        <td>\n          <div class=\"text-center\">{{ step.min_approver }}</div>\n        </td>\n        <td>\n          <div ng-repeat=\"assignment in stepPosition.position_assignments\">\n            <div ng-repeat=\"user in assignment.active_users\">{{ user.assignee_name }}</div>\n          </div>\n        </td>\n        <td>\n          <!-- rules List -->\n          <div class=\"position-users\">\n            <ul ng-repeat=\"rule in stepPosition.step_rules track by $index\">\n              <li ng-if=\"rule.name !== \'always\'\">\n                {{ rule.name }} {{ rule.pivot.operator }} {{ rule.pivot.value }}\n              </li>\n            </ul>\n          </div>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/approvalFlow/manage/export.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Export Approval Template</h4>\n  </div>\n\n  <form name=\"positionUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n          <div class=\"form-horizontal\">\n\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Type</label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <ui-select ng-model=\"template.type\" required>\n                  <ui-select-match placeholder=\"Select type...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"type in templateTypes | filter: $select.search\">\n                    <span ng-bind-html=\"type.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"template.type.code === \'PR\' || template.type.code === \'Budget\'\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Company</label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <ui-select ng-model=\"template.company\" required>\n                  <ui-select-match placeholder=\"Select company...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"company in companies | filter: {descr: $select.search}\">\n                    <span ng-bind-html=\"company.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"col-md-12 text-right\">\n                <input type=\"checkbox\" id=\"only-active\" ng-model=\"template.onlyActive\">\n                <label for=\"only-active\">Only active approval flow</label>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"exportTemplate(selectedCompany)\">\n        Export\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/approvalFlow/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-15\">\n  <div class=\"row\">\n    <div class=\"col-md-7 no-padding\">\n      <h3>Displaying Approval Flow Templates List</h3>\n    </div>\n\n    <div class=\"col-md-5 no-padding\">\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs ng-click-active\" ng-disabled=\"disableExportButton\" ng-click=\"exportTemplate()\">\n        Export Approval Template\n      </button>\n\n      <generic-import module-name=\"Approval Template\" params=\"importParams\">\n      </generic-import>\n    </div>\n  </div>\n\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--type-->\n        <b>Type</b> <br>\n        <ui-select class=\"mr-15\" ng-model=\"uiType.list\" close-on-select=\"true\" on-select=\"checkTemplateType()\">\n          <ui-select-match placeholder=\"Select a type ...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"types in templateTypes | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(types.descr | highlight: $select.search)\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--Code-->\n        <b>Code</b> <br>\n        <div class=\"form-group mr-15\">\n          <input type=\"text\" ng-model=\"uiCode\" class=\"form-control\" placeholder=\"Enter code\">\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--Title-->\n        <b>Title</b> <br>\n        <div class=\"form-group mr-15\">\n          <input type=\"text\" ng-model=\"uiTitle\" class=\"form-control\" placeholder=\"Enter title\">\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <b>Status</b><br>\n        <!--status-->\n        <ui-select class=\"mr-15\" ng-model=\"status.list\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a status ...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"status in statusListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(status.descr | highlight: $select.search)\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n  </div>\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--company-->\n        <b>Company</b>\n        <ui-select class=\"mr-15\" ng-model=\"uiCompanySelect.list\" on-select=\"processCostCenterList()\" close-on-select=\"true\" ng-disabled=\"uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\'\">\n          <ui-select-match placeholder=\"Select a company\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"companyItem in companyListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"companyItem.descr | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--cost center-->\n        <b>Cost Center</b> <br>\n        <ui-select class=\"mr-15\" ng-model=\"uiCostCenterSelect.list\" close-on-select=\"true\" ng-disabled=\"!uiCompanySelect.list.code\">\n          <ui-select-match placeholder=\"Select a cost center...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"costCenterItem in costCenterListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(costCenterItem.descr | highlight: $select.search) + \' [\' + costCenterItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--expense type-->\n        <b>Expense Type</b>\n        <ui-select class=\"mr-15\" ng-model=\"uiExpenseSelect.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"!uiCompanySelect.list.code\">\n          <ui-select-match placeholder=\"Select an expense type...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"expenseItem in expenseTypesListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(expenseItem.descr | highlight: $select.search) + \' [\' + expenseItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\" style=\"vertical-align: bottom\">\n      <br>\n      <button class=\"btn btn-primary pull-left ng-click-active\" ng-click=\"resetSelection()\">\n        Reset\n      </button>\n      <button class=\"btn btn-primary pull-left ng-click-active ml-10\" ng-click=\"search(0)\">\n        Search\n      </button>\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <br>\n      <approval-engine-pagination callback-search=\"search(page)\" start-rec-no=\"meta.startRecNo\" end-rec-no=\"meta.endRecNo\" total-rec=\"meta.totalRec\" total-page-number=\"meta.totalPageNumber\" current-page-number=\"meta.currentPageNumber\">\n      </approval-engine-pagination>\n    </div>\n  </div>\n\n\n\n\n  <div class=\"container-fluid\">\n    <div class=\"row m-t-xs m-b-xs\">\n      <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\" search-function=\"search(page,sortingCol,sortingOrder)\" is-approval-engine=\"true\" current-status=\"currentStatus\"></thead>\n\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no records for now.</td>\n        </tr>\n\n        <tr ng-repeat=\"approval in dataList track by $index\" fadeout-row=\"approval.id == highlightId\">\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\">\n            {{ $index + 1 + (limit * meta.currentPageNumber) }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'type\')\">\n            {{ approval.module }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'code\')\">\n            {{ approval.code }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'title\')\">\n            {{ approval.title }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'company\')\">\n            {{ (!!approval.organization.company) ? approval.organization.company.descr : \'\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'cost_center\')\">\n            {{ (!!approval.organization.cost_center) ?\n            (approval.organization.cost_center === \'all\') ? \'all\' : approval.organization.cost_center.descr : \'\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'expense_type\')\">\n            {{ (!!approval.organization.expense_type) ?\n            (approval.organization.expense_type === \'all\') ? \'all\' : approval.organization.expense_type.descr : \'\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'effective_at\')\">\n            {{ approval.effective_date | date:\'dd MMM yyyy\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'created_at\')\">\n            {{ approval.created_at | date:\'dd MMM yyyy HH:mm:ss\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'updated_at\')\">\n            {{ approval.updated_at | date:\'dd MMM yyyy HH:mm:ss\' }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'created_by\')\">\n            {{ approval.created_by }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'updated_by\')\">\n            {{ approval.updated_by }}\n          </td>\n\n          <td ui-sref=\"main.user.approvalFlow.detail({id: approval.id})\" ng-show=\"visibleColumn(\'status\')\">\n            {{ approval.status }}\n          </td>\n\n          <!--<td ng-click=\"removeTemplate(approval)\" class=\"text-center\">-->\n            <!--<i class=\"fa fa-remove red-text\"></i>-->\n          <!--</td>-->\n        </tr>\n\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/approvalFlow/preview/detail.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-15\">\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--type-->\n        <b>Type</b><span class=\"asterisk-required\">*</span><br>\n        <ui-select class=\"mr-15\" ng-model=\"uiType.list\" on-select=\"resetSelection(false, false)\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a type ...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"types in templateTypes | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(types.descr | highlight: $select.search)\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--company-->\n        <b>Company</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && (uiType.list.code === \'PR\' || uiType.list.code === \'Budget\'))\">*</span><br>\n        <ui-select ng-model=\"uiCompany.list\" on-select=\"processCostCenterList()\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"(!!uiType.list.code && uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\')\">\n          <ui-select-match placeholder=\"Select a company\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"companyItem in companyListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"companyItem.descr | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--cost center-->\n        <b>Cost Center</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && (uiType.list.code === \'PR\' || uiType.list.code === \'Budget\'))\">*</span><br>\n        <ui-select ng-model=\"uiCostCenter.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"(!uiCompany.list.code) || (!!uiType.list.code && uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\')\">\n          <ui-select-match placeholder=\"Select a cost center...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"costCenterItem in costCenterListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(costCenterItem.descr | highlight: $select.search) + \' [\' + costCenterItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--expense type-->\n        <b>Expense Type</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && (uiType.list.code === \'PR\' || uiType.list.code === \'Budget\'))\">*</span><br>\n        <ui-select ng-model=\"uiExpense.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"(!uiCompany.list.code) || (!!uiType.list.code && uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\')\">\n          <ui-select-match placeholder=\"Select an expense type...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"expenseItem in expenseTypesListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(expenseItem.descr | highlight: $select.search) + \' [\' + expenseItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--total amount-->\n        <b>Total Amount</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && (uiType.list.code === \'PR\' || uiType.list.code === \'Budget\'))\">*</span><br>\n        <div class=\"form-group mr-15\">\n          <input type=\"number\" step=\"0.01\" ng-model=\"uiAmount\" class=\"form-control\" placeholder=\"\" ng-disabled=\"(!!uiType.list.code && uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\')\">\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--Item Type-->\n        <b>Item Type</b> <br>\n        <ui-select class=\"ui-select-match-item-position-assign\" on-select=\"selectCompany(\'assign\')\" on-remove=\"selectCompany(\'unassign\')\" multiple=\"multiple\" sortable=\"true\" close-on-select=\"true\" ng-model=\"uiItemType.list\" ng-disabled=\"(!!uiType.list.code && uiType.list.code !== \'PR\')\">\n          <ui-select-match placeholder=\"Select item type ...\">{{$item.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"itemType in itemTypeListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"itemType.descr | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--currency-->\n        <b>Currency</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && (uiType.list.code === \'PR\' || uiType.list.code === \'Budget\'))\">*</span><br>\n        <ui-select ng-model=\"uiCurrency.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"(!uiCompany.list.code) || (!!uiType.list.code && uiType.list.code !== \'PR\' && uiType.list.code !== \'Budget\')\">\n          <ui-select-match placeholder=\"Select a currency...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"currencyItem in currencyListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(currencyItem.descr | highlight: $select.search) + \' [\' + currencyItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\" style=\"vertical-align: bottom\">\n      <div class=\"form-group\">\n        <!--catalog-->\n        <b>Contains</b>\n        <span class=\"asterisk-required\" ng-show=\"(!!uiType.list.code && uiType.list.code === \'PR\')\">*</span><br>\n        <ui-select ng-model=\"uiCatalog.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"(!!uiType.list.code && uiType.list.code !== \'PR\')\">\n          <ui-select-match placeholder=\"Select an option...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"catalogItem in catalogListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(catalogItem.descr | highlight: $select.search)\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <button class=\"btn btn-primary pull-right ng-click-active ml-15\" ng-click=\"preview()\">\n        Preview\n      </button>\n      <button class=\"btn btn-primary pull-right ng-click-active\" ng-click=\"resetSelection(true, true)\">\n        Reset\n      </button>\n    </div>\n  </div>\n\n  <div id=\"approval_div\">\n    <approval-flow class=\"mt-10\" id=\"approval_id\" data=\"approvals\" requestor=\"admin\" preparer=\"admin\" pr=\"\">\n    </approval-flow>\n  </div>\n  <div id=\"previewImage\">\n  </div>\n\n</div>\n");
$templateCache.put("app/budgetManagement/details/details.html","<div class=\"wrapper wrapper-content animated fadeInRight\" xmlns=\"http://www.w3.org/1999/html\">\n  <div id=\"fixHeaderViewWidth\" class=\"row screen-section budget\">\n    <div class=\"fixHeaderSupplier\" id=\"fixHeaderDirective\" fix-header height=\"true\" width=\"true\" top=\"true\">\n      <!--#region Budget actions section-->\n      <budget-actions data=\"budget\" assignments=\"budgetAssignments\" is-creator=\"isCreator()\" header-details-error=\"headerDetailsError\" budget-assignment-details-error=\"budgetAssignmentDetailsError\" budget-item-details-error=\"budgetItemDetailsError\" approval-flow-data=\"approvalFlowData\">\n      </budget-actions>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Header section-->\n    <div class=\"modal-body\">\n      <budget-details-header>\n      </budget-details-header>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Budget Assignment-->\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-6 switch\">\n          <div class=\"col-sm-1 col-xs-1\">\n            <div class=\"onoffswitch\" ng-class=\"{\n            \'onoffswitch-disabled\': !!budgetItemBreakdownSwitch || !getAssignmentRemovableState() || getEditingBudgetState() === \'notEditable\'\n            }\">\n              <input id=\"budgetAssignment\" type=\"checkbox\" class=\"onoffswitch-checkbox\" ng-model=\"budgetAssignSwitch\" ng-change=\"toggleSwitch(budgetAssignSwitch, \'assignment\')\" ng-disabled=\"!!budgetItemBreakdownSwitch || !getAssignmentRemovableState() || getEditingBudgetState() === \'notEditable\'\">\n              <label class=\"onoffswitch-label mt-5\" for=\"budgetAssignment\">\n                <span class=\"onoffswitch-inner\"></span>\n                <span class=\"onoffswitch-switch\"></span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-11 col-xs-11\">\n            <span class=\"section-text ml-10\">Budget Assignment </span>\n          </div>\n        </div>\n        <div class=\"col-md-6\">\n        </div>\n      </div>\n\n      <div class=\"row\" ng-show=\"!!budgetAssignSwitch\">\n        <div class=\"col-md-12\">\n          <budget-assignments budget-data=\"budget\" budget-assignment-details-error=\"budgetAssignmentDetailsError\" budget-item-details-error=\"budgetItemDetailsError\" editing-mode=\"getEditingBudgetState()\" cost-center-list=\"costCenterList\" expense-type-list=\"expenseTypeList\" apportion-list=\"apportionList\">\n          </budget-assignments>\n        </div>\n      </div>\n\n    </div>\n    <!--#endregion-->\n\n    <!--#region Item breakdown-->\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-6 switch\">\n          <div class=\"col-sm-1 col-xs-1\">\n            <div class=\"onoffswitch\" ng-class=\"{\'onoffswitch-disabled\': !!budgetAssignSwitch || !budget.cost_center ||\n                                              getEditingBudgetState() === \'notEditable\' || getItemBreakdownRemovableState()}\">\n              <input id=\"itemBreakdown\" type=\"checkbox\" class=\"onoffswitch-checkbox\" ng-model=\"budgetItemBreakdownSwitch\" ng-change=\"toggleSwitch(budgetItemBreakdownSwitch, \'itembreakdown\')\" ng-disabled=\"!!budgetAssignSwitch || !budget.cost_center ||\n                getEditingBudgetState() === \'notEditable\' || getItemBreakdownRemovableState()\">\n              <label class=\"onoffswitch-label mt-5\" for=\"itemBreakdown\">\n                <span class=\"onoffswitch-inner\"></span>\n                <span class=\"onoffswitch-switch\"></span>\n              </label>\n            </div>\n          </div>\n          <div class=\"col-sm-11 col-xs-11\">\n            <span class=\"section-text ml-10\">Item Breakdowns </span>\n          </div>\n        </div>\n        <div class=\"col-md-6\">\n        </div>\n      </div>\n\n      <div class=\"row\" ng-show=\"!!budgetItemBreakdownSwitch\">\n        <div class=\"col-md-12\">\n          <item-breakdowns budget-data=\"budget\" budget-master=\"budget\" budget-item-details-error=\"budgetItemDetailsError\" editing-mode=\"getEditingBudgetState()\" apportion-list=\"apportionList\">\n          </item-breakdowns>\n        </div>\n      </div>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Comments and history-->\n    <div class=\"modal-body\">\n      <div class=\"row screen-section\">\n        <comments-panel comments-object=\"budget\" comments-module=\"Budget\" comments-service=\"commentService\" contact-options=\"budget.approval_related_users\" delete-service=\"deleteService\">\n        </comments-panel>\n      </div>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Budget Master Attachments-->\n    <div class=\"modal-body\">\n      <div class=\"row screen-section\">\n        <attachments-block disable-edit=\"false\" class=\"screen-section\" files=\"budgetAttachments\" single-attachment-service=\"singleAttachmentService\" attachment-param=\"attachmentParam\" attachment-url=\"attachmentUrl\" attachment-model=\"Budget\" hide-is-visible-to-supplier=\"true\">\n        </attachments-block>\n      </div>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Approval flow-->\n    <div class=\"modal-body\">\n      <div class=\"row screen-section\">\n        <approval-flow class=\"screen-section\" id=\"approval_id\" data=\"approvalFlowData\" pr=\"budget\" preview=\"approvalsPreview()\" context=\"budget\" requestor=\"requestor\">\n        </approval-flow>\n      </div>\n    </div>\n    <!--#endregion-->\n\n  </div>\n</div>\n");
$templateCache.put("app/budgetManagement/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row mt-10\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left mr-5\">Displaying {{ status }} budgets</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <multi-approval-action class=\"pull-right\" ng-if=\"status === \'pending\' && getSelectedBudgets().length > 0\" get-selected-items=\"getSelectedBudgets()\" show-on-hold=\"true\" type=\"Budget(s)\">\n      </multi-approval-action>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"budgetManagementService\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 0}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\" multi-select-action=\"multiSelectPendingItems(status)\">\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There are no budgets at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" fadeout-row=\"data._id == highlightId\" ng-click=\"viewBudgetDetail(data)\" ng-class=\"{\'row-select\': item.selected}\">\n        <td ng-if=\"status === \'pending\'\">\n          <span ng-show=\"::(checkWaitingOnUser(data))\">\n            <input type=\"checkbox\" icheck ng-model=\"data.selected\">\n          </span>\n        </td>\n        <td ng-if=\"showColumn(\'code\')\">\n          {{ data.code || \'N/A\' }}\n        </td>\n        <td ng-if=\"showColumn(\'descr\')\">\n          {{ data.descr || \'N/A\' }}\n        </td>\n        <td ng-if=\"showColumn(\'company|descr\')\">\n          {{ data.company.descr || \'N/A\' }}\n        </td>\n        <td ng-if=\"showColumn(\'cost_center|descr\')\">\n          <span ng-repeat=\"cc in data.cost_center\">\n            {{cc.descr}}{{$last ? \'\' : \', \'}}\n          </span>\n        </td>\n        <td ng-if=\"showColumn(\'status\')\">\n        {{ (data.status || \'N/A\') | capitalize }}\n        </td>\n        <td ng-if=\"showColumn(\'progress\')\">\n          <pie-chart data=\"[data.progress, 100 - data.progress]\" options=\"peiChart.options\">\n          </pie-chart>\n          <span>\n            {{ \' \' + (!data.progress ? 0 : (data.progress | formatDecimal: 2)) + \'%\' }}\n          </span>\n        </td>\n        <td ng-if=\"showColumn(\'start_date\')\">\n          {{ (data.start_date || \'N/A\') | date: \'dd MMM yyyy\' }}\n        </td>\n        <td ng-if=\"showColumn(\'end_date\')\">\n          {{ (data.end_date || \'N/A\') | date: \'dd MMM yyyy\' }}\n        </td>\n        <td ng-if=\"showColumn(\'amount\')\">\n          {{ (data.amount || 0) | formatDecimal: 2 }}\n        </td>\n        <td ng-if=\"showColumn(\'used_amount\')\">\n          {{ (data.used_amount || 0) | formatDecimal: 2 }}\n        </td>\n        <td ng-if=\"showColumn(\'committed_amount\')\">\n          {{ (data.committed_amount || 0) | formatDecimal: 2 }}\n        </td>\n        <td ng-if=\"showColumn(\'block_amount\')\">\n          {{ (data.block_amount || 0) | formatDecimal: 2 }}\n        </td>\n        <td ng-if=\"showColumn(\'available_balance\')\">\n          {{ (data.available_balance || 0) | formatDecimal: 2 }}\n        </td>\n        <td ng-if=\"showColumn(\'created_at\')\">\n          {{ (data.created_at || \'N/A\') | date: \'dd MMM yyyy\' }}\n        </td>\n        <td ng-if=\"showColumn(\'creator.display_name\')\">\n          {{ data.creator[0].display_name || \'N/A\' }}\n        </td>\n        <td ng-if=\"showColumn(\'updated_at\')\">\n          {{ (data.updated_at || \'N/A\') | date: \'dd MMM yyyy\' }}\n        </td>\n        <td ng-if=\"showColumn(\'updater.display_name\')\">\n          {{ data.updater[0].display_name || \'N/A\' }}\n        </td>\n        <td ng-if=\"showColumn(\'delete_button\')\" ng-click=\"$event.stopImmediatePropagation()\">\n          <a ng-click=\"deleteBudget(data._id)\" ng-show=\" !!canDelete(data.created_by._id, data.status)\" class=\"btn btn-primary btn-xs\">\n            Delete\n          </a>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/catalogView/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Catalog Items</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"catalogItemsManageService\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There is no available catalog items at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" ng-class=\"{\'row-select\': item.selected}\" ng-click=\"viewCatalogItemDetails(data)\">\n        <td ng-if=\"showColumn(\'item_name\')\">\n          {{data.item_name}}\n        </td>\n        <td ng-if=\"showColumn(\'description\')\">\n          {{data.description}}\n        </td>\n        <td ng-if=\"showColumn(\'commodity_code\')\">\n          {{data.commodity_code}}\n        </td>\n        <td ng-if=\"showColumn(\'commodity_descr\')\">\n          {{data.commodity_descr}}\n        </td>\n        <td ng-if=\"showColumn(\'supplier.descr\')\">\n          {{data.supplier[0].descr}}\n        </td>\n        <td ng-if=\"showColumn(\'supplier_part_no\')\">\n          {{data.supplier_part_no}}\n        </td>\n        <td ng-if=\"showColumn(\'tax.rate\')\">\n          {{data.tax[0].code}} {{data.tax[0].rate}}\n        </td>\n        <td ng-if=\"showColumn(\'payment_term.descr\')\">\n          {{data.payment_term[0].descr}}\n        </td>\n        <td ng-if=\"showColumn(\'currency.code\')\">\n          {{data.currency[0].code}}\n        </td>\n        <td ng-if=\"showColumn(\'unit_price\')\">\n          {{data.unit_price | formatDecimal: 4}}\n        </td>\n        <td ng-if=\"showColumn(\'Uom.code\')\">\n          {{data.Uom[0].code}}\n        </td>\n        <td ng-if=\"showColumn(\'effective_at\')\">\n          {{data.effective_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-if=\"showColumn(\'expiry_at\')\">\n          {{data.expiry_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/emailLogs/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Email Logs</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There is no available email at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" class=\"cursor-auto\">\n        <td ng-if=\"showColumn(\'receiver_email\')\">\n          {{data.receiver_email}}\n        </td>\n        <td ng-if=\"showColumn(\'subject\')\">\n          {{data.subject}}\n        </td>\n        <td ng-if=\"showColumn(\'created_at\')\">\n          {{data.created_at | date: \'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-if=\"showColumn(\'updated_at\')\">\n          {{data.updated_at | date: \'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-if=\"showColumn(\'status\')\">\n          <span ng-class=\"{\'label label-warning\': data.status === \'BOUNCED\',\n           \'label label-primary\' : data.status === \'SENT\',\n           \'label label-danger\' : data.status === \'FAILED\'}\">\n            {{data.status}} </span>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/exportsListing/logs/logs.html","<div class=\"ibox-content\">\n  <div class=\"row\">\n    <div class=\"col-sm-2\"></div>\n    <label class=\"col-sm-2 control-label\">\n      Export Module\n    </label>\n    <div class=\"col-sm-4 m-b\">\n      <ui-select ng-model=\"exports.selectedModule\" on-select=\"onSelectedExportModule(exports.selectedModule)\">\n        <ui-select-match placeholder=\"Select module...\">\n          {{$select.selected.descr}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"em in exportModules | filter: $select.search\">\n          <span ng-bind-html=\"em.descr | highlight: $select.search\"></span>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n\n  <div ng-if=\"!!selectedExportType\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\">\n        Displaying Export Log for {{selectedTitle}}\n      </h3>\n    </div>\n\n    <embedded-pagination-service list=\"logs\" service=\"exportService\" offset=\"10\" params-source=\"embeddedParams\" meta=\"meta\">\n    </embedded-pagination-service>\n\n    <div class=\"row\">\n      <div class=\"col-md-12 table-responsive\">\n        <table class=\"table\" st-table=\"logs\" ng-class=\"{\'table-hover\' : logs.length > 1}\">\n          <thead>\n          <tr>\n            <td class=\"cursor-default\">Requestor</td>\n            <td class=\"cursor-default\">Date Generated</td>\n            <td class=\"cursor-default\">Done At</td>\n            <td class=\"cursor-default\">Status</td>\n            <td>Download Link</td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr class=\"no-data\" ng-hide=\"logs.length > 0\">\n            <td colspan=\"9\">There are no export logs for this module yet.</td>\n          </tr>\n          <tr ng-repeat=\"log in logs\">\n            <td class=\"cursor-default\">{{log.requestor.display_name}}</td>\n            <td class=\"cursor-default\">{{log.date | date: \'dd MMM yyyy\'}}</td>\n            <td class=\"cursor-default\">{{log.done_at | date: \'dd MMM yyyy\'}}</td>\n            <td class=\"cursor-default\">{{log.status}}</td>\n            <td ng-if=\"log.status.toLowerCase() === \'done\'\">\n              <a ng-click=\"downloadExport(log)\">Download CSV</a>\n            </td>\n            <td ng-if=\"log.status.toLowerCase() !== \'done\'\" class=\"cursor-default\">\n              <span class=\"grey-text\">No download link available yet</span>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/items/details/details.html","<div class=\"state_items_details clearfix\">\n  <div id=\"fixHeaderViewWidth\" class=\"row\">\n    <div id=\"fixHeaderDirective\" class=\"fix-header\" fix-header height=\"true\" width=\"true\" padding=\"true\" top=\"true\">\n      <!--screen section-->\n\n      <span class=\"back-buttons\" ng-if=\"!!status\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n\n      <span ng-if=\"itemDetail.attachment[0].extension == \'csv\'\" class=\"pr-title-disable\">\n        {{ itemDetail.attachment[0].title }}\n      </span>\n      <span ng-if=\"itemDetail.attachment[0].extension != \'csv\'\" class=\"pr-title-disable\">\n        {{ itemDetail.attachment[1].title }}\n      </span>\n\n      <span class=\"pull-right pr-status-access-directly\">{{\n        status === \"PENDING\"? \"Pending Approval\":\n        status === \"COMPOSE\"? \"Compose\":\n        status === \"APPROVED\"? \"Approved\":\n        status === \"EXPIRED\"? \"Expired\":\n        status === \"REJECTED\"? \"Rejected\":\n        status === \"DEACTIVATED\"? \"Inactive\": item.status}}</span>\n\n      <div class=\"ml-15\">\n        <span ng-if=\"status === \'PENDING\'\">\n          <approval-waiting-on data=\"approvalFlowData\"></approval-waiting-on>\n        </span>\n      </div>\n\n      <span class=\"btn-group item-action pull-right clear-floating-right\" role=\"group\">\n        <a ng-show=\"status === \'PENDING\' && checkWaitingOn()\" ng-click=\"approveItem()\" class=\"btn btn-link\">\n          <i class=\"item-action-icon fa fa-check\"></i>Approve\n        </a>\n        <a ng-show=\"status === \'PENDING\' && checkWaitingOn()\" ng-click=\"rejectItem()\" class=\"item-action-btn btn btn-link\">\n          <i class=\"item-action-icon item-action-icon-del fa fa-times\"></i>Reject\n        </a>\n        <a ng-show=\"status === \'APPROVED\'\" ng-click=\"changeStatus(\'deactivate\', itemDetail._id)\" class=\"item-action-btn btn btn-link\">\n          <i class=\"item-action-icon item-action-icon-del fa fa-times\"></i>Deactivate\n        </a>\n        <a ng-show=\"status === \'DEACTIVATED\'\" ng-click=\"changeStatus(\'activate\', itemDetail._id)\" class=\"item-action-btn btn btn-link\">\n          <i class=\"item-action-icon fa fa-check\"></i>Activate\n        </a>\n        <a ng-show=\"status.toLowerCase() === \'compose\'\" ng-click=\"changeStatus(\'submit\', itemDetail._id)\" class=\"item-action-btn btn btn-link\">\n          <i class=\"item-action-icon fa fa-check\"></i>Confirm\n        </a>\n        <a ng-show=\"status.toLowerCase() === \'compose\'\" ng-click=\"changeStatus(\'cancel\', itemDetail._id)\" class=\"item-action-btn btn btn-link\">\n          <i class=\"item-action-icon item-action-icon-del fa fa-times\"></i>Cancel\n        </a>\n      </span> <!--actions-->\n\n    </div> <!--header screen section-->\n\n  </div>\n\n  <div class=\"row\">\n    <div class=\"jumbotron\">\n      <div class=\"row screen-section\">\n        <div class=\"col-md-6 form-horizontal\">\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Requested by</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.created_by }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Uploaded file</label>\n            <div class=\"col-md-7\">\n              <span> {{ itemDetail.attachment[0].title }} </span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Uploaded at</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.created_at | date:\'dd MMM yyyy h:mm a\' }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Version</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.import_version }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Import effective date</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.import_effective_date | date:\'dd MMM yyyy h:mm a\'}}</span>\n            </div>\n          </div>\n          <!-- <div class=\"form-group\">\n            <label class=\"col-md-3\"># of item</label>\n\n            <div class=\"col-md-7\">\n                <span>{{::item.availability}}</span>\n            </div>\n          </div> -->\n        </div>\n        <div class=\"col-md-6 form-horizontal\">\n          <div ng-show=\"!!rejector.user\" class=\"form-group\">\n            <label class=\"col-md-5\">Rejected by</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ rejector.user.display_name }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Updated by</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.updated_by }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Supplier name</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.supplier_name }}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Catalog Group</label>\n            <div class=\"col-md-7 pt-10\">\n              {{ itemDetail.catalog_group.descr }}\n            </div>\n          </div>\n          <!-- <div class=\"form-group\">\n            <label class=\"col-md-5\">Version</label>\n\n            <div class=\"col-md-7\">\n              <span>{{::(item.version)}}</span>\n            </div>\n          </div> -->\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Catalog Code</label>\n            <div class=\"col-md-7 pt-10\">\n              <span>{{ itemDetail.catalog_code}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Description</label>\n            <div class=\"col-md-7 pt-10\">{{ itemDetail.catalog_descr }}</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-3\">\n        <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(13)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 13}\">\n          <div class=\"ibox-title\">\n            <h5>Total Item(s)</h5>\n          </div>\n          <div class=\"ibox-content\">\n            <h1 class=\"no-margins\">\n              {{ itemDetail.file_header.itemcount }}\n            </h1>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-3\">\n        <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(10)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 10}\">\n          <div class=\"ibox-title\">\n            <h5>New/Latest Item(s)</h5>\n          </div>\n          <div class=\"ibox-content\">\n            <h1 class=\"no-margins\">\n              {{itemDetail.import_info.new.total}}\n            </h1>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-3\">\n        <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(11)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 11}\">\n          <div class=\"ibox-title\">\n            <h5>Updated Item(s)</h5>\n          </div>\n          <div class=\"ibox-content\">\n            <h1 class=\"no-margins\">\n              {{itemDetail.import_info.update.total}}\n            </h1>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-3\">\n        <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(12)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 12}\">\n          <div class=\"ibox-title\">\n            <h5>Deleted Item(s)</h5>\n          </div>\n          <div class=\"ibox-content\">\n            <h1 class=\"no-margins\">\n              {{itemDetail.import_info.delete.total}}\n            </h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"ibox-content\" ng-if=\"showItemDetails\">\n      <h3 style=\"text-align: left\">{{itemDetailTitle}} Item(s) Listing</h3>\n      <span ng-if=\"itemDetailsLoaded\">\n       <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n       </columns-selector>\n        <embedded-pagination-service meta=\"itemDetailsMeta\" list=\"itemDetailsList\" service=\"itemDetailService\" params-source=\"embeddedParams\" offset=\"20\">\n        </embedded-pagination-service>\n      </span>\n      <table class=\"table\">\n        <thead embedded-table-header available-headers=\"columns\" list=\"itemDetailsList\" service=\"itemDetailService\" params-source=\"embeddedParams\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-if=\"!(itemDetailsList).length\">\n          <td colspan=\"9\">There are no available items for this status.</td>\n        </tr>\n        <tr ng-repeat=\"itemDetails in itemDetailsList\" class=\"cursor-pointer\" ng-click=\"viewSingleItemDetails(itemDetails)\">\n          <td ng-if=\"showColumn(\'item_name\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.item_name}\">\n            {{itemDetails.item_name}}\n          </td>\n          <td ng-if=\"showColumn(\'description\')\">\n            {{itemDetails.description}}\n          </td>\n          <td ng-if=\"showColumn(\'supplier.descr\')\">\n            {{itemDetails.supplier[0].descr}}\n          </td>\n          <td ng-if=\"showColumn(\'supplier_part_no\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.manufacturer_part_id}\">\n            {{itemDetails.supplier_part_no}}\n          </td>\n          <td ng-if=\"showColumn(\'tax.rate\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.tax_code}\">\n            {{itemDetails.tax[0].code}} {{itemDetails.tax[0].rate}}\n          </td>\n          <td ng-if=\"showColumn(\'payment_term.descr\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.payment_term_code}\">\n            {{itemDetails.payment_term[0].descr}}\n          </td>\n          <td ng-if=\"showColumn(\'currency.code\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.currency_code}\">\n            {{itemDetails.currency[0].code}}\n          </td>\n          <td ng-if=\"showColumn(\'unit_price\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.unit_price}\">\n            {{itemDetails.unit_price | formatDecimal: 4}}\n          </td>\n          <td ng-if=\"showColumn(\'Uom.code\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.uom_code}\">\n            {{itemDetails.Uom[0].code}}\n          </td>\n          <td ng-if=\"showColumn(\'effective_at\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.effective_at}\">\n            {{itemDetails.effective_at | date:\'dd MMM yyyy h:mm a\'}}\n          </td>\n          <td ng-if=\"showColumn(\'expiry_at\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.expiry_at}\">\n            {{itemDetails.expiry_at | date:\'dd MMM yyyy h:mm a\'}}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"ibox-content\">\n      <div class=\"container-fluid\">\n        <div class=\"row row-beauty\" style=\"overflow: auto\">\n          <h3 style=\"text-align: left\">Upload History</h3>\n          <table class=\"table\">\n            <thead>\n            <tr>\n              <th>Uploaded at</th>\n              <th>Uploaded by</th>\n              <th>Updated at</th>\n              <th>Updated by</th>\n              <th>Submitted at</th>\n              <th>Submitted by</th>\n              <th>Approved at</th>\n              <th>Approved by</th>\n              <th>Item(s)</th>\n              <th>Version</th>\n              <th>Status</th>\n              <th>File</th>\n              <th>Image</th>\n              <th>Details</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"attachments in dataHistory | orderBy:\'-import_version\'\" class=\"cursor-auto\">\n              <td>{{ attachments.created_at | date: \'dd MMM yyyy h:mm a\' }}</td>\n              <td>{{ attachments.created_by }}</td>\n              <td>{{ attachments.updated_at | date: \'dd MMM yyyy h:mm a\' }}</td>\n              <td>{{ attachments.updated_by }}</td>\n              <td>{{ attachments.submitted_at | date: \'dd MMM yyyy h:mm a\' }}</td>\n              <td>{{ attachments.submitted_by }}</td>\n              <td>{{ attachments.approved_at | date: \'dd MMM yyyy h:mm a\' }}</td>\n              <td>{{ attachments.approved_by }}</td>\n              <td>{{ attachments.file_header.itemcount }}</td>\n              <td>{{ attachments.import_version}}</td>\n              <td>\n                <span ng-if=\"attachments.import_status === \'PENDING_APPROVE\'\">Pending Approve</span>\n                <span ng-if=\"attachments.import_status !== \'PENDING_APPROVE\'\">\n                {{ attachments.import_status | titleCase }}\n              </span>\n              </td>\n              <td>\n              <span class=\"clicked-link\" ng-click=\"downloadImportCatalogCSV(attachments.attachment)\">\n                {{ getImportCatalogCSVTitle(attachments.attachment) }}\n              </span>\n              </td>\n              <td>\n              <span class=\"clicked-link\" ng-if=\"attachments.attachment[0].extension === \'zip\'\" ng-click=\"downloadImageFileZip(attachments.attachment)\">\n                {{ attachments.attachment[0].title }}\n              </span>\n                <span class=\"clicked-link\" ng-if=\"attachments.attachment[0].extension !== \'zip\'\" ng-click=\"downloadImageFileZip(attachments.attachment)\">\n                {{ attachments.attachment[1].title }}\n              </span>\n                <span ng-if=\"$first && attachments.attachment[0].extension != \'zip\'\n                        && attachments.attachment[1].extension != \'zip\'\">\n                <!--<a data-toggle=\"modal\" data-target=\"#uploadImage\">Upload image</a>-->\n                <a ng-click=\"uploadImageFileModal(attachments.attachment[0].import_summary_id)\">\n                  Upload image\n                </a>\n              </span>\n                <span ng-if=\"!$first && attachments.attachment[0].extension != \'zip\'\n                        && attachments.attachment[1].extension != \'zip\'\">\n                -\n              </span>\n              </td>\n              <td>\n                <a ng-click=\"viewHistoryDetails(attachments._id, dataHistory, itemDetail, status)\">\n                  View version details\n                </a>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <br>\n    <br>\n    <approval-flow class=\"screen-section\" id=\"approval_id\" data=\"approvals\" requestor=\"requestor\" ng-show=\"status === \'PENDING\'\">\n    </approval-flow>\n  </div>\n</div>\n");
$templateCache.put("app/items/details/historyDetails.html","<div class=\"item-history-detail\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n    <h3 class=\"modal-title\">History detail for version {{::itemHistory.import_version}}</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row screen-section\">\n      <div class=\"col-md-6 form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Requested by</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.created_by }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Uploaded file</label>\n          <div class=\"col-md-7\">\n            <span class=\"item-history-title\"> {{ itemHistory.attachment[0].title }} </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Uploaded at</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.created_at | date:\'dd MMM yyyy h:mm a\' }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Version</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.import_version }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Status</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.import_status }}</span>\n          </div>\n        </div>\n        <!-- <div class=\"form-group\">\n          <label class=\"col-md-3\"># of item</label>\n\n          <div class=\"col-md-7\">\n              <span>{{::item.availability}}</span>\n          </div>\n        </div> -->\n      </div>\n      <div class=\"col-md-6 form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Updated by</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.updated_by }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Supplier name</label>\n          <div class=\"col-md-7\">\n            <span>{{ itemHistory.supplier_name }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Catalog Group</label>\n          <div class=\"col-md-7\">\n            {{ itemHistory.catalog_group.descr }}\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Description</label>\n          <div class=\"col-md-7\">{{ itemHistory.file_header.comments }}</div>\n        </div>\n        <div class=\"form-group\" ng-if=\"itemHistory.import_status === \'REJECTED\'\">\n          <label class=\"col-md-5\">Rejected Reason</label>\n          <div class=\"col-md-7\">{{ itemHistory.reasons }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins\">\n      <div class=\"ibox-title\">\n        <h5>Total Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{ itemHistory.file_header.itemcount }}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins\">\n      <div class=\"ibox-title\">\n        <h5>New/Latest Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{itemHistory.import_info.new.total}}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins\">\n      <div class=\"ibox-title\">\n        <h5>Updated Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{itemHistory.import_info.update.total}}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins\">\n      <div class=\"ibox-title\">\n        <h5>Deleted Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{itemHistory.import_info.delete.total}}</h1>\n      </div>\n    </div>\n  </div>\n  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"submitCatalog()\" ng-show=\"itemHistory.import_status === \'COMPOSE\'\">\n    Confirm\n  </button>\n  <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n    Close\n  </button>\n</div>\n");
$templateCache.put("app/items/details/importImage.html","<!-- Modal for upload Image -->\n\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"cancel()\">\n          <span aria-hidden=\"true\">×</span><span class=\"sr-only\">Close</span>\n        </button>\n        <h4 class=\"modal-title\">Upload Image</h4>\n      </div>\n      <div class=\"modal-body\">\n        <input type=\"file\" file-model=\"submit_data.images\" accept=\".zip\">\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"importImage(this.submit_data.images, summaryId)\">\n          Upload\n        </button>\n      </div>\n    </div>\n");
$templateCache.put("app/items/details/singleItemDetails.html","<div class=\"item-history-detail\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n    <h3 class=\"modal-title\">Detail for item {{::singleItemDetail.item_name}}</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row screen-section\">\n      <div class=\"col-md-6 form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Created by</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.created_by }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Created at</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.created_at | date:\'dd MMM yyyy h:mm a\'  }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Effective At</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.effective_at | date:\'dd MMM yyyy h:mm a\' }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Expiry At</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.expiry_at | date:\'dd MMM yyyy h:mm a\'  }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Manufacturer Name</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.manufacturer_name }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Manufacturer Part ID</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.manufacturer_part_id }}\n            </span>\n          </div>\n        </div>\n        <!-- <div class=\"form-group\">\n          <label class=\"col-md-3\"># of item</label>\n\n          <div class=\"col-md-7\">\n              <span>{{::item.availability}}</span>\n          </div>\n        </div> -->\n      </div>\n      <div class=\"col-md-6 form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">UOM</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.pricing.uom.code }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Payment Term</label>\n          <div class=\"col-md-7\">\n            <span>\n              {{ singleItemDetail.payment_term.descr }}\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Currency</label>\n          <div class=\"col-md-7\">\n            <span>{{ singleItemDetail.pricing.currency.code }}</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Unit Price</label>\n          <div class=\"col-md-7\">\n            {{ singleItemDetail.pricing.unit_price }}\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-5\">Description</label>\n          <div class=\"col-md-7\">\n            {{ singleItemDetail.item_description }}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-white pull-right\" ng-click=\"cancel()\">\n    Close\n  </button>\n</div>\n");
$templateCache.put("app/items/import/confirmation.html","<div class=\"row\" ng-if=\"!!success\">\n  <div class=\"modal-body\">\n    <div class=\"row form-group\">\n      <div class=\"col-xs-3\">\n        <div class=\"pull-left\">\n          Selected Catalog Group\n        </div>\n      </div>\n      <div class=\"col-xs-3\">\n        <h5>{{selectedCatalogGroup.descr}}</h5>\n      </div>\n    </div>\n\n    <div class=\"row form-group\">\n      <div class=\"col-xs-3\">\n        <div class=\"pull-left\">\n          Selected Supplier\n        </div>\n      </div>\n      <div class=\"col-xs-3\">\n        <h5>{{selectedSupplier.descr}}</h5>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(13)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 13}\">\n      <div class=\"ibox-title\">\n        <h5>Summary</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <div>\n          <div class=\"stat-percent font-bold text-success\">{{message.header.itemcount}}</div>\n          <small>Total Items</small>\n        </div>\n        <div>\n          <div class=\"stat-percent font-bold text-success\">{{message.version}}</div>\n          <small>Version</small>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(10)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 10}\">\n      <div class=\"ibox-title\">\n        <h5>New Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{message.importInfo.new.total}}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(11)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 11}\">\n      <div class=\"ibox-title\">\n        <h5>Updated Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{message.importInfo.update.total}}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"ibox float-e-margins cursor-pointer\" ng-click=\"getItemListing(12)\" ng-class=\"{\'highlight-selected-catalog\': itemDetailsStatus === 12}\">\n      <div class=\"ibox-title\">\n        <h5>Deleted Item(s)</h5>\n      </div>\n      <div class=\"ibox-content\">\n        <h1 class=\"no-margins\">{{message.importInfo.delete.total}}</h1>\n      </div>\n    </div>\n  </div>\n</div>\n<div ng-if=\"!!error\" class=\"panel panel-danger\">\n  <div class=\"panel-heading\">\n    Error\n  </div>\n  <div class=\"panel-body\">\n    <div ng-repeat=\"header in message.header track by $index\">\n    <h3>{{header}}</h3>\n    </div>\n    <div ng-repeat=\"(key, data) in message.details\">\n    <h3>Error in Item Line {{key}} :</h3>\n      <h5 ng-repeat=\"detail in data track by $index\">{{detail}}</h5>\n   </div>\n  </div>\n</div>\n<embedded-pagination-service meta=\"itemDetailsMeta\" list=\"itemDetailsList\" service=\"itemDetailService\" params-source=\"embeddedParams\" offset=\"20\">\n</embedded-pagination-service>\n<table class=\"table\">\n  <thead>\n  <tr>\n    <th ng-if=\"column.showColumn(\'item_name\')\">Item Name</th>\n    <th ng-if=\"column.showColumn(\'supplier_part_no\')\">Supplier Part Number</th>\n    <th ng-if=\"column.showColumn(\'tax_rate\')\">Tax Rate</th>\n    <th ng-if=\"column.showColumn(\'payment_terms\')\">Payment Terms</th>\n    <th ng-if=\"column.showColumn(\'currency\')\">Currency</th>\n    <th ng-if=\"column.showColumn(\'unit_price\')\">Unit Price</th>\n    <th ng-if=\"column.showColumn(\'uom\')\">UOM</th>\n    <th ng-if=\"column.showColumn(\'effective_at\')\">Effective Date</th>\n    <th ng-if=\"column.showColumn(\'expiry_at\')\">Expiry Date</th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr ng-repeat=\"itemDetails in itemDetailsList\" class=\"cursor-pointer\" ng-click=\"viewSingleItemDetails(itemDetails)\">\n    <td ng-if=\"column.showColumn(\'item_name\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.item_name}\">{{itemDetails.item_name}}</td>\n    <td ng-if=\"column.showColumn(\'supplier_part_no\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.supplier_part_no}\">{{itemDetails.supplier_part_no}}</td>\n    <td ng-if=\"column.showColumn(\'tax_rate\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.tax_code}\">{{itemDetails.tax_code}} {{itemDetails.tax_rate}}</td>\n    <td ng-if=\"column.showColumn(\'payment_terms\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.payment_term_code}\">{{itemDetails.payment_term.descr}}</td>\n    <td ng-if=\"column.showColumn(\'currency\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.currency_code}\">{{itemDetails.pricing.currency.code}}</td>\n    <td ng-if=\"column.showColumn(\'unit_price\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.unit_price}\">{{itemDetails.pricing.unit_price | formatDecimal: 4}}</td>\n    <td ng-if=\"column.showColumn(\'uom\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.uom_code}\">{{itemDetails.pricing.uom.code}}</td>\n    <td ng-if=\"column.showColumn(\'effective_at\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.effective_at}\">{{itemDetails.effective_at | date:\'dd MMM yyyy h:mm a\'}}</td>\n    <td ng-if=\"column.showColumn(\'expiry_at\')\" ng-class=\"{\'highlight-changes-fields\': !!itemDetails.dirty_fields.expiry_at}\">{{itemDetails.expiry_at | date:\'dd MMM yyyy h:mm a\'}}</td>\n  </tr>\n  </tbody>\n</table>\n<div class=\"row\">\n  <div class=\"col-md-12 text-right mt-20\">\n    <button class=\"btn btn-white\" ng-click=\"cancelCatalog()\">Cancel</button>\n    <button class=\"btn btn-primary\" ng-click=\"submitCatalog()\">Confirm</button>\n  </div>\n</div>\n");
$templateCache.put("app/items/import/itemsImportTemplate.html","<div class=\"ibox-content wizard\">\n  <h2>\n    Import a Catalog\n  </h2>\n  <div class=\"steps clearfix\">\n    <ul>\n      <li ui-sref-active=\"current\" class=\"current\">\n        <a class=\"btn-default cursor-default\"><span>1</span> Select a Catalog Group</a>\n        <a ui-sref=\".select_bu\" ng-hide=\"true\"></a>\n      </li>\n      <li ui-sref-active=\"current\" class=\"current\">\n        <a class=\"btn-default cursor-default\"><span>2</span> Select a Supplier</a>\n        <a ui-sref=\".select_supplier\" ng-hide=\"true\"></a>\n      </li>\n      <li ui-sref-active=\"current\" class=\"current\">\n        <a class=\"btn-default cursor-default\"><span>3</span> Upload the file</a>\n        <a ui-sref=\".select_file\" ng-hide=\"true\"></a>\n      </li>\n      <li ui-sref-active=\"current\" class=\"current\">\n        <a class=\"btn-default cursor-default\"><span>4</span> Confirmation</a>\n        <a ui-sref=\".confirmation\" ng-hide=\"true\"></a>\n\n      </li>\n    </ul>\n  </div>\n  <div class=\"wizard\">\n    <div class=\"content\">\n      <form class=\"p-lg ng-dirty ng-valid ng-valid-minlength\">\n        <ui-view></ui-view>\n      </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/items/import/selectBUTemplate.html","<div class=\"row\">\n  <div class=\"col-md-4 col-xs-1 list-group\" ng-repeat=\"BU in BUs track by $index\">\n    <input type=\"radio\" ng-model=\"selection.BU\" ng-value=\"BU\" id=\"{{selection.BU}}\" ng-click=\"selectCatalogGroup(selection.BU._id)\" name=\"favorite\">&nbsp; {{BU.descr}}\n  </div>\n</div>\n\n<!-- Submit the form -->\n<div class=\"row\">\n  <div class=\"pull-right\">\n    <button class=\"btn btn-primary\" ui-sref=\"main.user.items.import.select_supplier\" ng-disabled=\"!selectedCatalogGroup\">\n      Next\n    </button>\n  </div>\n</div>\n");
$templateCache.put("app/items/import/selectFile.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div ng-if=\"!!error\" class=\"panel panel-danger\">\n        <div class=\"panel-heading\">\n          Error\n        </div>\n        <div class=\"panel-body\">\n          <div ng-repeat=\"errorMessage in message\">\n            {{errorMessage.value}} <br>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\" ng-if=\"errorImportID !== undefined\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        <h3>Error Catalog Reupload</h3>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Selected Catalog Group\n      </div>\n    </div>\n    <div class=\"col-xs-3\">\n      <h5>{{selectedCatalogGroup.descr}}</h5>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Selected Supplier\n      </div>\n    </div>\n    <div class=\"col-xs-3\">\n      <h5>{{selectedSupplier.descr}}</h5>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Catalog Code\n      </div>\n    </div>\n    <div class=\"col-xs-3\">\n      <ui-select ng-model=\"selectedCatalogCode\" on-select=\"onSelectedCatalogCode(selectedCatalogCode)\" ng-disabled=\"catalogObject.import_status === 8\">\n        <ui-select-match placeholder=\"Select A Catalog Code\">\n          {{$select.selected.code}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"cc in catalogCodeList | filter: $select.search\">\n          <span ng-bind-html=\"cc.code + (!!cc.code ? \' - \' + cc.descr : \'\') | highlight: $select.search\"></span>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\" ng-if=\"!!catalogCodeSelected\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Catalog Description\n      </div>\n    </div>\n\n    <div class=\"col-xs-3\">\n      {{selectedCatalogCode.descr}}\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Import effective date\n      </div>\n    </div>\n    <div class=\"col-xs-3\">\n      <input type=\"input\" ng-click=\"openDatePicker($event, \'startDate\')\" placeholder=\"Import effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"effective_at\" ng-model-options=\"datePickerTimezone\" ng-change=\"setEffectiveDate(effective_at)\" is-open=\"datepickerOpened.startDate\" datepicker-options=\"dateOptions\" class=\"form-control pr-needed-by-input\" required>\n    </div>\n\n    <span class=\"input-group-btn\">\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatePicker($event, \'startDate\')\">\n        <i class=\"fa fa-calendar\"></i>\n      </button>\n    </span>\n  </div>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Upload Items\n      </div>\n    </div>\n    <div class=\"col-xs-9\">\n      <input type=\"file\" file-model=\"item\">\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Upload Images (Optional)\n      </div>\n    </div>\n    <div class=\"col-xs-9\">\n      <input type=\"file\" file-model=\"images\">\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button class=\"btn btn-white\" ng-click=\"backToSelectSupplier()\">\n    Back\n  </button>\n  <button class=\"btn btn-primary\" ng-click=\"checkImportFile(item, images)\" ng-disabled=\"(!item || !effective_at || !(catalogCodeSelected))\">\n    Upload\n  </button>\n  <!--<button class=\"btn btn-primary\" ng-disabled=\"disableSubmitting\" -->\n          <!--ui-sref=\"main.items.import.step_three\"-->\n          <!--ng-click=\"submitCatalog()\">-->\n    <!--Submit Catalog-->\n  <!--</button>-->\n</div>\n\n  <!--<div ng-if=\"!selectedSupplier\">Please Choose a supplier </div>-->\n  <!-- <div ng-if=\"!selection.BU._id\">Please Choose a BU</div> -->\n<!-- <div>\n  <ul>\n  <li  ng-repeat=\"version in versions track by $index\"><a>Version {{$index + 1}}</a></li>\n  </ul>\n  <!--<p ng-if=\"!versions.length\">There no Available Previous Versions</p>-->\n<!-- </div> -->\n");
$templateCache.put("app/items/import/selectSupplierTemplate.html","<!-- Search box -->\n<div class=\"row\">\n  <div class=\"input-group col-md-12\">\n    <input type=\"text\" placeholder=\"Search for a Supplier\" name=\"search\" class=\"form-control input-lg\" ng-model=\"search.title\" ng-enter=\"search(search.title)\">\n    <div class=\"input-group-btn\">\n      <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-click=\"search(search.title)\">\n        <i class=\"fa fa-search\"></i>\n      </button>\n    </div>\n  </div>\n</div>\n<br>\n<!-- Result Search -->\n<div class=\"list-group col-md-12\" style=\"overflow:auto;height:200px\">\n  <div ng-show=\"searchResult == 0\">\n    Not Found\n  </div>\n  <a class=\"list-group-item\" ng-show=\"searchResult > 0\" ng-repeat=\"results in suppliersResults\" ng-click=\"selectSupplier(results)\" ng-class=\"{\'active\': results._id === selectedSupplier._id}\">\n    {{results.descr}}\n  </a>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-12 text-right\">\n    <button class=\"btn btn-white\" ui-sref=\"main.user.items.import.select_bu\">Back</button>\n    <!--<button class=\"btn btn-primary\" ui-sref=\"main.items.import.select_file\"-->\n            <!--ng-disabled=\"!selectedSupplier\">-->\n      <!--Next-->\n    <!--</button>-->\n    <button class=\"btn btn-primary\" ng-click=\"getCatalogCodeList()\" ui-sref=\"main.user.items.import.select_file\" ng-disabled=\"!selectedSupplier\">\n      Next\n    </button>\n  </div>\n</div>\n");
$templateCache.put("app/items/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 ng-hide=\"actionType === \'search\'\" class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{ status\n        }} Catalog Uploads</h3>\n      <h3 class=\"pull-left\" ng-if=\"actionType === \'search\'\" style=\"margin-top: 7px; margin-right: 5px\">Searching result\n        of \"<i>{{ title }}</i>\"</h3>\n\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n\n      <span class=\"pull-right\">\n        <button company-groups-management class=\"btn btn-primary pull-right btn-xs mr-15 margin-right\">\n          Catalog Groups\n        </button>\n\n        <master-export module-name=\"Catalogs\" collection=\"13\">\n        </master-export>\n\n        <multi-approval-action class=\"pull-right\" ng-if=\"status === \'pending\' && getSelectedItems().length > 0\" get-selected-items=\"getSelectedItems()\" type=\"item(s)\">\n        </multi-approval-action>\n      </span>\n      <pagination-service cursor=\"meta.cursor\" list=\"items\" service=\"itemManageService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table st-table=\"items\" class=\"table\" ng-class=\"{\'table-hover\' : items.length > 1}\">\n      <thead table-header condition=\"status\" available-headers=\"columns\" multi-select-action=\"multiSelectPendingItems(status)\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(items).length\">\n        <td colspan=\"9\">There is no available Uploads at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"item in items\" ng-class=\"{\'row-select\': item.selected}\" fadeout-row=\"item._id == highlightId\" ui-sref=\"main.user.items.detail({id: item._id, status: status})\">\n        <td ng-if=\"status === \'pending\'\">\n          <span ng-if=\"::(checkWaitingOnUser(item))\">\n            <input type=\"checkbox\" icheck ng-model=\"item.selected\">\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'catalog_group.descr\')\">\n          {{item.catalog_group[0].descr}}\n        </td>\n        <td ng-show=\"showColumn(\'catalog_code.code\') \">\n          {{item.catalog_code[0].code }}\n        </td>\n        <td ng-show=\"showColumn(\'catalog_code.descr\') \">\n          {{item.catalog_code[0].descr }}\n        </td>\n        <td ng-show=\"showColumn(\'supplier.descr\')\">\n          {{ item.supplier[0].descr }}\n        </td>\n        <td ng-show=\"showColumn(\'file_header|itemcount\')\">\n          {{ item.file_header.itemcount }}\n        </td>\n        <td ng-show=\"showColumn(\'import_effective_date\') \">\n          {{item.import_effective_date | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ item.creator[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ item.created_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ item.updater[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ item.updated_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-show=\"(status === \'all\') && showColumn(\'import_status\')\">\n          {{ getImportStatusName(item.import_status) }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/orders/detail/detail.html","<div class=\"state_orders_details clearfix\">\n  <div id=\"fixHeaderViewWidth\" class=\"row screen-section set-position-relative header-section\" ui-scrollfix=\"-15\">\n    <div id=\"fixHeaderDirective\" class=\"fix-header\" fix-header height=\"true\" width=\"true\" padding=\"true\">\n      <span class=\"back-buttons\">\n        <a class=\"btn btn-default\" ng-click=\"backToListingPO()\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"pr-title-disable\">\n      {{::po.supplier.descr}}\n    </span>\n      <i ng-if=\"canUpdatePO()\" ng-click=\"starred(po)\" style=\"cursor: hand;cursor: pointer\" ng-attr-class=\"{{ po.is_starred && \'fa fa-2x fa-star is_starred detail-star-hover\' ||\n                        \'fa fa-2x fa-star-o is_starred detail-star-hover-o\' }}\">\n      </i>\n      <span class=\"po-id\">{{::po.po_number}}</span>\n      <span class=\"pull-right po-id pr-status-access-directly\">{{po.generalStatus}}</span>\n      <span class=\"sr-only\" ng-click=\"starred(po)\">\n      {{ po.is_starred && \'Starred\' || \'Not starred\' }}\n    </span>\n      <span class=\"po-waiting-on-section\">\n      <span class=\"waiting-on-title\">Status:</span>\n\n      <span class=\"btn waiting-on-section-disable\" ng-hide=\"parseConditions(1,po.status)\" disabled=\"disabled\">\n        {{po.specificStatus}}\n      </span>\n      <span class=\"btn-group\" role=\"group\" ng-show=\"parseConditions(1,po.status)\">\n        <button class=\"btn btn-link dropdown-toggle\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n          {{\n          (parseConditions(6,po.status)) ? \"Awaiting Acknowledgement \":\n          (parseConditions(7,po.status)) ? \"Delivery Date Unconfirmed \":\n          (parseConditions(8,po.status)) ? \"Declined \":\n          po.status.toLowerCase()\n          }}\n          <span ng-if=\"canUpdatePO()\" class=\"fa fa-caret-down\"></span>\n        </button>\n        <ul ng-if=\"canUpdatePO()\" class=\"dropdown-menu pull-left\" role=\"menu\">\n          <li ng-repeat=\"item in poStatusOptions\" class=\"from-group\">\n              <a class=\"btn btn-link\" ng-click=\"selectedAction(item)\" ng-class=\"{\'waiting-on-selected-item\': item.status == status_mapping[po.status]}\">\n                {{item.descr}}</a>\n          </li>\n        </ul>\n      </span>\n    </span><!--waiting on-->\n\n      <div class=\"btn-group po-action pull-right\" role=\"group\" ng-class=\"{\'po-action-access-directly\': !status}\">\n      <a class=\"po-action-btn btn btn-link\" receive-goods ng-click=\"showReceiveGoods()\" ng-if=\"checkGRNAccess()\" ng-show=\"parseConditions(2,po.status)\">\n        <i class=\"po-action-icon fa fa-archive\"></i>Receive goods\n      </a>\n      <a class=\"po-action-btn btn btn-link\" reverse-goods ng-click=\"showReverseGoods()\" ng-if=\"checkGRNAccess()\" ng-show=\"parseConditions(3,po.status)\">\n        <i class=\"po-action-icon fa fa-undo\"></i>Reverse goods\n      </a>\n      <a class=\"po-action-btn btn btn-link\" cancel-po ng-click=\"showCancelPO()\" ng-if=\"checkGRNAccess() && checkCancelButton()\" ng-show=\"parseConditions(4,po.status)\">\n        <i class=\"po-action-icon po-action-icon-del fa fa-times\"></i>Cancel PO\n      </a>\n      <a class=\"po-action-btn btn btn-link\" close-po ng-click=\"showClosePO()\" ng-if=\"checkGRNAccess()\" ng-show=\"parseConditions(5,po.status)\">\n        <i class=\"po-action-icon fa fa-share-square\"></i>Close\n      </a>\n      <a class=\"po-action-btn btn btn-link\" ui-sref=\"main.user.purchaseRequisitions.details({id: po.originalPR, status: \'approved\', action: \'access_directly\', from: \'po\'})\">\n        <i class=\"po-action-icon fa fa-bars\"></i>View PR\n      </a>\n      <a class=\"po-action-btn btn btn-link\" ng-click=\"printPO()\">\n        <i class=\"po-action-icon fa fa-print\"></i>Print\n      </a>\n\n      <div ng-if=\"canUpdatePO()\" class=\"btn-group\" role=\"group\">\n        <button class=\"btn btn-link dropdown-toggle clear-more-padding-right\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n          More\n          <span class=\"caret\"></span>\n        </button>\n        <ul class=\"dropdown-menu pull-right\" role=\"menu\">\n          <li ng-if=\"disableResendPO()\">\n            <a class=\"po-action-btn btn btn-link\" resend-po ng-click=\"showResendPO()\" ng-if=\"checkGRNAccess()\">\n              <i class=\"po-action-icon fa fa-mail-forward\"></i>Resend PO\n            </a>\n          </li>\n          <li>\n            <a class=\"po-action-btn btn btn-link\" ng-click=\"notificationToggle()\">\n              <i class=\"po-action-icon fa fa-envelope\"></i>Notifications {{po.notify ? \"on\": \"off\"}}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div> <!--actions-->\n\n    </div><!--header-->\n  </div>\n\n  <div class=\"row\">\n\n    <div class=\"jumbotron screen-section\">\n      <div class=\"row\">\n        <div class=\"col-md-6 form-horizontal\">\n          <div class=\"row\">\n            <h3 class=\"col-md-3\">Bill To</h3>\n          </div>\n          <div class=\"form-group\" ng-if=\"!!po.billing.alternate_billing_company.descr\">\n            <label class=\"col-md-3\">Billing Co.</label>\n\n            <div class=\"col-md-7\">\n              <span>{{::po.billing.alternate_billing_company.descr}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n          <label class=\"col-md-3\">Company</label>\n\n            <div class=\"col-md-7\">\n              <span>{{::po.billing.company.descr}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-3\">Cost center</label>\n\n            <div class=\"col-md-7\">\n              <span>{{::po.billing.cost_center.descr}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-3\">Currency</label>\n\n            <div class=\"col-md-7\">\n                <span ng-if=\"!!po.currency\">\n                  {{::(po.currency.code || po.currency.name)\n                  + \' - \' + po.currency.descr}}\n                </span>\n              <span ng-if=\"!po.currency\">\n                  {{::(po.billing.currency.code || po.billing.currency.name)\n                  + \' - \' + po.billing.currency.descr}}\n                </span>\n\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-6 form-horizontal\">\n          <div class=\"row\">\n            <h3 class=\"col-md-5\">Deliver To</h3>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Company</label>\n\n            <div class=\"col-md-7\">\n              <span>{{::(po.delivery.company.name || po.delivery.company.descr)}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Address</label>\n\n            <div class=\"col-md-7\">\n              <p class=\"jumbo-address\" ng-if=\"!!po.delivery.address.line1.length\">{{po.delivery.address.line1}}</p>\n              <p class=\"jumbo-address\" ng-if=\"!!po.delivery.address.line2.length\">{{po.delivery.address.line2}}</p>\n              <p class=\"jumbo-address\" ng-if=\"!!po.delivery.address.line3.length\">{{po.delivery.address.line3}}</p>\n              <p class=\"jumbo-address\" ng-if=\"!!po.delivery.address.postal_code.length || !!po.delivery.address.city.length\">\n                <span>{{po.delivery.address.postal_code}}</span> <span>{{po.delivery.address.city}}</span>\n              </p>\n              <p class=\"jumbo-address\" ng-if=\"!!po.delivery.address.state.length || !!po.delivery.address.country.length\">\n                {{po.delivery.address.state}} <span ng-if=\"!!po.delivery.address.country.length\">-</span> {{po.delivery.address.country}}\n              </p>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Contact person</label>\n\n            <div class=\"col-md-7\" class=\"autosuggesttextbox\" bs-typeahead=\"datalists\">\n              <span>{{::(po.delivery.contact_person)}}</span>\n\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Needed by</label>\n\n            <div class=\"col-md-7\">\n              <span ng-if=\"po.needed_at != null\">{{::(po.needed_at | date: \"dd MMM yyyy\")}}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <hr>\n      <div class=\"row\">\n        <div class=\"col-md-6 form-horizontal\">\n          <div class=\"row\">\n            <h3 class=\"col-md-3 supplier-section-min-width\">Supplier</h3>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-3 supplier-section-min-width\">Company</label>\n            <div class=\"col-md-7\">\n                <span tooltip-html-unsafe=\"Supplier Info : <br> {{::po.supplier.descr + !!po.supplier.branch_descr ? po.supplier.branch_descr : \'\'}} <br> Contact Person: {{::po.supplier.contact_person.first_name}}\n                 <br> Email: {{::po.supplier.email }} <br> Phone: {{::po.supplier.phone}} <br> Fax: {{::po.supplier.fax}}\">\n                  {{::po.supplier.descr}}\n                  <br>\n                  {{!!po.supplier.branch_descr ? \'(\' + po.supplier.branch_descr + \')\' : \'\'}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-3 supplier-section-min-width\">Contact person</label>\n            <div class=\"col-md-7\">\n              <span>{{::po.supplier.contact_person.first_name}} {{::po.supplier.contact_person.last_name}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-3 supplier-section-min-width\">Payment terms</label>\n            <div class=\"col-md-7\">\n              <span>{{::po.payment_terms.descr}}</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-6 form-horizontal\">\n          <div class=\"row\">\n            <h3 class=\"col-md-5\">Other details</h3>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">PO date</label>\n            <div class=\"col-md-7\">\n              <span>{{::(po.po_date | date:\"dd MMM yyyy\")}}</span>\n            </div>\n          </div>\n          <div ng-if=\"po.status.toLowerCase()===\'closed\'\" class=\"form-group\">\n            <label class=\"col-md-5\">PO Closed date</label>\n            <div class=\"col-md-7\">\n              <span>{{::(po.status_date | date:\"dd MMM yyyy\")}}</span>\n            </div>\n          </div>\n          <div ng-if=\" po.status.toLowerCase()===\'fully_delivered\'\" class=\"form-group\">\n            <label class=\"col-md-5\">PO Delivered date</label>\n            <div class=\"col-md-7\">\n              <span>{{::(po.status_date | date:\"dd MMM yyyy\")}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">PR number</label>\n            <div class=\"col-md-7\">\n              <a ui-sref=\"main.user.purchaseRequisitions.details({id: po.originalPR, status: \'approved\', action: \'access_directly\', from: \'po\'})\">\n                <span>{{::po.pr_number}}</span>\n              </a>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Requestor</label>\n            <div class=\"col-md-7\">\n              <span>{{::po.requestor.display_name}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Creator</label>\n            <div class=\"col-md-7\">\n              <span>{{::po.creator.display_name}}</span>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"col-md-5\">Remarks</label>\n            <div class=\"col-md-7 item-history-title\">\n              <span>{{::(po.remarks || \'N/A\')}}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"itemlist screen-section\">\n      <po-itemlist-panel></po-itemlist-panel>\n    </div>\n    <div ng-show=\"!!po.notes\">\n      <div class=\"ibox-content\">\n        <h3 class=\"text-left-align\">Note to Suppliers\n        </h3>\n        <div class=\"supplier-note\">\n          <pre class=\"textBox\">{{po.notes}}</pre>\n        </div>\n      </div>\n    </div>\n    <comments-panel comments-object=\"po\" comments-module=\"PO\" comments-service=\"service\" contact-options=\"options.contact_persons\" disable-comment=\"!canUpdatePO()\">\n    </comments-panel>\n    <br>\n    <po-attachments-block disable-attaching=\"!canUpdatePO()\" class=\"screen-section\"></po-attachments-block>\n    <br>\n  </div>\n</div>\n");
$templateCache.put("app/orders/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{\n        ([\'SUBMITTED\', \'DECLINED\', \'CANCELLED\', \'CLOSED\', \'CONFIRMED\', \'ACCEPTED\'].indexOf(status) > -1) ? status.toLowerCase():\n        status == \'AWAITING_DELIVERY\'? \'awaiting delivery\':\n        status == \'PARTIALLY_DELIVERED\'? \'awaiting delivery\':\n        status == \'AWAITING_CONFIRMATION\'? \'awaiting delivery\':\n        status == \'DELIVERY_DATE_UNCONFIRMED\'? \'submitted\': status.toLowerCase()\n        }} POs</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <master-export module-name=\"Purchase Order\" collection=\"18\">\n      </master-export>\n    </div>\n      <pagination-service cursor=\"meta.cursor\" list=\"orders\" service=\"mangeOrdersService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n  </div>\n\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table st-table=\"orders\" class=\"table\" ng-class=\"{\'table-hover\' : orders.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(orders).length\">\n        <td colspan=\"9\">There is no PO in this status for now.</td>\n      </tr>\n      <tr ng-repeat=\"order in orders\" ng-class=\"{\'row-select\': order.selected}\" fadeout-row=\"order._id == highlightId\">\n        <td ng-show=\"showColumn(\'starred\')\" ng-click=\"$event.stopImmediatePropagation()\" class=\"star-cell\">\n          <i ng-click=\"starred(order)\" ng-attr-class=\"{{order.isStarred && \'fa fa-star star-hover\' || \'fa fa-star-o star-hover-o\' }}\"></i>\n        </td>\n        <td ng-show=\"showColumn(\'po_number\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.po_number}}\n        </td>\n        <td ng-show=\"showColumn(\'pr_number\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.pr_number}}\n        </td>\n        <td ng-show=\"showColumn(\'title\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.title}}\n        </td>\n        <td ng-show=\"showColumn(\'billing|company|descr\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.billing.company.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'supplier.descr\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.supplier[0].descr }}\n        </td>\n        <td ng-show=\"([\'SUBMITTED\', \'AWAITING_DELIVERY\', \'CLOSED\', \'DECLINED\', \'STARRED\', \'CANCELLED\'].indexOf(status) > -1) && showColumn(\'needed_at\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          <span ng-show=\"order.needed_at != null\">{{::(order.needed_at | date: \'dd MMM yyyy\')}}</span>\n        </td>\n        <td ng-show=\"([\'SUBMITTED\', \'AWAITING_DELIVERY\', \'CLOSED\', \'DECLINED\', \'STARRED\', \'CANCELLED\'].indexOf(status) > -1) && showColumn(\'created_at\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::(order.created_at | date: \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"status === \'CLOSED\' && showColumn(\'do_number\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::order.do_number}}\n        </td>\n        <td ng-show=\"([\'CLOSED\'].indexOf(status) > -1) && showColumn(\'status_date\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::(order.status_date | date: \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"([\'CANCELLED\'].indexOf(status) > -1) && showColumn(\'status_date\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::(order.status_date | date: \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"([\'AWAITING_DELIVERY\'].indexOf(status) > -1) && showColumn(\'received_percentage\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          <pie-chart data=\"[order.received_percentage*100, 100 - order.received_percentage*100]\" options=\"peiChart.options\"></pie-chart>\n          <span>{{ \" \" + (!order.received_percentage ? 0 : (order.received_percentage*100 | formatDecimal: 2)) + \"%\"}}</span>\n        </td>\n        <td ng-show=\"showColumn(\'net_total\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::(order.net_total | isoCurrency: order.currency.code :2)}}\n        </td>\n        <td ng-show=\"([\'AWAITING_DELIVERY\'].indexOf(status) > -1) && showColumn(\'updated_at\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::(order.updated_at | date: \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"([\'SUBMITTED\', \'AWAITING_DELIVERY\', \'DECLINED\', \'CLOSED\', \'STARRED\', \'ALL\'].indexOf(status) > -1) && showColumn(\'status\')\" ui-sref=\"main.user.orders.detail({id: order._id, status: status})\">\n          {{::changeStringCase(order.status)}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/positionManagement/assign/details.html","<div class=\"modal-content modal-inside width-700\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\" ng-show=\"!inEditMode\">Add New Position Assignment</h4>\n    <h4 class=\"modal-title\" ng-show=\"!!inEditMode\">Position Assignment</h4>\n  </div>\n  <form name=\"positionUpdateForm\">\n    <div class=\"modal-body\">\n\n      <!--for adding position assign-->\n      <div class=\"row\" ng-show=\"!inEditMode\">\n        <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Position Code\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <select class=\"form-control\" ng-model=\"selectedPosition\" ng-options=\"opt.id as opt.code for opt in positionListing | filter:{status:0}\" required>\n                </select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Company\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <ui-select class=\"ui-select-match-item-position-assign\" on-select=\"selectCompany(\'assign\')\" on-remove=\"selectCompany(\'unassign\')\" multiple=\"multiple\" sortable=\"true\" close-on-select=\"true\" limit=\"{{companyLimit}}\" ng-model=\"uiSelectCompanies.list\">\n                  <ui-select-match placeholder=\"Select company...\">{{$item.descr}}</ui-select-match>\n                  <ui-select-choices repeat=\"companyItem in companyListing | filter: {descr: $select.search}\">\n                    <div ng-bind-html=\"companyItem.descr | highlight: $select.search\"></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\" ng-hide=\"!!(costCenterLimit === 0) || checkPositionIsAdhoc(selectedPosition)\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Cost Center</label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <ui-select class=\"ui-select-match-item-position-assign\" on-select=\"selectCostCenter()\" on-remove=\"selectCostCenter()\" multiple=\"multiple\" sortable=\"true\" close-on-select=\"true\" limit=\"{{costCenterLimit}}\" ng-model=\"uiSelectCostCenter.list\">\n                  <ui-select-match placeholder=\"Select cost center...\">{{$item.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"ccItem in costCenterListing | filter: {descr: $select.search}\">\n                    <div ng-bind-html=\"ccItem.descr | highlight: $select.search\"></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\" ng-hide=\"checkPositionIsAdhoc(selectedPosition)\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">\n                User\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <select class=\"form-control\" ng-model=\"selectedUsername\" ng-options=\"opt.email as opt.display_name for opt in uiUsernameList | orderBy:\'display_name\'\" required>\n                </select>\n              </div>\n            </div>\n            <div class=\"form-group show-datepicker-clear-button\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Effective Date</label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <input type=\"input\" ng-click=\"openDatepicker($event)\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"uiEffectiveDate\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened\" min-date=\"startDateOptions.minDate\" datepicker-options=\"startDateOptions\" class=\"form-control pr-needed-by-input\">\n                \n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!--for editing position-->\n      <div class=\"row\" ng-show=\"inEditMode\">\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\"> Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\"> History</a>\n            </li>\n          </ul>\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{active : tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup pr-10 pl-10\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n                  <div class=\"form-horizontal\">\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Position</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" value=\"{{data.position_assignment.position.name}}\" ng-disabled=\"true\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Company</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" value=\"{{data.company.descr}}\" ng-disabled=\"true\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Cost Center</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" value=\"{{data.cost_center.descr}}\" ng-disabled=\"true\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">User</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" value=\"{{data.assignee_name}}\" ng-disabled=\"true\">\n                      </div>\n                    </div>\n                    <div class=\"form-group show-datepicker-clear-button\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Effective Date</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"input\" ng-click=\"openDatepicker($event)\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"uiEffectiveDate\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened\" min-date=\"startDateOptions.minDate\" datepicker-options=\"startDateOptions\" class=\"form-control pr-needed-by-input\" ng-disabled=\"!editClicked\">\n                        \n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Status\n                        <span class=\"asterisk-required\">*</span>\n                      </label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <select class=\"form-control\" ng-model=\"data.status\" ng-options=\"opt.id as opt.name for opt in status\" ng-disabled=\"!editClicked\" required>\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div id=\"tab-2\" class=\"tab-pane\" ng-class=\"{active : tab === 2}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"row m-t-xs m-b-xs\">\n                  <b>History Log :</b>\n                  <approval-engine-pagination callback-search=\"searchHistory(page)\" start-rec-no=\"metaDetail[\'startRecNo\']\" end-rec-no=\"metaDetail[\'endRecNo\']\" total-rec=\"metaDetail[\'totalRec\']\" total-page-number=\"metaDetail[\'totalPageNumber\']\" current-page-number=\"metaDetail[\'currentPageNumber\']\">\n                  </approval-engine-pagination>\n                </div>\n\n                <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n                  <table class=\"table\" ng-class=\"{\'table-hover\' : assignHistoryData.length > 1}\">\n                    <thead class=\"bg-color-lightgrey\">\n                      <th>Seq</th>\n                      <th>Username</th>\n                      <th>Action</th>\n                      <th>Date</th>\n                      <th>Changes</th>\n                    </thead>\n                    <tbody>\n                    <tr class=\"no-data\" ng-hide=\"assignHistoryData.length > 0\">\n                      <td colspan=\"9\">There are no records for now.</td>\n                    </tr>\n                    <tr ng-repeat=\"data in assignHistoryData track by $index\">\n                      <td>{{ $index+1+(10*metaDetail.currentPageNumber) }}</td>\n                      <td>{{ data.user.display_name }}</td>\n                      <td>{{ data.event }}</td>\n                      <td>{{ returnDate(data.created_at) | date:\'dd MMM yyyy h:mm a\' }}</td>\n                      <td>\n                        <div ng-repeat=\"log in data.log\">\n                          {{ log }}\n                        </div>\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n    <div class=\"modal-footer\">\n      <export-array-to-csv array-data=\"arrayData\" file-name=\"fileName\" trigger=\"triggerHistoryExport\">\n      </export-array-to-csv>\n      <button class=\"btn btn-primary pull-left ng-click-active\" ng-show=\"tab === 2\" ng-click=\"searchHistory(null, \'export\')\">\n        Export Log\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Cancel</button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editPositionAssign()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked && inEditMode && tab === 1\" class=\"btn btn-primary\" ng-click=\"updatePositionAssign()\">\n        Update\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked && !inEditMode\" class=\"btn btn-primary\" ng-click=\"addPositionAssign()\">\n        Save\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/positionManagement/assign/positionAssign.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-10\">\n\n  <div class=\"row\">\n    <div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 no-padding\">\n      <h3>Displaying Position Assignment List</h3>\n    </div>\n\n    <div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7 no-padding\">\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs ng-click-active\" ng-click=\"exportPosition()\">\n        Export Position Assignment\n      </button>\n      <generic-import module-name=\"Position Assignment\" params=\"importParams\">\n      </generic-import>\n      <button class=\"btn btn-primary pull-right mr-15 ng-click-active btn-xs\" ng-click=\"addPositionAssign()\">\n        Add Position Assignment\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--position-->\n        <b>Position code</b><br>\n        <ui-select ng-model=\"uiPositionCode.list\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a position\">{{$select.selected.code}}</ui-select-match>\n          <ui-select-choices repeat=\"positionItem in positionListing | filter: {code: $select.search}\">\n            <div ng-bind-html=\"positionItem.code | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--position-->\n        <b>Position name</b><br>\n        <ui-select ng-model=\"uiPosition.list\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a position\">{{$select.selected.name}}</ui-select-match>\n          <ui-select-choices repeat=\"positionItem in positionListing | filter: {name: $select.search}\">\n            <div ng-bind-html=\"positionItem.name | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--company-->\n        <b>Company</b><br>\n        <ui-select ng-model=\"uiCompany.list\" on-select=\"processCostCenterList()\" sortable=\"true\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a company\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"companyItem in companyListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"companyItem.descr | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--cost center-->\n        <b>Cost Center</b><br>\n        <ui-select ng-model=\"uiCostCenter.list\" sortable=\"true\" close-on-select=\"true\" ng-disabled=\"isCompanySelected()\">\n          <ui-select-match placeholder=\"Select a cost center...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"costCenterItem in costCenterListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(costCenterItem.descr | highlight: $select.search) + \' [\' + costCenterItem.code + \']\'\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    </div>\n  </div>\n\n  <div class=\"row no-padding\">\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <!--users-->\n        <b>Username</b><br>\n        <ui-select ng-model=\"uiUsername.list\" sortable=\"true\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a user\">{{$select.selected.display_name}}</ui-select-match>\n          <ui-select-choices repeat=\"userItem in userListing | orderBy:\'display_name\' | filter: {display_name: $select.search}\">\n            <div ng-bind-html=\"userItem.display_name | highlight: $select.search\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n      <div class=\"form-group\">\n        <b>Status</b><br>\n        <!--status-->\n        <ui-select class=\"\" ng-model=\"status.list\" close-on-select=\"true\">\n          <ui-select-match placeholder=\"Select a status ...\">{{$select.selected.descr}}</ui-select-match>\n          <ui-select-choices repeat=\"status in statusListing | filter: {descr: $select.search}\">\n            <div ng-bind-html=\"(status.descr | highlight: $select.search)\"></div>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n      <br>\n      <button class=\"btn btn-primary pull-left ng-click-active\" ng-click=\"resetSelection()\">\n        Reset\n      </button>\n      <button class=\"btn btn-primary pull-left ng-click-active ml-10\" ng-disabled=\"disableSearch\" ng-click=\"search(0)\">\n        Search\n      </button>\n    </div>\n    <div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\">\n      <br>\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <approval-engine-pagination callback-search=\"search(page)\" start-rec-no=\"meta.startRecNo\" end-rec-no=\"meta.endRecNo\" total-rec=\"meta.totalRec\" total-page-number=\"meta.totalPageNumber\" current-page-number=\"meta.currentPageNumber\">\n      </approval-engine-pagination>\n    </div>\n  </div>\n\n  <div class=\"container-fluid\">\n    <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n      <table class=\"table\" ng-class=\"{\'table-hover\' : positionAssign.length > 1}\">\n        <thead table-header available-headers=\"columns\" search-function=\"search(page,sortingCol,sortingOrder)\" is-approval-engine=\"true\" current-status=\"currentStatus\" class=\"bg-color-lightgrey\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"positionAssign.length > 0\">\n          <td colspan=\"9\">There are no records for now.</td>\n        </tr>\n        <tr ng-repeat=\"data in positionAssign track by $index\">\n          <td ng-show=\"visibleColumn(\'row\')\" ng-click=\"showDetails(data)\">\n            {{ $index + 1 + (limit * meta.currentPageNumber) }}\n          </td>\n          <td ng-show=\"visibleColumn(\'code\')\" ng-click=\"showDetails(data)\">\n            {{\n              data.position_assignment.position.code\n            }}{{\n              (data.position_assignment.organization_id === \'all\') ? \'-system\' : \'\';\n            }}\n          </td>\n          <td ng-show=\"visibleColumn(\'position\')\" ng-click=\"showDetails(data)\">\n            {{ data.position_assignment.position.name }}\n          </td>\n          <td ng-show=\"visibleColumn(\'company\')\" ng-click=\"showDetails(data)\">\n            {{data.company.descr}}\n          </td>\n          <td ng-show=\"visibleColumn(\'cost_center\')\" ng-click=\"showDetails(data)\">\n            {{data.cost_center.descr}}\n          </td>\n          <td ng-show=\"visibleColumn(\'assignee_name\')\" ng-click=\"showDetails(data)\">\n            {{data.assignee_name}}\n          </td>\n          <td ng-show=\"visibleColumn(\'type\')\" ng-click=\"showDetails(data)\">\n            {{ data.position_assignment.organization_type === \'cost_center\' ? \'cost center\' :\n               data.position_assignment.organization_type}}\n          </td>\n          <td ng-show=\"visibleColumn(\'effective_date\')\" ng-click=\"showDetails(data)\">\n            {{ data.effective_date ? (data.effective_date | date: \'dd MMM yyyy\') : \'\'}}\n          </td>\n          <td ng-show=\"visibleColumn(\'created_at\')\" ng-click=\"showDetails(data)\">\n            {{ returnDate(data.created_at) | date:\'dd MMM yyyy\' }}\n          </td>\n          <td ng-show=\"visibleColumn(\'created_by\')\" ng-click=\"showDetails(data)\">\n            {{ data.created_by }}\n          </td>\n          <td ng-show=\"visibleColumn(\'updated_at\')\" ng-click=\"showDetails(data)\">\n            {{ returnDate(data.updated_at) | date:\'dd MMM yyyy\' }}\n          </td>\n          <td ng-show=\"visibleColumn(\'updated_by\')\" ng-click=\"showDetails(data)\">\n            {{ data.updated_by }}\n          </td>\n          <td ng-show=\"visibleColumn(\'status\')\" ng-click=\"showDetails(data)\">\n            {{ returnStatus(data.status) }}\n          </td>\n          <!--<td ng-show=\"visibleColumn(\'remove\')\" ng-click=\"removePositionAssign(data)\" class=\"text-center\">-->\n            <!--<a ng-if=\"!!data.id\"><i class=\"fa fa-remove red-text\"></i></a>-->\n          <!--</td>-->\n        </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12 text-right\">\n        <approval-engine-pagination callback-search=\"search(page)\" start-rec-no=\"meta.startRecNo\" end-rec-no=\"meta.endRecNo\" total-rec=\"meta.totalRec\" total-page-number=\"meta.totalPageNumber\" current-page-number=\"meta.currentPageNumber\">\n        </approval-engine-pagination>\n      </div>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/positionManagement/manage/details.html","<div class=\"modal-content modal-inside width-700\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Position Details</h4>\n  </div>\n  <form name=\"positionUpdateForm\">\n    <div class=\"modal-body\">\n\n      <!--add position-->\n      <div class=\"row\" ng-show=\"editClicked && !inEditMode\">\n        <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n          <div class=\"form-horizontal\">\n\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Code\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.code\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Position\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.name\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Description\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.description\">\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Type\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <select class=\"form-control\" ng-model=\"positionDetails.position_type\" ng-options=\"opt.id as opt.name for opt in type\" required>\n                </select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Status\n                <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                <select class=\"form-control\" ng-model=\"positionDetails.status\" ng-options=\"opt.id as opt.name for opt in status\" required>\n                </select>\n              </div>\n            </div>\n\n          </div>\n        </div>\n      </div>\n\n      <!--edit position-->\n      <div class=\"row\" ng-show=\"inEditMode\">\n\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\"> Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\"> History</a>\n            </li>\n          </ul>\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{active : tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n                  <div class=\"form-horizontal\">\n\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Code</label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.code\" ng-disabled=\"!editClicked || inEditMode\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Position\n                        <span class=\"asterisk-required\">*</span>\n                      </label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.name\" ng-disabled=\"!editClicked\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Description\n                      </label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"positionDetails.description\" ng-disabled=\"!editClicked\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Type\n                        <span class=\"asterisk-required\">*</span>\n                      </label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <input ng-if=\"positionDetails.position_type === \'ad-hoc\'\" disabled=\"disabled\" type=\"text\" class=\"form-control\" ng-model=\"positionDetails.position_type\">\n                        <select class=\"form-control\" ng-if=\"positionDetails.position_type !== \'ad-hoc\'\" ng-model=\"positionDetails.position_type\" ng-options=\"opt.id as opt.name for opt in type\" ng-disabled=\"!editClicked\" required>\n                        </select>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 control-label\">Status\n                        <span class=\"asterisk-required\">*</span>\n                      </label>\n                      <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\">\n                        <select class=\"form-control\" ng-model=\"positionDetails.status\" ng-options=\"opt.id as opt.name for opt in status\" ng-disabled=\"!editClicked\" required>\n                        </select>\n                      </div>\n                    </div>\n\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div id=\"tab-2\" class=\"tab-pane\" ng-class=\"{active : tab === 2}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"row m-t-xs m-b-xs\">\n                  <b>History Log :</b>\n                  <approval-engine-pagination callback-search=\"searchHistory(page)\" start-rec-no=\"metaDetail[\'startRecNo\']\" end-rec-no=\"metaDetail[\'endRecNo\']\" total-rec=\"metaDetail[\'totalRec\']\" total-page-number=\"metaDetail[\'totalPageNumber\']\" current-page-number=\"metaDetail[\'currentPageNumber\']\">\n                  </approval-engine-pagination>\n                </div>\n\n                <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n                  <table class=\"table\" ng-class=\"{\'table-hover\' : positionHistoryData.length > 1}\">\n                    <thead class=\"bg-color-lightgrey\">\n                    <th>Seq</th>\n                    <th>Username</th>\n                    <th>Action</th>\n                    <th>Date</th>\n                    <th>Changes</th>\n                    </thead>\n                    <tbody>\n                    <tr class=\"no-data\" ng-hide=\"positionHistoryData.length > 0\">\n                      <td colspan=\"9\">There are no records for now.</td>\n                    </tr>\n                    <tr ng-repeat=\"data in positionHistoryData track by $index\">\n                      <td>{{$index+1+(10*metaDetail.currentPageNumber)}}</td>\n                      <td>{{ data.user.display_name }}</td>\n                      <td>{{ data.event }}</td>\n                      <td><span>{{ returnDate(data.created_at) | date:\'dd MMM yyyy h:mm a\' }}</span></td>\n                      <td><div ng-repeat=\"log in data.log\">{{ log }}</div></td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n    </div>\n    <div class=\"modal-footer\">\n      <export-array-to-csv array-data=\"arrayData\" file-name=\"fileName\" trigger=\"triggerHistoryExport\">\n      </export-array-to-csv>\n      <button class=\"btn btn-primary pull-left ng-click-active\" ng-show=\"tab === 2\" ng-click=\"searchHistory(null, \'export\')\">\n        Export Log\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editPosition()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked && inEditMode && tab === 1\" class=\"btn btn-primary\" ng-click=\"updatePosition()\">\n        Update\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked && !inEditMode\" class=\"btn btn-primary\" ng-click=\"addPosition()\">\n        Save\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/positionManagement/manage/positionManage.html","<div class=\"container-fluid general-listing row\">\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10 mt-10\">\n    <button class=\"btn btn-primary pull-right btn-xs ng-click-active\" ng-click=\"exportPosition()\">\n      Export Position\n    </button>\n    <generic-import module-name=\"Position\" params=\"importParams\">\n    </generic-import>\n    <button class=\"btn btn-primary pull-right btn-xs ng-click-active mr-15\" ng-click=\"add()\">\n      Add Position\n    </button>\n  </div>\n\n  <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    <div class=\"form-group\">\n      <b>Code</b><br>\n      <input type=\"text\" ng-model=\"positionCode\" class=\"form-control\" placeholder=\"Enter code\">\n    </div>\n  </div>\n  <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n    <div class=\"form-group\">\n      <b>Position</b><br>\n      <input type=\"text\" ng-model=\"positionName\" class=\"form-control\" placeholder=\"Enter position\">\n    </div>\n  </div>\n  <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n    <div class=\"form-group\">\n      <b>Status</b><br>\n      <!--status-->\n      <ui-select class=\"\" ng-model=\"status.list\" close-on-select=\"true\">\n        <ui-select-match placeholder=\"Select a status ...\">{{$select.selected.descr}}</ui-select-match>\n        <ui-select-choices repeat=\"status in statusListing | filter: {descr: $select.search}\">\n          <div ng-bind-html=\"(status.descr | highlight: $select.search)\"></div>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n  <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n    <br>\n    <button class=\"btn btn-primary ng-click-active\" ng-click=\"resetSelection()\">\n      Reset\n    </button>\n    <button class=\"btn btn-primary ng-click-active ml-10\" ng-click=\"search(0)\">\n      Search\n    </button>\n  </div>\n  <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n    <br>\n    <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n    </columns-selector>\n    <approval-engine-pagination callback-search=\"search(page)\" start-rec-no=\"meta.startRecNo\" end-rec-no=\"meta.endRecNo\" total-rec=\"meta.totalRec\" total-page-number=\"meta.totalPageNumber\" current-page-number=\"meta.currentPageNumber\">\n    </approval-engine-pagination>\n    <br>\n  </div>\n</div>\n\n<div class=\"container-fluid mt-10\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : positionData.length > 1}\">\n      <thead table-header available-headers=\"columns\" search-function=\"search(page,sortingCol,sortingOrder)\" is-approval-engine=\"true\" current-status=\"currentStatus\" class=\"bg-color-lightgrey\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"positionData.length > 0\">\n        <td colspan=\"9\">There are no records for now.</td>\n      </tr>\n      <tr ng-repeat=\"data in positionData track by $index\">\n        <td ng-show=\"visibleColumn(\'row\')\" ng-click=\"showDetails(data)\">\n          {{ $index + 1 + (limit * meta.currentPageNumber) }}\n        </td>\n        <td ng-show=\"visibleColumn(\'code\')\" ng-click=\"showDetails(data)\">\n          {{ data.code }}\n        </td>\n        <td ng-show=\"visibleColumn(\'name\')\" ng-click=\"showDetails(data)\">\n          {{ data.name }}\n        </td>\n        <td ng-show=\"visibleColumn(\'position_type\')\" ng-click=\"showDetails(data)\">\n          {{ data.position_type }}\n        </td>\n        <td ng-show=\"visibleColumn(\'updated_at\')\" ng-click=\"showDetails(data)\">\n          {{ returnDate(data.updated_at) | date:\'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"visibleColumn(\'updated_by\')\" ng-click=\"showDetails(data)\">\n          {{ data.updated_by }}\n        </td>\n        <td ng-show=\"visibleColumn(\'created_at\')\" ng-click=\"showDetails(data)\">\n          {{ returnDate(data.created_at) | date:\'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"visibleColumn(\'created_by\')\" ng-click=\"showDetails(data)\">\n          {{ data.created_by }}\n        </td>\n        <td ng-show=\"visibleColumn(\'status\')\" ng-click=\"showDetails(data)\">\n          {{ returnStatus(data.status) }}\n        </td>\n        <!--<td ng-show=\"visibleColumn(\'remove\')\" ng-click=\"removePosition(data)\" class=\"text-center\">-->\n          <!--<a ng-if=\"!!data.id\"><i class=\"fa fa-remove red-text\"></i></a>-->\n        <!--</td>-->\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12 text-right\">\n      <approval-engine-pagination callback-search=\"search(page)\" start-rec-no=\"meta.startRecNo\" end-rec-no=\"meta.endRecNo\" total-rec=\"meta.totalRec\" total-page-number=\"meta.totalPageNumber\" current-page-number=\"meta.currentPageNumber\">\n      </approval-engine-pagination>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/purchaseRequisitions/details/details-mobile.html","<div class=\"state_requisitions_details clearfix no-padding ml-15 mr-15\">\n\n  <div class=\"no-padding\">\n\n    <div class=\"row no-padding\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </div>\n\n    <div class=\"row no-padding\">\n      <h2 class=\"pull-left font-bold\">Purchase Requisitions </h2>\n    </div>\n\n    <div class=\"no-padding\">\n      <div class=\"fix-header\" fix-header height=\"true\" width=\"true\" padding=\"true\" top=\"true\">\n        <!--Div for PR Header -->\n        <purchase-requisition-header pr=\"PR\" shopping-mode-status=\"isShoppingMode()\" editing-state=\"getEditingPRState()\" cost-centers=\"costCenters\">\n        </purchase-requisition-header>\n      </div>\n      <pr-warning-block data=\"PR.pr_items\" ng-hide=\"isShoppingMode()\" pr=\"PR\" unavailable-items=\"PR.unavailable_item_lines\">\n      </pr-warning-block>\n    </div>\n\n    <div class=\"row no-padding\">\n\n      <!--Div for PR details Header -->\n      <purchase-requisition-details-header ng-hide=\"isShoppingMode()\" pr=\"PR\" editing-state=\"getEditingPRState()\" cost-centers=\"costCenters\" currency-list=\"currenciesList\">\n      </purchase-requisition-details-header>\n\n    </div>\n\n  </div>\n\n  <div class=\"no-padding ml-15 mr-15\">\n    <div class=\"row itemlist\" ng-hide=\"isShoppingMode()\">\n      <pr-item-list editing-state=\"getEditingPRState()\" pr=\"PR\">\n      </pr-item-list>\n    </div>\n  </div>\n\n  <div class=\"no-padding mt-10 mb-10\">\n    <supplier-note ng-hide=\"isShoppingMode()\" prid=\"PR._id\" editable=\"false\" status=\"PR.status\" items=\"PR.pr_items\">\n    </supplier-note>\n  </div>\n\n  <div ng-if=\"!isShoppingMode()\" class=\"no-padding\">\n    <comments-panel comments-object=\"PR\" comments-backup-object=\"backup_pr\" comments-module=\"PR\" comments-service=\"commentService\" contact-options=\"PR.approval_related_users\" delete-service=\"deleteService\">\n    </comments-panel>\n  </div>\n\n  <div ng-if=\"!isShoppingMode()\" class=\"no-padding margin-top\">\n    <attachments-block class=\"screen-section\" is-first-create=\"isFirstCreate\" profile=\"profile\" files=\"prAttachments\" single-attachment-service=\"singleAttachmentService\" attachment-param=\"attachmentParam\" attachment-url=\"attachmentUrl\" attachment-model=\"PR\">\n    </attachments-block>\n  </div>\n\n  <div class=\"no-padding mt-10\">\n    <approval-flow id=\"approval_id\" data=\"approvals\" requestor=\"PR.requestor\" preparer=\"PR.creator\" ng-show=\"(PR.status !== \'draft\' && !isShoppingMode()) ||\n      (PR.status === \'draft\' && !!PR.pr_items.length && !isShoppingMode())\" ischanged=\"getUpdatePRField()\" preview=\"approvalsPreview()\" waitingon=\"checkWaitingOn()\" pr=\"PR\">\n    </approval-flow>\n  </div>\n\n  <div class=\"no-padding mb-10\">\n    <div class=\"row\">\n      <div class=\"col-xs-12 col-sm-12 fixed-footer-div\">\n        <purchase-requisition-actions ng-hide=\"isShoppingMode()\" pr=\"PR\" editing-state=\"getEditingPRState()\" action-type=\"button\">\n        </purchase-requisition-actions>\n      </div>\n    </div>\n  </div>\n  <div ui-view></div>\n</div>\n");
$templateCache.put("app/purchaseRequisitions/details/details.html","<div class=\"state_requisitions_details clearfix\">\n\n  <div id=\"fixHeaderViewWidth\" class=\"row screen-section set-position-relative header-section\" ui-scrollfix=\"-15\">\n\n    <div id=\"fixHeaderDirective\" class=\"fix-header\" fix-header height=\"true\" width=\"true\" padding=\"true\" top=\"true\">\n      <!--Div for PR Header -->\n      <purchase-requisition-header pr=\"PR\" shopping-mode-status=\"isShoppingMode()\" editing-state=\"getEditingPRState()\" cost-centers=\"costCenters\">\n      </purchase-requisition-header>\n\n      <!--Div for PR actions (Approve, on-hold, delete, etc) -->\n      <purchase-requisition-actions ng-hide=\"isShoppingMode()\" pr=\"PR\" editing-state=\"getEditingPRState()\">\n      </purchase-requisition-actions>\n    </div>\n\n    <pr-warning-block data=\"PR.pr_items\" ng-hide=\"isShoppingMode()\" pr=\"PR\" unavailable-items=\"PR.unavailable_item_lines\">\n    </pr-warning-block>\n\n    <!--Div for PR details Header -->\n    <purchase-requisition-details-header ng-hide=\"isShoppingMode()\" pr=\"PR\" editing-state=\"getEditingPRState()\" cost-centers=\"costCenters\" currency-list=\"currenciesList\">\n    </purchase-requisition-details-header>\n\n  </div>\n\n  <div class=\"mb-35\" ng-class=\"{\'row ibox-content\': !!showDashboard}\" ng-hide=\"!showDashboard || isShoppingMode()\">\n    <budget-dashboard pr-budget=\"PR.budget\" pr-status=\"PR.status\" pr-id=\"PR._id\" show-dashboard=\"showDashboard\" source-currency=\"PR.currency\" source-company-id=\"PR.company._id\">\n    </budget-dashboard>\n  </div>\n\n  <div class=\"row itemlist\" ng-hide=\"isShoppingMode()\">\n    <pr-item-list editing-state=\"getEditingPRState()\" pr=\"PR\">\n    </pr-item-list>\n  </div>\n\n  <div class=\"row\">\n    <supplier-note ng-hide=\"isShoppingMode()\" prid=\"PR._id\" editable=\"!!(getEditingPRState() === \'editable\' ||\n      (isCurrentUserIsPAInApproval() && (PR.status === \'pending\' || PR.status === \'on_hold\')))\" status=\"PR.status\" items=\"PR.pr_items\">\n    </supplier-note>\n  </div>\n\n  <div class=\"row mt-30\">\n    <div ng-if=\"!isShoppingMode()\">\n      <comments-panel comments-object=\"PR\" comments-backup-object=\"backup_pr\" comments-module=\"PR\" comments-service=\"commentService\" contact-options=\"PR.approval_related_users\" delete-service=\"deleteService\">\n      </comments-panel>\n    </div>\n    <div ng-if=\"!isShoppingMode()\" class=\"mt-30\">\n      <attachments-block class=\"screen-section\" is-first-create=\"isFirstCreate\" profile=\"profile\" files=\"prAttachments\" single-attachment-service=\"singleAttachmentService\" attachment-param=\"attachmentParam\" attachment-url=\"attachmentUrl\" attachment-model=\"PR\">\n      </attachments-block>\n    </div>\n    <approval-flow class=\"mt-30\" id=\"approval_id\" data=\"approvals\" requestor=\"approvalFlowData.requested_by\" preparer=\"approvalFlowData.created_by\" ng-show=\"(PR.status !== \'draft\' && !isShoppingMode()) ||\n      (PR.status === \'draft\' && !!PR.pr_items.length && !isShoppingMode())\" ischanged=\"getUpdatePRField()\" preview=\"approvalsPreview()\" waitingon=\"checkWaitingOn()\" context=\"PR\">\n    </approval-flow>\n  </div>\n\n  <div ui-view></div>\n</div>\n\n");
$templateCache.put("app/purchaseRequisitions/manage/manage-mobile.html","<div class=\"container-fluid gray-bg fixed-top\" style=\"margin: 0 15px 0 15px\">\n\n  <div class=\"row\">\n    <div class=\"no-padding\">\n      <h2 class=\"pull-left\" style=\"margin-top: 3px; margin-right: 3px ;font-weight: bold\">Purchase Requisitions </h2>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 3px; margin-right: 3px ;font-weight: normal\">Displaying {{ ::status }}\n        PR </h3>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-7 no-padding-left btn-group pull-left share-tab-focus\" role=\"group\" ng-if=\"([\'draft\',\'pending\', \'approved\'].indexOf(status) > -1)\">\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'all\', \'btn-white\': selectedListTab !== \'all\'}\" ng-click=\"tabSelection(\'all\');\">\n        All\n      </button>\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'yours\', \'btn-white\': selectedListTab !== \'yours\'}\" ng-click=\"tabSelection(\'yours\');\">\n        Yours\n      </button>\n      <button type=\"button\" class=\"btn\" ng-hide=\"status === \'approved\' || status === \'pending\'\" ng-class=\"{\'btn-primary\': selectedListTab === \'shared\', \'btn-white\': selectedListTab !== \'shared\'}\" ng-click=\"tabSelection(\'shared\');\">\n        Shared with you\n      </button>\n      <button type=\"button\" class=\"btn\" ng-hide=\"status === \'approved\' || status === \'draft\'\" ng-class=\"{\'btn-primary\': selectedListTab === \'waiting\', \'btn-white\': selectedListTab !== \'waiting\'}\" ng-click=\"tabSelection(\'waiting\');\">\n        <i class=\"fa fa-flag\" ng-show=\"status === \'pending\'\"></i>\n        Waiting on you\n      </button>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"no-padding\" hidden>\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <multi-approval-action class=\"pull-right\" ng-if=\"status === \'pending\' && getSelectedRequisitions().length > 0\" get-selected-items=\"getSelectedRequisitions()\" show-on-hold=\"true\" type=\"Purchase Requisition(s)\">\n      </multi-approval-action>\n    </div>\n    <div class=\"mt-10\">\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"manageRequisitionsService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n\n<div class=\"container-fluid\" style=\"margin: 0 15px 0 15px\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <div class=\"panel panel-default\">\n      <table class=\"table table-bordered table-striped table-condensed table-responsive fixed-table-mobile\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\" condition=\"status\" multi-select-action=\"multiSelectPendingItems(status)\"></thead>\n\n        <tbody ng-if=\"!dataList.length\">\n        <tr class=\"no-data\">\n          <td colspan=\"4\">There is no PR in this status for now.</td>\n        </tr>\n        </tbody>\n\n        <tbody ng-repeat=\"requisition in dataList\" fadeout-row=\"requisition._id === highlightId\">\n        <tr>\n          <td ng-click=\"$event.stopImmediatePropagation()\" class=\"star-check-cell\">\n            <i ng-click=\"starringPR(requisition, checkStarred(requisition))\" ng-attr-class=\"{{ checkStarred(requisition) && \'fa fa-star star-hover\' ||\n               \'fa fa-star-o star-hover-o\' }}\">\n            </i>\n            <span class=\"sr-only\">{{ pr.starred && \'Starred\' || \'Not starred\' }}</span>\n          </td>\n          <td ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n            {{::requisition.company.descr}} <br>\n            <em>{{ requisition.reference }}</em>\n          </td>\n          <td ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n            <i ng-if=\"status === \'pending\' && displayFlag(requisition.waiting_on)\" title=\"Waiting on you\" class=\"fa fa-flag\">\n            </i>\n            <i ng-if=\"status === \'pending\' && requisition.flagged_escalated\" title=\"Escalated\" class=\"fa fa-flag-checkered\">\n            </i>\n            <i ng-if=\"requisition.status === \'on_hold\'\" title=\"On Hold\" class=\"label label-warning pull-right on-hold-label\">On Hold\n            </i>\n            {{::requisition.title}}\n          </td>\n          <td ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          <span ng-if=\"requisition.grand_total && requisition.currency.code\">\n            {{::(requisition.grand_total | isoCurrency: requisition.currency.code : 2 )}}\n          </span>\n          </td>\n          <td style=\"vertical-align: top\">\n\n            <i class=\"fa fa-chevron-circle-right fa-lg\" ng-show=\"!showDetails(requisition._id)\" ng-click=\"setShowDetailsId(requisition._id, \'show\')\" style=\"font-weight : bold\"></i>\n\n            <i class=\"fa fa-chevron-circle-down fa-lg\" ng-show=\"showDetails(requisition._id)\" ng-click=\"setShowDetailsId(requisition._id, \'hide\')\" style=\"font-weight : bold\"></i>\n\n          </td>\n        </tr>\n        <tr ng-show=\"showDetails(requisition._id)\">\n          <td colspan=\"4\">\n\n            <purchase-requisition-actions ng-if=\"showDetails(requisition._id)\" ng-hide=\"isShoppingMode()\" pr=\"requisition\" editing-state=\"getEditingPRState()\">\n            </purchase-requisition-actions>\n\n            <table class=\"details-td center\">\n              <tr>\n                <td>Waiting On</td>\n                <td style=\"color: #1ab394\">\n                  {{ requisition.waiting_on[0].display_name + ((requisition.waiting_on.length >= 2) ? \" + \" +\n                  (requisition.waiting_on.length - 1): \"\") }}\n                </td>\n              </tr>\n              <tr>\n                <td>Submitted On</td>\n                <td>{{ ::((requisition.submitted_at) | date: \'dd MMM yyyy\' ) }}</td>\n              </tr>\n              <tr>\n                <td>Progress</td>\n                <td>\n                  <pie-chart data=\"[requisition.progress, 100 - requisition.progress]\" options=\"peiChart.options\">\n                  </pie-chart>\n                  <span>{{ \" \" + (!requisition.progress ? 0 : (requisition.progress | formatDecimal: 2)) + \"%\"}}</span>\n                </td>\n              </tr>\n              <tr>\n                <td>Needed By</td>\n                <td>{{ requisition.needed_by_date | date: \'dd MMM yyyy\' }}</td>\n              </tr>\n              <tr>\n                <td>Creator</td>\n                <td>{{::requisition.creator.display_name}}</td>\n              </tr>\n              <tr>\n                <td>Requestor</td>\n                <td>{{ !requisition.requestor ? requisition.creator.display_name : requisition.requestor.display_name }}\n                </td>\n              </tr>\n              <tr>\n                <td>Created At</td>\n                <td>{{::(requisition.created_at | date: \'dd MMM yyyy\')}}</td>\n              </tr>\n              <tr>\n                <td>Updated At</td>\n                <td>{{::(requisition.updated_at | date: \'dd MMM yyyy\')}}</td>\n              </tr>\n              <tr>\n                <td>Cost Center</td>\n                <td style=\"color: #1ab394\">{{::requisition.cost_center.descr}}</td>\n              </tr>\n            </table>\n          </td>\n        </tr>\n\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/purchaseRequisitions/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{ ::status }} PR </h3>\n    </div>\n\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <master-export module-name=\"Purchase Requisitions\" collection=\"17\" disable-button=\"dataList.length < 0 || dataList.length === 0\">\n      </master-export>\n      <multi-approval-action class=\"pull-right\" ng-if=\"status === \'pending\' && getSelectedRequisitions().length > 0\" get-selected-items=\"getSelectedRequisitions()\" show-on-hold=\"true\" type=\"Purchase Requisition(s)\">\n      </multi-approval-action>\n    </div>\n\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"manageRequisitionsService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n\n    <div class=\"col-md-7 no-padding-left btn-group pull-left share-tab-focus\" role=\"group\" ng-if=\"([\'draft\',\'pending\', \'approved\'].indexOf(status) > -1)\">\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'all\', \'btn-white\': selectedListTab !== \'all\'}\" ng-click=\"tabSelection(\'all\');\">\n        All\n      </button>\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'yours\', \'btn-white\': selectedListTab !== \'yours\'}\" ng-click=\"tabSelection(\'yours\');\">\n        Yours\n      </button>\n      <button type=\"button\" class=\"btn\" ng-hide=\"status === \'approved\' || status === \'pending\'\" ng-class=\"{\'btn-primary\': selectedListTab === \'shared\', \'btn-white\': selectedListTab !== \'shared\'}\" ng-click=\"tabSelection(\'shared\');\">\n        Shared with you\n      </button>\n      <button type=\"button\" class=\"btn\" ng-hide=\"status === \'approved\' || status === \'draft\'\" ng-class=\"{\'btn-primary\': selectedListTab === \'waiting\', \'btn-white\': selectedListTab !== \'waiting\'}\" ng-click=\"tabSelection(\'waiting\');\">\n        <i class=\"fa fa-flag\" ng-show=\"status === \'pending\'\"></i>\n        Waiting on you\n      </button>\n    </div>\n  </div>\n\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table st-table=\"requisitions\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\" multi-select-action=\"multiSelectPendingItems(status)\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!dataList.length\">\n        <td colspan=\"9\">There is no PR in this status for now.</td>\n      </tr>\n      <tr ng-repeat=\"requisition in dataList\" fadeout-row=\"requisition._id === highlightId\">\n        <td ng-if=\"status === \'pending\'\">\n          <span ng-show=\"::(checkWaitingOnUser(requisition))\">\n            <input type=\"checkbox\" icheck ng-model=\"requisition.selected\">\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'star\')\" ng-click=\"$event.stopImmediatePropagation()\" class=\"star-check-cell\">\n          <i ng-click=\"starringPR(requisition, checkStarred(requisition))\" ng-attr-class=\"{{ checkStarred(requisition) && \'fa fa-star star-hover\' || \'fa fa-star-o star-hover-o\' }}\">\n          </i>\n          <span class=\"sr-only\">{{ pr.starred && \'Starred\' || \'Not starred\' }}</span>\n        </td>\n        <td ng-show=\"showColumn(\'reference\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{ requisition.reference }}\n        </td>\n        <td ng-show=\"showColumn(\'title\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          <i ng-if=\"status === \'pending\' && displayFlag(requisition.waiting_on)\" title=\"Waiting on you\" class=\"fa fa-flag\">\n          </i>\n          <i ng-if=\"status === \'pending\' && requisition.flagged_escalated\" title=\"Escalated\" class=\"fa fa-flag-checkered\">\n          </i>\n          <i ng-if=\"requisition.status === \'on_hold\'\" title=\"On Hold\" class=\"label label-warning pull-right on-hold-label\">On Hold\n          </i>\n          {{::requisition.title || \'Untitled Draft\'}}\n        </td>\n\n        <td ng-show=\"showColumn(\'waiting_on\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{ requisition.waiting_on[0].display_name + ((requisition.waiting_on.length >= 2) ? \" + \" +\n          (requisition.waiting_on.length - 1): \"\") }}\n        </td>\n\n        <td ng-show=\"showColumn(\'pos\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{ (requisition.pos[0] + ((requisition.pos.length - 1) === 1 ? \" + \" +\n          (requisition.pos.length - 1) + \" other\": (requisition.pos.length - 1) > 1 ? \" + \" +\n          (requisition.pos.length - 1) + \" others\": \"\")) }}\n        </td>\n\n        <td ng-show=\"showColumn(\'grand_total\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          <span ng-if=\"requisition.grand_total && requisition.currency.code\">\n            {{::(requisition.grand_total | isoCurrency: requisition.currency.code : 2 )}}\n          </span>\n        </td>\n\n        <td ng-show=\"showColumn(\'closed_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::(requisition.closed_at | date: \'dd MMM yyyy\')}}\n        </td>\n\n        <td ng-show=\"showColumn(\'submitted_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{ ::((requisition.submitted_at) | date: \'dd MMM yyyy\' ) }}\n        </td>\n\n        <td ng-show=\"showColumn(\'progress\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          <pie-chart data=\"[requisition.progress, 100 - requisition.progress]\" options=\"peiChart.options\">\n          </pie-chart>\n          <span>\n            {{ \" \" + (!requisition.progress ? 0 : (requisition.progress | formatDecimal: 2)) + \"%\"}}\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'needed_by_date\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{ requisition.needed_by_date | date: \'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"showColumn(\'creator|display_name\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::requisition.creator.display_name}}\n        </td>\n        <td ng-if=\"showColumn(\'requestor|display_name\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id, status: status})\">\n          {{ !requisition.requestor ? requisition.creator.display_name :\n          requisition.requestor.display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::(requisition.created_at | date: \'dd MMM yyyy\')}}\n        </td><td ng-show=\"showColumn(\'updated_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::(requisition.updated_at | date: \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"showColumn(\'company|descr\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::requisition.company.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'cost_center|descr\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{::requisition.cost_center.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'status\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{requisition.status | capitalize}}\n        </td>\n        <td ng-show=\"showColumn(\'withdrawn_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{requisition.withdrawn_at | date: \'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'withdrawer|display_name\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{requisition.withdrawer.display_name}}\n        </td>\n        <td ng-show=\"showColumn(\'deleted_at\')\" ui-sref=\"main.user.purchaseRequisitions.details({id: requisition._id})\">\n          {{requisition.marked_as_deleted_at | date: \'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'delete_button\')\">\n          <a ng-click=\"deletePR(requisition._id)\" ng-show=\"currentUser._id === requisition.creator._id\" class=\"btn btn-primary btn-xs\">\n            Delete PR\n          </a>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/reports/generate/generate.html","<div class=\"state_company_add\">\n  <span name=\"company_detail_form\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <fieldset class=\"form-horizontal\">\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">\n                  Report type:\n                </label>\n                <div class=\"col-sm-6\">\n                  <ui-select ng-model=\"reports.type\" on-select=\"generateOptionsBasedOnReportType($item)\">\n                    <ui-select-match placeholder=\"Select report type...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"report in reportTypes | filter: $select.search\">\n                      <span ng-bind-html=\"report.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n              </div>\n\n              <div ng-if=\"!!buSelect && (selectedSuppliers.length === 0)\">\n                <div class=\"form-group\">\n                  <label class=\"col-sm-3 control-label\">\n                    Business Units:\n                  </label>\n                  <div class=\"col-sm-6\">\n                    <ui-select ng-model=\"reports.businessId\" on-select=\"onSelectBusinessUnit(reports.businessId)\">\n                      <ui-select-match ng-attr-placeholder=\"Select Business Unit...\">\n                        {{$select.selected.descr}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"businessList in business | filter: $select.search | orderBy:sortedBusiness\">\n                        <span ng-bind-html=\"businessList.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                  </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"(!!businessUnitSelected && reports.type.code !== \'REQUISITION_COUNTER\' &&\n                            (selectedSuppliers.length=== 0)) || !!companyListSelect\">\n                  <label class=\"col-sm-3 control-label\">\n                    Company List:\n                  </label>\n                  <div class=\"col-sm-2\">\n                    <isteven-multi-select input-model=\"companyList\" output-model=\"selectedCompanies\" button-label=\"descr\" item-label=\"descr\" max-labels=\"0\" translation=\"multiselectTranslation\" max-height=\"200px\" helper-elements=\"all none filter\" on-item-click=\"onSelectSingle(\'company\' ,selectedCompanies)\" on-select-all=\"onSelectAll(\'company\', companyList)\" on-select-none=\"onSelectNone(\'company\')\" tick-property=\"ticked\" disable-property=\"disabled\" is-disabled=\"loading\">\n                    </isteven-multi-select>\n                  </div>\n                  <div class=\"col-sm-4 company-list\">\n                    <ol>\n                      <li ng-repeat=\"company in selectedCompanies\">{{ company.descr }}</li>\n                    </ol>\n                  </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"reports.type.code === \'BUDGET\'\">\n                  <label class=\"col-sm-3 control-label\">\n                    Cost Center (optional):\n                  </label>\n                  <div class=\"col-sm-2\">\n                    <isteven-multi-select input-model=\"costCenterList\" output-model=\"selectedCostCenters\" button-label=\"descr\" item-label=\"descr\" max-labels=\"0\" translation=\"multiselectTranslation\" max-height=\"200px\" helper-elements=\"all none filter\" on-item-click=\"onSelectSingle(\'costCenter\' ,selectedCostCenters)\" on-select-all=\"onSelectAll(\'costCenter\', costCenterList)\" on-select-none=\"onSelectNone(\'costCenter\')\" tick-property=\"ticked\" disable-property=\"disabled\" is-disabled=\"loading\">\n                    </isteven-multi-select>\n                  </div>\n                  <div class=\"col-sm-4 company-list\">\n                    <ol>\n                      <li ng-repeat=\"costCenter in selectedCostCenters\">{{ costCenter.descr }}</li>\n                    </ol>\n                  </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"reports.type.code === \'BUDGET\'\">\n                  <label class=\"col-sm-3 control-label\">\n                    Budget Generate Based On:\n                  </label>\n                  <div class=\"col-sm-6\">\n                  <ui-select ng-model=\"selectedBudgetType.list\">\n                    <ui-select-match placeholder=\"Select budget type...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"type in budgetType | filter: $select.search\">\n                      <span ng-bind-html=\"type.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group\" ng-if=\"!!supplierSelect && hasSupplierTagPermission() &&\n                          (selectedCompanies.length === 0)\">\n                <label class=\"col-sm-3 control-label\">\n                  Suppliers List:\n                </label>\n                <div class=\"col-sm-2\">\n                  <isteven-multi-select input-model=\"suppliersList\" output-model=\"selectedSuppliers\" button-label=\"descr\" item-label=\"descr\" max-labels=\"0\" translation=\"multiselectTranslation\" max-height=\"200px\" helper-elements=\"all none filter\" on-item-click=\"onSelectSingle(\'supplier\' ,selectedSuppliers)\" on-select-all=\"onSelectAll(\'supplier\', suppliersList)\" on-select-none=\"onSelectNone(\'supplier\')\" tick-property=\"ticked\" disable-property=\"disabled\" is-disabled=\"loading\">\n                  </isteven-multi-select>\n                </div>\n                <div class=\"col-sm-4 company-list\">\n                  <ol>\n                    <li ng-repeat=\"supplier in selectedSuppliers\">{{ supplier.descr }}</li>\n                  </ol>\n                </div>\n              </div>\n\n              <div class=\"form-group\" ng-if=\"!!spendReportBasedOn\">\n                <label class=\"col-sm-3 control-label\">\n                  Generate Spend Report based on:\n                </label>\n                <div class=\"col-sm-6\">\n                  <ui-select ng-model=\"selected.spendDateType\" on-select=\"onSelectDateType(selected.spendDateType)\">\n                    <ui-select-match ng-attr-placeholder=\"Select Date Type...\">\n                      {{$select.selected.name}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"type in spend_date_type\"> <!--filter: $select.search-->\n                      <span ng-bind-html=\"type.name \"></span> <!--| highlight: $select.search -->\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n              </div>\n\n              <div class=\"form-group\" ng-if=\"!!dateTypeSelect\">\n                <label class=\"col-sm-3 control-label\">\n                  Date Type:\n                </label>\n                <div class=\"col-sm-6\">\n                  <ui-select ng-model=\"selected.datetype\" on-select=\"onSelectDateType(selected.datetype)\">\n                    <ui-select-match ng-attr-placeholder=\"Select Date Type...\">\n                      {{$select.selected.name}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"type in date_type\"> <!--filter: $select.search-->\n                      <span ng-bind-html=\"type.name \"></span> <!--| highlight: $select.search -->\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n              </div>\n\n              <div class=\"form-group\" ng-if=\"!!dateSelect\">\n                <label class=\"col-sm-3 control-label\">\n                  Starting Date:\n                </label>\n                <div class=\"col-sm-2\">\n                  <div class=\"input-group\">\n                  <input type=\"input\" ng-click=\"openDatepicker($event, \'startDate\')\" placeholder=\"Start date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"startingDate.date\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.startDate\" datepicker-options=\"startDateOptions\" class=\"form-control\">\n                    \n                    <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'startDate\')\">\n                      <i class=\"fa fa-calendar\"></i>\n                    </button>\n                  </span>\n                  </div>\n                </div>\n                <label class=\"col-sm-2 control-label\">\n                  Ending Date:\n                </label>\n                <div class=\"col-sm-2\">\n                  <div class=\"input-group\">\n                    <input type=\"input\" ng-click=\"openDatepicker($event, \'endDate\')\" placeholder=\"End date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"endDate.date\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.endDate\" datepicker-options=\"endDateOptions\" class=\"form-control\">\n                    \n                    <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'endDate\')\">\n                      <i class=\"fa fa-calendar\"></i>\n                    </button>\n                  </span>\n                  </div>\n                </div>\n              </div>\n          </fieldset>\n          </div>\n        </div>\n      </div>\n</div>\n<div class=\"row\">\n  <div class=\"col-sm-3\"></div>\n  <div class=\"col-sm-6 m-b\">\n    <div class=\"col-sm-12 update-change text-right\">\n      <button class=\"btn btn-primary\" ng-click=\"generateReports(startingDate.date, endDate.date)\" ng-disabled=\"!!checkingReportStatus\">Generate\n      </button>\n    </div>\n  </div>\n</div>\n</span>\n</div>\n");
$templateCache.put("app/reports/logs/logs.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">\n        Displaying Report Logs\n      </h3>\n    </div>\n    <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n    </columns-selector>\n    <div class=\"col-md-7 no-padding\">\n      <pagination-service cursor=\"meta.cursor\" list=\"logs\" service=\"reportService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : logs.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(logs).length\">\n        <td colspan=\"9\">There are no Logs.</td>\n      </tr>\n      <tr ng-repeat=\"log in logs\" ng-click=\"logDetail(log)\" fadeout-row=\"log._id === highlightId\">\n        <td ng-class=\"{\'cursor-default\' : log.status !== 2}\" ng-show=\"showColumn(\'requestor_user.display_name\')\">{{log.requestor_user.display_name}}</td>\n        <td ng-class=\"{\'cursor-default\' : log.status !== 2}\" ng-show=\"showColumn(\'date\')\">{{log.date | date: \'dd MMM yyyy h:mm:ss a\'}}</td>\n        <td ng-class=\"{\'cursor-default\' : log.status !== 2}\" ng-show=\"showColumn(\'done_at\')\">{{log.done_at | date: \'dd MMM yyyy h:mm:ss a\'}}</td>\n        <td ng-class=\"{\'cursor-default\' : log.status !== 2}\" ng-show=\"showColumn(\'type\')\">{{:: getReportType(log.type)}}</td>\n        <td ng-class=\"{\'cursor-default\' : log.status !== 2}\" ng-show=\"showColumn(\'status\')\">{{:: getStatusName(log.status)}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/security/add/add-roleTemplate.html","<div class=\"container-fluid gray-bg fixed-top wrapper wrapper-content animated fadeInRight\" ng-if=\"!!selectedCompany\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"ibox\">\n        <div class=\"ibox-title role-title\">\n          <h5 class=\"col-sm-4\">\n            <a editable-text=\"managedRole.name\" buttons=\"no\" blur=\"submit\">\n              {{managedRole.name || \'Enter a name\'}}\n            </a>\n          </h5>\n          <h5 class=\"col-sm-7\">\n            <a editable-text=\"managedRole.descr\" buttons=\"no\" blur=\"submit\">\n              {{managedRole.descr || \'Enter a description\'}}\n            </a>\n          </h5>\n        </div>\n        <div class=\"ibox-content\">\n          <form method=\"get\" class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <div class=\"col-md-12\">\n                <table class=\"table\">\n                  <thead>\n                  <tr>\n                    <th>Class</th>\n                    <th class=\"text-center\">Create</th>\n                    <th class=\"text-center\">Read</th>\n                    <th class=\"text-center\">Update</th>\n                    <th class=\"text-center\">Delete</th>\n                    <th class=\"text-center\">Approve</th>\n                  </tr>\n                  </thead>\n\n                  <!-- Group 1 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'purchase requisition\' || class.className.toLowerCase() === \'purchase order\' ||\n                      class.className.toLowerCase() === \'goods received note\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                        <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm, option)\">\n                        </select>\n                        </span>\n                        <span ng-if=\"class.dropdown.length < 2\">\n                          <span>\n                            <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                          </span>\n                        </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 2 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'address book\' || class.className.toLowerCase() === \'business unit\' ||\n                      class.className.toLowerCase() === \'account code\' || class.className.toLowerCase() === \'exchange rate\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                        <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm, option)\">\n                        </select>\n                        </span>\n                        <span ng-if=\"class.dropdown.length < 2\">\n                          <span>\n                            <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                          </span>\n                        </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 3 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'contact\' || class.className.toLowerCase() === \'import catalog (details)\' ||\n                      class.className.toLowerCase() === \'import catalog (header)\' || class.className.toLowerCase() === \'item\' ||\n                      class.className.toLowerCase() === \'item detail\' || class.className.toLowerCase() === \'supplier\' ||  class.className.toLowerCase() === \'supplier tag\' ||\n                      class.className.toLowerCase() === \'unspsc\' || class.className.toLowerCase() === \'budget\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                        <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm, option)\">\n                        </select>\n                        </span>\n                        <span ng-if=\"class.dropdown.length < 2\">\n                          <span>\n                            <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                          </span>\n                        </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 4 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'commodity\' || class.className.toLowerCase() === \'currencies\' ||\n                      class.className.toLowerCase() === \'expense types\' || class.className.toLowerCase() === \'payment method\' || class.className.toLowerCase() === \'payment term\' ||\n                      class.className.toLowerCase() === \'tax\' || class.className.toLowerCase() === \'uom\' || class.className.toLowerCase() === \'reports\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                        <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm, option)\">\n                        </select>\n                        </span>\n                        <span ng-if=\"class.dropdown.length < 2\">\n                          <span>\n                            <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                          </span>\n                        </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n\n                </table>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-12 text-right\">\n                <button class=\"btn btn-white\" ng-click=\"cancelAddingARole()\">Cancel</button>\n                <button class=\"btn btn-primary\" ng-click=\"submitRole(\'added\')\">Submit</button>\n              </div>\n            </div>\n          </form>\n          <div ng-if=\"!selectedCompany\">\n            <div class=\"well\">\n              <h2 class=\"text-center\">Please Select a Company and a Role to update!</h2>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/security/edit/edit-roleTemplate.html","<div class=\"container-fluid gray-bg fixed-top wrapper wrapper-content animated fadeInRight\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"ibox\">\n        <div class=\"ibox-title\">\n          <h5>Edit {{managedRole.name}} Role</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <form ng-if=\"!!selectedCompany\" method=\"get\" class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Select permission</label>\n              <div class=\"col-sm-10\">\n                <div class=\"roles-list\">\n                  <div class=\"row permission-list\">\n                    <div class=\"col-md-3 role-wrapper\" ng-repeat=\"perm in permissionsClasses | filter: searchRole\">\n                      <div>\n                      <span ng-repeat=\"(key, value) in perm | filter: searchRole\">\n                        <div class=\"permission btn\" ng-click=\"openPermissionPanel(value, key)\">\n                          <label>\n                            {{value}}\n                          </label>\n                        </div>\n                      </span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-12 text-right\">\n                <button class=\"btn btn-white\" type=\"submit\" ui-sref=\"main.user.security.manage\">Cancel</button>\n                <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"submitRole(\'updated\')\">Submit</button>\n              </div>\n            </div>\n          </form>\n          <div ng-if=\"!selectedCompany\">\n            <div class=\"well\">\n              <h2 class=\"text-center\">Please Select a Company and a Role to update!</h2>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/security/edit/permissionsViewTemplate.html","<div class=\"container-fluid gray-bg fixed-top wrapper wrapper-content animated fadeInRight\">\n  <div ng-if=\"!selectedPermission\" id=\"security-companies\" class=\"row\">\n    <div class=\"col-sm-12\" ng-if=\"!!selectedCompany\" id=\"security-roles\">\n      <div class=\"ibox\">\n        <div class=\"ibox-title\">\n          <h5 class=\"col-sm-4\">\n            {{rolePreview.title}}\n          </h5>\n          <h5 class=\"col-sm-7\">\n            {{rolePreview.descr}}\n          </h5>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"roles-list\">\n            <div class=\"row\">\n              <div class=\"role-wrapper\">\n                <div class=\"col-md-6\">\n                  <div ng-if=\"userPerms.length > 0\">\n                  <table class=\"table\">\n                    <h2>PR/PO</h2>\n                    <thead>\n                    <th>Type</th>\n                    <th>Company</th>\n                    <th>Self</th>\n                    </thead>\n                    <tbody ng-repeat=\"preview in userPerms track by $index\">\n                    <tr>\n                      <td colspan=\"3\"><b>{{preview.className}}</b></td>\n                    </tr>\n                    <tr ng-repeat=\"action in preview.actions track by $index\">\n                      <td>\n                        {{action.permissions.subjectAction}}\n                      </td>\n                      <td>\n                        <span ng-if=\"action.domain !== \'Self\'\"><i class=\"fa fa-check-square\"></i></span>\n                      </td>\n                      <td>\n                        <span><i class=\"fa fa-check-square\"></i></span>\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                  </div>\n\n                  <div ng-if=\"adminPerms.length > 0\">\n                  <table class=\"table\">\n                    <h2>Administrative</h2>\n                    <thead>\n                    <th>Type</th>\n                    <th>Company</th>\n                    <th>Self</th>\n                    </thead>\n                    <tbody ng-repeat=\"preview in adminPerms track by $index\">\n                    <tr>\n                      <td colspan=\"3\"><b>{{preview.className}}</b></td>\n                    </tr>\n                    <tr ng-repeat=\"action in preview.actions track by $index\">\n                      <td>\n                        {{action.permissions.subjectAction}}\n                      </td>\n                      <td>\n                        <span ng-if=\"action.domain !== \'Self\'\"><i class=\"fa fa-check-square\"></i></span>\n                      </td>\n                      <td>\n                        <span><i class=\"fa fa-check-square\"></i></span>\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                  </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <button class=\"btn btn-white\" type=\"submit\" ng-click=\"back()\">Back</button>\n          <button class=\"btn btn-primary\" type=\"submit\" ui-sref=\"main.user.security.edit({id: managedRole._id})\">Edit</button>\n          <button class=\"btn btn-danger\" type=\"submit\" ng-click=\"deleteRole()\">Delete</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n");
$templateCache.put("app/security/manage/manageTemplate.html","<div class=\"container-fluid gray-bg fixed-top wrapper wrapper-content animated fadeInRight\" ng-if=\"!!selectedCompany && !!managedRole.name\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"ibox\">\n        <div class=\"ibox-title\">\n          <h5 class=\"col-sm-4\">\n            {{managedRole.name || \'\'}} - {{ !!managedRole.company_code ? managedRole.company_code : \'System Role\'}}\n          </h5>\n          <h5 class=\"col-sm-7\" ng-show=\"!editMode\">\n            {{managedRole.descr || \'\'}}\n          </h5>\n          <h5 class=\"col-sm-7\" ng-show=\"!!editMode\">\n            <a editable-text=\"managedRole.descr\" buttons=\"no\" blur=\"submit\">\n              {{managedRole.descr || \'Enter a description\'}}\n            </a>\n          </h5>\n        </div>\n        <div class=\"ibox-content\">\n          <form method=\"get\" class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <div class=\"col-md-12\">\n                <table class=\"table\">\n                  <thead>\n                  <tr>\n                    <th>Class</th>\n                    <th class=\"text-center\">Create</th>\n                    <th class=\"text-center\">Read</th>\n                    <th class=\"text-center\">Update</th>\n                    <th class=\"text-center\">Delete</th>\n                    <th class=\"text-center\">Approve</th>\n                  </tr>\n                  </thead>\n\n                  <!-- Group 1 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'purchase requisition\' || class.className.toLowerCase() === \'purchase order\' ||\n                      class.className.toLowerCase() === \'goods received note\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                      <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-show=\"!!editMode\" ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm)\">\n                        </select>\n                        <span ng-show=\"!editMode\">\n                          <span ng-if=\"perm.domain.name !== \'not allowed\'\">{{perm.domain.name}}</span>\n                          <span ng-if=\"perm.domain.name === \'not allowed\'\">\n                            <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n                          </span>\n                        </span>\n                      </span>\n                      <span ng-if=\"class.dropdown.length < 2\">\n                        <span ng-show=\"!!editMode\">\n                          <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                        </span>\n                        <i class=\"fa fa-check green-text\" ng-if=\"!!perm.checked && !editMode\"></i>\n                        <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n\n                      </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 2 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'address book\' || class.className.toLowerCase() === \'business unit\' ||\n                      class.className.toLowerCase() === \'account code\' || class.className.toLowerCase() === \'exchange rate\')\">\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                      <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-show=\"!!editMode\" ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm)\">\n                        </select>\n                        <span ng-show=\"!editMode\">\n                          <span ng-if=\"perm.domain.name !== \'not allowed\'\">{{perm.domain.name}}</span>\n                          <span ng-if=\"perm.domain.name === \'not allowed\'\">\n                            <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n                          </span>\n                        </span>\n                      </span>\n                      <span ng-if=\"class.dropdown.length < 2\">\n                        <span ng-show=\"!!editMode\">\n                          <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                        </span>\n                        <i class=\"fa fa-check green-text\" ng-if=\"!!perm.checked && !editMode\"></i>\n                        <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n\n                      </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 3 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'contact\' || class.className.toLowerCase() === \'import catalog (details)\' ||\n                      class.className.toLowerCase() === \'import catalog (header)\' || class.className.toLowerCase() === \'item\' ||\n                      class.className.toLowerCase() === \'item detail\' || class.className.toLowerCase() === \'supplier\' || class.className.toLowerCase() === \'supplier tag\' ||\n                       class.className.toLowerCase() === \'unspsc\' || class.className.toLowerCase() === \'budget\')\">\n\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                      <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-show=\"!!editMode\" ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm)\">\n                        </select>\n                        <span ng-show=\"!editMode\">\n                          <span ng-if=\"perm.domain.name !== \'not allowed\'\">{{perm.domain.name}}</span>\n                          <span ng-if=\"perm.domain.name === \'not allowed\'\">\n                            <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n                          </span>\n                        </span>\n                      </span>\n                      <span ng-if=\"class.dropdown.length < 2\">\n                        <span ng-show=\"!!editMode\">\n                          <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                        </span>\n                        <i class=\"fa fa-check green-text\" ng-if=\"!!perm.checked && !editMode\"></i>\n                        <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n\n                      </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n                  <tr>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                  </tr>\n                  <!-- Group 4 classes -->\n                  <tr ng-repeat=\"class in classPermissionsList | orderBy: \'className\'\" ng-if=\"!!class.className && (class.className.toLowerCase() === \'commodity\' || class.className.toLowerCase() === \'currencies\' ||\n                      class.className.toLowerCase() === \'expense types\' || class.className.toLowerCase() === \'payment method\' || class.className.toLowerCase() === \'payment term\' ||\n                      class.className.toLowerCase() === \'tax\' || class.className.toLowerCase() === \'uom\' || class.className.toLowerCase() === \'reports\')\">\n\n                    <td>{{class.className}}</td>\n                    <td ng-repeat=\"perm in class.val\" class=\"text-center\" class=\"col-md-6\">\n                      <span ng-if=\"class.dropdown.length > 1\">\n                        <select ng-show=\"!!editMode\" ng-model=\"perm.domain\" ng-options=\"option.name for option in class.dropdown track by option.name\" ng-change=\"editDropDown(perm)\">\n                        </select>\n                        <span ng-show=\"!editMode\">\n                          <span ng-if=\"perm.domain.name !== \'not allowed\'\">{{perm.domain.name}}</span>\n                          <span ng-if=\"perm.domain.name === \'not allowed\'\">\n                            <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n                          </span>\n                        </span>\n                      </span>\n                      <span ng-if=\"class.dropdown.length < 2\">\n                        <span ng-show=\"!!editMode\">\n                          <input type=\"checkbox\" icheck ng-model=\"perm.checked\" ng-click=\"editCheck(perm)\">\n                        </span>\n                        <i class=\"fa fa-check green-text\" ng-if=\"!!perm.checked && !editMode\"></i>\n                        <i class=\"fa fa-remove red-text\" ng-if=\"!perm.checked && !editMode\"></i>\n\n                      </span>\n                    </td>\n                    <td ng-if=\"class.val.length < 5\">&nbsp;</td>\n                  </tr>\n\n                </table>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-12 text-right\" ng-if=\"!!managedRole.company_code\">\n                <button class=\"btn btn-white\" ng-show=\"!editMode\" ng-click=\"enableEditing()\">Edit</button>\n                <button class=\"btn btn-danger\" ng-show=\"!!editMode\" ng-click=\"deleteRole()\">Delete</button>\n                <button class=\"btn btn-white\" ng-show=\"!!editMode\" ng-click=\"cancelEditing()\">Cancel</button>\n                <button class=\"btn btn-primary\" ng-show=\"!!editMode\" ng-click=\"submitRole(\'updated\')\">Submit</button>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"container-fluid gray-bg fixed-top wrapper wrapper-content animated fadeInRight\" ng-if=\"!!selectedCompany && !!managedRole.name\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"ibox\">\n        <div class=\"ibox-title\">\n          <h5 class=\"col-sm-12\">\n            Roles & Permissions History\n          </h5>\n        </div>\n        <div class=\"ibox-content\">\n          <history dependencies=\"historyDependencies\"></history>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/security/permissionsPanel/permissionsPanelTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h4 class=\"modal-title\">Permissions for {{permission}}</h4>\n  </div>\n  <div class=\"modal-body\" ng-repeat=\"perm in permissionsList track by $index\">\n    <div class=\"Create row\">\n      <input class=\"col-md-1\" type=\"checkbox\" ng-model=\"perm.checked\">\n      <label class=\"col-md-6\">{{perm.subjectAction}} </label>\n      <select class=\"col-md-3\" ng-model=\"perm.domain\" ng-options=\"option.name for option in domain\">\n      </select>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveSelection()\">Save</button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/security/rolesListing/rolesListing.html","<div class=\"state_roles_list\">\n  <div class=\"container-fluid gray-bg fixed-top\">\n    <div class=\"row\">\n      <div class=\"col-md-5 no-padding\">\n        <h3 class=\"pull-left\">Listing Roles</h3>\n\n      </div>\n      <div class=\"col-md-7 no-padding\">\n\n        <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n        </columns-selector>\n      </div>\n\n    </div>\n  </div>\n  <div class=\"container-fluid\">\n    <div class=\"row row-beauty\" style=\"overflow: auto\">\n      <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no roles in this company for now.</td>\n        </tr>\n        <tr ng-repeat=\"role in dataList\" ui-sref=\"main.user.security.edit({id: role._id, code: role.company_code})\">\n          <td ng-if=\"showColumn(\'name\')\">{{role.name}}</td>\n          <td ng-if=\"showColumn(\'type\')\">{{!!role.company_code ? \'Company\' : \'System\'}}</td>\n          <td ng-if=\"showColumn(\'descr\')\">{{role.descr}}</td>\n          <td ng-if=\"showColumn(\'creator.display_name\')\">{{role.creator.display_name}}</td>\n          <td ng-if=\"showColumn(\'created_at\')\">{{role.created_at | date:\'dd MMM yyyy\'}}</td>\n          <td ng-if=\"showColumn(\'updater.display_name\')\">{{role.updater.display_name}}</td>\n          <td ng-if=\"showColumn(\'updated_at\')\">{{role.updated_at | date:\'dd MMM yyyy\'}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/settings/PR-POSettings/PRPOSettingsTemplate.html","<h2>Company Settings</h2>\n<div class=\"state-master-data\">\n  <tab-drop-down data=\"tabData\" type=\"tabs\" active=\"tabData.active\">\n\n  </tab-drop-down>\n  <div>\n    <ul class=\"nav nav-tabs\">\n      <li ng-repeat=\"tab in tabs\" class=\"{{ tab.active ? \'active\' :\'\'}}\">\n        <a ng-click=\"changeTab(tab)\">{{tab.heading}}</a>\n      </li>\n    </ul>\n  </div>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/settings/adminSettings/adminSettings.html","\n<h2>Admin Configuration Page</h2>\n<div class=\"ibox-content no-padding border-left-right text-center\">\n  <div class=\"col-lg-12\">\n    <div class=\"panel-body\">\n      <div class=\"form-group\">\n        <div class=\"row\">\n\n          <label class=\"col-sm-2 control-label\">Password Expiration period: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.expiry\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"expiryDate in expiryDates | filter: $select.search\">\n                <span ng-bind-html=\"expiryDate.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Minimum Password Length: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.len\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"passLength in passwordLength | filter: $select.search\">\n                <span ng-bind-html=\"passLength.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Multicase Password: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.multicase\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"option in booleanArray | filter: $select.search\">\n                <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row text-grey\">\n          <label class=\"col-sm-2 control-label\">\n            The number of days a regular password remains valid before it expires.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            The minimum number of characters for the password.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            Indicates if password must contain upper and lower case chars (i.e. Abc).\n          </label>\n        </div>\n        <p>&nbsp</p>\n        <p>&nbsp</p>\n\n        <div class=\"row\">\n\n          <label class=\"col-sm-2 control-label\">Account inactive period: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.lock_after\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"inactiveDurations in inactiveDuration | filter: $select.search\">\n                <span ng-bind-html=\"inactiveDurations.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Password history count: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.history\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"passwordHistorys in passwordHistory | filter: $select.search\">\n                <span ng-bind-html=\"passwordHistorys.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Numbers Password: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.numbers\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"option in booleanArray | filter: $select.search\">\n                <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row text-grey\">\n          <label class=\"col-sm-2 control-label\">\n            The number of days before the account becomes inactive.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            The number previous passwords that cannot be reused.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            Indicates if password must contain numbers (e.g. abc123).\n          </label>\n        </div>\n        <p>&nbsp</p>\n        <p>&nbsp</p>\n\n        <div class=\"row\">\n\n          <label class=\"col-sm-2 control-label\">Failed login attempts: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.max_login_attempts\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"loginAttempt in loginAttempts | filter: $select.search\">\n                <span ng-bind-html=\"loginAttempt.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Maximum idle time: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.session_timeout\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"idleTimes in idleTime | filter: $select.search\">\n                <span ng-bind-html=\"idleTimes.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Symbols Password: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.symbols\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"option in booleanArray | filter: $select.search\">\n                <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row text-grey\">\n          <label class=\"col-sm-2 control-label\">\n            The number of failed login attempts before the user is blocked.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            The maximum idle time before the user is logged out.\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            Indicates if password must contain symbols (e.g. abc@!?).\n          </label>\n        </div>\n        <p>&nbsp</p>\n        <p>&nbsp</p>\n\n        <div class=\"row\">\n\n          <label class=\"col-sm-2 control-label\">Unlocked User After: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.unlock_after_minutes\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"unlockAfter in unlockAfterMinutes | filter: $select.search\">\n                <span ng-bind-html=\"unlockAfter.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n\n          <label class=\"col-sm-2 control-label\">Enable Auditing: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"settings.enable_auditing\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"option in booleanArray | filter: $select.search\">\n                <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row text-grey\">\n          <label class=\"col-sm-2 control-label\">\n            Unlock the account after set minutes of the last failed login attempt\n            (if the lock is caused by reaching the maximum allowed login attempts).\n          </label>\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label\">\n            Set enable auditing to true or false.\n          </label>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12 m-b\">\n      <div class=\"col-sm-4\"></div>\n      <div class=\"col-sm-4 update-change\">\n        <button class=\"btn btn-primary\" ng-click=\"submitSettings()\">\n          Apply\n        </button>\n        <button class=\"btn btn-white\" ng-click=\"cancelSubmit()\">\n          Cancel\n        </button>\n        <button class=\"btn btn-white\" ng-click=\"resetSettings()\">\n          Reset Settings\n        </button>\n      </div>\n      <div class=\"col-sm-4\"></div>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("app/settings/mainPanel/mainPanelSettingsTemplate.html","<div class=\"state_explore_apps_list\">\n    <div class=\"row row-beauty\">\n      <div class=\"apps-list\">\n        <div data-ng-repeat=\"setting in settings\">\n          <span>\n            <div class=\"wrapper\">\n              <button class=\"btn btn-info dim btn-lg\" type=\"button\" ui-sref=\"{{setting.key}}\"><i class=\"fa\">{{setting.title }}</i></button>\n            </div>\n          </span>\n        </div>\n      </div>\n    </div>\n</div>\n");
$templateCache.put("app/settings/tenantSettings/tenantSettings.html","<h2>Tenant Configuration Page</h2>\n<div class=\"ibox-content no-padding border-left-right text-center state-tenant-settings\">\n  <div class=\"col-lg-12\">\n    <div class=\"panel-body\">\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">Upload Tenant Logo: </label>\n          <div class=\"col-sm-2\">\n            <div flow-init flow-object=\"flowConfig\" flow-file-added=\"!!{png:1,jpg:1,jpeg:1}[$file.getExtension()]\" flow-files-submitted=\"$flow.upload()\" flow-file-success=\"isUploadImageSuccess($file, $message, $flow);\">\n              <div flow-btn ng-if=\"$flow.files[0]\">\n                <img class=\"profile-avatar\" flow-img=\"$flow.files[0]\">\n              </div>\n              <div flow-btn ng-if=\"$flow.isUploading()\">\n                Uploading...\n              </div>\n              <div flow-btn ng-if=\"!$flow.files[0]\">\n                <img class=\"profile-avatar\" image-error=\"assets/images/default-user.png\" ng-src=\"{{imageBasePath}}{{tenantImgUrl}}\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <br>\n      <br>\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">Foreign Exchange Rate Update Frequency: </label>\n          <div class=\"col-sm-2 m-b\">\n            <ui-select ng-model=\"tenantSetting.forex\">\n              <ui-select-match>\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"forex in forexUpdateFreq | filter: $select.search\">\n                <span ng-bind-html=\"forex.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">Terms and conditions: </label>\n          <div class=\"col-sm-5\">\n            <textarea placeholder=\"Terms and conditions\" type=\"text\" ng-model=\"tenantTermsAndConditions\" class=\"form-control terms-and-conditions-class\" rows=\"5\" cols=\"10\" wrap=\"hard\">\n             </textarea>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-10 m-b\">\n      <div class=\"col-sm-10 update-change\">\n        <button class=\"btn btn-primary\" ng-click=\"submitSettings()\">\n          Save\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"saveTenantInfo(true)\">\n          Save and Preview\n        </button>\n        <button class=\"btn btn-white\" ng-click=\"cancelSubmit()\">\n          Cancel\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("app/suppliersList/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" xmlns=\"http://www.w3.org/1999/html\">\n  <div class=\"state_suppliers_details\">\n\n    <span class=\"back-buttons ml-15\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-sm-11 change-action\">\n          <h2 style=\"text-align: left\">{{supplier.descr}}</h2>\n          <span class=\"waiting-on-title\">Last updated: </span>\n          <span class=\"dateshift\">{{supplier.updated_at | date:\'dd MMM yyyy h:mm a\'}}</span>\n          <br>\n          <span class=\"status\">Status:</span>\n          <span class=\"waiting-on-title\"> {{supplier.status | capitalize}} </span>\n        </div>\n\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier\'s Name\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier Code\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.mb_supplier_code}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  ROC/ROB/NRIC\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.reg_no}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Tax\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.tax.code}}\n\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  GST Registration Number\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.gst_code}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Preferred Currency\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.selectedCurrency.code}} - {{supplier.selectedCurrency.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Paid Up Capital\n                </label>\n                <div class=\"col-sm-5 m-b\">\n                  <label class=\"control-label\">\n                    {{supplier.selectedCurrency.code}}\n                  </label>\n                  {{supplier.paid_up_value}}\n                </div>\n                <div class=\"col-sm-2 m-b\">\n                  <label class=\"control-label\">\n                    Paid Up Capital Range\n                  </label>\n                </div>\n                <div class=\"col-sm-3 m-b\">\n                  <label class=\"control-label\">\n                    {{paidUpCategoryDescr}}\n                  </label>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Item/Commodity Code Supplied\n                </label>\n                <div class=\"col-sm-5 m-b\">\n                  <label class=\"control-label\">\n                    Primary Commodity\n                  </label>\n                </div>\n                <div class=\"col-sm-4 m-b\" ng-if=\"!!supplier.secondary_commodity\">\n                  <label class=\"control-label\">\n                    Secondary Commodity\n                  </label>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b supplierList-details\">\n                  {{supplier.primary_commodity.unique_name}} {{supplier.primary_commodity.descr}}\n                </div>\n                <div class=\"col-sm-4 m-b supplierList-details\" ng-if=\"!!supplier.secondary_commodity\">\n                  {{supplier.secondary_commodity.unique_name}} {{supplier.secondary_commodity.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Nature\n                </label>\n                <div class=\"col-sm-5\">\n                  <label class=\"control-label\">\n                    Primary\n                  </label>\n                </div>\n                <div class=\"col-sm-4\">\n                  <label class=\"control-label\">\n                    Secondary\n                  </label>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b supplierList-details\">\n                  {{supplier.selectedPrimaryBusinessNature.descr}}\n                </div>\n                <div class=\"col-sm-4 m-b supplierList-details\">\n                  {{supplier.selectedSecondaryBusinessNature.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Entity\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.selectedBusinessEntity.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Term\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.pay_terms.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Method\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.pay_method.descr}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Bumiputra Status\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"bumi in bumiputraStatus track by $index\">\n                    <input type=\"radio\" id=\"{{selection.bumi}}\" name=\"selectBumiputra\" ng-model=\"supplier.bumiputra_status\" ng-value=\"bumi.value\" ng-disabled=\"true\" ng-click=\"selectedBumiputra(bumi.value)\">\n                    &nbsp;&nbsp;{{bumi.descr}}\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Receiving PO Method\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_email\" ng-disabled=\"!editClicked\">\n                    &nbsp;&nbsp; Email\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_fax\" ng-disabled=\"!editClicked\">\n                    &nbsp;&nbsp; Fax\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_post\" ng-disabled=\"!editClicked\">\n                    &nbsp;&nbsp; Post\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"false\" class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Global Supplier\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.is_global_supplier\" ng-disabled=\"!editClicked\">\n                    &nbsp;&nbsp; Yes\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"false\" class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier Group\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <supplier-group hide-reason=\"false\" editable=\"false\" is-global=\"supplier.is_global_supplier\" data=\"supplier.bu_status\">\n                  </supplier-group>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Email\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.email || \'Not specified\'}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Phone\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.phone || \'Not specified\'}}\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Fax\n                </label>\n                <div class=\"col-sm-9 m-b supplierList-details\">\n                  {{supplier.fax || \'Not specified\'}}\n                </div>\n              </div>\n\n            <!-- Address -->\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Corresponding Address\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-lg-12 m-b supplierList-details\">\n                      {{address.line1}}\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-8 m-b supplierList-details\">\n                      {{address.line2}}\n                    </div>\n                    <div class=\"col-lg-4 m-b supplierList-details\">\n                      {{address.line3}}\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b supplierList-details\">\n                      {{address.postal_code}}\n                    </div>\n                    <div class=\"col-lg-4 m-b supplierList-details\">\n                      {{address.city}}\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b supplierList-details\">\n                      {{address.country}}\n                    </div>\n                    <div class=\"col-lg-4 m-b supplierList-details\">\n                      {{address.state}}\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Contact Person(s)\n                  <div>\n                    <i>( First contact is the primary contact )</i>\n                  </div>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row add-contact-person\">\n                    <div class=\"col-sm-4 contact-box\" ng-repeat=\"item in selectedContactPersons\">\n                      <a class=\"btn-btn-link pull-right remove-contact-stick\" ng-click=\"removeContact(item)\" ng-hide=\"!editClicked\">\n                        <span class=\"fa fa-trash-o\"></span>\n                      </a>\n                      <h3>\n                        <strong>{{item.first_name}}</strong>\n                      </h3>\n                      <address>\n                        Email: {{item.email}}<br>\n                        Phone: {{item.phone}}<br>\n                        Fax  : {{item.fax}}\n                      </address>\n                      <a class=\"edi-contact-button\" edit-contact=\"item\" updated-contact=\"onUpdatedContact(contact)\" ng-hide=\"!editClicked\">\n                        Edit\n                      </a>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <table class=\"table table-hover\">\n                  <tbody>\n                  <div>\n                    <branch-listing data=\"supplier.branches\" editable=\"false\" searchable=\"false\" selectable=\"false\">\n                    </branch-listing>\n                  </div>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Attach Additional File(s)\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <attachment-category module=\"Supplier\" data=\"supplier.attachments_descriptions\" editable=\"false\">\n                  </attachment-category>\n                </div>\n              </div>\n\n              <div style=\"clear:both\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <approval-flow class=\"screen-section\" id=\"approval_id\" data=\"approvals\" requestor=\"requestor\" ng-show=\"supplier.status.toLowerCase() == \'pending\'\">\n          </approval-flow>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"row\">\n          <h3 class=\"col-sm-1\">History</h3>\n          <div class=\"col-sm-12 m-b\" ng-if=\"!supplier.comments.data.length\">\n            <span>There is no history for this supplier yet</span>\n          </div>\n          <span ng-repeat=\"comment in supplier.comments.data.slice().reverse()\">\n            <div class=\"media-body ibox-content screen-section\">\n              <b>{{comment.commentator.display_name}}</b>\n              <span>{{comment.actionText}}</span>\n              <span class=\"pull-right\">{{comment.created_at | date : \'dd MMM yyyy @ h:mma\'}}</span>\n              <div class=\"well\">\n                {{comment.comment}}\n              </div>\n            </div>\n          </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n");
$templateCache.put("app/suppliersList/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 ng-hide=\"actionType === \'search\'\" class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{\n        status == \"black_listed\"? \"blacklisted\": status\n        }} Suppliers</h3>\n      <h3 class=\"pull-left\" ng-if=\"actionType === \'search\'\" style=\"margin-top: 7px; margin-right: 5px\">Searching result\n        of \"<i>{{ title }}</i>\"</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"suppliers\" service=\"supplierManageService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table id=\"dynamicHeightTable\" st-table=\"suppliers\" class=\"table\" dynamic-height tabindex=\"1\" ng-class=\"{\'table-hover\' : suppliers.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(suppliers).length\">\n        <td colspan=\"9\">There are no suppliers available.</td>\n      </tr>\n      <tr ng-repeat=\"supplier in suppliers\" ng-class=\"{\'row-select\': supplier.selected}\" fadeout-row=\"supplier._id == highlightId\" ui-sref=\"main.user.suppliersList.detail({id: supplier._id})\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{supplier.descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n          {{supplier.mb_supplier_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{supplier.reg_no || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{supplier.currency_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'email\')\">\n          {{supplier.email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n          {{supplier.contact_person[0].first_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.email\')\">\n          {{supplier.contact_person[0].email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.phone\')\">\n          {{supplier.contact_person[0].phone || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_business_nature\')\">\n          {{supplier.primary_business_nature || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n          {{supplier.primary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n          {{supplier.secondary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{(supplier.created_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{supplier.creator[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{(supplier.updated_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{supplier.updater[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"status === \'all\' && showColumn(\'status\')\">\n          {{::getStatusName(supplier.status, supplier.approval_status, supplier.draft_status) || \'N/A\'}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierTagging/supplierTagging-template.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5\">\n      <h3 class=\"pull-left\">Supplier Tagging</h3>\n    </div>\n    <div class=\"col-md-7\">\n    </div>\n  </div>\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"ibox-content\">\n    <span class=\"back-buttons ml-15\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n    <generic-import module-name=\"Supplier Tags\" params=\"params\">\n    </generic-import>\n\n    <div class=\"row supplier-tagging\">\n      <div class=\"col-md-12\">\n        <div class=\"col-md-6\">\n          <h3>Select a Company</h3>\n          <div class=\"row\">\n            <div class=\"container-fluid\">\n              <ui-select ng-model=\"tag.selectedCompany\" ng-change=\"selectCompany($select.selected)\">\n                <ui-select-match placeholder=\"Select a Company\">\n                  {{$select.selected.descr}}\n                </ui-select-match>\n                <ui-select-choices repeat=\"company in companiesList | filter: $select.search\">\n                  <span ng-bind-html=\"company.descr | highlight: $select.search\"></span>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n    <div class=\"row supplier-tagging\" ng-if=\"!!selectedCompanyCode\">\n\n      <div class=\"col-md-12\">\n        <div class=\"col-md-2\">\n          <h3>Select Supplier(s)</h3>\n        </div>\n      </div>\n      <div class=\"col-md-12\">\n        <div class=\"col-md-6\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"Search for supplier(s)\" ng-model=\"searchSuppliers.descr\">\n        </div>\n        <div class=\"col-md-6\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"Search for selected supplier(s)\" ng-model=\"searchSelectedSuppliers.descr\">\n        </div>\n      </div>\n\n      <div class=\"container-fluid\">\n        <div class=\"col-md-6\">\n          <div class=\"vertical-scroll-fixed-height\">\n            <table class=\"table\" ng-class=\"{\'table-hover\' : suppliersList.length > 1}\">\n              <thead>\n              <th>Supplier Name</th>\n              <th></th>\n              </thead>\n              <tbody>\n              <tr ng-repeat=\"supplier in suppliersList | filter: searchSuppliers | orderBy: \'descr\'\">\n                <td ng-click=\"selectSupplier(supplier)\">\n                  {{supplier.descr || \'N/A\'}}\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n        <div class=\"col-md-6\">\n          <div class=\"vertical-scroll-fixed-height\">\n            <table class=\"table\">\n              <thead>\n              <th>Selected Supplier(s)</th>\n              </thead>\n              <tbody>\n              <tr ng-repeat=\"supplier in selectedSuppliers | filter: searchSelectedSuppliers track by $index\" ng-if=\"selectedSuppliers.length > 0\">\n                <td class=\"label-primary\" ng-click=\"removeSupplier(supplier)\">\n                  {{supplier.descr || \'N/A\'}}\n                  <i class=\"fa fa-remove pull-right\"></i>\n                </td>\n              </tr>\n              <tr ng-if=\"selectedSuppliers.length < 1\">\n                <td>\n                  {{ !!loading ? \'Loading selected suppliers\' : \'No suppliers selected\' }}\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n          <span class=\"pull-right\">\n            <a class=\"btn btn-default\" ng-if=\"selectedSuppliers.length !== 0 && hasRemoveSupplierTagAccess()\" ng-click=\"removeAllSelectedSupplier()\">Remove All Selected Supplier(s)</a>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"row supplier-tagging\">\n        <div class=\"horizontal-align\">\n          <a class=\"btn btn-primary\" ng-click=\"createTag()\" ng-if=\"!loading\">Save Tag Selection</a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"state_requisitions_details container-fluid\">\n  <comments-panel ng-if=\"selectedCompanyCode\" comments-object=\"selectedCompanyCode\" comments-module=\"SupplierTag\" comments-service=\"commentService\">\n  </comments-panel>\n</div>\n");
$templateCache.put("app/suppliersManagement/detail/detail.html","<div class=\"wrapper wrapper-content animated fadeInRight\" xmlns=\"http://www.w3.org/1999/html\">\n  <div class=\"state_suppliers_details\">\n    <span class=\"back-buttons\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n    <div class=\"modal-body\">\n      <div id=\"fixHeaderViewWidth\" class=\"row\">\n        <div class=\"col-sm-11 change-action fixHeaderSupplier\" id=\"fixHeaderDirective\" fix-header height=\"true\">\n          <h2 style=\"text-align: left\">{{descrTitle}}</h2>\n          <div class=\"pull-left clear-floating-left\">\n            <h5 class=\"waiting-on-title\">Status: {{supplier.status | capitalize}}</h5>\n          </div>\n          <div class=\"pull-left clear-floating-left\" ng-if=\"supplier.status.toLowerCase() === \'pending\'\">\n            <h5 class=\"waiting-on-title\">\n              Status Details: {{supplier.submitted_from ? supplier.submitted_from : \'DRAFT\'}} <i class=\"fa fa-arrow-right\"></i>\n              <span class=\"supplier-current-status\">{{supplier.status | uppercase}}</span> <i class=\"fa fa-arrow-right\"></i>\n              {{supplier.original_status}}\n            </h5>\n          </div>\n          <span class=\"waiting-on-section pull-left clear-floating-left\" ng-show=\"supplier.status.toLowerCase() != \'pending\'\" ng-class=\"{\'waiting-on-access-directly\': !status}\">\n            <span class=\"waiting-on-title ml-0\">Last updated: </span>\n            <span class=\"dateshift\">{{supplier.updated_at | date:\'dd MMM yyyy h:mm a\'}}</span>\n          </span>\n          <div class=\"ml-15\">\n            <span ng-if=\"supplier.status.toLowerCase() === \'pending\'\">\n              <approval-waiting-on data=\"approvalFlowData\"></approval-waiting-on>\n            </span>\n          </div>\n          <span class=\"btn-group item-action pull-right clear-floating-right\" role=\"group\">\n            <a type=\"button\" class=\"btn btn-link mr-15\" ng-if=\"!!supplierDraftVersions && supplierDraftVersions.length > 1 && !pendingEditClicked\" ng-click=\"showDraftVersionList()\" ng-show=\"supplier.status.toLowerCase() === \'pending\'\">\n              <i class=\"fa fa-files-o\"></i>\n              <span>Compare with previous draft version</span>\n            </a>\n            <a type=\"button\" class=\"btn btn-link mr-15\" ng-if=\"!!supplierVersions && supplierVersions.length > 1 && !pendingEditClicked\" ng-click=\"showVersionList()\" ng-show=\"supplier.status.toLowerCase() === \'active\' || supplier.status.toLowerCase() === \'pending\'\">\n              <i class=\"fa fa-files-o\"></i>\n              <span ng-show=\"supplier.status.toLowerCase() === \'active\'\">Revision ({{supplierVersions.length}})</span>\n              <span ng-show=\"supplier.status.toLowerCase() === \'pending\'\">Compare with previous version</span>\n            </a>\n            <a id=\"editSupplierButton\" type=\"button\" class=\"btn btn-link mr-15\" ng-click=\"editSupplier()\" ng-if=\"!editClicked && !pendingEditClicked\" ng-show=\"supplier.status.toLowerCase() === \'draft\'\">\n              <i class=\"fa fa-pencil\"></i> Edit\n            </a>\n            <a ng-hide=\"supplier.status.toLowerCase() === \'black_listed\'\n               || (supplier.status.toLowerCase() === \'pending\'\n               && user._id !== supplier.created_by._id) || !editClicked\" ng-if=\"!pendingEditClicked\" class=\"btn btn-link mr-15\" ng-click=\"updateChanges(false)\">\n              <i class=\"fa fa-file-text\"></i> Save Changes\n            </a>\n            <a ng-hide=\"supplier.status.toLowerCase() === \'black_listed\' || !editClicked\" ng-if=\"!pendingEditClicked\" class=\"btn btn-link mr-15\" ng-click=\"revertUpdate()\" ng-disabled=\"!checkSupplierChanges()\">\n              <i class=\"fa fa-remove\"></i> Cancel\n            </a>\n            <a action-modal title=\"Confirm approve supplier?\" action-function=\"checkApprove()\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for approving the supplier\" body-message=\"This supplier will go through approval to be\n                {{ (!!supplier.original_status) ? supplier.original_status.toLowerCase() : supplier.status.toLowerCase() }}\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" ng-show=\"supplier.status.toLowerCase() === \'pending\' && checkWaitingOn() && !pendingEditClicked\" enable-attachment=\"true\" id=\"approveSupplier\" class=\"btn btn-link\">\n              <i class=\"fa fa-check\"></i> Approve\n            </a>\n            <a action-modal title=\"Confirm reject supplier?\" action-function=\"checkReject()\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for rejecting the supplier\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" ng-show=\"supplier.status.toLowerCase() === \'pending\' && checkWaitingOn() && !pendingEditClicked\" enable-attachment=\"true\" id=\"rejectSupplier\" class=\"btn btn-link\">\n              <i class=\"fa fa-times\"></i> Reject\n            </a>\n            <a id=\"submitSupplierButton\" ng-if=\"supplier.status.toLowerCase() === \'draft\' && !editClicked\" class=\"btn btn-link mr-15\" id=\"submitSupplier\" ng-click=\"updateStatus(\'submit\', false)\">\n              <i class=\"fa fa-arrow-circle-up\"></i> Submit\n            </a>\n            <a ng-if=\"supplier.status.toLowerCase() === \'pending\' && !editClicked && supplier.created_by._id === user._id\" class=\"btn btn-link mr-15\" ng-click=\"withdrawSupplier()\">\n              <i class=\"pr-action-icon fa fa-share-square\"></i> Withdraw\n            </a>\n\n            <!-- active statuses available actions -->\n            <span ng-show=\"supplier.status.toLowerCase() === \'active\' && !pendingEditClicked\">\n              <a ng-click=\"editActiveSupplier(supplier.status.toLowerCase())\" class=\"btn btn-link mr-15\">\n                <i class=\"fa fa-pencil-square-o\"></i> Edit Supplier\n              </a>\n              <a action-modal title=\"Confirm deactivate supplier?\" action-function=\"updateSupplierStatus(6)\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for deactivating the supplier\" body-message=\"This supplier will go through approval to be inactive\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" enable-attachment=\"true\" id=\"deactivateSupplier\" class=\"btn btn-link\">\n                  <i class=\"fa fa-times-circle-o\"></i> Deactivate Supplier\n              </a>\n              <!-- Blacklist -->\n              <a action-modal title=\"Confirm blacklist supplier?\" action-function=\"updateSupplierStatus(2)\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for blacklisting the supplier\" body-message=\"This supplier will go through approval to be blacklisted\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" enable-attachment=\"true\" id=\"blacklistSupplier\" class=\"btn btn-link\">\n                <i class=\"fa fa-lock\"></i> Move to Blacklist\n              </a>\n            </span>\n\n            <!-- Inactive Supplier-->\n            <a action-modal title=\"Confirm reactivate supplier?\" action-function=\"updateSupplierStatus(1)\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for reactivating the supplier\" body-message=\"This supplier will go through approval to be active\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" ng-show=\"supplier.status.toLowerCase() === \'inactive\' && !pendingEditClicked\" enable-attachment=\"true\" id=\"reactivateSupplier\" class=\"btn btn-link\">\n              <i class=\"fa fa-file\"></i> Reactivate Supplier\n            </a>\n\n            <!--Blacklisted Supplier-->\n            <a action-modal title=\"Confirm move blacklisted supplier to active?\" action-function=\"updateSupplierStatus(1)\" module=\"suppliers\" comment-key=\"status_reason\" comment-block=\"true\" comment-place-holder=\"State a reason for unblacklisting the supplier\" body-message=\"Supplier can be edited and submitted for reactivation approval\" extra-params=\"statusUpdatePayload\" error-handler=\"actionModalErrorHandler()\" enable-attachment=\"true\" id=\"unblacklistSupplierButton\" class=\"btn btn-link\" ng-show=\"supplier.status.toLowerCase() === \'black_listed\' && !pendingEditClicked\">\n                  <i class=\"fa fa-lock\"></i> Unblacklist Supplier\n              </a>\n\n            <!-- Rejected and Withdrawn Supplier-->\n            <a ng-click=\"reopenDraftSupplier(supplier.status)\" ng-show=\"(supplier.status.toLowerCase() === \'withdrawn\' && !pendingEditClicked ||\n                       supplier.status.toLowerCase() === \'rejected\') && supplier.created_by._id === user._id && !pendingEditClicked\" class=\"btn btn-link mr-15\">\n              <i class=\"fa fa-arrow-circle-up\"></i> Move to Draft\n            </a>\n\n            <!-- Edit pending Supplier -->\n          <a ng-if=\"supplier.status.toLowerCase() === \'pending\' && isEditableStatusChange() && checkWaitingOn() &&\n          !pendingEditClicked\" ng-click=\"requestEditableDraft()\" id=\"editPR\" class=\"pr-action-btn btn btn-link\">\n            <i class=\"pr-action-icon fa fa-pencil-square-o\"></i>Edit\n          </a>\n\n            <!-- Submit pending Supplier -->\n           <a id=\"submitPendingDraft\" type=\"button\" class=\"btn btn-link mr-15\" ng-click=\"submitEditableDraft()\" ng-if=\"pendingEditClicked\">\n            <i class=\"fa fa-arrow-circle-up\"></i> Submit Pending\n          </a>\n\n            <!-- Cancel pending Supplier -->\n          <a id=\"cancelPendingDraft\" type=\"button\" class=\"btn btn-link mr-15\" ng-click=\"cancelEditableDraft()\" ng-if=\"pendingEditClicked\">\n            <i class=\"fa fa-remove\"></i> Cancel Pending\n          </a>\n          </span>\n        </div>\n        <div class=\"col-lg-12 mt-10\">\n          <div class=\"panel-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier\'s Name <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input uppercase ng-class=\"{\'highlight-error-input\': (!updateDescr.length && submitted) || (updateDescr.length && descrCheck) || (!!descrFirstCharHyphen && submitted)}\" type=\"text\" ng-model=\"updateDescr\" class=\"form-control\" id=\"supplierDetailName\" placeholder=\"(Supplier\'s Name e.g. Maybank Berhad)\" ng-disabled=\"!editClicked\" ng-model-options=\"{ debounce: 100 }\" ng-pattern-restrict=\"[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-change=\"duplicationCheck(\'Supplier\',\'descr\',updateDescr,\'supplierDescr\'); checkHyphenFirstCharacter(updateDescr, \'descr\');\">\n                  <span class=\"text-danger\" ng-show=\"!updateDescr.length && submitted\">\n                    Supplier name is required\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"updateDescr.length && descrCheck\">\n                   Supplier Name {{updateDescr}} is already taken!\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"!!descrFirstCharHyphen && submitted\">\n                   Not allowed to enter hyphen as first character\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier Code <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"supplierCode\" type=\"text\" ng-model=\"update_code\" class=\"form-control\" readonly=\"readonly\">\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  ROC/ROB/NRIC\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n\n                <div class=\"col-sm-9 m-b\">\n                  <input uppercase type=\"text\" id=\"supplierRegNoField\" ng-model=\"updateRegNo\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-model-options=\"{ debounce: 100 }\" ng-class=\"{\'highlight-error-input\': (!updateRegNo.length && submitted) || (updateRegNo.length && rocCheck)}\" placeholder=\"(Supplier\'s ROC No. e.g. 3813-K)\" ng-pattern=\"/^[0-9A-Za-z-]{0,}$/\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-]{0,30}$\" ng-change=\"duplicationCheck(\'Supplier\',\'reg_no\',updateRegNo,\'roc\');\">\n                  <span class=\"text-danger\" ng-show=\"!updateRegNo.length && submitted\">\n                    ROC number required\n                  </span>\n\n                  <span class=\"text-danger\" ng-if=\"updateRegNo.length && rocCheck\">\n                    ROC number {{updateRegNo}} is already taken!\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Tax <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\':\n                            ((supplier.selectedTax == \'\' || supplier.selectedTax._id == null)\n                            && !!submitted)}\">\n                  <ui-select ng-model=\"supplier.selectedTax\" on-select=\"validateSelectedTax(supplier.selectedTax)\" ng-disabled=\"!editClicked\">\n                    <ui-select-match placeholder=\"Select tax...\">\n                      {{$select.selected.code}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"tax in taxes | filter: $select.search\">\n                      <span ng-bind-html=\"tax.code | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-if=\"(supplier.selectedTax == \'\' || supplier.selectedTax._id == null) && submitted\">\n                    Tax is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\" ng-show=\"!!supplier.selectedTax && !!supplier.selectedTax.code && (supplier.selectedTax.code !== \'NR0 - No Tax\')\">\n                <label class=\"col-sm-2 control-label\">\n                  GST Registration Number <span class=\"asterisk-required\">*</span>\n                </label>\n\n                <div class=\"col-sm-9 m-b\">\n                  <input type=\"text\" ng-model=\"update_gst_code\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': update_gst_code.length &&\n                              gstCheck || (!update_gst_code.length && submitted)}\" ng-disabled=\"!editClicked\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"(Supplier\'s GST Registration No. e.g. 000504664064)\" ng-pattern=\"/^[0-9-/]{0,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-/]{0,30}$\" ng-change=\"duplicationCheck(\'Supplier\',\'gst_code\',update_gst_code,\'gst\')\">\n                  <span class=\"text-danger\" ng-if=\"update_gst_code.length && gstCheck\">\n                    GST number {{update_gst_code}} is already taken!\n                  </span>\n\n                  <span class=\"text-danger\" ng-if=\"!update_gst_code.length && submitted\">\n                    GST no. is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Preferred Currency\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedCurrency && submitted}\">\n                  <ui-select ng-model=\"supplier.selectedCurrency\" ng-disabled=\"!editClicked\">\n                    <ui-select-match placeholder=\"Select Preferred Currency...\">\n                      {{$select.selected.code}} - {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"currency in currencies | filter: $select.search\">\n                      <span ng-bind-html=\"currency.code + \' - \' + currency.descr |\n                                      highlight: $select.search\">\n                      </span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedCurrency && submitted\">\n                    A Preferred Currency is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Paid Up Capital\n                </label>\n                <div class=\"col-sm-1 m-b\">\n                  <label class=\"control-label\">\n                    {{supplier.selectedCurrency.code}}\n                  </label>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <input type=\"number\" class=\"form-control\" placeholder=\"Enter capital amount\" ng-pattern=\"/^[0-9]{0,}$/\" ng-pattern-restrict=\"^([0-9]{0,50})$\" ng-disabled=\"!editClicked\" ng-model=\"update_paid_up_capital_amount\" ng-change=\"getPaidUpCategory()\">\n                </div>\n                <div ng-if=\"!!update_paid_up_capital_amount\" class=\"col-sm-5\">\n                  <div class=\"col-sm-5 m-b\">\n                    <label class=\"control-label\">\n                      Paid Up Capital Range\n                    </label>\n                  </div>\n                  <div class=\"col-sm-5 m-b\">\n                    <label class=\"control-label\">\n                      {{paidUpCategoryDescr}}\n                    </label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Item/Commodity Code Supplied\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-5 m-b\">\n                  <label class=\"control-label\">\n                    Primary Commodity\n                    <span class=\"asterisk-required\">*</span>\n                  </label>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <label class=\"control-label\">\n                    Secondary Commodity\n                  </label>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12\">\n                      <input ng-class=\"{\'highlight-error-input\': !supplier.primaryCommodity && submitted}\" type=\"text\" ng-model=\"primaryCommodityKeyword\" class=\"form-control\" ng-keyup=\"searchPrimaryCommodityCode(this.primaryCommodityKeyword); closeTreeSearchPrimary = false;\" placeholder=\"Search Commodities\" ng-disabled=\"!editClicked\">\n                    </div>\n                    <div class=\"col-md-12 mt-15\" ng-if=\"!!supplier.primaryCommodity\">\n                      <b>Selected Commodity: {{supplier.primaryCommodity.unique_name}} {{supplier.primaryCommodity.descr}}</b>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input tree-selection ng-model=\"supplier.primaryCommodity\" level=\"commodityLevel\" data=\"primaryCommodityCodes\" title=\"primaryCommodityKeyword\" action=\"openChildCommodityCodePrimary\" close-tree-search=\"closeTreeSearchPrimary\" selectable=\"commodity.selectable\">\n                    </div>\n                  </div>\n                  <span class=\"text-danger\" ng-show=\"!supplier.primaryCommodity && submitted\">\n                    A Primary Segment is required\n                  </span>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12\">\n                      <input type=\"text\" ng-model=\"secondaryCommodityKeyword\" class=\"form-control\" ng-keyup=\"searchSecondaryCommodityCode(this.secondaryCommodityKeyword); closeTreeSearchSecondary = false;\" placeholder=\"Search Commodities\" ng-disabled=\"!editClicked\">\n                    </div>\n                    <div class=\"col-md-12 mt-15\" ng-if=\"!!supplier.secondaryCommodity\">\n                      <b>Selected Commodity: {{supplier.secondaryCommodity.unique_name}} {{supplier.secondaryCommodity.descr}}</b>\n                      <a class=\"remove-commodity-in-supplier\" ng-hide=\"!editClicked\" ng-click=\"removeSecondaryCommodity()\"><i class=\"fa fa-remove red-text\"></i></a>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input tree-selection ng-model=\"supplier.secondaryCommodity\" level=\"commodityLevel\" data=\"secondaryCommodityCodes\" action=\"openChildCommodityCodeSecondary\" close-tree-search=\"closeTreeSearchSecondary\" title=\"secondaryCommodityKeyword\" selectable=\"commodity.selectable\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Nature\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-5\">\n                  <label>\n                    Primary\n                    <span class=\"asterisk-required\">*</span>\n                  </label>\n                </div>\n                <div class=\"col-sm-4\">\n                  <label>\n                    Secondary\n                  </label>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b\" ng-class=\"{\'ui-select-error-highlight\': (!supplier.selectedPrimaryBusinessNature &&\n                              submitted)  || (supplier.selectedPrimaryBusinessNature && validatedBN)}\">\n                  <ui-select ng-model=\"supplier.selectedPrimaryBusinessNature\" on-select=\"validatePrimaryBusinessNature(supplier.selectedPrimaryBusinessNature)\" ng-disabled=\"!editClicked\" required>\n                    <ui-select-match placeholder=\"Select a Primary Business Nature...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessNature in businessNatures | filter: $select.search\">\n                      <span ng-bind-html=\"businessNature.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedPrimaryBusinessNature && submitted\">\n                    A Primary Business Nature is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"supplier.selectedPrimaryBusinessNature && validatedBN\">\n                    Primary Business Nature cannot be the same as Secondary Business Nature\n                  </span>\n                </div>\n                <div class=\"col-sm-4 m-b\" ng-class=\"{\'ui-select-error-highlight\':(supplier.selectedSecondaryBusinessNature && validatedBN)}\">\n                  <ui-select ng-model=\"supplier.selectedSecondaryBusinessNature\" on-select=\"validateSecondaryBusinessNature(supplier.selectedSecondaryBusinessNature)\" ng-disabled=\"!editClicked\">\n                    <ui-select-match placeholder=\"Select a Secondary Business Nature...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessNature in businessNatures | filter: $select.search\">\n                      <span ng-bind-html=\"businessNature.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Entity\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedBusinessEntity && submitted}\">\n                  <ui-select ng-model=\"supplier.selectedBusinessEntity\" ng-disabled=\"!editClicked\" required>\n                    <ui-select-match placeholder=\"Select a Business Entity...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessEntity in businessEntities | filter: $select.search\">\n                      <span ng-bind-html=\"businessEntity.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedBusinessEntity && submitted\">\n                    A Business Entity is required\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Term\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedPaymentTerms && submitted}\">\n                  <ui-select ng-model=\"supplier.selectedPaymentTerms\" ng-disabled=\"!editClicked\">\n                    <ui-select-match placeholder=\"Select Payment Term...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"paymentTerm in paymentTerms | filter: $select.search\">\n                      <span ng-bind-html=\"paymentTerm.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedPaymentTerms && submitted\">\n                    A Payment Term is required\n                  </span>\n                </div>\n              </div>\n\n              <!--<label class=\"col-sm-2 control-label\">Freight Terms</label>-->\n              <!--<div class=\"col-sm-9 m-b\">-->\n                <!--<div class=\"row\">-->\n                  <!--<div class=\"col-sm-10\">-->\n                    <!--<ui-select ng-model=\"supplier.business_nature\" >-->\n                      <!--<ui-select-match placeholder=\"Select freight term...\">\n                            {{$select.selected.code}}&nbsp{{$select.selected.rate}}\n                          </ui-select-match>-->\n                      <!--<ui-select-choices\n                            repeat=\"freightTerm in freightTerms | filter: $select.search\">\n                            <span ng-bind-html=\"freightTerms.code | highlight: $select.search\"></span>\n                          </ui-select-choices>-->\n                    <!--</ui-select>-->\n                  <!--</div>-->\n                <!--</div>-->\n              <!--</div>-->\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Method\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedPaymentMethod && submitted}\">\n                  <ui-select ng-model=\"supplier.selectedPaymentMethod\" ng-disabled=\"!editClicked\">\n                    <ui-select-match placeholder=\"Select Payment Method...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"paymentMethod in paymentMethods | filter: $select.search\">\n                      <span ng-bind-html=\"paymentMethod.descr | highlight: $select.search\">\n                      </span> </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedPaymentMethod && submitted\">\n                    A Payment Method is required\n                  </span>\n                </div>\n              </div>\n\n              <!--<label class=\"col-sm-2 control-label\">JDE legacy Address Book No.</label>-->\n              <!--<div class=\"col-sm-9 m-b\">-->\n                <!--<div class=\"row\">-->\n                  <!--<div class=\"col-sm-10\">-->\n                    <!--<input type=\"text\" value=\"{{ supplier.reg_no }}\"\n                               placeholder=\"{{ supplier.reg_no }}\" class=\"form-control\" >-->\n                  <!--</div>-->\n                <!--</div>-->\n              <!--</div>-->\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Bumiputra Status\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"bumi in bumiputraStatus track by $index\">\n                    <input type=\"radio\" id=\"bumi-{{$index}}\" name=\"selectBumiputra\" ng-model=\"supplier.bumiputra_status\" ng-value=\"bumi.value\" ng-disabled=\"!editClicked\" ng-click=\"selectedBumiputra(bumi.value)\">\n                    &nbsp;&nbsp;<label for=\"bumi-{{$index}}\">{{bumi.descr}}</label>\n                  </div>\n                  <span class=\"text-danger\" ng-if=\"noBumiStatus && submitted\">\n                    Bumiputra status is required\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Receiving PO Method\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_email\" id=\"via-email\" ng-disabled=\"!editClicked\">\n                    <label for=\"via-email\">Email</label>\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_fax\" id=\"via-fax\" ng-disabled=\"!editClicked\">\n                    <label for=\"via-fax\">Fax</label>\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"supplier.receive_via_post\" id=\"via-post\" ng-disabled=\"!editClicked\">\n                    <label for=\"via-post\">Post</label>\n                  </div>\n                  <span class=\"text-danger\" ng-show=\"!supplier.receive_via_email &&\n                             !supplier.receive_via_fax && !supplier.receive_via_post && submitted\">\n                    PO Receiving Method is required\n                  </span>\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"false\" class=\"row\">\n              <label class=\"col-sm-2 control-label\">\n                Global Supplier <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b mt-10\">\n                <input type=\"checkbox\" ng-model=\"supplier.is_global_supplier\" id=\"is-global\" ng-disabled=\"!editClicked\">\n                <label for=\"is-global\">&nbsp; &nbsp;Yes</label>\n              </div>\n            </div>\n\n            <div ng-if=\"false\" class=\"row\">\n              <label class=\"col-sm-2 control-label\">\n                Supplier Group <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\">\n                <supplier-group hide-reason=\"false\" editable=\"editClicked\" is-global=\"supplier.is_global_supplier\" data=\"supplier.bu_status\">\n                </supplier-group>\n                <div class=\"text-danger\" ng-show=\"!supplier.bu_status.length && submitted && !supplier.is_global_supplier\">\n                  Supplier group is required\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <label class=\"col-sm-2 control-label\">\n                Company Email\n                <span ng-if=\"supplier.receive_via_email || (supplier.receive_via_email && !!submitted)\" class=\"asterisk-required\">\n                  *\n                </span>\n              </label>\n              <div class=\"col-sm-9 m-b\">\n                <input ng-class=\"{\'highlight-error-input\': !!update_email &&\n                            !validateEmail(update_email) && submitted ||\n                            (!update_email.length && supplier.receive_via_email && submitted)}\" type=\"text\" ng-model=\"update_email\" class=\"form-control\" validate-email ng-disabled=\"!editClicked\" placeholder=\"(Supplier\'s Company E-mail e.g. sunway@sunway.com)\">\n                <span class=\"text-danger\" ng-show=\"!!update_email && !validateEmail(update_email) && submitted\">\n                  Invalid email\n                </span>\n                <span class=\"text-danger\" ng-show=\"!update_email.length && supplier.receive_via_email && submitted\">\n                  An email is required\n                </span>\n              </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Phone\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"editSupplierCompanyPhone\" type=\"text\" ng-model=\"update_phone\" ng-change=\"validateNumbers(\'editSupplierCompanyPhone\', \'isValidPhoneNo\')\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': (!update_phone.length && submitted) || !isValidPhoneNo}\" ng-disabled=\"!editClicked\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)([0-9-+\\s]{0,50})$\" ng-intl-tel-input>\n                  <br>\n                  <span class=\"text-danger\" ng-show=\"!update_phone.length && submitted\">\n                    A phone number is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"!isValidPhoneNo\">\n                    Invalid phone number format\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Fax\n                  <span ng-if=\"supplier.receive_via_fax || (!!supplier.receive_via_fax && !!submitted)\" class=\"asterisk-required\">\n                    *\n                  </span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"editSupplierCompanyFax\" type=\"text\" ng-model=\"update_fax\" ng-change=\"validateNumbers(\'editSupplierCompanyFax\', \'isValidFaxNo\')\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': (!update_fax.length && supplier.receive_via_fax && submitted) ||\n                    !isValidFaxNo}\" ng-disabled=\"!editClicked\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-intl-tel-input>\n                  <br>\n                  <span class=\"text-danger\" ng-show=\"!update_fax.length && supplier.receive_via_fax && submitted\">\n                    A fax number is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"!isValidFaxNo\">\n                    Invalid fax number format\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Corresponding Address\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-lg-12 m-b\">\n                      <input type=\"text\" ng-model=\"address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !address.line1 && submitted}\" ucwords ng-disabled=\"!editClicked\">\n                      <span class=\"text-danger\" ng-show=\"!address.line1 && submitted\">\n                        An address line is required\n                      </span>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-8 m-b\">\n                      <input type=\"text\" ng-model=\"address.line2\" placeholder=\"Address Line 2\" class=\"form-control\" ucwords ng-disabled=\"!editClicked\">\n                    </div>\n                    <div class=\"col-lg-4 m-b\">\n                      <input type=\"text\" ng-model=\"address.line3\" placeholder=\"Address Line 3\" class=\"form-control\" ucwords ng-disabled=\"!editClicked\">\n                    </div>\n                  </div>\n\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b\">\n                      <input type=\"text\" ng-model=\"address.postal_code\" placeholder=\"Post Code\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !address.postal_code && submitted}\" ng-disabled=\"!editClicked\">\n                      <span class=\"text-danger\" ng-show=\"!address.postal_code && submitted\">\n                        A postal code is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\">\n                      <input type=\"text\" ng-model=\"address.city\" placeholder=\"City\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !address.city && submitted}\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-disabled=\"!editClicked\">\n                      <span class=\"text-danger\" ng-show=\"!address.city && submitted\">\n                        A city is required\n                      </span>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !address.country && submitted}\">\n                      <ui-select ng-model=\"address.country\" on-select=\"onUpdatedCountry(address.country)\" ng-disabled=\"!editClicked\" required>\n                        <ui-select-match placeholder=\"Select a country\">\n                          {{$select.selected}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"countryCodes in countries | filter: $select.search\">\n                          <span ng-bind-html=\"countryCodes.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.country && submitted\">\n                        A country is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !address.state && submitted}\" ng-if=\"!!selectedMalaysia\">\n                      <ui-select ng-model=\"address.state\" ng-disabled=\"!editClicked\" on-select=\"onUpdatedState(address.state)\" required>\n                        <ui-select-match placeholder=\"Select a state\">\n                          {{$select.selected}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                          <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.state && submitted\">\n                        A state is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\" ng-if=\"!selectedMalaysia\">\n                      <input type=\"text\" ng-model=\"address.state\" placeholder=\"State\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-class=\"{\'highlight-error-input\': !address.state && submitted}\" ng-pattern=\"/^[a-zA-Z-_\'/:;,.\\s]{2,}$/\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\">\n                      <span class=\"text-danger\" ng-show=\"!address.state && submitted\">\n                        A state is required\n                      </span>\n                    </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Contact Person(s)\n                  <span class=\"asterisk-required\">*</span>\n                  <div>\n                    <i>( First contact will be the primary contact )</i>\n                  </div>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row add-contact-person\" ng-if=\"!!selectedContactPersons && (selectedContactPersons[0] !== null)\">\n                    <div class=\"col-sm-4 contact-box\" ng-repeat=\"item in selectedContactPersons\">\n                      <a class=\"btn-btn-link pull-right remove-contact-stick\" ng-click=\"removeContact(item)\" ng-hide=\"!editClicked\">\n                        <span class=\"fa fa-trash-o\"></span>\n                      </a>\n                      <h3>\n                        <strong>{{item.first_name}}</strong>\n                      </h3>\n                      <address>\n                        Email: {{item.email}}<br>\n                        Phone: {{item.phone}}<br>\n                        Fax  : {{item.fax}}\n                      </address>\n                      <a class=\"edi-contact-button\" edit-contact=\"item\" updated-contact=\"onUpdatedContact(contact)\" ng-hide=\"!editClicked\">\n                        Edit\n                      </a>\n                    </div>\n                  </div>\n                  <div class=\"row add-contact-person\">\n                    <!-- FIXME: this is both true and false condition, (Ahmed Saleh, 22/3/2016) -->\n                    <button ng-class=\"{\'btn btn-success add-new-contact-button dropdown-toggle\': !(supplier.status === \'PENDING\'),\n                                       \'btn btn-default add-new-contact-button dropdown-toggle\': (supplier.status === \'PENDING\')}\" add-contact added-contact=\"onAddedContact(contact)\" uib-tooltip=\"Add a contact\" ng-hide=\"!editClicked\">\n                      <span class=\"fa fa-plus\"></span>\n                    </button>\n                  </div>\n                  <span class=\"text-danger\" ng-if=\"!selectedContactPersons.length && submitted\">\n                        A contact person is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-12\">\n                <branch-listing data=\"updateBranch\" editable=\"editClicked\" searchable=\"false\">\n                </branch-listing>\n              </div>\n            </div>\n            <div class=\"hr-line-dashed\"></div>\n            <div class=\"form-group\"></div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">Attach Additional File(s)</label>\n                <div class=\"col-sm-9 m-b\">\n                  <attachment-category module=\"Supplier\" host-class=\"Metabuyer-Models-Supplier\" object-id=\"supplier._id\" data=\"supplier.attachments_descriptions\" editable=\"editClicked\">\n                  </attachment-category>\n                </div>\n              </div>\n              <div style=\"clear:both\"></div>\n            </div>\n          </div>\n        </div>\n      <div class=\"form-group\"></div>\n      <div class=\"row\">\n        <approval-flow class=\"screen-section\" id=\"approval_id\" data=\"approvals\" requestor=\"requestor\" ng-show=\"supplier.status.toLowerCase() === \'pending\'\">\n        </approval-flow>\n      </div>\n      <div class=\"form-group\"></div>\n\n      <div class=\"row\">\n        <h3 class=\"col-sm-1\">History</h3>\n        <div class=\"col-sm-12 m-b\" ng-if=\"!supplier.comments.data.length\">\n          <span>There is no history for this supplier yet</span>\n        </div>\n        <span ng-repeat=\"comment in supplier.comments.data.slice().reverse()\">\n          <div class=\"media-body ibox-content screen-section supplier-comment\">\n            <b>{{comment.commentator.display_name}}</b>\n            <span>{{comment.actionText}}</span>\n            <span class=\"pull-right\">{{comment.created_at | date : \'dd MMM yyyy @ h:mma\'}}</span>\n            <div class=\"well\" ng-if=\"!!comment.comment\">\n              {{comment.comment}}\n              <span ng-if=\"!!comment.attachment\">\n                Attachment:\n                <span ng-click=\"downloadAttachment(comment.attachment)\">{{comment.attachment.ori_name}}</span>\n              </span>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/import/suppliersImportTemplate.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"row form-group\">\n    <div class=\"col-xs-3\">\n      <div class=\"pull-left\">\n        Upload Suppliers\n      </div>\n    </div>\n    <div class=\"col-xs-9\">\n      <input type=\"file\" file-model=\"submit_data.items\">\n    </div>\n  </div>\n  <div class=\"row form-group\">\n    <div class=\"col-xs-12\">\n        <b>** CSV files should be saved with UTF-8 encoding.</b>\n    </div>\n  </div>\n\n  <div ng-if=\"!!uploadError\" class=\"panel panel-danger\">\n    <div class=\"panel-heading\">\n      Error\n    </div>\n    <div class=\"panel-body\">\n      <div ng-if=\"!!errorArray\" ng-repeat=\"data in errorArray\">\n        <h3 ng-if=\"!!data.key && data.key > 0\">\n          <span ng-if=\"!isSuccessfullyImported(data.value)\">Error in</span>\n          Line {{ getLineNumber(data.key) }} :\n        </h3>\n        <h5 ng-if=\"!dataIsArray(data.value)\">{{data.value}}</h5>\n        <h5 ng-if=\"!!dataIsArray(data.value)\" ng-repeat=\"detail in data.value track by $index\">\n          <span>{{ detail }}</span>\n        </h5>\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" ng-click=\"importingSuppliers()\">Upload</button>\n</div>\n");
$templateCache.put("app/suppliersManagement/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 ng-hide=\"actionType === \'search\'\" class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{\n        status == \"black_listed\"? \"blacklisted\": status\n        }} Suppliers</h3>\n      <h3 class=\"pull-left\" ng-if=\"actionType === \'search\'\" style=\"margin-top: 7px; margin-right: 5px\">Searching result\n        of \"<i>{{ title }}</i>\"</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n\n      <span class=\"pull-right\">\n\n        <span ng-if=\"isCurrentUserSupplierManager()\">\n          <master-export module-name=\"Suppliers\" collection=\"10\">\n          </master-export>\n        </span>\n\n        <multi-approval-action ng-if=\"status === \'pending\' && getSelectedSuppliers().length > 0\" get-selected-items=\"getSelectedSuppliers()\" type=\"Supplier(s)\">\n        </multi-approval-action>\n\n      </span>\n\n      <pagination-service cursor=\"meta.cursor\" list=\"suppliers\" service=\"supplierManageService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table id=\"dynamicHeightTable\" st-table=\"suppliers\" class=\"table table-hover\" dynamic-height tabindex=\"1\">\n      <thead table-header available-headers=\"columns\" condition=\"status\" multi-select-action=\"multiSelectPendingItems(status)\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(suppliers).length\">\n        <td colspan=\"9\">There are no suppliers available.</td>\n      </tr>\n      <tr ng-repeat=\"supplier in suppliers\" ng-class=\"{\'row-select\': supplier.selected}\" fadeout-row=\"supplier._id == highlightId\" ui-sref=\"main.user.suppliers.detail({id: supplier._id, status: status})\">\n        <td ng-if=\"status === \'pending\'\">\n          <span ng-if=\"::(checkWaitingOnUser(supplier))\">\n            <input type=\"checkbox\" icheck ng-model=\"supplier.selected\">\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{supplier.descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n          {{supplier.mb_supplier_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{supplier.reg_no || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{supplier.currency_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'email\')\">\n          {{supplier.email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n          {{supplier.contact_person[0].first_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.email\')\">\n          {{supplier.contact_person[0].email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.phone\')\">\n          {{supplier.contact_person[0].phone || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_business_nature\')\">\n          {{supplier.primary_business_nature || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n          {{supplier.primary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n          {{supplier.secondary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{(supplier.created_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{supplier.creator[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{(supplier.updated_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{supplier.updater[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'blacklisted_by\')\">\n          {{supplier.blacklist_by.display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'blacklisted_reason\')\">\n          {{supplier.blacklist_reason || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'submittedFrom\')\">\n          {{::getOriginName(supplier.submittedFrom) || \'N/A\'}}\n        </td>\n        <td ng-show=\"status === \'all\' && showColumn(\'status\')\">\n          {{::getStatusName(supplier.status, supplier.approval_status, supplier.draft_status) || \'N/A\'}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/newSupplier/newSupplier.html","<div class=\"wrapper wrapper-content animated fadeInRight\">\n  <div class=\"state_suppliers_details\">\n    <div class=\"modal-body\">\n      <div id=\"fixHeaderViewWidth\" class=\"row\">\n        <div class=\"col-sm-11 change-action fixHeaderSupplier\" id=\"fixHeaderDirective\" fix-header height=\"true\">\n          <h2 class=\"text-left\">\n            Create New Draft Supplier\n          </h2>\n          <span class=\"btn-group item-action pull-right clear-floating-right\" role=\"group\">\n            <a class=\"btn btn-link mr-15\" ng-click=\"addNewSupplier(\'draft\')\">\n              <i class=\"fa fa-file-text\"></i> Save as draft\n            </a>\n            <a id=\"addSupplierSubmitButton\" class=\"btn btn-link mr-15\" ng-click=\"addNewSupplier(\'submit\')\">\n              <i class=\"fa fa-check\"></i> Submit\n            </a>\n            <a class=\"btn btn-link mr-15\" ng-click=\"backToListingSupplier()\">\n              Cancel\n            </a>\n          </span>\n        </div>\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <div class=\"form-group\">\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier\'s Name <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input uppercase id=\"addSupplierName\" type=\"text\" ng-model=\"supplier.descr\" class=\"form-control\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"(Supplier\'s Name e.g. MAYBANK BERHAD)\" ng-class=\"{\'highlight-error-input\': (!supplier.descr.length && !!saveAs) || !!descrFirstCharHyphen ||\n                                (supplier.descr.length && descrCheck)}\" ng-change=\"duplicationCheck(\'Supplier\',\'descr\',supplier.descr,\'supplierDescr\'); checkHyphenFirstCharacter(supplier.descr, \'descr\');\" ng-pattern-restrict=\"[0-9A-Z-_.(),&/\'\\s]{0,100}$\" required>\n                  <span class=\"text-danger\" ng-show=\"!supplier.descr.length && !!saveAs\">\n                    Supplier name is required\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"supplier.descr.length && descrCheck\">\n                   Supplier Name {{supplier.descr}} is already taken!\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"!!descrFirstCharHyphen\">\n                   Not allowed to enter hyphen as first character\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  ROC/ROB/NRIC <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input uppercase id=\"addSupplierROC\" type=\"text\" ng-class=\"{\'highlight-error-input\': (!supplier.reg_no.length && !!saveAs) ||\n                                (supplier.reg_no.length && rocCheck)}\" ng-model=\"supplier.reg_no\" class=\"form-control\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"(Supplier\'s ROC No. e.g. 3813-K)\" ng-pattern=\"/^[0-9A-Za-z-]{0,}$/\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-]{0,30}$\" ng-change=\"duplicationCheck(\'Supplier\',\'reg_no\',supplier.reg_no,\'roc\');\" required>\n                  <span class=\"text-danger\" ng-show=\"!supplier.reg_no.length && !!saveAs\">\n                    ROC number required\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"supplier.reg_no.length && rocCheck\">\n                    ROC no. {{supplier.reg_no}} is already taken!\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Tax <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\':\n                     ((supplier.selectedTax == \'\' || supplier.selectedTax._id == null) && saveAs === \'submit\')}\">\n                  <ui-select id=\"selectSupplierTax\" ng-model=\"supplier.selectedTax\" on-select=\"onSelectedTax(supplier.selectedTax)\">\n                    <ui-select-match id=\"supplierTax\" placeholder=\"Select tax...\">\n                      {{$select.selected.code}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"tax in taxes | filter: $select.search\">\n                      <span ng-bind-html=\"tax.code | highlight: $select.search\"></span>\n\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-if=\"(supplier.selectedTax == \'\' || supplier.selectedTax._id == null) && saveAs === \'submit\'\">\n                    Tax is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\" ng-show=\"!!supplier.selectedTax && (supplier.selectedTax.code !== \'NR0 - No Tax\')\">\n                <label class=\"col-sm-2 control-label\">\n                  GST Registration Number\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input type=\"text\" ng-model=\"supplier.gst_code\" class=\"form-control\" placeholder=\"(Supplier\'s GST Registration No. e.g. 000504664064)\" ng-pattern=\"/^[0-9-/]{0,}$/\" ng-model-options=\"{ debounce: 100 }\" ng-pattern-restrict=\"^(?!-)[0-9-/]{0,30}$\" ng-class=\"{\'highlight-error-input\': (supplier.gst_code.length && gstCheck) ||\n                                (!supplier.gst_code.length && saveAs)}\" ng-change=\"duplicationCheck(\'Supplier\',\'gst_code\',supplier.gst_code, \'gst\')\">\n                  <span class=\"text-danger\" ng-if=\"supplier.gst_code.length && gstCheck\">\n                    GST no. {{supplier.gst_code}} is already taken!\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"!supplier.gst_code.length && saveAs\">\n                    GST no. is required\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Preferred Currency <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedCurrency && saveAs === \'submit\'}\">\n                  <ui-select ng-model=\"supplier.selectedCurrency\" on-select=\"onSelectedCurrency(supplier.selectedCurrency)\">\n                    <ui-select-match placeholder=\"Select Preferred Currency...\">\n                      {{$select.selected.code}} - {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"currency in currencies | filter: $select.search\">\n                      <span ng-bind-html=\"currency.code + \' - \' + currency.descr |\n                                      highlight: $select.search\">\n                      </span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedCurrency && saveAs === \'submit\'\">\n                    A Preferred Currency is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Paid Up Capital\n                </label>\n                <div class=\"col-sm-1 m-b\">\n                  <label class=\"control-label\">\n                    {{supplier.currency_code}}\n                  </label>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <input id=\"addSupplierPaidUpCapital\" type=\"number\" class=\"form-control\" placeholder=\"Enter capital amount\" ng-pattern=\"/^[0-9]{0,}$/\" ng-pattern-restrict=\"^([0-9]{0,50})$\" ng-model=\"supplier.paid_up_capital_amount\" ng-change=\"getPaidUpCategory()\">\n                </div>\n                <div ng-if=\"!!supplier.paid_up_capital_amount\" class=\"col-sm-5\">\n                  <div class=\"col-sm-5 m-b\">\n                    <label class=\"control-label\">\n                      Paid Up Capital Range\n                    </label>\n                  </div>\n                  <div class=\"col-sm-5 m-b\">\n                    <label class=\"control-label\">\n                      {{paidUpCategoryDescr}}\n                    </label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Item/Commodity Code Supplied\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-5 m-b\">\n                  <label class=\"control-label\">\n                    Primary Commodity\n                    <span class=\"asterisk-required\">*</span>\n                  </label>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <label class=\"control-label\">\n                    Secondary Commodity\n                  </label>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12\">\n                      <input id=\"addSupplierPrimaryCommodity\" ng-class=\"{\'highlight-error-input\': !supplier.first_primary_commodity && saveAs === \'submit\'}\" type=\"text\" ng-model=\"primaryCommodityKeyword\" class=\"form-control\" ng-keyup=\"searchPrimaryCommodityCode(this.primaryCommodityKeyword); closeTreeSearchPrimary = false;\" placeholder=\"Search Commodities\">\n                    </div>\n                    <div class=\"col-md-12 mt-15\" ng-if=\"!!supplier.first_primary_commodity\">\n                      <b>Selected Commodity: {{supplier.first_primary_commodity.unique_name}} {{supplier.first_primary_commodity.descr}}</b>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input tree-selection ng-model=\"supplier.first_primary_commodity\" level=\"commodityLevel\" data=\"primaryCommodityCodes\" action=\"openChildCommodityCodePrimary\" title=\"primaryCommodityKeyword\" close-tree-search=\"closeTreeSearchPrimary\" selectable=\"commodity.selectable\">\n                    </div>\n                  </div>\n                  <span class=\"text-danger\" ng-show=\"!supplier.first_primary_commodity && saveAs === \'submit\'\">\n                    A Primary Commodity is required\n                  </span>\n                </div>\n                <div class=\"col-sm-4 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12\">\n                      <input type=\"text\" ng-model=\"secondaryCommodityKeyword\" class=\"form-control\" ng-keyup=\"searchSecondaryCommodityCode(this.secondaryCommodityKeyword); closeTreeSearchSecondary = false;\" placeholder=\"Search Commodities\">\n                    </div>\n                    <div class=\"col-md-12 mt-15\" ng-if=\"!!supplier.first_secondary_commodity\">\n                      <b>Selected Commodity: {{supplier.first_secondary_commodity.unique_name}} {{supplier.first_secondary_commodity.descr}}</b>\n                      <a class=\"remove-commodity-in-supplier\" ng-click=\"removeSecondaryCommodity()\"><i class=\"fa fa-remove red-text\"></i></a>\n                    </div>\n                    <div class=\"col-md-12\">\n                      <input tree-selection ng-model=\"supplier.first_secondary_commodity\" level=\"commodityLevel\" title=\"secondaryCommodityKeyword\" data=\"secondaryCommodityCodes\" action=\"openChildCommodityCodeSecondary\" close-tree-search=\"closeTreeSearchSecondary\" selectable=\"commodity.selectable\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Nature\n                </label>\n                <div class=\"col-sm-5\">\n                  <label>\n                    Primary\n                    <span class=\"asterisk-required\">*</span>\n                  </label>\n                </div>\n                <div class=\"col-sm-4\">\n                  <label>\n                    Secondary\n                  </label>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-sm-2\"></div>\n                <div class=\"col-sm-5 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.select_primary_business_nature && saveAs === \'submit\'}\">\n                  <ui-select id=\"selectSupplierPrimaryBusinessNature\" ng-model=\"supplier.select_primary_business_nature\" on-select=\"validatePrimaryBusinessNature(supplier.select_primary_business_nature)\" required>\n                    <ui-select-match placeholder=\"Select a Primary Business Nature...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessNature in businessNatures | filter: $select.search\">\n                      <span ng-bind-html=\"businessNature.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.select_primary_business_nature && saveAs === \'submit\'\">\n                    A Primary Business Nature is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"supplier.select_primary_business_nature && validatedBN\">\n                    Primary Business Nature cannot be the same as Secondary Business Nature\n                  </span>\n                </div>\n                <div class=\"col-sm-4 m-b\" ng-class=\"{\'highlight-error-input\':(supplier.select_secondary_business_nature && validatedBN)}\">\n                  <ui-select ng-model=\"supplier.select_secondary_business_nature\" on-select=\"validateSecondaryBusinessNature(supplier.select_secondary_business_nature)\">\n                    <ui-select-match placeholder=\"Select a Secondary Business Nature...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessNature in businessNatures | filter: $select.search\">\n                      <span ng-bind-html=\"businessNature.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Business Entity\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.select_business_entity &&\n                  saveAs === \'submit\'}\">\n                  <ui-select id=\"selectSupplierBusinessEntity\" ng-model=\"supplier.select_business_entity\" on-select=\"onSelectedBusinessEntity(supplier.select_business_entity)\">\n                    <ui-select-match placeholder=\"Select a Business Entity...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"businessEntity in businessEntities | filter: $select.search\">\n                      <span ng-bind-html=\"businessEntity.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.select_business_entity && saveAs === \'submit\'\">\n                    A Business Entity is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Term\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedPaymentTerms &&\n                                saveAs === \'submit\'}\">\n                  <ui-select id=\"selectSupplierPaymentTerms\" ng-model=\"supplier.selectedPaymentTerms\" on-select=\"onSelectedPaymentTerm(supplier.selectedPaymentTerms)\">\n                    <ui-select-match placeholder=\"Select Payment Term...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"paymentTerm in paymentTerms | filter: $select.search\">\n                      <span ng-bind-html=\"paymentTerm.descr | highlight: $select.search\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedPaymentTerms && saveAs === \'submit\'\">\n                    A Payment Term is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Payment Method\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !supplier.selectedPaymentMethod &&\n                                saveAs === \'submit\'}\">\n                  <ui-select id=\"selectSupplierPaymentMethod\" ng-model=\"supplier.selectedPaymentMethod\" on-select=\"onSelectedPaymentMethod(supplier.selectedPaymentMethod)\" required>\n                    <ui-select-match placeholder=\"Select Payment Method...\">\n                      {{$select.selected.descr}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"paymentMethod in paymentMethods | filter: $select.search\">\n                      <span ng-bind-html=\"paymentMethod.descr | highlight: $select.search\">\n                      </span> </ui-select-choices>\n                  </ui-select>\n                  <span class=\"text-danger\" ng-show=\"!supplier.selectedPaymentMethod && saveAs === \'submit\'\">\n                    A Payment Method is required\n                  </span>\n                </div>\n              </div>\n\n              <!--<label class=\"col-sm-2 control-label\">JDE legacy Address Book No.</label>-->\n              <!--<div class=\"col-sm-9 m-b\">-->\n              <!--<div class=\"row\">-->\n              <!--<div class=\"col-sm-10\">-->\n              <!--<input type=\"text\" value=\"{{ supplier.reg_no }}\"\n              placeholder=\"{{ supplier.reg_no }}\" class=\"form-control\" >-->\n              <!--</div>-->\n              <!--</div>-->\n              <!--</div>-->\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Bumiputra Status\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"bumi in bumiputraStatus track by $index\">\n                    <input type=\"radio\" id=\"bumi-{{$index}}\" name=\"selectBumiputra\" ng-model=\"supplier.bumiputra_status\" ng-value=\"bumi.value\" ng-click=\"selectedBumiputra(bumi.value)\">\n                    &nbsp;&nbsp;<label for=\"bumi-{{$index}}\">{{ bumi.descr }}</label>\n                  </div>\n                  <span class=\"text-danger\" ng-if=\"noBumiStatus && saveAs === \'submit\'\">\n                    Bumiputra status is required\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Receiving PO Method <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"receive_via_email\" id=\"via-email\">\n                    &nbsp;&nbsp; <label for=\"via-email\">Email</label>\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" name=\"receive_fax\" ng-model=\"receive_via_fax\" id=\"via-fax\">\n                    &nbsp;&nbsp; <label for=\"via-fax\">Fax</label>\n                  </div>\n                  <div class=\"m-r-xs checkbox-font-size\">\n                    <input type=\"checkbox\" ng-model=\"receive_via_post\" id=\"via-post\">\n                    &nbsp;&nbsp; <label for=\"via-post\">Post</label>\n                  </div>\n                  <span class=\"text-danger\" ng-if=\"(!receive_via_email && !receive_via_fax && !receive_via_post)\n                    && saveAs === \'submit\'\">\n                    PO Receiving Method is required\n                  </span>\n                </div>\n              </div>\n              <div ng-if=\"false\" class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Global Supplier <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b mt-10\">\n                  <input type=\"checkbox\" ng-model=\"supplier.is_global_supplier\" id=\"is-global\">\n                  <label for=\"is-global\">&nbsp; &nbsp;Yes</label>\n                </div>\n              </div>\n              <div ng-if=\"false\" class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Supplier Group <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <supplier-group hide-reason=\"true\" is-global=\"supplier.is_global_supplier\" editable=\"true\" data=\"supplier.bu_status\">\n                  </supplier-group>\n                  <div class=\"text-danger\" ng-show=\"!supplier.is_global_supplier && !supplier.bu_status.length && saveAs === \'submit\'\">\n                    Supplier group is required\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Email <span ng-if=\"!!receive_via_email\" class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"addSupplierCompanyEmail\" type=\"text\" ng-class=\"{\'highlight-error-input\': !supplier.email.length && receive_via_email && saveAs}\" ng-model=\"supplier.email\" class=\"form-control\" placeholder=\"(Supplier\'s Company E-mail e.g. sunway@sunway.com)\" ng-pattern=\"/^[A-Za-z0-9-_.]{1,}@{1}[A-Za-z0-9-_.]{1,}[.]{1}[A-Za-z0-9-_.]{2,}$/\" ng-pattern-restrict=\"^(?!-)([A-Za-z0-9-_.]{0,20}@?[A-Za-z0-9-_.]{0,20}[.]?[A-Za-z0-9-_.]{0,20})$\">\n                  <span class=\"text-danger\" ng-show=\"!supplier.email.length && receive_via_email && saveAs\">\n                    An email is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Phone <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"addSupplierCompanyPhone\" type=\"text\" ng-model=\"supplier.phone\" ng-change=\"validateNumbers(\'addSupplierCompanyPhone\', \'isValidPhoneNo\')\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': (!supplier.phone.length && saveAs === \'submit\') || !isValidPhoneNo}\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)([0-9-+\\s]{0,50})$\" ng-intl-tel-input required>\n                  <br>\n                  <span class=\"text-danger\" ng-show=\"!supplier.phone.length && saveAs === \'submit\'\">\n                    A phone number is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"!isValidPhoneNo\">\n                    Invalid phone number format\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Company Fax <span class=\"asterisk-required\" ng-if=\"!!receive_via_fax\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <input id=\"addSupplierCompanyFax\" type=\"text\" ng-model=\"supplier.fax\" ng-change=\"validateNumbers(\'addSupplierCompanyFax\', \'isValidFaxNo\')\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': (!supplier.fax.length && receive_via_fax && saveAs === \'submit\')\n                    || !isValidFaxNo}\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-intl-tel-input>\n                  <br>\n                  <span class=\"text-danger\" ng-show=\"!supplier.fax.length && receive_via_fax && saveAs === \'submit\'\">\n                    A fax number is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"!isValidFaxNo\">\n                    Invalid fax number format\n                  </span>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Corresponding Address\n                  <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row\">\n                    <div class=\"col-lg-12 m-b\">\n                      <input ucwords type=\"text\" id=\"addSupplierAddressLine1\" ng-class=\"{\'highlight-error-input\': !address.line1 && saveAs === \'submit\'}\" ng-model=\"address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" required>\n                      <span class=\"text-danger\" ng-show=\"!address.line1 && saveAs === \'submit\'\">\n                        An address line is required\n                      </span>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-8 m-b\">\n                      <input ucwords type=\"text\" ng-model=\"address.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n                    </div>\n                    <div class=\"col-lg-4 m-b\">\n                      <input ucwords type=\"text\" ng-model=\"address.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b\">\n                      <input id=\"addSupplierAddressPostalCode\" type=\"text\" ng-class=\"{\'highlight-error-input\': !address.postal_code && saveAs === \'submit\'}\" ng-model=\"address.postal_code\" placeholder=\"Post Code\" class=\"form-control\">\n                      <span class=\"text-danger\" ng-show=\"!address.postal_code && saveAs === \'submit\'\">\n                        A postal code is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\">\n                      <input ucwords id=\"addSupplierAddressCity\" type=\"text\" ng-class=\"{\'highlight-error-input\': !address.city && saveAs === \'submit\'}\" ng-model=\"address.city\" placeholder=\"City\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" class=\"form-control\" required>\n                      <span class=\"text-danger\" ng-show=\"!address.city && saveAs === \'submit\'\">\n                        A city is required\n                      </span>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !address.country && saveAs === \'submit\'}\">\n                      <ui-select id=\"selectSupplierAddressCountry\" ng-model=\"address.country\" on-select=\"onSelectedCountry(address.country)\" required>\n                        <ui-select-match placeholder=\"Select a country\">\n                          {{$select.selected}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"countryCodes in countries | filter: $select.search\">\n                          <span ng-bind-html=\"countryCodes.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.country && saveAs === \'submit\'\">\n                        A country is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\" ng-if=\"!selectedMalaysia\">\n                      <input ucwords type=\"text\" ng-class=\"{\'highlight-error-input\': !address.state && saveAs === \'submit\'}\" ng-model=\"address.state\" placeholder=\"State\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" class=\"form-control\" required>\n                      <span class=\"text-danger\" ng-show=\"!address.state && saveAs === \'submit\'\">\n                        A state is required\n                      </span>\n                    </div>\n                    <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !address.state && saveAs === \'submit\'}\" ng-if=\"!!selectedMalaysia\">\n                      <ui-select id=\"selectSupplierAddressState\" ng-model=\"address.state\" on-select=\"onSelectedState(address.state)\">\n                        <ui-select-match placeholder=\"Select a state\">\n                          {{$select.selected}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                          <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.state && saveAs === \'submit\'\">\n                        A state is required\n                      </span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">\n                  Contact Person(s)\n                  <span class=\"asterisk-required\">*</span>\n                  <div>\n                    <i>( First contact will be the primary contact )</i>\n                  </div>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"row add-contact-person\">\n                    <div class=\"col-sm-4 contact-box\" ng-repeat=\"item in selectedContactPersons\">\n                      <a class=\"btn-btn-link pull-right remove-contact-stick\" ng-click=\"removeContact(item)\">\n                        <span class=\"fa fa-trash-o\"></span>\n                      </a>\n                      <h3>\n                        <strong>{{item.first_name}} {{item.middle_name}} {{item.last_name}}</strong>\n                      </h3>\n                      <address>\n                        Email: {{item.email}}<br>\n                        Phone: {{item.phone}}<br>\n                        Fax  : {{item.fax}}\n                      </address>\n                      <a class=\"edi-contact-button\" edit-contact=\"item\" updated-contact=\"onUpdatedContact(contact)\">\n                        Edit\n                      </a>\n                    </div>\n                  </div>\n                  <div class=\"row add-contact-person\">\n                    <button id=\"addSupplierContact\" class=\"btn btn-success add-new-contact-button dropdown-toggle\" add-contact added-contact=\"onAddedContact(contact)\" uib-tooltip=\"Add a contact\">\n                      <span class=\"fa fa-plus\"></span>\n                    </button>\n                  </div>\n                  <span class=\"text-danger\" ng-if=\"!selectedContactPersons.length && saveAs === \'submit\'\">\n                    A contact person is required\n                 </span>\n                </div>\n              </div>\n              <div class=\"row\" style=\"padding-top:20px\">\n                <div class=\"col-md-12\">\n                  <branch-listing data=\"supplier.branches\" editable=\"true\">\n                  </branch-listing>\n                </div>\n              </div>\n              <div class=\"hr-line-dashed\"></div>\n              <div class=\"row\">\n                <label class=\"col-sm-2 control-label\">Attach Additional File(s)</label>\n                <div class=\"col-md-9 m-b m-t-sm\">\n                  <attachment-category module=\"Supplier\" data=\"supplier.additionalFile\" editable=\"true\">\n                  </attachment-category>\n                </div>\n              </div>\n              <div style=\"clear:both\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/versions/comparison.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"closeComparisonModal()\">\n      <span aria-hidden=\"true\">×</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <h4 class=\"modal-title\">Comparing Versions</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <table class=\"table table-striped\">\n          <tr>\n            <th> </th>\n            <th width=\"40%\">\n              <span ng-if=\"versionType !== \'draft\'\">Version {{supplierVersions[1].object_version}}</span>\n              <span ng-if=\"versionType === \'draft\'\">Version {{supplierVersions[1].object_draft_version}}</span>\n            </th>\n            <th width=\"40%\">\n              <span ng-if=\"currentStatus === \'pending\'\">\n                <span ng-if=\"!supplierVersions[0].draft_parent_id\">\n                  Current Version\n                </span>\n                <span ng-if=\"!!supplierVersions[0].draft_parent_id\">\n                  Version {{supplierVersions[0].object_draft_version}}\n                </span>\n              </span>\n              <span ng-if=\"currentStatus === \'active\'\">\n                Version {{supplierVersions[0].object_version}}\n              </span>\n            </th>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].descr !== supplierVersions[0].descr)}\">\n            <th>Supplier\'s Name</th>\n            <td>{{supplierVersions[1].descr}}</td>\n            <td>{{supplierVersions[0].descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].reg_no !== supplierVersions[0].reg_no)}\">\n            <th>Registration of Company (ROC)</th>\n            <td>{{supplierVersions[1].reg_no}}</td>\n            <td>{{supplierVersions[0].reg_no}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].tax.descr !== supplierVersions[0].tax.descr)}\">\n            <th>Tax</th>\n            <td>{{supplierVersions[1].tax.descr}}</td>\n            <td>{{supplierVersions[0].tax.descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].gst_code !== supplierVersions[0].gst_code)}\">\n            <th>GST Registration Number</th>\n            <td>{{supplierVersions[1].gst_code}}</td>\n            <td>{{supplierVersions[0].gst_code}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].currency_code !== supplierVersions[0].currency_code)}\">\n            <th>Preferred Currency</th>\n            <td>{{supplierVersions[1].currency_code}}</td>\n            <td>{{supplierVersions[0].currency_code}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].paid_up_value !== supplierVersions[0].paid_up_value)}\">\n            <th>Paid Up Capital</th>\n            <td>{{supplierVersions[1].paid_up_value}}</td>\n            <td>{{supplierVersions[0].paid_up_value}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].primary_commodity.descr !== supplierVersions[0].primary_commodity.descr)}\">\n            <th>Primary Commodity</th>\n            <td>{{supplierVersions[1].primary_commodity.descr}}</td>\n            <td>{{supplierVersions[0].primary_commodity.descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].secondary_commodity.descr !== supplierVersions[0].secondary_commodity.descr)}\">\n            <th>Secondary Commodity</th>\n            <td>{{supplierVersions[1].secondary_commodity.descr}}</td>\n            <td>{{supplierVersions[0].secondary_commodity.descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].primary_business_nature !== supplierVersions[0].primary_business_nature)}\">\n            <th>Primary Business Nature</th>\n            <td>{{supplierVersions[1].primary_business_nature}}</td>\n            <td>{{supplierVersions[0].primary_business_nature}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].secondary_business_nature !== supplierVersions[0].secondary_business_nature)}\">\n            <th>Secondary Business Nature</th>\n            <td>{{supplierVersions[1].secondary_business_nature}}</td>\n            <td>{{supplierVersions[0].secondary_business_nature}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].business_entity !== supplierVersions[0].business_entity)}\">\n            <th>Business Entity</th>\n            <td>{{supplierVersions[1].business_entity}}</td>\n            <td>{{supplierVersions[0].business_entity}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].pay_terms.descr !== supplierVersions[0].pay_terms.descr)}\">\n            <th>Payment Term</th>\n            <td>{{supplierVersions[1].pay_terms.descr}}</td>\n            <td>{{supplierVersions[0].pay_terms.descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].pay_method.descr !== supplierVersions[0].pay_method.descr)}\">\n            <th>Payment Method</th>\n            <td>{{supplierVersions[1].pay_method.descr}}</td>\n            <td>{{supplierVersions[0].pay_method.descr}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].bumi_status !== supplierVersions[0].bumi_status)}\">\n            <th>Bumiputera Status</th>\n            <td>{{supplierVersions[1].bumi_status === 1 ? \'Yes\' : \'No\'}}</td>\n            <td>{{supplierVersions[0].bumi_status === 1 ? \'Yes\' : \'No\'}}</td>\n          </tr>\n          <tr ng-class=\"{\n            \'updated-data\': (\n              supplierVersions[1].receive_via_email !== supplierVersions[0].receive_via_email ||\n              supplierVersions[1].receive_via_fax !== supplierVersions[0].receive_via_fax ||\n              supplierVersions[1].receive_via_post !== supplierVersions[0].receive_via_post\n            )\n          }\">\n            <th>Receiving PO Method</th>\n            <td>\n              <p><b>Email:</b> {{!!supplierVersions[1].receive_via_email ? \'Yes\' : \'No\'}}</p>\n              <p><b>Fax:</b> {{!!supplierVersions[1].receive_via_fax ? \'Yes\' : \'No\'}}</p>\n              <p><b>Post:</b> {{!!supplierVersions[1].receive_via_post ? \'Yes\' : \'No\'}}</p>\n            </td>\n            <td>\n              <p><b>Email:</b> {{!!supplierVersions[0].receive_via_email ? \'Yes\' : \'No\'}}</p>\n              <p><b>Fax:</b> {{!!supplierVersions[0].receive_via_fax ? \'Yes\' : \'No\'}}</p>\n              <p><b>Post:</b> {{!!supplierVersions[0].receive_via_post ? \'Yes\' : \'No\'}}</p>\n            </td>\n          </tr>\n          <tr ng-if=\"false\" ng-class=\"{\'updated-data\': (supplierVersions[1].is_global_supplier != supplierVersions[0].is_global_supplier)}\">\n            <th>Global Supplier</th>\n            <td>\n              {{ (supplierVersions[1].is_global_supplier == true) ? \'Yes\' : \'No\' }}\n            </td>\n            <td>\n              {{ (supplierVersions[0].is_global_supplier == true) ? \'Yes\' : \'No\' }}\n            </td>\n          </tr>\n          <tr ng-if=\"false\" ng-class=\"{\n                \'updated-data\': (\n                  !compareArrayValue(supplierVersions[1].bu_status,\n                                     supplierVersions[0].bu_status, \'code\') ||\n                  !compareArrayValue(supplierVersions[1].bu_status,\n                                     supplierVersions[0].bu_status, \'reason\') ||\n                  !compareArrayValue(supplierVersions[1].bu_status,\n                                 supplierVersions[0].bu_status, \'supplierGroupStatus\')\n                )\n             }\">\n            <th>Supplier Group</th>\n            <td>\n              <supplier-group data=\"supplierVersions[1].bu_status\" editable=\"false\" is-global=\"supplierVersions[1].is_global_supplier\" hide-reason=\"false\">\n              </supplier-group>\n            </td>\n            <td>\n              <supplier-group data=\"supplierVersions[0].bu_status\" editable=\"false\" is-global=\"supplierVersions[0].is_global_supplier\" hide-reason=\"false\">\n              </supplier-group>\n            </td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].email !== supplierVersions[0].email)}\">\n            <th>Company Email</th>\n            <td>{{supplierVersions[1].email}}</td>\n            <td>{{supplierVersions[0].email}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].phone !== supplierVersions[0].phone)}\">\n            <th>Company Phone</th>\n            <td>{{supplierVersions[1].phone}}</td>\n            <td>{{supplierVersions[0].phone}}</td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\': (supplierVersions[1].fax !== supplierVersions[0].fax)}\">\n            <th>Company Fax</th>\n            <td>{{supplierVersions[1].fax}}</td>\n            <td>{{supplierVersions[0].fax}}</td>\n          </tr>\n          <tr ng-class=\"{\n            \'updated-data\': (\n              supplierVersions[1].corresponding_address.line1 !== supplierVersions[0].corresponding_address.line1 ||\n              supplierVersions[1].corresponding_address.line2 !== supplierVersions[0].corresponding_address.line2 ||\n              supplierVersions[1].corresponding_address.line3 !== supplierVersions[0].corresponding_address.line3 ||\n              supplierVersions[1].corresponding_address.postal_code !== supplierVersions[0].corresponding_address.postal_code ||\n              supplierVersions[1].corresponding_address.city !== supplierVersions[0].corresponding_address.city ||\n              supplierVersions[1].corresponding_address.state !== supplierVersions[0].corresponding_address.state ||\n              supplierVersions[1].corresponding_address.country !== supplierVersions[0].corresponding_address.country\n            )\n          }\">\n            <th>Corresponding Address</th>\n            <td>\n              <p><b>Line 1:</b> {{supplierVersions[1].corresponding_address.line1}}</p>\n              <p><b>Line 2:</b> {{supplierVersions[1].corresponding_address.line2}}</p>\n              <p><b>Line 3:</b> {{supplierVersions[1].corresponding_address.line3}}</p>\n              <p><b>Postal code:</b> {{supplierVersions[1].corresponding_address.postal_code}}</p>\n              <p><b>City:</b> {{supplierVersions[1].corresponding_address.city}}</p>\n              <p><b>State:</b> {{supplierVersions[1].corresponding_address.state}}</p>\n              <p><b>Country:</b> {{supplierVersions[1].corresponding_address.country}}</p>\n            </td>\n            <td>\n              <p><b>Line 1:</b> {{supplierVersions[0].corresponding_address.line1}}</p>\n              <p><b>Line 2:</b> {{supplierVersions[0].corresponding_address.line2}}</p>\n              <p><b>Line 3:</b> {{supplierVersions[0].corresponding_address.line3}}</p>\n              <p><b>Postal code:</b> {{supplierVersions[0].corresponding_address.postal_code}}</p>\n              <p><b>City:</b> {{supplierVersions[0].corresponding_address.city}}</p>\n              <p><b>State:</b> {{supplierVersions[0].corresponding_address.state}}</p>\n              <p><b>Country:</b> {{supplierVersions[0].corresponding_address.country}}</p>\n            </td>\n          </tr>\n          <tr ng-class=\"{\n            \'updated-data\': (\n              supplierVersions[1].contact_person.first_name !== supplierVersions[0].contact_person.first_name ||\n              supplierVersions[1].contact_person.email !== supplierVersions[0].contact_person.email ||\n              supplierVersions[1].contact_person.fax !== supplierVersions[0].contact_person.fax ||\n              supplierVersions[1].contact_person.phone !== supplierVersions[0].contact_person.phone ||\n              !compareArrayValue(supplierVersions[1].additional_contacts.data,\n                                 supplierVersions[0].additional_contacts.data,\n                                 \'first_name\') ||\n              !compareArrayValue(supplierVersions[1].additional_contacts.data,\n                                 supplierVersions[0].additional_contacts.data,\n                                 \'email\') ||\n              !compareArrayValue(supplierVersions[1].additional_contacts.data,\n                                 supplierVersions[0].additional_contacts.data,\n                                 \'fax\') ||\n              !compareArrayValue(supplierVersions[1].additional_contacts.data,\n                                 supplierVersions[0].additional_contacts.data,\n                                 \'phone\')\n            )\n          }\">\n            <th>Contact Person</th>\n            <td>\n              <p><b>Name:</b> {{supplierVersions[1].contact_person.first_name}}</p>\n              <p><b>Email:</b> {{supplierVersions[1].contact_person.email}}</p>\n              <p><b>Fax:</b> {{supplierVersions[1].contact_person.fax}}</p>\n              <p><b>Phone:</b> {{supplierVersions[1].contact_person.phone}}</p>\n              <div class=\"contact-version\" ng-repeat=\"additional_contact1 in supplierVersions[1].additional_contacts.data\">\n                <p><b>Name:</b> {{additional_contact1.first_name}}</p>\n                <p><b>Email:</b> {{additional_contact1.email}}</p>\n                <p><b>Fax:</b> {{additional_contact1.fax}}</p>\n                <p><b>Phone:</b> {{additional_contact1.phone}}</p>\n              </div>\n            </td>\n            <td>\n              <p><b>Name:</b> {{supplierVersions[0].contact_person.first_name}}</p>\n              <p><b>Email:</b> {{supplierVersions[0].contact_person.email}}</p>\n              <p><b>Fax:</b> {{supplierVersions[0].contact_person.fax}}</p>\n              <p><b>Phone:</b> {{supplierVersions[0].contact_person.phone}}</p>\n              <div class=\"contact-version\" ng-repeat=\"additional_contact0 in supplierVersions[0].additional_contacts.data\">\n                <p><b>Name:</b> {{additional_contact0.first_name}}</p>\n                <p><b>Email:</b> {{additional_contact0.email}}</p>\n                <p><b>Fax:</b> {{additional_contact0.fax}}</p>\n                <p><b>Phone:</b> {{additional_contact0.phone}}</p>\n              </div>\n            </td>\n          </tr>\n          <tr ng-class=\"{\'updated-data\':\n          (supplierVersions[1].branches.length !== supplierVersions[0].branches.length || branchChanges)\n          }\">\n            <th>Supplier Branches</th>\n            <td>\n              <branch-listing data=\"supplierVersions[1].branches\" editable=\"false\">\n              </branch-listing>\n            </td>\n            <td>\n              <branch-listing data=\"supplierVersions[0].branches\" editable=\"false\">\n              </branch-listing>\n            </td>\n          </tr>\n          <tr ng-class=\"{\n            \'updated-data\':\n              ! compareAttachmentDescriptionVersion(\n                supplierVersions[1].attachments_descriptions,\n                supplierVersions[0].attachments_descriptions\n              )\n          }\">\n            <th>Additional Files</th>\n            <td>\n              <attachment-category module=\"Supplier\" data=\"supplierVersions[1].attachments_descriptions\" comparison=\"true\" editable=\"false\">\n              </attachment-category>\n            </td>\n            <td>\n              <attachment-category module=\"Supplier\" comparison=\"true\" data=\"supplierVersions[0].attachments_descriptions\" editable=\"false\">\n              </attachment-category>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeComparisonModal()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/versions/supplier-versions.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">\n      <span aria-hidden=\"true\">×</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <h4 class=\"modal-title\">Supplier Versions</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <table class=\"table\">\n          <tr>\n            <th>&nbsp;</th>\n            <th>Version Number</th>\n            <th>Created At</th>\n            <th>Created by</th>\n            <th>Last Updater</th>\n          </tr>\n          <tr ng-repeat=\"version in versions | orderBy: \'-object_version\'\">\n            <td>\n              <input icheck type=\"checkbox\" ng-model=\"selectedVersion\" ng-disabled=\"(checkedVersion.length === 2) && (checkedVersion.indexOf(version._id) === -1)\" ng-click=\"selectVersion(version._id, selectedVersion)\">\n            </td>\n            <td>\n              <span ng-if=\"$first\">\n                Current Version<br>\n                <span ng-if=\"currentStatus !== \'pending\'\">(version {{version.object_version}})</span>\n              </span>\n              <span ng-if=\"!$first\">\n                <span ng-if=\"versionType !== \'draft\'\">{{version.object_version}}</span>\n                <span ng-if=\"versionType === \'draft\'\">{{version.object_draft_version}}</span>\n              </span>\n            </td>\n            <td>{{version.created_at | date:\'dd MMM yyyy h:mm a\'}}</td>\n            <td>{{version.created_by.display_name}}</td>\n            <td>{{version.updated_by.display_name}}</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"checkedVersion.length < 2\" ng-click=\"compareVersions()\">\n      Compare\n    </button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/user/accountLocked/accountLocked.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_account_locked\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <i class=\"fa fa-exclamation-triangle fa-5x\"></i>\n    <h2 class=\"text-danger\">Sorry. You have reached the maximum number of allowed login attempts.</h2>\n    <h2 class=\"text-danger\">Your account is locked. To unlock your account please contact your Administrator.</h2>\n    <h2 class=\"text-danger\">Thank you.</h2>\n    <a class=\"btn btn-default\" ng-click=\"logout()\">Back to login</a>\n  </div>\n</div>\n\n");
$templateCache.put("app/user/activity/activity.html","<div class=\"container-fluid gray-bg list-user-control-fixed-top\" ui-scrollfix>\n  <div class=\"row row-beauty\">\n    <div class=\"col-md-5 no-padding\">\n      <label class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Your latest activity</label>\n      <div class=\"input-group\">\n        <input reset-field=\"search.reset()\" right=\"80\" type=\"text\" class=\"form-control\" aria-label=\"...\" placeholder=\"Search\" ui-keypress=\"{\'enter\':\'search.$($event)\'}\">\n        <div class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-default\">\n            <i class=\"fa fa-search\"></i>\n          </button>\n          \n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row row-beauty\">\n    activities list\n  </div>\n</div>");
$templateCache.put("app/user/invalidUrl/invalidUrl.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_not_authorized\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <i class=\"fa fa-exclamation-triangle fa-5x\"></i>\n    <h2 class=\"text-danger\">You are attempting to access Metabuyer from an outdated version.</h2>\n    <h2 class=\"text-danger\">Please click the link below to be redirected to Metabuyer.</h2>\n    <a class=\"btn btn-default\" ng-href=\"{{ environmentUrl }}\">Go to Login</a>\n  </div>\n</div>\n");
$templateCache.put("app/user/mainMenu/mainMenuTemplate.html","<div class=\"state_user_management_list\">\n  <tab-drop-down data=\"tabData\" activated-tab=\"activatedTab\" template-url=\"app/user/ui-router-tabs-template.html\">\n  </tab-drop-down>\n  <ui-view></ui-view>\n</div>\n");
$templateCache.put("app/user/notAuthorized/notAuthorized.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_not_authorized\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <i class=\"fa fa-exclamation-triangle fa-5x\"></i>\n    <h2 class=\"text-danger\">You are not authorized to view this page.</h2>\n    <h2 class=\"text-danger\">If there are any enquiries, please contact your Administrator.</h2>\n    <h2 class=\"text-danger\">Thank you.</h2>\n    <a class=\"btn btn-default\" ui-sref=\"main.user.mainMenu.waiting-on-you\">Back to home</a>\n  </div>\n</div>\n\n");
$templateCache.put("app/user/notifications/notifications.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <h3>Displaying all notifications</h3>\n    <div class=\"col-md-5 no-padding\">\n      <div class=\"btn-group pull-left clear-floating share-tab-focus\" role=\"group\">\n        <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'unread\', \'btn-white\': selectedListTab !== \'unread\'}\" ui-sref=\"main.user.mainMenu.notifications({subTab: \'unread\', cursor: null})\">\n          New\n        </button>\n        <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': selectedListTab === \'all\', \'btn-white\': selectedListTab !== \'all\'}\" ui-sref=\"main.user.mainMenu.notifications({subTab: \'all\', cursor: null})\">\n          All\n        </button>\n      </div>\n    </div>\n    <div class=\"col-md-7 no-padding\" ng-if=\"selectedListTab === \'all\'\">\n      <pagination-service cursor=\"meta.cursor\" list=\"notifications\" service=\"service\"></pagination-service>\n    </div>\n  </div>\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\">\n    <div class=\"ibox-content inspinia-timeline\">\n      <div class=\"timeline-item\">\n        <div class=\"row\" ng-repeat=\"item in notifications track by $index\">\n          <div class=\"col-xs-2 date\">\n            {{ item.time | date:\'dd MMM yyyy h:mm a\'}}<br>\n            <small class=\"text-navy-bold\">\n              <span am-time-ago=\"item.time\"></span>\n            </small>\n          </div>\n          <div class=\"col-xs-7 content\" ng-class=\"{\'no-top-border\': $index == 0}\">\n            <p class=\"m-b-xs\">\n\n              <!-- PO -->\n              <a ui-sref=\"main.user.orders.detail({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\po\'\">\n                <p>Purchase Order - <b>{{ item.changeType }}</b></p>\n                <p ng-if=\"item.additional_info\">\n                  PO Number - <b>{{ item.additional_info[0].po_number }}</b>\n                </p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </a>\n\n              <!-- Comment -->\n              <a ui-sref=\"main.user.orders.detail({id: item.additional_info[0].id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\comment\'\">\n                <div class=\"col-sm-6\">\n                  <p>Purchase Order - <b>{{ item.changeType }}</b>\n                  </p>\n                  <p ng-if=\"item.additional_info\">\n                    PO Number - <b>{{ item.additional_info[2].number }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </div>\n                <div class=\"col-sm-6\">\n                  <p>PO Title - <b>{{ item.additional_info[1].title }}</b>\n                  </p>\n                  <p>Comment - <b>{{ item.additional_info[4].comment }}</b>\n                  </p>\n                </div>\n              </a>\n\n              <!-- PR -->\n              <a ui-sref=\"main.user.purchaseRequisitions.details({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\pr\\\\pr\' ||\n                 item.class.toLowerCase() === \'metabuyer\\\\models\\\\pr\'\">\n                <p>Purchase Requisition - <b>{{ item.changeType }}</b></p>\n\n                <span ng-if=\"item.changeType.toLowerCase() !== \'escalated\'\">\n                  <p ng-if=\"item.additional_info\">\n                    PR Number - <b>{{item.prNumber }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </span>\n\n                <span ng-if=\"item.changeType.toLowerCase() === \'escalated\'\">\n                  <p ng-if=\"item.additional_info[1].escalation_user[0]\">\n                    From - <b>{{item.additional_info[1].escalation_user[0].escalated_user.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                    To - <b>{{item.additional_info[1].escalation_user[0].escalated_to.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                  </p>\n                </span>\n              </a>\n\n              <!--CommentHistory for PR-->\n              <a ui-sref=\"main.user.purchaseRequisitions.details({id: item.additional_info[0].pr._id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\commenthistory\' && !!item.additional_info[0].pr\">\n                <div class=\"col-sm-6\">\n                  <p>Purchase Requisition - <b>{{ item.changeType }}</b>\n                  </p>\n                  <p ng-if=\"item.additional_info\">\n                    PR Number - <b>{{ item.additional_info[0].pr.reference }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </div>\n                <div class=\"col-sm-6\">\n                  <p>PR Title - <b>{{ item.additional_info[0].pr.title }}</b>\n                  </p>\n                  <p>Comment - <b>{{ item.additional_info[3].comment }}</b>\n                  </p>\n                </div>\n              </a>\n\n            <!--CommentHistory for Budget-->\n            <a ui-sref=\"main.user.budget.details({id: item.additional_info[0].budget._id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\commenthistory\' && !!item.additional_info[0].budget\">\n              <div class=\"col-sm-6\">\n                <p>Budget - <b>{{ item.changeType }}</b>\n                </p>\n                <p ng-if=\"item.additional_info\">\n                  Budget Number - <b>{{ item.additional_info[0].budget.code }}</b>\n                </p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </div>\n              <div class=\"col-sm-6\">\n                <p>Budget Title - <b>{{ item.additional_info[0].budget.descr }}</b>\n                </p>\n                <p>Comment - <b>{{ item.additional_info[3].comment }}</b>\n                </p>\n              </div>\n            </a>\n\n              <a ui-sref=\"main.user.suppliers.detail({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\supplier\'\">\n                <p>Supplier - <b>{{ item.changeType }}</b></p>\n\n                <span ng-if=\"item.changeType.toLowerCase() !== \'escalated\'\">\n                  <p ng-if=\"item.additional_info\">\n                    Supplier - <b>{{ item.supplierDescr }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </span>\n\n                <span ng-if=\"item.changeType.toLowerCase() === \'escalated\'\">\n                  <p ng-if=\"item.additional_info[1].escalation_user[0]\">\n                    From - <b>{{item.additional_info[1].escalation_user[0].escalated_user.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                    To - <b>{{item.additional_info[1].escalation_user[0].escalated_to.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                  </p>\n                </span>\n              </a>\n\n              <a ui-sref=\"main.user.items.detail({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\importitemsummary\'\">\n                <p>Catalog - <b>{{ item.changeType }}</b></p>\n\n                <span ng-if=\"item.changeType.toLowerCase() !== \'escalated\'\">\n                  <p ng-if=\"item.additional_info\">\n                    Catalog - <b>{{ item.additional_info[1].catalog.catalog_descr }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </span>\n\n                <span ng-if=\"item.changeType.toLowerCase() === \'escalated\'\">\n                  <p ng-if=\"item.additional_info[1].escalation_user[0]\">\n                    From - <b>{{item.additional_info[1].escalation_user[0].escalated_user.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                    To - <b>{{item.additional_info[1].escalation_user[0].escalated_to.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                  </p>\n                </span>\n              </a>\n\n              <a class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\services\\\\delegation\\\\model\\\\delegation\'\">\n                <p>Delegation - <b>{{ item.changeType }}</b></p>\n                <span ng-if=\"item.additional_info && (item.changeType.toLowerCase() === \'delegated\')\">\n                  From <b> {{item.additional_info[1].delegation.user.display_name | capitalize}}</b>\n                  to <b> {{ item.additional_info[1].delegation.delegatee.display_name | capitalize}}</b>\n                  <p>\n                    Effective Date From <b> {{ item.additional_info[1].delegation.start_date | date }}</b>\n                    to <b> {{ item.additional_info[1].delegation.end_date | date }}</b>\n                  </p>\n                </span>\n                <span ng-if=\"item.additional_info && (item.changeType.toLowerCase() !== \'delegated\')\">\n                  <b>{{ item.additional_info[1].delegation.delegatee }}</b>\n                  <p>By <b>{{ item.user.display_name }} </b> </p>\n                </span>\n              </a>\n\n              <a ui-sref=\"main.user.orders.detail({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\models\\\\grn\'\">\n                <p>GRN - <b>{{ item.changeType }}</b></p>\n                <p ng-if=\"item.additional_info\">\n                  PO Number - <b>{{ item.additional_info[6].po_number }}</b>\n                </p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </a>\n\n              <a class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\services\\\\importer\\\\importlog\'\">\n                <p> {{getClassName(item.additional_info)}} Import - <b>{{ item.changeType }}</b></p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </a>\n\n              <a class=\"text-navy\" ui-sref=\"main.user.exports.log\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\services\\\\exports\\\\exportlog\'\">\n                <p> {{item.additional_info}} Export - <b>{{ item.changeType }}</b></p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </a>\n\n              <a class=\"text-navy\" ui-sref=\"main.user.reports.log\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\services\\\\reports\\\\reportlog\'\">\n                <p>Report - <b>{{ item.changeType }}</b></p>\n                <p>By <b>{{ item.user.display_name }}</b></p>\n              </a>\n\n              <a ui-sref=\"main.user.budget.details({id: item.object_id})\" class=\"text-navy\" ng-if=\"item.class.toLowerCase() === \'metabuyer\\\\budget\\\\models\\\\budget\'\">\n                <span ng-if=\"item.changeType.toLowerCase() !== \'escalated\'\">\n                  <p>Budget - <b>{{ item.changeType }}</b></p>\n                  <p ng-if=\"item.additional_info\">\n                    Budget Number - <b>{{item.budgetNumber }}</b>\n                  </p>\n                  <p>By <b>{{ item.user.display_name }}</b></p>\n                </span>\n\n                <span ng-if=\"item.changeType.toLowerCase() === \'escalated\'\">\n                  <p ng-if=\"item.additional_info[1].escalation_user[0]\">\n                    From - <b>{{item.additional_info[1].escalation_user[0].escalated_user.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                    To - <b>{{item.additional_info[1].escalation_user[0].escalated_to.display_name | capitalize }}\n                    ({{item.additional_info[1].escalation_user[0].role_name}})</b>\n                  </p>\n                </span>\n              </a>\n\n            </p>\n          </div>\n        </div>\n        <div ng-if=\"notifications.length === 0 && selectedListTab === \'all\'\"><p>There are no notifications</p></div>\n        <div ng-if=\"notifications.length === 0 && selectedListTab === \'unread\'\"><p>There are no new notifications</p></div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/user/passwordReset/password-reset-template.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_password_reset\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <form class=\"m-t\" role=\"form\" method=\"post\" ng-submit=\"updatePassword()\" name=\"loginForm\">\n\n      <div class=\"form-group has-feedback\">\n        <span class=\"password_reset\">New Password</span>\n        <input type=\"password\" id=\"password_new\" name=\"password_new\" class=\"form-control input-lg\" ng-class=\"{\'highlight-error-input\': wrongFormatError}\" ng-model=\"password_new\" placeholder=\"New password\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\" required>\n        <span class=\"text-danger\" ng-show=\"!loginForm.password_new.$error.required\n        && loginForm.password_new.$error.pattern && loginForm.password_new.$dirty\">\n          Minimum 8 characters with at least one lower & uppercase letter, and one number\n        </span>\n        <span class=\"text-danger\" ng-if=\"(loginForm.password_new.$error.minlength &&\n              !loginForm.password_new.$error.pattern)\">\n          Password must be 8 characters long\n        </span>\n      </div>\n      <div class=\"form-group has-feedback\">\n        <span class=\"password_reset\">Confirm New Password</span>\n        <input type=\"password\" id=\"password_confirm\" name=\"password_confirm\" class=\"form-control input-lg\" ng-class=\"{\'highlight-error-input\': missMatchError}\" ng-model=\"password_confirm\" placeholder=\"Confirm new password\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\" required>\n        <span class=\"text-danger\" ng-show=\"!loginForm.password_confirm.$error.required\n        && loginForm.password_confirm.$error.pattern && loginForm.password_confirm.$dirty\">\n          Minimum 8 characters with at least one lower & uppercase letter, and one number\n        </span>\n        <span class=\"text-danger\" ng-if=\"(loginForm.password_confirm.$error.minlength &&\n              !loginForm.password_confirm.$error.pattern)\">\n          Password must be 8 characters long\n        </span>\n        <span class=\"text-danger\" ng-if=\"missMatchError\">Password does not match</span>\n      </div>\n      <button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"loginForm.$invalid || isLoginClicked\">\n        Change Password\n      </button>\n      <a ng-click=\"logout()\">Logout</a>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/user/unauthorizedBudgetAccess/unauthorizedBudgetAccess.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_not_authorized\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <i class=\"fa fa-exclamation-triangle fa-5x\"></i>\n    <h2 class=\"text-danger\">You have no company with budget module enabled.</h2>\n    <h2 class=\"text-danger\">If there are any enquiries, please contact your Administrator.</h2>\n    <h2 class=\"text-danger\">Thank you.</h2>\n    <a class=\"btn btn-default\" ui-sref=\"main.user.mainMenu.waiting-on-you\">Back to home</a>\n  </div>\n</div>\n\n");
$templateCache.put("app/user/underMaintenance/underMaintenanceTemplate.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\">\n  <div class=\"state_not_authorized\">\n    <div>\n      <h1 class=\"logo-name\">Metabuyer</h1>\n    </div>\n    <i class=\"fa fa-exclamation-triangle fa-5x\"></i>\n    <h2 class=\"text-info\">Metabuyer is under maintenance</h2>\n    <h2 class=\"text-info\">we will be back soon.</h2>\n    <a class=\"btn btn-default\" ui-sref=\"login\">Back to log in page</a>\n  </div>\n</div>\n");
$templateCache.put("app/user/waiting-on-you/waiting-on-you-mobile.html","<div class=\"state-waiting-for-you mobile\">\n  <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"waitingService\"></pagination-service>\n  <div class=\"container-fluid gray-bg list-user-control-fixed-top ml-15 mr-15\" ui-scrollfix>\n    <div class=\"row row-beauty\">\n      <div class=\"col-md-5 no-padding\">\n        <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Items waiting for your response</h3>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container-fluid ml-15 mr-15\">\n    <div class=\"row row-beauty\" style=\"overflow: auto\">\n      <div class=\"panel panel-default\">\n        <table class=\"table table-bordered table-striped table-condensed table-responsive\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n          <thead>\n          <tr>\n            <td>Document Type</td>\n            <td>Company/Group</td>\n            <td>Document No.</td>\n            <td>Title</td>\n            <td>Creator</td>\n            <td>Received</td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr class=\"no-data\" ng-show=\"!(dataList.length)\">\n            <td colspan=\"5\">There is no items waiting for your response</td>\n          </tr>\n          <tr ng-repeat=\"item in dataList\" ng-click=\"redirectTo(item)\">\n            <td>{{item.displayCategory}}</td>\n            <td>{{item.context_company}}</td>\n            <td>\n              <span ng-if=\"item.context_status === \'on_hold\'\" class=\"label label-warning pull-right on-hold-label ng-scope\">On Hold\n              </span>\n              {{item.context_reference}}\n            </td>\n            <td>{{ item.context_descr }}</td>\n            <td>{{item.context_creator}}</td>\n            <td>\n              <span am-time-ago=\"{{ item.created_at }}\"></span>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/user/waiting-on-you/waiting-on-you.html","<div class=\"state-waiting-for-you\">\n  <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"waitingService\"></pagination-service>\n  <div class=\"container-fluid gray-bg list-user-control-fixed-top\" ui-scrollfix>\n    <div class=\"row row-beauty\">\n      <div class=\"col-md-5 no-padding\">\n        <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Items waiting for your response</h3>\n      </div>\n    </div>\n  </div>\n  <div class=\"container-fluid\">\n    <div class=\"row row-beauty\" style=\"overflow: auto\">\n      <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead>\n        <tr>\n          <td>Document Type</td>\n          <td>Company/Group</td>\n          <td>Document No.</td>\n          <td>Title</td>\n          <td>Creator</td>\n          <td>Received</td>\n        </tr>\n        </thead>\n        <tbody>\n        <tr class=\"no-data\" ng-show=\"!(dataList.length)\">\n          <td colspan=\"5\">There is no items waiting for your response</td>\n        </tr>\n        <tr ng-repeat=\"item in dataList\" ng-click=\"redirectTo(item)\">\n          <td>{{item.displayCategory}}</td>\n          <td>{{item.context_company}}</td>\n          <td>\n            <span ng-if=\"item.context_status === \'on_hold\'\" class=\"label label-warning pull-right on-hold-label ng-scope\">On Hold</span>\n            {{item.context_reference}}\n          </td>\n          <td>{{ item.context_descr }}</td>\n          <td>{{item.context_creator}}</td>\n          <td>\n            <span am-time-ago=\"{{ item.created_at }}\"></span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/usersManagement/add/add.html","<form name=\"user_detail_form\" novalidate>\n  <div class=\"state_user_add\">\n    <div class=\"row\">\n      <div class=\"col-lg-12\">\n        <div class=\"panel-body\">\n          <fieldset class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Full Name <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.name.length && submitted}\">\n                <input class=\"form-control\" name=\"user_name\" type=\"text\" ng-model=\"user.name\" placeholder=\"(e.g. John Doe)\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" required>\n                  <span class=\"text-danger\" ng-show=\"!user.name.length && submitted\">\n                    Username is required\n                  </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Employee Number <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.employee_number.length && submitted}\">\n                <input class=\"form-control\" name=\"employee_number\" type=\"text\" ng-model=\"user.employee_number\" placeholder=\"(e.g. 045893)\" ng-change=\"duplicationCheck(\'Users\',\'emp_no\',user.employee_number,\'emp\')\" required>\n                <span class=\"text-danger\" ng-show=\"!user.employee_number.length && submitted\">\n                    Employee number is required\n                  </span>\n                <span class=\"text-danger\" ng-show=\"user.employee_number.length && empCheck\">\n                    Employee number {{user.employee_number}} is already taken!\n                  </span>\n\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Email Address <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.email.length && submitted}\">\n\n                <input class=\"form-control background-white\" type=\"email\" name=\"user_email\" ng-model=\"user.email\" readonly=\"readonly\" onfocus=\"this.removeAttribute(\'readonly\')\" placeholder=\"(e.g. johndoe@sunway.com.my)\" ng-pattern-restrict=\"^([A-Za-z0-9-_.]{0,20}@?[A-Za-z0-9-_.]{0,20}[.]?[A-Za-z0-9-_.]{0,20})$\" ng-change=\"duplicationCheck(\'Users\',\'email\',user.email,\'email\')\" required>\n                  <span class=\"text-danger\" ng-if=\"!user.email.length && submitted\">\n                    Email is required\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"user_detail_form.user_email.$error.email && user.email.length && submitted\">\n                    Email is incorrect\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"user.email.length && emailCheck\">\n                    The email {{ user.email}} is already taken!\n                  </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Temporary Password <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.password.length && submitted}\">\n                <input class=\"form-control background-white\" type=\"password\" name=\"user_password\" readonly=\"readonly\" onfocus=\"this.removeAttribute(\'readonly\')\" ng-model=\"user.password\" required>\n                <button type=\"button\" ng-click=\"generatePassword()\" class=\"btn btn-link\">\n                  Auto Generate\n                </button>\n                <input type=\"checkbox\" ng-model=\"user.send_email\" ng-init=\"user.send_email = false\" ng-disabled=\"randomPassword\"> Send password via email\n                <div class=\"text-danger\" ng-show=\"submitted && !user.password.length\">\n                  Password is required\n                </div>\n                <div class=\"text-danger\" ng-show=\"submitted && (user.password.length && message_error.password_length)\">\n                  Password requires at least 8 characters\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Company<span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\">\n\n                <user-assignment selected-companies=\"user.companies\" companies=\"options.companies\">\n                </user-assignment>\n\n                <div class=\"text-danger\" ng-if=\"user.cc_list.length < 1 && submitted\">\n                  <span>Company & cost center is required</span>\n                </div>\n                <div class=\"text-danger\" ng-if=\"user.roles.length < 1 && submitted\">\n                  <span>A role is required</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Email Notification Frequency: </label>\n              <div class=\"col-sm-9 m-b\">\n                <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"ef in emailFrequency track by $index\">\n                  <input type=\"radio\" id=\"{{selection.ef}}\" name=\"selectEmailFrequency\" ng-model=\"user.email_notification_frequency\" ng-value=\"ef.value\" ng-click=\"selectedEmailFrequency(ef.value)\">\n                  &nbsp;&nbsp;{{ef.descr}}\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Phone\n              </label>\n              <div class=\"col-sm-9 m-b\">\n                <input class=\"form-control\" type=\"text\" name=\"user_mobile\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^([0-9-+\\s]{0,50})$\" ng-model=\"user.mobile\" placeholder=\"(e.g. 012-34567890 or +0659437688)\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Country <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-9 m-b\" ng-class=\"{\'ui-select-error-highlight\': !selected_options.country.selected && submitted}\">\n                <ui-select ng-model=\"selected_options.country.selected\" on-select=\"onCountryItemSelected($select.selected)\" theme=\"bootstrap\">\n                  <ui-select-match placeholder=\"Select a country...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices refresh=\"loadCountries()\" refresh-delay=\"0\" repeat=\"c in options.countries | filter: $select.search\">\n                    <div ng-bind-html=\"c.descr | highlight: $select.search\"></div>\n                  </ui-select-choices>\n                </ui-select>\n                <span class=\"text-danger\" ng-show=\"!selected_options.country.selected && submitted\">\n                  Country is required\n                </span>\n              </div>\n            </div>\n          </fieldset>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-2\"></div>\n      <div class=\"col-sm-9 m-b\">\n        <div class=\"col-sm-6 update-change\">\n          <button class=\"btn btn-primary\" ng-disabled=\"submitted\" ng-click=\"addUser()\">Add user</button>\n          <button class=\"btn btn-white\" ng-click=\"cancelAddUser()\">Cancel</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/add/user-costcenter-modalTemplate.html","<form>\n  <div class=\"user_select_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\">Select cost centers for <b>{{::userCostCenters[0].company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <th>\n              <input type=\"checkbox\" icheck ng-click=\"columnCostCenter.checkAllItems()\" ng-model=\"columnCostCenter.selected_all_cc\">\n            </th>\n            <th colspan=\"2\" class=\"text-left-align\">Cost centers</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"cc in userCostCenters track by $index\">\n            <td>\n              <input type=\"checkbox\" icheck ng-model=\"cc.selected\" ng-click=\"columnCostCenter.selectedItem(cc)\">\n            </td>\n            <td>\n              {{cc.descr}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/delegations/delegations.html","<div class=\"state_escalation_list\">\n  <div class=\"container-fluid gray-bg fixed-top\">\n    <div class=\"row\">\n      <div class=\"col-md-5 no-padding\">\n        <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Delegations Listing</h3>\n      </div>\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"delegationsService\" offset=\"offset\">\n      </pagination-service>\n    </div>\n  </div>\n  <div class=\"container-fluid\">\n    <div class=\"row row-beauty\" style=\"overflow: auto\">\n      <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no delegations for now.</td>\n        </tr>\n        <tr ng-repeat=\"delegation in dataList\" class=\"cursor-pointer\" fadeout-row=\"delegation.user_id == highlightId\">\n          <td ng-show=\"showColumn(\'creator.display_name\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.creator[0].display_name }}\n          </td>\n          <td ng-show=\"showColumn(\'user.display_name\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.user[0].display_name }}\n          </td>\n          <td ng-show=\"showColumn(\'delegatee.display_name\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.delegatee[0].display_name }}\n          </td>\n          <td ng-show=\"showColumn(\'company_code\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.company_code }}\n          </td>\n          <td ng-show=\"showColumn(\'company.descr\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.company[0].descr }}\n          </td>\n          <td ng-show=\"showColumn(\'start_date\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.start_date | date:\'dd MMM yyyy\' }}\n          </td>\n          <td ng-show=\"showColumn(\'end_date\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ delegation.end_date | date:\'dd MMM yyyy\' }}\n          </td>\n          <td ng-show=\"showColumn(\'reason\')\">\n            {{ delegation.reason | limitTo:50 }}\n            <span ng-if=\"delegation.reason.length > 50\">\n              <modal-more type=\"string\" title=\"Delegation Reason\" subtitle=\"\" data=\"delegation.reason\">\n              read more...\n            </modal-more>\n            </span>\n          </td>\n          <td ng-show=\"showColumn(\'status\')\" ui-sref=\"main.user.users.detail({id: delegation.user_id})\">\n            {{ getDelegationStatus(delegation.status) }}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/usersManagement/detail/admin-unlocking-user-panelTemplate.html","<form method=\"post\" ng-submit=\"confirmUnlockUser()\" name=\"adminUnlock\">\n  <div class=\"admin_unlock_user\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n    <h3 class=\"modal-title\">Unlock User</h3>\n  </div>\n  <div class=\"gray-bg wrapper\">\n    <h3>Reason for this User being Locked: </h3><span class=\"text-danger\">{{user.lock_comment}}</span>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group has-feedback\">\n        <label class=\"col-sm-4 control-label\">New Password</label>\n        <div class=\"col-sm-6\">\n          <input type=\"password\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': wrongFormatError}\" name=\"password_new\" ng-model=\"password_new\" ng-disabled=\"!unlockedLockedUser\" ng-minlength=\"8\" ng-maxlength=\"30\" ng-pattern=\"/(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])/\" required>\n            <span class=\"text-danger\" ng-show=\"!adminUnlock.password_new.$error.required\n            && adminUnlock.password_new.$error.pattern && adminUnlock.password_new.$dirty\">\n             Minimum 8 characters with at least one lower & uppercase letter, and one number\n            </span>\n            <span class=\"text-danger\" ng-if=\"(adminUnlock.password_new.$error.minlength && !adminUnlock.password_new.$error.pattern)\">\n              Password must be 8 characters long\n            </span>\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"unlockUser()\" ng-show=\"!unlockedLockedUser\">Unlock User</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!password_new\">Confirm Unlock</button>\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\">Close</button>\n  </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/detail/detail.html","<div class=\"container-fluid gray-bg list-user-control-fixed-top state-user-profile\" ui-scrollfix>\n  <div class=\"col-md-12 mt-10\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ user.display_name }}\n      </span>\n    <a ui-sref=\"main.user.users.edit({ id: user._id })\">\n      <button type=\"button\" class=\"btn btn-default pull-right\"><i class=\"fa fa-pencil\"></i> Edit user</button>\n    </a>\n  </div>\n  <div class=\"col-md-4 mt-10\">\n    <div class=\"ibox float-e-margins\">\n      <div class=\"ibox-title\">\n        <h5>Profile Detail</h5>\n      </div>\n      <form editable-form name=\"editableForm\" novalidate>\n        <div class=\"ibox-content no-padding border-left-right text-center\">\n          <div flow-init flow-object=\"flowConfig\" flow-file-added=\"!!{png:1,jpg:1,jpeg:1}[$file.getExtension()]\" flow-files-submitted=\"$flow.upload()\" flow-file-success=\"isUploadImageSuccess($file, $message, $flow);\">\n            <div flow-btn ng-if=\"$flow.files[0]\">\n              <img class=\"profile-avatar\" flow-img=\"$flow.files[0]\">\n            </div>\n            <div flow-btn ng-if=\"$flow.isUploading()\">\n              Uploading...\n            </div>\n            <div flow-btn ng-if=\"!$flow.files[0]\">\n              <img class=\"profile-avatar\" image-error=\"assets/images/default-user.png\" ng-src=\"{{imageBasePath}}/{{user.img_url}}\">\n            </div>\n          </div>\n        </div>\n        <div class=\"ibox-content profile-content\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">Name:</label>\n              <div class=\"col-md-7\">\n                <span class=\"label-select\" editable-text=\"user.display_name\" e-required>{{ user.display_name || \"-\"  }}</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">Employee number:</label>\n              <div class=\"col-md-7\">\n                <span class=\"label-select\">{{ user.emp_no || \"-\"  }}</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">System Roles:</label>\n              <div class=\"col-md-7\">\n                <span class=\"label-select\" ng-if=\"!systemObject.roles.length\">\n                    N/A\n                </span>\n                <div ng-repeat=\"sysRoles in systemObject.roles\">\n                  <span class=\"label-select\">\n                    {{sysRoles.name}}\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">System Position:</label>\n              <div class=\"col-md-7\">\n                <span class=\"label-select\" ng-if=\"!systemObject.positions.length\">\n                    N/A\n                </span>\n                <div ng-repeat=\"sysPos in systemObject.positions\">\n                  <span class=\"label-select\">\n                    {{sysPos.name}}\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">Status:</label>\n              <div class=\"col-md-7\">\n                <button type=\"button\" class=\"btn btn-xs\" ng-class=\"{\'btn-primary\' : user.status == \'ACTIVE\', \'btn-warning\': user.status == \'PENDING\'\n                                      , \'btn-danger\': user.status == \'INACTIVE\'}\" disabled=\"disabled\">{{ user.status == \"ACTIVE\" ? \"ACTIVE\": (user.status == \'PENDING\' ? \"Pending Approval\": user.status)}}</button>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">User Lock:</label>\n              <div class=\"col-md-7\">\n                <button type=\"button\" class=\"btn btn-xs\" ng-class=\"{\'btn-primary\' : !user.locked, \'btn-danger\': !!user.locked}\" ng-disabled=\"!user.locked\" ng-click=\"checkLockedUser()\">\n                  {{!user.locked ? \"Unlocked\": (!!user.locked ? \"Locked\": Locked)}}</button>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">Email:</label>\n              <div class=\"col-md-7 text-ellipsis\" uib-tooltip=\"{{ ::user.email }}\">\n                <span class=\"label-select\">{{ ::user.email }}</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5 label-select\">Email Notification Frequency:</label>\n              <div class=\"col-md-7\">\n                <span class=\"label-select\">{{ user.receive_email_immediate ? \'Immediate\' : \'End of Day\' }}</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-md-5\">Password:</label>\n              <div class=\"col-md-7 edit-field\">\n                  <span class=\"text-danger\" ng-if=\"!!user.password_expired\">\n                    Password expired!\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"!!user.locked\">\n                    You must first unlock the user!\n                  </span>\n                <a class=\"text-danger\" password-reset-modal data=\"user\" old-password-field=\"false\" ng-click=\"showPasswordModal()\" ng-if=\"!!user.reset && !user.locked\">\n                  The user has not set a new password\n                </a>\n                <a class=\"change-password\" password-reset-modal data=\"user\" old-password-field=\"false\" ng-click=\"showPasswordModal()\" ng-if=\"!user.reset\">\n                  Reset Password\n                </a>\n              </div>\n            </div>\n            <!--<div class=\"row form-group\">-->\n            <!--<label class=\"col-md-3 label-select\">Language:</label>-->\n            <!--<div class=\"col-md-8\">-->\n            <!--<span class=\"label-select\" editable-select=\"user.config.lang\" e-ng-options=\"lang.value as lang.label for lang in enums.lang\" e-required>-->\n            <!--{{ user.config.lang }}</span>-->\n            <!--</div>-->\n            <!--</div>-->\n            <!--<div class=\"row form-group\">-->\n            <!--<label class=\"col-md-3 label-select\">Timezone:</label>-->\n            <!--<div class=\"col-md-8\">-->\n            <!--<span class=\"label-select\" editable-select=\"user.config.TZ\"-->\n            <!--e-ng-options=\"timezone.value as timezone.label for timezone in enums.timezone\" e-required>-->\n            <!--{{ user.config.TZ }}</span>-->\n            <!--<span class=\"text-danger\" ng-show=\"!user.config.TZ && submitted\">Timezone is required</span>-->\n            <!--</div>-->\n            <!--</div>-->\n          </div>\n        </div>\n        <div class=\"ibox-content text-center\">\n          <div class=\"buttons\">\n            <button type=\"button\" class=\"btn btn-sm\" ng-show=\"!editableForm.$visible\" ng-click=\"changeUserStatus(user.status == \'INACTIVE\' ? \'ACTIVE\': \'INACTIVE\')\" ng-class=\"{\'btn-danger\' : user.status == \'ACTIVE\', \'btn-primary\': user.status == \'INACTIVE\'}\" ng-hide=\"user.status == \'PENDING\'\">\n              {{ user.status == \'INACTIVE\' ? \'ACTIVATE\': \'DEACTIVATE\' }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n\n  <div class=\"col-md-8 mt-10\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"ibox float-e-margins\">\n          <div class=\"row\">\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <td>Companies</td>\n                <td>Cost Centers</td>\n                <td>Roles</td>\n                <td>Superior</td>\n              </tr>\n              </thead>\n              <tbody>\n              <tr class=\"no-data\" ng-hide=\"user.companies.length > 0\">\n                <td colspan=\"9\">There are no companies for this user.</td>\n              </tr>\n              <tr ng-repeat=\"company in user.companies\">\n                <td>{{company.descr}}</td>\n                <td>\n              <span ng-switch on=\"company.cost_centers.length > 2\">\n                <span ng-switch-when=\"true\">\n                  <ul class=\"unstyled\">\n                    <li>\n                      {{company.cost_centers[0].code}}\n                    </li>\n                    <li>\n                      {{company.cost_centers[1].code}}\n                    </li>\n                    <li class=\"col-sm-2\">\n                      <a ng-click=\"viewCostCenter(company.cost_centers)\">more</a>\n                    </li>\n                  </ul>\n                </span>\n                <span ng-switch-default>\n                  <ul class=\"unstyled\" ng-repeat=\"cc in company.cost_centers track by $index\">\n                    <li>\n                      {{cc.code}}\n                    </li>\n                  </ul>\n                </span>\n              </span>\n                </td>\n                <td>\n              <span ng-switch on=\"company.roles.length > 2\">\n                <span ng-switch-when=\"true\">\n                  <ul class=\"unstyled\">\n                    <li>\n                      {{company.roles[0].name}}\n                    </li>\n                    <li>\n                      {{company.roles[1].name}}\n                    </li>\n                    <li class=\"col-sm-2\">\n                      <a ng-click=\"viewRoles(company.roles, company)\">more</a>\n                    </li>\n                  </ul>\n                </span>\n                <span ng-switch-default>\n                  <ul class=\"unstyled\" ng-repeat=\"role in company.roles track by $index\">\n                    <li>\n                      {{role.name}}\n                    </li>\n                  </ul>\n                </span>\n              </span>\n                </td>\n                <td>\n                  <ul class=\"unstyled\" ng-repeat=\"manager in company.managers track by $index\">\n                    <li>\n                      {{manager.display_name || \'Not assigned\'}}\n                    </li>\n                  </ul>\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-md-12\">\n        <div class=\"ibox float-e-margins\">\n          <div class=\"row\">\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <td>Positions</td>\n                <td>Company</td>\n                <td>Cost Center</td>\n                <td>Type</td>\n              </tr>\n              </thead>\n              <tbody>\n              <tr class=\"no-data\" ng-hide=\"positionAssign.length > 0\">\n                <td colspan=\"9\">There are no position for this user.</td>\n              </tr>\n              <tr ng-repeat=\"position in positionAssign\">\n                <td>{{ position.position_assignment.position.name }}</td>\n                <td>{{ position.company.descr }}</td>\n                <td>{{ position.cost_center.descr }}</td>\n                <td>{{ position.position_assignment.position.position_type }}</td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n\n      <user-delegation source=\"user\" user=\"user\"></user-delegation>\n\n      <div class=\"col-md-12 history\">\n        <div><h2>User History</h2></div>\n        <history dependencies=\"historyDependencies\"></history>\n      </div>\n\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/usersManagement/detail/edit-companies.html","<form name=\"form\" role=\"form\" novalidate>\n	<div class=\"modal-header\">\n		<button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n		<h3 class=\"modal-title\">Edit Company and Cost Centers</h3>\n	</div>\n	<div class=\"modal-body\">\n		<div class=\"form-horizontal\">\n			<div class=\"row form-group state-user-profile\">\n				<div ng-dropdown-multiselect=\"\" options=\"options.companies\" selected-model=\"selected_options.companies\" extra-settings=\"settingCompany\" translation-texts=\"defaultCompanyButtonText\" events=\"companyItemEvent\" orientation=\"ltr\"></div>\n				<div class=\"col-md-12\">\n					<div class=\"form-group\">\n						<ul class=\"unstyled\">\n							<li data-ng-repeat=\"selected_company in selected_options.companies\">\n								{{ selected_company.descr }}:\n								<ul class=\"unstyled\">\n									<li class=\"col-xs-12 company-description\" ng-repeat=\"item in selected_company.selected_cost_center\">\n										{{ item.descr }}\n									</li>\n								</ul>\n								<div ng-dropdown-multiselect=\"\" options=\"selected_company.costCenters\" selected-model=\"selected_company.selected_cost_center\" extra-settings=\"settingCostCenter\" translation-texts=\"defaultCostCenterButtonText\" events=\"costCenterItemEvent\" orientation=\"ltr\">\n								</div>\n								<!-- <button type=\"button\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-plus\"></i> Add cost center</button> -->\n							</li>\n						</ul>					\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n	<div class=\"modal-footer\">\n		<button type=\"button\" class=\"btn btn-primary\" ng-click=\"change()\" ng-disabled=\"form.$invalid || isUpdating || password.password !== password.password_confirm\">Change</button>\n		<button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button>\n	</div>\n</form>");
$templateCache.put("app/usersManagement/detail/showCostCenters-modalTemplate.html","<form>\n  <div class=\"user_view_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\"><b>{{::company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <th class=\"text-left-align\">CC code</th>\n            <th class=\"text-left-align\">CC description</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"cc in listCostCenters track by $index\">\n            <td>\n              {{cc.code}}\n            </td>\n            <td>\n              {{cc.descr}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/detail/showManagers-modalTemplate.html","<form>\n  <div class=\"user_view_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\"><b>{{::company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <th class=\"text-left-align\">Superior Name</th>\n            <th class=\"text-left-align\">Company Code</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"manager in listManagers track by $index\">\n            <td>\n              {{manager.display_name}}\n            </td>\n            <td>\n              {{manager.company_code}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/detail/showPositions-modalTemplate.html","<form>\n  <div class=\"user_view_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\"><b>{{::company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <th class=\"text-left-align\">Position Name</th>\n            <th class=\"text-left-align\">Company Code</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"position in listPositions track by $index\">\n            <td>\n              {{position.name}}\n            </td>\n            <td>\n              {{position.company_code ? position.company_code : \'System Position\'}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/detail/showRoles-modalTemplate.html","<form>\n  <div class=\"user_view_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\"><b>{{::company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <th class=\"text-left-align\">Roles</th>\n            <th class=\"text-left-align\">Company Code</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"role in listRoles track by $index\">\n            <td>\n              {{role.name}}\n            </td>\n            <td>\n              {{role.company_code ? role.company_code : \'System Role\'}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/edit/edit.html","<form name=\"user_edit_form\" novalidate>\n  <div class=\"state_user_add\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <fieldset class=\"form-horizontal\">\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">\n                  Full Name : <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.display_name.length && submitted}\">\n                  <input class=\"form-control\" name=\"user_name\" type=\"text\" ng-model=\"user.display_name\" placeholder=\"(e.g. John Doe)\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" required>\n                  <span class=\"text-danger\" ng-show=\"!user.display_name.length && submitted\">\n                    Full name is required\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">User Email : </label>\n                <div class=\"col-sm-9 m-b\">\n                  <label>{{::user.email}}</label>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">\n                  Company : <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\">\n                  <user-assignment user-id=\"user._id\" selected-companies=\"user.companies\" selected-cost-centers=\"user.costCenters\" selected-roles=\"user.roles\" selected-positions=\"user.positions\" selected-superiors=\"user.managers\" companies=\"options.companies\" save-disabled=\"saveDisabled\">\n                  </user-assignment>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">Email Notification Frequency: </label>\n                <div class=\"col-sm-9 m-b\">\n                  <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"ef in emailFrequency track by $index\">\n                  <input type=\"radio\" id=\"{{selection.ef}}\" name=\"selectEmailFrequency\" ng-model=\"user.email_notification_frequency\" ng-value=\"ef.value\" ng-click=\"selectedEmailFrequency(ef.value)\">\n                  &nbsp;&nbsp;{{ef.descr}}\n                    </div>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">\n                  Employee Number <span class=\"asterisk-required\">*</span>\n                </label>\n                <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !user.employee_number.length && submitted}\">\n                  <input class=\"form-control\" name=\"employee_number\" type=\"text\" ng-model=\"user.employee_number\" placeholder=\"(e.g. 045893)\" ng-change=\"duplicationCheck(\'Users\',\'emp_no\',user.employee_number,\'emp\')\" required>\n                  <span class=\"text-danger\" ng-show=\"!user.employee_number.length && submitted\">\n                    Employee number is required\n                  </span>\n                  <span class=\"text-danger\" ng-show=\"user.employee_number.length && empCheck\">\n                    Employee number {{user.employee_number}} is already taken!\n                  </span>\n\n                </div>\n              </div>\n            </fieldset>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-2\"></div>\n      <div class=\"col-sm-9 m-b\">\n        <div class=\"col-sm-6 update-change\">\n          <button class=\"btn btn-primary\" ng-click=\"saveUser()\" ng-disabled=\"saveDisabled\">Save changes</button>\n          <button class=\"btn btn-white\" ng-click=\"cancelEditUser()\">Cancel</button>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("app/usersManagement/escalation/escalationModificationPanelTemplate.html","<div class=\"inmodal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\">\n      x\n    </button>\n    <h4 class=\"modal-title\">Escalation</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"input-group col-md-12\">\n      <input type=\"text\" placeholder=\"Search for a Superior\" name=\"search\" class=\"form-control input-lg\" ng-model=\"search.title\" ui-keypress=\"{\'enter\':\'search(search.title)\'}\">\n      <div class=\"input-group-btn\">\n        <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-click=\"search(search.title)\">\n          <i class=\"fa fa-search\"></i>\n        </button>\n      </div>\n    </div>\n    <div>\n      <table class=\"table\">\n        <thead>\n        <th class=\"escalation-modal\">Name</th>\n        <th class=\"escalation-modal\">Email</th>\n        <th></th>\n        <th></th>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"searchedUser in usersSearched track by $index\">\n          <td class=\"escalation-modal\">{{searchedUser.display_name}}</td>\n          <td class=\"escalation-modal\">{{searchedUser.email}}</td>\n          <td>\n            <button ng-click=\"selectingUser(searchedUser)\" class=\"btn btn-primary\" ng-hide=\"user._id === searchedUser._id || searchedUser._id === superior._id\">\n              Select\n            </button>\n          </td>\n          <td>\n            <button ng-click=\"removeUser(searchedUser)\" class=\"btn btn-danger\" ng-show=\"searchedUser._id === superior._id\">\n              Remove\n            </button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/usersManagement/escalation/escalationTemplate.html","<div class=\"state_escalation_list\">\n<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Listing users for Escalation</h3>\n    </div>\n    <div class=\"col-md-7 no-padding mt-10\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <master-export module-name=\"Users\" collection=\"121\">\n      </master-export>\n      <generic-import module-name=\"Superior\" params=\"params\">\n      </generic-import>\n    </div>\n\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"userManageService\" status=\"status\" offset=\"offset\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"dataList\" class=\"table\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n        <td colspan=\"9\">There are no users in this status for now.</td>\n      </tr>\n      <tr ng-repeat=\"user in dataList\">\n        <td ng-show=\"showColumn(\'user.display_name\')\">\n          {{user.user[0].display_name}}\n        </td>\n        <td ng-show=\"showColumn(\'user.email\')\">\n          {{user.user[0].email}}\n        </td>\n        <td ng-show=\"showColumn(\'company.descr\')\">\n          {{user.company[0].descr || user.class | excludeMetabuyerModel }}\n        </td>\n        <td ng-show=\"showColumn(\'superior.display_name\')\" class=\"col-md-3\">\n          <a ng-click=\"modify(user.user[0], user.company[0], user.superior[0], user)\">\n            {{user.superior[0].display_name || \'Select a user\'}}\n          </a>\n        </td>\n        <td ng-show=\"showColumn(\'superior.email\')\" class=\"col-md-3\">\n          {{user.superior[0].email || \'\'}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n</div>\n");
$templateCache.put("app/usersManagement/import/import.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"panel-body\">\n          <div class=\"row\">\n            <h1>Import Users</h1>\n            <div class=\"pull-left\">\n              <generic-import module-name=\"Users\" params=\"params\">\n              </generic-import>\n            </div>\n          </div>\n          <div class=\"row\">\n            <h2><i>Example of a valid CSV format : </i></h2>\n            <img class=\"profile-avatar\" image-error=\"assets/images/sampleCSV.png\" ng-src=\"assets/images/sampleCSV.png\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/usersManagement/manage/manage.html","<div class=\"state_users_list\">\n<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding mt-10\">\n      <h3 ng-hide=\"actionType === \'search\'\" class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying {{status}} Users</h3>\n      <h3 class=\"pull-left\" ng-if=\"actionType === \'search\'\" style=\"margin-top: 7px; margin-right: 5px\">Searching result\n        of \"<i>{{ title }}</i>\"</h3>\n    </div>\n    <div class=\"col-md-7 no-padding mt-10\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n\n      <master-export module-name=\"Users\" collection=\"12\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"importAssignments()\">\n        Import User Assignments\n      </button>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"exportAssignments()\">\n        Export User Assignments\n      </button>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"userManageService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n        <td colspan=\"9\">There are no users in this status for now.</td>\n      </tr>\n      <tr ng-repeat=\"user in dataList \" ui-sref=\"main.user.users.detail({id: user._id})\" fadeout-row=\"user._id == highlightId\">\n        <td ng-show=\"showColumn(\'display_name\')\">{{user.display_name}}</td>\n        <td ng-show=\"showColumn(\'email\')\">{{user.email}}</td>\n        <td ng-show=\"showColumn(\'emp_no\')\">{{user.emp_no}}</td>\n        <td class=\"user-manage\" ng-show=\"showColumn(\'company\')\">{{listItem(user.companies, \'descr\')}}</td>\n        <td class=\"user-manage\" ng-show=\"showColumn(\'costCenter\')\">{{listItem(user.cc_list, \'descr\')}}</td>\n        <td ng-show=\"showColumn(\'created_at\')\">{{user.created_at | date: \'dd MMM yyyy\'}}</td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">{{user.creator[0].display_name}}</td>\n        <td ng-show=\"showColumn(\'updated_at\')\">{{user.updated_at | date: \'dd MMM yyyy\'}}</td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">{{user.updater[0].display_name}}</td>\n        <td ng-show=\"showColumn(\'role\')\">{{user.roles[0].name}}</td>\n        <td ng-show=\"status === \'all\' && showColumn(\'status\')\">{{getStatusName(user.status)}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n</div>\n");
$templateCache.put("app/usersManagement/onlineUsers/onlineUsersTemplate.html","<div class=\"state_online_users\">\n<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Listing Online users </h3>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"userManageService\" status=\"status\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead>\n      <tr>\n        <td st-sort=\"display_name\">Full Name</td>\n        <td st-sort=\"email\">Email</td>\n        <td st-sort=\"duration\">Duration</td>\n        <td st-sort=\"action\">Action</td>\n      </tr>\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n        <td colspan=\"9\">There are no Online users at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"info in dataList\">\n        <td>{{info.user.display_name}}</td>\n        <td>{{info.user.email}}</td>\n        <td am-time-ago=\"info.opened_at\"></td>\n        <td><a ng-click=\"disconnectUser(info, $index);\">Disconnect</a></td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n</div>\n\n");
$templateCache.put("components/accountCode/details/details.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Account Code Details</h4>\n  </div>\n  <form name=\"currencyUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Name</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"detailedAccountCode.name\" ng-disabled=\"!editClicked\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Code</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"detailedAccountCode.code\" ng-disabled=\"true\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Description</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"detailedAccountCode.descr\" ng-disabled=\"!editClicked\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Account Entries</label>\n              <div class=\"col-sm-10\">\n                <ui-select ng-model=\"detailedAccountCode.account_entries\" required ng-disabled=\"!editClicked\">\n                  <ui-select-match placeholder=\"Select account entries...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"option in accountEntries | filter: $select.search\">\n                    <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Account Type</label>\n              <div class=\"col-sm-10\">\n                <ui-select ng-model=\"detailedAccountCode.account_type\" required ng-disabled=\"!editClicked\">\n                  <ui-select-match placeholder=\"Select account type...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"option in accountType | filter: $select.search\">\n                    <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Account Receivable</label>\n              <div class=\"col-sm-10\">\n                <ui-select ng-model=\"detailedAccountCode.account_receivable\" required ng-disabled=\"!editClicked\">\n                  <ui-select-match placeholder=\"Select account receivable...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"option in accountReceivable | filter: $select.search\">\n                    <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Cost Centers</label>\n              <div class=\"col-sm-10\">\n                <ui-select multiple=\"multiple\" ng-model=\"detailedAccountCode.cost_center\" ng-disabled=\"!editClicked\">\n                  <ui-select-match placeholder=\"Select cost centers...\">\n                    {{ $item.descr }}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"option in costCenters | filter: $select.search\">\n                    <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Status</label>\n              <div class=\"col-sm-10\">\n                <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option\n                              in accountCodeStatuses track by option.isActive\" ng-model=\"detailedAccountCode.accountCodeStatus\">\n                </select>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n      <!--<button type=\"button\" class=\"btn btn-danger\"-->\n      <!--ng-click=\"deleteCostCenter()\">-->\n      <!--Delete-->\n      <!--</button>-->\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editAccountCode()\" ng-show=\"!editClicked\">\n        Edit\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked\" class=\"btn btn-primary\" ng-click=\"updateAccountCode()\">\n        Save changes\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("components/attachmentCategory/addAttachment/addAttachment.html","<div class=\"modal-content modal-inside add-attachment-category\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Add Attachment</h4>\n  </div>\n  <form name=\"add-attachment\" ng-submit=\"saveAttachment()\">\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-3 control-label\">Category <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-9\">\n            <ui-select ng-model=\"attachment.category\" on-select=\"onSelectCategory(attachment.category)\">\n              <ui-select-match placeholder=\"Select category...\"> {{$select.selected.name}} </ui-select-match>\n              <ui-select-choices repeat=\"category in attachmentCategories | filter: $select.search\">\n                <span ng-bind-html=\"category.name | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n\n        <!-- Attachment Fields based on the selected category -->\n        <div class=\"form-group\" ng-if=\"!!attachmentFields && !!attachmentFields.length\" ng-repeat=\"field in attachmentFields track by $index\">\n          <label class=\"col-sm-3 control-label\">\n            {{ field.name }} <span class=\"asterisk-required\" ng-if=\"!!field.is_mandatory\">*</span>\n          </label>\n          <div class=\"col-sm-9\">\n            <!-- String -->\n            <input type=\"text\" ng-if=\"field.type === \'string\'\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"!!field.is_mandatory\">\n\n            <!-- Number -->\n            <input type=\"number\" ng-if=\"field.type === \'int\'\" class=\"form-control\" ng-model=\"field.value\" ng-required=\"!!field.is_mandatory\">\n\n            <!-- Date -->\n            <input type=\"input\" readonly=\"readonly\" ng-click=\"openDatepicker($event, field._id)\" ng-if=\"field.type.toLowerCase() === \'mongodate\'\" placeholder=\"{{ field.name }}\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"field.value\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened[field._id]\" datepicker-options=\"dateOptions\" class=\"form-control\" ng-required=\"!!field.is_mandatory\">\n          </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"!!attachmentFields && !!attachmentFields.length\">\n          <label class=\"col-sm-3 control-label\">\n            Attachment <span class=\"asterisk-required\" ng-if=\"!editing\">*</span>\n          </label>\n          <div class=\"col-sm-9\">\n            <input type=\"file\" class=\"form-control\" ngfile-model=\"attachment.file\" ng-required=\"!editing\">\n            <span class=\"help-block m-b-none\" ng-if=\"!!editing\">Select new file to replace the current file.</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white pull-left\" ng-click=\"close()\">Close</button>\n      <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-if=\"!!attachmentFields && !!attachmentFields.length && !editing\">\n        Save\n      </button>\n      <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-if=\"!!attachmentFields && !!attachmentFields.length && !!editing\">\n        Save changes\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("components/budget/actions/actions.html","<div class=\"row no-background\">\n  <div class=\"col-md-12\">\n    <span class=\"back-buttons ml-15\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n\n    <!--Budget title non editable-->\n    <span class=\"budget-title-disabled\" ng-if=\"data.status.toLowerCase() !== \'draft\'\">\n      <text-show-less-more model=\"data.descr\" type=\"words\" length=\"20\" class=\"limit-lines\">\n      </text-show-less-more>\n    </span>\n\n    <!--Budget title editable-->\n    <span ng-if=\"data.status.toLowerCase() === \'draft\'\" editable-text=\"data.descr\" class=\"budget-title\" e-style=\"font-size: 20px; width: 500px\" e-required e-maxlength=\"255\" e-placeholder=\"Budget title\" ng-model=\"data.descr\" buttons=\"no\" blur=\"submit\">\n      <text-show-less-more model=\"data.descr\" type=\"words\" length=\"20\" class=\"limit-lines\">\n      </text-show-less-more>\n      <a class=\"btn\">\n        Edit\n      </a>\n    </span>\n  </div>\n  <div class=\"col-md-12\">\n    <div class=\"col-md-4\">\n      <!-- #region Waiting on -->\n      <div class=\"waiting-on\" ng-if=\"data.status.toLowerCase() === \'pending\' || data.status.toLowerCase() === \'on_hold\'\">\n        <approval-waiting-on data=\"approvalFlowData\"></approval-waiting-on>\n      </div>\n      <!-- #endregion waiting on -->\n    </div>\n    <div class=\"col-md-8\">\n      <span class=\"btn-group item-action pull-right clear-floating-right\" role=\"group\">\n\n        <!--Draft budget actions-->\n        <a class=\"btn btn-link mr-15\" ng-click=\"submitBudget()\" ng-show=\"data.status.toLowerCase() === \'draft\' && isCreator()\">\n          <i class=\"fa fa-arrow-circle-up\"></i> Submit\n        </a>\n        <a class=\"btn btn-link mr-15\" ng-click=\"saveBudget(\'draft\')\" ng-show=\"data.status.toLowerCase() === \'draft\' && isCreator()\">\n          <i class=\"fa fa-file-text\"></i> Save Changes\n        </a>\n        <a class=\"btn btn-link mr-15\" ng-if=\"canDelete()\" ng-click=\"deleteBudget()\">\n          <i class=\"fa fa-times\"></i> Delete\n        </a>\n        <a class=\"btn btn-link mr-15\" ng-if=\"canDeleteDraft()\" ng-click=\"deleteBudgetDraft()\">\n          <i class=\"fa fa-times\"></i> Delete draft\n        </a>\n\n          <!-- Revision -->\n        <a type=\"button\" class=\"btn btn-link mr-15\" ng-show=\"!!data.revisions && data.revisions.length &&\n              (data.status.toLowerCase() === \'approved\' || data.status.toLowerCase() === \'pending\')\" ng-click=\"showVersionList()\">\n          <i class=\"fa fa-files-o\"></i>\n          <span ng-if=\"data.status.toLowerCase() === \'approved\'\">Revision ({{ data.revisions.length + 1 }})</span>\n          <span ng-if=\"data.status.toLowerCase() === \'pending\'\">Compare with previous versions</span>\n        </a>\n\n          <!--Pending budget actions-->\n        <a class=\"btn btn-link mr-15\" ng-if=\"canApprove()\" action-modal title=\"Approve Budget\" action-function=\"approvalAction(\'approve\', \'You have approved this budget.\')\" action-condition=\"true\" module=\"budget\" success-handler=\"refreshBudgetDetails()\" next-action-id=\"{{nextBudget.context_id}}\" next-action-amount=\"totalBudgetOnHand\" id=\"budgetApprove\">\n          <i class=\"fa fa-check\"></i>Approve\n        </a>\n        <a class=\"btn btn-link mr-15\" ng-if=\"canReject()\" action-modal title=\"Reject Budget\" action-function=\"approvalAction(\'reject\', \'You have rejected this budget.\', rejectBudgetExtraParams)\" action-condition=\"true\" module=\"budget\" success-handler=\"refreshBudgetDetails()\" comment-block=\"true\" comment-place-holder=\"Write a reason for rejecting the budget, reason is mandatory to reject budget\" extra-params=\"rejectBudgetExtraParams\" next-action-id=\"{{nextBudget.context_id}}\" next-action-amount=\"totalBudgetOnHand\" id=\"budgetReject\">\n          <i class=\"fa fa-times\"></i>Reject\n        </a>\n        <a ng-if=\"canHold()\" action-modal title=\"Hold Budget\" action-function=\"approvalAction(\'on_hold\', \'You have placed this budget on hold\', onHoldExtraParams)\" action-condition=\"true\" module=\"budget\" next-action-id=\"{{nextBudget.context_id}}\" success-handler=\"refreshBudgetDetails()\" comment-block=\"true\" comment-place-holder=\"Write a reason for put on hold\" extra-params=\"onHoldExtraParams\" next-action-amount=\"totalBudgetOnHand\" id=\"hold\" class=\"btn btn-link mr-15\">\n          <i class=\"fa fa-pause\"></i>Hold\n        </a>\n        <a ng-if=\"canWithdraw()\" withdraw ng-click=\"showWithdraw()\" id=\"withdrawBudget\" class=\"btn btn-link mr-15\">\n          <i class=\"fa fa-share-square\"></i>Withdraw\n          <div ng-if=\"data.parent_id\">(Move to draft)</div>\n        </a>\n\n          <!--Un hold budget action-->\n        <a ng-if=\"canUnHold()\" action-modal title=\"Un-Hold Budget\" action-function=\"approvalAction(\'release\', \'You have released the hold from this budget\', {})\" action-condition=\"true\" module=\"budget\" success-handler=\"refreshBudgetDetails()\" extra-params=\"onHoldExtraParams\" id=\"un-hold\" class=\"btn btn-link mr-15\">\n          <i class=\"fa fa-check\"></i>Un-Hold\n        </a>\n\n          <!--Fully approved/active budget actions-->\n        <a class=\"btn btn-link mr-15\" ng-click=\"createRevisionDraft()\" ng-show=\"data.status.toLowerCase() === \'approved\' && isCreator()\">\n          <i class=\"fa fa-pencil-square-o\"></i> Revise\n        </a>\n        <a class=\"btn btn-link mr-15\" ng-if=\"canDeactivate()\" ng-click=\"deactivateBudget()\">\n          <i class=\"fa fa-times-circle-o\"></i> Deactivate\n        </a>\n\n          <!--Reactivated budget actions-->\n        <a class=\"btn btn-link mr-15\" ng-if=\"canReactivate()\" ng-click=\"reactivateBudget()\">\n          <i class=\"fa fa-file\"></i> Reactivate\n        </a>\n\n          <!--Resubmit budget actions-->\n        <a class=\"btn btn-link mr-15\" ng-if=\"canResubmit()\" ng-click=\"saveBudget(\'draft\')\">\n          <i class=\"fa fa-arrow-circle-up\"></i> Move to draft (to resubmit)\n        </a>\n      </span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/budget/apportion/apportionAllocation.editableTemplate.html","<div class=\"budget modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Apportion Allocation</h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <table class=\"table table-striped vertical-align-middle col-md-12\">\n          <thead>\n            <th width=\"10%\">Start Date</th>\n            <th width=\"10%\">End Date</th>\n            <th width=\"15%\">Used Amount</th>\n            <th width=\"15%\">Committed Amount</th>\n            <th width=\"15%\">Carried Forward Amount</th>\n            <th width=\"15%\">Available Balance</th>\n            <th width=\"20%\">Apportion Amount</th>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"allocation in apportionAllocation\" class=\"grey-text font-bold\">\n            <td width=\"10%\">\n              {{ allocation.start_date | date: \'dd MMM yyyy\' }}\n            </td>\n            <td width=\"10%\">\n              {{ allocation.end_date | date: \'dd MMM yyyy\' }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.used_amount || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.committed_amount || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.amount_carried_forward || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.available_balance || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"20%\">\n              <input type=\"number\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': allocation.amount < (allocation.used_amount + allocation.committed_amount)}\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" ng-model=\"allocation.amount\" ng-disabled=\"validateDateRange(allocation.end_date) && !!parentId\">\n              <span ng-show=\"allocation.amount < (allocation.used_amount + allocation.committed_amount)\" class=\"text-danger\">\n                Amount cannot be less than total used and committed amount\n              </span>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n        <table class=\"table apportion-amount-summary table-striped vertical-align-middle col-md-12\">\n          <thead>\n            <th>\n              <span>Budget Amount</span>\n            </th>\n            <th>\n            </th>\n            <th></th>\n            <th></th>\n            <th></th>\n            <th>\n              <span ng-if=\"(getTotalApportionAllocation() - availableAmount) <= 0\">Available Allocation</span>\n              <span ng-if=\"getTotalApportionAllocation() - availableAmount > 0\">Exceeded Allocation</span>\n            </th>\n            <th>\n              <span>Total Allocation</span>\n            </th>\n          </thead>\n          <tbody>\n          <tr>\n            <td>\n              <span>{{ availableAmount | formatDecimal: 2 }}</span>\n            </td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td>\n              <span ng-class=\"{\'text-danger\': ( getTotalApportionAllocation() - availableAmount ) > 0}\">\n                {{ - ( getTotalApportionAllocation() - availableAmount ) | formatDecimal: 2 }}\n              </span>\n            </td>\n            <td>\n              <span>{{ getTotalApportionAllocation() | formatDecimal: 2 }}</span>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <input id=\"allowApportionCarryForward\" type=\"checkbox\" icheck ng-model=\"apportionCarryForward\">\n        <label for=\"allowApportionCarryForward\">Allow apportion to carry forward</label>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveApportion()\">\n      Save\n    </button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">\n      Close\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/budget/apportion/apportionAllocation.nonEditableTemplate.html","<div class=\"budget modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">x</button>\n    <h4 class=\"modal-title\">Apportion Allocation</h4>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <table class=\"table table-striped vertical-align-middle col-md-12\">\n          <thead>\n          <th width=\"10%\">Start Date</th>\n          <th width=\"10%\">End Date</th>\n          <th width=\"15%\">Used Amount</th>\n          <th width=\"15%\">Committed Amount</th>\n          <th width=\"15%\">Carried Forward Amount</th>\n          <th width=\"15%\">Available Balance</th>\n          <th width=\"20%\">Apportion Amount</th>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"allocation in apportionAllocation\" class=\"grey-text font-bold\">\n            <td width=\"10%\">\n              {{ allocation.start_date | date: \'dd MMM yyyy\' }}\n            </td>\n            <td width=\"10%\">\n              {{ allocation.end_date | date: \'dd MMM yyyy\' }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.used_amount || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.committed_amount || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.amount_carried_forward || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"15%\">\n              {{ (allocation.available_balance || 0) | formatDecimal: 2 }}\n            </td>\n            <td width=\"20%\">\n              {{ (allocation.amount || 0) | formatDecimal: 2 }}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n        <table class=\"table apportion-amount-summary table-striped vertical-align-middle col-md-12\">\n          <thead>\n          <th>\n            <span>Budget Amount</span>\n          </th>\n          <th>\n          </th>\n          <th></th>\n          <th></th>\n          <th></th>\n          <th>\n            <span ng-if=\"(getTotalApportionAllocation() - availableAmount) <= 0\">Available Allocation</span>\n            <span ng-if=\"getTotalApportionAllocation() - availableAmount > 0\">Exceeded Allocation</span>\n          </th>\n          <th>\n            <span>Total Allocation</span>\n          </th>\n          </thead>\n          <tbody>\n          <tr>\n            <td>\n              <span>{{ availableAmount | formatDecimal: 2 }}</span>\n            </td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td>\n              <span ng-class=\"{\'text-danger\': ( getTotalApportionAllocation() - availableAmount ) > 0}\">\n                {{ - ( getTotalApportionAllocation() - availableAmount ) | formatDecimal: 2 }}\n              </span>\n            </td>\n            <td>\n              <span>{{ getTotalApportionAllocation() | formatDecimal: 2 }}</span>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <h3>Allow apportion to carry forward</h3>\n        {{!!apportionCarryForward ? \'Allowed\' : \'Not Allowed\'}}\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">\n      Close\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/budget/apportion/apportionButton.html","<button type=\"button\" class=\"apportion-details btn btn-default\" ng-show=\"apportionType !== \'N/A\'\" ng-click=\"openApportionDetails()\">\n  <i class=\"fa\" ng-class=\"{\'fa-pencil-square-o\': editingMode === \'editable\',\n  \'fa-info-circle\': editingMode !== \'editable\'}\"></i>\n</button>\n");
$templateCache.put("components/budget/assignments/budgetAssignments.editableTemplate.html","<div class=\"row budget\">\n  <div class=\"col-md-12\">\n\n    <div ng-repeat=\"assignment in budgetData.assignments track by $index\" class=\"budget-assignment\">\n      <!--First row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-12\">\n          <h3>{{ $index + 1 }}.</h3>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Budget Code</h3>\n            {{ assignment.code || \'N/A\' }}\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Budget Description<span class=\"asterisk-required\">*</span></h3>\n            <div>\n              <textarea class=\"form-control\" ng-model=\"assignment.descr\" ng-class=\"{\'highlight-error-input\': !!assignment.descr && !!budgetAssignmentDetailsError}\">\n              </textarea>\n            </div>\n            <span class=\"text-danger\" ng-if=\"!assignment.descr && !!budgetAssignmentDetailsError\">\n              Budget Description is required\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Cost Center<span class=\"asterisk-required\">*</span></h3>\n            <ui-select ng-model=\"assignment.cost_center\" ng-class=\"{\'highlight-error-input\': !assignment.cost_center && !!budgetAssignmentDetailsError}\">\n              <ui-select-match placeholder=\"Select cost center\" allow-clear=\"true\">\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"costCenterItem in budgetData.cost_center | filter: {descr: $select.search}\">\n                <div ng-bind-html=\"(costCenterItem.descr | highlight: $select.search)\">\n                </div>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!assignment.cost_center && !!budgetAssignmentDetailsError\">\n              Cost Center is required\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Expense Type<span class=\"asterisk-required\">*</span></h3>\n            <ui-select ng-model=\"assignment.expense_type\" ng-disabled=\"!!budgetData.expense_type\" ng-class=\"{\'highlight-error-input\': !assignment.expense_type && !!budgetAssignmentDetailsError}\">\n              <ui-select-match placeholder=\"Select expense type\" allow-clear=\"true\">\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"et in expenseTypeList | filter: $select.search\">\n                <div ng-bind-html=\"et.descr | highlight: $select.search\">\n                </div>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!assignment.expense_type && !!budgetAssignmentDetailsError\">\n              Expense Type is required\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-1\">\n          <button class=\"btn btn-danger\" ng-click=\"deleteBudgetAssignments($index)\" ng-show=\"canDelete(assignment)\">\n            Delete\n          </button>\n        </div>\n      </div>\n      <!--Second row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Budget Amount<span class=\"asterisk-required\">*</span></h3>\n            <input type=\"number\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" class=\"form-control\" ng-model=\"assignment.amount\" ng-model-options=\"{debounce: 1000}\" ng-change=\"checkApportionAllocation(originalAssignmentData[$index].amount, assignment.amount,\n              \'amount\', $index)\" ng-class=\"{\'highlight-error-input\': ((!assignment.amount && !!budgetAssignmentDetailsError)) || !!isAssignmentAmountGreaterThanMaster()}\" placeholder=\"Enter budget amount\">\n            <span class=\"text-danger\" ng-if=\"!assignment.amount && !!budgetAssignmentDetailsError\">\n              Budget Amount is required\n            </span>\n            <span class=\"text-danger\" ng-if=\"!!isAssignmentAmountGreaterThanMaster()\">\n              Total budget assignment amount cannot be more than budget master amount.\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount</h3>\n            <div>\n              <input type=\"number\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !!assignment.block_amount && !!assignment.amount &&\n               (assignment.block_amount > assignment.amount)}\" ng-model=\"assignment.block_amount\" ng-model-options=\"{debounce: 1000}\" ng-change=\"checkApportionAllocation(originalAssignmentData[$index].block_amount, assignment.block_amount,\n                 \'block_amount\', $index)\" placeholder=\"Enter blocked amount\">\n              <span class=\"text-danger\" ng-if=\"!!assignment.block_amount && !!assignment.amount &&\n                    (assignment.block_amount > assignment.amount)\">\n                Blocked Amount cannot be greater than Budget Amount\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount Reason<span class=\"asterisk-required\" ng-if=\"!!assignment.block_amount\">*</span>\n            </h3>\n            <textarea class=\"form-control\" ng-model=\"assignment.block_amount_reason\" ng-class=\"{\'highlight-error-input\': !!assignment.block_amount && !!budgetAssignmentDetailsError && !assignment.block_amount_reason}\" ng-disabled=\"!assignment.block_amount\">\n            </textarea>\n            <span class=\"text-danger\" ng-if=\"!!assignment.block_amount && !!budgetAssignmentDetailsError && !assignment.block_amount_reason\">\n              Block Amount Reason is required\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Justification</h3>\n            <textarea ng-model=\"assignment.justification\" placeholder=\"Enter justification\" class=\"form-control\">\n            </textarea>\n          </div>\n        </div>\n      </div>\n      <!--Third row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-2\">\n          <div class=\"row\">\n            <h3 class=\"col-md-12\">Start Date<span class=\"asterisk-required\">*</span></h3>\n          </div>\n          <div class=\"form-group\">\n            <div class=\"input-group\">\n              <input type=\"input\" ng-click=\"openAssignmentDatepicker($event, \'startDateAssignment\', $index)\" placeholder=\"Start date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"assignment.start_date\" ng-change=\"checkApportionAllocation(originalAssignmentData[$index].start_date, assignment.start_date,\n                \'start_date\', $index)\" is-open=\"assignment.startDatepickerOpened\" datepicker-options=\"startDateOptions[$index]\" ng-class=\"{\'highlight-error-input\': (!assignment.start_date && !!budgetAssignmentDetailsError) ||\n                (!!assignment.start_date && !!budgetData.start_date && (assignment.start_date < budgetData.start_date))}\" class=\"form-control\" required>\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"openAssignmentDatepicker($event, \'startDateAssignment\', $index)\">\n                  <i class=\"fa fa-calendar\"></i>\n                </button>\n              </span>\n            </div>\n            <span class=\"text-danger\" ng-if=\"!assignment.start_date && !!budgetAssignmentDetailsError\">\n              Start Date is required\n            </span>\n            <span class=\"text-danger\" ng-if=\"(!!assignment.start_date && !!budgetData.start_date && (assignment.start_date < budgetData.start_date))\">\n              Selected start date must not be earlier than budget master start date.\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <h3>End Date<span class=\"asterisk-required\">*</span></h3>\n          <div class=\"form-group\">\n            <div class=\"input-group\">\n              <input type=\"input\" ng-click=\"openAssignmentDatepicker($event, \'endDateAssignment\', $index)\" placeholder=\"End date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"assignment.end_date\" ng-change=\"checkApportionAllocation(originalAssignmentData[$index].end_date, assignment.end_date,\n                \'end_date\', $index)\" is-open=\"assignment.endDatepickerOpened\" datepicker-options=\"endDateOptions[$index]\" ng-class=\"{\'highlight-error-input\': (!assignment.end_date && !!budgetAssignmentDetailsError) ||\n                (!!assignment.end_date && !!budgetData.end_date && (assignment.end_date > budgetData.end_date))}\" class=\"form-control\" required>\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"openAssignmentDatepicker($event, \'endDateAssignment\', $index)\">\n                  <i class=\"fa fa-calendar\"></i>\n                </button>\n              </span>\n            </div>\n            <span class=\"text-danger\" ng-if=\"!assignment.end_date && !!budgetAssignmentDetailsError\">\n              End Date is required\n            </span>\n            <span class=\"text-danger\" ng-if=\"(!!assignment.end_date && !!budgetData.end_date && (assignment.end_date > budgetData.end_date))\">\n              Selected end date must not be later than budget master end date.\n            </span>\n          </div>\n        </div>\n        <!--<div class=\"col-md-3\">-->\n          <!--<div class=\"form-group\">-->\n            <!--<h3>Apportion<span class=\"asterisk-required\">*</span></h3>-->\n            <!--<div ng-class=\"{\'input-group\' : assignment.apportion_type !== \'N/A\' && !assignment.item_breakdowns.length &&-->\n                 <!--!!assignment.amount && !!assignment.start_date && !!assignment.end_date}\">-->\n              <!--<ui-select ng-model=\"assignment.apportion_type\"-->\n                         <!--ng-change=\"checkApportionAllocation(originalAssignmentData[$index].apportion_type,-->\n                         <!--assignment.apportion_type, \'apportion_type\', $index)\"-->\n                         <!--ng-disabled=\"budgetData.apportion_type !== \'N/A\' ||-->\n                         <!--(!assignment.start_date || !assignment.end_date || !assignment.amount) ||-->\n                         <!--hasParentBudget()\"-->\n                         <!--ng-class=\"{\'highlight-error-input\': !assignment.apportion_type && !!budgetAssignmentDetailsError}\">-->\n                <!--<ui-select-match placeholder=\"Select Apportion\">-->\n                  <!--{{$select.selected | capitalize}}-->\n                <!--</ui-select-match>-->\n                <!--<ui-select-choices repeat=\"apportion in apportionList | filter: $select.search\">-->\n                  <!--<div ng-bind-html=\"apportion | highlight: $select.search | capitalize\">-->\n                  <!--</div>-->\n                <!--</ui-select-choices>-->\n              <!--</ui-select>-->\n              <!--<span class=\"input-group-btn\"-->\n                    <!--ng-if=\"assignment.apportion_type !== \'N/A\' && !assignment.item_breakdowns.length &&-->\n                    <!--!!assignment.amount && !!assignment.start_date && !!assignment.end_date\">-->\n                <!--<apportion-->\n                  <!--apportion-type=\"assignment.apportion_type\"-->\n                  <!--editing-mode=\"editingMode\"-->\n                  <!--start-date=\"assignment.start_date\"-->\n                  <!--end-date=\"assignment.end_date\"-->\n                  <!--available-amount=\"(assignment.amount - assignment.block_amount)\"-->\n                  <!--apportion-allocation=\"assignment.apportion_allocation\"-->\n                  <!--apportion-related-values=\"assignment.apportionRelatedValues\"-->\n                  <!--apportion-carry-forward=\"assignment.apportion_carry_forward\"-->\n                  <!--parent-id=\"budgetData.parent_id\">-->\n              <!--</apportion>-->\n              <!--</span>-->\n            <!--</div>-->\n            <!--<span class=\"text-danger\"-->\n                  <!--ng-if=\"!assignment.apportion_type && !!budgetAssignmentDetailsError\">-->\n              <!--Apportion is required-->\n            <!--</span>-->\n          <!--</div>-->\n        <!--</div>-->\n        <div class=\"col-md-4\">\n          <br><br>\n          <input id=\"budgetAssignmentAllowDashboard{{$index}}\" type=\"checkbox\" icheck ng-model=\"assignment.pr_dashboard_display\">\n          <label for=\"budgetAssignmentAllowDashboard{{$index}}\">\n            Allow PR requester to view budget dashboard in PR\n          </label>\n        </div>\n        <div class=\"col-md-2\"></div>\n      </div>\n      <!--Fourth row-->\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <item-breakdowns budget-data=\"assignment\" budget-master=\"budgetData\" budget-item-details-error=\"budgetItemDetailsError\" editing-mode=\"editingMode\" apportion-list=\"apportionList\">\n          </item-breakdowns>\n        </div>\n      </div>\n      <div class=\"row screen-section\">\n        <div class=\"col-md-12\">\n          <table class=\"table table-text-center default-cursor\">\n            <thead>\n            <th>Budget Amount</th>\n            <th>Used Amount</th>\n            <th>Committed Amount</th>\n            <th>Blocked Amount</th>\n            <th>Available Amount</th>\n            <th> </th>\n            </thead>\n            <tbody>\n            <td class=\"grey-text\">\n              {{ ::assignment.amount ? assignment.amount : 0 }}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.used_amount ? assignment.used_amount : 0 }}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.committed_amount ? assignment.committed_amount : 0 }}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.block_amount ? assignment.block_amount : 0 }}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.available_balance }}\n            </td>\n            <td>\n            </td>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <button class=\"btn btn-primary\" ng-click=\"addBudgetAssignments()\">\n          Add Budget Assignment\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-12\">\n    <span class=\"section-text\">Total Assignment</span>\n  </div>\n\n  <div class=\"col-md-12\">\n    <table class=\"table table-text-center default-cursor\">\n      <thead>\n      <th>Total Budget Assignment Amount</th>\n      <th>Used Amount</th>\n      <th>Committed Amount</th>\n      <th>Blocked Amount</th>\n      <th>Available Amount</th>\n      </thead>\n      <tbody>\n      <tr class=\"grey-text\">\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_amount : 0 }}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_used_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_used_amount : 0 }}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_committed_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_committed_amount : 0 }}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_block_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_block_amount : 0 }}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_available_balance ?\n          budgetData.totalBudgetAssignmentsValue.total_available_balance : 0 }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/assignments/budgetAssignments.nonEditableTemplate.html","<div class=\"row budget\">\n  <div class=\"col-md-12\" ng-show=\"!!budgetData.status && budgetData.status !== \'draft\' && budgetData.assignments.length > 0\">\n    <label class=\"pull-right\">\n      <input type=\"checkbox\" ng-model=\"allAssignmentsExpand\" ng-click=\"toggleAssignmentDisplay()\">\n      Expand All\n    </label>\n  </div>\n  <uib-accordion class=\"col-md-12\" close-others=\"false\">\n    <div uib-accordion-group ng-repeat=\"assignment in budgetData.assignments track by $index\" class=\"budget-assignment panel-default accordion-budget-assignment\" is-open=\"assignment.isOpen\">\n      <uib-accordion-heading>\n        <div class=\"row header-font\">\n          <div class=\"col-md-4\">\n            <h3>{{ $index + 1 }} . {{assignment.descr}} ({{assignment.code}})</h3>\n          </div>\n          <div class=\"col-md-3\">\n            <h3>{{assignment.cost_center.descr || \'N/A\'}}</h3>\n          </div>\n          <div class=\"col-md-2\">\n            <h3>{{assignment.expense_type.descr || \'N/A\'}}</h3>\n          </div>\n          <div class=\"col-md-2\">\n            <h3 class=\"pull-right\">{{ assignment.amount === null ? 0 : assignment.amount | formatDecimal: 2 }}</h3>\n          </div>\n          <div class=\"col-md-1\">\n            <i class=\"pull-right fa expand-btn\" ng-class=\"{\'fa-chevron-up\': assignment.isOpen, \'fa-chevron-down\': !assignment.isOpen}\">\n            </i>\n          </div>\n        </div>\n      </uib-accordion-heading>\n\n      <!--First row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Budget Code</h3>\n            {{ assignment.code || \'N/A\' }}\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Budget Description</h3>\n            {{assignment.descr || \'N/A\'}}\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Cost Center</h3>\n            {{assignment.cost_center.descr || \'N/A\'}}\n          </div>\n        </div>\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Expense Type</h3>\n            {{assignment.expense_type.descr || \'N/A\'}}\n          </div>\n        </div>\n        <div class=\"col-md-1\"></div>\n      </div>\n      <!--Second row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Budget Amount</h3>\n            {{ assignment.amount === null ? 0 : assignment.amount | formatDecimal: 2 }}\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount</h3>\n            {{ assignment.block_amount === null ? 0 : assignment.block_amount | formatDecimal: 2}}\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount Reason</h3>\n            <p class=\"text-area-block\">{{assignment.block_amount_reason || \'N/A\'}}</p>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <h3>Justification</h3>\n          <p class=\"text-area-block\">{{assignment.justification || \'N/A\'}}</p>\n        </div>\n      </div>\n      <!--Third row-->\n      <div class=\"row screen-section\">\n        <div class=\"col-md-2\">\n          <div class=\"row\">\n            <h3 class=\"col-md-12\">Start Date</h3>\n          </div>\n          <div class=\"form-group\">\n            {{ (assignment.start_date || \'N/A\') | date:\'dd MMM yyyy\' }}\n          </div>\n        </div>\n        <div class=\"col-md-2\">\n          <h3>End Date</h3>\n          <div class=\"form-group\">\n            <div class=\"form-group\">\n              {{ (assignment.end_date || \'N/A\') | date:\'dd MMM yyyy\' }}\n            </div>\n          </div>\n        </div>\n        <!--<div class=\"col-md-3\">-->\n          <!--<div class=\"form-group\">-->\n            <!--<h3>Apportion</h3>-->\n            <!--{{ (assignment.apportion_type || \'N/A\') | capitalize }}-->\n            <!--<span ng-show=\"assignment.apportion_type !== \'N/A\'\">-->\n              <!--<apportion-->\n                <!--apportion-type=\"assignment.apportion_type\"-->\n                <!--editing-mode=\"editingMode\"-->\n                <!--start-date=\"assignment.start_date\"-->\n                <!--end-date=\"assignment.end_date\"-->\n                <!--available-amount=\"(assignment.amount - assignment.block_amount)\"-->\n                <!--apportion-allocation=\"assignment.apportion_allocation\"-->\n                <!--apportion-carry-forward=\"assignment.apportion_carry_forward\"-->\n                <!--parent-id=\"budgetData.parent_id\">-->\n              <!--</apportion>-->\n            <!--</span>-->\n          <!--</div>-->\n        <!--</div>-->\n        <div class=\"col-md-4\">\n          <div class=\"form-group\">\n            <h3>Allow PR requester to view budget dashboard in PR</h3>\n            {{ assignment.pr_dashboard_display ? \'Allowed\' : \'Not Allowed\'}}\n          </div>\n        </div>\n      </div>\n      <!--Fourth row-->\n      <div class=\"row\" ng-show=\"!!assignment.item_breakdowns.length\">\n        <div class=\"col-md-12\">\n          <item-breakdowns budget-data=\"assignment\" budget-master=\"budgetData\" budget-item-details-error=\"budgetAssignmentDetailsError\" editing-mode=\"editingMode\" apportion-list=\"apportionList\">\n          </item-breakdowns>\n        </div>\n      </div>\n      <div class=\"row screen-section\">\n        <div class=\"col-md-12\">\n          <table class=\"table table-text-center default-cursor\">\n            <thead>\n            <th>Budget Amount</th>\n            <th>Used Amount</th>\n            <th>Committed Amount</th>\n            <th>Blocked Amount</th>\n            <th>Available Amount</th>\n            <th> </th>\n            </thead>\n            <tbody>\n            <td class=\"grey-text\">\n              {{ ::assignment.amount ? assignment.amount : 0 | formatDecimal: 2}}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.used_amount ? assignment.used_amount : 0 | formatDecimal: 2}}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.committed_amount ? assignment.committed_amount : 0 | formatDecimal: 2}}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.block_amount ? assignment.block_amount : 0 | formatDecimal: 2}}\n            </td>\n            <td class=\"grey-text\">\n              {{ ::assignment.available_balance ? assignment.available_balance : 0 | formatDecimal: 2}}\n            </td>\n            <td>\n              <a ng-click=\"showAssignmentItems(assignment)\" class=\"btn\" ng-if=\"showItemListing()\">\n                <i class=\"fa fa-chevron-circle-down fa-lg\"></i>\n              </a>\n            </td>\n            </tbody>\n          </table>\n          <!--#region budget assignment item listing-->\n          <div ng-if=\"assignment.toggle\">\n            <item-listing budget=\"budgetData._id\" assignment=\"assignment._id\">\n            </item-listing>\n          </div>\n        </div>\n      </div>\n    </div>\n  </uib-accordion>\n\n  <div class=\"col-md-12\">\n    <span class=\"section-text\">Total Assignment</span>\n  </div>\n\n  <div class=\"col-md-12\">\n    <table class=\"table table-text-center default-cursor\">\n      <thead>\n      <th>Total Budget Assignment Amount</th>\n      <th>Used Amount</th>\n      <th>Committed Amount</th>\n      <th>Blocked Amount</th>\n      <th>Available Amount</th>\n      </thead>\n      <tbody>\n      <tr class=\"grey-text\">\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_amount : 0 | formatDecimal: 2}}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_used_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_used_amount : 0 | formatDecimal: 2}}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_committed_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_committed_amount : 0 | formatDecimal: 2}}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_block_amount ?\n          budgetData.totalBudgetAssignmentsValue.total_block_amount : 0 | formatDecimal: 2}}\n        </td>\n        <td>{{::budgetData.totalBudgetAssignmentsValue.total_available_balance ?\n          budgetData.totalBudgetAssignmentsValue.total_available_balance : 0 | formatDecimal: 2}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/createBudgetButton/createBudgetButton.html","<span ng-show=\"showCreateButton()\">\n  <!-- Single company-->\n  <button id=\"createBudgetButton\" ng-click=\"createBudget(listOfCompanies[0])\" ng-if=\"!!listOfCompanies.length && listOfCompanies.length === 1\" class=\"btn navbar-btn btn-primary dropdown-toggle\" aria-expanded=\"false\" ng-disabled=\"disabled\">\n    {{ title }}\n  </button>\n\n  <!-- Multi companies -->\n <div ng-repeat-end class=\"btn-group\" ng-if=\"listOfCompanies.length > 1\">\n   <button data-toggle=\"dropdown\" class=\"btn navbar-btn {{ \'btn-primary\' || \'btn-default\' }} dropdown-toggle\" aria-expanded=\"false\">\n          {{ title }}\n     <span class=\"fa fa-caret-down\"></span>\n   </button>\n   <ul class=\"dropdown-menu create-button\">\n     <div class=\"search-input-bar-full\">\n       <input type=\"text\" class=\"form-control\" placeholder=\"Search Companies\" ng-model=\"searchFilter\">\n      </div>\n\n     <li ng-repeat=\"company in listOfCompanies | filter:{descr: searchFilter}\">\n       <a ng-click=\"createBudget(company)\">{{ company.descr }}</a>\n     </li>\n   </ul>\n </div>\n</span>\n");
$templateCache.put("components/budget/dashboard/budgetDashboard.html","<div class=\"budget\" ng-show=\"!!showDashboard\">\n  <div class=\"col-md-12 text-center mb-10\">\n        <span class=\"dashboard-title\">\n          {{ budget.code }} - {{ budget.descr }}\n        </span>\n  </div>\n\n  <div class=\"col-md-3 text-center\">\n    <div>\n      <h4>Total budget</h4>\n    </div>\n    <ui-knob value=\"valueTotalBudget\" options=\"option\"></ui-knob>\n    <div>\n      <h4>{{ totalBudget*exchangeRate | isoCurrency:sourceCurrency.code:2 }}</h4>\n    </div>\n    <div ng-show=\"isSourceCurrencyDifferent()\" class=\"gray-text\">\n      <h4>({{ totalBudget | isoCurrency:budget.currency.code:2 }})</h4>\n    </div>\n  </div>\n\n  <div class=\"col-md-3 text-center\" ng-show=\"!currentApportion\">\n    <div>\n      <h4>Available Amount</h4>\n    </div>\n    <ui-knob value=\"valueTotalAvailableBudget\" options=\"option\"></ui-knob>\n    <div>\n      <h4>{{ totalAvailableBudget*exchangeRate | isoCurrency:sourceCurrency.code:2 }}</h4>\n    </div>\n    <div ng-show=\"isSourceCurrencyDifferent()\" class=\"gray-text\">\n      <h4>({{ totalAvailableBudget | isoCurrency:budget.currency.code:2 }})</h4>\n    </div>\n  </div>\n\n  <div class=\"col-md-3 text-center\" ng-show=\"!!currentApportion\">\n    <div>\n      <h4>Available Amount for {{currentApportion.start_date | date: \'dd MMM yyyy\'}} to {{currentApportion.end_date | date: \'dd MMM yyyy\'}}</h4>\n    </div>\n    <ui-knob value=\"valueTotalAvailableBudget\" options=\"option\"></ui-knob>\n    <div>\n      <h4>{{ totalAvailableBudget*exchangeRate | isoCurrency:sourceCurrency.code:2 }}</h4>\n    </div>\n    <div ng-show=\"isSourceCurrencyDifferent()\" class=\"gray-text\">\n      <h4>({{ totalAvailableBudget | isoCurrency:budget.currency.code:2 }})</h4>\n    </div>\n  </div>\n\n  <div class=\"col-md-3 text-center\">\n    <div>\n      <h4>Used Amount</h4>\n    </div>\n    <ui-knob value=\"valueTotalUsedBudget\" options=\"option\"></ui-knob>\n    <div>\n      <h4>{{ totalUsedBudget*exchangeRate | isoCurrency:sourceCurrency.code:2 }}</h4>\n    </div>\n    <div ng-show=\"isSourceCurrencyDifferent()\" class=\"gray-text\">\n      <h4>({{ totalUsedBudget | isoCurrency:budget.currency.code:2 }})</h4>\n    </div>\n  </div>\n\n  <div class=\"col-md-3 text-center\">\n    <div>\n      <h4>Committed Amount</h4>\n    </div>\n    <ui-knob value=\"valueTotalCommittedBudget\" options=\"option\"></ui-knob>\n    <div>\n      <h4>{{ totalCommittedBudget*exchangeRate | isoCurrency:sourceCurrency.code:2 }}</h4>\n    </div>\n    <div ng-show=\"isSourceCurrencyDifferent()\" class=\"gray-text\">\n      <h4>({{ totalCommittedBudget | isoCurrency:budget.currency.code:2 }})</h4>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("components/budget/detailsHeader/detailsHeader.editableTemplate.html","<div class=\"row\">\n  <div class=\"col-md-1\">\n    <h3 class=\"text-left-align\">Code</h3>\n  </div>\n  <div class=\"col-md-11 change-action text-left-align\">\n    <h4 class=\"code-text\">\n      {{budget.code}}\n    </h4>\n  </div>\n</div>\n\n<!--First row-->\n<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Company</h3>\n      {{budget.company.descr}}\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Currency</h3>\n      <div ng-if=\"!!budget.parent_id\"> {{ budget.currency.code }} </div>\n      <ui-select ng-if=\"!budget.parent_id\" ng-model=\"budget.currency\">\n        <ui-select-match placeholder=\"Select a currency...\">\n          {{$select.selected.code}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"currency in currencyList | filter: {code: $select.search}\">\n          <div ng-bind-html=\"currency.code | highlight: $select.search\"></div>\n        </ui-select-choices>\n      </ui-select>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\" ng-show=\"!budgetAllocate || !!budget.costCenter\">\n    <div class=\"form-group\">\n      <h3>Cost Center<span class=\"asterisk-required\">*</span></h3>\n      <div ng-dropdown-multiselect options=\"costCenterList\" selected-model=\"budget.cost_center\" extra-settings=\"costCenterExtraSettings\" class=\"company-select-currencies\">\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Expense Type<span class=\"asterisk-required\" ng-if=\"!budget.assignments.length\">*</span></h3>\n      <ui-select ng-model=\"budget.expense_type\" ng-class=\"{\'highlight-error-input\': !budget.expense_type && headerDetailsError && !budget.assignments.length}\">\n        <ui-select-match placeholder=\"Select an expense type...\" allow-clear=\"true\">\n          {{$select.selected.descr}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"expenseItem in expenseTypeList | filter: {descr: $select.search}\">\n          <div ng-bind-html=\"(expenseItem.descr | highlight: $select.search) + \' [\' + expenseItem.code + \']\'\">\n          </div>\n        </ui-select-choices>\n      </ui-select>\n      <span class=\"text-danger\" ng-if=\"!budget.expense_type && headerDetailsError && !budget.assignments.length\">\n        Expense Type is required\n      </span>\n    </div>\n  </div>\n</div>\n\n<!--Second row-->\n<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Budget Amount<span class=\"asterisk-required\">*</span></h3>\n      <input type=\"number\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" class=\"form-control\" ng-model=\"budget.amount\" ng-model-options=\"{debounce: 1000}\" ng-change=\"checkApportionAllocation(originalBudgetData.amount, budget.amount, \'amount\')\" ng-class=\"{\'highlight-error-input\': !budget.amount && headerDetailsError}\" placeholder=\"Enter budget amount\">\n      <span class=\"text-danger\" ng-if=\"!budget.amount && headerDetailsError\">\n        Budget Amount is required\n      </span>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Blocked Amount</h3>\n      <div>\n        <input type=\"number\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !!budget.block_amount && !!budget.amount &&\n               (budget.block_amount > budget.amount)}\" ng-model=\"budget.block_amount\" ng-model-options=\"{debounce: 1000}\" ng-change=\"checkApportionAllocation(originalBudgetData.block_amount, budget.block_amount,\n               \'block_amount\')\" placeholder=\"Enter blocked amount\">\n        <span class=\"text-danger\" ng-if=\"!!budget.block_amount && !!budget.amount &&\n              (budget.block_amount > budget.amount)\">\n          Blocked Amount cannot be greater than Budget Amount\n        </span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Blocked Amount Reason<span class=\"asterisk-required\" ng-if=\"!!budget.block_amount\">*</span></h3>\n      <textarea class=\"form-control\" ng-model=\"budget.block_amount_reason\" ng-class=\"{\'highlight-error-input\': !!budget.block_amount && headerDetailsError && !budget.block_amount_reason}\" ng-disabled=\"!budget.block_amount\">\n      </textarea>\n      <span class=\"text-danger\" ng-if=\"!!budget.block_amount && headerDetailsError && !budget.block_amount_reason\">\n        Blocked Amount Reason is required\n      </span>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Budget Owner<span class=\"asterisk-required\">*</span></h3>\n      <ui-select ng-model=\"budget.owner\" ng-class=\"{\'highlight-error-input\': !budget.owner && headerDetailsError}\">\n        <ui-select-match placeholder=\"Select Budget Owner\" allow-clear=\"true\">\n          {{$select.selected.display_name}}\n        </ui-select-match>\n        <ui-select-choices repeat=\"bo in ownerList | filter: $select.search\">\n          <span ng-bind-html=\"bo.display_name | highlight: $select.search\"></span>\n        </ui-select-choices>\n      </ui-select>\n      <span class=\"text-danger\" ng-if=\"!budget.owner && headerDetailsError\">\n        Budget Owner is required\n      </span>\n    </div>\n  </div>\n</div>\n\n<!--Third row-->\n<div class=\"row\">\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Start Date<span class=\"asterisk-required\">*</span></h3>\n      <div class=\"input-group\">\n        <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Start date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"budget.start_date\" ng-change=\"checkApportionAllocation(originalBudgetData.start_date, budget.start_date,\n               \'start_date\')\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" ng-class=\"{\'highlight-error-input\': !budget.start_date && headerDetailsError}\" class=\"form-control\" required>\n        <span class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\">\n            <i class=\"fa fa-calendar\"></i>\n          </button>\n        </span>\n      </div>\n      <span class=\"text-danger\" ng-if=\"!budget.start_date && headerDetailsError\">\n        Start Date is required\n      </span>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>End Date<span class=\"asterisk-required\">*</span></h3>\n      <div class=\"input-group\">\n        <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"End date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"budget.end_date\" datepickertime ng-change=\"checkApportionAllocation(originalBudgetData.end_date, budget.end_date,\n               \'end_date\')\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" ng-class=\"{\'highlight-error-input\': !budget.end_date && headerDetailsError}\" class=\"form-control\" required>\n        <span class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\">\n            <i class=\"fa fa-calendar\"></i>\n          </button>\n        </span>\n      </div>\n      <span class=\"text-danger\" ng-if=\"!budget.end_date && headerDetailsError\">\n        End Date is required\n      </span>\n    </div>\n  </div>\n\n  <!--<div class=\"col-md-3\">-->\n    <!--<div class=\"form-group\">-->\n      <!--<h3>Apportion<span class=\"asterisk-required\" ng-if=\"!budget.assignments.length\">*</span></h3>-->\n      <!--<div ng-class=\"{\'input-group\' : budget.apportion_type !== \'N/A\' && !budget.assignments.length &&-->\n           <!--!!budget.amount && !!budget.start_date && !!budget.end_date}\">-->\n        <!--<ui-select ng-model=\"budget.apportion_type\"-->\n                   <!--ng-change=\"checkApportionAllocation(originalBudgetData.apportion_type, budget.apportion_type,-->\n                   <!--\'apportion_type\')\"-->\n                   <!--theme=\"bootstrap\"-->\n                   <!--ng-disabled=\"(!budget.start_date || !budget.end_date) || hasParentBudget()\"-->\n                   <!--ng-class=\"{\'highlight-error-input\': !budget.apportion_type && headerDetailsError && !budget.assignments.length}\">-->\n          <!--<ui-select-match placeholder=\"Select Apportion\">-->\n            <!--{{$select.selected | capitalize}}-->\n          <!--</ui-select-match>-->\n          <!--<ui-select-choices repeat=\"apportion in apportionList | filter: $select.search\">-->\n            <!--<span ng-bind-html=\"apportion | highlight: $select.search | capitalize\"></span>-->\n          <!--</ui-select-choices>-->\n        <!--</ui-select>-->\n        <!--<span class=\"input-group-btn\"-->\n              <!--ng-if=\"budget.apportion_type !== \'N/A\' && !budget.assignments.length && !!budget.amount &&-->\n              <!--!!budget.start_date && !!budget.end_date\">-->\n          <!--<apportion-->\n            <!--apportion-type=\"budget.apportion_type\"-->\n            <!--editing-mode=\"getEditingBudgetState()\"-->\n            <!--start-date=\"budget.start_date\"-->\n            <!--end-date=\"budget.end_date\"-->\n            <!--available-amount=\"(budget.amount - budget.block_amount)\"-->\n            <!--apportion-allocation=\"budget.apportion_allocation\"-->\n            <!--apportion-carry-forward=\"budget.apportion_carry_forward\"-->\n            <!--apportion-related-values=\"apportionRelatedValues\"-->\n            <!--parent-id=\"budget.parent_id\">-->\n          <!--</apportion>-->\n        <!--</span>-->\n      <!--</div>-->\n      <!--<span class=\"text-danger\"-->\n            <!--ng-if=\"!budget.apportion_type && headerDetailsError && !budget.assignments.length\">-->\n        <!--Apportion is required-->\n      <!--</span>-->\n    <!--</div>-->\n  <!--</div>-->\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\" ng-show=\"!!budget.created_by && !!budget.created_by.display_name\">\n      <h3>Created By</h3>\n      {{ budget.created_by.display_name || \'N/A\' }}\n    </div>\n  </div>\n</div>\n\n<div class=\"row mb-15\">\n  <div class=\"col-md-4\">\n    <input id=\"budgetMasterAllowDashboard\" type=\"checkbox\" icheck ng-model=\"budget.pr_dashboard_display\" ng-click=\"changeAssignmentDashboardSetting(budget.pr_dashboard_display)\">\n    <label for=\"budgetMasterAllowDashboard\">Allow PR requester to view budget dashboard in PR</label>\n  </div>\n  <div class=\"col-md-8\">\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-12\">\n\n    <h3>Budget Amount Summary</h3>\n\n    <table class=\"table table-text-center\">\n      <thead>\n      <th>Budget Amount</th>\n      <th>Used Amount</th>\n      <th>Committed Amount</th>\n      <th>Blocked Amount</th>\n      <th>Available Amount</th>\n      <th>Available Assignment Amount</th>\n      <th> </th>\n      </thead>\n      <tbody>\n      <tr class=\"grey-text font-bold\">\n        <td>\n          {{ ::budget.previous_amount === null ? (budget.amount === null ? 0 : budget.amount) :\n          budget.previous_amount | formatDecimal: 2}}\n        </td>\n        <td>{{ ::budget.used_amount === null ? 0 : budget.used_amount | formatDecimal: 2}}</td>\n        <td>{{ ::budget.committed_amount === null ? \'0\' : budget.committed_amount | formatDecimal: 2}}</td>\n        <td>{{ ::budget.block_amount === null ? 0 : budget.block_amount | formatDecimal: 2}}</td>\n        <td>{{ ::budget.available_balance === null ? 0 : budget.available_balance | formatDecimal: 2}}</td>\n        <td>{{ ::budget.assignable_balance === null ? 0 : budget.assignable_balance | formatDecimal: 2}}</td>\n        <td>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/detailsHeader/detailsHeader.nonEditableTemplate.html","<div class=\"row\"></div>\n<div class=\"row\">\n  <div class=\"col-md-1\">\n    <h3 class=\"text-left-align\">Code</h3>\n  </div>\n  <div class=\"col-md-11 change-action text-left-align\">\n    <h4 class=\"code-text\">\n      {{ budget.code || \'N/A\' }}\n    </h4>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-1\">\n    <h3 class=\"text-left-align\">Status</h3>\n  </div>\n  <div class=\"col-md-11 change-action text-left-align\">\n    <h4 class=\"code-text\">\n      {{ budget.status | capitalize }}\n    </h4>\n  </div>\n</div>\n\n<!--First row-->\n<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Company</h3>\n      {{ budget.company.descr || \'N/A\' }}\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Currency</h3>\n      {{ budget.currency.code || \'N/A\' }}\n    </div>\n  </div>\n\n  <div class=\"col-md-3\" ng-show=\"!budgetAllocate || !!budget.cost_center\">\n    <div class=\"form-group\">\n      <h3>Cost Center</h3>\n      <span ng-repeat=\"cc in budget.cost_center\">\n        {{cc.descr}}{{$last ? \'\' : \', \'}}\n      </span>\n    </div>\n  </div>\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Expense Type</h3>\n      {{ budget.expense_type.descr || \'N/A\' }}\n    </div>\n  </div>\n</div>\n\n<!--Second row-->\n<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Budget Amount</h3>\n      {{ budget.amount | formatDecimal: 2 || \'N/A\' }}\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Blocked Amount</h3>\n      <div>\n        {{ budget.block_amount === null ? 0 : budget.block_amount | formatDecimal: 2 }}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Blocked Amount Reason</h3>\n      <p class=\"text-area-block\">{{ budget.block_amount_reason || \'N/A\' }}</p>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Budget Owner</h3>\n      {{ budget.owner.display_name || \'N/A\' }}\n    </div>\n  </div>\n</div>\n\n<!--Third row-->\n<div class=\"row\">\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>Start Date</h3>\n      <div class=\"input-group\">\n        {{ (budget.start_date || \'N/A\') | date : \'dd MMM yyyy\' }}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\">\n      <h3>End Date</h3>\n      <div class=\"input-group\">\n        {{ (budget.end_date || \'N/A\') | date : \'dd MMM yyyy\' }}\n      </div>\n    </div>\n  </div>\n\n  <!--<div class=\"col-md-3\">-->\n    <!--<div class=\"form-group\">-->\n      <!--<h3>Apportion</h3>-->\n      <!--<div>-->\n        <!--{{ (budget.apportion_type || \'N/A\') | capitalize }}-->\n        <!--<span ng-show=\"budget.apportion_type !== \'N/A\'\">-->\n          <!--<apportion-->\n            <!--apportion-type=\"budget.apportion_type\"-->\n            <!--editing-mode=\"getEditingBudgetState()\"-->\n            <!--start-date=\"budget.start_date\"-->\n            <!--end-date=\"budget.end_date\"-->\n            <!--available-amount=\"(budget.amount - budget.block_amount)\"-->\n            <!--apportion-allocation=\"budget.apportion_allocation\"-->\n            <!--apportion-carry-forward=\"budget.apportion_carry_forward\"-->\n            <!--parent-id=\"budget.parent_id\">-->\n          <!--</apportion>-->\n        <!--</span>-->\n      <!--</div>-->\n    <!--</div>-->\n  <!--</div>-->\n\n  <div class=\"col-md-3\">\n    <div class=\"form-group\" ng-show=\"!!budget.created_by && !!budget.created_by.display_name\">\n      <h3>Created By</h3>\n      {{ budget.created_by.display_name || \'N/A\' }}\n    </div>\n  </div>\n</div>\n\n<div class=\"row mb-15\">\n  <div class=\"col-md-8\">\n    <div class=\"form-group\">\n      <h3>Allow PR requester to view budget dashboard in PR</h3>\n      {{!!budget.pr_dashboard_display ? \'Allowed\' : \'Not Allowed\'}}\n  </div>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-md-12\">\n    <h3>Budget Amount Summary</h3>\n    <table class=\"table table-text-center default-cursor\">\n      <thead>\n        <th>Budget Amount</th>\n        <th>Used Amount</th>\n        <th>Committed Amount</th>\n        <th>Blocked Amount</th>\n        <th>Available Amount</th>\n        <th>Available Assignment Amount</th>\n        <th> </th>\n      </thead>\n      <tbody>\n      <tr class=\"grey-text font-bold\">\n        <td>\n          {{ budget.previous_amount === null ? (budget.amount === null ? 0 : budget.amount) :\n          budget.previous_amount | formatDecimal: 2}}\n        </td>\n        <td>{{ budget.used_amount === null ? 0 : budget.used_amount | formatDecimal: 2}}</td>\n        <td>{{ budget.committed_amount === null ? \'0\' : budget.committed_amount | formatDecimal: 2}}</td>\n        <td>{{ budget.block_amount === null ? 0 : budget.block_amount | formatDecimal: 2}}</td>\n        <td>{{ budget.available_balance === null ? 0 : budget.available_balance | formatDecimal: 2}}</td>\n        <td>{{ budget.assignable_balance === null ? 0 : budget.assignable_balance | formatDecimal: 2}}</td>\n        <td>\n          <a ng-click=\"showBudgetItems()\" class=\"btn\" ng-show=\"showItemListing()\">\n            <i class=\"fa fa-chevron-circle-down fa-lg\"></i>\n          </a>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n      <!--#region budget master item listing-->\n      <div ng-if=\"showBudgetItemListing\">\n        <item-listing budget=\"budget._id\">\n        </item-listing>\n      </div>\n  </div>\n</div>\n");
$templateCache.put("components/budget/itemBreakdowns/itemBreakdowns.editableTemplate.html","<div class=\"row budget\">\n  <div class=\"col-md-12\">\n    <table class=\"table multiselect-directive table-striped form-group default-cursor\">\n      <thead>\n      <th width=\"5%\"> Item No.</th>\n      <th width=\"20%\"> Item Description<span class=\"asterisk-required\">*</span></th>\n      <th width=\"20%\"> Commodity Code<span class=\"asterisk-required\">*</span></th>\n      <!--<th width=\"15%\"> Apportion<span class=\"asterisk-required\">*</span></th>-->\n      <th width=\"10%\"> Amount<span class=\"asterisk-required\">*</span></th>\n      <th width=\"10%\"> Quantity</th>\n      <th width=\"10%\"> UOM</th>\n      <th width=\"20%\"> Justification</th>\n      <th width=\"5%\"></th>\n      </thead>\n      <tbody>\n      <tr ng-repeat-start=\"budgetItem in budgetData.item_breakdowns track by $index\" class=\"animate-repeat\">\n        <td>\n          {{$index+1}} .\n        </td>\n        <td>\n          <textarea class=\"form-control\" ng-model=\"budgetItem.descr\" ng-class=\"{\'highlight-error-input\': !!budgetItem.descr && !!budgetItemDetailsError}\">\n          </textarea>\n          <span class=\"text-danger\" ng-if=\"!budgetItem.descr && !!budgetItemDetailsError\">\n            Item Description is required\n          </span>\n        </td>\n        <td>\n          <div>\n            <input type=\"text\" ng-model=\"budgetItem.commodity_code_descr\" class=\"form-control\" ng-keyup=\"searchCommodityCode(budgetItem.commodity_code_descr, $index);\n                        closeTreeSearch = false;\" placeholder=\"Search Commodities\" ng-disabled=\"canEditOrDeleteItemBreakdown(budgetItem)\" ng-class=\"{\'highlight-error-input\': !budgetItem.commodity_code_descr && !!budgetItemDetailsError}\">\n            <span class=\"text-danger\" ng-if=\"!budgetItem.commodity_code_descr && !!budgetItemDetailsError\">\n              Commodity Code is required\n            </span>\n          </div>\n          <div>\n            <input tree-selection ng-model=\"budgetItem.commodity_code\" ng-model-options=\"{debounce: 1000}\" level=\"commodityLevel\" data=\"commodityCodes[$index]\" title=\"budgetItem.commodity_code_descr\" action=\"openChildCommodityCode\" close-tree-search=\"closeTreeSearch\" selectable=\"commodity.selectable\">\n          </div>\n        </td>\n        <!--<td>-->\n          <!--<div ng-class=\"{\'input-group\' : !!budgetItem.apportion_allocation || budgetItem.apportion_type !== \'N/A\' &&-->\n               <!--!!budgetItem.allocated_amount}\">-->\n            <!--<ui-select ng-model=\"budgetItem.apportion_type\"-->\n                       <!--ng-change=\"checkApportionAllocation(originalItemBreakdownData[$index].apportion_type,-->\n                       <!--budgetItem.apportion_type, \'apportion_type\', $index)\"-->\n                       <!--ng-class=\"{\'highlight-error-input\': !budgetItem.apportion_type && !!budgetItemDetailsError}\"-->\n                       <!--ng-disabled=\"(!!budgetData.apportion_type && budgetData.apportion_type !== \'N/A\') ||-->\n                      <!--(!budgetData.start_date || !budgetData.end_date || !budgetItem.allocated_amount) ||-->\n                      <!--!!budgetMaster.parent_id\">-->\n              <!--<ui-select-match placeholder=\"Select Apportion\">-->\n                <!--{{$select.selected | capitalize}}-->\n              <!--</ui-select-match>-->\n              <!--<ui-select-choices repeat=\"apportion in apportionList | filter: $select.search\">-->\n                <!--<span ng-bind-html=\"apportion | highlight: $select.search | capitalize\"></span>-->\n              <!--</ui-select-choices>-->\n            <!--</ui-select>-->\n            <!--<span class=\"input-group-btn\"-->\n                  <!--ng-if=\"budgetItem.apportion_type !== \'N/A\' && !!budgetItem.allocated_amount\">-->\n              <!--<apportion-->\n                <!--apportion-type=\"budgetItem.apportion_type\"-->\n                <!--editing-mode=\"editingMode\"-->\n                <!--start-date=\"budgetData.start_date\"-->\n                <!--end-date=\"budgetData.end_date\"-->\n                <!--available-amount=\"budgetItem.allocated_amount\"-->\n                <!--apportion-allocation=\"budgetItem.apportion_allocation\"-->\n                <!--apportion-carry-forward=\"budgetItem.apportion_carry_forward\"-->\n                <!--apportion-related-values=\"budgetItem.apportionRelatedValues\"-->\n                <!--parent-id=\"budgetMaster.parent_id\">-->\n              <!--</apportion>-->\n            <!--</span>-->\n          <!--</div>-->\n          <!--<span class=\"text-danger\"-->\n                <!--ng-if=\"!budgetItem.apportion_type && !!budgetItemDetailsError\">-->\n            <!--Apportion is required-->\n          <!--</span>-->\n        <!--</td>-->\n        <td>\n          <div>\n            <input type=\"number\" step=\"0.01\" ng-pattern-restrict=\"^(?:[0-9]+(?:\\.[0-9]{0,2})?)?$\" class=\"form-control\" ng-model=\"budgetItem.allocated_amount\" ng-model-options=\"{debounce: 1000}\" ng-change=\"checkApportionAllocation(originalItemBreakdownData[$index].allocated_amount,\n                    budgetItem.allocated_amount, \'allocated_amount\', $index)\" ng-class=\"{\'highlight-error-input\': (!budgetItem.allocated_amount && !!budgetItemDetailsError) || !!isItemAmountGreaterThanInherited() || !!validateAmount(budgetItem)}\">\n            <span class=\"text-danger\" ng-if=\"!budgetItem.allocated_amount && !!budgetItemDetailsError\">\n              Amount is required\n            </span>\n            <span class=\"text-danger\" ng-if=\"!!isItemAmountGreaterThanInherited()\">\n              Total item amount exceeded the inherited amount.\n            </span>\n            <span class=\"text-danger\" ng-if=\"!!validateAmount(budgetItem)\">\n              Item amount cannot be lower than used and committed amount.\n            </span>\n          </div>\n        </td>\n        <td>\n          <div>\n            <input ng-class=\"{\'highlight-error-input\': !isQuantityValid(budgetItem.quantity, $index)}\" type=\"number\" class=\"form-control\" ng-disabled=\"canEditOrDeleteItemBreakdown(budgetItem)\" ng-model=\"budgetItem.quantity\">\n            <span class=\"text-danger\" ng-if=\"!isQuantityValid(budgetItem.quantity, $index)\">\n              Fraction is not allowed for selected UOM\n            </span>\n          </div>\n        </td>\n        <td>\n          <input type=\"text\" placeholder=\"Type to search\" class=\"form-control\" typeahead-focus-first typeahead-on-select=\"onUOMSelect($item, $index)\" uib-typeahead=\"uom.code + \' < \' + uom.descr + \' > \' for uom in searchUOM($viewValue)\" ng-model=\"budgetItem.UOMText\" ng-change=\"budgetItem.validUOMIsSelected = false\" ng-disabled=\"canEditOrDeleteItemBreakdown(budgetItem)\" typeahead-wait-ms=\"500\" aria-autocomplete=\"list\" typeahead-min-length=\"2\" ng-blur=\"validationUOMSelection(budgetItem, $index)\">\n        </td>\n        <td>\n          <textarea ng-model=\"budgetItem.justification\" placeholder=\"Enter justification\" class=\"form-control\">\n          </textarea>\n        </td>\n        <td>\n          <button class=\"btn btn-danger btn-xs\" ng-disabled=\"canEditOrDeleteItemBreakdown(budgetItem)\" ng-click=\"deleteItemBreakdown($index)\">\n            Delete\n          </button>\n        </td>\n      </tr>\n\n      <tr ng-repeat-end>\n        <td colspan=\"1\"></td>\n        <td colspan=\"7\">\n          <table class=\"table table-grey-header\">\n            <thead>\n              <tr>\n                <td>Used Amount</td>\n                <td>Committed Amount</td>\n                <td>Used Quantity</td>\n                <td>Committed Quantity</td>\n              </tr>\n            </thead>\n            <tbody>\n            <tr class=\"grey-text\">\n              <td>\n                {{ budgetItem.used_amount === null ? 0 : budgetItem.used_amount | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.committed_amount === null ? 0 : budgetItem.committed_amount | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.used_quantity === null ? 0 : budgetItem.used_quantity | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.committed_quantity === null ? 0 : budgetItem.committed_quantity | formatDecimal: 2}}\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr>\n        <td colspan=\"8\">\n          <button class=\"btn btn-primary btn-xs\" ng-click=\"addItemBreakdown()\">\n            Add Item Breakdown\n          </button>\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/itemBreakdowns/itemBreakdowns.nonEditableTemplate.html","<div class=\"row budget\">\n  <div class=\"col-md-12\">\n    <table class=\"table multiselect-directive table-striped form-group default-cursor\">\n      <thead>\n      <th width=\"5%\"> Item No. </th>\n      <th width=\"15%\"> Item Description</th>\n      <th width=\"20%\"> Commodity Code</th>\n      <!--<th width=\"10%\"> Apportion</th>-->\n      <th width=\"10%\"> Amount</th>\n      <th width=\"10%\"> Quantity</th>\n      <th width=\"10%\"> UOM</th>\n      <th width=\"30%\"> Justification</th>\n      </thead>\n      <tbody>\n      <tr ng-repeat-start=\"budgetItem in budgetData.item_breakdowns track by $index\" class=\"animate-repeat\">\n        <td>\n          {{$index+1}} .\n        </td>\n        <td>\n          <p class=\"text-area-block\">{{ budgetItem.descr || \'N/A\' }}</p>\n        </td>\n        <td>\n          {{ budgetItem.commodity_code_descr || \'N/A\' }}\n        </td>\n        <!--<td>-->\n          <!--{{ budgetItem.apportion_type || \'N/A\' | capitalize }}-->\n          <!--<span ng-show=\"budgetItem.apportion_type !== \'N/A\'\">-->\n            <!--<apportion-->\n              <!--ng-show=\"budgetItem.apportion_type !== \'N/A\'\"-->\n              <!--apportion-type=\"budgetItem.apportion_type\"-->\n              <!--editing-mode=\"editingMode\"-->\n              <!--start-date=\"budgetData.start_date\"-->\n              <!--end-date=\"budgetData.end_date\"-->\n              <!--available-amount=\"budgetItem.allocated_amount\"-->\n              <!--apportion-allocation=\"budgetItem.apportion_allocation\"-->\n              <!--apportion-carry-forward=\"budgetItem.apportion_carry_forward\"-->\n              <!--parent-id=\"budgetMaster.parent_id\">-->\n            <!--</apportion>-->\n          <!--</span>-->\n        <!--</td>-->\n        <td>\n          {{ budgetItem.allocated_amount === null ? 0 : budgetItem.allocated_amount | formatDecimal: 2}}\n        </td>\n        <td>\n          {{ budgetItem.quantity || \'N/A\' }}\n        </td>\n        <td>\n          {{ budgetItem.UOMText || \'N/A\' }}\n        </td>\n        <td>\n          {{ budgetItem.justification || \'N/A\' }}\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"7\">\n          <table class=\"table table-text-center\">\n            <thead>\n            <th>Used Amount</th>\n            <th>Committed Amount</th>\n            <th>Used Quantity</th>\n            <th>Committed Quantity</th>\n            </thead>\n            <tbody>\n\n            <tr class=\"grey-text\">\n              <td>\n                {{ budgetItem.used_amount === null ? 0 : budgetItem.used_amount | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.committed_amount === null ? 0 : budgetItem.committed_amount | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.used_quantity === null ? 0 : budgetItem.used_quantity | formatDecimal: 2}}\n              </td>\n              <td>\n                {{ budgetItem.committed_quantity === null ? 0 : budgetItem.committed_quantity | formatDecimal: 2}}\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </td>\n      </tr>\n      <tr ng-repeat-end></tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/itemListing/itemListing.html","<div class=\"row budget\">\n  <div class=\"col-md-12\">\n    <embedded-pagination-service list=\"itemData\" service=\"budgets\" params-source=\"embeddedParams\" offset=\"10\" meta=\"itemMeta\">\n    </embedded-pagination-service>\n    <div>\n      <h3> Items </h3>\n    </div>\n    <div class=\"btn-group pull-left clear-floating share-tab-focus\" role=\"group\">\n      <button type=\"button\" class=\"btn\" ng-click=\"selectTab(\'used\')\" ng-class=\"{\'btn-primary\': selectedTab === \'used\',\n                \'btn-white\': selectedTab !== \'used\'}\">\n        Used Amount\n      </button>\n      <button type=\"button\" class=\"btn\" ng-click=\"selectTab(\'committed\')\" ng-class=\"{\'btn-primary\': selectedTab === \'committed\',\n                \'btn-white\': selectedTab !== \'committed\'}\">\n        Committed Amount\n      </button>\n      <button type=\"button\" class=\"btn\" ng-click=\"selectTab(\'refunded\')\" ng-class=\"{\'btn-primary\': selectedTab === \'refunded\',\n                \'btn-white\': selectedTab !== \'refunded\'}\">\n        Cancelled Amount\n      </button>\n    </div>\n    <table class=\"table default-cursor\">\n      <thead>\n      <th>PR Number</th>\n      <th>PO Number</th>\n      <th>Item Name</th>\n      <th>Item Description</th>\n      <th>Quantity</th>\n      <th>Unit Price</th>\n      <th>Amount</th>\n      <th>Tax</th>\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"itemData.length > 0\">\n        <td colspan=\"8\">There are no item for now.</td>\n      </tr>\n      <tr ng-repeat=\"item in itemData\">\n        <td>\n          {{ item.pr_number }}\n        </td>\n        <td>\n          {{ item.po_number }}\n        </td>\n        <td>\n          {{ item.item_name }}\n        </td>\n        <td>\n          {{ item.item_descr }}\n        </td>\n        <td class=\"text-right\">\n          {{ item.quantity }}\n        </td>\n        <td class=\"text-right\">\n          {{ item.unit_price | formatDecimal: 2 }} {{ item.currency }}\n        </td>\n        <td class=\"text-right\">\n          {{ item.amount | formatDecimal: 2 }} {{ item.currency }}\n        </td>\n        <td class=\"text-right\">\n          {{ item.tax | formatDecimal: 2 }} {{ item.currency }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/budget/versions/budgetVersions.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">\n      <span aria-hidden=\"true\">×</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <h4 class=\"modal-title\">Budget Versions</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <table class=\"table\">\n          <tr>\n            <th>&nbsp;</th>\n            <th>Version Number</th>\n            <th>Created At</th>\n            <th>Created by</th>\n            <th>Last Updater</th>\n          </tr>\n          <tr ng-repeat=\"version in versions track by $index\">\n            <td>\n              <input icheck type=\"checkbox\" ng-model=\"selectedVersion\" ng-disabled=\"(getCheckedVersionLength() > 1 && !checkedVersion[$index])\" ng-click=\"selectVersion(version, selectedVersion, $index)\">\n            </td>\n            <td>\n              <span ng-if=\"$first\">\n                Current Version<br>\n              </span>\n              <span ng-if=\"!$first\">Version {{version.object_version}}</span>\n            </td>\n            <td>{{version.created_at | date:\'dd MMM yyyy h:mm a\'}}</td>\n            <td>{{version.created_by.display_name}}</td>\n            <td>{{version.updated_by.display_name}}</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"getCheckedVersionLength() !== 2\" ng-click=\"compareVersions()\">\n      Compare\n    </button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("components/budget/versions/compareBudgetVersion.html","<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" ng-click=\"close()\">×</button>\n  <h4 class=\"modal-title\">Comparing Budget Revisions</h4>\n  <p ng-show=\"!!selectedVersion[0].object_version && !!selectedVersion[1].object_version\">\n    Version {{ selectedVersion[0].object_version }}\n    compare to Version {{ selectedVersion[1].object_version }}\n  </p>\n</div>\n\n<div class=\"wrapper wrapper-content animated fadeInRight budget\" xmlns=\"http://www.w3.org/1999/html\">\n  <div>\n    <!--#region Header section-->\n    <div class=\"modal-body mb-10\">\n      <div class=\"row\">\n        <div class=\"col-md-1 mb-10 mt-10\">\n          <h3 class=\"text-left-align\">Title\n          </h3>\n        </div>\n        <div class=\"col-md-11 mb-10 mt-10\">\n          <span ng-if=\"selectedVersion[0].descr !== selectedVersion[1].descr\">\n            <del>{{selectedVersion[0].descr || \'N/A\'}}</del>\n            <br>\n            <ins>{{selectedVersion[1].descr || \'N/A\'}}</ins>\n          </span>\n          <span ng-if=\"selectedVersion[0].descr === selectedVersion[1].descr\">\n            {{selectedVersion[0].descr || \'N/A\'}}\n          </span>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-md-1\">\n          <h3 class=\"text-left-align\">Code</h3>\n        </div>\n        <div class=\"col-md-11 change-action text-left-align\">\n          <h4 class=\"code-text\">\n            <span ng-if=\"selectedVersion[0].code !== selectedVersion[1].code\">\n              <del>{{selectedVersion[0].code || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].code || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].code === selectedVersion[1].code\">\n              {{selectedVersion[0].code || \'N/A\'}}\n            </span>\n          </h4>\n        </div>\n      </div>\n\n      <!--First row-->\n      <div class=\"row\">\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Company</h3>\n            <span ng-if=\"selectedVersion[0].company.descr !== selectedVersion[1].company.descr\">\n              <del>{{selectedVersion[0].company.descr || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].company.descr || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].company.descr === selectedVersion[1].company.descr\">\n              {{selectedVersion[0].company.descr || \'N/A\'}}\n            </span>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Currency</h3>\n            <span ng-if=\"selectedVersion[0].currency.code !== selectedVersion[1].currency.code\">\n              <del>{{selectedVersion[0].currency.code || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].currency.code || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].currency.code === selectedVersion[1].currency.code\">\n              {{selectedVersion[0].currency.code || \'N/A\'}}\n            </span>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\" ng-show=\"!budgetAllocate || !!budget.costCenter\">\n          <div class=\"form-group\">\n            <h3>Cost Center</h3>\n            <span ng-if=\"selectedVersion[0].cost_center !== selectedVersion[1].cost_center\">\n              <del>{{selectedVersion[0].cost_center || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].cost_center || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].cost_center === selectedVersion[1].cost_center\">\n              {{selectedVersion[0].cost_center || \'N/A\'}}\n            </span>\n          </div>\n        </div>\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Expense Type</h3>\n            <span ng-if=\"selectedVersion[0].expense_type.descr !== selectedVersion[1].expense_type.descr\">\n              <del>{{selectedVersion[0].expense_type.descr || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].expense_type.descr || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].expense_type.descr === selectedVersion[1].expense_type.descr\">\n              {{selectedVersion[0].expense_type.descr || \'N/A\'}}\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <!--Second row-->\n      <div class=\"row\">\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Budget Amount</h3>\n            <span ng-if=\"selectedVersion[0].amount !== selectedVersion[1].amount\">\n              <del>{{ selectedVersion[0].amount  === null ? 0 : selectedVersion[0].amount | formatDecimal: 2}}</del>\n              <br>\n              <ins>{{ selectedVersion[1].amount  === null ? 0 : selectedVersion[1].amount | formatDecimal: 2}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].amount === selectedVersion[1].amount\">\n              {{ selectedVersion[0].amount  === null ? 0 : selectedVersion[0].amount | formatDecimal: 2}}\n            </span>\n          </div>\n        </div>\n\n        <!--<div class=\"col-md-3\">-->\n          <!--<div class=\"form-group\">-->\n            <!--<h3>Apportion</h3>-->\n            <!--<span ng-if=\"selectedVersion[0].apportion_type !== selectedVersion[1].apportion_type\">-->\n              <!--<del>{{selectedVersion[0].apportion_type || \'N/A\'}}</del>-->\n              <!--<br>-->\n              <!--<ins>{{selectedVersion[1].apportion_type || \'N/A\'}}</ins>-->\n            <!--</span>-->\n            <!--<span ng-if=\"selectedVersion[0].apportion_type === selectedVersion[1].apportion_type\">-->\n              <!--{{selectedVersion[0].apportion_type || \'N/A\'}}-->\n            <!--</span>-->\n          <!--</div>-->\n        <!--</div>-->\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Start Date</h3>\n            <div class=\"input-group\">\n              <span ng-if=\"selectedVersion[0].start_date !== selectedVersion[1].start_date\">\n                <del>{{selectedVersion[0].start_date | date : \'dd MMM yyyy\'}}</del>\n                <br>\n                <ins>{{selectedVersion[1].start_date | date : \'dd MMM yyyy\'}}</ins>\n              </span>\n              <span ng-if=\"selectedVersion[0].start_date === selectedVersion[1].start_date\">\n                {{selectedVersion[0].start_date | date : \'dd MMM yyyy\'}}\n              </span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>End Date</h3>\n            <div class=\"input-group\">\n              <span ng-if=\"selectedVersion[0].end_date !== selectedVersion[1].end_date\">\n                <del>{{selectedVersion[0].end_date | date : \'dd MMM yyyy\'}}</del>\n                <br>\n                <ins>{{selectedVersion[1].end_date | date : \'dd MMM yyyy\'}}</ins>\n              </span>\n              <span ng-if=\"selectedVersion[0].end_date === selectedVersion[1].end_date\">\n                {{selectedVersion[0].end_date | date : \'dd MMM yyyy\'}}\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!--Third row-->\n      <div class=\"row\">\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount</h3>\n            <div>\n              <span ng-if=\"selectedVersion[0].block_amount !== selectedVersion[1].block_amount\">\n                <del>{{ selectedVersion[0].block_amount  === null ? 0 : selectedVersion[0].block_amount | formatDecimal: 2}}</del>\n                <br>\n                <ins>{{ selectedVersion[1].block_amount  === null ? 0 : selectedVersion[1].block_amount | formatDecimal: 2}}</ins>\n              </span>\n              <span ng-if=\"selectedVersion[0].block_amount === selectedVersion[1].block_amount\">\n                {{ selectedVersion[0].block_amount  === null ? 0 : selectedVersion[0].block_amount | formatDecimal: 2}}\n              </span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Blocked Amount Reason</h3>\n            <span ng-if=\"selectedVersion[0].block_amount_reason !== selectedVersion[1].block_amount_reason\">\n              <p class=\"text-area-block\"><del>{{selectedVersion[0].block_amount_reason || \'N/A\'}}</del></p>\n              <br>\n              <p class=\"text-area-block\"><ins>{{selectedVersion[1].block_amount_reason || \'N/A\'}}</ins></p>\n            </span>\n            <span ng-if=\"selectedVersion[0].block_amount_reason === selectedVersion[1].block_amount_reason\">\n              <p class=\"text-area-block\">{{selectedVersion[0].block_amount_reason || \'N/A\'}}</p>\n            </span>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <h3>Budget Owner</h3>\n            <span ng-if=\"selectedVersion[0].owner.display_name !== selectedVersion[1].owner.display_name\">\n              <del>{{selectedVersion[0].owner.display_name || \'N/A\'}}</del>\n              <br>\n              <ins>{{selectedVersion[1].owner.display_name || \'N/A\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].owner.display_name === selectedVersion[1].owner.display_name\">\n              {{selectedVersion[0].owner.display_name || \'N/A\'}}\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row mb-15\">\n        <div class=\"col-md-12\">\n          <div class=\"form-group\">\n            <h3>Allow PR requester to view budget dashboard in PR</h3>\n            <span ng-if=\"selectedVersion[0].pr_dashboard_display !== selectedVersion[1].pr_dashboard_display\">\n              <del>{{!!selectedVersion[0].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\'}}</del>\n              <br>\n              <ins>{{!!selectedVersion[1].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\'}}</ins>\n            </span>\n            <span ng-if=\"selectedVersion[0].pr_dashboard_display === selectedVersion[1].pr_dashboard_display\">\n              {{!!selectedVersion[0].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\'}}\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <!--TODO: Check how to display differences here (Justin 21/9/17)-->\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <h3>Budget Amount Summary</h3>\n          <table class=\"table table-text-center\">\n            <thead>\n            <th>Budget Amount</th>\n            <th>Used Amount</th>\n            <th>Committed Amount</th>\n            <th>Blocked Amount</th>\n            <th>Available Amount</th>\n            <th>Available Assignment Amount</th>\n            </thead>\n            <tbody>\n            <tr class=\"grey-text font-bold\">\n              <td>\n                <span ng-if=\"selectedVersion[0].amount !== selectedVersion[1].amount\">\n                  <del>{{ selectedVersion[0].amount  === null ? 0 : selectedVersion[0].amount | formatDecimal: 2}}</del>\n                  <br>\n                  <ins>{{ selectedVersion[1].amount  === null ? 0 : selectedVersion[1].amount | formatDecimal: 2}}</ins>\n                </span>\n                <span ng-if=\"selectedVersion[0].amount === selectedVersion[1].amount\">\n                  {{ selectedVersion[0].amount  === null ? 0 : selectedVersion[0].amount | formatDecimal: 2}}\n                </span>\n              </td>\n              <td>{{ selectedVersion[0].used_amount === null ? 0 : selectedVersion[0].used_amount | formatDecimal: 2}}\n              </td>\n              <td>{{ selectedVersion[0].committed_amount === null ? \'0\' : selectedVersion[0].committed_amount |\n                formatDecimal: 2}}\n              </td>\n              <td>\n                <span ng-if=\"selectedVersion[0].block_amount !== selectedVersion[1].block_amount\">\n                  <del>{{ selectedVersion[0].block_amount  === null ? 0 : selectedVersion[0].block_amount | formatDecimal: 2}}</del>\n                  <br>\n                  <ins>{{ selectedVersion[1].block_amount  === null ? 0 : selectedVersion[1].block_amount | formatDecimal: 2}}</ins>\n                </span>\n                <span ng-if=\"selectedVersion[0].block_amount === selectedVersion[1].block_amount\">\n                  {{ selectedVersion[0].block_amount  === null ? 0 : selectedVersion[0].block_amount | formatDecimal: 2}}\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"selectedVersion[0].available_balance !== selectedVersion[1].available_balance\">\n                  <del>{{ selectedVersion[0].available_balance  === null ? 0 : selectedVersion[0].available_balance | formatDecimal: 2}}</del>\n                  <br>\n                  <ins>{{ selectedVersion[1].available_balance  === null ? 0 : selectedVersion[1].available_balance | formatDecimal: 2}}</ins>\n                </span>\n                <span ng-if=\"selectedVersion[0].available_balance === selectedVersion[1].available_balance\">\n                  {{ selectedVersion[0].available_balance  === null ? 0 : selectedVersion[0].available_balance | formatDecimal: 2}}\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"selectedVersion[0].assignable_balance !== selectedVersion[1].assignable_balance\">\n                  <del>{{ selectedVersion[0].assignable_balance  === null ? 0 : selectedVersion[0].assignable_balance | formatDecimal: 2}}</del>\n                  <br>\n                  <ins>{{ selectedVersion[1].assignable_balance  === null ? 0 : selectedVersion[1].assignable_balance | formatDecimal: 2}}</ins>\n                </span>\n                <span ng-if=\"selectedVersion[0].assignable_balance === selectedVersion[1].assignable_balance\">\n                  {{ selectedVersion[0].assignable_balance  === null ? 0 : selectedVersion[0].assignable_balance | formatDecimal: 2}}\n                </span>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <!--#endregion-->\n\n    <!--#region Budget Assignment-->\n    <div class=\"modal-body\">\n      <div class=\"row\" ng-show=\"!!selectedVersion[0].assignments.length || !!selectedVersion[1].assignments.length\">\n        <div class=\"col-md-12\">\n          <span class=\"section-text\">Budget Assignment</span>\n        </div>\n        <div class=\"budget-assignment col-md-12\" ng-repeat=\"number in assignmentSize track by $index\">\n\n          <div>\n            <!--First row-->\n            <div class=\"row screen-section\">\n              <div class=\"col-md-12\">\n                <h3>{{ number + 1 }}.</h3>\n              </div>\n\n              <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                  <h3>Budget Code</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].code &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].code\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].code !== selectedVersion[1].assignments[$index].code\">\n                      <del>{{ selectedVersion[0].assignments[$index].code }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].code }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].code === selectedVersion[1].assignments[$index].code\">\n                      {{ selectedVersion[1].assignments[$index].code }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].code &&\n                                 (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].code)\">\n                    <del>{{ selectedVersion[0].assignments[$index].code }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].code) &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].code\">\n                    <ins>{{ selectedVersion[1].assignments[$index].code }}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-3\">\n                <div class=\"form-group\">\n                  <h3>Budget Description</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].descr &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].descr\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].descr !== selectedVersion[1].assignments[$index].descr\">\n                      <del>{{ selectedVersion[0].assignments[$index].descr }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].descr }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].descr === selectedVersion[1].assignments[$index].descr\">\n                      {{ selectedVersion[1].assignments[$index].descr }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].descr &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].descr)\">\n                    <del>{{ selectedVersion[0].assignments[$index].descr }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].descr) &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].descr\">\n                    <ins>{{ selectedVersion[1].assignments[$index].descr }}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                  <h3>Cost Center</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].cost_center &&\n                               !!selectedVersion[0].assignments[$index].cost_center.descr && !!selectedVersion[1].assignments[$index] &&\n                               !!selectedVersion[1].assignments[$index].cost_center && !!selectedVersion[1].assignments[$index].cost_center.descr\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].cost_center.descr !== selectedVersion[1].assignments[$index].cost_center.descr\">\n                      <del>{{ selectedVersion[0].assignments[$index].cost_center.descr }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].cost_center.descr }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].cost_center.descr === selectedVersion[1].assignments[$index].cost_center.descr\">\n                      {{ selectedVersion[1].assignments[$index].cost_center.descr }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].cost_center &&\n                               !!selectedVersion[0].assignments[$index].cost_center.descr &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].cost_center ||\n                               !selectedVersion[1].assignments[$index].cost_center.descr)\">\n                    <del>{{ selectedVersion[0].assignments[$index].cost_center.descr }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].cost_center\n                               || !selectedVersion[0].assignments[$index].cost_center.descr) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].cost_center &&\n                               !!selectedVersion[1].assignments[$index].cost_center.descr\">\n                    <ins>{{ selectedVersion[1].assignments[$index].cost_center.descr }}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-3\">\n                <div class=\"form-group\">\n                  <h3>Expense Type</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].expense_type &&\n                               !!selectedVersion[0].assignments[$index].expense_type.descr && !!selectedVersion[1].assignments[$index] &&\n                               !!selectedVersion[1].assignments[$index].expense_type && !!selectedVersion[1].assignments[$index].expense_type.descr\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].expense_type.descr !== selectedVersion[1].assignments[$index].expense_type.descr\">\n                      <del>{{ selectedVersion[0].assignments[$index].expense_type.descr }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].expense_type.descr }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].expense_type.descr === selectedVersion[1].assignments[$index].expense_type.descr\">\n                      {{ selectedVersion[1].assignments[$index].expense_type.descr }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].expense_type &&\n                               !!selectedVersion[0].assignments[$index].expense_type.descr &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].expense_type ||\n                               !selectedVersion[1].assignments[$index].expense_type.descr)\">\n                    <del>{{ selectedVersion[0].assignments[$index].expense_type.descr }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].expense_type\n                               || !selectedVersion[0].assignments[$index].expense_type.descr) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].expense_type &&\n                               !!selectedVersion[1].assignments[$index].expense_type.descr\">\n                    <ins>{{ selectedVersion[1].assignments[$index].expense_type.descr }}</ins>\n                  </span>\n\n                </div>\n              </div>\n              <div class=\"col-md-1\"></div>\n            </div>\n\n            <!--Second row-->\n            <div class=\"row screen-section\">\n              <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                  <h3>Budget Amount</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].amount &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].amount\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].amount !== selectedVersion[1].assignments[$index].amount\">\n                      <del>{{ selectedVersion[0].assignments[$index].amount | formatDecimal: 2}}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].amount === selectedVersion[1].assignments[$index].amount\">\n                     {{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].amount &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].amount)\">\n                    <del>{{ selectedVersion[0].assignments[$index].amount | formatDecimal: 2}}</del>\n                  </span>\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].amount) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].amount\">\n                    <ins>{{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                  <h3>Blocked Amount</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].block_amount !== selectedVersion[1].assignments[$index].block_amount\">\n                      <del>{{ selectedVersion[0].assignments[$index].block_amount | formatDecimal: 2}}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].block_amount === selectedVersion[1].assignments[$index].block_amount\">\n                      {{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].block_amount)\">\n                    <del>{{ selectedVersion[0].assignments[$index].block_amount | formatDecimal: 2}}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].block_amount) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount\">\n                    <ins>{{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                  <h3>Blocked Amount Reason</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount_reason &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount_reason\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].block_amount_reason !== selectedVersion[1].assignments[$index].block_amount_reason\">\n                      <p class=\"text-area-block\"><del>{{ selectedVersion[0].assignments[$index].block_amount_reason }}</del></p>\n                      <br>\n                      <p class=\"text-area-block\"><ins>{{ selectedVersion[1].assignments[$index].block_amount_reason }}</ins></p>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].block_amount_reason === selectedVersion[1].assignments[$index].block_amount_reason\">\n                      <p class=\"text-area-block\">{{ selectedVersion[1].assignments[$index].block_amount_reason }}</p>\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount_reason &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].block_amount_reason)\">\n                    <p class=\"text-area-block\"><del>{{ selectedVersion[0].assignments[$index].block_amount_reason }}</del></p>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].block_amount_reason) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount_reason\">\n                    <p class=\"text-area-block\"><ins>{{ selectedVersion[1].assignments[$index].block_amount_reason }}</ins></p>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-4\"></div>\n            </div>\n            <!--Third row-->\n            <div class=\"row screen-section\">\n              <div class=\"col-md-2\">\n                <div class=\"row\">\n                  <h3 class=\"col-md-12\">Start Date</h3>\n                </div>\n                <div class=\"form-group\">\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].start_date &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].start_date\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].start_date !== selectedVersion[1].assignments[$index].start_date\">\n                      <del>{{ selectedVersion[0].assignments[$index].start_date | date:\'dd MMM yyyy\' }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].start_date | date:\'dd MMM yyyy\' }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].start_date === selectedVersion[1].assignments[$index].start_date\">\n                      {{ selectedVersion[1].assignments[$index].start_date | date:\'dd MMM yyyy\' }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].start_date &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].start_date)\">\n                    <del>{{ selectedVersion[0].assignments[$index].start_date | date:\'dd MMM yyyy\' }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].start_date) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].start_date\">\n                     <ins>{{ selectedVersion[1].assignments[$index].start_date | date:\'dd MMM yyyy\' }}</ins>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-2\">\n                <h3>End Date</h3>\n                <div class=\"form-group\">\n                  <div class=\"form-group\">\n                    <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].end_date &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].end_date\">\n                      <span ng-if=\"selectedVersion[0].assignments[$index].end_date !== selectedVersion[1].assignments[$index].end_date\">\n                        <del>{{ selectedVersion[0].assignments[$index].end_date | date:\'dd MMM yyyy\' }}</del>\n                        <br>\n                        <ins>{{ selectedVersion[1].assignments[$index].end_date | date:\'dd MMM yyyy\' }}</ins>\n                      </span>\n                      <span ng-if=\"selectedVersion[0].assignments[$index].end_date === selectedVersion[1].assignments[$index].end_date\">\n                       {{ selectedVersion[1].assignments[$index].end_date | date:\'dd MMM yyyy\' }}\n                      </span>\n                    </span>\n\n                    <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].end_date &&\n                                 (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].end_date)\">\n                      <del>{{ selectedVersion[0].assignments[$index].end_date | date:\'dd MMM yyyy\' }}</del>\n                    </span>\n                    <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].end_date) &&\n                                 !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].end_date\">\n                      <ins>{{ selectedVersion[1].assignments[$index].end_date | date:\'dd MMM yyyy\' }}</ins>\n                    </span>\n                  </div>\n                </div>\n              </div>\n              <!--<div class=\"col-md-3\">-->\n                <!--<div class=\"form-group\">-->\n                  <!--<h3>Apportion</h3>-->\n                  <!--<span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].apportion_type &&-->\n                                 <!--!!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].apportion_type\">-->\n                    <!--<span-->\n                      <!--ng-if=\"selectedVersion[0].assignments[$index].apportion_type !== selectedVersion[1].assignments[$index].apportion_type\">-->\n                      <!--<del>{{ selectedVersion[0].assignments[$index].apportion_type | capitalize }}</del>-->\n                      <!--<br>-->\n                      <!--<ins>{{ selectedVersion[1].assignments[$index].apportion_type | capitalize }}</ins>-->\n                    <!--</span>-->\n                    <!--<span-->\n                      <!--ng-if=\"selectedVersion[0].assignments[$index].apportion_type === selectedVersion[1].assignments[$index].apportion_type\">-->\n                      <!--{{ selectedVersion[1].assignments[$index].apportion_type | capitalize }}-->\n                    <!--</span>-->\n                  <!--</span>-->\n\n                  <!--<span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].apportion_type &&-->\n                               <!--(!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].apportion_type)\">-->\n                    <!--<del>{{ selectedVersion[0].assignments[$index].apportion_type | capitalize }}</del>-->\n                  <!--</span>-->\n\n                  <!--<span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].apportion_type) &&-->\n                               <!--!!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].apportion_type\">-->\n                    <!--<ins>{{ selectedVersion[1].assignments[$index].apportion_type | capitalize }}</ins>-->\n                  <!--</span>-->\n                <!--</div>-->\n              <!--</div>-->\n              <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                  <h3>Allow PR requester to view budget dashboard in PR</h3>\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].pr_dashboard_display &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].pr_dashboard_display\">\n                    <span ng-if=\"selectedVersion[0].assignments[$index].pr_dashboard_display !== selectedVersion[1].assignments[$index].pr_dashboard_display\">\n                      <del>{{ selectedVersion[0].assignments[$index].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\' }}</del>\n                      <br>\n                      <ins>{{ selectedVersion[1].assignments[$index].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\' }}</ins>\n                    </span>\n                    <span ng-if=\"selectedVersion[0].assignments[$index].pr_dashboard_display === selectedVersion[1].assignments[$index].pr_dashboard_display\">\n                      {{ selectedVersion[1].assignments[$index].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\' }}\n                    </span>\n                  </span>\n\n                  <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].pr_dashboard_display &&\n                               (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].pr_dashboard_display)\">\n                    <del>{{ selectedVersion[0].assignments[$index].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\' }}</del>\n                  </span>\n\n                  <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].pr_dashboard_display) &&\n                               !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].pr_dashboard_display\">\n                    <ins>{{ selectedVersion[1].assignments[$index].pr_dashboard_display ? \'Allowed\' : \'Not Allowed\' }}</ins>\n                  </span>\n                </div>\n              </div>\n            </div>\n            <!--Fourth row-->\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <table class=\"table multiselect-directive table-striped form-group\" ng-show=\"assignmentItemSize.length > 0\">\n                  <thead>\n                  <th width=\"5%\"> Item No.</th>\n                  <th width=\"15%\"> Item Description</th>\n                  <th width=\"20%\"> Commodity Code</th>\n                  <!--<th width=\"10%\"> Apportion</th>-->\n                  <th width=\"15%\"> Amount</th>\n                  <th width=\"15%\"> Quantity</th>\n                  <th width=\"15%\"> UOM</th>\n                  </thead>\n                  <tbody>\n                  <tr ng-repeat-start=\"itemNumber in assignmentItemSize[$index]\">\n                    <td>\n                      {{ itemNumber + 1 }} .\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr\">\n                          <p class=\"text-area-block\"><del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr }}</del></p>\n                          <br>\n                          <p class=\"text-area-block\"><ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr }}</ins></p>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr\">\n                          <p class=\"text-area-block\">{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr }}</p>\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr &&\n                                   (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr)\">\n                        <p class=\"text-area-block\"><del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr }}</del></p>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].descr) &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr\">\n                        <p class=\"text-area-block\"><ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].descr }}</ins></p>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr\">\n                          <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr }}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr }}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr\">\n                          {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr }}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr &&\n                                   (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr)\">\n                        <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr }}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr) &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr\">\n                        <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].commodity_code_descr }}</ins>\n                      </span>\n                    </td>\n                    <!--<td>-->\n                      <!--<span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].apportion_type &&-->\n                                   <!--!!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                        <!--<span-->\n                          <!--ng-if=\"selectedVersion[0].item_breakdowns[$index].apportion_type !== selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                          <!--<del>{{ selectedVersion[0].item_breakdowns[$index].apportion_type | capitalize }}</del>-->\n                          <!--<br>-->\n                          <!--<ins>{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}</ins>-->\n                        <!--</span>-->\n                        <!--<span-->\n                          <!--ng-if=\"selectedVersion[0].item_breakdowns[$index].apportion_type === selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                          <!--{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}-->\n                        <!--</span>-->\n                      <!--</span>-->\n\n                      <!--<span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].apportion_type &&-->\n                                   <!--(!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].apportion_type)\">-->\n                        <!--<del>{{ selectedVersion[0].item_breakdowns[$index].apportion_type | capitalize }}</del>-->\n                      <!--</span>-->\n\n                      <!--<span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].apportion_type) &&-->\n                                    <!--!!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                        <!--<ins>{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}</ins>-->\n                      <!--</span>-->\n                    <!--</td>-->\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount\">\n                          <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount\">\n                          {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount &&\n                                   (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount)\">\n                        <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].allocated_amount) &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount\">\n                        <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].allocated_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity\">\n                          <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity }}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity }}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity\">\n                          {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity }}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity &&\n                                   (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity)\">\n                        <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity }}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].quantity) &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity\">\n                        <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].quantity }}</ins>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText\">\n                          <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText }}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText }}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText\">\n                          {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText }}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText &&\n                                   (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText)\">\n                        <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText }}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].UOMText) &&\n                                   !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText\">\n                        <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].UOMText }}</ins>\n                      </span>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td colspan=\"7\">\n                      <table class=\"table table-text-center\">\n                        <tbody>\n                        <tr>\n                          <td>Used Amount</td>\n                          <td>Committed Amount</td>\n                          <td>Used Quantity</td>\n                          <td>Committed Quantity</td>\n                        </tr>\n                        <tr class=\"grey-text\">\n                          <td>\n                            <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_amount &&\n                                         !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_amount\">\n                              <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_amount !== selectedVersion[1].item_breakdowns[$index].used_amount\">\n                                <del>{{ selectedVersion[0].item_breakdowns[$index].used_amount | formatDecimal: 2}}</del>\n                                <br>\n                                <ins>{{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}</ins>\n                              </span>\n                              <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_amount === selectedVersion[1].item_breakdowns[$index].used_amount\">\n                                {{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}\n                              </span>\n                            </span>\n\n                            <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_amount &&\n                                         (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].used_amount)\">\n                              <del>{{ selectedVersion[0].item_breakdowns[$index].used_amount | formatDecimal: 2}}</del>\n                            </span>\n\n                            <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].used_amount) &&\n                                         !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_amount\">\n                              <ins>{{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}</ins>\n                            </span>\n                          </td>\n                          <td>\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount\">\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount\">\n                                <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount | formatDecimal: 2}}</del>\n                                <br>\n                                <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount | formatDecimal: 2}}</ins>\n                              </span>\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount\">\n                                {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount | formatDecimal: 2}}\n                              </span>\n                            </span>\n\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount &&\n                                         (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount)\">\n                              <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount | formatDecimal: 2}}</del>\n                            </span>\n\n                            <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_amount) &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount\">\n                              <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_amount | formatDecimal: 2}}</ins>\n                            </span>\n                          </td>\n                          <td>\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity\">\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity\">\n                                <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity | formatDecimal: 2}}</del>\n                                <br>\n                                <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity | formatDecimal: 2}}</ins>\n                              </span>\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity\">\n                                {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity | formatDecimal: 2}}\n                              </span>\n                            </span>\n\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity &&\n                                         (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity)\">\n                              <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity | formatDecimal: 2}}</del>\n                            </span>\n\n                            <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].used_quantity) &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity\">\n                              <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].used_quantity | formatDecimal: 2}}</ins>\n                            </span>\n                          </td>\n                          <td>\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity\">\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity !== selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity\">\n                                <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity | formatDecimal: 2}}</del>\n                                <br>\n                                <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity | formatDecimal: 2}}</ins>\n                              </span>\n                              <span ng-if=\"selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity === selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity\">\n                                {{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity | formatDecimal: 2}}\n                              </span>\n                            </span>\n\n                            <span ng-if=\"!!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity &&\n                                         (!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity)\">\n                              <del>{{ selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity | formatDecimal: 2}}</del>\n                            </span>\n\n                            <span ng-if=\"(!selectedVersion[0].assignments[$index].item_breakdowns[itemNumber] || !selectedVersion[0].assignments[$index].item_breakdowns[itemNumber].committed_quantity) &&\n                                         !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber] && !!selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity\">\n                              <ins>{{ selectedVersion[1].assignments[$index].item_breakdowns[itemNumber].committed_quantity | formatDecimal: 2}}</ins>\n                            </span>\n                          </td>\n                        </tr>\n                        </tbody>\n                      </table>\n                    </td>\n                  </tr>\n                  <tr ng-repeat-end></tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"row screen-section\">\n                <div class=\"col-md-12\">\n                  <table class=\"table table-text-center\">\n                    <thead>\n                    <th>Budget Amount</th>\n                    <th>Used Amount</th>\n                    <th>Committed Amount</th>\n                    <th>Blocked Amount</th>\n                    <th>Available Amount</th>\n                    </thead>\n                    <tbody>\n                    <td class=\"grey-text\">\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].amount &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].amount\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].amount !== selectedVersion[1].assignments[$index].amount\">\n                          <del>{{ selectedVersion[0].assignments[$index].amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].amount === selectedVersion[1].assignments[$index].amount\">\n                          {{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].amount &&\n                                   (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].amount)\">\n                        <del>{{ selectedVersion[0].assignments[$index].amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].amount) &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].amount\">\n                        <ins>{{ selectedVersion[1].assignments[$index].amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td class=\"grey-text\">\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].used_amount &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].used_amount\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].used_amount !== selectedVersion[1].assignments[$index].used_amount\">\n                          <del>{{ selectedVersion[0].assignments[$index].used_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].used_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].used_amount === selectedVersion[1].assignments[$index].used_amount\">\n                          {{ selectedVersion[1].assignments[$index].used_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].used_amount &&\n                                   (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].used_amount)\">\n                        <del>{{ selectedVersion[0].assignments[$index].used_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].used_amount) &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].used_amount\">\n                        <ins>{{ selectedVersion[1].assignments[$index].used_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td class=\"grey-text\">\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].committed_amount &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].committed_amount\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].committed_amount !== selectedVersion[1].assignments[$index].committed_amount\">\n                          <del>{{ selectedVersion[0].assignments[$index].committed_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].committed_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].committed_amount === selectedVersion[1].assignments[$index].committed_amount\">\n                          {{ selectedVersion[1].assignments[$index].committed_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].committed_amount &&\n                                   (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].committed_amount)\">\n                        <del>{{ selectedVersion[0].assignments[$index].committed_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].committed_amount) &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].committed_amount\">\n                        <ins>{{ selectedVersion[1].assignments[$index].committed_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td class=\"grey-text\">\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].block_amount !== selectedVersion[1].assignments[$index].block_amount\">\n                          <del>{{ selectedVersion[0].assignments[$index].block_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].block_amount === selectedVersion[1].assignments[$index].block_amount\">\n                          {{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].block_amount &&\n                                   (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].block_amount)\">\n                        <del>{{ selectedVersion[0].assignments[$index].block_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].block_amount) &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].block_amount\">\n                        <ins>{{ selectedVersion[1].assignments[$index].block_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td class=\"grey-text\">\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].available_balance &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].available_balance\">\n                        <span ng-if=\"selectedVersion[0].assignments[$index].available_balance !== selectedVersion[1].assignments[$index].available_balance\">\n                          <del>{{ selectedVersion[0].assignments[$index].available_balance | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].assignments[$index].available_balance | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].assignments[$index].available_balance === selectedVersion[1].assignments[$index].available_balance\">\n                          {{ selectedVersion[1].assignments[$index].available_balance | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].assignments[$index] && !!selectedVersion[0].assignments[$index].available_balance &&\n                                   (!selectedVersion[1].assignments[$index] || !selectedVersion[1].assignments[$index].available_balance)\">\n                        <del>{{ selectedVersion[0].assignments[$index].available_balance | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].assignments[$index] || !selectedVersion[0].assignments[$index].available_balance) &&\n                                   !!selectedVersion[1].assignments[$index] && !!selectedVersion[1].assignments[$index].available_balance\">\n                        <ins>{{ selectedVersion[1].assignments[$index].available_balance | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-12\" ng-show=\"selectedVersion[0].totalBudgetAssignmentsValue || selectedVersion[1].totalBudgetAssignmentsValue\">\n          <span class=\"section-text\">Total Assignment</span>\n        </div>\n\n        <div class=\"col-md-12\" ng-show=\"selectedVersion[0].totalBudgetAssignmentsValue || selectedVersion[1].totalBudgetAssignmentsValue\">\n          <table class=\"table\">\n            <thead>\n            <th>Total Budget Assignment Amount</th>\n            <th>Used Amount</th>\n            <th>Committed Amount</th>\n            <th>Blocked Amount</th>\n            <th>Available Amount</th>\n            </thead>\n            <tbody>\n            <tr class=\"grey-text\">\n              <td>\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_amount &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_amount\">\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_amount !== selectedVersion[1].totalBudgetAssignmentsValue.total_amount\">\n                    <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_amount | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_amount | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_amount === selectedVersion[1].totalBudgetAssignmentsValue.total_amount\">\n                    {{ selectedVersion[1].totalBudgetAssignmentsValue.total_amount | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_amount &&\n                             (!selectedVersion[1].totalBudgetAssignmentsValue || !selectedVersion[1].totalBudgetAssignmentsValue.total_amount)\">\n                  <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_amount | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].totalBudgetAssignmentsValue || !selectedVersion[0].totalBudgetAssignmentsValue.total_amount) &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_amount\">\n                  <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_amount | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount\">\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount !== selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount\">\n                    <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount === selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount\">\n                    {{ selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount &&\n                             (!selectedVersion[1].totalBudgetAssignmentsValue || !selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount)\">\n                  <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].totalBudgetAssignmentsValue || !selectedVersion[0].totalBudgetAssignmentsValue.total_used_amount) &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount\">\n                  <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_used_amount | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount\">\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount !== selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount\">\n                    <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount === selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount\">\n                    {{ selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount &&\n                             (!selectedVersion[1].totalBudgetAssignmentsValue || !selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount)\">\n                  <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].totalBudgetAssignmentsValue || !selectedVersion[0].totalBudgetAssignmentsValue.total_committed_amount) &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount\">\n                  <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_committed_amount | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount\">\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount !== selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount\">\n                    <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount === selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount\">\n                    {{ selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount &&\n                             (!selectedVersion[1].totalBudgetAssignmentsValue || !selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount)\">\n                  <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].totalBudgetAssignmentsValue || !selectedVersion[0].totalBudgetAssignmentsValue.total_block_amount) &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount\">\n                  <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_block_amount | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance\">\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance !== selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance\">\n                    <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance === selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance\">\n                    {{ selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].totalBudgetAssignmentsValue && !!selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance &&\n                             (!selectedVersion[1].totalBudgetAssignmentsValue || !selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance)\">\n                  <del>{{ selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].totalBudgetAssignmentsValue || !selectedVersion[0].totalBudgetAssignmentsValue.total_available_balance) &&\n                             !!selectedVersion[1].totalBudgetAssignmentsValue && !!selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance\">\n                  <ins>{{ selectedVersion[1].totalBudgetAssignmentsValue.total_available_balance | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <!--#endregion-->\n\n      <!--#region Item breakdown-->\n      <div class=\"row\" ng-show=\"selectedVersion[0].item_breakdowns.length || selectedVersion[1].item_breakdowns.length\">\n        <div class=\"col-md-12\">\n          <span class=\"section-text\">Item Breakdowns</span>\n        </div>\n        <div class=\"col-md-12\">\n          <table class=\"table multiselect-directive table-striped form-group\" ng-show=\"itemBreakdownsSize.length > 0\">\n            <thead>\n            <th width=\"5%\"> Item No.</th>\n            <th width=\"15%\"> Item Description</th>\n            <th width=\"20%\"> Commodity Code</th>\n            <!--<th width=\"10%\"> Apportion</th>-->\n            <th width=\"15%\"> Amount</th>\n            <th width=\"15%\"> Quantity</th>\n            <th width=\"15%\"> UOM</th>\n            </thead>\n            <tbody>\n            <tr ng-repeat-start=\"number in itemBreakdownsSize track by $index\" class=\"animate-repeat\">\n              <td>\n                {{ number + 1 }} .\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].descr &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].descr\">\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].descr !== selectedVersion[1].item_breakdowns[$index].descr\">\n                    <p class=\"text-area-block\"><del>{{ selectedVersion[0].item_breakdowns[$index].descr }}</del></p>\n                    <br>\n                    <p class=\"text-area-block\"><ins>{{ selectedVersion[1].item_breakdowns[$index].descr }}</ins></p>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].descr === selectedVersion[1].item_breakdowns[$index].descr\">\n                    <p class=\"text-area-block\">{{ selectedVersion[1].item_breakdowns[$index].descr }}</p>\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].descr &&\n                             (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].descr)\">\n                  <p class=\"text-area-block\"><del>{{ selectedVersion[0].item_breakdowns[$index].descr }}</del></p>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].descr) &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].descr\">\n                  <p class=\"text-area-block\"><ins>{{ selectedVersion[1].item_breakdowns[$index].descr }}</ins></p>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].commodity_code_descr &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].commodity_code_descr\">\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].commodity_code_descr !== selectedVersion[1].item_breakdowns[$index].commodity_code_descr\">\n                    <del>{{ selectedVersion[0].item_breakdowns[$index].commodity_code_descr }}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].item_breakdowns[$index].commodity_code_descr }}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].commodity_code_descr === selectedVersion[1].item_breakdowns[$index].commodity_code_descr\">\n                    {{ selectedVersion[1].item_breakdowns[$index].commodity_code_descr }}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].commodity_code_descr &&\n                             (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].commodity_code_descr)\">\n                  <del>{{ selectedVersion[0].item_breakdowns[$index].commodity_code_descr }}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].commodity_code_descr) &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].commodity_code_descr\">\n                  <ins>{{ selectedVersion[1].item_breakdowns[$index].commodity_code_descr }}</ins>\n                </span>\n              </td>\n              <!--<td>-->\n                <!--<span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].apportion_type &&-->\n                             <!--!!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                  <!--<span-->\n                    <!--ng-if=\"selectedVersion[0].item_breakdowns[$index].apportion_type !== selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                    <!--<del>{{ selectedVersion[0].item_breakdowns[$index].apportion_type | capitalize }}</del>-->\n                    <!--<br>-->\n                    <!--<ins>{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}</ins>-->\n                  <!--</span>-->\n                  <!--<span-->\n                    <!--ng-if=\"selectedVersion[0].item_breakdowns[$index].apportion_type === selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                    <!--{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}-->\n                  <!--</span>-->\n                <!--</span>-->\n\n                <!--<span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].apportion_type &&-->\n                             <!--(!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].apportion_type)\">-->\n                  <!--<del>{{ selectedVersion[0].item_breakdowns[$index].apportion_type | capitalize }}</del>-->\n                <!--</span>-->\n\n                <!--<span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].apportion_type) &&-->\n                             <!--!!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].apportion_type\">-->\n                  <!--<ins>{{ selectedVersion[1].item_breakdowns[$index].apportion_type | capitalize }}</ins>-->\n                <!--</span>-->\n              <!--</td>-->\n              <td>\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].allocated_amount &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].allocated_amount\">\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].allocated_amount !== selectedVersion[1].item_breakdowns[$index].allocated_amount\">\n                    <del>{{ selectedVersion[0].item_breakdowns[$index].allocated_amount | formatDecimal: 2}}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].item_breakdowns[$index].allocated_amount | formatDecimal: 2}}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].allocated_amount === selectedVersion[1].item_breakdowns[$index].allocated_amount\">\n                    {{ selectedVersion[1].item_breakdowns[$index].allocated_amount | formatDecimal: 2}}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].allocated_amount &&\n                             (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].allocated_amount)\">\n                  <del>{{ selectedVersion[0].item_breakdowns[$index].allocated_amount | formatDecimal: 2}}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].allocated_amount) &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].allocated_amount\">\n                  <ins>{{ selectedVersion[1].item_breakdowns[$index].allocated_amount | formatDecimal: 2}}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].quantity &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].quantity\">\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].quantity !== selectedVersion[1].item_breakdowns[$index].quantity\">\n                    <del>{{ selectedVersion[0].item_breakdowns[$index].quantity }}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].item_breakdowns[$index].quantity }}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].quantity === selectedVersion[1].item_breakdowns[$index].quantity\">\n                    {{ selectedVersion[1].item_breakdowns[$index].quantity }}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].quantity &&\n                             (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].quantity)\">\n                  <del>{{ selectedVersion[0].item_breakdowns[$index].quantity }}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].quantity) &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].quantity\">\n                  <ins>{{ selectedVersion[1].item_breakdowns[$index].quantity }}</ins>\n                </span>\n              </td>\n              <td>\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].UOMText &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].UOMText\">\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].UOMText !== selectedVersion[1].item_breakdowns[$index].UOMText\">\n                    <del>{{ selectedVersion[0].item_breakdowns[$index].UOMText }}</del>\n                    <br>\n                    <ins>{{ selectedVersion[1].item_breakdowns[$index].UOMText }}</ins>\n                  </span>\n                  <span ng-if=\"selectedVersion[0].item_breakdowns[$index].UOMText === selectedVersion[1].item_breakdowns[$index].UOMText\">\n                    {{ selectedVersion[1].item_breakdowns[$index].UOMText }}\n                  </span>\n                </span>\n\n                <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].UOMText &&\n                             (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].UOMText)\">\n                  <del>{{ selectedVersion[0].item_breakdowns[$index].UOMText }}</del>\n                </span>\n\n                <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].UOMText) &&\n                             !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].UOMText\">\n                  <ins>{{ selectedVersion[1].item_breakdowns[$index].UOMText }}</ins>\n                </span>\n              </td>\n            </tr>\n            <tr>\n              <td colspan=\"7\">\n                <table class=\"table table-text-center\">\n                  <tbody>\n                  <tr>\n                    <td>Used Amount</td>\n                    <td>Committed Amount</td>\n                    <td>Used Quantity</td>\n                    <td>Committed Quantity</td>\n                  </tr>\n                  <tr class=\"grey-text\">\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_amount &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_amount\">\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_amount !== selectedVersion[1].item_breakdowns[$index].used_amount\">\n                          <del>{{ selectedVersion[0].item_breakdowns[$index].used_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_amount === selectedVersion[1].item_breakdowns[$index].used_amount\">\n                          {{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_amount &&\n                                   (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].used_amount)\">\n                        <del>{{ selectedVersion[0].item_breakdowns[$index].used_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].used_amount) &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_amount\">\n                        <ins>{{ selectedVersion[1].item_breakdowns[$index].used_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].committed_amount &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].committed_amount\">\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].committed_amount !== selectedVersion[1].item_breakdowns[$index].committed_amount\">\n                          <del>{{ selectedVersion[0].item_breakdowns[$index].committed_amount | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].item_breakdowns[$index].committed_amount | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].committed_amount === selectedVersion[1].item_breakdowns[$index].committed_amount\">\n                          {{ selectedVersion[1].item_breakdowns[$index].committed_amount | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].committed_amount &&\n                                   (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].committed_amount)\">\n                        <del>{{ selectedVersion[0].item_breakdowns[$index].committed_amount | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].committed_amount) &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].committed_amount\">\n                        <ins>{{ selectedVersion[1].item_breakdowns[$index].committed_amount | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_quantity &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_quantity\">\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_quantity !== selectedVersion[1].item_breakdowns[$index].used_quantity\">\n                          <del>{{ selectedVersion[0].item_breakdowns[$index].used_quantity | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].item_breakdowns[$index].used_quantity | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].used_quantity === selectedVersion[1].item_breakdowns[$index].used_quantity\">\n                          {{ selectedVersion[1].item_breakdowns[$index].used_quantity | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].used_quantity &&\n                                   (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].used_quantity)\">\n                        <del>{{ selectedVersion[0].item_breakdowns[$index].used_quantity | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].used_quantity) &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].used_quantity\">\n                        <ins>{{ selectedVersion[1].item_breakdowns[$index].used_quantity | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                    <td>\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].committed_quantity &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].committed_quantity\">\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].committed_quantity !== selectedVersion[1].item_breakdowns[$index].committed_quantity\">\n                          <del>{{ selectedVersion[0].item_breakdowns[$index].committed_quantity | formatDecimal: 2}}</del>\n                          <br>\n                          <ins>{{ selectedVersion[1].item_breakdowns[$index].committed_quantity | formatDecimal: 2}}</ins>\n                        </span>\n                        <span ng-if=\"selectedVersion[0].item_breakdowns[$index].committed_quantity === selectedVersion[1].item_breakdowns[$index].committed_quantity\">\n                          {{ selectedVersion[1].item_breakdowns[$index].committed_quantity | formatDecimal: 2}}\n                        </span>\n                      </span>\n\n                      <span ng-if=\"!!selectedVersion[0].item_breakdowns[$index] && !!selectedVersion[0].item_breakdowns[$index].committed_quantity &&\n                                   (!selectedVersion[1].item_breakdowns[$index] || !selectedVersion[1].item_breakdowns[$index].committed_quantity)\">\n                        <del>{{ selectedVersion[0].item_breakdowns[$index].committed_quantity | formatDecimal: 2}}</del>\n                      </span>\n\n                      <span ng-if=\"(!selectedVersion[0].item_breakdowns[$index] || !selectedVersion[0].item_breakdowns[$index].committed_quantity) &&\n                                   !!selectedVersion[1].item_breakdowns[$index] && !!selectedVersion[1].item_breakdowns[$index].committed_quantity\">\n                        <ins>{{ selectedVersion[1].item_breakdowns[$index].committed_quantity | formatDecimal: 2}}</ins>\n                      </span>\n                    </td>\n                  </tr>\n                  </tbody>\n                </table>\n              </td>\n            </tr>\n            <tr ng-repeat-end></tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <!--#endregion-->\n\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-white\" ng-click=\"close()\">\n      Close\n    </button>\n  </div>\n</div>\n");
$templateCache.put("components/approval-flow/add-approver/add-approver.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Add New Approver</h4>\n  </div>\n  <form name=\"currencyUpdateForm\" ng-submit=\"addApprover()\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Users</label>\n              <div class=\"col-sm-10\">\n                <div ng-dropdown-multiselect=\"\" options=\"users\" selected-model=\"usersSelected\" extra-settings=\"userSetting\" class=\"company-select-currencies\">\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-offset-2 col-sm-10\">\n                <span ng-repeat=\"user in usersSelected track by $index\">{{getUserName(user.id)}}{{$last ? \'\':\',\'}}\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n      <button type=\"submit\" ng-disabled=\"!usersSelected.length\" class=\"btn btn-primary\">\n        Add\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("components/exchangeRate/details/details.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">{{::exchangeRateDetails.code}} Details</h4>\n  </div>\n  <form name=\"exchangeRateUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n            </li>\n          </ul>\n\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                  <div class=\"form-horizontal\">\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Code</label>\n                      <div class=\"col-sm-10\">\n                        <label class=\"control-label\">{{::exchangeRateDetails.code}}</label>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Rate</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"exchangeRateDetails.rate\" ng-pattern=\"/^[0-9.]{0,}$/\" ng-pattern-restrict=\"^[0-9.]{0,10}$\" ng-disabled=\"!editClicked\" required>\n                        <span class=\"text-danger\" ng-show=\"validateEditedRate(exchangeRateDetails.rate) &&\n                              submitted\">\n                          Multiplier rate cannot be zero\n                        </span>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Effective date</label>\n                      <div class=\"col-sm-9\">\n                        <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRateDetails.effective_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" class=\"form-control\" ng-disabled=\"!editClicked\" required>\n                        \n                        <span class=\"text-danger\" ng-show=\"!!exchangeRateDetails.effective_at &&\n                                !!exchangeRateDetails.expiry_at &&\n                                (exchangeRateDetails.expiry_at <= exchangeRateDetails.effective_at) &&\n                              submitted\">\n                          Effective date must be before expiry date\n                        </span>\n                      </div>\n                      <span class=\"col-sm-1\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\" ng-disabled=\"!editClicked\">\n                          <i class=\"fa fa-calendar\"></i>\n                        </button>\n                </span>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Expiry date</label>\n                      <div class=\"col-sm-9\">\n                        <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"Expiry date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRateDetails.expiry_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" class=\"form-control\" ng-disabled=\"!editClicked\" required>\n                        <span class=\"text-danger\" ng-show=\"\n                                !!exchangeRateDetails.effective_at &&\n                                !!exchangeRateDetails.expiry_at &&\n                                (exchangeRateDetails.expiry_at <= exchangeRateDetails.effective_at) &&\n                                submitted\">\n                          Expiry date must be after effective date\n                        </span>\n                      </div>\n                      <span class=\"col-sm-1\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\" ng-disabled=\"!editClicked\">\n                          <i class=\"fa fa-calendar\"></i>\n                        </button>\n                      </span>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Description</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"exchangeRateDetails.descr\" ng-disabled=\"!editClicked\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Status</label>\n                      <div class=\"col-sm-10\">\n                        <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in exchangeRateStatuses track by option.isActive\" ng-model=\"exchangeRateDetails.exchangeStatus\" required></select>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n            </div>\n\n            <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n              <history dependencies=\"historyDependencies\"></history>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editExchangeRate()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"updateExchangeRate()\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/actions/purchaseRequisitionActions-mobile-button.html","<!-- Action Button -->\n<div class=\"no-padding\">\n  <!-- Waiting On -->\n  <span ng-if=\"(PR.status.toLowerCase() === \'pending\' || PR.status.toLowerCase() === \'on_hold\') && !isShoppingMode()\">\n    <approval-waiting-on hidden data=\"approvalFlowData()\"></approval-waiting-on>\n  </span>\n  <!--actions-->\n  <!--class=\"btn-group pr-action pull-right clear-floating-right pr-btn\"-->\n  <div class=\"col-xs-12 col-sm-12 no-padding\">\n    <button ng-if=\"canReject()\" class=\"btn btn-pr-action\" ng-class=\"!canHold() && !canUnHold() ? \'col-xs-6 col-sm-6\' : \'col-xs-4 col-sm-4\'\" style=\"background-color: #1ab394; border:1px solid white\">\n      <!-- Reject -->\n      <a action-modal-mobile title=\"Reject Purchase Requisition\" action-function=\"approvalAction(\'reject\', \'You have rejected this PR\', rejectPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for rejecting the PR, reason is mandatory to reject PR\" extra-params=\"rejectPRExtraParams\" next-action-amount=\"totalPRs\" id=\"reject\" style=\"color: white\">\n        <i class=\"fa fa-times\" style=\"color: white\"></i><br>Reject\n      </a>\n    </button>\n\n    <button ng-if=\"canHold() || canUnHold()\" class=\"col-xs-4 col-sm-4 btn btn-pr-action\" style=\"background-color: #1ab394; border:1px solid white\">\n      <!-- Hold -->\n      <a ng-if=\"canHold()\" action-modal-mobile title=\"Hold Purchase Requisition\" action-function=\"approvalAction(\'on_hold\', \'You have placed this purchase requisition on hold\', onHoldPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for hold\" extra-params=\"onHoldPRExtraParams\" next-action-amount=\"totalPRs\" id=\"hold\" style=\"color: white\">\n        <i class=\"fa fa-pause\" style=\"color: white\"></i><br>Hold\n      </a>\n\n      <!-- Un-hold -->\n      <a ng-if=\"canUnHold()\" action-modal-mobile title=\"Un-Hold Purchase Requisition\" action-function=\"approvalAction(\'release\', \'You have released the hold from this purchase requisition\', {})\" action-condition=\"actionCondition()\" module=\"pr\" success-handler=\"refreshPRDetail()\" extra-params=\"onHoldPRExtraParams\" id=\"un-hold\" style=\"color: white\">\n        <i class=\"fa fa-check\" style=\"color: white\"></i><br>Un-Hold\n      </a>\n    </button>\n\n    <button ng-if=\"canApprove()\" class=\"btn btn-pr-action\" ng-class=\"!canHold() && !canUnHold() ? \'col-xs-6 col-sm-6\' : \'col-xs-4 col-sm-4\'\" style=\"background-color: #1ab394; border:1px solid white\">\n      <!-- Approve -->\n      <a action-modal-mobile title=\"Approve Purchase Requisition\" action-function=\"approvalAction(\'approve\', \'You have approved this purchase requisition\')\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" next-action-amount=\"totalPRs\" all-actions-completed=\"true\" id=\"approvePR\" style=\"color: white\">\n        <i class=\"pr-action-icon fa fa-check\" style=\"color: white\"></i><br>Approve\n      </a>\n    </button>\n\n  </div>\n\n</div>\n\n\n");
$templateCache.put("components/purchaseRequisitionComponents/actions/purchaseRequisitionActions-mobile.html","<!-- Action Button -->\n<div class=\"col-xs-12 col-sm-12\">\n	<span> <!-- Waiting On -->\n    <span ng-if=\"(PR.status.toLowerCase() === \'pending\' || PR.status.toLowerCase() === \'on_hold\') && !isShoppingMode()\">\n			<approval-waiting-on hidden data=\"approvalFlowData()\"></approval-waiting-on>\n	  </span>\n    <!--actions-->\n    <span class=\"btn-group pr-action pull-right clear-floating-right pr-btn\" role=\"group\" ng-class=\"{\'pr-action-access-directly\': action == \'access_directly\' || !access_status,\n        \'pr-action-margin-top\': PR.status.toLowerCase() === \'draft\' && pr.collaborators.length == 0}\">\n\n      <!-- Reject -->\n      <a ng-if=\"canReject()\" action-modal-mobile title=\"Reject Purchase Requisition\" action-function=\"approvalAction(\'reject\', \'You have rejected this PR\', rejectPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for rejecting the PR, reason is mandatory to reject PR\" extra-params=\"rejectPRExtraParams\" next-action-amount=\"totalPRs\" id=\"reject\" class=\"btn btn-link\" style=\"color: red\">\n        <i class=\"pr-action-icon pr-action-icon-del fa fa-times\"></i>\n        Reject\n		  </a>\n      <!-- Hold -->\n      <a ng-if=\"canHold()\" action-modal-mobile title=\"Hold Purchase Requisition\" action-function=\"approvalAction(\'on_hold\', \'You have placed this purchase requisition on hold\', onHoldPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for hold\" extra-params=\"onHoldPRExtraParams\" next-action-amount=\"totalPRs\" id=\"hold\" class=\"btn btn-link\" style=\"color: orange\">\n        <i class=\"pr-action-icon fa fa-pause\"></i>\n        Hold\n		  </a>\n      <!-- Un-hold -->\n      <a ng-if=\"canUnHold()\" action-modal-mobile title=\"Un-Hold Purchase Requisition\" action-function=\"approvalAction(\'release\', \'You have released the hold from this purchase requisition\', {})\" action-condition=\"actionCondition()\" module=\"pr\" success-handler=\"refreshPRDetail()\" extra-params=\"onHoldPRExtraParams\" id=\"un-hold\" class=\"btn btn-link\">\n        <i class=\"pr-action-icon fa fa-check\"></i>\n        Un-Hold\n      </a>\n      <!-- Approve -->\n      <a ng-if=\"canApprove()\" action-modal-mobile title=\"Approve Purchase Requisition\" action-function=\"approvalAction(\'approve\', \'You have approved this purchase requisition\')\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR._id}}\" success-handler=\"refreshPRDetail()\" next-action-amount=\"totalPRs\" all-actions-completed=\"true\" id=\"approvePR\" class=\"btn btn-link\">\n      <i class=\"pr-action-icon fa fa-check\"></i>\n      Approve\n		</a>\n    </span>\n	</span>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/actions/purchaseRequisitionActions.html","\n<!-- Action Button -->\n<div class=\"col-md-1 col-md-offset-10\"><br></div>\n<div class=\"row\">\n  <div class=\"col-md-4\">\n    <div class=\"col-md-11\">\n      <!-- Waiting On -->\n      <span ng-if=\"(PR.status.toLowerCase() === \'pending\' || PR.status.toLowerCase() === \'on_hold\') && !isShoppingMode()\">\n        <approval-waiting-on data=\"approvalFlowData()\"></approval-waiting-on>\n      </span>\n    </div>\n    <span class=\"pull-left clear-floating-left\" ng-show=\"PR.status.toLowerCase() == \'approved\'\">\n      <span class=\"pull-left\">Date Approved:&nbsp;&nbsp;</span>\n      <span class=\"pull-left\">\n        {{PR.closed_at | date: \"dd MMM yyyy\"}}\n        (<span am-time-ago=\"PR.closed_at\"></span>)\n      </span>\n    </span>\n  </div>\n\n  <div class=\"col-md-4 col-md-offset-4\">\n    <span>\n      <!--share with - collaborator-->\n      <span class=\"pr-share-with pull-left clear-floating-left\" ng-class=\"{\'pr-share-with-on-access-directly\': action == \'access_directly\'|| !access_status}\" ng-if=\"!!PR.collaborators && !!PR.collaborators.length\">\n        <span class=\"pr-share-title pull-left\" ng-class=\"{\'margin-title-access-directly\': action == \'access_directly\'|| !access_status}\">\n          Shared with:\n        </span>\n        <ul class=\"pr-collaborators-avatar pull-left\">\n          <li ng-repeat=\"collaborator in PR.collaborators\">\n            <a id=\"inviteCollaborator\" collaborators-panel ng-click=\"inviteCollaborator()\">\n              <img ng-src=\"{{ userBasePath }}/{{ collaborator.img_url }}\" uib-tooltip=\"{{ collaborator.display_name }}\" class=\"img-circle\" image-error=\"assets/images/avatar-default.png\">\n              </a>\n          </li>\n        </ul>\n      </span>\n\n\n      <!-- validation alerrt -->\n      <section class=\"pr-text-error\">\n        <span class=\"text-danger\" ng-show=\"message_error.pr_title.length && submitted\">\n          PR title is required.\n        </span>\n      </section>\n\n\n\n      <!--actions-->\n      <span class=\"btn-group pr-action pull-right clear-floating-right pr-btn\" role=\"group\" ng-class=\"{\'pr-action-access-directly\': action == \'access_directly\' || !access_status,\n                       \'pr-action-margin-top\': PR.status.toLowerCase() === \'draft\' && pr.collaborators.length == 0}\">\n        <!-- Submit -->\n        <!--TODO replace temp() to new function, to be done after Salleh fix the action-modal, hanwah-->\n        <a ng-if=\"canSubmit()\" action-modal title=\"Submit requisition?\" action-function=\"submitPurchaseRequisition(false)\" id=\"submitPR\" class=\"btn btn-link\" ng-disable=\"{{sending}}\">\n          <i class=\"pr-action-icon fa fa-arrow-circle-up\"></i>Submit\n        </a>\n\n        <!-- Approve -->\n        <a ng-if=\"canApprove() && (editingState !== \'editable\')\" action-modal title=\"Approve Purchase Requisition\" action-function=\"approvalAction(\'approve\', \'You have approved this purchase requisition\')\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR.context_id}}\" success-handler=\"refreshPRDetail()\" next-action-amount=\"totalPRs\" all-actions-completed=\"true\" id=\"approvePR\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-check\"></i>Approve\n        </a>\n\n        <!-- Hold -->\n        <a ng-if=\"canHold() && (editingState !== \'editable\')\" action-modal title=\"Hold Purchase Requisition\" action-function=\"approvalAction(\'on_hold\', \'You have placed this purchase requisition on hold\', onHoldPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR.context_id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for hold\" extra-params=\"onHoldPRExtraParams\" next-action-amount=\"totalPRs\" id=\"hold\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-pause\"></i>Hold\n        </a>\n\n        <!-- Un-hold -->\n        <a ng-if=\"canUnHold() && (editingState !== \'editable\')\" action-modal title=\"Un-Hold Purchase Requisition\" action-function=\"approvalAction(\'release\', \'You have released the hold from this purchase requisition\', {})\" action-condition=\"actionCondition()\" module=\"pr\" success-handler=\"refreshPRDetail()\" extra-params=\"onHoldPRExtraParams\" id=\"un-hold\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-check\"></i>Un-Hold\n        </a>\n\n        <!-- Withdraw-->\n        <a ng-if=\"canWithdraw() && (editingState !== \'editable\')\" withdraw ng-click=\"showWithdraw()\" id=\"withdrawPR\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon fa fa-share-square\"></i>Withdraw\n        </a>\n\n        <!-- Reject -->\n        <a ng-if=\"canReject() && (editingState !== \'editable\')\" action-modal title=\"Reject Purchase Requisition\" action-function=\"approvalAction(\'reject\', \'You have rejected this PR\', rejectPRExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" next-action-id=\"{{nextPR.context_id}}\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason for rejecting the PR, reason is mandatory to reject PR\" extra-params=\"rejectPRExtraParams\" next-action-amount=\"totalPRs\" id=\"reject\" class=\"btn btn-link\">\n          <i class=\"pr-action-icon pr-action-icon-del fa fa-times\"></i>Reject\n        </a>\n\n        <!-- Enter Edit Mode -->\n        <a ng-if=\"PR.status.toLowerCase() === \'pending\' && allowEditingPR() && editingState !== \'editable\'\" ng-click=\"requestEditableDraft()\" id=\"editPR\" class=\"pr-action-btn btn btn-link\">\n          <i class=\"pr-action-icon fa fa-pencil-square-o\"></i>Edit\n        </a>\n\n        <!-- On Edit mode -->\n\n        <a ng-if=\"PR.status.toLowerCase() === \'edit\' && editingState === \'editable\'\" ng-click=\"submitEditableDraft()\" id=\"submitEditedPR\" class=\"pr-action-btn btn btn-link\">\n           <i class=\"pr-action-icon fa fa-check\"></i>Submit\n        </a>\n\n        <a ng-if=\"PR.status.toLowerCase() === \'edit\' && editingState === \'editable\'\" ng-click=\"cancelEditingPR()\" id=\"cancelEditedPR\" class=\"pr-action-btn btn btn-link\">\n           <i class=\"pr-action-icon fa fa-times\"></i>Cancel\n        </a>\n\n\n        <!-- Delete -->\n        <a ng-if=\"canDelete()\" id=\"deletePR\" ng-click=\"deletePR()\" class=\"pr-action-btn btn btn-link\">\n          <i class=\"pr-action-icon pr-action-icon-del fa fa-times\"></i>Delete\n        </a>\n\n        <!-- Move to draft -->\n        <a ng-if=\"(PR.status.toLowerCase() === \'rejected\' || PR.status.toLowerCase() === \'withdrawn\')\n                  && isPRCreator()\" ng-click=\"moveToDraftPR()\" id=\"resubmitPR\" class=\"btn btn-link\">\n           <i class=\"pr-action-icon fa fa-arrow-circle-up\"></i>Move to Draft (to resubmit)\n        </a>\n\n        <!-- generate PO -->\n        <a ng-if=\"canGeneratePO()\" ng-click=\"generatePurchaseOrder(PR._id)\" id=\"generatePO\" class=\"btn btn-link\">\n           <i class=\"pr-action-icon fa fa-arrow-circle-up\"></i>Generate PO\n        </a>\n\n        <!-- Print -->\n        <a id=\"printPR\" class=\"pr-action-btn btn btn-link\" ng-click=\"printPRViaPDF()\" ng-disabled=\"!PR.pr_items || PR.pr_items.length < 1\">\n          <i class=\"pr-action-icon fa fa-print\"></i>Print\n        </a>\n\n        <!-- More Actions -->\n        <div class=\"btn-group\" role=\"group\" ng-show=\"!PR.is_deleted\">\n          <button id=\"morePR\" class=\"btn btn-link dropdown-toggle clear-more-padding-right\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n            More\n            <span class=\"caret\"></span>\n          </button>\n          <ul class=\"dropdown-menu pull-right\" role=\"menu\">\n            <li>\n              <a class=\"pr-action-btn btn btn-link\" ng-click=\"duplicatePR()\" ng-show=\"isPRCreator() || PR.requestor._id === currentUser._id\">\n                <i class=\"pr-action-icon fa fa-copy\"></i>Duplicate\n              </a>\n            </li>\n            <!--<li>-->\n              <!--<a class=\"pr-action-btn btn btn-link \" collaborators-panel-->\n                 <!--ng-click=\"inviteCollaborator()\"-->\n                 <!--ng-show=\"canUpdateCollaborators(PR.status.toLowerCase())\">-->\n                <!--<i class=\"pr-action-icon fa fa-group\"></i>Collaborators-->\n              <!--</a>-->\n            <!--</li>-->\n            <li>\n              <a class=\"pr-action-btn btn btn-link\" ng-click=\"notificationToggle()\">\n                <i class=\"pr-action-icon fa fa-envelope\"></i>Notifications {{PR.notify ? \"on\": \"off\"}}\n              </a>\n            </li>\n            <li>\n              <a class=\"pr-action-btn btn btn-link\" ng-if=\"allowedToRevertApproval()\" action-modal title=\"Reset approval flow step\" action-function=\"revertApproval(revertExtraParams)\" action-condition=\"actionCondition()\" module=\"pr\" send-email=\"true\" success-handler=\"refreshPRDetail()\" comment-block=\"true\" comment-place-holder=\"Write a reason resetting the step\" extra-params=\"revertExtraParams\" id=\"revert\" class=\"btn btn-link\">\n                <i class=\"pr-action-icon fa fa-undo\"></i>Revert approval step\n            </a>\n            </li>\n          </ul>\n        </div>\n\n      </span>\n    </span>\n  </div>\n\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/branchPrListing/branchPrListing.html","<div class=\"inmodal branch-listing\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"closeBranchListing()\">x</button>\n    <span class=\"modal-title branch-book-title\">Supplier Branch Listing</span>\n  </div>\n  <div class=\"modal-body\">\n    <br>\n    <table class=\"table table-hover\">\n      <tbody>\n        <div>\n          <branch-listing data=\"branchSelection.data\" editable=\"false\" searchable=\"true\" selectable=\"true\">\n          </branch-listing>\n        </div>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/createPurchaseRequisitionButton/createPurchaseRequisitionButtonTemplate.html","<span ng-show=\"showCreateButton()\">\n  <!-- Single company-->\n  <button id=\"clickPRButton\" ng-click=\"createPR(listOfCompanies[0])\" ng-if=\"!!listOfCompanies.length && listOfCompanies.length === 1\" class=\"btn navbar-btn btn-create-pr btn-primary dropdown-toggle\" aria-expanded=\"false\" ng-disabled=\"disabled\">\n    {{title}}\n  </button>\n\n  <!-- Multi companies -->\n <div ng-repeat-end class=\"btn-group\" ng-if=\"listOfCompanies.length > 1\">\n   <button data-toggle=\"dropdown\" class=\"btn navbar-btn btn-create-pr\n                     {{ \'btn-primary\' || \'btn-default\' }} dropdown-toggle\" aria-expanded=\"false\">\n          {{ title }}\n          <span class=\"fa fa-caret-down\"></span>\n   </button>\n    <ul class=\"dropdown-menu create-button\">\n      <div class=\"search-input-bar-full\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search Companies\" ng-model=\"searchFilter\">\n      </div>\n\n      <li ng-repeat=\"c in listOfCompanies | filter:{descr: searchFilter}\">\n        <a ng-click=\"createPR(c)\">{{ c.descr }}</a>\n      </li>\n    </ul>\n </div>\n\n</span>\n");
$templateCache.put("components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.EditableTemplate.html","<div class=\"jumbotron mt-15 col-md-12\">\n  <!--Html for pr warning block here-->\n  <div class=\"row screen-section\">\n    <!--Company Billing-->\n    <div class=\"col-md-6 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-3\">Bill To</h3>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Company</label>\n        <div class=\"col-md-7\">\n         <span id=\"prBillingCompanySpan\" class=\"billing-company\">\n           {{editableData.company.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Billing address-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Address</label>\n\n        <div class=\"col-md-7\">\n          <div>\n            <a address-book=\"{{editableData.billing_to_address._id}}\" address-list=\"costCenterBillingAddresses\" on-selected-address-book=\"onSelectBillingAddress(address_book)\" access-from=\"PRHeaderBillingAddress\" event-handler=\"true\">\n              Select address\n            </a>\n          </div>\n          <span id=\"prBillingAddressSpan\" class=\"address-text-format\">{{\n            (editableData.billing_to_address.line1.length ? editableData.billing_to_address.line1 + \"\\n\": \"\") +\n            (editableData.billing_to_address.line2.length ? editableData.billing_to_address.line2 + \"\\n\": \"\") +\n            (editableData.billing_to_address.line3.length ? editableData.billing_to_address.line3 + \"\\n\": \"\") +\n            (editableData.billing_to_address.postal_code.length ? editableData.billing_to_address.postal_code : \"\") +\n            (editableData.billing_to_address.city.length ? (editableData.billing_to_address.postal_code.length ? \" \" : \"\") +\n             editableData.billing_to_address.city + \"\\n\" :\n            (editableData.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n            (editableData.billing_to_address.state.length ? editableData.billing_to_address.state : \"\") +\n            (editableData.billing_to_address.country.length? (editableData.billing_to_address.state.length ? \", \" : \"\") +\n             editableData.billing_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n\n      <!--Billing Company html here-->\n      <div class=\"form-group\" ng-if=\"editableData.company.billing_company_codes_list.length > 0\">\n        <label class=\"col-md-3\">Billing Company</label>\n        <div class=\"col-md-7\">\n          <ui-select ng-model=\"editableData.alternate_billing_company\" on-select=\"onSelectBillingCompany(editableData.alternate_billing_company)\">\n            <ui-select-match placeholder=\"Select a billing company\" allow-clear=\"true\">\n              {{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"billingCompanyCode in editableData.company.billing_company_codes_list | filter: $select.search\">\n              <div ng-bind-html=\"billingCompanyCode.descr | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n\n      <!--Cost center html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Cost center</label>\n        <div class=\"col-md-7\">\n          <ui-select class=\"billing-cost-center\" ng-model=\"editableData.cost_center\" on-select=\"onSelectCostCenter(editableData.cost_center)\">\n            <ui-select-match placeholder=\"Select a cost center\" id=\"prCostCenter\">\n              {{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"c in costCenters | filter: $select.search\">\n              <div ng-bind-html=\"c.descr | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n\n      <!--Expense type html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Expense type</label>\n        <div class=\"col-md-7\">\n          <ui-select id=\"prSelectExpenseType\" ng-model=\"editableData.expense_type\" theme=\"bootstrap\" on-select=\"onSelectExpenseType(editableData.expense_type)\">\n            <ui-select-match id=\"prExpenseType\" placeholder=\"Select an expense type\" class=\"billing-expense\">\n              {{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"et in expenseTypes | filter: $select.search\">\n              <div ng-bind-html=\"et.descr | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n          <span class=\"text-danger\" ng-show=\"submissionValidation(\'expense_type\') && !editableData.expense_type\">\n            Expense Type is required.\n          </span>\n        </div>\n      </div>\n\n      <!--Budget html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Budget</label>\n        <div class=\"col-md-7\">\n          <ui-select ng-model=\"editableData.budget\" theme=\"bootstrap\" ng-class=\"{\'highlight-error-input\' : submissionValidation(\'budget\') && !editableData.budget._id && checkAvailableBudget(budgetListing)}\" ng-disabled=\"!!budgetSetting && !budgetSetting.enable\" on-select=\"onSelectBudget(editableData.budget)\">\n            <ui-select-match placeholder=\"Select a budget\">\n              <div ng-show=\"!!$select.selected.descr\">\n                {{$select.selected.descr}} ( {{$select.selected.code}} )\n              </div>\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"budget in budgetListing | filter: $select.search\">\n              <div ng-bind-html=\"budget.descr + \' ( \' + budget.code + \' ) \'| highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n          <span class=\"text-danger\" ng-show=\"submissionValidation(\'budget\') && !editableData.budget._id && checkAvailableBudget(budgetListing)\">\n            Budget is required.\n          </span>\n        </div>\n      </div>\n\n\n      <!--Currency html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Currency</label>\n        <div class=\"col-md-7\">\n          <ui-select ng-model=\"editableData.currency\" theme=\"bootstrap\" on-select=\"onSelectCurrency(editableData.currency)\">\n            <ui-select-match placeholder=\"Select a currency\" id=\"prCurrency\">\n              {{ $select.selected.code + \' - \' + $select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"c in getCurrencyList() | filter: $select.search\">\n              <div ng-bind-html=\"c.code + \' - \' + c.descr | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n    </div>\n\n    <!--Company Delivery-->\n    <div class=\"col-md-6 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-5\">Deliver To</h3>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Company</label>\n        <div class=\"col-md-7\">\n          <span id=\"prDeliveryCompanySpan\" class=\"delivery-company\">\n           {{editableData.company.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Delivery Address-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Address</label>\n        <div class=\"col-md-7\">\n          <div>\n            <a address-book=\"{{editableData.delivery_to_address._id}}\" address-list=\"costCenterDeliveryAddresses\" on-selected-address-book=\"onSelectDeliveryAddress(address_book)\" access-from=\"PRHeaderDeliveryAddress\" event-handler=\"true\">\n              Select address\n            </a>\n          </div>\n          <span id=\"prDeliveryAddressSpan\" class=\"address-text-format\">{{\n            (editableData.delivery_to_address.line1.length ? editableData.delivery_to_address.line1 + \"\\n\": \"\") +\n            (editableData.delivery_to_address.line2.length ? editableData.delivery_to_address.line2 + \"\\n\": \"\") +\n            (editableData.delivery_to_address.line3.length ? editableData.delivery_to_address.line3 + \"\\n\": \"\") +\n            (editableData.delivery_to_address.postal_code.length ? editableData.delivery_to_address.postal_code : \"\") +\n            (editableData.delivery_to_address.city.length ? (editableData.delivery_to_address.postal_code.length ? \" \" : \"\") +\n             editableData.delivery_to_address.city + \"\\n\" :\n            (editableData.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n            (editableData.delivery_to_address.state.length ? editableData.delivery_to_address.state : \"\") +\n            (editableData.delivery_to_address.country.length? (editableData.delivery_to_address.state.length ? \", \" : \"\") +\n             editableData.delivery_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n\n      <!--Contact person html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Contact person</label>\n        <div class=\"col-md-7\">\n          <input id=\"prContactPerson\" type=\"text\" ng-class=\"{\'highlight-error-input\' : (submissionValidation(\'contact_person\') && !editableData.contact_person) }\" typeahead-on-select=\"onSelectContactPerson($item)\" placeholder=\"Select a person\" class=\"form-control\" uib-typeahead=\"user.display_name for user in contactPersonsList | filter:{display_name:$viewValue}\" ng-model=\"editableData.contact_person\" typeahead-wait-ms=\"delay\" aria-autocomplete=\"list\" typeahead-min-length=\"1\" ng-blur=\"onSelectContactPerson(editableData.contact_person)\">\n          <span class=\"text-danger\" ng-show=\"submissionValidation(\'contact_person\') && !editableData.contact_person\">\n            Contact person is required.\n          </span>\n        </div>\n      </div>\n\n      <!--Needed by html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Needed by</label>\n        <div class=\"col-md-7\">\n          <div class=\"input-group pr-needed-by-pack\">\n            <div id=\"prNeededByDate\" type=\"input\" ng-click=\"openDatePicker($event)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"editableData.needed_by_date\" ng-model-options=\"datePickerTimezone\" is-open=\"editableData.neededByDatePanel\" datepicker-options=\"dateOptions\" class=\"form-control pr-needed-by-input\">\n              <span ng-if=\"editableData.needed_by_date !==0\">\n                {{editableData.needed_by_date | date : \'dd MMM yy\'}}\n              </span>\n              <button class=\"needed-by-clear-button fa fa-remove\" ng-if=\"!!editableData.needed_by_date\" ng-click=\"clearNeededByDate($event)\"></button>\n            </div>\n\n            <span class=\"pr-needed-by-dates-button\">\n              <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatePicker($event)\">\n                <i class=\"fa fa-calendar\"></i>\n              </button>\n            </span>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n\n  <!--Other details html here-->\n  <div class=\"row screen-section\">\n    <div class=\"col-md-8 col-md-offset-2 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-5\">Other Details</h3>\n      </div>\n\n      <!--Draft PR no. here-->\n      <div class=\"form-group\" ng-if=\"PR.status.toLowerCase() !== \'draft\'\">\n        <label class=\"col-xs-5\">Draft PR number</label>\n        <div class=\"col-xs-7\">\n          {{PR.pr_number}}\n        </div>\n      </div>\n\n      <!--PR Creator here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Creator</label>\n        <div id=\"prCreator\" class=\"col-md-7\">\n          {{editableData.creator.display_name}}\n        </div>\n      </div>\n\n      <!--PR on behalf of here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">On behalf of</label>\n        <div class=\"col-md-7\">\n          <ui-select id=\"prSelectOnBehalfOf\" ng-disabled=\"!PR.cost_center\" ng-model=\"editableData.requestor\" search-enabled=\"true\" on-select=\"onSelectPRRequestor(editableData.requestor);\" theme=\"bootstrap\">\n            <ui-select-match placeholder=\"Select a person\" id=\"prOnBehalfOf\">\n              {{$select.selected.display_name}}\n            </ui-select-match>\n            <ui-select-choices refresh-delay=\"0\" repeat=\"r in requestorsList | filter: $select.search\">\n              <div ng-bind-html=\"r.display_name | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Remarks</label>\n        <div class=\"col-md-7\">\n          <textarea class=\"form-control\" ng-model=\"editableData.remarks\" ng-change=\"onChangeRemarks(editableData.remarks)\">\n          </textarea>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.NonEditableTemplate-mobile.html","<div class=\"container-fluid no-padding\" style=\"width: 100%\">\n  <div class=\"col-xs-12 col-sm-12\" style=\"overflow-x: auto; padding-left: 0; padding-right: 0\">\n    <table class=\"table table-bordered table-striped table-condensed table-responsive\">\n      <tbody>\n      <tr>\n        <td class=\"col-xs-6 col-sm-6\"><span style=\"font-weight: bold\">Company</span><br>\n          <span class=\"billing-company\">{{PR.company.descr}}\n          </span>\n        </td>\n        <td class=\"col-xs-6 col-sm-6\">\n          <span style=\"font-weight: bold\">Expense Type\n          </span><br>\n          <span class=\"billing-expense\">{{PR.expense_type.descr}}\n          </span>\n        </td>\n      </tr>\n      <tr>\n        <td class=\"col-xs-12 col-sm-12\" colspan=\"2\"><span style=\"font-weight: bold\">Supplier</span>\n          <span ng-repeat=\"item in PR.pr_items | unique: \'supplier.descr\'\"><br>\n            <span class=\"supplier-descr\">{{item}}\n            </span>\n          </span>\n        </td>\n      </tr>\n      <tr>\n        <td class=\"col-xs-12 col-sm-12\" colspan=\"2\">\n          <approval-waiting-on data=\"approvalFlowData()\" style=\"word-wrap: break-word\">\n          </approval-waiting-on>\n        </td>\n      </tr>\n      <tr class=\"row-no-border\">\n        <td class=\"col-xs-6 col-sm-6\" style=\"font-weight: bold\">Total amount incl. of GST ({{PR.currency.code}})\n        </td>\n        <td class=\"col-xs-6 col-sm-6\" style=\"text-align: right; font-size: 17px\">\n          <span class=\"grand-total\">{{PR.grand_total | formatDecimal: 2}}\n          </span>\n        </td>\n      </tr>\n\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div class=\"jumbotron col-xs-12 col-sm-12 jumbotron-noneditable-color\">\n  <div class=\"container-fluid no-padding-mobile\">\n    <div class=\"no-padding-mobile\" style=\"layout: fixed\">\n      <div class=\"row\">\n        <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 16px; font-weight: bold\">\n          <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px; margin-left: 2px\"></i>Bill to :\n        </div>\n        <div class=\"col-xs-4 col-sm-4\">\n          <div class=\"fa fa-chevron-down expand-btn\" ng-if=\"!billToShow\" ng-click=\"setShowing(\'bill_to\')\">\n          </div>\n          <div class=\"fa fa-chevron-up expand-btn\" ng-if=\"billToShow\" ng-click=\"setShowing(\'bill_to\')\">\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"billToShow\" class=\"row\">\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Company\n          </span><br>\n          <span class=\"field-value\">{{PR.company.descr}}\n          </span>\n        </div>\n        <div class=\"col-xs-6 col-sm-6\" ng-if=\"!!PR.alternate_billing_company.descr\">\n          <span class=\"field-name\">Billing Company\n          </span><br>\n          <span class=\"field-value\">{{::PR.alternate_billing_company.descr}}\n          </span>\n        </div>\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Cost Center\n          </span><br>\n          <span class=\"field-value\">{{PR.cost_center.descr}}\n          </span>\n        </div>\n      </div>\n      <div ng-show=\"billToShow\" class=\"row\">\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Expense Type\n          </span><br>\n          <span class=\"field-value\">{{PR.expense_type.descr}}\n          </span>\n        </div>\n        <div class=\"col-xs-6 col-sm-6\" ng-if=\"!!PR.budget\">\n          <span class=\"field-name\">Budget\n          </span><br>\n          <span class=\"field-value\">\n            {{ (!!PR.budget.descr && !!PR.budget.code) ?\n           PR.budget.descr + \'(\' + PR.budget.code + \')\' : \'N/A\' }}\n          </span>\n        </div>\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Currency\n          </span><br>\n          <span class=\"field-value\">{{PR.currency.descr}}\n          </span>\n        </div>\n      </div>\n      <div ng-show=\"billToShow\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Address\n          </span><br>\n          <span class=\"field-value\">\n            {{ (PR.billing_to_address.line1.length\n						? PR.billing_to_address.line1 + \"\\n\": \"\") +\n						(PR.billing_to_address.line2.length ? PR.billing_to_address.line2\n						+ \"\\n\": \"\") + (PR.billing_to_address.line3.length ?\n						PR.billing_to_address.line3 + \"\\n\": \"\") +\n						(PR.billing_to_address.postal_code.length ?\n						PR.billing_to_address.postal_code : \"\") +\n						(PR.billing_to_address.city.length ?\n						(PR.billing_to_address.postal_code.length ? \" \" : \"\") +\n						PR.billing_to_address.city + \"\\n\" :\n						(PR.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n						(PR.billing_to_address.state.length ? PR.billing_to_address.state\n						: \"\") + (PR.billing_to_address.country.length?\n						(PR.billing_to_address.state.length ? \", \" : \"\") +\n						PR.billing_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<br>\n\n\n<div class=\"jumbotron col-xs-12 col-sm-12 jumbotron-noneditable-color\">\n  <div class=\"container-fluid no-padding-mobile\">\n    <div class=\"no-padding-mobile\" style=\"layout: fixed\">\n      <div class=\"row\">\n        <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 16px; font-weight: bold\">\n          <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px; margin-left: 2px\">\n          </i>\n          Deliver to :\n        </div>\n        <div class=\"col-xs-4 col-sm-4\">\n          <div class=\"fa fa-chevron-down expand-btn\" ng-if=\"!deliverToShow\" ng-click=\"setShowing(\'deliver_to\')\">\n          </div>\n          <div class=\"fa fa-chevron-up expand-btn\" ng-if=\"deliverToShow\" ng-click=\"setShowing(\'deliver_to\')\">\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"deliverToShow\" class=\"row\">\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Contact Person\n          </span><br>\n          <span class=\"field-value\">{{PR.contact_person}}\n          </span>\n        </div>\n        <div class=\"col-xs-6 col-sm-6\">\n          <span class=\"field-name\">Needed by\n          </span><br>\n          <span class=\"field-value\">{{PR.needed_by_date | date : \'dd MMM yy\'}}\n          </span>\n        </div>\n      </div>\n      <div ng-show=\"deliverToShow\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Address\n          </span><br>\n          <span class=\"field-value\"> {{PR.company.descr}}\n          </span>\n        </div>\n      </div>\n      <div ng-show=\"deliverToShow\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Address\n          </span><br>\n          <span class=\"field-value\">\n            {{ (PR.delivery_to_address.line1.length ?\n            PR.delivery_to_address.line1 + \"\\n\": \"\") +\n            (PR.delivery_to_address.line2.length ?\n						PR.delivery_to_address.line2 + \"\\n\": \"\") +\n						(PR.delivery_to_address.line3.length ?\n						PR.delivery_to_address.line3 + \"\\n\": \"\") +\n						(PR.delivery_to_address.postal_code.length ?\n						PR.delivery_to_address.postal_code : \"\") +\n						(PR.delivery_to_address.city.length ?\n						(PR.delivery_to_address.postal_code.length ? \" \" : \"\") +\n						PR.delivery_to_address.city + \"\\n\" :\n						(PR.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n						(PR.delivery_to_address.state.length ?\n						PR.delivery_to_address.state : \"\") +\n						(PR.delivery_to_address.country.length?\n						(PR.delivery_to_address.state.length ? \", \" : \"\") +\n						PR.delivery_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<br>\n<div class=\"jumbotron col-xs-12 col-sm-12 jumbotron-noneditable-color\">\n  <div class=\"container-fluid no-padding-mobile\">\n    <div class=\"no-padding-mobile\" style=\"layout: fixed\">\n      <div class=\"row\">\n        <div class=\"col-xs-8 col-sm-8\" style=\"font-size: 16px; font-weight: bold\">\n          <i class=\"fa fa-check-circle-o\" style=\"margin-right: 3px; margin-left: 2px\">\n          </i>\n          Other details :\n        </div>\n        <div class=\"col-xs-4 col-sm-4\">\n          <div class=\"fa fa-chevron-down expand-btn\" ng-if=\"!otherToShow\" ng-click=\"setShowing(\'other_details\')\">\n          </div>\n          <div class=\"fa fa-chevron-up expand-btn\" ng-if=\"otherToShow\" ng-click=\"setShowing(\'other_details\')\">\n          </div>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" ng-if=\"PR.status.toLowerCase() !== \'draft\'\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Draft PR Number\n          </span><br>\n          <span class=\"field-value\"> {{ PR.reference }}\n          </span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Creator\n          </span><br>\n          <span class=\"field-value\"> {{PR.creator.display_name}}\n          </span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" ng-if=\"(PR.creator._id !== PR.requestor._id)\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">On behalf of\n          </span><br>\n          <span class=\"field-value\"> {{PR.requestor.display_name}}\n          </span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Remarks\n          </span><br>\n          <span class=\"field-value\">{{PR.remarks || \'N/A\'}}</span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" ng-if=\"PR.status.toLowerCase() !== \'draft\' && PR.status.toLowerCase() !== \'deleted\'\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Submission date\n          </span><br>\n          <span class=\"field-value\"> {{ PR.submitted_at | date:\'dd MMM yyyy\'}} (\n            <span am-time-ago=\"PR.submitted_at\">\n            </span>)\n					</span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" ng-if=\"PR.status.toLowerCase() === \'approved\'\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">Approved date\n          </span><br>\n          <span class=\"field-value\"> {{ PR.closed_at | date:\'dd MMM yyyy\' }}\n            (<span am-time-ago=\"PR.closed_at\">\n            </span>)\n					</span>\n        </div>\n      </div>\n\n      <div ng-show=\"otherToShow\" ng-if=\"PR.status.toLowerCase() === \'approved\'\" class=\"row\">\n        <div class=\"col-xs-12 col-sm-12\">\n          <span class=\"field-name\">PO Number\n          </span><br>\n          <span class=\"field-value\"> <a ng-repeat=\"po in PR.pos\" ui-sref=\"main.user.orders.detail({id : po._id})\">\n							{{po.number}} </a>\n					</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/detailsHeader/purchaseRequisitionDetailsHeader.NonEditableTemplate.html","<div class=\"jumbotron mt-15 col-md-12 jumbotron-noneditable-color\">\n  <!--Html for pr warning block here-->\n\n  <div class=\"row screen-section\">\n    <!--Company Billing-->\n    <div class=\"col-md-6 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-3\">Bill To</h3>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Company</label>\n        <div class=\"col-md-7\">\n         <span class=\"billing-company\">\n           {{PR.company.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Billing address-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Address</label>\n\n        <div class=\"col-md-7\">\n          <span class=\"address-text-format\">{{\n            (PR.billing_to_address.line1.length ? PR.billing_to_address.line1 + \"\\n\": \"\") +\n            (PR.billing_to_address.line2.length ? PR.billing_to_address.line2 + \"\\n\": \"\") +\n            (PR.billing_to_address.line3.length ? PR.billing_to_address.line3 + \"\\n\": \"\") +\n            (PR.billing_to_address.postal_code.length ? PR.billing_to_address.postal_code : \"\") +\n            (PR.billing_to_address.city.length ? (PR.billing_to_address.postal_code.length ? \" \" : \"\") +\n             PR.billing_to_address.city + \"\\n\" :\n            (PR.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n            (PR.billing_to_address.state.length ? PR.billing_to_address.state : \"\") +\n            (PR.billing_to_address.country.length? (PR.billing_to_address.state.length ? \", \" : \"\") +\n             PR.billing_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n\n      <!--Alternative billing company html here-->\n      <div class=\"form-group\" ng-if=\"!!PR.alternate_billing_company\">\n        <label class=\"col-md-3\">Billing Company</label>\n        <div class=\"col-md-7\">\n         <span>\n          {{::PR.alternate_billing_company.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Cost center html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Cost center</label>\n        <div class=\"col-md-7\">\n         <span class=\"billing-cost-center\">\n          {{PR.cost_center.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Expense type html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Expense type</label>\n        <div class=\"col-md-7\">\n         <span class=\"billing-expense\">\n           {{PR.expense_type.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Budget html here-->\n      <div class=\"form-group\" ng-if=\"!!PR.budget\">\n        <label class=\"col-md-3\">Budget</label>\n        <div class=\"col-md-7\">\n         <span class=\"billing-expense\">\n           {{ (!!PR.budget.descr && !!PR.budget.code) ?\n           PR.budget.descr + \'(\' + PR.budget.code + \')\' : \'N/A\' }}\n         </span>\n        </div>\n      </div>\n\n      <!--Currency html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-3\">Currency</label>\n        <div class=\"col-md-7\">\n         <span class=\"billing-expense\">\n           {{PR.currency.descr}}\n         </span>\n        </div>\n      </div>\n    </div>\n\n    <!--Company Delivery-->\n    <div class=\"col-md-6 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-5\">Deliver To</h3>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Company</label>\n        <div class=\"col-md-7\">\n            <span class=\"delivery-company\">\n            {{PR.company.descr}}\n         </span>\n        </div>\n      </div>\n\n      <!--Delivery Address-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Address</label>\n        <div class=\"col-md-7\">\n          <div>\n\n          </div>\n          <span class=\"address-text-format\">{{\n            (PR.delivery_to_address.line1.length ? PR.delivery_to_address.line1 + \"\\n\": \"\") +\n            (PR.delivery_to_address.line2.length ? PR.delivery_to_address.line2 + \"\\n\": \"\") +\n            (PR.delivery_to_address.line3.length ? PR.delivery_to_address.line3 + \"\\n\": \"\") +\n            (PR.delivery_to_address.postal_code.length ? PR.delivery_to_address.postal_code : \"\") +\n            (PR.delivery_to_address.city.length ? (PR.delivery_to_address.postal_code.length ? \" \" : \"\") +\n             PR.delivery_to_address.city + \"\\n\" :\n            (PR.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n            (PR.delivery_to_address.state.length ? PR.delivery_to_address.state : \"\") +\n            (PR.delivery_to_address.country.length? (PR.delivery_to_address.state.length ? \", \" : \"\") +\n             PR.delivery_to_address.country: \"\") }}\n          </span>\n        </div>\n      </div>\n\n      <!--Contact person html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Contact person</label>\n        <div class=\"col-md-7\">\n            <span>\n           {{PR.contact_person}}\n         </span>\n        </div>\n      </div>\n\n      <!--Needed by html here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Needed by</label>\n        <div class=\"col-md-7\">\n          <div class=\"input-group pr-needed-by-pack\">\n           <span>\n             {{PR.needed_by_date | date : \'dd MMM yy\'}}\n           </span>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n\n  <!--Other details html here-->\n  <div class=\"row screen-section\">\n    <div class=\"col-md-8 col-md-offset-2 form-horizontal\">\n      <div class=\"row\">\n        <h3 class=\"col-md-5\">Other Details</h3>\n      </div>\n\n      <!--Draft PR no. here-->\n      <div class=\"form-group\" ng-if=\"PR.status.toLowerCase() !== \'draft\'\">\n        <label class=\"col-xs-5\">Draft PR number</label>\n        <div class=\"col-xs-7\">\n          {{ PR.reference }}\n        </div>\n      </div>\n\n      <!--PR Creator here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Creator</label>\n        <div class=\"col-md-7\">\n          {{PR.creator.display_name}}\n        </div>\n      </div>\n\n      <!--PR Remarks here-->\n      <div class=\"form-group\">\n        <label class=\"col-md-5\">Remarks</label>\n        <div class=\"col-md-7 item-history-title\">\n          {{PR.remarks || \'N/A\'}}\n        </div>\n      </div>\n\n      <!--PR on behalf of here-->\n      <div class=\"form-group\" ng-if=\"(PR.creator._id !== PR.requestor._id)\">\n        <label class=\"col-md-5\">On behalf of</label>\n        <div class=\"col-md-7\">\n         <span>\n           {{PR.requestor.display_name}}\n         </span>\n        </div>\n      </div>\n\n      <!--Submitted date here-->\n      <div class=\"form-group\" ng-if=\"PR.status.toLowerCase() !== \'draft\' && PR.status.toLowerCase() !== \'deleted\'\">\n        <label class=\"col-md-5\">Submission date</label>\n        <div class=\"col-md-7\">\n          {{ PR.submitted_at | date:\'dd MMM yyyy\' }}\n          (<span am-time-ago=\"PR.submitted_at\"></span>)\n        </div>\n      </div>\n\n      <!--Approved date here-->\n      <div class=\"form-group\" ng-if=\"PR.status.toLowerCase() === \'approved\'\">\n        <label class=\"col-md-5\">Approved date</label>\n        <div class=\"col-md-7\">\n          {{ PR.closed_at | date:\'dd MMM yyyy\' }}\n          (<span am-time-ago=\"PR.closed_at\"></span>)\n        </div>\n      </div>\n\n      <!--PO numbers here-->\n      <div class=\"form-group\" ng-if=\"PR.status.toLowerCase() === \'approved\'\">\n        <label class=\"col-md-5\">PO number</label>\n        <div class=\"col-md-7\">\n          <a class=\"col-md-12\" ng-repeat=\"po in PR.pos\" ui-sref=\"main.user.orders.detail({id : po._id})\">\n            {{po.number}}\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/itemDetails/itemDetails.html","<article class=\"product-details\">\n  <button aria-hidden=\"true\" ng-click=\"close()\" class=\"close\" type=\"button\">×</button>\n\n  <!-- Non Catalog label -->\n  <i ng-if=\"details.is_stock === 0\" title=\"Non catalog\" class=\"label label-danger pull-right details-label\">Non catalog\n  </i>\n\n  <!-- Partial Item label-->\n  <i ng-if=\"details.is_partial === 1\" title=\"partial\" class=\"label label-warning pull-right details-label\">Partial\n  </i>\n\n  <!-- Item Name-->\n  <h4>\n    {{ details.item_name }}\n    <a id=\"starPRItem\" class=\"star-pr\" ng-if=\"enableStarring\">\n      <i ng-click=\"itemStarring(details, details.mainItemId)\" ng-attr-class=\"{{ !!details.starred && \'fa fa-star star-hover\' || \'fa fa-star-o star-hover-o\'}}\">\n      </i>\n    </a>\n\n    <!-- Non Catalog Edit -->\n    <a id=\"editNonCatalog\" class=\"edit-non\" ng-if=\"details.is_stock === 0 && (getPRState() === \'editable\')\n        && !isShoppingMode()\" non-catalog-item item=\"item\">\n      Edit\n    </a>\n  </h4>\n\n  <div class=\"product-description clearfix\">\n    <aside class=\"pull-right\">\n      <div class=\"product-images\">\n        <img ng-if=\"!!item.item.img_url\" class=\"img-responsive\" ng-src=\"{{ imageBasePath }}{{ item.item.img_url }}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n        <img ng-if=\"!item.item.img_url\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n      </div>\n    </aside>\n\n    <p style=\"white-space: pre-line\" class=\"limit-lines\" ng-if=\"details.description\">\n      {{ details.description }}\n    </p>\n\n    <div ng-if=\"!!item.commodity.code\" class=\"item-details-commodity\">\n      <strong>Commodity Code:</strong>\n      <br>\n      <span>\n        {{ item.commodity.code }}\n        <text-show-less-more model=\"item.commodity.descr\" type=\"words\" length=\"12\">\n        </text-show-less-more>\n      </span>\n    </div>\n  </div>\n\n  <div class=\"product-variations\">\n    <table class=\"table table-striped table-hover\">\n      <thead>\n      <tr>\n        <th>Supplier</th>\n        <th>Price</th>\n        <th>Supplier Part #</th>\n        <th>Lead Time</th>\n        <th>Payment Term</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr>\n        <td> {{ details.supplier_descr }} </td>\n        <td>\n          {{ item.unit_price | isoCurrency: item.currency.code:4 }} /\n          {{ item.UOM.code }}\n        </td>\n        <td> {{ details.supplier_part_no }} </td>\n        <td> {{ !!details.lead_time ? details.lead_time : \'Not specified\' }} </td>\n        <td> {{ item.payment_term.descr }} </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</article>\n");
$templateCache.put("components/purchaseRequisitionComponents/itemList/prItemList.EditableTemplate.html","<item-multi-select items=\"PRData().pr_items\" update-items=\"updateItem(itemIndex, field, isDecimal, newValue, backupValue)\" address-list=\"costCenterDeliveryAddresses\" un-select-all-items=\"itemMainCheckboxClicked(value)\" remove-items=\"removeItems(data, type)\" update-multi-items=\"updateMultiItems(items, field, value)\">\n</item-multi-select>\n\n<div class=\"overlay\" ng-show=\"checkLoading(\'lineItemTable\')\">\n  <div id=\"loading-img\"></div>\n</div>\n<table class=\"table screen-section\">\n  <colgroup>\n    <col class=\"column-checkbox\">\n    <col class=\"column-image\">\n    <col class=\"column-item-details column-item-details-no-check-box\">\n    <col class=\"column-quantity\">\n    <col class=\"column-unit-price\">\n    <col class=\"column-amount\">\n  </colgroup>\n  <thead>\n  <tr>\n    <th>\n      <input type=\"checkbox\" icheck ng-click=\"itemMainCheckboxClicked(itemMainCheckBox.selected)\" ng-model=\"itemMainCheckBox.selected\">\n    </th>\n    <th colspan=\"2\" class=\"text-left-align\">Item</th>\n    <th> Qty </th>\n    <th> Unit Price </th>\n    <th> Amount </th>\n    <th> Discount </th>\n    <th> Total Amount </th>\n    <th> GST </th>\n  </tr>\n  </thead>\n\n  <tbody>\n  <tr ng-if=\"!PRData().pr_items || !PRData().pr_items.length\">\n    <td colspan=\"8\">\n      <span ng-if=\"!!PRData().cost_center\">There are no items.\n        <a id=\"prAddItemButton\" ng-click=\"isLoading.addItem=true\" ng-if=\"isPRCreator()\" ui-sref=\"main.user.purchaseRequisitions.details.catalog.tab\">\n          Add an item.\n        </a>\n        <span ng-if=\"!PRData().cost_center\">\n          Select the billing company and cost centre to add an item.\n        </span>\n      </span>\n\n      <section class=\"text-danger\" ng-show=\"message_error.items.item && submitted\">\n        Item(s) is required\n      </section>\n    </td>\n  </tr>\n\n  <tr ng-repeat-start=\"item in PRData().pr_items track by $index\" class=\"animate-repeat\" ng-class=\"{ \'row-select\': !!item.selected  }\">\n    <td>\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <input icheck type=\"checkbox\" ng-model=\"item.selected\" ng-change=\"Unchecked()\" ng-click=\"!!item.selected ? !!item.selected : !item.selected\">\n        </div>\n        <div class=\"col-md-12 duplicate-item\">\n          <i class=\"fa fa-copy\" ng-click=\"duplicateItem(item)\" uib-tooltip=\"Duplicate line item\">\n          </i>\n        </div>\n      </div>\n    </td>\n\n    <td>\n      <div class=\"product-image-wrapper\">\n        <!-- todo: create directive to display image -->\n        <img class=\"img-responsive\" ng-if=\"!!item.item.img_url\" ng-src=\"{{ imageBasePath }}{{ item.item.img_url }}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item_details.item_name}}\">\n        <img ng-if=\"!item.item.img_url\" class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n      </div>\n      <a ng-click=\"removeItems([item])\" class=\"small text-danger\">\n        Delete Item\n      </a>\n    </td>\n\n    <!-- item or supplier status -->\n    <td class=\"text-left-align\">\n      <span ng-if=\"item.item_details.is_stock === 0\" class=\"label label-danger pull-right\">Non Catalog</span>\n      <span ng-if=\"!!item.item_details.is_stock && !!item.item_details.is_partial\" class=\"label label-warning pull-right\">\n        Partial Item\n      </span>\n      <span ng-if=\"item.supplier.status === \'BLACK_LISTED\'\" class=\"label label-blacklist pull-right\">\n        Supplier Blacklisted\n      </span>\n      <p>\n        <item-details details=\"item\" img-path=\"imageBasePath\" enable-starring=\"false\" class=\"clicked-link\">\n          {{ $index + 1 }}. {{item.item_details.item_name}}\n        </item-details>\n      </p>\n      <p>\n        <text-show-less-more model=\"item.item_details.description\" type=\"words\" class=\"limit-lines\">\n        </text-show-less-more>\n      </p>\n      <p>\n        <script type=\"text/ng-template\" id=\"supplierTooltip\">\n          <div>\n            {{item.supplier.descr}}\n            <br> Contact Person: {{ item.supplier.contact_person.first_name ?\n              item.supplier.contact_person.first_name : \'Not available\' }}\n            <br> Email: {{item.supplier.contact_person.email ?\n              item.supplier.contact_person.email : \'Not available\'}}\n            <br> Phone: {{item.supplier.phone ? item.supplier.phone : \'Not available\'}}\n            <br> Fax: {{item.supplier.fax ? item.supplier.fax : \'Not available\'}}\n          </div>\n        </script>\n        <b uib-tooltip-template=\"\'supplierTooltip\'\">\n          {{item.supplier.descr}}\n        </b>\n      </p>\n      <p ng-if=\"!!item.payment_term\">{{item.payment_term.descr}}</p>\n\n      <!-- Other Details (Needed by date, transportation, and so on) -->\n      <div class=\"row grey-border-top\" ng-show=\"checkOthersValue(item, \'needed_by_date\') || checkOthersValue(item, \'delivery_address\') ||\n                 checkOthersValue(item, \'note\') || checkOthersValue(item, \'account_code\') ||\n                 checkOthersValue(item, \'branch\')\">\n        <!-- Needed by date -->\n        <div class=\"col-md-12 grey-border-bottom\" ng-show=\"checkOthersValue(item, \'needed_by_date\')\">\n          <b>Needed by date: </b>&nbsp;\n          <span class=\"pull-right cursor-pointer\">\n            <i class=\"fa fa-trash\" ng-click=\"removeOtherValue(item, \'needed-by\', $index)\"></i>\n          </span>\n\n          <span ng-show=\"!item.needed_by_date\">\n            <i>Select date</i>\n          </span>\n          <span ng-show=\"!!item.needed_by_date\">\n            {{ item.needed_by_date | date:\'dd MMM yyyy\' }}\n          </span>\n          <span monitor-date=\"item.needed_by_date\" on-changed-date=\"updateNeededByDate($index, item.needed_by_date, item.backup_needed_by_date)\">\n          </span>\n          <button class=\"btn btn-white btn-xs\" ng-click=\"openDatePicker($event, $index)\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"item.needed_by_date\" ng-model-options=\"datePickerTimezone\" is-open=\"item.datePicker\" datepicker-options=\"dateOptions\" ng-required=\"true\">\n            <i class=\"fa fa-calendar\"></i>\n          </button>\n        </div>\n\n        <!-- Supplier Branch -->\n        <div ng-show=\"checkOthersValue(item, \'branch\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Supplier Branch:</b>\n          <span class=\"pull-right cursor-pointer\">\n            <i class=\"fa fa-trash\" ng-click=\"removeOtherValue(item, \'branch\', $index)\"></i>\n          </span>\n          <div ng-if=\"!item.branch\">\n            <a ng-if=\"!item.branch\" ng-click=\"supplierBranchModal(item.supplier._id, $index, item.branch)\">\n              Select Supplier Branch\n            </a>\n          </div>\n          <div ng-if=\"!!item.branch\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n              <b>Branch   :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n                {{(item.branch.descr + \" (\" + item.branch.code + \")\")}}\n            </div>\n            <br ng-if=\"item.branch.descr\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n              <b>Address :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n              {{\n              (item.branch.address.line1.length ? item.branch.address.line1 + \", \": \"\") +\n              (item.branch.address.line2.length ? item.branch.address.line2 : \"\")\n              }}\n              <br ng-if=\"item.branch.address.line1 || item.branch.address.line2\">\n              {{\n              (item.branch.address.line3.length ? item.branch.address.line3 + \",\": \"\") +\n              (item.branch.address.city.length ? item.branch.address.city : \"\")\n              }}\n              <br ng-if=\"item.branch.address.line3 || item.branch.address.city\">\n              {{ (item.branch.address.postal_code.length ? item.branch.address.postal_code + \",\" : \"\") +\n              (item.branch.address.state.length ? item.branch.address.state : \"\")\n              }}\n              <br ng-if=\"item.branch.address.postal_code || item.branch.address.state\">\n              {{\n              (item.branch.address.country.length? item.branch.address.country + \". \" : \"\")\n              }}\n              <br ng-if=\"item.branch.address.country\">\n            </div>\n            <br ng-if=\"item.branch.address._id\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n              <b>Phone   :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n              {{item.branch.phone.length ? item.branch.phone : \"Not Available\"}}\n            </div>\n            <br ng-if=\"item.branch.phone\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n              <b>Fax     :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n              {{item.branch.fax.length ? item.branch.fax : \"Not Available\"}}\n            </div>\n            <br ng-if=\"item.branch.fax\">\n          </div>\n        </div>\n\n        <!-- Delivery Address -->\n        <div ng-show=\"checkOthersValue(item, \'delivery_address\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Delivery Address:</b>\n          <span class=\"pull-right cursor-pointer\">\n            <i class=\"fa fa-trash\" ng-click=\"removeOtherValue(item, \'delivery_address\', $index)\"></i>\n          </span>\n          <div ng-if=\"!item.delivery_address\">\n            <a address-book=\"{{item.delivery_address._id}}\" address-list=\"getDeliveryAddresses()\" on-selected-address-book=\"onSelectDeliveryAddress(address_book, $index, item.delivery_address)\" access-from=\"LineItemDeliveryAddress\" event-handler=\"true\">\n              Select address\n            </a>\n          </div>\n\n          <div ng-if=\"!!item.delivery_address\">\n            <span class=\"address-text-format\">{{\n              (item.delivery_address.line1.length ? item.delivery_address.line1 + \"\\n\": \"\") +\n              (item.delivery_address.line2.length ? item.delivery_address.line2 + \"\\n\": \"\") +\n              (item.delivery_address.line3.length ? item.delivery_address.line3 + \"\\n\": \"\") +\n              (item.delivery_address.postal_code.length ? item.delivery_address.postal_code : \"\") +\n              (item.delivery_address.length ? (item.delivery_address.length ? \" \" : \"\") +\n              item.delivery_address.city + \"\\n\" : (item.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n              (item.delivery_address.state.length ? item.delivery_address.state : \"\") +\n              (item.delivery_address.country.length? (item.delivery_address.country.length ? \", \" : \"\") +\n              item.delivery_address.country: \"\") }}\n            </span>\n            <a class=\"pull-left\" address-book=\"{{item.delivery_address._id}}\" address-list=\"getDeliveryAddresses()\" on-selected-address-book=\"onSelectDeliveryAddress(address_book, $index, item.delivery_address)\" access-from=\"LineItemDeliveryAddress\" event-handler=\"true\">\n              Update address\n            </a>\n          </div>\n        </div>\n\n        <!-- Notes -->\n        <div ng-show=\"checkOthersValue(item, \'note\')\" ng-init=\"item.note_focus = !(checkOthersValue(item, \'note\'))\" class=\"col-md-12 grey-border-bottom\">\n          <b>Notes (Only for external):</b>\n          <span class=\"pull-right cursor-pointer\">\n            <i class=\"fa fa-trash\" ng-click=\"removeOtherValue(item, \'note\', $index)\"></i>\n          </span>\n          <br>\n          <editable-focus focus=\"item.note_focus\" is-textarea=\"true\" model=\"item.note\" class=\"limit-lines\" update-function=\"updateItem($index, \'note\', false, item.note, item.backup_note)\">\n          </editable-focus>\n        </div>\n\n        <!-- Account codes -->\n        <div ng-show=\"checkOthersValue(item, \'account_code\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Account Codes:</b>\n          <span class=\"pull-right cursor-pointer\">\n            <i class=\"fa fa-trash\" ng-click=\"removeOtherValue(item, \'account-code\', $index)\"></i>\n          </span>\n          <div class=\"mt-5 mb-10\">\n            <ui-select ng-model=\"item.account_code\" on-select=\"onSelectAccountCode(item.account_code, $index)\">\n              <ui-select-match placeholder=\"Select account code...\">\n                {{ PRData().company.code + \':\' + PRData().cost_center.code + \':\' + $select.selected.code}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"ac in getAccountCodes() | filter: $select.search\">\n                <span ng-bind-html=\"ac.company_code | highlight: $select.search\"></span>:\n                <span ng-bind-html=\"PRData().cost_center.code | highlight: $select.search\"></span>:\n                <span ng-bind-html=\"ac.code | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n      </div>\n    </td>\n\n    <td>\n      <a ng-model=\"item.qty\" editable-number=\"item.qty\" e-class=\"item-quantity-edit\" e-step=\"0.00001\" blur=\"submit\" buttons=\"no\" e-ng-pattern=\"/^[0-9]+(\\.[0-9]{1,5})?$/\" onaftersave=\"updateItem($index, \'qty\', !!item.UOM.is_fraction, item.qty, item.backup_qty)\">\n        {{ item.qty }} {{ item.UOM.code }}\n      </a>\n    </td>\n\n    <!--For item unit price-->\n    <td>\n      <!--For catalog item and non partial item (i.e. non editable unit price)-->\n      <div ng-if=\"item.item_details.is_stock === 1 && item.item_details.is_partial === 0\">\n        {{ item.unit_price_pr_currency | formatDecimal: 4}}\n\n        <!--Show item price in item currency in grey text if currency differs from PR-->\n        <div ng-if=\"!!differentCurrencyChecker(item.currency.code)\" class=\"grey-text\">\n          {{ item.unit_price | isoCurrency: item.currency.code: 4}}\n        </div>\n      </div>\n\n      <!--For non catalog item or partial items (i.e. editable unit price)-->\n      <div ng-if=\"item.item_details.is_stock === 0 || item.item_details.is_partial === 1\">\n\n        <!--If item currency is different from PR currency-->\n        <div>\n          <div ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n            {{ item.unit_price_pr_currency | formatDecimal: 4 }}\n          </div>\n\n          <!--Show item price in item currency in grey text if currency differs from PR-->\n          {{item.backup_price}}\n          <div>\n            <a ng-model=\"item.unit_price\" editable-number=\"item.unit_price\" e-step=\"0.0001\" class=\"item-quantity-edit\" blur=\"submit\" buttons=\"no\" e-ng-pattern=\"/^[0-9]+(\\.[0-9]{1,5})?$/\" onaftersave=\"updateItem($index, \'price\', true, item.unit_price, item.backup_unit_price)\">\n              {{ item.unit_price | isoCurrency: item.currency.code: 4}}\n            </a>\n          </div>\n        </div>\n\n      </div>\n    </td>\n\n    <td>\n      <div ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.amount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        {{item.amount | formatDecimal: 2}}\n        <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n          {{ item.currency.code }}\n        </span>\n      </div>\n    </td>\n\n    <td>\n\n      <!-- Discount value if percentage is true -->\n      <div ng-show=\"!!item.discount\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          ({{item.discount_pr_currency | formatDecimal: 2}})\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          ({{ item.discount | isoCurrency: item.currency.code: 2 }})\n        </div>\n      </div>\n\n      <!-- discount -->\n      <a ng-show=\"!item.addingDiscount\" uib-tooltip=\"Add discount\" ng-click=\"addingDiscount($index)\" class=\"item-edit-quantity\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n          <span ng-if=\"!!item.discount_percentage\">\n           ({{ item.discount_entry }})\n          </span>\n           <span ng-if=\"!item.discount_percentage\">\n          ({{ item.discount_entry | isoCurrency: item.currency.code: 2}})\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n          <span ng-if=\"!!item.discount_percentage\">\n           ({{ item.discount_entry }})\n          </span>\n           <span ng-if=\"!item.discount_percentage\">\n          ({{ item.discount_entry | formatDecimal: 2}})\n          </span>\n        </span>\n        <span ng-show=\"!item.discount_entry\">\n          Add\n        </span>\n      </a>\n\n      <input id=\"discountInput{{$index}}\" title=\"Add discount\" ng-hide=\"!item.addingDiscount\" type=\"text\" focus-input=\"item.addingDiscount\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" step=\".01\" ng-enter=\"item.addingDiscount = false; updateDiscountInputFocus($index);\" ng-blur=\"updateItem($index, \'discount\', true, item.discount_entry, item.backup_discount); item.addingDiscount = false;\" ng-model=\"item.discount_entry\">\n\n\n      <div ng-show=\"!!item.discount\">\n        <i class=\"fa fa-trash cursor-pointer\" ng-click=\"updateItem($index, \'discount\', true, 0, item.backup_discount); item.addingDiscount = false;\">\n        </i>\n      </div>\n    </td>\n\n    <td>\n      <div> {{ item.amount_with_discount_pr_currency | formatDecimal: 2 }} </div>\n      <div ng-if=\"!!differentCurrencyChecker(item.currency.code)\" class=\"grey-text\">\n        {{ item.amount_with_discount | isoCurrency: item.currency.code: 2  }}\n      </div>\n    </td>\n\n    <td>\n      <div class=\"btn-group\" role=\"group\" ng-if=\"!!item.unit_price\">\n        <a class=\"dropdown-toggle add-gst\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n          {{(!!item.tax && !!item.tax._id) ?\n          (item.tax.code + \" \" + item.tax.rate + \"%\") : \"Add\"}}\n        </a>\n\n        <div ng-if=\"differentCurrencyChecker(item.currency.code)\">\n          {{ item.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n          {{ item.tax.amount | formatDecimal: 2}}\n          <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </div>\n\n        <ul class=\"dropdown-menu taxes-list\">\n          <li ng-repeat=\"tax in taxList()\">\n            <a ng-click=\"updateItemTax($parent.$index, \'tax\', false, tax, item.backup_tax)\">\n              {{ tax.code + \' \' + tax.rate + \'%\' }}\n            </a>\n          </li>\n        </ul>\n        <div>\n          <button ng-click=\"removeTax($index)\" ng-show=\"(!!item.tax && !!item.tax._id) && item.is_stock === 0\" class=\"btn btn-white btn-xs\">\n            <i class=\"fa fa-trash\" title=\"Delete Tax\"></i>\n          </button>\n        </div>\n      </div>\n\n    </td>\n  </tr>\n\n  <!-- Freight -->\n  <tr ng-show=\"checkOthersValue(item, \'freights\')\" class=\"tr-freight-transportation\" ng-class=\"{ \'row-select-freight-transport-button\': !!item.selected  }\">\n    <td colspan=\"2\"></td>\n    <td>\n      <div class=\"row\">\n        <div class=\"col-md-12 text-left\">\n          <b>Freight</b>\n          <span class=\"pull-right cursor-pointer\">\n          <i class=\"fa fa-trash\" ng-click=\"removeFreightOrTransportation(\'freights\', $index)\"></i>\n        </span>\n        </div>\n      </div>\n    </td>\n    <td colspan=\"2\"></td>\n    <td>\n      <!-- Freight if percentage is true -->\n      <div ng-show=\"!!item.freights\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          {{item.freights.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          {{ item.freights.amount | isoCurrency: item.currency.code : 2 }}\n        </div>\n      </div>\n      <a ng-show=\"!item.freights.addingFreights\" uib-tooltip=\"Add freight\" ng-click=\"addingFreightsTransport($index, \'freights\', \'addingFreights\')\" class=\"item-edit-quantity\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n          {{ item.freights.entry }}\n          <span ng-show=\"!item.freights.amount_percentage\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n          {{ item.freights.entry }}\n        </span>\n        <span ng-show=\"!item.freights.entry\">\n          Add\n        </span>\n      </a>\n\n      <input title=\"Add freight\" ng-hide=\"!item.freights.addingFreights\" type=\"text\" focus-input=\"item.freights.addingFreights\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" ng-enter=\"item.freights.addingFreights = false;\" ng-blur=\"updateFreightTransport($index, \'freights\', \'entry\', \'amount\');\n                         item.freights.addingFreights = false;\" ng-model=\"item.freights.entry\">\n    </td>\n\n    <!-- Freight Discount -->\n    <td>\n\n      <div ng-show=\"!!item.freights.entry\">\n\n        <!-- Discount value if percentage is true -->\n        <div ng-show=\"!!item.freights\">\n          <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n            ({{item.freights.discount_amount_pr_currency | formatDecimal: 2}})\n          </div>\n          <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n            ({{ item.freights.discount_amount | isoCurrency: item.currency.code: 2 }})\n          </div>\n        </div>\n\n        <a ng-show=\"!item.freights.addingFreightsDiscount\" uib-tooltip=\"Add discount\" ng-click=\"addingFreightsTransport($index, \'freights\', \'addingFreightsDiscount\')\" class=\"item-edit-quantity\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n          <span ng-if=\"!!item.freights.discount_percentage\">\n            ({{ item.freights.discount_entry }})\n          </span>\n          <span ng-if=\"!item.freights.discount_percentage\">\n            ({{ item.freights.discount_entry | isoCurrency: item.currency.code : 2 }})\n          </span>\n        </span>\n          <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n          ({{ item.freights.discount_entry }})\n        </span>\n          <span ng-show=\"!item.freights.discount_entry\">\n          Add\n        </span>\n        </a>\n\n        <input title=\"Add discount\" ng-hide=\"!item.freights.addingFreightsDiscount\" type=\"text\" focus-input=\"item.freights.addingFreightsDiscount\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" ng-enter=\"item.freights.addingFreightsDiscount = false;\" ng-blur=\"updateFreightTransport($index, \'freights\', \'discount_entry\', \'discount\');\n                          item.freights.addingFreightsDiscount = false;\" ng-model=\"item.freights.discount_entry\">\n      </div>\n    </td>\n    <!-- Freight Amount -->\n    <td>\n      <div ng-show=\"!!item.freights.amount\">\n        {{ item.freights.amount_with_discount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.freights.amount_with_discount | isoCurrency: item.currency.code : 2 }}\n      </div>\n    </td>\n    <!-- Freight Tax -->\n    <td>\n      <div ng-show=\"!!item.freights.entry\">\n        <a class=\"dropdown-toggle add-gst\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n          {{(!!item.freights.tax && !!item.freights.tax._id) ?\n          (item.freights.tax.code + \" \" + item.freights.tax.rate + \"%\") : \"Add\"}}\n        </a>\n\n        <div ng-if=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.tax\">\n          {{ item.freights.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.freights.tax\">\n          {{ item.freights.tax.amount | isoCurrency: item.currency.code: 2}}\n        </div>\n\n        <ul class=\"dropdown-menu freight-taxes-list\">\n          <li ng-repeat=\"tax in taxList()\">\n            <a ng-click=\"updateFreightTransport($parent.$index, \'freights\', \'tax_id\', \'tax_id\', tax)\">\n              {{ tax.code + \' \' + tax.rate + \'%\' }}\n            </a>\n          </li>\n        </ul>\n        <div>\n          <button ng-click=\"removeTax($index, \'freights\')\" ng-show=\"(!!item.freights.tax && !!item.freights.tax._id)\" class=\"btn btn-white btn-xs\">\n            <i class=\"fa fa-trash\" title=\"Delete Tax\"></i>\n          </button>\n        </div>\n      </div>\n    </td>\n  </tr>\n\n  <!-- Transportation -->\n  <tr ng-show=\"checkOthersValue(item, \'transportation\')\" class=\"tr-freight-transportation\" ng-class=\"{ \'row-select-freight-transport-button\': !!item.selected  }\">\n    <td colspan=\"2\"></td>\n    <td>\n      <div class=\"row\">\n        <div class=\"col-md-12 text-left\">\n          <b>Transportation</b>\n          <span class=\"pull-right cursor-pointer\">\n          <i class=\"fa fa-trash\" ng-click=\"removeFreightOrTransportation(\'transportation\', $index)\"></i>\n        </span>\n        </div>\n      </div>\n    </td>\n    <td colspan=\"2\"></td>\n    <td>\n\n      <!-- Transportation if percentage is true -->\n      <div ng-show=\"!!item.transportation\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          {{item.transportation.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          {{ item.transportation.amount | isoCurrency: item.currency.code : 2 }}\n        </div>\n      </div>\n\n      <a ng-show=\"!item.transportation.addingTransportation\" uib-tooltip=\"Add transportation\" ng-click=\"addingFreightsTransport($index, \'transportation\', \'addingTransportation\')\" class=\"item-edit-quantity\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n          {{ item.transportation.entry }}\n          <span ng-show=\"!item.transportation.amount_percentage\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n          {{ item.transportation.entry }}\n        </span>\n        <span ng-show=\"!item.transportation.entry\">\n          Add\n        </span>\n      </a>\n\n      <input title=\"Add transportation\" ng-hide=\"!item.transportation.addingTransportation\" type=\"text\" focus-input=\"item.transportation.addingTransportation\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" ng-enter=\"item.transportation.addingTransportation = false;\" ng-blur=\"updateFreightTransport($index, \'transportation\', \'entry\', \'amount\');\n                         item.transportation.addingTransportation = false;\" ng-model=\"item.transportation.entry\">\n    </td>\n\n    <!-- Transportation Discount -->\n    <td>\n      <div ng-show=\"!!item.transportation.entry\">\n\n        <!-- Discount value if percentage is true -->\n        <div ng-show=\"!!item.transportation\">\n          <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n            ({{item.transportation.discount_amount_pr_currency | formatDecimal: 2}})\n          </div>\n          <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n            ({{ item.transportation.discount_amount | isoCurrency : item.currency.code : 2 }})\n          </div>\n        </div>\n\n        <a ng-show=\"!item.transportation.addingTransportationDiscount\" uib-tooltip=\"Add discount\" ng-click=\"addingFreightsTransport($index, \'transportation\', \'addingTransportationDiscount\')\" class=\"item-edit-quantity\">\n          <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n            <span ng-if=\"!!item.transportation.discount_percentage\">\n              ({{ item.transportation.discount_entry }})\n            </span>\n\n            <span ng-show=\"!item.transportation.discount_percentage\">\n              ({{item.transportation.discount_entry | isoCurrency: item.currency.code : 2}})\n            </span>\n          </span>\n            <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n            ({{ item.transportation.discount_entry }})\n          </span>\n          <span ng-show=\"!item.transportation.discount_entry\">\n            Add\n          </span>\n        </a>\n\n        <input title=\"Add discount\" ng-hide=\"!item.transportation.addingTransportationDiscount\" type=\"text\" focus-input=\"item.transportation.addingTransportationDiscount\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" ng-enter=\"item.transportation.addingTransportationDiscount = false;\" ng-blur=\"updateFreightTransport($index, \'transportation\', \'discount_entry\', \'discount\');\n                          item.transportation.addingTransportationDiscount = false;\" ng-model=\"item.transportation.discount_entry\">\n\n      </div>\n    </td>\n    <!-- transportation Amount -->\n    <td>\n      <div ng-show=\"!!item.transportation.amount\">\n        {{ item.transportation.amount_with_discount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.transportation.amount_with_discount | isoCurrency: item.currency.code : 2 }}\n      </div>\n    </td>\n    <!-- transportation Tax -->\n    <td>\n      <div ng-show=\"!!item.transportation.entry\">\n        <a class=\"dropdown-toggle add-gst\" data-toggle=\"dropdown\" aria-expanded=\"true\">\n          {{(!!item.transportation.tax && !!item.transportation.tax._id) ?\n          (item.transportation.tax.code + \" \" + item.transportation.tax.rate + \"%\") : \"Add\"}}\n        </a>\n\n        <div ng-if=\"differentCurrencyChecker(item.currency.code) && !!item.transportation.tax\">\n          {{ item.transportation.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.transportation.tax\">\n          {{ item.transportation.tax.amount | isoCurrency : item.currency.code : 2}}\n        </div>\n\n        <ul class=\"dropdown-menu freight-taxes-list\">\n          <li ng-repeat=\"tax in taxList()\">\n            <a ng-click=\"updateFreightTransport($parent.$index, \'transportation\', \'tax_id\', \'tax_id\', tax)\">\n              {{ tax.code + \' \' + tax.rate + \'%\' }}\n            </a>\n          </li>\n        </ul>\n        <div>\n          <button ng-click=\"removeTax($index, \'transportation\')\" ng-show=\"(!!item.transportation.tax && !!item.transportation.tax._id)\" class=\"btn btn-white btn-xs\">\n            <i class=\"fa fa-trash\" title=\"Delete Tax\"></i>\n          </button>\n        </div>\n      </div>\n    </td>\n  </tr>\n\n  <!-- Add Others Info -->\n  <tr ng-repeat-end class=\"tr-no-border\" ng-class=\"{ \'row-select-add-button\': !!item.selected  }\">\n    <td colspan=\"2\"></td>\n    <td>\n      <button class=\"dropdown-toggle btn btn-xs btn-white other-button pull-left mb-10 mt-5\" id=\"dropdownMenu1\" data-toggle=\"dropdown\">\n        Add\n        <span class=\"fa fa-caret-down\"></span>\n      </button>\n      <ul class=\"dropdown-menu item-list\">\n        <li ng-repeat=\"othersName in itemOthersDetail\">\n          <a ng-click=\"addOthers(othersName.code, $parent.$index)\" ng-hide=\"checkOthersValue(item, othersName.code)\">\n            {{ othersName.name | changeStringCase }}\n          </a>\n        </li>\n      </ul>\n    </td>\n    <td colspan=\"6\"></td>\n  </tr>\n  </tbody>\n\n  <!-- Total -->\n  <tfoot ng-if=\"!!PRData().pr_items && !!PRData().pr_items.length\">\n\n  <!-- Total Amount, discount and tax -->\n  <tr ng-show=\"PRData().lump_sum_discount_entry != null && PRData().lump_sum_discount > -1\">\n    <td colspan=\"4\"></td>\n    <!-- Currency -->\n    <td> {{ PRData().currency.code }} </td>\n    <td>\n      <span uib-tooltip=\"Amount\">\n        {{ PRData().amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <!-- Discount Total -->\n      <span ng-if=\"!!PRData().discount_total\" uib-tooltip=\"Discount\">\n        ({{ PRData().discount_total | formatDecimal:2 }})\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"Total Amount\">\n        {{ (PRData().amount - PRData().discount_total) | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"GST\">\n        {{ PRData().tax_total | formatDecimal:2 }}\n      </span>\n    </td>\n  </tr>\n\n  <!-- Lump Sum Discount-->\n  <tr ng-show=\"PRData().lump_sum_discount_entry != null && PRData().lump_sum_discount > -1\">\n    <td></td>\n    <td>\n      <span class=\"text-danger text-extra-small cursor-pointer\" ng-show=\"!PRData().lump_sum_discount || (!!PRData().lump_sum_discount && PRData().lump_sum_discount === \'null\')\" ng-click=\"addLumpSum(null)\">\n        Delete discount\n      </span>\n\n      <span class=\"text-danger text-extra-small cursor-pointer\" ng-show=\"PRData().lump_sum_discount > 0\" ng-click=\"updateLumpSum(null, PRData().backup_lump_sum_discount)\">\n        Delete discount\n      </span>\n    </td>\n    <td colspan=\"4\" class=\"text-left\">\n      <small class=\"table-padding text-black\">Lump sum discount</small>\n    </td>\n    <td>\n      <!-- Discount value if percentage is true -->\n      <div ng-if=\"!!PRData().lump_sum_discount_percentage\">\n        <small> ({{ PRData().lump_sum_discount | formatDecimal : 2 }}) </small>\n      </div>\n\n      <div>\n        <small>\n          <a ng-show=\"!PRData().addingLumpSum\" uib-tooltip=\"Add lump sum\" ng-click=\"addingLumpSum()\" class=\"item-edit-quantity\">\n            {{ !!PRData().lump_sum_discount_entry ? \'(\' +  PRData().lump_sum_discount_entry + \')\' : \'Add\' }}\n          </a>\n        </small>\n\n      <input title=\"Add discount\" ng-hide=\"!PRData().addingLumpSum\" type=\"text\" focus-input=\"PRData().addingLumpSum\" class=\"discount-input\" allow-pattern=\"[0-9.%]\" ng-enter=\"PRData().addingLumpSum = false;\" ng-blur=\"updateLumpSum(PRData().lump_sum_discount_entry, PRData().backup_lump_sum_discount); PRData().addingLumpSum = false;\" ng-model=\"PRData().lump_sum_discount_entry\">\n\n      </div>\n    </td>\n    <td></td>\n    <td>\n      <span ng-if=\"!!PRData().lump_sum_discount_tax\" uib-tooltip=\"GST\">\n        ({{PRData().lump_sum_discount_tax | formatDecimal:2}})\n      </span>\n    </td>\n  </tr>\n\n  <!-- Total Amount with lump sum -->\n  <tr>\n    <td></td>\n    <td></td>\n    <td colspan=\"2\" class=\"text-left\">\n      <a ng-click=\"addLumpSum(0)\" ng-if=\"PRData().lump_sum_discount_entry === null && showLumpSumButton()\">\n        <small>Add lump sum discount</small>\n      </a>\n    </td>\n    <!-- Currency -->\n    <td> {{ PRData().currency.code }} </td>\n    <td>\n      <span uib-tooltip=\"Amount\">\n        {{ PRData().amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <!-- Discount Total -->\n      <span ng-if=\"!!PRData().discount_total || !!PRData().lump_sum_discount\" uib-tooltip=\"Discount\">\n        ({{ PRData().discount_total_with_lump_sum ? PRData().discount_total_with_lump_sum : PRData().discount_total | formatDecimal:2 }})\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"Total Amount\">\n        {{ !!PRData().discounted_amount_with_lump_sum ? PRData().discounted_amount_with_lump_sum :\n        PRData().discounted_amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"GST\">\n        <span ng-if=\"!!PRData().tax_total_with_lump_sum\">\n          {{ PRData().tax_total_with_lump_sum | formatDecimal:2 }}\n        </span>\n        <span ng-if=\"!PRData().tax_total_with_lump_sum\">\n          {{ PRData().tax_total | formatDecimal:2 }}\n        </span>\n      </span>\n    </td>\n  </tr>\n\n  <!-- Grand Total -->\n  <tr>\n    <td colspan=\"8\" class=\"text-right\"> Total amount inclusive of GST </td>\n    <td>\n      <span class=\"grand-total double-underlines\" uib-tooltip=\"Total amount inclusive of GST\">\n        {{ PRData().grand_total | formatDecimal:2 }}\n      </span>\n    </td>\n  </tr>\n\n  </tfoot>\n</table>\n\n<!-- Add button (red, circle, bottom right)-->\n<div class=\"add-item-scroll-fix\" ng-if=\"isPRCreator() || allowEditingPR() || canEditPR()\">\n  <button class=\"btn btn-circle btn-danger btn-lg\" uib-tooltip=\"Add an item\" ui-sref=\"main.user.purchaseRequisitions.details.catalog.tab\" ng-click=\"setLoading(\'addingItem\', true)\" id=\"prAddItemButtonCircle\">\n    {{ checkLoading(\'addingItem\') ? \"...\" : \"\" }}\n    <i ng-hide=\"checkLoading(\'addingItem\')\" class=\"fa fa-plus\"></i>\n  </button>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/itemList/prItemList.NonEditableTemplate-mobile.html","<div class=\"overlay\" ng-show=\"checkLoading(\'lineItemTable\')\">\n  <div id=\"loading-img\"></div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row\" style=\"overflow: auto\">\n\n    <div class=\"panel panel-default\" style=\"margin-bottom: 5px\">\n      <table class=\"table table-bordered table-striped table-condensed table-responsive fixed-table-mobile\">\n        <thead>\n        <tr>\n          <th class=\"text-left-align\">Item</th>\n          <th> Qty</th>\n          <th> Unit Price</th>\n          <th> Amount</th>\n        </tr>\n        </thead>\n\n        <tbody>\n        <tr ng-if=\"!PRData().pr_items || !PRData().pr_items.length\">\n          <td colspan=\"4\">\n            <span ng-if=\"!!PRData().cost_center\">There are no items.</span>\n          </td>\n        </tr>\n\n        <tr ng-repeat-start=\"item in PRData().pr_items track by $index\" class=\"animate-repeat\">\n          <td class=\"text-left-align\">\n            <span ng-if=\"item.item_details.is_stock === 0\" class=\"label label-danger pull-right\">Non Catalog</span>\n            <span ng-if=\"!!item.item_details.is_stock && !!item.item_details.is_partial\" class=\"label label-warning pull-right\">\n              Partial Item\n            </span>\n            <span ng-if=\"item.supplier.status === \'BLACK_LISTED\'\" class=\"label label-blacklist pull-right\">\n              Supplier Blacklisted\n            </span>\n            <p>\n              <item-details details=\"item\" img-path=\"imageBasePath\" enable-starring=\"false\" class=\"clicked-link\">\n                {{ $index + 1 }}. {{item.item_details.item_name}}\n              </item-details>\n            </p>\n            <p>\n              <text-show-less-more model=\"item.item_details.description\" type=\"words\" class=\"limit-lines\">\n              </text-show-less-more>\n            </p>\n            <p>\n              <script type=\"text/ng-template\" id=\"supplierTooltip\">\n                <div>\n                  {{item.supplier.descr}}\n                  <br> Contact Person: {{ item.supplier.contact_person.first_name ?\n                  item.supplier.contact_person.first_name : \'Not available\' }}\n                  <br> Email: {{item.supplier.contact_person.email ?\n                  item.supplier.contact_person.email : \'Not available\'}}\n                  <br> Phone: {{item.supplier.phone ? item.supplier.phone : \'Not available\'}}\n                  <br> Fax: {{item.supplier.fax ? item.supplier.fax : \'Not available\'}}\n                </div>\n              </script>\n              <b uib-tooltip-template=\"\'supplierTooltip\'\">\n                {{item.supplier.descr}}\n              </b>\n            </p>\n            <p ng-if=\"!!item.payment_term\">{{item.payment_term.descr}}</p>\n\n            <!-- Other Details (Needed by date, transportation, and so on) -->\n            <div class=\"row\" ng-if=\"checkOthersValue(item, \'needed_by_date\') || checkOthersValue(item, \'delivery_address\') ||\n               checkOthersValue(item, \'note\') || checkOthersValue(item, \'account_code\')\">\n              <!-- Needed by date -->\n              <div class=\"col-xs-11 col-sm-11 grey-border-top grey-border-bottom\" ng-show=\"checkOthersValue(item, \'needed_by_date\')\">\n                <b>Needed by date:</b> <br>\n                <span ng-show=\"!!item.needed_by_date\">{{ item.needed_by_date | date:\'dd MMM yyyy\' }}</span>\n              </div>\n\n              <!-- Delivery Address -->\n              <div ng-show=\"checkOthersValue(item, \'delivery_address\')\" class=\"col-xs-11 col-sm-11 grey-border-bottom\">\n                <b>Delivery Address:</b> <br>\n                <div ng-if=\"!!item.delivery_address\">\n                  <span class=\"address-text-format\">{{\n                    (item.delivery_address.line1.length ? item.delivery_address.line1 + \"\\n\": \"\") +\n                    (item.delivery_address.line2.length ? item.delivery_address.line2 + \"\\n\": \"\") +\n                    (item.delivery_address.line3.length ? item.delivery_address.line3 + \"\\n\": \"\") +\n                    (item.delivery_address.postal_code.length ? item.delivery_address.postal_code : \"\") +\n                    (item.delivery_address.length ? (item.delivery_address.length ? \" \" : \"\") +\n                    item.delivery_address.city + \"\\n\" : (item.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n                    (item.delivery_address.state.length ? item.delivery_address.state : \"\") +\n                    (item.delivery_address.country.length? (item.delivery_address.country.length ? \", \" : \"\") +\n                    item.delivery_address.country: \"\") }}\n                  </span>\n                </div>\n              </div>\n              <div ng-show=\"checkOthersValue(item, \'note\')\" ng-init=\"item.note_focus = !(checkOthersValue(item, \'note\'))\" class=\"col-xs-11 col-sm-11 grey-border-bottom\">\n                <b>Notes (Only for external):</b> <br>\n                <br>\n                {{ item.note }}\n              </div>\n\n              <!-- Waiting for the account code from issue 1413 -->\n              <!-- Account codes -->\n              <div ng-show=\"checkOthersValue(item, \'account_code\')\" class=\"col-xs-11 col-sm-11 grey-border-bottom\">\n                <b>Account Codes:</b> <br>\n                <div>\n                  {{ PRData().company.code + \':\' + PRData().cost_center.code + \':\' + item.account_code.code}}\n                </div>\n              </div>\n            </div>\n          </td>\n          <td>\n            {{ item.qty }} {{ item.UOM.code }}\n          </td>\n          <td>\n            <div ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n              {{ item.unit_price_pr_currency | formatDecimal: 4}}\n            </div>\n            <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              {{item.unit_price | isoCurrency: item.currency.code: 4}}\n            </div>\n          </td>\n          <td>\n            <div ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n              {{ item.amount_pr_currency | formatDecimal: 2 }}\n            </div>\n            <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              {{item.amount | formatDecimal: 2}}\n              <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">{{ item.currency.code }}</span>\n            </div>\n\n            <div class=\"mt-5\" ng-show=\"!!item.discount\">\n              <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_percentage ||\n                   !!differentCurrencyChecker(item.currency.code)\">\n                <em>Discount<br>({{item.discount_pr_currency | formatDecimal: 2}})</em>\n              </div>\n              <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n                <em>({{ item.discount | isoCurrency: item.currency.code: 2 }})</em>\n              </div>\n            </div>\n            <span ng-show=\"!item.addingDiscount\" class=\"item-edit-quantity\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n                <em>Discount<br></em>\n                <span ng-if=\"!!item.discount_percentage\">\n                  <em>({{ item.discount_entry }})</em>\n                </span>\n                <span ng-if=\"!item.discount_percentage\">\n                  <em>({{ item.discount_entry | isoCurrency: item.currency.code: 2}})</em>\n                </span>\n                <br>\n              </span>\n              <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n                <em>Discount <br></em>\n                <span ng-if=\"!!item.discount_percentage\">\n                  <em>({{ item.discount_entry }})</em>\n                </span>\n                <span ng-if=\"!item.discount_percentage\">\n                  <em>({{ item.discount_entry | formatDecimal: 2}})</em>\n                </span>\n                <br>\n              </span>\n            </span>\n\n            <div class=\"mt-5\">\n              <em>{{item.tax.code + \" \" + item.tax.rate + \"%\"}}</em>\n            </div>\n            <div ng-if=\"differentCurrencyChecker(item.currency.code)\">\n              <em>{{ item.tax.amount_pr_currency | formatDecimal: 2}}</em>\n            </div>\n            <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              <em>{{ item.tax.amount | formatDecimal: 2}}</em>\n              <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n                <em>{{ \' \' + item.currency.code }}</em>\n              </span>\n            </div>\n\n          </td>\n        </tr>\n\n        <!-- Freight -->\n        <tr ng-show=\"checkOthersValue(item, \'freights\')\">\n          <td>\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-sm-12 text-left\">\n                <b>Freight</b><br>\n                -Discount<br>\n                -GST\n                <span class=\"pull-right cursor-pointer\"></span>\n              </div>\n            </div>\n          </td>\n          <td></td>\n          <td></td>\n          <td style=\"text-align: right\">\n\n            <!-- Freight if percentage is true -->\n            <div ng-show=\"!!item.freights\">\n              <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n                {{item.freights.amount_pr_currency | formatDecimal: 2}}\n              </div>\n              <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n                {{ item.freights.amount | isoCurrency: item.currency.code : 2 }}\n              </div>\n            </div>\n            <span ng-if=\"!!item.freights.entry\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n                {{ item.freights.entry | formatDecimal: 2}}\n                <span ng-show=\"!item.freights.amount_percentage\">{{ \' \' + item.currency.code }}</span>\n              </span>\n              <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n                {{ item.freights.entry | formatDecimal: 2}}\n              </span>\n            </span>\n\n            <br>\n            <!-- Freight Discount value if percentage is true -->\n            <div ng-show=\"!!item.freights.entry\">\n              <div ng-show=\"!!item.freights\">\n                <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n                  ({{item.freights.discount_amount_pr_currency | formatDecimal: 2}})\n                </div>\n                <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n                  ({{ item.freights.discount_amount | isoCurrency: item.currency.code: 2 }})\n                </div>\n              </div>\n              <span ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!item.freights.addingFreightsDiscount\">\n                <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n                  <span ng-show=\"!!item.freights.discount_percentage\">\n                    ({{ item.freights.discount_entry | formatDecimal: 2}})\n                  </span>\n                  <span ng-show=\"!item.freights.discount_percentage\">\n                    ({{ item.freights.discount_entry | isoCurrency: item.currency.code : 2 }})\n                  </span>\n                </span>\n                <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n                  ({{ item.freights.discount_entry | formatDecimal: 2}})\n                </span>\n              </span>\n            </div>\n\n            <!-- Freight Tax value -->\n            <div ng-show=\"!!item.freights.entry\">\n              <!--<span>\n                {{(!!item.freights.tax && !!item.freights.tax._id) ?\n                (item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') : \'\'}}\n              </span>-->\n\n              <div ng-if=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.tax\">\n                {{ item.freights.tax.amount_pr_currency | formatDecimal: 2}}\n              </div>\n              <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.freights.tax\">\n                {{ item.freights.tax.amount | formatDecimal: 2}}\n                <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">{{ \' \' + item.currency.code }}</span>\n              </div>\n            </div>\n          </td>\n        </tr>\n\n        <!-- Transportation -->\n        <tr ng-show=\"checkOthersValue(item, \'transportation\')\">\n          <td>\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-sm-12 text-left\">\n                <b>Transportation</b><br>\n                -discount<br>\n                -GST\n                <span class=\"pull-right cursor-pointer\"></span>\n              </div>\n            </div>\n          </td>\n          <td></td>\n          <td></td>\n          <td style=\"text-align: right\">\n            <!-- Transportation if percentage is true -->\n            <div ng-show=\"!!item.transportation\">\n              <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n                {{item.transportation.amount_pr_currency | formatDecimal: 2}}\n              </div>\n              <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n                {{ item.transportation.amount | isoCurrency: item.currency.code : 2 }}\n              </div>\n            </div>\n\n            <span ng-show=\"!!item.transportation.entry\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n              <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n                {{ item.transportation.entry }}\n                <span ng-show=\"!item.transportation.amount_percentage\">{{ \' \' + item.currency.code }}</span>\n              </span>\n              <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n               {{ item.transportation.entry | formatDecimal: 2}}\n              </span>\n            </span>\n\n\n            <!-- Transportation discount -->\n            <br>\n            <div ng-show=\"!!item.transportation.entry\">\n              <!-- Discount value if percentage is true -->\n              <div ng-show=\"!!item.transportation\">\n                <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n                  ({{item.transportation.discount_amount_pr_currency | formatDecimal: 2}})\n                </div>\n                <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n                  ({{ item.transportation.discount_amount | isoCurrency : item.currency.code : 2 }})\n                </div>\n              </div>\n\n              <span ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!item.transportation.addingTransportationDiscount\">\n                <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n                  <span ng-show=\"!!item.transportation.discount_percentage\">({{ item.transportation.discount_entry | formatDecimal: 2}})</span>\n                  <span ng-show=\"!item.transportation.discount_percentage\">({{ item.transportation.discount_entry | isoCurrency: item.currency.code : 2}})</span>\n                </span>\n                <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n                  ({{ item.transportation.discount_entry | formatDecimal: 2}})\n                </span>\n              </span>\n            </div>\n\n            <!-- Transportation tax -->\n            <div ng-show=\"!!item.transportation.entry\">\n              <div ng-if=\"differentCurrencyChecker(item.currency.code) && !!item.transportation.tax\">\n                {{ item.transportation.tax.amount_pr_currency | formatDecimal: 2}}\n              </div>\n              <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.transportation.tax\">\n                {{ item.transportation.tax.amount | formatDecimal: 2}}\n                <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">{{ \' \' + item.currency.code }}</span>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr ng-repeat-end></tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<!--lump sum discount-->\n<div class=\"container-fluid\">\n  <div class=\"row\" style=\"overflow: auto\">\n    <div class=\"panel panel-default\" style=\"margin-bottom: 0px\">\n      <table class=\"table table-borderless table-condensed table-responsive\">\n        <tr ng-show=\"PRData().lump_sum_discount_entry !== null\">\n          <td>\n            <div class=\"col-xs-12 col-sm-12\">\n              <div class=\"row\">\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  <div>Lump sum discount</div>\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <!-- Discount value if percentage is true -->\n                  <div ng-if=\"!!PRData().lump_sum_discount_percentage\">\n                    ({{ PRData().lump_sum_discount | formatDecimal : 2 }})\n                  </div>\n                  <div>\n                    <span ng-show=\"!PRData().addingLumpSum\" uib-tooltip=\"Add lump sum\" class=\"item-edit-quantity\">\n                      {{ !!PRData().lump_sum_discount_entry ? \'(\' +  PRData().lump_sum_discount_entry + \')\' : \'\' }}\n                    </span>\n                  </div>\n                </div>\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  Lump sum discount(Tax)\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <div ng-if=\"!!PRData().lump_sum_discount_tax\" uib-tooltip=\"GST\">\n                    ({{PRData().lump_sum_discount_tax | formatDecimal:2}})\n                  </div>\n                </div>\n              </div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</div>\n\n<!-- Total Amount with lumpsum-->\n<div class=\"container-fluid\">\n  <div class=\"row\" style=\"overflow: auto\">\n    <div class=\"panel panel-default\" style=\"margin-bottom: 0px\">\n      <table class=\"table table-borderless table-condensed table-responsive\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"col-xs-12 col-sm-12\">\n              <div class=\"row\">\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  <div>Subtotal</div>\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <div style=\"text-align: right; font-size: 1em\">\n                    <span uib-tooltip=\"Amount\">{{ PRData().amount | formatDecimal:2 }}</span>\n                  </div>\n                </div>\n              </div>\n\n              <!-- Discount -->\n              <div class=\"row\">\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  <div>Discount</div>\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <div style=\"text-align: right; font-size: 1em\">\n                    <span ng-if=\"!!PRData().discount_total || !!PRData().lump_sum_discount\" uib-tooltip=\"Discount\">\n                      ({{ PRData().discount_total_with_lump_sum ? PRData().discount_total_with_lump_sum :\n                      PRData().discount_total | formatDecimal:2 }})\n                    </span>\n                  </div>\n                </div>\n              </div>\n\n              <!-- GST -->\n              <div class=\"row\">\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  <div>GST</div>\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <div style=\"text-align: right; font-size: 1em\">\n                    <span ng-if=\"!!PRData().tax_total_with_lump_sum\">\n                      {{ PRData().tax_total_with_lump_sum | formatDecimal:2 }}\n                    </span>\n                    <span ng-if=\"!PRData().tax_total_with_lump_sum\">\n                      {{ PRData().tax_total | formatDecimal:2 }}\n                    </span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </td>\n        </tr>\n\n        <!-- Grand Total -->\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"col-xs-12 col-sm-12\">\n              <div class=\"row\">\n                <div class=\"col-xs-8 col-sm-8 no-padding\" style=\"text-align: left\">\n                  <div class=\"grand-total\">Total amount inclusive of GST ({{ PRData().currency.code }})</div>\n                </div>\n                <div class=\"col-xs-4 col-sm-4 no-padding\" style=\"text-align: right\">\n                  <div class=\"grand-total double-underlines\" style=\"text-align: right\">{{\n                    PRData().grand_total | formatDecimal:2 }}\n                  </div>\n                </div>\n              </div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/itemList/prItemList.NonEditableTemplate.html","<div class=\"overlay\" ng-show=\"checkLoading(\'lineItemTable\')\">\n  <div id=\"loading-img\"></div>\n</div>\n<table class=\"table screen-section\">\n  <colgroup>\n    <col class=\"column-image\">\n    <col class=\"column-item-details column-item-details-no-check-box\">\n    <col class=\"column-quantity\">\n    <col class=\"column-unit-price\">\n    <col class=\"column-amount\">\n  </colgroup>\n  <thead>\n  <tr>\n    <th colspan=\"2\" class=\"text-left-align\">Item</th>\n    <th> Qty </th>\n    <th> Unit Price </th>\n    <th> Amount </th>\n    <th> Discount </th>\n    <th> Total Amount </th>\n    <th> GST </th>\n  </tr>\n  </thead>\n\n  <tbody>\n  <tr ng-if=\"!PRData().pr_items || !PRData().pr_items.length\">\n    <td colspan=\"8\">\n      <span ng-if=\"!!PRData().cost_center\">There are no items.</span>\n    </td>\n  </tr>\n\n  <tr ng-repeat-start=\"item in PRData().pr_items track by $index\" class=\"animate-repeat\">\n    <td>\n      <div class=\"product-image-wrapper\">\n        <!-- todo: create directive to display image -->\n        <img class=\"img-responsive\" ng-if=\"!!item.item.img_url\" ng-src=\"{{ imageBasePath }}{{ item.item.img_url }}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item_details.item_name}}\">\n        <img ng-if=\"!item.item.img_url\" class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n      </div>\n    </td>\n\n    <!-- item or supplier status -->\n    <td class=\"text-left-align\">\n      <span ng-if=\"item.item_details.is_stock === 0\" class=\"label label-danger pull-right\">Non Catalog</span>\n      <span ng-if=\"!!item.item_details.is_stock && !!item.item_details.is_partial\" class=\"label label-warning pull-right\">\n        Partial Item\n      </span>\n      <span ng-if=\"item.supplier.status === \'BLACK_LISTED\'\" class=\"label label-blacklist pull-right\">\n        Supplier Blacklisted\n      </span>\n      <p>\n        <item-details details=\"item\" img-path=\"imageBasePath\" enable-starring=\"false\" class=\"clicked-link\">\n          {{ $index + 1 }}. {{item.item_details.item_name}}\n        </item-details>\n      </p>\n      <p>\n        <text-show-less-more model=\"item.item_details.description\" type=\"words\" class=\"limit-lines\">\n        </text-show-less-more>\n      </p>\n      <p>\n        <script type=\"text/ng-template\" id=\"supplierTooltip\">\n          <div>\n            {{item.supplier.descr}}\n            <br> Contact Person: {{ item.supplier.contact_person.first_name ?\n            item.supplier.contact_person.first_name : \'Not available\' }}\n            <br> Email: {{item.supplier.contact_person.email ?\n            item.supplier.contact_person.email : \'Not available\'}}\n            <br> Phone: {{item.supplier.phone ? item.supplier.phone : \'Not available\'}}\n            <br> Fax: {{item.supplier.fax ? item.supplier.fax : \'Not available\'}}\n          </div>\n        </script>\n        <b uib-tooltip-template=\"\'supplierTooltip\'\">\n          {{item.supplier.descr}}\n        </b>\n      </p>\n      <p ng-if=\"!!item.payment_term\">{{item.payment_term.descr}}</p>\n\n      <!-- Other Details (Needed by date, transportation, and so on) -->\n      <div class=\"row grey-border-top\" ng-if=\"checkOthersValue(item, \'needed_by_date\') || checkOthersValue(item, \'delivery_address\') ||\n               checkOthersValue(item, \'note\') || checkOthersValue(item, \'account_code\') ||\n               checkOthersValue(item, \'branch\')\">\n        <!-- Needed by date -->\n        <div class=\"col-md-12 grey-border-bottom\" ng-show=\"checkOthersValue(item, \'needed_by_date\')\">\n          <b>Needed by date:</b> &nbsp;\n          <span ng-show=\"!!item.needed_by_date\">\n            {{ item.needed_by_date | date:\'dd MMM yyyy\' }}\n          </span>\n        </div>\n\n        <!-- Supplier Branch -->\n        <div ng-show=\"checkOthersValue(item, \'branch\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Supplier Branch:</b>\n          <div ng-if=\"!!item.branch\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n              <b>Branch   :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n                {{(item.branch.descr + \" (\" + item.branch.code + \")\")}}\n            </div>\n            <br ng-if=\"item.branch.descr\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n              <b>Address :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n              {{\n              (item.branch.address.line1.length ? item.branch.address.line1 + \", \": \"\") +\n              (item.branch.address.line2.length ? item.branch.address.line2 : \"\")\n              }}\n              <br ng-if=\"item.branch.address.line1 || item.branch.address.line2\">\n              {{\n              (item.branch.address.line3.length ? item.branch.address.line3 + \",\": \"\") +\n              (item.branch.address.city.length ? item.branch.address.city : \"\")\n              }}\n              <br ng-if=\"item.branch.address.line3 || item.branch.address.city\">\n              {{ (item.branch.address.postal_code.length ? item.branch.address.postal_code + \",\" : \"\") +\n              (item.branch.address.state.length ? item.branch.address.state : \"\")\n              }}\n              <br ng-if=\"item.branch.address.postal_code || item.branch.address.state\">\n              {{\n              (item.branch.address.country.length? item.branch.address.country + \". \" : \"\")\n              }}\n              <br ng-if=\"item.branch.address.country\">\n            </div>\n            <br ng-if=\"item.branch.address._id\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n              <b>Phone   :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n              {{item.branch.phone.length ? item.branch.phone : \"Not Available\"}}\n            </div>\n            <br ng-if=\"item.branch.phone\">\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n              <b>Fax     :</b>\n            </div>\n            <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n              {{item.branch.fax.length ? item.branch.fax : \"Not Available\"}}\n            </div>\n            <br ng-if=\"item.branch.fax\">\n          </div>\n        </div>\n\n        <!-- Delivery Address -->\n        <div ng-show=\"checkOthersValue(item, \'delivery_address\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Delivery Address:</b>\n\n          <div ng-if=\"!!item.delivery_address\">\n            <span class=\"address-text-format\">{{\n              (item.delivery_address.line1.length ? item.delivery_address.line1 + \"\\n\": \"\") +\n              (item.delivery_address.line2.length ? item.delivery_address.line2 + \"\\n\": \"\") +\n              (item.delivery_address.line3.length ? item.delivery_address.line3 + \"\\n\": \"\") +\n              (item.delivery_address.postal_code.length ? item.delivery_address.postal_code : \"\") +\n              (item.delivery_address.length ? (item.delivery_address.length ? \" \" : \"\") +\n              item.delivery_address.city + \"\\n\" : (item.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n              (item.delivery_address.state.length ? item.delivery_address.state : \"\") +\n              (item.delivery_address.country.length? (item.delivery_address.country.length ? \", \" : \"\") +\n              item.delivery_address.country: \"\") }}\n            </span>\n          </div>\n        </div>\n        <div ng-show=\"checkOthersValue(item, \'note\')\" ng-init=\"item.note_focus = !(checkOthersValue(item, \'note\'))\" class=\"col-md-12 grey-border-bottom\">\n          <b>Notes (Only for external):</b>\n          <br>\n          {{ item.note }}\n        </div>\n\n        <!-- Waiting for the account code from issue 1413 -->\n        <!-- Account codes -->\n        <div ng-show=\"checkOthersValue(item, \'account_code\')\" class=\"col-md-12 grey-border-bottom\">\n          <b>Account Codes:</b>\n          <div>\n            {{ PRData().company.code + \':\' + PRData().cost_center.code + \':\' + item.account_code.code}}\n          </div>\n        </div>\n      </div>\n    </td>\n\n    <td>\n      {{ item.qty }} {{ item.UOM.code }}\n    </td>\n\n    <td>\n      <div ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.unit_price_pr_currency | formatDecimal: 4}}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        {{item.unit_price | isoCurrency: item.currency.code: 4}}\n      </div>\n    </td>\n\n    <td>\n      <div ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.amount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        {{item.amount | formatDecimal: 2}}\n        <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n          {{ item.currency.code }}\n        </span>\n      </div>\n    </td>\n\n    <td>\n      <!-- Discount value if percentage is true -->\n      <div ng-show=\"!!item.discount\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          ({{item.discount_pr_currency | formatDecimal: 2}})\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          ({{ item.discount | isoCurrency: item.currency.code: 2 }})\n        </div>\n      </div>\n      <!-- discount -->\n      <span ng-show=\"!item.addingDiscount\" class=\"item-edit-quantity\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n          <span ng-if=\"!!item.discount_percentage\">\n           ({{ item.discount_entry }})\n          </span>\n           <span ng-if=\"!item.discount_percentage\">\n          ({{ item.discount_entry | isoCurrency: item.currency.code: 2}})\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.discount_entry\">\n          <span ng-if=\"!!item.discount_percentage\">\n           ({{ item.discount_entry }})\n          </span>\n           <span ng-if=\"!item.discount_percentage\">\n          ({{ item.discount_entry | formatDecimal: 2}})\n          </span>\n        </span>\n      </span>\n    </td>\n\n    <td>\n      <div> {{ item.amount_with_discount_pr_currency | formatDecimal: 2 }} </div>\n      <div ng-if=\"!!differentCurrencyChecker(item.currency.code)\" class=\"grey-text\">\n        {{ item.amount_with_discount | isoCurrency: item.currency.code: 2  }}\n      </div>\n    </td>\n\n    <td>\n      <div class=\"btn-group\" role=\"group\" ng-if=\"!!item.unit_price\">\n        <div>\n          {{item.tax.code + \" \" + item.tax.rate + \"%\"}}\n        </div>\n        <div ng-if=\"differentCurrencyChecker(item.currency.code)\">\n          {{ item.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n          {{ item.tax.amount | formatDecimal: 2}}\n          <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </div>\n\n        <div>\n          <button ng-click=\"removeTax(item, $index)\" ng-show=\"(!!item.tax && !!item.tax._id) && item.is_stock === 0\" class=\"btn btn-white btn-xs\">\n            <i class=\"fa fa-trash\" title=\"Delete Tax\"></i>\n          </button>\n        </div>\n      </div>\n\n    </td>\n  </tr>\n\n  <!-- Freight -->\n  <tr ng-show=\"checkOthersValue(item, \'freights\')\" class=\"tr-freight-transportation\">\n    <td></td>\n    <td>\n      <div class=\"row\">\n        <div class=\"col-md-12 text-left\">\n          <b>Freight</b>\n          <span class=\"pull-right cursor-pointer\">\n        </span>\n        </div>\n      </div>\n    </td>\n    <td colspan=\"2\"></td>\n    <td>\n\n      <!-- Freight if percentage is true -->\n      <div ng-show=\"!!item.freights\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          {{item.freights.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          {{ item.freights.amount | isoCurrency: item.currency.code : 2 }}\n        </div>\n      </div>\n\n      <span ng-if=\"!!item.freights.entry\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n          {{ item.freights.entry }}\n          <span ng-show=\"!item.freights.amount_percentage\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.entry\">\n          {{ item.freights.entry }}\n        </span>\n      </span>\n\n    </td>\n\n    <!-- Freight Discount -->\n    <td>\n      <div ng-show=\"!!item.freights.entry\">\n\n        <!-- Discount value if percentage is true -->\n        <div ng-show=\"!!item.freights\">\n          <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n            ({{item.freights.discount_amount_pr_currency | formatDecimal: 2}})\n          </div>\n          <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.freights.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n            ({{ item.freights.discount_amount | isoCurrency: item.currency.code: 2 }})\n          </div>\n        </div>\n\n        <span ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!item.freights.addingFreightsDiscount\">\n          <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n            <span ng-show=\"!!item.freights.discount_percentage\">\n              ({{ item.freights.discount_entry }})\n            </span>\n            <span ng-show=\"!item.freights.discount_percentage\">\n              ({{ item.freights.discount_entry | isoCurrency: item.currency.code : 2 }})\n            </span>\n          </span>\n          <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.freights.discount_entry\">\n            ({{ item.freights.discount_entry }})\n          </span>\n        </span>\n\n      </div>\n    </td>\n    <!-- Freight Amount -->\n    <td>\n      <div ng-show=\"!!item.freights.amount\">\n        {{ item.freights.amount_with_discount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.freights.amount_with_discount | isoCurrency: item.currency.code : 2 }}\n      </div>\n    </td>\n    <!-- Freight Tax -->\n    <td>\n      <div ng-show=\"!!item.freights.entry\">\n        <span>\n          {{(!!item.freights.tax && !!item.freights.tax._id) ?\n          (item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') : \'\'}}\n        </span>\n\n        <div ng-if=\"!!differentCurrencyChecker(item.currency.code) && !!item.freights.tax\">\n          {{ item.freights.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.freights.tax\">\n          {{ item.freights.tax.amount | formatDecimal: 2}}\n          <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </div>\n      </div>\n    </td>\n  </tr>\n\n  <!-- Transportation -->\n  <tr ng-repeat-end ng-show=\"checkOthersValue(item, \'transportation\')\" class=\"tr-freight-transportation\">\n    <td></td>\n    <td>\n      <div class=\"row\">\n        <div class=\"col-md-12 text-left\">\n          <b>Transportation</b>\n          <span class=\"pull-right cursor-pointer\">\n        </span>\n        </div>\n      </div>\n    </td>\n    <td colspan=\"2\"></td>\n    <td>\n\n      <!-- Transportation if percentage is true -->\n      <div ng-show=\"!!item.transportation\">\n        <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.amount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n          {{item.transportation.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.amount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n          {{ item.transportation.amount | isoCurrency: item.currency.code : 2 }}\n        </div>\n      </div>\n\n      <span ng-show=\"!!item.transportation.entry\" ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\">\n        <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n          {{ item.transportation.entry }}\n          <span ng-show=\"!item.transportation.amount_percentage\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </span>\n        <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.entry\">\n          {{ item.transportation.entry }}\n        </span>\n      </span>\n    </td>\n\n    <!-- Transportation Discount -->\n    <td>\n      <div ng-show=\"!!item.transportation.entry\">\n        <!-- Discount value if percentage is true -->\n        <div ng-show=\"!!item.transportation\">\n          <div ng-if=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_percentage ||\n                  !!differentCurrencyChecker(item.currency.code)\">\n            ({{item.transportation.discount_amount_pr_currency | formatDecimal: 2}})\n          </div>\n          <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!item.transportation.discount_percentage && !!differentCurrencyChecker(item.currency.code)\">\n            ({{ item.transportation.discount_amount | isoCurrency : item.currency.code : 2 }})\n          </div>\n        </div>\n\n        <span ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!item.transportation.addingTransportationDiscount\">\n          <span ng-show=\"!!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n                        <span ng-show=\"!!item.transportation.discount_percentage\">\n            ({{ item.transportation.discount_entry }})\n                          </span>\n            <span ng-show=\"!item.transportation.discount_percentage\">\n              ({{ item.transportation.discount_entry | isoCurrency: item.currency.code : 2}})\n            </span>\n          </span>\n            <span ng-show=\"!differentCurrencyChecker(item.currency.code) && !!item.transportation.discount_entry\">\n            ({{ item.transportation.discount_entry }})\n          </span>\n        </span>\n      </div>\n    </td>\n    <!-- transportation Amount -->\n    <td>\n      <div ng-show=\"!!item.transportation.amount\">\n        {{ item.transportation.amount_with_discount_pr_currency | formatDecimal: 2 }}\n      </div>\n      <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-show=\"!!differentCurrencyChecker(item.currency.code)\">\n        {{ item.transportation.amount_with_discount | isoCurrency: item.currency.code : 2 }}\n      </div>\n    </td>\n    <!-- transportation Tax -->\n    <td>\n      <div ng-show=\"!!item.transportation.entry\">\n        <span>\n          {{(!!item.transportation.tax && !!item.transportation.tax._id) ?\n          (item.transportation.tax.code + \' \' + item.transportation.tax.rate + \'%\') : \'\'}}\n        </span>\n\n        <div ng-if=\"differentCurrencyChecker(item.currency.code) && !!item.transportation.tax\">\n          {{ item.transportation.tax.amount_pr_currency | formatDecimal: 2}}\n        </div>\n        <div ng-class=\"{ \'grey-text\': !!differentCurrencyChecker(item.currency.code)}\" ng-if=\"!!item.transportation.tax\">\n          {{ item.transportation.tax.amount | formatDecimal: 2}}\n          <span ng-if=\"!!differentCurrencyChecker(item.currency.code)\">\n            {{ \' \' + item.currency.code }}\n          </span>\n        </div>\n      </div>\n    </td>\n  </tr>\n  </tbody>\n\n  <!-- Total -->\n  <tfoot ng-if=\"!!PRData().pr_items && !!PRData().pr_items.length\">\n\n  <!-- Total Amount, discount and tax -->\n  <tr ng-show=\"PRData().lump_sum_discount_entry !== null\">\n    <td colspan=\"3\"></td>\n    <!-- Currency -->\n    <td> {{ PRData().currency.code }} </td>\n    <td>\n      <span uib-tooltip=\"Amount\">\n        {{ PRData().amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <!-- Discount Total -->\n      <span ng-if=\"!!PRData().discount_total\" uib-tooltip=\"Discount\">\n        ({{ PRData().discount_total | formatDecimal:2 }})\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"Total Amount\">\n        {{ PRData().discounted_amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"GST\">\n        {{ PRData().tax_total | formatDecimal:2 }}\n      </span>\n    </td>\n  </tr>\n\n  <!-- Lump Sum Discount-->\n  <tr ng-show=\"PRData().lump_sum_discount_entry !== null\">\n    <td></td>\n    <td colspan=\"4\" class=\"text-left\">\n      <small class=\"table-padding text-black\">Lump sum discount</small>\n    </td>\n    <td>\n      <!-- Discount value if percentage is true -->\n      <div ng-if=\"!!PRData().lump_sum_discount_percentage\">\n        <small> ({{ PRData().lump_sum_discount | formatDecimal : 2 }})</small>\n      </div>\n      <div>\n        <small>\n          <span ng-show=\"!PRData().addingLumpSum\" uib-tooltip=\"Add lump sum\" class=\"item-edit-quantity\">\n            {{ !!PRData().lump_sum_discount_entry ? \'(\' +  PRData().lump_sum_discount_entry + \')\' : \'\' }}\n          </span>\n        </small>\n      </div>\n    </td>\n    <td></td>\n    <td ng-if=\"!!PRData().lump_sum_discount_tax\" uib-tooltip=\"GST\">\n      ({{PRData().lump_sum_discount_tax | formatDecimal:2}})\n    </td>\n  </tr>\n\n  <!-- Total Amount with lumpsum -->\n  <tr>\n    <td colspan=\"3\"></td>\n    <!-- Currency -->\n    <td> {{ PRData().currency.code }} </td>\n    <td>\n      <span uib-tooltip=\"Amount\">\n        {{ PRData().amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <!-- Discount Total -->\n      <span ng-if=\"!!PRData().discount_total || !!PRData().lump_sum_discount\" uib-tooltip=\"Discount\">\n        ({{ PRData().discount_total_with_lump_sum ? PRData().discount_total_with_lump_sum :\n        PRData().discount_total | formatDecimal:2 }})\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"Total Amount\">\n        {{ !!PRData().discounted_amount_with_lump_sum ? PRData().discounted_amount_with_lump_sum :\n        PRData().discounted_amount | formatDecimal:2 }}\n      </span>\n    </td>\n    <td>\n      <span uib-tooltip=\"GST\">\n        <span ng-if=\"!!PRData().tax_total_with_lump_sum\">\n          {{ PRData().tax_total_with_lump_sum | formatDecimal:2 }}\n        </span>\n        <span ng-if=\"!PRData().tax_total_with_lump_sum\">\n          {{ PRData().tax_total | formatDecimal:2 }}\n        </span>\n      </span>\n    </td>\n  </tr>\n\n  <!-- Grand Total -->\n  <tr>\n    <td colspan=\"7\" class=\"text-right\"> Total amount inclusive of GST </td>\n    <td>\n      <span class=\"grand-total double-underlines\" uib-tooltip=\"Total amount inclusive of GST\">\n        {{ PRData().grand_total | formatDecimal:2 }}\n      </span>\n    </td>\n  </tr>\n\n  </tfoot>\n</table>\n");
$templateCache.put("components/purchaseRequisitionComponents/nonCatalog/nonCatalogItemTemplate.html","<div class=\"inmodal non-catalog\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">×</button>\n    <h4 class=\"modal-title non-catalog-item-name\" ng-if=\"!editingState\">\n      Add a non catalog item\n    </h4>\n    <h4 class=\"modal-title non-catalog-item-name\" ng-if=\"editingState\">\n      Edit non catalog item\n    </h4>\n  </div>\n\n  <div class=\"panel-body\">\n    <fieldset class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          Name: <span class=\"asterisk-required\">*</span>\n        </label>\n        <div class=\"col-sm-9\">\n          <input name=\"nonCatalogName\" ng-class=\"{\'highlight-error-input\': (!nonCatalog.item_details.item_name && formSubmitted)}\" ng-model=\"nonCatalog.item_details.item_name\" id=\"nonCatalog.name\" class=\"form-control\" required>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          Description: <span class=\"asterisk-required\">*</span>\n        </label>\n        <div class=\"col-sm-9\">\n          <textarea name=\"description\" ng-model=\"nonCatalog.item_details.description\" id=\"nonCatalog.description\" required ng-class=\"{\'highlight-error-input\': (!nonCatalog.item_details.description.length && formSubmitted)}\" class=\"form-control\">\n          </textarea>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">UOM: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9\">\n          <input id=\"nonCatalog.uom\" type=\"text\" typeahead-on-select=\"validUOMIsSelected = true; onUOMSelect($item)\" placeholder=\"Type to search (min. 2 characters)\" class=\"form-control\" required ng-change=\"validUOMIsSelected = false\" ng-class=\"{\'highlight-error-input\': (!nonCatalog.UOM._id && formSubmitted)}\" typeahead-focus-first uib-typeahead=\"uom.code + \' < \' + uom.descr + \' > \' for uom in searchUOM($viewValue)\" ng-model=\"nonCatalog.UOMText\" typeahead-wait-ms=\"500\" aria-autocomplete=\"list\" typeahead-min-length=\"2\" ng-blur=\"validationUOMSelection(nonCatalog.UOMText)\">\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"!editingState\">\n        <label class=\"col-sm-3 control-label\">\n          Quantity: <span class=\"asterisk-required\">*</span>\n        </label>\n        <div class=\"col-sm-9\">\n          <input name=\"itemQuantity\" ng-model=\"nonCatalog.qty\" ng-pattern-restrict=\"^[0-9]{0,}[.]?[0-9]{0,}$\" id=\"nonCatalog.quantity\" class=\"form-control\" ng-trim=\"false\" required ng-class=\"{\'highlight-error-input\': ((!nonCatalog.qty || nonCatalog.qty ==0) && formSubmitted)}\">\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"nonCatalog.supplier_id\" class=\"col-sm-3 control-label\">\n          Supplier: <span class=\"asterisk-required\">*</span>\n        </label>\n        <div class=\"col-sm-9 searchfield non-item-search-supplier\">\n          <input type=\"text\" typeahead-on-select=\"validSupplierIsSelected = true; onSupplierSelect($item); formatModel($model)\" id=\"nonCatalog.supplier_id\" placeholder=\"Type to search (min. 3 characters)\" class=\"form-control\" required ng-change=\"validSupplierIsSelected = false\" ng-class=\"{\'highlight-error-input\': (!nonCatalog.supplierName.length && formSubmitted) || invalidSupplierSelected}\" typeahead-focus-first uib-typeahead=\"(supplier.descr + \' ( \' + supplier.reg_no + \' )\' +\n              \'<span class=\\\'label label-\' + supplier.labelStatus + \' supplier-status-tag pull-right\\\'>\' +\n              ((supplier.status.toLowerCase() === \'black_listed\' ? \'Black Listed\'\n              : supplier.status.toLowerCase() === \'active\' ? \'\' : supplier.status.toLowerCase() | capitalize)))\n              + \'</span>\'\n              for supplier in searchSuppliers($viewValue)\" ng-model=\"nonCatalog.supplierName\" typeahead-wait-ms=\"500\" aria-autocomplete=\"list\" typeahead-min-length=\"3\" ng-blur=\"validationSupplierSelection(nonCatalog.supplierName)\">\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"!editingState\">\n        <label class=\"col-sm-3 control-label\">Tax: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9\">\n          <span ng-class=\"{\'highlight-error-input\': (!nonCatalog.tax._id && formSubmitted)}\">\n            <ui-select ng-model=\"nonCatalog.tax\">\n              <ui-select-match placeholder=\"Select a Tax\">\n                {{$select.selected.name || $select.selected.code +\n                (!!$select.selected.descr ? \' - \' + $select.selected.descr : \"\")}}\n              </ui-select-match>\n              <ui-select-choices refresh-delay=\"0\" repeat=\"tax in taxesList | filter: $select.search track by $index \">\n                <span ng-bind-html=\"tax.code  + (!!tax.descr ? \' - \' + tax.descr : \'\') |\n                  highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"supplierPartNo\" class=\"col-sm-3 control-label\">Supplier Part Number: </label>\n        <div class=\"col-sm-9\">\n          <input name=\"supplierPartNo\" ng-model=\"nonCatalog.item_details.supplier_part_no\" id=\"supplierPartNo\" class=\"form-control\" placeholder=\"Enter a Supplier Part Number for this Item\">\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">Commodity Code: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9\">\n          <div class=\"row\">\n            <div class=\"col-md-12 input-group searchfield non-item-search-supplier\">\n              <input id=\"nonCatalog.commodity_code\" ng-class=\"{\'highlight-error-input\': (!nonCatalog.commodity_code._id && formSubmitted)}\" type=\"text\" ng-model=\"commodityKeyword\" class=\"form-control\" ng-change=\"nonCatalog.commodity_code = undefined\" ng-enter=\"searchCommodityCode(this.commodityKeyword); closeTreeSearch=false\" placeholder=\"Search Commodity Code (Press enter to search)\">\n              <span class=\"input-group-addon\" ng-click=\"searchCommodityCode(this.commodityKeyword); closeTreeSearch=false\">\n                <i class=\"fa fa-search\" ng-class=\"{true:\'fa-spinner fa-spin\', false:\'fa-search\'}[commoditySearching]\"></i>\n              </span>\n            </div>\n            <div class=\"col-md-12\">\n              <input tree-selection ng-model=\"nonCatalog.commodity_code\" title=\"commodityKeyword\" level=\"commodityLevel\" required data=\"commodityCodes\" action=\"openChildCommodityCode\" selectable=\"commodity.selectable\" close-tree-search=\"closeTreeSearch\">\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">Currency: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9\" id=\"prSelectCurrencyType\">\n          <span ng-class=\"{\'highlight-error-input\': (!nonCatalog.currency._id && formSubmitted)}\">\n            <ui-select ng-model=\"nonCatalog.currency\" theme=\"bootstrap\" on-select=\"onSelectedCurrency(nonCatalog.currency)\">\n              <ui-select-match placeholder=\"Select a currency\">\n                {{$select.selected.name || $select.selected.code +\n                (!!$select.selected.descr ? \' - \' + $select.selected.descr : \"\")}}\n              </ui-select-match>\n              <ui-select-choices refresh-delay=\"0\" repeat=\"c in getCurrencyList() | filter: $select.search\">\n                <span ng-bind-html=\"c.code  + (!!c.descr ? \' - \' + c.descr : \'\') |\n                  highlight: $select.search\">\n                </span>\n              </ui-select-choices>\n            </ui-select>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"!editingState\">\n        <label class=\"col-sm-3 control-label\">Unit Price: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9\">\n          <input ng-class=\"{\'highlight-error-input\': (!nonCatalog.unit_price && nonCatalog.unit_price !== 0) && formSubmitted}\" name=\"unitPrice\" ng-model=\"nonCatalog.unit_price\" id=\"nonCatalog.unit_price\" class=\"form-control\" only-number=\"nonCatalog.unitPrice\" ng-pattern-restrict=\"^\\d{0,17}(\\.\\d{0,4})?$\" ng-trim=\"false\" ng-maxlength=\"17\">\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">Payment Terms: <span class=\"asterisk-required\">*</span></label>\n        <div class=\"col-sm-9 m-b\">\n          <span ng-class=\"{\'highlight-error-input\': (!nonCatalog.payment_term._id && formSubmitted)}\">\n            <ui-select ng-model=\"nonCatalog.payment_term\">\n              <ui-select-match placeholder=\"Select Payment Term...\">\n                {{$select.selected.descr}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"paymentTerm in paymentTermsList | filter: $select.search\">\n                <span ng-bind-html=\"paymentTerm.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\">\n          Item image\n        </label>\n        <div class=\"col-sm-9\">\n          <div class=\"col-sm-12 pt-10\">\n            <input type=\"file\" file-model=\"nonCatalog.image\" accept=\"image/*\">\n            <small ng-show=\"editingState\">Upload new Image to replace</small>\n          </div>\n        </div>\n      </div>\n\n    </fieldset>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-white\" ng-click=\"close()\">Close</button>\n    <input id=\"prAddToCart\" type=\"submit\" ng-if=\"!editingState\" ng-disabled=\"!!submitted\" ng-click=\"submitNonCatalogItem(\'create\')\" class=\"btn btn-primary\" value=\"Add to cart\">\n    <input type=\"submit\" ng-disabled=\"!!submitted\" ng-if=\"!!editingState\" ng-click=\"submitNonCatalogItem(\'update\', nonCatalog)\" class=\"btn btn-primary\" value=\"Save changes\">\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/prHeader/purchaseRequisitionHeaderTemplate-mobile.html","<div class=\"row\">\n  <span class=\"pr-title-disable pr-header-prtitle-mobile\" ng-if=\"editingState !== \'editable\'\" ng-class=\"{\'margin-title-access-directly\': action == \'access_directly\'|| !access_status}\">\n    {{ PR.title || \'Click to edit\' }}\n  </span>\n</div>\n<div class=\"row\">\n  <div style=\"padding-top: 3px\">\n    <div class=\"col-xs-8 col-sm-8\" style=\"padding-left: 0px\">\n      <span id=\"prNumberSpan\" class=\"pr-id pr-header-prid-mobile\">\n        {{PR.reference }}\n      </span>\n      <i ng-if=\"!PR.is_deleted\" id=\"starPR\" ng-click=\"starringPR(PR, checkStarred(PR))\" ng-attr-class=\"{{checkStarred(PR) && \'fa fa-2x fa-star is_starred detail-star-hover cursor-pointer\' ||\n         \'fa fa-2x fa-star-o is_starred detail-star-hover-o cursor-pointer\'}}\">\n      </i>\n\n      <span class=\"sr-only\" ng-click=\"starred(requisition)\">\n        {{ pr.starred && \'Starred\' || \'Not starred\' }}\n      </span>\n\n    </div>\n  </div>\n  <div class=\"col-xs-4 col-sm-4\" style=\"text-align: right\">\n    <span class=\"pr-status-access-directly status-label\">\n      {{PR.status.toLocaleLowerCase() === \"draft\"? \"\":\n      PR.status.toLocaleLowerCase() === \"pending\"? \"Pending\":\n      PR.status.toLocaleLowerCase() === \"approved\"? \"Approved\":\n      PR.status.toLocaleLowerCase() === \"rejected\"? \"Rejected\":\n      PR.status.toLocaleLowerCase() === \"on_hold\"? \"On-Hold\":\n      PR.status.toLocaleLowerCase() === \"deleted\"? \"Deleted\":\n      PR.status.toLocaleLowerCase() === \"withdrawn\"? \"Withdrawn\": pr.status\n      }}\n    </span>\n  </div>\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/prHeader/purchaseRequisitionHeaderTemplate.html","<span class=\"back-buttons\">\n  <a ng-if=\"isShoppingMode()\" ng-click=\"back()\" class=\"btn btn-default\">\n    <i class=\"fa fa-chevron-left\"></i> Back to PR\n  </a>\n  <a ng-if=\"!isShoppingMode()\" ng-click=\"back()\" id=\"backToListingPR\" class=\"btn btn-default\">\n    <i class=\"fa fa-chevron-left\"></i> Back\n  </a>\n</span>\n\n<!--PR title-->\n<span class=\"pr-title-disable\" ng-if=\"editingState !== \'editable\'\" ng-class=\"{\'margin-title-access-directly\': action == \'access_directly\'|| !access_status}\">\n  <text-show-less-more model=\"PR.title\" type=\"words\" length=\"10\" class=\"limit-lines\">\n  </text-show-less-more>\n</span>\n\n<span id=\"prTitleSpan\" class=\"pr-title\" ng-class=\"{\'highlight-error-input\': !PR.title.length}\" editable-text=\"PR.title\" e-style=\"font-size: 20px;\n           width: 500px;\n           max-height: 25px\" e-required e-maxlength=\"120\" e-placeholder=\"PR title\" ng-model=\"PR.title\" e-id=\"prTitleInput\" buttons=\"no\" blur=\"submit\" ng-if=\"editingState === \'editable\'\" onaftersave=\"updatePRTitle(PR.title)\">\n  <text-show-less-more model=\"PR.title\" type=\"character\" length=\"64\" class=\"limit-lines\">\n  </text-show-less-more>\n  <a class=\"btn\">\n    Edit PR Title\n  </a>\n</span>\n\n<i ng-if=\"!PR.is_deleted\" id=\"starPR\" ng-click=\"starringPR(PR, checkStarred(PR))\" ng-attr-class=\"{{\n     checkStarred(PR) && \'fa fa-2x fa-star is_starred detail-star-hover cursor-pointer\' ||\n     \'fa fa-2x fa-star-o is_starred detail-star-hover-o cursor-pointer\'\n   }}\">\n</i>\n\n<span class=\"sr-only\" ng-click=\"starred(requisition)\">\n  {{ pr.starred && \'Starred\' || \'Not starred\' }}\n</span>\n\n<span id=\"prNumberSpan\" class=\"pr-id\">{{ PR.reference }}</span>\n\n  <span ng-if=\"PR.status.toLowerCase() === \'deleted\'\" class=\"deletedPR\">Deleted</span>\n\n<!-- Revision -->\n<span class=\"dropdown revision\" ng-if=\"!!PRData().revisions && PRData().revisions.length && PRData().status !== \'draft\'\">\n  <span class=\"dropdown-toggle\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\n    Revision {{PRData().revisions.length}}\n    <span class=\"fa fa-caret-down\"></span>\n  </span>\n  <ul class=\"dropdown-menu\" aria-labelledby=\"dropdownMenu1\">\n    <li ng-repeat=\"revision in PRData().revisions | reverse track by $index\">\n      <a ng-if=\"!$last\" ng-click=\"openRevision(PRData(), revision.value, ($index + PRData().revisions.length - ($index * 2) - 1))\">\n        Revision {{ $index + PRData().revisions.length - ($index * 2) - 1 }}\n      </a>\n      <a ng-if=\"$last\" ng-click=\"openRevision(PRData(), revision.value, ($index + PRData().revisions.length - ($index * 2) - 1))\">\n        Original\n      </a>\n    </li>\n  </ul>\n</span>\n\n<!--Calling shopping cart directive for screen section-->\n<shopping-cart pr-billing=\"PRData().billing\" grand-total-amount=\"((PRData().amount - (PRData().discount_total + PRData().lump_sum_discount)) + PRData().tax_total)\" update-quantity=\"updateQuantity\" remove-item=\"removeItem\" open-line-item-details=\"openLineItemDetails\" editing-state=\"editingState\" pr-currency=\"PRData().currency\">\n</shopping-cart>\n\n<!--directly status-->\n<span class=\"pull-right pr-status-access-directly clear-floating-right\">\n  {{ PR.status.toLocaleLowerCase() === \"draft\"? \"\":\n  PR.status.toLocaleLowerCase() === \"pending\"? \"Pending Approval\":\n  PR.status.toLocaleLowerCase() === \"approved\"? \"Approved\":\n  PR.status.toLocaleLowerCase() === \"rejected\"? \"Rejected\":\n  PR.status.toLocaleLowerCase() === \"on_hold\"? \"On-Hold\":\n  PR.status.toLocaleLowerCase() === \"deleted\"? \"Deleted\":\n  PR.status.toLocaleLowerCase() === \"withdrawn\"? \"Withdrawn\": pr.status }}\n</span>\n");
$templateCache.put("components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/catalog.html","<div class=\"col-xs-12\">\n\n  <span ng-show=\"catalogDisplayHandler !== \'showCategories\'\">\n    <embedded-pagination-service list=\"$parent.catalogList\" service=\"$parent.itemsService\" meta=\"$parent.meta\" params-source=\"$parent.paramsSource\" offset=\"20\">\n    </embedded-pagination-service>\n  </span>\n\n  <div style=\"clear:both\"></div>\n  <div class=\"p-t-5\">\n    <div ng-if=\"searchActivated && meta.cursor.count === 0\">\n      <p>Found 0 results.\n        <a non-catalog-item requisition=\"PR\">\n          Create a non catalog item.\n        </a>\n      </p>\n    </div>\n\n    <div ng-if=\"searchActivated && meta.cursor.count > 0\">\n      <p>Found {{meta.cursor.count}} results. Not what you are looking for?\n        <a non-catalog-item requisition=\"PR\">\n          Create a non catalog item.\n        </a>\n      </p>\n    </div>\n  </div>\n\n  <section class=\"all-categories\" ng-show=\"catalogDisplayHandler === \'showCategories\'\">\n    <h1 class=\"sr-only\">All Categories</h1>\n\n    <div class=\"panel panel-default\" ng-repeat=\"seg in segments | orderBy: \'title\'\">\n      <div class=\"panel-heading\">\n        <h2>\n          <a ng-click=\"browseCatalog(seg.code, seg.title, false, \'category\')\">\n            {{seg.title}}\n          </a>\n        </h2>\n      </div>\n\n      <div class=\"panel-body\">\n        <ul>\n          <li ng-repeat=\"fam in seg.families\">\n            <a ng-click=\"browseCatalog(fam.code, fam.title, false, \'category\')\">\n              {{fam.title}}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </section>\n\n  <div class=\"well\" ng-show=\"catalogDisplayHandler === \'showMessage\'\">\n    <h2 class=\"text-center\">{{ message }}</h2>\n  </div>\n\n  <div class=\"row\" ng-show=\"catalogDisplayHandler === \'showItems\'\">\n    <div ng-repeat=\"product in $parent.catalogList track by $index\" class=\"col-sm-4 col-md-3\">\n\n      <div class=\"thumbnail thumbnail-shadow star-check-cell star-check-cell-catalog\" ng-class=\"selected(product._id)? \' selected\' : \'\'\">\n        <a class=\"star-pr\"><i ng-click=\"itemStarring(product, product.item_id)\" ng-attr-class=\"{{ product.starred &&\n                           \'fa fa-2x fa-star star-hover\' || \'fa fa-2x fa-star-o star-hover-o\'}}\">\n        </i></a>\n        <span ng-if=\"product.default.is_stock === 0 || product.default.is_stock === \'\'\" class=\"label label-danger pull-right ng-scope\">\n          Non catalog\n        </span>\n        <span ng-if=\"product.default.is_partial === 1\" class=\"label label-warning pull-right ng-scope\">\n          Partial Item\n        </span>\n        <div ng-click=\"showItemDetails(product)\" class=\"product-image-wrapper\" ng-switch on=\"!!product.default.img_url\">\n          <img ng-switch-when=\"true\" ng-src=\"{{ imageBasePath }}{{product.default.img_url}}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" class=\"img-responsive\">\n          <img ng-switch-default class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n        </div>\n\n        <div class=\"caption\">\n          <p class=\"blue-title font-bold\">\n            <a ng-click=\"showItemDetails(product)\">{{product.item_name}}</a>\n          </p>\n\n          <p class=\"font-bold red-price\" ng-if=\"product.default.pricing.unit_price > 0\">\n            {{product.default.pricing.unit_price | formatDecimal: checkDecimal(product.default.pricing.unit_price)}}\n            {{product.default.pricing.currency.code}} / {{product.default.pricing.uom.code}}\n          </p>\n\n          <p class=\"font-bold red-price\" ng-if=\"product.default.pricing.unit_price === 0\">\n            0.00 {{product.default.pricing.currency.code}} / {{product.default.pricing.uom.code}}\n          </p>\n\n          <h6 ng-if=\"!product.default.payment_term.code\">No payment term specified</h6>\n          <h6 ng-if=\"product.default.payment_term.code\">Payment Terms: {{product.default.payment_term.code}}</h6>\n\n          <div>\n            <h6 ng-if=\"!product.default.supplier.name\">No supplier specified</h6>\n            <h6 ng-if=\"product.more == 1 && !!product.default.supplier.name\">by {{product.default.supplier.name}}</h6>\n            <h6 ng-if=\"product.more > 1\">by {{product.default.supplier.name | limitTo: 12}}... and {{product.more - 1}} other supplier(s).</h6>\n            <h6 ng-if=\"product.more < 1 \">&nbsp;&nbsp;&nbsp;&nbsp;</h6>\n          </div>\n\n          <h6 ng-if=\"product.item_description.length <= 170\" class=\"catalog-description\">\n            {{product.item_description | limitTo: 170}}\n          </h6>\n\n          <h6 ng-if=\"product.item_description.length > 170\" class=\"catalog-description\">\n            {{product.item_description | limitTo: 170}}...\n          </h6>\n\n          <h6 ng-if=\"!product.item_description\" class=\"catalog-description\">\n            No Description.\n          </h6>\n\n          <input ng-model=\"quantityOrdered\" type=\"hidden\">\n          <div class=\"text-center\">\n            <a class=\"btn btn-primary button-full no-padding\" ng-class=\"{disabled: checkLoading(\'addingItem\')}\" ng-disabled=\"checkLoading(\'addingItem\')\" role=\"button\" ng-click=\"addItemToPR(product.default)\" id=\"addItemToCart\">\n              <span class=\"btn-icon pull-left\" ng-if=\"product.selected\">\n                <i class=\"fa fa-shopping-cart\"></i>\n              </span>\n              <span class=\"font-bold btn-text\">\n                Add to cart\n              </span>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <span ng-show=\"catalogDisplayHandler !== \'showCategories\'\">\n    <embedded-pagination-service list=\"$parent.catalogList\" service=\"$parent.itemsService\" meta=\"$parent.meta\" params-source=\"$parent.paramsSource\" offset=\"20\">\n    </embedded-pagination-service>\n  </span>\n\n</div>\n");
$templateCache.put("components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/catalogPanelTemplate.html","<div class=\"panel panel-default\">\n  <!--<div class=\"panel-heading\" ui-scrollfix=\"+0\">-->\n  <!--</div>-->\n  <div class=\"panel-body\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-12\">\n          <label for=\"mini-catalog-search\" class=\"control-label sr-only\">Search</label>\n          <div class=\"input-group p-r-md\">\n            <div class=\"input-group-btn\">\n              <button data-toggle=\"dropdown\" class=\"btn btn-white dropdown-toggle\" aria-expanded=\"true\">\n                {{ selectedFilter.label || \'All\'}}\n                <i class=\"fa fa-caret-down\"></i>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li ng-repeat=\"filter in searchFilter track by $index\">\n                  <a ng-click=\"selectFilter(filter)\">{{ filter.label }}</a>\n                </li>\n              </ul>\n            </div>\n            <input type=\"search\" ng-model=\"search.title\" class=\"form-control\" id=\"mini-catalog-search\" placeholder=\" {{selectedFilter.text}}\n                   \" ui-keypress=\"{enter: \'searchCatalog(search.title)\'}\">\n            <div class=\"input-group-btn\">\n              <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"searchCatalog(search.title)\">\n                  <i class=\"fa fa-search\"></i>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-2\" ui-scrollfix=\"-20\" ng-if=\"!disableScrollMenu\">\n        <nav class=\"list-group\">\n            <a class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'starred\'}\" ng-click=\"browseCatalog(\'starred\', \'Starred Items\', false, \'tab\'); selectedTab = \'starred\'\">\n              Starred Items\n            </a>\n            <a class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'bought\'}\" ng-click=\"browseCatalog(\'bought\', \'Recently Bought\', false, \'tab\'); selectedTab = \'bought\'\">\n              Recently Bought\n            </a>\n            <a class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'viewed\'}\" ng-click=\"browseCatalog(\'viewed\', \'Recently Viewed\', false, \'tab\'); selectedTab = \'viewed\'\">\n              Recently Viewed\n            </a>\n            <a id=\"prLatestItemTab\" class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'latest\'}\" ng-click=\"browseCatalog(\'latest\', \'Latest Items\', false, \'tab\'); selectedTab = \'latest\'\">\n              Latest Items\n            </a>\n            <a class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'supplier\'}\" ng-click=\"browseCatalog(\'supplier\', \'\', true, \'supplier\'); selectedTab = \'supplier\'\" id=\"prBrowseSuppliers\">\n              Browse Suppliers\n            </a>\n            <a class=\"list-group-item\" ng-class=\"{\'active\': selectedTab === \'all_categories\'}\" ng-click=\"setCategoriesView(true); selectedTab = \'all_categories\'\">\n              All Categories\n            </a>\n            <a class=\"list-group-item\" ng-class=\"{\n                 \'active\': selectedTab === \'search_results\',\n                 \'hide\':  selectedTab === \'starred\' ||\n                          selectedTab === \'bought\' || selectedTab === \'viewed\' ||\n                          selectedTab === \'latest\' || selectedTab === \'supplier\' ||\n                          selectedTab === \'all_categories\'\n               }\">\n              Search Results\n            </a>\n          <div class=\"list-group-item\">\n            <ol class=\"breadcrumb\">\n              <li ng-if=\"currentCategory.greatGrandParent\">\n                <!-- grandparent categories -->\n                <a ng-click=\"browseCatalog(currentCategory.greatGrandParent.code, currentCategory.greatGrandParent.title, false, \'category\')\">\n                  {{currentCategory.greatGrandParent.title}}\n                </a>\n              </li>\n              <li ng-if=\"currentCategory.grandParent\">\n                <!-- grandparent categories -->\n                <a ng-click=\"browseCatalog(currentCategory.grandParent.code, currentCategory.grandParent.title, false, \'category\')\">\n                  {{currentCategory.grandParent.title}}\n                </a>\n              </li>\n              <li ng-if=\"currentCategory.parent\">\n                <!-- parent categories -->\n                <a ng-click=\"browseCatalog(currentCategory.parent.code, currentCategory.parent.title, false, \'category\')\">\n                  {{currentCategory.parent.title}}\n                </a>\n              </li>\n              <li><b>{{currentCategory.current.title}}</b>\n                <ul>\n                  <li ng-repeat=\"category in currentCategory.childern track by $index\">\n                    <a ng-click=\"browseCatalog(category.code, category.title, false, \'category\')\">\n                      {{category.title}} <span class=\"badge\">{{category.total}}</span>\n                    </a>\n                  </li>\n                </ul>\n              </li>\n            </ol>\n          </div>\n        </nav>\n      </div>\n      <div class=\"col-md-10 catalog-item-view\">\n        <div class=\"panel-body row col-sm-12\" ng-if=\"!!supplierSearchDisplay\">\n          <div class=\"col-sm-2\"></div>\n          <label class=\"col-sm-2 control-label font-bold\">Search for a Supplier</label>\n          <div class=\"col-sm-4 m-b\">\n            <div class=\"input-group searchfield\">\n            <span class=\"input-group-addon\">\n              <i class=\"fa\" ng-class=\"{true:\'fa-spinner fa-spin\', false:\'fa-search\'}[loading]\" ng-click=\"supplierListing(searchedSupplier.text)\"></i>\n            </span>\n              <input type=\"text\" typeahead-on-select=\"browseCatalog($item.mb_supplier_code, $item.descr, false, \'supplier\');\" placeholder=\"Type to search\" class=\"form-control\" typeahead-focus-first uib-typeahead=\"supplier.descr for supplier in supplierListing($viewValue)\" ng-model=\"searchedSupplier.text\" id=\"searchSupplier\" typeahead-wait-ms=\"500\" aria-autocomplete=\"list\" typeahead-min-length=\"3\">\n              <span ng-click=\"clearSupplierSearch()\" ng-show=\"!!searchedSupplier.text\" class=\"input-group-addon\" id=\"prClearSupplier\">\n              <i class=\"fa fa-remove\"></i>\n            </span>\n            </div>\n          </div>\n          <div class=\"col-sm-3\"></div>\n        </div>\n\n        <ui-view></ui-view>\n      </div>\n\n    </div>\n  </div><!-- .panel-body -->\n</div><!-- .panel.panel-default -->\n");
$templateCache.put("components/purchaseRequisitionComponents/purchaseRequisitionShoppingMode/detailsTemplate.html","<article class=\"product-details\" ng-model=\"details\">\n  <button aria-hidden=\"true\" ng-click=\"close()\" class=\"close\" type=\"button\" id=\"closePRItemDetails\">×</button>\n  <i ng-if=\"mainItem.default.is_stock === 0\" title=\"Non catalog\" class=\"label label-danger pull-right details-label\">Non catalog\n  </i>\n  <i ng-if=\"mainItem.default.is_partial === 1\" title=\"partial\" class=\"label label-warning pull-right details-label\">Partial\n  </i>\n  <h4>\n    {{mainItem.item_name}} &nbsp;&nbsp;\n    <a class=\"star-pr\"><i ng-click=\"itemStarring(mainItem, mainItem.item_id)\" ng-attr-class=\"{{ mainItem.starred && \'fa fa-star star-hover\' || \'fa fa-star-o star-hover-o\'}}\"></i>\n    </a>\n\n    <a class=\"edit-non\" ng-if=\"(user._id === mainItem.default.created_by) && (mainItem.is_partial !== 1 && mainItem.is_stock !== 1)\" ng-click=\"goToAddNonCatalog(mainItem, itemDetails[0])\">\n      Edit\n    </a>\n  </h4>\n\n  <div class=\"product-description clearfix\">\n    <aside class=\"pull-right\">\n      <div class=\"product-images\" ng-switch on=\"!!mainItem.default.img_url\">\n        <img ng-switch-when=\"true\" ng-src=\"{{ imageBasePath }}{{mainItem.default.img_url}}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" class=\"img-responsive\">\n        <img ng-switch-default class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n      </div>\n\n      <div class=\"product-action\">\n        <input type=\"hidden\" ng-model=\"quantityOrdered\">\n      </div>\n    </aside>\n\n    <p style=\"white-space: pre-line\">{{mainItem.item_description ? mainItem.item_description : mainItem.desc }}</p>\n    <p style=\"white-space: pre-line\" ng-if=\"mainItem.description\">{{mainItem.description}}</p>\n\n    <div ng-if=\"!!lastCommodity\" class=\"item-details-commodity\">\n      <strong>Commodity Code:</strong>\n      <br>\n      {{lastCommodity.code}}\n      <text-show-less-more model=\"lastCommodity.descr\" type=\"words\" length=\"12\">\n      </text-show-less-more>\n    </div>\n\n  </div>\n\n  <div class=\"product-variations\">\n    <table class=\"table table-striped table-hover\">\n      <thead>\n      <tr>\n        <th>Supplier</th>\n        <th>Price</th>\n        <th>Supplier Part #</th>\n        <th>Payment Term</th>\n        <th>Lead Time</th>\n        <th></th>\n      </tr>\n      </thead>\n      <tbody>\n      <div>\n        <tr ng-repeat=\"detail in itemDetails track by $index\">\n          <td>\n            {{detail.supplier.name}}\n          </td>\n          <td ng-if=\"detail.pricing.unit_price > 0\">\n            {{detail.pricing.unit_price | isoCurrency: detail.pricing.currency.code:checkDecimal(detail.pricing.unit_price)}} / {{detail.pricing.uom.code}}\n          </td>\n          <td ng-if=\"detail.pricing.unit_price === 0\">\n            0.00 {{ detail.pricing.currency.code }} / {{detail.pricing.uom.code}}\n          </td>\n          <td>\n            {{detail.supplier_part_no}}\n          </td>\n          <td>\n            {{detail.payment_term.descr}}\n          </td>\n          <td>\n            {{!!detail.lead_time ? detail.lead_time : \'Not specified\'}}\n          </td>\n          <td>\n            <a ng-class=\"{disabled: checkLoading(\'addingItem\')}\" ng-disabled=\"checkLoading(\'addingItem\')\" id=\"prAddToCart\" class=\"btn btn-primary pull-right\" role=\"button\" ng-click=\"addItemToPR(detail)\">\n              Add to cart\n            </a>\n          </td>\n        </tr>\n      </div>\n      </tbody>\n    </table>\n  </div>\n</article>\n");
$templateCache.put("components/purchaseRequisitionComponents/revision/revision.html","<div class=\"modal-content modal-inside state_requisitions_details\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" id=\"closePRVersion\" class=\"close\" ng-click=\"cancel()\">×</button>\n    <h4 class=\"modal-title\">PR Revision</h4>\n    <p>\n      Current Version compare to <span ng-if=\"version === 0\">Original</span> Version\n      <span ng-if=\"version > 0\">{{ version }}</span>\n    </p>\n  </div>\n\n  <div class=\"modal-body\">\n    <!-- PR Header -->\n    <div class=\"row\">\n      <div class=\"jumbotron jumbotron-noneditable-color\">\n        <div class=\"row\">\n          <!-- Revision section-->\n          <div class=\"col-md-12 text-center jumbotron-title\">\n            <span ng-if=\"currentPR.title !== prevPR.title\">\n              <del>{{prevPR.title}}</del>\n              <br>\n              <ins>{{currentPR.title}}</ins>\n            </span>\n            <span ng-if=\"currentPR.title === prevPR.title\">\n              <h2>{{prevPR.title}}</h2>\n            </span>\n          </div>\n          <div class=\"col-xs-6 form-horizontal\">\n            <div class=\"row\">\n              <h3 class=\"col-xs-5 text-right\">Bill To</h3>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Company</label>\n\n              <div class=\"col-xs-7\">\n                <span> {{ currentPR.company.descr }} </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Address</label>\n\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.billing_to_address._id !== prevPR.billing_to_address._id\">\n                  <del>\n                    <span class=\"address-text-format\">{{\n                      (prevPR.billing_to_address.line1.length ?\n                        prevPR.billing_to_address.line1 + \"\\n\": \"\") +\n                      (prevPR.billing_to_address.line2.length ?\n                        prevPR.billing_to_address.line2 + \"\\n\": \"\") +\n                      (prevPR.billing_to_address.line3.length ?\n                        prevPR.billing_to_address.line3 + \"\\n\": \"\") +\n                      (prevPR.billing_to_address.postal_code.length ?\n                        prevPR.billing_to_address.postal_code : \"\") +\n                      (prevPR.billing_to_address.city.length ?\n                        (prevPR.billing_to_address.postal_code.length ? \" \" : \"\") +\n                        prevPR.billing_to_address.city + \"\\n\" :\n                      (prevPR.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                      (prevPR.billing_to_address.state.length ?\n                        prevPR.billing_to_address.state : \"\") +\n                      (prevPR.billing_to_address.country.length?\n                        (prevPR.billing_to_address.state.length ? \", \" : \"\") +\n                        prevPR.billing_to_address.country: \"\") }}\n                    </span>\n                  </del>\n                  <br>\n                  <ins>\n                    <span class=\"address-text-format\">{{\n                      (currentPR.billing_to_address.line1.length ?\n                        currentPR.billing_to_address.line1 + \"\\n\": \"\") +\n                      (currentPR.billing_to_address.line2.length ?\n                        currentPR.billing_to_address.line2 + \"\\n\": \"\") +\n                      (currentPR.billing_to_address.line3.length ?\n                        currentPR.billing_to_address.line3 + \"\\n\": \"\") +\n                      (currentPR.billing_to_address.postal_code.length ?\n                        currentPR.billing_to_address.postal_code : \"\") +\n                      (currentPR.billing_to_address.city.length ?\n                        (currentPR.billing_to_address.postal_code.length ? \" \" : \"\") +\n                      currentPR.billing_to_address.city + \"\\n\" :\n                        (currentPR.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                      (currentPR.billing_to_address.state.length ?\n                        currentPR.billing_to_address.state : \"\") +\n                      (currentPR.billing_to_address.country.length?\n                        (currentPR.billing_to_address.state.length ? \", \" : \"\") +\n                      currentPR.billing_to_address.country: \"\") }}\n                    </span>\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.billing_to_address._id === prevPR.billing_to_address._id\">\n                  <span class=\"address-text-format\">{{\n                    (currentPR.billing_to_address.line1.length ?\n                      currentPR.billing_to_address.line1 + \"\\n\": \"\") +\n                    (currentPR.billing_to_address.line2.length ?\n                      currentPR.billing_to_address.line2 + \"\\n\": \"\") +\n                    (currentPR.billing_to_address.line3.length ?\n                      currentPR.billing_to_address.line3 + \"\\n\": \"\") +\n                    (currentPR.billing_to_address.postal_code.length ?\n                      currentPR.billing_to_address.postal_code : \"\") +\n                    (currentPR.billing_to_address.city.length ?\n                      (currentPR.billing_to_address.postal_code.length ? \" \" : \"\") +\n                    currentPR.billing_to_address.city + \"\\n\" :\n                      (currentPR.billing_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                    (currentPR.billing_to_address.state.length ?\n                      currentPR.billing_to_address.state : \"\") +\n                    (currentPR.billing_to_address.country.length?\n                      (currentPR.billing_to_address.state.length ? \", \" : \"\") +\n                    currentPR.billing_to_address.country: \"\") }}\n                  </span>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Cost center</label>\n              <div class=\"col-xs-7\">\n                <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.item_details.item_name\" prev-val=\"item.prevVersion.item_details.item_name\">\n                </diff-version>\n                <span ng-if=\"currentPR.cost_center._id !== prevPR.cost_center._id\">\n                  <del>{{ prevPR.cost_center.descr }}</del>\n                  <br>\n                  <ins>\n                    {{ currentPR.cost_center.descr }}\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.cost_center._id === prevPR.cost_center._id\">\n                  <span>\n                    {{ currentPR.cost_center.descr }}\n                  </span>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Expense type</label>\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.expense_type.code !== prevPR.expense_type.code\">\n                  <del>\n                    {{ prevPR.expense_type.descr }}\n                  </del>\n                  <br>\n                  <ins>\n                    {{ currentPR.expense_type.descr }}\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.expense_type.code === prevPR.expense_type.code\">\n                  {{ currentPR.expense_type.descr }}\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Budget</label>\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.budget._id !== prevPR.budget._id\">\n                  <del>\n                    {{ prevPR.budget.descr }}\n                  </del>\n                  <br>\n                  <ins>\n                    {{ currentPR.budget.descr }}\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.budget._id === prevPR.budget._id\">\n                  {{ currentPR.budget.descr }}\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Currency</label>\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.currency.code !== prevPR.currency.code\">\n                  <del>\n                    {{ prevPR.currency.code + \' - \' + prevPR.currency.descr }}\n                  </del>\n                  <br>\n                  <ins>\n                    {{ currentPR.currency.code + \' - \' + currentPR.currency.descr }}\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.currency.code === prevPR.currency.code\">\n                  {{ currentPR.currency.code + \' - \' + currentPR.currency.descr }}\n                </span>\n              </div>\n\n            </div>\n          </div>\n          <div class=\"col-xs-6 form-horizontal\">\n            <div class=\"row\">\n              <h3 class=\"col-xs-5 text-right\">Deliver To</h3>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Company</label>\n\n              <div class=\"col-xs-7\">\n                <span>{{ currentPR.company.descr }}</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Address</label>\n\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.delivery_to_address._id !== prevPR.delivery_to_address._id\">\n                  <del>\n                    <span class=\"address-text-format\">{{\n                      (prevPR.delivery_to_address.line1.length ?\n                        prevPR.delivery_to_address.line1 + \"\\n\": \"\") +\n                      (prevPR.delivery_to_address.line2.length ?\n                        prevPR.delivery_to_address.line2 + \"\\n\": \"\") +\n                      (prevPR.delivery_to_address.line3.length ?\n                        prevPR.delivery_to_address.line3 + \"\\n\": \"\") +\n                      (prevPR.delivery_to_address.postal_code.length ?\n                        prevPR.delivery_to_address.postal_code : \"\") +\n                      (prevPR.delivery_to_address.city.length ?\n                        (prevPR.delivery_to_address.postal_code.length ? \" \" : \"\") +\n                      prevPR.delivery_to_address.city + \"\\n\" :\n                        (prevPR.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                      (prevPR.delivery_to_address.state.length ?\n                        prevPR.delivery_to_address.state : \"\") +\n                      (prevPR.delivery_to_address.country.length?\n                        (prevPR.delivery_to_address.state.length ? \", \" : \"\") +\n                      prevPR.delivery_to_address.country: \"\") }}\n                    </span>\n                  </del>\n                  <br>\n                  <ins>\n                    <span class=\"address-text-format\">{{\n                      (currentPR.delivery_to_address.line1.length ?\n                        currentPR.delivery_to_address.line1 + \"\\n\": \"\") +\n                      (currentPR.delivery_to_address.line2.length ?\n                        currentPR.delivery_to_address.line2 + \"\\n\": \"\") +\n                      (currentPR.delivery_to_address.line3.length ?\n                        currentPR.delivery_to_address.line3 + \"\\n\": \"\") +\n                      (currentPR.delivery_to_address.postal_code.length ?\n                        currentPR.delivery_to_address.postal_code : \"\") +\n                      (currentPR.delivery_to_address.city.length ?\n                        (currentPR.delivery_to_address.postal_code.length ? \" \" : \"\") +\n                      currentPR.delivery_to_address.city + \"\\n\" :\n                        (currentPR.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                      (currentPR.delivery_to_address.state.length ?\n                        currentPR.delivery_to_address.state : \"\") +\n                      (currentPR.delivery_to_address.country.length?\n                        (currentPR.delivery_to_address.state.length ? \", \" : \"\") +\n                      currentPR.delivery_to_address.country: \"\") }}\n                    </span>\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.delivery_to_address._id === prevPR.delivery_to_address._id\">\n                  <span class=\"address-text-format\">{{\n                    (currentPR.delivery_to_address.line1.length ?\n                      currentPR.delivery_to_address.line1 + \"\\n\": \"\") +\n                    (currentPR.delivery_to_address.line2.length ?\n                      currentPR.delivery_to_address.line2 + \"\\n\": \"\") +\n                    (currentPR.delivery_to_address.line3.length ?\n                      currentPR.delivery_to_address.line3 + \"\\n\": \"\") +\n                    (currentPR.delivery_to_address.postal_code.length ?\n                      currentPR.delivery_to_address.postal_code : \"\") +\n                    (currentPR.delivery_to_address.city.length ?\n                      (currentPR.delivery_to_address.postal_code.length ? \" \" : \"\") +\n                    currentPR.delivery_to_address.city + \"\\n\" :\n                      (currentPR.delivery_to_address.postal_code.length ? \"\\n\" : \"\")) +\n                    (currentPR.delivery_to_address.state.length ?\n                      currentPR.delivery_to_address.state : \"\") +\n                    (currentPR.delivery_to_address.country.length?\n                      (currentPR.delivery_to_address.state.length ? \", \" : \"\") +\n                    currentPR.delivery_to_address.country: \"\") }}\n                  </span>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Contact person</label>\n\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.contact_person !== prevPR.contact_person\">\n                  <del>{{prevPR.contact_person}}</del>\n                  <br>\n                  <ins>{{currentPR.contact_person}}</ins>\n                </span>\n                <span ng-if=\"currentPR.contact_person === prevPR.contact_person\">\n                  <span>{{currentPR.contact_person}}</span>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-5 text-right\">Needed by</label>\n\n              <div class=\"col-xs-7\">\n                <span ng-if=\"currentPR.needed_by_date !== prevPR.needed_by_date\">\n                  <del>{{prevPR.needed_by_date | date: \'dd MMM yyyy\'}}</del>\n                  <br>\n                  <ins>{{currentPR.needed_by_date | date: \'dd MMM yyyy\'}}</ins>\n                </span>\n                <span ng-if=\"currentPR.needed_by_date === prevPR.needed_by_date\">\n                  <span>{{currentPR.needed_by_date | date: \'dd MMM yyyy\'}}</span>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <hr>\n        <div class=\"row\">\n          <div class=\"col-xs-8 col-xs-offset-2 form-horizontal\">\n            <div class=\"row\">\n              <h3 class=\"col-xs-12 text-center\">Other Details</h3>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-6 text-right\">Creator</label>\n              <div class=\"col-xs-6\">\n                {{ currentPR.creator.display_name }}\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-6 text-right\">On behalf of</label>\n              <div class=\"col-xs-6\">\n                <span ng-if=\"currentPR.requestor._id !== prevPR.requestor._id\">\n                  <del>{{prevPR.requestor.display_name}}</del>\n                  <br>\n                  <ins>{{currentPR.requestor.display_name}}</ins>\n                </span>\n                <span ng-if=\"currentPR.requestor._id === prevPR.requestor._id\">\n                  <span>{{currentPR.requestor.display_name}}</span>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-xs-6 text-right\">Submission date</label>\n              <div class=\"col-xs-6\">\n                <span ng-if=\"currentPR.submitted_at != prevPR.submitted_at\">\n                  <del>\n                    {{prevPR.submitted_at | date: \"dd MMM yyyy\"}}\n                    (<span am-time-ago=\"prevPR.submitted_at\"></span>)\n                  </del>\n                  <br>\n                  <ins>\n                    {{currentPR.submitted_at | date: \"dd MMM yyyy\"}}\n                    (<span am-time-ago=\"currentPR.submitted_at\"></span>)\n                  </ins>\n                </span>\n                <span ng-if=\"currentPR.submitted_at === prevPR.submitted_at\">\n                  <span>\n                    {{currentPR.submitted_at | date: \"dd MMM yyyy\"}}\n                    (<span am-time-ago=\"currentPR.submitted_at\"></span>)\n                  </span>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!-- revision section-->\n      </div>\n      <div class=\"itemlist\" id=\"itemlist\">\n        <table class=\"table screen-section\">\n          <colgroup>\n            <col class=\"column-image\">\n            <col class=\"column-item-details column-item-details-no-check-box\">\n            <col class=\"column-quantity\">\n            <col class=\"column-unit-price\">\n            <col class=\"column-amount\">\n          </colgroup>\n          <thead>\n          <tr>\n            <th colspan=\"2\" class=\"text-left-align\">Item</th>\n            <th> Qty </th>\n            <th> Unit Price </th>\n            <th> Amount </th>\n            <th> Discount </th>\n            <th> Total Amount </th>\n            <th> GST </th>\n          </tr>\n          </thead>\n\n          <tbody>\n          <tr ng-repeat-start=\"item in lineItemDiff track by $index\" class=\"animate-repeat\" ng-class=\"{ \'rev-del\': item.diffStatus === \'deleted\', \'rev-ins\': item.diffStatus === \'added\' }\">\n            <td>\n              <div class=\"product-image-wrapper\">\n                <!-- todo: create directive to display image -->\n                <img class=\"img-responsive\" ng-if=\"!!item.item.img_url\" ng-src=\"{{ imageBasePath }}{{ item.item.img_url }}\" image-error=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\" alt=\"{{item.item_details.item_name}}\">\n                <img ng-if=\"!item.item.img_url\" class=\"img-responsive\" ng-src=\"http://img1.wikia.nocookie.net/__cb20141028171337/pandorahearts/images/a/ad/Not_available.jpg\">\n              </div>\n            </td>\n\n            <!-- item or supplier status -->\n            <td class=\"text-left-align\">\n              <span ng-if=\"item.item_details.is_stock === 0\" class=\"label label-danger pull-right\">Non Catalog</span>\n              <span ng-if=\"!!item.item_details.is_stock && !!item.item_details.is_partial\" class=\"label label-warning pull-right\">\n                Partial Item\n              </span>\n              <span ng-if=\"item.supplier.status.toLowerCase() === \'black_listed\'\" class=\"label label-blacklist pull-right\">\n                Supplier Blacklisted\n              </span>\n              <p>\n                {{ $index + 1 }}.\n                <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.item_details.item_name\" prev-val=\"item.prevVersion.item_details.item_name\">\n                </diff-version>\n                <span ng-if=\"item.diffStatus !== \'updated\'\"> {{ item.item_details.item_name }} </span>\n              </p>\n              <p>\n                <text-show-less-more model=\"item.item_details.description\" type=\"words\" class=\"limit-lines\">\n                </text-show-less-more>\n              </p>\n              <p>\n                <b uib-tooltip-html=\"\'{{item.supplier.descr}}\n                  <br> Contact Person: {{item.supplier.contact_person.first_name ? item.supplier.contact_person.first_name : \'Not available\'}}\n                  <br> Email: {{item.supplier.contact_person.email ? item.supplier.contact_person.email : \'Not available\'}}\n                  <br> Phone: {{item.supplier.phone ? item.supplier.phone : \'Not available\'}}\n                  <br> Fax: {{item.supplier.fax ? item.supplier.fax : \'Not available\'}}\'\">\n                  <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.supplier.descr\" prev-val=\"item.prevVersion.supplier.descr\">\n                  </diff-version>\n                  <span ng-if=\"item.diffStatus !== \'updated\'\"> {{ item.supplier.descr }} </span>\n                </b>\n              </p>\n              <span>\n                <span ng-if=\"item.diffStatus !== \'updated\'\"> {{item.payment_term.descr}} </span>\n                <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.payment_term.descr\" prev-val=\"item.prevVersion.payment_term.descr\">\n                </diff-version>\n              </span>\n\n              <!-- Other Details (Needed by date, transportation, and so on) -->\n              <div class=\"row grey-border-top\">\n                <!-- Needed by date -->\n                <div class=\"col-md-12 grey-border-bottom\" ng-if=\"item.diffStatus === \'updated\' && (!!item.needed_by_date || !!item.prevVersion.needed_by_date)\">\n                  <b>Needed by date:</b> &nbsp;\n                  <span ng-if=\"item.needed_by_date === item.prevVersion.needed_by_date\">\n                    {{ item.needed_by_date | date:\'dd MMM yyyy\' }}\n                  </span>\n                  <span ng-if=\"item.needed_by_date !== item.prevVersion.needed_by_date\">\n                    <del>{{ item.prevVersion.needed_by_date | date:\'dd MMM yyyy\' }}</del>\n                    &nbsp;\n                    <ins>{{ item.needed_by_date | date:\'dd MMM yyyy\' }}</ins>\n                  </span>\n                </div>\n\n                <div class=\"col-md-12 grey-border-bottom\" ng-if=\"item.diffStatus !== \'updated\' && !!item.needed_by_date\">\n                  <b>Needed by date:</b> &nbsp;\n                  <span>\n                    {{ item.needed_by_date | date:\'dd MMM yyyy\' }}\n                  </span>\n                </div>\n\n                <!-- Delivery Address -->\n                <div ng-if=\"item.diffStatus === \'updated\' && (!!item.delivery_address || !!item.prevVersion.delivery_address)\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Delivery Address:</b>\n                  <div>\n                    <span ng-if=\"item.delivery_address._id !== item.prevVersion.delivery_address._id\">\n                      <del ng-if=\"item.prevVersion.delivery_address._id\">\n                        <span class=\"address-text-format\">{{\n                          (item.prevVersion.delivery_address.line1.length ? item.prevVersion.delivery_address.line1 + \"\\n\": \"\") +\n                          (item.prevVersion.delivery_address.line2.length ? item.prevVersion.delivery_address.line2 + \"\\n\": \"\") +\n                          (item.prevVersion.delivery_address.line3.length ? item.prevVersion.delivery_address.line3 + \"\\n\": \"\") +\n                          (item.prevVersion.delivery_address.postal_code.length ? item.prevVersion.delivery_address.postal_code : \"\") +\n                          (item.prevVersion.delivery_address.length ? (item.prevVersion.delivery_address.length ? \" \" : \"\") +\n                          item.prevVersion.delivery_address.city + \"\\n\" : (item.prevVersion.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n                          (item.prevVersion.delivery_address.state.length ? item.prevVersion.delivery_address.state : \"\") +\n                          (item.prevVersion.delivery_address.country.length? (item.prevVersion.delivery_address.country.length ? \", \" : \"\") +\n                          item.prevVersion.delivery_address.country: \"\") }}\n                        </span>\n                      </del>\n                      <br ng-if=\"item.prevVersion.delivery_address._id\">\n                      <ins ng-if=\"item.delivery_address._id\">\n                        <span class=\"address-text-format\">{{\n                          (item.delivery_address.line1.length ? item.delivery_address.line1 + \"\\n\": \"\") +\n                          (item.delivery_address.line2.length ? item.delivery_address.line2 + \"\\n\": \"\") +\n                          (item.delivery_address.line3.length ? item.delivery_address.line3 + \"\\n\": \"\") +\n                          (item.delivery_address.postal_code.length ? item.delivery_address.postal_code : \"\") +\n                          (item.delivery_address.length ? (item.delivery_address.length ? \" \" : \"\") +\n                          item.delivery_address.city + \"\\n\" : (item.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n                          (item.delivery_address.state.length ? item.delivery_address.state : \"\") +\n                          (item.delivery_address.country.length? (item.delivery_address.country.length ? \", \" : \"\") +\n                          item.delivery_address.country: \"\") }}\n                        </span>\n                      </ins>\n                    </span>\n                  </div>\n                </div>\n\n                <div ng-if=\"item.diffStatus !== \'updated\' && !!item.delivery_address\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Delivery Address:</b>\n\n                  <div>\n                    <span class=\"address-text-format\">{{\n                      (item.delivery_address.line1.length ? item.delivery_address.line1 + \"\\n\": \"\") +\n                      (item.delivery_address.line2.length ? item.delivery_address.line2 + \"\\n\": \"\") +\n                      (item.delivery_address.line3.length ? item.delivery_address.line3 + \"\\n\": \"\") +\n                      (item.delivery_address.postal_code.length ? item.delivery_address.postal_code : \"\") +\n                      (item.delivery_address.length ? (item.delivery_address.length ? \" \" : \"\") +\n                      item.delivery_address.city + \"\\n\" : (item.delivery_address.postal_code.length ? \"\\n\" : \"\")) +\n                      (item.delivery_address.state.length ? item.delivery_address.state : \"\") +\n                      (item.delivery_address.country.length? (item.delivery_address.country.length ? \", \" : \"\") +\n                      item.delivery_address.country: \"\") }}\n                    </span>\n                  </div>\n                </div>\n\n                <!-- Supplier Branches -->\n                <div ng-if=\"item.diffStatus === \'updated\' && (!!item.branch || !!item.prevVersion.branch)\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Supplier Branches:</b>\n                  <div>\n                    <span ng-if=\"item.branch.address._id !== item.prevVersion.branch.address._id\">\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.descr || item.branch.descr\">\n                        <b>Branch   :</b>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.descr\">\n                        <del>\n                        {{(item.prevVersion.branch.descr + \" (\" + item.prevVersion.branch.code + \")\")}}\n                        </del>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n                        <ins>\n                        {{(item.branch.descr + \" (\" + item.branch.code + \")\")}}\n                        </ins>\n                      </div>\n                      <br ng-if=\"item.prevVersion.branch.descr || item.branch.descr\">\n\n\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.address._id || item.branch.address._id\">\n                        <b>Address :</b>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.address._id\">\n                        <del>\n                          {{\n                            (item.prevVersion.branch.address.line1.length ? item.prevVersion.branch.address.line1 + \", \": \"\") +\n                            (item.prevVersion.branch.address.line2.length ? item.prevVersion.branch.address.line2 : \"\")\n                          }}\n                        <br ng-if=\"item.prevVersion.branch.address.line1 || item.prevVersion.branch.address.line2\">\n                          {{\n                            (item.prevVersion.branch.address.line3.length ? item.prevVersion.branch.address.line3 + \",\": \"\") +\n                            (item.prevVersion.branch.address.city.length ? item.prevVersion.branch.address.city : \"\")\n                          }}\n                        <br ng-if=\"item.prevVersion.branch.address.line3 || item.prevVersion.branch.address.city\">\n                          {{ (item.prevVersion.branch.address.postal_code.length ? item.prevVersion.branch.address.postal_code + \",\" : \"\") +\n                            (item.prevVersion.branch.address.state.length ? item.prevVersion.branch.address.state : \"\")\n                          }}\n                        <br ng-if=\"item.prevVersion.branch.address.postal_code || item.prevVersion.branch.address.state\">\n                          {{\n                            (item.prevVersion.branch.address.country.length? item.prevVersion.branch.address.country + \". \" : \"\")\n                          }}\n                        <br ng-if=\"item.prevVersion.branch.address.country\">\n                        </del>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n                        <ins>\n                          {{\n                            (item.branch.address.line1.length ? item.branch.address.line1 + \", \": \"\") +\n                            (item.branch.address.line2.length ? item.branch.address.line2 : \"\")\n                          }}\n                        <br ng-if=\"item.branch.address.line1 || item.branch.address.line2\">\n                          {{\n                            (item.branch.address.line3.length ? item.branch.address.line3 + \",\": \"\") +\n                            (item.branch.address.city.length ? item.branch.address.city : \"\")\n                          }}\n                        <br ng-if=\"item.branch.address.line3 || item.branch.address.city\">\n                          {{ (item.branch.address.postal_code.length ? item.branch.address.postal_code + \",\" : \"\") +\n                            (item.branch.address.state.length ? item.branch.address.state : \"\")\n                          }}\n                        <br ng-if=\"item.branch.address.postal_code || item.branch.address.state\">\n                          {{\n                            (item.branch.address.country.length? item.branch.address.country + \". \" : \"\")\n                          }}\n                        <br ng-if=\"item.branch.address.country\">\n                        </ins>\n                      </div>\n                      <br ng-if=\"item.prevVersion.branch.address._id || item.branch.address._id\">\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.phone || item.branch.phone\">\n                        <b>Phone   :</b>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.phone\">\n                        <del>\n                          {{item.prevVersion.branch.phone.length ? item.prevVersion.branch.phone : \"Not Available\"}}\n                        </del>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n                        <ins>\n                          {{item.branch.phone.length ? item.branch.phone : \"Not Available\"}}\n                        </ins>\n                      </div>\n                      <br ng-if=\"item.prevVersion.branch.phone || item.branch.phone\">\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.fax || item.branch.fax\">\n                        <b>Fax     :</b>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.prevVersion.branch.fax\">\n                        <del>\n                          {{item.prevVersion.branch.fax.length ? item.prevVersion.branch.fax : \"Not Available\"}}\n                        </del>\n                      </div>\n                      <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n                        <ins>\n                          {{item.branch.fax.length ? item.branch.fax : \"Not Available\"}}\n                        </ins>\n                      </div>\n                      <br ng-if=\"item.prevVersion.branch.fax || item.branch.fax\">\n                    </span>\n                  </div>\n                </div>\n\n                <div ng-if=\"!!item.prevVersion.branch && !!item.branch\" class=\"col-md-12 grey-border-bottom\">\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n                    <b>Branch   :</b>\n                  </div>\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.descr\">\n                      {{(item.branch.descr + \" (\" + item.branch.code + \")\")}}\n                  </div>\n                  <br ng-if=\"item.branch.descr\">\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n                    <b>Address :</b>\n                  </div>\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.address._id\">\n                      {{\n                      (item.branch.address.line1.length ? item.branch.address.line1 + \", \": \"\") +\n                      (item.branch.address.line2.length ? item.branch.address.line2 : \"\")\n                      }}\n                      <br ng-if=\"item.branch.address.line1 || item.branch.address.line2\">\n                      {{\n                      (item.branch.address.line3.length ? item.branch.address.line3 + \",\": \"\") +\n                      (item.branch.address.city.length ? item.branch.address.city : \"\")\n                      }}\n                      <br ng-if=\"item.branch.address.line3 || item.branch.address.city\">\n                      {{ (item.branch.address.postal_code.length ? item.branch.address.postal_code + \",\" : \"\") +\n                      (item.branch.address.state.length ? item.branch.address.state : \"\")\n                      }}\n                      <br ng-if=\"item.branch.address.postal_code || item.branch.address.state\">\n                      {{\n                      (item.branch.address.country.length? item.branch.address.country + \". \" : \"\")\n                      }}\n                      <br ng-if=\"item.branch.address.country\">\n                  </div>\n                  <br ng-if=\"item.branch.address._id\">\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n                    <b>Phone   :</b>\n                  </div>\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.phone\">\n                      {{item.branch.phone.length ? item.branch.phone : \"Not Available\"}}\n                  </div>\n                  <br ng-if=\"item.branch.phone\">\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n                    <b>Fax     :</b>\n                  </div>\n                  <div class=\"col-xs-12 col-md-12\" ng-if=\"item.branch.fax\">\n                      {{item.branch.fax.length ? item.branch.fax : \"Not Available\"}}\n                  </div>\n                  <br ng-if=\"item.branch.fax\">\n                </div>\n\n\n                <div ng-if=\"item.diffStatus === \'updated\' && (!!item.note || !!item.prevVersion.note)\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Notes (Only for external):</b>\n                  <br>\n                  <diff-version new-val=\"item.note\" line-break=\"true\" prev-val=\"item.prevVersion.note\">\n                  </diff-version>\n                </div>\n\n                <div ng-if=\"item.diffStatus !== \'updated\' && !!item.note\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Notes (Only for external):</b>\n                  <br>\n                  {{ item.note }}\n                </div>\n\n                <!-- Waiting for the account code from issue 1413 -->\n                <!-- Account codes -->\n                <div ng-if=\"item.diffStatus === \'updated\' && (!!item.account_code || !!item.prevVersion.account_code)\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Account Codes:</b>\n                  <div>\n                    <span ng-if=\"currentPR.company.code + \':\' + currentPR.cost_center.code + \':\' + item.account_code.code !==\n                          prevPR.company.code + \':\' + prevPR.cost_center.code + \':\' + item.prevVersion.account_code.code\">\n                      <del ng-if=\"!!item.prevVersion.account_code.code\">\n                        {{ prevPR.company.code + \':\' + prevPR.cost_center.code + \':\' + item.prevVersion.account_code.code}}\n                      </del>\n                      <br ng-if=\"!!item.prevVersion.account_code.code\">\n                      <ins ng-if=\"!!item.account_code.code\">\n                        {{ currentPR.company.code + \':\' + currentPR.cost_center.code + \':\' + item.account_code.code }}\n                      </ins>\n                    </span>\n                    <span ng-if=\"currentPR.company.code + \':\' + currentPR.cost_center.code + \':\' + item.account_code.code ===\n                          prevPR.company.code + \':\' + prevPR.cost_center.code + \':\' + item.prevVersion.account_code.code\">\n                      {{ currentPR.company.code + \':\' + currentPR.cost_center.code + \':\' + item.account_code.code }}\n                    </span>\n                  </div>\n                </div>\n\n                <div ng-if=\"item.diffStatus !== \'updated\' && !!item.account_code\" class=\"col-md-12 grey-border-bottom\">\n                  <b>Account Codes:</b>\n                  <div>\n                    {{ currentPR.company.code + \':\' + currentPR.cost_center.code + \':\' + item.account_code.code}}\n                  </div>\n                </div>\n\n              </div>\n            </td>\n\n            <td>\n              <span ng-if=\"item.diffStatus !== \'updated\'\"> {{ item.qty }} </span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.qty\" prev-val=\"item.prevVersion.qty\">\n              </diff-version>\n              <span ng-if=\"item.diffStatus !== \'updated\'\"> {{ item.UOM.code }} </span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.UOM.code\" prev-val=\"item.prevVersion.UOM.code\">\n              </diff-version>\n            </td>\n\n            <td>\n              <span ng-if=\"item.diffStatus !== \'updated\'\">{{ item.unit_price | formatDecimal: 4 }}</span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.unit_price\" prev-val=\"item.prevVersion.unit_price\" filter-decimal=\"4\">\n              </diff-version>\n              <span ng-if=\"item.diffStatus !== \'updated\'\">{{ item.currency.code }}</span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.currency.code\" prev-val=\"item.prevVersion.currency.code\">\n              </diff-version>\n            </td>\n\n            <td>\n              <span ng-if=\"item.diffStatus !== \'updated\'\"> {{item.amount | formatDecimal: 2}} </span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.amount\" prev-val=\"item.prevVersion.amount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n\n            <td>\n              <span ng-if=\"item.diffStatus !== \'updated\' && !!item.discount\"> ({{ item.discount }}) </span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.discount\" prev-val=\"item.prevVersion.discount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n\n            <td>\n              <span ng-if=\"item.diffStatus !== \'updated\'\">\n                {{ item.amount_with_discount | isoCurrency: item.currency.code: 2  }}\n              </span>\n              <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.amount_with_discount\" prev-val=\"item.prevVersion.amount_with_discount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n\n            <td>\n              <div>\n                <div ng-if=\"item.diffStatus !== \'updated\'\"> {{item.tax.code + \' \' + item.tax.rate + \'%\'}} </div>\n                <div ng-if=\"item.diffStatus === \'updated\'\">\n                  <!-- can\'t handle with the directive -->\n                  <span ng-if=\"(item.tax.code + \' \' + item.tax.rate + \'%\') !== (item.prevVersion.tax.code + \' \' + item.prevVersion.tax.rate + \'%\')\">\n                    <del> {{ item.prevVersion.tax.code + \' \' + item.prevVersion.tax.rate + \'%\' }} </del>\n                    <br>\n                    <ins> {{ item.tax.code + \' \' + item.tax.rate + \'%\' }} </ins>\n                  </span>\n                  <span ng-if=\"(item.tax.code + \' \' + item.tax.rate + \'%\') === (item.prevVersion.tax.code + \' \' + item.prevVersion.tax.rate + \'%\')\">\n                    {{ item.tax.code + \' \' + item.tax.rate + \'%\' }}\n                  </span>\n                </div>\n                <div ng-if=\"item.diffStatus !== \'updated\'\"> {{ item.tax.amount | formatDecimal: 2}} </div>\n                <div>\n                  <diff-version ng-if=\"item.diffStatus === \'updated\'\" new-val=\"item.tax.amount\" prev-val=\"item.prevVersion.tax.amount\" line-break=\"true\" filter-decimal=\"2\">\n                  </diff-version>\n                </div>\n              </div>\n\n            </td>\n          </tr>\n\n          <!-- Freight -->\n          <tr ng-if=\"item.diffStatus !== \'updated\' && !!item.freights && !!item.freights.amount\" class=\"tr-freight-transportation\">\n            <td></td>\n            <td>\n              <div class=\"row\">\n                <div class=\"col-md-12 text-left\">\n                  <b>Freight</b>\n                </div>\n              </div>\n            </td>\n            <td colspan=\"2\"></td>\n            <td>\n              <!-- Freight if percentage is true -->\n              <div ng-show=\"!!item.freights\">\n                {{ item.freights.amount | formatDecimal: 2 }}\n              </div>\n            </td>\n\n            <!-- Freight Discount -->\n            <td>\n              <span ng-if=\"!!item.freights.discount_amount\">\n                ({{ item.freights.discount_amount | formatDecimal: 2 }})\n              </span>\n            </td>\n            <!-- Freight Amount -->\n            <td>\n              <span ng-if=\"!!item.freights.amount_with_discount\">\n                {{ item.freights.amount_with_discount | formatDecimal: 2 }}\n              </span>\n            </td>\n            <!-- Freight Tax -->\n            <td>\n              <div>\n                <span>\n                  {{(!!item.freights.tax && !!item.freights.tax._id) ?\n                  (item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') : \'\'}}\n                </span>\n\n                <div ng-if=\"!!item.freights.tax\">\n                  {{ item.freights.tax.amount | formatDecimal: 2}}\n                </div>\n              </div>\n            </td>\n          </tr>\n\n          <tr ng-if=\"item.diffStatus === \'updated\' &&\n                   ((!!item.freights && !!item.freights.amount) || (!!item.prevVersion.freights && !!item.prevVersion.freights.amount))\" class=\"tr-freight-transportation\">\n            <td></td>\n            <td>\n              <div class=\"row\">\n                <div class=\"col-md-12 text-left\">\n                  <b>Freight</b>\n                </div>\n              </div>\n            </td>\n            <td colspan=\"2\"></td>\n            <td>\n              <!-- Freight if percentage is true -->\n              <div ng-show=\"!!item.freights\">\n                <diff-version new-val=\"item.freights.amount\" prev-val=\"item.prevVersion.freights.amount\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </div>\n            </td>\n\n            <!-- Freight Discount -->\n            <td>\n              <diff-version new-val=\"item.freights.discount_amount\" prev-val=\"item.prevVersion.freights.discount_amount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n            <!-- Freight Amount -->\n            <td>\n              <diff-version new-val=\"item.freights.amount_with_discount\" prev-val=\"item.prevVersion.freights.amount_with_discount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n            <!-- Freight Tax -->\n            <td>\n              <div ng-show=\"!!item.freights.tax\">\n                <span ng-if=\"(item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') !==\n                         (item.prevVersion.freights.tax.code + \' \' + item.prevVersion.freights.tax.rate + \'%\')\">\n                  <del ng-if=\"!!item.prevVersion.freights.tax\">\n                    {{ (item.prevVersion.freights.tax.code + \' \' + item.prevVersion.freights.tax.rate + \'%\') }}\n                  </del>\n                  <br ng-if=\"!!item.prevVersion.freights.tax\">\n                  <ins ng-if=\"!!item.freights.tax.code\">\n                    {{ (item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') }}\n                  </ins>\n                </span>\n                <span ng-if=\"(item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') ===\n                         (item.prevVersion.freights.tax.code + \' \' + item.prevVersion.freights.tax.rate + \'%\')\">\n                  {{ (item.freights.tax.code + \' \' + item.freights.tax.rate + \'%\') }}\n                </span>\n\n                <div>\n                  <diff-version new-val=\"item.freights.tax.amount\" prev-val=\"item.prevVersion.freights.tax.amount\" line-break=\"true\" filter-decimal=\"2\">\n                  </diff-version>\n                </div>\n              </div>\n            </td>\n          </tr>\n\n          <!-- Transportation -->\n          <tr ng-if=\"item.diffStatus !== \'updated\' && !!item.transportation && !!item.transportation.amount\" class=\"tr-freight-transportation\">\n            <td></td>\n            <td>\n              <div class=\"row\">\n                <div class=\"col-md-12 text-left\">\n                  <b>Transportation</b>\n                </div>\n              </div>\n            </td>\n            <td colspan=\"2\"></td>\n            <td>\n              <div ng-show=\"!!item.transportation\">\n                {{ item.transportation.amount | formatDecimal: 2 }}\n              </div>\n            </td>\n\n            <!-- transportation Discount -->\n            <td>\n              <span ng-if=\"!!item.transportation.discount_amount\">\n                ({{ item.transportation.discount_amount | formatDecimal: 2 }})\n              </span>\n            </td>\n            <!-- transportation Amount -->\n            <td>\n              <span ng-if=\"!!item.transportation.amount_with_discount\">\n                {{ item.transportation.amount_with_discount | formatDecimal: 2 }}\n              </span>\n            </td>\n            <!-- transportation Tax -->\n            <td>\n              <div>\n                <span>\n                  {{(!!item.transportation.tax && !!item.transportation.tax._id) ?\n                  (item.transportation.tax.code + \' \' + item.transportation.tax.rate + \'%\') : \'\'}}\n                </span>\n\n                <div ng-if=\"!!item.transportation.tax\">\n                  {{ item.transportation.tax.amount | formatDecimal: 2}}\n                </div>\n              </div>\n            </td>\n          </tr>\n\n          <tr ng-repeat-end ng-if=\"item.diffStatus === \'updated\' &&\n                   ((!!item.transportation && !!item.transportation.amount) ||\n                   (!!item.prevVersion.transportation && !!item.prevVersion.transportation.amount))\" class=\"tr-freight-transportation\">\n            <td></td>\n            <td>\n              <div class=\"row\">\n                <div class=\"col-md-12 text-left\">\n                  <b>Transportation</b>\n                </div>\n              </div>\n            </td>\n            <td colspan=\"2\"></td>\n            <td>\n              <!-- transportation if percentage is true -->\n              <div ng-show=\"!!item.transportation\">\n                <diff-version new-val=\"item.transportation.amount\" prev-val=\"item.prevVersion.transportation.amount\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </div>\n            </td>\n\n            <!-- transportation Discount -->\n            <td>\n              <diff-version new-val=\"item.transportation.discount_amount\" prev-val=\"item.prevVersion.transportation.discount_amount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n            <!-- transportation Amount -->\n            <td>\n              <diff-version new-val=\"item.transportation.amount_with_discount\" prev-val=\"item.prevVersion.transportation.amount_with_discount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n            <!-- transportation Tax -->\n            <td>\n              <div ng-show=\"!!item.transportation.tax\">\n                <span ng-if=\"(item.transportation.tax.code + \' \' + item.transportation.tax.rate + \'%\') !==\n                         (item.prevVersion.transportation.tax.code + \' \' + item.prevVersion.transportation.tax.rate + \'%\')\">\n                  <del ng-if=\"!!item.prevVersion.transportation.tax\">\n                    {{ (item.prevVersion.transportation.tax.code + \' \' + item.prevVersion.transportation.tax.rate + \'%\') }}\n                  </del>\n                  <br ng-if=\"!!item.prevVersion.transportation.tax\">\n                  <ins ng-if=\"!!item.transportation.tax.code\">\n                    {{ (item.transportation.tax.code + \' \' + item.transportation.tax.rate + \'%\') }}\n                  </ins>\n                </span>\n                <span ng-if=\"(item.transportation.tax.code + \' \' + item.transportation.tax.rate + \'%\') ===\n                         (item.prevVersion.transportation.tax.code + \' \' + item.prevVersion.transportation.tax.rate + \'%\')\">\n                  {{ (item.transportation.tax.code + \' \' + item.freights.tax.rate + \'%\') }}\n                </span>\n\n                <div>\n                  <diff-version new-val=\"item.transportation.tax.amount\" prev-val=\"item.prevVersion.transportation.tax.amount\" line-break=\"true\" filter-decimal=\"2\">\n                  </diff-version>\n                </div>\n              </div>\n            </td>\n          </tr>\n          </tbody>\n\n          <!-- Total -->\n          <tfoot>\n          <!-- Total Amount, discount and tax -->\n          <tr ng-show=\"!!currentPR.lump_sum_discount || !!prevPR.lump_sum_discount\">\n            <td colspan=\"3\"></td>\n            <!-- Currency -->\n            <td>\n              <diff-version new-val=\"currentPR.currency.code\" prev-val=\"prevPR.currency.code\" line-break=\"true\">\n              </diff-version>\n            </td>\n            <td>\n              <span uib-tooltip=\"Amount\">\n                <diff-version new-val=\"currentPR.amount\" prev-val=\"prevPR.amount\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n            <td>\n              <!-- Discount Total -->\n              <span uib-tooltip=\"Discount\">\n                <diff-version new-val=\"currentPR.discount_total\" prev-val=\"prevPR.discount_total\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n            <td>\n              <span uib-tooltip=\"Total Amount\">\n                <!-- not supported by directive -->\n                <span ng-if=\"(currentPR.amount - currentPR.discount_total) === (prevPR.amount - prevPR.discount_total)\">\n                  {{ (currentPR.amount - currentPR.discount_total) | formatDecimal:2 }}\n                </span>\n                <span ng-if=\"(currentPR.amount - currentPR.discount_total) !== (prevPR.amount - prevPR.discount_total)\">\n                  <del>{{ (currentPR.amount - currentPR.discount_total) | formatDecimal:2 }}</del>\n                  <br>\n                  <ins>{{ (prevPR.amount - prevPR.discount_total) | formatDecimal:2 }}</ins>\n                </span>\n              </span>\n            </td>\n            <td>\n              <span uib-tooltip=\"GST\">\n                <diff-version new-val=\"currentPR.tax_total\" prev-val=\"prevPR.tax_total\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n          </tr>\n\n          <!-- Lump Sum Discount-->\n          <tr ng-show=\"!!currentPR.lump_sum_discount || !!prevPR.lump_sum_discount\">\n            <td></td>\n            <td colspan=\"3\" class=\"text-left\">\n              <small class=\"table-padding text-black\">Lump sum discount</small>\n            </td>\n            <td>\n              <diff-version new-val=\"currentPR.lump_sum_discount\" prev-val=\"prevPR.lump_sum_discount\" line-break=\"true\" filter-decimal=\"2\">\n              </diff-version>\n            </td>\n            <td colspan=\"3\"></td>\n          </tr>\n\n          <!-- Total Amount with lumpsum -->\n          <tr>\n            <td colspan=\"3\"></td>\n            <!-- Currency -->\n            <td>\n              <diff-version new-val=\"currentPR.currency.code\" prev-val=\"prevPR.currency.code\" line-break=\"true\">\n              </diff-version>\n            </td>\n            <td>\n              <span uib-tooltip=\"Amount\">\n                <diff-version new-val=\"currentPR.amount\" prev-val=\"prevPR.amount\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n            <td>\n              <!-- Discount Total -->\n              <span ng-if=\"!!currentPR.discount_total || !!currentPR.lump_sum_discount ||\n                       !!prevPR.discount_total || !!prevPR.lump_sum_discount\" uib-tooltip=\"Discount\">\n                <diff-version new-val=\"currentPR.discount_total\" prev-val=\"prevPR.discount_total\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n            <td>\n              <span uib-tooltip=\"Total Amount\">\n                <span ng-if=\"(currentPR.amount - (currentPR.discount_total + currentPR.lump_sum_discount)) ===\n                              (prevPR.amount - (prevPR.discount_total + prevPR.lump_sum_discount))\">\n                  {{ (currentPR.amount - (currentPR.discount_total + currentPR.lump_sum_discount)) | formatDecimal:2 }}\n                </span>\n                <span ng-if=\"(currentPR.amount - (currentPR.discount_total + currentPR.lump_sum_discount)) !==\n                              (prevPR.amount - (prevPR.discount_total + prevPR.lump_sum_discount))\">\n                  <del>{{ (prevPR.amount - (prevPR.discount_total + prevPR.lump_sum_discount)) | formatDecimal:2 }}</del>\n                  <br>\n                  <ins>{{ (currentPR.amount - (currentPR.discount_total + currentPR.lump_sum_discount)) | formatDecimal:2 }}</ins>\n                </span>\n              </span>\n            </td>\n            <td>\n              <span uib-tooltip=\"GST\">\n                <diff-version new-val=\"currentPR.tax_total\" prev-val=\"prevPR.tax_total\" line-break=\"true\" filter-decimal=\"2\">\n                </diff-version>\n              </span>\n            </td>\n          </tr>\n\n          <!-- Grand Total -->\n          <tr>\n            <td colspan=\"7\" class=\"text-right\"> Total amount inclusive of GST </td>\n            <td>\n              <span class=\"grand-total double-underlines\" uib-tooltip=\"Total amount inclusive of GST\">\n                <span ng-if=\"(currentPR.grand_total === prevPR.grand_total)\">\n                  {{ currentPR.grand_total | formatDecimal:2 }}\n                </span>\n                <span ng-if=\"(currentPR.grand_total !== prevPR.grand_total)\">\n                  <del>{{ prevPR.grand_total | formatDecimal:2 }}</del>\n                  <br>\n                  <ins>{{ currentPR.grand_total | formatDecimal:2 }}</ins>\n                </span>\n              </span>\n            </td>\n          </tr>\n\n          </tfoot>\n        </table>\n\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button type=\"submit\" class=\"btn btn-white\" ng-click=\"close()\">\n      Close\n    </button>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/businessUnits/add/add.html","<div class=\"state_BU_add\">\n<form name=\"BU_detail_form\" ng-submit=\"addBU()\">\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-lg-12\">\n        <div class=\"panel-body\">\n          <fieldset class=\"form-horizontal\">\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Business Unit Name: <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" name=\"BU_name\" type=\"text\" ng-model=\"BU.name\" placeholder=\"(e.g. Property)\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-class=\"{\'highlight-error-input\': !BU.name.length && submitted}\" required>\n                <span class=\"text-danger\" ng-if=\"!!BU_detail_form.BU_name.$error.required && submitted\">\n                  Business Unit name is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Business Unit Code: <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" name=\"BU_code\" type=\"text\" ng-model=\"BU.code\" placeholder=\"(e.g.78707)\" ng-pattern=\"/^[0-9A-Za-z]{0,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z]{0,30}$\" ng-model-options=\"{ debounce: 100 }\" ng-change=\"duplicationCheck(\'BusinessUnit\',\'code\',BU.code,\'code\')\" ng-class=\"{\'highlight-error-input\': (!BU.code.length && submitted) || (BU.code.length && codeCheck)}\" required>\n                <span class=\"text-danger\" ng-if=\"!!BU_detail_form.BU_code.$error.required && submitted\">\n                  Business Unit code is required\n                </span>\n                <span class=\"text-danger\" ng-if=\"BU.code.length && codeCheck\">Business Unit code {{BU.code}} is already taken!</span>\n              </div>\n            </div>\n          </fieldset>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-2\"></div>\n    <div class=\"col-sm-9 m-b\">\n      <div class=\"col-sm-6 update-change\">\n        <a ng-click=\"addBU()\" class=\"btn btn-primary\">Add Business Unit</a>\n        <a ng-click=\"cancelAddBU()\" class=\"btn btn-white\">Cancel</a>\n      </div>\n      <div class=\"col-sm-6 change-action\">\n      </div>\n    </div>\n  </div>\n</form>\n</div>\n");
$templateCache.put("app/companiesManagement/businessUnits/details/details.html","<div class=\"wrapper wrapper-content animated fadeInRight\" xmlns=\"http://www.w3.org/1999/html\">\n  <div class=\"state_BU_details\">\n    <span class=\"back-buttons\">\n      <a ng-click=\"back()\" class=\"btn btn-default\">\n        <i class=\"fa fa-chevron-left\"></i> Back\n      </a>\n    </span>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"ibox float-e-margins\">\n            <div class=\"ibox-title\">\n              <h5>Business Unit Details</h5>\n            </div>\n            <div class=\"ibox-content\">\n              <form method=\"get\" name=\"businessUnit\" class=\"form-horizontal\">\n                <div class=\"form-group\">\n                  <label class=\"col-sm-2 control-label\">Last updated</label>\n                  <div class=\"col-sm-10 form-only-text\">\n                    {{ BUDetails.updated_at | date:\'dd MMM yyyy h:mm a\' }}\n                  </div>\n                </div>\n                <div class=\"hr-line-dashed\"></div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-2 control-label\">Code</label>\n                  <div class=\"col-sm-10\">\n                    <input type=\"text\" ng-model=\"BUDetails.code\" class=\"form-control\" readonly=\"readonly\">\n                  </div>\n                </div>\n                <div class=\"hr-line-dashed\"></div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-2 control-label\">Description</label>\n                  <div class=\"col-sm-10\" ng-class=\"{\'highlight-error-input\': !BUDetails.descr.length && submitted}\">\n                    <div class=\"form-only-text\" ng-show=\"!editBu\">\n                      {{ BUDetails.descr }}\n                    </div>\n                    <input type=\"text\" ng-model=\"newBUDetails.descr\" ng-show=\"editBu\" class=\"form-control\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" required>\n                    <span class=\"text-danger\" ng-if=\"!newBUDetails.descr.length && submitted\">\n                      Business Unit\'s name is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"hr-line-dashed\"></div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-2 control-label\">Companies</label>\n                  <div class=\"col-sm-10 form-only-text\">\n                    <a ui-sref=\"main.user.companiesMgmt.manageCompanies({ bu_code: BUDetails.code })\">\n                      View Companies under this Business Unit\n                    </a>\n                  </div>\n                </div>\n\n                <div class=\"hr-line-dashed\"></div>\n                <div class=\"form-group\">\n                  <label class=\"col-sm-2 control-label\">Status</label>\n                  <div class=\"col-sm-10\">\n                    <div class=\"form-only-text\" ng-show=\"!editBu\">\n                      {{ getStatusTextualRepresentation(BUDetails.is_active) }}\n                    </div>\n                    <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-show=\"editBu\" ng-options=\"option.id as option.label for option in buStatuses\" ng-model=\"newBUDetails.is_active\" required></select>\n                    <span class=\"text-danger\" ng-if=\"newBUDetails.is_active !== 0 && newBUDetails.is_active !== 1  && submitted\" ng-show=\"editBu\">\n                      Business Unit\'s status is required\n                    </span>\n                  </div>\n                </div>\n\n                <div class=\"hr-line-dashed\"></div>\n                <div class=\"form-group\">\n                  <div class=\"col-sm-4 col-sm-offset-2\">\n                    <!--<button class=\"btn btn-danger\"-->\n                            <!--ng-show=\"!editBu\"-->\n                            <!--type=\"button\" ng-click=\"deleteBu()\">-->\n                      <!--Delete-->\n                    <!--</button>-->\n                    <button class=\"btn btn-info\" ng-show=\"!editBu\" type=\"button\" ng-click=\"editableBu()\">\n                      Edit\n                    </button>\n                    <button class=\"btn btn-primary\" ng-show=\"!!editBu\" type=\"submit\" ng-click=\"updateChanges()\">\n                      Save Changes\n                    </button>\n                    <button class=\"btn btn-white\" ng-click=\"cancelUpdate()\" ng-show=\"!!editBu\">\n                      Cancel\n                    </button>\n                  </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/businessUnits/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Business Units</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <master-export module-name=\"Business Units\" collection=\"20\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"importBU()\">\n        Import Business Units\n      </button>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingBUService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"BU\" class=\"table\" ng-class=\"{\'table-hover\' : BUs.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n        <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n          <td colspan=\"9\">There are no business units.</td>\n        </tr>\n        <tr ng-repeat=\"BU in dataList track by $index\" ui-sref=\"main.user.companiesMgmt.detailBusinessUnits({ id: BU._id })\" fadeout-row=\"BU._id == highlightId\">\n          <td ng-if=\"showColumn(\'descr\')\">\n            {{BU.descr}}\n          </td>\n          <td ng-if=\"showColumn(\'code\')\">\n            {{BU.code}}\n          </td>\n          <td ng-if=\"showColumn(\'created_at\')\">\n            {{BU.created_at | date : \'dd MMM yyyy\'}}\n          </td>\n          <td ng-if=\"showColumn(\'updated_at\')\">\n            {{BU.updated_at | date : \'dd MMM yyyy\'}}\n          </td>\n          <td ng-if=\"showColumn(\'is_active\')\">\n            {{ getTextualIsActive(BU.is_active) }}\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/companies/accountCode/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ companyDetails.descr }}\n      </span>\n    </div>\n  </div>\n</div>\n<account-codes data=\"accountCodes\" code=\"companyDetails.code\" cost-centers=\"companyDetails.costCenters\"></account-codes>\n");
$templateCache.put("app/companiesManagement/companies/add/add.html","<div class=\"state_company_add\">\n<form name=\"company_detail_form\" ng-submit=\"addCompany()\" novalidate>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-lg-12\">\n        <div class=\"panel-body\">\n          <fieldset class=\"form-horizontal\">\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Name: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" name=\"company_name\" type=\"text\" ng-model=\"company.name\" placeholder=\"(e.g. Sunway Management Sdn Bhd)\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-class=\"{\'highlight-error-input\': !company.name.length && submitted}\" required>\n                <span class=\"text-danger\" ng-if=\"!!company_detail_form.company_name.$error.required && submitted\">\n                  Company name is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Code: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" name=\"company_code\" type=\"text\" ng-model=\"company.code\" ng-model-options=\"{ debounce: 100 }\" placeholder=\"(e.g.6803)\" ng-pattern=\"/^[0-9A-Za-z]{0,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z]{0,10}$\" ng-change=\"duplicationCheck(\'Company\',\'code\',company.code,\'code\')\" ng-class=\"{\'highlight-error-input\': (!company.code.length && submitted) ||\n                    (company.code.length && codeCheck)}\" required>\n                <span class=\"text-danger\" ng-if=\"!!company_detail_form.company_code.$error.required && submitted\">\n                  Company code is required\n                </span>\n                <span class=\"text-danger\" ng-if=\"company.code.length && codeCheck\">\n                  Company code {{company.code}} is already taken!\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Parent Company: </label>\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"company.parent_company_id\" search-enabled=\"true\" theme=\"bootstrap\">\n                  <ui-select-match placeholder=\"Select parent company...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"parent in parentCompanies | filter: $select.search\">\n                    <div ng-bind-html=\"parent.descr | highlight: $select.search\"></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Company Reg No: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" type=\"text\" name=\"company_reg_no\" ng-model=\"company.reg_no\" placeholder=\"(e.g. 3813-K)\" ng-pattern=\"/^[0-9A-Za-z-]{0,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z-]{0,30}$\" ng-change=\"duplicationCheck(\'Company\',\'reg_no\',company.reg_no,\'roc\')\" ng-class=\"{\'highlight-error-input\':\n                   (!company.reg_no.length && submitted) || (company.reg_no.length && rocCheck)}\" required>\n                <span class=\"text-danger\" ng-if=\"!!company_detail_form.company_reg_no.$error.required && submitted\">\n                  Company Reg No is required\n                </span>\n                <span class=\"text-danger\" ng-if=\"company.reg_no.length && rocCheck\">\n                  Company reg no. {{company.reg_no}} is already taken!\n                </span>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <label class=\"col-sm-2 control-label\">\n                Corresponding Address <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9 m-b\">\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"corresponding_address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !corresponding_address.line1 && submitted}\" required>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.line1 && submitted\">\n                      An address line is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-8 m-b\">\n                    <input type=\"text\" ng-model=\"corresponding_address.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n                  </div>\n                  <div class=\"col-lg-4 m-b\">\n                    <input type=\"text\" ng-model=\"corresponding_address.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-4 m-b\">\n                    <input type=\"text\" ng-model=\"corresponding_address.postal_code\" placeholder=\"Post Code\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !corresponding_address.postal_code && submitted}\" required>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.postal_code && submitted\">\n                      A postal code is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-4 m-b\">\n                    <input type=\"text\" ng-model=\"corresponding_address.city\" placeholder=\"City\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z-_\'/:;,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z-_\'/:;,.\\s]{0,50}$\" ng-class=\"{\'highlight-error-input\': !corresponding_address.city && submitted}\" required>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.city && submitted\">\n                      A city is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-4 m-b\">\n                    <ui-select ng-model=\"corresponding_address.Country\" on-select=\"onSelectedCountry(corresponding_address.Country)\" ng-class=\"{\'highlight-error-input\': !corresponding_address.Country && submitted}\" required>\n                      <ui-select-match placeholder=\"Select a Country\">\n                        {{$select.selected.descr}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"countrys in countries | filter: $select.search\">\n                        <span ng-bind-html=\"countrys.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.Country && submitted\">\n                    A Country is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-4 m-b\" ng-if=\"!!selectedMalaysia\">\n                   <ui-select ng-model=\"corresponding_address.state\" on-select=\"onSelectedState(corresponding_address.state)\" ng-class=\"{\'highlight-error-input\': !corresponding_address.state && submitted}\" required>\n                      <ui-select-match placeholder=\"Select a state\">\n                      {{$select.selected}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                        <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                   </ui-select>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.state && submitted\">\n                    A state is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-4 m-b\" ng-if=\"!selectedMalaysia\">\n                    <input type=\"text\" ng-model=\"corresponding_address.state\" placeholder=\"State\" class=\"form-control\" ng-pattern=\"/^[a-zA-Z-_\'/:;,.\\s]{2,}$/\" ng-pattern-restrict=\"^[a-zA-Z-_\'/:;,.\\s]{0,50}$\" ng-class=\"{\'highlight-error-input\': !corresponding_address.state && submitted}\" required>\n                    <span class=\"text-danger\" ng-show=\"!corresponding_address.state && submitted\">\n                      A state is required\n                    </span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                GST/VAT Reg No:\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" type=\"text\" name=\"company_gst_code\" ng-model=\"company.gst_code\" placeholder=\"(e.g. 000504664064)\" ng-pattern=\"/^[0-9-/]{0,}$/\" ng-pattern-restrict=\"^[0-9-/]{0,30}$\" ng-change=\"duplicationCheck(\'Company\',\'gst_code\',company.gst_code,\'gst\')\" ng-class=\"{\'highlight-error-input\': (company.gst_code.length && gstCheck)}\">\n                <span class=\"text-danger\" ng-if=\"company.gst_code.length && gstCheck\">\n                  GST/VAT reg no. {{company.gst_code}} is already taken!\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Business Unit: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"selected_options.bu.selected\" search-enabled=\"true\" theme=\"bootstrap\" on-select=\"onSelectedBU(selected_options.bu.selected)\" ng-class=\"{\'highlight-error-input\': !selected_options.bu.selected && submitted}\" required>\n                  <ui-select-match placeholder=\"Select business unit...\">\n                    {{::$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"bu in BU | filter: $select.search\">\n                    <span ng-bind-html=\"bu.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n                 <span class=\"text-danger\" ng-if=\"_.isEmpty(selected_options.bu.selected) && submitted\">\n                  Business unit is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Industry:\n              </label>\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"selected_options.industry.selected\" search-enabled=\"true\" theme=\"bootstrap\" on-select=\"onSelectedIndustry(selected_options.industry.selected)\">\n                  <ui-select-match placeholder=\"Select industry...\">\n                    {{::$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"industry in industries | filter: $select.search\">\n                    <span ng-bind-html=\"industry.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Expense Type: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\" ng-class=\"{\'highlight-error-input\': !selectedExpenseTypes && submitted}\">\n                <div ng-if=\"!!selectedExpenseTypes && !!selectedExpenseTypes.length\" class=\"selected-option\">\n                  <span ng-repeat=\"expenseType in selectedExpenseTypes | limitTo: 5\">\n                    <span ng-class=\"{\'dark-grey\' : $odd }\">{{ expenseType.descr }}</span>\n                    <span ng-if=\"!$last\">, </span>\n                  </span>\n                    <span ng-if=\"selectedExpenseTypes.length > 5\">\n                    ,\n                    <modal-more type=\"array\" title=\"{{company.name}}\" subtitle=\"Selected Expense Types\" data=\"selectedExpenseTypes\" filter=\"[\'code\', \'descr\']\">\n                      <a>more</a>\n                    </modal-more>\n                  </span>\n                </div>\n\n                <div ng-dropdown-multiselect options=\"expenseTypes\" selected-model=\"selectedExpenseTypes\" extra-settings=\"extraSettingExpenseTypes\" events=\"selectExpenseTypes\" class=\"company-select-currencies\">\n                </div>\n\n                <span class=\"text-danger\" ng-if=\"_.isEmpty(selectedExpenseTypes) && submitted\">\n                  Expense type is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Currencies: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\" ng-class=\"{\'highlight-error-input\': !selectedCurrencies && submitted}\">\n\n                <div class=\"horizontal-repeat\" ng-repeat=\"selected_currency in selectedCurrencies | limitTo: 10\">\n                  <div class=\"col-sm-1\">{{selected_currency.code}}</div>\n                </div>\n\n                <div class=\"horizontal-repeat\" ng-if=\"selectedCurrencies.length > 10\">\n                  <div class=\"col-sm-1\">\n                    <modal-more type=\"array\" title=\"{{company.name}}\" subtitle=\"Selected Currencies\" data=\"selectedCurrencies\" filter=\"[\'code\', \'descr\']\">\n                      <a>more</a>\n                    </modal-more>\n                  </div>\n                </div>\n\n                <div ng-dropdown-multiselect=\"\" options=\"companyCurrencies\" selected-model=\"selectedCurrencies\" extra-settings=\"extraSettingCurrencies\" events=\"selectCurrencies\" class=\"company-select-currencies\">\n                </div>\n\n                <span class=\"text-danger\" ng-if=\"_.isEmpty(selectedCurrencies) && submitted\">\n                  Currency is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Preferred Currency: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\" ng-class=\"{\'highlight-error-input\': !selectedPreferredCurrency && submitted}\">\n\n                <div class=\"horizontal-repeat\">\n                    <span class=\"col-sm-1\">{{selectedPreferredCurrency.code}}</span>\n                </div>\n\n                <div ng-dropdown-multiselect=\"\" options=\"selectedCompanyCurrencies\" selected-model=\"selectedPreferredCurrency\" extra-settings=\"extraSettingPreferredCurrencies\" class=\"company-select-currencies\">\n                </div>\n\n                <span class=\"text-danger\" ng-if=\"_.isEmpty(selectedPreferredCurrency) && submitted\">\n                  Preferred Currency is required\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Phone: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" type=\"text\" name=\"phone\" ng-model=\"company.phone\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^([0-9-+\\s]{0,50})$\" placeholder=\"(e.g. 012-34567890 or +0659437688)\" ng-class=\"{\'highlight-error-input\': !company.phone.length && submitted}\" required>\n                <span class=\"text-danger\" ng-if=\"company_detail_form.phone.$error.required && submitted\">\n                  Phone number is required\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Fax:\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" type=\"text\" name=\"fax\" ng-model=\"company.fax\" placeholder=\"(e.g. +44 161 999 8888)\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^[0-9-+\\s]{0,50}$\">\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Set PO Initial Status: </label>\n              <div class=\"col-sm-9\">\n\n                <ui-select ng-model=\"company.PO_initial_status\" search-enabled=\"true\">\n                  <ui-select-match placeholder=\"Select PO Initial Status...\">\n                    {{$select.selected.descr}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"status in POInitialStatuses | filter: $select.search\">\n                    <div ng-bind-html=\"status.descr | highlight: $select.search\"></div>\n                  </ui-select-choices>\n                </ui-select>\n\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Approver Hold PR: </label>\n              <div class=\"col-sm-9\">\n                <div class=\"col-sm-8\">\n                  <input icheck type=\"checkbox\" class=\"form-control\" id=\"add-allowedToHoldPR\" ng-model=\"company.allowedToHoldPR\">\n                  <label for=\"add-allowedToHoldPR\">Yes, Approver is able to Hold PR</label>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Company Email: <span class=\"asterisk-required\">*</span>\n              </label>\n              <div class=\"col-sm-9\">\n                <input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"company.email\" placeholder=\"(e.g. sunway@sunway.com)\" ng-pattern=\"/^[A-Za-z0-9-_.]{1,}@{1}\\w{1,}[.]{1}[A-Za-z0-9-_.]{2,}$/\" ng-pattern-restrict=\"^([A-Za-z0-9-_.]{0,20}@?\\w{0,20}[.]?[A-Za-z0-9-_.]{0,20})$\" ng-class=\"{\'highlight-error-input\': !company.email.length && submitted}\" required>\n                <span class=\"text-danger\" ng-if=\"company_detail_form.email.$error.required && submitted\">\n                  Email is required\n                </span>\n                <span class=\"text-danger\" ng-if=\"company_detail_form.email.$dirty &&\n                      company_detail_form.email.$error.email\">\n                  Email is incorrect\n                </span>\n                <span class=\"text-danger\" ng-if=\"company_detail_form.email.$dirty &&\n                      response_error.email.length && submitted\">\n                  {{response_error.email}}\n                </span>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">\n                Company Picture:\n              </label>\n              <div class=\"col-sm-9\">\n                <input type=\"file\" file-model=\"companyFile\">\n              </div>\n            </div>\n          </fieldset>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-2\"></div>\n    <div class=\"col-sm-9 m-b\">\n      <div class=\"col-sm-6 update-change\">\n        <a ng-click=\"addNewCompany()\" class=\"btn btn-primary\">Add Company</a>\n        <a ng-click=\"cancelAddCompany()\" class=\"btn btn-white\">Cancel</a>\n      </div>\n      <div class=\"col-sm-6 change-action\">\n      </div>\n    </div>\n  </div>\n</form>\n</div>\n");
$templateCache.put("app/companiesManagement/companies/content/content.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ companyDetails.descr }}\n      </span>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n  <div class=\"ibox float-e-margins\">\n    <div class=\"ibox-title\">\n      <h5>Terms and Conditions</h5>\n    </div>\n    <div class=\"ibox-content\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <div class=\"col-md-6\">\n            <h3>\n              <input type=\"radio\" ng-model=\"termsAndConditionsLevel\" ng-value=\"\'tenant\'\">\n              Default (Tenant level)\n            </h3>\n          </div>\n          <div class=\"col-md-6\">\n            <h3>\n              <input type=\"radio\" ng-model=\"termsAndConditionsLevel\" ng-value=\"\'company\'\">\n              Custom\n            </h3>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <div class=\"ibox\">\n            <div class=\"ibox-content\">\n              <textarea id=\"test\" placeholder=\"Default terms and conditions\" type=\"text\" ng-model=\"tenantTermsAndConditions\" class=\"form-control terms-and-conditions-class\" rows=\"5\" cols=\"10\" readonly=\"readonly\" wrap=\"hard\">\n             </textarea>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-6\">\n          <div class=\"ibox\">\n            <div class=\"ibox-content\">\n             <textarea placeholder=\"Set custom terms and conditions\" type=\"text\" ng-model=\"customTermsAndConditions\" class=\"form-control terms-and-conditions-class\" rows=\"5\" cols=\"10\" max-length=\"255\" wrap=\"hard\" ng-disabled=\"termsAndConditionsLevel != \'company\'\">\n             </textarea>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"ibox-content text-center\">\n        <div class=\"buttons\">\n          <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"saveTermsAndConditions(termsAndConditionsLevel, customTermsAndConditions, false)\">\n            Save\n          </button>\n          <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"saveTermsAndConditions(termsAndConditionsLevel, customTermsAndConditions, true)\">\n            Save and Preview\n          </button>\n          <button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"back()\">\n            Cancel\n          </button>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/companies/details/details.html","<div class=\"container-fluid gray-bg list-user-control-fixed-top state-user-profile\" ui-scrollfix>\n  <div class=\"row animated fadeInRight\" ng-show=\"!isCostCenterMode()\">\n    <div class=\"col-md-12 mb-10\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ companyDetails.descr }}\n      </span>\n    </div>\n\n    <div class=\"col-lg-3\">\n      <div class=\"widget style1 lazur-bg cursor-pointer\" ui-sref=\"main.user.companiesMgmt.companiesUsers({id: companyDetails._id, code: companyDetails.code, cursor: null})\">\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <i class=\"fa fa-users fa-5x\"></i>\n          </div>\n          <div class=\"col-xs-8 text-right\">\n            <span> Company\'s </span>\n            <h3 class=\"font-bold widget-font\">Users</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-lg-3\">\n      <div class=\"widget style1 yellow-bg cursor-pointer\" ui-sref=\"main.user.companiesMgmt.companiesAccountCode({id: companyDetails._id, cursor: null})\">\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <i class=\"fa fa-book fa-5x\"></i>\n          </div>\n          <div class=\"col-xs-8 text-right\">\n            <span> Company\'s </span>\n            <h3 class=\"font-bold widget-font\">Account Codes</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-lg-3\">\n      <div class=\"widget style1 navy-bg cursor-pointer\" ui-sref=\"main.user.companiesMgmt.companiesExchangeRate({id: companyDetails._id})\">\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <i class=\"fa fa-usd fa-5x\"></i>\n          </div>\n          <div class=\"col-xs-8 text-right\">\n            <span> Company\'s </span>\n            <h3 class=\"font-bold widget-font\">Exchange Rates</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-lg-3\">\n      <div class=\"widget style1 blue-bg cursor-pointer\" ui-sref=\"main.user.companiesMgmt.companiesContent({id: companyDetails._id})\">\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <i class=\"fa fa-file-text fa-5x\"></i>\n          </div>\n          <div class=\"col-xs-8 text-right\">\n            <span> Company\'s </span>\n            <h3 class=\"font-bold widget-font\">Contents</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-md-6\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5> Company Detail </h5>\n        </div>\n        <form editable-form name=\"editableForm\" onaftersave=\"saveCorrespondingAddressChanges()\" novalidate>\n          <div class=\"ibox-content no-padding border-left-right text-center\">\n            <div flow-init flow-object=\"flowConfig\" flow-file-added=\"!!{png:1,jpg:1,jpeg:1}[$file.getExtension()]\" flow-files-submitted=\"$flow.upload()\" flow-file-success=\"isUploadImageSuccess($file, $message, $flow);\">\n              <div flow-btn ng-if=\"$flow.files[0]\">\n                <img class=\"profile-avatar\" flow-img=\"$flow.files[0]\">\n              </div>\n              <div flow-btn ng-if=\"$flow.isUploading()\">\n                Uploading...\n              </div>\n              <div flow-btn ng-if=\"!$flow.files[0]\">\n                <img class=\"profile-avatar\" image-error=\"assets/images/default-user.png\" ng-src=\"{{imageBasePath}}/{{companyDetails.img_url}}\">\n              </div>\n            </div>\n          </div>\n          <div class=\"ibox-content profile-content\">\n            <div class=\"form-horizontal\">\n              <div class=\"form-group\">\n                <label class=\"col-md-3 label-select\">Name:</label>\n                <div class=\"col-md-8\">\n                  <span editable-text=\"companyDetails.descr\" e-placeholder=\"Enter name\" e-required>\n                    {{ companyDetails.descr || \"-\" }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 label-select\">Code:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span>\n                    {{ companyDetails.code || \"-\" }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 label-select\">Reg No:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span>\n                    {{ companyDetails.reg_no || \"-\" }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 label-select\">GST Reg No:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                 <span e-ng-pattern=\"/^[0-9-/]{0,}$/\" e-ng-pattern-restrict=\"^[0-9-/]{0,30}$\" editable-text=\"companyDetails.gst_code\" e-placeholder=\"GST registration number\" e-ng-change=\"duplicationCheck(\'Company\',\'gst_code\', $data ,\'gst\')\">\n                  {{ companyDetails.gst_code || \"-\" }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3\">Set Printing Logo: </label>\n                <div class=\"col-sm-8\">\n                  <span editable-select=\"companyDetails.print_logo\" e-ng-options=\"print.descr for print in printLogoOptions track by print.value\">\n                    {{ getPrintLogoSetting(companyDetails.print_logo) }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3\">Set PO initial Status: </label>\n                <div class=\"col-sm-8\">\n                  <span editable-select=\"companyDetails.PO_initial_status\" e-ng-options=\"status.descr for status in POInitialStatuses\">\n                    {{ companyDetails.PO_initial_status.descr }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3\">Hold PR :</label>\n                <span class=\"col-sm-8\" ng-if=\"!editableForm.$visible\">\n                  {{loadApproverOptions()}}\n                </span>\n                <div class=\"col-sm-8\" ng-if=\"!!editableForm.$visible\">\n                  <input icheck type=\"checkbox\" class=\"form-control\" id=\"add-allowedToHoldPR\" ng-model=\"companyDetails.config.allowedToHoldPR\">\n                  <label for=\"add-allowedToHoldPR\">Yes, Approver is able to Hold PR</label>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3\">Parent Company: </label>\n                <div class=\"col-sm-8\">\n                  <span editable-select=\"companyDetails.parent_company[0]._id\" onshow=\"loadParentCompany()\" e-ng-options=\"pc._id as pc.descr for pc in parentCompany\">\n                    {{ companyDetails.parent_company[0].descr || \"-\" }}\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Expense Types:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span>\n                    <ul class=\"unstyled\" ng-repeat=\"expenseType in companyDetails.expense_types  | limitTo: 5 track by $index\">\n                      <li>\n                        {{expenseType.descr}}\n                      </li>\n                    </ul>\n                    <span ng-if=\"companyDetails.expense_types.length > 5\">\n                      <modal-more type=\"array\" title=\"{{companyDetails.descr}}\" subtitle=\"Selected Expense Types\" data=\"companyDetails.expense_types\" filter=\"[\'code\', \'descr\']\">\n                        <a>more</a>\n                      </modal-more>\n                    </span>\n                  </span>\n\n                  <div ng-dropdown-multiselect=\"\" options=\"expenseTypes\" ng-if=\"!!editableForm.$visible\" selected-model=\"companyDetails.expense_types\" extra-settings=\"extraSettingCurrencies\" e-required class=\"company-select-currencies edit-company\">\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Currencies:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span>\n                    <ul class=\"unstyled\" ng-repeat=\"currency in companyCurrencies  | limitTo: 10 track by $index\">\n                      <li>\n                        {{currency.code}}\n                      </li>\n                    </ul>\n                    <span ng-if=\"companyCurrencies.length > 10\">\n                      <modal-more type=\"array\" title=\"{{companyDetails.descr}}\" subtitle=\"Selected Currencies\" data=\"companyCurrencies\" filter=\"[\'code\', \'descr\']\">\n                        <a>more</a>\n                      </modal-more>\n                    </span>\n                  </span>\n\n                  <div ng-dropdown-multiselect=\"\" options=\"currencies\" ng-if=\"!!editableForm.$visible\" selected-model=\"companyCurrencies\" extra-settings=\"extraSettingCurrencies\" events=\"selectCurrencies\" e-required class=\"company-select-currencies edit-company\">\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Preferred Currency:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span>\n                    {{ selectedPreferredCurrency.code }}\n                  </span>\n                  <div ng-dropdown-multiselect=\"\" ng-if=\"!!editableForm.$visible\" options=\"preferredCurrencyList\" e-required selected-model=\"selectedPreferredCurrency\" extra-settings=\"extraSettingPreferredCurrencies\" class=\"company-select-currencies edit-company\">\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Company Email:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span editable-text=\"companyDetails.email\" e-placeholder=\"Enter company email\" e-required>\n                    {{ companyDetails.email }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Fax:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span editable-text=\"companyDetails.fax\" e-placeholder=\"Enter fax\">\n                    {{ companyDetails.fax }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">Phone:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <span editable-text=\"companyDetails.phone\" e-placeholder=\"Enter phone number\" e-required>\n                    {{ companyDetails.phone }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3\">\n                  Corresponding Address:\n                </label>\n                  <div class=\"col-md-8\">\n                    <span editable-text=\"companyDetails.corresponding_address.line1 \" e-required e-placeholder=\"Corresponding Address Line 1\">\n                      {{ companyDetails.corresponding_address.line1  }}\n                    </span>\n                  </div>\n                  <div class=\"col-md-3\" ng-if=\"!!companyDetails.corresponding_address.line2 || (editableForm.$visible)\">\n                  </div>\n                  <div class=\"col-md-8\" ng-if=\"!!companyDetails.corresponding_address.line2 || (editableForm.$visible)\">\n                    <span editable-text=\"companyDetails.corresponding_address.line2 \" e-placeholder=\"Corresponding Address Line 2\">\n                      {{ companyDetails.corresponding_address.line2  }}\n                    </span>\n                  </div>\n                  <div class=\"col-md-3\" ng-if=\"!!companyDetails.corresponding_address.line3 || (editableForm.$visible)\">\n                  </div>\n                  <div class=\"col-md-8\" ng-if=\"!!companyDetails.corresponding_address.line3 || (editableForm.$visible)\">\n                    <span editable-text=\"companyDetails.corresponding_address.line3 \" e-placeholder=\"Corresponding Address Line 3\">\n                      {{ companyDetails.corresponding_address.line3  }}\n                    </span>\n                  </div>\n                <div class=\"col-md-3\" ng-if=\"!editableForm.$visible\"></div>\n                <div class=\"col-md-8\" ng-if=\"!editableForm.$visible\">\n                  {{ companyDetails.corresponding_address.postal_code  }}\n                  {{ companyDetails.corresponding_address.city  }},\n                  {{ companyDetails.corresponding_address.state  }},\n                  {{ companyDetails.corresponding_address.country  }}\n                </div>\n                <div class=\"col-md-3\"></div>\n                  <div class=\"col-md-4\">\n                   <span editable-text=\"companyDetails.corresponding_address.postal_code\" e-required e-placeholder=\"Postal code\">\n                   </span>\n                  </div>\n                  <div class=\"col-md-4\">\n                    <span editable-text=\"companyDetails.corresponding_address.city \" e-required e-placeholder=\"City\">\n                    </span>\n                  </div>\n                <div class=\"col-md-3\"></div>\n                  <div class=\"col-md-4\" ng-show=\"!!editableForm.$visible\">\n                    <span editable-select=\"companyDetails.corresponding_address.country\" e-ng-options=\"countrys.descr as countrys.descr for countrys in countries\" e-ng-change=\"onSelectedCountry(this,companyDetails.corresponding_address.country)\">\n                    {{ companyDetails.corresponding_address.country }}\n                    </span>\n                  </div>\n                  <div class=\"col-md-4\" ng-if=\"!!selectedMalaysia\" ng-show=\"!!editableForm.$visible\">\n                    <span editable-select=\"companyDetails.corresponding_address.state\" e-ng-change=\"onSelectedState(this,companyDetails.corresponding_address.state)\" e-ng-options=\"MYState.descr as MYState.descr for MYState in MYStates\">\n                    {{ companyDetails.corresponding_address.state }}\n                    </span>\n                  </div>\n                  <div class=\"col-md-4\" ng-if=\"!selectedMalaysia\" ng-show=\"!!editableForm.$visible\">\n                    <span editable-text=\"companyDetails.corresponding_address.state\" e-required e-placeholder=\"State\">\n                    </span>\n                  </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"ibox-content text-center\">\n            <div class=\"buttons\">\n              <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"editableForm.$show()\" ng-show=\"!editableForm.$visible\">\n                Edit\n              </button>\n              <span ng-show=\"editableForm.$visible\">\n                <button type=\"submit\" class=\"btn btn-sm btn-primary\" ng-disabled=\"editableForm.$invalid || editableForm.$waiting\">\n                  Save\n                </button>\n                <button type=\"button\" class=\"btn btn-sm btn-white\" ng-disabled=\"editableForm.$waiting\" ng-click=\"editableForm.$cancel()\">\n                  Cancel\n                </button>\n              </span>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Cost Centers</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <div class=\"col-sm-12 col-xs-12\" ng-show=\"companyDetails.costCenters.length > 0\">\n                <input type=\"text\" placeholder=\"Search cost center\" ng-model=\"searchCostCenter\" class=\"input form-control mb-10\">\n                <div class=\"cost-center-box\">\n                  <div class=\"table-responsive\">\n                    <table class=\"table table-striped table-hover\">\n                      <tbody>\n                      <tr ng-repeat=\"costCenter in companyDetails.costCenters |\n                                     filter: searchCostCenter | orderBy: \'-updated_at.sec\'\">\n                        <td ng-click=\"costCenterDetails(costCenter._id)\">\n                          <a class=\"client-link\">\n                            {{ costCenter.code }} - {{ costCenter.descr }}\n                          </a>\n                        </td>\n                      </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-md-12\" ng-show=\"companyDetails.costCenters.length === 0\">\n                No Cost Center\n              </div>\n              <div class=\"col-md-12\">\n                <div class=\"hr-line-dashed\"></div>\n                <button class=\"btn btn-primary btn-block\" type=\"button\" ng-click=\"addCostCenterModal()\">\n                  Add cost center\n                </button>\n                <button class=\"btn btn-primary btn-block\" type=\"button\" ng-click=\"importCostCentersModal()\">\n                  Import cost centers\n                </button>\n                <master-export module-name=\"cost centers\" collection=\"2\">\n                </master-export>\n                <button class=\"btn btn-primary btn-block\" type=\"button\" ng-click=\"exportCostCenterAddresses()\">\n                  Export cost center addresses\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Other information</h5>\n          <div class=\"pull-right\">\n            <a ng-click=\"editableFormBu.$show()\" ng-show=\"!editableForm.$visible\" class=\"btn btn-white btn-xs\">Edit</a>\n          </div>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"form-horizontal\">\n            <form editable-form name=\"editableFormBu\" onaftersave=\"saveBu(companyDetails)\" novalidate>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 col-xs-3\">Business Unit:</label>\n                <div class=\"col-sm-9 col-xs-9\">\n                  <span editable-select=\"companyDetails.business_unit.code\" e-ng-options=\"c.code as c.descr for c in BUs\" e-required>\n                    {{ loadBUs() }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 col-xs-3\">Industry:</label>\n                <div class=\"col-sm-9 col-xs-9\">\n                  <span editable-select=\"companyDetails.industry.code\" e-ng-options=\"c.code as c.descr for c in industries\">\n                    {{ loadIndustry() }}\n                  </span>\n                </div>\n              </div>\n              <div class=\"text-center\">\n                <span ng-show=\"editableFormBu.$visible\">\n                  <button type=\"submit\" class=\"btn btn-sm btn-primary\" ng-disabled=\"editableFormBu.$invalid || editableFormBu.$waiting\">\n                    Save\n                  </button>\n                  <button type=\"button\" class=\"btn btn-sm btn-white\" ng-disabled=\"editableFormBu.$waiting\" ng-click=\"editableFormBu.$cancel()\">\n                    Cancel\n                  </button>\n                </span>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n      <company-billing-options company=\"companyDetails\">\n      </company-billing-options>\n\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Budget Settings</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"form-horizontal\">\n            <form editable-form name=\"editableBudgetSetting\" onaftersave=\"saveBudgetSetting(companyDetails)\" novalidate>\n              <label>Budget Module : </label>\n              <div class=\"form-group\">\n                <div class=\"col-sm-2 col-xs-2\">\n                  <div class=\"onoffswitch\">\n                    <input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"budgetModule\" ng-model=\"budgetModuleToggle\" ng-change=\"budgetSettingToggle(\'module\')\">\n                    <label class=\"onoffswitch-label\" for=\"budgetModule\">\n                      <span class=\"onoffswitch-inner\"></span>\n                      <span class=\"onoffswitch-switch\"></span>\n                    </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-10 col-xs-10\">\n                  <span>\n                    Use budget module\n                  </span>\n                </div>\n              </div>\n              <label>PR Exceed Budget : </label>\n              <div class=\"form-group\">\n                <div class=\"col-sm-2 col-xs-2\">\n                  <div class=\"onoffswitch\">\n                    <input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"exceedBudget\" ng-model=\"budgetExceedToggle\" ng-disabled=\"!budgetModuleToggle\">\n                    <label class=\"onoffswitch-label\" for=\"exceedBudget\">\n                      <span class=\"onoffswitch-inner\"></span>\n                      <span class=\"onoffswitch-switch\"></span>\n                    </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-10 col-xs-10\">\n                  Allow PR to Exceed Budget\n                </div>\n              </div>\n              <label>Budget Notifications Setting : </label>\n              <div class=\"form-group\">\n                <div class=\"col-sm-2 col-xs-2\">\n                  <div class=\"onoffswitch\">\n                    <input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"budgetNotification\" ng-model=\"budgetNotificationToggle\" ng-change=\"budgetSettingToggle(\'notification\')\" ng-disabled=\"!budgetModuleToggle\">\n                    <label class=\"onoffswitch-label\" for=\"budgetNotification\">\n                      <span class=\"onoffswitch-inner\"></span>\n                      <span class=\"onoffswitch-switch\"></span>\n                    </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-10 col-xs-10\">\n                  Allow Budget Notifications\n                </div>\n                <div ng-show=\"budgetNotificationToggle\" class=\"col-sm-2 col-xs-2\">Threshold:</div>\n                <div ng-show=\"budgetNotificationToggle\" class=\"col-sm-8 col-xs-8\">\n                  <rzslider rz-slider-model=\"budgetThreshold.normal.low\" rz-slider-options=\"budgetThreshold.normal.options\">\n                  </rzslider>\n                </div>\n                <div class=\"col-sm-12 col-xs-12 text-center\" ng-show=\"budgetSettingChanges()\">\n                <span>\n                  <button type=\"submit\" class=\"btn btn-sm btn-primary\">\n                    Save\n                  </button>\n                  <button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"budgetSettingToggle(\'reset\')\">\n                    Cancel\n                  </button>\n                </span>\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ui-view></div>\n</div>\n");
$templateCache.put("app/companiesManagement/companies/details/viewCurrencies-modalTemplate.html","<form>\n  <div class=\"user_view_cc\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\"><b>{{::company_name}}</b></h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <table class=\"table\">\n          <thead>\n          <tr>\n            <td><b>Code</b></td>\n            <td><b>Description</b></td>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"currency in viewCurrencies track by $index\">\n            <td>\n              {{currency.code}}\n            </td>\n            <td>\n              {{currency.descr}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      </div>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/companiesManagement/companies/exchangeRate/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ companyDetails.descr }}\n      </span>\n    </div>\n  </div>\n</div>\n<exchange-rate data=\"exchangeRate\" currencies=\"currenciesExchange\" id=\"companyDetails._id\">\n</exchange-rate>\n");
$templateCache.put("app/companiesManagement/companies/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">\n        Displaying Companies\n      </h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <master-export module-name=\"Companies\" collection=\"1\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"importCompanies()\">\n        Import Companies\n      </button>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"importAddresses()\">\n        Import Addresses\n      </button>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"!!paramId\">\n      <span class=\"btn btn-default\" ng-click=\"back()\">\n        Back\n      </span>\n  </div>\n\n  <div class=\"row\">\n    <pagination-service cursor=\"meta.cursor\" list=\"companies\" service=\"currenciesService\" params=\"params\">\n    </pagination-service>\n  </div>\n\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"companies\" class=\"table\" ng-class=\"{\'table-hover\' : companies.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(companies).length\">\n        <td colspan=\"9\">There are no companies.</td>\n      </tr>\n      <tr ng-repeat=\"company in companies\" ui-sref=\"main.user.companiesMgmt.detailCompanies({ id: company._id })\" fadeout-row=\"company._id == highlightId\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{::company.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'code\')\">\n          {{::company.code}}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{::company.reg_no }}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{::company.currency_code}}\n        </td>\n        <td ng-show=\"showColumn(\'business_unit.descr\')\">\n          {{::company.business_unit.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'industry.descr\')\">\n          {{::company.industry.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{::(company.creator.display_name)}}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{::(company.created_at | date : \'dd MMM yyyy\')}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{::(company.updater.display_name)}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{::(company.updated_at | date : \'dd MMM yyyy\')}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/companies/users/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">\n        {{ companyDetails.descr }}\n      </span>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding mt-20\">\n      <h3>List of Users</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"companyUsers\" service=\"userManageService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"companies\" class=\"table\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"companyUsers.length === 0\">\n        <td colspan=\"2\">There are no Users.</td>\n      </tr>\n      <tr ng-repeat=\"user in companyUsers\" ui-sref=\"main.user.users.detail({id: user._id})\">\n        <td ng-show=\"showColumn(\'display_name\')\">\n          {{ user.display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'email\')\">\n          {{ user.email }}\n        </td>\n        <td ng-show=\"showColumn(\'emp_no\')\">\n          {{user.emp_no}}\n        </td>\n        <td ng-show=\"showColumn(\'role\')\">\n          <span ng-if=\"user.roles.length >= 2\">\n            {{user.roles[0].name}},\n            {{user.roles[1].name}}\n            <a ng-if=\"user.roles.length > 2\" ng-click=\"viewRoles(user.roles, user.display_name); $event.stopPropagation()\"> ... more</a>\n          </span>\n          <span ng-if=\"user.roles.length < 2\">\n            {{user.roles[0].name}}\n            {{!!user.roles[1].name ? \', \' + user.roles[1].name : \'\'}}\n          </span>\n          <span ng-if=\"!user.roles.length\">\n            Not Assigned\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'manager\')\">\n          <span ng-if=\"user.managers.length >= 2\">\n            {{user.managers[0].display_name}},\n            {{user.managers[1].display_name}}\n            <a ng-if=\"user.managers.length > 2\" ng-click=\"viewManagers(user.managers, user.display_name); $event.stopPropagation()\"> ... more</a>\n          </span>\n          <span ng-if=\"user.managers.length < 2\">\n            {{user.managers[0].display_name}}\n            {{!!user.managers[1].display_name ? \', \' + user.managers[1].display_name : \'\'}}\n          </span>\n          <span ng-if=\"!user.managers.length\">\n            Not Assigned\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'position\')\">\n          <span ng-if=\"user.positions.length >= 2\">\n            {{user.positions[0].name}},\n            {{user.positions[1].name}}\n            <a ng-if=\"user.positions.length > 2\" ng-click=\"viewPositions(user.positions, user.display_name); $event.stopPropagation()\"> ... more</a>\n          </span>\n          <span ng-if=\"user.positions.length < 2\">\n            {{user.positions[0].name}}\n            {{!!user.positions[1].name ? \', \' + user.positions[1].name : \'\'}}\n          </span>\n          <span ng-if=\"!user.positions.length\">\n            Not Assigned\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'cc_list\')\">\n          <span ng-if=\"user.cc_list.length >= 2\">\n            {{user.cc_list[0].descr}},\n            {{user.cc_list[1].descr}}\n            <a ng-if=\"user.cc_list.length > 2\" ng-click=\"viewCostCenter(user.cc_list, user.display_name); $event.stopPropagation()\"> ... more</a>\n          </span>\n          <span ng-if=\"user.cc_list.length < 2\">\n            {{user.cc_list[0].descr}}\n            {{!!user.cc_list[1].descr ? \', \' + user.cc_list[1].descr : \'\'}}\n          </span>\n          <span ng-if=\"!user.cc_list.length\">\n            Not Assigned\n          </span>\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{user.created_at | date: \'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{user.creator[0].display_name}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{user.updated_at | date: \'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{user.updater[0].display_name}}\n        </td>\n        <td ng-show=\"showColumn(\'status\')\">\n          {{getStatusName(user.status)}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/costcenters/add/add.html","  <form name=\"costCenterForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Name <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-9\">\n                <input type=\"text\" ng-class=\"{\'highlight-error-input\': !costcenter.descr && submitted}\" ng-disabled=\"!!isEditingMode\" class=\"form-control\" ng-model=\"costcenter.descr\" required>\n                <span class=\"text-danger\" ng-if=\"!costcenter.descr && submitted\">Cost center name is required</span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Code <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-9\">\n                <input type=\"text\" ng-class=\"{\'highlight-error-input\': !costcenter.code && submitted}\" ng-disabled=\"!!isEditingMode\" class=\"form-control\" ng-model=\"costcenter.code\" ng-model-options=\"{debounce:100}\" ng-change=\"duplicationCheck(\'CostCenter\',\'code\',costcenter.code,\'code\')\" required>\n                <span class=\"text-danger\" ng-if=\"!costcenter.code && submitted\">Cost center code is required</span>\n                <span class=\"text-danger\" ng-if=\"costcenter.code && codeCheck\">Code {{costcenter.code}} is already taken</span>\n              </div>\n            </div>\n\n            <div class=\"form-group\" ng-if=\"!isEditingMode\">\n              <label class=\"col-sm-2 control-label\">Address <span class=\"asterisk-required\">*</span></label>\n              <div class=\"col-sm-10 cost-center-address-checkbox\">\n                <input icheck type=\"checkbox\" class=\"form-control\" id=\"add-address\" ng-model=\"followCompanyAddress.billing\" ng-click=\"checkAddress(\'billing\', followCompanyAddress.billing)\">\n                <label for=\"add-address\">Set Address to follow Company\'s corresponding address</label>\n              </div>\n            </div>\n            <div class=\"form-group\" ng-if=\"!isEditingMode\">\n              <label class=\"col-sm-2 control-label\">Billing Address</label>\n              <div class=\"col-sm-9\">\n                <addresses-panel ng-show=\"!followCompanyAddress.billing\" ng-class=\"{\'highlight-error-input\': !costcenter.billingAddressId && submitted}\" selected-address-id=\"costcenter.billingAddressId\" address-type=\"billing\" cache-key=\"companyAddresses\" company-code=\"companyDetails.code\">\n                </addresses-panel>\n                <span class=\"text-danger\" ng-if=\"!costcenter.billingAddressId && submitted\">\n                  Cost center billing address is required\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\" ng-if=\"!isEditingMode\">\n              <label class=\"col-sm-2 control-label\">Delivery Address</label>\n              <div class=\"col-sm-9\">\n                <div class=\"form-group col-md-12 cost-center-address-checkbox\">\n                  <input icheck type=\"checkbox\" class=\"form-control\" id=\"copy-billing-address\" ng-model=\"followCompanyAddress.delivery\" ng-click=\"checkAddress(\'delivery\', followCompanyAddress.delivery)\">\n                  <label for=\"copy-billing-address\">Set delivery address to follow billing address</label>\n                </div>\n                <addresses-panel ng-show=\"!followCompanyAddress.delivery\" ng-class=\"{\'highlight-error-input\': !costcenter.deliveryAddressId && submitted}\" selected-address-id=\"costcenter.deliveryAddressId\" address-type=\"delivery\" cache-key=\"companyAddresses\" company-code=\"companyDetails.code\">\n                </addresses-panel>\n                <span class=\"text-danger\" ng-if=\"!costcenter.deliveryAddressId && submitted\">\n                  Cost center delivery address is required\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\"> Cost Center Users </label>\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Search for users\" ng-model=\"searchUser.display_name\">\n              </div>\n              <div class=\"col-sm-4\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"Search for selected users\" ng-model=\"searchSelectedUsers.display_name\">\n              </div>\n              <div class=\"clearfix\"></div>\n\n              <div class=\"col-sm-offset-2 col-sm-4\">\n                <div class=\"vertical-scroll-fixed-height\">\n                  <table class=\"table\" ng-class=\"{\'table-hover\' : companyUsers.length > 1}\">\n                    <thead>\n                    <th>User Name</th>\n                    <th></th>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat=\"user in companyUsers | orderBy: \'display_name\' | filter: searchUser\">\n                      <td ng-click=\"selectUser(user)\">\n                        {{user.display_name || \'N/A\'}}\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n              <div class=\"col-sm-4\">\n                <div class=\"vertical-scroll-fixed-height\">\n                  <table class=\"table\">\n                    <thead>\n                    <th>Selected Users(s)</th>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat=\"user in selectedUsers | orderBy: \'display_name\' | filter: searchSelectedUsers\" ng-if=\"selectedUsers.length > 0\">\n                      <td class=\"label-primary\" ng-click=\"removeUser(user)\">\n                        {{user.display_name || \'N/A\'}}\n                        <i class=\"fa fa-remove pull-right\"></i>\n                      </td>\n                    </tr>\n                    <tr ng-if=\"selectedUsers.length < 1\">\n                      <td>\n                        {{ !!loading ? \'Loading selected users\' : \'No users selected\' }}\n                      </td>\n                    </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-2\"> </div>\n              <div class=\"col-sm-9\">\n                <span class=\"pull-left\">\n                  <a class=\"btn btn-default\" ng-if=\"companyUsers.length !== 0\" ng-click=\"addAllCompanyUsers()\">Add All User(s)\n                  </a>\n                </span>\n                <span class=\"pull-right\">\n                  <a class=\"btn btn-default\" ng-if=\"selectedUsers.length !== 0\" ng-click=\"removeAllSelectedUsers()\">Remove All Selected User(s)\n                  </a>\n                  </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-2\"></div>\n      <div class=\"col-md-9 m-b\">\n        <div class=\"col-md-6 update-change\">\n          <a ng-click=\"addCostCenter()\" class=\"btn btn-primary\" ng-if=\"!isEditingMode\">Add Cost Center</a>\n          <a ng-click=\"saveCostCenter()\" class=\"btn btn-primary\" ng-if=\"!!isEditingMode\">Save Changes</a>\n          <a ng-click=\"back()\" class=\"btn btn-white\">Cancel</a>\n        </div>\n        <div class=\"col-md-6 change-action\">\n        </div>\n      </div>\n    </div>\n  </form>\n");
$templateCache.put("app/companiesManagement/costcenters/address/addAddress.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">New {{ addressType | capitalize }} Address</h4>\n  </div>\n  <form name=\"costCenterForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2\"></label>\n              <div class=\"col-sm-10\">\n                <div class=\"row\">\n                  <input type=\"checkbox\" ng-model=\"duplicateAddress\" ng-change=\"duplicatingAddress(duplicateAddress)\">\n                  <span class=\"text-navy-bold\">\n                    Copy company corresponding address\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">{{addressType | capitalize}} Address</label>\n              <div class=\"col-sm-10\">\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" required>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.postal_code\" placeholder=\"Post Code\" required class=\"form-control\">\n                  </div>\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.city\" required placeholder=\"City\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.country && submitted}\">\n                    <ui-select ng-model=\"address.country\" on-select=\"onSelectedCountry(address.country)\" required>\n                      <ui-select-match placeholder=\"Select a Country\">\n                        {{$select.selected}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"countrys in countries | filter: $select.search\">\n                        <span ng-bind-html=\"countrys.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                    <span class=\"text-danger\" ng-show=\"!address.country && submitted\">\n                    A Country is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.state && submitted}\" ng-if=\"!!selectedMalaysia\">\n                    <ui-select ng-model=\"address.state\" on-select=\"onSelectedState(address.state)\" required>\n                      <ui-select-match placeholder=\"Select a state\">\n                        {{$select.selected}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                        <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                    <span class=\"text-danger\" ng-show=\"!address.state && submitted\">\n                    A state is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-6 m-b\" ng-if=\"!selectedMalaysia\">\n                    <input type=\"text\" ng-model=\"address.state\" placeholder=\"State\" required class=\"form-control\" ng-pattern=\"/^[a-zA-Z\\s]{2,}$/\" ng-pattern-restrict=\"^[a-zA-Z\\s]{0,50}$\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.phone\" placeholder=\"Phone\" class=\"form-control\" required ng-pattern=\"/^[0-9A-Za-z\\s]{5,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z\\s]{0,30}$\">\n                  </div>\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.fax\" placeholder=\"Fax\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveNewAddress(addressType)\">\n        Save\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/companiesManagement/costcenters/address/editAddress.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Edit {{ addressType | capitalize }} Address</h4>\n  </div>\n  <form name=\"costCenterForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">{{addressType | capitalize}} Address</label>\n              <div class=\"col-sm-10\">\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.reference\" class=\"form-control\" ng-readonly=\"true\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\" ng-class=\"{\'highlight-error-input\': !address.line1 && submitted}\">\n                    <input type=\"text\" ng-model=\"address.line1\" placeholder=\"Address Line 1\" class=\"form-control\">\n                    <span class=\"text-danger\" ng-show=\"!address.line1 && submitted\">\n                      Line 1 is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-12 m-b\">\n                    <input type=\"text\" ng-model=\"address.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.postal_code && submitted}\">\n                    <input type=\"text\" ng-model=\"address.postal_code\" placeholder=\"Post Code\" class=\"form-control\">\n\n                    <span class=\"text-danger\" ng-show=\"!address.postal_code && submitted\">\n                      Postal code is required\n                    </span>\n                  </div>\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.city && submitted}\">\n                    <input type=\"text\" ng-model=\"address.city\" placeholder=\"City\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n\n                    <span class=\"text-danger\" ng-show=\"!address.city && submitted\">\n                      City is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.country && submitted}\">\n                    <ui-select ng-model=\"address.country\" on-select=\"onUpdatedCountry(address.country)\">\n                      <ui-select-match placeholder=\"Select a country\">\n                        {{$select.selected}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"countryCodes in countries | filter: $select.search\">\n                        <span ng-bind-html=\"countryCodes.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.country && submitted\">\n                        A country is required\n                      </span>\n                  </div>\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.state && submitted}\" ng-if=\"!!selectedMalaysia\">\n                    <ui-select ng-model=\"address.state\" on-select=\"onUpdatedState(address.state)\">\n                      <ui-select-match placeholder=\"Select a state\">\n                        {{$select.selected}}\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                        <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                      </ui-select-choices>\n                    </ui-select>\n                      <span class=\"text-danger\" ng-show=\"!address.state && submitted\">\n                        A state is required\n                      </span>\n                  </div>\n                  <div class=\"col-lg-6 m-b\" ng-class=\"{\'highlight-error-input\': !address.state && submitted}\" ng-if=\"!selectedMalaysia\">\n                    <input type=\"text\" ng-model=\"address.state\" placeholder=\"State\" class=\"form-control\" ng-pattern=\"/^[a-zA-Z\\s]{2,}$/\" ng-pattern-restrict=\"^[a-zA-Z\\s]{0,50}$\">\n\n                    <span class=\"text-danger\" ng-show=\"!address.state && submitted\">\n                        A state is required\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.phone\" placeholder=\"Phone\" required class=\"form-control\" ng-pattern=\"/^[0-9A-Za-z\\s]{5,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z\\s]{0,30}$\">\n                  </div>\n                  <div class=\"col-lg-6 m-b\">\n                    <input type=\"text\" ng-model=\"address.fax\" placeholder=\"Fax\" class=\"form-control\" ng-pattern=\"/^[0-9a-zA-Z/,.\\s]{2,}$/\" ng-pattern-restrict=\"^[0-9a-zA-Z/,.\\s]{0,50}$\">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveEditAddress()\">\n        Save changes\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/companiesManagement/costcenters/address/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <h2>\n        <span class=\"back-buttons\">\n          <a ng-click=\"back()\" class=\"btn btn-default\">\n            <i class=\"fa fa-chevron-left\"></i> Back\n          </a>\n        </span>\n        Address Book of {{ costCenterDetails.descr }}\n      </h2>\n      <!--<div class=\"input-group\">-->\n          <!--<span class=\"input-group-addon\">-->\n            <!--<i class=\"fa fa-search\" ng-click=\"search()\"></i>-->\n          <!--</span>-->\n        <!--<input ng-model=\"searchText\"-->\n               <!--class=\"form-control ng-pristine ng-valid ng-touched\"-->\n               <!--placeholder=\"Search address\">-->\n      <!--</div>-->\n      <div class=\"clients-list mt-30\">\n        <ul class=\"nav nav-tabs\">\n          <li class=\"active\">\n            <a data-toggle=\"tab\" aria-expanded=\"true\" ng-click=\"addressActiveTab(\'billing\')\">\n              <i class=\"fa fa-user\"></i> Billing address\n            </a>\n          </li>\n          <li class=\"\">\n            <a data-toggle=\"tab\" aria-expanded=\"false\" ng-click=\"addressActiveTab(\'delivery\')\">\n              <i class=\"fa fa-briefcase\"></i> Delivery address\n            </a>\n          </li>\n          <li class=\"pull-right\">\n            <button class=\"btn btn-sm btn-primary\" ng-if=\"!!billingAddressActive\" ng-click=\"newAddress(\'billing\')\">\n              Add new billing address\n            </button>\n            <button class=\"btn btn-sm btn-primary\" ng-if=\"!!deliveryAddressActive\" ng-click=\"newAddress(\'delivery\')\">\n              Add new delivery address\n            </button>\n          </li>\n        </ul>\n        <div class=\"tab-content\">\n          <div id=\"tab-1\" class=\"tab-pane active\" ng-if=\"!!billingAddressActive\">\n            <div class=\"table-responsive\">\n              <table class=\"table table-striped table-hover\">\n                <thead>\n                <tr>\n                  <td>#</td>\n                  <td>Code</td>\n                  <td>Address</td>\n                  <td>City</td>\n                  <td>State</td>\n                  <td>Country</td>\n                  <td>Postal code</td>\n                  <td>Phone</td>\n                  <td>Fax</td>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-if=\"!addressList.billing_addresses  || addressList.billing_addresses.length === 0\">\n                  <td colspan=\"6\">\n                    There are no data for now. <a ng-click=\"newAddress(\'billing\')\">Add new address</a>\n                  </td>\n                </tr>\n                <tr ng-repeat=\"billing in addressList.billing_addresses track by $index\" ng-click=\"detailAddress(billing, \'billing\')\">\n                  <td>\n                    <input type=\"checkbox\" icheck ng-model=\"billing.selected\" ng-click=\"beforeSave(billing.selected)\">\n                  </td>\n                  <td>{{ (!!billing.reference) ? billing.reference : \'N/A\' }}</td>\n                  <td>\n                    <span ng-if=\"!!billing.line1\">\n                      {{billing.line1}}\n                    </span>\n                    <span ng-if=\"!!billing.line2\">\n                      , <br>{{billing.line2}}\n                    </span>\n                    <span ng-if=\"!!billing.line3\">\n                      , <br>{{billing.line3}}\n                    </span>\n                  </td>\n                  <td>{{billing.city}}</td>\n                  <td>{{ (!!billing.state.code) ? billing.state.descr : billing.state  }}</td>\n                  <td>{{billing.country}}</td>\n                  <td>{{billing.postal_code}}</td>\n                  <td>{{billing.phone}}</td>\n                  <td>{{billing.fax}}</td>\n                </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n          <div id=\"tab-2\" ng-if=\"!!deliveryAddressActive\">\n            <div class=\"table-responsive\">\n              <table class=\"table table-striped table-hover\">\n                <thead>\n                <tr>\n                  <td>#</td>\n                  <td>Code</td>\n                  <td>Address</td>\n                  <td>City</td>\n                  <td>State</td>\n                  <td>Country</td>\n                  <td>Postal code</td>\n                  <td>Phone</td>\n                  <td>Fax</td>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-if=\"!addressList.delivery_addresses || addressList.delivery_addresses.length === 0\">\n                  <td colspan=\"6\">\n                    There are no data for now. <a ng-click=\"newAddress(\'delivery\')\">Add new address</a>\n                  </td>\n                </tr>\n                <tr ng-repeat=\"delivery in addressList.delivery_addresses track by $index\" ng-click=\"detailAddress(delivery, \'delivery\')\">\n                  <td>\n                    <input type=\"checkbox\" icheck ng-model=\"delivery.selected\" ng-click=\"beforeSave(delivery.selected)\">\n                  </td>\n                  <td>{{ (!!delivery.reference) ? delivery.reference : \'N/A\' }}</td>\n                  <td>\n                    <span ng-if=\"!!delivery.line1\">\n                      {{delivery.line1}}\n                    </span>\n                    <span ng-if=\"!!delivery.line2\">\n                      , <br>{{delivery.line2}}\n                    </span>\n                    <span ng-if=\"!!delivery.line3\">\n                      , <br>{{delivery.line3}}\n                    </span>\n                  </td>\n                  <td>{{delivery.city}}</td>\n                  <td>{{ (!!delivery.state.code) ? delivery.state.descr : delivery.state  }}</td>\n                  <td>{{delivery.country}}</td>\n                  <td>{{delivery.postal_code}}</td>\n                  <td>{{delivery.phone}}</td>\n                  <td>{{delivery.fax}}</td>\n                </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/costcenters/details/details.html","<div class=\"modal-content modal-inside\" ng-app=\"metabuyer\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">{{ costCenterDetails.descr }}</h4>\n  </div>\n  <form name=\"costCenterForm\" novalidate>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Name</label>\n              <div class=\"col-sm-10\" ng-class=\"{\'highlight-error-input\': !costCenterDetails.descr && submitted}\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"costCenterDetails.descr\" ng-disabled=\"!editClicked\" required>\n                <span class=\"text-danger\" ng-if=\"!costCenterDetails.descr && submitted\">\n                  Cost center name is required\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Code</label>\n              <div class=\"col-sm-10\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"costCenterDetails.code\" readonly=\"readonly\" required>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\"></label>\n              <div class=\"col-sm-10\">\n                <span class=\"text-navy-bold\">\n                  <a ng-click=\"addressesList(costCenterDetails._id)\">\n                    Address Book\n                  </a>\n                </span>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\"></label>\n              <div class=\"col-sm-10\">\n                <span class=\"text-navy-bold\">\n                  <a ng-click=\"editCostCenterUsers(costCenterDetails._id)\">\n                    Edit Cost Center User(s)\n                  </a>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editCostCenter()\" ng-show=\"!editClicked\">\n        Edit\n      </button>\n      <button type=\"submit\" ng-show=\"editClicked\" class=\"btn btn-primary\" ng-click=\"updateChanges()\">\n        Save changes\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button>\n      <button type=\"button\" class=\"btn btn-danger\" ng-click=\"deleteCostCenter()\">\n        Delete\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/companiesManagement/costcenters/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Display costcenters</h3>\n    </div>\n    <div class=\"col-md-3 col-md-offset-4\">\n      <div class=\"pull-right\" ng-dropdown-multiselect=\"\" options=\"column.columns\" selected-model=\"column.selectedColumns\" icon-class=\"\'fa fa-wrench\'\" translation-texts=\"column.buttonText\" extra-settings=\"column.setting\" events=\"column.events\"></div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-4 no-padding\">\n      <div class=\"pull-left\" class=\"btn-group\" ng-show=\"isShowcompany\">\n        <button type=\"button \" class=\"btn btn-default btn-sm dropdown-toggle m-l-sm\" data-toggle=\"dropdown\" aria-expanded=\"false\">\n          Action <span class=\"fa fa-caret-down\"></span>\n        </button>\n      </div>\n    </div>\n    <div class=\"col-md-4 col-md-offset-4\">\n      <div ng-if=\"!!pagination.meta\">\n        <div class=\"btn-group pull-right clear-floating pagination-focus\">\n          <button type=\"button\" class=\"btn btn-white\" ng-class=\"{disabled: pagination.getPageIndex() == 1}\" ng-click=\"pagination.goPreviousPage()\"><span aria-hidden=\"true\">&laquo;</span></button>\n          <button class=\"btn btn-white\" ng-class=\"{disabled: pagination.getPageSize() == pagination.total}\" ng-click=\"pagination.goNextPage()\"><span aria-hidden=\"true\">&raquo;</span></button>\n        </div>\n        <label class=\"pull-right m-t-xs m-r-xs m-b-sm\"> {{pagination.getPageIndex()}} - {{\n          pagination.getPageSize() }} of {{\n          pagination.getTotalPage() }} </label>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"costCenters\" class=\"table\">\n      <thead>\n      <tr>\n        <!--<td style=\"text-align: center\"><input icheck type=\"checkbox\" ng-click=\"checkAll()\" ng-model=\"selectedAll\"></td>-->\n        <td st-sort=\"company_name\" ng-show=\"column.showColumn(\'company\')\">Company</td>\n        <td st-sort=\"descr\" ng-show=\"column.showColumn(\'name\')\">Name</td>\n        <td st-sort=\"code\" ng-show=\"column.showColumn(\'code\')\">Code</td>\n        <td st-sort=\"company.created_at\" ng-show=\"column.showColumn(\'created\')\">Created At</td>\n      </tr>\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-show=\"!costCenters.length\">\n        <td colspan=\"9\">There is no cost centers.</td>\n      </tr>\n      <tr ng-repeat=\"costCenter in costCenters\" ng-class=\"{\'row-select\': costCenter.selected}\">\n        <!--<td ng-click=\"$event.stopPropagation()\" style=\"text-align: center\"><input icheck type=\"checkbox\" ng-model=\"costCenter.selected\"-->\n        <!--ng-change=\"check(costCenter)\">-->\n        <!--</td>-->\n        <td ng-show=\"column.showColumn(\'company\')\">{{costCenter.company_name}}</td>\n        <td ng-show=\"column.showColumn(\'name\')\">{{costCenter.descr}}</td>\n        <td ng-show=\"column.showColumn(\'code\')\">{{costCenter.code}}</td>\n        <td ng-show=\"column.showColumn(\'created\')\">{{costCenter.company.created_at | date}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/industries/add/add.html","<div class=\"state_BU_add\">\n  <form name=\"industry_add_form\" ng-submit=\"addIndustry()\" novalidate>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <fieldset class=\"form-horizontal\">\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">Industry Name: <span class=\"asterisk-required\">*</span></label>\n                <div class=\"col-sm-9\">\n                  <input class=\"form-control\" name=\"industry_name\" type=\"text\" ng-model=\"industry.name\" placeholder=\"(e.g. Construction)\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-class=\"{\'highlight-error-input\': !industry.name.length && submitted}\" required>\n                <span class=\"text-danger\" ng-if=\"!!industry_add_form.industry_name.$error.required && submitted\">\n                  Industry\'s name is required\n                </span>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-2 control-label\">Industry Code: <span class=\"asterisk-required\">*</span></label>\n                <div class=\"col-sm-9\">\n                  <input class=\"form-control\" name=\"industry_code\" type=\"text\" ng-model=\"industry.code\" placeholder=\"(e.g.78707)\" ng-pattern=\"/^[0-9A-Za-z]{0,}$/\" ng-pattern-restrict=\"^[0-9A-Za-z]{0,30}$\" ng-change=\"duplicationCheck(\'Industry\',\'code\',industry.code,\'code\')\" ng-class=\"{\'highlight-error-input\': (!industry.code.length && submitted) || (industry.code.length && codeCheck)}\" required>\n                <span class=\"text-danger\" ng-if=\"!!industry_add_form.industry_code.$error.required && submitted\">\n                  Industry\'s code is required\n                </span>\n                  <span class=\"text-danger\" ng-if=\"industry.code.length && codeCheck\">\n                    Industry code {{industry.code}} is already taken!\n                  </span>\n                </div>\n              </div>\n            </fieldset>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-2\"></div>\n      <div class=\"col-sm-9 m-b\">\n        <div class=\"col-sm-6 update-change\">\n          <a ng-click=\"addIndustry()\" class=\"btn btn-primary\">Add Industry</a>\n          <a ng-click=\"cancelAddIndustry()\" class=\"btn btn-white\">Cancel</a>\n        </div>\n        <div class=\"col-sm-6 change-action\">\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/companiesManagement/industries/details/details.html","<div class=\"wrapper wrapper-content animated fadeInRight\" xmlns=\"http://www.w3.org/1999/html\">\n  <div class=\"state_industry_details\">\n    <div class=\"col-lg-12\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Industry Details</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <form method=\"get\" name=\"industry\" class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Last updated</label>\n              <div class=\"col-sm-10 form-only-text\">\n                {{ industryDetails.updated_at | date:\'dd MMM yyyy h:mm a\' }}\n              </div>\n            </div>\n            <div class=\"hr-line-dashed\"></div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Name</label>\n              <div class=\"col-sm-10\" ng-class=\"{\'highlight-error-input\': !industryDetails.descr.length && submitted}\">\n                <div class=\"form-only-text\" ng-show=\"!editIndustry\">\n                  {{ industryDetails.descr }}\n                </div>\n                <input type=\"text\" ng-model=\"newIndustryDetails.descr\" ng-show=\"editIndustry\" class=\"form-control\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" required>\n                <span class=\"text-danger\" ng-if=\"!newIndustryDetails.descr.length && submitted\">\n                  Industry\'s name is required\n                </span>\n              </div>\n            </div>\n            <div class=\"hr-line-dashed\"></div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Code</label>\n              <div class=\"col-sm-10\" ng-class=\"{\'highlight-error-input\': !industryDetails.code.length && submitted}\">\n                <div class=\"form-only-text\" ng-show=\"!editIndustry\">\n                  {{ industryDetails.code }}\n                </div>\n                <input type=\"text\" ng-model=\"newIndustryDetails.code\" ng-show=\"editIndustry\" class=\"form-control\" ng-pattern-restrict=\"^[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-change=\"duplicationCheck(\'Industry\',\'code\',industry.code,\'code\')\" required>\n                <span class=\"text-danger\" ng-if=\"!newIndustryDetails.code.length && submitted\">\n                   Industry\'s code is required\n                </span>\n                <span class=\"text-danger\" ng-if=\"!!newIndustryDetails.code.length && codeCheck\">\n                    Industry code {{newIndustryDetails.code}} is already taken!\n                  </span>\n              </div>\n            </div>\n            <div class=\"hr-line-dashed\"></div>\n\n            <div class=\"form-group\">\n              <label class=\"col-sm-2 control-label\">Companies</label>\n              <div class=\"col-sm-10 form-only-text\">\n                <a ui-sref=\"main.user.companiesMgmt.manageCompanies({ industry_code: industryDetails.code })\">\n                  View Companies under this Industry\n                </a>\n              </div>\n            </div>\n\n            <div class=\"hr-line-dashed\"></div>\n            <div class=\"form-group\">\n              <div class=\"col-sm-4 col-sm-offset-2\">\n                <button class=\"btn btn-danger\" ng-show=\"!editIndustry\" type=\"button\" ng-click=\"deleteIndustry()\">\n                  Delete\n                </button>\n                <button class=\"btn btn-info\" ng-show=\"!editIndustry\" type=\"button\" ng-click=\"editableIndustry()\">\n                  Edit\n                </button>\n                <button class=\"btn btn-primary\" ng-show=\"!!editIndustry\" type=\"submit\" ng-click=\"updateChanges()\">\n                  Save Changes\n                </button>\n                <button class=\"btn btn-white\" ng-click=\"revertUpdate()\" ng-show=\"!editIndustry\">\n                  Cancel\n                </button>\n                <button class=\"btn btn-white\" ng-click=\"cancelUpdate()\" ng-show=\"!!editIndustry\">\n                  Cancel\n                </button>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/companiesManagement/industries/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Listing {{ status }} Industries </h3>\n\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <master-export module-name=\"Industries\" collection=\"19\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right mr-15 btn-xs\" ng-click=\"importIndustry()\">\n        Import Industries\n      </button>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingIndustryService\" status=\"status\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n        <td colspan=\"9\">There are no Industries for now.</td>\n      </tr>\n      <tr ng-repeat=\"industry in dataList | filter:{status:status}\" ui-sref=\"main.user.companiesMgmt.detailIndustries({id: industry._id})\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{industry.descr}}\n        </td>\n        <td ng-show=\"showColumn(\'code\')\">\n          {{industry.code}}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{industry.created_at | date: \'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{industry.updated_at | date: \'dd MMM yyyy\'}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/items/catalog-code/add/addCatalogCode.html","<form ng-submit=\"submitCatalogCode(catalogCode.code, catalogCode.descr)\">\n  <div class=\"edit-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\">Add Catalog Code</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Catalog Code </label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" ng-model=\"catalogCode.code\" class=\"form-control\" required>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Catalog Code Description </label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"catalogCode.descr\" required>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      <input type=\"submit\" value=\"Add\" class=\"btn btn-primary\">\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/items/catalog-code/details/singleCatalogCode.html","<form>\n  <div class=\"edit-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\">{{::catalogCodeDetails.code}} Catalog Code</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Catalog Code </label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" ng-model=\"catalogCodeDetails.code\" class=\"form-control\" readonly=\"readonly\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Catalog Code Description </label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"catalogCodeDetails.descr\" required>\n            <span class=\"text-danger\" ng-show=\"!catalogCodeDetails.descr\">\n               Catalog Code Description is required!\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveChanges()\">Save</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/items/catalog-code/manage/ManageCatalogCode.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Catalog Codes</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <button ng-click=\"importCatalogCodes()\" class=\"btn btn-primary pull-right mr-15 btn-xs\">\n        Import Catalog Codes\n      </button>\n      <button ng-click=\"newCatalogCode()\" class=\"btn btn-primary pull-right btn-xs mr-15 margin-right\">\n        Add Catalog Code\n      </button>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"catalogCodesManageService\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There is no available catalog code at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" ng-class=\"{\'row-select\': item.selected}\" ng-click=\"viewCatalogCodeDetails(data)\">\n        <td ng-show=\"showColumn(\'code\') \">\n          {{data.code }}\n        </td>\n        <td ng-show=\"showColumn(\'descr\') \">\n          {{data.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ data.creator[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ data.created_at | date:\'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ data.updater[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ data.updated_at | date:\'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"showColumn(\'is_active\')\">\n          {{ getActiveStatusName(data.is_active) }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/items/catalog-group/add/addCatalogGroup.html","<div class=\"state_company_add\">\n  <form name=\"company_detail_form\">\n      <div class=\"row\">\n        <div class=\"col-sm-3\">\n        </div>\n        <div class=\"col-sm-3\">\n          <h3>Create Catalog Group</h3>\n        </div>\n      </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <fieldset class=\"form-horizontal\">\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">Code <span class=\"asterisk-required\">*</span></label>\n                <div class=\"col-sm-6\">\n                  <input type=\"text\" ng-model=\"catalogGroup.code\" class=\"form-control\" placeholder=\"Catalog Group Code\" ng-change=\"duplicationCheck(\'CatalogGroup\',\'code\',catalogGroup.code,\'code\')\" ng-class=\"{\'highlight-error-input\': ((!catalogGroup.code.length && submitted )||\n                     (catalogGroup.code.length && codeCheck))}\">\n                  <span class=\"text-danger\" ng-if=\"!catalogGroup.code && submitted\">\n                    Catalog Group\'s code is required\n                  </span>\n                  <span class=\"text-danger\" ng-if=\"catalogGroup.code.length && codeCheck\">\n                   Catalog Group\'s code {{catalogGroup.code}} is already taken!\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">Description <span class=\"asterisk-required\">*</span></label>\n                <div class=\"col-sm-6\">\n                  <input type=\"text\" class=\"form-control\" placeholder=\"Catalog Group Description\" ng-model=\"catalogGroup.descr\" ng-class=\"{\'highlight-error-input\': !catalogGroup.descr.length && submitted}\">\n                  <span class=\"text-danger\" ng-if=\"!catalogGroup.descr && submitted\">\n                    Catalog Group\'s description is required\n                  </span>\n                </div>\n              </div>\n\n              <!--TODO: have status actually take effect on catalog group (Justin 14/11/16)-->\n              <!--<div class=\"form-group\">-->\n                <!--<label class=\"col-sm-3 control-label\">Status <span class=\"asterisk-required\">*</span></label>-->\n                <!--<div class=\"col-sm-6\">-->\n                  <!--<select name=\"statusSelect\"-->\n                          <!--id=\"statusSelect\"-->\n                          <!--ng-model=\"catalogGroup.status\"-->\n                          <!--class=\"form-control\"-->\n                          <!--ng-options=\"option.isActive for option in catalogGroupStatuses track by option.isActive\">-->\n                  <!--</select>-->\n                  <!--<span class=\"text-danger\"-->\n                        <!--ng-if=\"!catalogGroup.status && submitted\">-->\n                    <!--Catalog Group\'s status is required-->\n                  <!--</span>-->\n                <!--</div>-->\n              <!--</div>-->\n\n              <!--TODO: have company assignment in catalog group creation (Justin 11/11/16)-->\n              <!--<div class=\"form-group\">-->\n                <!--<label class=\"col-sm-3 control-label\">Companies <span class=\"asterisk-required\">*</span></label>-->\n                <!--<div class=\"col-sm-6\">-->\n                  <!--<ui-select-->\n                    <!--on-remove = \"selectCompany($item, \'unassign\')\"-->\n                    <!--on-select = \"selectCompany($item, \'assign\')\"-->\n                    <!--ui-disable-choice = \"!!loadingCompaniesList || !catalogGroup._id\"-->\n                    <!--multiple ng-model=\"selectedCompanies\" remove-selected=\"false\"-->\n                    <!--sortable=\"true\" close-on-select=\"true\">-->\n                    <!--<ui-select-match placeholder=\"Select company(s)...\">{{$item.descr}}</ui-select-match>-->\n                    <!--<ui-select-choices repeat=\"company in companies | filter: $select.search\">-->\n                      <!--<div ng-bind-html=\"company.descr | highlight: $select.search\"></div>-->\n                    <!--</ui-select-choices>-->\n                  <!--</ui-select>-->\n                  <!--<span class=\"text-danger\" ng-if=\"!selectedCompanies.length && submitted\">-->\n                    <!--Catalog Group\'s company is required-->\n                  <!--</span>-->\n                <!--</div>-->\n              <!--</div>-->\n\n            </fieldset>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-3\"></div>\n      <div class=\"col-sm-6 m-b\">\n        <div class=\"col-sm-6 update-change\">\n          <a ng-click=\"submitCatalogGroup(catalogGroup.code, catalogGroup.descr, catalogGroup.status)\" class=\"btn btn-primary\">Create</a>\n          <a ng-click=\"cancel()\" class=\"btn btn-white\">Cancel</a>\n        </div>\n        <div class=\"col-sm-6 change-action\">\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/items/catalog-group/edit/editCatalogGroup.html","<div class=\"state_company_add\">\n  <form name=\"company_detail_form\" novalidate>\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n      </div>\n      <div class=\"col-sm-3\">\n        <h3>Edit Catalog Group</h3>\n      </div>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-lg-12\">\n          <div class=\"panel-body\">\n            <fieldset class=\"form-horizontal\">\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">Code </label>\n                <div class=\"col-sm-6\">\n                  <input type=\"text\" ng-model=\"catalogGroupDetails.code\" class=\"form-control\" readonly=\"readonly\">\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">Description </label>\n                <div class=\"col-sm-6\">\n                  <input type=\"text\" class=\"form-control\" ng-disabled=\"!editClicked\" placeholder=\"Catalog Group description\" ng-class=\"{\'highlight-error-input\': !catalogGroupDetails.descr.length && submitted}\" ng-model=\"catalogGroupDetails.descr\">\n                  <span class=\"text-danger\" ng-if=\"!catalogGroupDetails.descr && submitted\">\n                    Catalog Group\'s description is required\n                  </span>\n                </div>\n              </div>\n\n              <!--TODO: have status actually take effect on catalog group (Justin 14/11/16)-->\n              <!--<div class=\"form-group\">-->\n                <!--<label class=\"col-sm-3 control-label\">Status </label>-->\n                <!--<div class=\"col-sm-6\">-->\n                  <!--<select name=\"statusSelect\"-->\n                          <!--id=\"statusSelect\"-->\n                          <!--ng-model=\"catalogGroupDetails.status\"-->\n                          <!--ng-disabled=\"!editClicked\"-->\n                          <!--class=\"form-control\"-->\n                          <!--ng-options=\"option.isActive for option in catalogGroupStatuses track by option.isActive\">-->\n                  <!--</select>-->\n                  <!--<span class=\"text-danger\"-->\n                        <!--ng-if=\"!catalogGroupDetails.status && submitted\">-->\n                    <!--Catalog Group\'s status is required-->\n                  <!--</span>-->\n                <!--</div>-->\n              <!--</div>-->\n\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">Companies</label>\n                <div class=\"col-sm-6 dropdown-h-100\">\n                  <ui-select on-remove=\"selectCompany($item,\'unassign\')\" on-select=\"selectCompany($item, \'assign\')\" ui-disable-choice=\"!!loadingCompaniesList || !catalogGroup._id\" multiple=\"multiple\" ng-model=\"selectedCompanies\" ng-disabled=\"!editClicked\" remove-selected=\"false\" sortable=\"true\" close-on-select=\"true\">\n                    <ui-select-match placeholder=\"Select company(s)...\">{{$item.descr}}</ui-select-match>\n                    <ui-select-choices position=\"bottom\" repeat=\"company in companies | filter: {descr: $select.search} | orderBy:\'descr\'\">\n                      <div ng-bind-html=\"company.descr | highlight: $select.search\"></div>\n                    </ui-select-choices>\n                  </ui-select>\n                  <div class=\"grey-text\">\n                    <h4>Note: Company assignment is saved automatically</h4>\n                  </div>\n                </div>\n              </div>\n            </fieldset>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-3\"></div>\n      <div class=\"col-sm-6 m-b\">\n        <div class=\"col-sm-6 update-change\">\n          <a class=\"btn btn-primary\" ng-if=\"!editClicked\" ng-click=\"editMode()\">Edit</a>\n          <a class=\"btn btn-primary\" ng-if=\"!!editClicked\" ng-click=\"saveChanges()\">Save</a>\n          <a class=\"btn btn-white\" ng-click=\"cancelUpdate()\">Cancel</a>\n        </div>\n        <div class=\"col-sm-6 change-action\">\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/items/catalog-group/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Catalog Groups</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <button ng-click=\"importCatalogGroups()\" class=\"btn btn-primary pull-right mr-15 btn-xs\">\n        Import Catalog Group Assignment\n      </button>\n      <button ng-click=\"newCatalogGroup()\" class=\"btn btn-primary pull-right btn-xs mr-15 margin-right\">\n        Add Catalog Group\n      </button>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"catalogItemsManageService\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There is no available catalog groups at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" ng-class=\"{\'row-select\': item.selected}\" ng-click=\"viewCatalogGroupDetails(data)\">\n        <td ng-if=\"showColumn(\'code\')\">\n          {{data.code}}\n        </td>\n        <td ng-if=\"showColumn(\'descr\')\">\n          {{data.descr}}\n        </td>\n        <td ng-if=\"showColumn(\'effective_at\')\">\n          {{data.effective_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-if=\"showColumn(\'expiry_at\')\">\n          {{data.expiry_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ data.creator[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ data.created_at | date:\'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ data.updater[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ data.updated_at | date:\'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"showColumn(\'is_active\')\">\n          {{ getActiveStatusName(data.is_active) }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/items/catalog-items/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Catalog Items</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <master-export module-name=\"Catalog Items\" collection=\"16\">\n      </master-export>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"catalogItemsManageService\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There is no available catalog items at the moment.</td>\n      </tr>\n      <tr ng-repeat=\"data in dataList\" ng-class=\"{\'row-select\': item.selected}\" ng-click=\"viewCatalogItemDetails(data)\">\n        <td ng-if=\"showColumn(\'item_name\')\">\n          {{data.item_name}}\n        </td>\n        <td ng-if=\"showColumn(\'description\')\">\n          {{data.description}}\n        </td>\n        <td ng-if=\"showColumn(\'commodity_code\')\">\n          {{data.commodity_code}}\n        </td>\n        <td ng-if=\"showColumn(\'commodity_descr\')\">\n          {{data.commodity_descr}}\n        </td>\n        <td ng-if=\"showColumn(\'supplier.descr\')\">\n          {{data.supplier[0].descr}}\n        </td>\n        <td ng-if=\"showColumn(\'supplier_part_no\')\">\n          {{data.supplier_part_no}}\n        </td>\n        <td ng-if=\"showColumn(\'tax.rate\')\">\n          {{data.tax[0].code}} {{data.tax[0].rate}}\n        </td>\n        <td ng-if=\"showColumn(\'payment_term.descr\')\">\n          {{data.payment_term[0].descr}}\n        </td>\n        <td ng-if=\"showColumn(\'currency.code\')\">\n          {{data.currency[0].code}}\n        </td>\n        <td ng-if=\"showColumn(\'unit_price\')\">\n          {{data.unit_price | formatDecimal: 4}}\n        </td>\n        <td ng-if=\"showColumn(\'Uom.code\')\">\n          {{data.Uom[0].code}}\n        </td>\n        <td ng-if=\"showColumn(\'effective_at\')\">\n          {{data.effective_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-if=\"showColumn(\'expiry_at\')\">\n          {{data.expiry_at | date:\'dd MMM yyyy h:mm a\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ data.creator[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ data.created_at | date:\'dd MMM yyyy\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ data.updater[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ data.updated_at | date:\'dd MMM yyyy\' }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/commodityCode/add/addCommodityTemplate.html","<form>\n  <div class=\"add-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">×</button>\n      <h3 class=\"modal-title\">Add Commodity</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Description <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"commodity.descr\" placeholder=\"Enter description\" ng-class=\"{\'highlight-error-input\': !commodity.descr.length && submitted}\" required>\n            <span class=\"text-danger\" ng-if=\"!commodity.descr.length && submitted\">Description is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Status <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"commodity.status\" ng-class=\"{\'highlight-error-input\': !commodity.status && submitted}\">\n              <ui-select-match placeholder=\"Select status...\"> {{$select.selected.isActive}} </ui-select-match>\n              <ui-select-choices repeat=\"status in commodityStatuses | filter: $select.search\">\n                <span ng-bind-html=\"status.isActive | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!commodity.status && submitted\">Status is required</span>\n\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Domain <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"commodity.domain\" placeholder=\"Enter domain\" ng-class=\"{\'highlight-error-input\': !commodity.domain.length && submitted}\" required>\n            <span class=\"text-danger\" ng-if=\"!commodity.domain.length && submitted\">Domain is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Type <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"commodity.select_commodity_type\" ng-class=\"{\'highlight-error-input\': !commodity.select_commodity_type && submitted}\">\n              <ui-select-match placeholder=\"Select type...\"> {{$select.selected.descr}} </ui-select-match>\n              <ui-select-choices repeat=\"type in commodityTypes | filter: $select.search\">\n                <span ng-bind-html=\"type.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!commodity.select_commodity_type && submitted\">Type is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Segment <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"masterDataSegments.selected\" on-select=\"selectedMasterDataSegments(masterDataSegments.selected)\" ng-class=\"{\'highlight-error-input\': !masterDataSegments.selected && submitted}\">\n              <ui-select-match placeholder=\"Select segment...\"> {{$select.selected.descr}} </ui-select-match>\n              <ui-select-choices repeat=\"segment in masterDataSegments | filter: $select.search\">\n                <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                <span ng-bind-html=\"segment.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!masterDataSegments.selected && submitted\">Segment is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"!!masterDataSegments.selected\">\n          <label class=\"col-sm-4 control-label\">Family <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"masterDataFamilies.selected\" on-select=\"selectedMasterDataFamilies(masterDataFamilies.selected)\" ng-class=\"{\'highlight-error-input\': !masterDataFamilies.selected && submitted}\">\n              <ui-select-match placeholder=\"Select family...\"> {{$select.selected.descr}} </ui-select-match>\n              <ui-select-choices repeat=\"family in masterDataFamilies | filter: $select.search\">\n                <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                <span ng-bind-html=\"family.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!masterDataFamilies.selected && submitted\">Family is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"!!masterDataFamilies.selected\">\n          <label class=\"col-sm-4 control-label\">Class <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"masterDataClasses.selected\" on-select=\"selectedMasterDataClasses(masterDataClasses.selected)\" ng-class=\"{\'highlight-error-input\': !masterDataClasses.selected && submitted}\">\n              <ui-select-match placeholder=\"Select class...\"> {{$select.selected.descr}} </ui-select-match>\n              <ui-select-choices repeat=\"class in masterDataClasses| filter: $select.search\">\n                <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                <span ng-bind-html=\"class.descr | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!masterDataClasses.selected && submitted\">Class is required</span>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"!!masterDataClasses.selected\">\n          <label class=\"col-sm-4 control-label\">Commodity Code <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"commodity.commodity\" placeholder=\"Enter commodity code\" ng-pattern=\"/^[0-9]{1,}$/\" ng-pattern-restrict=\"^[0-9]{0,2}$\" ng-change=\"duplicationCheck(\'Commodity\',\'code\',commodity.commodity,\'code\')\" ng-class=\"{\'highlight-error-input\': (!commodity.commodity.length && submitted) ||\n                   (commodity.commodity.length && codeCheck) || (commodity.commodity.length < 2) && submitted}\" required>\n            <span class=\"text-danger\" ng-if=\"!commodity.commodity.length && submitted\">\n                    Commodity code is required\n            </span>\n            <span class=\"text-danger\" ng-if=\"commodity.commodity.length && codeCheck\">\n                    Commodity code {{commodity.commodity}} is already taken!\n            </span>\n            <span class=\"text-danger\" ng-if=\"(commodity.commodity.length < 2) && submitted\">\n                    Commodity code needs to be 2 digits\n            </span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">Posting <span class=\"asterisk-required\">*</span></label>\n          <div class=\"col-sm-6\">\n            <ui-select ng-model=\"commodity.posting\" ng-class=\"{\'highlight-error-input\': !commodity.posting && submitted}\">\n              <ui-select-match placeholder=\"Select posting...\"> {{$select.selected.text}} </ui-select-match>\n              <ui-select-choices repeat=\"option in commodityPosting | filter: $select.search\">\n                <span ng-bind-html=\"option.text | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-if=\"!commodity.posting && submitted\">Posting is required</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addCommodity(commodity)\">Add</button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Cancel</button>\n    </div>\n  </div>\n</form>\n\n\n");
$templateCache.put("app/masterDataManagement/commodityCode/details/details.html","<form>\n  <div class=\"edit-commodity\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Commodity Code Details</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"tabs-container\">\n        <ul class=\"nav nav-tabs\">\n          <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n            <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n          </li>\n          <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n            <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n          </li>\n        </ul>\n\n        <div class=\"tab-content\">\n          <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n            <div class=\"panel-body tab-content-fixed-popup\">\n              <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                <div class=\"form-horizontal\">\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Code </label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" ng-model=\"commodityDetails.code\" class=\"form-control\" readonly=\"readonly\">\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Description </label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" ng-model=\"commodityDetails.descr\" ng-disabled=\"!editClicked\" required>\n                      <span class=\"text-danger\" ng-if=\"!commodityDetails.descr.length && submitted\">Description is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Status </label>\n                    <div class=\"col-sm-10\">\n                      <select name=\"statusSelect\" id=\"statusSelect\" ng-model=\"commodityDetails.commodityStatus\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in commodityStatuses track by option.isActive\">\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Domain </label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" ng-model=\"commodityDetails.domain\" ng-class=\"{\'highlight-error-input\': !commodityDetails.domain.length && submitted}\" ng-disabled=\"!editClicked\" required>\n                      <span class=\"text-danger\" ng-if=\"!commodityDetails.domain.length && submitted\">Domain is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Type </label>\n                    <div class=\"col-sm-10\" ng-class=\"{\'highlight-error-input\': !commodityDetails.select_commodity_type && submitted}\">\n                      <ui-select ng-model=\"commodityDetails.select_commodity_type\" ng-disabled=\"!editClicked\">\n                        <ui-select-match placeholder=\"Select type...\"> {{$select.selected.descr}} </ui-select-match>\n                        <ui-select-choices repeat=\"type in commodityTypes | filter: $select.search\">\n                          <span ng-bind-html=\"type.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-if=\"!commodityDetails.select_commodity_type && submitted\">Type is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Segment </label>\n                    <div class=\"col-sm-10\">\n                      <ui-select ng-model=\"masterDataSegments.selected\" ng-disabled=\"!editClicked\" ng-class=\"{\'highlight-error-input\': !masterDataSegments.selected && submitted}\" on-select=\"selectedMasterDataSegments(masterDataSegments.selected)\">\n                        <ui-select-match placeholder=\"Select segment...\"> {{$select.selected.descr}} </ui-select-match>\n                        <ui-select-choices repeat=\"segment in masterDataSegments | filter: $select.search\">\n                          <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                          <span ng-bind-html=\"segment.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-if=\"!masterDataSegments.selected && submitted\">Segment is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" ng-if=\"!!masterDataSegments.selected\">\n                    <label class=\"col-sm-2 control-label\">Family </label>\n                    <div class=\"col-sm-10\">\n                      <ui-select ng-model=\"masterDataFamilies.selected\" ng-disabled=\"!editClicked\" ng-class=\"{\'highlight-error-input\': !masterDataFamilies.selected && submitted}\" on-select=\"selectedMasterDataFamilies(masterDataFamilies.selected)\">\n                        <ui-select-match placeholder=\"Select family...\"> {{$select.selected.descr}} </ui-select-match>\n                        <ui-select-choices repeat=\"family in masterDataFamilies | filter: $select.search\">\n                          <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                          <span ng-bind-html=\"family.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-if=\"!masterDataFamilies.selected && submitted\">Family is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" ng-if=\"!!masterDataFamilies.selected\">\n                    <label class=\"col-sm-2 control-label\">Class </label>\n                    <div class=\"col-sm-10\">\n                      <ui-select ng-model=\"masterDataClasses.selected\" ng-disabled=\"!editClicked\" ng-class=\"{\'highlight-error-input\': !masterDataClasses.selected && submitted}\" on-select=\"selectedMasterDataClasses(masterDataClasses.selected)\">\n                        <ui-select-match placeholder=\"Select class...\"> {{$select.selected.descr}} </ui-select-match>\n                        <ui-select-choices repeat=\"class in masterDataClasses| filter: $select.search\">\n                          <!--<span ng-bind-html=\"segment.code | highlight: $select.search\"></span>-->\n                          <span ng-bind-html=\"class.descr | highlight: $select.search\"></span>\n                        </ui-select-choices>\n                      </ui-select>\n                      <span class=\"text-danger\" ng-if=\"!masterDataClasses.selected && submitted\">Class is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" ng-if=\"!!masterDataClasses.selected\">\n                    <label class=\"col-sm-2 control-label\">Commodity code </label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" ng-model=\"commodityDetails.commodity\" placeholder=\"Enter commodity code\" ng-pattern=\"/^[0-9]{1,}$/\" ng-pattern-restrict=\"^[0-9]{0,2}$\" ng-class=\"{\'highlight-error-input\': (!commodityDetails.commodity.length && submitted) ||\n         (commodityDetails.commodity.length && codeCheck) || ((commodityDetails.commodity.length < 2) && submitted)}\" ng-change=\"duplicationCheck(\'Commodity\',\'code\',commodityDetails.commodity,\'code\')\" ng-disabled=\"!editClicked\" required>\n                      <span class=\"text-danger\" ng-if=\"!commodityDetails.commodity.length && submitted\">\n              Commodity code is required\n      </span>\n                      <span class=\"text-danger\" ng-if=\"commodityDetails.commodity.length && codeCheck\">\n              Commodity code {{commodityDetails.commodity}} is already taken!\n      </span>\n                      <span class=\"text-danger\" ng-if=\"(commodityDetails.commodity.length < 2) && submitted\">\n              Commodity code needs to be 2 digits\n      </span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Posting </label>\n                    <div class=\"col-sm-10\">\n                      <select name=\"postingSelect\" id=\"postingSelect\" ng-model=\"commodityDetails.posting\" class=\"form-control\" ng-options=\"option.text for option in commodityPosting track by option.text\" ng-disabled=\"!editClicked\">\n                      </select>\n                    </div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n\n          <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n            <history dependencies=\"historyDependencies\"></history>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editMode()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveCommodity()\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("app/masterDataManagement/commodityCode/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <span class=\"expense-header\">List of Commodity</span>\n      <master-export module-name=\"Commodities\" collection=\"11\">\n      </master-export>\n      <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importCommodity()\">\n        Import Commodities\n      </button>\n    </div>\n    <div class=\"col-md-12 mt-15\">\n      <form name=\"searchCommodityCode\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\">\n            <i class=\"fa fa-search\" ng-click=\"search(searchText)\"></i>\n          </span>\n          <input ng-model=\"searchText\" ng-enter=\"search(searchText)\" class=\"form-control\" placeholder=\"Search Commodities\">\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n      <span class=\"expense-header\">Add Commodity</span>\n      <div class=\"row\">\n        <div class=\"col-md-5\">\n          <input type=\"text\" class=\"form-control\" ng-model=\"commodity.descr\" placeholder=\"Enter description\">\n        </div>\n        <div class=\"col-md-3\">\n          <input type=\"text\" class=\"form-control\" ng-model=\"commodity.domain\" placeholder=\"Enter domain\">\n        </div>\n        <div class=\"col-md-2\">\n          <button class=\"btn btn-primary\" ng-click=\"addCommodityModal()\">\n            Submit\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" params=\"params\" service=\"commodityService\">\n      </pagination-service>\n    </div>\n  </div>\n\n  <button class=\"btn btn-default\" ng-click=\"backToParent()\" ng-if=\"!!showParentButton\">\n    Back to parent\n  </button>\n  <button class=\"btn btn-default\" ng-click=\"backToSegments()\" ng-if=\"!!showSegmentButton\">\n    Back to segment\n  </button>\n\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\" ng-if=\"!query\">There are no data for now.</td>\n          <td colspan=\"9\" ng-if=\"!!query\">There are no data matching with search result.</td>\n        </tr>\n        <tr id=\"data.code\" title=\"Click to view child\" ng-repeat=\"data in dataList\" ng-click=\"viewChild(data, $index)\" fadeout-row=\"data.unique_name == highlightId\">\n          <td ng-show=\"showColumn(\'code\')\">{{data.code}}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{data.descr}}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ data.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ data.updater[0].display_name }}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: data.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: data.creator[0].display_name }}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{getActiveStatusName(data.is_active)}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/currency/details/details.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Currency Details</h4>\n  </div>\n  <form name=\"currencyUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n            </li>\n          </ul>\n\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                  <div class=\"form-horizontal\">\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Code</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"currencyDetails.code\" readonly=\"readonly\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Description</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"currencyDetails.descr\" ng-disabled=\"!editClicked\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Status</label>\n                      <div class=\"col-sm-10\">\n                        <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"currencyStatus.isActive for currencyStatus in currencyStatuses track by currencyStatus.isActive\" ng-model=\"currencyDetails.currencyStatus\" required></select>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n            </div>\n\n            <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n              <history dependencies=\"historyDependencies\"></history>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n          Close\n        </button>\n\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"editCurrency()\" ng-show=\"!editClicked && tab === 1\">\n          Edit\n        </button>\n\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"updateCurrency()\" ng-show=\"editClicked && tab === 1\">\n          Save changes\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/masterDataManagement/currency/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Currencies</span>\n        <master-export module-name=\"Currencies\" collection=\"0\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importCurrencies()\">\n          Import Currencies\n        </button>\n      </div>\n      <form name=\"searchUom\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search Currencies\">\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n      <span class=\"expense-header\">Add Currency</span>\n      <div class=\"row\"></div>\n      <form name=\"addCurrency\" class=\"no-ng-check\" ng-submit=\"newCurrencies()\">\n        <div class=\"col-md-3\">\n          <input ng-model=\"currency.code\" class=\"form-control\" placeholder=\"Enter code\" required>\n        </div>\n        <div class=\"col-md-4\">\n          <input ng-model=\"currency.descr\" class=\"form-control\" placeholder=\"Enter description\" required>\n        </div>\n        <div class=\"col-md-3\">\n          <input type=\"submit\" value=\"Submit\" class=\"btn btn-primary\">\n        </div>\n      </form>\n    </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"currenciesService\" params=\"params\">\n      </pagination-service>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no Currency for now.</td>\n        </tr>\n        <tr ng-repeat=\"currency in dataList\" ng-click=\"currencyDetails($index)\">\n          <td ng-show=\"showColumn(\'code\')\">{{ currency.code }}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{ currency.descr }}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ currency.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ currency.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: currency.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: currency.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{ getActiveStatusName(currency.is_active) }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n\n<!--<div class=\"state_currency\">-->\n  <!--<div class=\"row\">-->\n      <!--<h3>Supported Currencies</h3>-->\n      <!--<div class=\"container-fluid\">-->\n        <!--<span class=\"col-md-6\">The currencies that are supported in the system</span>-->\n        <!--<div class=\"col-md-6\">-->\n          <!--<ui-select class=\"select-dropdown_width\" ng-model=\"currency\" theme=\"bootstrap\"-->\n                     <!--on-select=\"onSelectedSupportedCurrency(currency)\">-->\n            <!--<ui-select-match placeholder=\"Select supported currency\">{{$select.selected}}-->\n            <!--</ui-select-match>-->\n            <!--<ui-select-choices refresh-delay=\"0\" repeat=\"c in options.supported_currencies | filter: $select.search\">-->\n              <!--<div ng-bind-html=\"c | highlight: $select.search\"></div>-->\n            <!--</ui-select-choices>-->\n          <!--</ui-select>-->\n        <!--</div>-->\n      <!--</div>-->\n  <!--</div>-->\n  <!--<div class=\"row\">-->\n    <!--<h3>Currency conversion</h3>-->\n    <!--<div class=\"container-fluid form-group\">-->\n      <!--<span class=\"col-md-6\">Source of the conversion</span>-->\n      <!--<div class=\"col-md-6\">-->\n        <!--<ui-select class=\"select-dropdown_width\" ng-model=\"source_conversion\" theme=\"bootstrap\"-->\n                   <!--on-select=\"onSelectedSourceConversion(source_conversion)\">-->\n          <!--<ui-select-match placeholder=\"Select source of conversion\">{{$select.selected}}</ui-select-match>-->\n          <!--<ui-select-choices refresh-delay=\"0\" repeat=\"c in options.source_conversion | filter: $select.search\">-->\n            <!--<div ng-bind-html=\"c | highlight: $select.search\"></div>-->\n          <!--</ui-select-choices>-->\n        <!--</ui-select>-->\n      <!--</div>-->\n    <!--</div>-->\n    <!--<div class=\"container-fluid form-group\" ng-if=\"!manual\">-->\n      <!--<span class=\"col-md-6\">Time interval to retrieve the conversion rate</span>-->\n      <!--<div class=\"col-md-6\">-->\n        <!--<ui-select class=\"select-dropdown_width\" ng-model=\"time_interval\" theme=\"bootstrap\"-->\n          <!--on-select=\"onSelectedTimeInterval(time_interval)\">-->\n          <!--<ui-select-match placeholder=\"Select time interval\">{{$select.selected}}</ui-select-match>-->\n          <!--<ui-select-choices refresh-delay=\"0\" repeat=\"c in options.time_interval | filter: $select.search\">-->\n            <!--<div ng-bind-html=\"c | highlight: $select.search\"></div>-->\n          <!--</ui-select-choices>-->\n        <!--</ui-select>-->\n      <!--</div>-->\n    <!--</div>-->\n  <!--</div>-->\n\n  <!--<div class=\"row\">-->\n    <!--<h3>Current and historical rates used</h3>-->\n    <!--<div class=\"container-fluid\">-->\n      <!--<div class=\"col-md-12\">-->\n        <!--<div class=\"input-group m-b\">-->\n        <!--<span class=\"input-group-btn\">-->\n          <!--<button type=\"button\" class=\"btn btn-white\"><span class=\"fa fa-search\"></span></button>-->\n        <!--</span>-->\n          <!--<input type=\"text\" class=\"form-control\" placeholder=\"Search currency\">-->\n        <!--</div>-->\n        <!--<div class=\"row\" ng-if=\"manual\">-->\n          <!--<div class=\"col-md-3\">-->\n            <!--<input ng-model=\"newCurrency.pair\" class=\"form-control\" placeholder=\"Enter currency pair\">-->\n          <!--</div>-->\n          <!--<div class=\"col-md-3\">-->\n            <!--<input ng-model=\"newCurrency.rate\" class=\"form-control\" placeholder=\"Enter rate\">-->\n          <!--</div>-->\n\n          <!--<div class=\"col-md-2\">-->\n            <!--<div class=\"input-group\">-->\n              <!--<input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Start date\"-->\n                     <!--datepicker-popup=\"dd MMM yyyy\" ng-model=\"newCurrency.start_date\" is-open=\"datepickerOpened.start_date\"-->\n                     <!--datepicker-options=\"dateOptions\" close-text=\"Close\"-->\n                     <!--class=\"form-control pr-needed-by-input\">-->\n              <!--</input>-->\n        <!--<span class=\"input-group-btn\">-->\n          <!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\"><i-->\n            <!--class=\"fa fa-calendar\"></i></button>-->\n        <!--</span>-->\n            <!--</div>-->\n          <!--</div>-->\n          <!--<div class=\"col-md-2\">-->\n            <!--<div class=\"input-group\">-->\n              <!--<input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"End date\"-->\n                     <!--datepicker-popup=\"dd MMM yyyy\" ng-model=\"newCurrency.end_date\" is-open=\"datepickerOpened.end_date\"-->\n                     <!--datepicker-options=\"dateOptions\" nclose-text=\"Close\"-->\n                     <!--class=\"form-control pr-needed-by-input\" min-date=\"newTax.start_date\">-->\n              <!--</input>-->\n        <!--<span class=\"input-group-btn\">-->\n          <!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\"><i-->\n            <!--class=\"fa fa-calendar\"></i></button>-->\n        <!--</span>-->\n            <!--</div>-->\n          <!--</div>-->\n          <!--<div class=\"col-md-2\">-->\n            <!--<input ng-click=\"addCurrency(newCurrency)\" type=\"button\" value=\"Add\" class=\"btn btn-blue\">-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n    <!--</div>-->\n\n    <!--<div class=\"container-fluid\">-->\n      <!--<div class=\"col-md-12\">-->\n        <!--<table class=\"table\">-->\n          <!--<thead>-->\n          <!--<tr>-->\n            <!--<td>Currency pair</td>-->\n            <!--<td>Rate</td>-->\n            <!--<td>Start date</td>-->\n            <!--<td>End date</td>-->\n            <!--<td>Updated at</td>-->\n            <!--<td>Historical</td>-->\n          <!--</tr>-->\n          <!--</thead>-->\n          <!--<tbody>-->\n          <!--<tr>-->\n            <!--<td>USD/MYR</td>-->\n            <!--<td>3.8901</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td>12 am Tomorrow</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td><line-chart data=\"historicalLineChart.data\" options=\"historicalLineChart.options\"></line-chart></td>-->\n          <!--</tr>-->\n          <!--<tr>-->\n            <!--<td>USD/MYR</td>-->\n            <!--<td>3.8901</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td>12 am Tomorrow</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td><line-chart data=\"historicalLineChart.data\" options=\"historicalLineChart.options\"></line-chart></td>-->\n          <!--</tr>-->\n          <!--<tr>-->\n            <!--<td>USD/MYR</td>-->\n            <!--<td>3.8901</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td>12 am Tomorrow</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td><line-chart data=\"historicalLineChart.data\" options=\"historicalLineChart.options\"></line-chart></td>-->\n          <!--</tr>-->\n          <!--<tr>-->\n            <!--<td>USD/MYR</td>-->\n            <!--<td>3.8901</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td>12 am Tomorrow</td>-->\n            <!--<td>12 am Today</td>-->\n            <!--<td><line-chart data=\"historicalLineChart.data\" options=\"historicalLineChart.options\"></line-chart></td>-->\n          <!--</tr>-->\n          <!--</tbody>-->\n        <!--</table>-->\n      <!--</div>-->\n    <!--</div>-->\n  <!--</div>-->\n<!--</div>-->\n</div>");
$templateCache.put("app/masterDataManagement/exchangeRate/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Exchange Rates</span>\n        <master-export module-name=\"Exchange Rates\" collection=\"4\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importGlobalExchangeRate()\">\n          Import Exchange Rates\n        </button>\n      </div>\n      <form name=\"searchUom\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search exchange rates\">\n        </div>\n      </form>\n   </div>\n </div>\n <div class=\"row masterdata-add\">\n   <span class=\"expense-header\">Add Exchange Rate</span>\n   <div class=\"row\"></div>\n   <form name=\"addExchangeRate\" class=\"no-ng-check\" ng-submit=\"newExchangeRate()\">\n     <div class=\"row\">\n       <div class=\"col-md-12\">\n         <div class=\"col-md-3\">\n           <ui-select class=\"select-dropdown_width\" ng-model=\"exchangeRate.fromCurrency\" theme=\"bootstrap\" on-select=\"onSelectedFromCurrency(exchangeRate.fromCurrency)\">\n             <ui-select-match placeholder=\"Select source currency\">{{$select.selected.descr}}</ui-select-match>\n             <ui-select-choices refresh-delay=\"0\" repeat=\"c in currencyExchange | filter: $select.search\">\n               <div ng-bind-html=\"c.code  + (!!c.descr ? \' - \' + c.descr : \'\')| highlight: $select.search\">\n               </div>\n\n             </ui-select-choices>\n           </ui-select>\n           <span class=\"text-danger\" ng-show=\"exchangeRate.fromCurrency == null && !exchangeRate.fromCurrency && submitted\">\n             Select source currency is required\n           </span>\n           <br>\n           <span class=\"text-danger\" ng-show=\"exchangeRate.fromCurrency==exchangeRate.toCurrency && submitted\">\n             Please select different source and target currency\n           </span>\n         </div>\n         <div class=\"col-md-3\">\n           <ui-select class=\"select-dropdown_width\" ng-model=\"exchangeRate.toCurrency\" theme=\"bootstrap\" on-select=\"onSelectedToCurrency(exchangeRate.toCurrency)\">\n             <ui-select-match placeholder=\"Select target currency\">{{$select.selected.descr}}</ui-select-match>\n             <ui-select-choices refresh-delay=\"0\" repeat=\"c in currencyExchange | filter: $select.search\">\n               <div ng-bind-html=\"c.code  + (!!c.descr ? \' - \' + c.descr : \'\') | highlight: $select.search\">\n               </div>\n             </ui-select-choices>\n           </ui-select>\n           <span class=\"text-danger\" ng-show=\"!exchangeRate.toCurrency && submitted\">\n             Target currency is required\n           </span>\n         </div>\n         <div class=\"col-md-2\">\n           <input ng-model=\"exchangeRate.multiplier_rate\" class=\"form-control\" placeholder=\"Enter rate\" ng-pattern=\"/^[0-9.]{0,}$/\" ng-pattern-restrict=\"^[0-9.]{0,10}$\" required>\n\n           <span class=\"text-danger\" ng-show=\"validateMultiplierRate(exchangeRate.multiplier_rate) && submitted\">\n             Multiplier rate cannot be zero\n           </span>\n         </div>\n         <div class=\"col-md-3\">\n           <input ng-model=\"exchangeRate.descr\" class=\"form-control\" placeholder=\"Enter description\" required>\n           <span class=\"text-danger\" ng-show=\"!exchangeRate.descr.length && submitted\">\n             Description is required\n           </span>\n         </div>\n         <div class=\"col-md-1\">\n           <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n           </columns-selector>\n         </div>\n       </div>\n     </div>\n     <div class=\"row\">\n       <div class=\"col-md-12\">\n         <div class=\"col-md-3\">\n           <div class=\"input-group\">\n             <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRate.effective_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" class=\"form-control pr-needed-by-input\" required>\n             \n             <span class=\"input-group-btn\">\n               <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\">\n                 <i class=\"fa fa-calendar\"></i>\n               </button>\n             </span>\n           </div>\n           <span class=\"text-danger\" ng-show=\"!!exchangeRate.effective_at && !!exchangeRate.expiry_at &&\n                 (exchangeRate.effective_at >= exchangeRate.expiry_at) && submitted\">\n             Effective date must be before expiry date\n           </span>\n         </div>\n         <div class=\"col-md-3\">\n           <div class=\"input-group\">\n             <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"Expiry date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"exchangeRate.expiry_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" class=\"form-control pr-needed-by-input\" required>\n             <span class=\"input-group-btn\">\n               <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\">\n                 <i class=\"fa fa-calendar\"></i>\n               </button>\n             </span>\n           </div>\n           <span class=\"text-danger\" ng-show=\"!!exchangeRate.effective_at && !!exchangeRate.expiry_at &&\n                 (exchangeRate.expiry_at <= exchangeRate.effective_at) && submitted\">\n             Expiry date must be after effective date\n           </span>\n         </div>\n         <div class=\"col-md-2\">\n           <input type=\"submit\" value=\"Add\" class=\"btn btn-primary\">\n         </div>\n         <div class=\"col-md-4\">\n           <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"exchangeRateService\" id=\"id\">\n           </pagination-service>\n         </div>\n       </div>\n     </div>\n   </form>\n </div>\n  <a class=\"fa fa-times\" ng-click=\"reset()\" ng-if=\"!!query\">\n    Reset search\n  </a>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no exchange rates for now.</td>\n        </tr>\n        <tr ng-repeat=\"exchangeRate in dataList\" ng-click=\"exchangeRateDetail($index)\">\n          <td ng-show=\"showColumn(\'code\')\">{{ exchangeRate.code }}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{ exchangeRate.descr }}</td>\n          <td ng-show=\"showColumn(\'multiplier_rate\')\">{{ exchangeRate.multiplier_rate }}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ exchangeRate.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ exchangeRate.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: exchangeRate.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: exchangeRate.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'effective_at\')\">{{ exchangeRate.effective_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'expiry_at\')\">{{ exchangeRate.expiry_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'status\')\">{{ getActiveStatusName(exchangeRate.is_active) }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/expenseTypes/details/details.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Expense Type Details</h4>\n  </div>\n  <form name=\"expenseTypeUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"tabs-container\">\n            <ul class=\"nav nav-tabs\">\n              <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n                <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n              </li>\n              <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n                <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n              </li>\n            </ul>\n\n            <div class=\"tab-content\">\n              <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n                <div class=\"panel-body tab-content-fixed-popup\">\n                  <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                    <div class=\"form-horizontal\">\n                      <div class=\"form-group\">\n                        <label class=\"col-sm-2 control-label\">Code</label>\n                        <div class=\"col-sm-10\">\n                          <input type=\"text\" class=\"form-control\" ng-model=\"expenseTypeDetails.code\" readonly=\"readonly\">\n                        </div>\n                      </div>\n                      <div class=\"form-group\">\n                        <label class=\"col-sm-2 control-label\">Description</label>\n                        <div class=\"col-sm-10\">\n                          <input type=\"text\" class=\"form-control\" ng-model=\"expenseTypeDetails.descr\" ng-disabled=\"!editClicked\" required>\n                        </div>\n                      </div>\n                      <div class=\"form-group\">\n                        <label class=\"col-sm-2 control-label\">Status</label>\n                        <div class=\"col-sm-10\">\n                          <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in expenseTypeStatuses track by option.isActive\" ng-model=\"expenseTypeDetails.expenseTypeStatus\" required></select>\n                        </div>\n                      </div>\n                    </div>\n\n                  </div>\n                </div>\n              </div>\n\n              <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n                <history dependencies=\"historyDependencies\"></history>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n          Close\n        </button>\n\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"editExpenseType()\" ng-show=\"!editClicked && tab === 1\">\n          Edit\n        </button>\n\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"updateExpenseType()\" ng-show=\"editClicked && tab === 1\">\n          Save changes\n        </button>\n      </div>\n\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/masterDataManagement/expenseTypes/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n        <span class=\"expense-header\">List of Expense Types</span>\n        <master-export module-name=\"Expense Types\" collection=\"9\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importExpenseType()\">\n          Import Expense Types\n        </button>\n        <div class=\"col-md-12 mt-15\">\n          <form name=\"searchExpenseType\" ng-submit=\"search(searchText)\">\n            <div class=\"input-group\">\n            <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n              <i class=\"fa fa-search\"></i>\n            </span>\n              <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search Expense Types\">\n            </div>\n          </form>\n        </div>\n    </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n      <span class=\"expense-header\">Add Expense Type</span>\n      <div class=\"row\">\n        <form name=\"addExpenseType\" class=\"no-ng-check\">\n          <div class=\"col-md-3\">\n            <input ng-model=\"expenseType.code\" class=\"form-control\" placeholder=\"Enter code\" required>\n          </div>\n          <div class=\"col-md-5\">\n            <input ng-model=\"expenseType.descr\" class=\"form-control\" placeholder=\"Enter description\" required>\n          </div>\n          <div class=\"col-md-2\">\n            <input ng-click=\"addNewExpenseType()\" type=\"submit\" value=\"Submit\" class=\"btn btn-primary\" value=\"Add\">\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"expenseTypeMasterDataList\" params=\"params\">\n      </pagination-service>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no Expense Type for now.</td>\n        </tr>\n        <tr ng-repeat=\"expenseType in dataList\" ng-click=\"expenseTypesDetails($index)\">\n          <td ng-show=\"showColumn(\'code\')\">{{ expenseType.code }}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{ expenseType.descr }}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ expenseType.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ expenseType.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: expenseType.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: expenseType.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{ getActiveStatusName(expenseType.is_active) }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/paymentMethods/details/details.html","<form name=\"paymentMethodUpdateForm\">\n  <div class=\"edit-payment-method\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Payment Method Details</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"tabs-container\">\n        <ul class=\"nav nav-tabs\">\n          <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n            <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n          </li>\n          <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n            <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n          </li>\n        </ul>\n\n        <div class=\"tab-content\">\n          <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n            <div class=\"panel-body tab-content-fixed-popup\">\n              <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                <div class=\"form-horizontal\">\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Code</label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" ng-model=\"paymentMethodDetails.code\" readonly=\"readonly\">\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Description</label>\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" ng-model=\"paymentMethodDetails.descr\" ng-class=\"{\'highlight-error-input\': !paymentMethodDetails.descr.length && submitted}\" ng-disabled=\"!editClicked\" required>\n                      <span class=\"text-danger\" ng-if=\"!paymentMethodDetails.descr.length && submitted\">Payment method\'s description is required</span>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-sm-2 control-label\">Status</label>\n                    <div class=\"col-sm-10\">\n                      <select name=\"statusSelect\" id=\"statusSelect\" ng-model=\"paymentMethodDetails.paymentMethodStatus\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in paymentMethodStatuses track by option.isActive\" required>\n                      </select>\n                    </div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n\n          <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n            <history dependencies=\"historyDependencies\"></history>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editMode()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"savePaymentMethod()\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("app/masterDataManagement/paymentMethods/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Payment Methods</span>\n        <master-export module-name=\"Payment Methods\" collection=\"7\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importPaymentMethod()\">\n          Import Payment Methods\n        </button>\n      </div>\n      </div>\n      <div class=\"col-md-12\">\n      <form name=\"searchPaymentMethod\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search Payment Methods\">\n        </div>\n      </form>\n      </div>\n    </div>\n  </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n      <span class=\"expense-header\">Add Payment Method</span>\n  <div class=\"row\">\n    <form name=\"paymentMethod\" class=\"no-ng-check\" ng-submit=\"addPaymentMethod()\">\n    <div class=\"col-md-3\">\n      <input type=\"text\" class=\"form-control\" ng-model=\"paymentMethods.code\" placeholder=\"Enter code\" ng-change=\"duplicationCheck(\'PaymentMethod\',\'code\',paymentMethods.code,\'code\')\" required>\n      <span class=\"text-danger\" ng-if=\"paymentMethods.code.length && codeCheck\">\n        Payment method code {{paymentMethods.code}} is already taken!\n      </span>\n    </div>\n    <div class=\"col-md-5\">\n      <input type=\"text\" class=\"form-control\" ng-model=\"paymentMethods.descr\" placeholder=\"Enter description\" required>\n    </div>\n    <div class=\"col-md-2\">\n      <input type=\"submit\" value=\"Submit\" class=\"btn btn-primary\">\n    </div>\n    </form>\n    </div>\n  </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"paymentMethodService\" params=\"params\">\n      </pagination-service>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table st-table=\"dataList\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no payment methods for now.</td>\n        </tr>\n        <tr ng-repeat=\"pm in dataList\" ng-click=\"editPaymentMethod(pm)\">\n          <td ng-show=\"showColumn(\'code\')\">{{pm.code}}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{pm.descr}}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ pm.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ pm.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: pm.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: pm.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{getActiveStatusName(pm.is_active)}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/paymentTerms/details/details.html","<form name=\"paymentTermUpdateForm\">\n  <div class=\"edit-payment-term\">\n    <div class=\"modal-header\">\n      <button type=\"button\" class=\"close\" ng-click=\"cancel()\">×</button>\n      <h3 class=\"modal-title\">Payment Term Details</h3>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n            </li>\n          </ul>\n\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                  <div class=\"form-horizontal\">\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Code</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"paymentTermDetails.code\" readonly=\"readonly\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Description</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"paymentTermDetails.descr\" ng-class=\"{\'highlight-error-input\': !paymentTermDetails.descr.length && submitted}\" ng-disabled=\"!editClicked\" required>\n                        <span class=\"text-danger\" ng-if=\"!paymentTermDetails.descr.length && submitted\">Payment term\'s description is required</span>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Status</label>\n                      <div class=\"col-sm-10\">\n                        <select name=\"statusSelect\" id=\"statusSelect\" ng-model=\"paymentTermDetails.paymentTermStatus\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in paymentTermStatuses track by option.isActive\">\n                        </select>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n            </div>\n\n            <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n              <history dependencies=\"historyDependencies\"></history>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editMode()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"savePaymentTerm()\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n\n  </div>\n</form>\n");
$templateCache.put("app/masterDataManagement/paymentTerms/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Payment Terms</span>\n        <master-export module-name=\"Payment Terms\" collection=\"6\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importPaymentTerm()\">\n          Import Payment Terms\n        </button>\n      </div>\n      </div>\n      <div class=\"col-md-12\">\n      <form name=\"searchPaymentTerms\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search Payment Terms\">\n        </div>\n      </form>\n      </div>\n    </div>\n  </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n  <span class=\"expense-header\">Add Payment Term</span>\n      <div class=\"row\"></div>\n  <div class=\"row\">\n    <form name=\"paymentTerm\" class=\"no-ng-check\" ng-submit=\"addPaymentTerm()\">\n      <div class=\"col-md-3\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"paymentTerms.code\" placeholder=\"Enter code\" ng-change=\"duplicationCheck(\'PaymentTerm\',\'code\',paymentTerms.code,\'code\')\" required>\n      <span class=\"text-danger\" ng-if=\"paymentTerms.code.length && codeCheck\">\n        Payment method code {{paymentTerms.code}} is already taken!\n      </span>\n    </div>\n    <div class=\"col-md-5\">\n      <input type=\"text\" class=\"form-control\" ng-model=\"paymentTerms.descr\" placeholder=\"Enter description\" required>\n    </div>\n    <div class=\"col-md-2\">\n      <input type=\"submit\" value=\"Submit\" class=\"btn btn-primary\">\n    </div>\n\n    </form>\n  </div>\n    </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"paymentTermService\" params=\"params\">\n      </pagination-service>\n    </div>\n\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no payment terms for now.</td>\n        </tr>\n        <tr ng-repeat=\"pt in dataList\" ng-click=\"editPaymentTerm(pt)\">\n          <td ng-show=\"showColumn(\'code\')\">{{pt.code}}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{pt.descr}}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ pt.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ pt.updater[0].display_name }}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: pt.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: pt.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{getActiveStatusName(pt.is_active)}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/taxes/detail/detail.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">Tax Details</h4>\n  </div>\n  <form name=\"taxUpdateForm\" ng-submit=\"updateTax(taxDetails)\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"tabs-container\">\n            <ul class=\"nav nav-tabs\">\n              <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n                <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n              </li>\n              <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n                <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n              </li>\n            </ul>\n\n            <div class=\"tab-content\">\n              <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n                <div class=\"panel-body\">\n                  <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                    <div class=\"form-horizontal\">\n                      <div class=\"modal-body\">\n                        <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Code</label>\n                          <div class=\"col-md-10\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"taxDetails.code\" readonly=\"readonly\" required>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Description</label>\n                          <div class=\"col-md-10\">\n                            <input type=\"text\" ng-disabled=\"!editClicked\" class=\"form-control\" ng-model=\"taxDetails.descr\" required>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Rate</label>\n                          <div class=\"col-md-10\">\n                            <input ng-disabled=\"!editClicked\" class=\"form-control\" ng-model=\"taxDetails.rate\" ng-pattern=\"/^[0-9.]{0,}$/\" ng-pattern-restrict=\"^[0-9.]{0,10}$\" required>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <label class=\"col-md-2 control-label\">Country Code</label>\n                          <div class=\"col-md-10\">\n                            <ui-select ng-model=\"taxDetails.selectedCountryCode\" required ng-disabled=\"!editClicked\">\n                              <ui-select-match placeholder=\"Select country code...\">\n                                {{$select.selected.code}} - {{$select.selected.descr}}\n                              </ui-select-match>\n                              <ui-select-choices repeat=\"option in countryCode | filter: $select.search\">\n                                <span>{{ option.code }} - </span>\n                                <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n                              </ui-select-choices>\n                            </ui-select>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <label class=\"col-sm-2 control-label\">Status</label>\n                          <div class=\"col-sm-10\">\n                            <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"option.isActive for option in taxStatuses track by option.isActive\" ng-model=\"taxDetails.taxStatus\" required>\n                            </select>\n                          </div>\n                        </div>\n                        <div class=\"form-group\">\n                          <div class=\"col-md-offset-2 col-md-5\">\n                            <div class=\"input-group\">\n                              <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"taxDetails.effective_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" max-date=\"taxDetails.expiry_at\" datepicker-options=\"startDateOptions\" class=\"form-control\" ng-class=\"{\'white-background\': editClicked}\" required ng-disabled=\"!editClicked\">\n                              <span class=\"input-group-btn\">\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\" ng-disabled=\"!editClicked\">\n                                  <i class=\"fa fa-calendar\"></i>\n                                </button>\n                              </span>\n                            </div>\n                            <span class=\"text-danger\" ng-show=\"!!taxDetails.effective_at &&\n                                  !!taxDetails.expiry_at &&\n                                  (taxDetails.effective_at >= taxDetails.expiry_at) &&\n                                  submitted\">\n                              Effective date must be before expiry date\n                            </span>\n                          </div>\n                          <div class=\"col-md-5\">\n                            <div class=\"input-group\">\n                              <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"Expiry date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"taxDetails.expiry_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" min-date=\"taxDetails.effective_at\" datepicker-options=\"endDateOptions\" class=\"form-control\" ng-class=\"{\'white-background\': editClicked}\" required ng-disabled=\"!editClicked\">\n                              <span class=\"input-group-btn\">\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\" ng-disabled=\"!editClicked\">\n                                  <i class=\"fa fa-calendar\"></i>\n                                </button>\n                              </span>\n                            </div>\n                            <span class=\"text-danger\" ng-show=\"\n                                  !!taxDetails.effective_at &&\n                                  !!taxDetails.expiry_at &&\n                                  (taxDetails.expiry_at <= taxDetails.effective_at) &&\n                                  submitted\">\n                              Expiry date must be after effective date\n                            </span>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n\n                  </div>\n                </div>\n              </div>\n\n              <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n                <history dependencies=\"historyDependencies\"></history>\n              </div>\n            </div>\n          </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editTax()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n\n\n  </form>\n</div>\n");
$templateCache.put("app/masterDataManagement/taxes/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top master-data-tax mt-30\">\n  <div class=\"row masterdata-add\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-12\">\n      <div class=\"row\">\n        <span class=\"expense-header\">List of Taxes</span>\n        <master-export module-name=\"Taxes\" collection=\"8\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importTax()\">\n          Import Taxes\n        </button>\n      </div>\n      </div>\n      <div class=\"col-md-12\">\n      <form name=\"searchUom\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search Taxes\">\n        </div>\n      </form>\n      </div>\n    </div>\n  </div>\n  </div>\n  <div class=\"row masterdata-add\">\n    <form name=\"addUOM\" class=\"no-ng-check\" ng-submit=\"addNewTax(newTax)\">\n    <span class=\"expense-header\">Add Tax</span>\n      <div class=\"row\">\n\n  <div class=\"col-md-11\">\n      <div class=\"col-md-2\">\n        <input ng-model=\"newTax.code\" class=\"form-control\" placeholder=\"Code\" required>\n      </div>\n      <div class=\"col-md-4\">\n        <input ng-model=\"newTax.descr\" class=\"form-control\" placeholder=\"Enter tax description\" required>\n      </div>\n      <div class=\"col-md-2\">\n        <input ng-model=\"newTax.rate\" ng-pattern=\"/^[0-9.]{0,}$/\" ng-pattern-restrict=\"^[0-9.]{0,10}$\" class=\"form-control\" placeholder=\"Rate (%)\" required>\n      </div>\n      <div class=\"col-md-3\">\n\n        <ui-select ng-model=\"newTax.countryCode\" required>\n          <ui-select-match placeholder=\"Select country code...\">\n            {{$select.selected.code}} - {{$select.selected.descr}}\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in countryCode | filter: $select.search\">\n            <span>{{::option.code}} - </span>\n            <span ng-bind-html=\"option.descr | highlight: $select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n        <span class=\"text-danger\" ng-if=\"!newTax.countryCode && submitted\">Country code is required</span>\n      </div>\n    </div>\n      <div class=\"col-md-1\">\n        <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n        </columns-selector>\n      </div>\n\n</div>\n\n    <div class=\"row\">\n      <div class=\"col-md-10\">\n        <div class=\"col-md-4\">\n          <div class=\"input-group\">\n            <input type=\"input\" ng-click=\"openDatepicker($event, \'start_date\')\" placeholder=\"Effective date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"newTax.effective_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.start_date\" datepicker-options=\"startDateOptions\" class=\"form-control\" required>\n            <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'start_date\')\">\n              <i class=\"fa fa-calendar\"></i>\n            </button>\n          </span>\n          </div>\n          <span class=\"text-danger\" ng-show=\"!!newTax.effective_at && !!newTax.expiry_at &&\n                 (newTax.effective_at >= newTax.expiry_at) && submitted\">\n             Effective date must be before expiry date\n           </span>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"input-group\">\n            <input type=\"input\" ng-click=\"openDatepicker($event, \'end_date\')\" placeholder=\"Expiry date\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"newTax.expiry_at\" ng-model-options=\"datePickerTimezone\" is-open=\"datepickerOpened.end_date\" datepicker-options=\"endDateOptions\" class=\"form-control\" required>\n            <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatepicker($event, \'end_date\')\">\n              <i class=\"fa fa-calendar\"></i>\n            </button>\n          </span>\n          </div>\n          <span class=\"text-danger\" ng-show=\"!!newTax.effective_at && !!newTax.expiry_at &&\n                 (newTax.expiry_at <= newTax.effective_at) && submitted\">\n             Expiry date must be after effective date\n           </span>\n        </div>\n        <div class=\"col-md-2\">\n          <input type=\"submit\" value=\"Submit\" class=\"btn btn-primary\">\n        </div>\n        </div>\n      <div class=\"col-md-2\">\n        <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"exchangeRateService\" id=\"id\">\n        </pagination-service>\n      </div>\n    </div>\n    </form>\n  </div>\n\n\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr ng-repeat=\"tax in dataList\" ng-click=\"openTaxDetails($index)\">\n          <td ng-show=\"showColumn(\'code\')\">{{tax.code}}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{tax.descr}}</td>\n          <td ng-show=\"showColumn(\'rate\')\">{{tax.rate}}</td>\n          <td ng-show=\"showColumn(\'effective_at\')\">{{tax.effective_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'expiry_at\')\">{{tax.expiry_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{getActiveStatusName(tax.is_active)}}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/masterDataManagement/uom/details/details.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"cancel()\">x</button>\n    <h4 class=\"modal-title\">UOM Details</h4>\n  </div>\n  <form name=\"uomUpdateForm\">\n    <div class=\"modal-body\">\n      <div class=\"row\">\n        <div class=\"tabs-container\">\n          <ul class=\"nav nav-tabs\">\n            <li class=\"active\" ng-class=\"{ active: tab === 1 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(1)\" aria-expanded=\"true\">Edit</a>\n            </li>\n            <li class=\"\" ng-class=\"{ active: tab === 2 }\">\n              <a data-toggle=\"tab\" ng-click=\"toggleTab(2)\" aria-expanded=\"false\">History</a>\n            </li>\n          </ul>\n\n          <div class=\"tab-content\">\n            <div id=\"tab-1\" class=\"tab-pane\" ng-class=\"{ active: tab === 1}\">\n              <div class=\"panel-body tab-content-fixed-popup\">\n                <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\">\n\n                  <div class=\"form-horizontal\">\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Code</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"uomDetails.code\" readonly=\"readonly\">\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Description</label>\n                      <div class=\"col-sm-10\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"uomDetails.descr\" ng-disabled=\"!editClicked\" required>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Fraction</label>\n                      <div class=\"col-sm-10\">\n                        <select name=\"uomFraction\" id=\"uomFraction\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"fraction.status for fraction in uomFraction track by fraction.status\" ng-model=\"uomDetails.is_fraction\" required></select>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <label class=\"col-sm-2 control-label\">Status</label>\n                      <div class=\"col-sm-10\">\n                        <select name=\"statusSelect\" id=\"statusSelect\" class=\"form-control\" ng-disabled=\"!editClicked\" ng-options=\"uomStatus.isActive for uomStatus in uomStatuses track by uomStatus.isActive\" ng-model=\"uomDetails.uomStatus\" required></select>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n              </div>\n            </div>\n\n            <div id=\"tab-2\" class=\"tab-pane panel-body\" ng-class=\"{ active: tab === 2}\">\n              <history dependencies=\"historyDependencies\"></history>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">\n        Close\n      </button>\n\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"editUOM()\" ng-show=\"!editClicked && tab === 1\">\n        Edit\n      </button>\n\n      <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"updateUom()\" ng-show=\"editClicked && tab === 1\">\n        Save changes\n      </button>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("app/masterDataManagement/uom/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top general-listing mt-30\">\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-12\">\n        <span class=\"expense-header\">List of UOMs</span>\n        <master-export module-name=\"UOMs\" collection=\"5\">\n        </master-export>\n        <button class=\"btn btn-primary pull-right btn-xs margin-right\" ng-click=\"importUOM()\">\n          Import UOMs\n        </button>\n      <div class=\"row\"></div>\n      </div>\n      <div class=\"col-md-12\">\n      <form name=\"searchUom\" ng-submit=\"search(searchText)\">\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\" ng-click=\"search(searchText)\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input ng-model=\"searchText\" class=\"form-control\" placeholder=\"Search UOMs\">\n        </div>\n      </form>\n        </div>\n  </div>\n\n  <div class=\"row masterdata-add\">\n    <div class=\"col-md-10\">\n      <span class=\"expense-header\">Add UOM</span>\n       <div class=\"row\"></div>\n        <form name=\"addUOM\" class=\"no-ng-check\" ng-submit=\"newUom()\">\n        <div class=\"col-md-3\">\n          <input ng-model=\"uom.code\" class=\"form-control\" placeholder=\"Enter code\" required>\n        </div>\n          <div class=\"col-md-4\">\n            <input ng-model=\"uom.descr\" class=\"form-control\" placeholder=\"Enter description\" required>\n          </div>\n          <div class=\"col-md-3\">\n            <ui-select ng-model=\"uom.is_fraction\">\n              <ui-select-match placeholder=\"Fraction enabling\">\n                {{$select.selected.status}}\n              </ui-select-match>\n              <ui-select-choices repeat=\"option in uomFraction\">\n                <span ng-bind-html=\"option.status\"></span>\n              </ui-select-choices>\n            </ui-select>\n            <span class=\"text-danger\" ng-show=\"!uom.is_fraction && submitted\">\n              Fraction is required\n            </span>\n            <br>\n          </div>\n          <div class=\"col-md-2\">\n            <input type=\"submit\" value=\"Submit\" class=\"btn btn-primary\">\n          </div>\n        </form>\n    </div>\n    <div class=\"col-md-2\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"uomService\" params=\"params\">\n      </pagination-service>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table class=\"table\" st-table=\"dataList\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n        <thead table-header available-headers=\"columns\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-hide=\"dataList.length > 0\">\n          <td colspan=\"9\">There are no UOM for now.</td>\n        </tr>\n        <tr ng-repeat=\"uom in dataList\" ng-click=\"uomDetails($index)\">\n          <td ng-show=\"showColumn(\'code\')\">{{ uom.code }}</td>\n          <td ng-show=\"showColumn(\'descr\')\">{{ uom.descr }}</td>\n          <td ng-show=\"showColumn(\'fraction\')\">{{ uom.is_fraction === 1 ? \'Allowed\' : \'Not allowed\' }}</td>\n          <td ng-show=\"showColumn(\'updated_at\')\">{{ uom.updated_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">{{ uom.updater[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'created_at\')\">{{ :: uom.created_at | date: \'dd MMM yyyy\'}}</td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">{{ :: uom.creator[0].display_name}}</td>\n          <td ng-show=\"showColumn(\'is_active\')\">{{ getActiveStatusName(uom.is_active) }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/settings/PR-POSettings/prefix/PRPOPrefixTemplate.html","  <a>{{company.descr}}</a>\n<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">\n        Displaying Companies\n      </h3>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : companies.length > 1}\">\n      <thead>\n      <tr>\n        <th>Company Name</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(companies).length\">\n        <td colspan=\"9\">There are no companies.</td>\n      </tr>\n      <tr class=\"cursor-pointer\" ng-repeat=\"company in companies\" ng-class=\"{\'row-select\': company.selected}\" ng-click=\"openPrefixPanel(company)\">\n        <td>\n          {{::company.descr}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n");
$templateCache.put("app/settings/PR-POSettings/prefix/prefixModalTemplate.html","<div class=\"inmodal\">\n<div class=\"modal-header\">\n    <h4 class=\"modal-title\">Prefixes for {{companyTitle}}</h4>\n</div>\n\n  <div class=\"ibox-content\">\n    <div class=\"form-group\" ng-if=\"prefixes.length === 0\">\n      <div class=\"row\">\n        <div class=\"col-sm-4\">\n          <input type=\"text\" ng-model=\"addPrefixField\" class=\"form-control\" placeholder=\"Company Prefix\" required>\n        </div>\n        <div class=\"col-sm-2\">\n          <input type=\"number\" ng-model=\"addPrefixCount\" class=\"form-control\" placeholder=\"Count\" required>\n        </div>\n        <div class=\"col-sm-3\">\n          <ui-select ng-model=\"selectPrefixType\" on-select=\"onSelectedPrefixType(selectPrefixType)\">\n            <ui-select-match placeholder=\"Select type...\">\n              {{$select.selected.descr}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"prefix in prefixTypes | filter: $select.search\">\n              <span ng-bind-html=\"prefix.descr | highlight: $select.search\"></span>\n            </ui-select-choices>\n          </ui-select>\n        </div>\n        <div class=\"col-sm-1\">\n          <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addPrefix(addPrefixField, addPrefixCount)\" ng-disabled=\"!addPrefixField\">Add Prefix</button>\n        </div>\n      </div>\n    </div>\n\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>#</th>\n        <th>Reference Counter</th>\n        <th class=\"col-sm-3\">Prefix</th>\n        <th>Count</th>\n        <th class=\"col-sm-4\">Type</th>\n        <!--<th class=\"col-sm-1\"></th>-->\n      </tr>\n      </thead>\n      <tbody>\n      <tr class=\"modal-body\" ng-repeat=\"prefix in prefixes track by $index\" ng-click=\"editMode()\">\n        <td>{{$index + 1}}</td>\n        <td>{{prefix.prefix}}-{{prefix.company_code}}-{{prefix.suffix}}</td>\n        <td editable-text=\"prefix.prefix\" blur=\"submit\" buttons=\"no\" onbeforesave=\"validateXeditable($data, prefix)\" onaftersave=\"updatePrefix(prefix.prefix, prefix, $index)\" e-required>{{prefix.prefix}}</td>\n        <td>{{prefix.count}}</td>\n        <td>{{replaceStringCase(prefix.type)}}</td>\n        <!--<td>-->\n          <!--<a ng-click=\"deletePrefix(prefix, $index)\">-->\n          <!--<i class=\"fa fa-trash-o\"></i>-->\n          <!--</a>-->\n        <!--</td>-->\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"modal-footer\">\n      <!--<button type=\"submit\"-->\n              <!--class=\"btn btn-primary\"-->\n              <!--ng-click=\"updatePrefix(companyPrefix)\"-->\n              <!--ng-if=\"editClicked\">Save</button>-->\n      <!--<button type=\"button\"-->\n              <!--class=\"btn btn-default\"-->\n              <!--ng-click=\"editMode()\"-->\n              <!--ng-if=\"!editClicked\">Edit</button>-->\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierGroups/detail/detail.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"title-details\">{{ supplierBUCode }} - {{ supplierBUDescr }} Supplier Business Unit</span>\n    </div>\n\n    <div class=\"col-md-5 no-padding mt-15\">\n      <h3>Displaying {{supplierBUStatus}} Suppliers</h3>\n    </div>\n\n    <div class=\"col-md-7 no-padding mt-15\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n    </div>\n\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingSupplierService\" offset=\"20\">\n    </pagination-service>\n\n    <div class=\"no-padding-left btn-group pull-left share-tab-focus\" role=\"group\">\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'all\', \'btn-white\': supplierBUStatus !== \'all\'}\" ui-sref=\"main.user.suppliersList.supplierGroupDetail({status: \'all\'})\">\n        All\n      </button>\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'active\', \'btn-white\': supplierBUStatus !== \'active\'}\" ui-sref=\"main.user.suppliersList.supplierGroupDetail({status: \'active\'})\">\n        Active\n      </button>\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'black listed\', \'btn-white\': supplierBUStatus !== \'black listed\'}\" ui-sref=\"main.user.suppliersList.supplierGroupDetail({status: \'black_listed\'})\">\n        Black Listed\n      </button>\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'inactive\', \'btn-white\': supplierBUStatus !== \'inactive\'}\" ui-sref=\"main.user.suppliersList.supplierGroupDetail({status: \'inactive\'})\">\n        Inactive\n      </button>\n    </div>\n  </div>\n</div>\n  <div class=\"container-fluid\">\n    <div class=\"row m-t-xs m-b-xs\">\n      <div class=\"table-responsive\">\n        <table id=\"dynamicHeightTable\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\" dynamic-height tabindex=\"1\">\n          <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n          <tbody>\n          <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n            <td colspan=\"9\">There are no suppliers in this group.</td>\n          </tr>\n          <tr ng-repeat=\"supplier in dataList track by $index\" ui-sref=\"main.user.suppliersList.detail({id: supplier._id})\" fadeout-row=\"supplier._id == highlightId\">\n            <td ng-show=\"showColumn(\'descr\')\">\n              {{supplier.descr}}\n            </td>\n            <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n              {{supplier.mb_supplier_code}}\n            </td>\n            <td ng-show=\"showColumn(\'reg_no\')\">\n              {{supplier.reg_no }}\n            </td>\n            <td ng-show=\"showColumn(\'currency_code\')\">\n              {{supplier.currency_code}}\n            </td>\n            <td ng-show=\"showColumn(\'email\')\">\n              {{supplier.email}}\n            </td>\n            <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n              {{supplier.contact_person[0].first_name}}\n            </td>\n            <td ng-show=\"showColumn(\'contact_person.email\')\">\n              {{supplier.contact_person[0].email}}\n            </td>\n            <td ng-show=\"showColumn(\'contact_person.phone\')\">\n              {{supplier.contact_person[0].phone}}\n            </td>\n            <td ng-show=\"showColumn(\'primary_business_nature\')\">\n              {{supplier.primary_business_nature}}\n            </td>\n            <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n              {{supplier.primary_commodity[0].descr}}\n            </td>\n            <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n              {{supplier.secondary_commodity[0].descr || \'N/A\'}}\n            </td>\n            <td ng-show=\"showColumn(\'created_at\')\">\n              {{supplier.created_at | date: \'dd MMM yyyy\'}}\n            </td>\n            <td ng-show=\"showColumn(\'creator.display_name\')\">\n              {{supplier.creator[0].display_name}}\n            </td>\n            <td ng-show=\"showColumn(\'updated_at\')\">\n              {{supplier.updated_at | date: \'dd MMM yyyy\'}}\n            </td>\n            <td ng-show=\"showColumn(\'updater.display_name\')\">\n              {{supplier.updater[0].display_name}}\n            </td>\n            <td ng-show=\"status === \'all\' && showColumn(\'bu_status\')\">\n              {{getStatusName(supplier.bu_status, supplier.status)}}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n");
$templateCache.put("app/suppliersList/supplierGroups/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Supplier Business Units</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingBUService\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There are no supplier business units.</td>\n      </tr>\n      <tr ng-repeat=\"sg in dataList track by $index\" ui-sref=\"main.user.suppliersList.supplierGroupDetail(\n            {\n              bu_code: sg.code,\n              bu_descr: sg.descr,\n              status: \'all\',\n              order_by: \'descr\',\n              order: 1\n            }\n          )\">\n        <td ng-if=\"showColumn(\'code\')\">\n          {{sg.code}}\n        </td>\n        <td ng-if=\"showColumn(\'descr\')\">\n          {{sg.descr}}\n        </td>\n        <td ng-if=\"showColumn(\'created_at\')\">\n          {{sg.created_at | date : \'dd MMM yyyy\'}}\n        </td>\n        <td ng-if=\"showColumn(\'creator.display_name\')\">\n          {{sg.creator[0].display_name}}\n        </td>\n        <td ng-if=\"showColumn(\'updated_at\')\">\n          {{sg.updated_at | date : \'dd MMM yyyy\'}}\n        </td>\n        <td ng-if=\"showColumn(\'updater.display_name\')\">\n          {{sg.updater[0].display_name}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierTagsByCompany/detail/detail.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">Suppliers Tagged to {{ companyName }}</span>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying suppliers</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <span ng-if=\"!!suppliersTaggedToCompany.length && isCurrentUserSupplierManager()\">\n        <master-export module-name=\"Suppliers Tagged to {{ companyName }}\" collection=\"101\">\n        </master-export>\n      </span>\n    </div>\n      <button class=\"btn btn-sm btn-white pull-right\" ng-if=\"!!suppliersTaggedToCompany.length && !!canEditSupplierTag\" ng-click=\"goToSupplierTagging()\">\n        Edit Suppliers Tagged\n      </button>\n    <pagination-service cursor=\"meta.cursor\" list=\"suppliersTaggedToCompany\" service=\"supplierTagService\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : suppliersTaggedToCompany.length > 1}\" ng-show=\"!editClicked\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(suppliersTaggedToCompany).length\">\n        <td colspan=\"9\">There are no suppliers tagged to this company.</td>\n      </tr>\n      <tr ng-repeat=\"supplier in suppliersTaggedToCompany\" ng-class=\"{\'row-select\': supplier.selected}\" ui-sref=\"main.user.suppliersList.detail({id: supplier._id})\" fadeout-row=\"supplier._id == highlightId\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{ supplier.descr || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n          {{ supplier.mb_supplier_code || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{ supplier.reg_no || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{ supplier.currency_code || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'email\')\">\n          {{ supplier.email || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n          {{ supplier.contact_person[0].first_name || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.email\')\">\n          {{ supplier.contact_person[0].email || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.phone\')\">\n          {{ supplier.contact_person[0].phone || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'primary_business_nature\')\">\n          {{ supplier.primary_business_nature || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n          {{ supplier.primary_commodity[0].descr || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n          {{ supplier.secondary_commodity[0].descr || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ supplier.created_at | date: \'dd MMM yyyy\' || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ supplier.creator[0].display_name || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ supplier.updated_at | date: \'dd MMM yyyy\' || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ supplier.updater[0].display_name || \'N/A\' }}\n        </td>\n        <td ng-show=\"showColumn(\'status\')\">\n          {{ ::getStatusName(supplier.status, supplier.approval_status, supplier.draft_status) || \'N/A\' }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierTagsByCompany/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Companies</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"companiesService;\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There are no companies available.</td>\n      </tr>\n      <tr ng-repeat=\"company in dataList\" ng-class=\"{\'row-select\': tags.selected}\" ng-click=\"supplierTagDetails(company)\" fadeout-row=\"company._id == highlightId\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{ company.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'code\')\">\n          {{ company.code }}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{ company.reg_no }}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{ company.currency_code }}\n        </td>\n        <td ng-show=\"showColumn(\'business_unit.descr\')\">\n          {{ company.business_unit[0].descr }}\n        </td>\n        <td ng-show=\"showColumn(\'industry.descr\')\">\n          {{ company.industry[0].descr }}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ company.creator[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ company.created_at | date : \'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ company.updater[0].display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ company.updated_at | date : \'dd MMM yyyy\' }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierTagsBySupplier/detail/detail.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">Companies Tagged to {{ supplierName }}</span>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Companies</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n      <span ng-if=\"!!companiesTaggedToSupplier.length && isCurrentUserSupplierManager()\">\n        <master-export module-name=\"Companies Tagged to {{ supplierName }}\" collection=\"101\">\n        </master-export>\n      </span>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"companiesTaggedToSupplier\" service=\"supplierTagService\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : companiesTaggedToSupplier.length > 1}\" ng-show=\"!editClicked\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(companiesTaggedToSupplier).length\">\n        <td colspan=\"9\">There are no companies tagged to this supplier.</td>\n      </tr>\n      <tr ng-repeat=\"company in companiesTaggedToSupplier\" ng-class=\"{\'row-select\': company.selected}\" ui-sref=\"main.user.companiesMgmt.detailCompanies({ id: company._id })\" fadeout-row=\"company._id == highlightId\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{ company.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'code\')\">\n          {{ company.code }}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{ company.reg_no }}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{ company.currency_code }}\n        </td>\n        <td ng-show=\"showColumn(\'business_unit.descr\')\">\n          {{ company.business_unit.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'industry.descr\')\">\n          {{ company.industry.descr }}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{ company.creator.display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{ company.created_at | date : \'dd MMM yyyy\' }}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{ company.updater.display_name }}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{ company.updated_at | date : \'dd MMM yyyy\' }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersList/supplierTagsBySupplier/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\" ui-scrollfix>\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Suppliers</h3>\n    </div>\n    <!-- Single button -->\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"suppliersService\" status=\"status\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row m-t-xs m-b-xs\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There are no suppliers available.</td>\n      </tr>\n      <tr ng-repeat=\"supplier in dataList\" ng-class=\"{\'row-select\': tags.selected}\" ng-click=\"supplierTagDetails(supplier)\" fadeout-row=\"supplier.mb_supplier_code == highlightId\">\n        <td ng-show=\"showColumn(\'descr\')\">\n          {{supplier.descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n          {{supplier.mb_supplier_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'reg_no\')\">\n          {{supplier.reg_no || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'currency_code\')\">\n          {{supplier.currency_code || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'email\')\">\n          {{supplier.email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n          {{supplier.contact_person[0].first_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.email\')\">\n          {{supplier.contact_person[0].email || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'contact_person.phone\')\">\n          {{supplier.contact_person[0].phone || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_business_nature\')\">\n          {{supplier.primary_business_nature || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n          {{supplier.primary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n          {{supplier.secondary_commodity[0].descr || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'created_at\')\">\n          {{(supplier.created_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'creator.display_name\')\">\n          {{supplier.creator[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updated_at\')\">\n          {{(supplier.updated_at | date: \'dd MMM yyyy\') || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'updater.display_name\')\">\n          {{supplier.updater[0].display_name || \'N/A\'}}\n        </td>\n        <td ng-show=\"showColumn(\'status\')\">\n          {{getStatusName(supplier.status)}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/branches/add/add.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">x</button>\n    <h4 class=\"modal-title\">Add Supplier Branch</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"form-horizontal\">\n          <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">\n              Supplier Branch Name\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !branches.descr && submitted}\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"branches.descr\" maxlength=\"150\" placeholder=\"Supplier Branch Name\" required>\n              <span class=\"text-danger\" ng-if=\"!branches.descr && submitted\">\n                Branch name is required\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Receiving PO Method\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branches.receive_via_email\" id=\"via-email\">\n              <label for=\"via-email\">Email</label>\n            </div>\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branches.receive_via_fax\" id=\"via-fax\">\n              <label for=\"via-fax\">Fax</label>\n            </div>\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branches.receive_via_post\" id=\"via-post\">\n              <label for=\"via-post\">Post</label>\n            </div>\n            <span class=\"text-danger\" ng-show=\"!branches.receive_via_email &&\n              !branches.receive_via_fax && !branches.receive_via_post && !!submitted\">\n              PO Receiving Method is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Email\n            <span class=\"asterisk-required\" ng-if=\"!!branches.receive_via_email\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input ng-class=\"{\'highlight-error-input\': !!branches.email &&\n                          !validateEmail(branches.email)}\" type=\"text\" ng-model=\"branches.email\" class=\"form-control\" placeholder=\"(Supplier\'s Branch E-mail e.g. sunway@sunway.com)\">\n            <span class=\"text-danger\" ng-show=\"!!branches.email && !validateEmail(branches.email)\">\n                Invalid email\n            </span>\n            <span class=\"text-danger\" ng-show=\"!branches.email.length && submitted\">\n                An email is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Phone\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input type=\"text\" ng-model=\"branches.phone\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branches.phone.length && submitted}\" placeholder=\"(Supplier\'s Phone No. e.g. 000504664064)\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)([0-9-+\\s]{0,50})$\">\n              <span class=\"text-danger\" ng-show=\"!branches.phone.length && submitted\">\n                A phone number is required\n              </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Fax\n            <span class=\"asterisk-required\" ng-if=\"!!branches.receive_via_fax\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input ng-class=\"{\'highlight-error-input\': !branches.fax.length && submitted}\" type=\"text\" ng-model=\"branches.fax\" class=\"form-control\" placeholder=\"(Supplier\'s Fax No. e.g. +44 161 999 8888)\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\">\n            <span class=\"text-danger\" ng-show=\"!branches.fax.length && submitted\">\n                A fax number is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Status\n            <span class=\"asterisk-required\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"m-r-xs checkbox-font-size\">\n              <div class=\"col-sm-9 m-b\">\n                <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"status in branchStatus track by $index\">\n                  <input type=\"radio\" id=\"status-{{$index}}\" name=\"branchStatus\" ng-model=\"branches.isActive\" ng-value=\"status.value\">\n                  &nbsp;&nbsp;<label>{{status.descr}}</label>\n                </div>\n                <span class=\"text-danger\" ng-if=\"noBumiStatus && submitted\">\n                    Bumiputra status is required\n                  </span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Corresponding Address\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 m-b\">\n                <input type=\"text\" ng-model=\"branches.address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branches.address.line1 && submitted}\">\n                <span class=\"text-danger\" ng-show=\"!branches.address.line1 && submitted\">\n                  An address line is required\n                </span>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-8 m-b\">\n                <input type=\"text\" ng-model=\"branches.address.line2\" placeholder=\"Address Line 2\" class=\"form-control\">\n              </div>\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branches.address.line3\" placeholder=\"Address Line 3\" class=\"form-control\">\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branches.address.postal_code\" placeholder=\"Post Code\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branches.address.postal_code && submitted}\">\n                <span class=\"text-danger\" ng-show=\"!branches.address.postal_code && submitted\">\n                  A postal code is required\n                </span>\n              </div>\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branches.address.city\" placeholder=\"City\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branches.address.city && submitted}\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\">\n                <span class=\"text-danger\" ng-show=\"!branches.address.city && submitted\">\n                  A city is required\n                </span>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !branches.address.country && submitted}\">\n                <ui-select ng-model=\"branches.address.country\" on-select=\"onUpdatedCountry(branches.address.country)\" required>\n                  <ui-select-match placeholder=\"Select a country\">\n                    {{$select.selected}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"countryCodes in countries | filter: $select.search\">\n                    <span ng-bind-html=\"countryCodes.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n                <span class=\"text-danger\" ng-show=\"!branches.address.country && submitted\">\n                    A country is required\n                </span>\n              </div>\n              <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !branches.address.state && submitted}\" ng-if=\"!!selectedMalaysia\">\n                <ui-select ng-model=\"branches.address.state\" on-select=\"onUpdatedState(branches.address.state)\" required>\n                  <ui-select-match placeholder=\"Select a state\">\n                    {{$select.selected}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                    <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n                <span class=\"text-danger\" ng-show=\"!branches.address.state && submitted\">\n                  A state is required\n                </span>\n              </div>\n              <div class=\"col-lg-4 m-b\" ng-if=\"!selectedMalaysia\">\n                <input type=\"text\" ng-model=\"branches.address.state\" placeholder=\"State\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branches.address.state && submitted}\" ng-pattern=\"/^[a-zA-Z-_\'/:;,.\\s]{2,}$/\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\">\n                <span class=\"text-danger\" ng-show=\"!branches.address.state && submitted\">\n                    A state is required\n                </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Branch Contact Person(s)\n              <span class=\"asterisk-required\">*</span>\n              <div>\n                <i>( First contact will be the primary contact )</i>\n              </div>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <div class=\"row add-contact-person\" ng-if=\"!!branches.contact && (branches.contact[0] !== null)\">\n                <div class=\"col-sm-4 contact-box\" ng-repeat=\"item in branches.contact\">\n                  <a class=\"btn-btn-link pull-right remove-contact-stick\" ng-click=\"removeContact(item)\">\n                    <span class=\"fa fa-trash-o\"></span>\n                  </a>\n                  <h3>\n                    <strong>{{item.first_name}}</strong>\n                  </h3>\n                  <address>\n                    Email: {{item.email}}<br>\n                    Phone: {{item.phone}}<br>\n                    Fax  : {{item.fax}}\n                  </address>\n                  <a class=\"clickable-link\" edit-contact=\"item\" updated-contact=\"onUpdatedContact(contact)\">\n                    Edit\n                  </a>\n                </div>\n              </div>\n              <div class=\"row add-contact-person\">\n                <button ng-class=\"{\'btn btn-success add-new-contact-button dropdown-toggle\': !(supplier.status === \'PENDING\'),\n                             \'btn btn-default add-new-contact-button dropdown-toggle\': (supplier.status === \'PENDING\')}\" add-contact added-contact=\"addContact(contact)\" uib-tooltip=\"Add a contact\">\n                  <span class=\"fa fa-plus\"></span>\n                </button>\n              </div>\n              <span class=\"text-danger\" ng-if=\"!branches.contact.length && submitted\">\n                  A contact person is required\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"newBranch()\" ng-disabled=\"!!submitted\">\n      Add\n    </button>\n    <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">\n      Close\n    </button>\n  </div>\n</div>\n\n");
$templateCache.put("app/suppliersManagement/branches/details/details.html","<div class=\"modal-content modal-inside\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"closeModal()\">x</button>\n    <h4 class=\"modal-title\">{{ !!editClicked ? \'Modify\' : \'View\'  }} Supplier\'s Branch</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"form-horizontal\">\n          <div class=\"form-group\">\n            <label class=\"col-sm-2 control-label\">\n              Supplier Branch Name\n              <span class=\"asterisk-required\">*</span>\n            </label>\n            <div class=\"col-sm-9 m-b\" ng-class=\"{\'highlight-error-input\': !branchesDetails.descr && submitted}\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"branchesDetails.descr\" maxlength=\"150\" ng-disabled=\"!editClicked\" placeholder=\"Supplier Branch Name\" required>\n              <span class=\"text-danger\" ng-if=\"!branchesDetails.descr && submitted\">Branch name is required</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Supplier Code\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input type=\"text\" ng-model=\"branchesDetails.code\" class=\"form-control\" readonly=\"readonly\">\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Receiving PO Method\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branchesDetails.receive_via_email\" id=\"via-email\" ng-disabled=\"!editClicked\">\n              <label for=\"via-email\">Email</label>\n            </div>\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branchesDetails.receive_via_fax\" id=\"via-fax\" ng-disabled=\"!editClicked\">\n              <label for=\"via-fax\">Fax</label>\n            </div>\n            <div class=\"m-r-xs checkbox-font-size\">\n              <input type=\"checkbox\" ng-model=\"branchesDetails.receive_via_post\" id=\"via-post\" ng-disabled=\"!editClicked\">\n              <label for=\"via-post\">Post</label>\n            </div>\n            <span class=\"text-danger\" ng-show=\"!branchesDetails.receive_via_email &&\n                         !branchesDetails.receive_via_fax && !branchesDetails.receive_via_post\n                         && !!submitted\">\n                PO Receiving Method is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Email\n            <span class=\"asterisk-required\" ng-if=\"!!branchesDetails.receive_via_email\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input ng-class=\"{\'highlight-error-input\': !!branchesDetails.email &&\n                          !validateEmail(branchesDetails.email)}\" type=\"text\" ng-model=\"branchesDetails.email\" class=\"form-control\" validate-email placeholder=\"(Supplier\'s Branch E-mail e.g. sunway@sunway.com)\" ng-disabled=\"!editClicked\">\n            <span class=\"text-danger\" ng-show=\"!!branchesDetails.email && !validateEmail(branchesDetails.email)\">\n                Invalid email\n            </span>\n            <span class=\"text-danger\" ng-show=\"!branchesDetails.email.length && submitted\">\n                An email is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Phone\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input type=\"text\" ng-model=\"branchesDetails.phone\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branchesDetails.phone.length && !!submitted}\" placeholder=\"(Supplier\'s Phone No. e.g. 000504664064)\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)([0-9-+\\s]{0,50})$\" ng-disabled=\"!editClicked\">\n            <span class=\"text-danger\" ng-show=\"!branchesDetails.phone.length && !!submitted\">\n              A phone number is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Fax\n            <span class=\"asterisk-required\" ng-if=\"!!branchesDetails.receive_via_fax\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <input ng-class=\"{\'highlight-error-input\': !branchesDetails.fax.length && !!submitted}\" type=\"text\" ng-model=\"branchesDetails.fax\" class=\"form-control\" placeholder=\"(Supplier\'s Fax No. e.g. +44 161 999 8888)\" ng-pattern=\"/^[0-9-+\\s]{7,}$/\" ng-pattern-restrict=\"^(?!-)[0-9-+\\s]{0,50}$\" ng-disabled=\"!editClicked\">\n            <span class=\"text-danger\" ng-show=\"!branchesDetails.fax.length && submitted\">\n                  A fax number is required\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Branch Status\n            <span class=\"asterisk-required\">\n              *\n            </span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"status in branchStatus track by $index\">\n              <div class=\"input-group\">\n                <input type=\"radio\" ng-disabled=\"!editClicked\" ng-model=\"branchesDetails.isActive\" ng-value=\"status.value\">\n                <span>\n                  &nbsp;&nbsp;{{status.descr}}\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-2 control-label\">\n            Corresponding Address\n            <span class=\"asterisk-required\">*</span>\n          </label>\n          <div class=\"col-sm-9 m-b\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 m-b\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.line1\" placeholder=\"Address Line 1\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branchesDetails.address.line1 && submitted}\" ng-disabled=\"!editClicked\">\n                <span class=\"text-danger\" ng-show=\"!branchesDetails.address.line1 && submitted\">\n                  An address line is required\n                </span>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-8 m-b\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.line2\" placeholder=\"Address Line 2\" class=\"form-control\" ng-disabled=\"!editClicked\">\n              </div>\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.line3\" placeholder=\"Address Line 3\" class=\"form-control\" ng-disabled=\"!editClicked\">\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.postal_code\" placeholder=\"Post Code\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branchesDetails.address.postal_code && submitted}\" ng-disabled=\"!editClicked\">\n                <span class=\"text-danger\" ng-show=\"!branchesDetails.address.postal_code && submitted\">\n                  A postal code is required\n                </span>\n              </div>\n              <div class=\"col-lg-4 m-b\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.city\" placeholder=\"City\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branchesDetails.address.city && submitted}\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-disabled=\"!editClicked\">\n                <span class=\"text-danger\" ng-show=\"!branchesDetails.address.city && submitted\">\n                  A city is required\n                </span>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !branchesDetails.address.country && submitted}\">\n                <ui-select ng-model=\"branchesDetails.address.country\" on-select=\"onUpdatedCountry(branchesDetails.address.country)\" ng-disabled=\"!editClicked\" required>\n                  <ui-select-match placeholder=\"Select a country\">\n                    {{$select.selected}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"countryCodes in countries | filter: $select.search\">\n                    <span ng-bind-html=\"countryCodes.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n              <div class=\"col-lg-4 m-b\" ng-class=\"{\'ui-select-error-highlight\': !branchesDetails.address.state && submitted}\" ng-if=\"!!selectedMalaysia\">\n                <ui-select ng-model=\"branchesDetails.address.state\" ng-disabled=\"!editClicked\" on-select=\"onUpdatedState(branchesDetails.address.state)\" required>\n                  <ui-select-match placeholder=\"Select a state\">\n                    {{$select.selected}}\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"MYState in MYStates | filter: $select.search\">\n                    <span ng-bind-html=\"MYState.descr | highlight: $select.search\"></span>\n                  </ui-select-choices>\n                </ui-select>\n                <span class=\"text-danger\" ng-show=\"!branchesDetails.address.state && submitted\">\n                  A state is required\n                </span>\n              </div>\n              <div class=\"col-lg-4 m-b\" ng-if=\"!selectedMalaysia\">\n                <input type=\"text\" ng-model=\"branchesDetails.address.state\" placeholder=\"State\" class=\"form-control\" ng-class=\"{\'highlight-error-input\': !branchesDetails.address.state && submitted}\" ng-pattern=\"/^[a-zA-Z-_\'/:;,.\\s]{2,}$/\" ng-pattern-restrict=\"^(?!-)[0-9A-Za-z-_.(),&/\'\\s]{0,100}$\" ng-disabled=\"!editClicked\">\n                <span class=\"text-danger\" ng-show=\"!branchesDetails.address.state && submitted\">\n                  A state is required\n                </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <label class=\"col-sm-2 control-label\">\n              Branch Contact Person(s)\n              <span class=\"asterisk-required\">*</span>\n              <div>\n                <i>( First contact will be the primary contact )</i>\n              </div>\n            </label>\n            <div class=\"col-sm-9 m-b\">\n              <div class=\"row add-contact-person\" ng-if=\"!!branchesDetails.contact && (branchesDetails.contact[0] !== null)\">\n                <div class=\"col-sm-4 contact-box\" ng-repeat=\"item in branchesDetails.contact\">\n                  <a class=\"btn-btn-link pull-right remove-contact-stick\" ng-click=\"removeContact(item)\" ng-hide=\"!editClicked\">\n                    <span class=\"fa fa-trash-o\"></span>\n                  </a>\n                  <h3>\n                    <strong>{{item.first_name}}</strong>\n                  </h3>\n                  <address>\n                    Email: {{item.email}}<br>\n                    Phone: {{item.phone}}<br>\n                    Fax  : {{item.fax}}\n                  </address>\n                  <a class=\"clickable-link\" edit-contact=\"item\" updated-contact=\"onUpdatedContact(contact)\" ng-hide=\"!editClicked\">\n                    Edit\n                  </a>\n                </div>\n              </div>\n              <div class=\"row add-contact-person\">\n                <button ng-class=\"{\'btn btn-success add-new-contact-button dropdown-toggle\': !(supplier.status === \'PENDING\'),\n                             \'btn btn-default add-new-contact-button dropdown-toggle\': (supplier.status === \'PENDING\')}\" add-contact added-contact=\"addContact(contact)\" uib-tooltip=\"Add a contact\" ng-disabled=\"!editClicked\" ng-hide=\"!editClicked\">\n                  <span class=\"fa fa-plus\"></span>\n                </button>\n              </div>\n              <span class=\"text-danger\" ng-if=\"!branchesDetails.contact.length && submitted\">\n                A contact person is required\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"submit\" class=\"btn btn-primary\" ng-if=\"editClicked\" ng-click=\"saveBranchDetails()\">\n        Save\n      </button>\n      <button type=\"button\" class=\"btn btn-white\" ng-click=\"closeModal()\">\n        Close\n      </button>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/suppliersManagement/supplierGroups/detail/detail.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <span class=\"back-buttons\">\n        <a ng-click=\"back()\" class=\"btn btn-default\">\n          <i class=\"fa fa-chevron-left\"></i> Back\n        </a>\n      </span>\n      <span class=\"title-details\">{{ supplierBUCode }} - {{ supplierBUDescr }} Supplier Business Unit</span>\n    </div>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding mt-20\">\n      <h3>Displaying {{supplierBUStatus}} Suppliers</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\" condition=\"status\">\n      </columns-selector>\n      <span ng-if=\"isCurrentUserSupplierManager()\">\n        <master-export module-name=\"Suppliers\" collection=\"10\">\n      </master-export>\n      </span>\n      <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingSupplierService\" offset=\"20\">\n      </pagination-service>\n    </div>\n  </div>\n\n  <div class=\"btn-group pull-left clear-floating share-tab-focus\" role=\"group\">\n    <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'all\', \'btn-white\': supplierBUStatus !== \'all\'}\" ui-sref=\"main.user.suppliers.supplierGroupDetail({status: \'all\'})\">\n      All\n    </button>\n    <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'active\', \'btn-white\': supplierBUStatus !== \'active\'}\" ui-sref=\"main.user.suppliers.supplierGroupDetail({status: \'active\'})\">\n      Active\n    </button>\n    <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'black listed\', \'btn-white\': supplierBUStatus !== \'black listed\'}\" ui-sref=\"main.user.suppliers.supplierGroupDetail({status: \'black_listed\'})\">\n      Black Listed\n    </button>\n    <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-primary\': supplierBUStatus === \'inactive\', \'btn-white\': supplierBUStatus !== \'inactive\'}\" ui-sref=\"main.user.suppliers.supplierGroupDetail({status: \'inactive\'})\">\n      Inactive\n    </button>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 table-responsive\">\n      <table id=\"dynamicHeightTable\" class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\" dynamic-height tabindex=\"1\">\n        <thead table-header available-headers=\"columns\" condition=\"status\"></thead>\n        <tbody>\n        <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n          <td colspan=\"9\">There are no suppliers in this group.</td>\n        </tr>\n        <tr ng-repeat=\"supplier in dataList track by $index\" ui-sref=\"main.user.suppliers.detail({id: supplier._id})\" fadeout-row=\"supplier._id == highlightId\">\n          <td ng-show=\"showColumn(\'descr\')\">\n            {{supplier.descr}}\n          </td>\n          <td ng-show=\"showColumn(\'mb_supplier_code\')\">\n            {{supplier.mb_supplier_code}}\n          </td>\n          <td ng-show=\"showColumn(\'reg_no\')\">\n            {{supplier.reg_no }}\n          </td>\n          <td ng-show=\"showColumn(\'currency_code\')\">\n            {{supplier.currency_code}}\n          </td>\n          <td ng-show=\"showColumn(\'email\')\">\n            {{supplier.email}}\n          </td>\n          <td ng-show=\"showColumn(\'contact_person.first_name\')\">\n            {{supplier.contact_person[0].first_name}}\n          </td>\n          <td ng-show=\"showColumn(\'contact_person.email\')\">\n            {{supplier.contact_person[0].email}}\n          </td>\n          <td ng-show=\"showColumn(\'contact_person.phone\')\">\n            {{supplier.contact_person[0].phone}}\n          </td>\n          <td ng-show=\"showColumn(\'primary_business_nature\')\">\n            {{supplier.primary_business_nature}}\n          </td>\n          <td ng-show=\"showColumn(\'primary_commodity.descr\')\">\n            {{supplier.primary_commodity[0].descr}}\n          </td>\n          <td ng-show=\"showColumn(\'secondary_commodity.descr\')\">\n            {{supplier.secondary_commodity[0].descr || \'N/A\'}}\n          </td>\n          <td ng-show=\"showColumn(\'created_at\')\">\n            {{supplier.created_at | date: \'dd MMM yyyy\'}}\n          </td>\n          <td ng-show=\"showColumn(\'creator.display_name\')\">\n            {{supplier.creator[0].display_name}}\n          </td>\n          <td ng-show=\"showColumn(\'updated_at\')\">\n            {{supplier.updated_at | date: \'dd MMM yyyy\'}}\n          </td>\n          <td ng-show=\"showColumn(\'updater.display_name\')\">\n            {{supplier.updater[0].display_name}}\n          </td>\n          <td ng-show=\"status === \'all\' && showColumn(\'bu_status\')\">\n            {{getStatusName(supplier.bu_status, supplier.status)}}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/suppliersManagement/supplierGroups/manage/manage.html","<div class=\"container-fluid gray-bg fixed-top\">\n  <div class=\"row\">\n    <div class=\"col-md-5 no-padding\">\n      <h3 class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Displaying Supplier Business Units</h3>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n\n      <columns-selector available-columns=\"columns\" storage-key=\"storageKey\">\n      </columns-selector>\n    </div>\n    <pagination-service cursor=\"meta.cursor\" list=\"dataList\" service=\"listingBUService\" offset=\"20\">\n    </pagination-service>\n  </div>\n</div>\n<div class=\"container-fluid\">\n  <div class=\"row row-beauty\" style=\"overflow: auto\">\n    <table class=\"table\" ng-class=\"{\'table-hover\' : dataList.length > 1}\">\n      <thead table-header available-headers=\"columns\"></thead>\n      <tbody>\n      <tr class=\"no-data\" ng-if=\"!(dataList).length\">\n        <td colspan=\"9\">There are no supplier business units.</td>\n      </tr>\n      <tr ng-repeat=\"sg in dataList track by $index\" ui-sref=\"main.user.suppliers.supplierGroupDetail(\n            {\n              bu_code: sg.code,\n              bu_descr: sg.descr,\n              status: \'all\',\n              order_by: \'descr\',\n              order: 1\n            }\n          )\">\n        <td ng-if=\"showColumn(\'code\')\">\n          {{sg.code}}\n        </td>\n        <td ng-if=\"showColumn(\'descr\')\">\n          {{sg.descr}}\n        </td>\n        <td ng-if=\"showColumn(\'created_at\')\">\n          {{sg.created_at | date : \'dd MMM yyyy\'}}\n        </td>\n        <td ng-if=\"showColumn(\'creator.display_name\')\">\n          {{sg.creator[0].display_name}}\n        </td>\n        <td ng-if=\"showColumn(\'updated_at\')\">\n          {{sg.updated_at | date : \'dd MMM yyyy\'}}\n        </td>\n        <td ng-if=\"showColumn(\'updater.display_name\')\">\n          {{sg.updater[0].display_name}}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("app/user/settings/subscriptions/subscriptions.html","<div class=\"container-fluid gray-bg list-user-control-fixed-top\" ui-scrollfix>\n  <div class=\"row row-beauty\">\n    <div class=\"col-md-5 no-padding\">\n      <label class=\"pull-left\" style=\"margin-top: 7px; margin-right: 5px\">Subscriptions</label>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/user/settings/userProfile/userProfileTemplate.html","<div class=\"container-fluid gray-bg list-user-control-fixed-top state-user-profile\" ui-scrollfix>\n  <div class=\"row animated fadeInRight\">\n    <div class=\"col-md-4\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Profile Detail</h5>\n        </div>\n        <div>\n          <div class=\"ibox-content no-padding border-left-right text-center\">\n            <div flow-init flow-object=\"flowConfig\" flow-file-added=\"!!{png:1,jpg:1,jpeg:1}[$file.getExtension()]\" flow-files-submitted=\"$flow.upload()\" flow-file-success=\"isUploadImageSuccess($file, $message, $flow);\" flow-file-error=\"isUploadImageError($file, $message, $flow);\">\n              <div flow-btn ng-if=\"$flow.files[0]\">\n                <img class=\"profile-avatar\" flow-img=\"$flow.files[0]\">\n              </div>\n              <div flow-btn ng-if=\"$flow.isUploading()\">\n                Uploading...\n              </div>\n              <div flow-btn ng-if=\"!$flow.files[0]\">\n                <img class=\"profile-avatar\" image-error=\"assets/images/default-user.png\" ng-src=\"{{imageBasePath}}{{profile.img_url}}\">\n              </div>\n            </div>\n          </div>\n          <div class=\"ibox-content profile-content\">\n            <div class=\"form-horizontal\">\n              <div class=\"form-group\">\n                <label class=\"col-md-3 col-sm-3 col-xs-3\">Name:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  {{ ::profile.display_name }}\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 col-sm-3 col-xs-3\">Employee number:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  {{ ::profile.emp_no }}\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 col-sm-3 col-xs-3\">Email:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8 text-ellipsis\" uib-tooltip=\"{{ ::profile.email }}\">\n                  {{ ::profile.email }}\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-md-3 col-sm-3 col-xs-3\">Password:</label>\n                <div class=\"col-md-8 col-sm-8 col-xs-8\">\n                  <a id=\"userProfileChangePassword\" class=\"change-password\" password-reset-modal data=\"profile\" old-password-field=\"true\" ng-click=\"showPasswordModal()\">\n                    Change Password\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-8\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Companies and Roles</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-3 col-xs-3\">Company & Cost Centers:</label>\n              <div class=\"col-sm-8 col-xs-8\">\n                <ul class=\"unstyled\">\n                  <li data-ng-repeat=\"item in companies\">\n                    {{ item.name }}:\n                    <ul class=\"unstyled\">\n                      <li class=\"col-xs-12 company-description\" ng-repeat=\"costCenter in item.costCenters\">\n                        {{ costCenter.descr }}\n                      </li>\n                    </ul>\n                  </li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label class=\"col-sm-3 col-xs-3\">Role:</label>\n              <div class=\"col-sm-8 col-xs-8\">\n                <ul class=\"unstyled\">\n                  <li ng-repeat=\"item in profile.roles\">\n                    {{ item.name }}\n                    <span ng-if=\"!!item.company_code && item.company_code != null\">\n                     - {{item.company_code}}\n                    </span>\n                    <span ng-if=\"!item.company_code || item.company_code === null\">\n                     - System Role\n                    </span>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-title\">\n          <h5>Email Notification Frequency</h5>\n        </div>\n        <div class=\"ibox-content\">\n          <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n              <label class=\"col-sm-4 control-label\">Set Email Notification Frequency: </label>\n              <div class=\"col-sm-8 m-b\">\n                <div class=\"m-r-xs checkbox-font-size\" ng-repeat=\"ef in emailFrequency track by $index\">\n                  <input type=\"radio\" id=\"{{selection.ef}}\" name=\"selectEmailFrequency\" ng-model=\"$parent.activeRadio\" ng-value=\"ef.id\" ng-click=\"selectedEmailFrequency(ef.value)\">\n                  &nbsp;&nbsp;{{ef.descr}}\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <user-delegation source=\"profile\" user=\"currentUser\"></user-delegation>\n      <button ng-click=\"removeCachedData()\" class=\"btn btn-primary\">Remove cached data</button>\n    </div>\n  </div>\n</div>\n");}]);